import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  date: any;
  float8: any;
  jsonb: any;
  numeric: any;
  time: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  created_at: Scalars['timestamp'];
  name: Scalars['String'];
};

export type ApiKeyCreateInput = {
  name: Scalars['String'];
};

export type ApiKeyCreateResponse = {
  __typename?: 'ApiKeyCreateResponse';
  api_key: Scalars['String'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type NetsuiteFileResponse = {
  __typename?: 'NetsuiteFileResponse';
  message: Scalars['String'];
  pdf: Scalars['String'];
};

export type OpportunityFile = {
  __typename?: 'OpportunityFile';
  ContentDocument: OpportunityFileDetails;
  ContentDocumentId: Scalars['String'];
  ContentVersion: OpportunityFileVersion;
  Id: Scalars['String'];
  LinkedEntityId: Scalars['String'];
};

export type OpportunityFileDetails = {
  __typename?: 'OpportunityFileDetails';
  ContentSize: Scalars['Int'];
  FileExtension: Scalars['String'];
  FileType: Scalars['String'];
  Title: Scalars['String'];
};

export type OpportunityFileVersion = {
  __typename?: 'OpportunityFileVersion';
  Content: Scalars['String'];
  Id: Scalars['String'];
};

export type SalesforceOpportunityResponse = {
  __typename?: 'SalesforceOpportunityResponse';
  done: Scalars['Boolean'];
  records: Array<OpportunityFile>;
  totalSize: Scalars['Int'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "account" */
export type Account = {
  __typename?: 'account';
  account_category?: Maybe<Scalars['String']>;
  account_creation_date?: Maybe<Scalars['date']>;
  account_currency?: Maybe<Scalars['String']>;
  account_deactivation_date?: Maybe<Scalars['date']>;
  account_legal_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  account_manager?: Maybe<Owner>;
  account_name: Scalars['String'];
  ad_revenue_model?: Maybe<Scalars['String']>;
  /** An object relationship */
  address?: Maybe<Company_Address>;
  ads_plus_customer_email_id_1?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_2?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_3?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_4?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_5?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_6?: Maybe<Scalars['String']>;
  amagi_id: Scalars['String'];
  amagi_now?: Maybe<Scalars['String']>;
  amagi_now_url?: Maybe<Scalars['String']>;
  bill_to_contact?: Maybe<Scalars['String']>;
  billing_address?: Maybe<Scalars['jsonb']>;
  billing_contact?: Maybe<Scalars['jsonb']>;
  billing_date_rule?: Maybe<Scalars['String']>;
  billing_term?: Maybe<Scalars['String']>;
  billing_threshold_rule?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  business_category?: Maybe<Scalars['String']>;
  c_plus_percentage_share?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  cases: Array<Case>;
  /** An aggregate relationship */
  cases_aggregate: Case_Aggregate;
  cdpderived_revenue_segment?: Maybe<Scalars['String']>;
  /** An array relationship */
  channels: Array<Channel>;
  /** An aggregate relationship */
  channels_aggregate: Channel_Aggregate;
  /** An array relationship */
  children: Array<Account>;
  /** An aggregate relationship */
  children_aggregate: Account_Aggregate;
  churn_effective_date?: Maybe<Scalars['date']>;
  churn_requested_by?: Maybe<Scalars['String']>;
  churn_risk_percentage?: Maybe<Scalars['numeric']>;
  churn_type?: Maybe<Scalars['String']>;
  cloud_region: Scalars['jsonb'];
  cloud_service_provider: Scalars['jsonb'];
  cloudport?: Maybe<Scalars['String']>;
  cloudport_url?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  company_category?: Maybe<Scalars['String']>;
  connect_msa_effective_date?: Maybe<Scalars['date']>;
  /** An array relationship */
  contacts: Array<Contact>;
  /** An aggregate relationship */
  contacts_aggregate: Contact_Aggregate;
  content_plus_customer_email_id_1?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_2?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_3?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_4?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_5?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_6?: Maybe<Scalars['String']>;
  content_plus_internal_email_id?: Maybe<Scalars['String']>;
  content_plus_owner?: Maybe<Scalars['String']>;
  cplus_msa_effective_date?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_period_in_days?: Maybe<Scalars['String']>;
  credit_score?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  csm?: Maybe<Owner>;
  customer_business_model?: Maybe<Scalars['String']>;
  customer_churn_reason?: Maybe<Scalars['String']>;
  customer_contract_period?: Maybe<Scalars['numeric']>;
  customer_financial_risk_category?: Maybe<Scalars['String']>;
  customer_life_time_value?: Maybe<Scalars['numeric']>;
  customer_origin?: Maybe<Scalars['String']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['numeric']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['numeric']>;
  customer_scale?: Maybe<Scalars['String']>;
  customer_since_date?: Maybe<Scalars['timestamptz']>;
  customer_tier?: Maybe<Scalars['String']>;
  customer_type?: Maybe<Scalars['String']>;
  customers_profit_for_previous_year?: Maybe<Scalars['numeric']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['numeric']>;
  deposit_amount_mrr_months?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  dso?: Maybe<Scalars['String']>;
  entitled_to_stop_services_after?: Maybe<Scalars['String']>;
  first_invoice_date?: Maybe<Scalars['date']>;
  industry_segment?: Maybe<Scalars['String']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  invoices: Array<Invoice>;
  /** An aggregate relationship */
  invoices_aggregate: Invoice_Aggregate;
  invoicing_currency?: Maybe<Scalars['String']>;
  is_active?: Maybe<Scalars['Boolean']>;
  is_deleted: Scalars['Boolean'];
  is_msa_ratecard_customer?: Maybe<Scalars['Boolean']>;
  is_ono?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  /** An object relationship */
  legal_entity?: Maybe<Legal_Entity>;
  legal_entity_id?: Maybe<Scalars['String']>;
  legal_entity_name?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  /** An object relationship */
  media_industry_sub_segment?: Maybe<Media_Industry_Sub_Segment>;
  monetization_preference?: Maybe<Scalars['String']>;
  msa_effective_date?: Maybe<Scalars['date']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  no_of_employees?: Maybe<Scalars['numeric']>;
  onboarding_customer_email_id_1?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_2?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_3?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_4?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_5?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_6?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_7?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_8?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_9?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_10?: Maybe<Scalars['String']>;
  order_initial_term?: Maybe<Scalars['numeric']>;
  order_renewal_term?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  orders: Array<Order>;
  /** An aggregate relationship */
  orders_aggregate: Order_Aggregate;
  other_churn_reason?: Maybe<Scalars['String']>;
  /** An object relationship */
  owner: Owner;
  /** An object relationship */
  parent?: Maybe<Account>;
  payment_due_on_receipt?: Maybe<Scalars['Boolean']>;
  payment_term_for_terminated_services?: Maybe<Scalars['numeric']>;
  payment_terms?: Maybe<Scalars['String']>;
  payment_terms_in_days?: Maybe<Scalars['numeric']>;
  phone?: Maybe<Scalars['String']>;
  planner?: Maybe<Scalars['String']>;
  planner_url?: Maybe<Scalars['String']>;
  platform_tier?: Maybe<Scalars['String']>;
  /** An array relationship */
  platforms: Array<Platform>;
  /** An aggregate relationship */
  platforms_aggregate: Platform_Aggregate;
  preferred_payment_channel?: Maybe<Scalars['String']>;
  price_escalation?: Maybe<Scalars['String']>;
  price_escalation_period?: Maybe<Scalars['numeric']>;
  products_with_limitations?: Maybe<Scalars['String']>;
  /** An array relationship */
  quotes: Array<Quote>;
  /** An aggregate relationship */
  quotes_aggregate: Quote_Aggregate;
  /** An object relationship */
  record_type?: Maybe<Record_Type>;
  region?: Maybe<Scalars['String']>;
  revenue_group_1?: Maybe<Scalars['String']>;
  revenue_group_2?: Maybe<Scalars['String']>;
  salesforce_accountmanager_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_csm_id?: Maybe<Scalars['String']>;
  salesforce_geohead_id?: Maybe<Scalars['String']>;
  /** Primary key from salesforce, used only for updates. */
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date: Scalars['timestamptz'];
  salesforce_owner_id: Scalars['String'];
  salesforce_parent_id?: Maybe<Scalars['String']>;
  salesforce_record_type_id?: Maybe<Scalars['String']>;
  salesforce_salesrep_id?: Maybe<Scalars['String']>;
  security_deposit?: Maybe<Scalars['String']>;
  /** An object relationship */
  segment?: Maybe<Segment>;
  self_service_access?: Maybe<Scalars['String']>;
  service_tier?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['numeric']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  tam?: Maybe<Scalars['String']>;
  termination_details?: Maybe<Scalars['String']>;
  termination_due_to_platform_notice?: Maybe<Scalars['numeric']>;
  thunderstorm?: Maybe<Scalars['String']>;
  thunderstorm_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  yearly_escalation_percentage?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "account" */
export type AccountBilling_AddressArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "account" */
export type AccountBilling_ContactArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "account" */
export type AccountCasesArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountCases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountChannelsArgs = {
  distinct_on?: InputMaybe<Array<Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Order_By>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountChannels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Order_By>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountChildrenArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountCloud_RegionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "account" */
export type AccountCloud_Service_ProviderArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "account" */
export type AccountContactsArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountOrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountPlatformsArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountPlatforms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountQuotesArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


/** columns and relationships of "account" */
export type AccountQuotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};

/** aggregated selection of "account" */
export type Account_Aggregate = {
  __typename?: 'account_aggregate';
  aggregate?: Maybe<Account_Aggregate_Fields>;
  nodes: Array<Account>;
};

export type Account_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Account_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Account_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Account_Aggregate_Bool_Exp_Count>;
};

export type Account_Aggregate_Bool_Exp_Bool_And = {
  arguments: Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Account_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Account_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Account_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Account_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Account_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "account" */
export type Account_Aggregate_Fields = {
  __typename?: 'account_aggregate_fields';
  avg?: Maybe<Account_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Account_Max_Fields>;
  min?: Maybe<Account_Min_Fields>;
  stddev?: Maybe<Account_Stddev_Fields>;
  stddev_pop?: Maybe<Account_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Account_Stddev_Samp_Fields>;
  sum?: Maybe<Account_Sum_Fields>;
  var_pop?: Maybe<Account_Var_Pop_Fields>;
  var_samp?: Maybe<Account_Var_Samp_Fields>;
  variance?: Maybe<Account_Variance_Fields>;
};


/** aggregate fields of "account" */
export type Account_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Account_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "account" */
export type Account_Aggregate_Order_By = {
  avg?: InputMaybe<Account_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Account_Max_Order_By>;
  min?: InputMaybe<Account_Min_Order_By>;
  stddev?: InputMaybe<Account_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Account_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Account_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Account_Sum_Order_By>;
  var_pop?: InputMaybe<Account_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Account_Var_Samp_Order_By>;
  variance?: InputMaybe<Account_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Account_Avg_Fields = {
  __typename?: 'account_avg_fields';
  c_plus_percentage_share?: Maybe<Scalars['Float']>;
  churn_risk_percentage?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Float']>;
  customer_contract_period?: Maybe<Scalars['Float']>;
  customer_life_time_value?: Maybe<Scalars['Float']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['Float']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['Float']>;
  customers_profit_for_previous_year?: Maybe<Scalars['Float']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['Float']>;
  deposit_amount_mrr_months?: Maybe<Scalars['Float']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  no_of_employees?: Maybe<Scalars['Float']>;
  order_initial_term?: Maybe<Scalars['Float']>;
  order_renewal_term?: Maybe<Scalars['Float']>;
  payment_term_for_terminated_services?: Maybe<Scalars['Float']>;
  payment_terms_in_days?: Maybe<Scalars['Float']>;
  price_escalation_period?: Maybe<Scalars['Float']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['Float']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['Float']>;
  termination_due_to_platform_notice?: Maybe<Scalars['Float']>;
  yearly_escalation_percentage?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "account" */
export type Account_Avg_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  deposit_amount_mrr_months?: InputMaybe<Order_By>;
  interest_percent_applicable_post_due_date?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  order_initial_term?: InputMaybe<Order_By>;
  order_renewal_term?: InputMaybe<Order_By>;
  payment_term_for_terminated_services?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
  price_escalation_period?: InputMaybe<Order_By>;
  so_cancel_notice_after_oit?: InputMaybe<Order_By>;
  so_cancel_notice_during_oit?: InputMaybe<Order_By>;
  termination_due_to_platform_notice?: InputMaybe<Order_By>;
  yearly_escalation_percentage?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "account". All fields are combined with a logical 'AND'. */
export type Account_Bool_Exp = {
  _and?: InputMaybe<Array<Account_Bool_Exp>>;
  _not?: InputMaybe<Account_Bool_Exp>;
  _or?: InputMaybe<Array<Account_Bool_Exp>>;
  account_category?: InputMaybe<String_Comparison_Exp>;
  account_creation_date?: InputMaybe<Date_Comparison_Exp>;
  account_currency?: InputMaybe<String_Comparison_Exp>;
  account_deactivation_date?: InputMaybe<Date_Comparison_Exp>;
  account_legal_name?: InputMaybe<String_Comparison_Exp>;
  account_manager?: InputMaybe<Owner_Bool_Exp>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  ad_revenue_model?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<Company_Address_Bool_Exp>;
  ads_plus_customer_email_id_1?: InputMaybe<String_Comparison_Exp>;
  ads_plus_customer_email_id_2?: InputMaybe<String_Comparison_Exp>;
  ads_plus_customer_email_id_3?: InputMaybe<String_Comparison_Exp>;
  ads_plus_customer_email_id_4?: InputMaybe<String_Comparison_Exp>;
  ads_plus_customer_email_id_5?: InputMaybe<String_Comparison_Exp>;
  ads_plus_customer_email_id_6?: InputMaybe<String_Comparison_Exp>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  amagi_now?: InputMaybe<String_Comparison_Exp>;
  amagi_now_url?: InputMaybe<String_Comparison_Exp>;
  bill_to_contact?: InputMaybe<String_Comparison_Exp>;
  billing_address?: InputMaybe<Jsonb_Comparison_Exp>;
  billing_contact?: InputMaybe<Jsonb_Comparison_Exp>;
  billing_date_rule?: InputMaybe<String_Comparison_Exp>;
  billing_term?: InputMaybe<String_Comparison_Exp>;
  billing_threshold_rule?: InputMaybe<String_Comparison_Exp>;
  billing_type?: InputMaybe<String_Comparison_Exp>;
  business_category?: InputMaybe<String_Comparison_Exp>;
  c_plus_percentage_share?: InputMaybe<Numeric_Comparison_Exp>;
  cases?: InputMaybe<Case_Bool_Exp>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  cdpderived_revenue_segment?: InputMaybe<String_Comparison_Exp>;
  channels?: InputMaybe<Channel_Bool_Exp>;
  channels_aggregate?: InputMaybe<Channel_Aggregate_Bool_Exp>;
  children?: InputMaybe<Account_Bool_Exp>;
  children_aggregate?: InputMaybe<Account_Aggregate_Bool_Exp>;
  churn_effective_date?: InputMaybe<Date_Comparison_Exp>;
  churn_requested_by?: InputMaybe<String_Comparison_Exp>;
  churn_risk_percentage?: InputMaybe<Numeric_Comparison_Exp>;
  churn_type?: InputMaybe<String_Comparison_Exp>;
  cloud_region?: InputMaybe<Jsonb_Comparison_Exp>;
  cloud_service_provider?: InputMaybe<Jsonb_Comparison_Exp>;
  cloudport?: InputMaybe<String_Comparison_Exp>;
  cloudport_url?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  company_category?: InputMaybe<String_Comparison_Exp>;
  connect_msa_effective_date?: InputMaybe<Date_Comparison_Exp>;
  contacts?: InputMaybe<Contact_Bool_Exp>;
  contacts_aggregate?: InputMaybe<Contact_Aggregate_Bool_Exp>;
  content_plus_customer_email_id_1?: InputMaybe<String_Comparison_Exp>;
  content_plus_customer_email_id_2?: InputMaybe<String_Comparison_Exp>;
  content_plus_customer_email_id_3?: InputMaybe<String_Comparison_Exp>;
  content_plus_customer_email_id_4?: InputMaybe<String_Comparison_Exp>;
  content_plus_customer_email_id_5?: InputMaybe<String_Comparison_Exp>;
  content_plus_customer_email_id_6?: InputMaybe<String_Comparison_Exp>;
  content_plus_internal_email_id?: InputMaybe<String_Comparison_Exp>;
  content_plus_owner?: InputMaybe<String_Comparison_Exp>;
  cplus_msa_effective_date?: InputMaybe<Date_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_period_in_days?: InputMaybe<String_Comparison_Exp>;
  credit_score?: InputMaybe<Numeric_Comparison_Exp>;
  csm?: InputMaybe<Owner_Bool_Exp>;
  customer_business_model?: InputMaybe<String_Comparison_Exp>;
  customer_churn_reason?: InputMaybe<String_Comparison_Exp>;
  customer_contract_period?: InputMaybe<Numeric_Comparison_Exp>;
  customer_financial_risk_category?: InputMaybe<String_Comparison_Exp>;
  customer_life_time_value?: InputMaybe<Numeric_Comparison_Exp>;
  customer_origin?: InputMaybe<String_Comparison_Exp>;
  customer_revenue_for_previous_year?: InputMaybe<Numeric_Comparison_Exp>;
  customer_revenue_for_the_present_year?: InputMaybe<Numeric_Comparison_Exp>;
  customer_scale?: InputMaybe<String_Comparison_Exp>;
  customer_since_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_tier?: InputMaybe<String_Comparison_Exp>;
  customer_type?: InputMaybe<String_Comparison_Exp>;
  customers_profit_for_previous_year?: InputMaybe<Numeric_Comparison_Exp>;
  customers_profit_for_the_present_year?: InputMaybe<Numeric_Comparison_Exp>;
  deposit_amount_mrr_months?: InputMaybe<Numeric_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dso?: InputMaybe<String_Comparison_Exp>;
  entitled_to_stop_services_after?: InputMaybe<String_Comparison_Exp>;
  first_invoice_date?: InputMaybe<Date_Comparison_Exp>;
  industry_segment?: InputMaybe<String_Comparison_Exp>;
  interest_percent_applicable_post_due_date?: InputMaybe<Numeric_Comparison_Exp>;
  invoices?: InputMaybe<Invoice_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Bool_Exp>;
  invoicing_currency?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_msa_ratecard_customer?: InputMaybe<Boolean_Comparison_Exp>;
  is_ono?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  legal_entity?: InputMaybe<Legal_Entity_Bool_Exp>;
  legal_entity_id?: InputMaybe<String_Comparison_Exp>;
  legal_entity_name?: InputMaybe<String_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  media_industry_sub_segment?: InputMaybe<Media_Industry_Sub_Segment_Bool_Exp>;
  monetization_preference?: InputMaybe<String_Comparison_Exp>;
  msa_effective_date?: InputMaybe<Date_Comparison_Exp>;
  netsuite_id?: InputMaybe<Numeric_Comparison_Exp>;
  no_of_employees?: InputMaybe<Numeric_Comparison_Exp>;
  onboarding_customer_email_id_1?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_2?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_3?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_4?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_5?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_6?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_7?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_8?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_9?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_10?: InputMaybe<String_Comparison_Exp>;
  order_initial_term?: InputMaybe<Numeric_Comparison_Exp>;
  order_renewal_term?: InputMaybe<Numeric_Comparison_Exp>;
  orders?: InputMaybe<Order_Bool_Exp>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Bool_Exp>;
  other_churn_reason?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<Owner_Bool_Exp>;
  parent?: InputMaybe<Account_Bool_Exp>;
  payment_due_on_receipt?: InputMaybe<Boolean_Comparison_Exp>;
  payment_term_for_terminated_services?: InputMaybe<Numeric_Comparison_Exp>;
  payment_terms?: InputMaybe<String_Comparison_Exp>;
  payment_terms_in_days?: InputMaybe<Numeric_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  planner?: InputMaybe<String_Comparison_Exp>;
  planner_url?: InputMaybe<String_Comparison_Exp>;
  platform_tier?: InputMaybe<String_Comparison_Exp>;
  platforms?: InputMaybe<Platform_Bool_Exp>;
  platforms_aggregate?: InputMaybe<Platform_Aggregate_Bool_Exp>;
  preferred_payment_channel?: InputMaybe<String_Comparison_Exp>;
  price_escalation?: InputMaybe<String_Comparison_Exp>;
  price_escalation_period?: InputMaybe<Numeric_Comparison_Exp>;
  products_with_limitations?: InputMaybe<String_Comparison_Exp>;
  quotes?: InputMaybe<Quote_Bool_Exp>;
  quotes_aggregate?: InputMaybe<Quote_Aggregate_Bool_Exp>;
  record_type?: InputMaybe<Record_Type_Bool_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  revenue_group_1?: InputMaybe<String_Comparison_Exp>;
  revenue_group_2?: InputMaybe<String_Comparison_Exp>;
  salesforce_accountmanager_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_csm_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_geohead_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_owner_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_parent_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_record_type_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_salesrep_id?: InputMaybe<String_Comparison_Exp>;
  security_deposit?: InputMaybe<String_Comparison_Exp>;
  segment?: InputMaybe<Segment_Bool_Exp>;
  self_service_access?: InputMaybe<String_Comparison_Exp>;
  service_tier?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  so_cancel_notice_after_oit?: InputMaybe<Numeric_Comparison_Exp>;
  so_cancel_notice_during_oit?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tam?: InputMaybe<String_Comparison_Exp>;
  termination_details?: InputMaybe<String_Comparison_Exp>;
  termination_due_to_platform_notice?: InputMaybe<Numeric_Comparison_Exp>;
  thunderstorm?: InputMaybe<String_Comparison_Exp>;
  thunderstorm_url?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  yearly_escalation_percentage?: InputMaybe<Numeric_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "account" */
export type Account_Inc_Input = {
  c_plus_percentage_share?: InputMaybe<Scalars['numeric']>;
  churn_risk_percentage?: InputMaybe<Scalars['numeric']>;
  credit_score?: InputMaybe<Scalars['numeric']>;
  customer_life_time_value?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Account_Max_Fields = {
  __typename?: 'account_max_fields';
  account_category?: Maybe<Scalars['String']>;
  account_creation_date?: Maybe<Scalars['date']>;
  account_currency?: Maybe<Scalars['String']>;
  account_deactivation_date?: Maybe<Scalars['date']>;
  account_legal_name?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  ad_revenue_model?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_1?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_2?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_3?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_4?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_5?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_6?: Maybe<Scalars['String']>;
  amagi_id?: Maybe<Scalars['String']>;
  amagi_now?: Maybe<Scalars['String']>;
  amagi_now_url?: Maybe<Scalars['String']>;
  bill_to_contact?: Maybe<Scalars['String']>;
  billing_date_rule?: Maybe<Scalars['String']>;
  billing_term?: Maybe<Scalars['String']>;
  billing_threshold_rule?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  business_category?: Maybe<Scalars['String']>;
  c_plus_percentage_share?: Maybe<Scalars['numeric']>;
  cdpderived_revenue_segment?: Maybe<Scalars['String']>;
  churn_effective_date?: Maybe<Scalars['date']>;
  churn_requested_by?: Maybe<Scalars['String']>;
  churn_risk_percentage?: Maybe<Scalars['numeric']>;
  churn_type?: Maybe<Scalars['String']>;
  cloudport?: Maybe<Scalars['String']>;
  cloudport_url?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  company_category?: Maybe<Scalars['String']>;
  connect_msa_effective_date?: Maybe<Scalars['date']>;
  content_plus_customer_email_id_1?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_2?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_3?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_4?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_5?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_6?: Maybe<Scalars['String']>;
  content_plus_internal_email_id?: Maybe<Scalars['String']>;
  content_plus_owner?: Maybe<Scalars['String']>;
  cplus_msa_effective_date?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_period_in_days?: Maybe<Scalars['String']>;
  credit_score?: Maybe<Scalars['numeric']>;
  customer_business_model?: Maybe<Scalars['String']>;
  customer_churn_reason?: Maybe<Scalars['String']>;
  customer_contract_period?: Maybe<Scalars['numeric']>;
  customer_financial_risk_category?: Maybe<Scalars['String']>;
  customer_life_time_value?: Maybe<Scalars['numeric']>;
  customer_origin?: Maybe<Scalars['String']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['numeric']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['numeric']>;
  customer_scale?: Maybe<Scalars['String']>;
  customer_since_date?: Maybe<Scalars['timestamptz']>;
  customer_tier?: Maybe<Scalars['String']>;
  customer_type?: Maybe<Scalars['String']>;
  customers_profit_for_previous_year?: Maybe<Scalars['numeric']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['numeric']>;
  deposit_amount_mrr_months?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  dso?: Maybe<Scalars['String']>;
  entitled_to_stop_services_after?: Maybe<Scalars['String']>;
  first_invoice_date?: Maybe<Scalars['date']>;
  industry_segment?: Maybe<Scalars['String']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['numeric']>;
  invoicing_currency?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  legal_entity_id?: Maybe<Scalars['String']>;
  legal_entity_name?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  monetization_preference?: Maybe<Scalars['String']>;
  msa_effective_date?: Maybe<Scalars['date']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  no_of_employees?: Maybe<Scalars['numeric']>;
  onboarding_customer_email_id_1?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_2?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_3?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_4?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_5?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_6?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_7?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_8?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_9?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_10?: Maybe<Scalars['String']>;
  order_initial_term?: Maybe<Scalars['numeric']>;
  order_renewal_term?: Maybe<Scalars['numeric']>;
  other_churn_reason?: Maybe<Scalars['String']>;
  payment_term_for_terminated_services?: Maybe<Scalars['numeric']>;
  payment_terms?: Maybe<Scalars['String']>;
  payment_terms_in_days?: Maybe<Scalars['numeric']>;
  phone?: Maybe<Scalars['String']>;
  planner?: Maybe<Scalars['String']>;
  planner_url?: Maybe<Scalars['String']>;
  platform_tier?: Maybe<Scalars['String']>;
  preferred_payment_channel?: Maybe<Scalars['String']>;
  price_escalation?: Maybe<Scalars['String']>;
  price_escalation_period?: Maybe<Scalars['numeric']>;
  products_with_limitations?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  revenue_group_1?: Maybe<Scalars['String']>;
  revenue_group_2?: Maybe<Scalars['String']>;
  salesforce_accountmanager_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_csm_id?: Maybe<Scalars['String']>;
  salesforce_geohead_id?: Maybe<Scalars['String']>;
  /** Primary key from salesforce, used only for updates. */
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_parent_id?: Maybe<Scalars['String']>;
  salesforce_record_type_id?: Maybe<Scalars['String']>;
  salesforce_salesrep_id?: Maybe<Scalars['String']>;
  security_deposit?: Maybe<Scalars['String']>;
  self_service_access?: Maybe<Scalars['String']>;
  service_tier?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['numeric']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  tam?: Maybe<Scalars['String']>;
  termination_details?: Maybe<Scalars['String']>;
  termination_due_to_platform_notice?: Maybe<Scalars['numeric']>;
  thunderstorm?: Maybe<Scalars['String']>;
  thunderstorm_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  yearly_escalation_percentage?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "account" */
export type Account_Max_Order_By = {
  account_category?: InputMaybe<Order_By>;
  account_creation_date?: InputMaybe<Order_By>;
  account_currency?: InputMaybe<Order_By>;
  account_deactivation_date?: InputMaybe<Order_By>;
  account_legal_name?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  ad_revenue_model?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_1?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_2?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_3?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_4?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_5?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_6?: InputMaybe<Order_By>;
  amagi_id?: InputMaybe<Order_By>;
  amagi_now?: InputMaybe<Order_By>;
  amagi_now_url?: InputMaybe<Order_By>;
  bill_to_contact?: InputMaybe<Order_By>;
  billing_date_rule?: InputMaybe<Order_By>;
  billing_term?: InputMaybe<Order_By>;
  billing_threshold_rule?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  business_category?: InputMaybe<Order_By>;
  c_plus_percentage_share?: InputMaybe<Order_By>;
  cdpderived_revenue_segment?: InputMaybe<Order_By>;
  churn_effective_date?: InputMaybe<Order_By>;
  churn_requested_by?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  churn_type?: InputMaybe<Order_By>;
  cloudport?: InputMaybe<Order_By>;
  cloudport_url?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  company_category?: InputMaybe<Order_By>;
  connect_msa_effective_date?: InputMaybe<Order_By>;
  content_plus_customer_email_id_1?: InputMaybe<Order_By>;
  content_plus_customer_email_id_2?: InputMaybe<Order_By>;
  content_plus_customer_email_id_3?: InputMaybe<Order_By>;
  content_plus_customer_email_id_4?: InputMaybe<Order_By>;
  content_plus_customer_email_id_5?: InputMaybe<Order_By>;
  content_plus_customer_email_id_6?: InputMaybe<Order_By>;
  content_plus_internal_email_id?: InputMaybe<Order_By>;
  content_plus_owner?: InputMaybe<Order_By>;
  cplus_msa_effective_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_period_in_days?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_business_model?: InputMaybe<Order_By>;
  customer_churn_reason?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_financial_risk_category?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_origin?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customer_scale?: InputMaybe<Order_By>;
  customer_since_date?: InputMaybe<Order_By>;
  customer_tier?: InputMaybe<Order_By>;
  customer_type?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  deposit_amount_mrr_months?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dso?: InputMaybe<Order_By>;
  entitled_to_stop_services_after?: InputMaybe<Order_By>;
  first_invoice_date?: InputMaybe<Order_By>;
  industry_segment?: InputMaybe<Order_By>;
  interest_percent_applicable_post_due_date?: InputMaybe<Order_By>;
  invoicing_currency?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  legal_entity_id?: InputMaybe<Order_By>;
  legal_entity_name?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  monetization_preference?: InputMaybe<Order_By>;
  msa_effective_date?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  onboarding_customer_email_id_1?: InputMaybe<Order_By>;
  onboarding_customer_email_id_2?: InputMaybe<Order_By>;
  onboarding_customer_email_id_3?: InputMaybe<Order_By>;
  onboarding_customer_email_id_4?: InputMaybe<Order_By>;
  onboarding_customer_email_id_5?: InputMaybe<Order_By>;
  onboarding_customer_email_id_6?: InputMaybe<Order_By>;
  onboarding_customer_email_id_7?: InputMaybe<Order_By>;
  onboarding_customer_email_id_8?: InputMaybe<Order_By>;
  onboarding_customer_email_id_9?: InputMaybe<Order_By>;
  onboarding_customer_email_id_10?: InputMaybe<Order_By>;
  order_initial_term?: InputMaybe<Order_By>;
  order_renewal_term?: InputMaybe<Order_By>;
  other_churn_reason?: InputMaybe<Order_By>;
  payment_term_for_terminated_services?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  planner?: InputMaybe<Order_By>;
  planner_url?: InputMaybe<Order_By>;
  platform_tier?: InputMaybe<Order_By>;
  preferred_payment_channel?: InputMaybe<Order_By>;
  price_escalation?: InputMaybe<Order_By>;
  price_escalation_period?: InputMaybe<Order_By>;
  products_with_limitations?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  revenue_group_1?: InputMaybe<Order_By>;
  revenue_group_2?: InputMaybe<Order_By>;
  salesforce_accountmanager_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_csm_id?: InputMaybe<Order_By>;
  salesforce_geohead_id?: InputMaybe<Order_By>;
  /** Primary key from salesforce, used only for updates. */
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_parent_id?: InputMaybe<Order_By>;
  salesforce_record_type_id?: InputMaybe<Order_By>;
  salesforce_salesrep_id?: InputMaybe<Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  self_service_access?: InputMaybe<Order_By>;
  service_tier?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  so_cancel_notice_after_oit?: InputMaybe<Order_By>;
  so_cancel_notice_during_oit?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tam?: InputMaybe<Order_By>;
  termination_details?: InputMaybe<Order_By>;
  termination_due_to_platform_notice?: InputMaybe<Order_By>;
  thunderstorm?: InputMaybe<Order_By>;
  thunderstorm_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_escalation_percentage?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Account_Min_Fields = {
  __typename?: 'account_min_fields';
  account_category?: Maybe<Scalars['String']>;
  account_creation_date?: Maybe<Scalars['date']>;
  account_currency?: Maybe<Scalars['String']>;
  account_deactivation_date?: Maybe<Scalars['date']>;
  account_legal_name?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  ad_revenue_model?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_1?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_2?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_3?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_4?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_5?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_6?: Maybe<Scalars['String']>;
  amagi_id?: Maybe<Scalars['String']>;
  amagi_now?: Maybe<Scalars['String']>;
  amagi_now_url?: Maybe<Scalars['String']>;
  bill_to_contact?: Maybe<Scalars['String']>;
  billing_date_rule?: Maybe<Scalars['String']>;
  billing_term?: Maybe<Scalars['String']>;
  billing_threshold_rule?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  business_category?: Maybe<Scalars['String']>;
  c_plus_percentage_share?: Maybe<Scalars['numeric']>;
  cdpderived_revenue_segment?: Maybe<Scalars['String']>;
  churn_effective_date?: Maybe<Scalars['date']>;
  churn_requested_by?: Maybe<Scalars['String']>;
  churn_risk_percentage?: Maybe<Scalars['numeric']>;
  churn_type?: Maybe<Scalars['String']>;
  cloudport?: Maybe<Scalars['String']>;
  cloudport_url?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  company_category?: Maybe<Scalars['String']>;
  connect_msa_effective_date?: Maybe<Scalars['date']>;
  content_plus_customer_email_id_1?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_2?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_3?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_4?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_5?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_6?: Maybe<Scalars['String']>;
  content_plus_internal_email_id?: Maybe<Scalars['String']>;
  content_plus_owner?: Maybe<Scalars['String']>;
  cplus_msa_effective_date?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_period_in_days?: Maybe<Scalars['String']>;
  credit_score?: Maybe<Scalars['numeric']>;
  customer_business_model?: Maybe<Scalars['String']>;
  customer_churn_reason?: Maybe<Scalars['String']>;
  customer_contract_period?: Maybe<Scalars['numeric']>;
  customer_financial_risk_category?: Maybe<Scalars['String']>;
  customer_life_time_value?: Maybe<Scalars['numeric']>;
  customer_origin?: Maybe<Scalars['String']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['numeric']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['numeric']>;
  customer_scale?: Maybe<Scalars['String']>;
  customer_since_date?: Maybe<Scalars['timestamptz']>;
  customer_tier?: Maybe<Scalars['String']>;
  customer_type?: Maybe<Scalars['String']>;
  customers_profit_for_previous_year?: Maybe<Scalars['numeric']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['numeric']>;
  deposit_amount_mrr_months?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  dso?: Maybe<Scalars['String']>;
  entitled_to_stop_services_after?: Maybe<Scalars['String']>;
  first_invoice_date?: Maybe<Scalars['date']>;
  industry_segment?: Maybe<Scalars['String']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['numeric']>;
  invoicing_currency?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  legal_entity_id?: Maybe<Scalars['String']>;
  legal_entity_name?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  monetization_preference?: Maybe<Scalars['String']>;
  msa_effective_date?: Maybe<Scalars['date']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  no_of_employees?: Maybe<Scalars['numeric']>;
  onboarding_customer_email_id_1?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_2?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_3?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_4?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_5?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_6?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_7?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_8?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_9?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_10?: Maybe<Scalars['String']>;
  order_initial_term?: Maybe<Scalars['numeric']>;
  order_renewal_term?: Maybe<Scalars['numeric']>;
  other_churn_reason?: Maybe<Scalars['String']>;
  payment_term_for_terminated_services?: Maybe<Scalars['numeric']>;
  payment_terms?: Maybe<Scalars['String']>;
  payment_terms_in_days?: Maybe<Scalars['numeric']>;
  phone?: Maybe<Scalars['String']>;
  planner?: Maybe<Scalars['String']>;
  planner_url?: Maybe<Scalars['String']>;
  platform_tier?: Maybe<Scalars['String']>;
  preferred_payment_channel?: Maybe<Scalars['String']>;
  price_escalation?: Maybe<Scalars['String']>;
  price_escalation_period?: Maybe<Scalars['numeric']>;
  products_with_limitations?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  revenue_group_1?: Maybe<Scalars['String']>;
  revenue_group_2?: Maybe<Scalars['String']>;
  salesforce_accountmanager_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_csm_id?: Maybe<Scalars['String']>;
  salesforce_geohead_id?: Maybe<Scalars['String']>;
  /** Primary key from salesforce, used only for updates. */
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_parent_id?: Maybe<Scalars['String']>;
  salesforce_record_type_id?: Maybe<Scalars['String']>;
  salesforce_salesrep_id?: Maybe<Scalars['String']>;
  security_deposit?: Maybe<Scalars['String']>;
  self_service_access?: Maybe<Scalars['String']>;
  service_tier?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['numeric']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  tam?: Maybe<Scalars['String']>;
  termination_details?: Maybe<Scalars['String']>;
  termination_due_to_platform_notice?: Maybe<Scalars['numeric']>;
  thunderstorm?: Maybe<Scalars['String']>;
  thunderstorm_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  yearly_escalation_percentage?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "account" */
export type Account_Min_Order_By = {
  account_category?: InputMaybe<Order_By>;
  account_creation_date?: InputMaybe<Order_By>;
  account_currency?: InputMaybe<Order_By>;
  account_deactivation_date?: InputMaybe<Order_By>;
  account_legal_name?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  ad_revenue_model?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_1?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_2?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_3?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_4?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_5?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_6?: InputMaybe<Order_By>;
  amagi_id?: InputMaybe<Order_By>;
  amagi_now?: InputMaybe<Order_By>;
  amagi_now_url?: InputMaybe<Order_By>;
  bill_to_contact?: InputMaybe<Order_By>;
  billing_date_rule?: InputMaybe<Order_By>;
  billing_term?: InputMaybe<Order_By>;
  billing_threshold_rule?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  business_category?: InputMaybe<Order_By>;
  c_plus_percentage_share?: InputMaybe<Order_By>;
  cdpderived_revenue_segment?: InputMaybe<Order_By>;
  churn_effective_date?: InputMaybe<Order_By>;
  churn_requested_by?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  churn_type?: InputMaybe<Order_By>;
  cloudport?: InputMaybe<Order_By>;
  cloudport_url?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  company_category?: InputMaybe<Order_By>;
  connect_msa_effective_date?: InputMaybe<Order_By>;
  content_plus_customer_email_id_1?: InputMaybe<Order_By>;
  content_plus_customer_email_id_2?: InputMaybe<Order_By>;
  content_plus_customer_email_id_3?: InputMaybe<Order_By>;
  content_plus_customer_email_id_4?: InputMaybe<Order_By>;
  content_plus_customer_email_id_5?: InputMaybe<Order_By>;
  content_plus_customer_email_id_6?: InputMaybe<Order_By>;
  content_plus_internal_email_id?: InputMaybe<Order_By>;
  content_plus_owner?: InputMaybe<Order_By>;
  cplus_msa_effective_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_period_in_days?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_business_model?: InputMaybe<Order_By>;
  customer_churn_reason?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_financial_risk_category?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_origin?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customer_scale?: InputMaybe<Order_By>;
  customer_since_date?: InputMaybe<Order_By>;
  customer_tier?: InputMaybe<Order_By>;
  customer_type?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  deposit_amount_mrr_months?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dso?: InputMaybe<Order_By>;
  entitled_to_stop_services_after?: InputMaybe<Order_By>;
  first_invoice_date?: InputMaybe<Order_By>;
  industry_segment?: InputMaybe<Order_By>;
  interest_percent_applicable_post_due_date?: InputMaybe<Order_By>;
  invoicing_currency?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  legal_entity_id?: InputMaybe<Order_By>;
  legal_entity_name?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  monetization_preference?: InputMaybe<Order_By>;
  msa_effective_date?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  onboarding_customer_email_id_1?: InputMaybe<Order_By>;
  onboarding_customer_email_id_2?: InputMaybe<Order_By>;
  onboarding_customer_email_id_3?: InputMaybe<Order_By>;
  onboarding_customer_email_id_4?: InputMaybe<Order_By>;
  onboarding_customer_email_id_5?: InputMaybe<Order_By>;
  onboarding_customer_email_id_6?: InputMaybe<Order_By>;
  onboarding_customer_email_id_7?: InputMaybe<Order_By>;
  onboarding_customer_email_id_8?: InputMaybe<Order_By>;
  onboarding_customer_email_id_9?: InputMaybe<Order_By>;
  onboarding_customer_email_id_10?: InputMaybe<Order_By>;
  order_initial_term?: InputMaybe<Order_By>;
  order_renewal_term?: InputMaybe<Order_By>;
  other_churn_reason?: InputMaybe<Order_By>;
  payment_term_for_terminated_services?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  planner?: InputMaybe<Order_By>;
  planner_url?: InputMaybe<Order_By>;
  platform_tier?: InputMaybe<Order_By>;
  preferred_payment_channel?: InputMaybe<Order_By>;
  price_escalation?: InputMaybe<Order_By>;
  price_escalation_period?: InputMaybe<Order_By>;
  products_with_limitations?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  revenue_group_1?: InputMaybe<Order_By>;
  revenue_group_2?: InputMaybe<Order_By>;
  salesforce_accountmanager_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_csm_id?: InputMaybe<Order_By>;
  salesforce_geohead_id?: InputMaybe<Order_By>;
  /** Primary key from salesforce, used only for updates. */
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_parent_id?: InputMaybe<Order_By>;
  salesforce_record_type_id?: InputMaybe<Order_By>;
  salesforce_salesrep_id?: InputMaybe<Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  self_service_access?: InputMaybe<Order_By>;
  service_tier?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  so_cancel_notice_after_oit?: InputMaybe<Order_By>;
  so_cancel_notice_during_oit?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tam?: InputMaybe<Order_By>;
  termination_details?: InputMaybe<Order_By>;
  termination_due_to_platform_notice?: InputMaybe<Order_By>;
  thunderstorm?: InputMaybe<Order_By>;
  thunderstorm_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_escalation_percentage?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "account" */
export type Account_Mutation_Response = {
  __typename?: 'account_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Account>;
};

/** Ordering options when selecting data from "account". */
export type Account_Order_By = {
  account_category?: InputMaybe<Order_By>;
  account_creation_date?: InputMaybe<Order_By>;
  account_currency?: InputMaybe<Order_By>;
  account_deactivation_date?: InputMaybe<Order_By>;
  account_legal_name?: InputMaybe<Order_By>;
  account_manager?: InputMaybe<Owner_Order_By>;
  account_name?: InputMaybe<Order_By>;
  ad_revenue_model?: InputMaybe<Order_By>;
  address?: InputMaybe<Company_Address_Order_By>;
  ads_plus_customer_email_id_1?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_2?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_3?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_4?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_5?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_6?: InputMaybe<Order_By>;
  amagi_id?: InputMaybe<Order_By>;
  amagi_now?: InputMaybe<Order_By>;
  amagi_now_url?: InputMaybe<Order_By>;
  bill_to_contact?: InputMaybe<Order_By>;
  billing_address?: InputMaybe<Order_By>;
  billing_contact?: InputMaybe<Order_By>;
  billing_date_rule?: InputMaybe<Order_By>;
  billing_term?: InputMaybe<Order_By>;
  billing_threshold_rule?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  business_category?: InputMaybe<Order_By>;
  c_plus_percentage_share?: InputMaybe<Order_By>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  cdpderived_revenue_segment?: InputMaybe<Order_By>;
  channels_aggregate?: InputMaybe<Channel_Aggregate_Order_By>;
  children_aggregate?: InputMaybe<Account_Aggregate_Order_By>;
  churn_effective_date?: InputMaybe<Order_By>;
  churn_requested_by?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  churn_type?: InputMaybe<Order_By>;
  cloud_region?: InputMaybe<Order_By>;
  cloud_service_provider?: InputMaybe<Order_By>;
  cloudport?: InputMaybe<Order_By>;
  cloudport_url?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  company_category?: InputMaybe<Order_By>;
  connect_msa_effective_date?: InputMaybe<Order_By>;
  contacts_aggregate?: InputMaybe<Contact_Aggregate_Order_By>;
  content_plus_customer_email_id_1?: InputMaybe<Order_By>;
  content_plus_customer_email_id_2?: InputMaybe<Order_By>;
  content_plus_customer_email_id_3?: InputMaybe<Order_By>;
  content_plus_customer_email_id_4?: InputMaybe<Order_By>;
  content_plus_customer_email_id_5?: InputMaybe<Order_By>;
  content_plus_customer_email_id_6?: InputMaybe<Order_By>;
  content_plus_internal_email_id?: InputMaybe<Order_By>;
  content_plus_owner?: InputMaybe<Order_By>;
  cplus_msa_effective_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_period_in_days?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  csm?: InputMaybe<Owner_Order_By>;
  customer_business_model?: InputMaybe<Order_By>;
  customer_churn_reason?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_financial_risk_category?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_origin?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customer_scale?: InputMaybe<Order_By>;
  customer_since_date?: InputMaybe<Order_By>;
  customer_tier?: InputMaybe<Order_By>;
  customer_type?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  deposit_amount_mrr_months?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dso?: InputMaybe<Order_By>;
  entitled_to_stop_services_after?: InputMaybe<Order_By>;
  first_invoice_date?: InputMaybe<Order_By>;
  industry_segment?: InputMaybe<Order_By>;
  interest_percent_applicable_post_due_date?: InputMaybe<Order_By>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Order_By>;
  invoicing_currency?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_msa_ratecard_customer?: InputMaybe<Order_By>;
  is_ono?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  legal_entity?: InputMaybe<Legal_Entity_Order_By>;
  legal_entity_id?: InputMaybe<Order_By>;
  legal_entity_name?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  media_industry_sub_segment?: InputMaybe<Media_Industry_Sub_Segment_Order_By>;
  monetization_preference?: InputMaybe<Order_By>;
  msa_effective_date?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  onboarding_customer_email_id_1?: InputMaybe<Order_By>;
  onboarding_customer_email_id_2?: InputMaybe<Order_By>;
  onboarding_customer_email_id_3?: InputMaybe<Order_By>;
  onboarding_customer_email_id_4?: InputMaybe<Order_By>;
  onboarding_customer_email_id_5?: InputMaybe<Order_By>;
  onboarding_customer_email_id_6?: InputMaybe<Order_By>;
  onboarding_customer_email_id_7?: InputMaybe<Order_By>;
  onboarding_customer_email_id_8?: InputMaybe<Order_By>;
  onboarding_customer_email_id_9?: InputMaybe<Order_By>;
  onboarding_customer_email_id_10?: InputMaybe<Order_By>;
  order_initial_term?: InputMaybe<Order_By>;
  order_renewal_term?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Order_By>;
  other_churn_reason?: InputMaybe<Order_By>;
  owner?: InputMaybe<Owner_Order_By>;
  parent?: InputMaybe<Account_Order_By>;
  payment_due_on_receipt?: InputMaybe<Order_By>;
  payment_term_for_terminated_services?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  planner?: InputMaybe<Order_By>;
  planner_url?: InputMaybe<Order_By>;
  platform_tier?: InputMaybe<Order_By>;
  platforms_aggregate?: InputMaybe<Platform_Aggregate_Order_By>;
  preferred_payment_channel?: InputMaybe<Order_By>;
  price_escalation?: InputMaybe<Order_By>;
  price_escalation_period?: InputMaybe<Order_By>;
  products_with_limitations?: InputMaybe<Order_By>;
  quotes_aggregate?: InputMaybe<Quote_Aggregate_Order_By>;
  record_type?: InputMaybe<Record_Type_Order_By>;
  region?: InputMaybe<Order_By>;
  revenue_group_1?: InputMaybe<Order_By>;
  revenue_group_2?: InputMaybe<Order_By>;
  salesforce_accountmanager_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_csm_id?: InputMaybe<Order_By>;
  salesforce_geohead_id?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_parent_id?: InputMaybe<Order_By>;
  salesforce_record_type_id?: InputMaybe<Order_By>;
  salesforce_salesrep_id?: InputMaybe<Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  segment?: InputMaybe<Segment_Order_By>;
  self_service_access?: InputMaybe<Order_By>;
  service_tier?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  so_cancel_notice_after_oit?: InputMaybe<Order_By>;
  so_cancel_notice_during_oit?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tam?: InputMaybe<Order_By>;
  termination_details?: InputMaybe<Order_By>;
  termination_due_to_platform_notice?: InputMaybe<Order_By>;
  thunderstorm?: InputMaybe<Order_By>;
  thunderstorm_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_escalation_percentage?: InputMaybe<Order_By>;
};

/** primary key columns input for table: account */
export type Account_Pk_Columns_Input = {
  /** Primary key from salesforce, used only for updates. */
  salesforce_id: Scalars['String'];
};

/** select columns of table "account" */
export enum Account_Select_Column {
  /** column name */
  AccountCategory = 'account_category',
  /** column name */
  AccountCreationDate = 'account_creation_date',
  /** column name */
  AccountCurrency = 'account_currency',
  /** column name */
  AccountDeactivationDate = 'account_deactivation_date',
  /** column name */
  AccountLegalName = 'account_legal_name',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  AdRevenueModel = 'ad_revenue_model',
  /** column name */
  AdsPlusCustomerEmailId_1 = 'ads_plus_customer_email_id_1',
  /** column name */
  AdsPlusCustomerEmailId_2 = 'ads_plus_customer_email_id_2',
  /** column name */
  AdsPlusCustomerEmailId_3 = 'ads_plus_customer_email_id_3',
  /** column name */
  AdsPlusCustomerEmailId_4 = 'ads_plus_customer_email_id_4',
  /** column name */
  AdsPlusCustomerEmailId_5 = 'ads_plus_customer_email_id_5',
  /** column name */
  AdsPlusCustomerEmailId_6 = 'ads_plus_customer_email_id_6',
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  AmagiNow = 'amagi_now',
  /** column name */
  AmagiNowUrl = 'amagi_now_url',
  /** column name */
  BillToContact = 'bill_to_contact',
  /** column name */
  BillingAddress = 'billing_address',
  /** column name */
  BillingContact = 'billing_contact',
  /** column name */
  BillingDateRule = 'billing_date_rule',
  /** column name */
  BillingTerm = 'billing_term',
  /** column name */
  BillingThresholdRule = 'billing_threshold_rule',
  /** column name */
  BillingType = 'billing_type',
  /** column name */
  BusinessCategory = 'business_category',
  /** column name */
  CPlusPercentageShare = 'c_plus_percentage_share',
  /** column name */
  CdpderivedRevenueSegment = 'cdpderived_revenue_segment',
  /** column name */
  ChurnEffectiveDate = 'churn_effective_date',
  /** column name */
  ChurnRequestedBy = 'churn_requested_by',
  /** column name */
  ChurnRiskPercentage = 'churn_risk_percentage',
  /** column name */
  ChurnType = 'churn_type',
  /** column name */
  CloudRegion = 'cloud_region',
  /** column name */
  CloudServiceProvider = 'cloud_service_provider',
  /** column name */
  Cloudport = 'cloudport',
  /** column name */
  CloudportUrl = 'cloudport_url',
  /** column name */
  Comments = 'comments',
  /** column name */
  CompanyCategory = 'company_category',
  /** column name */
  ConnectMsaEffectiveDate = 'connect_msa_effective_date',
  /** column name */
  ContentPlusCustomerEmailId_1 = 'content_plus_customer_email_id_1',
  /** column name */
  ContentPlusCustomerEmailId_2 = 'content_plus_customer_email_id_2',
  /** column name */
  ContentPlusCustomerEmailId_3 = 'content_plus_customer_email_id_3',
  /** column name */
  ContentPlusCustomerEmailId_4 = 'content_plus_customer_email_id_4',
  /** column name */
  ContentPlusCustomerEmailId_5 = 'content_plus_customer_email_id_5',
  /** column name */
  ContentPlusCustomerEmailId_6 = 'content_plus_customer_email_id_6',
  /** column name */
  ContentPlusInternalEmailId = 'content_plus_internal_email_id',
  /** column name */
  ContentPlusOwner = 'content_plus_owner',
  /** column name */
  CplusMsaEffectiveDate = 'cplus_msa_effective_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditPeriodInDays = 'credit_period_in_days',
  /** column name */
  CreditScore = 'credit_score',
  /** column name */
  CustomerBusinessModel = 'customer_business_model',
  /** column name */
  CustomerChurnReason = 'customer_churn_reason',
  /** column name */
  CustomerContractPeriod = 'customer_contract_period',
  /** column name */
  CustomerFinancialRiskCategory = 'customer_financial_risk_category',
  /** column name */
  CustomerLifeTimeValue = 'customer_life_time_value',
  /** column name */
  CustomerOrigin = 'customer_origin',
  /** column name */
  CustomerRevenueForPreviousYear = 'customer_revenue_for_previous_year',
  /** column name */
  CustomerRevenueForThePresentYear = 'customer_revenue_for_the_present_year',
  /** column name */
  CustomerScale = 'customer_scale',
  /** column name */
  CustomerSinceDate = 'customer_since_date',
  /** column name */
  CustomerTier = 'customer_tier',
  /** column name */
  CustomerType = 'customer_type',
  /** column name */
  CustomersProfitForPreviousYear = 'customers_profit_for_previous_year',
  /** column name */
  CustomersProfitForThePresentYear = 'customers_profit_for_the_present_year',
  /** column name */
  DepositAmountMrrMonths = 'deposit_amount_mrr_months',
  /** column name */
  Description = 'description',
  /** column name */
  Dso = 'dso',
  /** column name */
  EntitledToStopServicesAfter = 'entitled_to_stop_services_after',
  /** column name */
  FirstInvoiceDate = 'first_invoice_date',
  /** column name */
  IndustrySegment = 'industry_segment',
  /** column name */
  InterestPercentApplicablePostDueDate = 'interest_percent_applicable_post_due_date',
  /** column name */
  InvoicingCurrency = 'invoicing_currency',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMsaRatecardCustomer = 'is_msa_ratecard_customer',
  /** column name */
  IsOno = 'is_ono',
  /** column name */
  Language = 'language',
  /** column name */
  LegalEntityId = 'legal_entity_id',
  /** column name */
  LegalEntityName = 'legal_entity_name',
  /** column name */
  Logo = 'logo',
  /** column name */
  MonetizationPreference = 'monetization_preference',
  /** column name */
  MsaEffectiveDate = 'msa_effective_date',
  /** column name */
  NetsuiteId = 'netsuite_id',
  /** column name */
  NoOfEmployees = 'no_of_employees',
  /** column name */
  OnboardingCustomerEmailId_1 = 'onboarding_customer_email_id_1',
  /** column name */
  OnboardingCustomerEmailId_2 = 'onboarding_customer_email_id_2',
  /** column name */
  OnboardingCustomerEmailId_3 = 'onboarding_customer_email_id_3',
  /** column name */
  OnboardingCustomerEmailId_4 = 'onboarding_customer_email_id_4',
  /** column name */
  OnboardingCustomerEmailId_5 = 'onboarding_customer_email_id_5',
  /** column name */
  OnboardingCustomerEmailId_6 = 'onboarding_customer_email_id_6',
  /** column name */
  OnboardingCustomerEmailId_7 = 'onboarding_customer_email_id_7',
  /** column name */
  OnboardingCustomerEmailId_8 = 'onboarding_customer_email_id_8',
  /** column name */
  OnboardingCustomerEmailId_9 = 'onboarding_customer_email_id_9',
  /** column name */
  OnboardingCustomerEmailId_10 = 'onboarding_customer_email_id_10',
  /** column name */
  OrderInitialTerm = 'order_initial_term',
  /** column name */
  OrderRenewalTerm = 'order_renewal_term',
  /** column name */
  OtherChurnReason = 'other_churn_reason',
  /** column name */
  PaymentDueOnReceipt = 'payment_due_on_receipt',
  /** column name */
  PaymentTermForTerminatedServices = 'payment_term_for_terminated_services',
  /** column name */
  PaymentTerms = 'payment_terms',
  /** column name */
  PaymentTermsInDays = 'payment_terms_in_days',
  /** column name */
  Phone = 'phone',
  /** column name */
  Planner = 'planner',
  /** column name */
  PlannerUrl = 'planner_url',
  /** column name */
  PlatformTier = 'platform_tier',
  /** column name */
  PreferredPaymentChannel = 'preferred_payment_channel',
  /** column name */
  PriceEscalation = 'price_escalation',
  /** column name */
  PriceEscalationPeriod = 'price_escalation_period',
  /** column name */
  ProductsWithLimitations = 'products_with_limitations',
  /** column name */
  Region = 'region',
  /** column name */
  RevenueGroup_1 = 'revenue_group_1',
  /** column name */
  RevenueGroup_2 = 'revenue_group_2',
  /** column name */
  SalesforceAccountmanagerId = 'salesforce_accountmanager_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceCsmId = 'salesforce_csm_id',
  /** column name */
  SalesforceGeoheadId = 'salesforce_geohead_id',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  SalesforceOwnerId = 'salesforce_owner_id',
  /** column name */
  SalesforceParentId = 'salesforce_parent_id',
  /** column name */
  SalesforceRecordTypeId = 'salesforce_record_type_id',
  /** column name */
  SalesforceSalesrepId = 'salesforce_salesrep_id',
  /** column name */
  SecurityDeposit = 'security_deposit',
  /** column name */
  SelfServiceAccess = 'self_service_access',
  /** column name */
  ServiceTier = 'service_tier',
  /** column name */
  Size = 'size',
  /** column name */
  SoCancelNoticeAfterOit = 'so_cancel_notice_after_oit',
  /** column name */
  SoCancelNoticeDuringOit = 'so_cancel_notice_during_oit',
  /** column name */
  Status = 'status',
  /** column name */
  Tam = 'tam',
  /** column name */
  TerminationDetails = 'termination_details',
  /** column name */
  TerminationDueToPlatformNotice = 'termination_due_to_platform_notice',
  /** column name */
  Thunderstorm = 'thunderstorm',
  /** column name */
  ThunderstormUrl = 'thunderstorm_url',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  YearlyEscalationPercentage = 'yearly_escalation_percentage'
}

/** select "account_aggregate_bool_exp_bool_and_arguments_columns" columns of table "account" */
export enum Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMsaRatecardCustomer = 'is_msa_ratecard_customer',
  /** column name */
  IsOno = 'is_ono',
  /** column name */
  PaymentDueOnReceipt = 'payment_due_on_receipt'
}

/** select "account_aggregate_bool_exp_bool_or_arguments_columns" columns of table "account" */
export enum Account_Select_Column_Account_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMsaRatecardCustomer = 'is_msa_ratecard_customer',
  /** column name */
  IsOno = 'is_ono',
  /** column name */
  PaymentDueOnReceipt = 'payment_due_on_receipt'
}

/** input type for updating data in table "account" */
export type Account_Set_Input = {
  account_deactivation_date?: InputMaybe<Scalars['date']>;
  ad_revenue_model?: InputMaybe<Scalars['String']>;
  amagi_now?: InputMaybe<Scalars['String']>;
  amagi_now_url?: InputMaybe<Scalars['String']>;
  c_plus_percentage_share?: InputMaybe<Scalars['numeric']>;
  churn_risk_percentage?: InputMaybe<Scalars['numeric']>;
  cloudport?: InputMaybe<Scalars['String']>;
  cloudport_url?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  credit_score?: InputMaybe<Scalars['numeric']>;
  customer_business_model?: InputMaybe<Scalars['String']>;
  customer_life_time_value?: InputMaybe<Scalars['numeric']>;
  customer_type?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dso?: InputMaybe<Scalars['String']>;
  industry_segment?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_ono?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  monetization_preference?: InputMaybe<Scalars['String']>;
  planner?: InputMaybe<Scalars['String']>;
  planner_url?: InputMaybe<Scalars['String']>;
  platform_tier?: InputMaybe<Scalars['String']>;
  preferred_payment_channel?: InputMaybe<Scalars['String']>;
  revenue_group_1?: InputMaybe<Scalars['String']>;
  revenue_group_2?: InputMaybe<Scalars['String']>;
  self_service_access?: InputMaybe<Scalars['String']>;
  service_tier?: InputMaybe<Scalars['String']>;
  thunderstorm?: InputMaybe<Scalars['String']>;
  thunderstorm_url?: InputMaybe<Scalars['String']>;
};

export type Account_Statement_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Account_Statement_Meta_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Account_Statement_Outstanding_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
};

export type Account_Statement_Summary_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Account_Stddev_Fields = {
  __typename?: 'account_stddev_fields';
  c_plus_percentage_share?: Maybe<Scalars['Float']>;
  churn_risk_percentage?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Float']>;
  customer_contract_period?: Maybe<Scalars['Float']>;
  customer_life_time_value?: Maybe<Scalars['Float']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['Float']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['Float']>;
  customers_profit_for_previous_year?: Maybe<Scalars['Float']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['Float']>;
  deposit_amount_mrr_months?: Maybe<Scalars['Float']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  no_of_employees?: Maybe<Scalars['Float']>;
  order_initial_term?: Maybe<Scalars['Float']>;
  order_renewal_term?: Maybe<Scalars['Float']>;
  payment_term_for_terminated_services?: Maybe<Scalars['Float']>;
  payment_terms_in_days?: Maybe<Scalars['Float']>;
  price_escalation_period?: Maybe<Scalars['Float']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['Float']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['Float']>;
  termination_due_to_platform_notice?: Maybe<Scalars['Float']>;
  yearly_escalation_percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "account" */
export type Account_Stddev_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  deposit_amount_mrr_months?: InputMaybe<Order_By>;
  interest_percent_applicable_post_due_date?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  order_initial_term?: InputMaybe<Order_By>;
  order_renewal_term?: InputMaybe<Order_By>;
  payment_term_for_terminated_services?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
  price_escalation_period?: InputMaybe<Order_By>;
  so_cancel_notice_after_oit?: InputMaybe<Order_By>;
  so_cancel_notice_during_oit?: InputMaybe<Order_By>;
  termination_due_to_platform_notice?: InputMaybe<Order_By>;
  yearly_escalation_percentage?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Account_Stddev_Pop_Fields = {
  __typename?: 'account_stddev_pop_fields';
  c_plus_percentage_share?: Maybe<Scalars['Float']>;
  churn_risk_percentage?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Float']>;
  customer_contract_period?: Maybe<Scalars['Float']>;
  customer_life_time_value?: Maybe<Scalars['Float']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['Float']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['Float']>;
  customers_profit_for_previous_year?: Maybe<Scalars['Float']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['Float']>;
  deposit_amount_mrr_months?: Maybe<Scalars['Float']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  no_of_employees?: Maybe<Scalars['Float']>;
  order_initial_term?: Maybe<Scalars['Float']>;
  order_renewal_term?: Maybe<Scalars['Float']>;
  payment_term_for_terminated_services?: Maybe<Scalars['Float']>;
  payment_terms_in_days?: Maybe<Scalars['Float']>;
  price_escalation_period?: Maybe<Scalars['Float']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['Float']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['Float']>;
  termination_due_to_platform_notice?: Maybe<Scalars['Float']>;
  yearly_escalation_percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "account" */
export type Account_Stddev_Pop_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  deposit_amount_mrr_months?: InputMaybe<Order_By>;
  interest_percent_applicable_post_due_date?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  order_initial_term?: InputMaybe<Order_By>;
  order_renewal_term?: InputMaybe<Order_By>;
  payment_term_for_terminated_services?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
  price_escalation_period?: InputMaybe<Order_By>;
  so_cancel_notice_after_oit?: InputMaybe<Order_By>;
  so_cancel_notice_during_oit?: InputMaybe<Order_By>;
  termination_due_to_platform_notice?: InputMaybe<Order_By>;
  yearly_escalation_percentage?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Account_Stddev_Samp_Fields = {
  __typename?: 'account_stddev_samp_fields';
  c_plus_percentage_share?: Maybe<Scalars['Float']>;
  churn_risk_percentage?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Float']>;
  customer_contract_period?: Maybe<Scalars['Float']>;
  customer_life_time_value?: Maybe<Scalars['Float']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['Float']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['Float']>;
  customers_profit_for_previous_year?: Maybe<Scalars['Float']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['Float']>;
  deposit_amount_mrr_months?: Maybe<Scalars['Float']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  no_of_employees?: Maybe<Scalars['Float']>;
  order_initial_term?: Maybe<Scalars['Float']>;
  order_renewal_term?: Maybe<Scalars['Float']>;
  payment_term_for_terminated_services?: Maybe<Scalars['Float']>;
  payment_terms_in_days?: Maybe<Scalars['Float']>;
  price_escalation_period?: Maybe<Scalars['Float']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['Float']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['Float']>;
  termination_due_to_platform_notice?: Maybe<Scalars['Float']>;
  yearly_escalation_percentage?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "account" */
export type Account_Stddev_Samp_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  deposit_amount_mrr_months?: InputMaybe<Order_By>;
  interest_percent_applicable_post_due_date?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  order_initial_term?: InputMaybe<Order_By>;
  order_renewal_term?: InputMaybe<Order_By>;
  payment_term_for_terminated_services?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
  price_escalation_period?: InputMaybe<Order_By>;
  so_cancel_notice_after_oit?: InputMaybe<Order_By>;
  so_cancel_notice_during_oit?: InputMaybe<Order_By>;
  termination_due_to_platform_notice?: InputMaybe<Order_By>;
  yearly_escalation_percentage?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "account" */
export type Account_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Account_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Account_Stream_Cursor_Value_Input = {
  account_category?: InputMaybe<Scalars['String']>;
  account_creation_date?: InputMaybe<Scalars['date']>;
  account_currency?: InputMaybe<Scalars['String']>;
  account_deactivation_date?: InputMaybe<Scalars['date']>;
  account_legal_name?: InputMaybe<Scalars['String']>;
  account_name?: InputMaybe<Scalars['String']>;
  ad_revenue_model?: InputMaybe<Scalars['String']>;
  ads_plus_customer_email_id_1?: InputMaybe<Scalars['String']>;
  ads_plus_customer_email_id_2?: InputMaybe<Scalars['String']>;
  ads_plus_customer_email_id_3?: InputMaybe<Scalars['String']>;
  ads_plus_customer_email_id_4?: InputMaybe<Scalars['String']>;
  ads_plus_customer_email_id_5?: InputMaybe<Scalars['String']>;
  ads_plus_customer_email_id_6?: InputMaybe<Scalars['String']>;
  amagi_id?: InputMaybe<Scalars['String']>;
  amagi_now?: InputMaybe<Scalars['String']>;
  amagi_now_url?: InputMaybe<Scalars['String']>;
  bill_to_contact?: InputMaybe<Scalars['String']>;
  billing_address?: InputMaybe<Scalars['jsonb']>;
  billing_contact?: InputMaybe<Scalars['jsonb']>;
  billing_date_rule?: InputMaybe<Scalars['String']>;
  billing_term?: InputMaybe<Scalars['String']>;
  billing_threshold_rule?: InputMaybe<Scalars['String']>;
  billing_type?: InputMaybe<Scalars['String']>;
  business_category?: InputMaybe<Scalars['String']>;
  c_plus_percentage_share?: InputMaybe<Scalars['numeric']>;
  cdpderived_revenue_segment?: InputMaybe<Scalars['String']>;
  churn_effective_date?: InputMaybe<Scalars['date']>;
  churn_requested_by?: InputMaybe<Scalars['String']>;
  churn_risk_percentage?: InputMaybe<Scalars['numeric']>;
  churn_type?: InputMaybe<Scalars['String']>;
  cloud_region?: InputMaybe<Scalars['jsonb']>;
  cloud_service_provider?: InputMaybe<Scalars['jsonb']>;
  cloudport?: InputMaybe<Scalars['String']>;
  cloudport_url?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  company_category?: InputMaybe<Scalars['String']>;
  connect_msa_effective_date?: InputMaybe<Scalars['date']>;
  content_plus_customer_email_id_1?: InputMaybe<Scalars['String']>;
  content_plus_customer_email_id_2?: InputMaybe<Scalars['String']>;
  content_plus_customer_email_id_3?: InputMaybe<Scalars['String']>;
  content_plus_customer_email_id_4?: InputMaybe<Scalars['String']>;
  content_plus_customer_email_id_5?: InputMaybe<Scalars['String']>;
  content_plus_customer_email_id_6?: InputMaybe<Scalars['String']>;
  content_plus_internal_email_id?: InputMaybe<Scalars['String']>;
  content_plus_owner?: InputMaybe<Scalars['String']>;
  cplus_msa_effective_date?: InputMaybe<Scalars['date']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credit_period_in_days?: InputMaybe<Scalars['String']>;
  credit_score?: InputMaybe<Scalars['numeric']>;
  customer_business_model?: InputMaybe<Scalars['String']>;
  customer_churn_reason?: InputMaybe<Scalars['String']>;
  customer_contract_period?: InputMaybe<Scalars['numeric']>;
  customer_financial_risk_category?: InputMaybe<Scalars['String']>;
  customer_life_time_value?: InputMaybe<Scalars['numeric']>;
  customer_origin?: InputMaybe<Scalars['String']>;
  customer_revenue_for_previous_year?: InputMaybe<Scalars['numeric']>;
  customer_revenue_for_the_present_year?: InputMaybe<Scalars['numeric']>;
  customer_scale?: InputMaybe<Scalars['String']>;
  customer_since_date?: InputMaybe<Scalars['timestamptz']>;
  customer_tier?: InputMaybe<Scalars['String']>;
  customer_type?: InputMaybe<Scalars['String']>;
  customers_profit_for_previous_year?: InputMaybe<Scalars['numeric']>;
  customers_profit_for_the_present_year?: InputMaybe<Scalars['numeric']>;
  deposit_amount_mrr_months?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  dso?: InputMaybe<Scalars['String']>;
  entitled_to_stop_services_after?: InputMaybe<Scalars['String']>;
  first_invoice_date?: InputMaybe<Scalars['date']>;
  industry_segment?: InputMaybe<Scalars['String']>;
  interest_percent_applicable_post_due_date?: InputMaybe<Scalars['numeric']>;
  invoicing_currency?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_msa_ratecard_customer?: InputMaybe<Scalars['Boolean']>;
  is_ono?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  legal_entity_id?: InputMaybe<Scalars['String']>;
  legal_entity_name?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  monetization_preference?: InputMaybe<Scalars['String']>;
  msa_effective_date?: InputMaybe<Scalars['date']>;
  netsuite_id?: InputMaybe<Scalars['numeric']>;
  no_of_employees?: InputMaybe<Scalars['numeric']>;
  onboarding_customer_email_id_1?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_2?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_3?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_4?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_5?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_6?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_7?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_8?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_9?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_10?: InputMaybe<Scalars['String']>;
  order_initial_term?: InputMaybe<Scalars['numeric']>;
  order_renewal_term?: InputMaybe<Scalars['numeric']>;
  other_churn_reason?: InputMaybe<Scalars['String']>;
  payment_due_on_receipt?: InputMaybe<Scalars['Boolean']>;
  payment_term_for_terminated_services?: InputMaybe<Scalars['numeric']>;
  payment_terms?: InputMaybe<Scalars['String']>;
  payment_terms_in_days?: InputMaybe<Scalars['numeric']>;
  phone?: InputMaybe<Scalars['String']>;
  planner?: InputMaybe<Scalars['String']>;
  planner_url?: InputMaybe<Scalars['String']>;
  platform_tier?: InputMaybe<Scalars['String']>;
  preferred_payment_channel?: InputMaybe<Scalars['String']>;
  price_escalation?: InputMaybe<Scalars['String']>;
  price_escalation_period?: InputMaybe<Scalars['numeric']>;
  products_with_limitations?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  revenue_group_1?: InputMaybe<Scalars['String']>;
  revenue_group_2?: InputMaybe<Scalars['String']>;
  salesforce_accountmanager_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_csm_id?: InputMaybe<Scalars['String']>;
  salesforce_geohead_id?: InputMaybe<Scalars['String']>;
  /** Primary key from salesforce, used only for updates. */
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_owner_id?: InputMaybe<Scalars['String']>;
  salesforce_parent_id?: InputMaybe<Scalars['String']>;
  salesforce_record_type_id?: InputMaybe<Scalars['String']>;
  salesforce_salesrep_id?: InputMaybe<Scalars['String']>;
  security_deposit?: InputMaybe<Scalars['String']>;
  self_service_access?: InputMaybe<Scalars['String']>;
  service_tier?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  so_cancel_notice_after_oit?: InputMaybe<Scalars['numeric']>;
  so_cancel_notice_during_oit?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['String']>;
  tam?: InputMaybe<Scalars['String']>;
  termination_details?: InputMaybe<Scalars['String']>;
  termination_due_to_platform_notice?: InputMaybe<Scalars['numeric']>;
  thunderstorm?: InputMaybe<Scalars['String']>;
  thunderstorm_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  yearly_escalation_percentage?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Account_Sum_Fields = {
  __typename?: 'account_sum_fields';
  c_plus_percentage_share?: Maybe<Scalars['numeric']>;
  churn_risk_percentage?: Maybe<Scalars['numeric']>;
  credit_score?: Maybe<Scalars['numeric']>;
  customer_contract_period?: Maybe<Scalars['numeric']>;
  customer_life_time_value?: Maybe<Scalars['numeric']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['numeric']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['numeric']>;
  customers_profit_for_previous_year?: Maybe<Scalars['numeric']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['numeric']>;
  deposit_amount_mrr_months?: Maybe<Scalars['numeric']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  no_of_employees?: Maybe<Scalars['numeric']>;
  order_initial_term?: Maybe<Scalars['numeric']>;
  order_renewal_term?: Maybe<Scalars['numeric']>;
  payment_term_for_terminated_services?: Maybe<Scalars['numeric']>;
  payment_terms_in_days?: Maybe<Scalars['numeric']>;
  price_escalation_period?: Maybe<Scalars['numeric']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['numeric']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['numeric']>;
  termination_due_to_platform_notice?: Maybe<Scalars['numeric']>;
  yearly_escalation_percentage?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "account" */
export type Account_Sum_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  deposit_amount_mrr_months?: InputMaybe<Order_By>;
  interest_percent_applicable_post_due_date?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  order_initial_term?: InputMaybe<Order_By>;
  order_renewal_term?: InputMaybe<Order_By>;
  payment_term_for_terminated_services?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
  price_escalation_period?: InputMaybe<Order_By>;
  so_cancel_notice_after_oit?: InputMaybe<Order_By>;
  so_cancel_notice_during_oit?: InputMaybe<Order_By>;
  termination_due_to_platform_notice?: InputMaybe<Order_By>;
  yearly_escalation_percentage?: InputMaybe<Order_By>;
};

export type Account_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Account_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Account_Set_Input>;
  /** filter the rows which have to be updated */
  where: Account_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Account_Var_Pop_Fields = {
  __typename?: 'account_var_pop_fields';
  c_plus_percentage_share?: Maybe<Scalars['Float']>;
  churn_risk_percentage?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Float']>;
  customer_contract_period?: Maybe<Scalars['Float']>;
  customer_life_time_value?: Maybe<Scalars['Float']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['Float']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['Float']>;
  customers_profit_for_previous_year?: Maybe<Scalars['Float']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['Float']>;
  deposit_amount_mrr_months?: Maybe<Scalars['Float']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  no_of_employees?: Maybe<Scalars['Float']>;
  order_initial_term?: Maybe<Scalars['Float']>;
  order_renewal_term?: Maybe<Scalars['Float']>;
  payment_term_for_terminated_services?: Maybe<Scalars['Float']>;
  payment_terms_in_days?: Maybe<Scalars['Float']>;
  price_escalation_period?: Maybe<Scalars['Float']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['Float']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['Float']>;
  termination_due_to_platform_notice?: Maybe<Scalars['Float']>;
  yearly_escalation_percentage?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "account" */
export type Account_Var_Pop_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  deposit_amount_mrr_months?: InputMaybe<Order_By>;
  interest_percent_applicable_post_due_date?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  order_initial_term?: InputMaybe<Order_By>;
  order_renewal_term?: InputMaybe<Order_By>;
  payment_term_for_terminated_services?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
  price_escalation_period?: InputMaybe<Order_By>;
  so_cancel_notice_after_oit?: InputMaybe<Order_By>;
  so_cancel_notice_during_oit?: InputMaybe<Order_By>;
  termination_due_to_platform_notice?: InputMaybe<Order_By>;
  yearly_escalation_percentage?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Account_Var_Samp_Fields = {
  __typename?: 'account_var_samp_fields';
  c_plus_percentage_share?: Maybe<Scalars['Float']>;
  churn_risk_percentage?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Float']>;
  customer_contract_period?: Maybe<Scalars['Float']>;
  customer_life_time_value?: Maybe<Scalars['Float']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['Float']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['Float']>;
  customers_profit_for_previous_year?: Maybe<Scalars['Float']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['Float']>;
  deposit_amount_mrr_months?: Maybe<Scalars['Float']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  no_of_employees?: Maybe<Scalars['Float']>;
  order_initial_term?: Maybe<Scalars['Float']>;
  order_renewal_term?: Maybe<Scalars['Float']>;
  payment_term_for_terminated_services?: Maybe<Scalars['Float']>;
  payment_terms_in_days?: Maybe<Scalars['Float']>;
  price_escalation_period?: Maybe<Scalars['Float']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['Float']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['Float']>;
  termination_due_to_platform_notice?: Maybe<Scalars['Float']>;
  yearly_escalation_percentage?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "account" */
export type Account_Var_Samp_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  deposit_amount_mrr_months?: InputMaybe<Order_By>;
  interest_percent_applicable_post_due_date?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  order_initial_term?: InputMaybe<Order_By>;
  order_renewal_term?: InputMaybe<Order_By>;
  payment_term_for_terminated_services?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
  price_escalation_period?: InputMaybe<Order_By>;
  so_cancel_notice_after_oit?: InputMaybe<Order_By>;
  so_cancel_notice_during_oit?: InputMaybe<Order_By>;
  termination_due_to_platform_notice?: InputMaybe<Order_By>;
  yearly_escalation_percentage?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Account_Variance_Fields = {
  __typename?: 'account_variance_fields';
  c_plus_percentage_share?: Maybe<Scalars['Float']>;
  churn_risk_percentage?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Float']>;
  customer_contract_period?: Maybe<Scalars['Float']>;
  customer_life_time_value?: Maybe<Scalars['Float']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['Float']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['Float']>;
  customers_profit_for_previous_year?: Maybe<Scalars['Float']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['Float']>;
  deposit_amount_mrr_months?: Maybe<Scalars['Float']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  no_of_employees?: Maybe<Scalars['Float']>;
  order_initial_term?: Maybe<Scalars['Float']>;
  order_renewal_term?: Maybe<Scalars['Float']>;
  payment_term_for_terminated_services?: Maybe<Scalars['Float']>;
  payment_terms_in_days?: Maybe<Scalars['Float']>;
  price_escalation_period?: Maybe<Scalars['Float']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['Float']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['Float']>;
  termination_due_to_platform_notice?: Maybe<Scalars['Float']>;
  yearly_escalation_percentage?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "account" */
export type Account_Variance_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  deposit_amount_mrr_months?: InputMaybe<Order_By>;
  interest_percent_applicable_post_due_date?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  order_initial_term?: InputMaybe<Order_By>;
  order_renewal_term?: InputMaybe<Order_By>;
  payment_term_for_terminated_services?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
  price_escalation_period?: InputMaybe<Order_By>;
  so_cancel_notice_after_oit?: InputMaybe<Order_By>;
  so_cancel_notice_during_oit?: InputMaybe<Order_By>;
  termination_due_to_platform_notice?: InputMaybe<Order_By>;
  yearly_escalation_percentage?: InputMaybe<Order_By>;
};

export type Actual_Revenue_Cummulative_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
};

export type Actual_Revenue_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "ads_plus_customer_contacts" */
export type Ads_Plus_Customer_Contacts = {
  __typename?: 'ads_plus_customer_contacts';
  /** An object relationship */
  ads_plus_customer_contacts?: Maybe<Customer>;
  ads_plus_customer_email_id_1?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_2?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_3?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_4?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_5?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_6?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "ads_plus_customer_contacts" */
export type Ads_Plus_Customer_Contacts_Aggregate = {
  __typename?: 'ads_plus_customer_contacts_aggregate';
  aggregate?: Maybe<Ads_Plus_Customer_Contacts_Aggregate_Fields>;
  nodes: Array<Ads_Plus_Customer_Contacts>;
};

/** aggregate fields of "ads_plus_customer_contacts" */
export type Ads_Plus_Customer_Contacts_Aggregate_Fields = {
  __typename?: 'ads_plus_customer_contacts_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Ads_Plus_Customer_Contacts_Max_Fields>;
  min?: Maybe<Ads_Plus_Customer_Contacts_Min_Fields>;
};


/** aggregate fields of "ads_plus_customer_contacts" */
export type Ads_Plus_Customer_Contacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ads_Plus_Customer_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "ads_plus_customer_contacts". All fields are combined with a logical 'AND'. */
export type Ads_Plus_Customer_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Ads_Plus_Customer_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Ads_Plus_Customer_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Ads_Plus_Customer_Contacts_Bool_Exp>>;
  ads_plus_customer_contacts?: InputMaybe<Customer_Bool_Exp>;
  ads_plus_customer_email_id_1?: InputMaybe<String_Comparison_Exp>;
  ads_plus_customer_email_id_2?: InputMaybe<String_Comparison_Exp>;
  ads_plus_customer_email_id_3?: InputMaybe<String_Comparison_Exp>;
  ads_plus_customer_email_id_4?: InputMaybe<String_Comparison_Exp>;
  ads_plus_customer_email_id_5?: InputMaybe<String_Comparison_Exp>;
  ads_plus_customer_email_id_6?: InputMaybe<String_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ads_Plus_Customer_Contacts_Max_Fields = {
  __typename?: 'ads_plus_customer_contacts_max_fields';
  ads_plus_customer_email_id_1?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_2?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_3?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_4?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_5?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_6?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Ads_Plus_Customer_Contacts_Min_Fields = {
  __typename?: 'ads_plus_customer_contacts_min_fields';
  ads_plus_customer_email_id_1?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_2?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_3?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_4?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_5?: Maybe<Scalars['String']>;
  ads_plus_customer_email_id_6?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "ads_plus_customer_contacts". */
export type Ads_Plus_Customer_Contacts_Order_By = {
  ads_plus_customer_contacts?: InputMaybe<Customer_Order_By>;
  ads_plus_customer_email_id_1?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_2?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_3?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_4?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_5?: InputMaybe<Order_By>;
  ads_plus_customer_email_id_6?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
};

/** select columns of table "ads_plus_customer_contacts" */
export enum Ads_Plus_Customer_Contacts_Select_Column {
  /** column name */
  AdsPlusCustomerEmailId_1 = 'ads_plus_customer_email_id_1',
  /** column name */
  AdsPlusCustomerEmailId_2 = 'ads_plus_customer_email_id_2',
  /** column name */
  AdsPlusCustomerEmailId_3 = 'ads_plus_customer_email_id_3',
  /** column name */
  AdsPlusCustomerEmailId_4 = 'ads_plus_customer_email_id_4',
  /** column name */
  AdsPlusCustomerEmailId_5 = 'ads_plus_customer_email_id_5',
  /** column name */
  AdsPlusCustomerEmailId_6 = 'ads_plus_customer_email_id_6',
  /** column name */
  SalesforceId = 'salesforce_id'
}

/** Streaming cursor of the table "ads_plus_customer_contacts" */
export type Ads_Plus_Customer_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ads_Plus_Customer_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ads_Plus_Customer_Contacts_Stream_Cursor_Value_Input = {
  ads_plus_customer_email_id_1?: InputMaybe<Scalars['String']>;
  ads_plus_customer_email_id_2?: InputMaybe<Scalars['String']>;
  ads_plus_customer_email_id_3?: InputMaybe<Scalars['String']>;
  ads_plus_customer_email_id_4?: InputMaybe<Scalars['String']>;
  ads_plus_customer_email_id_5?: InputMaybe<Scalars['String']>;
  ads_plus_customer_email_id_6?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

export type Billed_Revenue_Cummulative_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
};

export type Billed_Revenue_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
};

export type Booked_Revenue_Cummulative_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
};

export type Booked_Revenue_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "case" */
export type Case = {
  __typename?: 'case';
  account_owner?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['String']>;
  ad_placement_type?: Maybe<Scalars['String']>;
  ads_plus_content_type?: Maybe<Scalars['String']>;
  amagi_id?: Maybe<Scalars['String']>;
  amg_id?: Maybe<Scalars['String']>;
  avg_content_length?: Maybe<Scalars['String']>;
  avg_monthly_volumes_by_geo?: Maybe<Scalars['numeric']>;
  aws_calculator_link?: Maybe<Scalars['String']>;
  aws_services?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  case_accepted_datetime?: Maybe<Scalars['timestamptz']>;
  case_blocked_reason?: Maybe<Scalars['String']>;
  case_currency?: Maybe<Scalars['String']>;
  case_number?: Maybe<Scalars['String']>;
  case_origin?: Maybe<Scalars['String']>;
  case_reason?: Maybe<Scalars['String']>;
  case_type?: Maybe<Scalars['String']>;
  channel_language?: Maybe<Scalars['String']>;
  channel_name?: Maybe<Scalars['String']>;
  churn_effective_date?: Maybe<Scalars['date']>;
  churn_reason?: Maybe<Scalars['String']>;
  churn_reason_category?: Maybe<Scalars['String']>;
  churn_requested_date?: Maybe<Scalars['date']>;
  churn_value?: Maybe<Scalars['numeric']>;
  churned_prior_to_notice_period?: Maybe<Scalars['String']>;
  churned_quote_line?: Maybe<Scalars['String']>;
  closed_date?: Maybe<Scalars['timestamptz']>;
  company?: Maybe<Scalars['String']>;
  competitor?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_fax?: Maybe<Scalars['String']>;
  contact_mobile?: Maybe<Scalars['String']>;
  contact_phone?: Maybe<Scalars['String']>;
  content_adhere_to_lab_initiatives?: Maybe<Scalars['String']>;
  content_app_is_listed_in?: Maybe<Scalars['String']>;
  content_includes_sensitive_categories?: Maybe<Scalars['String']>;
  content_listed_in_prem_ctv_marketplace?: Maybe<Scalars['String']>;
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  description_second?: Maybe<Scalars['String']>;
  detailed_reason_for_churn?: Maybe<Scalars['String']>;
  details_of_requirements_from_operations?: Maybe<Scalars['String']>;
  eligibility_state?: Maybe<Scalars['String']>;
  eligibility_state_reason?: Maybe<Scalars['String']>;
  email_id?: Maybe<Scalars['String']>;
  geo?: Maybe<Scalars['String']>;
  if_other?: Maybe<Scalars['String']>;
  impact?: Maybe<Scalars['String']>;
  informed_customer_platform?: Maybe<Scalars['String']>;
  internal_comments?: Maybe<Scalars['String']>;
  is_closed?: Maybe<Scalars['Boolean']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  is_the_content_instream?: Maybe<Scalars['String']>;
  is_the_content_professionally_produced?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  market?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notice_period_waiver_approved_by?: Maybe<Scalars['String']>;
  opportunity_comments?: Maybe<Scalars['String']>;
  opportunity_mrr?: Maybe<Scalars['numeric']>;
  opportunity_name?: Maybe<Scalars['String']>;
  opportunity_stage?: Maybe<Scalars['String']>;
  other_ctv_marketplace?: Maybe<Scalars['String']>;
  other_supported_video_metadata?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  platform_name?: Maybe<Scalars['String']>;
  poc_credits_requested?: Maybe<Scalars['numeric']>;
  poc_end_date?: Maybe<Scalars['date']>;
  poc_start_date?: Maybe<Scalars['date']>;
  priority?: Maybe<Scalars['String']>;
  project_success_criteria?: Maybe<Scalars['String']>;
  quip_doc_link?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  renewal?: Maybe<Scalars['numeric']>;
  request?: Maybe<Scalars['String']>;
  request_status?: Maybe<Scalars['String']>;
  requester_email?: Maybe<Scalars['String']>;
  rev_ops_department?: Maybe<Scalars['String']>;
  rev_ops_notes?: Maybe<Scalars['String']>;
  rev_ops_owner?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_contact_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_last_referenced_date?: Maybe<Scalars['timestamptz']>;
  salesforce_last_viewed_date?: Maybe<Scalars['timestamptz']>;
  salesforce_master_record_id?: Maybe<Scalars['String']>;
  salesforce_opportunity_id?: Maybe<Scalars['String']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_record_type_id?: Maybe<Scalars['String']>;
  salesforce_requester_id?: Maybe<Scalars['String']>;
  service_description?: Maybe<Scalars['String']>;
  show_churn_effective_date_warning?: Maybe<Scalars['Boolean']>;
  sla?: Maybe<Scalars['String']>;
  sst_jira_ticket?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  subject_second?: Maybe<Scalars['String']>;
  submission_date?: Maybe<Scalars['timestamptz']>;
  technical_description?: Maybe<Scalars['String']>;
  to_be_raised_for_poc_credits?: Maybe<Scalars['Boolean']>;
  type_of_request?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vertical?: Maybe<Scalars['String']>;
  video_metadata_supported?: Maybe<Scalars['String']>;
  vod?: Maybe<Scalars['String']>;
  will_customer_provide_licensing_rights?: Maybe<Scalars['String']>;
};

/** aggregated selection of "case" */
export type Case_Aggregate = {
  __typename?: 'case_aggregate';
  aggregate?: Maybe<Case_Aggregate_Fields>;
  nodes: Array<Case>;
};

export type Case_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Case_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Case_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Case_Aggregate_Bool_Exp_Count>;
};

export type Case_Aggregate_Bool_Exp_Bool_And = {
  arguments: Case_Select_Column_Case_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Case_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Case_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Case_Select_Column_Case_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Case_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Case_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Case_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Case_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "case" */
export type Case_Aggregate_Fields = {
  __typename?: 'case_aggregate_fields';
  avg?: Maybe<Case_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Case_Max_Fields>;
  min?: Maybe<Case_Min_Fields>;
  stddev?: Maybe<Case_Stddev_Fields>;
  stddev_pop?: Maybe<Case_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Case_Stddev_Samp_Fields>;
  sum?: Maybe<Case_Sum_Fields>;
  var_pop?: Maybe<Case_Var_Pop_Fields>;
  var_samp?: Maybe<Case_Var_Samp_Fields>;
  variance?: Maybe<Case_Variance_Fields>;
};


/** aggregate fields of "case" */
export type Case_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Case_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "case" */
export type Case_Aggregate_Order_By = {
  avg?: InputMaybe<Case_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Case_Max_Order_By>;
  min?: InputMaybe<Case_Min_Order_By>;
  stddev?: InputMaybe<Case_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Case_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Case_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Case_Sum_Order_By>;
  var_pop?: InputMaybe<Case_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Case_Var_Samp_Order_By>;
  variance?: InputMaybe<Case_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Case_Avg_Fields = {
  __typename?: 'case_avg_fields';
  avg_monthly_volumes_by_geo?: Maybe<Scalars['Float']>;
  churn_value?: Maybe<Scalars['Float']>;
  opportunity_mrr?: Maybe<Scalars['Float']>;
  poc_credits_requested?: Maybe<Scalars['Float']>;
  renewal?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "case" */
export type Case_Avg_Order_By = {
  avg_monthly_volumes_by_geo?: InputMaybe<Order_By>;
  churn_value?: InputMaybe<Order_By>;
  opportunity_mrr?: InputMaybe<Order_By>;
  poc_credits_requested?: InputMaybe<Order_By>;
  renewal?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "case". All fields are combined with a logical 'AND'. */
export type Case_Bool_Exp = {
  _and?: InputMaybe<Array<Case_Bool_Exp>>;
  _not?: InputMaybe<Case_Bool_Exp>;
  _or?: InputMaybe<Array<Case_Bool_Exp>>;
  account_owner?: InputMaybe<String_Comparison_Exp>;
  action?: InputMaybe<String_Comparison_Exp>;
  ad_placement_type?: InputMaybe<String_Comparison_Exp>;
  ads_plus_content_type?: InputMaybe<String_Comparison_Exp>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  amg_id?: InputMaybe<String_Comparison_Exp>;
  avg_content_length?: InputMaybe<String_Comparison_Exp>;
  avg_monthly_volumes_by_geo?: InputMaybe<Numeric_Comparison_Exp>;
  aws_calculator_link?: InputMaybe<String_Comparison_Exp>;
  aws_services?: InputMaybe<String_Comparison_Exp>;
  background?: InputMaybe<String_Comparison_Exp>;
  case_accepted_datetime?: InputMaybe<Timestamptz_Comparison_Exp>;
  case_blocked_reason?: InputMaybe<String_Comparison_Exp>;
  case_currency?: InputMaybe<String_Comparison_Exp>;
  case_number?: InputMaybe<String_Comparison_Exp>;
  case_origin?: InputMaybe<String_Comparison_Exp>;
  case_reason?: InputMaybe<String_Comparison_Exp>;
  case_type?: InputMaybe<String_Comparison_Exp>;
  channel_language?: InputMaybe<String_Comparison_Exp>;
  channel_name?: InputMaybe<String_Comparison_Exp>;
  churn_effective_date?: InputMaybe<Date_Comparison_Exp>;
  churn_reason?: InputMaybe<String_Comparison_Exp>;
  churn_reason_category?: InputMaybe<String_Comparison_Exp>;
  churn_requested_date?: InputMaybe<Date_Comparison_Exp>;
  churn_value?: InputMaybe<Numeric_Comparison_Exp>;
  churned_prior_to_notice_period?: InputMaybe<String_Comparison_Exp>;
  churned_quote_line?: InputMaybe<String_Comparison_Exp>;
  closed_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  company?: InputMaybe<String_Comparison_Exp>;
  competitor?: InputMaybe<String_Comparison_Exp>;
  contact_email?: InputMaybe<String_Comparison_Exp>;
  contact_fax?: InputMaybe<String_Comparison_Exp>;
  contact_mobile?: InputMaybe<String_Comparison_Exp>;
  contact_phone?: InputMaybe<String_Comparison_Exp>;
  content_adhere_to_lab_initiatives?: InputMaybe<String_Comparison_Exp>;
  content_app_is_listed_in?: InputMaybe<String_Comparison_Exp>;
  content_includes_sensitive_categories?: InputMaybe<String_Comparison_Exp>;
  content_listed_in_prem_ctv_marketplace?: InputMaybe<String_Comparison_Exp>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  description_second?: InputMaybe<String_Comparison_Exp>;
  detailed_reason_for_churn?: InputMaybe<String_Comparison_Exp>;
  details_of_requirements_from_operations?: InputMaybe<String_Comparison_Exp>;
  eligibility_state?: InputMaybe<String_Comparison_Exp>;
  eligibility_state_reason?: InputMaybe<String_Comparison_Exp>;
  email_id?: InputMaybe<String_Comparison_Exp>;
  geo?: InputMaybe<String_Comparison_Exp>;
  if_other?: InputMaybe<String_Comparison_Exp>;
  impact?: InputMaybe<String_Comparison_Exp>;
  informed_customer_platform?: InputMaybe<String_Comparison_Exp>;
  internal_comments?: InputMaybe<String_Comparison_Exp>;
  is_closed?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_the_content_instream?: InputMaybe<String_Comparison_Exp>;
  is_the_content_professionally_produced?: InputMaybe<String_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  market?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notice_period_waiver_approved_by?: InputMaybe<String_Comparison_Exp>;
  opportunity_comments?: InputMaybe<String_Comparison_Exp>;
  opportunity_mrr?: InputMaybe<Numeric_Comparison_Exp>;
  opportunity_name?: InputMaybe<String_Comparison_Exp>;
  opportunity_stage?: InputMaybe<String_Comparison_Exp>;
  other_ctv_marketplace?: InputMaybe<String_Comparison_Exp>;
  other_supported_video_metadata?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  platform_name?: InputMaybe<String_Comparison_Exp>;
  poc_credits_requested?: InputMaybe<Numeric_Comparison_Exp>;
  poc_end_date?: InputMaybe<Date_Comparison_Exp>;
  poc_start_date?: InputMaybe<Date_Comparison_Exp>;
  priority?: InputMaybe<String_Comparison_Exp>;
  project_success_criteria?: InputMaybe<String_Comparison_Exp>;
  quip_doc_link?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  renewal?: InputMaybe<Numeric_Comparison_Exp>;
  request?: InputMaybe<String_Comparison_Exp>;
  request_status?: InputMaybe<String_Comparison_Exp>;
  requester_email?: InputMaybe<String_Comparison_Exp>;
  rev_ops_department?: InputMaybe<String_Comparison_Exp>;
  rev_ops_notes?: InputMaybe<String_Comparison_Exp>;
  rev_ops_owner?: InputMaybe<String_Comparison_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_channel_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_contact_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_last_referenced_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_last_viewed_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_master_record_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_opportunity_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_owner_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_record_type_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_requester_id?: InputMaybe<String_Comparison_Exp>;
  service_description?: InputMaybe<String_Comparison_Exp>;
  show_churn_effective_date_warning?: InputMaybe<Boolean_Comparison_Exp>;
  sla?: InputMaybe<String_Comparison_Exp>;
  sst_jira_ticket?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  subject_second?: InputMaybe<String_Comparison_Exp>;
  submission_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  technical_description?: InputMaybe<String_Comparison_Exp>;
  to_be_raised_for_poc_credits?: InputMaybe<Boolean_Comparison_Exp>;
  type_of_request?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vertical?: InputMaybe<String_Comparison_Exp>;
  video_metadata_supported?: InputMaybe<String_Comparison_Exp>;
  vod?: InputMaybe<String_Comparison_Exp>;
  will_customer_provide_licensing_rights?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Case_Max_Fields = {
  __typename?: 'case_max_fields';
  account_owner?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['String']>;
  ad_placement_type?: Maybe<Scalars['String']>;
  ads_plus_content_type?: Maybe<Scalars['String']>;
  amagi_id?: Maybe<Scalars['String']>;
  amg_id?: Maybe<Scalars['String']>;
  avg_content_length?: Maybe<Scalars['String']>;
  avg_monthly_volumes_by_geo?: Maybe<Scalars['numeric']>;
  aws_calculator_link?: Maybe<Scalars['String']>;
  aws_services?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  case_accepted_datetime?: Maybe<Scalars['timestamptz']>;
  case_blocked_reason?: Maybe<Scalars['String']>;
  case_currency?: Maybe<Scalars['String']>;
  case_number?: Maybe<Scalars['String']>;
  case_origin?: Maybe<Scalars['String']>;
  case_reason?: Maybe<Scalars['String']>;
  case_type?: Maybe<Scalars['String']>;
  channel_language?: Maybe<Scalars['String']>;
  channel_name?: Maybe<Scalars['String']>;
  churn_effective_date?: Maybe<Scalars['date']>;
  churn_reason?: Maybe<Scalars['String']>;
  churn_reason_category?: Maybe<Scalars['String']>;
  churn_requested_date?: Maybe<Scalars['date']>;
  churn_value?: Maybe<Scalars['numeric']>;
  churned_prior_to_notice_period?: Maybe<Scalars['String']>;
  churned_quote_line?: Maybe<Scalars['String']>;
  closed_date?: Maybe<Scalars['timestamptz']>;
  company?: Maybe<Scalars['String']>;
  competitor?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_fax?: Maybe<Scalars['String']>;
  contact_mobile?: Maybe<Scalars['String']>;
  contact_phone?: Maybe<Scalars['String']>;
  content_adhere_to_lab_initiatives?: Maybe<Scalars['String']>;
  content_app_is_listed_in?: Maybe<Scalars['String']>;
  content_includes_sensitive_categories?: Maybe<Scalars['String']>;
  content_listed_in_prem_ctv_marketplace?: Maybe<Scalars['String']>;
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  description_second?: Maybe<Scalars['String']>;
  detailed_reason_for_churn?: Maybe<Scalars['String']>;
  details_of_requirements_from_operations?: Maybe<Scalars['String']>;
  eligibility_state?: Maybe<Scalars['String']>;
  eligibility_state_reason?: Maybe<Scalars['String']>;
  email_id?: Maybe<Scalars['String']>;
  geo?: Maybe<Scalars['String']>;
  if_other?: Maybe<Scalars['String']>;
  impact?: Maybe<Scalars['String']>;
  informed_customer_platform?: Maybe<Scalars['String']>;
  internal_comments?: Maybe<Scalars['String']>;
  is_the_content_instream?: Maybe<Scalars['String']>;
  is_the_content_professionally_produced?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  market?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notice_period_waiver_approved_by?: Maybe<Scalars['String']>;
  opportunity_comments?: Maybe<Scalars['String']>;
  opportunity_mrr?: Maybe<Scalars['numeric']>;
  opportunity_name?: Maybe<Scalars['String']>;
  opportunity_stage?: Maybe<Scalars['String']>;
  other_ctv_marketplace?: Maybe<Scalars['String']>;
  other_supported_video_metadata?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  platform_name?: Maybe<Scalars['String']>;
  poc_credits_requested?: Maybe<Scalars['numeric']>;
  poc_end_date?: Maybe<Scalars['date']>;
  poc_start_date?: Maybe<Scalars['date']>;
  priority?: Maybe<Scalars['String']>;
  project_success_criteria?: Maybe<Scalars['String']>;
  quip_doc_link?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  renewal?: Maybe<Scalars['numeric']>;
  request?: Maybe<Scalars['String']>;
  request_status?: Maybe<Scalars['String']>;
  requester_email?: Maybe<Scalars['String']>;
  rev_ops_department?: Maybe<Scalars['String']>;
  rev_ops_notes?: Maybe<Scalars['String']>;
  rev_ops_owner?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_contact_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_last_referenced_date?: Maybe<Scalars['timestamptz']>;
  salesforce_last_viewed_date?: Maybe<Scalars['timestamptz']>;
  salesforce_master_record_id?: Maybe<Scalars['String']>;
  salesforce_opportunity_id?: Maybe<Scalars['String']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_record_type_id?: Maybe<Scalars['String']>;
  salesforce_requester_id?: Maybe<Scalars['String']>;
  service_description?: Maybe<Scalars['String']>;
  sla?: Maybe<Scalars['String']>;
  sst_jira_ticket?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  subject_second?: Maybe<Scalars['String']>;
  submission_date?: Maybe<Scalars['timestamptz']>;
  technical_description?: Maybe<Scalars['String']>;
  type_of_request?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vertical?: Maybe<Scalars['String']>;
  video_metadata_supported?: Maybe<Scalars['String']>;
  vod?: Maybe<Scalars['String']>;
  will_customer_provide_licensing_rights?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "case" */
export type Case_Max_Order_By = {
  account_owner?: InputMaybe<Order_By>;
  action?: InputMaybe<Order_By>;
  ad_placement_type?: InputMaybe<Order_By>;
  ads_plus_content_type?: InputMaybe<Order_By>;
  amagi_id?: InputMaybe<Order_By>;
  amg_id?: InputMaybe<Order_By>;
  avg_content_length?: InputMaybe<Order_By>;
  avg_monthly_volumes_by_geo?: InputMaybe<Order_By>;
  aws_calculator_link?: InputMaybe<Order_By>;
  aws_services?: InputMaybe<Order_By>;
  background?: InputMaybe<Order_By>;
  case_accepted_datetime?: InputMaybe<Order_By>;
  case_blocked_reason?: InputMaybe<Order_By>;
  case_currency?: InputMaybe<Order_By>;
  case_number?: InputMaybe<Order_By>;
  case_origin?: InputMaybe<Order_By>;
  case_reason?: InputMaybe<Order_By>;
  case_type?: InputMaybe<Order_By>;
  channel_language?: InputMaybe<Order_By>;
  channel_name?: InputMaybe<Order_By>;
  churn_effective_date?: InputMaybe<Order_By>;
  churn_reason?: InputMaybe<Order_By>;
  churn_reason_category?: InputMaybe<Order_By>;
  churn_requested_date?: InputMaybe<Order_By>;
  churn_value?: InputMaybe<Order_By>;
  churned_prior_to_notice_period?: InputMaybe<Order_By>;
  churned_quote_line?: InputMaybe<Order_By>;
  closed_date?: InputMaybe<Order_By>;
  company?: InputMaybe<Order_By>;
  competitor?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_fax?: InputMaybe<Order_By>;
  contact_mobile?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  content_adhere_to_lab_initiatives?: InputMaybe<Order_By>;
  content_app_is_listed_in?: InputMaybe<Order_By>;
  content_includes_sensitive_categories?: InputMaybe<Order_By>;
  content_listed_in_prem_ctv_marketplace?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_second?: InputMaybe<Order_By>;
  detailed_reason_for_churn?: InputMaybe<Order_By>;
  details_of_requirements_from_operations?: InputMaybe<Order_By>;
  eligibility_state?: InputMaybe<Order_By>;
  eligibility_state_reason?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  geo?: InputMaybe<Order_By>;
  if_other?: InputMaybe<Order_By>;
  impact?: InputMaybe<Order_By>;
  informed_customer_platform?: InputMaybe<Order_By>;
  internal_comments?: InputMaybe<Order_By>;
  is_the_content_instream?: InputMaybe<Order_By>;
  is_the_content_professionally_produced?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  market?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notice_period_waiver_approved_by?: InputMaybe<Order_By>;
  opportunity_comments?: InputMaybe<Order_By>;
  opportunity_mrr?: InputMaybe<Order_By>;
  opportunity_name?: InputMaybe<Order_By>;
  opportunity_stage?: InputMaybe<Order_By>;
  other_ctv_marketplace?: InputMaybe<Order_By>;
  other_supported_video_metadata?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  poc_credits_requested?: InputMaybe<Order_By>;
  poc_end_date?: InputMaybe<Order_By>;
  poc_start_date?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  project_success_criteria?: InputMaybe<Order_By>;
  quip_doc_link?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  renewal?: InputMaybe<Order_By>;
  request?: InputMaybe<Order_By>;
  request_status?: InputMaybe<Order_By>;
  requester_email?: InputMaybe<Order_By>;
  rev_ops_department?: InputMaybe<Order_By>;
  rev_ops_notes?: InputMaybe<Order_By>;
  rev_ops_owner?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_contact_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_last_referenced_date?: InputMaybe<Order_By>;
  salesforce_last_viewed_date?: InputMaybe<Order_By>;
  salesforce_master_record_id?: InputMaybe<Order_By>;
  salesforce_opportunity_id?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_record_type_id?: InputMaybe<Order_By>;
  salesforce_requester_id?: InputMaybe<Order_By>;
  service_description?: InputMaybe<Order_By>;
  sla?: InputMaybe<Order_By>;
  sst_jira_ticket?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_second?: InputMaybe<Order_By>;
  submission_date?: InputMaybe<Order_By>;
  technical_description?: InputMaybe<Order_By>;
  type_of_request?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vertical?: InputMaybe<Order_By>;
  video_metadata_supported?: InputMaybe<Order_By>;
  vod?: InputMaybe<Order_By>;
  will_customer_provide_licensing_rights?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Case_Min_Fields = {
  __typename?: 'case_min_fields';
  account_owner?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['String']>;
  ad_placement_type?: Maybe<Scalars['String']>;
  ads_plus_content_type?: Maybe<Scalars['String']>;
  amagi_id?: Maybe<Scalars['String']>;
  amg_id?: Maybe<Scalars['String']>;
  avg_content_length?: Maybe<Scalars['String']>;
  avg_monthly_volumes_by_geo?: Maybe<Scalars['numeric']>;
  aws_calculator_link?: Maybe<Scalars['String']>;
  aws_services?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  case_accepted_datetime?: Maybe<Scalars['timestamptz']>;
  case_blocked_reason?: Maybe<Scalars['String']>;
  case_currency?: Maybe<Scalars['String']>;
  case_number?: Maybe<Scalars['String']>;
  case_origin?: Maybe<Scalars['String']>;
  case_reason?: Maybe<Scalars['String']>;
  case_type?: Maybe<Scalars['String']>;
  channel_language?: Maybe<Scalars['String']>;
  channel_name?: Maybe<Scalars['String']>;
  churn_effective_date?: Maybe<Scalars['date']>;
  churn_reason?: Maybe<Scalars['String']>;
  churn_reason_category?: Maybe<Scalars['String']>;
  churn_requested_date?: Maybe<Scalars['date']>;
  churn_value?: Maybe<Scalars['numeric']>;
  churned_prior_to_notice_period?: Maybe<Scalars['String']>;
  churned_quote_line?: Maybe<Scalars['String']>;
  closed_date?: Maybe<Scalars['timestamptz']>;
  company?: Maybe<Scalars['String']>;
  competitor?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['String']>;
  contact_fax?: Maybe<Scalars['String']>;
  contact_mobile?: Maybe<Scalars['String']>;
  contact_phone?: Maybe<Scalars['String']>;
  content_adhere_to_lab_initiatives?: Maybe<Scalars['String']>;
  content_app_is_listed_in?: Maybe<Scalars['String']>;
  content_includes_sensitive_categories?: Maybe<Scalars['String']>;
  content_listed_in_prem_ctv_marketplace?: Maybe<Scalars['String']>;
  content_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  description_second?: Maybe<Scalars['String']>;
  detailed_reason_for_churn?: Maybe<Scalars['String']>;
  details_of_requirements_from_operations?: Maybe<Scalars['String']>;
  eligibility_state?: Maybe<Scalars['String']>;
  eligibility_state_reason?: Maybe<Scalars['String']>;
  email_id?: Maybe<Scalars['String']>;
  geo?: Maybe<Scalars['String']>;
  if_other?: Maybe<Scalars['String']>;
  impact?: Maybe<Scalars['String']>;
  informed_customer_platform?: Maybe<Scalars['String']>;
  internal_comments?: Maybe<Scalars['String']>;
  is_the_content_instream?: Maybe<Scalars['String']>;
  is_the_content_professionally_produced?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  market?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notice_period_waiver_approved_by?: Maybe<Scalars['String']>;
  opportunity_comments?: Maybe<Scalars['String']>;
  opportunity_mrr?: Maybe<Scalars['numeric']>;
  opportunity_name?: Maybe<Scalars['String']>;
  opportunity_stage?: Maybe<Scalars['String']>;
  other_ctv_marketplace?: Maybe<Scalars['String']>;
  other_supported_video_metadata?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  platform_name?: Maybe<Scalars['String']>;
  poc_credits_requested?: Maybe<Scalars['numeric']>;
  poc_end_date?: Maybe<Scalars['date']>;
  poc_start_date?: Maybe<Scalars['date']>;
  priority?: Maybe<Scalars['String']>;
  project_success_criteria?: Maybe<Scalars['String']>;
  quip_doc_link?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  renewal?: Maybe<Scalars['numeric']>;
  request?: Maybe<Scalars['String']>;
  request_status?: Maybe<Scalars['String']>;
  requester_email?: Maybe<Scalars['String']>;
  rev_ops_department?: Maybe<Scalars['String']>;
  rev_ops_notes?: Maybe<Scalars['String']>;
  rev_ops_owner?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_contact_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_last_referenced_date?: Maybe<Scalars['timestamptz']>;
  salesforce_last_viewed_date?: Maybe<Scalars['timestamptz']>;
  salesforce_master_record_id?: Maybe<Scalars['String']>;
  salesforce_opportunity_id?: Maybe<Scalars['String']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_record_type_id?: Maybe<Scalars['String']>;
  salesforce_requester_id?: Maybe<Scalars['String']>;
  service_description?: Maybe<Scalars['String']>;
  sla?: Maybe<Scalars['String']>;
  sst_jira_ticket?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  subject_second?: Maybe<Scalars['String']>;
  submission_date?: Maybe<Scalars['timestamptz']>;
  technical_description?: Maybe<Scalars['String']>;
  type_of_request?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vertical?: Maybe<Scalars['String']>;
  video_metadata_supported?: Maybe<Scalars['String']>;
  vod?: Maybe<Scalars['String']>;
  will_customer_provide_licensing_rights?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "case" */
export type Case_Min_Order_By = {
  account_owner?: InputMaybe<Order_By>;
  action?: InputMaybe<Order_By>;
  ad_placement_type?: InputMaybe<Order_By>;
  ads_plus_content_type?: InputMaybe<Order_By>;
  amagi_id?: InputMaybe<Order_By>;
  amg_id?: InputMaybe<Order_By>;
  avg_content_length?: InputMaybe<Order_By>;
  avg_monthly_volumes_by_geo?: InputMaybe<Order_By>;
  aws_calculator_link?: InputMaybe<Order_By>;
  aws_services?: InputMaybe<Order_By>;
  background?: InputMaybe<Order_By>;
  case_accepted_datetime?: InputMaybe<Order_By>;
  case_blocked_reason?: InputMaybe<Order_By>;
  case_currency?: InputMaybe<Order_By>;
  case_number?: InputMaybe<Order_By>;
  case_origin?: InputMaybe<Order_By>;
  case_reason?: InputMaybe<Order_By>;
  case_type?: InputMaybe<Order_By>;
  channel_language?: InputMaybe<Order_By>;
  channel_name?: InputMaybe<Order_By>;
  churn_effective_date?: InputMaybe<Order_By>;
  churn_reason?: InputMaybe<Order_By>;
  churn_reason_category?: InputMaybe<Order_By>;
  churn_requested_date?: InputMaybe<Order_By>;
  churn_value?: InputMaybe<Order_By>;
  churned_prior_to_notice_period?: InputMaybe<Order_By>;
  churned_quote_line?: InputMaybe<Order_By>;
  closed_date?: InputMaybe<Order_By>;
  company?: InputMaybe<Order_By>;
  competitor?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_fax?: InputMaybe<Order_By>;
  contact_mobile?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  content_adhere_to_lab_initiatives?: InputMaybe<Order_By>;
  content_app_is_listed_in?: InputMaybe<Order_By>;
  content_includes_sensitive_categories?: InputMaybe<Order_By>;
  content_listed_in_prem_ctv_marketplace?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_second?: InputMaybe<Order_By>;
  detailed_reason_for_churn?: InputMaybe<Order_By>;
  details_of_requirements_from_operations?: InputMaybe<Order_By>;
  eligibility_state?: InputMaybe<Order_By>;
  eligibility_state_reason?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  geo?: InputMaybe<Order_By>;
  if_other?: InputMaybe<Order_By>;
  impact?: InputMaybe<Order_By>;
  informed_customer_platform?: InputMaybe<Order_By>;
  internal_comments?: InputMaybe<Order_By>;
  is_the_content_instream?: InputMaybe<Order_By>;
  is_the_content_professionally_produced?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  market?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notice_period_waiver_approved_by?: InputMaybe<Order_By>;
  opportunity_comments?: InputMaybe<Order_By>;
  opportunity_mrr?: InputMaybe<Order_By>;
  opportunity_name?: InputMaybe<Order_By>;
  opportunity_stage?: InputMaybe<Order_By>;
  other_ctv_marketplace?: InputMaybe<Order_By>;
  other_supported_video_metadata?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  poc_credits_requested?: InputMaybe<Order_By>;
  poc_end_date?: InputMaybe<Order_By>;
  poc_start_date?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  project_success_criteria?: InputMaybe<Order_By>;
  quip_doc_link?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  renewal?: InputMaybe<Order_By>;
  request?: InputMaybe<Order_By>;
  request_status?: InputMaybe<Order_By>;
  requester_email?: InputMaybe<Order_By>;
  rev_ops_department?: InputMaybe<Order_By>;
  rev_ops_notes?: InputMaybe<Order_By>;
  rev_ops_owner?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_contact_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_last_referenced_date?: InputMaybe<Order_By>;
  salesforce_last_viewed_date?: InputMaybe<Order_By>;
  salesforce_master_record_id?: InputMaybe<Order_By>;
  salesforce_opportunity_id?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_record_type_id?: InputMaybe<Order_By>;
  salesforce_requester_id?: InputMaybe<Order_By>;
  service_description?: InputMaybe<Order_By>;
  sla?: InputMaybe<Order_By>;
  sst_jira_ticket?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_second?: InputMaybe<Order_By>;
  submission_date?: InputMaybe<Order_By>;
  technical_description?: InputMaybe<Order_By>;
  type_of_request?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vertical?: InputMaybe<Order_By>;
  video_metadata_supported?: InputMaybe<Order_By>;
  vod?: InputMaybe<Order_By>;
  will_customer_provide_licensing_rights?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "case". */
export type Case_Order_By = {
  account_owner?: InputMaybe<Order_By>;
  action?: InputMaybe<Order_By>;
  ad_placement_type?: InputMaybe<Order_By>;
  ads_plus_content_type?: InputMaybe<Order_By>;
  amagi_id?: InputMaybe<Order_By>;
  amg_id?: InputMaybe<Order_By>;
  avg_content_length?: InputMaybe<Order_By>;
  avg_monthly_volumes_by_geo?: InputMaybe<Order_By>;
  aws_calculator_link?: InputMaybe<Order_By>;
  aws_services?: InputMaybe<Order_By>;
  background?: InputMaybe<Order_By>;
  case_accepted_datetime?: InputMaybe<Order_By>;
  case_blocked_reason?: InputMaybe<Order_By>;
  case_currency?: InputMaybe<Order_By>;
  case_number?: InputMaybe<Order_By>;
  case_origin?: InputMaybe<Order_By>;
  case_reason?: InputMaybe<Order_By>;
  case_type?: InputMaybe<Order_By>;
  channel_language?: InputMaybe<Order_By>;
  channel_name?: InputMaybe<Order_By>;
  churn_effective_date?: InputMaybe<Order_By>;
  churn_reason?: InputMaybe<Order_By>;
  churn_reason_category?: InputMaybe<Order_By>;
  churn_requested_date?: InputMaybe<Order_By>;
  churn_value?: InputMaybe<Order_By>;
  churned_prior_to_notice_period?: InputMaybe<Order_By>;
  churned_quote_line?: InputMaybe<Order_By>;
  closed_date?: InputMaybe<Order_By>;
  company?: InputMaybe<Order_By>;
  competitor?: InputMaybe<Order_By>;
  contact_email?: InputMaybe<Order_By>;
  contact_fax?: InputMaybe<Order_By>;
  contact_mobile?: InputMaybe<Order_By>;
  contact_phone?: InputMaybe<Order_By>;
  content_adhere_to_lab_initiatives?: InputMaybe<Order_By>;
  content_app_is_listed_in?: InputMaybe<Order_By>;
  content_includes_sensitive_categories?: InputMaybe<Order_By>;
  content_listed_in_prem_ctv_marketplace?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_second?: InputMaybe<Order_By>;
  detailed_reason_for_churn?: InputMaybe<Order_By>;
  details_of_requirements_from_operations?: InputMaybe<Order_By>;
  eligibility_state?: InputMaybe<Order_By>;
  eligibility_state_reason?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  geo?: InputMaybe<Order_By>;
  if_other?: InputMaybe<Order_By>;
  impact?: InputMaybe<Order_By>;
  informed_customer_platform?: InputMaybe<Order_By>;
  internal_comments?: InputMaybe<Order_By>;
  is_closed?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_the_content_instream?: InputMaybe<Order_By>;
  is_the_content_professionally_produced?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  market?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notice_period_waiver_approved_by?: InputMaybe<Order_By>;
  opportunity_comments?: InputMaybe<Order_By>;
  opportunity_mrr?: InputMaybe<Order_By>;
  opportunity_name?: InputMaybe<Order_By>;
  opportunity_stage?: InputMaybe<Order_By>;
  other_ctv_marketplace?: InputMaybe<Order_By>;
  other_supported_video_metadata?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  poc_credits_requested?: InputMaybe<Order_By>;
  poc_end_date?: InputMaybe<Order_By>;
  poc_start_date?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  project_success_criteria?: InputMaybe<Order_By>;
  quip_doc_link?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  renewal?: InputMaybe<Order_By>;
  request?: InputMaybe<Order_By>;
  request_status?: InputMaybe<Order_By>;
  requester_email?: InputMaybe<Order_By>;
  rev_ops_department?: InputMaybe<Order_By>;
  rev_ops_notes?: InputMaybe<Order_By>;
  rev_ops_owner?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_contact_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_last_referenced_date?: InputMaybe<Order_By>;
  salesforce_last_viewed_date?: InputMaybe<Order_By>;
  salesforce_master_record_id?: InputMaybe<Order_By>;
  salesforce_opportunity_id?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_record_type_id?: InputMaybe<Order_By>;
  salesforce_requester_id?: InputMaybe<Order_By>;
  service_description?: InputMaybe<Order_By>;
  show_churn_effective_date_warning?: InputMaybe<Order_By>;
  sla?: InputMaybe<Order_By>;
  sst_jira_ticket?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_second?: InputMaybe<Order_By>;
  submission_date?: InputMaybe<Order_By>;
  technical_description?: InputMaybe<Order_By>;
  to_be_raised_for_poc_credits?: InputMaybe<Order_By>;
  type_of_request?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vertical?: InputMaybe<Order_By>;
  video_metadata_supported?: InputMaybe<Order_By>;
  vod?: InputMaybe<Order_By>;
  will_customer_provide_licensing_rights?: InputMaybe<Order_By>;
};

/** select columns of table "case" */
export enum Case_Select_Column {
  /** column name */
  AccountOwner = 'account_owner',
  /** column name */
  Action = 'action',
  /** column name */
  AdPlacementType = 'ad_placement_type',
  /** column name */
  AdsPlusContentType = 'ads_plus_content_type',
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  AmgId = 'amg_id',
  /** column name */
  AvgContentLength = 'avg_content_length',
  /** column name */
  AvgMonthlyVolumesByGeo = 'avg_monthly_volumes_by_geo',
  /** column name */
  AwsCalculatorLink = 'aws_calculator_link',
  /** column name */
  AwsServices = 'aws_services',
  /** column name */
  Background = 'background',
  /** column name */
  CaseAcceptedDatetime = 'case_accepted_datetime',
  /** column name */
  CaseBlockedReason = 'case_blocked_reason',
  /** column name */
  CaseCurrency = 'case_currency',
  /** column name */
  CaseNumber = 'case_number',
  /** column name */
  CaseOrigin = 'case_origin',
  /** column name */
  CaseReason = 'case_reason',
  /** column name */
  CaseType = 'case_type',
  /** column name */
  ChannelLanguage = 'channel_language',
  /** column name */
  ChannelName = 'channel_name',
  /** column name */
  ChurnEffectiveDate = 'churn_effective_date',
  /** column name */
  ChurnReason = 'churn_reason',
  /** column name */
  ChurnReasonCategory = 'churn_reason_category',
  /** column name */
  ChurnRequestedDate = 'churn_requested_date',
  /** column name */
  ChurnValue = 'churn_value',
  /** column name */
  ChurnedPriorToNoticePeriod = 'churned_prior_to_notice_period',
  /** column name */
  ChurnedQuoteLine = 'churned_quote_line',
  /** column name */
  ClosedDate = 'closed_date',
  /** column name */
  Company = 'company',
  /** column name */
  Competitor = 'competitor',
  /** column name */
  ContactEmail = 'contact_email',
  /** column name */
  ContactFax = 'contact_fax',
  /** column name */
  ContactMobile = 'contact_mobile',
  /** column name */
  ContactPhone = 'contact_phone',
  /** column name */
  ContentAdhereToLabInitiatives = 'content_adhere_to_lab_initiatives',
  /** column name */
  ContentAppIsListedIn = 'content_app_is_listed_in',
  /** column name */
  ContentIncludesSensitiveCategories = 'content_includes_sensitive_categories',
  /** column name */
  ContentListedInPremCtvMarketplace = 'content_listed_in_prem_ctv_marketplace',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionSecond = 'description_second',
  /** column name */
  DetailedReasonForChurn = 'detailed_reason_for_churn',
  /** column name */
  DetailsOfRequirementsFromOperations = 'details_of_requirements_from_operations',
  /** column name */
  EligibilityState = 'eligibility_state',
  /** column name */
  EligibilityStateReason = 'eligibility_state_reason',
  /** column name */
  EmailId = 'email_id',
  /** column name */
  Geo = 'geo',
  /** column name */
  IfOther = 'if_other',
  /** column name */
  Impact = 'impact',
  /** column name */
  InformedCustomerPlatform = 'informed_customer_platform',
  /** column name */
  InternalComments = 'internal_comments',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsTheContentInstream = 'is_the_content_instream',
  /** column name */
  IsTheContentProfessionallyProduced = 'is_the_content_professionally_produced',
  /** column name */
  Language = 'language',
  /** column name */
  Market = 'market',
  /** column name */
  Name = 'name',
  /** column name */
  NoticePeriodWaiverApprovedBy = 'notice_period_waiver_approved_by',
  /** column name */
  OpportunityComments = 'opportunity_comments',
  /** column name */
  OpportunityMrr = 'opportunity_mrr',
  /** column name */
  OpportunityName = 'opportunity_name',
  /** column name */
  OpportunityStage = 'opportunity_stage',
  /** column name */
  OtherCtvMarketplace = 'other_ctv_marketplace',
  /** column name */
  OtherSupportedVideoMetadata = 'other_supported_video_metadata',
  /** column name */
  Phone = 'phone',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  PocCreditsRequested = 'poc_credits_requested',
  /** column name */
  PocEndDate = 'poc_end_date',
  /** column name */
  PocStartDate = 'poc_start_date',
  /** column name */
  Priority = 'priority',
  /** column name */
  ProjectSuccessCriteria = 'project_success_criteria',
  /** column name */
  QuipDocLink = 'quip_doc_link',
  /** column name */
  Region = 'region',
  /** column name */
  Renewal = 'renewal',
  /** column name */
  Request = 'request',
  /** column name */
  RequestStatus = 'request_status',
  /** column name */
  RequesterEmail = 'requester_email',
  /** column name */
  RevOpsDepartment = 'rev_ops_department',
  /** column name */
  RevOpsNotes = 'rev_ops_notes',
  /** column name */
  RevOpsOwner = 'rev_ops_owner',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SalesforceChannelId = 'salesforce_channel_id',
  /** column name */
  SalesforceContactId = 'salesforce_contact_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  SalesforceLastReferencedDate = 'salesforce_last_referenced_date',
  /** column name */
  SalesforceLastViewedDate = 'salesforce_last_viewed_date',
  /** column name */
  SalesforceMasterRecordId = 'salesforce_master_record_id',
  /** column name */
  SalesforceOpportunityId = 'salesforce_opportunity_id',
  /** column name */
  SalesforceOwnerId = 'salesforce_owner_id',
  /** column name */
  SalesforceRecordTypeId = 'salesforce_record_type_id',
  /** column name */
  SalesforceRequesterId = 'salesforce_requester_id',
  /** column name */
  ServiceDescription = 'service_description',
  /** column name */
  ShowChurnEffectiveDateWarning = 'show_churn_effective_date_warning',
  /** column name */
  Sla = 'sla',
  /** column name */
  SstJiraTicket = 'sst_jira_ticket',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectSecond = 'subject_second',
  /** column name */
  SubmissionDate = 'submission_date',
  /** column name */
  TechnicalDescription = 'technical_description',
  /** column name */
  ToBeRaisedForPocCredits = 'to_be_raised_for_poc_credits',
  /** column name */
  TypeOfRequest = 'type_of_request',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Vertical = 'vertical',
  /** column name */
  VideoMetadataSupported = 'video_metadata_supported',
  /** column name */
  Vod = 'vod',
  /** column name */
  WillCustomerProvideLicensingRights = 'will_customer_provide_licensing_rights'
}

/** select "case_aggregate_bool_exp_bool_and_arguments_columns" columns of table "case" */
export enum Case_Select_Column_Case_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  ShowChurnEffectiveDateWarning = 'show_churn_effective_date_warning',
  /** column name */
  ToBeRaisedForPocCredits = 'to_be_raised_for_poc_credits'
}

/** select "case_aggregate_bool_exp_bool_or_arguments_columns" columns of table "case" */
export enum Case_Select_Column_Case_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  ShowChurnEffectiveDateWarning = 'show_churn_effective_date_warning',
  /** column name */
  ToBeRaisedForPocCredits = 'to_be_raised_for_poc_credits'
}

/** aggregate stddev on columns */
export type Case_Stddev_Fields = {
  __typename?: 'case_stddev_fields';
  avg_monthly_volumes_by_geo?: Maybe<Scalars['Float']>;
  churn_value?: Maybe<Scalars['Float']>;
  opportunity_mrr?: Maybe<Scalars['Float']>;
  poc_credits_requested?: Maybe<Scalars['Float']>;
  renewal?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "case" */
export type Case_Stddev_Order_By = {
  avg_monthly_volumes_by_geo?: InputMaybe<Order_By>;
  churn_value?: InputMaybe<Order_By>;
  opportunity_mrr?: InputMaybe<Order_By>;
  poc_credits_requested?: InputMaybe<Order_By>;
  renewal?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Case_Stddev_Pop_Fields = {
  __typename?: 'case_stddev_pop_fields';
  avg_monthly_volumes_by_geo?: Maybe<Scalars['Float']>;
  churn_value?: Maybe<Scalars['Float']>;
  opportunity_mrr?: Maybe<Scalars['Float']>;
  poc_credits_requested?: Maybe<Scalars['Float']>;
  renewal?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "case" */
export type Case_Stddev_Pop_Order_By = {
  avg_monthly_volumes_by_geo?: InputMaybe<Order_By>;
  churn_value?: InputMaybe<Order_By>;
  opportunity_mrr?: InputMaybe<Order_By>;
  poc_credits_requested?: InputMaybe<Order_By>;
  renewal?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Case_Stddev_Samp_Fields = {
  __typename?: 'case_stddev_samp_fields';
  avg_monthly_volumes_by_geo?: Maybe<Scalars['Float']>;
  churn_value?: Maybe<Scalars['Float']>;
  opportunity_mrr?: Maybe<Scalars['Float']>;
  poc_credits_requested?: Maybe<Scalars['Float']>;
  renewal?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "case" */
export type Case_Stddev_Samp_Order_By = {
  avg_monthly_volumes_by_geo?: InputMaybe<Order_By>;
  churn_value?: InputMaybe<Order_By>;
  opportunity_mrr?: InputMaybe<Order_By>;
  poc_credits_requested?: InputMaybe<Order_By>;
  renewal?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "case" */
export type Case_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Case_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Case_Stream_Cursor_Value_Input = {
  account_owner?: InputMaybe<Scalars['String']>;
  action?: InputMaybe<Scalars['String']>;
  ad_placement_type?: InputMaybe<Scalars['String']>;
  ads_plus_content_type?: InputMaybe<Scalars['String']>;
  amagi_id?: InputMaybe<Scalars['String']>;
  amg_id?: InputMaybe<Scalars['String']>;
  avg_content_length?: InputMaybe<Scalars['String']>;
  avg_monthly_volumes_by_geo?: InputMaybe<Scalars['numeric']>;
  aws_calculator_link?: InputMaybe<Scalars['String']>;
  aws_services?: InputMaybe<Scalars['String']>;
  background?: InputMaybe<Scalars['String']>;
  case_accepted_datetime?: InputMaybe<Scalars['timestamptz']>;
  case_blocked_reason?: InputMaybe<Scalars['String']>;
  case_currency?: InputMaybe<Scalars['String']>;
  case_number?: InputMaybe<Scalars['String']>;
  case_origin?: InputMaybe<Scalars['String']>;
  case_reason?: InputMaybe<Scalars['String']>;
  case_type?: InputMaybe<Scalars['String']>;
  channel_language?: InputMaybe<Scalars['String']>;
  channel_name?: InputMaybe<Scalars['String']>;
  churn_effective_date?: InputMaybe<Scalars['date']>;
  churn_reason?: InputMaybe<Scalars['String']>;
  churn_reason_category?: InputMaybe<Scalars['String']>;
  churn_requested_date?: InputMaybe<Scalars['date']>;
  churn_value?: InputMaybe<Scalars['numeric']>;
  churned_prior_to_notice_period?: InputMaybe<Scalars['String']>;
  churned_quote_line?: InputMaybe<Scalars['String']>;
  closed_date?: InputMaybe<Scalars['timestamptz']>;
  company?: InputMaybe<Scalars['String']>;
  competitor?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  contact_fax?: InputMaybe<Scalars['String']>;
  contact_mobile?: InputMaybe<Scalars['String']>;
  contact_phone?: InputMaybe<Scalars['String']>;
  content_adhere_to_lab_initiatives?: InputMaybe<Scalars['String']>;
  content_app_is_listed_in?: InputMaybe<Scalars['String']>;
  content_includes_sensitive_categories?: InputMaybe<Scalars['String']>;
  content_listed_in_prem_ctv_marketplace?: InputMaybe<Scalars['String']>;
  content_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  description_second?: InputMaybe<Scalars['String']>;
  detailed_reason_for_churn?: InputMaybe<Scalars['String']>;
  details_of_requirements_from_operations?: InputMaybe<Scalars['String']>;
  eligibility_state?: InputMaybe<Scalars['String']>;
  eligibility_state_reason?: InputMaybe<Scalars['String']>;
  email_id?: InputMaybe<Scalars['String']>;
  geo?: InputMaybe<Scalars['String']>;
  if_other?: InputMaybe<Scalars['String']>;
  impact?: InputMaybe<Scalars['String']>;
  informed_customer_platform?: InputMaybe<Scalars['String']>;
  internal_comments?: InputMaybe<Scalars['String']>;
  is_closed?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_the_content_instream?: InputMaybe<Scalars['String']>;
  is_the_content_professionally_produced?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  market?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notice_period_waiver_approved_by?: InputMaybe<Scalars['String']>;
  opportunity_comments?: InputMaybe<Scalars['String']>;
  opportunity_mrr?: InputMaybe<Scalars['numeric']>;
  opportunity_name?: InputMaybe<Scalars['String']>;
  opportunity_stage?: InputMaybe<Scalars['String']>;
  other_ctv_marketplace?: InputMaybe<Scalars['String']>;
  other_supported_video_metadata?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  platform_name?: InputMaybe<Scalars['String']>;
  poc_credits_requested?: InputMaybe<Scalars['numeric']>;
  poc_end_date?: InputMaybe<Scalars['date']>;
  poc_start_date?: InputMaybe<Scalars['date']>;
  priority?: InputMaybe<Scalars['String']>;
  project_success_criteria?: InputMaybe<Scalars['String']>;
  quip_doc_link?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  renewal?: InputMaybe<Scalars['numeric']>;
  request?: InputMaybe<Scalars['String']>;
  request_status?: InputMaybe<Scalars['String']>;
  requester_email?: InputMaybe<Scalars['String']>;
  rev_ops_department?: InputMaybe<Scalars['String']>;
  rev_ops_notes?: InputMaybe<Scalars['String']>;
  rev_ops_owner?: InputMaybe<Scalars['String']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_channel_id?: InputMaybe<Scalars['String']>;
  salesforce_contact_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_last_referenced_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_last_viewed_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_master_record_id?: InputMaybe<Scalars['String']>;
  salesforce_opportunity_id?: InputMaybe<Scalars['String']>;
  salesforce_owner_id?: InputMaybe<Scalars['String']>;
  salesforce_record_type_id?: InputMaybe<Scalars['String']>;
  salesforce_requester_id?: InputMaybe<Scalars['String']>;
  service_description?: InputMaybe<Scalars['String']>;
  show_churn_effective_date_warning?: InputMaybe<Scalars['Boolean']>;
  sla?: InputMaybe<Scalars['String']>;
  sst_jira_ticket?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  subject_second?: InputMaybe<Scalars['String']>;
  submission_date?: InputMaybe<Scalars['timestamptz']>;
  technical_description?: InputMaybe<Scalars['String']>;
  to_be_raised_for_poc_credits?: InputMaybe<Scalars['Boolean']>;
  type_of_request?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  vertical?: InputMaybe<Scalars['String']>;
  video_metadata_supported?: InputMaybe<Scalars['String']>;
  vod?: InputMaybe<Scalars['String']>;
  will_customer_provide_licensing_rights?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Case_Sum_Fields = {
  __typename?: 'case_sum_fields';
  avg_monthly_volumes_by_geo?: Maybe<Scalars['numeric']>;
  churn_value?: Maybe<Scalars['numeric']>;
  opportunity_mrr?: Maybe<Scalars['numeric']>;
  poc_credits_requested?: Maybe<Scalars['numeric']>;
  renewal?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "case" */
export type Case_Sum_Order_By = {
  avg_monthly_volumes_by_geo?: InputMaybe<Order_By>;
  churn_value?: InputMaybe<Order_By>;
  opportunity_mrr?: InputMaybe<Order_By>;
  poc_credits_requested?: InputMaybe<Order_By>;
  renewal?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Case_Var_Pop_Fields = {
  __typename?: 'case_var_pop_fields';
  avg_monthly_volumes_by_geo?: Maybe<Scalars['Float']>;
  churn_value?: Maybe<Scalars['Float']>;
  opportunity_mrr?: Maybe<Scalars['Float']>;
  poc_credits_requested?: Maybe<Scalars['Float']>;
  renewal?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "case" */
export type Case_Var_Pop_Order_By = {
  avg_monthly_volumes_by_geo?: InputMaybe<Order_By>;
  churn_value?: InputMaybe<Order_By>;
  opportunity_mrr?: InputMaybe<Order_By>;
  poc_credits_requested?: InputMaybe<Order_By>;
  renewal?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Case_Var_Samp_Fields = {
  __typename?: 'case_var_samp_fields';
  avg_monthly_volumes_by_geo?: Maybe<Scalars['Float']>;
  churn_value?: Maybe<Scalars['Float']>;
  opportunity_mrr?: Maybe<Scalars['Float']>;
  poc_credits_requested?: Maybe<Scalars['Float']>;
  renewal?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "case" */
export type Case_Var_Samp_Order_By = {
  avg_monthly_volumes_by_geo?: InputMaybe<Order_By>;
  churn_value?: InputMaybe<Order_By>;
  opportunity_mrr?: InputMaybe<Order_By>;
  poc_credits_requested?: InputMaybe<Order_By>;
  renewal?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Case_Variance_Fields = {
  __typename?: 'case_variance_fields';
  avg_monthly_volumes_by_geo?: Maybe<Scalars['Float']>;
  churn_value?: Maybe<Scalars['Float']>;
  opportunity_mrr?: Maybe<Scalars['Float']>;
  poc_credits_requested?: Maybe<Scalars['Float']>;
  renewal?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "case" */
export type Case_Variance_Order_By = {
  avg_monthly_volumes_by_geo?: InputMaybe<Order_By>;
  churn_value?: InputMaybe<Order_By>;
  opportunity_mrr?: InputMaybe<Order_By>;
  poc_credits_requested?: InputMaybe<Order_By>;
  renewal?: InputMaybe<Order_By>;
};

/** columns and relationships of "cdp_outstanding_amounts_mv" */
export type Cdp_Outstanding_Amounts_Mv = {
  __typename?: 'cdp_outstanding_amounts_mv';
  account_category?: Maybe<Scalars['String']>;
  account_legal_name?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  account_owner?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
  amagi_id?: Maybe<Scalars['String']>;
  billing_period?: Maybe<Scalars['String']>;
  business_category?: Maybe<Scalars['String']>;
  calc_date?: Maybe<Scalars['date']>;
  company_category?: Maybe<Scalars['String']>;
  credit_amount_usd?: Maybe<Scalars['numeric']>;
  currency?: Maybe<Scalars['String']>;
  customer_size?: Maybe<Scalars['String']>;
  customer_tier?: Maybe<Scalars['String']>;
  customer_type?: Maybe<Scalars['String']>;
  due_amount?: Maybe<Scalars['numeric']>;
  due_date?: Maybe<Scalars['date']>;
  first_payment_date?: Maybe<Scalars['date']>;
  industry_segment?: Maybe<Scalars['String']>;
  invoice_amount_usd?: Maybe<Scalars['numeric']>;
  invoice_due_date?: Maybe<Scalars['date']>;
  latest_payed_amount_usd?: Maybe<Scalars['numeric']>;
  latest_payment_date?: Maybe<Scalars['date']>;
  netsuite_created_at?: Maybe<Scalars['timestamptz']>;
  netsuite_customer_id?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  org_currency_amount_due?: Maybe<Scalars['numeric']>;
  org_currency_invoice_amount?: Maybe<Scalars['numeric']>;
  overdue?: Maybe<Scalars['numeric']>;
  overdue_0_30?: Maybe<Scalars['numeric']>;
  overdue_0_60?: Maybe<Scalars['numeric']>;
  overdue_0_90?: Maybe<Scalars['numeric']>;
  overdue_0_120?: Maybe<Scalars['numeric']>;
  overdue_0_150?: Maybe<Scalars['numeric']>;
  overdue_0_180?: Maybe<Scalars['numeric']>;
  overdue_180plus?: Maybe<Scalars['numeric']>;
  payment_status?: Maybe<Scalars['String']>;
  payment_terms?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  so_po_reference_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transaction_date?: Maybe<Scalars['date']>;
  transaction_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unapplied_receipt_amount_usd?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "cdp_outstanding_amounts_mv" */
export type Cdp_Outstanding_Amounts_Mv_Aggregate = {
  __typename?: 'cdp_outstanding_amounts_mv_aggregate';
  aggregate?: Maybe<Cdp_Outstanding_Amounts_Mv_Aggregate_Fields>;
  nodes: Array<Cdp_Outstanding_Amounts_Mv>;
};

/** aggregate fields of "cdp_outstanding_amounts_mv" */
export type Cdp_Outstanding_Amounts_Mv_Aggregate_Fields = {
  __typename?: 'cdp_outstanding_amounts_mv_aggregate_fields';
  avg?: Maybe<Cdp_Outstanding_Amounts_Mv_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Cdp_Outstanding_Amounts_Mv_Max_Fields>;
  min?: Maybe<Cdp_Outstanding_Amounts_Mv_Min_Fields>;
  stddev?: Maybe<Cdp_Outstanding_Amounts_Mv_Stddev_Fields>;
  stddev_pop?: Maybe<Cdp_Outstanding_Amounts_Mv_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cdp_Outstanding_Amounts_Mv_Stddev_Samp_Fields>;
  sum?: Maybe<Cdp_Outstanding_Amounts_Mv_Sum_Fields>;
  var_pop?: Maybe<Cdp_Outstanding_Amounts_Mv_Var_Pop_Fields>;
  var_samp?: Maybe<Cdp_Outstanding_Amounts_Mv_Var_Samp_Fields>;
  variance?: Maybe<Cdp_Outstanding_Amounts_Mv_Variance_Fields>;
};


/** aggregate fields of "cdp_outstanding_amounts_mv" */
export type Cdp_Outstanding_Amounts_Mv_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cdp_Outstanding_Amounts_Mv_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Cdp_Outstanding_Amounts_Mv_Avg_Fields = {
  __typename?: 'cdp_outstanding_amounts_mv_avg_fields';
  age?: Maybe<Scalars['Float']>;
  credit_amount_usd?: Maybe<Scalars['Float']>;
  due_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  latest_payed_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  org_currency_amount_due?: Maybe<Scalars['Float']>;
  org_currency_invoice_amount?: Maybe<Scalars['Float']>;
  overdue?: Maybe<Scalars['Float']>;
  overdue_0_30?: Maybe<Scalars['Float']>;
  overdue_0_60?: Maybe<Scalars['Float']>;
  overdue_0_90?: Maybe<Scalars['Float']>;
  overdue_0_120?: Maybe<Scalars['Float']>;
  overdue_0_150?: Maybe<Scalars['Float']>;
  overdue_0_180?: Maybe<Scalars['Float']>;
  overdue_180plus?: Maybe<Scalars['Float']>;
  unapplied_receipt_amount_usd?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cdp_outstanding_amounts_mv". All fields are combined with a logical 'AND'. */
export type Cdp_Outstanding_Amounts_Mv_Bool_Exp = {
  _and?: InputMaybe<Array<Cdp_Outstanding_Amounts_Mv_Bool_Exp>>;
  _not?: InputMaybe<Cdp_Outstanding_Amounts_Mv_Bool_Exp>;
  _or?: InputMaybe<Array<Cdp_Outstanding_Amounts_Mv_Bool_Exp>>;
  account_category?: InputMaybe<String_Comparison_Exp>;
  account_legal_name?: InputMaybe<String_Comparison_Exp>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  account_owner?: InputMaybe<String_Comparison_Exp>;
  age?: InputMaybe<Int_Comparison_Exp>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  billing_period?: InputMaybe<String_Comparison_Exp>;
  business_category?: InputMaybe<String_Comparison_Exp>;
  calc_date?: InputMaybe<Date_Comparison_Exp>;
  company_category?: InputMaybe<String_Comparison_Exp>;
  credit_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  customer_size?: InputMaybe<String_Comparison_Exp>;
  customer_tier?: InputMaybe<String_Comparison_Exp>;
  customer_type?: InputMaybe<String_Comparison_Exp>;
  due_amount?: InputMaybe<Numeric_Comparison_Exp>;
  due_date?: InputMaybe<Date_Comparison_Exp>;
  first_payment_date?: InputMaybe<Date_Comparison_Exp>;
  industry_segment?: InputMaybe<String_Comparison_Exp>;
  invoice_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  invoice_due_date?: InputMaybe<Date_Comparison_Exp>;
  latest_payed_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  latest_payment_date?: InputMaybe<Date_Comparison_Exp>;
  netsuite_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  netsuite_customer_id?: InputMaybe<Numeric_Comparison_Exp>;
  netsuite_id?: InputMaybe<Numeric_Comparison_Exp>;
  org_currency_amount_due?: InputMaybe<Numeric_Comparison_Exp>;
  org_currency_invoice_amount?: InputMaybe<Numeric_Comparison_Exp>;
  overdue?: InputMaybe<Numeric_Comparison_Exp>;
  overdue_0_30?: InputMaybe<Numeric_Comparison_Exp>;
  overdue_0_60?: InputMaybe<Numeric_Comparison_Exp>;
  overdue_0_90?: InputMaybe<Numeric_Comparison_Exp>;
  overdue_0_120?: InputMaybe<Numeric_Comparison_Exp>;
  overdue_0_150?: InputMaybe<Numeric_Comparison_Exp>;
  overdue_0_180?: InputMaybe<Numeric_Comparison_Exp>;
  overdue_180plus?: InputMaybe<Numeric_Comparison_Exp>;
  payment_status?: InputMaybe<String_Comparison_Exp>;
  payment_terms?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  so_po_reference_number?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  transaction_date?: InputMaybe<Date_Comparison_Exp>;
  transaction_id?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  unapplied_receipt_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Cdp_Outstanding_Amounts_Mv_Max_Fields = {
  __typename?: 'cdp_outstanding_amounts_mv_max_fields';
  account_category?: Maybe<Scalars['String']>;
  account_legal_name?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  account_owner?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
  amagi_id?: Maybe<Scalars['String']>;
  billing_period?: Maybe<Scalars['String']>;
  business_category?: Maybe<Scalars['String']>;
  calc_date?: Maybe<Scalars['date']>;
  company_category?: Maybe<Scalars['String']>;
  credit_amount_usd?: Maybe<Scalars['numeric']>;
  currency?: Maybe<Scalars['String']>;
  customer_size?: Maybe<Scalars['String']>;
  customer_tier?: Maybe<Scalars['String']>;
  customer_type?: Maybe<Scalars['String']>;
  due_amount?: Maybe<Scalars['numeric']>;
  due_date?: Maybe<Scalars['date']>;
  first_payment_date?: Maybe<Scalars['date']>;
  industry_segment?: Maybe<Scalars['String']>;
  invoice_amount_usd?: Maybe<Scalars['numeric']>;
  invoice_due_date?: Maybe<Scalars['date']>;
  latest_payed_amount_usd?: Maybe<Scalars['numeric']>;
  latest_payment_date?: Maybe<Scalars['date']>;
  netsuite_created_at?: Maybe<Scalars['timestamptz']>;
  netsuite_customer_id?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  org_currency_amount_due?: Maybe<Scalars['numeric']>;
  org_currency_invoice_amount?: Maybe<Scalars['numeric']>;
  overdue?: Maybe<Scalars['numeric']>;
  overdue_0_30?: Maybe<Scalars['numeric']>;
  overdue_0_60?: Maybe<Scalars['numeric']>;
  overdue_0_90?: Maybe<Scalars['numeric']>;
  overdue_0_120?: Maybe<Scalars['numeric']>;
  overdue_0_150?: Maybe<Scalars['numeric']>;
  overdue_0_180?: Maybe<Scalars['numeric']>;
  overdue_180plus?: Maybe<Scalars['numeric']>;
  payment_status?: Maybe<Scalars['String']>;
  payment_terms?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  so_po_reference_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transaction_date?: Maybe<Scalars['date']>;
  transaction_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unapplied_receipt_amount_usd?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Cdp_Outstanding_Amounts_Mv_Min_Fields = {
  __typename?: 'cdp_outstanding_amounts_mv_min_fields';
  account_category?: Maybe<Scalars['String']>;
  account_legal_name?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  account_owner?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
  amagi_id?: Maybe<Scalars['String']>;
  billing_period?: Maybe<Scalars['String']>;
  business_category?: Maybe<Scalars['String']>;
  calc_date?: Maybe<Scalars['date']>;
  company_category?: Maybe<Scalars['String']>;
  credit_amount_usd?: Maybe<Scalars['numeric']>;
  currency?: Maybe<Scalars['String']>;
  customer_size?: Maybe<Scalars['String']>;
  customer_tier?: Maybe<Scalars['String']>;
  customer_type?: Maybe<Scalars['String']>;
  due_amount?: Maybe<Scalars['numeric']>;
  due_date?: Maybe<Scalars['date']>;
  first_payment_date?: Maybe<Scalars['date']>;
  industry_segment?: Maybe<Scalars['String']>;
  invoice_amount_usd?: Maybe<Scalars['numeric']>;
  invoice_due_date?: Maybe<Scalars['date']>;
  latest_payed_amount_usd?: Maybe<Scalars['numeric']>;
  latest_payment_date?: Maybe<Scalars['date']>;
  netsuite_created_at?: Maybe<Scalars['timestamptz']>;
  netsuite_customer_id?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  org_currency_amount_due?: Maybe<Scalars['numeric']>;
  org_currency_invoice_amount?: Maybe<Scalars['numeric']>;
  overdue?: Maybe<Scalars['numeric']>;
  overdue_0_30?: Maybe<Scalars['numeric']>;
  overdue_0_60?: Maybe<Scalars['numeric']>;
  overdue_0_90?: Maybe<Scalars['numeric']>;
  overdue_0_120?: Maybe<Scalars['numeric']>;
  overdue_0_150?: Maybe<Scalars['numeric']>;
  overdue_0_180?: Maybe<Scalars['numeric']>;
  overdue_180plus?: Maybe<Scalars['numeric']>;
  payment_status?: Maybe<Scalars['String']>;
  payment_terms?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  so_po_reference_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transaction_date?: Maybe<Scalars['date']>;
  transaction_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unapplied_receipt_amount_usd?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "cdp_outstanding_amounts_mv". */
export type Cdp_Outstanding_Amounts_Mv_Order_By = {
  account_category?: InputMaybe<Order_By>;
  account_legal_name?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  account_owner?: InputMaybe<Order_By>;
  age?: InputMaybe<Order_By>;
  amagi_id?: InputMaybe<Order_By>;
  billing_period?: InputMaybe<Order_By>;
  business_category?: InputMaybe<Order_By>;
  calc_date?: InputMaybe<Order_By>;
  company_category?: InputMaybe<Order_By>;
  credit_amount_usd?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_size?: InputMaybe<Order_By>;
  customer_tier?: InputMaybe<Order_By>;
  customer_type?: InputMaybe<Order_By>;
  due_amount?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  first_payment_date?: InputMaybe<Order_By>;
  industry_segment?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  invoice_due_date?: InputMaybe<Order_By>;
  latest_payed_amount_usd?: InputMaybe<Order_By>;
  latest_payment_date?: InputMaybe<Order_By>;
  netsuite_created_at?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  org_currency_amount_due?: InputMaybe<Order_By>;
  org_currency_invoice_amount?: InputMaybe<Order_By>;
  overdue?: InputMaybe<Order_By>;
  overdue_0_30?: InputMaybe<Order_By>;
  overdue_0_60?: InputMaybe<Order_By>;
  overdue_0_90?: InputMaybe<Order_By>;
  overdue_0_120?: InputMaybe<Order_By>;
  overdue_0_150?: InputMaybe<Order_By>;
  overdue_0_180?: InputMaybe<Order_By>;
  overdue_180plus?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  so_po_reference_number?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unapplied_receipt_amount_usd?: InputMaybe<Order_By>;
};

/** select columns of table "cdp_outstanding_amounts_mv" */
export enum Cdp_Outstanding_Amounts_Mv_Select_Column {
  /** column name */
  AccountCategory = 'account_category',
  /** column name */
  AccountLegalName = 'account_legal_name',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  AccountOwner = 'account_owner',
  /** column name */
  Age = 'age',
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  BillingPeriod = 'billing_period',
  /** column name */
  BusinessCategory = 'business_category',
  /** column name */
  CalcDate = 'calc_date',
  /** column name */
  CompanyCategory = 'company_category',
  /** column name */
  CreditAmountUsd = 'credit_amount_usd',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerSize = 'customer_size',
  /** column name */
  CustomerTier = 'customer_tier',
  /** column name */
  CustomerType = 'customer_type',
  /** column name */
  DueAmount = 'due_amount',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  FirstPaymentDate = 'first_payment_date',
  /** column name */
  IndustrySegment = 'industry_segment',
  /** column name */
  InvoiceAmountUsd = 'invoice_amount_usd',
  /** column name */
  InvoiceDueDate = 'invoice_due_date',
  /** column name */
  LatestPayedAmountUsd = 'latest_payed_amount_usd',
  /** column name */
  LatestPaymentDate = 'latest_payment_date',
  /** column name */
  NetsuiteCreatedAt = 'netsuite_created_at',
  /** column name */
  NetsuiteCustomerId = 'netsuite_customer_id',
  /** column name */
  NetsuiteId = 'netsuite_id',
  /** column name */
  OrgCurrencyAmountDue = 'org_currency_amount_due',
  /** column name */
  OrgCurrencyInvoiceAmount = 'org_currency_invoice_amount',
  /** column name */
  Overdue = 'overdue',
  /** column name */
  Overdue_0_30 = 'overdue_0_30',
  /** column name */
  Overdue_0_60 = 'overdue_0_60',
  /** column name */
  Overdue_0_90 = 'overdue_0_90',
  /** column name */
  Overdue_0_120 = 'overdue_0_120',
  /** column name */
  Overdue_0_150 = 'overdue_0_150',
  /** column name */
  Overdue_0_180 = 'overdue_0_180',
  /** column name */
  Overdue_180plus = 'overdue_180plus',
  /** column name */
  PaymentStatus = 'payment_status',
  /** column name */
  PaymentTerms = 'payment_terms',
  /** column name */
  Region = 'region',
  /** column name */
  SoPoReferenceNumber = 'so_po_reference_number',
  /** column name */
  Status = 'status',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  Type = 'type',
  /** column name */
  UnappliedReceiptAmountUsd = 'unapplied_receipt_amount_usd'
}

/** aggregate stddev on columns */
export type Cdp_Outstanding_Amounts_Mv_Stddev_Fields = {
  __typename?: 'cdp_outstanding_amounts_mv_stddev_fields';
  age?: Maybe<Scalars['Float']>;
  credit_amount_usd?: Maybe<Scalars['Float']>;
  due_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  latest_payed_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  org_currency_amount_due?: Maybe<Scalars['Float']>;
  org_currency_invoice_amount?: Maybe<Scalars['Float']>;
  overdue?: Maybe<Scalars['Float']>;
  overdue_0_30?: Maybe<Scalars['Float']>;
  overdue_0_60?: Maybe<Scalars['Float']>;
  overdue_0_90?: Maybe<Scalars['Float']>;
  overdue_0_120?: Maybe<Scalars['Float']>;
  overdue_0_150?: Maybe<Scalars['Float']>;
  overdue_0_180?: Maybe<Scalars['Float']>;
  overdue_180plus?: Maybe<Scalars['Float']>;
  unapplied_receipt_amount_usd?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Cdp_Outstanding_Amounts_Mv_Stddev_Pop_Fields = {
  __typename?: 'cdp_outstanding_amounts_mv_stddev_pop_fields';
  age?: Maybe<Scalars['Float']>;
  credit_amount_usd?: Maybe<Scalars['Float']>;
  due_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  latest_payed_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  org_currency_amount_due?: Maybe<Scalars['Float']>;
  org_currency_invoice_amount?: Maybe<Scalars['Float']>;
  overdue?: Maybe<Scalars['Float']>;
  overdue_0_30?: Maybe<Scalars['Float']>;
  overdue_0_60?: Maybe<Scalars['Float']>;
  overdue_0_90?: Maybe<Scalars['Float']>;
  overdue_0_120?: Maybe<Scalars['Float']>;
  overdue_0_150?: Maybe<Scalars['Float']>;
  overdue_0_180?: Maybe<Scalars['Float']>;
  overdue_180plus?: Maybe<Scalars['Float']>;
  unapplied_receipt_amount_usd?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Cdp_Outstanding_Amounts_Mv_Stddev_Samp_Fields = {
  __typename?: 'cdp_outstanding_amounts_mv_stddev_samp_fields';
  age?: Maybe<Scalars['Float']>;
  credit_amount_usd?: Maybe<Scalars['Float']>;
  due_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  latest_payed_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  org_currency_amount_due?: Maybe<Scalars['Float']>;
  org_currency_invoice_amount?: Maybe<Scalars['Float']>;
  overdue?: Maybe<Scalars['Float']>;
  overdue_0_30?: Maybe<Scalars['Float']>;
  overdue_0_60?: Maybe<Scalars['Float']>;
  overdue_0_90?: Maybe<Scalars['Float']>;
  overdue_0_120?: Maybe<Scalars['Float']>;
  overdue_0_150?: Maybe<Scalars['Float']>;
  overdue_0_180?: Maybe<Scalars['Float']>;
  overdue_180plus?: Maybe<Scalars['Float']>;
  unapplied_receipt_amount_usd?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cdp_outstanding_amounts_mv" */
export type Cdp_Outstanding_Amounts_Mv_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cdp_Outstanding_Amounts_Mv_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cdp_Outstanding_Amounts_Mv_Stream_Cursor_Value_Input = {
  account_category?: InputMaybe<Scalars['String']>;
  account_legal_name?: InputMaybe<Scalars['String']>;
  account_name?: InputMaybe<Scalars['String']>;
  account_owner?: InputMaybe<Scalars['String']>;
  age?: InputMaybe<Scalars['Int']>;
  amagi_id?: InputMaybe<Scalars['String']>;
  billing_period?: InputMaybe<Scalars['String']>;
  business_category?: InputMaybe<Scalars['String']>;
  calc_date?: InputMaybe<Scalars['date']>;
  company_category?: InputMaybe<Scalars['String']>;
  credit_amount_usd?: InputMaybe<Scalars['numeric']>;
  currency?: InputMaybe<Scalars['String']>;
  customer_size?: InputMaybe<Scalars['String']>;
  customer_tier?: InputMaybe<Scalars['String']>;
  customer_type?: InputMaybe<Scalars['String']>;
  due_amount?: InputMaybe<Scalars['numeric']>;
  due_date?: InputMaybe<Scalars['date']>;
  first_payment_date?: InputMaybe<Scalars['date']>;
  industry_segment?: InputMaybe<Scalars['String']>;
  invoice_amount_usd?: InputMaybe<Scalars['numeric']>;
  invoice_due_date?: InputMaybe<Scalars['date']>;
  latest_payed_amount_usd?: InputMaybe<Scalars['numeric']>;
  latest_payment_date?: InputMaybe<Scalars['date']>;
  netsuite_created_at?: InputMaybe<Scalars['timestamptz']>;
  netsuite_customer_id?: InputMaybe<Scalars['numeric']>;
  netsuite_id?: InputMaybe<Scalars['numeric']>;
  org_currency_amount_due?: InputMaybe<Scalars['numeric']>;
  org_currency_invoice_amount?: InputMaybe<Scalars['numeric']>;
  overdue?: InputMaybe<Scalars['numeric']>;
  overdue_0_30?: InputMaybe<Scalars['numeric']>;
  overdue_0_60?: InputMaybe<Scalars['numeric']>;
  overdue_0_90?: InputMaybe<Scalars['numeric']>;
  overdue_0_120?: InputMaybe<Scalars['numeric']>;
  overdue_0_150?: InputMaybe<Scalars['numeric']>;
  overdue_0_180?: InputMaybe<Scalars['numeric']>;
  overdue_180plus?: InputMaybe<Scalars['numeric']>;
  payment_status?: InputMaybe<Scalars['String']>;
  payment_terms?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  so_po_reference_number?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  transaction_date?: InputMaybe<Scalars['date']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unapplied_receipt_amount_usd?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Cdp_Outstanding_Amounts_Mv_Sum_Fields = {
  __typename?: 'cdp_outstanding_amounts_mv_sum_fields';
  age?: Maybe<Scalars['Int']>;
  credit_amount_usd?: Maybe<Scalars['numeric']>;
  due_amount?: Maybe<Scalars['numeric']>;
  invoice_amount_usd?: Maybe<Scalars['numeric']>;
  latest_payed_amount_usd?: Maybe<Scalars['numeric']>;
  netsuite_customer_id?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  org_currency_amount_due?: Maybe<Scalars['numeric']>;
  org_currency_invoice_amount?: Maybe<Scalars['numeric']>;
  overdue?: Maybe<Scalars['numeric']>;
  overdue_0_30?: Maybe<Scalars['numeric']>;
  overdue_0_60?: Maybe<Scalars['numeric']>;
  overdue_0_90?: Maybe<Scalars['numeric']>;
  overdue_0_120?: Maybe<Scalars['numeric']>;
  overdue_0_150?: Maybe<Scalars['numeric']>;
  overdue_0_180?: Maybe<Scalars['numeric']>;
  overdue_180plus?: Maybe<Scalars['numeric']>;
  unapplied_receipt_amount_usd?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Cdp_Outstanding_Amounts_Mv_Var_Pop_Fields = {
  __typename?: 'cdp_outstanding_amounts_mv_var_pop_fields';
  age?: Maybe<Scalars['Float']>;
  credit_amount_usd?: Maybe<Scalars['Float']>;
  due_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  latest_payed_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  org_currency_amount_due?: Maybe<Scalars['Float']>;
  org_currency_invoice_amount?: Maybe<Scalars['Float']>;
  overdue?: Maybe<Scalars['Float']>;
  overdue_0_30?: Maybe<Scalars['Float']>;
  overdue_0_60?: Maybe<Scalars['Float']>;
  overdue_0_90?: Maybe<Scalars['Float']>;
  overdue_0_120?: Maybe<Scalars['Float']>;
  overdue_0_150?: Maybe<Scalars['Float']>;
  overdue_0_180?: Maybe<Scalars['Float']>;
  overdue_180plus?: Maybe<Scalars['Float']>;
  unapplied_receipt_amount_usd?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Cdp_Outstanding_Amounts_Mv_Var_Samp_Fields = {
  __typename?: 'cdp_outstanding_amounts_mv_var_samp_fields';
  age?: Maybe<Scalars['Float']>;
  credit_amount_usd?: Maybe<Scalars['Float']>;
  due_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  latest_payed_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  org_currency_amount_due?: Maybe<Scalars['Float']>;
  org_currency_invoice_amount?: Maybe<Scalars['Float']>;
  overdue?: Maybe<Scalars['Float']>;
  overdue_0_30?: Maybe<Scalars['Float']>;
  overdue_0_60?: Maybe<Scalars['Float']>;
  overdue_0_90?: Maybe<Scalars['Float']>;
  overdue_0_120?: Maybe<Scalars['Float']>;
  overdue_0_150?: Maybe<Scalars['Float']>;
  overdue_0_180?: Maybe<Scalars['Float']>;
  overdue_180plus?: Maybe<Scalars['Float']>;
  unapplied_receipt_amount_usd?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Cdp_Outstanding_Amounts_Mv_Variance_Fields = {
  __typename?: 'cdp_outstanding_amounts_mv_variance_fields';
  age?: Maybe<Scalars['Float']>;
  credit_amount_usd?: Maybe<Scalars['Float']>;
  due_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  latest_payed_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  org_currency_amount_due?: Maybe<Scalars['Float']>;
  org_currency_invoice_amount?: Maybe<Scalars['Float']>;
  overdue?: Maybe<Scalars['Float']>;
  overdue_0_30?: Maybe<Scalars['Float']>;
  overdue_0_60?: Maybe<Scalars['Float']>;
  overdue_0_90?: Maybe<Scalars['Float']>;
  overdue_0_120?: Maybe<Scalars['Float']>;
  overdue_0_150?: Maybe<Scalars['Float']>;
  overdue_0_180?: Maybe<Scalars['Float']>;
  overdue_180plus?: Maybe<Scalars['Float']>;
  unapplied_receipt_amount_usd?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "cdp_top10_non_paying_cust_mv" */
export type cdp_top10_non_paying_cust_mv= {
  __typename?: 'cdp_top10_non_paying_cust_mv';
  account_name?: Maybe<Scalars['String']>;
  amagi_id?: Maybe<Scalars['String']>;
  final_due_amount?: Maybe<Scalars['numeric']>;
  logo?: Maybe<Scalars['String']>;
  netsuite_customer_id?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "cdp_top10_non_paying_cust_mv". All fields are combined with a logical 'AND'. */
export type cdp_top10_non_paying_Cust_Mv_Bool_Exp = {
  _and?: InputMaybe<Array<cdp_top10_non_paying_Cust_Mv_Bool_Exp>>;
  _not?: InputMaybe<cdp_top10_non_paying_Cust_Mv_Bool_Exp>;
  _or?: InputMaybe<Array<cdp_top10_non_paying_Cust_Mv_Bool_Exp>>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  final_due_amount?: InputMaybe<Numeric_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  netsuite_customer_id?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Ordering options when selecting data from "cdp_top10_non_paying_cust_mv". */
export type cdp_top10_non_paying_Cust_Mv_Order_By = {
  account_name?: InputMaybe<Order_By>;
  amagi_id?: InputMaybe<Order_By>;
  final_due_amount?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
};

/** select columns of table "cdp_top10_non_paying_cust_mv" */
export enum cdp_top10_non_paying_Cust_Mv_Select_Column {
  /** column name */
  AccountName = 'account_name',
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  FinalDueAmount = 'final_due_amount',
  /** column name */
  Logo = 'logo',
  /** column name */
  NetsuiteCustomerId = 'netsuite_customer_id'
}

/** Streaming cursor of the table "cdp_top10_non_paying_cust_mv" */
export type cdp_top10_non_paying_Cust_Mv_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: cdp_top10_non_paying_Cust_Mv_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cdp_top10_non_paying_Cust_Mv_Stream_Cursor_Value_Input = {
  account_name?: InputMaybe<Scalars['String']>;
  amagi_id?: InputMaybe<Scalars['String']>;
  final_due_amount?: InputMaybe<Scalars['numeric']>;
  logo?: InputMaybe<Scalars['String']>;
  netsuite_customer_id?: InputMaybe<Scalars['numeric']>;
};

/** columns and relationships of "cdp_top10_paying_cust_mv" */
export type cdp_top10_paying_Cust_Mv = {
  __typename?: 'cdp_top10_paying_cust_mv';
  account_name?: Maybe<Scalars['String']>;
  amagi_id?: Maybe<Scalars['String']>;
  invoice_amount_usd?: Maybe<Scalars['numeric']>;
  logo?: Maybe<Scalars['String']>;
  netsuite_customer_id?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "cdp_top10_paying_cust_mv". All fields are combined with a logical 'AND'. */
export type cdp_top10_paying_Cust_Mv_Bool_Exp = {
  _and?: InputMaybe<Array<cdp_top10_paying_Cust_Mv_Bool_Exp>>;
  _not?: InputMaybe<cdp_top10_paying_Cust_Mv_Bool_Exp>;
  _or?: InputMaybe<Array<cdp_top10_paying_Cust_Mv_Bool_Exp>>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  invoice_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  netsuite_customer_id?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Ordering options when selecting data from "cdp_top10_paying_cust_mv". */
export type cdp_top10_paying_Cust_Mv_Order_By = {
  account_name?: InputMaybe<Order_By>;
  amagi_id?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
};

/** select columns of table "cdp_top10_paying_cust_mv" */
export enum cdp_top10_paying_Cust_Mv_Select_Column {
  /** column name */
  AccountName = 'account_name',
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  InvoiceAmountUsd = 'invoice_amount_usd',
  /** column name */
  Logo = 'logo',
  /** column name */
  NetsuiteCustomerId = 'netsuite_customer_id'
}

/** Streaming cursor of the table "cdp_top10_paying_cust_mv" */
export type cdp_top10_paying_Cust_Mv_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: cdp_top10_paying_Cust_Mv_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type cdp_top10_paying_Cust_Mv_Stream_Cursor_Value_Input = {
  account_name?: InputMaybe<Scalars['String']>;
  amagi_id?: InputMaybe<Scalars['String']>;
  invoice_amount_usd?: InputMaybe<Scalars['numeric']>;
  logo?: InputMaybe<Scalars['String']>;
  netsuite_customer_id?: InputMaybe<Scalars['numeric']>;
};

/** columns and relationships of "channel" */
export type Channel = {
  __typename?: 'channel';
  ad_flag?: Maybe<Scalars['Boolean']>;
  amagi_auto_cc_generation?: Maybe<Scalars['Boolean']>;
  amagi_id_of_channel_owner?: Maybe<Scalars['String']>;
  audio_format?: Maybe<Scalars['String']>;
  availablity_country_and_regions?: Maybe<Scalars['jsonb']>;
  billing_contact?: Maybe<Scalars['String']>;
  channel_brand?: Maybe<Scalars['String']>;
  channel_content_type?: Maybe<Scalars['String']>;
  channel_country?: Maybe<Scalars['jsonb']>;
  channel_end_time?: Maybe<Scalars['timestamptz']>;
  channel_id?: Maybe<Scalars['String']>;
  channel_logo_bug?: Maybe<Scalars['Boolean']>;
  channel_master_id?: Maybe<Scalars['uuid']>;
  channel_origin_country_region?: Maybe<Scalars['String']>;
  channel_rating?: Maybe<Scalars['jsonb']>;
  channel_region?: Maybe<Scalars['jsonb']>;
  channel_resolution?: Maybe<Scalars['String']>;
  channel_start_time?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  channel_to_channel: Array<Channel>;
  /** An aggregate relationship */
  channel_to_channel_aggregate: Channel_Aggregate;
  /** An object relationship */
  channel_to_channel_master?: Maybe<Channel_Master>;
  /** An object relationship */
  channel_to_channel_of_grouped?: Maybe<Channel>;
  /** An array relationship */
  channel_to_delivery: Array<Delivery>;
  /** An aggregate relationship */
  channel_to_delivery_aggregate: Delivery_Aggregate;
  channel_type?: Maybe<Scalars['String']>;
  channels_grouped?: Maybe<Scalars['String']>;
  closed_caption?: Maybe<Scalars['Boolean']>;
  closed_caption_language?: Maybe<Scalars['jsonb']>;
  closed_caption_type?: Maybe<Scalars['String']>;
  closed_captioning?: Maybe<Scalars['Boolean']>;
  content_ingest_format?: Maybe<Scalars['String']>;
  create_pop_channel?: Maybe<Scalars['Boolean']>;
  create_promotional?: Maybe<Scalars['Boolean']>;
  create_short_form_video?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  custom_fields?: Maybe<Scalars['jsonb']>;
  custom_tags: Scalars['jsonb'];
  /** An object relationship */
  customer?: Maybe<Account>;
  customer_description?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['jsonb']>;
  description_long?: Maybe<Scalars['String']>;
  description_short?: Maybe<Scalars['String']>;
  dubbing?: Maybe<Scalars['Boolean']>;
  dubbing_language?: Maybe<Scalars['jsonb']>;
  duplicate_salesforce_id?: Maybe<Scalars['String']>;
  edit_promotional?: Maybe<Scalars['Boolean']>;
  facebook?: Maybe<Scalars['String']>;
  fast?: Maybe<Scalars['String']>;
  feed_type?: Maybe<Scalars['String']>;
  genre?: Maybe<Scalars['jsonb']>;
  graphics_enabled?: Maybe<Scalars['Boolean']>;
  graphics_format?: Maybe<Scalars['String']>;
  graphics_support?: Maybe<Scalars['jsonb']>;
  graphics_type?: Maybe<Scalars['String']>;
  grouped_channel?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** A computed field, executes function "convert_to_string" */
  id_text?: Maybe<Scalars['String']>;
  input_audio_format?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  is_adsplus_channel?: Maybe<Scalars['Boolean']>;
  is_contentplus_channel?: Maybe<Scalars['Boolean']>;
  is_deleted: Scalars['Boolean'];
  is_duplicate?: Maybe<Scalars['Boolean']>;
  is_duplicate_salesforce?: Maybe<Scalars['Boolean']>;
  is_redundant?: Maybe<Scalars['Boolean']>;
  is_salesforce_channel?: Maybe<Scalars['Boolean']>;
  keyring?: Maybe<Scalars['jsonb']>;
  language?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  live_feed_input?: Maybe<Scalars['String']>;
  live_management?: Maybe<Scalars['Boolean']>;
  live_playout?: Maybe<Scalars['Boolean']>;
  live_recording?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Scalars['String']>;
  metadata_ingest_format?: Maybe<Scalars['String']>;
  multiple_salesforce_id?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  onboarded_date?: Maybe<Scalars['date']>;
  ordered_channel?: Maybe<Scalars['String']>;
  original_audio_language?: Maybe<Scalars['String']>;
  paid_flag?: Maybe<Scalars['Boolean']>;
  parental_rating_standard?: Maybe<Scalars['String']>;
  platform_delivered_to?: Maybe<Scalars['jsonb']>;
  playlist_format?: Maybe<Scalars['String']>;
  playout_format?: Maybe<Scalars['String']>;
  posters?: Maybe<Scalars['jsonb']>;
  presentations?: Maybe<Scalars['jsonb']>;
  promotion_flag?: Maybe<Scalars['Boolean']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  short_description?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sponsorship?: Maybe<Scalars['Boolean']>;
  ssai_partner?: Maybe<Scalars['String']>;
  start_time?: Maybe<Scalars['time']>;
  stream_container_type?: Maybe<Scalars['String']>;
  sub_genre?: Maybe<Scalars['jsonb']>;
  subtitle_language?: Maybe<Scalars['jsonb']>;
  subtitle_support?: Maybe<Scalars['Boolean']>;
  subtitle_type?: Maybe<Scalars['jsonb']>;
  subtitling?: Maybe<Scalars['Boolean']>;
  target_audience?: Maybe<Scalars['jsonb']>;
  time_zone?: Maybe<Scalars['String']>;
  trademark_and_logo?: Maybe<Scalars['Boolean']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  use_of_display_technology?: Maybe<Scalars['Boolean']>;
  video_format?: Maybe<Scalars['String']>;
  videos?: Maybe<Scalars['jsonb']>;
};

/** columns and relationships of "redundant_playout_channels" */
export type Redundant_Playout_Channels = {
  __typename?: 'redundant_playout_channels';
  channel_id: Scalars['uuid'];
  delivery_id: Scalars['uuid'];
  redundant_channel_id: Scalars['uuid'];
};

/** response of any mutation on the table "redundant_playout_channels" */
export type Redundant_Playout_Channels_Mutation_Response = {
  __typename?: 'redundant_playout_channels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Redundant_Playout_Channels>;
};

/** columns and relationships of "channel" */
export type ChannelAvailablity_Country_And_RegionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelChannel_CountryArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelChannel_RatingArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelChannel_RegionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelChannel_To_ChannelArgs = {
  distinct_on?: InputMaybe<Array<Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Order_By>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


/** columns and relationships of "channel" */
export type ChannelChannel_To_Channel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Order_By>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


/** columns and relationships of "channel" */
export type ChannelChannel_To_DeliveryArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Order_By>>;
  where?: InputMaybe<Delivery_Bool_Exp>;
};


/** columns and relationships of "channel" */
export type ChannelChannel_To_Delivery_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Order_By>>;
  where?: InputMaybe<Delivery_Bool_Exp>;
};


/** columns and relationships of "channel" */
export type ChannelClosed_Caption_LanguageArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelCustom_FieldsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelCustom_TagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelDescriptionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelDubbing_LanguageArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelGenreArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelGraphics_SupportArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelKeyringArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelMultiple_Salesforce_IdArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelPlatform_Delivered_ToArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelPostersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelPresentationsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelSub_GenreArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelSubtitle_LanguageArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelSubtitle_TypeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelTarget_AudienceArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "channel" */
export type ChannelVideosArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "channel_active" */
export type Channel_Active = {
  __typename?: 'channel_active';
  /** An object relationship */
  channel_info?: Maybe<Channel>;
  /** An object relationship */
  platform_info?: Maybe<Platform>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "channel_active" */
export type Channel_Active_Aggregate = {
  __typename?: 'channel_active_aggregate';
  aggregate?: Maybe<Channel_Active_Aggregate_Fields>;
  nodes: Array<Channel_Active>;
};

/** aggregate fields of "channel_active" */
export type Channel_Active_Aggregate_Fields = {
  __typename?: 'channel_active_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Channel_Active_Max_Fields>;
  min?: Maybe<Channel_Active_Min_Fields>;
};


/** aggregate fields of "channel_active" */
export type Channel_Active_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Channel_Active_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "channel_active". All fields are combined with a logical 'AND'. */
export type Channel_Active_Bool_Exp = {
  _and?: InputMaybe<Array<Channel_Active_Bool_Exp>>;
  _not?: InputMaybe<Channel_Active_Bool_Exp>;
  _or?: InputMaybe<Array<Channel_Active_Bool_Exp>>;
  channel_info?: InputMaybe<Channel_Bool_Exp>;
  platform_info?: InputMaybe<Platform_Bool_Exp>;
  salesforce_channel_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_platform_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Channel_Active_Max_Fields = {
  __typename?: 'channel_active_max_fields';
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Channel_Active_Min_Fields = {
  __typename?: 'channel_active_min_fields';
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "channel_active". */
export type Channel_Active_Order_By = {
  channel_info?: InputMaybe<Channel_Order_By>;
  platform_info?: InputMaybe<Platform_Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
};

/** select columns of table "channel_active" */
export enum Channel_Active_Select_Column {
  /** column name */
  SalesforceChannelId = 'salesforce_channel_id',
  /** column name */
  SalesforcePlatformId = 'salesforce_platform_id'
}

/** Streaming cursor of the table "channel_active" */
export type Channel_Active_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Channel_Active_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Channel_Active_Stream_Cursor_Value_Input = {
  salesforce_channel_id?: InputMaybe<Scalars['String']>;
  salesforce_platform_id?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "channel" */
export type Channel_Aggregate = {
  __typename?: 'channel_aggregate';
  aggregate?: Maybe<Channel_Aggregate_Fields>;
  nodes: Array<Channel>;
};

export type Channel_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Channel_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Channel_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Channel_Aggregate_Bool_Exp_Count>;
};

export type Channel_Aggregate_Bool_Exp_Bool_And = {
  arguments: Channel_Select_Column_Channel_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Channel_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Channel_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Channel_Select_Column_Channel_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Channel_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Channel_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Channel_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Channel_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "channel" */
export type Channel_Aggregate_Fields = {
  __typename?: 'channel_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Channel_Max_Fields>;
  min?: Maybe<Channel_Min_Fields>;
};


/** aggregate fields of "channel" */
export type Channel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Channel_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "channel" */
export type Channel_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Channel_Max_Order_By>;
  min?: InputMaybe<Channel_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Channel_Append_Input = {
  availablity_country_and_regions?: InputMaybe<Scalars['jsonb']>;
  channel_country?: InputMaybe<Scalars['jsonb']>;
  channel_rating?: InputMaybe<Scalars['jsonb']>;
  channel_region?: InputMaybe<Scalars['jsonb']>;
  closed_caption_language?: InputMaybe<Scalars['jsonb']>;
  custom_fields?: InputMaybe<Scalars['jsonb']>;
  custom_tags?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['jsonb']>;
  dubbing_language?: InputMaybe<Scalars['jsonb']>;
  genre?: InputMaybe<Scalars['jsonb']>;
  graphics_support?: InputMaybe<Scalars['jsonb']>;
  keyring?: InputMaybe<Scalars['jsonb']>;
  multiple_salesforce_id?: InputMaybe<Scalars['jsonb']>;
  platform_delivered_to?: InputMaybe<Scalars['jsonb']>;
  posters?: InputMaybe<Scalars['jsonb']>;
  presentations?: InputMaybe<Scalars['jsonb']>;
  sub_genre?: InputMaybe<Scalars['jsonb']>;
  subtitle_language?: InputMaybe<Scalars['jsonb']>;
  subtitle_type?: InputMaybe<Scalars['jsonb']>;
  target_audience?: InputMaybe<Scalars['jsonb']>;
  videos?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "channel" */
export type Channel_Arr_Rel_Insert_Input = {
  data: Array<Channel_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Channel_On_Conflict>;
};

/** Boolean expression to filter rows from the table "channel". All fields are combined with a logical 'AND'. */
export type Channel_Bool_Exp = {
  _and?: InputMaybe<Array<Channel_Bool_Exp>>;
  _not?: InputMaybe<Channel_Bool_Exp>;
  _or?: InputMaybe<Array<Channel_Bool_Exp>>;
  ad_flag?: InputMaybe<Boolean_Comparison_Exp>;
  amagi_auto_cc_generation?: InputMaybe<Boolean_Comparison_Exp>;
  amagi_id_of_channel_owner?: InputMaybe<String_Comparison_Exp>;
  audio_format?: InputMaybe<String_Comparison_Exp>;
  availablity_country_and_regions?: InputMaybe<Jsonb_Comparison_Exp>;
  billing_contact?: InputMaybe<String_Comparison_Exp>;
  channel_brand?: InputMaybe<String_Comparison_Exp>;
  channel_content_type?: InputMaybe<String_Comparison_Exp>;
  channel_country?: InputMaybe<Jsonb_Comparison_Exp>;
  channel_end_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  channel_id?: InputMaybe<String_Comparison_Exp>;
  channel_logo_bug?: InputMaybe<Boolean_Comparison_Exp>;
  channel_master_id?: InputMaybe<Uuid_Comparison_Exp>;
  channel_origin_country_region?: InputMaybe<String_Comparison_Exp>;
  channel_rating?: InputMaybe<Jsonb_Comparison_Exp>;
  channel_region?: InputMaybe<Jsonb_Comparison_Exp>;
  channel_resolution?: InputMaybe<String_Comparison_Exp>;
  channel_start_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  channel_to_channel?: InputMaybe<Channel_Bool_Exp>;
  channel_to_channel_aggregate?: InputMaybe<Channel_Aggregate_Bool_Exp>;
  channel_to_channel_master?: InputMaybe<Channel_Master_Bool_Exp>;
  channel_to_channel_of_grouped?: InputMaybe<Channel_Bool_Exp>;
  channel_to_delivery?: InputMaybe<Delivery_Bool_Exp>;
  channel_to_delivery_aggregate?: InputMaybe<Delivery_Aggregate_Bool_Exp>;
  channel_type?: InputMaybe<String_Comparison_Exp>;
  channels_grouped?: InputMaybe<String_Comparison_Exp>;
  closed_caption?: InputMaybe<Boolean_Comparison_Exp>;
  closed_caption_language?: InputMaybe<Jsonb_Comparison_Exp>;
  closed_caption_type?: InputMaybe<String_Comparison_Exp>;
  closed_captioning?: InputMaybe<Boolean_Comparison_Exp>;
  content_ingest_format?: InputMaybe<String_Comparison_Exp>;
  create_pop_channel?: InputMaybe<Boolean_Comparison_Exp>;
  create_promotional?: InputMaybe<Boolean_Comparison_Exp>;
  create_short_form_video?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  custom_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  custom_tags?: InputMaybe<Jsonb_Comparison_Exp>;
  customer?: InputMaybe<Account_Bool_Exp>;
  customer_description?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<Jsonb_Comparison_Exp>;
  description_long?: InputMaybe<String_Comparison_Exp>;
  description_short?: InputMaybe<String_Comparison_Exp>;
  dubbing?: InputMaybe<Boolean_Comparison_Exp>;
  dubbing_language?: InputMaybe<Jsonb_Comparison_Exp>;
  duplicate_salesforce_id?: InputMaybe<String_Comparison_Exp>;
  edit_promotional?: InputMaybe<Boolean_Comparison_Exp>;
  facebook?: InputMaybe<String_Comparison_Exp>;
  fast?: InputMaybe<String_Comparison_Exp>;
  feed_type?: InputMaybe<String_Comparison_Exp>;
  genre?: InputMaybe<Jsonb_Comparison_Exp>;
  graphics_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  graphics_format?: InputMaybe<String_Comparison_Exp>;
  graphics_support?: InputMaybe<Jsonb_Comparison_Exp>;
  graphics_type?: InputMaybe<String_Comparison_Exp>;
  grouped_channel?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  id_text?: InputMaybe<String_Comparison_Exp>;
  input_audio_format?: InputMaybe<String_Comparison_Exp>;
  instagram?: InputMaybe<String_Comparison_Exp>;
  is_adsplus_channel?: InputMaybe<Boolean_Comparison_Exp>;
  is_contentplus_channel?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_duplicate?: InputMaybe<Boolean_Comparison_Exp>;
  is_duplicate_salesforce?: InputMaybe<Boolean_Comparison_Exp>;
  is_redundant?: InputMaybe<Boolean_Comparison_Exp>;
  is_salesforce_channel?: InputMaybe<Boolean_Comparison_Exp>;
  keyring?: InputMaybe<Jsonb_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  linkedin?: InputMaybe<String_Comparison_Exp>;
  live_feed_input?: InputMaybe<String_Comparison_Exp>;
  live_management?: InputMaybe<Boolean_Comparison_Exp>;
  live_playout?: InputMaybe<Boolean_Comparison_Exp>;
  live_recording?: InputMaybe<Boolean_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  metadata_ingest_format?: InputMaybe<String_Comparison_Exp>;
  multiple_salesforce_id?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  onboarded_date?: InputMaybe<Date_Comparison_Exp>;
  ordered_channel?: InputMaybe<String_Comparison_Exp>;
  original_audio_language?: InputMaybe<String_Comparison_Exp>;
  paid_flag?: InputMaybe<Boolean_Comparison_Exp>;
  parental_rating_standard?: InputMaybe<String_Comparison_Exp>;
  platform_delivered_to?: InputMaybe<Jsonb_Comparison_Exp>;
  playlist_format?: InputMaybe<String_Comparison_Exp>;
  playout_format?: InputMaybe<String_Comparison_Exp>;
  posters?: InputMaybe<Jsonb_Comparison_Exp>;
  presentations?: InputMaybe<Jsonb_Comparison_Exp>;
  promotion_flag?: InputMaybe<Boolean_Comparison_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  short_description?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  sponsorship?: InputMaybe<Boolean_Comparison_Exp>;
  ssai_partner?: InputMaybe<String_Comparison_Exp>;
  start_time?: InputMaybe<Time_Comparison_Exp>;
  stream_container_type?: InputMaybe<String_Comparison_Exp>;
  sub_genre?: InputMaybe<Jsonb_Comparison_Exp>;
  subtitle_language?: InputMaybe<Jsonb_Comparison_Exp>;
  subtitle_support?: InputMaybe<Boolean_Comparison_Exp>;
  subtitle_type?: InputMaybe<Jsonb_Comparison_Exp>;
  subtitling?: InputMaybe<Boolean_Comparison_Exp>;
  target_audience?: InputMaybe<Jsonb_Comparison_Exp>;
  time_zone?: InputMaybe<String_Comparison_Exp>;
  trademark_and_logo?: InputMaybe<Boolean_Comparison_Exp>;
  twitter?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  use_of_display_technology?: InputMaybe<Boolean_Comparison_Exp>;
  video_format?: InputMaybe<String_Comparison_Exp>;
  videos?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** columns and relationships of "channel_churned" */
export type Channel_Churned = {
  __typename?: 'channel_churned';
  /** An object relationship */
  channel_info?: Maybe<Channel>;
  /** An object relationship */
  platform_info?: Maybe<Platform>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "channel_churned" */
export type Channel_Churned_Aggregate = {
  __typename?: 'channel_churned_aggregate';
  aggregate?: Maybe<Channel_Churned_Aggregate_Fields>;
  nodes: Array<Channel_Churned>;
};

/** aggregate fields of "channel_churned" */
export type Channel_Churned_Aggregate_Fields = {
  __typename?: 'channel_churned_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Channel_Churned_Max_Fields>;
  min?: Maybe<Channel_Churned_Min_Fields>;
};


/** aggregate fields of "channel_churned" */
export type Channel_Churned_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Channel_Churned_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "channel_churned". All fields are combined with a logical 'AND'. */
export type Channel_Churned_Bool_Exp = {
  _and?: InputMaybe<Array<Channel_Churned_Bool_Exp>>;
  _not?: InputMaybe<Channel_Churned_Bool_Exp>;
  _or?: InputMaybe<Array<Channel_Churned_Bool_Exp>>;
  channel_info?: InputMaybe<Channel_Bool_Exp>;
  platform_info?: InputMaybe<Platform_Bool_Exp>;
  salesforce_channel_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_platform_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Channel_Churned_Max_Fields = {
  __typename?: 'channel_churned_max_fields';
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Channel_Churned_Min_Fields = {
  __typename?: 'channel_churned_min_fields';
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "channel_churned". */
export type Channel_Churned_Order_By = {
  channel_info?: InputMaybe<Channel_Order_By>;
  platform_info?: InputMaybe<Platform_Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
};

/** select columns of table "channel_churned" */
export enum Channel_Churned_Select_Column {
  /** column name */
  SalesforceChannelId = 'salesforce_channel_id',
  /** column name */
  SalesforcePlatformId = 'salesforce_platform_id'
}

/** Streaming cursor of the table "channel_churned" */
export type Channel_Churned_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Channel_Churned_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Channel_Churned_Stream_Cursor_Value_Input = {
  salesforce_channel_id?: InputMaybe<Scalars['String']>;
  salesforce_platform_id?: InputMaybe<Scalars['String']>;
};

/** unique or primary key constraints on table "channel" */
export enum Channel_Constraint {
  /** unique or primary key constraint on columns "amg_channel_id" */
  ChannelAmgChannelIdKey = 'channel_amg_channel_id_key',
  /** unique or primary key constraint on columns "channel_master_id" */
  ChannelChannelMasterIdKey = 'channel_channel_master_id_key',
  /** unique or primary key constraint on columns "id" */
  ChannelPkey = 'channel_pkey',
  /** unique or primary key constraint on columns "salesforce_id" */
  ChannelSalesforceIdKey = 'channel_salesforce_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Channel_Delete_At_Path_Input = {
  availablity_country_and_regions?: InputMaybe<Array<Scalars['String']>>;
  channel_country?: InputMaybe<Array<Scalars['String']>>;
  channel_rating?: InputMaybe<Array<Scalars['String']>>;
  channel_region?: InputMaybe<Array<Scalars['String']>>;
  closed_caption_language?: InputMaybe<Array<Scalars['String']>>;
  custom_fields?: InputMaybe<Array<Scalars['String']>>;
  custom_tags?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Array<Scalars['String']>>;
  dubbing_language?: InputMaybe<Array<Scalars['String']>>;
  genre?: InputMaybe<Array<Scalars['String']>>;
  graphics_support?: InputMaybe<Array<Scalars['String']>>;
  keyring?: InputMaybe<Array<Scalars['String']>>;
  multiple_salesforce_id?: InputMaybe<Array<Scalars['String']>>;
  platform_delivered_to?: InputMaybe<Array<Scalars['String']>>;
  posters?: InputMaybe<Array<Scalars['String']>>;
  presentations?: InputMaybe<Array<Scalars['String']>>;
  sub_genre?: InputMaybe<Array<Scalars['String']>>;
  subtitle_language?: InputMaybe<Array<Scalars['String']>>;
  subtitle_type?: InputMaybe<Array<Scalars['String']>>;
  target_audience?: InputMaybe<Array<Scalars['String']>>;
  videos?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Channel_Delete_Elem_Input = {
  availablity_country_and_regions?: InputMaybe<Scalars['Int']>;
  channel_country?: InputMaybe<Scalars['Int']>;
  channel_rating?: InputMaybe<Scalars['Int']>;
  channel_region?: InputMaybe<Scalars['Int']>;
  closed_caption_language?: InputMaybe<Scalars['Int']>;
  custom_fields?: InputMaybe<Scalars['Int']>;
  custom_tags?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['Int']>;
  dubbing_language?: InputMaybe<Scalars['Int']>;
  genre?: InputMaybe<Scalars['Int']>;
  graphics_support?: InputMaybe<Scalars['Int']>;
  keyring?: InputMaybe<Scalars['Int']>;
  multiple_salesforce_id?: InputMaybe<Scalars['Int']>;
  platform_delivered_to?: InputMaybe<Scalars['Int']>;
  posters?: InputMaybe<Scalars['Int']>;
  presentations?: InputMaybe<Scalars['Int']>;
  sub_genre?: InputMaybe<Scalars['Int']>;
  subtitle_language?: InputMaybe<Scalars['Int']>;
  subtitle_type?: InputMaybe<Scalars['Int']>;
  target_audience?: InputMaybe<Scalars['Int']>;
  videos?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Channel_Delete_Key_Input = {
  availablity_country_and_regions?: InputMaybe<Scalars['String']>;
  channel_country?: InputMaybe<Scalars['String']>;
  channel_rating?: InputMaybe<Scalars['String']>;
  channel_region?: InputMaybe<Scalars['String']>;
  closed_caption_language?: InputMaybe<Scalars['String']>;
  custom_fields?: InputMaybe<Scalars['String']>;
  custom_tags?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dubbing_language?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Scalars['String']>;
  graphics_support?: InputMaybe<Scalars['String']>;
  keyring?: InputMaybe<Scalars['String']>;
  multiple_salesforce_id?: InputMaybe<Scalars['String']>;
  platform_delivered_to?: InputMaybe<Scalars['String']>;
  posters?: InputMaybe<Scalars['String']>;
  presentations?: InputMaybe<Scalars['String']>;
  sub_genre?: InputMaybe<Scalars['String']>;
  subtitle_language?: InputMaybe<Scalars['String']>;
  subtitle_type?: InputMaybe<Scalars['String']>;
  target_audience?: InputMaybe<Scalars['String']>;
  videos?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "channel_delivered_to_go_live" */
export type Channel_Delivered_To_Go_Live = {
  __typename?: 'channel_delivered_to_go_live';
  /** An object relationship */
  channel_info?: Maybe<Channel>;
  /** An object relationship */
  platform_info?: Maybe<Platform>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "channel_delivered_to_go_live". All fields are combined with a logical 'AND'. */
export type Channel_Delivered_To_Go_Live_Bool_Exp = {
  _and?: InputMaybe<Array<Channel_Delivered_To_Go_Live_Bool_Exp>>;
  _not?: InputMaybe<Channel_Delivered_To_Go_Live_Bool_Exp>;
  _or?: InputMaybe<Array<Channel_Delivered_To_Go_Live_Bool_Exp>>;
  channel_info?: InputMaybe<Channel_Bool_Exp>;
  platform_info?: InputMaybe<Platform_Bool_Exp>;
  salesforce_channel_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_platform_id?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "channel_delivered_to_go_live". */
export type Channel_Delivered_To_Go_Live_Order_By = {
  channel_info?: InputMaybe<Channel_Order_By>;
  platform_info?: InputMaybe<Platform_Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
};

/** select columns of table "channel_delivered_to_go_live" */
export enum Channel_Delivered_To_Go_Live_Select_Column {
  /** column name */
  SalesforceChannelId = 'salesforce_channel_id',
  /** column name */
  SalesforcePlatformId = 'salesforce_platform_id'
}

/** Streaming cursor of the table "channel_delivered_to_go_live" */
export type Channel_Delivered_To_Go_Live_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Channel_Delivered_To_Go_Live_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Channel_Delivered_To_Go_Live_Stream_Cursor_Value_Input = {
  salesforce_channel_id?: InputMaybe<Scalars['String']>;
  salesforce_platform_id?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "channel" */
export type Channel_Insert_Input = {
  ad_flag?: InputMaybe<Scalars['Boolean']>;
  amagi_auto_cc_generation?: InputMaybe<Scalars['Boolean']>;
  amagi_id_of_channel_owner?: InputMaybe<Scalars['String']>;
  audio_format?: InputMaybe<Scalars['String']>;
  availablity_country_and_regions?: InputMaybe<Scalars['jsonb']>;
  billing_contact?: InputMaybe<Scalars['String']>;
  channel_country?: InputMaybe<Scalars['jsonb']>;
  channel_end_time?: InputMaybe<Scalars['timestamptz']>;
  channel_logo_bug?: InputMaybe<Scalars['Boolean']>;
  channel_master_id?: InputMaybe<Scalars['uuid']>;
  channel_origin_country_region?: InputMaybe<Scalars['String']>;
  channel_rating?: InputMaybe<Scalars['jsonb']>;
  channel_region?: InputMaybe<Scalars['jsonb']>;
  channel_resolution?: InputMaybe<Scalars['String']>;
  channel_start_time?: InputMaybe<Scalars['timestamptz']>;
  channel_to_channel?: InputMaybe<Channel_Arr_Rel_Insert_Input>;
  channel_to_channel_of_grouped?: InputMaybe<Channel_Obj_Rel_Insert_Input>;
  channel_type?: InputMaybe<Scalars['String']>;
  closed_caption?: InputMaybe<Scalars['Boolean']>;
  closed_caption_language?: InputMaybe<Scalars['jsonb']>;
  closed_caption_type?: InputMaybe<Scalars['String']>;
  closed_captioning?: InputMaybe<Scalars['Boolean']>;
  content_ingest_format?: InputMaybe<Scalars['String']>;
  create_pop_channel?: InputMaybe<Scalars['Boolean']>;
  create_promotional?: InputMaybe<Scalars['Boolean']>;
  create_short_form_video?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  custom_fields?: InputMaybe<Scalars['jsonb']>;
  custom_tags?: InputMaybe<Scalars['jsonb']>;
  customer_description?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  description_long?: InputMaybe<Scalars['String']>;
  description_short?: InputMaybe<Scalars['String']>;
  dubbing?: InputMaybe<Scalars['Boolean']>;
  dubbing_language?: InputMaybe<Scalars['jsonb']>;
  edit_promotional?: InputMaybe<Scalars['Boolean']>;
  facebook?: InputMaybe<Scalars['String']>;
  feed_type?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Scalars['jsonb']>;
  graphics_enabled?: InputMaybe<Scalars['Boolean']>;
  graphics_format?: InputMaybe<Scalars['String']>;
  graphics_support?: InputMaybe<Scalars['jsonb']>;
  graphics_type?: InputMaybe<Scalars['String']>;
  input_audio_format?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  is_adsplus_channel?: InputMaybe<Scalars['Boolean']>;
  is_contentplus_channel?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_duplicate?: InputMaybe<Scalars['Boolean']>;
  is_redundant?: InputMaybe<Scalars['Boolean']>;
  keyring?: InputMaybe<Scalars['jsonb']>;
  linkedin?: InputMaybe<Scalars['String']>;
  live_feed_input?: InputMaybe<Scalars['String']>;
  live_management?: InputMaybe<Scalars['Boolean']>;
  live_playout?: InputMaybe<Scalars['Boolean']>;
  live_recording?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  metadata_ingest_format?: InputMaybe<Scalars['String']>;
  multiple_salesforce_id?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  onboarded_date?: InputMaybe<Scalars['date']>;
  ordered_channel?: InputMaybe<Scalars['String']>;
  original_audio_language?: InputMaybe<Scalars['String']>;
  paid_flag?: InputMaybe<Scalars['Boolean']>;
  parental_rating_standard?: InputMaybe<Scalars['String']>;
  platform_delivered_to?: InputMaybe<Scalars['jsonb']>;
  playlist_format?: InputMaybe<Scalars['String']>;
  playout_format?: InputMaybe<Scalars['String']>;
  posters?: InputMaybe<Scalars['jsonb']>;
  presentations?: InputMaybe<Scalars['jsonb']>;
  promotion_flag?: InputMaybe<Scalars['Boolean']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  source?: InputMaybe<Scalars['String']>;
  sponsorship?: InputMaybe<Scalars['Boolean']>;
  ssai_partner?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['time']>;
  stream_container_type?: InputMaybe<Scalars['String']>;
  subtitle_language?: InputMaybe<Scalars['jsonb']>;
  subtitle_support?: InputMaybe<Scalars['Boolean']>;
  subtitle_type?: InputMaybe<Scalars['jsonb']>;
  subtitling?: InputMaybe<Scalars['Boolean']>;
  target_audience?: InputMaybe<Scalars['jsonb']>;
  time_zone?: InputMaybe<Scalars['String']>;
  trademark_and_logo?: InputMaybe<Scalars['Boolean']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  use_of_display_technology?: InputMaybe<Scalars['Boolean']>;
  vchip?: InputMaybe<Scalars['Boolean']>;
  video_format?: InputMaybe<Scalars['String']>;
  videos?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "channel_master" */
export type Channel_Master = {
  __typename?: 'channel_master';
  channel_salesforce_id: Scalars['String'];
  id: Scalars['uuid'];
  preferred_channel_master_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "channel_master" */
export type Channel_Master_Aggregate = {
  __typename?: 'channel_master_aggregate';
  aggregate?: Maybe<Channel_Master_Aggregate_Fields>;
  nodes: Array<Channel_Master>;
};

/** aggregate fields of "channel_master" */
export type Channel_Master_Aggregate_Fields = {
  __typename?: 'channel_master_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Channel_Master_Max_Fields>;
  min?: Maybe<Channel_Master_Min_Fields>;
};


/** aggregate fields of "channel_master" */
export type Channel_Master_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Channel_Master_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "channel_master". All fields are combined with a logical 'AND'. */
export type Channel_Master_Bool_Exp = {
  _and?: InputMaybe<Array<Channel_Master_Bool_Exp>>;
  _not?: InputMaybe<Channel_Master_Bool_Exp>;
  _or?: InputMaybe<Array<Channel_Master_Bool_Exp>>;
  channel_salesforce_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  preferred_channel_master_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Channel_Master_Max_Fields = {
  __typename?: 'channel_master_max_fields';
  channel_salesforce_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  preferred_channel_master_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Channel_Master_Min_Fields = {
  __typename?: 'channel_master_min_fields';
  channel_salesforce_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  preferred_channel_master_id?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "channel_master". */
export type Channel_Master_Order_By = {
  channel_salesforce_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  preferred_channel_master_id?: InputMaybe<Order_By>;
};

/** select columns of table "channel_master" */
export enum Channel_Master_Select_Column {
  /** column name */
  ChannelSalesforceId = 'channel_salesforce_id',
  /** column name */
  Id = 'id',
  /** column name */
  PreferredChannelMasterId = 'preferred_channel_master_id'
}

/** Streaming cursor of the table "channel_master" */
export type Channel_Master_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Channel_Master_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Channel_Master_Stream_Cursor_Value_Input = {
  channel_salesforce_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  preferred_channel_master_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Channel_Max_Fields = {
  __typename?: 'channel_max_fields';
  amagi_id_of_channel_owner?: Maybe<Scalars['String']>;
  audio_format?: Maybe<Scalars['String']>;
  billing_contact?: Maybe<Scalars['String']>;
  channel_brand?: Maybe<Scalars['String']>;
  channel_content_type?: Maybe<Scalars['String']>;
  channel_end_time?: Maybe<Scalars['timestamptz']>;
  channel_id?: Maybe<Scalars['String']>;
  channel_master_id?: Maybe<Scalars['uuid']>;
  channel_origin_country_region?: Maybe<Scalars['String']>;
  channel_resolution?: Maybe<Scalars['String']>;
  channel_start_time?: Maybe<Scalars['timestamptz']>;
  channel_type?: Maybe<Scalars['String']>;
  channels_grouped?: Maybe<Scalars['String']>;
  closed_caption_type?: Maybe<Scalars['String']>;
  content_ingest_format?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  customer_description?: Maybe<Scalars['String']>;
  description_long?: Maybe<Scalars['String']>;
  description_short?: Maybe<Scalars['String']>;
  duplicate_salesforce_id?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  fast?: Maybe<Scalars['String']>;
  feed_type?: Maybe<Scalars['String']>;
  graphics_format?: Maybe<Scalars['String']>;
  graphics_type?: Maybe<Scalars['String']>;
  grouped_channel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  input_audio_format?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  live_feed_input?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  metadata_ingest_format?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onboarded_date?: Maybe<Scalars['date']>;
  ordered_channel?: Maybe<Scalars['String']>;
  original_audio_language?: Maybe<Scalars['String']>;
  parental_rating_standard?: Maybe<Scalars['String']>;
  playlist_format?: Maybe<Scalars['String']>;
  playout_format?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  short_description?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  ssai_partner?: Maybe<Scalars['String']>;
  stream_container_type?: Maybe<Scalars['String']>;
  time_zone?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  video_format?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "channel" */
export type Channel_Max_Order_By = {
  amagi_id_of_channel_owner?: InputMaybe<Order_By>;
  audio_format?: InputMaybe<Order_By>;
  billing_contact?: InputMaybe<Order_By>;
  channel_brand?: InputMaybe<Order_By>;
  channel_content_type?: InputMaybe<Order_By>;
  channel_end_time?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  channel_master_id?: InputMaybe<Order_By>;
  channel_origin_country_region?: InputMaybe<Order_By>;
  channel_resolution?: InputMaybe<Order_By>;
  channel_start_time?: InputMaybe<Order_By>;
  channel_type?: InputMaybe<Order_By>;
  channels_grouped?: InputMaybe<Order_By>;
  closed_caption_type?: InputMaybe<Order_By>;
  content_ingest_format?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_description?: InputMaybe<Order_By>;
  description_long?: InputMaybe<Order_By>;
  description_short?: InputMaybe<Order_By>;
  duplicate_salesforce_id?: InputMaybe<Order_By>;
  facebook?: InputMaybe<Order_By>;
  fast?: InputMaybe<Order_By>;
  feed_type?: InputMaybe<Order_By>;
  graphics_format?: InputMaybe<Order_By>;
  graphics_type?: InputMaybe<Order_By>;
  grouped_channel?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_audio_format?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  linkedin?: InputMaybe<Order_By>;
  live_feed_input?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  metadata_ingest_format?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  onboarded_date?: InputMaybe<Order_By>;
  ordered_channel?: InputMaybe<Order_By>;
  original_audio_language?: InputMaybe<Order_By>;
  parental_rating_standard?: InputMaybe<Order_By>;
  playlist_format?: InputMaybe<Order_By>;
  playout_format?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  short_description?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  ssai_partner?: InputMaybe<Order_By>;
  stream_container_type?: InputMaybe<Order_By>;
  time_zone?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_format?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Channel_Min_Fields = {
  __typename?: 'channel_min_fields';
  amagi_id_of_channel_owner?: Maybe<Scalars['String']>;
  audio_format?: Maybe<Scalars['String']>;
  billing_contact?: Maybe<Scalars['String']>;
  channel_brand?: Maybe<Scalars['String']>;
  channel_content_type?: Maybe<Scalars['String']>;
  channel_end_time?: Maybe<Scalars['timestamptz']>;
  channel_id?: Maybe<Scalars['String']>;
  channel_master_id?: Maybe<Scalars['uuid']>;
  channel_origin_country_region?: Maybe<Scalars['String']>;
  channel_resolution?: Maybe<Scalars['String']>;
  channel_start_time?: Maybe<Scalars['timestamptz']>;
  channel_type?: Maybe<Scalars['String']>;
  channels_grouped?: Maybe<Scalars['String']>;
  closed_caption_type?: Maybe<Scalars['String']>;
  content_ingest_format?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  customer_description?: Maybe<Scalars['String']>;
  description_long?: Maybe<Scalars['String']>;
  description_short?: Maybe<Scalars['String']>;
  duplicate_salesforce_id?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  fast?: Maybe<Scalars['String']>;
  feed_type?: Maybe<Scalars['String']>;
  graphics_format?: Maybe<Scalars['String']>;
  graphics_type?: Maybe<Scalars['String']>;
  grouped_channel?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  input_audio_format?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  live_feed_input?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  metadata_ingest_format?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onboarded_date?: Maybe<Scalars['date']>;
  ordered_channel?: Maybe<Scalars['String']>;
  original_audio_language?: Maybe<Scalars['String']>;
  parental_rating_standard?: Maybe<Scalars['String']>;
  playlist_format?: Maybe<Scalars['String']>;
  playout_format?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  short_description?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  ssai_partner?: Maybe<Scalars['String']>;
  stream_container_type?: Maybe<Scalars['String']>;
  time_zone?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  video_format?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "channel" */
export type Channel_Min_Order_By = {
  amagi_id_of_channel_owner?: InputMaybe<Order_By>;
  audio_format?: InputMaybe<Order_By>;
  billing_contact?: InputMaybe<Order_By>;
  channel_brand?: InputMaybe<Order_By>;
  channel_content_type?: InputMaybe<Order_By>;
  channel_end_time?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  channel_master_id?: InputMaybe<Order_By>;
  channel_origin_country_region?: InputMaybe<Order_By>;
  channel_resolution?: InputMaybe<Order_By>;
  channel_start_time?: InputMaybe<Order_By>;
  channel_type?: InputMaybe<Order_By>;
  channels_grouped?: InputMaybe<Order_By>;
  closed_caption_type?: InputMaybe<Order_By>;
  content_ingest_format?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer_description?: InputMaybe<Order_By>;
  description_long?: InputMaybe<Order_By>;
  description_short?: InputMaybe<Order_By>;
  duplicate_salesforce_id?: InputMaybe<Order_By>;
  facebook?: InputMaybe<Order_By>;
  fast?: InputMaybe<Order_By>;
  feed_type?: InputMaybe<Order_By>;
  graphics_format?: InputMaybe<Order_By>;
  graphics_type?: InputMaybe<Order_By>;
  grouped_channel?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_audio_format?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  linkedin?: InputMaybe<Order_By>;
  live_feed_input?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  metadata_ingest_format?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  onboarded_date?: InputMaybe<Order_By>;
  ordered_channel?: InputMaybe<Order_By>;
  original_audio_language?: InputMaybe<Order_By>;
  parental_rating_standard?: InputMaybe<Order_By>;
  playlist_format?: InputMaybe<Order_By>;
  playout_format?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  short_description?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  ssai_partner?: InputMaybe<Order_By>;
  stream_container_type?: InputMaybe<Order_By>;
  time_zone?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_format?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "channel" */
export type Channel_Mutation_Response = {
  __typename?: 'channel_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Channel>;
};

/** input type for inserting object relation for remote table "channel" */
export type Channel_Obj_Rel_Insert_Input = {
  data: Channel_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Channel_On_Conflict>;
};

/** on_conflict condition type for table "channel" */
export type Channel_On_Conflict = {
  constraint: Channel_Constraint;
  update_columns?: Array<Channel_Update_Column>;
  where?: InputMaybe<Channel_Bool_Exp>;
};

/** Ordering options when selecting data from "channel". */
export type Channel_Order_By = {
  ad_flag?: InputMaybe<Order_By>;
  amagi_auto_cc_generation?: InputMaybe<Order_By>;
  amagi_id_of_channel_owner?: InputMaybe<Order_By>;
  audio_format?: InputMaybe<Order_By>;
  availablity_country_and_regions?: InputMaybe<Order_By>;
  billing_contact?: InputMaybe<Order_By>;
  channel_brand?: InputMaybe<Order_By>;
  channel_content_type?: InputMaybe<Order_By>;
  channel_country?: InputMaybe<Order_By>;
  channel_end_time?: InputMaybe<Order_By>;
  channel_id?: InputMaybe<Order_By>;
  channel_logo_bug?: InputMaybe<Order_By>;
  channel_master_id?: InputMaybe<Order_By>;
  channel_origin_country_region?: InputMaybe<Order_By>;
  channel_rating?: InputMaybe<Order_By>;
  channel_region?: InputMaybe<Order_By>;
  channel_resolution?: InputMaybe<Order_By>;
  channel_start_time?: InputMaybe<Order_By>;
  channel_to_channel_aggregate?: InputMaybe<Channel_Aggregate_Order_By>;
  channel_to_channel_master?: InputMaybe<Channel_Master_Order_By>;
  channel_to_channel_of_grouped?: InputMaybe<Channel_Order_By>;
  channel_to_delivery_aggregate?: InputMaybe<Delivery_Aggregate_Order_By>;
  channel_type?: InputMaybe<Order_By>;
  channels_grouped?: InputMaybe<Order_By>;
  closed_caption?: InputMaybe<Order_By>;
  closed_caption_language?: InputMaybe<Order_By>;
  closed_caption_type?: InputMaybe<Order_By>;
  closed_captioning?: InputMaybe<Order_By>;
  content_ingest_format?: InputMaybe<Order_By>;
  create_pop_channel?: InputMaybe<Order_By>;
  create_promotional?: InputMaybe<Order_By>;
  create_short_form_video?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_fields?: InputMaybe<Order_By>;
  custom_tags?: InputMaybe<Order_By>;
  customer?: InputMaybe<Account_Order_By>;
  customer_description?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  description_long?: InputMaybe<Order_By>;
  description_short?: InputMaybe<Order_By>;
  dubbing?: InputMaybe<Order_By>;
  dubbing_language?: InputMaybe<Order_By>;
  duplicate_salesforce_id?: InputMaybe<Order_By>;
  edit_promotional?: InputMaybe<Order_By>;
  facebook?: InputMaybe<Order_By>;
  fast?: InputMaybe<Order_By>;
  feed_type?: InputMaybe<Order_By>;
  genre?: InputMaybe<Order_By>;
  graphics_enabled?: InputMaybe<Order_By>;
  graphics_format?: InputMaybe<Order_By>;
  graphics_support?: InputMaybe<Order_By>;
  graphics_type?: InputMaybe<Order_By>;
  grouped_channel?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_text?: InputMaybe<Order_By>;
  input_audio_format?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  is_adsplus_channel?: InputMaybe<Order_By>;
  is_contentplus_channel?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_duplicate?: InputMaybe<Order_By>;
  is_duplicate_salesforce?: InputMaybe<Order_By>;
  is_redundant?: InputMaybe<Order_By>;
  is_salesforce_channel?: InputMaybe<Order_By>;
  keyring?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  linkedin?: InputMaybe<Order_By>;
  live_feed_input?: InputMaybe<Order_By>;
  live_management?: InputMaybe<Order_By>;
  live_playout?: InputMaybe<Order_By>;
  live_recording?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  metadata_ingest_format?: InputMaybe<Order_By>;
  multiple_salesforce_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  onboarded_date?: InputMaybe<Order_By>;
  ordered_channel?: InputMaybe<Order_By>;
  original_audio_language?: InputMaybe<Order_By>;
  paid_flag?: InputMaybe<Order_By>;
  parental_rating_standard?: InputMaybe<Order_By>;
  platform_delivered_to?: InputMaybe<Order_By>;
  playlist_format?: InputMaybe<Order_By>;
  playout_format?: InputMaybe<Order_By>;
  posters?: InputMaybe<Order_By>;
  presentations?: InputMaybe<Order_By>;
  promotion_flag?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  short_description?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  sponsorship?: InputMaybe<Order_By>;
  ssai_partner?: InputMaybe<Order_By>;
  start_time?: InputMaybe<Order_By>;
  stream_container_type?: InputMaybe<Order_By>;
  sub_genre?: InputMaybe<Order_By>;
  subtitle_language?: InputMaybe<Order_By>;
  subtitle_support?: InputMaybe<Order_By>;
  subtitle_type?: InputMaybe<Order_By>;
  subtitling?: InputMaybe<Order_By>;
  target_audience?: InputMaybe<Order_By>;
  time_zone?: InputMaybe<Order_By>;
  trademark_and_logo?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_of_display_technology?: InputMaybe<Order_By>;
  video_format?: InputMaybe<Order_By>;
  videos?: InputMaybe<Order_By>;
};

/** primary key columns input for table: channel */
export type Channel_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Channel_Prepend_Input = {
  availablity_country_and_regions?: InputMaybe<Scalars['jsonb']>;
  channel_country?: InputMaybe<Scalars['jsonb']>;
  channel_rating?: InputMaybe<Scalars['jsonb']>;
  channel_region?: InputMaybe<Scalars['jsonb']>;
  closed_caption_language?: InputMaybe<Scalars['jsonb']>;
  custom_fields?: InputMaybe<Scalars['jsonb']>;
  custom_tags?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['jsonb']>;
  dubbing_language?: InputMaybe<Scalars['jsonb']>;
  genre?: InputMaybe<Scalars['jsonb']>;
  graphics_support?: InputMaybe<Scalars['jsonb']>;
  keyring?: InputMaybe<Scalars['jsonb']>;
  multiple_salesforce_id?: InputMaybe<Scalars['jsonb']>;
  platform_delivered_to?: InputMaybe<Scalars['jsonb']>;
  posters?: InputMaybe<Scalars['jsonb']>;
  presentations?: InputMaybe<Scalars['jsonb']>;
  sub_genre?: InputMaybe<Scalars['jsonb']>;
  subtitle_language?: InputMaybe<Scalars['jsonb']>;
  subtitle_type?: InputMaybe<Scalars['jsonb']>;
  target_audience?: InputMaybe<Scalars['jsonb']>;
  videos?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "channel_progress" */
export type Channel_Progress = {
  __typename?: 'channel_progress';
  /** An object relationship */
  channel_info?: Maybe<Channel>;
  /** An object relationship */
  platform_info?: Maybe<Platform>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "channel_progress" */
export type Channel_Progress_Aggregate = {
  __typename?: 'channel_progress_aggregate';
  aggregate?: Maybe<Channel_Progress_Aggregate_Fields>;
  nodes: Array<Channel_Progress>;
};

/** aggregate fields of "channel_progress" */
export type Channel_Progress_Aggregate_Fields = {
  __typename?: 'channel_progress_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Channel_Progress_Max_Fields>;
  min?: Maybe<Channel_Progress_Min_Fields>;
};


/** aggregate fields of "channel_progress" */
export type Channel_Progress_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Channel_Progress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "channel_progress". All fields are combined with a logical 'AND'. */
export type Channel_Progress_Bool_Exp = {
  _and?: InputMaybe<Array<Channel_Progress_Bool_Exp>>;
  _not?: InputMaybe<Channel_Progress_Bool_Exp>;
  _or?: InputMaybe<Array<Channel_Progress_Bool_Exp>>;
  channel_info?: InputMaybe<Channel_Bool_Exp>;
  platform_info?: InputMaybe<Platform_Bool_Exp>;
  salesforce_channel_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_platform_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Channel_Progress_Max_Fields = {
  __typename?: 'channel_progress_max_fields';
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Channel_Progress_Min_Fields = {
  __typename?: 'channel_progress_min_fields';
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "channel_progress". */
export type Channel_Progress_Order_By = {
  channel_info?: InputMaybe<Channel_Order_By>;
  platform_info?: InputMaybe<Platform_Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
};

/** select columns of table "channel_progress" */
export enum Channel_Progress_Select_Column {
  /** column name */
  SalesforceChannelId = 'salesforce_channel_id',
  /** column name */
  SalesforcePlatformId = 'salesforce_platform_id'
}

/** Streaming cursor of the table "channel_progress" */
export type Channel_Progress_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Channel_Progress_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Channel_Progress_Stream_Cursor_Value_Input = {
  salesforce_channel_id?: InputMaybe<Scalars['String']>;
  salesforce_platform_id?: InputMaybe<Scalars['String']>;
};

/** select columns of table "channel" */
export enum Channel_Select_Column {
  /** column name */
  AdFlag = 'ad_flag',
  /** column name */
  AmagiAutoCcGeneration = 'amagi_auto_cc_generation',
  /** column name */
  AmagiIdOfChannelOwner = 'amagi_id_of_channel_owner',
  /** column name */
  AudioFormat = 'audio_format',
  /** column name */
  AvailablityCountryAndRegions = 'availablity_country_and_regions',
  /** column name */
  BillingContact = 'billing_contact',
  /** column name */
  ChannelBrand = 'channel_brand',
  /** column name */
  ChannelContentType = 'channel_content_type',
  /** column name */
  ChannelCountry = 'channel_country',
  /** column name */
  ChannelEndTime = 'channel_end_time',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  ChannelLogoBug = 'channel_logo_bug',
  /** column name */
  ChannelMasterId = 'channel_master_id',
  /** column name */
  ChannelOriginCountryRegion = 'channel_origin_country_region',
  /** column name */
  ChannelRating = 'channel_rating',
  /** column name */
  ChannelRegion = 'channel_region',
  /** column name */
  ChannelResolution = 'channel_resolution',
  /** column name */
  ChannelStartTime = 'channel_start_time',
  /** column name */
  ChannelType = 'channel_type',
  /** column name */
  ChannelsGrouped = 'channels_grouped',
  /** column name */
  ClosedCaption = 'closed_caption',
  /** column name */
  ClosedCaptionLanguage = 'closed_caption_language',
  /** column name */
  ClosedCaptionType = 'closed_caption_type',
  /** column name */
  ClosedCaptioning = 'closed_captioning',
  /** column name */
  ContentIngestFormat = 'content_ingest_format',
  /** column name */
  CreatePopChannel = 'create_pop_channel',
  /** column name */
  CreatePromotional = 'create_promotional',
  /** column name */
  CreateShortFormVideo = 'create_short_form_video',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  CustomTags = 'custom_tags',
  /** column name */
  CustomerDescription = 'customer_description',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionLong = 'description_long',
  /** column name */
  DescriptionShort = 'description_short',
  /** column name */
  Dubbing = 'dubbing',
  /** column name */
  DubbingLanguage = 'dubbing_language',
  /** column name */
  DuplicateSalesforceId = 'duplicate_salesforce_id',
  /** column name */
  EditPromotional = 'edit_promotional',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  Fast = 'fast',
  /** column name */
  FeedType = 'feed_type',
  /** column name */
  Genre = 'genre',
  /** column name */
  GraphicsEnabled = 'graphics_enabled',
  /** column name */
  GraphicsFormat = 'graphics_format',
  /** column name */
  GraphicsSupport = 'graphics_support',
  /** column name */
  GraphicsType = 'graphics_type',
  /** column name */
  GroupedChannel = 'grouped_channel',
  /** column name */
  Id = 'id',
  /** column name */
  InputAudioFormat = 'input_audio_format',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  IsAdsplusChannel = 'is_adsplus_channel',
  /** column name */
  IsContentplusChannel = 'is_contentplus_channel',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDuplicate = 'is_duplicate',
  /** column name */
  IsDuplicateSalesforce = 'is_duplicate_salesforce',
  /** column name */
  IsRedundant = 'is_redundant',
  /** column name */
  IsSalesforceChannel = 'is_salesforce_channel',
  /** column name */
  Keyring = 'keyring',
  /** column name */
  Language = 'language',
  /** column name */
  Linkedin = 'linkedin',
  /** column name */
  LiveFeedInput = 'live_feed_input',
  /** column name */
  LiveManagement = 'live_management',
  /** column name */
  LivePlayout = 'live_playout',
  /** column name */
  LiveRecording = 'live_recording',
  /** column name */
  Logo = 'logo',
  /** column name */
  MetadataIngestFormat = 'metadata_ingest_format',
  /** column name */
  MultipleSalesforceId = 'multiple_salesforce_id',
  /** column name */
  Name = 'name',
  /** column name */
  OnboardedDate = 'onboarded_date',
  /** column name */
  OrderedChannel = 'ordered_channel',
  /** column name */
  OriginalAudioLanguage = 'original_audio_language',
  /** column name */
  PaidFlag = 'paid_flag',
  /** column name */
  ParentalRatingStandard = 'parental_rating_standard',
  /** column name */
  PlatformDeliveredTo = 'platform_delivered_to',
  /** column name */
  PlaylistFormat = 'playlist_format',
  /** column name */
  PlayoutFormat = 'playout_format',
  /** column name */
  Posters = 'posters',
  /** column name */
  Presentations = 'presentations',
  /** column name */
  PromotionFlag = 'promotion_flag',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  ShortDescription = 'short_description',
  /** column name */
  Source = 'source',
  /** column name */
  Sponsorship = 'sponsorship',
  /** column name */
  SsaiPartner = 'ssai_partner',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  StreamContainerType = 'stream_container_type',
  /** column name */
  SubGenre = 'sub_genre',
  /** column name */
  SubtitleLanguage = 'subtitle_language',
  /** column name */
  SubtitleSupport = 'subtitle_support',
  /** column name */
  SubtitleType = 'subtitle_type',
  /** column name */
  Subtitling = 'subtitling',
  /** column name */
  TargetAudience = 'target_audience',
  /** column name */
  TimeZone = 'time_zone',
  /** column name */
  TrademarkAndLogo = 'trademark_and_logo',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseOfDisplayTechnology = 'use_of_display_technology',
  /** column name */
  VideoFormat = 'video_format',
  /** column name */
  Videos = 'videos'
}

/** select "channel_aggregate_bool_exp_bool_and_arguments_columns" columns of table "channel" */
export enum Channel_Select_Column_Channel_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AdFlag = 'ad_flag',
  /** column name */
  AmagiAutoCcGeneration = 'amagi_auto_cc_generation',
  /** column name */
  ChannelLogoBug = 'channel_logo_bug',
  /** column name */
  ClosedCaption = 'closed_caption',
  /** column name */
  ClosedCaptioning = 'closed_captioning',
  /** column name */
  CreatePopChannel = 'create_pop_channel',
  /** column name */
  CreatePromotional = 'create_promotional',
  /** column name */
  CreateShortFormVideo = 'create_short_form_video',
  /** column name */
  Dubbing = 'dubbing',
  /** column name */
  EditPromotional = 'edit_promotional',
  /** column name */
  GraphicsEnabled = 'graphics_enabled',
  /** column name */
  IsAdsplusChannel = 'is_adsplus_channel',
  /** column name */
  IsContentplusChannel = 'is_contentplus_channel',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDuplicate = 'is_duplicate',
  /** column name */
  IsDuplicateSalesforce = 'is_duplicate_salesforce',
  /** column name */
  IsRedundant = 'is_redundant',
  /** column name */
  IsSalesforceChannel = 'is_salesforce_channel',
  /** column name */
  LiveManagement = 'live_management',
  /** column name */
  LivePlayout = 'live_playout',
  /** column name */
  LiveRecording = 'live_recording',
  /** column name */
  PaidFlag = 'paid_flag',
  /** column name */
  PromotionFlag = 'promotion_flag',
  /** column name */
  Sponsorship = 'sponsorship',
  /** column name */
  SubtitleSupport = 'subtitle_support',
  /** column name */
  Subtitling = 'subtitling',
  /** column name */
  TrademarkAndLogo = 'trademark_and_logo',
  /** column name */
  UseOfDisplayTechnology = 'use_of_display_technology'
}

/** select "channel_aggregate_bool_exp_bool_or_arguments_columns" columns of table "channel" */
export enum Channel_Select_Column_Channel_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AdFlag = 'ad_flag',
  /** column name */
  AmagiAutoCcGeneration = 'amagi_auto_cc_generation',
  /** column name */
  ChannelLogoBug = 'channel_logo_bug',
  /** column name */
  ClosedCaption = 'closed_caption',
  /** column name */
  ClosedCaptioning = 'closed_captioning',
  /** column name */
  CreatePopChannel = 'create_pop_channel',
  /** column name */
  CreatePromotional = 'create_promotional',
  /** column name */
  CreateShortFormVideo = 'create_short_form_video',
  /** column name */
  Dubbing = 'dubbing',
  /** column name */
  EditPromotional = 'edit_promotional',
  /** column name */
  GraphicsEnabled = 'graphics_enabled',
  /** column name */
  IsAdsplusChannel = 'is_adsplus_channel',
  /** column name */
  IsContentplusChannel = 'is_contentplus_channel',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDuplicate = 'is_duplicate',
  /** column name */
  IsDuplicateSalesforce = 'is_duplicate_salesforce',
  /** column name */
  IsRedundant = 'is_redundant',
  /** column name */
  IsSalesforceChannel = 'is_salesforce_channel',
  /** column name */
  LiveManagement = 'live_management',
  /** column name */
  LivePlayout = 'live_playout',
  /** column name */
  LiveRecording = 'live_recording',
  /** column name */
  PaidFlag = 'paid_flag',
  /** column name */
  PromotionFlag = 'promotion_flag',
  /** column name */
  Sponsorship = 'sponsorship',
  /** column name */
  SubtitleSupport = 'subtitle_support',
  /** column name */
  Subtitling = 'subtitling',
  /** column name */
  TrademarkAndLogo = 'trademark_and_logo',
  /** column name */
  UseOfDisplayTechnology = 'use_of_display_technology'
}

/** input type for updating data in table "channel" */
export type Channel_Set_Input = {
  ad_flag?: InputMaybe<Scalars['Boolean']>;
  amagi_auto_cc_generation?: InputMaybe<Scalars['Boolean']>;
  amagi_id_of_channel_owner?: InputMaybe<Scalars['String']>;
  audio_format?: InputMaybe<Scalars['String']>;
  availablity_country_and_regions?: InputMaybe<Scalars['jsonb']>;
  billing_contact?: InputMaybe<Scalars['String']>;
  channel_country?: InputMaybe<Scalars['jsonb']>;
  channel_end_time?: InputMaybe<Scalars['timestamptz']>;
  channel_id?: InputMaybe<Scalars['String']>;
  channel_logo_bug?: InputMaybe<Scalars['Boolean']>;
  channel_origin_country_region?: InputMaybe<Scalars['String']>;
  channel_rating?: InputMaybe<Scalars['jsonb']>;
  channel_region?: InputMaybe<Scalars['jsonb']>;
  channel_resolution?: InputMaybe<Scalars['String']>;
  channel_start_time?: InputMaybe<Scalars['timestamptz']>;
  channel_type?: InputMaybe<Scalars['String']>;
  channel_brand?: InputMaybe<Scalars['String']>;
  closed_caption?: InputMaybe<Scalars['Boolean']>;
  closed_caption_language?: InputMaybe<Scalars['jsonb']>;
  closed_caption_type?: InputMaybe<Scalars['String']>;
  closed_captioning?: InputMaybe<Scalars['Boolean']>;
  content_ingest_format?: InputMaybe<Scalars['String']>;
  create_pop_channel?: InputMaybe<Scalars['Boolean']>;
  create_promotional?: InputMaybe<Scalars['Boolean']>;
  create_short_form_video?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  custom_fields?: InputMaybe<Scalars['jsonb']>;
  custom_tags?: InputMaybe<Scalars['jsonb']>;
  customer_description?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  description_long?: InputMaybe<Scalars['String']>;
  description_short?: InputMaybe<Scalars['String']>;
  dubbing?: InputMaybe<Scalars['Boolean']>;
  dubbing_language?: InputMaybe<Scalars['jsonb']>;
  edit_promotional?: InputMaybe<Scalars['Boolean']>;
  facebook?: InputMaybe<Scalars['String']>;
  fast?: InputMaybe<Scalars['String']>;
  feed_type?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Scalars['jsonb']>;
  graphics_enabled?: InputMaybe<Scalars['Boolean']>;
  graphics_format?: InputMaybe<Scalars['String']>;
  graphics_support?: InputMaybe<Scalars['jsonb']>;
  graphics_type?: InputMaybe<Scalars['String']>;
  input_audio_format?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  is_adsplus_channel?: InputMaybe<Scalars['Boolean']>;
  is_contentplus_channel?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_duplicate?: InputMaybe<Scalars['Boolean']>;
  is_redundant?: InputMaybe<Scalars['Boolean']>;
  keyring?: InputMaybe<Scalars['jsonb']>;
  linkedin?: InputMaybe<Scalars['String']>;
  live_feed_input?: InputMaybe<Scalars['String']>;
  live_management?: InputMaybe<Scalars['Boolean']>;
  live_playout?: InputMaybe<Scalars['Boolean']>;
  live_recording?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  metadata_ingest_format?: InputMaybe<Scalars['String']>;
  multiple_salesforce_id?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  onboarded_date?: InputMaybe<Scalars['date']>;
  ordered_channel?: InputMaybe<Scalars['String']>;
  original_audio_language?: InputMaybe<Scalars['String']>;
  paid_flag?: InputMaybe<Scalars['Boolean']>;
  parental_rating_standard?: InputMaybe<Scalars['String']>;
  platform_delivered_to?: InputMaybe<Scalars['jsonb']>;
  playlist_format?: InputMaybe<Scalars['String']>;
  playout_format?: InputMaybe<Scalars['String']>;
  posters?: InputMaybe<Scalars['jsonb']>;
  presentations?: InputMaybe<Scalars['jsonb']>;
  promotion_flag?: InputMaybe<Scalars['Boolean']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  sponsorship?: InputMaybe<Scalars['Boolean']>;
  ssai_partner?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['time']>;
  stream_container_type?: InputMaybe<Scalars['String']>;
  sub_genre?: InputMaybe<Scalars['jsonb']>;
  subtitle_language?: InputMaybe<Scalars['jsonb']>;
  subtitle_support?: InputMaybe<Scalars['Boolean']>;
  subtitle_type?: InputMaybe<Scalars['jsonb']>;
  subtitling?: InputMaybe<Scalars['Boolean']>;
  target_audience?: InputMaybe<Scalars['jsonb']>;
  time_zone?: InputMaybe<Scalars['String']>;
  trademark_and_logo?: InputMaybe<Scalars['Boolean']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  use_of_display_technology?: InputMaybe<Scalars['Boolean']>;
  video_format?: InputMaybe<Scalars['String']>;
  videos?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "channel" */
export type Channel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Channel_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Channel_Stream_Cursor_Value_Input = {
  ad_flag?: InputMaybe<Scalars['Boolean']>;
  amagi_auto_cc_generation?: InputMaybe<Scalars['Boolean']>;
  amagi_id_of_channel_owner?: InputMaybe<Scalars['String']>;
  audio_format?: InputMaybe<Scalars['String']>;
  availablity_country_and_regions?: InputMaybe<Scalars['jsonb']>;
  billing_contact?: InputMaybe<Scalars['String']>;
  channel_brand?: InputMaybe<Scalars['String']>;
  channel_content_type?: InputMaybe<Scalars['String']>;
  channel_country?: InputMaybe<Scalars['jsonb']>;
  channel_end_time?: InputMaybe<Scalars['timestamptz']>;
  channel_id?: InputMaybe<Scalars['String']>;
  channel_logo_bug?: InputMaybe<Scalars['Boolean']>;
  channel_master_id?: InputMaybe<Scalars['uuid']>;
  channel_origin_country_region?: InputMaybe<Scalars['String']>;
  channel_rating?: InputMaybe<Scalars['jsonb']>;
  channel_region?: InputMaybe<Scalars['jsonb']>;
  channel_resolution?: InputMaybe<Scalars['String']>;
  channel_start_time?: InputMaybe<Scalars['timestamptz']>;
  channel_type?: InputMaybe<Scalars['String']>;
  channels_grouped?: InputMaybe<Scalars['String']>;
  closed_caption?: InputMaybe<Scalars['Boolean']>;
  closed_caption_language?: InputMaybe<Scalars['jsonb']>;
  closed_caption_type?: InputMaybe<Scalars['String']>;
  closed_captioning?: InputMaybe<Scalars['Boolean']>;
  content_ingest_format?: InputMaybe<Scalars['String']>;
  create_pop_channel?: InputMaybe<Scalars['Boolean']>;
  create_promotional?: InputMaybe<Scalars['Boolean']>;
  create_short_form_video?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  custom_fields?: InputMaybe<Scalars['jsonb']>;
  custom_tags?: InputMaybe<Scalars['jsonb']>;
  customer_description?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['jsonb']>;
  description_long?: InputMaybe<Scalars['String']>;
  description_short?: InputMaybe<Scalars['String']>;
  dubbing?: InputMaybe<Scalars['Boolean']>;
  dubbing_language?: InputMaybe<Scalars['jsonb']>;
  duplicate_salesforce_id?: InputMaybe<Scalars['String']>;
  edit_promotional?: InputMaybe<Scalars['Boolean']>;
  facebook?: InputMaybe<Scalars['String']>;
  fast?: InputMaybe<Scalars['String']>;
  feed_type?: InputMaybe<Scalars['String']>;
  genre?: InputMaybe<Scalars['jsonb']>;
  graphics_enabled?: InputMaybe<Scalars['Boolean']>;
  graphics_format?: InputMaybe<Scalars['String']>;
  graphics_support?: InputMaybe<Scalars['jsonb']>;
  graphics_type?: InputMaybe<Scalars['String']>;
  grouped_channel?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  input_audio_format?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  is_adsplus_channel?: InputMaybe<Scalars['Boolean']>;
  is_contentplus_channel?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_duplicate?: InputMaybe<Scalars['Boolean']>;
  is_duplicate_salesforce?: InputMaybe<Scalars['Boolean']>;
  is_redundant?: InputMaybe<Scalars['Boolean']>;
  is_salesforce_channel?: InputMaybe<Scalars['Boolean']>;
  keyring?: InputMaybe<Scalars['jsonb']>;
  language?: InputMaybe<Scalars['String']>;
  linkedin?: InputMaybe<Scalars['String']>;
  live_feed_input?: InputMaybe<Scalars['String']>;
  live_management?: InputMaybe<Scalars['Boolean']>;
  live_playout?: InputMaybe<Scalars['Boolean']>;
  live_recording?: InputMaybe<Scalars['Boolean']>;
  logo?: InputMaybe<Scalars['String']>;
  metadata_ingest_format?: InputMaybe<Scalars['String']>;
  multiple_salesforce_id?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  onboarded_date?: InputMaybe<Scalars['date']>;
  ordered_channel?: InputMaybe<Scalars['String']>;
  original_audio_language?: InputMaybe<Scalars['String']>;
  paid_flag?: InputMaybe<Scalars['Boolean']>;
  parental_rating_standard?: InputMaybe<Scalars['String']>;
  platform_delivered_to?: InputMaybe<Scalars['jsonb']>;
  playlist_format?: InputMaybe<Scalars['String']>;
  playout_format?: InputMaybe<Scalars['String']>;
  posters?: InputMaybe<Scalars['jsonb']>;
  presentations?: InputMaybe<Scalars['jsonb']>;
  promotion_flag?: InputMaybe<Scalars['Boolean']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  short_description?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sponsorship?: InputMaybe<Scalars['Boolean']>;
  ssai_partner?: InputMaybe<Scalars['String']>;
  start_time?: InputMaybe<Scalars['time']>;
  stream_container_type?: InputMaybe<Scalars['String']>;
  sub_genre?: InputMaybe<Scalars['jsonb']>;
  subtitle_language?: InputMaybe<Scalars['jsonb']>;
  subtitle_support?: InputMaybe<Scalars['Boolean']>;
  subtitle_type?: InputMaybe<Scalars['jsonb']>;
  subtitling?: InputMaybe<Scalars['Boolean']>;
  target_audience?: InputMaybe<Scalars['jsonb']>;
  time_zone?: InputMaybe<Scalars['String']>;
  trademark_and_logo?: InputMaybe<Scalars['Boolean']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  use_of_display_technology?: InputMaybe<Scalars['Boolean']>;
  video_format?: InputMaybe<Scalars['String']>;
  videos?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "channel" */
export enum Channel_Update_Column {
  /** column name */
  AdFlag = 'ad_flag',
  /** column name */
  AmagiAutoCcGeneration = 'amagi_auto_cc_generation',
  /** column name */
  AmagiIdOfChannelOwner = 'amagi_id_of_channel_owner',
  /** column name */
  AudioFormat = 'audio_format',
  /** column name */
  AvailablityCountryAndRegions = 'availablity_country_and_regions',
  /** column name */
  BillingContact = 'billing_contact',
  /** column name */
  ChannelCountry = 'channel_country',
  /** column name */
  ChannelEndTime = 'channel_end_time',
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  ChannelLogoBug = 'channel_logo_bug',
  /** column name */
  ChannelOriginCountryRegion = 'channel_origin_country_region',
  /** column name */
  ChannelRating = 'channel_rating',
  /** column name */
  ChannelRegion = 'channel_region',
  /** column name */
  ChannelResolution = 'channel_resolution',
  /** column name */
  ChannelStartTime = 'channel_start_time',
  /** column name */
  ChannelType = 'channel_type',
  /** column name */
  ClosedCaption = 'closed_caption',
  /** column name */
  ClosedCaptionLanguage = 'closed_caption_language',
  /** column name */
  ClosedCaptionType = 'closed_caption_type',
  /** column name */
  ClosedCaptioning = 'closed_captioning',
  /** column name */
  ContentIngestFormat = 'content_ingest_format',
  /** column name */
  CreatePopChannel = 'create_pop_channel',
  /** column name */
  CreatePromotional = 'create_promotional',
  /** column name */
  CreateShortFormVideo = 'create_short_form_video',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  CustomTags = 'custom_tags',
  /** column name */
  CustomerDescription = 'customer_description',
  /** column name */
  Description = 'description',
  /** column name */
  DescriptionLong = 'description_long',
  /** column name */
  DescriptionShort = 'description_short',
  /** column name */
  Dubbing = 'dubbing',
  /** column name */
  DubbingLanguage = 'dubbing_language',
  /** column name */
  EditPromotional = 'edit_promotional',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  Fast = 'fast',
  /** column name */
  FeedType = 'feed_type',
  /** column name */
  Genre = 'genre',
  /** column name */
  GraphicsEnabled = 'graphics_enabled',
  /** column name */
  GraphicsFormat = 'graphics_format',
  /** column name */
  GraphicsSupport = 'graphics_support',
  /** column name */
  GraphicsType = 'graphics_type',
  /** column name */
  InputAudioFormat = 'input_audio_format',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  IsAdsplusChannel = 'is_adsplus_channel',
  /** column name */
  IsContentplusChannel = 'is_contentplus_channel',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDuplicate = 'is_duplicate',
  /** column name */
  IsRedundant = 'is_redundant',
  /** column name */
  Keyring = 'keyring',
  /** column name */
  Linkedin = 'linkedin',
  /** column name */
  LiveFeedInput = 'live_feed_input',
  /** column name */
  LiveManagement = 'live_management',
  /** column name */
  LivePlayout = 'live_playout',
  /** column name */
  LiveRecording = 'live_recording',
  /** column name */
  Logo = 'logo',
  /** column name */
  MetadataIngestFormat = 'metadata_ingest_format',
  /** column name */
  MultipleSalesforceId = 'multiple_salesforce_id',
  /** column name */
  Name = 'name',
  /** column name */
  OnboardedDate = 'onboarded_date',
  /** column name */
  OrderedChannel = 'ordered_channel',
  /** column name */
  OriginalAudioLanguage = 'original_audio_language',
  /** column name */
  PaidFlag = 'paid_flag',
  /** column name */
  ParentalRatingStandard = 'parental_rating_standard',
  /** column name */
  PlatformDeliveredTo = 'platform_delivered_to',
  /** column name */
  PlaylistFormat = 'playlist_format',
  /** column name */
  PlayoutFormat = 'playout_format',
  /** column name */
  Posters = 'posters',
  /** column name */
  Presentations = 'presentations',
  /** column name */
  PromotionFlag = 'promotion_flag',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  Sponsorship = 'sponsorship',
  /** column name */
  SsaiPartner = 'ssai_partner',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  StreamContainerType = 'stream_container_type',
  /** column name */
  SubGenre = 'sub_genre',
  /** column name */
  SubtitleLanguage = 'subtitle_language',
  /** column name */
  SubtitleSupport = 'subtitle_support',
  /** column name */
  SubtitleType = 'subtitle_type',
  /** column name */
  Subtitling = 'subtitling',
  /** column name */
  TargetAudience = 'target_audience',
  /** column name */
  TimeZone = 'time_zone',
  /** column name */
  TrademarkAndLogo = 'trademark_and_logo',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseOfDisplayTechnology = 'use_of_display_technology',
  /** column name */
  VideoFormat = 'video_format',
  /** column name */
  Videos = 'videos'
}

export type Channel_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Channel_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Channel_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Channel_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Channel_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Channel_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Channel_Set_Input>;
  /** filter the rows which have to be updated */
  where: Channel_Bool_Exp;
};

/** columns and relationships of "cloudport" */
export type Cloudport = {
  __typename?: 'cloudport';
  amagi_id?: Maybe<Scalars['String']>;
  blip_url?: Maybe<Scalars['String']>;
  blip_version?: Maybe<Scalars['String']>;
  cp_playout?: Maybe<Scalars['String']>;
  env?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
};

/** order by aggregate values of table "cloudport" */
export type Cloudport_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cloudport_Max_Order_By>;
  min?: InputMaybe<Cloudport_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "cloudport". All fields are combined with a logical 'AND'. */
export type Cloudport_Bool_Exp = {
  _and?: InputMaybe<Array<Cloudport_Bool_Exp>>;
  _not?: InputMaybe<Cloudport_Bool_Exp>;
  _or?: InputMaybe<Array<Cloudport_Bool_Exp>>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  blip_url?: InputMaybe<String_Comparison_Exp>;
  blip_version?: InputMaybe<String_Comparison_Exp>;
  cp_playout?: InputMaybe<String_Comparison_Exp>;
  env?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "cloudport" */
export type Cloudport_Max_Order_By = {
  amagi_id?: InputMaybe<Order_By>;
  blip_url?: InputMaybe<Order_By>;
  blip_version?: InputMaybe<Order_By>;
  cp_playout?: InputMaybe<Order_By>;
  env?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "cloudport" */
export type Cloudport_Min_Order_By = {
  amagi_id?: InputMaybe<Order_By>;
  blip_url?: InputMaybe<Order_By>;
  blip_version?: InputMaybe<Order_By>;
  cp_playout?: InputMaybe<Order_By>;
  env?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "cloudport". */
export type Cloudport_Order_By = {
  amagi_id?: InputMaybe<Order_By>;
  blip_url?: InputMaybe<Order_By>;
  blip_version?: InputMaybe<Order_By>;
  cp_playout?: InputMaybe<Order_By>;
  env?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "cloudport" */
export enum Cloudport_Select_Column {
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  BlipUrl = 'blip_url',
  /** column name */
  BlipVersion = 'blip_version',
  /** column name */
  CpPlayout = 'cp_playout',
  /** column name */
  Env = 'env',
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "cloudport" */
export type Cloudport_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cloudport_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cloudport_Stream_Cursor_Value_Input = {
  amagi_id?: InputMaybe<Scalars['String']>;
  blip_url?: InputMaybe<Scalars['String']>;
  blip_version?: InputMaybe<Scalars['String']>;
  cp_playout?: InputMaybe<Scalars['String']>;
  env?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** columns and relationships of "company_address" */
export type Company_Address = {
  __typename?: 'company_address';
  /** An object relationship */
  account: Account;
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  address_line_3?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_establishment_date?: Maybe<Scalars['String']>;
  company_industry_segment?: Maybe<Scalars['String']>;
  company_industry_sub_segment?: Maybe<Scalars['String']>;
  company_linkedin_handle?: Maybe<Scalars['String']>;
  company_size?: Maybe<Scalars['Int']>;
  company_twitter_handle?: Maybe<Scalars['String']>;
  company_website?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  salesforce_account_id: Scalars['String'];
  state_province?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** aggregated selection of "company_address" */
export type Company_Address_Aggregate = {
  __typename?: 'company_address_aggregate';
  aggregate?: Maybe<Company_Address_Aggregate_Fields>;
  nodes: Array<Company_Address>;
};

/** aggregate fields of "company_address" */
export type Company_Address_Aggregate_Fields = {
  __typename?: 'company_address_aggregate_fields';
  avg?: Maybe<Company_Address_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Company_Address_Max_Fields>;
  min?: Maybe<Company_Address_Min_Fields>;
  stddev?: Maybe<Company_Address_Stddev_Fields>;
  stddev_pop?: Maybe<Company_Address_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Company_Address_Stddev_Samp_Fields>;
  sum?: Maybe<Company_Address_Sum_Fields>;
  var_pop?: Maybe<Company_Address_Var_Pop_Fields>;
  var_samp?: Maybe<Company_Address_Var_Samp_Fields>;
  variance?: Maybe<Company_Address_Variance_Fields>;
};


/** aggregate fields of "company_address" */
export type Company_Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Company_Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Company_Address_Avg_Fields = {
  __typename?: 'company_address_avg_fields';
  company_size?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "company_address". All fields are combined with a logical 'AND'. */
export type Company_Address_Bool_Exp = {
  _and?: InputMaybe<Array<Company_Address_Bool_Exp>>;
  _not?: InputMaybe<Company_Address_Bool_Exp>;
  _or?: InputMaybe<Array<Company_Address_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  address_line_1?: InputMaybe<String_Comparison_Exp>;
  address_line_2?: InputMaybe<String_Comparison_Exp>;
  address_line_3?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  company_establishment_date?: InputMaybe<String_Comparison_Exp>;
  company_industry_segment?: InputMaybe<String_Comparison_Exp>;
  company_industry_sub_segment?: InputMaybe<String_Comparison_Exp>;
  company_linkedin_handle?: InputMaybe<String_Comparison_Exp>;
  company_size?: InputMaybe<Int_Comparison_Exp>;
  company_twitter_handle?: InputMaybe<String_Comparison_Exp>;
  company_website?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  state_province?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  zip_code?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Company_Address_Max_Fields = {
  __typename?: 'company_address_max_fields';
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  address_line_3?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_establishment_date?: Maybe<Scalars['String']>;
  company_industry_segment?: Maybe<Scalars['String']>;
  company_industry_sub_segment?: Maybe<Scalars['String']>;
  company_linkedin_handle?: Maybe<Scalars['String']>;
  company_size?: Maybe<Scalars['Int']>;
  company_twitter_handle?: Maybe<Scalars['String']>;
  company_website?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Company_Address_Min_Fields = {
  __typename?: 'company_address_min_fields';
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  address_line_3?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_establishment_date?: Maybe<Scalars['String']>;
  company_industry_segment?: Maybe<Scalars['String']>;
  company_industry_sub_segment?: Maybe<Scalars['String']>;
  company_linkedin_handle?: Maybe<Scalars['String']>;
  company_size?: Maybe<Scalars['Int']>;
  company_twitter_handle?: Maybe<Scalars['String']>;
  company_website?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "company_address". */
export type Company_Address_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  address_line_1?: InputMaybe<Order_By>;
  address_line_2?: InputMaybe<Order_By>;
  address_line_3?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  company_establishment_date?: InputMaybe<Order_By>;
  company_industry_segment?: InputMaybe<Order_By>;
  company_industry_sub_segment?: InputMaybe<Order_By>;
  company_linkedin_handle?: InputMaybe<Order_By>;
  company_size?: InputMaybe<Order_By>;
  company_twitter_handle?: InputMaybe<Order_By>;
  company_website?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  state_province?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

/** select columns of table "company_address" */
export enum Company_Address_Select_Column {
  /** column name */
  AddressLine_1 = 'address_line_1',
  /** column name */
  AddressLine_2 = 'address_line_2',
  /** column name */
  AddressLine_3 = 'address_line_3',
  /** column name */
  City = 'city',
  /** column name */
  CompanyEstablishmentDate = 'company_establishment_date',
  /** column name */
  CompanyIndustrySegment = 'company_industry_segment',
  /** column name */
  CompanyIndustrySubSegment = 'company_industry_sub_segment',
  /** column name */
  CompanyLinkedinHandle = 'company_linkedin_handle',
  /** column name */
  CompanySize = 'company_size',
  /** column name */
  CompanyTwitterHandle = 'company_twitter_handle',
  /** column name */
  CompanyWebsite = 'company_website',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  Region = 'region',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  StateProvince = 'state_province',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZipCode = 'zip_code'
}

/** aggregate stddev on columns */
export type Company_Address_Stddev_Fields = {
  __typename?: 'company_address_stddev_fields';
  company_size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Company_Address_Stddev_Pop_Fields = {
  __typename?: 'company_address_stddev_pop_fields';
  company_size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Company_Address_Stddev_Samp_Fields = {
  __typename?: 'company_address_stddev_samp_fields';
  company_size?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "company_address" */
export type Company_Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Company_Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Company_Address_Stream_Cursor_Value_Input = {
  address_line_1?: InputMaybe<Scalars['String']>;
  address_line_2?: InputMaybe<Scalars['String']>;
  address_line_3?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company_establishment_date?: InputMaybe<Scalars['String']>;
  company_industry_segment?: InputMaybe<Scalars['String']>;
  company_industry_sub_segment?: InputMaybe<Scalars['String']>;
  company_linkedin_handle?: InputMaybe<Scalars['String']>;
  company_size?: InputMaybe<Scalars['Int']>;
  company_twitter_handle?: InputMaybe<Scalars['String']>;
  company_website?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  state_province?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zip_code?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Company_Address_Sum_Fields = {
  __typename?: 'company_address_sum_fields';
  company_size?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Company_Address_Var_Pop_Fields = {
  __typename?: 'company_address_var_pop_fields';
  company_size?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Company_Address_Var_Samp_Fields = {
  __typename?: 'company_address_var_samp_fields';
  company_size?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Company_Address_Variance_Fields = {
  __typename?: 'company_address_variance_fields';
  company_size?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "consumption_rate" */
export type Consumption_Rate = {
  __typename?: 'consumption_rate';
  /** An object relationship */
  consumption_schedule?: Maybe<Consumption_Schedule>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  lower_bound?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  pricing_method?: Maybe<Scalars['String']>;
  processing_order?: Maybe<Scalars['numeric']>;
  salesforce_consumption_schedule_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  upper_bound?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "consumption_rate" */
export type Consumption_Rate_Aggregate = {
  __typename?: 'consumption_rate_aggregate';
  aggregate?: Maybe<Consumption_Rate_Aggregate_Fields>;
  nodes: Array<Consumption_Rate>;
};

export type Consumption_Rate_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Consumption_Rate_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Consumption_Rate_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Consumption_Rate_Aggregate_Bool_Exp_Count>;
};

export type Consumption_Rate_Aggregate_Bool_Exp_Bool_And = {
  arguments: Consumption_Rate_Select_Column_Consumption_Rate_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Consumption_Rate_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Consumption_Rate_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Consumption_Rate_Select_Column_Consumption_Rate_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Consumption_Rate_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Consumption_Rate_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Consumption_Rate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Consumption_Rate_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "consumption_rate" */
export type Consumption_Rate_Aggregate_Fields = {
  __typename?: 'consumption_rate_aggregate_fields';
  avg?: Maybe<Consumption_Rate_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Consumption_Rate_Max_Fields>;
  min?: Maybe<Consumption_Rate_Min_Fields>;
  stddev?: Maybe<Consumption_Rate_Stddev_Fields>;
  stddev_pop?: Maybe<Consumption_Rate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Consumption_Rate_Stddev_Samp_Fields>;
  sum?: Maybe<Consumption_Rate_Sum_Fields>;
  var_pop?: Maybe<Consumption_Rate_Var_Pop_Fields>;
  var_samp?: Maybe<Consumption_Rate_Var_Samp_Fields>;
  variance?: Maybe<Consumption_Rate_Variance_Fields>;
};


/** aggregate fields of "consumption_rate" */
export type Consumption_Rate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consumption_Rate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "consumption_rate" */
export type Consumption_Rate_Aggregate_Order_By = {
  avg?: InputMaybe<Consumption_Rate_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Consumption_Rate_Max_Order_By>;
  min?: InputMaybe<Consumption_Rate_Min_Order_By>;
  stddev?: InputMaybe<Consumption_Rate_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Consumption_Rate_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Consumption_Rate_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Consumption_Rate_Sum_Order_By>;
  var_pop?: InputMaybe<Consumption_Rate_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Consumption_Rate_Var_Samp_Order_By>;
  variance?: InputMaybe<Consumption_Rate_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Consumption_Rate_Avg_Fields = {
  __typename?: 'consumption_rate_avg_fields';
  lower_bound?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  processing_order?: Maybe<Scalars['Float']>;
  upper_bound?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "consumption_rate" */
export type Consumption_Rate_Avg_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  processing_order?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "consumption_rate". All fields are combined with a logical 'AND'. */
export type Consumption_Rate_Bool_Exp = {
  _and?: InputMaybe<Array<Consumption_Rate_Bool_Exp>>;
  _not?: InputMaybe<Consumption_Rate_Bool_Exp>;
  _or?: InputMaybe<Array<Consumption_Rate_Bool_Exp>>;
  consumption_schedule?: InputMaybe<Consumption_Schedule_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency_iso_code?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  lower_bound?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  pricing_method?: InputMaybe<String_Comparison_Exp>;
  processing_order?: InputMaybe<Numeric_Comparison_Exp>;
  salesforce_consumption_schedule_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  upper_bound?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Consumption_Rate_Max_Fields = {
  __typename?: 'consumption_rate_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  lower_bound?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  pricing_method?: Maybe<Scalars['String']>;
  processing_order?: Maybe<Scalars['numeric']>;
  salesforce_consumption_schedule_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  upper_bound?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "consumption_rate" */
export type Consumption_Rate_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  currency_iso_code?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  lower_bound?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  pricing_method?: InputMaybe<Order_By>;
  processing_order?: InputMaybe<Order_By>;
  salesforce_consumption_schedule_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Consumption_Rate_Min_Fields = {
  __typename?: 'consumption_rate_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['String']>;
  lower_bound?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  pricing_method?: Maybe<Scalars['String']>;
  processing_order?: Maybe<Scalars['numeric']>;
  salesforce_consumption_schedule_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  upper_bound?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "consumption_rate" */
export type Consumption_Rate_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  currency_iso_code?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  lower_bound?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  pricing_method?: InputMaybe<Order_By>;
  processing_order?: InputMaybe<Order_By>;
  salesforce_consumption_schedule_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "consumption_rate". */
export type Consumption_Rate_Order_By = {
  consumption_schedule?: InputMaybe<Consumption_Schedule_Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_iso_code?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  lower_bound?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  pricing_method?: InputMaybe<Order_By>;
  processing_order?: InputMaybe<Order_By>;
  salesforce_consumption_schedule_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** select columns of table "consumption_rate" */
export enum Consumption_Rate_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyIsoCode = 'currency_iso_code',
  /** column name */
  Description = 'description',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LowerBound = 'lower_bound',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  PricingMethod = 'pricing_method',
  /** column name */
  ProcessingOrder = 'processing_order',
  /** column name */
  SalesforceConsumptionScheduleId = 'salesforce_consumption_schedule_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpperBound = 'upper_bound'
}

/** select "consumption_rate_aggregate_bool_exp_bool_and_arguments_columns" columns of table "consumption_rate" */
export enum Consumption_Rate_Select_Column_Consumption_Rate_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "consumption_rate_aggregate_bool_exp_bool_or_arguments_columns" columns of table "consumption_rate" */
export enum Consumption_Rate_Select_Column_Consumption_Rate_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** aggregate stddev on columns */
export type Consumption_Rate_Stddev_Fields = {
  __typename?: 'consumption_rate_stddev_fields';
  lower_bound?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  processing_order?: Maybe<Scalars['Float']>;
  upper_bound?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "consumption_rate" */
export type Consumption_Rate_Stddev_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  processing_order?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Consumption_Rate_Stddev_Pop_Fields = {
  __typename?: 'consumption_rate_stddev_pop_fields';
  lower_bound?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  processing_order?: Maybe<Scalars['Float']>;
  upper_bound?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "consumption_rate" */
export type Consumption_Rate_Stddev_Pop_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  processing_order?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Consumption_Rate_Stddev_Samp_Fields = {
  __typename?: 'consumption_rate_stddev_samp_fields';
  lower_bound?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  processing_order?: Maybe<Scalars['Float']>;
  upper_bound?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "consumption_rate" */
export type Consumption_Rate_Stddev_Samp_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  processing_order?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "consumption_rate" */
export type Consumption_Rate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consumption_Rate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consumption_Rate_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_iso_code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  lower_bound?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  pricing_method?: InputMaybe<Scalars['String']>;
  processing_order?: InputMaybe<Scalars['numeric']>;
  salesforce_consumption_schedule_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  upper_bound?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Consumption_Rate_Sum_Fields = {
  __typename?: 'consumption_rate_sum_fields';
  lower_bound?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  processing_order?: Maybe<Scalars['numeric']>;
  upper_bound?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "consumption_rate" */
export type Consumption_Rate_Sum_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  processing_order?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Consumption_Rate_Var_Pop_Fields = {
  __typename?: 'consumption_rate_var_pop_fields';
  lower_bound?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  processing_order?: Maybe<Scalars['Float']>;
  upper_bound?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "consumption_rate" */
export type Consumption_Rate_Var_Pop_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  processing_order?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Consumption_Rate_Var_Samp_Fields = {
  __typename?: 'consumption_rate_var_samp_fields';
  lower_bound?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  processing_order?: Maybe<Scalars['Float']>;
  upper_bound?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "consumption_rate" */
export type Consumption_Rate_Var_Samp_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  processing_order?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Consumption_Rate_Variance_Fields = {
  __typename?: 'consumption_rate_variance_fields';
  lower_bound?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  processing_order?: Maybe<Scalars['Float']>;
  upper_bound?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "consumption_rate" */
export type Consumption_Rate_Variance_Order_By = {
  lower_bound?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  processing_order?: InputMaybe<Order_By>;
  upper_bound?: InputMaybe<Order_By>;
};

/** columns and relationships of "consumption_schedule" */
export type Consumption_Schedule = {
  __typename?: 'consumption_schedule';
  billing_rule?: Maybe<Scalars['String']>;
  billing_term?: Maybe<Scalars['numeric']>;
  billing_term_unit?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  /** An array relationship */
  consumption_rates: Array<Consumption_Rate>;
  /** An aggregate relationship */
  consumption_rates_aggregate: Consumption_Rate_Aggregate;
  /** An array relationship */
  consumption_schedule_to_consumption_rate: Array<Consumption_Rate>;
  /** An aggregate relationship */
  consumption_schedule_to_consumption_rate_aggregate: Consumption_Rate_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  is_active?: Maybe<Scalars['Boolean']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  last_reference_date?: Maybe<Scalars['timestamptz']>;
  last_viewed_date?: Maybe<Scalars['timestamptz']>;
  matching_attribute?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  no_of_consumption_rates?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  quote_line_consumption_schedules: Array<Quote_Line_Consumption_Schedule>;
  /** An aggregate relationship */
  quote_line_consumption_schedules_aggregate: Quote_Line_Consumption_Schedule_Aggregate;
  rating_method?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_revenue_recognition_rule_id?: Maybe<Scalars['String']>;
  salesforce_tax_rule_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unit_of_measure?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "consumption_schedule" */
export type Consumption_ScheduleConsumption_RatesArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumption_Rate_Order_By>>;
  where?: InputMaybe<Consumption_Rate_Bool_Exp>;
};


/** columns and relationships of "consumption_schedule" */
export type Consumption_ScheduleConsumption_Rates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumption_Rate_Order_By>>;
  where?: InputMaybe<Consumption_Rate_Bool_Exp>;
};


/** columns and relationships of "consumption_schedule" */
export type Consumption_ScheduleConsumption_Schedule_To_Consumption_RateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumption_Rate_Order_By>>;
  where?: InputMaybe<Consumption_Rate_Bool_Exp>;
};


/** columns and relationships of "consumption_schedule" */
export type Consumption_ScheduleConsumption_Schedule_To_Consumption_Rate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumption_Rate_Order_By>>;
  where?: InputMaybe<Consumption_Rate_Bool_Exp>;
};


/** columns and relationships of "consumption_schedule" */
export type Consumption_ScheduleQuote_Line_Consumption_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Order_By>>;
  where?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
};


/** columns and relationships of "consumption_schedule" */
export type Consumption_ScheduleQuote_Line_Consumption_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Order_By>>;
  where?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
};

/** aggregated selection of "consumption_schedule" */
export type Consumption_Schedule_Aggregate = {
  __typename?: 'consumption_schedule_aggregate';
  aggregate?: Maybe<Consumption_Schedule_Aggregate_Fields>;
  nodes: Array<Consumption_Schedule>;
};

/** aggregate fields of "consumption_schedule" */
export type Consumption_Schedule_Aggregate_Fields = {
  __typename?: 'consumption_schedule_aggregate_fields';
  avg?: Maybe<Consumption_Schedule_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Consumption_Schedule_Max_Fields>;
  min?: Maybe<Consumption_Schedule_Min_Fields>;
  stddev?: Maybe<Consumption_Schedule_Stddev_Fields>;
  stddev_pop?: Maybe<Consumption_Schedule_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Consumption_Schedule_Stddev_Samp_Fields>;
  sum?: Maybe<Consumption_Schedule_Sum_Fields>;
  var_pop?: Maybe<Consumption_Schedule_Var_Pop_Fields>;
  var_samp?: Maybe<Consumption_Schedule_Var_Samp_Fields>;
  variance?: Maybe<Consumption_Schedule_Variance_Fields>;
};


/** aggregate fields of "consumption_schedule" */
export type Consumption_Schedule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consumption_Schedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Consumption_Schedule_Avg_Fields = {
  __typename?: 'consumption_schedule_avg_fields';
  billing_term?: Maybe<Scalars['Float']>;
  no_of_consumption_rates?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "consumption_schedule". All fields are combined with a logical 'AND'. */
export type Consumption_Schedule_Bool_Exp = {
  _and?: InputMaybe<Array<Consumption_Schedule_Bool_Exp>>;
  _not?: InputMaybe<Consumption_Schedule_Bool_Exp>;
  _or?: InputMaybe<Array<Consumption_Schedule_Bool_Exp>>;
  billing_rule?: InputMaybe<String_Comparison_Exp>;
  billing_term?: InputMaybe<Numeric_Comparison_Exp>;
  billing_term_unit?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  consumption_rates?: InputMaybe<Consumption_Rate_Bool_Exp>;
  consumption_rates_aggregate?: InputMaybe<Consumption_Rate_Aggregate_Bool_Exp>;
  consumption_schedule_to_consumption_rate?: InputMaybe<Consumption_Rate_Bool_Exp>;
  consumption_schedule_to_consumption_rate_aggregate?: InputMaybe<Consumption_Rate_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency_iso_code?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  last_reference_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_viewed_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  matching_attribute?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  no_of_consumption_rates?: InputMaybe<Numeric_Comparison_Exp>;
  quote_line_consumption_schedules?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
  quote_line_consumption_schedules_aggregate?: InputMaybe<Quote_Line_Consumption_Schedule_Aggregate_Bool_Exp>;
  rating_method?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_owner_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_revenue_recognition_rule_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_tax_rule_id?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  unit_of_measure?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Consumption_Schedule_Max_Fields = {
  __typename?: 'consumption_schedule_max_fields';
  billing_rule?: Maybe<Scalars['String']>;
  billing_term?: Maybe<Scalars['numeric']>;
  billing_term_unit?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  last_reference_date?: Maybe<Scalars['timestamptz']>;
  last_viewed_date?: Maybe<Scalars['timestamptz']>;
  matching_attribute?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  no_of_consumption_rates?: Maybe<Scalars['numeric']>;
  rating_method?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_revenue_recognition_rule_id?: Maybe<Scalars['String']>;
  salesforce_tax_rule_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unit_of_measure?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Consumption_Schedule_Min_Fields = {
  __typename?: 'consumption_schedule_min_fields';
  billing_rule?: Maybe<Scalars['String']>;
  billing_term?: Maybe<Scalars['numeric']>;
  billing_term_unit?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  last_reference_date?: Maybe<Scalars['timestamptz']>;
  last_viewed_date?: Maybe<Scalars['timestamptz']>;
  matching_attribute?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  no_of_consumption_rates?: Maybe<Scalars['numeric']>;
  rating_method?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_revenue_recognition_rule_id?: Maybe<Scalars['String']>;
  salesforce_tax_rule_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unit_of_measure?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "consumption_schedule". */
export type Consumption_Schedule_Order_By = {
  billing_rule?: InputMaybe<Order_By>;
  billing_term?: InputMaybe<Order_By>;
  billing_term_unit?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  consumption_rates_aggregate?: InputMaybe<Consumption_Rate_Aggregate_Order_By>;
  consumption_schedule_to_consumption_rate_aggregate?: InputMaybe<Consumption_Rate_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_iso_code?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  last_reference_date?: InputMaybe<Order_By>;
  last_viewed_date?: InputMaybe<Order_By>;
  matching_attribute?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  no_of_consumption_rates?: InputMaybe<Order_By>;
  quote_line_consumption_schedules_aggregate?: InputMaybe<Quote_Line_Consumption_Schedule_Aggregate_Order_By>;
  rating_method?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_revenue_recognition_rule_id?: InputMaybe<Order_By>;
  salesforce_tax_rule_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unit_of_measure?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "consumption_schedule" */
export enum Consumption_Schedule_Select_Column {
  /** column name */
  BillingRule = 'billing_rule',
  /** column name */
  BillingTerm = 'billing_term',
  /** column name */
  BillingTermUnit = 'billing_term_unit',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyIsoCode = 'currency_iso_code',
  /** column name */
  Description = 'description',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastReferenceDate = 'last_reference_date',
  /** column name */
  LastViewedDate = 'last_viewed_date',
  /** column name */
  MatchingAttribute = 'matching_attribute',
  /** column name */
  Name = 'name',
  /** column name */
  NoOfConsumptionRates = 'no_of_consumption_rates',
  /** column name */
  RatingMethod = 'rating_method',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  SalesforceOwnerId = 'salesforce_owner_id',
  /** column name */
  SalesforceRevenueRecognitionRuleId = 'salesforce_revenue_recognition_rule_id',
  /** column name */
  SalesforceTaxRuleId = 'salesforce_tax_rule_id',
  /** column name */
  Type = 'type',
  /** column name */
  UnitOfMeasure = 'unit_of_measure',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Consumption_Schedule_Stddev_Fields = {
  __typename?: 'consumption_schedule_stddev_fields';
  billing_term?: Maybe<Scalars['Float']>;
  no_of_consumption_rates?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Consumption_Schedule_Stddev_Pop_Fields = {
  __typename?: 'consumption_schedule_stddev_pop_fields';
  billing_term?: Maybe<Scalars['Float']>;
  no_of_consumption_rates?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Consumption_Schedule_Stddev_Samp_Fields = {
  __typename?: 'consumption_schedule_stddev_samp_fields';
  billing_term?: Maybe<Scalars['Float']>;
  no_of_consumption_rates?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "consumption_schedule" */
export type Consumption_Schedule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consumption_Schedule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consumption_Schedule_Stream_Cursor_Value_Input = {
  billing_rule?: InputMaybe<Scalars['String']>;
  billing_term?: InputMaybe<Scalars['numeric']>;
  billing_term_unit?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_iso_code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_reference_date?: InputMaybe<Scalars['timestamptz']>;
  last_viewed_date?: InputMaybe<Scalars['timestamptz']>;
  matching_attribute?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  no_of_consumption_rates?: InputMaybe<Scalars['numeric']>;
  rating_method?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_owner_id?: InputMaybe<Scalars['String']>;
  salesforce_revenue_recognition_rule_id?: InputMaybe<Scalars['String']>;
  salesforce_tax_rule_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unit_of_measure?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Consumption_Schedule_Sum_Fields = {
  __typename?: 'consumption_schedule_sum_fields';
  billing_term?: Maybe<Scalars['numeric']>;
  no_of_consumption_rates?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Consumption_Schedule_Var_Pop_Fields = {
  __typename?: 'consumption_schedule_var_pop_fields';
  billing_term?: Maybe<Scalars['Float']>;
  no_of_consumption_rates?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Consumption_Schedule_Var_Samp_Fields = {
  __typename?: 'consumption_schedule_var_samp_fields';
  billing_term?: Maybe<Scalars['Float']>;
  no_of_consumption_rates?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Consumption_Schedule_Variance_Fields = {
  __typename?: 'consumption_schedule_variance_fields';
  billing_term?: Maybe<Scalars['Float']>;
  no_of_consumption_rates?: Maybe<Scalars['Float']>;
};

/** Customer Contacts */
export type Contact = {
  __typename?: 'contact';
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  address_line_3?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  contact_type?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  customer: Account;
  department?: Maybe<Scalars['String']>;
  domain_exist?: Maybe<Scalars['Boolean']>;
  email_id?: Maybe<Scalars['String']>;
  /** A computed field, executes function "email_ids" */
  email_ids?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  is_deleted: Scalars['Boolean'];
  /** A computed field, executes function "contact_is_primary" */
  is_primary?: Maybe<Scalars['Boolean']>;
  last_name: Scalars['String'];
  middle_name?: Maybe<Scalars['String']>;
  mobile_phone_number?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  salesforce_account_id: Scalars['String'];
  salesforce_created_date: Scalars['timestamptz'];
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date: Scalars['timestamptz'];
  salutation?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  work_phone_number?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** aggregated selection of "contact" */
export type Contact_Aggregate = {
  __typename?: 'contact_aggregate';
  aggregate?: Maybe<Contact_Aggregate_Fields>;
  nodes: Array<Contact>;
};

export type Contact_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Contact_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Contact_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Contact_Aggregate_Bool_Exp_Count>;
};

export type Contact_Aggregate_Bool_Exp_Bool_And = {
  arguments: Contact_Select_Column_Contact_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Contact_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Contact_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Contact_Select_Column_Contact_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Contact_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Contact_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Contact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Contact_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "contact" */
export type Contact_Aggregate_Fields = {
  __typename?: 'contact_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Contact_Max_Fields>;
  min?: Maybe<Contact_Min_Fields>;
};


/** aggregate fields of "contact" */
export type Contact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "contact" */
export type Contact_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Contact_Max_Order_By>;
  min?: InputMaybe<Contact_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "contact". All fields are combined with a logical 'AND'. */
export type Contact_Bool_Exp = {
  _and?: InputMaybe<Array<Contact_Bool_Exp>>;
  _not?: InputMaybe<Contact_Bool_Exp>;
  _or?: InputMaybe<Array<Contact_Bool_Exp>>;
  address_line_1?: InputMaybe<String_Comparison_Exp>;
  address_line_2?: InputMaybe<String_Comparison_Exp>;
  address_line_3?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  contact_type?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer?: InputMaybe<Account_Bool_Exp>;
  department?: InputMaybe<String_Comparison_Exp>;
  domain_exist?: InputMaybe<Boolean_Comparison_Exp>;
  email_id?: InputMaybe<String_Comparison_Exp>;
  email_ids?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_primary?: InputMaybe<Boolean_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  middle_name?: InputMaybe<String_Comparison_Exp>;
  mobile_phone_number?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salutation?: InputMaybe<String_Comparison_Exp>;
  state_province?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  work_phone_number?: InputMaybe<String_Comparison_Exp>;
  zip_code?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Contact_Max_Fields = {
  __typename?: 'contact_max_fields';
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  address_line_3?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  contact_type?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  department?: Maybe<Scalars['String']>;
  email_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  mobile_phone_number?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salutation?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  work_phone_number?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "contact" */
export type Contact_Max_Order_By = {
  address_line_1?: InputMaybe<Order_By>;
  address_line_2?: InputMaybe<Order_By>;
  address_line_3?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  contact_type?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  department?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  middle_name?: InputMaybe<Order_By>;
  mobile_phone_number?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salutation?: InputMaybe<Order_By>;
  state_province?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  work_phone_number?: InputMaybe<Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Contact_Min_Fields = {
  __typename?: 'contact_min_fields';
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  address_line_3?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  contact_type?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  department?: Maybe<Scalars['String']>;
  email_id?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  mobile_phone_number?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salutation?: Maybe<Scalars['String']>;
  state_province?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  work_phone_number?: Maybe<Scalars['String']>;
  zip_code?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "contact" */
export type Contact_Min_Order_By = {
  address_line_1?: InputMaybe<Order_By>;
  address_line_2?: InputMaybe<Order_By>;
  address_line_3?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  contact_type?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  department?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  middle_name?: InputMaybe<Order_By>;
  mobile_phone_number?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salutation?: InputMaybe<Order_By>;
  state_province?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  work_phone_number?: InputMaybe<Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "contact". */
export type Contact_Order_By = {
  address_line_1?: InputMaybe<Order_By>;
  address_line_2?: InputMaybe<Order_By>;
  address_line_3?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  contact_type?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  customer?: InputMaybe<Account_Order_By>;
  department?: InputMaybe<Order_By>;
  domain_exist?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  email_ids?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_primary?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  middle_name?: InputMaybe<Order_By>;
  mobile_phone_number?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salutation?: InputMaybe<Order_By>;
  state_province?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  work_phone_number?: InputMaybe<Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

/** select columns of table "contact" */
export enum Contact_Select_Column {
  /** column name */
  AddressLine_1 = 'address_line_1',
  /** column name */
  AddressLine_2 = 'address_line_2',
  /** column name */
  AddressLine_3 = 'address_line_3',
  /** column name */
  City = 'city',
  /** column name */
  ContactType = 'contact_type',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Department = 'department',
  /** column name */
  DomainExist = 'domain_exist',
  /** column name */
  EmailId = 'email_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MiddleName = 'middle_name',
  /** column name */
  MobilePhoneNumber = 'mobile_phone_number',
  /** column name */
  Region = 'region',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  Salutation = 'salutation',
  /** column name */
  StateProvince = 'state_province',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WorkPhoneNumber = 'work_phone_number',
  /** column name */
  ZipCode = 'zip_code'
}

/** select "contact_aggregate_bool_exp_bool_and_arguments_columns" columns of table "contact" */
export enum Contact_Select_Column_Contact_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DomainExist = 'domain_exist',
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "contact_aggregate_bool_exp_bool_or_arguments_columns" columns of table "contact" */
export enum Contact_Select_Column_Contact_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DomainExist = 'domain_exist',
  /** column name */
  IsDeleted = 'is_deleted'
}

/** Streaming cursor of the table "contact" */
export type Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contact_Stream_Cursor_Value_Input = {
  address_line_1?: InputMaybe<Scalars['String']>;
  address_line_2?: InputMaybe<Scalars['String']>;
  address_line_3?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  contact_type?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  department?: InputMaybe<Scalars['String']>;
  domain_exist?: InputMaybe<Scalars['Boolean']>;
  email_id?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  middle_name?: InputMaybe<Scalars['String']>;
  mobile_phone_number?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  salutation?: InputMaybe<Scalars['String']>;
  state_province?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  work_phone_number?: InputMaybe<Scalars['String']>;
  zip_code?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "content_plus_contacts" */
export type Content_Plus_Contacts = {
  __typename?: 'content_plus_contacts';
  /** An object relationship */
  amagi_content_plus_owner?: Maybe<Owner>;
  /** An object relationship */
  content_plus_contacts?: Maybe<Customer>;
  content_plus_customer_email_id_1?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_2?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_3?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_4?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_5?: Maybe<Scalars['String']>;
  content_plus_customer_email_id_6?: Maybe<Scalars['String']>;
  content_plus_internal_email_id?: Maybe<Scalars['String']>;
  content_plus_owner?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "content_plus_contacts". All fields are combined with a logical 'AND'. */
export type Content_Plus_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Content_Plus_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Content_Plus_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Content_Plus_Contacts_Bool_Exp>>;
  amagi_content_plus_owner?: InputMaybe<Owner_Bool_Exp>;
  content_plus_contacts?: InputMaybe<Customer_Bool_Exp>;
  content_plus_customer_email_id_1?: InputMaybe<String_Comparison_Exp>;
  content_plus_customer_email_id_2?: InputMaybe<String_Comparison_Exp>;
  content_plus_customer_email_id_3?: InputMaybe<String_Comparison_Exp>;
  content_plus_customer_email_id_4?: InputMaybe<String_Comparison_Exp>;
  content_plus_customer_email_id_5?: InputMaybe<String_Comparison_Exp>;
  content_plus_customer_email_id_6?: InputMaybe<String_Comparison_Exp>;
  content_plus_internal_email_id?: InputMaybe<String_Comparison_Exp>;
  content_plus_owner?: InputMaybe<String_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "content_plus_contacts". */
export type Content_Plus_Contacts_Order_By = {
  amagi_content_plus_owner?: InputMaybe<Owner_Order_By>;
  content_plus_contacts?: InputMaybe<Customer_Order_By>;
  content_plus_customer_email_id_1?: InputMaybe<Order_By>;
  content_plus_customer_email_id_2?: InputMaybe<Order_By>;
  content_plus_customer_email_id_3?: InputMaybe<Order_By>;
  content_plus_customer_email_id_4?: InputMaybe<Order_By>;
  content_plus_customer_email_id_5?: InputMaybe<Order_By>;
  content_plus_customer_email_id_6?: InputMaybe<Order_By>;
  content_plus_internal_email_id?: InputMaybe<Order_By>;
  content_plus_owner?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
};

/** select columns of table "content_plus_contacts" */
export enum Content_Plus_Contacts_Select_Column {
  /** column name */
  ContentPlusCustomerEmailId_1 = 'content_plus_customer_email_id_1',
  /** column name */
  ContentPlusCustomerEmailId_2 = 'content_plus_customer_email_id_2',
  /** column name */
  ContentPlusCustomerEmailId_3 = 'content_plus_customer_email_id_3',
  /** column name */
  ContentPlusCustomerEmailId_4 = 'content_plus_customer_email_id_4',
  /** column name */
  ContentPlusCustomerEmailId_5 = 'content_plus_customer_email_id_5',
  /** column name */
  ContentPlusCustomerEmailId_6 = 'content_plus_customer_email_id_6',
  /** column name */
  ContentPlusInternalEmailId = 'content_plus_internal_email_id',
  /** column name */
  ContentPlusOwner = 'content_plus_owner',
  /** column name */
  SalesforceId = 'salesforce_id'
}

/** Streaming cursor of the table "content_plus_contacts" */
export type Content_Plus_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Content_Plus_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Content_Plus_Contacts_Stream_Cursor_Value_Input = {
  content_plus_customer_email_id_1?: InputMaybe<Scalars['String']>;
  content_plus_customer_email_id_2?: InputMaybe<Scalars['String']>;
  content_plus_customer_email_id_3?: InputMaybe<Scalars['String']>;
  content_plus_customer_email_id_4?: InputMaybe<Scalars['String']>;
  content_plus_customer_email_id_5?: InputMaybe<Scalars['String']>;
  content_plus_customer_email_id_6?: InputMaybe<Scalars['String']>;
  content_plus_internal_email_id?: InputMaybe<Scalars['String']>;
  content_plus_owner?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
};

export type Credit_Memo_By_Id_Args = {
  _id?: InputMaybe<Scalars['String']>;
};

export type Creditmemos_Applied_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Creditmemos_Total_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Creditmemos_Unapplied_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "customer" */
export type Customer = {
  __typename?: 'customer';
  account_category?: Maybe<Scalars['String']>;
  account_creation_date?: Maybe<Scalars['date']>;
  account_currency?: Maybe<Scalars['String']>;
  account_deactivation_date?: Maybe<Scalars['date']>;
  account_legal_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  account_manager?: Maybe<Owner>;
  account_name?: Maybe<Scalars['String']>;
  /** A computed field, executes function "account_statement" */
  account_statement?: Maybe<Array<Fn_Return_Account_Statement>>;
  /** A computed field, executes function "account_statement_meta" */
  account_statement_meta?: Maybe<Array<Fn_Return_Account_Statement_Meta>>;
  /** A computed field, executes function "account_statement_outstanding" */
  account_statement_outstanding?: Maybe<Array<Fn_Return_Account_Statement_Outstanding>>;
  /** A computed field, executes function "account_statement_summary" */
  account_statement_summary?: Maybe<Array<Fn_Return_Account_Statement_Summary>>;
  /** A computed field, executes function "actual_revenue" */
  actual_revenue?: Maybe<Array<Fn_Return_Financial_Graph>>;
  /** A computed field, executes function "actual_revenue_cummulative" */
  actual_revenue_cummulative?: Maybe<Array<Fn_Return_Financial_Graph>>;
  /** A computed field, executes function "actual_revenue_cummulative_origin" */
  actual_revenue_cummulative_origin?: Maybe<Array<Fn_Return_Financial_Graph>>;
  ad_revenue_model?: Maybe<Scalars['String']>;
  /** An object relationship */
  address?: Maybe<Company_Address>;
  /** An object relationship */
  ads_plus_customer_contacts?: Maybe<Ads_Plus_Customer_Contacts>;
  amagi_id?: Maybe<Scalars['String']>;
  amagi_now?: Maybe<Scalars['String']>;
  amagi_now_url?: Maybe<Scalars['String']>;
  /** A computed field, executes function "avg_service_availibity" */
  avg_service_availibity?: Maybe<Array<Fn_Return_Avg_Service_Availibity>>;
  /** An object relationship */
  bill_contact?: Maybe<Contact>;
  bill_to_contact?: Maybe<Scalars['String']>;
  /** A computed field, executes function "billed_revenue" */
  billed_revenue?: Maybe<Array<Fn_Return_Financial_Graph>>;
  /** A computed field, executes function "billed_revenue_cummulative" */
  billed_revenue_cummulative?: Maybe<Array<Fn_Return_Financial_Graph>>;
  /** A computed field, executes function "billed_revenue_cummulative_origin" */
  billed_revenue_cummulative_origin?: Maybe<Array<Fn_Return_Financial_Graph>>;
  billing_address?: Maybe<Scalars['jsonb']>;
  billing_contact?: Maybe<Scalars['jsonb']>;
  billing_term?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  /** A computed field, executes function "booked_revenue" */
  booked_revenue?: Maybe<Array<Fn_Return_Financial_Graph>>;
  /** A computed field, executes function "booked_revenue_cummulative" */
  booked_revenue_cummulative?: Maybe<Array<Fn_Return_Financial_Graph>>;
  /** A computed field, executes function "booked_revenue_cummulative_origin" */
  booked_revenue_cummulative_origin?: Maybe<Array<Fn_Return_Financial_Graph>>;
  business_category?: Maybe<Scalars['String']>;
  c_plus_percentage_share?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  cases: Array<Case>;
  /** An aggregate relationship */
  cases_aggregate: Case_Aggregate;
  cdpderived_revenue_segment?: Maybe<Scalars['String']>;
  /** A computed field, executes function "channel_deliveries" */
  channel_deliveries?: Maybe<Array<Fn_Return_Deliveries_Count>>;
  /** An array relationship */
  channels: Array<Channel>;
  /** An aggregate relationship */
  channels_aggregate: Channel_Aggregate;
  /** An array relationship */
  children: Array<Customer>;
  /** An aggregate relationship */
  children_aggregate: Customer_Aggregate;
  churn_requested_by?: Maybe<Scalars['String']>;
  churn_risk_percentage?: Maybe<Scalars['numeric']>;
  cloud_region?: Maybe<Scalars['jsonb']>;
  cloud_service_provider?: Maybe<Scalars['jsonb']>;
  cloudport?: Maybe<Scalars['String']>;
  cloudport_url?: Maybe<Scalars['String']>;
  /** An array relationship */
  cloudport_urls: Array<Cloudport>;
  /** A computed field, executes function "combined_credit_memos" */
  combined_credit_memos?: Maybe<Array<Fn_Return_Combined_Invoice>>;
  /** A computed field, executes function "combined_invoices" */
  combined_invoices?: Maybe<Array<Fn_Return_Combined_Invoice>>;
  /** A computed field, executes function "combined_receipts" */
  combined_receipts?: Maybe<Array<Fn_Return_Combined_Receipt>>;
  comments?: Maybe<Scalars['String']>;
  company_category?: Maybe<Scalars['String']>;
  connect_msa_effective_date?: Maybe<Scalars['date']>;
  /** An array relationship */
  contacts: Array<Contact>;
  /** An aggregate relationship */
  contacts_aggregate: Contact_Aggregate;
  /** An object relationship */
  content_plus_contacts?: Maybe<Content_Plus_Contacts>;
  /** An object relationship */
  contract_terms?: Maybe<Customer_Contract_Terms>;
  cplus_msa_effective_date?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "credit_memos" */
  credit_memos?: Maybe<Array<Fn_Return_Combined_Invoice>>;
  credit_period_in_days?: Maybe<Scalars['String']>;
  credit_score?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "creditmemos_applied" */
  creditmemos_applied?: Maybe<Array<Fn_Return_Billing_Summary>>;
  /** A computed field, executes function "creditmemos_total" */
  creditmemos_total?: Maybe<Array<Fn_Return_Billing_Summary>>;
  /** A computed field, executes function "creditmemos_unapplied" */
  creditmemos_unapplied?: Maybe<Array<Fn_Return_Billing_Summary>>;
  /** An object relationship */
  csm?: Maybe<Owner>;
  customer_business_model?: Maybe<Scalars['String']>;
  customer_contract_period?: Maybe<Scalars['numeric']>;
  customer_files?: Maybe<SalesforceOpportunityResponse>;
  customer_financial_risk_category?: Maybe<Scalars['String']>;
  customer_life_time_value?: Maybe<Scalars['numeric']>;
  customer_origin?: Maybe<Scalars['String']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['numeric']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "customer_revenue_split" */
  customer_revenue_split?: Maybe<Array<Fn_Return_Revenue_Split>>;
  customer_scale?: Maybe<Scalars['String']>;
  customer_since_date?: Maybe<Scalars['timestamptz']>;
  customer_tier?: Maybe<Scalars['String']>;
  customer_type?: Maybe<Scalars['String']>;
  customers_profit_for_previous_year?: Maybe<Scalars['numeric']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  dso?: Maybe<Scalars['String']>;
  first_invoice_date?: Maybe<Scalars['date']>;
  /** An object relationship */
  freshdesk?: Maybe<Freshdesk_Company>;
  industry_segment?: Maybe<Scalars['String']>;
  /** An array relationship */
  invoices: Array<Invoice>;
  /** An aggregate relationship */
  invoices_aggregate: Invoice_Aggregate;
  /** A computed field, executes function "invoices_due" */
  invoices_due?: Maybe<Array<Fn_Return_Billing_Summary>>;
  /** A computed field, executes function "invoices_overdue" */
  invoices_overdue?: Maybe<Array<Fn_Return_Billing_Summary>>;
  /** A computed field, executes function "invoices_paid_in_full" */
  invoices_paid_in_full?: Maybe<Array<Fn_Return_Billing_Summary>>;
  /** A computed field, executes function "invoices_total" */
  invoices_total?: Maybe<Array<Fn_Return_Billing_Summary>>;
  invoicing_currency?: Maybe<Scalars['String']>;
  is_active?: Maybe<Scalars['Boolean']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  is_msa_ratecard_customer?: Maybe<Scalars['Boolean']>;
  is_ono?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  /** A computed field, executes function "latest_arr" */
  latest_arr?: Maybe<Array<Fn_Return_Latest_Mrr>>;
  /** A computed field, executes function "latest_mrr" */
  latest_mrr?: Maybe<Array<Fn_Return_Latest_Mrr>>;
  /** An object relationship */
  legal_entity?: Maybe<Legal_Entity>;
  legal_entity_id?: Maybe<Scalars['String']>;
  legal_entity_name?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  /** An object relationship */
  media_industry_sub_segment?: Maybe<Media_Industry_Sub_Segment>;
  monetization_preference?: Maybe<Scalars['String']>;
  msa_effective_date?: Maybe<Scalars['date']>;
  /** A computed field, executes function "netsuite_credit_issued" */
  netsuite_credit_issued?: Maybe<Array<Fn_Return_Financial_Graph>>;
  /** A computed field, executes function "netsuite_credit_issued_cummulative" */
  netsuite_credit_issued_cummulative?: Maybe<Array<Fn_Return_Financial_Graph>>;
  /** A computed field, executes function "netsuite_credit_issued_cummulative_origin" */
  netsuite_credit_issued_cummulative_origin?: Maybe<Array<Fn_Return_Financial_Graph>>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "netsuite_invoice_revenue" */
  netsuite_invoice_revenue?: Maybe<Array<Fn_Return_Financial_Graph>>;
  /** An array relationship */
  netsuite_receipts: Array<Netsuite_Receipt>;
  /** An aggregate relationship */
  netsuite_receipts_aggregate: Netsuite_Receipt_Aggregate;
  /** An array relationship */
  netsuite_transactions: Array<Netsuite_Transaction>;
  /** An aggregate relationship */
  netsuite_transactions_aggregate: Netsuite_Transaction_Aggregate;
  no_of_employees?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  onboarding_customer_contacts?: Maybe<Onboarding_Customer_Contacts>;
  /** An array relationship */
  opportunity: Array<Opportunity>;
  /** An aggregate relationship */
  opportunity_aggregate: Opportunity_Aggregate;
  /** An array relationship */
  orders: Array<Order>;
  /** An aggregate relationship */
  orders_aggregate: Order_Aggregate;
  /** An object relationship */
  owner?: Maybe<Owner>;
  /** An object relationship */
  parent?: Maybe<Customer>;
  payment_due_on_receipt?: Maybe<Scalars['Boolean']>;
  payment_terms?: Maybe<Scalars['String']>;
  payment_terms_in_days?: Maybe<Scalars['numeric']>;
  phone?: Maybe<Scalars['String']>;
  planner?: Maybe<Scalars['String']>;
  planner_url?: Maybe<Scalars['String']>;
  /** An array relationship */
  platform: Array<Platform>;
  /** An aggregate relationship */
  platform_aggregate: Platform_Aggregate;
  platform_tier?: Maybe<Scalars['String']>;
  preferred_payment_channel?: Maybe<Scalars['String']>;
  /** A computed field, executes function "product_revenue_invoice" */
  product_revenue_invoice?: Maybe<Array<Fn_Return_Product_Financial_Graph>>;
  /** A computed field, executes function "product_table_detail" */
  product_table_detail?: Maybe<Array<Fn_Return_Product_Table_Detail>>;
  /** An object relationship */
  product_url?: Maybe<Customer_Product_Url>;
  /** An array relationship */
  quotes: Array<Quote>;
  /** An aggregate relationship */
  quotes_aggregate: Quote_Aggregate;
  /** A computed field, executes function "receipts_applied" */
  receipts_applied?: Maybe<Array<Fn_Return_Billing_Summary>>;
  /** A computed field, executes function "receipts_total" */
  receipts_total?: Maybe<Array<Fn_Return_Billing_Summary>>;
  /** A computed field, executes function "receipts_unapplied" */
  receipts_unapplied?: Maybe<Array<Fn_Return_Billing_Summary>>;
  /** An object relationship */
  record_type?: Maybe<Record_Type>;
  region?: Maybe<Scalars['String']>;
  revenue_group_1?: Maybe<Scalars['String']>;
  revenue_group_2?: Maybe<Scalars['String']>;
  /** A computed field, executes function "sales" */
  sales?: Maybe<Array<Fn_Return_Sales_Response>>;
  salesforce_accountmanager_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_csm_id?: Maybe<Scalars['String']>;
  salesforce_geohead_id?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_parent_id?: Maybe<Scalars['String']>;
  salesforce_record_type_id?: Maybe<Scalars['String']>;
  salesforce_salesrep_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  segment?: Maybe<Segment>;
  self_service_access?: Maybe<Scalars['String']>;
  service_tier?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tam?: Maybe<Scalars['String']>;
  thunderstorm?: Maybe<Scalars['String']>;
  thunderstorm_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "vod_deliveries" */
  vod_deliveries?: Maybe<Array<Fn_Return_Deliveries_Count>>;
};


/** columns and relationships of "customer" */
export type CustomerAccount_StatementArgs = {
  args: Account_Statement_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerAccount_Statement_MetaArgs = {
  args: Account_Statement_Meta_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Meta_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Meta_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerAccount_Statement_OutstandingArgs = {
  args: Account_Statement_Outstanding_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Outstanding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Outstanding_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Outstanding_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerAccount_Statement_SummaryArgs = {
  args: Account_Statement_Summary_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Summary_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerActual_RevenueArgs = {
  args: Actual_Revenue_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerActual_Revenue_CummulativeArgs = {
  args: Actual_Revenue_Cummulative_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerActual_Revenue_Cummulative_OriginArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerAvg_Service_AvailibityArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Avg_Service_Availibity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Avg_Service_Availibity_Order_By>>;
  where?: InputMaybe<Fn_Return_Avg_Service_Availibity_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerBilled_RevenueArgs = {
  args: Billed_Revenue_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerBilled_Revenue_CummulativeArgs = {
  args: Billed_Revenue_Cummulative_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerBilled_Revenue_Cummulative_OriginArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerBilling_AddressArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customer" */
export type CustomerBilling_ContactArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customer" */
export type CustomerBooked_RevenueArgs = {
  args: Booked_Revenue_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerBooked_Revenue_CummulativeArgs = {
  args: Booked_Revenue_Cummulative_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerBooked_Revenue_Cummulative_OriginArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerCasesArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerCases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerChannel_DeliveriesArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Deliveries_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Deliveries_Count_Order_By>>;
  where?: InputMaybe<Fn_Return_Deliveries_Count_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerChannelsArgs = {
  distinct_on?: InputMaybe<Array<Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Order_By>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerChannels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Order_By>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerChildrenArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerChildren_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerCloud_RegionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customer" */
export type CustomerCloud_Service_ProviderArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "customer" */
export type CustomerCloudport_UrlsArgs = {
  distinct_on?: InputMaybe<Array<Cloudport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cloudport_Order_By>>;
  where?: InputMaybe<Cloudport_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerCombined_Credit_MemosArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerCombined_InvoicesArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerCombined_ReceiptsArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Receipt_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Receipt_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerContactsArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerCredit_MemosArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerCreditmemos_AppliedArgs = {
  args: Creditmemos_Applied_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerCreditmemos_TotalArgs = {
  args: Creditmemos_Total_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerCreditmemos_UnappliedArgs = {
  args: Creditmemos_Unapplied_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerCustomer_Revenue_SplitArgs = {
  args: Customer_Revenue_Split_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Revenue_Split_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Revenue_Split_Order_By>>;
  where?: InputMaybe<Fn_Return_Revenue_Split_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerInvoices_DueArgs = {
  args: Invoices_Due_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerInvoices_OverdueArgs = {
  args: Invoices_Overdue_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerInvoices_Paid_In_FullArgs = {
  args: Invoices_Paid_In_Full_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerInvoices_TotalArgs = {
  args: Invoices_Total_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerLatest_ArrArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Latest_Mrr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Latest_Mrr_Order_By>>;
  where?: InputMaybe<Fn_Return_Latest_Mrr_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerLatest_MrrArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Latest_Mrr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Latest_Mrr_Order_By>>;
  where?: InputMaybe<Fn_Return_Latest_Mrr_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerNetsuite_Credit_IssuedArgs = {
  args: Netsuite_Credit_Issued_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerNetsuite_Credit_Issued_CummulativeArgs = {
  args: Netsuite_Credit_Issued_Cummulative_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerNetsuite_Credit_Issued_Cummulative_OriginArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerNetsuite_Invoice_RevenueArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerNetsuite_ReceiptsArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Receipt_Order_By>>;
  where?: InputMaybe<Netsuite_Receipt_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerNetsuite_Receipts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Receipt_Order_By>>;
  where?: InputMaybe<Netsuite_Receipt_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerNetsuite_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Transaction_Order_By>>;
  where?: InputMaybe<Netsuite_Transaction_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerNetsuite_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Transaction_Order_By>>;
  where?: InputMaybe<Netsuite_Transaction_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerOpportunityArgs = {
  distinct_on?: InputMaybe<Array<Opportunity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opportunity_Order_By>>;
  where?: InputMaybe<Opportunity_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerOpportunity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Opportunity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opportunity_Order_By>>;
  where?: InputMaybe<Opportunity_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerOrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerPlatformArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerPlatform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerProduct_Revenue_InvoiceArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Product_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Product_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Product_Financial_Graph_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerProduct_Table_DetailArgs = {
  args: Product_Table_Detail_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Product_Table_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Product_Table_Detail_Order_By>>;
  where?: InputMaybe<Fn_Return_Product_Table_Detail_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerQuotesArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerQuotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerReceipts_AppliedArgs = {
  args: Receipts_Applied_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerReceipts_TotalArgs = {
  args: Receipts_Total_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerReceipts_UnappliedArgs = {
  args: Receipts_Unapplied_Customer_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerSalesArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Sales_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Sales_Response_Order_By>>;
  where?: InputMaybe<Fn_Return_Sales_Response_Bool_Exp>;
};


/** columns and relationships of "customer" */
export type CustomerVod_DeliveriesArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Deliveries_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Deliveries_Count_Order_By>>;
  where?: InputMaybe<Fn_Return_Deliveries_Count_Bool_Exp>;
};

/** aggregated selection of "customer" */
export type Customer_Aggregate = {
  __typename?: 'customer_aggregate';
  aggregate?: Maybe<Customer_Aggregate_Fields>;
  nodes: Array<Customer>;
};

export type Customer_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Customer_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Customer_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Customer_Aggregate_Bool_Exp_Count>;
};

export type Customer_Aggregate_Bool_Exp_Bool_And = {
  arguments: Customer_Select_Column_Customer_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Customer_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Customer_Select_Column_Customer_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Customer_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Customer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Customer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Customer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "customer" */
export type Customer_Aggregate_Fields = {
  __typename?: 'customer_aggregate_fields';
  avg?: Maybe<Customer_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Customer_Max_Fields>;
  min?: Maybe<Customer_Min_Fields>;
  stddev?: Maybe<Customer_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Sum_Fields>;
  var_pop?: Maybe<Customer_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Var_Samp_Fields>;
  variance?: Maybe<Customer_Variance_Fields>;
};


/** aggregate fields of "customer" */
export type Customer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "customer" */
export type Customer_Aggregate_Order_By = {
  avg?: InputMaybe<Customer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Customer_Max_Order_By>;
  min?: InputMaybe<Customer_Min_Order_By>;
  stddev?: InputMaybe<Customer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Customer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Customer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Customer_Sum_Order_By>;
  var_pop?: InputMaybe<Customer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Customer_Var_Samp_Order_By>;
  variance?: InputMaybe<Customer_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Customer_Avg_Fields = {
  __typename?: 'customer_avg_fields';
  c_plus_percentage_share?: Maybe<Scalars['Float']>;
  churn_risk_percentage?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Float']>;
  customer_contract_period?: Maybe<Scalars['Float']>;
  customer_life_time_value?: Maybe<Scalars['Float']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['Float']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['Float']>;
  customers_profit_for_previous_year?: Maybe<Scalars['Float']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  no_of_employees?: Maybe<Scalars['Float']>;
  payment_terms_in_days?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "customer" */
export type Customer_Avg_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "customer". All fields are combined with a logical 'AND'. */
export type Customer_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Bool_Exp>>;
  _not?: InputMaybe<Customer_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Bool_Exp>>;
  account_category?: InputMaybe<String_Comparison_Exp>;
  account_creation_date?: InputMaybe<Date_Comparison_Exp>;
  account_currency?: InputMaybe<String_Comparison_Exp>;
  account_deactivation_date?: InputMaybe<Date_Comparison_Exp>;
  account_legal_name?: InputMaybe<String_Comparison_Exp>;
  account_manager?: InputMaybe<Owner_Bool_Exp>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  actual_revenue_cummulative_origin?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
  ad_revenue_model?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<Company_Address_Bool_Exp>;
  ads_plus_customer_contacts?: InputMaybe<Ads_Plus_Customer_Contacts_Bool_Exp>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  amagi_now?: InputMaybe<String_Comparison_Exp>;
  amagi_now_url?: InputMaybe<String_Comparison_Exp>;
  avg_service_availibity?: InputMaybe<Fn_Return_Avg_Service_Availibity_Bool_Exp>;
  bill_contact?: InputMaybe<Contact_Bool_Exp>;
  bill_to_contact?: InputMaybe<String_Comparison_Exp>;
  billed_revenue_cummulative_origin?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
  billing_address?: InputMaybe<Jsonb_Comparison_Exp>;
  billing_contact?: InputMaybe<Jsonb_Comparison_Exp>;
  billing_term?: InputMaybe<String_Comparison_Exp>;
  billing_type?: InputMaybe<String_Comparison_Exp>;
  booked_revenue_cummulative_origin?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
  business_category?: InputMaybe<String_Comparison_Exp>;
  c_plus_percentage_share?: InputMaybe<Numeric_Comparison_Exp>;
  cases?: InputMaybe<Case_Bool_Exp>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Bool_Exp>;
  cdpderived_revenue_segment?: InputMaybe<String_Comparison_Exp>;
  channel_deliveries?: InputMaybe<Fn_Return_Deliveries_Count_Bool_Exp>;
  channels?: InputMaybe<Channel_Bool_Exp>;
  channels_aggregate?: InputMaybe<Channel_Aggregate_Bool_Exp>;
  children?: InputMaybe<Customer_Bool_Exp>;
  children_aggregate?: InputMaybe<Customer_Aggregate_Bool_Exp>;
  churn_requested_by?: InputMaybe<String_Comparison_Exp>;
  churn_risk_percentage?: InputMaybe<Numeric_Comparison_Exp>;
  cloud_region?: InputMaybe<Jsonb_Comparison_Exp>;
  cloud_service_provider?: InputMaybe<Jsonb_Comparison_Exp>;
  cloudport?: InputMaybe<String_Comparison_Exp>;
  cloudport_url?: InputMaybe<String_Comparison_Exp>;
  cloudport_urls?: InputMaybe<Cloudport_Bool_Exp>;
  combined_credit_memos?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
  combined_invoices?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
  combined_receipts?: InputMaybe<Fn_Return_Combined_Receipt_Bool_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  company_category?: InputMaybe<String_Comparison_Exp>;
  connect_msa_effective_date?: InputMaybe<Date_Comparison_Exp>;
  contacts?: InputMaybe<Contact_Bool_Exp>;
  contacts_aggregate?: InputMaybe<Contact_Aggregate_Bool_Exp>;
  content_plus_contacts?: InputMaybe<Content_Plus_Contacts_Bool_Exp>;
  contract_terms?: InputMaybe<Customer_Contract_Terms_Bool_Exp>;
  cplus_msa_effective_date?: InputMaybe<Date_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_memos?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
  credit_period_in_days?: InputMaybe<String_Comparison_Exp>;
  credit_score?: InputMaybe<Numeric_Comparison_Exp>;
  csm?: InputMaybe<Owner_Bool_Exp>;
  customer_business_model?: InputMaybe<String_Comparison_Exp>;
  customer_contract_period?: InputMaybe<Numeric_Comparison_Exp>;
  customer_financial_risk_category?: InputMaybe<String_Comparison_Exp>;
  customer_life_time_value?: InputMaybe<Numeric_Comparison_Exp>;
  customer_origin?: InputMaybe<String_Comparison_Exp>;
  customer_revenue_for_previous_year?: InputMaybe<Numeric_Comparison_Exp>;
  customer_revenue_for_the_present_year?: InputMaybe<Numeric_Comparison_Exp>;
  customer_scale?: InputMaybe<String_Comparison_Exp>;
  customer_since_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer_tier?: InputMaybe<String_Comparison_Exp>;
  customer_type?: InputMaybe<String_Comparison_Exp>;
  customers_profit_for_previous_year?: InputMaybe<Numeric_Comparison_Exp>;
  customers_profit_for_the_present_year?: InputMaybe<Numeric_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dso?: InputMaybe<String_Comparison_Exp>;
  first_invoice_date?: InputMaybe<Date_Comparison_Exp>;
  freshdesk?: InputMaybe<Freshdesk_Company_Bool_Exp>;
  industry_segment?: InputMaybe<String_Comparison_Exp>;
  invoices?: InputMaybe<Invoice_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Bool_Exp>;
  invoicing_currency?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_msa_ratecard_customer?: InputMaybe<Boolean_Comparison_Exp>;
  is_ono?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  latest_arr?: InputMaybe<Fn_Return_Latest_Mrr_Bool_Exp>;
  latest_mrr?: InputMaybe<Fn_Return_Latest_Mrr_Bool_Exp>;
  legal_entity?: InputMaybe<Legal_Entity_Bool_Exp>;
  legal_entity_id?: InputMaybe<String_Comparison_Exp>;
  legal_entity_name?: InputMaybe<String_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  media_industry_sub_segment?: InputMaybe<Media_Industry_Sub_Segment_Bool_Exp>;
  monetization_preference?: InputMaybe<String_Comparison_Exp>;
  msa_effective_date?: InputMaybe<Date_Comparison_Exp>;
  netsuite_credit_issued_cummulative_origin?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
  netsuite_id?: InputMaybe<Numeric_Comparison_Exp>;
  netsuite_invoice_revenue?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
  netsuite_receipts?: InputMaybe<Netsuite_Receipt_Bool_Exp>;
  netsuite_receipts_aggregate?: InputMaybe<Netsuite_Receipt_Aggregate_Bool_Exp>;
  netsuite_transactions?: InputMaybe<Netsuite_Transaction_Bool_Exp>;
  netsuite_transactions_aggregate?: InputMaybe<Netsuite_Transaction_Aggregate_Bool_Exp>;
  no_of_employees?: InputMaybe<Numeric_Comparison_Exp>;
  onboarding_customer_contacts?: InputMaybe<Onboarding_Customer_Contacts_Bool_Exp>;
  opportunity?: InputMaybe<Opportunity_Bool_Exp>;
  opportunity_aggregate?: InputMaybe<Opportunity_Aggregate_Bool_Exp>;
  orders?: InputMaybe<Order_Bool_Exp>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Bool_Exp>;
  owner?: InputMaybe<Owner_Bool_Exp>;
  parent?: InputMaybe<Customer_Bool_Exp>;
  payment_due_on_receipt?: InputMaybe<Boolean_Comparison_Exp>;
  payment_terms?: InputMaybe<String_Comparison_Exp>;
  payment_terms_in_days?: InputMaybe<Numeric_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  planner?: InputMaybe<String_Comparison_Exp>;
  planner_url?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<Platform_Bool_Exp>;
  platform_aggregate?: InputMaybe<Platform_Aggregate_Bool_Exp>;
  platform_tier?: InputMaybe<String_Comparison_Exp>;
  preferred_payment_channel?: InputMaybe<String_Comparison_Exp>;
  product_revenue_invoice?: InputMaybe<Fn_Return_Product_Financial_Graph_Bool_Exp>;
  product_url?: InputMaybe<Customer_Product_Url_Bool_Exp>;
  quotes?: InputMaybe<Quote_Bool_Exp>;
  quotes_aggregate?: InputMaybe<Quote_Aggregate_Bool_Exp>;
  record_type?: InputMaybe<Record_Type_Bool_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  revenue_group_1?: InputMaybe<String_Comparison_Exp>;
  revenue_group_2?: InputMaybe<String_Comparison_Exp>;
  sales?: InputMaybe<Fn_Return_Sales_Response_Bool_Exp>;
  salesforce_accountmanager_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_csm_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_geohead_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_owner_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_parent_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_record_type_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_salesrep_id?: InputMaybe<String_Comparison_Exp>;
  segment?: InputMaybe<Segment_Bool_Exp>;
  self_service_access?: InputMaybe<String_Comparison_Exp>;
  service_tier?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tam?: InputMaybe<String_Comparison_Exp>;
  thunderstorm?: InputMaybe<String_Comparison_Exp>;
  thunderstorm_url?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vod_deliveries?: InputMaybe<Fn_Return_Deliveries_Count_Bool_Exp>;
};

export type Customer_By_Amagi_Id_Args = {
  _amagi_id?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "customer_contract_terms" */
export type Customer_Contract_Terms = {
  __typename?: 'customer_contract_terms';
  billing_date_rule?: Maybe<Scalars['String']>;
  billing_threshold_rule?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  deposit_amount_mrr_months?: Maybe<Scalars['numeric']>;
  entitled_to_stop_services_after?: Maybe<Scalars['String']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['numeric']>;
  msa_effective_date?: Maybe<Scalars['date']>;
  order_initial_term?: Maybe<Scalars['numeric']>;
  order_renewal_term?: Maybe<Scalars['numeric']>;
  payment_term_for_terminated_services?: Maybe<Scalars['numeric']>;
  payment_terms?: Maybe<Scalars['String']>;
  price_escalation?: Maybe<Scalars['String']>;
  price_escalation_period?: Maybe<Scalars['numeric']>;
  salesforce_id?: Maybe<Scalars['String']>;
  security_deposit?: Maybe<Scalars['String']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['numeric']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['numeric']>;
  termination_due_to_platform_notice?: Maybe<Scalars['numeric']>;
  yearly_escalation_percentage?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "customer_contract_terms" */
export type Customer_Contract_Terms_Aggregate = {
  __typename?: 'customer_contract_terms_aggregate';
  aggregate?: Maybe<Customer_Contract_Terms_Aggregate_Fields>;
  nodes: Array<Customer_Contract_Terms>;
};

/** aggregate fields of "customer_contract_terms" */
export type Customer_Contract_Terms_Aggregate_Fields = {
  __typename?: 'customer_contract_terms_aggregate_fields';
  avg?: Maybe<Customer_Contract_Terms_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Customer_Contract_Terms_Max_Fields>;
  min?: Maybe<Customer_Contract_Terms_Min_Fields>;
  stddev?: Maybe<Customer_Contract_Terms_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Contract_Terms_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Contract_Terms_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Contract_Terms_Sum_Fields>;
  var_pop?: Maybe<Customer_Contract_Terms_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Contract_Terms_Var_Samp_Fields>;
  variance?: Maybe<Customer_Contract_Terms_Variance_Fields>;
};


/** aggregate fields of "customer_contract_terms" */
export type Customer_Contract_Terms_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Contract_Terms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Customer_Contract_Terms_Avg_Fields = {
  __typename?: 'customer_contract_terms_avg_fields';
  deposit_amount_mrr_months?: Maybe<Scalars['Float']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['Float']>;
  order_initial_term?: Maybe<Scalars['Float']>;
  order_renewal_term?: Maybe<Scalars['Float']>;
  payment_term_for_terminated_services?: Maybe<Scalars['Float']>;
  price_escalation_period?: Maybe<Scalars['Float']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['Float']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['Float']>;
  termination_due_to_platform_notice?: Maybe<Scalars['Float']>;
  yearly_escalation_percentage?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "customer_contract_terms". All fields are combined with a logical 'AND'. */
export type Customer_Contract_Terms_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Contract_Terms_Bool_Exp>>;
  _not?: InputMaybe<Customer_Contract_Terms_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Contract_Terms_Bool_Exp>>;
  billing_date_rule?: InputMaybe<String_Comparison_Exp>;
  billing_threshold_rule?: InputMaybe<String_Comparison_Exp>;
  billing_type?: InputMaybe<String_Comparison_Exp>;
  deposit_amount_mrr_months?: InputMaybe<Numeric_Comparison_Exp>;
  entitled_to_stop_services_after?: InputMaybe<String_Comparison_Exp>;
  interest_percent_applicable_post_due_date?: InputMaybe<Numeric_Comparison_Exp>;
  msa_effective_date?: InputMaybe<Date_Comparison_Exp>;
  order_initial_term?: InputMaybe<Numeric_Comparison_Exp>;
  order_renewal_term?: InputMaybe<Numeric_Comparison_Exp>;
  payment_term_for_terminated_services?: InputMaybe<Numeric_Comparison_Exp>;
  payment_terms?: InputMaybe<String_Comparison_Exp>;
  price_escalation?: InputMaybe<String_Comparison_Exp>;
  price_escalation_period?: InputMaybe<Numeric_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  security_deposit?: InputMaybe<String_Comparison_Exp>;
  so_cancel_notice_after_oit?: InputMaybe<Numeric_Comparison_Exp>;
  so_cancel_notice_during_oit?: InputMaybe<Numeric_Comparison_Exp>;
  termination_due_to_platform_notice?: InputMaybe<Numeric_Comparison_Exp>;
  yearly_escalation_percentage?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Customer_Contract_Terms_Max_Fields = {
  __typename?: 'customer_contract_terms_max_fields';
  billing_date_rule?: Maybe<Scalars['String']>;
  billing_threshold_rule?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  deposit_amount_mrr_months?: Maybe<Scalars['numeric']>;
  entitled_to_stop_services_after?: Maybe<Scalars['String']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['numeric']>;
  msa_effective_date?: Maybe<Scalars['date']>;
  order_initial_term?: Maybe<Scalars['numeric']>;
  order_renewal_term?: Maybe<Scalars['numeric']>;
  payment_term_for_terminated_services?: Maybe<Scalars['numeric']>;
  payment_terms?: Maybe<Scalars['String']>;
  price_escalation?: Maybe<Scalars['String']>;
  price_escalation_period?: Maybe<Scalars['numeric']>;
  salesforce_id?: Maybe<Scalars['String']>;
  security_deposit?: Maybe<Scalars['String']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['numeric']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['numeric']>;
  termination_due_to_platform_notice?: Maybe<Scalars['numeric']>;
  yearly_escalation_percentage?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Customer_Contract_Terms_Min_Fields = {
  __typename?: 'customer_contract_terms_min_fields';
  billing_date_rule?: Maybe<Scalars['String']>;
  billing_threshold_rule?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  deposit_amount_mrr_months?: Maybe<Scalars['numeric']>;
  entitled_to_stop_services_after?: Maybe<Scalars['String']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['numeric']>;
  msa_effective_date?: Maybe<Scalars['date']>;
  order_initial_term?: Maybe<Scalars['numeric']>;
  order_renewal_term?: Maybe<Scalars['numeric']>;
  payment_term_for_terminated_services?: Maybe<Scalars['numeric']>;
  payment_terms?: Maybe<Scalars['String']>;
  price_escalation?: Maybe<Scalars['String']>;
  price_escalation_period?: Maybe<Scalars['numeric']>;
  salesforce_id?: Maybe<Scalars['String']>;
  security_deposit?: Maybe<Scalars['String']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['numeric']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['numeric']>;
  termination_due_to_platform_notice?: Maybe<Scalars['numeric']>;
  yearly_escalation_percentage?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "customer_contract_terms". */
export type Customer_Contract_Terms_Order_By = {
  billing_date_rule?: InputMaybe<Order_By>;
  billing_threshold_rule?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  deposit_amount_mrr_months?: InputMaybe<Order_By>;
  entitled_to_stop_services_after?: InputMaybe<Order_By>;
  interest_percent_applicable_post_due_date?: InputMaybe<Order_By>;
  msa_effective_date?: InputMaybe<Order_By>;
  order_initial_term?: InputMaybe<Order_By>;
  order_renewal_term?: InputMaybe<Order_By>;
  payment_term_for_terminated_services?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  price_escalation?: InputMaybe<Order_By>;
  price_escalation_period?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  security_deposit?: InputMaybe<Order_By>;
  so_cancel_notice_after_oit?: InputMaybe<Order_By>;
  so_cancel_notice_during_oit?: InputMaybe<Order_By>;
  termination_due_to_platform_notice?: InputMaybe<Order_By>;
  yearly_escalation_percentage?: InputMaybe<Order_By>;
};

/** select columns of table "customer_contract_terms" */
export enum Customer_Contract_Terms_Select_Column {
  /** column name */
  BillingDateRule = 'billing_date_rule',
  /** column name */
  BillingThresholdRule = 'billing_threshold_rule',
  /** column name */
  BillingType = 'billing_type',
  /** column name */
  DepositAmountMrrMonths = 'deposit_amount_mrr_months',
  /** column name */
  EntitledToStopServicesAfter = 'entitled_to_stop_services_after',
  /** column name */
  InterestPercentApplicablePostDueDate = 'interest_percent_applicable_post_due_date',
  /** column name */
  MsaEffectiveDate = 'msa_effective_date',
  /** column name */
  OrderInitialTerm = 'order_initial_term',
  /** column name */
  OrderRenewalTerm = 'order_renewal_term',
  /** column name */
  PaymentTermForTerminatedServices = 'payment_term_for_terminated_services',
  /** column name */
  PaymentTerms = 'payment_terms',
  /** column name */
  PriceEscalation = 'price_escalation',
  /** column name */
  PriceEscalationPeriod = 'price_escalation_period',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SecurityDeposit = 'security_deposit',
  /** column name */
  SoCancelNoticeAfterOit = 'so_cancel_notice_after_oit',
  /** column name */
  SoCancelNoticeDuringOit = 'so_cancel_notice_during_oit',
  /** column name */
  TerminationDueToPlatformNotice = 'termination_due_to_platform_notice',
  /** column name */
  YearlyEscalationPercentage = 'yearly_escalation_percentage'
}

/** aggregate stddev on columns */
export type Customer_Contract_Terms_Stddev_Fields = {
  __typename?: 'customer_contract_terms_stddev_fields';
  deposit_amount_mrr_months?: Maybe<Scalars['Float']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['Float']>;
  order_initial_term?: Maybe<Scalars['Float']>;
  order_renewal_term?: Maybe<Scalars['Float']>;
  payment_term_for_terminated_services?: Maybe<Scalars['Float']>;
  price_escalation_period?: Maybe<Scalars['Float']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['Float']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['Float']>;
  termination_due_to_platform_notice?: Maybe<Scalars['Float']>;
  yearly_escalation_percentage?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Customer_Contract_Terms_Stddev_Pop_Fields = {
  __typename?: 'customer_contract_terms_stddev_pop_fields';
  deposit_amount_mrr_months?: Maybe<Scalars['Float']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['Float']>;
  order_initial_term?: Maybe<Scalars['Float']>;
  order_renewal_term?: Maybe<Scalars['Float']>;
  payment_term_for_terminated_services?: Maybe<Scalars['Float']>;
  price_escalation_period?: Maybe<Scalars['Float']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['Float']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['Float']>;
  termination_due_to_platform_notice?: Maybe<Scalars['Float']>;
  yearly_escalation_percentage?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Customer_Contract_Terms_Stddev_Samp_Fields = {
  __typename?: 'customer_contract_terms_stddev_samp_fields';
  deposit_amount_mrr_months?: Maybe<Scalars['Float']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['Float']>;
  order_initial_term?: Maybe<Scalars['Float']>;
  order_renewal_term?: Maybe<Scalars['Float']>;
  payment_term_for_terminated_services?: Maybe<Scalars['Float']>;
  price_escalation_period?: Maybe<Scalars['Float']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['Float']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['Float']>;
  termination_due_to_platform_notice?: Maybe<Scalars['Float']>;
  yearly_escalation_percentage?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "customer_contract_terms" */
export type Customer_Contract_Terms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Contract_Terms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Contract_Terms_Stream_Cursor_Value_Input = {
  billing_date_rule?: InputMaybe<Scalars['String']>;
  billing_threshold_rule?: InputMaybe<Scalars['String']>;
  billing_type?: InputMaybe<Scalars['String']>;
  deposit_amount_mrr_months?: InputMaybe<Scalars['numeric']>;
  entitled_to_stop_services_after?: InputMaybe<Scalars['String']>;
  interest_percent_applicable_post_due_date?: InputMaybe<Scalars['numeric']>;
  msa_effective_date?: InputMaybe<Scalars['date']>;
  order_initial_term?: InputMaybe<Scalars['numeric']>;
  order_renewal_term?: InputMaybe<Scalars['numeric']>;
  payment_term_for_terminated_services?: InputMaybe<Scalars['numeric']>;
  payment_terms?: InputMaybe<Scalars['String']>;
  price_escalation?: InputMaybe<Scalars['String']>;
  price_escalation_period?: InputMaybe<Scalars['numeric']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  security_deposit?: InputMaybe<Scalars['String']>;
  so_cancel_notice_after_oit?: InputMaybe<Scalars['numeric']>;
  so_cancel_notice_during_oit?: InputMaybe<Scalars['numeric']>;
  termination_due_to_platform_notice?: InputMaybe<Scalars['numeric']>;
  yearly_escalation_percentage?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Customer_Contract_Terms_Sum_Fields = {
  __typename?: 'customer_contract_terms_sum_fields';
  deposit_amount_mrr_months?: Maybe<Scalars['numeric']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['numeric']>;
  order_initial_term?: Maybe<Scalars['numeric']>;
  order_renewal_term?: Maybe<Scalars['numeric']>;
  payment_term_for_terminated_services?: Maybe<Scalars['numeric']>;
  price_escalation_period?: Maybe<Scalars['numeric']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['numeric']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['numeric']>;
  termination_due_to_platform_notice?: Maybe<Scalars['numeric']>;
  yearly_escalation_percentage?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Customer_Contract_Terms_Var_Pop_Fields = {
  __typename?: 'customer_contract_terms_var_pop_fields';
  deposit_amount_mrr_months?: Maybe<Scalars['Float']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['Float']>;
  order_initial_term?: Maybe<Scalars['Float']>;
  order_renewal_term?: Maybe<Scalars['Float']>;
  payment_term_for_terminated_services?: Maybe<Scalars['Float']>;
  price_escalation_period?: Maybe<Scalars['Float']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['Float']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['Float']>;
  termination_due_to_platform_notice?: Maybe<Scalars['Float']>;
  yearly_escalation_percentage?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Customer_Contract_Terms_Var_Samp_Fields = {
  __typename?: 'customer_contract_terms_var_samp_fields';
  deposit_amount_mrr_months?: Maybe<Scalars['Float']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['Float']>;
  order_initial_term?: Maybe<Scalars['Float']>;
  order_renewal_term?: Maybe<Scalars['Float']>;
  payment_term_for_terminated_services?: Maybe<Scalars['Float']>;
  price_escalation_period?: Maybe<Scalars['Float']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['Float']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['Float']>;
  termination_due_to_platform_notice?: Maybe<Scalars['Float']>;
  yearly_escalation_percentage?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Customer_Contract_Terms_Variance_Fields = {
  __typename?: 'customer_contract_terms_variance_fields';
  deposit_amount_mrr_months?: Maybe<Scalars['Float']>;
  interest_percent_applicable_post_due_date?: Maybe<Scalars['Float']>;
  order_initial_term?: Maybe<Scalars['Float']>;
  order_renewal_term?: Maybe<Scalars['Float']>;
  payment_term_for_terminated_services?: Maybe<Scalars['Float']>;
  price_escalation_period?: Maybe<Scalars['Float']>;
  so_cancel_notice_after_oit?: Maybe<Scalars['Float']>;
  so_cancel_notice_during_oit?: Maybe<Scalars['Float']>;
  termination_due_to_platform_notice?: Maybe<Scalars['Float']>;
  yearly_escalation_percentage?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Customer_Max_Fields = {
  __typename?: 'customer_max_fields';
  account_category?: Maybe<Scalars['String']>;
  account_creation_date?: Maybe<Scalars['date']>;
  account_currency?: Maybe<Scalars['String']>;
  account_deactivation_date?: Maybe<Scalars['date']>;
  account_legal_name?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  ad_revenue_model?: Maybe<Scalars['String']>;
  amagi_id?: Maybe<Scalars['String']>;
  amagi_now?: Maybe<Scalars['String']>;
  amagi_now_url?: Maybe<Scalars['String']>;
  bill_to_contact?: Maybe<Scalars['String']>;
  billing_term?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  business_category?: Maybe<Scalars['String']>;
  c_plus_percentage_share?: Maybe<Scalars['numeric']>;
  cdpderived_revenue_segment?: Maybe<Scalars['String']>;
  churn_requested_by?: Maybe<Scalars['String']>;
  churn_risk_percentage?: Maybe<Scalars['numeric']>;
  cloudport?: Maybe<Scalars['String']>;
  cloudport_url?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  company_category?: Maybe<Scalars['String']>;
  connect_msa_effective_date?: Maybe<Scalars['date']>;
  cplus_msa_effective_date?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_period_in_days?: Maybe<Scalars['String']>;
  credit_score?: Maybe<Scalars['numeric']>;
  customer_business_model?: Maybe<Scalars['String']>;
  customer_contract_period?: Maybe<Scalars['numeric']>;
  customer_financial_risk_category?: Maybe<Scalars['String']>;
  customer_life_time_value?: Maybe<Scalars['numeric']>;
  customer_origin?: Maybe<Scalars['String']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['numeric']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['numeric']>;
  customer_scale?: Maybe<Scalars['String']>;
  customer_since_date?: Maybe<Scalars['timestamptz']>;
  customer_tier?: Maybe<Scalars['String']>;
  customer_type?: Maybe<Scalars['String']>;
  customers_profit_for_previous_year?: Maybe<Scalars['numeric']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  dso?: Maybe<Scalars['String']>;
  first_invoice_date?: Maybe<Scalars['date']>;
  industry_segment?: Maybe<Scalars['String']>;
  invoicing_currency?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  legal_entity_id?: Maybe<Scalars['String']>;
  legal_entity_name?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  monetization_preference?: Maybe<Scalars['String']>;
  msa_effective_date?: Maybe<Scalars['date']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  no_of_employees?: Maybe<Scalars['numeric']>;
  payment_terms?: Maybe<Scalars['String']>;
  payment_terms_in_days?: Maybe<Scalars['numeric']>;
  phone?: Maybe<Scalars['String']>;
  planner?: Maybe<Scalars['String']>;
  planner_url?: Maybe<Scalars['String']>;
  platform_tier?: Maybe<Scalars['String']>;
  preferred_payment_channel?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  revenue_group_1?: Maybe<Scalars['String']>;
  revenue_group_2?: Maybe<Scalars['String']>;
  salesforce_accountmanager_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_csm_id?: Maybe<Scalars['String']>;
  salesforce_geohead_id?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_parent_id?: Maybe<Scalars['String']>;
  salesforce_record_type_id?: Maybe<Scalars['String']>;
  salesforce_salesrep_id?: Maybe<Scalars['String']>;
  self_service_access?: Maybe<Scalars['String']>;
  service_tier?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tam?: Maybe<Scalars['String']>;
  thunderstorm?: Maybe<Scalars['String']>;
  thunderstorm_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "customer" */
export type Customer_Max_Order_By = {
  account_category?: InputMaybe<Order_By>;
  account_creation_date?: InputMaybe<Order_By>;
  account_currency?: InputMaybe<Order_By>;
  account_deactivation_date?: InputMaybe<Order_By>;
  account_legal_name?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  ad_revenue_model?: InputMaybe<Order_By>;
  amagi_id?: InputMaybe<Order_By>;
  amagi_now?: InputMaybe<Order_By>;
  amagi_now_url?: InputMaybe<Order_By>;
  bill_to_contact?: InputMaybe<Order_By>;
  billing_term?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  business_category?: InputMaybe<Order_By>;
  c_plus_percentage_share?: InputMaybe<Order_By>;
  cdpderived_revenue_segment?: InputMaybe<Order_By>;
  churn_requested_by?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  cloudport?: InputMaybe<Order_By>;
  cloudport_url?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  company_category?: InputMaybe<Order_By>;
  connect_msa_effective_date?: InputMaybe<Order_By>;
  cplus_msa_effective_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_period_in_days?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_business_model?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_financial_risk_category?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_origin?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customer_scale?: InputMaybe<Order_By>;
  customer_since_date?: InputMaybe<Order_By>;
  customer_tier?: InputMaybe<Order_By>;
  customer_type?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dso?: InputMaybe<Order_By>;
  first_invoice_date?: InputMaybe<Order_By>;
  industry_segment?: InputMaybe<Order_By>;
  invoicing_currency?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  legal_entity_id?: InputMaybe<Order_By>;
  legal_entity_name?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  monetization_preference?: InputMaybe<Order_By>;
  msa_effective_date?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  planner?: InputMaybe<Order_By>;
  planner_url?: InputMaybe<Order_By>;
  platform_tier?: InputMaybe<Order_By>;
  preferred_payment_channel?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  revenue_group_1?: InputMaybe<Order_By>;
  revenue_group_2?: InputMaybe<Order_By>;
  salesforce_accountmanager_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_csm_id?: InputMaybe<Order_By>;
  salesforce_geohead_id?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_parent_id?: InputMaybe<Order_By>;
  salesforce_record_type_id?: InputMaybe<Order_By>;
  salesforce_salesrep_id?: InputMaybe<Order_By>;
  self_service_access?: InputMaybe<Order_By>;
  service_tier?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tam?: InputMaybe<Order_By>;
  thunderstorm?: InputMaybe<Order_By>;
  thunderstorm_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Customer_Min_Fields = {
  __typename?: 'customer_min_fields';
  account_category?: Maybe<Scalars['String']>;
  account_creation_date?: Maybe<Scalars['date']>;
  account_currency?: Maybe<Scalars['String']>;
  account_deactivation_date?: Maybe<Scalars['date']>;
  account_legal_name?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  ad_revenue_model?: Maybe<Scalars['String']>;
  amagi_id?: Maybe<Scalars['String']>;
  amagi_now?: Maybe<Scalars['String']>;
  amagi_now_url?: Maybe<Scalars['String']>;
  bill_to_contact?: Maybe<Scalars['String']>;
  billing_term?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  business_category?: Maybe<Scalars['String']>;
  c_plus_percentage_share?: Maybe<Scalars['numeric']>;
  cdpderived_revenue_segment?: Maybe<Scalars['String']>;
  churn_requested_by?: Maybe<Scalars['String']>;
  churn_risk_percentage?: Maybe<Scalars['numeric']>;
  cloudport?: Maybe<Scalars['String']>;
  cloudport_url?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  company_category?: Maybe<Scalars['String']>;
  connect_msa_effective_date?: Maybe<Scalars['date']>;
  cplus_msa_effective_date?: Maybe<Scalars['date']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credit_period_in_days?: Maybe<Scalars['String']>;
  credit_score?: Maybe<Scalars['numeric']>;
  customer_business_model?: Maybe<Scalars['String']>;
  customer_contract_period?: Maybe<Scalars['numeric']>;
  customer_financial_risk_category?: Maybe<Scalars['String']>;
  customer_life_time_value?: Maybe<Scalars['numeric']>;
  customer_origin?: Maybe<Scalars['String']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['numeric']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['numeric']>;
  customer_scale?: Maybe<Scalars['String']>;
  customer_since_date?: Maybe<Scalars['timestamptz']>;
  customer_tier?: Maybe<Scalars['String']>;
  customer_type?: Maybe<Scalars['String']>;
  customers_profit_for_previous_year?: Maybe<Scalars['numeric']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  dso?: Maybe<Scalars['String']>;
  first_invoice_date?: Maybe<Scalars['date']>;
  industry_segment?: Maybe<Scalars['String']>;
  invoicing_currency?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  legal_entity_id?: Maybe<Scalars['String']>;
  legal_entity_name?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  monetization_preference?: Maybe<Scalars['String']>;
  msa_effective_date?: Maybe<Scalars['date']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  no_of_employees?: Maybe<Scalars['numeric']>;
  payment_terms?: Maybe<Scalars['String']>;
  payment_terms_in_days?: Maybe<Scalars['numeric']>;
  phone?: Maybe<Scalars['String']>;
  planner?: Maybe<Scalars['String']>;
  planner_url?: Maybe<Scalars['String']>;
  platform_tier?: Maybe<Scalars['String']>;
  preferred_payment_channel?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  revenue_group_1?: Maybe<Scalars['String']>;
  revenue_group_2?: Maybe<Scalars['String']>;
  salesforce_accountmanager_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_csm_id?: Maybe<Scalars['String']>;
  salesforce_geohead_id?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_parent_id?: Maybe<Scalars['String']>;
  salesforce_record_type_id?: Maybe<Scalars['String']>;
  salesforce_salesrep_id?: Maybe<Scalars['String']>;
  self_service_access?: Maybe<Scalars['String']>;
  service_tier?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tam?: Maybe<Scalars['String']>;
  thunderstorm?: Maybe<Scalars['String']>;
  thunderstorm_url?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "customer" */
export type Customer_Min_Order_By = {
  account_category?: InputMaybe<Order_By>;
  account_creation_date?: InputMaybe<Order_By>;
  account_currency?: InputMaybe<Order_By>;
  account_deactivation_date?: InputMaybe<Order_By>;
  account_legal_name?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  ad_revenue_model?: InputMaybe<Order_By>;
  amagi_id?: InputMaybe<Order_By>;
  amagi_now?: InputMaybe<Order_By>;
  amagi_now_url?: InputMaybe<Order_By>;
  bill_to_contact?: InputMaybe<Order_By>;
  billing_term?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  business_category?: InputMaybe<Order_By>;
  c_plus_percentage_share?: InputMaybe<Order_By>;
  cdpderived_revenue_segment?: InputMaybe<Order_By>;
  churn_requested_by?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  cloudport?: InputMaybe<Order_By>;
  cloudport_url?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  company_category?: InputMaybe<Order_By>;
  connect_msa_effective_date?: InputMaybe<Order_By>;
  cplus_msa_effective_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_period_in_days?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_business_model?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_financial_risk_category?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_origin?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customer_scale?: InputMaybe<Order_By>;
  customer_since_date?: InputMaybe<Order_By>;
  customer_tier?: InputMaybe<Order_By>;
  customer_type?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dso?: InputMaybe<Order_By>;
  first_invoice_date?: InputMaybe<Order_By>;
  industry_segment?: InputMaybe<Order_By>;
  invoicing_currency?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  legal_entity_id?: InputMaybe<Order_By>;
  legal_entity_name?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  monetization_preference?: InputMaybe<Order_By>;
  msa_effective_date?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  planner?: InputMaybe<Order_By>;
  planner_url?: InputMaybe<Order_By>;
  platform_tier?: InputMaybe<Order_By>;
  preferred_payment_channel?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  revenue_group_1?: InputMaybe<Order_By>;
  revenue_group_2?: InputMaybe<Order_By>;
  salesforce_accountmanager_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_csm_id?: InputMaybe<Order_By>;
  salesforce_geohead_id?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_parent_id?: InputMaybe<Order_By>;
  salesforce_record_type_id?: InputMaybe<Order_By>;
  salesforce_salesrep_id?: InputMaybe<Order_By>;
  self_service_access?: InputMaybe<Order_By>;
  service_tier?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tam?: InputMaybe<Order_By>;
  thunderstorm?: InputMaybe<Order_By>;
  thunderstorm_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "customer". */
export type Customer_Order_By = {
  account_category?: InputMaybe<Order_By>;
  account_creation_date?: InputMaybe<Order_By>;
  account_currency?: InputMaybe<Order_By>;
  account_deactivation_date?: InputMaybe<Order_By>;
  account_legal_name?: InputMaybe<Order_By>;
  account_manager?: InputMaybe<Owner_Order_By>;
  account_name?: InputMaybe<Order_By>;
  actual_revenue_cummulative_origin_aggregate?: InputMaybe<Fn_Return_Financial_Graph_Aggregate_Order_By>;
  ad_revenue_model?: InputMaybe<Order_By>;
  address?: InputMaybe<Company_Address_Order_By>;
  ads_plus_customer_contacts?: InputMaybe<Ads_Plus_Customer_Contacts_Order_By>;
  amagi_id?: InputMaybe<Order_By>;
  amagi_now?: InputMaybe<Order_By>;
  amagi_now_url?: InputMaybe<Order_By>;
  avg_service_availibity_aggregate?: InputMaybe<Fn_Return_Avg_Service_Availibity_Aggregate_Order_By>;
  bill_contact?: InputMaybe<Contact_Order_By>;
  bill_to_contact?: InputMaybe<Order_By>;
  billed_revenue_cummulative_origin_aggregate?: InputMaybe<Fn_Return_Financial_Graph_Aggregate_Order_By>;
  billing_address?: InputMaybe<Order_By>;
  billing_contact?: InputMaybe<Order_By>;
  billing_term?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  booked_revenue_cummulative_origin_aggregate?: InputMaybe<Fn_Return_Financial_Graph_Aggregate_Order_By>;
  business_category?: InputMaybe<Order_By>;
  c_plus_percentage_share?: InputMaybe<Order_By>;
  cases_aggregate?: InputMaybe<Case_Aggregate_Order_By>;
  cdpderived_revenue_segment?: InputMaybe<Order_By>;
  channel_deliveries_aggregate?: InputMaybe<Fn_Return_Deliveries_Count_Aggregate_Order_By>;
  channels_aggregate?: InputMaybe<Channel_Aggregate_Order_By>;
  children_aggregate?: InputMaybe<Customer_Aggregate_Order_By>;
  churn_requested_by?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  cloud_region?: InputMaybe<Order_By>;
  cloud_service_provider?: InputMaybe<Order_By>;
  cloudport?: InputMaybe<Order_By>;
  cloudport_url?: InputMaybe<Order_By>;
  cloudport_urls_aggregate?: InputMaybe<Cloudport_Aggregate_Order_By>;
  combined_credit_memos_aggregate?: InputMaybe<Fn_Return_Combined_Invoice_Aggregate_Order_By>;
  combined_invoices_aggregate?: InputMaybe<Fn_Return_Combined_Invoice_Aggregate_Order_By>;
  combined_receipts_aggregate?: InputMaybe<Fn_Return_Combined_Receipt_Aggregate_Order_By>;
  comments?: InputMaybe<Order_By>;
  company_category?: InputMaybe<Order_By>;
  connect_msa_effective_date?: InputMaybe<Order_By>;
  contacts_aggregate?: InputMaybe<Contact_Aggregate_Order_By>;
  content_plus_contacts?: InputMaybe<Content_Plus_Contacts_Order_By>;
  contract_terms?: InputMaybe<Customer_Contract_Terms_Order_By>;
  cplus_msa_effective_date?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credit_memos_aggregate?: InputMaybe<Fn_Return_Combined_Invoice_Aggregate_Order_By>;
  credit_period_in_days?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  csm?: InputMaybe<Owner_Order_By>;
  customer_business_model?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_financial_risk_category?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_origin?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customer_scale?: InputMaybe<Order_By>;
  customer_since_date?: InputMaybe<Order_By>;
  customer_tier?: InputMaybe<Order_By>;
  customer_type?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dso?: InputMaybe<Order_By>;
  first_invoice_date?: InputMaybe<Order_By>;
  freshdesk?: InputMaybe<Freshdesk_Company_Order_By>;
  industry_segment?: InputMaybe<Order_By>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Order_By>;
  invoicing_currency?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_msa_ratecard_customer?: InputMaybe<Order_By>;
  is_ono?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  latest_arr_aggregate?: InputMaybe<Fn_Return_Latest_Mrr_Aggregate_Order_By>;
  latest_mrr_aggregate?: InputMaybe<Fn_Return_Latest_Mrr_Aggregate_Order_By>;
  legal_entity?: InputMaybe<Legal_Entity_Order_By>;
  legal_entity_id?: InputMaybe<Order_By>;
  legal_entity_name?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  media_industry_sub_segment?: InputMaybe<Media_Industry_Sub_Segment_Order_By>;
  monetization_preference?: InputMaybe<Order_By>;
  msa_effective_date?: InputMaybe<Order_By>;
  netsuite_credit_issued_cummulative_origin_aggregate?: InputMaybe<Fn_Return_Financial_Graph_Aggregate_Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  netsuite_invoice_revenue_aggregate?: InputMaybe<Fn_Return_Financial_Graph_Aggregate_Order_By>;
  netsuite_receipts_aggregate?: InputMaybe<Netsuite_Receipt_Aggregate_Order_By>;
  netsuite_transactions_aggregate?: InputMaybe<Netsuite_Transaction_Aggregate_Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  onboarding_customer_contacts?: InputMaybe<Onboarding_Customer_Contacts_Order_By>;
  opportunity_aggregate?: InputMaybe<Opportunity_Aggregate_Order_By>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Order_By>;
  owner?: InputMaybe<Owner_Order_By>;
  parent?: InputMaybe<Customer_Order_By>;
  payment_due_on_receipt?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  planner?: InputMaybe<Order_By>;
  planner_url?: InputMaybe<Order_By>;
  platform_aggregate?: InputMaybe<Platform_Aggregate_Order_By>;
  platform_tier?: InputMaybe<Order_By>;
  preferred_payment_channel?: InputMaybe<Order_By>;
  product_revenue_invoice_aggregate?: InputMaybe<Fn_Return_Product_Financial_Graph_Aggregate_Order_By>;
  product_url?: InputMaybe<Customer_Product_Url_Order_By>;
  quotes_aggregate?: InputMaybe<Quote_Aggregate_Order_By>;
  record_type?: InputMaybe<Record_Type_Order_By>;
  region?: InputMaybe<Order_By>;
  revenue_group_1?: InputMaybe<Order_By>;
  revenue_group_2?: InputMaybe<Order_By>;
  sales_aggregate?: InputMaybe<Fn_Return_Sales_Response_Aggregate_Order_By>;
  salesforce_accountmanager_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_csm_id?: InputMaybe<Order_By>;
  salesforce_geohead_id?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_parent_id?: InputMaybe<Order_By>;
  salesforce_record_type_id?: InputMaybe<Order_By>;
  salesforce_salesrep_id?: InputMaybe<Order_By>;
  segment?: InputMaybe<Segment_Order_By>;
  self_service_access?: InputMaybe<Order_By>;
  service_tier?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tam?: InputMaybe<Order_By>;
  thunderstorm?: InputMaybe<Order_By>;
  thunderstorm_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vod_deliveries_aggregate?: InputMaybe<Fn_Return_Deliveries_Count_Aggregate_Order_By>;
};

export type Customer_Product_By_Amagi_Id_Args = {
  customer_salesforce_id_or_amagi_id?: InputMaybe<Scalars['String']>;
};

export type Customer_Product_Purchased_By_Amagi_Id_Args = {
  customer_salesforce_id_or_amagi_id?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "customer_product_url" */
export type Customer_Product_Url = {
  __typename?: 'customer_product_url';
  amagi_now_url?: Maybe<Scalars['String']>;
  cloudport_urls?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  customer_product_url?: Maybe<Customer>;
  planner_url?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  thunderstorm_url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "customer_product_url" */
export type Customer_Product_UrlCloudport_UrlsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "customer_product_url" */
export type Customer_Product_Url_Aggregate = {
  __typename?: 'customer_product_url_aggregate';
  aggregate?: Maybe<Customer_Product_Url_Aggregate_Fields>;
  nodes: Array<Customer_Product_Url>;
};

/** aggregate fields of "customer_product_url" */
export type Customer_Product_Url_Aggregate_Fields = {
  __typename?: 'customer_product_url_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Customer_Product_Url_Max_Fields>;
  min?: Maybe<Customer_Product_Url_Min_Fields>;
};


/** aggregate fields of "customer_product_url" */
export type Customer_Product_Url_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Product_Url_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "customer_product_url". All fields are combined with a logical 'AND'. */
export type Customer_Product_Url_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Product_Url_Bool_Exp>>;
  _not?: InputMaybe<Customer_Product_Url_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Product_Url_Bool_Exp>>;
  amagi_now_url?: InputMaybe<String_Comparison_Exp>;
  cloudport_urls?: InputMaybe<Jsonb_Comparison_Exp>;
  customer_product_url?: InputMaybe<Customer_Bool_Exp>;
  planner_url?: InputMaybe<String_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  thunderstorm_url?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Customer_Product_Url_Max_Fields = {
  __typename?: 'customer_product_url_max_fields';
  amagi_now_url?: Maybe<Scalars['String']>;
  planner_url?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  thunderstorm_url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Customer_Product_Url_Min_Fields = {
  __typename?: 'customer_product_url_min_fields';
  amagi_now_url?: Maybe<Scalars['String']>;
  planner_url?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  thunderstorm_url?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "customer_product_url". */
export type Customer_Product_Url_Order_By = {
  amagi_now_url?: InputMaybe<Order_By>;
  cloudport_urls?: InputMaybe<Order_By>;
  customer_product_url?: InputMaybe<Customer_Order_By>;
  planner_url?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  thunderstorm_url?: InputMaybe<Order_By>;
};

/** select columns of table "customer_product_url" */
export enum Customer_Product_Url_Select_Column {
  /** column name */
  AmagiNowUrl = 'amagi_now_url',
  /** column name */
  CloudportUrls = 'cloudport_urls',
  /** column name */
  PlannerUrl = 'planner_url',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  ThunderstormUrl = 'thunderstorm_url'
}

/** Streaming cursor of the table "customer_product_url" */
export type Customer_Product_Url_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Product_Url_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Product_Url_Stream_Cursor_Value_Input = {
  amagi_now_url?: InputMaybe<Scalars['String']>;
  cloudport_urls?: InputMaybe<Scalars['jsonb']>;
  planner_url?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  thunderstorm_url?: InputMaybe<Scalars['String']>;
};

export type Customer_Region_Revenue_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "customer_revenue_segment" */
export type Customer_Revenue_Segment = {
  __typename?: 'customer_revenue_segment';
  flag?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  lower_bound?: Maybe<Scalars['numeric']>;
  updated_at: Scalars['timestamptz'];
  uppper_bound?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "customer_revenue_segment" */
export type Customer_Revenue_Segment_Aggregate = {
  __typename?: 'customer_revenue_segment_aggregate';
  aggregate?: Maybe<Customer_Revenue_Segment_Aggregate_Fields>;
  nodes: Array<Customer_Revenue_Segment>;
};

/** aggregate fields of "customer_revenue_segment" */
export type Customer_Revenue_Segment_Aggregate_Fields = {
  __typename?: 'customer_revenue_segment_aggregate_fields';
  avg?: Maybe<Customer_Revenue_Segment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Customer_Revenue_Segment_Max_Fields>;
  min?: Maybe<Customer_Revenue_Segment_Min_Fields>;
  stddev?: Maybe<Customer_Revenue_Segment_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Revenue_Segment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Revenue_Segment_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Revenue_Segment_Sum_Fields>;
  var_pop?: Maybe<Customer_Revenue_Segment_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Revenue_Segment_Var_Samp_Fields>;
  variance?: Maybe<Customer_Revenue_Segment_Variance_Fields>;
};


/** aggregate fields of "customer_revenue_segment" */
export type Customer_Revenue_Segment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Revenue_Segment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Customer_Revenue_Segment_Avg_Fields = {
  __typename?: 'customer_revenue_segment_avg_fields';
  lower_bound?: Maybe<Scalars['Float']>;
  uppper_bound?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "customer_revenue_segment". All fields are combined with a logical 'AND'. */
export type Customer_Revenue_Segment_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Revenue_Segment_Bool_Exp>>;
  _not?: InputMaybe<Customer_Revenue_Segment_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Revenue_Segment_Bool_Exp>>;
  flag?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_bound?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uppper_bound?: InputMaybe<Numeric_Comparison_Exp>;
};

/** columns and relationships of "customer_revenue_segment_data" */
export type Customer_Revenue_Segment_Data = {
  __typename?: 'customer_revenue_segment_data';
  amagi_id: Scalars['String'];
  average_mrr?: Maybe<Scalars['numeric']>;
  id: Scalars['uuid'];
};

/** aggregated selection of "customer_revenue_segment_data" */
export type Customer_Revenue_Segment_Data_Aggregate = {
  __typename?: 'customer_revenue_segment_data_aggregate';
  aggregate?: Maybe<Customer_Revenue_Segment_Data_Aggregate_Fields>;
  nodes: Array<Customer_Revenue_Segment_Data>;
};

/** aggregate fields of "customer_revenue_segment_data" */
export type Customer_Revenue_Segment_Data_Aggregate_Fields = {
  __typename?: 'customer_revenue_segment_data_aggregate_fields';
  avg?: Maybe<Customer_Revenue_Segment_Data_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Customer_Revenue_Segment_Data_Max_Fields>;
  min?: Maybe<Customer_Revenue_Segment_Data_Min_Fields>;
  stddev?: Maybe<Customer_Revenue_Segment_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Customer_Revenue_Segment_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Customer_Revenue_Segment_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Customer_Revenue_Segment_Data_Sum_Fields>;
  var_pop?: Maybe<Customer_Revenue_Segment_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Customer_Revenue_Segment_Data_Var_Samp_Fields>;
  variance?: Maybe<Customer_Revenue_Segment_Data_Variance_Fields>;
};


/** aggregate fields of "customer_revenue_segment_data" */
export type Customer_Revenue_Segment_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Customer_Revenue_Segment_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Customer_Revenue_Segment_Data_Avg_Fields = {
  __typename?: 'customer_revenue_segment_data_avg_fields';
  average_mrr?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "customer_revenue_segment_data". All fields are combined with a logical 'AND'. */
export type Customer_Revenue_Segment_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Customer_Revenue_Segment_Data_Bool_Exp>>;
  _not?: InputMaybe<Customer_Revenue_Segment_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Customer_Revenue_Segment_Data_Bool_Exp>>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  average_mrr?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Customer_Revenue_Segment_Data_Max_Fields = {
  __typename?: 'customer_revenue_segment_data_max_fields';
  amagi_id?: Maybe<Scalars['String']>;
  average_mrr?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Customer_Revenue_Segment_Data_Min_Fields = {
  __typename?: 'customer_revenue_segment_data_min_fields';
  amagi_id?: Maybe<Scalars['String']>;
  average_mrr?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "customer_revenue_segment_data". */
export type Customer_Revenue_Segment_Data_Order_By = {
  amagi_id?: InputMaybe<Order_By>;
  average_mrr?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "customer_revenue_segment_data" */
export enum Customer_Revenue_Segment_Data_Select_Column {
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  AverageMrr = 'average_mrr',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Customer_Revenue_Segment_Data_Stddev_Fields = {
  __typename?: 'customer_revenue_segment_data_stddev_fields';
  average_mrr?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Customer_Revenue_Segment_Data_Stddev_Pop_Fields = {
  __typename?: 'customer_revenue_segment_data_stddev_pop_fields';
  average_mrr?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Customer_Revenue_Segment_Data_Stddev_Samp_Fields = {
  __typename?: 'customer_revenue_segment_data_stddev_samp_fields';
  average_mrr?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "customer_revenue_segment_data" */
export type Customer_Revenue_Segment_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Revenue_Segment_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Revenue_Segment_Data_Stream_Cursor_Value_Input = {
  amagi_id?: InputMaybe<Scalars['String']>;
  average_mrr?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Customer_Revenue_Segment_Data_Sum_Fields = {
  __typename?: 'customer_revenue_segment_data_sum_fields';
  average_mrr?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Customer_Revenue_Segment_Data_Var_Pop_Fields = {
  __typename?: 'customer_revenue_segment_data_var_pop_fields';
  average_mrr?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Customer_Revenue_Segment_Data_Var_Samp_Fields = {
  __typename?: 'customer_revenue_segment_data_var_samp_fields';
  average_mrr?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Customer_Revenue_Segment_Data_Variance_Fields = {
  __typename?: 'customer_revenue_segment_data_variance_fields';
  average_mrr?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Customer_Revenue_Segment_Max_Fields = {
  __typename?: 'customer_revenue_segment_max_fields';
  flag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lower_bound?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uppper_bound?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Customer_Revenue_Segment_Min_Fields = {
  __typename?: 'customer_revenue_segment_min_fields';
  flag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lower_bound?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uppper_bound?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "customer_revenue_segment". */
export type Customer_Revenue_Segment_Order_By = {
  flag?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lower_bound?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uppper_bound?: InputMaybe<Order_By>;
};

/** select columns of table "customer_revenue_segment" */
export enum Customer_Revenue_Segment_Select_Column {
  /** column name */
  Flag = 'flag',
  /** column name */
  Id = 'id',
  /** column name */
  LowerBound = 'lower_bound',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UppperBound = 'uppper_bound'
}

/** aggregate stddev on columns */
export type Customer_Revenue_Segment_Stddev_Fields = {
  __typename?: 'customer_revenue_segment_stddev_fields';
  lower_bound?: Maybe<Scalars['Float']>;
  uppper_bound?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Customer_Revenue_Segment_Stddev_Pop_Fields = {
  __typename?: 'customer_revenue_segment_stddev_pop_fields';
  lower_bound?: Maybe<Scalars['Float']>;
  uppper_bound?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Customer_Revenue_Segment_Stddev_Samp_Fields = {
  __typename?: 'customer_revenue_segment_stddev_samp_fields';
  lower_bound?: Maybe<Scalars['Float']>;
  uppper_bound?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "customer_revenue_segment" */
export type Customer_Revenue_Segment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Revenue_Segment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Revenue_Segment_Stream_Cursor_Value_Input = {
  flag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lower_bound?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  uppper_bound?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Customer_Revenue_Segment_Sum_Fields = {
  __typename?: 'customer_revenue_segment_sum_fields';
  lower_bound?: Maybe<Scalars['numeric']>;
  uppper_bound?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Customer_Revenue_Segment_Var_Pop_Fields = {
  __typename?: 'customer_revenue_segment_var_pop_fields';
  lower_bound?: Maybe<Scalars['Float']>;
  uppper_bound?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Customer_Revenue_Segment_Var_Samp_Fields = {
  __typename?: 'customer_revenue_segment_var_samp_fields';
  lower_bound?: Maybe<Scalars['Float']>;
  uppper_bound?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Customer_Revenue_Segment_Variance_Fields = {
  __typename?: 'customer_revenue_segment_variance_fields';
  lower_bound?: Maybe<Scalars['Float']>;
  uppper_bound?: Maybe<Scalars['Float']>;
};

export type Customer_Revenue_Split_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

/** select columns of table "customer" */
export enum Customer_Select_Column {
  /** column name */
  AccountCategory = 'account_category',
  /** column name */
  AccountCreationDate = 'account_creation_date',
  /** column name */
  AccountCurrency = 'account_currency',
  /** column name */
  AccountDeactivationDate = 'account_deactivation_date',
  /** column name */
  AccountLegalName = 'account_legal_name',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  AdRevenueModel = 'ad_revenue_model',
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  AmagiNow = 'amagi_now',
  /** column name */
  AmagiNowUrl = 'amagi_now_url',
  /** column name */
  BillToContact = 'bill_to_contact',
  /** column name */
  BillingAddress = 'billing_address',
  /** column name */
  BillingContact = 'billing_contact',
  /** column name */
  BillingTerm = 'billing_term',
  /** column name */
  BillingType = 'billing_type',
  /** column name */
  BusinessCategory = 'business_category',
  /** column name */
  CPlusPercentageShare = 'c_plus_percentage_share',
  /** column name */
  CdpderivedRevenueSegment = 'cdpderived_revenue_segment',
  /** column name */
  ChurnRequestedBy = 'churn_requested_by',
  /** column name */
  ChurnRiskPercentage = 'churn_risk_percentage',
  /** column name */
  CloudRegion = 'cloud_region',
  /** column name */
  CloudServiceProvider = 'cloud_service_provider',
  /** column name */
  Cloudport = 'cloudport',
  /** column name */
  CloudportUrl = 'cloudport_url',
  /** column name */
  Comments = 'comments',
  /** column name */
  CompanyCategory = 'company_category',
  /** column name */
  ConnectMsaEffectiveDate = 'connect_msa_effective_date',
  /** column name */
  CplusMsaEffectiveDate = 'cplus_msa_effective_date',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreditPeriodInDays = 'credit_period_in_days',
  /** column name */
  CreditScore = 'credit_score',
  /** column name */
  CustomerBusinessModel = 'customer_business_model',
  /** column name */
  CustomerContractPeriod = 'customer_contract_period',
  /** column name */
  CustomerFinancialRiskCategory = 'customer_financial_risk_category',
  /** column name */
  CustomerLifeTimeValue = 'customer_life_time_value',
  /** column name */
  CustomerOrigin = 'customer_origin',
  /** column name */
  CustomerRevenueForPreviousYear = 'customer_revenue_for_previous_year',
  /** column name */
  CustomerRevenueForThePresentYear = 'customer_revenue_for_the_present_year',
  /** column name */
  CustomerScale = 'customer_scale',
  /** column name */
  CustomerSinceDate = 'customer_since_date',
  /** column name */
  CustomerTier = 'customer_tier',
  /** column name */
  CustomerType = 'customer_type',
  /** column name */
  CustomersProfitForPreviousYear = 'customers_profit_for_previous_year',
  /** column name */
  CustomersProfitForThePresentYear = 'customers_profit_for_the_present_year',
  /** column name */
  Description = 'description',
  /** column name */
  Dso = 'dso',
  /** column name */
  FirstInvoiceDate = 'first_invoice_date',
  /** column name */
  IndustrySegment = 'industry_segment',
  /** column name */
  InvoicingCurrency = 'invoicing_currency',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMsaRatecardCustomer = 'is_msa_ratecard_customer',
  /** column name */
  IsOno = 'is_ono',
  /** column name */
  Language = 'language',
  /** column name */
  LegalEntityId = 'legal_entity_id',
  /** column name */
  LegalEntityName = 'legal_entity_name',
  /** column name */
  Logo = 'logo',
  /** column name */
  MonetizationPreference = 'monetization_preference',
  /** column name */
  MsaEffectiveDate = 'msa_effective_date',
  /** column name */
  NetsuiteId = 'netsuite_id',
  /** column name */
  NoOfEmployees = 'no_of_employees',
  /** column name */
  PaymentDueOnReceipt = 'payment_due_on_receipt',
  /** column name */
  PaymentTerms = 'payment_terms',
  /** column name */
  PaymentTermsInDays = 'payment_terms_in_days',
  /** column name */
  Phone = 'phone',
  /** column name */
  Planner = 'planner',
  /** column name */
  PlannerUrl = 'planner_url',
  /** column name */
  PlatformTier = 'platform_tier',
  /** column name */
  PreferredPaymentChannel = 'preferred_payment_channel',
  /** column name */
  Region = 'region',
  /** column name */
  RevenueGroup_1 = 'revenue_group_1',
  /** column name */
  RevenueGroup_2 = 'revenue_group_2',
  /** column name */
  SalesforceAccountmanagerId = 'salesforce_accountmanager_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceCsmId = 'salesforce_csm_id',
  /** column name */
  SalesforceGeoheadId = 'salesforce_geohead_id',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  SalesforceOwnerId = 'salesforce_owner_id',
  /** column name */
  SalesforceParentId = 'salesforce_parent_id',
  /** column name */
  SalesforceRecordTypeId = 'salesforce_record_type_id',
  /** column name */
  SalesforceSalesrepId = 'salesforce_salesrep_id',
  /** column name */
  SelfServiceAccess = 'self_service_access',
  /** column name */
  ServiceTier = 'service_tier',
  /** column name */
  Size = 'size',
  /** column name */
  Status = 'status',
  /** column name */
  Tam = 'tam',
  /** column name */
  Thunderstorm = 'thunderstorm',
  /** column name */
  ThunderstormUrl = 'thunderstorm_url',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "customer_aggregate_bool_exp_bool_and_arguments_columns" columns of table "customer" */
export enum Customer_Select_Column_Customer_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMsaRatecardCustomer = 'is_msa_ratecard_customer',
  /** column name */
  IsOno = 'is_ono',
  /** column name */
  PaymentDueOnReceipt = 'payment_due_on_receipt'
}

/** select "customer_aggregate_bool_exp_bool_or_arguments_columns" columns of table "customer" */
export enum Customer_Select_Column_Customer_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMsaRatecardCustomer = 'is_msa_ratecard_customer',
  /** column name */
  IsOno = 'is_ono',
  /** column name */
  PaymentDueOnReceipt = 'payment_due_on_receipt'
}

/** aggregate stddev on columns */
export type Customer_Stddev_Fields = {
  __typename?: 'customer_stddev_fields';
  c_plus_percentage_share?: Maybe<Scalars['Float']>;
  churn_risk_percentage?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Float']>;
  customer_contract_period?: Maybe<Scalars['Float']>;
  customer_life_time_value?: Maybe<Scalars['Float']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['Float']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['Float']>;
  customers_profit_for_previous_year?: Maybe<Scalars['Float']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  no_of_employees?: Maybe<Scalars['Float']>;
  payment_terms_in_days?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "customer" */
export type Customer_Stddev_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Customer_Stddev_Pop_Fields = {
  __typename?: 'customer_stddev_pop_fields';
  c_plus_percentage_share?: Maybe<Scalars['Float']>;
  churn_risk_percentage?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Float']>;
  customer_contract_period?: Maybe<Scalars['Float']>;
  customer_life_time_value?: Maybe<Scalars['Float']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['Float']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['Float']>;
  customers_profit_for_previous_year?: Maybe<Scalars['Float']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  no_of_employees?: Maybe<Scalars['Float']>;
  payment_terms_in_days?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "customer" */
export type Customer_Stddev_Pop_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Customer_Stddev_Samp_Fields = {
  __typename?: 'customer_stddev_samp_fields';
  c_plus_percentage_share?: Maybe<Scalars['Float']>;
  churn_risk_percentage?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Float']>;
  customer_contract_period?: Maybe<Scalars['Float']>;
  customer_life_time_value?: Maybe<Scalars['Float']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['Float']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['Float']>;
  customers_profit_for_previous_year?: Maybe<Scalars['Float']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  no_of_employees?: Maybe<Scalars['Float']>;
  payment_terms_in_days?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "customer" */
export type Customer_Stddev_Samp_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "customer" */
export type Customer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Customer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Customer_Stream_Cursor_Value_Input = {
  account_category?: InputMaybe<Scalars['String']>;
  account_creation_date?: InputMaybe<Scalars['date']>;
  account_currency?: InputMaybe<Scalars['String']>;
  account_deactivation_date?: InputMaybe<Scalars['date']>;
  account_legal_name?: InputMaybe<Scalars['String']>;
  account_name?: InputMaybe<Scalars['String']>;
  ad_revenue_model?: InputMaybe<Scalars['String']>;
  amagi_id?: InputMaybe<Scalars['String']>;
  amagi_now?: InputMaybe<Scalars['String']>;
  amagi_now_url?: InputMaybe<Scalars['String']>;
  bill_to_contact?: InputMaybe<Scalars['String']>;
  billing_address?: InputMaybe<Scalars['jsonb']>;
  billing_contact?: InputMaybe<Scalars['jsonb']>;
  billing_term?: InputMaybe<Scalars['String']>;
  billing_type?: InputMaybe<Scalars['String']>;
  business_category?: InputMaybe<Scalars['String']>;
  c_plus_percentage_share?: InputMaybe<Scalars['numeric']>;
  cdpderived_revenue_segment?: InputMaybe<Scalars['String']>;
  churn_requested_by?: InputMaybe<Scalars['String']>;
  churn_risk_percentage?: InputMaybe<Scalars['numeric']>;
  cloud_region?: InputMaybe<Scalars['jsonb']>;
  cloud_service_provider?: InputMaybe<Scalars['jsonb']>;
  cloudport?: InputMaybe<Scalars['String']>;
  cloudport_url?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  company_category?: InputMaybe<Scalars['String']>;
  connect_msa_effective_date?: InputMaybe<Scalars['date']>;
  cplus_msa_effective_date?: InputMaybe<Scalars['date']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credit_period_in_days?: InputMaybe<Scalars['String']>;
  credit_score?: InputMaybe<Scalars['numeric']>;
  customer_business_model?: InputMaybe<Scalars['String']>;
  customer_contract_period?: InputMaybe<Scalars['numeric']>;
  customer_financial_risk_category?: InputMaybe<Scalars['String']>;
  customer_life_time_value?: InputMaybe<Scalars['numeric']>;
  customer_origin?: InputMaybe<Scalars['String']>;
  customer_revenue_for_previous_year?: InputMaybe<Scalars['numeric']>;
  customer_revenue_for_the_present_year?: InputMaybe<Scalars['numeric']>;
  customer_scale?: InputMaybe<Scalars['String']>;
  customer_since_date?: InputMaybe<Scalars['timestamptz']>;
  customer_tier?: InputMaybe<Scalars['String']>;
  customer_type?: InputMaybe<Scalars['String']>;
  customers_profit_for_previous_year?: InputMaybe<Scalars['numeric']>;
  customers_profit_for_the_present_year?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  dso?: InputMaybe<Scalars['String']>;
  first_invoice_date?: InputMaybe<Scalars['date']>;
  industry_segment?: InputMaybe<Scalars['String']>;
  invoicing_currency?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_msa_ratecard_customer?: InputMaybe<Scalars['Boolean']>;
  is_ono?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  legal_entity_id?: InputMaybe<Scalars['String']>;
  legal_entity_name?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  monetization_preference?: InputMaybe<Scalars['String']>;
  msa_effective_date?: InputMaybe<Scalars['date']>;
  netsuite_id?: InputMaybe<Scalars['numeric']>;
  no_of_employees?: InputMaybe<Scalars['numeric']>;
  payment_due_on_receipt?: InputMaybe<Scalars['Boolean']>;
  payment_terms?: InputMaybe<Scalars['String']>;
  payment_terms_in_days?: InputMaybe<Scalars['numeric']>;
  phone?: InputMaybe<Scalars['String']>;
  planner?: InputMaybe<Scalars['String']>;
  planner_url?: InputMaybe<Scalars['String']>;
  platform_tier?: InputMaybe<Scalars['String']>;
  preferred_payment_channel?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  revenue_group_1?: InputMaybe<Scalars['String']>;
  revenue_group_2?: InputMaybe<Scalars['String']>;
  salesforce_accountmanager_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_csm_id?: InputMaybe<Scalars['String']>;
  salesforce_geohead_id?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_owner_id?: InputMaybe<Scalars['String']>;
  salesforce_parent_id?: InputMaybe<Scalars['String']>;
  salesforce_record_type_id?: InputMaybe<Scalars['String']>;
  salesforce_salesrep_id?: InputMaybe<Scalars['String']>;
  self_service_access?: InputMaybe<Scalars['String']>;
  service_tier?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tam?: InputMaybe<Scalars['String']>;
  thunderstorm?: InputMaybe<Scalars['String']>;
  thunderstorm_url?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Customer_Sum_Fields = {
  __typename?: 'customer_sum_fields';
  c_plus_percentage_share?: Maybe<Scalars['numeric']>;
  churn_risk_percentage?: Maybe<Scalars['numeric']>;
  credit_score?: Maybe<Scalars['numeric']>;
  customer_contract_period?: Maybe<Scalars['numeric']>;
  customer_life_time_value?: Maybe<Scalars['numeric']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['numeric']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['numeric']>;
  customers_profit_for_previous_year?: Maybe<Scalars['numeric']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  no_of_employees?: Maybe<Scalars['numeric']>;
  payment_terms_in_days?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "customer" */
export type Customer_Sum_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
};

export type Customer_Tier_Revenue_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Customer_Type_Revenue_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

/** aggregate var_pop on columns */
export type Customer_Var_Pop_Fields = {
  __typename?: 'customer_var_pop_fields';
  c_plus_percentage_share?: Maybe<Scalars['Float']>;
  churn_risk_percentage?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Float']>;
  customer_contract_period?: Maybe<Scalars['Float']>;
  customer_life_time_value?: Maybe<Scalars['Float']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['Float']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['Float']>;
  customers_profit_for_previous_year?: Maybe<Scalars['Float']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  no_of_employees?: Maybe<Scalars['Float']>;
  payment_terms_in_days?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "customer" */
export type Customer_Var_Pop_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Customer_Var_Samp_Fields = {
  __typename?: 'customer_var_samp_fields';
  c_plus_percentage_share?: Maybe<Scalars['Float']>;
  churn_risk_percentage?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Float']>;
  customer_contract_period?: Maybe<Scalars['Float']>;
  customer_life_time_value?: Maybe<Scalars['Float']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['Float']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['Float']>;
  customers_profit_for_previous_year?: Maybe<Scalars['Float']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  no_of_employees?: Maybe<Scalars['Float']>;
  payment_terms_in_days?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "customer" */
export type Customer_Var_Samp_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Customer_Variance_Fields = {
  __typename?: 'customer_variance_fields';
  c_plus_percentage_share?: Maybe<Scalars['Float']>;
  churn_risk_percentage?: Maybe<Scalars['Float']>;
  credit_score?: Maybe<Scalars['Float']>;
  customer_contract_period?: Maybe<Scalars['Float']>;
  customer_life_time_value?: Maybe<Scalars['Float']>;
  customer_revenue_for_previous_year?: Maybe<Scalars['Float']>;
  customer_revenue_for_the_present_year?: Maybe<Scalars['Float']>;
  customers_profit_for_previous_year?: Maybe<Scalars['Float']>;
  customers_profit_for_the_present_year?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  no_of_employees?: Maybe<Scalars['Float']>;
  payment_terms_in_days?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "customer" */
export type Customer_Variance_Order_By = {
  c_plus_percentage_share?: InputMaybe<Order_By>;
  churn_risk_percentage?: InputMaybe<Order_By>;
  credit_score?: InputMaybe<Order_By>;
  customer_contract_period?: InputMaybe<Order_By>;
  customer_life_time_value?: InputMaybe<Order_By>;
  customer_revenue_for_previous_year?: InputMaybe<Order_By>;
  customer_revenue_for_the_present_year?: InputMaybe<Order_By>;
  customers_profit_for_previous_year?: InputMaybe<Order_By>;
  customers_profit_for_the_present_year?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  no_of_employees?: InputMaybe<Order_By>;
  payment_terms_in_days?: InputMaybe<Order_By>;
};

export type Dashboard_Revenue_Split_Args = {
  from_date?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "data_growth" */
export type Data_Growth = {
  __typename?: 'data_growth';
  created_at: Scalars['timestamptz'];
  date: Scalars['date'];
  id: Scalars['uuid'];
  row_count: Scalars['Int'];
  table_name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** Boolean expression to filter rows from the table "data_growth". All fields are combined with a logical 'AND'. */
export type Data_Growth_Bool_Exp = {
  _and?: InputMaybe<Array<Data_Growth_Bool_Exp>>;
  _not?: InputMaybe<Data_Growth_Bool_Exp>;
  _or?: InputMaybe<Array<Data_Growth_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  row_count?: InputMaybe<Int_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "data_growth". */
export type Data_Growth_Order_By = {
  created_at?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  row_count?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "data_growth" */
export enum Data_Growth_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  RowCount = 'row_count',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "data_growth" */
export type Data_Growth_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Data_Growth_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Data_Growth_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  row_count?: InputMaybe<Scalars['Int']>;
  table_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

export type Data_Growth_Trend_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "data_quality" */
export type Data_Quality = {
  __typename?: 'data_quality';
  accuracy?: Maybe<Scalars['numeric']>;
  column_name?: Maybe<Scalars['String']>;
  complete_weight?: Maybe<Scalars['numeric']>;
  completeness?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "completeness_weight" */
  completeness_weight?: Maybe<Scalars['numeric']>;
  created_at: Scalars['timestamptz'];
  custom_value?: Maybe<Scalars['numeric']>;
  date?: Maybe<Scalars['date']>;
  id: Scalars['Int'];
  table_name?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  weight?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "data_quality". All fields are combined with a logical 'AND'. */
export type Data_Quality_Bool_Exp = {
  _and?: InputMaybe<Array<Data_Quality_Bool_Exp>>;
  _not?: InputMaybe<Data_Quality_Bool_Exp>;
  _or?: InputMaybe<Array<Data_Quality_Bool_Exp>>;
  accuracy?: InputMaybe<Numeric_Comparison_Exp>;
  column_name?: InputMaybe<String_Comparison_Exp>;
  complete_weight?: InputMaybe<Numeric_Comparison_Exp>;
  completeness?: InputMaybe<Numeric_Comparison_Exp>;
  completeness_weight?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  custom_value?: InputMaybe<Numeric_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weight?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Ordering options when selecting data from "data_quality". */
export type Data_Quality_Order_By = {
  accuracy?: InputMaybe<Order_By>;
  column_name?: InputMaybe<Order_By>;
  complete_weight?: InputMaybe<Order_By>;
  completeness?: InputMaybe<Order_By>;
  completeness_weight?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  custom_value?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weight?: InputMaybe<Order_By>;
};

/** select columns of table "data_quality" */
export enum Data_Quality_Select_Column {
  /** column name */
  Accuracy = 'accuracy',
  /** column name */
  ColumnName = 'column_name',
  /** column name */
  CompleteWeight = 'complete_weight',
  /** column name */
  Completeness = 'completeness',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomValue = 'custom_value',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  TableName = 'table_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Weight = 'weight'
}

/** Streaming cursor of the table "data_quality" */
export type Data_Quality_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Data_Quality_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Data_Quality_Stream_Cursor_Value_Input = {
  accuracy?: InputMaybe<Scalars['numeric']>;
  column_name?: InputMaybe<Scalars['String']>;
  complete_weight?: InputMaybe<Scalars['numeric']>;
  completeness?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  custom_value?: InputMaybe<Scalars['numeric']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  table_name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  weight?: InputMaybe<Scalars['numeric']>;
};

export type Data_Quality_Trend_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "delivery" */
export type Delivery = {
  __typename?: 'delivery';
  ad_load_minutes?: Maybe<Scalars['Int']>;
  ads_plus?: Maybe<Scalars['String']>;
  amagi_share_backfill?: Maybe<Scalars['String']>;
  amagi_share_primary?: Maybe<Scalars['String']>;
  assignee?: Maybe<Scalars['String']>;
  audio_languages?: Maybe<Scalars['jsonb']>;
  blocked_reason?: Maybe<Scalars['String']>;
  blocked_reason_details?: Maybe<Scalars['String']>;
  business_model?: Maybe<Scalars['jsonb']>;
  cdn_fee_owner?: Maybe<Scalars['String']>;
  cdn_tag_1?: Maybe<Scalars['String']>;
  cdn_tag_2?: Maybe<Scalars['String']>;
  cdn_tag_3?: Maybe<Scalars['String']>;
  cdn_tag_4?: Maybe<Scalars['String']>;
  cdp_delivery_type?: Maybe<Scalars['String']>;
  churned_date?: Maybe<Scalars['date']>;
  churned_reason?: Maybe<Scalars['String']>;
  connect_distribution_model?: Maybe<Scalars['String']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  content_partner_backfill?: Maybe<Scalars['String']>;
  content_partner_primary?: Maybe<Scalars['String']>;
  content_plus?: Maybe<Scalars['String']>;
  deal_split_amagi_share?: Maybe<Scalars['Int']>;
  deal_split_with_content_partner?: Maybe<Scalars['Int']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Int']>;
  deal_type_for_content_partner?: Maybe<Scalars['String']>;
  deal_type_for_platform_partner?: Maybe<Scalars['String']>;
  delivered_date?: Maybe<Scalars['date']>;
  delivered_region?: Maybe<Scalars['jsonb']>;
  delivered_using_amagi_now?: Maybe<Scalars['String']>;
  delivery_published_to_amagi_now?: Maybe<Scalars['Boolean']>;
  delivery_status?: Maybe<Scalars['String']>;
  delivery_stream_type?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  delivery_to_channel?: Maybe<Channel>;
  /** An object relationship */
  delivery_to_delivery_timeline?: Maybe<Delivery_Timeline>;
  /** An object relationship */
  delivery_to_order?: Maybe<Order>;
  /** An object relationship */
  delivery_to_platform?: Maybe<Platform>;
  delivery_type?: Maybe<Scalars['String']>;
  epg_url?: Maybe<Scalars['String']>;
  feed_type?: Maybe<Scalars['String']>;
  go_live_date?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  inventory_share_amagi_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_amagi_primary_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_content_partner_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_content_partner_primary_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_platform_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_platform_primary_ad_tag?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  is_deleted_order?: Maybe<Scalars['Boolean']>;
  on_hold_date?: Maybe<Scalars['timestamptz']>;
  on_hold_reason?: Maybe<Scalars['String']>;
  ordered_date?: Maybe<Scalars['date']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  platform_partner_backfill?: Maybe<Scalars['String']>;
  platform_partner_primary?: Maybe<Scalars['String']>;
  playout?: Maybe<Scalars['String']>;
  point_product_delivery_id?: Maybe<Scalars['String']>;
  product_purchased_for_this_delivery?: Maybe<Scalars['jsonb']>;
  provisioning_start_date?: Maybe<Scalars['date']>;
  redundancy?: Maybe<Scalars['Int']>;
  request_origin?: Maybe<Scalars['String']>;
  revenue_share_backfill_ad_tag?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_backfill?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_primary?: Maybe<Scalars['String']>;
  revenue_share_primary_ad_tag?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_order_id?: Maybe<Scalars['String']>;
  salesforce_order_item_id?: Maybe<Scalars['String']>;
  salesforce_order_product_id?: Maybe<Scalars['String']>;
  salesforce_order_product_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
  ssai?: Maybe<Scalars['Boolean']>;
  ssai_fee_owner?: Maybe<Scalars['String']>;
  stream_url?: Maybe<Scalars['String']>;
  test_delivery?: Maybe<Scalars['String']>;
  transcoding?: Maybe<Scalars['Boolean']>;
  ts_setup?: Maybe<Scalars['String']>;
  turnaround?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user?: Maybe<User>;
};


/** columns and relationships of "delivery" */
export type DeliveryAudio_LanguagesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "delivery" */
export type DeliveryBusiness_ModelArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "delivery" */
export type DeliveryDelivered_RegionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "delivery" */
export type DeliveryDelivery_Stream_TypeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "delivery" */
export type DeliveryProduct_Purchased_For_This_DeliveryArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "delivery" */
export type Delivery_Aggregate = {
  __typename?: 'delivery_aggregate';
  aggregate?: Maybe<Delivery_Aggregate_Fields>;
  nodes: Array<Delivery>;
};

export type Delivery_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Delivery_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Delivery_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Delivery_Aggregate_Bool_Exp_Count>;
};

export type Delivery_Aggregate_Bool_Exp_Bool_And = {
  arguments: Delivery_Select_Column_Delivery_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Delivery_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Delivery_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Delivery_Select_Column_Delivery_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Delivery_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Delivery_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Delivery_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Delivery_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "delivery" */
export type Delivery_Aggregate_Fields = {
  __typename?: 'delivery_aggregate_fields';
  avg?: Maybe<Delivery_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Delivery_Max_Fields>;
  min?: Maybe<Delivery_Min_Fields>;
  stddev?: Maybe<Delivery_Stddev_Fields>;
  stddev_pop?: Maybe<Delivery_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Delivery_Stddev_Samp_Fields>;
  sum?: Maybe<Delivery_Sum_Fields>;
  var_pop?: Maybe<Delivery_Var_Pop_Fields>;
  var_samp?: Maybe<Delivery_Var_Samp_Fields>;
  variance?: Maybe<Delivery_Variance_Fields>;
};


/** aggregate fields of "delivery" */
export type Delivery_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Delivery_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "delivery" */
export type Delivery_Aggregate_Order_By = {
  avg?: InputMaybe<Delivery_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Delivery_Max_Order_By>;
  min?: InputMaybe<Delivery_Min_Order_By>;
  stddev?: InputMaybe<Delivery_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Delivery_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Delivery_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Delivery_Sum_Order_By>;
  var_pop?: InputMaybe<Delivery_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Delivery_Var_Samp_Order_By>;
  variance?: InputMaybe<Delivery_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Delivery_Append_Input = {
  audio_languages?: InputMaybe<Scalars['jsonb']>;
  business_model?: InputMaybe<Scalars['jsonb']>;
  delivered_region?: InputMaybe<Scalars['jsonb']>;
  delivery_stream_type?: InputMaybe<Scalars['jsonb']>;
  product_purchased_for_this_delivery?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Delivery_Avg_Fields = {
  __typename?: 'delivery_avg_fields';
  ad_load_minutes?: Maybe<Scalars['Float']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  deal_split_amagi_share?: Maybe<Scalars['Float']>;
  deal_split_with_content_partner?: Maybe<Scalars['Float']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Float']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  redundancy?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "delivery" */
export type Delivery_Avg_Order_By = {
  ad_load_minutes?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  deal_split_amagi_share?: InputMaybe<Order_By>;
  deal_split_with_content_partner?: InputMaybe<Order_By>;
  deal_split_with_platform_partner?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  redundancy?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "delivery". All fields are combined with a logical 'AND'. */
export type Delivery_Bool_Exp = {
  _and?: InputMaybe<Array<Delivery_Bool_Exp>>;
  _not?: InputMaybe<Delivery_Bool_Exp>;
  _or?: InputMaybe<Array<Delivery_Bool_Exp>>;
  ad_load_minutes?: InputMaybe<Int_Comparison_Exp>;
  ads_plus?: InputMaybe<String_Comparison_Exp>;
  amagi_share_backfill?: InputMaybe<String_Comparison_Exp>;
  amagi_share_primary?: InputMaybe<String_Comparison_Exp>;
  assignee?: InputMaybe<String_Comparison_Exp>;
  audio_languages?: InputMaybe<Jsonb_Comparison_Exp>;
  blocked_reason?: InputMaybe<String_Comparison_Exp>;
  blocked_reason_details?: InputMaybe<String_Comparison_Exp>;
  business_model?: InputMaybe<Jsonb_Comparison_Exp>;
  cdn_fee_owner?: InputMaybe<String_Comparison_Exp>;
  cdn_tag_1?: Maybe<Scalars['String']>;
  cdn_tag_2?: Maybe<Scalars['String']>;
  cdn_tag_3?: Maybe<Scalars['String']>;
  cdn_tag_4?: Maybe<Scalars['String']>;
  cdp_delivery_type?: InputMaybe<String_Comparison_Exp>;
  churned_date?: InputMaybe<Date_Comparison_Exp>;
  churned_reason?: InputMaybe<String_Comparison_Exp>;
  connect_distribution_model?: InputMaybe<String_Comparison_Exp>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Numeric_Comparison_Exp>;
  content_partner_backfill?: InputMaybe<String_Comparison_Exp>;
  content_partner_primary?: InputMaybe<String_Comparison_Exp>;
  content_plus?: InputMaybe<String_Comparison_Exp>;
  deal_split_amagi_share?: InputMaybe<Int_Comparison_Exp>;
  deal_split_with_content_partner?: InputMaybe<Int_Comparison_Exp>;
  deal_split_with_platform_partner?: InputMaybe<Int_Comparison_Exp>;
  deal_type_for_content_partner?: InputMaybe<String_Comparison_Exp>;
  deal_type_for_platform_partner?: InputMaybe<String_Comparison_Exp>;
  delivered_date?: InputMaybe<Date_Comparison_Exp>;
  delivered_region?: InputMaybe<Jsonb_Comparison_Exp>;
  delivered_using_amagi_now?: InputMaybe<String_Comparison_Exp>;
  delivery_published_to_amagi_now?: InputMaybe<Boolean_Comparison_Exp>;
  delivery_status?: InputMaybe<String_Comparison_Exp>;
  delivery_stream_type?: InputMaybe<Jsonb_Comparison_Exp>;
  delivery_to_channel?: InputMaybe<Channel_Bool_Exp>;
  delivery_to_delivery_timeline?: InputMaybe<Delivery_Timeline_Bool_Exp>;
  delivery_to_order?: InputMaybe<Order_Bool_Exp>;
  delivery_to_platform?: InputMaybe<Platform_Bool_Exp>;
  delivery_type?: InputMaybe<String_Comparison_Exp>;
  epg_url?: InputMaybe<String_Comparison_Exp>;
  feed_type?: InputMaybe<String_Comparison_Exp>;
  go_live_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  inventory_share_amagi_backfill_ad_tag?: InputMaybe<String_Comparison_Exp>;
  inventory_share_amagi_primary_ad_tag?: InputMaybe<String_Comparison_Exp>;
  inventory_share_content_partner_backfill_ad_tag?: InputMaybe<String_Comparison_Exp>;
  inventory_share_content_partner_primary_ad_tag?: InputMaybe<String_Comparison_Exp>;
  inventory_share_platform_backfill_ad_tag?: InputMaybe<String_Comparison_Exp>;
  inventory_share_platform_primary_ad_tag?: InputMaybe<String_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted_order?: InputMaybe<Boolean_Comparison_Exp>;
  on_hold_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  on_hold_reason?: InputMaybe<String_Comparison_Exp>;
  ordered_date?: InputMaybe<Date_Comparison_Exp>;
  platform_ad_sales_commission_percentage?: InputMaybe<Numeric_Comparison_Exp>;
  platform_partner_backfill?: InputMaybe<String_Comparison_Exp>;
  platform_partner_primary?: InputMaybe<String_Comparison_Exp>;
  playout?: InputMaybe<String_Comparison_Exp>;
  point_product_delivery_id?: InputMaybe<String_Comparison_Exp>;
  product_purchased_for_this_delivery?: InputMaybe<Jsonb_Comparison_Exp>;
  provisioning_start_date?: InputMaybe<Date_Comparison_Exp>;
  redundancy?: InputMaybe<Int_Comparison_Exp>;
  request_origin?: InputMaybe<String_Comparison_Exp>;
  revenue_share_backfill_ad_tag?: InputMaybe<String_Comparison_Exp>;
  revenue_share_monetised_by_backfill?: InputMaybe<String_Comparison_Exp>;
  revenue_share_monetised_by_primary?: InputMaybe<String_Comparison_Exp>;
  revenue_share_primary_ad_tag?: InputMaybe<String_Comparison_Exp>;
  salesforce_channel_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_order_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_order_item_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_order_product_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_order_product_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_platform_id?: InputMaybe<String_Comparison_Exp>;
  ssai?: InputMaybe<Boolean_Comparison_Exp>;
  ssai_fee_owner?: InputMaybe<String_Comparison_Exp>;
  stream_url?: InputMaybe<String_Comparison_Exp>;
  test_delivery?: InputMaybe<String_Comparison_Exp>;
  transcoding?: InputMaybe<Boolean_Comparison_Exp>;
  ts_setup?: InputMaybe<String_Comparison_Exp>;
  turnaround?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

export type Delivery_Channel_Platform_Args = {
  amagi_ids?: InputMaybe<Scalars['String']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Delivery_Data_Append_Input = {
  audio_languages?: InputMaybe<Scalars['jsonb']>;
  business_model?: InputMaybe<Scalars['jsonb']>;
  delivered_region?: InputMaybe<Scalars['jsonb']>;
  product?: InputMaybe<Scalars['jsonb']>;
  product_purchased_for_this_delivery?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "delivery_data". All fields are combined with a logical 'AND'. */
export type Delivery_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Delivery_Data_Bool_Exp>>;
  _not?: InputMaybe<Delivery_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Delivery_Data_Bool_Exp>>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Delivery_Data_Delete_At_Path_Input = {
  audio_languages?: InputMaybe<Array<Scalars['String']>>;
  business_model?: InputMaybe<Array<Scalars['String']>>;
  delivered_region?: InputMaybe<Array<Scalars['String']>>;
  product?: InputMaybe<Array<Scalars['String']>>;
  product_purchased_for_this_delivery?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Delivery_Data_Delete_Elem_Input = {
  audio_languages?: InputMaybe<Scalars['Int']>;
  business_model?: InputMaybe<Scalars['Int']>;
  delivered_region?: InputMaybe<Scalars['Int']>;
  product?: InputMaybe<Scalars['Int']>;
  product_purchased_for_this_delivery?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Delivery_Data_Delete_Key_Input = {
  audio_languages?: InputMaybe<Scalars['String']>;
  business_model?: InputMaybe<Scalars['String']>;
  delivered_region?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  product_purchased_for_this_delivery?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "delivery_data" */
export type Delivery_Data_Inc_Input = {
  deal_split_amagi_share?: InputMaybe<Scalars['Int']>;
  deal_split_with_content_partner?: InputMaybe<Scalars['Int']>;
  deal_split_with_platform_partner?: InputMaybe<Scalars['Int']>;
  redundancy?: InputMaybe<Scalars['Int']>;
};

/** response of any mutation on the table "delivery_data" */
export type Delivery_Data_Mutation_Response = {
  __typename?: 'delivery_data_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Delivery_Data_Prepend_Input = {
  audio_languages?: InputMaybe<Scalars['jsonb']>;
  business_model?: InputMaybe<Scalars['jsonb']>;
  delivered_region?: InputMaybe<Scalars['jsonb']>;
  product?: InputMaybe<Scalars['jsonb']>;
  product_purchased_for_this_delivery?: InputMaybe<Scalars['jsonb']>;
};

/** input type for updating data in table "delivery_data" */
export type Delivery_Data_Set_Input = {
  amagi_share_backfill?: InputMaybe<Scalars['String']>;
  amagi_share_primary?: InputMaybe<Scalars['String']>;
  audio_languages?: InputMaybe<Scalars['jsonb']>;
  business_model?: InputMaybe<Scalars['jsonb']>;
  channel_salesforce_id?: InputMaybe<Scalars['String']>;
  churned_date?: InputMaybe<Scalars['date']>;
  churned_reason?: InputMaybe<Scalars['String']>;
  content_partner_backfill?: InputMaybe<Scalars['String']>;
  content_partner_primary?: InputMaybe<Scalars['String']>;
  deal_split_amagi_share?: InputMaybe<Scalars['Int']>;
  deal_split_with_content_partner?: InputMaybe<Scalars['Int']>;
  deal_split_with_platform_partner?: InputMaybe<Scalars['Int']>;
  deal_type_for_content_partner?: InputMaybe<Scalars['String']>;
  deal_type_for_platform_partner?: InputMaybe<Scalars['String']>;
  delivered_date?: InputMaybe<Scalars['timestamptz']>;
  delivered_region?: InputMaybe<Scalars['jsonb']>;
  delivery_status?: InputMaybe<Scalars['String']>;
  delivery_type?: InputMaybe<Scalars['String']>;
  feed_type?: InputMaybe<Scalars['String']>;
  go_live_date?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  ordered_date?: InputMaybe<Scalars['date']>;
  platform_partner_backfill?: InputMaybe<Scalars['String']>;
  platform_partner_primary?: InputMaybe<Scalars['String']>;
  platform_salesforce_id?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['jsonb']>;
  product_purchased_for_this_delivery?: InputMaybe<Scalars['jsonb']>;
  product_purchased_for_this_deliverys?: InputMaybe<Scalars['String']>;
  provisioning_start_date?: InputMaybe<Scalars['date']>;
  quote_line_salesforce_id?: InputMaybe<Scalars['String']>;
  redundancy?: InputMaybe<Scalars['Int']>;
  salesforce_order_id?: InputMaybe<Scalars['String']>;
  ssai?: InputMaybe<Scalars['Boolean']>;
};

export type Delivery_Data_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Delivery_Data_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Delivery_Data_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Delivery_Data_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Delivery_Data_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Delivery_Data_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Delivery_Data_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Delivery_Data_Set_Input>;
  /** filter the rows which have to be updated */
  where: Delivery_Data_Bool_Exp;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Delivery_Delete_At_Path_Input = {
  audio_languages?: InputMaybe<Array<Scalars['String']>>;
  business_model?: InputMaybe<Array<Scalars['String']>>;
  delivered_region?: InputMaybe<Array<Scalars['String']>>;
  delivery_stream_type?: InputMaybe<Array<Scalars['String']>>;
  product_purchased_for_this_delivery?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Delivery_Delete_Elem_Input = {
  audio_languages?: InputMaybe<Scalars['Int']>;
  business_model?: InputMaybe<Scalars['Int']>;
  delivered_region?: InputMaybe<Scalars['Int']>;
  delivery_stream_type?: InputMaybe<Scalars['Int']>;
  product_purchased_for_this_delivery?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Delivery_Delete_Key_Input = {
  audio_languages?: InputMaybe<Scalars['String']>;
  business_model?: InputMaybe<Scalars['String']>;
  delivered_region?: InputMaybe<Scalars['String']>;
  delivery_stream_type?: InputMaybe<Scalars['String']>;
  product_purchased_for_this_delivery?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "delivery" */
export type Delivery_Inc_Input = {
  ad_load_minutes?: InputMaybe<Scalars['Int']>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Scalars['numeric']>;
  deal_split_amagi_share?: InputMaybe<Scalars['Int']>;
  deal_split_with_content_partner?: InputMaybe<Scalars['Int']>;
  deal_split_with_platform_partner?: InputMaybe<Scalars['Int']>;
  platform_ad_sales_commission_percentage?: InputMaybe<Scalars['numeric']>;
  redundancy?: InputMaybe<Scalars['Int']>;
};

/** columns and relationships of "delivery_main" */
export type Delivery_Main = {
  __typename?: 'delivery_main';
  ad_load_minutes?: Maybe<Scalars['Int']>;
  ads_plus?: Maybe<Scalars['String']>;
  amagi_share_backfill?: Maybe<Scalars['String']>;
  amagi_share_primary?: Maybe<Scalars['String']>;
  assignee?: Maybe<Scalars['String']>;
  audio_languages?: Maybe<Scalars['jsonb']>;
  business_model?: Maybe<Scalars['jsonb']>;
  cdn_fee_owner?: Maybe<Scalars['String']>;
  cdn_tag_1?: Maybe<Scalars['String']>;
  cdn_tag_2?: Maybe<Scalars['String']>;
  cdn_tag_3?: Maybe<Scalars['String']>;
  cdn_tag_4?: Maybe<Scalars['String']>;
  cdp_delivery_type?: Maybe<Scalars['String']>;
  churned_date?: Maybe<Scalars['date']>;
  churned_reason?: Maybe<Scalars['String']>;
  connect_distribution_model?: Maybe<Scalars['String']>;
  content_partner_backfill?: Maybe<Scalars['String']>;
  content_partner_primary?: Maybe<Scalars['String']>;
  content_plus?: Maybe<Scalars['String']>;
  deal_split_amagi_share?: Maybe<Scalars['Int']>;
  deal_split_with_content_partner?: Maybe<Scalars['Int']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Int']>;
  deal_type_for_content_partner?: Maybe<Scalars['String']>;
  deal_type_for_platform_partner?: Maybe<Scalars['String']>;
  delivered_date?: Maybe<Scalars['date']>;
  delivered_region?: Maybe<Scalars['jsonb']>;
  delivered_using_amagi_now?: Maybe<Scalars['String']>;
  delivery_published_to_amagi_now?: Maybe<Scalars['Boolean']>;
  /** A computed field, executes function "delivery_share" */
  delivery_share?: Maybe<Array<Fn_Return_Delivery_Share>>;
  delivery_status?: Maybe<Scalars['String']>;
  delivery_stream_type?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  delivery_to_channel?: Maybe<Channel>;
  /** An object relationship */
  delivery_to_delivery_timeline?: Maybe<Delivery_Timeline>;
  /** An object relationship */
  delivery_to_order?: Maybe<Order>;
  /** An object relationship */
  delivery_to_platform?: Maybe<Platform>;
  delivery_type?: Maybe<Scalars['String']>;
  feed_type?: Maybe<Scalars['String']>;
  go_live_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  on_hold_date?: Maybe<Scalars['timestamptz']>;
  on_hold_reason?: Maybe<Scalars['String']>;
  ordered_date?: Maybe<Scalars['date']>;
  platform_partner_backfill?: Maybe<Scalars['String']>;
  platform_partner_primary?: Maybe<Scalars['String']>;
  playout?: Maybe<Scalars['String']>;
  point_product_delivery_id?: Maybe<Scalars['String']>;
  product_purchased_for_this_delivery?: Maybe<Scalars['jsonb']>;
  provisioning_start_date?: Maybe<Scalars['date']>;
  redundancy?: Maybe<Scalars['Int']>;
  request_origin?: Maybe<Scalars['String']>;
  rn?: Maybe<Scalars['bigint']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_order_id?: Maybe<Scalars['String']>;
  salesforce_order_item_id?: Maybe<Scalars['String']>;
  salesforce_order_product_id?: Maybe<Scalars['String']>;
  salesforce_order_product_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
  ssai?: Maybe<Scalars['Boolean']>;
  ssai_fee_owner?: Maybe<Scalars['String']>;
  ts_setup?: Maybe<Scalars['String']>;
  turnaround?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user?: Maybe<User>;
};


/** columns and relationships of "delivery_main" */
export type Delivery_MainAudio_LanguagesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "delivery_main" */
export type Delivery_MainBusiness_ModelArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "delivery_main" */
export type Delivery_MainDelivered_RegionArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "delivery_main" */
export type Delivery_MainDelivery_ShareArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Share_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Share_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Share_Bool_Exp>;
};


/** columns and relationships of "delivery_main" */
export type Delivery_MainDelivery_Stream_TypeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "delivery_main" */
export type Delivery_MainProduct_Purchased_For_This_DeliveryArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "delivery_main" */
export type Delivery_Main_Aggregate = {
  __typename?: 'delivery_main_aggregate';
  aggregate?: Maybe<Delivery_Main_Aggregate_Fields>;
  nodes: Array<Delivery_Main>;
};

/** aggregate fields of "delivery_main" */
export type Delivery_Main_Aggregate_Fields = {
  __typename?: 'delivery_main_aggregate_fields';
  avg?: Maybe<Delivery_Main_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Delivery_Main_Max_Fields>;
  min?: Maybe<Delivery_Main_Min_Fields>;
  stddev?: Maybe<Delivery_Main_Stddev_Fields>;
  stddev_pop?: Maybe<Delivery_Main_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Delivery_Main_Stddev_Samp_Fields>;
  sum?: Maybe<Delivery_Main_Sum_Fields>;
  var_pop?: Maybe<Delivery_Main_Var_Pop_Fields>;
  var_samp?: Maybe<Delivery_Main_Var_Samp_Fields>;
  variance?: Maybe<Delivery_Main_Variance_Fields>;
};


/** aggregate fields of "delivery_main" */
export type Delivery_Main_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Delivery_Main_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Delivery_Main_Avg_Fields = {
  __typename?: 'delivery_main_avg_fields';
  ad_load_minutes?: Maybe<Scalars['Float']>;
  deal_split_amagi_share?: Maybe<Scalars['Float']>;
  deal_split_with_content_partner?: Maybe<Scalars['Float']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Float']>;
  redundancy?: Maybe<Scalars['Float']>;
  rn?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "delivery_main". All fields are combined with a logical 'AND'. */
export type Delivery_Main_Bool_Exp = {
  _and?: InputMaybe<Array<Delivery_Main_Bool_Exp>>;
  _not?: InputMaybe<Delivery_Main_Bool_Exp>;
  _or?: InputMaybe<Array<Delivery_Main_Bool_Exp>>;
  ad_load_minutes?: InputMaybe<Int_Comparison_Exp>;
  ads_plus?: InputMaybe<String_Comparison_Exp>;
  amagi_share_backfill?: InputMaybe<String_Comparison_Exp>;
  amagi_share_primary?: InputMaybe<String_Comparison_Exp>;
  assignee?: InputMaybe<String_Comparison_Exp>;
  audio_languages?: InputMaybe<Jsonb_Comparison_Exp>;
  business_model?: InputMaybe<Jsonb_Comparison_Exp>;
  cdn_fee_owner?: InputMaybe<String_Comparison_Exp>;
  cdn_tag_1?: Maybe<Scalars['String']>;
  cdn_tag_2?: Maybe<Scalars['String']>;
  cdn_tag_3?: Maybe<Scalars['String']>;
  cdn_tag_4?: Maybe<Scalars['String']>;
  cdp_delivery_type?: InputMaybe<String_Comparison_Exp>;
  churned_date?: InputMaybe<Date_Comparison_Exp>;
  churned_reason?: InputMaybe<String_Comparison_Exp>;
  connect_distribution_model?: InputMaybe<String_Comparison_Exp>;
  content_partner_backfill?: InputMaybe<String_Comparison_Exp>;
  content_partner_primary?: InputMaybe<String_Comparison_Exp>;
  content_plus?: InputMaybe<String_Comparison_Exp>;
  deal_split_amagi_share?: InputMaybe<Int_Comparison_Exp>;
  deal_split_with_content_partner?: InputMaybe<Int_Comparison_Exp>;
  deal_split_with_platform_partner?: InputMaybe<Int_Comparison_Exp>;
  deal_type_for_content_partner?: InputMaybe<String_Comparison_Exp>;
  deal_type_for_platform_partner?: InputMaybe<String_Comparison_Exp>;
  delivered_date?: InputMaybe<Date_Comparison_Exp>;
  delivered_region?: InputMaybe<Jsonb_Comparison_Exp>;
  delivered_using_amagi_now?: InputMaybe<String_Comparison_Exp>;
  delivery_published_to_amagi_now?: InputMaybe<Boolean_Comparison_Exp>;
  delivery_share?: InputMaybe<Fn_Return_Delivery_Share_Bool_Exp>;
  delivery_status?: InputMaybe<String_Comparison_Exp>;
  delivery_stream_type?: InputMaybe<Jsonb_Comparison_Exp>;
  delivery_to_channel?: InputMaybe<Channel_Bool_Exp>;
  delivery_to_delivery_timeline?: InputMaybe<Delivery_Timeline_Bool_Exp>;
  delivery_to_order?: InputMaybe<Order_Bool_Exp>;
  delivery_to_platform?: InputMaybe<Platform_Bool_Exp>;
  delivery_type?: InputMaybe<String_Comparison_Exp>;
  feed_type?: InputMaybe<String_Comparison_Exp>;
  go_live_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  on_hold_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  on_hold_reason?: InputMaybe<String_Comparison_Exp>;
  ordered_date?: InputMaybe<Date_Comparison_Exp>;
  platform_partner_backfill?: InputMaybe<String_Comparison_Exp>;
  platform_partner_primary?: InputMaybe<String_Comparison_Exp>;
  playout?: InputMaybe<String_Comparison_Exp>;
  point_product_delivery_id?: InputMaybe<String_Comparison_Exp>;
  product_purchased_for_this_delivery?: InputMaybe<Jsonb_Comparison_Exp>;
  provisioning_start_date?: InputMaybe<Date_Comparison_Exp>;
  redundancy?: InputMaybe<Int_Comparison_Exp>;
  request_origin?: InputMaybe<String_Comparison_Exp>;
  rn?: InputMaybe<Bigint_Comparison_Exp>;
  salesforce_channel_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_order_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_order_item_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_order_product_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_order_product_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_platform_id?: InputMaybe<String_Comparison_Exp>;
  ssai?: InputMaybe<Boolean_Comparison_Exp>;
  ssai_fee_owner?: InputMaybe<String_Comparison_Exp>;
  ts_setup?: InputMaybe<String_Comparison_Exp>;
  turnaround?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** aggregate max on columns */
export type Delivery_Main_Max_Fields = {
  __typename?: 'delivery_main_max_fields';
  ad_load_minutes?: Maybe<Scalars['Int']>;
  ads_plus?: Maybe<Scalars['String']>;
  amagi_share_backfill?: Maybe<Scalars['String']>;
  amagi_share_primary?: Maybe<Scalars['String']>;
  assignee?: Maybe<Scalars['String']>;
  cdn_fee_owner?: Maybe<Scalars['String']>;
  cdn_tag_1?: Maybe<Scalars['String']>;
  cdn_tag_2?: Maybe<Scalars['String']>;
  cdn_tag_3?: Maybe<Scalars['String']>;
  cdn_tag_4?: Maybe<Scalars['String']>;
  cdp_delivery_type?: Maybe<Scalars['String']>;
  churned_date?: Maybe<Scalars['date']>;
  churned_reason?: Maybe<Scalars['String']>;
  connect_distribution_model?: Maybe<Scalars['String']>;
  content_partner_backfill?: Maybe<Scalars['String']>;
  content_partner_primary?: Maybe<Scalars['String']>;
  content_plus?: Maybe<Scalars['String']>;
  deal_split_amagi_share?: Maybe<Scalars['Int']>;
  deal_split_with_content_partner?: Maybe<Scalars['Int']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Int']>;
  deal_type_for_content_partner?: Maybe<Scalars['String']>;
  deal_type_for_platform_partner?: Maybe<Scalars['String']>;
  delivered_date?: Maybe<Scalars['date']>;
  delivered_using_amagi_now?: Maybe<Scalars['String']>;
  delivery_status?: Maybe<Scalars['String']>;
  delivery_type?: Maybe<Scalars['String']>;
  feed_type?: Maybe<Scalars['String']>;
  go_live_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  on_hold_date?: Maybe<Scalars['timestamptz']>;
  on_hold_reason?: Maybe<Scalars['String']>;
  ordered_date?: Maybe<Scalars['date']>;
  platform_partner_backfill?: Maybe<Scalars['String']>;
  platform_partner_primary?: Maybe<Scalars['String']>;
  playout?: Maybe<Scalars['String']>;
  point_product_delivery_id?: Maybe<Scalars['String']>;
  provisioning_start_date?: Maybe<Scalars['date']>;
  redundancy?: Maybe<Scalars['Int']>;
  request_origin?: Maybe<Scalars['String']>;
  rn?: Maybe<Scalars['bigint']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_order_id?: Maybe<Scalars['String']>;
  salesforce_order_item_id?: Maybe<Scalars['String']>;
  salesforce_order_product_id?: Maybe<Scalars['String']>;
  salesforce_order_product_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
  ssai_fee_owner?: Maybe<Scalars['String']>;
  ts_setup?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Delivery_Main_Min_Fields = {
  __typename?: 'delivery_main_min_fields';
  ad_load_minutes?: Maybe<Scalars['Int']>;
  ads_plus?: Maybe<Scalars['String']>;
  amagi_share_backfill?: Maybe<Scalars['String']>;
  amagi_share_primary?: Maybe<Scalars['String']>;
  assignee?: Maybe<Scalars['String']>;
  cdn_fee_owner?: Maybe<Scalars['String']>;
  cdn_tag_1?: Maybe<Scalars['String']>;
  cdn_tag_2?: Maybe<Scalars['String']>;
  cdn_tag_3?: Maybe<Scalars['String']>;
  cdn_tag_4?: Maybe<Scalars['String']>;
  cdp_delivery_type?: Maybe<Scalars['String']>;
  churned_date?: Maybe<Scalars['date']>;
  churned_reason?: Maybe<Scalars['String']>;
  connect_distribution_model?: Maybe<Scalars['String']>;
  content_partner_backfill?: Maybe<Scalars['String']>;
  content_partner_primary?: Maybe<Scalars['String']>;
  content_plus?: Maybe<Scalars['String']>;
  deal_split_amagi_share?: Maybe<Scalars['Int']>;
  deal_split_with_content_partner?: Maybe<Scalars['Int']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Int']>;
  deal_type_for_content_partner?: Maybe<Scalars['String']>;
  deal_type_for_platform_partner?: Maybe<Scalars['String']>;
  delivered_date?: Maybe<Scalars['date']>;
  delivered_using_amagi_now?: Maybe<Scalars['String']>;
  delivery_status?: Maybe<Scalars['String']>;
  delivery_type?: Maybe<Scalars['String']>;
  feed_type?: Maybe<Scalars['String']>;
  go_live_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  on_hold_date?: Maybe<Scalars['timestamptz']>;
  on_hold_reason?: Maybe<Scalars['String']>;
  ordered_date?: Maybe<Scalars['date']>;
  platform_partner_backfill?: Maybe<Scalars['String']>;
  platform_partner_primary?: Maybe<Scalars['String']>;
  playout?: Maybe<Scalars['String']>;
  point_product_delivery_id?: Maybe<Scalars['String']>;
  provisioning_start_date?: Maybe<Scalars['date']>;
  redundancy?: Maybe<Scalars['Int']>;
  request_origin?: Maybe<Scalars['String']>;
  rn?: Maybe<Scalars['bigint']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_order_id?: Maybe<Scalars['String']>;
  salesforce_order_item_id?: Maybe<Scalars['String']>;
  salesforce_order_product_id?: Maybe<Scalars['String']>;
  salesforce_order_product_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
  ssai_fee_owner?: Maybe<Scalars['String']>;
  ts_setup?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "delivery_main". */
export type Delivery_Main_Order_By = {
  ad_load_minutes?: InputMaybe<Order_By>;
  ads_plus?: InputMaybe<Order_By>;
  amagi_share_backfill?: InputMaybe<Order_By>;
  amagi_share_primary?: InputMaybe<Order_By>;
  assignee?: InputMaybe<Order_By>;
  audio_languages?: InputMaybe<Order_By>;
  business_model?: InputMaybe<Order_By>;
  cdn_fee_owner?: InputMaybe<Order_By>;
  cdn_tag_1?: Maybe<Scalars['String']>;
  cdn_tag_2?: Maybe<Scalars['String']>;
  cdn_tag_3?: Maybe<Scalars['String']>;
  cdn_tag_4?: Maybe<Scalars['String']>;
  cdp_delivery_type?: InputMaybe<Order_By>;
  churned_date?: InputMaybe<Order_By>;
  churned_reason?: InputMaybe<Order_By>;
  connect_distribution_model?: InputMaybe<Order_By>;
  content_partner_backfill?: InputMaybe<Order_By>;
  content_partner_primary?: InputMaybe<Order_By>;
  content_plus?: InputMaybe<Order_By>;
  deal_split_amagi_share?: InputMaybe<Order_By>;
  deal_split_with_content_partner?: InputMaybe<Order_By>;
  deal_split_with_platform_partner?: InputMaybe<Order_By>;
  deal_type_for_content_partner?: InputMaybe<Order_By>;
  deal_type_for_platform_partner?: InputMaybe<Order_By>;
  delivered_date?: InputMaybe<Order_By>;
  delivered_region?: InputMaybe<Order_By>;
  delivered_using_amagi_now?: InputMaybe<Order_By>;
  delivery_published_to_amagi_now?: InputMaybe<Order_By>;
  delivery_share_aggregate?: InputMaybe<Fn_Return_Delivery_Share_Aggregate_Order_By>;
  delivery_status?: InputMaybe<Order_By>;
  delivery_stream_type?: InputMaybe<Order_By>;
  delivery_to_channel?: InputMaybe<Channel_Order_By>;
  delivery_to_delivery_timeline?: InputMaybe<Delivery_Timeline_Order_By>;
  delivery_to_order?: InputMaybe<Order_Order_By>;
  delivery_to_platform?: InputMaybe<Platform_Order_By>;
  delivery_type?: InputMaybe<Order_By>;
  feed_type?: InputMaybe<Order_By>;
  go_live_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  on_hold_date?: InputMaybe<Order_By>;
  on_hold_reason?: InputMaybe<Order_By>;
  ordered_date?: InputMaybe<Order_By>;
  platform_partner_backfill?: InputMaybe<Order_By>;
  platform_partner_primary?: InputMaybe<Order_By>;
  playout?: InputMaybe<Order_By>;
  point_product_delivery_id?: InputMaybe<Order_By>;
  product_purchased_for_this_delivery?: InputMaybe<Order_By>;
  provisioning_start_date?: InputMaybe<Order_By>;
  redundancy?: InputMaybe<Order_By>;
  request_origin?: InputMaybe<Order_By>;
  rn?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_order_id?: InputMaybe<Order_By>;
  salesforce_order_item_id?: InputMaybe<Order_By>;
  salesforce_order_product_id?: InputMaybe<Order_By>;
  salesforce_order_product_last_modified_date?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
  ssai?: InputMaybe<Order_By>;
  ssai_fee_owner?: InputMaybe<Order_By>;
  ts_setup?: InputMaybe<Order_By>;
  turnaround?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** select columns of table "delivery_main" */
export enum Delivery_Main_Select_Column {
  /** column name */
  AdLoadMinutes = 'ad_load_minutes',
  /** column name */
  AdsPlus = 'ads_plus',
  /** column name */
  AmagiShareBackfill = 'amagi_share_backfill',
  /** column name */
  AmagiSharePrimary = 'amagi_share_primary',
  /** column name */
  Assignee = 'assignee',
  /** column name */
  AudioLanguages = 'audio_languages',
  /** column name */
  BusinessModel = 'business_model',
  /** column name */
  CdnFeeOwner = 'cdn_fee_owner',
  /** column name */
  CdnTag_1 = 'cdn_tag_1',
  /** column name */
  CdnTag_2 = 'cdn_tag_2',
  /** column name */
  CdnTag_3 = 'cdn_tag_3',
  /** column name */
  CdnTag_4 = 'cdn_tag_4',
  /** column name */
  CdpDeliveryType = 'cdp_delivery_type',
  /** column name */
  ChurnedDate = 'churned_date',
  /** column name */
  ChurnedReason = 'churned_reason',
  /** column name */
  ConnectDistributionModel = 'connect_distribution_model',
  /** column name */
  ContentPartnerBackfill = 'content_partner_backfill',
  /** column name */
  ContentPartnerPrimary = 'content_partner_primary',
  /** column name */
  ContentPlus = 'content_plus',
  /** column name */
  DealSplitAmagiShare = 'deal_split_amagi_share',
  /** column name */
  DealSplitWithContentPartner = 'deal_split_with_content_partner',
  /** column name */
  DealSplitWithPlatformPartner = 'deal_split_with_platform_partner',
  /** column name */
  DealTypeForContentPartner = 'deal_type_for_content_partner',
  /** column name */
  DealTypeForPlatformPartner = 'deal_type_for_platform_partner',
  /** column name */
  DeliveredDate = 'delivered_date',
  /** column name */
  DeliveredRegion = 'delivered_region',
  /** column name */
  DeliveredUsingAmagiNow = 'delivered_using_amagi_now',
  /** column name */
  DeliveryPublishedToAmagiNow = 'delivery_published_to_amagi_now',
  /** column name */
  DeliveryStatus = 'delivery_status',
  /** column name */
  DeliveryStreamType = 'delivery_stream_type',
  /** column name */
  DeliveryType = 'delivery_type',
  /** column name */
  FeedType = 'feed_type',
  /** column name */
  GoLiveDate = 'go_live_date',
  /** column name */
  Id = 'id',
  /** column name */
  OnHoldDate = 'on_hold_date',
  /** column name */
  OnHoldReason = 'on_hold_reason',
  /** column name */
  OrderedDate = 'ordered_date',
  /** column name */
  PlatformPartnerBackfill = 'platform_partner_backfill',
  /** column name */
  PlatformPartnerPrimary = 'platform_partner_primary',
  /** column name */
  Playout = 'playout',
  /** column name */
  PointProductDeliveryId = 'point_product_delivery_id',
  /** column name */
  ProductPurchasedForThisDelivery = 'product_purchased_for_this_delivery',
  /** column name */
  ProvisioningStartDate = 'provisioning_start_date',
  /** column name */
  Redundancy = 'redundancy',
  /** column name */
  RequestOrigin = 'request_origin',
  /** column name */
  Rn = 'rn',
  /** column name */
  SalesforceChannelId = 'salesforce_channel_id',
  /** column name */
  SalesforceOrderId = 'salesforce_order_id',
  /** column name */
  SalesforceOrderItemId = 'salesforce_order_item_id',
  /** column name */
  SalesforceOrderProductId = 'salesforce_order_product_id',
  /** column name */
  SalesforceOrderProductLastModifiedDate = 'salesforce_order_product_last_modified_date',
  /** column name */
  SalesforcePlatformId = 'salesforce_platform_id',
  /** column name */
  Ssai = 'ssai',
  /** column name */
  SsaiFeeOwner = 'ssai_fee_owner',
  /** column name */
  TsSetup = 'ts_setup',
  /** column name */
  Turnaround = 'turnaround',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Delivery_Main_Stddev_Fields = {
  __typename?: 'delivery_main_stddev_fields';
  ad_load_minutes?: Maybe<Scalars['Float']>;
  deal_split_amagi_share?: Maybe<Scalars['Float']>;
  deal_split_with_content_partner?: Maybe<Scalars['Float']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Float']>;
  redundancy?: Maybe<Scalars['Float']>;
  rn?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Delivery_Main_Stddev_Pop_Fields = {
  __typename?: 'delivery_main_stddev_pop_fields';
  ad_load_minutes?: Maybe<Scalars['Float']>;
  deal_split_amagi_share?: Maybe<Scalars['Float']>;
  deal_split_with_content_partner?: Maybe<Scalars['Float']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Float']>;
  redundancy?: Maybe<Scalars['Float']>;
  rn?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Delivery_Main_Stddev_Samp_Fields = {
  __typename?: 'delivery_main_stddev_samp_fields';
  ad_load_minutes?: Maybe<Scalars['Float']>;
  deal_split_amagi_share?: Maybe<Scalars['Float']>;
  deal_split_with_content_partner?: Maybe<Scalars['Float']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Float']>;
  redundancy?: Maybe<Scalars['Float']>;
  rn?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "delivery_main" */
export type Delivery_Main_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delivery_Main_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delivery_Main_Stream_Cursor_Value_Input = {
  ad_load_minutes?: InputMaybe<Scalars['Int']>;
  ads_plus?: InputMaybe<Scalars['String']>;
  amagi_share_backfill?: InputMaybe<Scalars['String']>;
  amagi_share_primary?: InputMaybe<Scalars['String']>;
  assignee?: InputMaybe<Scalars['String']>;
  audio_languages?: InputMaybe<Scalars['jsonb']>;
  business_model?: InputMaybe<Scalars['jsonb']>;
  cdn_fee_owner?: InputMaybe<Scalars['String']>;
  cdn_tag_1?: InputMaybe<Scalars['String']>;
  cdn_tag_2?: InputMaybe<Scalars['String']>;
  cdn_tag_3?: InputMaybe<Scalars['String']>;
  cdn_tag_4?: InputMaybe<Scalars['String']>;
  cdp_delivery_type?: InputMaybe<Scalars['String']>;
  churned_date?: InputMaybe<Scalars['date']>;
  churned_reason?: InputMaybe<Scalars['String']>;
  connect_distribution_model?: InputMaybe<Scalars['String']>;
  content_partner_backfill?: InputMaybe<Scalars['String']>;
  content_partner_primary?: InputMaybe<Scalars['String']>;
  content_plus?: InputMaybe<Scalars['String']>;
  deal_split_amagi_share?: InputMaybe<Scalars['Int']>;
  deal_split_with_content_partner?: InputMaybe<Scalars['Int']>;
  deal_split_with_platform_partner?: InputMaybe<Scalars['Int']>;
  deal_type_for_content_partner?: InputMaybe<Scalars['String']>;
  deal_type_for_platform_partner?: InputMaybe<Scalars['String']>;
  delivered_date?: InputMaybe<Scalars['date']>;
  delivered_region?: InputMaybe<Scalars['jsonb']>;
  delivered_using_amagi_now?: InputMaybe<Scalars['String']>;
  delivery_published_to_amagi_now?: InputMaybe<Scalars['Boolean']>;
  delivery_status?: InputMaybe<Scalars['String']>;
  delivery_stream_type?: InputMaybe<Scalars['jsonb']>;
  delivery_type?: InputMaybe<Scalars['String']>;
  feed_type?: InputMaybe<Scalars['String']>;
  go_live_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  on_hold_date?: InputMaybe<Scalars['timestamptz']>;
  on_hold_reason?: InputMaybe<Scalars['String']>;
  ordered_date?: InputMaybe<Scalars['date']>;
  platform_partner_backfill?: InputMaybe<Scalars['String']>;
  platform_partner_primary?: InputMaybe<Scalars['String']>;
  playout?: InputMaybe<Scalars['String']>;
  point_product_delivery_id?: InputMaybe<Scalars['String']>;
  product_purchased_for_this_delivery?: InputMaybe<Scalars['jsonb']>;
  provisioning_start_date?: InputMaybe<Scalars['date']>;
  redundancy?: InputMaybe<Scalars['Int']>;
  request_origin?: InputMaybe<Scalars['String']>;
  rn?: InputMaybe<Scalars['bigint']>;
  salesforce_channel_id?: InputMaybe<Scalars['String']>;
  salesforce_order_id?: InputMaybe<Scalars['String']>;
  salesforce_order_item_id?: InputMaybe<Scalars['String']>;
  salesforce_order_product_id?: InputMaybe<Scalars['String']>;
  salesforce_order_product_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_platform_id?: InputMaybe<Scalars['String']>;
  ssai?: InputMaybe<Scalars['Boolean']>;
  ssai_fee_owner?: InputMaybe<Scalars['String']>;
  ts_setup?: InputMaybe<Scalars['String']>;
  turnaround?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Delivery_Main_Sum_Fields = {
  __typename?: 'delivery_main_sum_fields';
  ad_load_minutes?: Maybe<Scalars['Int']>;
  deal_split_amagi_share?: Maybe<Scalars['Int']>;
  deal_split_with_content_partner?: Maybe<Scalars['Int']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Int']>;
  redundancy?: Maybe<Scalars['Int']>;
  rn?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Delivery_Main_Var_Pop_Fields = {
  __typename?: 'delivery_main_var_pop_fields';
  ad_load_minutes?: Maybe<Scalars['Float']>;
  deal_split_amagi_share?: Maybe<Scalars['Float']>;
  deal_split_with_content_partner?: Maybe<Scalars['Float']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Float']>;
  redundancy?: Maybe<Scalars['Float']>;
  rn?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Delivery_Main_Var_Samp_Fields = {
  __typename?: 'delivery_main_var_samp_fields';
  ad_load_minutes?: Maybe<Scalars['Float']>;
  deal_split_amagi_share?: Maybe<Scalars['Float']>;
  deal_split_with_content_partner?: Maybe<Scalars['Float']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Float']>;
  redundancy?: Maybe<Scalars['Float']>;
  rn?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Delivery_Main_Variance_Fields = {
  __typename?: 'delivery_main_variance_fields';
  ad_load_minutes?: Maybe<Scalars['Float']>;
  deal_split_amagi_share?: Maybe<Scalars['Float']>;
  deal_split_with_content_partner?: Maybe<Scalars['Float']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Float']>;
  redundancy?: Maybe<Scalars['Float']>;
  rn?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Delivery_Max_Fields = {
  __typename?: 'delivery_max_fields';
  ad_load_minutes?: Maybe<Scalars['Int']>;
  ads_plus?: Maybe<Scalars['String']>;
  amagi_share_backfill?: Maybe<Scalars['String']>;
  amagi_share_primary?: Maybe<Scalars['String']>;
  assignee?: Maybe<Scalars['String']>;
  blocked_reason?: Maybe<Scalars['String']>;
  blocked_reason_details?: Maybe<Scalars['String']>;
  cdn_fee_owner?: Maybe<Scalars['String']>;
  cdn_tag_1?: InputMaybe<Scalars['String']>;
  cdn_tag_2?: InputMaybe<Scalars['String']>;
  cdn_tag_3?: InputMaybe<Scalars['String']>;
  cdn_tag_4?: InputMaybe<Scalars['String']>;
  cdp_delivery_type?: Maybe<Scalars['String']>;
  churned_date?: Maybe<Scalars['date']>;
  churned_reason?: Maybe<Scalars['String']>;
  connect_distribution_model?: Maybe<Scalars['String']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  content_partner_backfill?: Maybe<Scalars['String']>;
  content_partner_primary?: Maybe<Scalars['String']>;
  content_plus?: Maybe<Scalars['String']>;
  deal_split_amagi_share?: Maybe<Scalars['Int']>;
  deal_split_with_content_partner?: Maybe<Scalars['Int']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Int']>;
  deal_type_for_content_partner?: Maybe<Scalars['String']>;
  deal_type_for_platform_partner?: Maybe<Scalars['String']>;
  delivered_date?: Maybe<Scalars['date']>;
  delivered_using_amagi_now?: Maybe<Scalars['String']>;
  delivery_status?: Maybe<Scalars['String']>;
  delivery_type?: Maybe<Scalars['String']>;
  epg_url?: Maybe<Scalars['String']>;
  feed_type?: Maybe<Scalars['String']>;
  go_live_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  inventory_share_amagi_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_amagi_primary_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_content_partner_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_content_partner_primary_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_platform_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_platform_primary_ad_tag?: Maybe<Scalars['String']>;
  on_hold_date?: Maybe<Scalars['timestamptz']>;
  on_hold_reason?: Maybe<Scalars['String']>;
  ordered_date?: Maybe<Scalars['date']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  platform_partner_backfill?: Maybe<Scalars['String']>;
  platform_partner_primary?: Maybe<Scalars['String']>;
  playout?: Maybe<Scalars['String']>;
  point_product_delivery_id?: Maybe<Scalars['String']>;
  provisioning_start_date?: Maybe<Scalars['date']>;
  redundancy?: Maybe<Scalars['Int']>;
  request_origin?: Maybe<Scalars['String']>;
  revenue_share_backfill_ad_tag?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_backfill?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_primary?: Maybe<Scalars['String']>;
  revenue_share_primary_ad_tag?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_order_id?: Maybe<Scalars['String']>;
  salesforce_order_item_id?: Maybe<Scalars['String']>;
  salesforce_order_product_id?: Maybe<Scalars['String']>;
  salesforce_order_product_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
  ssai_fee_owner?: Maybe<Scalars['String']>;
  stream_url?: Maybe<Scalars['String']>;
  test_delivery?: Maybe<Scalars['String']>;
  ts_setup?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "delivery" */
export type Delivery_Max_Order_By = {
  ad_load_minutes?: InputMaybe<Order_By>;
  ads_plus?: InputMaybe<Order_By>;
  amagi_share_backfill?: InputMaybe<Order_By>;
  amagi_share_primary?: InputMaybe<Order_By>;
  assignee?: InputMaybe<Order_By>;
  blocked_reason?: InputMaybe<Order_By>;
  blocked_reason_details?: InputMaybe<Order_By>;
  cdn_fee_owner?: InputMaybe<Order_By>;
  cdn_tag_1?: InputMaybe<Scalars['String']>;
  cdn_tag_2?: InputMaybe<Scalars['String']>;
  cdn_tag_3?: InputMaybe<Scalars['String']>;
  cdn_tag_4?: InputMaybe<Scalars['String']>;
  cdp_delivery_type?: InputMaybe<Order_By>;
  churned_date?: InputMaybe<Order_By>;
  churned_reason?: InputMaybe<Order_By>;
  connect_distribution_model?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  content_partner_backfill?: InputMaybe<Order_By>;
  content_partner_primary?: InputMaybe<Order_By>;
  content_plus?: InputMaybe<Order_By>;
  deal_split_amagi_share?: InputMaybe<Order_By>;
  deal_split_with_content_partner?: InputMaybe<Order_By>;
  deal_split_with_platform_partner?: InputMaybe<Order_By>;
  deal_type_for_content_partner?: InputMaybe<Order_By>;
  deal_type_for_platform_partner?: InputMaybe<Order_By>;
  delivered_date?: InputMaybe<Order_By>;
  delivered_using_amagi_now?: InputMaybe<Order_By>;
  delivery_status?: InputMaybe<Order_By>;
  delivery_type?: InputMaybe<Order_By>;
  epg_url?: InputMaybe<Order_By>;
  feed_type?: InputMaybe<Order_By>;
  go_live_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inventory_share_amagi_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_amagi_primary_ad_tag?: InputMaybe<Order_By>;
  inventory_share_content_partner_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_content_partner_primary_ad_tag?: InputMaybe<Order_By>;
  inventory_share_platform_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_platform_primary_ad_tag?: InputMaybe<Order_By>;
  on_hold_date?: InputMaybe<Order_By>;
  on_hold_reason?: InputMaybe<Order_By>;
  ordered_date?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  platform_partner_backfill?: InputMaybe<Order_By>;
  platform_partner_primary?: InputMaybe<Order_By>;
  playout?: InputMaybe<Order_By>;
  point_product_delivery_id?: InputMaybe<Order_By>;
  provisioning_start_date?: InputMaybe<Order_By>;
  redundancy?: InputMaybe<Order_By>;
  request_origin?: InputMaybe<Order_By>;
  revenue_share_backfill_ad_tag?: InputMaybe<Order_By>;
  revenue_share_monetised_by_backfill?: InputMaybe<Order_By>;
  revenue_share_monetised_by_primary?: InputMaybe<Order_By>;
  revenue_share_primary_ad_tag?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_order_id?: InputMaybe<Order_By>;
  salesforce_order_item_id?: InputMaybe<Order_By>;
  salesforce_order_product_id?: InputMaybe<Order_By>;
  salesforce_order_product_last_modified_date?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
  ssai_fee_owner?: InputMaybe<Order_By>;
  stream_url?: InputMaybe<Order_By>;
  test_delivery?: InputMaybe<Order_By>;
  ts_setup?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Delivery_Min_Fields = {
  __typename?: 'delivery_min_fields';
  ad_load_minutes?: Maybe<Scalars['Int']>;
  ads_plus?: Maybe<Scalars['String']>;
  amagi_share_backfill?: Maybe<Scalars['String']>;
  amagi_share_primary?: Maybe<Scalars['String']>;
  assignee?: Maybe<Scalars['String']>;
  blocked_reason?: Maybe<Scalars['String']>;
  blocked_reason_details?: Maybe<Scalars['String']>;
  cdn_fee_owner?: Maybe<Scalars['String']>;
  cdn_tag_1?: InputMaybe<Scalars['String']>;
  cdn_tag_2?: InputMaybe<Scalars['String']>;
  cdn_tag_3?: InputMaybe<Scalars['String']>;
  cdn_tag_4?: InputMaybe<Scalars['String']>;
  cdp_delivery_type?: Maybe<Scalars['String']>;
  churned_date?: Maybe<Scalars['date']>;
  churned_reason?: Maybe<Scalars['String']>;
  connect_distribution_model?: Maybe<Scalars['String']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  content_partner_backfill?: Maybe<Scalars['String']>;
  content_partner_primary?: Maybe<Scalars['String']>;
  content_plus?: Maybe<Scalars['String']>;
  deal_split_amagi_share?: Maybe<Scalars['Int']>;
  deal_split_with_content_partner?: Maybe<Scalars['Int']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Int']>;
  deal_type_for_content_partner?: Maybe<Scalars['String']>;
  deal_type_for_platform_partner?: Maybe<Scalars['String']>;
  delivered_date?: Maybe<Scalars['date']>;
  delivered_using_amagi_now?: Maybe<Scalars['String']>;
  delivery_status?: Maybe<Scalars['String']>;
  delivery_type?: Maybe<Scalars['String']>;
  epg_url?: Maybe<Scalars['String']>;
  feed_type?: Maybe<Scalars['String']>;
  go_live_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  inventory_share_amagi_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_amagi_primary_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_content_partner_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_content_partner_primary_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_platform_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_platform_primary_ad_tag?: Maybe<Scalars['String']>;
  on_hold_date?: Maybe<Scalars['timestamptz']>;
  on_hold_reason?: Maybe<Scalars['String']>;
  ordered_date?: Maybe<Scalars['date']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  platform_partner_backfill?: Maybe<Scalars['String']>;
  platform_partner_primary?: Maybe<Scalars['String']>;
  playout?: Maybe<Scalars['String']>;
  point_product_delivery_id?: Maybe<Scalars['String']>;
  provisioning_start_date?: Maybe<Scalars['date']>;
  redundancy?: Maybe<Scalars['Int']>;
  request_origin?: Maybe<Scalars['String']>;
  revenue_share_backfill_ad_tag?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_backfill?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_primary?: Maybe<Scalars['String']>;
  revenue_share_primary_ad_tag?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_order_id?: Maybe<Scalars['String']>;
  salesforce_order_item_id?: Maybe<Scalars['String']>;
  salesforce_order_product_id?: Maybe<Scalars['String']>;
  salesforce_order_product_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
  ssai_fee_owner?: Maybe<Scalars['String']>;
  stream_url?: Maybe<Scalars['String']>;
  test_delivery?: Maybe<Scalars['String']>;
  ts_setup?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "delivery" */
export type Delivery_Min_Order_By = {
  ad_load_minutes?: InputMaybe<Order_By>;
  ads_plus?: InputMaybe<Order_By>;
  amagi_share_backfill?: InputMaybe<Order_By>;
  amagi_share_primary?: InputMaybe<Order_By>;
  assignee?: InputMaybe<Order_By>;
  blocked_reason?: InputMaybe<Order_By>;
  blocked_reason_details?: InputMaybe<Order_By>;
  cdn_fee_owner?: InputMaybe<Order_By>;
  cdn_tag_1?: InputMaybe<Scalars['String']>;
  cdn_tag_2?: InputMaybe<Scalars['String']>;
  cdn_tag_3?: InputMaybe<Scalars['String']>;
  cdn_tag_4?: InputMaybe<Scalars['String']>;
  cdp_delivery_type?: InputMaybe<Order_By>;
  churned_date?: InputMaybe<Order_By>;
  churned_reason?: InputMaybe<Order_By>;
  connect_distribution_model?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  content_partner_backfill?: InputMaybe<Order_By>;
  content_partner_primary?: InputMaybe<Order_By>;
  content_plus?: InputMaybe<Order_By>;
  deal_split_amagi_share?: InputMaybe<Order_By>;
  deal_split_with_content_partner?: InputMaybe<Order_By>;
  deal_split_with_platform_partner?: InputMaybe<Order_By>;
  deal_type_for_content_partner?: InputMaybe<Order_By>;
  deal_type_for_platform_partner?: InputMaybe<Order_By>;
  delivered_date?: InputMaybe<Order_By>;
  delivered_using_amagi_now?: InputMaybe<Order_By>;
  delivery_status?: InputMaybe<Order_By>;
  delivery_type?: InputMaybe<Order_By>;
  epg_url?: InputMaybe<Order_By>;
  feed_type?: InputMaybe<Order_By>;
  go_live_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inventory_share_amagi_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_amagi_primary_ad_tag?: InputMaybe<Order_By>;
  inventory_share_content_partner_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_content_partner_primary_ad_tag?: InputMaybe<Order_By>;
  inventory_share_platform_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_platform_primary_ad_tag?: InputMaybe<Order_By>;
  on_hold_date?: InputMaybe<Order_By>;
  on_hold_reason?: InputMaybe<Order_By>;
  ordered_date?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  platform_partner_backfill?: InputMaybe<Order_By>;
  platform_partner_primary?: InputMaybe<Order_By>;
  playout?: InputMaybe<Order_By>;
  point_product_delivery_id?: InputMaybe<Order_By>;
  provisioning_start_date?: InputMaybe<Order_By>;
  redundancy?: InputMaybe<Order_By>;
  request_origin?: InputMaybe<Order_By>;
  revenue_share_backfill_ad_tag?: InputMaybe<Order_By>;
  revenue_share_monetised_by_backfill?: InputMaybe<Order_By>;
  revenue_share_monetised_by_primary?: InputMaybe<Order_By>;
  revenue_share_primary_ad_tag?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_order_id?: InputMaybe<Order_By>;
  salesforce_order_item_id?: InputMaybe<Order_By>;
  salesforce_order_product_id?: InputMaybe<Order_By>;
  salesforce_order_product_last_modified_date?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
  ssai_fee_owner?: InputMaybe<Order_By>;
  stream_url?: InputMaybe<Order_By>;
  test_delivery?: InputMaybe<Order_By>;
  ts_setup?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "delivery" */
export type Delivery_Mutation_Response = {
  __typename?: 'delivery_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Delivery>;
};

/** columns and relationships of "delivery_now" */
export type Delivery_Now = {
  __typename?: 'delivery_now';
  amagi_id?: Maybe<Scalars['String']>;
  channel_code?: Maybe<Scalars['String']>;
  delivery_id?: Maybe<Scalars['String']>;
  error_code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  platform_code?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "delivery_now". All fields are combined with a logical 'AND'. */
export type Delivery_Now_Bool_Exp = {
  _and?: InputMaybe<Array<Delivery_Now_Bool_Exp>>;
  _not?: InputMaybe<Delivery_Now_Bool_Exp>;
  _or?: InputMaybe<Array<Delivery_Now_Bool_Exp>>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  channel_code?: InputMaybe<String_Comparison_Exp>;
  delivery_id?: InputMaybe<String_Comparison_Exp>;
  error_code?: InputMaybe<String_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  platform_code?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "delivery_now". */
export type Delivery_Now_Order_By = {
  amagi_id?: InputMaybe<Order_By>;
  channel_code?: InputMaybe<Order_By>;
  delivery_id?: InputMaybe<Order_By>;
  error_code?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  platform_code?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "delivery_now" */
export enum Delivery_Now_Select_Column {
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  ChannelCode = 'channel_code',
  /** column name */
  DeliveryId = 'delivery_id',
  /** column name */
  ErrorCode = 'error_code',
  /** column name */
  Message = 'message',
  /** column name */
  PlatformCode = 'platform_code',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type'
}

/** Streaming cursor of the table "delivery_now" */
export type Delivery_Now_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delivery_Now_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delivery_Now_Stream_Cursor_Value_Input = {
  amagi_id?: InputMaybe<Scalars['String']>;
  channel_code?: InputMaybe<Scalars['String']>;
  delivery_id?: InputMaybe<Scalars['String']>;
  error_code?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  platform_code?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** Ordering options when selecting data from "delivery". */
export type Delivery_Order_By = {
  ad_load_minutes?: InputMaybe<Order_By>;
  ads_plus?: InputMaybe<Order_By>;
  amagi_share_backfill?: InputMaybe<Order_By>;
  amagi_share_primary?: InputMaybe<Order_By>;
  assignee?: InputMaybe<Order_By>;
  audio_languages?: InputMaybe<Order_By>;
  blocked_reason?: InputMaybe<Order_By>;
  blocked_reason_details?: InputMaybe<Order_By>;
  business_model?: InputMaybe<Order_By>;
  cdn_fee_owner?: InputMaybe<Order_By>;
  cdn_tag_1?: InputMaybe<Scalars['String']>;
  cdn_tag_2?: InputMaybe<Scalars['String']>;
  cdn_tag_3?: InputMaybe<Scalars['String']>;
  cdn_tag_4?: InputMaybe<Scalars['String']>;
  cdp_delivery_type?: InputMaybe<Order_By>;
  churned_date?: InputMaybe<Order_By>;
  churned_reason?: InputMaybe<Order_By>;
  connect_distribution_model?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  content_partner_backfill?: InputMaybe<Order_By>;
  content_partner_primary?: InputMaybe<Order_By>;
  content_plus?: InputMaybe<Order_By>;
  deal_split_amagi_share?: InputMaybe<Order_By>;
  deal_split_with_content_partner?: InputMaybe<Order_By>;
  deal_split_with_platform_partner?: InputMaybe<Order_By>;
  deal_type_for_content_partner?: InputMaybe<Order_By>;
  deal_type_for_platform_partner?: InputMaybe<Order_By>;
  delivered_date?: InputMaybe<Order_By>;
  delivered_region?: InputMaybe<Order_By>;
  delivered_using_amagi_now?: InputMaybe<Order_By>;
  delivery_published_to_amagi_now?: InputMaybe<Order_By>;
  delivery_status?: InputMaybe<Order_By>;
  delivery_stream_type?: InputMaybe<Order_By>;
  delivery_to_channel?: InputMaybe<Channel_Order_By>;
  delivery_to_delivery_timeline?: InputMaybe<Delivery_Timeline_Order_By>;
  delivery_to_order?: InputMaybe<Order_Order_By>;
  delivery_to_platform?: InputMaybe<Platform_Order_By>;
  delivery_type?: InputMaybe<Order_By>;
  epg_url?: InputMaybe<Order_By>;
  feed_type?: InputMaybe<Order_By>;
  go_live_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inventory_share_amagi_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_amagi_primary_ad_tag?: InputMaybe<Order_By>;
  inventory_share_content_partner_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_content_partner_primary_ad_tag?: InputMaybe<Order_By>;
  inventory_share_platform_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_platform_primary_ad_tag?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_deleted_order?: InputMaybe<Order_By>;
  on_hold_date?: InputMaybe<Order_By>;
  on_hold_reason?: InputMaybe<Order_By>;
  ordered_date?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  platform_partner_backfill?: InputMaybe<Order_By>;
  platform_partner_primary?: InputMaybe<Order_By>;
  playout?: InputMaybe<Order_By>;
  point_product_delivery_id?: InputMaybe<Order_By>;
  product_purchased_for_this_delivery?: InputMaybe<Order_By>;
  provisioning_start_date?: InputMaybe<Order_By>;
  redundancy?: InputMaybe<Order_By>;
  request_origin?: InputMaybe<Order_By>;
  revenue_share_backfill_ad_tag?: InputMaybe<Order_By>;
  revenue_share_monetised_by_backfill?: InputMaybe<Order_By>;
  revenue_share_monetised_by_primary?: InputMaybe<Order_By>;
  revenue_share_primary_ad_tag?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_order_id?: InputMaybe<Order_By>;
  salesforce_order_item_id?: InputMaybe<Order_By>;
  salesforce_order_product_id?: InputMaybe<Order_By>;
  salesforce_order_product_last_modified_date?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
  ssai?: InputMaybe<Order_By>;
  ssai_fee_owner?: InputMaybe<Order_By>;
  stream_url?: InputMaybe<Order_By>;
  test_delivery?: InputMaybe<Order_By>;
  transcoding?: InputMaybe<Order_By>;
  ts_setup?: InputMaybe<Order_By>;
  turnaround?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
};

export type Delivery_Payload_Args = {
  _order_product_id?: InputMaybe<Scalars['String']>;
};

/** primary key columns input for table: delivery */
export type Delivery_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Delivery_Prepend_Input = {
  audio_languages?: InputMaybe<Scalars['jsonb']>;
  business_model?: InputMaybe<Scalars['jsonb']>;
  delivered_region?: InputMaybe<Scalars['jsonb']>;
  delivery_stream_type?: InputMaybe<Scalars['jsonb']>;
  product_purchased_for_this_delivery?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "delivery" */
export enum Delivery_Select_Column {
  /** column name */
  AdLoadMinutes = 'ad_load_minutes',
  /** column name */
  AdsPlus = 'ads_plus',
  /** column name */
  AmagiShareBackfill = 'amagi_share_backfill',
  /** column name */
  AmagiSharePrimary = 'amagi_share_primary',
  /** column name */
  Assignee = 'assignee',
  /** column name */
  AudioLanguages = 'audio_languages',
  /** column name */
  BlockedReason = 'blocked_reason',
  /** column name */
  BlockedReasonDetails = 'blocked_reason_details',
  /** column name */
  BusinessModel = 'business_model',
  /** column name */
  CdnFeeOwner = 'cdn_fee_owner',
  /** column name */
  /** column name */
  CdnTag_1 = 'cdn_tag_1',
  /** column name */
  CdnTag_2 = 'cdn_tag_2',
  /** column name */
  CdnTag_3 = 'cdn_tag_3',
  /** column name */
  CdnTag_4 = 'cdn_tag_4',
  CdpDeliveryType = 'cdp_delivery_type',
  /** column name */
  ChurnedDate = 'churned_date',
  /** column name */
  ChurnedReason = 'churned_reason',
  /** column name */
  ConnectDistributionModel = 'connect_distribution_model',
  /** column name */
  ContentPartnerAdSalesCommissionPercentage = 'content_partner_ad_sales_commission_percentage',
  /** column name */
  ContentPartnerBackfill = 'content_partner_backfill',
  /** column name */
  ContentPartnerPrimary = 'content_partner_primary',
  /** column name */
  ContentPlus = 'content_plus',
  /** column name */
  DealSplitAmagiShare = 'deal_split_amagi_share',
  /** column name */
  DealSplitWithContentPartner = 'deal_split_with_content_partner',
  /** column name */
  DealSplitWithPlatformPartner = 'deal_split_with_platform_partner',
  /** column name */
  DealTypeForContentPartner = 'deal_type_for_content_partner',
  /** column name */
  DealTypeForPlatformPartner = 'deal_type_for_platform_partner',
  /** column name */
  DeliveredDate = 'delivered_date',
  /** column name */
  DeliveredRegion = 'delivered_region',
  /** column name */
  DeliveredUsingAmagiNow = 'delivered_using_amagi_now',
  /** column name */
  DeliveryPublishedToAmagiNow = 'delivery_published_to_amagi_now',
  /** column name */
  DeliveryStatus = 'delivery_status',
  /** column name */
  DeliveryStreamType = 'delivery_stream_type',
  /** column name */
  DeliveryType = 'delivery_type',
  /** column name */
  EpgUrl = 'epg_url',
  /** column name */
  FeedType = 'feed_type',
  /** column name */
  GoLiveDate = 'go_live_date',
  /** column name */
  Id = 'id',
  /** column name */
  InventoryShareAmagiBackfillAdTag = 'inventory_share_amagi_backfill_ad_tag',
  /** column name */
  InventoryShareAmagiPrimaryAdTag = 'inventory_share_amagi_primary_ad_tag',
  /** column name */
  InventoryShareContentPartnerBackfillAdTag = 'inventory_share_content_partner_backfill_ad_tag',
  /** column name */
  InventoryShareContentPartnerPrimaryAdTag = 'inventory_share_content_partner_primary_ad_tag',
  /** column name */
  InventorySharePlatformBackfillAdTag = 'inventory_share_platform_backfill_ad_tag',
  /** column name */
  InventorySharePlatformPrimaryAdTag = 'inventory_share_platform_primary_ad_tag',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDeletedOrder = 'is_deleted_order',
  /** column name */
  OnHoldDate = 'on_hold_date',
  /** column name */
  OnHoldReason = 'on_hold_reason',
  /** column name */
  OrderedDate = 'ordered_date',
  /** column name */
  PlatformAdSalesCommissionPercentage = 'platform_ad_sales_commission_percentage',
  /** column name */
  PlatformPartnerBackfill = 'platform_partner_backfill',
  /** column name */
  PlatformPartnerPrimary = 'platform_partner_primary',
  /** column name */
  Playout = 'playout',
  /** column name */
  PointProductDeliveryId = 'point_product_delivery_id',
  /** column name */
  ProductPurchasedForThisDelivery = 'product_purchased_for_this_delivery',
  /** column name */
  ProvisioningStartDate = 'provisioning_start_date',
  /** column name */
  Redundancy = 'redundancy',
  /** column name */
  RequestOrigin = 'request_origin',
  /** column name */
  RevenueShareBackfillAdTag = 'revenue_share_backfill_ad_tag',
  /** column name */
  RevenueShareMonetisedByBackfill = 'revenue_share_monetised_by_backfill',
  /** column name */
  RevenueShareMonetisedByPrimary = 'revenue_share_monetised_by_primary',
  /** column name */
  RevenueSharePrimaryAdTag = 'revenue_share_primary_ad_tag',
  /** column name */
  SalesforceChannelId = 'salesforce_channel_id',
  /** column name */
  SalesforceOrderId = 'salesforce_order_id',
  /** column name */
  SalesforceOrderItemId = 'salesforce_order_item_id',
  /** column name */
  SalesforceOrderProductId = 'salesforce_order_product_id',
  /** column name */
  SalesforceOrderProductLastModifiedDate = 'salesforce_order_product_last_modified_date',
  /** column name */
  SalesforcePlatformId = 'salesforce_platform_id',
  /** column name */
  Ssai = 'ssai',
  /** column name */
  SsaiFeeOwner = 'ssai_fee_owner',
  /** column name */
  StreamUrl = 'stream_url',
  /** column name */
  TestDelivery = 'test_delivery',
  /** column name */
  Transcoding = 'transcoding',
  /** column name */
  TsSetup = 'ts_setup',
  /** column name */
  Turnaround = 'turnaround',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "delivery_aggregate_bool_exp_bool_and_arguments_columns" columns of table "delivery" */
export enum Delivery_Select_Column_Delivery_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DeliveryPublishedToAmagiNow = 'delivery_published_to_amagi_now',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDeletedOrder = 'is_deleted_order',
  /** column name */
  Ssai = 'ssai',
  /** column name */
  Transcoding = 'transcoding',
  /** column name */
  Turnaround = 'turnaround'
}

/** select "delivery_aggregate_bool_exp_bool_or_arguments_columns" columns of table "delivery" */
export enum Delivery_Select_Column_Delivery_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DeliveryPublishedToAmagiNow = 'delivery_published_to_amagi_now',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDeletedOrder = 'is_deleted_order',
  /** column name */
  Ssai = 'ssai',
  /** column name */
  Transcoding = 'transcoding',
  /** column name */
  Turnaround = 'turnaround'
}

/** input type for updating data in table "delivery" */
export type Delivery_Set_Input = {
  ad_load_minutes?: InputMaybe<Scalars['Int']>;
  ads_plus?: InputMaybe<Scalars['String']>;
  amagi_share_backfill?: InputMaybe<Scalars['String']>;
  amagi_share_primary?: InputMaybe<Scalars['String']>;
  assignee?: InputMaybe<Scalars['String']>;
  audio_languages?: InputMaybe<Scalars['jsonb']>;
  business_model?: InputMaybe<Scalars['jsonb']>;
  cdn_fee_owner?: InputMaybe<Scalars['String']>;
  cdn_tag_1?: InputMaybe<Scalars['String']>;
  cdn_tag_2?: InputMaybe<Scalars['String']>;
  cdn_tag_3?: InputMaybe<Scalars['String']>;
  cdn_tag_4?: InputMaybe<Scalars['String']>;
  connect_distribution_model?: InputMaybe<Scalars['String']>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Scalars['numeric']>;
  content_partner_backfill?: InputMaybe<Scalars['String']>;
  content_partner_primary?: InputMaybe<Scalars['String']>;
  content_plus?: InputMaybe<Scalars['String']>;
  deal_split_amagi_share?: InputMaybe<Scalars['Int']>;
  deal_split_with_content_partner?: InputMaybe<Scalars['Int']>;
  deal_split_with_platform_partner?: InputMaybe<Scalars['Int']>;
  deal_type_for_content_partner?: InputMaybe<Scalars['String']>;
  deal_type_for_platform_partner?: InputMaybe<Scalars['String']>;
  delivered_date?: InputMaybe<Scalars['date']>;
  delivered_region?: InputMaybe<Scalars['jsonb']>;
  delivery_published_to_amagi_now?: InputMaybe<Scalars['Boolean']>;
  delivery_stream_type?: InputMaybe<Scalars['jsonb']>;
  delivery_type?: InputMaybe<Scalars['String']>;
  feed_type?: InputMaybe<Scalars['String']>;
  go_live_date?: InputMaybe<Scalars['date']>;
  inventory_share_amagi_backfill_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_amagi_primary_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_content_partner_backfill_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_content_partner_primary_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_platform_backfill_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_platform_primary_ad_tag?: InputMaybe<Scalars['String']>;
  on_hold_date?: InputMaybe<Scalars['timestamptz']>;
  on_hold_reason?: InputMaybe<Scalars['String']>;
  ordered_date?: InputMaybe<Scalars['date']>;
  platform_ad_sales_commission_percentage?: InputMaybe<Scalars['numeric']>;
  platform_partner_backfill?: InputMaybe<Scalars['String']>;
  platform_partner_primary?: InputMaybe<Scalars['String']>;
  playout?: InputMaybe<Scalars['String']>;
  point_product_delivery_id?: InputMaybe<Scalars['String']>;
  product_purchased_for_this_delivery?: InputMaybe<Scalars['jsonb']>;
  provisioning_start_date?: InputMaybe<Scalars['date']>;
  redundancy?: InputMaybe<Scalars['Int']>;
  request_origin?: InputMaybe<Scalars['String']>;
  revenue_share_backfill_ad_tag?: InputMaybe<Scalars['String']>;
  revenue_share_monetised_by_backfill?: InputMaybe<Scalars['String']>;
  revenue_share_monetised_by_primary?: InputMaybe<Scalars['String']>;
  revenue_share_primary_ad_tag?: InputMaybe<Scalars['String']>;
  salesforce_order_product_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  ssai?: InputMaybe<Scalars['Boolean']>;
  ssai_fee_owner?: InputMaybe<Scalars['String']>;
  test_delivery?: InputMaybe<Scalars['String']>;
  transcoding?: InputMaybe<Scalars['Boolean']>;
  ts_setup?: InputMaybe<Scalars['String']>;
  turnaround?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Delivery_Stddev_Fields = {
  __typename?: 'delivery_stddev_fields';
  ad_load_minutes?: Maybe<Scalars['Float']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  deal_split_amagi_share?: Maybe<Scalars['Float']>;
  deal_split_with_content_partner?: Maybe<Scalars['Float']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Float']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  redundancy?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "delivery" */
export type Delivery_Stddev_Order_By = {
  ad_load_minutes?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  deal_split_amagi_share?: InputMaybe<Order_By>;
  deal_split_with_content_partner?: InputMaybe<Order_By>;
  deal_split_with_platform_partner?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  redundancy?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Delivery_Stddev_Pop_Fields = {
  __typename?: 'delivery_stddev_pop_fields';
  ad_load_minutes?: Maybe<Scalars['Float']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  deal_split_amagi_share?: Maybe<Scalars['Float']>;
  deal_split_with_content_partner?: Maybe<Scalars['Float']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Float']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  redundancy?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "delivery" */
export type Delivery_Stddev_Pop_Order_By = {
  ad_load_minutes?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  deal_split_amagi_share?: InputMaybe<Order_By>;
  deal_split_with_content_partner?: InputMaybe<Order_By>;
  deal_split_with_platform_partner?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  redundancy?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Delivery_Stddev_Samp_Fields = {
  __typename?: 'delivery_stddev_samp_fields';
  ad_load_minutes?: Maybe<Scalars['Float']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  deal_split_amagi_share?: Maybe<Scalars['Float']>;
  deal_split_with_content_partner?: Maybe<Scalars['Float']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Float']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  redundancy?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "delivery" */
export type Delivery_Stddev_Samp_Order_By = {
  ad_load_minutes?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  deal_split_amagi_share?: InputMaybe<Order_By>;
  deal_split_with_content_partner?: InputMaybe<Order_By>;
  deal_split_with_platform_partner?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  redundancy?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "delivery" */
export type Delivery_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delivery_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delivery_Stream_Cursor_Value_Input = {
  ad_load_minutes?: InputMaybe<Scalars['Int']>;
  ads_plus?: InputMaybe<Scalars['String']>;
  amagi_share_backfill?: InputMaybe<Scalars['String']>;
  amagi_share_primary?: InputMaybe<Scalars['String']>;
  assignee?: InputMaybe<Scalars['String']>;
  audio_languages?: InputMaybe<Scalars['jsonb']>;
  blocked_reason?: InputMaybe<Scalars['String']>;
  blocked_reason_details?: InputMaybe<Scalars['String']>;
  business_model?: InputMaybe<Scalars['jsonb']>;
  cdn_fee_owner?: InputMaybe<Scalars['String']>;
  cdn_tag_1?: InputMaybe<Scalars['String']>;
  cdn_tag_2?: InputMaybe<Scalars['String']>;
  cdn_tag_3?: InputMaybe<Scalars['String']>;
  cdn_tag_4?: InputMaybe<Scalars['String']>;
  cdp_delivery_type?: InputMaybe<Scalars['String']>;
  churned_date?: InputMaybe<Scalars['date']>;
  churned_reason?: InputMaybe<Scalars['String']>;
  connect_distribution_model?: InputMaybe<Scalars['String']>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Scalars['numeric']>;
  content_partner_backfill?: InputMaybe<Scalars['String']>;
  content_partner_primary?: InputMaybe<Scalars['String']>;
  content_plus?: InputMaybe<Scalars['String']>;
  deal_split_amagi_share?: InputMaybe<Scalars['Int']>;
  deal_split_with_content_partner?: InputMaybe<Scalars['Int']>;
  deal_split_with_platform_partner?: InputMaybe<Scalars['Int']>;
  deal_type_for_content_partner?: InputMaybe<Scalars['String']>;
  deal_type_for_platform_partner?: InputMaybe<Scalars['String']>;
  delivered_date?: InputMaybe<Scalars['date']>;
  delivered_region?: InputMaybe<Scalars['jsonb']>;
  delivered_using_amagi_now?: InputMaybe<Scalars['String']>;
  delivery_published_to_amagi_now?: InputMaybe<Scalars['Boolean']>;
  delivery_status?: InputMaybe<Scalars['String']>;
  delivery_stream_type?: InputMaybe<Scalars['jsonb']>;
  delivery_type?: InputMaybe<Scalars['String']>;
  epg_url?: InputMaybe<Scalars['String']>;
  feed_type?: InputMaybe<Scalars['String']>;
  go_live_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  inventory_share_amagi_backfill_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_amagi_primary_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_content_partner_backfill_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_content_partner_primary_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_platform_backfill_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_platform_primary_ad_tag?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_deleted_order?: InputMaybe<Scalars['Boolean']>;
  on_hold_date?: InputMaybe<Scalars['timestamptz']>;
  on_hold_reason?: InputMaybe<Scalars['String']>;
  ordered_date?: InputMaybe<Scalars['date']>;
  platform_ad_sales_commission_percentage?: InputMaybe<Scalars['numeric']>;
  platform_partner_backfill?: InputMaybe<Scalars['String']>;
  platform_partner_primary?: InputMaybe<Scalars['String']>;
  playout?: InputMaybe<Scalars['String']>;
  point_product_delivery_id?: InputMaybe<Scalars['String']>;
  product_purchased_for_this_delivery?: InputMaybe<Scalars['jsonb']>;
  provisioning_start_date?: InputMaybe<Scalars['date']>;
  redundancy?: InputMaybe<Scalars['Int']>;
  request_origin?: InputMaybe<Scalars['String']>;
  revenue_share_backfill_ad_tag?: InputMaybe<Scalars['String']>;
  revenue_share_monetised_by_backfill?: InputMaybe<Scalars['String']>;
  revenue_share_monetised_by_primary?: InputMaybe<Scalars['String']>;
  revenue_share_primary_ad_tag?: InputMaybe<Scalars['String']>;
  salesforce_channel_id?: InputMaybe<Scalars['String']>;
  salesforce_order_id?: InputMaybe<Scalars['String']>;
  salesforce_order_item_id?: InputMaybe<Scalars['String']>;
  salesforce_order_product_id?: InputMaybe<Scalars['String']>;
  salesforce_order_product_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_platform_id?: InputMaybe<Scalars['String']>;
  ssai?: InputMaybe<Scalars['Boolean']>;
  ssai_fee_owner?: InputMaybe<Scalars['String']>;
  stream_url?: InputMaybe<Scalars['String']>;
  test_delivery?: InputMaybe<Scalars['String']>;
  transcoding?: InputMaybe<Scalars['Boolean']>;
  ts_setup?: InputMaybe<Scalars['String']>;
  turnaround?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Delivery_Sum_Fields = {
  __typename?: 'delivery_sum_fields';
  ad_load_minutes?: Maybe<Scalars['Int']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  deal_split_amagi_share?: Maybe<Scalars['Int']>;
  deal_split_with_content_partner?: Maybe<Scalars['Int']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Int']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  redundancy?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "delivery" */
export type Delivery_Sum_Order_By = {
  ad_load_minutes?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  deal_split_amagi_share?: InputMaybe<Order_By>;
  deal_split_with_content_partner?: InputMaybe<Order_By>;
  deal_split_with_platform_partner?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  redundancy?: InputMaybe<Order_By>;
};

/** columns and relationships of "delivery_timeline" */
export type Delivery_Timeline = {
  __typename?: 'delivery_timeline';
  churned_date?: Maybe<Scalars['date']>;
  delivered_date?: Maybe<Scalars['date']>;
  go_live_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  on_hold_date?: Maybe<Scalars['timestamptz']>;
  ordered_date?: Maybe<Scalars['date']>;
  provisioning_start_date?: Maybe<Scalars['date']>;
};

/** aggregated selection of "delivery_timeline" */
export type Delivery_Timeline_Aggregate = {
  __typename?: 'delivery_timeline_aggregate';
  aggregate?: Maybe<Delivery_Timeline_Aggregate_Fields>;
  nodes: Array<Delivery_Timeline>;
};

/** aggregate fields of "delivery_timeline" */
export type Delivery_Timeline_Aggregate_Fields = {
  __typename?: 'delivery_timeline_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Delivery_Timeline_Max_Fields>;
  min?: Maybe<Delivery_Timeline_Min_Fields>;
};


/** aggregate fields of "delivery_timeline" */
export type Delivery_Timeline_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Delivery_Timeline_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "delivery_timeline". All fields are combined with a logical 'AND'. */
export type Delivery_Timeline_Bool_Exp = {
  _and?: InputMaybe<Array<Delivery_Timeline_Bool_Exp>>;
  _not?: InputMaybe<Delivery_Timeline_Bool_Exp>;
  _or?: InputMaybe<Array<Delivery_Timeline_Bool_Exp>>;
  churned_date?: InputMaybe<Date_Comparison_Exp>;
  delivered_date?: InputMaybe<Date_Comparison_Exp>;
  go_live_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  on_hold_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  ordered_date?: InputMaybe<Date_Comparison_Exp>;
  provisioning_start_date?: InputMaybe<Date_Comparison_Exp>;
};

/** aggregate max on columns */
export type Delivery_Timeline_Max_Fields = {
  __typename?: 'delivery_timeline_max_fields';
  churned_date?: Maybe<Scalars['date']>;
  delivered_date?: Maybe<Scalars['date']>;
  go_live_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  on_hold_date?: Maybe<Scalars['timestamptz']>;
  ordered_date?: Maybe<Scalars['date']>;
  provisioning_start_date?: Maybe<Scalars['date']>;
};

/** aggregate min on columns */
export type Delivery_Timeline_Min_Fields = {
  __typename?: 'delivery_timeline_min_fields';
  churned_date?: Maybe<Scalars['date']>;
  delivered_date?: Maybe<Scalars['date']>;
  go_live_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  on_hold_date?: Maybe<Scalars['timestamptz']>;
  ordered_date?: Maybe<Scalars['date']>;
  provisioning_start_date?: Maybe<Scalars['date']>;
};

/** Ordering options when selecting data from "delivery_timeline". */
export type Delivery_Timeline_Order_By = {
  churned_date?: InputMaybe<Order_By>;
  delivered_date?: InputMaybe<Order_By>;
  go_live_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  on_hold_date?: InputMaybe<Order_By>;
  ordered_date?: InputMaybe<Order_By>;
  provisioning_start_date?: InputMaybe<Order_By>;
};

/** select columns of table "delivery_timeline" */
export enum Delivery_Timeline_Select_Column {
  /** column name */
  ChurnedDate = 'churned_date',
  /** column name */
  DeliveredDate = 'delivered_date',
  /** column name */
  GoLiveDate = 'go_live_date',
  /** column name */
  Id = 'id',
  /** column name */
  OnHoldDate = 'on_hold_date',
  /** column name */
  OrderedDate = 'ordered_date',
  /** column name */
  ProvisioningStartDate = 'provisioning_start_date'
}

/** Streaming cursor of the table "delivery_timeline" */
export type Delivery_Timeline_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Delivery_Timeline_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Delivery_Timeline_Stream_Cursor_Value_Input = {
  churned_date?: InputMaybe<Scalars['date']>;
  delivered_date?: InputMaybe<Scalars['date']>;
  go_live_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  on_hold_date?: InputMaybe<Scalars['timestamptz']>;
  ordered_date?: InputMaybe<Scalars['date']>;
  provisioning_start_date?: InputMaybe<Scalars['date']>;
};

export type Delivery_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Delivery_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Delivery_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Delivery_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Delivery_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Delivery_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Delivery_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Delivery_Set_Input>;
  /** filter the rows which have to be updated */
  where: Delivery_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Delivery_Var_Pop_Fields = {
  __typename?: 'delivery_var_pop_fields';
  ad_load_minutes?: Maybe<Scalars['Float']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  deal_split_amagi_share?: Maybe<Scalars['Float']>;
  deal_split_with_content_partner?: Maybe<Scalars['Float']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Float']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  redundancy?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "delivery" */
export type Delivery_Var_Pop_Order_By = {
  ad_load_minutes?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  deal_split_amagi_share?: InputMaybe<Order_By>;
  deal_split_with_content_partner?: InputMaybe<Order_By>;
  deal_split_with_platform_partner?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  redundancy?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Delivery_Var_Samp_Fields = {
  __typename?: 'delivery_var_samp_fields';
  ad_load_minutes?: Maybe<Scalars['Float']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  deal_split_amagi_share?: Maybe<Scalars['Float']>;
  deal_split_with_content_partner?: Maybe<Scalars['Float']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Float']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  redundancy?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "delivery" */
export type Delivery_Var_Samp_Order_By = {
  ad_load_minutes?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  deal_split_amagi_share?: InputMaybe<Order_By>;
  deal_split_with_content_partner?: InputMaybe<Order_By>;
  deal_split_with_platform_partner?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  redundancy?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Delivery_Variance_Fields = {
  __typename?: 'delivery_variance_fields';
  ad_load_minutes?: Maybe<Scalars['Float']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  deal_split_amagi_share?: Maybe<Scalars['Float']>;
  deal_split_with_content_partner?: Maybe<Scalars['Float']>;
  deal_split_with_platform_partner?: Maybe<Scalars['Float']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  redundancy?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "delivery" */
export type Delivery_Variance_Order_By = {
  ad_load_minutes?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  deal_split_amagi_share?: InputMaybe<Order_By>;
  deal_split_with_content_partner?: InputMaybe<Order_By>;
  deal_split_with_platform_partner?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  redundancy?: InputMaybe<Order_By>;
};

export type Domain_Exist_Args = {
  email?: InputMaybe<Scalars['String']>;
  full_email?: InputMaybe<Scalars['String']>;
};

export type Email_Exist_Args = {
  email?: InputMaybe<Scalars['String']>;
};

export type Existing_New_Churned_Dashboard_Args = {
  from_date?: InputMaybe<Scalars['String']>;
};

export type Existing_New_Churned_Dashboard_Channel_Args = {
  from_date?: InputMaybe<Scalars['String']>;
};

export type Existing_New_Churned_Platform_Dashboard_Args = {
  from_date?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "feature_flag" */
export type Feature_Flag = {
  __typename?: 'feature_flag';
  feature: Scalars['String'];
  roles?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "feature_flag" */
export type Feature_FlagRolesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "feature_flag". All fields are combined with a logical 'AND'. */
export type Feature_Flag_Bool_Exp = {
  _and?: InputMaybe<Array<Feature_Flag_Bool_Exp>>;
  _not?: InputMaybe<Feature_Flag_Bool_Exp>;
  _or?: InputMaybe<Array<Feature_Flag_Bool_Exp>>;
  feature?: InputMaybe<String_Comparison_Exp>;
  roles?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Ordering options when selecting data from "feature_flag". */
export type Feature_Flag_Order_By = {
  feature?: InputMaybe<Order_By>;
  roles?: InputMaybe<Order_By>;
};

/** select columns of table "feature_flag" */
export enum Feature_Flag_Select_Column {
  /** column name */
  Feature = 'feature',
  /** column name */
  Roles = 'roles'
}

/** Streaming cursor of the table "feature_flag" */
export type Feature_Flag_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Feature_Flag_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Feature_Flag_Stream_Cursor_Value_Input = {
  feature?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

/** columns and relationships of "fn_return.account_statement" */
export type Fn_Return_Account_Statement = {
  __typename?: 'fn_return_account_statement';
  balance?: Maybe<Scalars['numeric']>;
  charges?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
  transaction_date: Scalars['String'];
  transaction_id?: Maybe<Scalars['String']>;
  transaction_type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fn_return.account_statement" */
export type Fn_Return_Account_Statement_Aggregate = {
  __typename?: 'fn_return_account_statement_aggregate';
  aggregate?: Maybe<Fn_Return_Account_Statement_Aggregate_Fields>;
  nodes: Array<Fn_Return_Account_Statement>;
};

/** aggregate fields of "fn_return.account_statement" */
export type Fn_Return_Account_Statement_Aggregate_Fields = {
  __typename?: 'fn_return_account_statement_aggregate_fields';
  avg?: Maybe<Fn_Return_Account_Statement_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Account_Statement_Max_Fields>;
  min?: Maybe<Fn_Return_Account_Statement_Min_Fields>;
  stddev?: Maybe<Fn_Return_Account_Statement_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Account_Statement_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Account_Statement_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Account_Statement_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Account_Statement_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Account_Statement_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Account_Statement_Variance_Fields>;
};


/** aggregate fields of "fn_return.account_statement" */
export type Fn_Return_Account_Statement_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Account_Statement_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fn_Return_Account_Statement_Avg_Fields = {
  __typename?: 'fn_return_account_statement_avg_fields';
  balance?: Maybe<Scalars['Float']>;
  charges?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fn_return.account_statement". All fields are combined with a logical 'AND'. */
export type Fn_Return_Account_Statement_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Account_Statement_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Account_Statement_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Account_Statement_Bool_Exp>>;
  balance?: InputMaybe<Numeric_Comparison_Exp>;
  charges?: InputMaybe<Numeric_Comparison_Exp>;
  payment?: InputMaybe<Numeric_Comparison_Exp>;
  transaction_date?: InputMaybe<String_Comparison_Exp>;
  transaction_id?: InputMaybe<String_Comparison_Exp>;
  transaction_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fn_Return_Account_Statement_Max_Fields = {
  __typename?: 'fn_return_account_statement_max_fields';
  balance?: Maybe<Scalars['numeric']>;
  charges?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
  transaction_date?: Maybe<Scalars['String']>;
  transaction_id?: Maybe<Scalars['String']>;
  transaction_type?: Maybe<Scalars['String']>;
};

/** columns and relationships of "fn_return.account_statement_meta" */
export type Fn_Return_Account_Statement_Meta = {
  __typename?: 'fn_return_account_statement_meta';
  count?: Maybe<Scalars['bigint']>;
  transaction_type: Scalars['String'];
};

/** aggregated selection of "fn_return.account_statement_meta" */
export type Fn_Return_Account_Statement_Meta_Aggregate = {
  __typename?: 'fn_return_account_statement_meta_aggregate';
  aggregate?: Maybe<Fn_Return_Account_Statement_Meta_Aggregate_Fields>;
  nodes: Array<Fn_Return_Account_Statement_Meta>;
};

/** aggregate fields of "fn_return.account_statement_meta" */
export type Fn_Return_Account_Statement_Meta_Aggregate_Fields = {
  __typename?: 'fn_return_account_statement_meta_aggregate_fields';
  avg?: Maybe<Fn_Return_Account_Statement_Meta_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Account_Statement_Meta_Max_Fields>;
  min?: Maybe<Fn_Return_Account_Statement_Meta_Min_Fields>;
  stddev?: Maybe<Fn_Return_Account_Statement_Meta_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Account_Statement_Meta_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Account_Statement_Meta_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Account_Statement_Meta_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Account_Statement_Meta_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Account_Statement_Meta_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Account_Statement_Meta_Variance_Fields>;
};


/** aggregate fields of "fn_return.account_statement_meta" */
export type Fn_Return_Account_Statement_Meta_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Account_Statement_Meta_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fn_Return_Account_Statement_Meta_Avg_Fields = {
  __typename?: 'fn_return_account_statement_meta_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fn_return.account_statement_meta". All fields are combined with a logical 'AND'. */
export type Fn_Return_Account_Statement_Meta_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Account_Statement_Meta_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Account_Statement_Meta_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Account_Statement_Meta_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  transaction_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fn_Return_Account_Statement_Meta_Max_Fields = {
  __typename?: 'fn_return_account_statement_meta_max_fields';
  count?: Maybe<Scalars['bigint']>;
  transaction_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Fn_Return_Account_Statement_Meta_Min_Fields = {
  __typename?: 'fn_return_account_statement_meta_min_fields';
  count?: Maybe<Scalars['bigint']>;
  transaction_type?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "fn_return.account_statement_meta". */
export type Fn_Return_Account_Statement_Meta_Order_By = {
  count?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.account_statement_meta" */
export enum Fn_Return_Account_Statement_Meta_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  TransactionType = 'transaction_type'
}

/** aggregate stddev on columns */
export type Fn_Return_Account_Statement_Meta_Stddev_Fields = {
  __typename?: 'fn_return_account_statement_meta_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Account_Statement_Meta_Stddev_Pop_Fields = {
  __typename?: 'fn_return_account_statement_meta_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Account_Statement_Meta_Stddev_Samp_Fields = {
  __typename?: 'fn_return_account_statement_meta_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fn_return_account_statement_meta" */
export type Fn_Return_Account_Statement_Meta_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Account_Statement_Meta_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Account_Statement_Meta_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  transaction_type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Fn_Return_Account_Statement_Meta_Sum_Fields = {
  __typename?: 'fn_return_account_statement_meta_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Fn_Return_Account_Statement_Meta_Var_Pop_Fields = {
  __typename?: 'fn_return_account_statement_meta_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Account_Statement_Meta_Var_Samp_Fields = {
  __typename?: 'fn_return_account_statement_meta_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fn_Return_Account_Statement_Meta_Variance_Fields = {
  __typename?: 'fn_return_account_statement_meta_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** aggregate min on columns */
export type Fn_Return_Account_Statement_Min_Fields = {
  __typename?: 'fn_return_account_statement_min_fields';
  balance?: Maybe<Scalars['numeric']>;
  charges?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
  transaction_date?: Maybe<Scalars['String']>;
  transaction_id?: Maybe<Scalars['String']>;
  transaction_type?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "fn_return.account_statement". */
export type Fn_Return_Account_Statement_Order_By = {
  balance?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  transaction_type?: InputMaybe<Order_By>;
};

/** columns and relationships of "fn_return.account_statement_outstanding" */
export type Fn_Return_Account_Statement_Outstanding = {
  __typename?: 'fn_return_account_statement_outstanding';
  balance?: Maybe<Scalars['numeric']>;
  outstanding: Scalars['String'];
};

/** aggregated selection of "fn_return.account_statement_outstanding" */
export type Fn_Return_Account_Statement_Outstanding_Aggregate = {
  __typename?: 'fn_return_account_statement_outstanding_aggregate';
  aggregate?: Maybe<Fn_Return_Account_Statement_Outstanding_Aggregate_Fields>;
  nodes: Array<Fn_Return_Account_Statement_Outstanding>;
};

/** aggregate fields of "fn_return.account_statement_outstanding" */
export type Fn_Return_Account_Statement_Outstanding_Aggregate_Fields = {
  __typename?: 'fn_return_account_statement_outstanding_aggregate_fields';
  avg?: Maybe<Fn_Return_Account_Statement_Outstanding_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Account_Statement_Outstanding_Max_Fields>;
  min?: Maybe<Fn_Return_Account_Statement_Outstanding_Min_Fields>;
  stddev?: Maybe<Fn_Return_Account_Statement_Outstanding_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Account_Statement_Outstanding_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Account_Statement_Outstanding_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Account_Statement_Outstanding_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Account_Statement_Outstanding_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Account_Statement_Outstanding_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Account_Statement_Outstanding_Variance_Fields>;
};


/** aggregate fields of "fn_return.account_statement_outstanding" */
export type Fn_Return_Account_Statement_Outstanding_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Account_Statement_Outstanding_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fn_Return_Account_Statement_Outstanding_Avg_Fields = {
  __typename?: 'fn_return_account_statement_outstanding_avg_fields';
  balance?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fn_return.account_statement_outstanding". All fields are combined with a logical 'AND'. */
export type Fn_Return_Account_Statement_Outstanding_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Account_Statement_Outstanding_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Account_Statement_Outstanding_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Account_Statement_Outstanding_Bool_Exp>>;
  balance?: InputMaybe<Numeric_Comparison_Exp>;
  outstanding?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fn_Return_Account_Statement_Outstanding_Max_Fields = {
  __typename?: 'fn_return_account_statement_outstanding_max_fields';
  balance?: Maybe<Scalars['numeric']>;
  outstanding?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Fn_Return_Account_Statement_Outstanding_Min_Fields = {
  __typename?: 'fn_return_account_statement_outstanding_min_fields';
  balance?: Maybe<Scalars['numeric']>;
  outstanding?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "fn_return.account_statement_outstanding". */
export type Fn_Return_Account_Statement_Outstanding_Order_By = {
  balance?: InputMaybe<Order_By>;
  outstanding?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.account_statement_outstanding" */
export enum Fn_Return_Account_Statement_Outstanding_Select_Column {
  /** column name */
  Balance = 'balance',
  /** column name */
  Outstanding = 'outstanding'
}

/** aggregate stddev on columns */
export type Fn_Return_Account_Statement_Outstanding_Stddev_Fields = {
  __typename?: 'fn_return_account_statement_outstanding_stddev_fields';
  balance?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Account_Statement_Outstanding_Stddev_Pop_Fields = {
  __typename?: 'fn_return_account_statement_outstanding_stddev_pop_fields';
  balance?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Account_Statement_Outstanding_Stddev_Samp_Fields = {
  __typename?: 'fn_return_account_statement_outstanding_stddev_samp_fields';
  balance?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fn_return_account_statement_outstanding" */
export type Fn_Return_Account_Statement_Outstanding_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Account_Statement_Outstanding_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Account_Statement_Outstanding_Stream_Cursor_Value_Input = {
  balance?: InputMaybe<Scalars['numeric']>;
  outstanding?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Fn_Return_Account_Statement_Outstanding_Sum_Fields = {
  __typename?: 'fn_return_account_statement_outstanding_sum_fields';
  balance?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Fn_Return_Account_Statement_Outstanding_Var_Pop_Fields = {
  __typename?: 'fn_return_account_statement_outstanding_var_pop_fields';
  balance?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Account_Statement_Outstanding_Var_Samp_Fields = {
  __typename?: 'fn_return_account_statement_outstanding_var_samp_fields';
  balance?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fn_Return_Account_Statement_Outstanding_Variance_Fields = {
  __typename?: 'fn_return_account_statement_outstanding_variance_fields';
  balance?: Maybe<Scalars['Float']>;
};

/** select columns of table "fn_return.account_statement" */
export enum Fn_Return_Account_Statement_Select_Column {
  /** column name */
  Balance = 'balance',
  /** column name */
  Charges = 'charges',
  /** column name */
  Payment = 'payment',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  TransactionType = 'transaction_type'
}

/** aggregate stddev on columns */
export type Fn_Return_Account_Statement_Stddev_Fields = {
  __typename?: 'fn_return_account_statement_stddev_fields';
  balance?: Maybe<Scalars['Float']>;
  charges?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Account_Statement_Stddev_Pop_Fields = {
  __typename?: 'fn_return_account_statement_stddev_pop_fields';
  balance?: Maybe<Scalars['Float']>;
  charges?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Account_Statement_Stddev_Samp_Fields = {
  __typename?: 'fn_return_account_statement_stddev_samp_fields';
  balance?: Maybe<Scalars['Float']>;
  charges?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fn_return_account_statement" */
export type Fn_Return_Account_Statement_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Account_Statement_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Account_Statement_Stream_Cursor_Value_Input = {
  balance?: InputMaybe<Scalars['numeric']>;
  charges?: InputMaybe<Scalars['numeric']>;
  payment?: InputMaybe<Scalars['numeric']>;
  transaction_date?: InputMaybe<Scalars['String']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  transaction_type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Fn_Return_Account_Statement_Sum_Fields = {
  __typename?: 'fn_return_account_statement_sum_fields';
  balance?: Maybe<Scalars['numeric']>;
  charges?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "fn_return.account_statement_summary" */
export type Fn_Return_Account_Statement_Summary = {
  __typename?: 'fn_return_account_statement_summary';
  balance?: Maybe<Scalars['numeric']>;
  charges?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
  total: Scalars['String'];
};

/** aggregated selection of "fn_return.account_statement_summary" */
export type Fn_Return_Account_Statement_Summary_Aggregate = {
  __typename?: 'fn_return_account_statement_summary_aggregate';
  aggregate?: Maybe<Fn_Return_Account_Statement_Summary_Aggregate_Fields>;
  nodes: Array<Fn_Return_Account_Statement_Summary>;
};

/** aggregate fields of "fn_return.account_statement_summary" */
export type Fn_Return_Account_Statement_Summary_Aggregate_Fields = {
  __typename?: 'fn_return_account_statement_summary_aggregate_fields';
  avg?: Maybe<Fn_Return_Account_Statement_Summary_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Account_Statement_Summary_Max_Fields>;
  min?: Maybe<Fn_Return_Account_Statement_Summary_Min_Fields>;
  stddev?: Maybe<Fn_Return_Account_Statement_Summary_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Account_Statement_Summary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Account_Statement_Summary_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Account_Statement_Summary_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Account_Statement_Summary_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Account_Statement_Summary_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Account_Statement_Summary_Variance_Fields>;
};


/** aggregate fields of "fn_return.account_statement_summary" */
export type Fn_Return_Account_Statement_Summary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Account_Statement_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fn_Return_Account_Statement_Summary_Avg_Fields = {
  __typename?: 'fn_return_account_statement_summary_avg_fields';
  balance?: Maybe<Scalars['Float']>;
  charges?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fn_return.account_statement_summary". All fields are combined with a logical 'AND'. */
export type Fn_Return_Account_Statement_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Account_Statement_Summary_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Account_Statement_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Account_Statement_Summary_Bool_Exp>>;
  balance?: InputMaybe<Numeric_Comparison_Exp>;
  charges?: InputMaybe<Numeric_Comparison_Exp>;
  payment?: InputMaybe<Numeric_Comparison_Exp>;
  total?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fn_Return_Account_Statement_Summary_Max_Fields = {
  __typename?: 'fn_return_account_statement_summary_max_fields';
  balance?: Maybe<Scalars['numeric']>;
  charges?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
  total?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Fn_Return_Account_Statement_Summary_Min_Fields = {
  __typename?: 'fn_return_account_statement_summary_min_fields';
  balance?: Maybe<Scalars['numeric']>;
  charges?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
  total?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "fn_return.account_statement_summary". */
export type Fn_Return_Account_Statement_Summary_Order_By = {
  balance?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.account_statement_summary" */
export enum Fn_Return_Account_Statement_Summary_Select_Column {
  /** column name */
  Balance = 'balance',
  /** column name */
  Charges = 'charges',
  /** column name */
  Payment = 'payment',
  /** column name */
  Total = 'total'
}

/** aggregate stddev on columns */
export type Fn_Return_Account_Statement_Summary_Stddev_Fields = {
  __typename?: 'fn_return_account_statement_summary_stddev_fields';
  balance?: Maybe<Scalars['Float']>;
  charges?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Account_Statement_Summary_Stddev_Pop_Fields = {
  __typename?: 'fn_return_account_statement_summary_stddev_pop_fields';
  balance?: Maybe<Scalars['Float']>;
  charges?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Account_Statement_Summary_Stddev_Samp_Fields = {
  __typename?: 'fn_return_account_statement_summary_stddev_samp_fields';
  balance?: Maybe<Scalars['Float']>;
  charges?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fn_return_account_statement_summary" */
export type Fn_Return_Account_Statement_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Account_Statement_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Account_Statement_Summary_Stream_Cursor_Value_Input = {
  balance?: InputMaybe<Scalars['numeric']>;
  charges?: InputMaybe<Scalars['numeric']>;
  payment?: InputMaybe<Scalars['numeric']>;
  total?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Fn_Return_Account_Statement_Summary_Sum_Fields = {
  __typename?: 'fn_return_account_statement_summary_sum_fields';
  balance?: Maybe<Scalars['numeric']>;
  charges?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Fn_Return_Account_Statement_Summary_Var_Pop_Fields = {
  __typename?: 'fn_return_account_statement_summary_var_pop_fields';
  balance?: Maybe<Scalars['Float']>;
  charges?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Account_Statement_Summary_Var_Samp_Fields = {
  __typename?: 'fn_return_account_statement_summary_var_samp_fields';
  balance?: Maybe<Scalars['Float']>;
  charges?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fn_Return_Account_Statement_Summary_Variance_Fields = {
  __typename?: 'fn_return_account_statement_summary_variance_fields';
  balance?: Maybe<Scalars['Float']>;
  charges?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** aggregate var_pop on columns */
export type Fn_Return_Account_Statement_Var_Pop_Fields = {
  __typename?: 'fn_return_account_statement_var_pop_fields';
  balance?: Maybe<Scalars['Float']>;
  charges?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Account_Statement_Var_Samp_Fields = {
  __typename?: 'fn_return_account_statement_var_samp_fields';
  balance?: Maybe<Scalars['Float']>;
  charges?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fn_Return_Account_Statement_Variance_Fields = {
  __typename?: 'fn_return_account_statement_variance_fields';
  balance?: Maybe<Scalars['Float']>;
  charges?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity = {
  __typename?: 'fn_return_avg_service_availibity';
  available_time_secs?: Maybe<Scalars['float8']>;
  avg_service_availability?: Maybe<Scalars['numeric']>;
  down_time_secs?: Maybe<Scalars['numeric']>;
  months: Scalars['date'];
};

/** aggregated selection of "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Aggregate = {
  __typename?: 'fn_return_avg_service_availibity_aggregate';
  aggregate?: Maybe<Fn_Return_Avg_Service_Availibity_Aggregate_Fields>;
  nodes: Array<Fn_Return_Avg_Service_Availibity>;
};

/** aggregate fields of "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Aggregate_Fields = {
  __typename?: 'fn_return_avg_service_availibity_aggregate_fields';
  avg?: Maybe<Fn_Return_Avg_Service_Availibity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Avg_Service_Availibity_Max_Fields>;
  min?: Maybe<Fn_Return_Avg_Service_Availibity_Min_Fields>;
  stddev?: Maybe<Fn_Return_Avg_Service_Availibity_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Avg_Service_Availibity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Avg_Service_Availibity_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Avg_Service_Availibity_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Avg_Service_Availibity_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Avg_Service_Availibity_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Avg_Service_Availibity_Variance_Fields>;
};


/** aggregate fields of "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Avg_Service_Availibity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Aggregate_Order_By = {
  avg?: InputMaybe<Fn_Return_Avg_Service_Availibity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fn_Return_Avg_Service_Availibity_Max_Order_By>;
  min?: InputMaybe<Fn_Return_Avg_Service_Availibity_Min_Order_By>;
  stddev?: InputMaybe<Fn_Return_Avg_Service_Availibity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fn_Return_Avg_Service_Availibity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fn_Return_Avg_Service_Availibity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fn_Return_Avg_Service_Availibity_Sum_Order_By>;
  var_pop?: InputMaybe<Fn_Return_Avg_Service_Availibity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fn_Return_Avg_Service_Availibity_Var_Samp_Order_By>;
  variance?: InputMaybe<Fn_Return_Avg_Service_Availibity_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fn_Return_Avg_Service_Availibity_Avg_Fields = {
  __typename?: 'fn_return_avg_service_availibity_avg_fields';
  available_time_secs?: Maybe<Scalars['Float']>;
  avg_service_availability?: Maybe<Scalars['Float']>;
  down_time_secs?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Avg_Order_By = {
  available_time_secs?: InputMaybe<Order_By>;
  avg_service_availability?: InputMaybe<Order_By>;
  down_time_secs?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fn_return.avg_service_availibity". All fields are combined with a logical 'AND'. */
export type Fn_Return_Avg_Service_Availibity_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Avg_Service_Availibity_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Avg_Service_Availibity_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Avg_Service_Availibity_Bool_Exp>>;
  available_time_secs?: InputMaybe<Float8_Comparison_Exp>;
  avg_service_availability?: InputMaybe<Numeric_Comparison_Exp>;
  down_time_secs?: InputMaybe<Numeric_Comparison_Exp>;
  months?: InputMaybe<Date_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fn_Return_Avg_Service_Availibity_Max_Fields = {
  __typename?: 'fn_return_avg_service_availibity_max_fields';
  available_time_secs?: Maybe<Scalars['float8']>;
  avg_service_availability?: Maybe<Scalars['numeric']>;
  down_time_secs?: Maybe<Scalars['numeric']>;
  months?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Max_Order_By = {
  available_time_secs?: InputMaybe<Order_By>;
  avg_service_availability?: InputMaybe<Order_By>;
  down_time_secs?: InputMaybe<Order_By>;
  months?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fn_Return_Avg_Service_Availibity_Min_Fields = {
  __typename?: 'fn_return_avg_service_availibity_min_fields';
  available_time_secs?: Maybe<Scalars['float8']>;
  avg_service_availability?: Maybe<Scalars['numeric']>;
  down_time_secs?: Maybe<Scalars['numeric']>;
  months?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Min_Order_By = {
  available_time_secs?: InputMaybe<Order_By>;
  avg_service_availability?: InputMaybe<Order_By>;
  down_time_secs?: InputMaybe<Order_By>;
  months?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "fn_return.avg_service_availibity". */
export type Fn_Return_Avg_Service_Availibity_Order_By = {
  available_time_secs?: InputMaybe<Order_By>;
  avg_service_availability?: InputMaybe<Order_By>;
  down_time_secs?: InputMaybe<Order_By>;
  months?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.avg_service_availibity" */
export enum Fn_Return_Avg_Service_Availibity_Select_Column {
  /** column name */
  AvailableTimeSecs = 'available_time_secs',
  /** column name */
  AvgServiceAvailability = 'avg_service_availability',
  /** column name */
  DownTimeSecs = 'down_time_secs',
  /** column name */
  Months = 'months'
}

/** aggregate stddev on columns */
export type Fn_Return_Avg_Service_Availibity_Stddev_Fields = {
  __typename?: 'fn_return_avg_service_availibity_stddev_fields';
  available_time_secs?: Maybe<Scalars['Float']>;
  avg_service_availability?: Maybe<Scalars['Float']>;
  down_time_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Stddev_Order_By = {
  available_time_secs?: InputMaybe<Order_By>;
  avg_service_availability?: InputMaybe<Order_By>;
  down_time_secs?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Avg_Service_Availibity_Stddev_Pop_Fields = {
  __typename?: 'fn_return_avg_service_availibity_stddev_pop_fields';
  available_time_secs?: Maybe<Scalars['Float']>;
  avg_service_availability?: Maybe<Scalars['Float']>;
  down_time_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Stddev_Pop_Order_By = {
  available_time_secs?: InputMaybe<Order_By>;
  avg_service_availability?: InputMaybe<Order_By>;
  down_time_secs?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Avg_Service_Availibity_Stddev_Samp_Fields = {
  __typename?: 'fn_return_avg_service_availibity_stddev_samp_fields';
  available_time_secs?: Maybe<Scalars['Float']>;
  avg_service_availability?: Maybe<Scalars['Float']>;
  down_time_secs?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Stddev_Samp_Order_By = {
  available_time_secs?: InputMaybe<Order_By>;
  avg_service_availability?: InputMaybe<Order_By>;
  down_time_secs?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fn_return_avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Avg_Service_Availibity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Avg_Service_Availibity_Stream_Cursor_Value_Input = {
  available_time_secs?: InputMaybe<Scalars['float8']>;
  avg_service_availability?: InputMaybe<Scalars['numeric']>;
  down_time_secs?: InputMaybe<Scalars['numeric']>;
  months?: InputMaybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type Fn_Return_Avg_Service_Availibity_Sum_Fields = {
  __typename?: 'fn_return_avg_service_availibity_sum_fields';
  available_time_secs?: Maybe<Scalars['float8']>;
  avg_service_availability?: Maybe<Scalars['numeric']>;
  down_time_secs?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Sum_Order_By = {
  available_time_secs?: InputMaybe<Order_By>;
  avg_service_availability?: InputMaybe<Order_By>;
  down_time_secs?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Fn_Return_Avg_Service_Availibity_Var_Pop_Fields = {
  __typename?: 'fn_return_avg_service_availibity_var_pop_fields';
  available_time_secs?: Maybe<Scalars['Float']>;
  avg_service_availability?: Maybe<Scalars['Float']>;
  down_time_secs?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Var_Pop_Order_By = {
  available_time_secs?: InputMaybe<Order_By>;
  avg_service_availability?: InputMaybe<Order_By>;
  down_time_secs?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Avg_Service_Availibity_Var_Samp_Fields = {
  __typename?: 'fn_return_avg_service_availibity_var_samp_fields';
  available_time_secs?: Maybe<Scalars['Float']>;
  avg_service_availability?: Maybe<Scalars['Float']>;
  down_time_secs?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Var_Samp_Order_By = {
  available_time_secs?: InputMaybe<Order_By>;
  avg_service_availability?: InputMaybe<Order_By>;
  down_time_secs?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fn_Return_Avg_Service_Availibity_Variance_Fields = {
  __typename?: 'fn_return_avg_service_availibity_variance_fields';
  available_time_secs?: Maybe<Scalars['Float']>;
  avg_service_availability?: Maybe<Scalars['Float']>;
  down_time_secs?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "fn_return.avg_service_availibity" */
export type Fn_Return_Avg_Service_Availibity_Variance_Order_By = {
  available_time_secs?: InputMaybe<Order_By>;
  avg_service_availability?: InputMaybe<Order_By>;
  down_time_secs?: InputMaybe<Order_By>;
};

/** columns and relationships of "fn_return.billing_summary" */
export type Fn_Return_Billing_Summary = {
  __typename?: 'fn_return_billing_summary';
  amount: Scalars['numeric'];
  count?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "fn_return.billing_summary" */
export type Fn_Return_Billing_Summary_Aggregate = {
  __typename?: 'fn_return_billing_summary_aggregate';
  aggregate?: Maybe<Fn_Return_Billing_Summary_Aggregate_Fields>;
  nodes: Array<Fn_Return_Billing_Summary>;
};

/** aggregate fields of "fn_return.billing_summary" */
export type Fn_Return_Billing_Summary_Aggregate_Fields = {
  __typename?: 'fn_return_billing_summary_aggregate_fields';
  avg?: Maybe<Fn_Return_Billing_Summary_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Billing_Summary_Max_Fields>;
  min?: Maybe<Fn_Return_Billing_Summary_Min_Fields>;
  stddev?: Maybe<Fn_Return_Billing_Summary_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Billing_Summary_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Billing_Summary_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Billing_Summary_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Billing_Summary_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Billing_Summary_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Billing_Summary_Variance_Fields>;
};


/** aggregate fields of "fn_return.billing_summary" */
export type Fn_Return_Billing_Summary_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fn_Return_Billing_Summary_Avg_Fields = {
  __typename?: 'fn_return_billing_summary_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fn_return.billing_summary". All fields are combined with a logical 'AND'. */
export type Fn_Return_Billing_Summary_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Billing_Summary_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Billing_Summary_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fn_Return_Billing_Summary_Max_Fields = {
  __typename?: 'fn_return_billing_summary_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Fn_Return_Billing_Summary_Min_Fields = {
  __typename?: 'fn_return_billing_summary_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  count?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "fn_return.billing_summary". */
export type Fn_Return_Billing_Summary_Order_By = {
  amount?: InputMaybe<Order_By>;
  count?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.billing_summary" */
export enum Fn_Return_Billing_Summary_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Count = 'count'
}

/** aggregate stddev on columns */
export type Fn_Return_Billing_Summary_Stddev_Fields = {
  __typename?: 'fn_return_billing_summary_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Billing_Summary_Stddev_Pop_Fields = {
  __typename?: 'fn_return_billing_summary_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Billing_Summary_Stddev_Samp_Fields = {
  __typename?: 'fn_return_billing_summary_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fn_return_billing_summary" */
export type Fn_Return_Billing_Summary_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Billing_Summary_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Billing_Summary_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  count?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Fn_Return_Billing_Summary_Sum_Fields = {
  __typename?: 'fn_return_billing_summary_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Fn_Return_Billing_Summary_Var_Pop_Fields = {
  __typename?: 'fn_return_billing_summary_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Billing_Summary_Var_Samp_Fields = {
  __typename?: 'fn_return_billing_summary_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fn_Return_Billing_Summary_Variance_Fields = {
  __typename?: 'fn_return_billing_summary_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  count?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fn_return.channel_deliveries_count" */
export type Fn_Return_Channel_Deliveries_Count = {
  __typename?: 'fn_return_channel_deliveries_count';
  count?: Maybe<Scalars['bigint']>;
  delivery_status: Scalars['String'];
};

/** Boolean expression to filter rows from the table "fn_return.channel_deliveries_count". All fields are combined with a logical 'AND'. */
export type Fn_Return_Channel_Deliveries_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Channel_Deliveries_Count_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Channel_Deliveries_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Channel_Deliveries_Count_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  delivery_status?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.channel_deliveries_count". */
export type Fn_Return_Channel_Deliveries_Count_Order_By = {
  count?: InputMaybe<Order_By>;
  delivery_status?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.channel_deliveries_count" */
export enum Fn_Return_Channel_Deliveries_Count_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  DeliveryStatus = 'delivery_status'
}

/** Streaming cursor of the table "fn_return_channel_deliveries_count" */
export type Fn_Return_Channel_Deliveries_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Channel_Deliveries_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Channel_Deliveries_Count_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  delivery_status?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "fn_return.combined_invoice" */
export type Fn_Return_Combined_Invoice = {
  __typename?: 'fn_return_combined_invoice';
  amount_due?: Maybe<Scalars['numeric']>;
  amount_due_usd?: Maybe<Scalars['numeric']>;
  billing_period?: Maybe<Scalars['String']>;
  /** A computed field, executes function "combined_credit_memo_lines" */
  combined_credit_memo_lines?: Maybe<Array<Fn_Return_Combined_Invoice_Line>>;
  /** A computed field, executes function "combined_invoice_lines" */
  combined_invoice_lines?: Maybe<Array<Fn_Return_Combined_Invoice_Line>>;
  /** A computed field, executes function "credit_memo_lines" */
  credit_memo_lines?: Maybe<Array<Fn_Return_Combined_Invoice_Line>>;
  currency?: Maybe<Scalars['String']>;
  customer_currency_amount?: Maybe<Scalars['numeric']>;
  due_date?: Maybe<Scalars['date']>;
  invoice_amount?: Maybe<Scalars['numeric']>;
  invoice_amount_usd?: Maybe<Scalars['numeric']>;
  invoice_date?: Maybe<Scalars['date']>;
  invoice_id: Scalars['String'];
  paid_date?: Maybe<Scalars['date']>;
  payment_status?: Maybe<Scalars['String']>;
  payment_terms?: Maybe<Scalars['String']>;
  root_cause_reason?: Maybe<Scalars['String']>;
  so_po_reference_number?: Maybe<Scalars['String']>;
  sub_status?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
};


/** columns and relationships of "fn_return.combined_invoice" */
export type Fn_Return_Combined_InvoiceCombined_Credit_Memo_LinesArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
};


/** columns and relationships of "fn_return.combined_invoice" */
export type Fn_Return_Combined_InvoiceCombined_Invoice_LinesArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
};


/** columns and relationships of "fn_return.combined_invoice" */
export type Fn_Return_Combined_InvoiceCredit_Memo_LinesArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
};

export type Fn_Return_Combined_Invoice_Aggregate = {
  __typename?: 'fn_return_combined_invoice_aggregate';
  aggregate?: Maybe<Fn_Return_Combined_Invoice_Aggregate_Fields>;
  nodes: Array<Fn_Return_Combined_Invoice>;
};

/** aggregate fields of "fn_return.combined_invoice" */
export type Fn_Return_Combined_Invoice_Aggregate_Fields = {
  __typename?: 'fn_return_combined_invoice_aggregate_fields';
  avg?: Maybe<Fn_Return_Combined_Invoice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Combined_Invoice_Max_Fields>;
  min?: Maybe<Fn_Return_Combined_Invoice_Min_Fields>;
  stddev?: Maybe<Fn_Return_Combined_Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Combined_Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Combined_Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Combined_Invoice_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Combined_Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Combined_Invoice_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Combined_Invoice_Variance_Fields>;
};


/** aggregate fields of "fn_return.combined_invoice" */
export type Fn_Return_Combined_Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fn_return.combined_invoice" */
export type Fn_Return_Combined_Invoice_Aggregate_Order_By = {
  avg?: InputMaybe<Fn_Return_Combined_Invoice_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fn_Return_Combined_Invoice_Max_Order_By>;
  min?: InputMaybe<Fn_Return_Combined_Invoice_Min_Order_By>;
  stddev?: InputMaybe<Fn_Return_Combined_Invoice_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fn_Return_Combined_Invoice_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fn_Return_Combined_Invoice_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fn_Return_Combined_Invoice_Sum_Order_By>;
  var_pop?: InputMaybe<Fn_Return_Combined_Invoice_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fn_Return_Combined_Invoice_Var_Samp_Order_By>;
  variance?: InputMaybe<Fn_Return_Combined_Invoice_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fn_Return_Combined_Invoice_Avg_Fields = {
  __typename?: 'fn_return_combined_invoice_avg_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_due_usd?: Maybe<Scalars['Float']>;
  customer_currency_amount?: Maybe<Scalars['Float']>;
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "fn_return.combined_invoice" */
export type Fn_Return_Combined_Invoice_Avg_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fn_return.combined_invoice". All fields are combined with a logical 'AND'. */
export type Fn_Return_Combined_Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Combined_Invoice_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Combined_Invoice_Bool_Exp>>;
  amount_due?: InputMaybe<Numeric_Comparison_Exp>;
  amount_due_usd?: InputMaybe<Numeric_Comparison_Exp>;
  billing_period?: InputMaybe<String_Comparison_Exp>;
  combined_credit_memo_lines?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
  combined_invoice_lines?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
  credit_memo_lines?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  customer_currency_amount?: InputMaybe<Numeric_Comparison_Exp>;
  due_date?: InputMaybe<Date_Comparison_Exp>;
  invoice_amount?: InputMaybe<Numeric_Comparison_Exp>;
  invoice_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  invoice_date?: InputMaybe<Date_Comparison_Exp>;
  invoice_id?: InputMaybe<String_Comparison_Exp>;
  paid_date?: InputMaybe<Date_Comparison_Exp>;
  payment_status?: InputMaybe<String_Comparison_Exp>;
  payment_terms?: InputMaybe<String_Comparison_Exp>;
  root_cause_reason?: InputMaybe<String_Comparison_Exp>;
  so_po_reference_number?: InputMaybe<String_Comparison_Exp>;
  sub_status?: InputMaybe<String_Comparison_Exp>;
  tax?: InputMaybe<Numeric_Comparison_Exp>;
  tax_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line = {
  __typename?: 'fn_return_combined_invoice_line';
  amount?: Maybe<Scalars['numeric']>;
  amount_usd?: Maybe<Scalars['numeric']>;
  cdpderived_product?: Maybe<Scalars['String']>;
  cdpderived_product_description?: Maybe<Scalars['String']>;
  cdpderived_product_id?: Maybe<Scalars['String']>;
  cdpderived_product_short_name?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  charge_type?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customer_currency_amount?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  gross_amount?: Maybe<Scalars['numeric']>;
  gross_amount_usd?: Maybe<Scalars['numeric']>;
  invoice_line_id?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  product_id: Scalars['String'];
  /** An object relationship */
  product_info?: Maybe<Product>;
  quantity?: Maybe<Scalars['numeric']>;
  rate?: Maybe<Scalars['numeric']>;
  region?: Maybe<Scalars['String']>;
  revenue_type?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
  tax_rate?: Maybe<Scalars['String']>;
  tax_type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Aggregate = {
  __typename?: 'fn_return_combined_invoice_line_aggregate';
  aggregate?: Maybe<Fn_Return_Combined_Invoice_Line_Aggregate_Fields>;
  nodes: Array<Fn_Return_Combined_Invoice_Line>;
};

/** aggregate fields of "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Aggregate_Fields = {
  __typename?: 'fn_return_combined_invoice_line_aggregate_fields';
  avg?: Maybe<Fn_Return_Combined_Invoice_Line_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Combined_Invoice_Line_Max_Fields>;
  min?: Maybe<Fn_Return_Combined_Invoice_Line_Min_Fields>;
  stddev?: Maybe<Fn_Return_Combined_Invoice_Line_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Combined_Invoice_Line_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Combined_Invoice_Line_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Combined_Invoice_Line_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Combined_Invoice_Line_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Combined_Invoice_Line_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Combined_Invoice_Line_Variance_Fields>;
};


/** aggregate fields of "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Aggregate_Order_By = {
  avg?: InputMaybe<Fn_Return_Combined_Invoice_Line_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fn_Return_Combined_Invoice_Line_Max_Order_By>;
  min?: InputMaybe<Fn_Return_Combined_Invoice_Line_Min_Order_By>;
  stddev?: InputMaybe<Fn_Return_Combined_Invoice_Line_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fn_Return_Combined_Invoice_Line_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fn_Return_Combined_Invoice_Line_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fn_Return_Combined_Invoice_Line_Sum_Order_By>;
  var_pop?: InputMaybe<Fn_Return_Combined_Invoice_Line_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fn_Return_Combined_Invoice_Line_Var_Samp_Order_By>;
  variance?: InputMaybe<Fn_Return_Combined_Invoice_Line_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fn_Return_Combined_Invoice_Line_Avg_Fields = {
  __typename?: 'fn_return_combined_invoice_line_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  customer_currency_amount?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  gross_amount_usd?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fn_return.combined_invoice_line". All fields are combined with a logical 'AND'. */
export type Fn_Return_Combined_Invoice_Line_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  cdpderived_product?: InputMaybe<String_Comparison_Exp>;
  cdpderived_product_description?: InputMaybe<String_Comparison_Exp>;
  cdpderived_product_id?: InputMaybe<String_Comparison_Exp>;
  cdpderived_product_short_name?: InputMaybe<String_Comparison_Exp>;
  channel?: InputMaybe<String_Comparison_Exp>;
  charge_type?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  customer_currency_amount?: InputMaybe<Numeric_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  gross_amount?: InputMaybe<Numeric_Comparison_Exp>;
  gross_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  invoice_line_id?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
  product_id?: InputMaybe<String_Comparison_Exp>;
  product_info?: InputMaybe<Product_Bool_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  rate?: InputMaybe<Numeric_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  revenue_type?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  tax_amount?: InputMaybe<Numeric_Comparison_Exp>;
  tax_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  tax_rate?: InputMaybe<String_Comparison_Exp>;
  tax_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fn_Return_Combined_Invoice_Line_Max_Fields = {
  __typename?: 'fn_return_combined_invoice_line_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_usd?: Maybe<Scalars['numeric']>;
  cdpderived_product?: Maybe<Scalars['String']>;
  cdpderived_product_description?: Maybe<Scalars['String']>;
  cdpderived_product_id?: Maybe<Scalars['String']>;
  cdpderived_product_short_name?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  charge_type?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customer_currency_amount?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  gross_amount?: Maybe<Scalars['numeric']>;
  gross_amount_usd?: Maybe<Scalars['numeric']>;
  invoice_line_id?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  rate?: Maybe<Scalars['numeric']>;
  region?: Maybe<Scalars['String']>;
  revenue_type?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
  tax_rate?: Maybe<Scalars['String']>;
  tax_type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  cdpderived_product?: InputMaybe<Order_By>;
  cdpderived_product_description?: InputMaybe<Order_By>;
  cdpderived_product_id?: InputMaybe<Order_By>;
  cdpderived_product_short_name?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  charge_type?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  invoice_line_id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  revenue_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
  tax_type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fn_Return_Combined_Invoice_Line_Min_Fields = {
  __typename?: 'fn_return_combined_invoice_line_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_usd?: Maybe<Scalars['numeric']>;
  cdpderived_product?: Maybe<Scalars['String']>;
  cdpderived_product_description?: Maybe<Scalars['String']>;
  cdpderived_product_id?: Maybe<Scalars['String']>;
  cdpderived_product_short_name?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  charge_type?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customer_currency_amount?: Maybe<Scalars['numeric']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  gross_amount?: Maybe<Scalars['numeric']>;
  gross_amount_usd?: Maybe<Scalars['numeric']>;
  invoice_line_id?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  rate?: Maybe<Scalars['numeric']>;
  region?: Maybe<Scalars['String']>;
  revenue_type?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
  tax_rate?: Maybe<Scalars['String']>;
  tax_type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  cdpderived_product?: InputMaybe<Order_By>;
  cdpderived_product_description?: InputMaybe<Order_By>;
  cdpderived_product_id?: InputMaybe<Order_By>;
  cdpderived_product_short_name?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  charge_type?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  invoice_line_id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  revenue_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
  tax_type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "fn_return.combined_invoice_line". */
export type Fn_Return_Combined_Invoice_Line_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  cdpderived_product?: InputMaybe<Order_By>;
  cdpderived_product_description?: InputMaybe<Order_By>;
  cdpderived_product_id?: InputMaybe<Order_By>;
  cdpderived_product_short_name?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  charge_type?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  invoice_line_id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_info?: InputMaybe<Product_Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  revenue_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
  tax_type?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.combined_invoice_line" */
export enum Fn_Return_Combined_Invoice_Line_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountUsd = 'amount_usd',
  /** column name */
  CdpderivedProduct = 'cdpderived_product',
  /** column name */
  CdpderivedProductDescription = 'cdpderived_product_description',
  /** column name */
  CdpderivedProductId = 'cdpderived_product_id',
  /** column name */
  CdpderivedProductShortName = 'cdpderived_product_short_name',
  /** column name */
  Channel = 'channel',
  /** column name */
  ChargeType = 'charge_type',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerCurrencyAmount = 'customer_currency_amount',
  /** column name */
  Description = 'description',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  GrossAmount = 'gross_amount',
  /** column name */
  GrossAmountUsd = 'gross_amount_usd',
  /** column name */
  InvoiceLineId = 'invoice_line_id',
  /** column name */
  Platform = 'platform',
  /** column name */
  Product = 'product',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Rate = 'rate',
  /** column name */
  Region = 'region',
  /** column name */
  RevenueType = 'revenue_type',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TaxAmount = 'tax_amount',
  /** column name */
  TaxAmountUsd = 'tax_amount_usd',
  /** column name */
  TaxRate = 'tax_rate',
  /** column name */
  TaxType = 'tax_type'
}

/** aggregate stddev on columns */
export type Fn_Return_Combined_Invoice_Line_Stddev_Fields = {
  __typename?: 'fn_return_combined_invoice_line_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  customer_currency_amount?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  gross_amount_usd?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Combined_Invoice_Line_Stddev_Pop_Fields = {
  __typename?: 'fn_return_combined_invoice_line_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  customer_currency_amount?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  gross_amount_usd?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Combined_Invoice_Line_Stddev_Samp_Fields = {
  __typename?: 'fn_return_combined_invoice_line_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  customer_currency_amount?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  gross_amount_usd?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fn_return_combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Combined_Invoice_Line_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Combined_Invoice_Line_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  amount_usd?: InputMaybe<Scalars['numeric']>;
  cdpderived_product?: InputMaybe<Scalars['String']>;
  cdpderived_product_description?: InputMaybe<Scalars['String']>;
  cdpderived_product_id?: InputMaybe<Scalars['String']>;
  cdpderived_product_short_name?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  charge_type?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  customer_currency_amount?: InputMaybe<Scalars['numeric']>;
  description?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['date']>;
  gross_amount?: InputMaybe<Scalars['numeric']>;
  gross_amount_usd?: InputMaybe<Scalars['numeric']>;
  invoice_line_id?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  rate?: InputMaybe<Scalars['numeric']>;
  region?: InputMaybe<Scalars['String']>;
  revenue_type?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  tax_amount_usd?: InputMaybe<Scalars['numeric']>;
  tax_rate?: InputMaybe<Scalars['String']>;
  tax_type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Fn_Return_Combined_Invoice_Line_Sum_Fields = {
  __typename?: 'fn_return_combined_invoice_line_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_usd?: Maybe<Scalars['numeric']>;
  customer_currency_amount?: Maybe<Scalars['numeric']>;
  gross_amount?: Maybe<Scalars['numeric']>;
  gross_amount_usd?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  rate?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Fn_Return_Combined_Invoice_Line_Var_Pop_Fields = {
  __typename?: 'fn_return_combined_invoice_line_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  customer_currency_amount?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  gross_amount_usd?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Combined_Invoice_Line_Var_Samp_Fields = {
  __typename?: 'fn_return_combined_invoice_line_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  customer_currency_amount?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  gross_amount_usd?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fn_Return_Combined_Invoice_Line_Variance_Fields = {
  __typename?: 'fn_return_combined_invoice_line_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  customer_currency_amount?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  gross_amount_usd?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "fn_return.combined_invoice_line" */
export type Fn_Return_Combined_Invoice_Line_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Fn_Return_Combined_Invoice_Max_Fields = {
  __typename?: 'fn_return_combined_invoice_max_fields';
  amount_due?: Maybe<Scalars['numeric']>;
  amount_due_usd?: Maybe<Scalars['numeric']>;
  billing_period?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customer_currency_amount?: Maybe<Scalars['numeric']>;
  due_date?: Maybe<Scalars['date']>;
  invoice_amount?: Maybe<Scalars['numeric']>;
  invoice_amount_usd?: Maybe<Scalars['numeric']>;
  invoice_date?: Maybe<Scalars['date']>;
  invoice_id?: Maybe<Scalars['String']>;
  paid_date?: Maybe<Scalars['date']>;
  payment_status?: Maybe<Scalars['String']>;
  payment_terms?: Maybe<Scalars['String']>;
  root_cause_reason?: Maybe<Scalars['String']>;
  so_po_reference_number?: Maybe<Scalars['String']>;
  sub_status?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "fn_return.combined_invoice" */
export type Fn_Return_Combined_Invoice_Max_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  billing_period?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  invoice_date?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  paid_date?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  root_cause_reason?: InputMaybe<Order_By>;
  so_po_reference_number?: InputMaybe<Order_By>;
  sub_status?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fn_Return_Combined_Invoice_Min_Fields = {
  __typename?: 'fn_return_combined_invoice_min_fields';
  amount_due?: Maybe<Scalars['numeric']>;
  amount_due_usd?: Maybe<Scalars['numeric']>;
  billing_period?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customer_currency_amount?: Maybe<Scalars['numeric']>;
  due_date?: Maybe<Scalars['date']>;
  invoice_amount?: Maybe<Scalars['numeric']>;
  invoice_amount_usd?: Maybe<Scalars['numeric']>;
  invoice_date?: Maybe<Scalars['date']>;
  invoice_id?: Maybe<Scalars['String']>;
  paid_date?: Maybe<Scalars['date']>;
  payment_status?: Maybe<Scalars['String']>;
  payment_terms?: Maybe<Scalars['String']>;
  root_cause_reason?: Maybe<Scalars['String']>;
  so_po_reference_number?: Maybe<Scalars['String']>;
  sub_status?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "fn_return.combined_invoice" */
export type Fn_Return_Combined_Invoice_Min_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  billing_period?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  invoice_date?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  paid_date?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  root_cause_reason?: InputMaybe<Order_By>;
  so_po_reference_number?: InputMaybe<Order_By>;
  sub_status?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "fn_return.combined_invoice". */
export type Fn_Return_Combined_Invoice_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  billing_period?: InputMaybe<Order_By>;
  combined_credit_memo_lines_aggregate?: InputMaybe<Fn_Return_Combined_Invoice_Line_Aggregate_Order_By>;
  combined_invoice_lines_aggregate?: InputMaybe<Fn_Return_Combined_Invoice_Line_Aggregate_Order_By>;
  credit_memo_lines_aggregate?: InputMaybe<Fn_Return_Combined_Invoice_Line_Aggregate_Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  invoice_date?: InputMaybe<Order_By>;
  invoice_id?: InputMaybe<Order_By>;
  paid_date?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  root_cause_reason?: InputMaybe<Order_By>;
  so_po_reference_number?: InputMaybe<Order_By>;
  sub_status?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.combined_invoice" */
export enum Fn_Return_Combined_Invoice_Select_Column {
  /** column name */
  AmountDue = 'amount_due',
  /** column name */
  AmountDueUsd = 'amount_due_usd',
  /** column name */
  BillingPeriod = 'billing_period',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerCurrencyAmount = 'customer_currency_amount',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  InvoiceAmount = 'invoice_amount',
  /** column name */
  InvoiceAmountUsd = 'invoice_amount_usd',
  /** column name */
  InvoiceDate = 'invoice_date',
  /** column name */
  InvoiceId = 'invoice_id',
  /** column name */
  PaidDate = 'paid_date',
  /** column name */
  PaymentStatus = 'payment_status',
  /** column name */
  PaymentTerms = 'payment_terms',
  /** column name */
  RootCauseReason = 'root_cause_reason',
  /** column name */
  SoPoReferenceNumber = 'so_po_reference_number',
  /** column name */
  SubStatus = 'sub_status',
  /** column name */
  Tax = 'tax',
  /** column name */
  TaxAmountUsd = 'tax_amount_usd',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type Fn_Return_Combined_Invoice_Stddev_Fields = {
  __typename?: 'fn_return_combined_invoice_stddev_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_due_usd?: Maybe<Scalars['Float']>;
  customer_currency_amount?: Maybe<Scalars['Float']>;
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "fn_return.combined_invoice" */
export type Fn_Return_Combined_Invoice_Stddev_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Combined_Invoice_Stddev_Pop_Fields = {
  __typename?: 'fn_return_combined_invoice_stddev_pop_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_due_usd?: Maybe<Scalars['Float']>;
  customer_currency_amount?: Maybe<Scalars['Float']>;
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "fn_return.combined_invoice" */
export type Fn_Return_Combined_Invoice_Stddev_Pop_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Combined_Invoice_Stddev_Samp_Fields = {
  __typename?: 'fn_return_combined_invoice_stddev_samp_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_due_usd?: Maybe<Scalars['Float']>;
  customer_currency_amount?: Maybe<Scalars['Float']>;
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "fn_return.combined_invoice" */
export type Fn_Return_Combined_Invoice_Stddev_Samp_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fn_return_combined_invoice" */
export type Fn_Return_Combined_Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Combined_Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Combined_Invoice_Stream_Cursor_Value_Input = {
  amount_due?: InputMaybe<Scalars['numeric']>;
  amount_due_usd?: InputMaybe<Scalars['numeric']>;
  billing_period?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  customer_currency_amount?: InputMaybe<Scalars['numeric']>;
  due_date?: InputMaybe<Scalars['date']>;
  invoice_amount?: InputMaybe<Scalars['numeric']>;
  invoice_amount_usd?: InputMaybe<Scalars['numeric']>;
  invoice_date?: InputMaybe<Scalars['date']>;
  invoice_id?: InputMaybe<Scalars['String']>;
  paid_date?: InputMaybe<Scalars['date']>;
  payment_status?: InputMaybe<Scalars['String']>;
  payment_terms?: InputMaybe<Scalars['String']>;
  root_cause_reason?: InputMaybe<Scalars['String']>;
  so_po_reference_number?: InputMaybe<Scalars['String']>;
  sub_status?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['numeric']>;
  tax_amount_usd?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Fn_Return_Combined_Invoice_Sum_Fields = {
  __typename?: 'fn_return_combined_invoice_sum_fields';
  amount_due?: Maybe<Scalars['numeric']>;
  amount_due_usd?: Maybe<Scalars['numeric']>;
  customer_currency_amount?: Maybe<Scalars['numeric']>;
  invoice_amount?: Maybe<Scalars['numeric']>;
  invoice_amount_usd?: Maybe<Scalars['numeric']>;
  tax?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "fn_return.combined_invoice" */
export type Fn_Return_Combined_Invoice_Sum_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Fn_Return_Combined_Invoice_Var_Pop_Fields = {
  __typename?: 'fn_return_combined_invoice_var_pop_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_due_usd?: Maybe<Scalars['Float']>;
  customer_currency_amount?: Maybe<Scalars['Float']>;
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "fn_return.combined_invoice" */
export type Fn_Return_Combined_Invoice_Var_Pop_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Combined_Invoice_Var_Samp_Fields = {
  __typename?: 'fn_return_combined_invoice_var_samp_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_due_usd?: Maybe<Scalars['Float']>;
  customer_currency_amount?: Maybe<Scalars['Float']>;
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "fn_return.combined_invoice" */
export type Fn_Return_Combined_Invoice_Var_Samp_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fn_Return_Combined_Invoice_Variance_Fields = {
  __typename?: 'fn_return_combined_invoice_variance_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_due_usd?: Maybe<Scalars['Float']>;
  customer_currency_amount?: Maybe<Scalars['Float']>;
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "fn_return.combined_invoice" */
export type Fn_Return_Combined_Invoice_Variance_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  customer_currency_amount?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** columns and relationships of "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt = {
  __typename?: 'fn_return_combined_receipt';
  applied_amount?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "combined_receipt_lines" */
  combined_receipt_lines?: Maybe<Array<Fn_Return_Combined_Receipt_Line>>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  memo?: Maybe<Scalars['String']>;
  netsuite_id: Scalars['numeric'];
  receipt_no: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  unapplied_amount?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "fn_return.combined_receipt" */
export type Fn_Return_Combined_ReceiptCombined_Receipt_LinesArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Receipt_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Receipt_Line_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Receipt_Line_Bool_Exp>;
};

/** aggregated selection of "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Aggregate = {
  __typename?: 'fn_return_combined_receipt_aggregate';
  aggregate?: Maybe<Fn_Return_Combined_Receipt_Aggregate_Fields>;
  nodes: Array<Fn_Return_Combined_Receipt>;
};

/** aggregate fields of "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Aggregate_Fields = {
  __typename?: 'fn_return_combined_receipt_aggregate_fields';
  avg?: Maybe<Fn_Return_Combined_Receipt_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Combined_Receipt_Max_Fields>;
  min?: Maybe<Fn_Return_Combined_Receipt_Min_Fields>;
  stddev?: Maybe<Fn_Return_Combined_Receipt_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Combined_Receipt_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Combined_Receipt_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Combined_Receipt_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Combined_Receipt_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Combined_Receipt_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Combined_Receipt_Variance_Fields>;
};


/** aggregate fields of "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Combined_Receipt_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Aggregate_Order_By = {
  avg?: InputMaybe<Fn_Return_Combined_Receipt_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fn_Return_Combined_Receipt_Max_Order_By>;
  min?: InputMaybe<Fn_Return_Combined_Receipt_Min_Order_By>;
  stddev?: InputMaybe<Fn_Return_Combined_Receipt_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fn_Return_Combined_Receipt_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fn_Return_Combined_Receipt_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fn_Return_Combined_Receipt_Sum_Order_By>;
  var_pop?: InputMaybe<Fn_Return_Combined_Receipt_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fn_Return_Combined_Receipt_Var_Samp_Order_By>;
  variance?: InputMaybe<Fn_Return_Combined_Receipt_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fn_Return_Combined_Receipt_Avg_Fields = {
  __typename?: 'fn_return_combined_receipt_avg_fields';
  applied_amount?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  unapplied_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Avg_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fn_return.combined_receipt". All fields are combined with a logical 'AND'. */
export type Fn_Return_Combined_Receipt_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Combined_Receipt_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Combined_Receipt_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Combined_Receipt_Bool_Exp>>;
  applied_amount?: InputMaybe<Numeric_Comparison_Exp>;
  combined_receipt_lines?: InputMaybe<Fn_Return_Combined_Receipt_Line_Bool_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  memo?: InputMaybe<String_Comparison_Exp>;
  netsuite_id?: InputMaybe<Numeric_Comparison_Exp>;
  receipt_no?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  unapplied_amount?: InputMaybe<Numeric_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Inc_Input = {
  applied_amount?: InputMaybe<Scalars['numeric']>;
  netsuite_id?: InputMaybe<Scalars['numeric']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  unapplied_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Insert_Input = {
  applied_amount?: InputMaybe<Scalars['numeric']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  memo?: InputMaybe<Scalars['String']>;
  netsuite_id?: InputMaybe<Scalars['numeric']>;
  receipt_no?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  unapplied_amount?: InputMaybe<Scalars['numeric']>;
};

/** columns and relationships of "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line = {
  __typename?: 'fn_return_combined_receipt_line';
  amount_due?: Maybe<Scalars['numeric']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  netsuite_transaction_id: Scalars['String'];
  original_amount?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Aggregate = {
  __typename?: 'fn_return_combined_receipt_line_aggregate';
  aggregate?: Maybe<Fn_Return_Combined_Receipt_Line_Aggregate_Fields>;
  nodes: Array<Fn_Return_Combined_Receipt_Line>;
};

/** aggregate fields of "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Aggregate_Fields = {
  __typename?: 'fn_return_combined_receipt_line_aggregate_fields';
  avg?: Maybe<Fn_Return_Combined_Receipt_Line_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Combined_Receipt_Line_Max_Fields>;
  min?: Maybe<Fn_Return_Combined_Receipt_Line_Min_Fields>;
  stddev?: Maybe<Fn_Return_Combined_Receipt_Line_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Combined_Receipt_Line_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Combined_Receipt_Line_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Combined_Receipt_Line_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Combined_Receipt_Line_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Combined_Receipt_Line_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Combined_Receipt_Line_Variance_Fields>;
};


/** aggregate fields of "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Combined_Receipt_Line_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Aggregate_Order_By = {
  avg?: InputMaybe<Fn_Return_Combined_Receipt_Line_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fn_Return_Combined_Receipt_Line_Max_Order_By>;
  min?: InputMaybe<Fn_Return_Combined_Receipt_Line_Min_Order_By>;
  stddev?: InputMaybe<Fn_Return_Combined_Receipt_Line_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fn_Return_Combined_Receipt_Line_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fn_Return_Combined_Receipt_Line_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fn_Return_Combined_Receipt_Line_Sum_Order_By>;
  var_pop?: InputMaybe<Fn_Return_Combined_Receipt_Line_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fn_Return_Combined_Receipt_Line_Var_Samp_Order_By>;
  variance?: InputMaybe<Fn_Return_Combined_Receipt_Line_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fn_Return_Combined_Receipt_Line_Avg_Fields = {
  __typename?: 'fn_return_combined_receipt_line_avg_fields';
  amount_due?: Maybe<Scalars['Float']>;
  original_amount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Avg_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fn_return.combined_receipt_line". All fields are combined with a logical 'AND'. */
export type Fn_Return_Combined_Receipt_Line_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Combined_Receipt_Line_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Combined_Receipt_Line_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Combined_Receipt_Line_Bool_Exp>>;
  amount_due?: InputMaybe<Numeric_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  netsuite_transaction_id?: InputMaybe<String_Comparison_Exp>;
  original_amount?: InputMaybe<Numeric_Comparison_Exp>;
  payment?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Inc_Input = {
  amount_due?: InputMaybe<Scalars['numeric']>;
  original_amount?: InputMaybe<Scalars['numeric']>;
  payment?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Insert_Input = {
  amount_due?: InputMaybe<Scalars['numeric']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  netsuite_transaction_id?: InputMaybe<Scalars['String']>;
  original_amount?: InputMaybe<Scalars['numeric']>;
  payment?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Fn_Return_Combined_Receipt_Line_Max_Fields = {
  __typename?: 'fn_return_combined_receipt_line_max_fields';
  amount_due?: Maybe<Scalars['numeric']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  netsuite_transaction_id?: Maybe<Scalars['String']>;
  original_amount?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Max_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fn_Return_Combined_Receipt_Line_Min_Fields = {
  __typename?: 'fn_return_combined_receipt_line_min_fields';
  amount_due?: Maybe<Scalars['numeric']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  netsuite_transaction_id?: Maybe<Scalars['String']>;
  original_amount?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Min_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Mutation_Response = {
  __typename?: 'fn_return_combined_receipt_line_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fn_Return_Combined_Receipt_Line>;
};

/** Ordering options when selecting data from "fn_return.combined_receipt_line". */
export type Fn_Return_Combined_Receipt_Line_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.combined_receipt_line" */
export enum Fn_Return_Combined_Receipt_Line_Select_Column {
  /** column name */
  AmountDue = 'amount_due',
  /** column name */
  Currency = 'currency',
  /** column name */
  Date = 'date',
  /** column name */
  NetsuiteTransactionId = 'netsuite_transaction_id',
  /** column name */
  OriginalAmount = 'original_amount',
  /** column name */
  Payment = 'payment',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Set_Input = {
  amount_due?: InputMaybe<Scalars['numeric']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  netsuite_transaction_id?: InputMaybe<Scalars['String']>;
  original_amount?: InputMaybe<Scalars['numeric']>;
  payment?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Fn_Return_Combined_Receipt_Line_Stddev_Fields = {
  __typename?: 'fn_return_combined_receipt_line_stddev_fields';
  amount_due?: Maybe<Scalars['Float']>;
  original_amount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Stddev_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Combined_Receipt_Line_Stddev_Pop_Fields = {
  __typename?: 'fn_return_combined_receipt_line_stddev_pop_fields';
  amount_due?: Maybe<Scalars['Float']>;
  original_amount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Stddev_Pop_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Combined_Receipt_Line_Stddev_Samp_Fields = {
  __typename?: 'fn_return_combined_receipt_line_stddev_samp_fields';
  amount_due?: Maybe<Scalars['Float']>;
  original_amount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Stddev_Samp_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fn_return_combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Combined_Receipt_Line_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Combined_Receipt_Line_Stream_Cursor_Value_Input = {
  amount_due?: InputMaybe<Scalars['numeric']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  netsuite_transaction_id?: InputMaybe<Scalars['String']>;
  original_amount?: InputMaybe<Scalars['numeric']>;
  payment?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Fn_Return_Combined_Receipt_Line_Sum_Fields = {
  __typename?: 'fn_return_combined_receipt_line_sum_fields';
  amount_due?: Maybe<Scalars['numeric']>;
  original_amount?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Sum_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

export type Fn_Return_Combined_Receipt_Line_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fn_Return_Combined_Receipt_Line_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fn_Return_Combined_Receipt_Line_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fn_Return_Combined_Receipt_Line_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fn_Return_Combined_Receipt_Line_Var_Pop_Fields = {
  __typename?: 'fn_return_combined_receipt_line_var_pop_fields';
  amount_due?: Maybe<Scalars['Float']>;
  original_amount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Var_Pop_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Combined_Receipt_Line_Var_Samp_Fields = {
  __typename?: 'fn_return_combined_receipt_line_var_samp_fields';
  amount_due?: Maybe<Scalars['Float']>;
  original_amount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Var_Samp_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fn_Return_Combined_Receipt_Line_Variance_Fields = {
  __typename?: 'fn_return_combined_receipt_line_variance_fields';
  amount_due?: Maybe<Scalars['Float']>;
  original_amount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "fn_return.combined_receipt_line" */
export type Fn_Return_Combined_Receipt_Line_Variance_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Fn_Return_Combined_Receipt_Max_Fields = {
  __typename?: 'fn_return_combined_receipt_max_fields';
  applied_amount?: Maybe<Scalars['numeric']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  memo?: Maybe<Scalars['String']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  receipt_no?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  unapplied_amount?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Max_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  memo?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  receipt_no?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fn_Return_Combined_Receipt_Min_Fields = {
  __typename?: 'fn_return_combined_receipt_min_fields';
  applied_amount?: Maybe<Scalars['numeric']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  memo?: Maybe<Scalars['String']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  receipt_no?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  unapplied_amount?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Min_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  memo?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  receipt_no?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Mutation_Response = {
  __typename?: 'fn_return_combined_receipt_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Fn_Return_Combined_Receipt>;
};

/** Ordering options when selecting data from "fn_return.combined_receipt". */
export type Fn_Return_Combined_Receipt_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  combined_receipt_lines_aggregate?: InputMaybe<Fn_Return_Combined_Receipt_Line_Aggregate_Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  memo?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  receipt_no?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.combined_receipt" */
export enum Fn_Return_Combined_Receipt_Select_Column {
  /** column name */
  AppliedAmount = 'applied_amount',
  /** column name */
  Currency = 'currency',
  /** column name */
  Date = 'date',
  /** column name */
  Memo = 'memo',
  /** column name */
  NetsuiteId = 'netsuite_id',
  /** column name */
  ReceiptNo = 'receipt_no',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UnappliedAmount = 'unapplied_amount'
}

/** input type for updating data in table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Set_Input = {
  applied_amount?: InputMaybe<Scalars['numeric']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  memo?: InputMaybe<Scalars['String']>;
  netsuite_id?: InputMaybe<Scalars['numeric']>;
  receipt_no?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  unapplied_amount?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Fn_Return_Combined_Receipt_Stddev_Fields = {
  __typename?: 'fn_return_combined_receipt_stddev_fields';
  applied_amount?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  unapplied_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Stddev_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Combined_Receipt_Stddev_Pop_Fields = {
  __typename?: 'fn_return_combined_receipt_stddev_pop_fields';
  applied_amount?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  unapplied_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Stddev_Pop_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Combined_Receipt_Stddev_Samp_Fields = {
  __typename?: 'fn_return_combined_receipt_stddev_samp_fields';
  applied_amount?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  unapplied_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Stddev_Samp_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fn_return_combined_receipt" */
export type Fn_Return_Combined_Receipt_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Combined_Receipt_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Combined_Receipt_Stream_Cursor_Value_Input = {
  applied_amount?: InputMaybe<Scalars['numeric']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  memo?: InputMaybe<Scalars['String']>;
  netsuite_id?: InputMaybe<Scalars['numeric']>;
  receipt_no?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  unapplied_amount?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Fn_Return_Combined_Receipt_Sum_Fields = {
  __typename?: 'fn_return_combined_receipt_sum_fields';
  applied_amount?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  unapplied_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Sum_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
};

export type Fn_Return_Combined_Receipt_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Fn_Return_Combined_Receipt_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Fn_Return_Combined_Receipt_Set_Input>;
  /** filter the rows which have to be updated */
  where: Fn_Return_Combined_Receipt_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Fn_Return_Combined_Receipt_Var_Pop_Fields = {
  __typename?: 'fn_return_combined_receipt_var_pop_fields';
  applied_amount?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  unapplied_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Var_Pop_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Combined_Receipt_Var_Samp_Fields = {
  __typename?: 'fn_return_combined_receipt_var_samp_fields';
  applied_amount?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  unapplied_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Var_Samp_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fn_Return_Combined_Receipt_Variance_Fields = {
  __typename?: 'fn_return_combined_receipt_variance_fields';
  applied_amount?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  unapplied_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "fn_return.combined_receipt" */
export type Fn_Return_Combined_Receipt_Variance_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "fn_return.customer_industry_type" */
export type Fn_Return_Customer_Industry_Type = {
  __typename?: 'fn_return_customer_industry_type';
  count: Scalars['numeric'];
  industry_type: Scalars['String'];
};

/** Boolean expression to filter rows from the table "fn_return.customer_industry_type". All fields are combined with a logical 'AND'. */
export type Fn_Return_Customer_Industry_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Customer_Industry_Type_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Customer_Industry_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Customer_Industry_Type_Bool_Exp>>;
  count?: InputMaybe<Numeric_Comparison_Exp>;
  industry_type?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.customer_industry_type". */
export type Fn_Return_Customer_Industry_Type_Order_By = {
  count?: InputMaybe<Order_By>;
  industry_type?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.customer_industry_type" */
export enum Fn_Return_Customer_Industry_Type_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  IndustryType = 'industry_type'
}

/** Streaming cursor of the table "fn_return_customer_industry_type" */
export type Fn_Return_Customer_Industry_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Customer_Industry_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Customer_Industry_Type_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['numeric']>;
  industry_type?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "fn_return.customer_region_revenue" */
export type Fn_Return_Customer_Region_Revenue = {
  __typename?: 'fn_return_customer_region_revenue';
  customer_region: Scalars['String'];
  total?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "fn_return.customer_region_revenue". All fields are combined with a logical 'AND'. */
export type Fn_Return_Customer_Region_Revenue_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Customer_Region_Revenue_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Customer_Region_Revenue_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Customer_Region_Revenue_Bool_Exp>>;
  customer_region?: InputMaybe<String_Comparison_Exp>;
  total?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.customer_region_revenue". */
export type Fn_Return_Customer_Region_Revenue_Order_By = {
  customer_region?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.customer_region_revenue" */
export enum Fn_Return_Customer_Region_Revenue_Select_Column {
  /** column name */
  CustomerRegion = 'customer_region',
  /** column name */
  Total = 'total'
}

/** Streaming cursor of the table "fn_return_customer_region_revenue" */
export type Fn_Return_Customer_Region_Revenue_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Customer_Region_Revenue_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Customer_Region_Revenue_Stream_Cursor_Value_Input = {
  customer_region?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['numeric']>;
};

/** columns and relationships of "fn_return.customer_search" */
export type Fn_Return_Customer_Search = {
  __typename?: 'fn_return_customer_search';
  account_currency?: Maybe<Scalars['String']>;
  account_legal_name?: Maybe<Scalars['String']>;
  account_manager_name?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  amagi_id?: Maybe<Scalars['String']>;
  channel_names?: Maybe<Scalars['String']>;
  company_address_region?: Maybe<Scalars['String']>;
  csm_name?: Maybe<Scalars['String']>;
  customer_tier?: Maybe<Scalars['String']>;
  customer_type?: Maybe<Scalars['String']>;
  industry_segment?: Maybe<Scalars['String']>;
  media_industry_sub_segment_name?: Maybe<Scalars['String']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  opportunity_id?: Maybe<Scalars['String']>;
  opportunity_name?: Maybe<Scalars['String']>;
  order_number?: Maybe<Scalars['String']>;
  platform_names?: Maybe<Scalars['String']>;
  product_codes?: Maybe<Scalars['String']>;
  product_families?: Maybe<Scalars['String']>;
  product_names?: Maybe<Scalars['String']>;
  rep_director?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_id: Scalars['String'];
  size?: Maybe<Scalars['String']>;
  transaction_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fn_return.customer_search" */
export type Fn_Return_Customer_Search_Aggregate = {
  __typename?: 'fn_return_customer_search_aggregate';
  aggregate?: Maybe<Fn_Return_Customer_Search_Aggregate_Fields>;
  nodes: Array<Fn_Return_Customer_Search>;
};

/** aggregate fields of "fn_return.customer_search" */
export type Fn_Return_Customer_Search_Aggregate_Fields = {
  __typename?: 'fn_return_customer_search_aggregate_fields';
  avg?: Maybe<Fn_Return_Customer_Search_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Customer_Search_Max_Fields>;
  min?: Maybe<Fn_Return_Customer_Search_Min_Fields>;
  stddev?: Maybe<Fn_Return_Customer_Search_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Customer_Search_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Customer_Search_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Customer_Search_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Customer_Search_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Customer_Search_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Customer_Search_Variance_Fields>;
};


/** aggregate fields of "fn_return.customer_search" */
export type Fn_Return_Customer_Search_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Customer_Search_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fn_Return_Customer_Search_Avg_Fields = {
  __typename?: 'fn_return_customer_search_avg_fields';
  netsuite_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fn_return.customer_search". All fields are combined with a logical 'AND'. */
export type Fn_Return_Customer_Search_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Customer_Search_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Customer_Search_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Customer_Search_Bool_Exp>>;
  account_currency?: InputMaybe<String_Comparison_Exp>;
  account_legal_name?: InputMaybe<String_Comparison_Exp>;
  account_manager_name?: InputMaybe<String_Comparison_Exp>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  channel_names?: InputMaybe<String_Comparison_Exp>;
  company_address_region?: InputMaybe<String_Comparison_Exp>;
  csm_name?: InputMaybe<String_Comparison_Exp>;
  customer_tier?: InputMaybe<String_Comparison_Exp>;
  customer_type?: InputMaybe<String_Comparison_Exp>;
  industry_segment?: InputMaybe<String_Comparison_Exp>;
  media_industry_sub_segment_name?: InputMaybe<String_Comparison_Exp>;
  netsuite_id?: InputMaybe<Numeric_Comparison_Exp>;
  opportunity_id?: InputMaybe<String_Comparison_Exp>;
  opportunity_name?: InputMaybe<String_Comparison_Exp>;
  order_number?: InputMaybe<String_Comparison_Exp>;
  platform_names?: InputMaybe<String_Comparison_Exp>;
  product_codes?: InputMaybe<String_Comparison_Exp>;
  product_families?: InputMaybe<String_Comparison_Exp>;
  product_names?: InputMaybe<String_Comparison_Exp>;
  rep_director?: InputMaybe<String_Comparison_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  transaction_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fn_Return_Customer_Search_Max_Fields = {
  __typename?: 'fn_return_customer_search_max_fields';
  account_currency?: Maybe<Scalars['String']>;
  account_legal_name?: Maybe<Scalars['String']>;
  account_manager_name?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  amagi_id?: Maybe<Scalars['String']>;
  channel_names?: Maybe<Scalars['String']>;
  company_address_region?: Maybe<Scalars['String']>;
  csm_name?: Maybe<Scalars['String']>;
  customer_tier?: Maybe<Scalars['String']>;
  customer_type?: Maybe<Scalars['String']>;
  industry_segment?: Maybe<Scalars['String']>;
  media_industry_sub_segment_name?: Maybe<Scalars['String']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  opportunity_id?: Maybe<Scalars['String']>;
  opportunity_name?: Maybe<Scalars['String']>;
  order_number?: Maybe<Scalars['String']>;
  platform_names?: Maybe<Scalars['String']>;
  product_codes?: Maybe<Scalars['String']>;
  product_families?: Maybe<Scalars['String']>;
  product_names?: Maybe<Scalars['String']>;
  rep_director?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  transaction_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Fn_Return_Customer_Search_Min_Fields = {
  __typename?: 'fn_return_customer_search_min_fields';
  account_currency?: Maybe<Scalars['String']>;
  account_legal_name?: Maybe<Scalars['String']>;
  account_manager_name?: Maybe<Scalars['String']>;
  account_name?: Maybe<Scalars['String']>;
  amagi_id?: Maybe<Scalars['String']>;
  channel_names?: Maybe<Scalars['String']>;
  company_address_region?: Maybe<Scalars['String']>;
  csm_name?: Maybe<Scalars['String']>;
  customer_tier?: Maybe<Scalars['String']>;
  customer_type?: Maybe<Scalars['String']>;
  industry_segment?: Maybe<Scalars['String']>;
  media_industry_sub_segment_name?: Maybe<Scalars['String']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  opportunity_id?: Maybe<Scalars['String']>;
  opportunity_name?: Maybe<Scalars['String']>;
  order_number?: Maybe<Scalars['String']>;
  platform_names?: Maybe<Scalars['String']>;
  product_codes?: Maybe<Scalars['String']>;
  product_families?: Maybe<Scalars['String']>;
  product_names?: Maybe<Scalars['String']>;
  rep_director?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  transaction_id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "fn_return.customer_search". */
export type Fn_Return_Customer_Search_Order_By = {
  account_currency?: InputMaybe<Order_By>;
  account_legal_name?: InputMaybe<Order_By>;
  account_manager_name?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  amagi_id?: InputMaybe<Order_By>;
  channel_names?: InputMaybe<Order_By>;
  company_address_region?: InputMaybe<Order_By>;
  csm_name?: InputMaybe<Order_By>;
  customer_tier?: InputMaybe<Order_By>;
  customer_type?: InputMaybe<Order_By>;
  industry_segment?: InputMaybe<Order_By>;
  media_industry_sub_segment_name?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  opportunity_id?: InputMaybe<Order_By>;
  opportunity_name?: InputMaybe<Order_By>;
  order_number?: InputMaybe<Order_By>;
  platform_names?: InputMaybe<Order_By>;
  product_codes?: InputMaybe<Order_By>;
  product_families?: InputMaybe<Order_By>;
  product_names?: InputMaybe<Order_By>;
  rep_director?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.customer_search" */
export enum Fn_Return_Customer_Search_Select_Column {
  /** column name */
  AccountCurrency = 'account_currency',
  /** column name */
  AccountLegalName = 'account_legal_name',
  /** column name */
  AccountManagerName = 'account_manager_name',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  ChannelNames = 'channel_names',
  /** column name */
  CompanyAddressRegion = 'company_address_region',
  /** column name */
  CsmName = 'csm_name',
  /** column name */
  CustomerTier = 'customer_tier',
  /** column name */
  CustomerType = 'customer_type',
  /** column name */
  IndustrySegment = 'industry_segment',
  /** column name */
  MediaIndustrySubSegmentName = 'media_industry_sub_segment_name',
  /** column name */
  NetsuiteId = 'netsuite_id',
  /** column name */
  OpportunityId = 'opportunity_id',
  /** column name */
  OpportunityName = 'opportunity_name',
  /** column name */
  OrderNumber = 'order_number',
  /** column name */
  PlatformNames = 'platform_names',
  /** column name */
  ProductCodes = 'product_codes',
  /** column name */
  ProductFamilies = 'product_families',
  /** column name */
  ProductNames = 'product_names',
  /** column name */
  RepDirector = 'rep_director',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  Size = 'size',
  /** column name */
  TransactionId = 'transaction_id'
}

/** aggregate stddev on columns */
export type Fn_Return_Customer_Search_Stddev_Fields = {
  __typename?: 'fn_return_customer_search_stddev_fields';
  netsuite_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Customer_Search_Stddev_Pop_Fields = {
  __typename?: 'fn_return_customer_search_stddev_pop_fields';
  netsuite_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Customer_Search_Stddev_Samp_Fields = {
  __typename?: 'fn_return_customer_search_stddev_samp_fields';
  netsuite_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fn_return_customer_search" */
export type Fn_Return_Customer_Search_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Customer_Search_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Customer_Search_Stream_Cursor_Value_Input = {
  account_currency?: InputMaybe<Scalars['String']>;
  account_legal_name?: InputMaybe<Scalars['String']>;
  account_manager_name?: InputMaybe<Scalars['String']>;
  account_name?: InputMaybe<Scalars['String']>;
  amagi_id?: InputMaybe<Scalars['String']>;
  channel_names?: InputMaybe<Scalars['String']>;
  company_address_region?: InputMaybe<Scalars['String']>;
  csm_name?: InputMaybe<Scalars['String']>;
  customer_tier?: InputMaybe<Scalars['String']>;
  customer_type?: InputMaybe<Scalars['String']>;
  industry_segment?: InputMaybe<Scalars['String']>;
  media_industry_sub_segment_name?: InputMaybe<Scalars['String']>;
  netsuite_id?: InputMaybe<Scalars['numeric']>;
  opportunity_id?: InputMaybe<Scalars['String']>;
  opportunity_name?: InputMaybe<Scalars['String']>;
  order_number?: InputMaybe<Scalars['String']>;
  platform_names?: InputMaybe<Scalars['String']>;
  product_codes?: InputMaybe<Scalars['String']>;
  product_families?: InputMaybe<Scalars['String']>;
  product_names?: InputMaybe<Scalars['String']>;
  rep_director?: InputMaybe<Scalars['String']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['String']>;
  transaction_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Fn_Return_Customer_Search_Sum_Fields = {
  __typename?: 'fn_return_customer_search_sum_fields';
  netsuite_id?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Fn_Return_Customer_Search_Var_Pop_Fields = {
  __typename?: 'fn_return_customer_search_var_pop_fields';
  netsuite_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Customer_Search_Var_Samp_Fields = {
  __typename?: 'fn_return_customer_search_var_samp_fields';
  netsuite_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fn_Return_Customer_Search_Variance_Fields = {
  __typename?: 'fn_return_customer_search_variance_fields';
  netsuite_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fn_return.customer_tier_revenue" */
export type Fn_Return_Customer_Tier_Revenue = {
  __typename?: 'fn_return_customer_tier_revenue';
  customer_tier: Scalars['String'];
  total?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "fn_return.customer_tier_revenue". All fields are combined with a logical 'AND'. */
export type Fn_Return_Customer_Tier_Revenue_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Customer_Tier_Revenue_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Customer_Tier_Revenue_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Customer_Tier_Revenue_Bool_Exp>>;
  customer_tier?: InputMaybe<String_Comparison_Exp>;
  total?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.customer_tier_revenue". */
export type Fn_Return_Customer_Tier_Revenue_Order_By = {
  customer_tier?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.customer_tier_revenue" */
export enum Fn_Return_Customer_Tier_Revenue_Select_Column {
  /** column name */
  CustomerTier = 'customer_tier',
  /** column name */
  Total = 'total'
}

/** Streaming cursor of the table "fn_return_customer_tier_revenue" */
export type Fn_Return_Customer_Tier_Revenue_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Customer_Tier_Revenue_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Customer_Tier_Revenue_Stream_Cursor_Value_Input = {
  customer_tier?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['numeric']>;
};

/** columns and relationships of "fn_return.customer_type" */
export type Fn_Return_Customer_Type = {
  __typename?: 'fn_return_customer_type';
  count?: Maybe<Scalars['numeric']>;
  customer_type: Scalars['String'];
};

/** Boolean expression to filter rows from the table "fn_return.customer_type". All fields are combined with a logical 'AND'. */
export type Fn_Return_Customer_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Customer_Type_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Customer_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Customer_Type_Bool_Exp>>;
  count?: InputMaybe<Numeric_Comparison_Exp>;
  customer_type?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.customer_type". */
export type Fn_Return_Customer_Type_Order_By = {
  count?: InputMaybe<Order_By>;
  customer_type?: InputMaybe<Order_By>;
};

/** columns and relationships of "fn_return.customer_type_revenue" */
export type Fn_Return_Customer_Type_Revenue = {
  __typename?: 'fn_return_customer_type_revenue';
  customer_type: Scalars['String'];
  total?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "fn_return.customer_type_revenue". All fields are combined with a logical 'AND'. */
export type Fn_Return_Customer_Type_Revenue_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Customer_Type_Revenue_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Customer_Type_Revenue_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Customer_Type_Revenue_Bool_Exp>>;
  customer_type?: InputMaybe<String_Comparison_Exp>;
  total?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.customer_type_revenue". */
export type Fn_Return_Customer_Type_Revenue_Order_By = {
  customer_type?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.customer_type_revenue" */
export enum Fn_Return_Customer_Type_Revenue_Select_Column {
  /** column name */
  CustomerType = 'customer_type',
  /** column name */
  Total = 'total'
}

/** Streaming cursor of the table "fn_return_customer_type_revenue" */
export type Fn_Return_Customer_Type_Revenue_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Customer_Type_Revenue_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Customer_Type_Revenue_Stream_Cursor_Value_Input = {
  customer_type?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['numeric']>;
};

/** select columns of table "fn_return.customer_type" */
export enum Fn_Return_Customer_Type_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  CustomerType = 'customer_type'
}

/** Streaming cursor of the table "fn_return_customer_type" */
export type Fn_Return_Customer_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Customer_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Customer_Type_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['numeric']>;
  customer_type?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "fn_return.data_growth_graph" */
export type Fn_Return_Data_Growth_Graph = {
  __typename?: 'fn_return_data_growth_graph';
  date: Scalars['date'];
  total_rows?: Maybe<Scalars['bigint']>;
};

/** Boolean expression to filter rows from the table "fn_return.data_growth_graph". All fields are combined with a logical 'AND'. */
export type Fn_Return_Data_Growth_Graph_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Data_Growth_Graph_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Data_Growth_Graph_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Data_Growth_Graph_Bool_Exp>>;
  date?: InputMaybe<Date_Comparison_Exp>;
  total_rows?: InputMaybe<Bigint_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.data_growth_graph". */
export type Fn_Return_Data_Growth_Graph_Order_By = {
  date?: InputMaybe<Order_By>;
  total_rows?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.data_growth_graph" */
export enum Fn_Return_Data_Growth_Graph_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  TotalRows = 'total_rows'
}

/** Streaming cursor of the table "fn_return_data_growth_graph" */
export type Fn_Return_Data_Growth_Graph_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Data_Growth_Graph_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Data_Growth_Graph_Stream_Cursor_Value_Input = {
  date?: InputMaybe<Scalars['date']>;
  total_rows?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "fn_return.data_quality" */
export type Fn_Return_Data_Quality = {
  __typename?: 'fn_return_data_quality';
  accuracy?: Maybe<Scalars['numeric']>;
  column_name?: Maybe<Scalars['String']>;
  completeness?: Maybe<Scalars['numeric']>;
  date?: Maybe<Scalars['date']>;
  id: Scalars['Int'];
  table_name?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "fn_return.data_quality". All fields are combined with a logical 'AND'. */
export type Fn_Return_Data_Quality_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Data_Quality_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Data_Quality_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Data_Quality_Bool_Exp>>;
  accuracy?: InputMaybe<Numeric_Comparison_Exp>;
  column_name?: InputMaybe<String_Comparison_Exp>;
  completeness?: InputMaybe<Numeric_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  table_name?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "fn_return.data_quality_graph" */
export type Fn_Return_Data_Quality_Graph = {
  __typename?: 'fn_return_data_quality_graph';
  accuracy?: Maybe<Scalars['numeric']>;
  completeness?: Maybe<Scalars['numeric']>;
  date: Scalars['date'];
};

/** Boolean expression to filter rows from the table "fn_return.data_quality_graph". All fields are combined with a logical 'AND'. */
export type Fn_Return_Data_Quality_Graph_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Data_Quality_Graph_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Data_Quality_Graph_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Data_Quality_Graph_Bool_Exp>>;
  accuracy?: InputMaybe<Numeric_Comparison_Exp>;
  completeness?: InputMaybe<Numeric_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.data_quality_graph". */
export type Fn_Return_Data_Quality_Graph_Order_By = {
  accuracy?: InputMaybe<Order_By>;
  completeness?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.data_quality_graph" */
export enum Fn_Return_Data_Quality_Graph_Select_Column {
  /** column name */
  Accuracy = 'accuracy',
  /** column name */
  Completeness = 'completeness',
  /** column name */
  Date = 'date'
}

/** Streaming cursor of the table "fn_return_data_quality_graph" */
export type Fn_Return_Data_Quality_Graph_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Data_Quality_Graph_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Data_Quality_Graph_Stream_Cursor_Value_Input = {
  accuracy?: InputMaybe<Scalars['numeric']>;
  completeness?: InputMaybe<Scalars['numeric']>;
  date?: InputMaybe<Scalars['date']>;
};

/** Ordering options when selecting data from "fn_return.data_quality". */
export type Fn_Return_Data_Quality_Order_By = {
  accuracy?: InputMaybe<Order_By>;
  column_name?: InputMaybe<Order_By>;
  completeness?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  table_name?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.data_quality" */
export enum Fn_Return_Data_Quality_Select_Column {
  /** column name */
  Accuracy = 'accuracy',
  /** column name */
  ColumnName = 'column_name',
  /** column name */
  Completeness = 'completeness',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  TableName = 'table_name'
}

/** Streaming cursor of the table "fn_return_data_quality" */
export type Fn_Return_Data_Quality_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Data_Quality_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Data_Quality_Stream_Cursor_Value_Input = {
  accuracy?: InputMaybe<Scalars['numeric']>;
  column_name?: InputMaybe<Scalars['String']>;
  completeness?: InputMaybe<Scalars['numeric']>;
  date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['Int']>;
  table_name?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "fn_return.deliveries_count" */
export type Fn_Return_Deliveries_Count = {
  __typename?: 'fn_return_deliveries_count';
  result: Scalars['jsonb'];
};


/** columns and relationships of "fn_return.deliveries_count" */
export type Fn_Return_Deliveries_CountResultArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "fn_return.deliveries_count" */
export type Fn_Return_Deliveries_Count_Aggregate = {
  __typename?: 'fn_return_deliveries_count_aggregate';
  aggregate?: Maybe<Fn_Return_Deliveries_Count_Aggregate_Fields>;
  nodes: Array<Fn_Return_Deliveries_Count>;
};

/** aggregate fields of "fn_return.deliveries_count" */
export type Fn_Return_Deliveries_Count_Aggregate_Fields = {
  __typename?: 'fn_return_deliveries_count_aggregate_fields';
  count: Scalars['Int'];
};


/** aggregate fields of "fn_return.deliveries_count" */
export type Fn_Return_Deliveries_Count_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Deliveries_Count_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fn_return.deliveries_count" */
export type Fn_Return_Deliveries_Count_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fn_return.deliveries_count". All fields are combined with a logical 'AND'. */
export type Fn_Return_Deliveries_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Deliveries_Count_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Deliveries_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Deliveries_Count_Bool_Exp>>;
  result?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.deliveries_count". */
export type Fn_Return_Deliveries_Count_Order_By = {
  result?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.deliveries_count" */
export enum Fn_Return_Deliveries_Count_Select_Column {
  /** column name */
  Result = 'result'
}

/** Streaming cursor of the table "fn_return_deliveries_count" */
export type Fn_Return_Deliveries_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Deliveries_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Deliveries_Count_Stream_Cursor_Value_Input = {
  result?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "fn_return.delivery_channel_platform" */
export type Fn_Return_Delivery_Channel_Platform = {
  __typename?: 'fn_return_delivery_channel_platform';
  channel_id?: Maybe<Scalars['uuid']>;
  channel_logo?: Maybe<Scalars['String']>;
  channel_name?: Maybe<Scalars['String']>;
  platform_id?: Maybe<Scalars['uuid']>;
  platform_logo?: Maybe<Scalars['String']>;
  platform_name?: Maybe<Scalars['String']>;
  products: Scalars['jsonb'];
};


/** columns and relationships of "fn_return.delivery_channel_platform" */
export type Fn_Return_Delivery_Channel_PlatformProductsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

export type Fn_Return_Delivery_Channel_Platform_Aggregate = {
  __typename?: 'fn_return_delivery_channel_platform_aggregate';
  aggregate?: Maybe<Fn_Return_Delivery_Channel_Platform_Aggregate_Fields>;
  nodes: Array<Fn_Return_Delivery_Channel_Platform>;
};

/** aggregate fields of "fn_return.delivery_channel_platform" */
export type Fn_Return_Delivery_Channel_Platform_Aggregate_Fields = {
  __typename?: 'fn_return_delivery_channel_platform_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Delivery_Channel_Platform_Max_Fields>;
  min?: Maybe<Fn_Return_Delivery_Channel_Platform_Min_Fields>;
};


/** aggregate fields of "fn_return.delivery_channel_platform" */
export type Fn_Return_Delivery_Channel_Platform_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fn_return.delivery_channel_platform". All fields are combined with a logical 'AND'. */
export type Fn_Return_Delivery_Channel_Platform_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Delivery_Channel_Platform_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Bool_Exp>>;
  channel_id?: InputMaybe<Uuid_Comparison_Exp>;
  channel_logo?: InputMaybe<String_Comparison_Exp>;
  channel_name?: InputMaybe<String_Comparison_Exp>;
  platform_id?: InputMaybe<Uuid_Comparison_Exp>;
  platform_logo?: InputMaybe<String_Comparison_Exp>;
  platform_name?: InputMaybe<String_Comparison_Exp>;
  products?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fn_Return_Delivery_Channel_Platform_Max_Fields = {
  __typename?: 'fn_return_delivery_channel_platform_max_fields';
  channel_id?: Maybe<Scalars['uuid']>;
  channel_logo?: Maybe<Scalars['String']>;
  channel_name?: Maybe<Scalars['String']>;
  platform_id?: Maybe<Scalars['uuid']>;
  platform_logo?: Maybe<Scalars['String']>;
  platform_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Fn_Return_Delivery_Channel_Platform_Min_Fields = {
  __typename?: 'fn_return_delivery_channel_platform_min_fields';
  channel_id?: Maybe<Scalars['uuid']>;
  channel_logo?: Maybe<Scalars['String']>;
  channel_name?: Maybe<Scalars['String']>;
  platform_id?: Maybe<Scalars['uuid']>;
  platform_logo?: Maybe<Scalars['String']>;
  platform_name?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "fn_return.delivery_channel_platform". */
export type Fn_Return_Delivery_Channel_Platform_Order_By = {
  channel_id?: InputMaybe<Order_By>;
  channel_logo?: InputMaybe<Order_By>;
  channel_name?: InputMaybe<Order_By>;
  platform_id?: InputMaybe<Order_By>;
  platform_logo?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  products?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.delivery_channel_platform" */
export enum Fn_Return_Delivery_Channel_Platform_Select_Column {
  /** column name */
  ChannelId = 'channel_id',
  /** column name */
  ChannelLogo = 'channel_logo',
  /** column name */
  ChannelName = 'channel_name',
  /** column name */
  PlatformId = 'platform_id',
  /** column name */
  PlatformLogo = 'platform_logo',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  Products = 'products'
}

/** Streaming cursor of the table "fn_return_delivery_channel_platform" */
export type Fn_Return_Delivery_Channel_Platform_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Delivery_Channel_Platform_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Delivery_Channel_Platform_Stream_Cursor_Value_Input = {
  channel_id?: InputMaybe<Scalars['uuid']>;
  channel_logo?: InputMaybe<Scalars['String']>;
  channel_name?: InputMaybe<Scalars['String']>;
  platform_id?: InputMaybe<Scalars['uuid']>;
  platform_logo?: InputMaybe<Scalars['String']>;
  platform_name?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "fn_return.delivery_count" */
export type Fn_Return_Delivery_Count = {
  __typename?: 'fn_return_delivery_count';
  count: Scalars['bigint'];
  type?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "fn_return.delivery_count". All fields are combined with a logical 'AND'. */
export type Fn_Return_Delivery_Count_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Delivery_Count_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Delivery_Count_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Delivery_Count_Bool_Exp>>;
  count?: InputMaybe<Bigint_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.delivery_count". */
export type Fn_Return_Delivery_Count_Order_By = {
  count?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.delivery_count" */
export enum Fn_Return_Delivery_Count_Select_Column {
  /** column name */
  Count = 'count',
  /** column name */
  Type = 'type'
}

/** Streaming cursor of the table "fn_return_delivery_count" */
export type Fn_Return_Delivery_Count_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Delivery_Count_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Delivery_Count_Stream_Cursor_Value_Input = {
  count?: InputMaybe<Scalars['bigint']>;
  type?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "fn_return.delivery_payload" */
export type Fn_Return_Delivery_Payload = {
  __typename?: 'fn_return_delivery_payload';
  ads_plus_amagi_backfill?: Maybe<Scalars['String']>;
  ads_plus_amagi_primary?: Maybe<Scalars['String']>;
  ads_plus_content_partner_backfill?: Maybe<Scalars['String']>;
  ads_plus_content_partner_primary?: Maybe<Scalars['String']>;
  ads_plus_platform_partner_backfill?: Maybe<Scalars['String']>;
  ads_plus_platform_partner_primary?: Maybe<Scalars['String']>;
  amagi_id: Scalars['String'];
  cdn_fee_owner?: Maybe<Scalars['String']>;
  cdn_tag_1?: InputMaybe<Scalars['String']>;
  cdn_tag_2?: InputMaybe<Scalars['String']>;
  cdn_tag_3?: InputMaybe<Scalars['String']>;
  cdn_tag_4?: InputMaybe<Scalars['String']>;
  channel_code?: Maybe<Scalars['String']>;
  deal_share_amagi?: Maybe<Scalars['numeric']>;
  deal_share_content_partner?: Maybe<Scalars['numeric']>;
  deal_share_platform_partner?: Maybe<Scalars['numeric']>;
  deal_type?: Maybe<Scalars['String']>;
  delivery_id?: Maybe<Scalars['String']>;
  is_content_plus?: Maybe<Scalars['Boolean']>;
  platform_code?: Maybe<Scalars['String']>;
  product_code?: Maybe<Scalars['String']>;
  request_origin?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_backfill?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_primary?: Maybe<Scalars['String']>;
  ssai?: Maybe<Scalars['Boolean']>;
};

export type Fn_Return_Delivery_Payload_Aggregate = {
  __typename?: 'fn_return_delivery_payload_aggregate';
  aggregate?: Maybe<Fn_Return_Delivery_Payload_Aggregate_Fields>;
  nodes: Array<Fn_Return_Delivery_Payload>;
};

/** aggregate fields of "fn_return.delivery_payload" */
export type Fn_Return_Delivery_Payload_Aggregate_Fields = {
  __typename?: 'fn_return_delivery_payload_aggregate_fields';
  avg?: Maybe<Fn_Return_Delivery_Payload_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Delivery_Payload_Max_Fields>;
  min?: Maybe<Fn_Return_Delivery_Payload_Min_Fields>;
  stddev?: Maybe<Fn_Return_Delivery_Payload_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Delivery_Payload_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Delivery_Payload_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Delivery_Payload_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Delivery_Payload_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Delivery_Payload_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Delivery_Payload_Variance_Fields>;
};


/** aggregate fields of "fn_return.delivery_payload" */
export type Fn_Return_Delivery_Payload_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Delivery_Payload_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fn_Return_Delivery_Payload_Avg_Fields = {
  __typename?: 'fn_return_delivery_payload_avg_fields';
  deal_share_amagi?: Maybe<Scalars['Float']>;
  deal_share_content_partner?: Maybe<Scalars['Float']>;
  deal_share_platform_partner?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fn_return.delivery_payload". All fields are combined with a logical 'AND'. */
export type Fn_Return_Delivery_Payload_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Delivery_Payload_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Delivery_Payload_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Delivery_Payload_Bool_Exp>>;
  ads_plus_amagi_backfill?: InputMaybe<String_Comparison_Exp>;
  ads_plus_amagi_primary?: InputMaybe<String_Comparison_Exp>;
  ads_plus_content_partner_backfill?: InputMaybe<String_Comparison_Exp>;
  ads_plus_content_partner_primary?: InputMaybe<String_Comparison_Exp>;
  ads_plus_platform_partner_backfill?: InputMaybe<String_Comparison_Exp>;
  ads_plus_platform_partner_primary?: InputMaybe<String_Comparison_Exp>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  cdn_fee_owner?: InputMaybe<String_Comparison_Exp>;
  cdn_tag_1?: InputMaybe<Scalars['String']>;
  cdn_tag_2?: InputMaybe<Scalars['String']>;
  cdn_tag_3?: InputMaybe<Scalars['String']>;
  cdn_tag_4?: InputMaybe<Scalars['String']>;
  channel_code?: InputMaybe<String_Comparison_Exp>;
  deal_share_amagi?: InputMaybe<Numeric_Comparison_Exp>;
  deal_share_content_partner?: InputMaybe<Numeric_Comparison_Exp>;
  deal_share_platform_partner?: InputMaybe<Numeric_Comparison_Exp>;
  deal_type?: InputMaybe<String_Comparison_Exp>;
  delivery_id?: InputMaybe<String_Comparison_Exp>;
  is_content_plus?: InputMaybe<Boolean_Comparison_Exp>;
  platform_code?: InputMaybe<String_Comparison_Exp>;
  product_code?: InputMaybe<String_Comparison_Exp>;
  request_origin?: InputMaybe<String_Comparison_Exp>;
  revenue_share_monetised_by_backfill?: InputMaybe<String_Comparison_Exp>;
  revenue_share_monetised_by_primary?: InputMaybe<String_Comparison_Exp>;
  ssai?: InputMaybe<Boolean_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fn_Return_Delivery_Payload_Max_Fields = {
  __typename?: 'fn_return_delivery_payload_max_fields';
  ads_plus_amagi_backfill?: Maybe<Scalars['String']>;
  ads_plus_amagi_primary?: Maybe<Scalars['String']>;
  ads_plus_content_partner_backfill?: Maybe<Scalars['String']>;
  ads_plus_content_partner_primary?: Maybe<Scalars['String']>;
  ads_plus_platform_partner_backfill?: Maybe<Scalars['String']>;
  ads_plus_platform_partner_primary?: Maybe<Scalars['String']>;
  amagi_id?: Maybe<Scalars['String']>;
  cdn_fee_owner?: Maybe<Scalars['String']>;
  cdn_tag_1?: InputMaybe<Scalars['String']>;
  cdn_tag_2?: InputMaybe<Scalars['String']>;
  cdn_tag_3?: InputMaybe<Scalars['String']>;
  cdn_tag_4?: InputMaybe<Scalars['String']>;
  channel_code?: Maybe<Scalars['String']>;
  deal_share_amagi?: Maybe<Scalars['numeric']>;
  deal_share_content_partner?: Maybe<Scalars['numeric']>;
  deal_share_platform_partner?: Maybe<Scalars['numeric']>;
  deal_type?: Maybe<Scalars['String']>;
  delivery_id?: Maybe<Scalars['String']>;
  platform_code?: Maybe<Scalars['String']>;
  product_code?: Maybe<Scalars['String']>;
  request_origin?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_backfill?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_primary?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Fn_Return_Delivery_Payload_Min_Fields = {
  __typename?: 'fn_return_delivery_payload_min_fields';
  ads_plus_amagi_backfill?: Maybe<Scalars['String']>;
  ads_plus_amagi_primary?: Maybe<Scalars['String']>;
  ads_plus_content_partner_backfill?: Maybe<Scalars['String']>;
  ads_plus_content_partner_primary?: Maybe<Scalars['String']>;
  ads_plus_platform_partner_backfill?: Maybe<Scalars['String']>;
  ads_plus_platform_partner_primary?: Maybe<Scalars['String']>;
  amagi_id?: Maybe<Scalars['String']>;
  cdn_fee_owner?: Maybe<Scalars['String']>;
  cdn_tag_1?: InputMaybe<Scalars['String']>;
  cdn_tag_2?: InputMaybe<Scalars['String']>;
  cdn_tag_3?: InputMaybe<Scalars['String']>;
  cdn_tag_4?: InputMaybe<Scalars['String']>;
  channel_code?: Maybe<Scalars['String']>;
  deal_share_amagi?: Maybe<Scalars['numeric']>;
  deal_share_content_partner?: Maybe<Scalars['numeric']>;
  deal_share_platform_partner?: Maybe<Scalars['numeric']>;
  deal_type?: Maybe<Scalars['String']>;
  delivery_id?: Maybe<Scalars['String']>;
  platform_code?: Maybe<Scalars['String']>;
  product_code?: Maybe<Scalars['String']>;
  request_origin?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_backfill?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_primary?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "fn_return.delivery_payload". */
export type Fn_Return_Delivery_Payload_Order_By = {
  ads_plus_amagi_backfill?: InputMaybe<Order_By>;
  ads_plus_amagi_primary?: InputMaybe<Order_By>;
  ads_plus_content_partner_backfill?: InputMaybe<Order_By>;
  ads_plus_content_partner_primary?: InputMaybe<Order_By>;
  ads_plus_platform_partner_backfill?: InputMaybe<Order_By>;
  ads_plus_platform_partner_primary?: InputMaybe<Order_By>;
  amagi_id?: InputMaybe<Order_By>;
  cdn_fee_owner?: InputMaybe<Order_By>;
  cdn_tag_1?: InputMaybe<Scalars['String']>;
  cdn_tag_2?: InputMaybe<Scalars['String']>;
  cdn_tag_3?: InputMaybe<Scalars['String']>;
  cdn_tag_4?: InputMaybe<Scalars['String']>;
  channel_code?: InputMaybe<Order_By>;
  deal_share_amagi?: InputMaybe<Order_By>;
  deal_share_content_partner?: InputMaybe<Order_By>;
  deal_share_platform_partner?: InputMaybe<Order_By>;
  deal_type?: InputMaybe<Order_By>;
  delivery_id?: InputMaybe<Order_By>;
  is_content_plus?: InputMaybe<Order_By>;
  platform_code?: InputMaybe<Order_By>;
  product_code?: InputMaybe<Order_By>;
  request_origin?: InputMaybe<Order_By>;
  revenue_share_monetised_by_backfill?: InputMaybe<Order_By>;
  revenue_share_monetised_by_primary?: InputMaybe<Order_By>;
  ssai?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.delivery_payload" */
export enum Fn_Return_Delivery_Payload_Select_Column {
  /** column name */
  AdsPlusAmagiBackfill = 'ads_plus_amagi_backfill',
  /** column name */
  AdsPlusAmagiPrimary = 'ads_plus_amagi_primary',
  /** column name */
  AdsPlusContentPartnerBackfill = 'ads_plus_content_partner_backfill',
  /** column name */
  AdsPlusContentPartnerPrimary = 'ads_plus_content_partner_primary',
  /** column name */
  AdsPlusPlatformPartnerBackfill = 'ads_plus_platform_partner_backfill',
  /** column name */
  AdsPlusPlatformPartnerPrimary = 'ads_plus_platform_partner_primary',
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  CdnFeeOwner = 'cdn_fee_owner',
  /** column name */
  CdnTag_1 = 'cdn_tag_1',
  /** column name */
  CdnTag_2 = 'cdn_tag_2',
  /** column name */
  CdnTag_3 = 'cdn_tag_3',
  /** column name */
  CdnTag_4 = 'cdn_tag_4',
  /** column name */
  ChannelCode = 'channel_code',
  /** column name */
  DealShareAmagi = 'deal_share_amagi',
  /** column name */
  DealShareContentPartner = 'deal_share_content_partner',
  /** column name */
  DealSharePlatformPartner = 'deal_share_platform_partner',
  /** column name */
  DealType = 'deal_type',
  /** column name */
  DeliveryId = 'delivery_id',
  /** column name */
  IsContentPlus = 'is_content_plus',
  /** column name */
  PlatformCode = 'platform_code',
  /** column name */
  ProductCode = 'product_code',
  /** column name */
  RequestOrigin = 'request_origin',
  /** column name */
  RevenueShareMonetisedByBackfill = 'revenue_share_monetised_by_backfill',
  /** column name */
  RevenueShareMonetisedByPrimary = 'revenue_share_monetised_by_primary',
  /** column name */
  Ssai = 'ssai'
}

/** aggregate stddev on columns */
export type Fn_Return_Delivery_Payload_Stddev_Fields = {
  __typename?: 'fn_return_delivery_payload_stddev_fields';
  deal_share_amagi?: Maybe<Scalars['Float']>;
  deal_share_content_partner?: Maybe<Scalars['Float']>;
  deal_share_platform_partner?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Delivery_Payload_Stddev_Pop_Fields = {
  __typename?: 'fn_return_delivery_payload_stddev_pop_fields';
  deal_share_amagi?: Maybe<Scalars['Float']>;
  deal_share_content_partner?: Maybe<Scalars['Float']>;
  deal_share_platform_partner?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Delivery_Payload_Stddev_Samp_Fields = {
  __typename?: 'fn_return_delivery_payload_stddev_samp_fields';
  deal_share_amagi?: Maybe<Scalars['Float']>;
  deal_share_content_partner?: Maybe<Scalars['Float']>;
  deal_share_platform_partner?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fn_return_delivery_payload" */
export type Fn_Return_Delivery_Payload_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Delivery_Payload_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Delivery_Payload_Stream_Cursor_Value_Input = {
  ads_plus_amagi_backfill?: InputMaybe<Scalars['String']>;
  ads_plus_amagi_primary?: InputMaybe<Scalars['String']>;
  ads_plus_content_partner_backfill?: InputMaybe<Scalars['String']>;
  ads_plus_content_partner_primary?: InputMaybe<Scalars['String']>;
  ads_plus_platform_partner_backfill?: InputMaybe<Scalars['String']>;
  ads_plus_platform_partner_primary?: InputMaybe<Scalars['String']>;
  amagi_id?: InputMaybe<Scalars['String']>;
  cdn_fee_owner?: InputMaybe<Scalars['String']>;
  cdn_tag_1?: InputMaybe<Scalars['String']>;
  cdn_tag_2?: InputMaybe<Scalars['String']>;
  cdn_tag_3?: InputMaybe<Scalars['String']>;
  cdn_tag_4?: InputMaybe<Scalars['String']>;
  channel_code?: InputMaybe<Scalars['String']>;
  deal_share_amagi?: InputMaybe<Scalars['numeric']>;
  deal_share_content_partner?: InputMaybe<Scalars['numeric']>;
  deal_share_platform_partner?: InputMaybe<Scalars['numeric']>;
  deal_type?: InputMaybe<Scalars['String']>;
  delivery_id?: InputMaybe<Scalars['String']>;
  is_content_plus?: InputMaybe<Scalars['Boolean']>;
  platform_code?: InputMaybe<Scalars['String']>;
  product_code?: InputMaybe<Scalars['String']>;
  request_origin?: InputMaybe<Scalars['String']>;
  revenue_share_monetised_by_backfill?: InputMaybe<Scalars['String']>;
  revenue_share_monetised_by_primary?: InputMaybe<Scalars['String']>;
  ssai?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Fn_Return_Delivery_Payload_Sum_Fields = {
  __typename?: 'fn_return_delivery_payload_sum_fields';
  deal_share_amagi?: Maybe<Scalars['numeric']>;
  deal_share_content_partner?: Maybe<Scalars['numeric']>;
  deal_share_platform_partner?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Fn_Return_Delivery_Payload_Var_Pop_Fields = {
  __typename?: 'fn_return_delivery_payload_var_pop_fields';
  deal_share_amagi?: Maybe<Scalars['Float']>;
  deal_share_content_partner?: Maybe<Scalars['Float']>;
  deal_share_platform_partner?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Delivery_Payload_Var_Samp_Fields = {
  __typename?: 'fn_return_delivery_payload_var_samp_fields';
  deal_share_amagi?: Maybe<Scalars['Float']>;
  deal_share_content_partner?: Maybe<Scalars['Float']>;
  deal_share_platform_partner?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fn_Return_Delivery_Payload_Variance_Fields = {
  __typename?: 'fn_return_delivery_payload_variance_fields';
  deal_share_amagi?: Maybe<Scalars['Float']>;
  deal_share_content_partner?: Maybe<Scalars['Float']>;
  deal_share_platform_partner?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fn_return.delivery_share" */
export type Fn_Return_Delivery_Share = {
  __typename?: 'fn_return_delivery_share';
  delivery_deal: Scalars['jsonb'];
};


/** columns and relationships of "fn_return.delivery_share" */
export type Fn_Return_Delivery_ShareDelivery_DealArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "fn_return.delivery_share" */
export type Fn_Return_Delivery_Share_Aggregate = {
  __typename?: 'fn_return_delivery_share_aggregate';
  aggregate?: Maybe<Fn_Return_Delivery_Share_Aggregate_Fields>;
  nodes: Array<Fn_Return_Delivery_Share>;
};

/** aggregate fields of "fn_return.delivery_share" */
export type Fn_Return_Delivery_Share_Aggregate_Fields = {
  __typename?: 'fn_return_delivery_share_aggregate_fields';
  count: Scalars['Int'];
};


/** aggregate fields of "fn_return.delivery_share" */
export type Fn_Return_Delivery_Share_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Delivery_Share_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fn_return.delivery_share" */
export type Fn_Return_Delivery_Share_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fn_return.delivery_share". All fields are combined with a logical 'AND'. */
export type Fn_Return_Delivery_Share_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Delivery_Share_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Delivery_Share_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Delivery_Share_Bool_Exp>>;
  delivery_deal?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.delivery_share". */
export type Fn_Return_Delivery_Share_Order_By = {
  delivery_deal?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.delivery_share" */
export enum Fn_Return_Delivery_Share_Select_Column {
  /** column name */
  DeliveryDeal = 'delivery_deal'
}

/** Streaming cursor of the table "fn_return_delivery_share" */
export type Fn_Return_Delivery_Share_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Delivery_Share_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Delivery_Share_Stream_Cursor_Value_Input = {
  delivery_deal?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "fn_return.domain_validation" */
export type Fn_Return_Domain_Validation = {
  __typename?: 'fn_return_domain_validation';
  domain_exist: Scalars['jsonb'];
  email_exist: Scalars['jsonb'];
};


/** columns and relationships of "fn_return.domain_validation" */
export type Fn_Return_Domain_ValidationDomain_ExistArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "fn_return.domain_validation" */
export type Fn_Return_Domain_ValidationEmail_ExistArgs = {
  path?: InputMaybe<Scalars['String']>;
};

export type Fn_Return_Domain_Validation_Aggregate = {
  __typename?: 'fn_return_domain_validation_aggregate';
  aggregate?: Maybe<Fn_Return_Domain_Validation_Aggregate_Fields>;
  nodes: Array<Fn_Return_Domain_Validation>;
};

/** aggregate fields of "fn_return.domain_validation" */
export type Fn_Return_Domain_Validation_Aggregate_Fields = {
  __typename?: 'fn_return_domain_validation_aggregate_fields';
  count: Scalars['Int'];
};


/** aggregate fields of "fn_return.domain_validation" */
export type Fn_Return_Domain_Validation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Domain_Validation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fn_return.domain_validation". All fields are combined with a logical 'AND'. */
export type Fn_Return_Domain_Validation_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Domain_Validation_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Domain_Validation_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Domain_Validation_Bool_Exp>>;
  domain_exist?: InputMaybe<Jsonb_Comparison_Exp>;
  email_exist?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.domain_validation". */
export type Fn_Return_Domain_Validation_Order_By = {
  domain_exist?: InputMaybe<Order_By>;
  email_exist?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.domain_validation" */
export enum Fn_Return_Domain_Validation_Select_Column {
  /** column name */
  DomainExist = 'domain_exist',
  /** column name */
  EmailExist = 'email_exist'
}

/** Streaming cursor of the table "fn_return_domain_validation" */
export type Fn_Return_Domain_Validation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Domain_Validation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Domain_Validation_Stream_Cursor_Value_Input = {
  domain_exist?: InputMaybe<Scalars['jsonb']>;
  email_exist?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "fn_return.email_validation" */
export type Fn_Return_Email_Validation = {
  __typename?: 'fn_return_email_validation';
  email_exist: Scalars['jsonb'];
};


/** columns and relationships of "fn_return.email_validation" */
export type Fn_Return_Email_ValidationEmail_ExistArgs = {
  path?: InputMaybe<Scalars['String']>;
};

export type Fn_Return_Email_Validation_Aggregate = {
  __typename?: 'fn_return_email_validation_aggregate';
  aggregate?: Maybe<Fn_Return_Email_Validation_Aggregate_Fields>;
  nodes: Array<Fn_Return_Email_Validation>;
};

/** aggregate fields of "fn_return.email_validation" */
export type Fn_Return_Email_Validation_Aggregate_Fields = {
  __typename?: 'fn_return_email_validation_aggregate_fields';
  count: Scalars['Int'];
};


/** aggregate fields of "fn_return.email_validation" */
export type Fn_Return_Email_Validation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Email_Validation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fn_return.email_validation". All fields are combined with a logical 'AND'. */
export type Fn_Return_Email_Validation_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Email_Validation_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Email_Validation_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Email_Validation_Bool_Exp>>;
  email_exist?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.email_validation". */
export type Fn_Return_Email_Validation_Order_By = {
  email_exist?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.email_validation" */
export enum Fn_Return_Email_Validation_Select_Column {
  /** column name */
  EmailExist = 'email_exist'
}

/** Streaming cursor of the table "fn_return_email_validation" */
export type Fn_Return_Email_Validation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Email_Validation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Email_Validation_Stream_Cursor_Value_Input = {
  email_exist?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "fn_return.existing_new_churned_dashboard" */
export type Fn_Return_Existing_New_Churned_Dashboard = {
  __typename?: 'fn_return_existing_new_churned_dashboard';
  churned: Scalars['bigint'];
  existing: Scalars['numeric'];
  month: Scalars['String'];
  new: Scalars['bigint'];
};

/** Boolean expression to filter rows from the table "fn_return.existing_new_churned_dashboard". All fields are combined with a logical 'AND'. */
export type Fn_Return_Existing_New_Churned_Dashboard_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Existing_New_Churned_Dashboard_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Bool_Exp>>;
  churned?: InputMaybe<Bigint_Comparison_Exp>;
  existing?: InputMaybe<Numeric_Comparison_Exp>;
  month?: InputMaybe<String_Comparison_Exp>;
  new?: InputMaybe<Bigint_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.existing_new_churned_dashboard". */
export type Fn_Return_Existing_New_Churned_Dashboard_Order_By = {
  churned?: InputMaybe<Order_By>;
  existing?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  new?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.existing_new_churned_dashboard" */
export enum Fn_Return_Existing_New_Churned_Dashboard_Select_Column {
  /** column name */
  Churned = 'churned',
  /** column name */
  Existing = 'existing',
  /** column name */
  Month = 'month',
  /** column name */
  New = 'new'
}

/** Streaming cursor of the table "fn_return_existing_new_churned_dashboard" */
export type Fn_Return_Existing_New_Churned_Dashboard_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Existing_New_Churned_Dashboard_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Existing_New_Churned_Dashboard_Stream_Cursor_Value_Input = {
  churned?: InputMaybe<Scalars['bigint']>;
  existing?: InputMaybe<Scalars['numeric']>;
  month?: InputMaybe<Scalars['String']>;
  new?: InputMaybe<Scalars['bigint']>;
};

/** columns and relationships of "fn_return.financial_graph" */
export type Fn_Return_Financial_Graph = {
  __typename?: 'fn_return_financial_graph';
  amount: Scalars['numeric'];
  month: Scalars['String'];
};

/** order by aggregate values of table "fn_return.financial_graph" */
export type Fn_Return_Financial_Graph_Aggregate_Order_By = {
  avg?: InputMaybe<Fn_Return_Financial_Graph_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fn_Return_Financial_Graph_Max_Order_By>;
  min?: InputMaybe<Fn_Return_Financial_Graph_Min_Order_By>;
  stddev?: InputMaybe<Fn_Return_Financial_Graph_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fn_Return_Financial_Graph_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fn_Return_Financial_Graph_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fn_Return_Financial_Graph_Sum_Order_By>;
  var_pop?: InputMaybe<Fn_Return_Financial_Graph_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fn_Return_Financial_Graph_Var_Samp_Order_By>;
  variance?: InputMaybe<Fn_Return_Financial_Graph_Variance_Order_By>;
};

/** order by avg() on columns of table "fn_return.financial_graph" */
export type Fn_Return_Financial_Graph_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fn_return.financial_graph". All fields are combined with a logical 'AND'. */
export type Fn_Return_Financial_Graph_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Financial_Graph_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Financial_Graph_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  month?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "fn_return.financial_graph" */
export type Fn_Return_Financial_Graph_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "fn_return.financial_graph" */
export type Fn_Return_Financial_Graph_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "fn_return.financial_graph". */
export type Fn_Return_Financial_Graph_Order_By = {
  amount?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.financial_graph" */
export enum Fn_Return_Financial_Graph_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Month = 'month'
}

/** order by stddev() on columns of table "fn_return.financial_graph" */
export type Fn_Return_Financial_Graph_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "fn_return.financial_graph" */
export type Fn_Return_Financial_Graph_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "fn_return.financial_graph" */
export type Fn_Return_Financial_Graph_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fn_return_financial_graph" */
export type Fn_Return_Financial_Graph_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Financial_Graph_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Financial_Graph_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  month?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "fn_return.financial_graph" */
export type Fn_Return_Financial_Graph_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "fn_return.financial_graph" */
export type Fn_Return_Financial_Graph_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "fn_return.financial_graph" */
export type Fn_Return_Financial_Graph_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "fn_return.financial_graph" */
export type Fn_Return_Financial_Graph_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr = {
  __typename?: 'fn_return_latest_mrr';
  amount: Scalars['numeric'];
  month: Scalars['String'];
  revenue_split?: Maybe<Scalars['String']>;
};

/** aggregated selection of "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr_Aggregate = {
  __typename?: 'fn_return_latest_mrr_aggregate';
  aggregate?: Maybe<Fn_Return_Latest_Mrr_Aggregate_Fields>;
  nodes: Array<Fn_Return_Latest_Mrr>;
};

/** aggregate fields of "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr_Aggregate_Fields = {
  __typename?: 'fn_return_latest_mrr_aggregate_fields';
  avg?: Maybe<Fn_Return_Latest_Mrr_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Latest_Mrr_Max_Fields>;
  min?: Maybe<Fn_Return_Latest_Mrr_Min_Fields>;
  stddev?: Maybe<Fn_Return_Latest_Mrr_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Latest_Mrr_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Latest_Mrr_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Latest_Mrr_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Latest_Mrr_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Latest_Mrr_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Latest_Mrr_Variance_Fields>;
};


/** aggregate fields of "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Latest_Mrr_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr_Aggregate_Order_By = {
  avg?: InputMaybe<Fn_Return_Latest_Mrr_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fn_Return_Latest_Mrr_Max_Order_By>;
  min?: InputMaybe<Fn_Return_Latest_Mrr_Min_Order_By>;
  stddev?: InputMaybe<Fn_Return_Latest_Mrr_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fn_Return_Latest_Mrr_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fn_Return_Latest_Mrr_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fn_Return_Latest_Mrr_Sum_Order_By>;
  var_pop?: InputMaybe<Fn_Return_Latest_Mrr_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fn_Return_Latest_Mrr_Var_Samp_Order_By>;
  variance?: InputMaybe<Fn_Return_Latest_Mrr_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fn_Return_Latest_Mrr_Avg_Fields = {
  __typename?: 'fn_return_latest_mrr_avg_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fn_return.latest_mrr". All fields are combined with a logical 'AND'. */
export type Fn_Return_Latest_Mrr_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Latest_Mrr_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Latest_Mrr_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Latest_Mrr_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  month?: InputMaybe<String_Comparison_Exp>;
  revenue_split?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fn_Return_Latest_Mrr_Max_Fields = {
  __typename?: 'fn_return_latest_mrr_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  month?: Maybe<Scalars['String']>;
  revenue_split?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  revenue_split?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fn_Return_Latest_Mrr_Min_Fields = {
  __typename?: 'fn_return_latest_mrr_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  month?: Maybe<Scalars['String']>;
  revenue_split?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  revenue_split?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "fn_return.latest_mrr". */
export type Fn_Return_Latest_Mrr_Order_By = {
  amount?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  revenue_split?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.latest_mrr" */
export enum Fn_Return_Latest_Mrr_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Month = 'month',
  /** column name */
  RevenueSplit = 'revenue_split'
}

/** aggregate stddev on columns */
export type Fn_Return_Latest_Mrr_Stddev_Fields = {
  __typename?: 'fn_return_latest_mrr_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Latest_Mrr_Stddev_Pop_Fields = {
  __typename?: 'fn_return_latest_mrr_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Latest_Mrr_Stddev_Samp_Fields = {
  __typename?: 'fn_return_latest_mrr_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fn_return_latest_mrr" */
export type Fn_Return_Latest_Mrr_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Latest_Mrr_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Latest_Mrr_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  month?: InputMaybe<Scalars['String']>;
  revenue_split?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Fn_Return_Latest_Mrr_Sum_Fields = {
  __typename?: 'fn_return_latest_mrr_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Fn_Return_Latest_Mrr_Var_Pop_Fields = {
  __typename?: 'fn_return_latest_mrr_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Latest_Mrr_Var_Samp_Fields = {
  __typename?: 'fn_return_latest_mrr_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fn_Return_Latest_Mrr_Variance_Fields = {
  __typename?: 'fn_return_latest_mrr_variance_fields';
  amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "fn_return.latest_mrr" */
export type Fn_Return_Latest_Mrr_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "fn_return.msa_rate_card" */
export type Fn_Return_Msa_Rate_Card = {
  __typename?: 'fn_return_msa_rate_card';
  products?: Maybe<Scalars['jsonb']>;
  quote_number: Scalars['String'];
  quote_type?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};


/** columns and relationships of "fn_return.msa_rate_card" */
export type Fn_Return_Msa_Rate_CardProductsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "fn_return.msa_rate_card" */
export type Fn_Return_Msa_Rate_Card_Aggregate = {
  __typename?: 'fn_return_msa_rate_card_aggregate';
  aggregate?: Maybe<Fn_Return_Msa_Rate_Card_Aggregate_Fields>;
  nodes: Array<Fn_Return_Msa_Rate_Card>;
};

/** aggregate fields of "fn_return.msa_rate_card" */
export type Fn_Return_Msa_Rate_Card_Aggregate_Fields = {
  __typename?: 'fn_return_msa_rate_card_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Msa_Rate_Card_Max_Fields>;
  min?: Maybe<Fn_Return_Msa_Rate_Card_Min_Fields>;
};


/** aggregate fields of "fn_return.msa_rate_card" */
export type Fn_Return_Msa_Rate_Card_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "fn_return.msa_rate_card". All fields are combined with a logical 'AND'. */
export type Fn_Return_Msa_Rate_Card_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Msa_Rate_Card_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Bool_Exp>>;
  products?: InputMaybe<Jsonb_Comparison_Exp>;
  quote_number?: InputMaybe<String_Comparison_Exp>;
  quote_type?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fn_Return_Msa_Rate_Card_Max_Fields = {
  __typename?: 'fn_return_msa_rate_card_max_fields';
  quote_number?: Maybe<Scalars['String']>;
  quote_type?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Fn_Return_Msa_Rate_Card_Min_Fields = {
  __typename?: 'fn_return_msa_rate_card_min_fields';
  quote_number?: Maybe<Scalars['String']>;
  quote_type?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "fn_return.msa_rate_card". */
export type Fn_Return_Msa_Rate_Card_Order_By = {
  products?: InputMaybe<Order_By>;
  quote_number?: InputMaybe<Order_By>;
  quote_type?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.msa_rate_card" */
export enum Fn_Return_Msa_Rate_Card_Select_Column {
  /** column name */
  Products = 'products',
  /** column name */
  QuoteNumber = 'quote_number',
  /** column name */
  QuoteType = 'quote_type',
  /** column name */
  Status = 'status'
}

/** Streaming cursor of the table "fn_return_msa_rate_card" */
export type Fn_Return_Msa_Rate_Card_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Msa_Rate_Card_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Msa_Rate_Card_Stream_Cursor_Value_Input = {
  products?: InputMaybe<Scalars['jsonb']>;
  quote_number?: InputMaybe<Scalars['String']>;
  quote_type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "fn_return.product_financial_graph" */
export type Fn_Return_Product_Financial_Graph = {
  __typename?: 'fn_return_product_financial_graph';
  amount: Scalars['numeric'];
  amount_to_date: Scalars['numeric'];
  month: Scalars['String'];
  name: Scalars['String'];
};

/** order by aggregate values of table "fn_return.product_financial_graph" */
export type Fn_Return_Product_Financial_Graph_Aggregate_Order_By = {
  avg?: InputMaybe<Fn_Return_Product_Financial_Graph_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fn_Return_Product_Financial_Graph_Max_Order_By>;
  min?: InputMaybe<Fn_Return_Product_Financial_Graph_Min_Order_By>;
  stddev?: InputMaybe<Fn_Return_Product_Financial_Graph_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fn_Return_Product_Financial_Graph_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fn_Return_Product_Financial_Graph_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fn_Return_Product_Financial_Graph_Sum_Order_By>;
  var_pop?: InputMaybe<Fn_Return_Product_Financial_Graph_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fn_Return_Product_Financial_Graph_Var_Samp_Order_By>;
  variance?: InputMaybe<Fn_Return_Product_Financial_Graph_Variance_Order_By>;
};

/** order by avg() on columns of table "fn_return.product_financial_graph" */
export type Fn_Return_Product_Financial_Graph_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_to_date?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fn_return.product_financial_graph". All fields are combined with a logical 'AND'. */
export type Fn_Return_Product_Financial_Graph_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Product_Financial_Graph_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Product_Financial_Graph_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Product_Financial_Graph_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  amount_to_date?: InputMaybe<Numeric_Comparison_Exp>;
  month?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "fn_return.product_financial_graph" */
export type Fn_Return_Product_Financial_Graph_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_to_date?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "fn_return.product_financial_graph" */
export type Fn_Return_Product_Financial_Graph_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_to_date?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "fn_return.product_financial_graph". */
export type Fn_Return_Product_Financial_Graph_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_to_date?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.product_financial_graph" */
export enum Fn_Return_Product_Financial_Graph_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountToDate = 'amount_to_date',
  /** column name */
  Month = 'month',
  /** column name */
  Name = 'name'
}

/** order by stddev() on columns of table "fn_return.product_financial_graph" */
export type Fn_Return_Product_Financial_Graph_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_to_date?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "fn_return.product_financial_graph" */
export type Fn_Return_Product_Financial_Graph_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_to_date?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "fn_return.product_financial_graph" */
export type Fn_Return_Product_Financial_Graph_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_to_date?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fn_return_product_financial_graph" */
export type Fn_Return_Product_Financial_Graph_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Product_Financial_Graph_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Product_Financial_Graph_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  amount_to_date?: InputMaybe<Scalars['numeric']>;
  month?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "fn_return.product_financial_graph" */
export type Fn_Return_Product_Financial_Graph_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_to_date?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "fn_return.product_financial_graph" */
export type Fn_Return_Product_Financial_Graph_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_to_date?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "fn_return.product_financial_graph" */
export type Fn_Return_Product_Financial_Graph_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_to_date?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "fn_return.product_financial_graph" */
export type Fn_Return_Product_Financial_Graph_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_to_date?: InputMaybe<Order_By>;
};

/** columns and relationships of "fn_return.product_purchased" */
export type Fn_Return_Product_Purchased = {
  __typename?: 'fn_return_product_purchased';
  product_count?: Maybe<Scalars['bigint']>;
  product_id: Scalars['String'];
  product_name?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "fn_return.product_purchased". All fields are combined with a logical 'AND'. */
export type Fn_Return_Product_Purchased_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Product_Purchased_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Product_Purchased_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Product_Purchased_Bool_Exp>>;
  product_count?: InputMaybe<Bigint_Comparison_Exp>;
  product_id?: InputMaybe<String_Comparison_Exp>;
  product_name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.product_purchased". */
export type Fn_Return_Product_Purchased_Order_By = {
  product_count?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.product_purchased" */
export enum Fn_Return_Product_Purchased_Select_Column {
  /** column name */
  ProductCount = 'product_count',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ProductName = 'product_name'
}

/** Streaming cursor of the table "fn_return_product_purchased" */
export type Fn_Return_Product_Purchased_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Product_Purchased_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Product_Purchased_Stream_Cursor_Value_Input = {
  product_count?: InputMaybe<Scalars['bigint']>;
  product_id?: InputMaybe<Scalars['String']>;
  product_name?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "fn_return.product_table_detail" */
export type Fn_Return_Product_Table_Detail = {
  __typename?: 'fn_return_product_table_detail';
  arr: Scalars['numeric'];
  consumption_mrr: Scalars['numeric'];
  family: Scalars['String'];
  group: Scalars['String'];
  mrr: Scalars['numeric'];
  name: Scalars['String'];
  one_time_fee: Scalars['numeric'];
  product_id: Scalars['String'];
  short_name?: Maybe<Scalars['String']>;
  sub_group: Scalars['String'];
  subscription: Scalars['numeric'];
};

/** Boolean expression to filter rows from the table "fn_return.product_table_detail". All fields are combined with a logical 'AND'. */
export type Fn_Return_Product_Table_Detail_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Product_Table_Detail_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Product_Table_Detail_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Product_Table_Detail_Bool_Exp>>;
  arr?: InputMaybe<Numeric_Comparison_Exp>;
  consumption_mrr?: InputMaybe<Numeric_Comparison_Exp>;
  family?: InputMaybe<String_Comparison_Exp>;
  group?: InputMaybe<String_Comparison_Exp>;
  mrr?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  one_time_fee?: InputMaybe<Numeric_Comparison_Exp>;
  product_id?: InputMaybe<String_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  sub_group?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.product_table_detail". */
export type Fn_Return_Product_Table_Detail_Order_By = {
  arr?: InputMaybe<Order_By>;
  consumption_mrr?: InputMaybe<Order_By>;
  family?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  mrr?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  one_time_fee?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  sub_group?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.product_table_detail" */
export enum Fn_Return_Product_Table_Detail_Select_Column {
  /** column name */
  Arr = 'arr',
  /** column name */
  ConsumptionMrr = 'consumption_mrr',
  /** column name */
  Family = 'family',
  /** column name */
  Group = 'group',
  /** column name */
  Mrr = 'mrr',
  /** column name */
  Name = 'name',
  /** column name */
  OneTimeFee = 'one_time_fee',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  SubGroup = 'sub_group',
  /** column name */
  Subscription = 'subscription'
}

/** Streaming cursor of the table "fn_return_product_table_detail" */
export type Fn_Return_Product_Table_Detail_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Product_Table_Detail_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Product_Table_Detail_Stream_Cursor_Value_Input = {
  arr?: InputMaybe<Scalars['numeric']>;
  consumption_mrr?: InputMaybe<Scalars['numeric']>;
  family?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  mrr?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  one_time_fee?: InputMaybe<Scalars['numeric']>;
  product_id?: InputMaybe<Scalars['String']>;
  short_name?: InputMaybe<Scalars['String']>;
  sub_group?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Scalars['numeric']>;
};

/** columns and relationships of "fn_return.revenue_segment_data" */
export type Fn_Return_Revenue_Segment_Data = {
  __typename?: 'fn_return_revenue_segment_data';
  amagi_id: Scalars['String'];
  average_mrr?: Maybe<Scalars['numeric']>;
  updated_date?: Maybe<Scalars['date']>;
};

/** aggregated selection of "fn_return.revenue_segment_data" */
export type Fn_Return_Revenue_Segment_Data_Aggregate = {
  __typename?: 'fn_return_revenue_segment_data_aggregate';
  aggregate?: Maybe<Fn_Return_Revenue_Segment_Data_Aggregate_Fields>;
  nodes: Array<Fn_Return_Revenue_Segment_Data>;
};

/** aggregate fields of "fn_return.revenue_segment_data" */
export type Fn_Return_Revenue_Segment_Data_Aggregate_Fields = {
  __typename?: 'fn_return_revenue_segment_data_aggregate_fields';
  avg?: Maybe<Fn_Return_Revenue_Segment_Data_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Revenue_Segment_Data_Max_Fields>;
  min?: Maybe<Fn_Return_Revenue_Segment_Data_Min_Fields>;
  stddev?: Maybe<Fn_Return_Revenue_Segment_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Revenue_Segment_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Revenue_Segment_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Revenue_Segment_Data_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Revenue_Segment_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Revenue_Segment_Data_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Revenue_Segment_Data_Variance_Fields>;
};


/** aggregate fields of "fn_return.revenue_segment_data" */
export type Fn_Return_Revenue_Segment_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fn_Return_Revenue_Segment_Data_Avg_Fields = {
  __typename?: 'fn_return_revenue_segment_data_avg_fields';
  average_mrr?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fn_return.revenue_segment_data". All fields are combined with a logical 'AND'. */
export type Fn_Return_Revenue_Segment_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Revenue_Segment_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Bool_Exp>>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  average_mrr?: InputMaybe<Numeric_Comparison_Exp>;
  updated_date?: InputMaybe<Date_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fn_Return_Revenue_Segment_Data_Max_Fields = {
  __typename?: 'fn_return_revenue_segment_data_max_fields';
  amagi_id?: Maybe<Scalars['String']>;
  average_mrr?: Maybe<Scalars['numeric']>;
  updated_date?: Maybe<Scalars['date']>;
};

/** aggregate min on columns */
export type Fn_Return_Revenue_Segment_Data_Min_Fields = {
  __typename?: 'fn_return_revenue_segment_data_min_fields';
  amagi_id?: Maybe<Scalars['String']>;
  average_mrr?: Maybe<Scalars['numeric']>;
  updated_date?: Maybe<Scalars['date']>;
};

/** Ordering options when selecting data from "fn_return.revenue_segment_data". */
export type Fn_Return_Revenue_Segment_Data_Order_By = {
  amagi_id?: InputMaybe<Order_By>;
  average_mrr?: InputMaybe<Order_By>;
  updated_date?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.revenue_segment_data" */
export enum Fn_Return_Revenue_Segment_Data_Select_Column {
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  AverageMrr = 'average_mrr',
  /** column name */
  UpdatedDate = 'updated_date'
}

/** aggregate stddev on columns */
export type Fn_Return_Revenue_Segment_Data_Stddev_Fields = {
  __typename?: 'fn_return_revenue_segment_data_stddev_fields';
  average_mrr?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Revenue_Segment_Data_Stddev_Pop_Fields = {
  __typename?: 'fn_return_revenue_segment_data_stddev_pop_fields';
  average_mrr?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Revenue_Segment_Data_Stddev_Samp_Fields = {
  __typename?: 'fn_return_revenue_segment_data_stddev_samp_fields';
  average_mrr?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fn_return_revenue_segment_data" */
export type Fn_Return_Revenue_Segment_Data_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Revenue_Segment_Data_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Revenue_Segment_Data_Stream_Cursor_Value_Input = {
  amagi_id?: InputMaybe<Scalars['String']>;
  average_mrr?: InputMaybe<Scalars['numeric']>;
  updated_date?: InputMaybe<Scalars['date']>;
};

/** aggregate sum on columns */
export type Fn_Return_Revenue_Segment_Data_Sum_Fields = {
  __typename?: 'fn_return_revenue_segment_data_sum_fields';
  average_mrr?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Fn_Return_Revenue_Segment_Data_Var_Pop_Fields = {
  __typename?: 'fn_return_revenue_segment_data_var_pop_fields';
  average_mrr?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Revenue_Segment_Data_Var_Samp_Fields = {
  __typename?: 'fn_return_revenue_segment_data_var_samp_fields';
  average_mrr?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fn_Return_Revenue_Segment_Data_Variance_Fields = {
  __typename?: 'fn_return_revenue_segment_data_variance_fields';
  average_mrr?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "fn_return.revenue_split" */
export type Fn_Return_Revenue_Split = {
  __typename?: 'fn_return_revenue_split';
  amount: Scalars['numeric'];
  currency?: Maybe<Scalars['String']>;
  month: Scalars['String'];
  revenue_split: Scalars['String'];
};

/** Boolean expression to filter rows from the table "fn_return.revenue_split". All fields are combined with a logical 'AND'. */
export type Fn_Return_Revenue_Split_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Revenue_Split_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Revenue_Split_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Revenue_Split_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  month?: InputMaybe<String_Comparison_Exp>;
  revenue_split?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.revenue_split". */
export type Fn_Return_Revenue_Split_Order_By = {
  amount?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  revenue_split?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.revenue_split" */
export enum Fn_Return_Revenue_Split_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Currency = 'currency',
  /** column name */
  Month = 'month',
  /** column name */
  RevenueSplit = 'revenue_split'
}

/** Streaming cursor of the table "fn_return_revenue_split" */
export type Fn_Return_Revenue_Split_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Revenue_Split_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Revenue_Split_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  currency?: InputMaybe<Scalars['String']>;
  month?: InputMaybe<Scalars['String']>;
  revenue_split?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "fn_return.sales_response" */
export type Fn_Return_Sales_Response = {
  __typename?: 'fn_return_sales_response';
  amount: Scalars['numeric'];
  source: Scalars['String'];
  status: Scalars['String'];
};

/** order by aggregate values of table "fn_return.sales_response" */
export type Fn_Return_Sales_Response_Aggregate_Order_By = {
  avg?: InputMaybe<Fn_Return_Sales_Response_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fn_Return_Sales_Response_Max_Order_By>;
  min?: InputMaybe<Fn_Return_Sales_Response_Min_Order_By>;
  stddev?: InputMaybe<Fn_Return_Sales_Response_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fn_Return_Sales_Response_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fn_Return_Sales_Response_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fn_Return_Sales_Response_Sum_Order_By>;
  var_pop?: InputMaybe<Fn_Return_Sales_Response_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fn_Return_Sales_Response_Var_Samp_Order_By>;
  variance?: InputMaybe<Fn_Return_Sales_Response_Variance_Order_By>;
};

/** order by avg() on columns of table "fn_return.sales_response" */
export type Fn_Return_Sales_Response_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fn_return.sales_response". All fields are combined with a logical 'AND'. */
export type Fn_Return_Sales_Response_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Sales_Response_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Sales_Response_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Sales_Response_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "fn_return.sales_response" */
export type Fn_Return_Sales_Response_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "fn_return.sales_response" */
export type Fn_Return_Sales_Response_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "fn_return.sales_response". */
export type Fn_Return_Sales_Response_Order_By = {
  amount?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.sales_response" */
export enum Fn_Return_Sales_Response_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status'
}

/** order by stddev() on columns of table "fn_return.sales_response" */
export type Fn_Return_Sales_Response_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "fn_return.sales_response" */
export type Fn_Return_Sales_Response_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "fn_return.sales_response" */
export type Fn_Return_Sales_Response_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fn_return_sales_response" */
export type Fn_Return_Sales_Response_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Sales_Response_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Sales_Response_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** order by sum() on columns of table "fn_return.sales_response" */
export type Fn_Return_Sales_Response_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "fn_return.sales_response" */
export type Fn_Return_Sales_Response_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "fn_return.sales_response" */
export type Fn_Return_Sales_Response_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "fn_return.sales_response" */
export type Fn_Return_Sales_Response_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "fn_return.sf_ns_check" */
export type Fn_Return_Sf_Ns_Check = {
  __typename?: 'fn_return_sf_ns_check';
  check: Scalars['String'];
};

/** Boolean expression to filter rows from the table "fn_return.sf_ns_check". All fields are combined with a logical 'AND'. */
export type Fn_Return_Sf_Ns_Check_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Sf_Ns_Check_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Sf_Ns_Check_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Sf_Ns_Check_Bool_Exp>>;
  check?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.sf_ns_check". */
export type Fn_Return_Sf_Ns_Check_Order_By = {
  check?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.sf_ns_check" */
export enum Fn_Return_Sf_Ns_Check_Select_Column {
  /** column name */
  Check = 'check'
}

/** Streaming cursor of the table "fn_return_sf_ns_check" */
export type Fn_Return_Sf_Ns_Check_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Sf_Ns_Check_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Sf_Ns_Check_Stream_Cursor_Value_Input = {
  check?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "fn_return.top_customers" */
export type Fn_Return_Top_Customers = {
  __typename?: 'fn_return_top_customers';
  account_name: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['numeric']>;
};

/** Boolean expression to filter rows from the table "fn_return.top_customers". All fields are combined with a logical 'AND'. */
export type Fn_Return_Top_Customers_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Top_Customers_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Top_Customers_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Top_Customers_Bool_Exp>>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  total?: InputMaybe<Numeric_Comparison_Exp>;
};

/** Ordering options when selecting data from "fn_return.top_customers". */
export type Fn_Return_Top_Customers_Order_By = {
  account_name?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.top_customers" */
export enum Fn_Return_Top_Customers_Select_Column {
  /** column name */
  AccountName = 'account_name',
  /** column name */
  Logo = 'logo',
  /** column name */
  Total = 'total'
}

/** Streaming cursor of the table "fn_return_top_customers" */
export type Fn_Return_Top_Customers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Top_Customers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Top_Customers_Stream_Cursor_Value_Input = {
  account_name?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['numeric']>;
};

/** columns and relationships of "fn_return.total_open_close_ticket_dashboard" */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard = {
  __typename?: 'fn_return_total_open_close_ticket_dashboard';
  closed_ticket?: Maybe<Scalars['bigint']>;
  month: Scalars['String'];
  open_ticket?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "fn_return.total_open_close_ticket_dashboard" */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Aggregate = {
  __typename?: 'fn_return_total_open_close_ticket_dashboard_aggregate';
  aggregate?: Maybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Aggregate_Fields>;
  nodes: Array<Fn_Return_Total_Open_Close_Ticket_Dashboard>;
};

/** aggregate fields of "fn_return.total_open_close_ticket_dashboard" */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Aggregate_Fields = {
  __typename?: 'fn_return_total_open_close_ticket_dashboard_aggregate_fields';
  avg?: Maybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Max_Fields>;
  min?: Maybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Min_Fields>;
  stddev?: Maybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Stddev_Fields>;
  stddev_pop?: Maybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Stddev_Samp_Fields>;
  sum?: Maybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Sum_Fields>;
  var_pop?: Maybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Var_Pop_Fields>;
  var_samp?: Maybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Var_Samp_Fields>;
  variance?: Maybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Variance_Fields>;
};


/** aggregate fields of "fn_return.total_open_close_ticket_dashboard" */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Avg_Fields = {
  __typename?: 'fn_return_total_open_close_ticket_dashboard_avg_fields';
  closed_ticket?: Maybe<Scalars['Float']>;
  open_ticket?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "fn_return.total_open_close_ticket_dashboard". All fields are combined with a logical 'AND'. */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Bool_Exp = {
  _and?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Bool_Exp>>;
  _not?: InputMaybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Bool_Exp>;
  _or?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Bool_Exp>>;
  closed_ticket?: InputMaybe<Bigint_Comparison_Exp>;
  month?: InputMaybe<String_Comparison_Exp>;
  open_ticket?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Max_Fields = {
  __typename?: 'fn_return_total_open_close_ticket_dashboard_max_fields';
  closed_ticket?: Maybe<Scalars['bigint']>;
  month?: Maybe<Scalars['String']>;
  open_ticket?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Min_Fields = {
  __typename?: 'fn_return_total_open_close_ticket_dashboard_min_fields';
  closed_ticket?: Maybe<Scalars['bigint']>;
  month?: Maybe<Scalars['String']>;
  open_ticket?: Maybe<Scalars['bigint']>;
};

/** Ordering options when selecting data from "fn_return.total_open_close_ticket_dashboard". */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Order_By = {
  closed_ticket?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  open_ticket?: InputMaybe<Order_By>;
};

/** select columns of table "fn_return.total_open_close_ticket_dashboard" */
export enum Fn_Return_Total_Open_Close_Ticket_Dashboard_Select_Column {
  /** column name */
  ClosedTicket = 'closed_ticket',
  /** column name */
  Month = 'month',
  /** column name */
  OpenTicket = 'open_ticket'
}

/** aggregate stddev on columns */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Stddev_Fields = {
  __typename?: 'fn_return_total_open_close_ticket_dashboard_stddev_fields';
  closed_ticket?: Maybe<Scalars['Float']>;
  open_ticket?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Stddev_Pop_Fields = {
  __typename?: 'fn_return_total_open_close_ticket_dashboard_stddev_pop_fields';
  closed_ticket?: Maybe<Scalars['Float']>;
  open_ticket?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Stddev_Samp_Fields = {
  __typename?: 'fn_return_total_open_close_ticket_dashboard_stddev_samp_fields';
  closed_ticket?: Maybe<Scalars['Float']>;
  open_ticket?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "fn_return_total_open_close_ticket_dashboard" */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fn_Return_Total_Open_Close_Ticket_Dashboard_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Stream_Cursor_Value_Input = {
  closed_ticket?: InputMaybe<Scalars['bigint']>;
  month?: InputMaybe<Scalars['String']>;
  open_ticket?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Sum_Fields = {
  __typename?: 'fn_return_total_open_close_ticket_dashboard_sum_fields';
  closed_ticket?: Maybe<Scalars['bigint']>;
  open_ticket?: Maybe<Scalars['bigint']>;
};

/** aggregate var_pop on columns */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Var_Pop_Fields = {
  __typename?: 'fn_return_total_open_close_ticket_dashboard_var_pop_fields';
  closed_ticket?: Maybe<Scalars['Float']>;
  open_ticket?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Var_Samp_Fields = {
  __typename?: 'fn_return_total_open_close_ticket_dashboard_var_samp_fields';
  closed_ticket?: Maybe<Scalars['Float']>;
  open_ticket?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Fn_Return_Total_Open_Close_Ticket_Dashboard_Variance_Fields = {
  __typename?: 'fn_return_total_open_close_ticket_dashboard_variance_fields';
  closed_ticket?: Maybe<Scalars['Float']>;
  open_ticket?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "freshdesk_company" */
export type Freshdesk_Company = {
  __typename?: 'freshdesk_company';
  amagi_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  freshdesk_to_customer?: Maybe<Account>;
  id: Scalars['numeric'];
  /** An array relationship */
  tickets: Array<Freshdesk_Ticket>;
  /** An aggregate relationship */
  tickets_aggregate: Freshdesk_Ticket_Aggregate;
};


/** columns and relationships of "freshdesk_company" */
export type Freshdesk_CompanyTicketsArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Freshdesk_Ticket_Order_By>>;
  where?: InputMaybe<Freshdesk_Ticket_Bool_Exp>;
};


/** columns and relationships of "freshdesk_company" */
export type Freshdesk_CompanyTickets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Freshdesk_Ticket_Order_By>>;
  where?: InputMaybe<Freshdesk_Ticket_Bool_Exp>;
};

/** aggregated selection of "freshdesk_company" */
export type Freshdesk_Company_Aggregate = {
  __typename?: 'freshdesk_company_aggregate';
  aggregate?: Maybe<Freshdesk_Company_Aggregate_Fields>;
  nodes: Array<Freshdesk_Company>;
};

/** aggregate fields of "freshdesk_company" */
export type Freshdesk_Company_Aggregate_Fields = {
  __typename?: 'freshdesk_company_aggregate_fields';
  avg?: Maybe<Freshdesk_Company_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Freshdesk_Company_Max_Fields>;
  min?: Maybe<Freshdesk_Company_Min_Fields>;
  stddev?: Maybe<Freshdesk_Company_Stddev_Fields>;
  stddev_pop?: Maybe<Freshdesk_Company_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Freshdesk_Company_Stddev_Samp_Fields>;
  sum?: Maybe<Freshdesk_Company_Sum_Fields>;
  var_pop?: Maybe<Freshdesk_Company_Var_Pop_Fields>;
  var_samp?: Maybe<Freshdesk_Company_Var_Samp_Fields>;
  variance?: Maybe<Freshdesk_Company_Variance_Fields>;
};


/** aggregate fields of "freshdesk_company" */
export type Freshdesk_Company_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Freshdesk_Company_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Freshdesk_Company_Avg_Fields = {
  __typename?: 'freshdesk_company_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "freshdesk_company". All fields are combined with a logical 'AND'. */
export type Freshdesk_Company_Bool_Exp = {
  _and?: InputMaybe<Array<Freshdesk_Company_Bool_Exp>>;
  _not?: InputMaybe<Freshdesk_Company_Bool_Exp>;
  _or?: InputMaybe<Array<Freshdesk_Company_Bool_Exp>>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  freshdesk_to_customer?: InputMaybe<Account_Bool_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  tickets?: InputMaybe<Freshdesk_Ticket_Bool_Exp>;
  tickets_aggregate?: InputMaybe<Freshdesk_Ticket_Aggregate_Bool_Exp>;
};

/** aggregate max on columns */
export type Freshdesk_Company_Max_Fields = {
  __typename?: 'freshdesk_company_max_fields';
  amagi_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Freshdesk_Company_Min_Fields = {
  __typename?: 'freshdesk_company_min_fields';
  amagi_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
};

/** Ordering options when selecting data from "freshdesk_company". */
export type Freshdesk_Company_Order_By = {
  amagi_id?: InputMaybe<Order_By>;
  freshdesk_to_customer?: InputMaybe<Account_Order_By>;
  id?: InputMaybe<Order_By>;
  tickets_aggregate?: InputMaybe<Freshdesk_Ticket_Aggregate_Order_By>;
};

/** select columns of table "freshdesk_company" */
export enum Freshdesk_Company_Select_Column {
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Freshdesk_Company_Stddev_Fields = {
  __typename?: 'freshdesk_company_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Freshdesk_Company_Stddev_Pop_Fields = {
  __typename?: 'freshdesk_company_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Freshdesk_Company_Stddev_Samp_Fields = {
  __typename?: 'freshdesk_company_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "freshdesk_company" */
export type Freshdesk_Company_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Freshdesk_Company_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Freshdesk_Company_Stream_Cursor_Value_Input = {
  amagi_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Freshdesk_Company_Sum_Fields = {
  __typename?: 'freshdesk_company_sum_fields';
  id?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Freshdesk_Company_Var_Pop_Fields = {
  __typename?: 'freshdesk_company_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Freshdesk_Company_Var_Samp_Fields = {
  __typename?: 'freshdesk_company_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Freshdesk_Company_Variance_Fields = {
  __typename?: 'freshdesk_company_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "freshdesk_contact" */
export type Freshdesk_Contact = {
  __typename?: 'freshdesk_contact';
  company_id?: Maybe<Scalars['bigint']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['numeric'];
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "freshdesk_contact" */
export type Freshdesk_Contact_Aggregate = {
  __typename?: 'freshdesk_contact_aggregate';
  aggregate?: Maybe<Freshdesk_Contact_Aggregate_Fields>;
  nodes: Array<Freshdesk_Contact>;
};

/** aggregate fields of "freshdesk_contact" */
export type Freshdesk_Contact_Aggregate_Fields = {
  __typename?: 'freshdesk_contact_aggregate_fields';
  avg?: Maybe<Freshdesk_Contact_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Freshdesk_Contact_Max_Fields>;
  min?: Maybe<Freshdesk_Contact_Min_Fields>;
  stddev?: Maybe<Freshdesk_Contact_Stddev_Fields>;
  stddev_pop?: Maybe<Freshdesk_Contact_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Freshdesk_Contact_Stddev_Samp_Fields>;
  sum?: Maybe<Freshdesk_Contact_Sum_Fields>;
  var_pop?: Maybe<Freshdesk_Contact_Var_Pop_Fields>;
  var_samp?: Maybe<Freshdesk_Contact_Var_Samp_Fields>;
  variance?: Maybe<Freshdesk_Contact_Variance_Fields>;
};


/** aggregate fields of "freshdesk_contact" */
export type Freshdesk_Contact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Freshdesk_Contact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Freshdesk_Contact_Avg_Fields = {
  __typename?: 'freshdesk_contact_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "freshdesk_contact". All fields are combined with a logical 'AND'. */
export type Freshdesk_Contact_Bool_Exp = {
  _and?: InputMaybe<Array<Freshdesk_Contact_Bool_Exp>>;
  _not?: InputMaybe<Freshdesk_Contact_Bool_Exp>;
  _or?: InputMaybe<Array<Freshdesk_Contact_Bool_Exp>>;
  company_id?: InputMaybe<Bigint_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Freshdesk_Contact_Max_Fields = {
  __typename?: 'freshdesk_contact_max_fields';
  company_id?: Maybe<Scalars['bigint']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Freshdesk_Contact_Min_Fields = {
  __typename?: 'freshdesk_contact_min_fields';
  company_id?: Maybe<Scalars['bigint']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "freshdesk_contact". */
export type Freshdesk_Contact_Order_By = {
  company_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "freshdesk_contact" */
export enum Freshdesk_Contact_Select_Column {
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Freshdesk_Contact_Stddev_Fields = {
  __typename?: 'freshdesk_contact_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Freshdesk_Contact_Stddev_Pop_Fields = {
  __typename?: 'freshdesk_contact_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Freshdesk_Contact_Stddev_Samp_Fields = {
  __typename?: 'freshdesk_contact_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "freshdesk_contact" */
export type Freshdesk_Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Freshdesk_Contact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Freshdesk_Contact_Stream_Cursor_Value_Input = {
  company_id?: InputMaybe<Scalars['bigint']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Freshdesk_Contact_Sum_Fields = {
  __typename?: 'freshdesk_contact_sum_fields';
  company_id?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Freshdesk_Contact_Var_Pop_Fields = {
  __typename?: 'freshdesk_contact_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Freshdesk_Contact_Var_Samp_Fields = {
  __typename?: 'freshdesk_contact_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Freshdesk_Contact_Variance_Fields = {
  __typename?: 'freshdesk_contact_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "freshdesk_ticket" */
export type Freshdesk_Ticket = {
  __typename?: 'freshdesk_ticket';
  billing_issue_status?: Maybe<Scalars['String']>;
  charge_codes?: Maybe<Scalars['String']>;
  closed_at?: Maybe<Scalars['timestamptz']>;
  company_id?: Maybe<Scalars['numeric']>;
  coordinator?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['timestamptz']>;
  credit_amount?: Maybe<Scalars['String']>;
  credit_currency?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  delivery_channel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dispute_outcome?: Maybe<Scalars['String']>;
  dispute_type?: Maybe<Scalars['String']>;
  disputed_amount?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  /** An object relationship */
  freshdesk?: Maybe<Freshdesk_Company>;
  group?: Maybe<Scalars['numeric']>;
  group_agent?: Maybe<Scalars['numeric']>;
  impact?: Maybe<Scalars['String']>;
  incident_end_time?: Maybe<Scalars['String']>;
  incident_start_time?: Maybe<Scalars['String']>;
  internal_status?: Maybe<Scalars['String']>;
  invoice_amount?: Maybe<Scalars['String']>;
  invoice_month?: Maybe<Scalars['date']>;
  invoice_number?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  last_updated_date?: Maybe<Scalars['timestamptz']>;
  priority?: Maybe<Scalars['numeric']>;
  product?: Maybe<Scalars['String']>;
  product_resp?: Maybe<Scalars['String']>;
  product_resp_area?: Maybe<Scalars['String']>;
  product_resp_area_component?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  resolved_date?: Maybe<Scalars['timestamptz']>;
  root_cause?: Maybe<Scalars['String']>;
  root_cause_category?: Maybe<Scalars['String']>;
  root_cause_owner?: Maybe<Scalars['String']>;
  salesforce_case_id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['numeric']>;
  subject?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['jsonb']>;
  ticket_id: Scalars['numeric'];
  /** A computed field, executes function "ticket_priority" */
  ticket_priority?: Maybe<Scalars['String']>;
  /** A computed field, executes function "ticket_source" */
  ticket_source?: Maybe<Scalars['String']>;
  /** A computed field, executes function "ticket_status" */
  ticket_status?: Maybe<Scalars['String']>;
  ticket_type?: Maybe<Scalars['String']>;
};


/** columns and relationships of "freshdesk_ticket" */
export type Freshdesk_TicketTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "freshdesk_ticket" */
export type Freshdesk_Ticket_Aggregate = {
  __typename?: 'freshdesk_ticket_aggregate';
  aggregate?: Maybe<Freshdesk_Ticket_Aggregate_Fields>;
  nodes: Array<Freshdesk_Ticket>;
};

export type Freshdesk_Ticket_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Freshdesk_Ticket_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Freshdesk_Ticket_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Freshdesk_Ticket_Aggregate_Bool_Exp_Count>;
};

export type Freshdesk_Ticket_Aggregate_Bool_Exp_Bool_And = {
  arguments: Freshdesk_Ticket_Select_Column_Freshdesk_Ticket_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Freshdesk_Ticket_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Freshdesk_Ticket_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Freshdesk_Ticket_Select_Column_Freshdesk_Ticket_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Freshdesk_Ticket_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Freshdesk_Ticket_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Freshdesk_Ticket_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Freshdesk_Ticket_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "freshdesk_ticket" */
export type Freshdesk_Ticket_Aggregate_Fields = {
  __typename?: 'freshdesk_ticket_aggregate_fields';
  avg?: Maybe<Freshdesk_Ticket_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Freshdesk_Ticket_Max_Fields>;
  min?: Maybe<Freshdesk_Ticket_Min_Fields>;
  stddev?: Maybe<Freshdesk_Ticket_Stddev_Fields>;
  stddev_pop?: Maybe<Freshdesk_Ticket_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Freshdesk_Ticket_Stddev_Samp_Fields>;
  sum?: Maybe<Freshdesk_Ticket_Sum_Fields>;
  var_pop?: Maybe<Freshdesk_Ticket_Var_Pop_Fields>;
  var_samp?: Maybe<Freshdesk_Ticket_Var_Samp_Fields>;
  variance?: Maybe<Freshdesk_Ticket_Variance_Fields>;
};


/** aggregate fields of "freshdesk_ticket" */
export type Freshdesk_Ticket_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Freshdesk_Ticket_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "freshdesk_ticket" */
export type Freshdesk_Ticket_Aggregate_Order_By = {
  avg?: InputMaybe<Freshdesk_Ticket_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Freshdesk_Ticket_Max_Order_By>;
  min?: InputMaybe<Freshdesk_Ticket_Min_Order_By>;
  stddev?: InputMaybe<Freshdesk_Ticket_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Freshdesk_Ticket_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Freshdesk_Ticket_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Freshdesk_Ticket_Sum_Order_By>;
  var_pop?: InputMaybe<Freshdesk_Ticket_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Freshdesk_Ticket_Var_Samp_Order_By>;
  variance?: InputMaybe<Freshdesk_Ticket_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Freshdesk_Ticket_Avg_Fields = {
  __typename?: 'freshdesk_ticket_avg_fields';
  company_id?: Maybe<Scalars['Float']>;
  group?: Maybe<Scalars['Float']>;
  group_agent?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  ticket_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "freshdesk_ticket" */
export type Freshdesk_Ticket_Avg_Order_By = {
  company_id?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  group_agent?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "freshdesk_ticket". All fields are combined with a logical 'AND'. */
export type Freshdesk_Ticket_Bool_Exp = {
  _and?: InputMaybe<Array<Freshdesk_Ticket_Bool_Exp>>;
  _not?: InputMaybe<Freshdesk_Ticket_Bool_Exp>;
  _or?: InputMaybe<Array<Freshdesk_Ticket_Bool_Exp>>;
  billing_issue_status?: InputMaybe<String_Comparison_Exp>;
  charge_codes?: InputMaybe<String_Comparison_Exp>;
  closed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  company_id?: InputMaybe<Numeric_Comparison_Exp>;
  coordinator?: InputMaybe<String_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  credit_amount?: InputMaybe<String_Comparison_Exp>;
  credit_currency?: InputMaybe<String_Comparison_Exp>;
  customer_id?: InputMaybe<String_Comparison_Exp>;
  customer_name?: InputMaybe<String_Comparison_Exp>;
  delivery_channel?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dispute_outcome?: InputMaybe<String_Comparison_Exp>;
  dispute_type?: InputMaybe<String_Comparison_Exp>;
  disputed_amount?: InputMaybe<String_Comparison_Exp>;
  duration?: InputMaybe<String_Comparison_Exp>;
  freshdesk?: InputMaybe<Freshdesk_Company_Bool_Exp>;
  group?: InputMaybe<Numeric_Comparison_Exp>;
  group_agent?: InputMaybe<Numeric_Comparison_Exp>;
  impact?: InputMaybe<String_Comparison_Exp>;
  incident_end_time?: InputMaybe<String_Comparison_Exp>;
  incident_start_time?: InputMaybe<String_Comparison_Exp>;
  internal_status?: InputMaybe<String_Comparison_Exp>;
  invoice_amount?: InputMaybe<String_Comparison_Exp>;
  invoice_month?: InputMaybe<Date_Comparison_Exp>;
  invoice_number?: InputMaybe<String_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  last_updated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  priority?: InputMaybe<Numeric_Comparison_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
  product_resp?: InputMaybe<String_Comparison_Exp>;
  product_resp_area?: InputMaybe<String_Comparison_Exp>;
  product_resp_area_component?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  resolved_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  root_cause?: InputMaybe<String_Comparison_Exp>;
  root_cause_category?: InputMaybe<String_Comparison_Exp>;
  root_cause_owner?: InputMaybe<String_Comparison_Exp>;
  salesforce_case_id?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<Numeric_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  ticket_id?: InputMaybe<Numeric_Comparison_Exp>;
  ticket_priority?: InputMaybe<String_Comparison_Exp>;
  ticket_source?: InputMaybe<String_Comparison_Exp>;
  ticket_status?: InputMaybe<String_Comparison_Exp>;
  ticket_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Freshdesk_Ticket_Max_Fields = {
  __typename?: 'freshdesk_ticket_max_fields';
  billing_issue_status?: Maybe<Scalars['String']>;
  charge_codes?: Maybe<Scalars['String']>;
  closed_at?: Maybe<Scalars['timestamptz']>;
  company_id?: Maybe<Scalars['numeric']>;
  coordinator?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['timestamptz']>;
  credit_amount?: Maybe<Scalars['String']>;
  credit_currency?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  delivery_channel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dispute_outcome?: Maybe<Scalars['String']>;
  dispute_type?: Maybe<Scalars['String']>;
  disputed_amount?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['numeric']>;
  group_agent?: Maybe<Scalars['numeric']>;
  impact?: Maybe<Scalars['String']>;
  incident_end_time?: Maybe<Scalars['String']>;
  incident_start_time?: Maybe<Scalars['String']>;
  internal_status?: Maybe<Scalars['String']>;
  invoice_amount?: Maybe<Scalars['String']>;
  invoice_month?: Maybe<Scalars['date']>;
  invoice_number?: Maybe<Scalars['String']>;
  last_updated_date?: Maybe<Scalars['timestamptz']>;
  priority?: Maybe<Scalars['numeric']>;
  product?: Maybe<Scalars['String']>;
  product_resp?: Maybe<Scalars['String']>;
  product_resp_area?: Maybe<Scalars['String']>;
  product_resp_area_component?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  resolved_date?: Maybe<Scalars['timestamptz']>;
  root_cause?: Maybe<Scalars['String']>;
  root_cause_category?: Maybe<Scalars['String']>;
  root_cause_owner?: Maybe<Scalars['String']>;
  salesforce_case_id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['numeric']>;
  subject?: Maybe<Scalars['String']>;
  ticket_id?: Maybe<Scalars['numeric']>;
  ticket_type?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "freshdesk_ticket" */
export type Freshdesk_Ticket_Max_Order_By = {
  billing_issue_status?: InputMaybe<Order_By>;
  charge_codes?: InputMaybe<Order_By>;
  closed_at?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  coordinator?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  credit_amount?: InputMaybe<Order_By>;
  credit_currency?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  delivery_channel?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dispute_outcome?: InputMaybe<Order_By>;
  dispute_type?: InputMaybe<Order_By>;
  disputed_amount?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  group_agent?: InputMaybe<Order_By>;
  impact?: InputMaybe<Order_By>;
  incident_end_time?: InputMaybe<Order_By>;
  incident_start_time?: InputMaybe<Order_By>;
  internal_status?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_month?: InputMaybe<Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  last_updated_date?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  product_resp?: InputMaybe<Order_By>;
  product_resp_area?: InputMaybe<Order_By>;
  product_resp_area_component?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  resolved_date?: InputMaybe<Order_By>;
  root_cause?: InputMaybe<Order_By>;
  root_cause_category?: InputMaybe<Order_By>;
  root_cause_owner?: InputMaybe<Order_By>;
  salesforce_case_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  ticket_type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Freshdesk_Ticket_Min_Fields = {
  __typename?: 'freshdesk_ticket_min_fields';
  billing_issue_status?: Maybe<Scalars['String']>;
  charge_codes?: Maybe<Scalars['String']>;
  closed_at?: Maybe<Scalars['timestamptz']>;
  company_id?: Maybe<Scalars['numeric']>;
  coordinator?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['timestamptz']>;
  credit_amount?: Maybe<Scalars['String']>;
  credit_currency?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  delivery_channel?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dispute_outcome?: Maybe<Scalars['String']>;
  dispute_type?: Maybe<Scalars['String']>;
  disputed_amount?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['numeric']>;
  group_agent?: Maybe<Scalars['numeric']>;
  impact?: Maybe<Scalars['String']>;
  incident_end_time?: Maybe<Scalars['String']>;
  incident_start_time?: Maybe<Scalars['String']>;
  internal_status?: Maybe<Scalars['String']>;
  invoice_amount?: Maybe<Scalars['String']>;
  invoice_month?: Maybe<Scalars['date']>;
  invoice_number?: Maybe<Scalars['String']>;
  last_updated_date?: Maybe<Scalars['timestamptz']>;
  priority?: Maybe<Scalars['numeric']>;
  product?: Maybe<Scalars['String']>;
  product_resp?: Maybe<Scalars['String']>;
  product_resp_area?: Maybe<Scalars['String']>;
  product_resp_area_component?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  resolved_date?: Maybe<Scalars['timestamptz']>;
  root_cause?: Maybe<Scalars['String']>;
  root_cause_category?: Maybe<Scalars['String']>;
  root_cause_owner?: Maybe<Scalars['String']>;
  salesforce_case_id?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['numeric']>;
  subject?: Maybe<Scalars['String']>;
  ticket_id?: Maybe<Scalars['numeric']>;
  ticket_type?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "freshdesk_ticket" */
export type Freshdesk_Ticket_Min_Order_By = {
  billing_issue_status?: InputMaybe<Order_By>;
  charge_codes?: InputMaybe<Order_By>;
  closed_at?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  coordinator?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  credit_amount?: InputMaybe<Order_By>;
  credit_currency?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  delivery_channel?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dispute_outcome?: InputMaybe<Order_By>;
  dispute_type?: InputMaybe<Order_By>;
  disputed_amount?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  group_agent?: InputMaybe<Order_By>;
  impact?: InputMaybe<Order_By>;
  incident_end_time?: InputMaybe<Order_By>;
  incident_start_time?: InputMaybe<Order_By>;
  internal_status?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_month?: InputMaybe<Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  last_updated_date?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  product_resp?: InputMaybe<Order_By>;
  product_resp_area?: InputMaybe<Order_By>;
  product_resp_area_component?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  resolved_date?: InputMaybe<Order_By>;
  root_cause?: InputMaybe<Order_By>;
  root_cause_category?: InputMaybe<Order_By>;
  root_cause_owner?: InputMaybe<Order_By>;
  salesforce_case_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  ticket_type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "freshdesk_ticket". */
export type Freshdesk_Ticket_Order_By = {
  billing_issue_status?: InputMaybe<Order_By>;
  charge_codes?: InputMaybe<Order_By>;
  closed_at?: InputMaybe<Order_By>;
  company_id?: InputMaybe<Order_By>;
  coordinator?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  credit_amount?: InputMaybe<Order_By>;
  credit_currency?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  delivery_channel?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dispute_outcome?: InputMaybe<Order_By>;
  dispute_type?: InputMaybe<Order_By>;
  disputed_amount?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  freshdesk?: InputMaybe<Freshdesk_Company_Order_By>;
  group?: InputMaybe<Order_By>;
  group_agent?: InputMaybe<Order_By>;
  impact?: InputMaybe<Order_By>;
  incident_end_time?: InputMaybe<Order_By>;
  incident_start_time?: InputMaybe<Order_By>;
  internal_status?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_month?: InputMaybe<Order_By>;
  invoice_number?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  last_updated_date?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  product_resp?: InputMaybe<Order_By>;
  product_resp_area?: InputMaybe<Order_By>;
  product_resp_area_component?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  resolved_date?: InputMaybe<Order_By>;
  root_cause?: InputMaybe<Order_By>;
  root_cause_category?: InputMaybe<Order_By>;
  root_cause_owner?: InputMaybe<Order_By>;
  salesforce_case_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
  ticket_priority?: InputMaybe<Order_By>;
  ticket_source?: InputMaybe<Order_By>;
  ticket_status?: InputMaybe<Order_By>;
  ticket_type?: InputMaybe<Order_By>;
};

/** select columns of table "freshdesk_ticket" */
export enum Freshdesk_Ticket_Select_Column {
  /** column name */
  BillingIssueStatus = 'billing_issue_status',
  /** column name */
  ChargeCodes = 'charge_codes',
  /** column name */
  ClosedAt = 'closed_at',
  /** column name */
  CompanyId = 'company_id',
  /** column name */
  Coordinator = 'coordinator',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  CreditAmount = 'credit_amount',
  /** column name */
  CreditCurrency = 'credit_currency',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  DeliveryChannel = 'delivery_channel',
  /** column name */
  Description = 'description',
  /** column name */
  DisputeOutcome = 'dispute_outcome',
  /** column name */
  DisputeType = 'dispute_type',
  /** column name */
  DisputedAmount = 'disputed_amount',
  /** column name */
  Duration = 'duration',
  /** column name */
  Group = 'group',
  /** column name */
  GroupAgent = 'group_agent',
  /** column name */
  Impact = 'impact',
  /** column name */
  IncidentEndTime = 'incident_end_time',
  /** column name */
  IncidentStartTime = 'incident_start_time',
  /** column name */
  InternalStatus = 'internal_status',
  /** column name */
  InvoiceAmount = 'invoice_amount',
  /** column name */
  InvoiceMonth = 'invoice_month',
  /** column name */
  InvoiceNumber = 'invoice_number',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastUpdatedDate = 'last_updated_date',
  /** column name */
  Priority = 'priority',
  /** column name */
  Product = 'product',
  /** column name */
  ProductResp = 'product_resp',
  /** column name */
  ProductRespArea = 'product_resp_area',
  /** column name */
  ProductRespAreaComponent = 'product_resp_area_component',
  /** column name */
  Region = 'region',
  /** column name */
  ResolvedDate = 'resolved_date',
  /** column name */
  RootCause = 'root_cause',
  /** column name */
  RootCauseCategory = 'root_cause_category',
  /** column name */
  RootCauseOwner = 'root_cause_owner',
  /** column name */
  SalesforceCaseId = 'salesforce_case_id',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  Subject = 'subject',
  /** column name */
  Tags = 'tags',
  /** column name */
  TicketId = 'ticket_id',
  /** column name */
  TicketType = 'ticket_type'
}

/** select "freshdesk_ticket_aggregate_bool_exp_bool_and_arguments_columns" columns of table "freshdesk_ticket" */
export enum Freshdesk_Ticket_Select_Column_Freshdesk_Ticket_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "freshdesk_ticket_aggregate_bool_exp_bool_or_arguments_columns" columns of table "freshdesk_ticket" */
export enum Freshdesk_Ticket_Select_Column_Freshdesk_Ticket_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** aggregate stddev on columns */
export type Freshdesk_Ticket_Stddev_Fields = {
  __typename?: 'freshdesk_ticket_stddev_fields';
  company_id?: Maybe<Scalars['Float']>;
  group?: Maybe<Scalars['Float']>;
  group_agent?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  ticket_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "freshdesk_ticket" */
export type Freshdesk_Ticket_Stddev_Order_By = {
  company_id?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  group_agent?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Freshdesk_Ticket_Stddev_Pop_Fields = {
  __typename?: 'freshdesk_ticket_stddev_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  group?: Maybe<Scalars['Float']>;
  group_agent?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  ticket_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "freshdesk_ticket" */
export type Freshdesk_Ticket_Stddev_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  group_agent?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Freshdesk_Ticket_Stddev_Samp_Fields = {
  __typename?: 'freshdesk_ticket_stddev_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  group?: Maybe<Scalars['Float']>;
  group_agent?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  ticket_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "freshdesk_ticket" */
export type Freshdesk_Ticket_Stddev_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  group_agent?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "freshdesk_ticket" */
export type Freshdesk_Ticket_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Freshdesk_Ticket_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Freshdesk_Ticket_Stream_Cursor_Value_Input = {
  billing_issue_status?: InputMaybe<Scalars['String']>;
  charge_codes?: InputMaybe<Scalars['String']>;
  closed_at?: InputMaybe<Scalars['timestamptz']>;
  company_id?: InputMaybe<Scalars['numeric']>;
  coordinator?: InputMaybe<Scalars['String']>;
  created_date?: InputMaybe<Scalars['timestamptz']>;
  credit_amount?: InputMaybe<Scalars['String']>;
  credit_currency?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['String']>;
  customer_name?: InputMaybe<Scalars['String']>;
  delivery_channel?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  dispute_outcome?: InputMaybe<Scalars['String']>;
  dispute_type?: InputMaybe<Scalars['String']>;
  disputed_amount?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['numeric']>;
  group_agent?: InputMaybe<Scalars['numeric']>;
  impact?: InputMaybe<Scalars['String']>;
  incident_end_time?: InputMaybe<Scalars['String']>;
  incident_start_time?: InputMaybe<Scalars['String']>;
  internal_status?: InputMaybe<Scalars['String']>;
  invoice_amount?: InputMaybe<Scalars['String']>;
  invoice_month?: InputMaybe<Scalars['date']>;
  invoice_number?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_updated_date?: InputMaybe<Scalars['timestamptz']>;
  priority?: InputMaybe<Scalars['numeric']>;
  product?: InputMaybe<Scalars['String']>;
  product_resp?: InputMaybe<Scalars['String']>;
  product_resp_area?: InputMaybe<Scalars['String']>;
  product_resp_area_component?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  resolved_date?: InputMaybe<Scalars['timestamptz']>;
  root_cause?: InputMaybe<Scalars['String']>;
  root_cause_category?: InputMaybe<Scalars['String']>;
  root_cause_owner?: InputMaybe<Scalars['String']>;
  salesforce_case_id?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['numeric']>;
  subject?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  ticket_id?: InputMaybe<Scalars['numeric']>;
  ticket_type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Freshdesk_Ticket_Sum_Fields = {
  __typename?: 'freshdesk_ticket_sum_fields';
  company_id?: Maybe<Scalars['numeric']>;
  group?: Maybe<Scalars['numeric']>;
  group_agent?: Maybe<Scalars['numeric']>;
  priority?: Maybe<Scalars['numeric']>;
  source?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['numeric']>;
  ticket_id?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "freshdesk_ticket" */
export type Freshdesk_Ticket_Sum_Order_By = {
  company_id?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  group_agent?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Freshdesk_Ticket_Var_Pop_Fields = {
  __typename?: 'freshdesk_ticket_var_pop_fields';
  company_id?: Maybe<Scalars['Float']>;
  group?: Maybe<Scalars['Float']>;
  group_agent?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  ticket_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "freshdesk_ticket" */
export type Freshdesk_Ticket_Var_Pop_Order_By = {
  company_id?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  group_agent?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Freshdesk_Ticket_Var_Samp_Fields = {
  __typename?: 'freshdesk_ticket_var_samp_fields';
  company_id?: Maybe<Scalars['Float']>;
  group?: Maybe<Scalars['Float']>;
  group_agent?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  ticket_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "freshdesk_ticket" */
export type Freshdesk_Ticket_Var_Samp_Order_By = {
  company_id?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  group_agent?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Freshdesk_Ticket_Variance_Fields = {
  __typename?: 'freshdesk_ticket_variance_fields';
  company_id?: Maybe<Scalars['Float']>;
  group?: Maybe<Scalars['Float']>;
  group_agent?: Maybe<Scalars['Float']>;
  priority?: Maybe<Scalars['Float']>;
  source?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Float']>;
  ticket_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "freshdesk_ticket" */
export type Freshdesk_Ticket_Variance_Order_By = {
  company_id?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  group_agent?: InputMaybe<Order_By>;
  priority?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  ticket_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "incident" */
export type Incident = {
  __typename?: 'incident';
  amagi_id: Scalars['String'];
  date: Scalars['date'];
  duration: Scalars['Int'];
  id: Scalars['String'];
};

/** aggregated selection of "incident" */
export type Incident_Aggregate = {
  __typename?: 'incident_aggregate';
  aggregate?: Maybe<Incident_Aggregate_Fields>;
  nodes: Array<Incident>;
};

/** aggregate fields of "incident" */
export type Incident_Aggregate_Fields = {
  __typename?: 'incident_aggregate_fields';
  avg?: Maybe<Incident_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Incident_Max_Fields>;
  min?: Maybe<Incident_Min_Fields>;
  stddev?: Maybe<Incident_Stddev_Fields>;
  stddev_pop?: Maybe<Incident_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Incident_Stddev_Samp_Fields>;
  sum?: Maybe<Incident_Sum_Fields>;
  var_pop?: Maybe<Incident_Var_Pop_Fields>;
  var_samp?: Maybe<Incident_Var_Samp_Fields>;
  variance?: Maybe<Incident_Variance_Fields>;
};


/** aggregate fields of "incident" */
export type Incident_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Incident_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Incident_Avg_Fields = {
  __typename?: 'incident_avg_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "incident". All fields are combined with a logical 'AND'. */
export type Incident_Bool_Exp = {
  _and?: InputMaybe<Array<Incident_Bool_Exp>>;
  _not?: InputMaybe<Incident_Bool_Exp>;
  _or?: InputMaybe<Array<Incident_Bool_Exp>>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Incident_Max_Fields = {
  __typename?: 'incident_max_fields';
  amagi_id?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Incident_Min_Fields = {
  __typename?: 'incident_min_fields';
  amagi_id?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "incident". */
export type Incident_Order_By = {
  amagi_id?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "incident" */
export enum Incident_Select_Column {
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  Date = 'date',
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Incident_Stddev_Fields = {
  __typename?: 'incident_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Incident_Stddev_Pop_Fields = {
  __typename?: 'incident_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Incident_Stddev_Samp_Fields = {
  __typename?: 'incident_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "incident" */
export type Incident_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Incident_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Incident_Stream_Cursor_Value_Input = {
  amagi_id?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Incident_Sum_Fields = {
  __typename?: 'incident_sum_fields';
  duration?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Incident_Var_Pop_Fields = {
  __typename?: 'incident_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Incident_Var_Samp_Fields = {
  __typename?: 'incident_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Incident_Variance_Fields = {
  __typename?: 'incident_variance_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "invoice" */
export type Invoice = {
  __typename?: 'invoice';
  ar_status?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credits?: Maybe<Scalars['numeric']>;
  custom_invoice_number?: Maybe<Scalars['String']>;
  /** An object relationship */
  customer: Account;
  date?: Maybe<Scalars['date']>;
  days_outstanding?: Maybe<Scalars['numeric']>;
  debit_payments?: Maybe<Scalars['numeric']>;
  debits?: Maybe<Scalars['numeric']>;
  default_payment_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  impact_amount?: Maybe<Scalars['numeric']>;
  integration_status?: Maybe<Scalars['String']>;
  /** An array relationship */
  invoice_lines: Array<Invoice_Line>;
  /** An aggregate relationship */
  invoice_lines_aggregate: Invoice_Line_Aggregate;
  invoice_month?: Maybe<Scalars['String']>;
  invoice_pdf_attached?: Maybe<Scalars['String']>;
  /** An object relationship */
  invoice_to_netsuite_transaction?: Maybe<Netsuite_Transaction>;
  invoices?: Maybe<SalesforceOpportunityResponse>;
  is_deleted: Scalars['Boolean'];
  negative_line_conversion?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  netsuite_invoice?: Maybe<Netsuite_Transaction>;
  /** An object relationship */
  order?: Maybe<Order>;
  payment_days?: Maybe<Scalars['numeric']>;
  payment_status?: Maybe<Scalars['String']>;
  payment_terms?: Maybe<Scalars['String']>;
  payments?: Maybe<Scalars['numeric']>;
  po_number?: Maybe<Scalars['String']>;
  posted_date?: Maybe<Scalars['date']>;
  salesforce_account_id: Scalars['String'];
  salesforce_created_date: Scalars['timestamptz'];
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date: Scalars['timestamptz'];
  salesforce_legal_entity_id?: Maybe<Scalars['String']>;
  salesforce_order_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  sub_total?: Maybe<Scalars['numeric']>;
  target_date?: Maybe<Scalars['date']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "invoice" */
export type InvoiceInvoice_LinesArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Line_Order_By>>;
  where?: InputMaybe<Invoice_Line_Bool_Exp>;
};


/** columns and relationships of "invoice" */
export type InvoiceInvoice_Lines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Line_Order_By>>;
  where?: InputMaybe<Invoice_Line_Bool_Exp>;
};

/** aggregated selection of "invoice" */
export type Invoice_Aggregate = {
  __typename?: 'invoice_aggregate';
  aggregate?: Maybe<Invoice_Aggregate_Fields>;
  nodes: Array<Invoice>;
};

export type Invoice_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Invoice_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Invoice_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Invoice_Aggregate_Bool_Exp_Count>;
};

export type Invoice_Aggregate_Bool_Exp_Bool_And = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoice_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invoice" */
export type Invoice_Aggregate_Fields = {
  __typename?: 'invoice_aggregate_fields';
  avg?: Maybe<Invoice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Invoice_Max_Fields>;
  min?: Maybe<Invoice_Min_Fields>;
  stddev?: Maybe<Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Invoice_Sum_Fields>;
  var_pop?: Maybe<Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Invoice_Var_Samp_Fields>;
  variance?: Maybe<Invoice_Variance_Fields>;
};


/** aggregate fields of "invoice" */
export type Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoice" */
export type Invoice_Aggregate_Order_By = {
  avg?: InputMaybe<Invoice_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoice_Max_Order_By>;
  min?: InputMaybe<Invoice_Min_Order_By>;
  stddev?: InputMaybe<Invoice_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invoice_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invoice_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invoice_Sum_Order_By>;
  var_pop?: InputMaybe<Invoice_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invoice_Var_Samp_Order_By>;
  variance?: InputMaybe<Invoice_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Invoice_Avg_Fields = {
  __typename?: 'invoice_avg_fields';
  credits?: Maybe<Scalars['Float']>;
  days_outstanding?: Maybe<Scalars['Float']>;
  debit_payments?: Maybe<Scalars['Float']>;
  debits?: Maybe<Scalars['Float']>;
  impact_amount?: Maybe<Scalars['Float']>;
  negative_line_conversion?: Maybe<Scalars['Float']>;
  payment_days?: Maybe<Scalars['Float']>;
  payments?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoice" */
export type Invoice_Avg_Order_By = {
  credits?: InputMaybe<Order_By>;
  days_outstanding?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  negative_line_conversion?: InputMaybe<Order_By>;
  payment_days?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoice". All fields are combined with a logical 'AND'. */
export type Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Invoice_Bool_Exp>>;
  _not?: InputMaybe<Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Invoice_Bool_Exp>>;
  ar_status?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credits?: InputMaybe<Numeric_Comparison_Exp>;
  custom_invoice_number?: InputMaybe<String_Comparison_Exp>;
  customer?: InputMaybe<Account_Bool_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  days_outstanding?: InputMaybe<Numeric_Comparison_Exp>;
  debit_payments?: InputMaybe<Numeric_Comparison_Exp>;
  debits?: InputMaybe<Numeric_Comparison_Exp>;
  default_payment_type?: InputMaybe<String_Comparison_Exp>;
  due_date?: InputMaybe<Date_Comparison_Exp>;
  impact_amount?: InputMaybe<Numeric_Comparison_Exp>;
  integration_status?: InputMaybe<String_Comparison_Exp>;
  invoice_lines?: InputMaybe<Invoice_Line_Bool_Exp>;
  invoice_lines_aggregate?: InputMaybe<Invoice_Line_Aggregate_Bool_Exp>;
  invoice_month?: InputMaybe<String_Comparison_Exp>;
  invoice_pdf_attached?: InputMaybe<String_Comparison_Exp>;
  invoice_to_netsuite_transaction?: InputMaybe<Netsuite_Transaction_Bool_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  negative_line_conversion?: InputMaybe<Numeric_Comparison_Exp>;
  netsuite_invoice?: InputMaybe<Netsuite_Transaction_Bool_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  payment_days?: InputMaybe<Numeric_Comparison_Exp>;
  payment_status?: InputMaybe<String_Comparison_Exp>;
  payment_terms?: InputMaybe<String_Comparison_Exp>;
  payments?: InputMaybe<Numeric_Comparison_Exp>;
  po_number?: InputMaybe<String_Comparison_Exp>;
  posted_date?: InputMaybe<Date_Comparison_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_legal_entity_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_order_id?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  sub_total?: InputMaybe<Numeric_Comparison_Exp>;
  target_date?: InputMaybe<Date_Comparison_Exp>;
  tax_amount?: InputMaybe<Numeric_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

export type Invoice_By_Id_Args = {
  _id?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "invoice_line" */
export type Invoice_Line = {
  __typename?: 'invoice_line';
  allocated_revenue_amount?: Maybe<Scalars['numeric']>;
  ar_status?: Maybe<Scalars['String']>;
  balance?: Maybe<Scalars['numeric']>;
  balance_without_debits?: Maybe<Scalars['numeric']>;
  base_currency?: Maybe<Scalars['String']>;
  base_currency_amount?: Maybe<Scalars['numeric']>;
  billing_frequency?: Maybe<Scalars['String']>;
  calculated_quantity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  channel?: Maybe<Channel>;
  charge_date?: Maybe<Scalars['String']>;
  charge_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credits?: Maybe<Scalars['numeric']>;
  days_past_due?: Maybe<Scalars['numeric']>;
  debit_payments?: Maybe<Scalars['numeric']>;
  debits?: Maybe<Scalars['numeric']>;
  due_date?: Maybe<Scalars['date']>;
  end_date?: Maybe<Scalars['date']>;
  grouped_quantity?: Maybe<Scalars['numeric']>;
  impact_amount?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  invoice: Invoice;
  invoice_line_month?: Maybe<Scalars['String']>;
  invoice_line_state?: Maybe<Scalars['String']>;
  invoice_line_status?: Maybe<Scalars['String']>;
  is_deleted: Scalars['Boolean'];
  legal_entity_reference?: Maybe<Scalars['String']>;
  payments?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  platform?: Maybe<Platform>;
  po_number?: Maybe<Scalars['String']>;
  /** An object relationship */
  product?: Maybe<Product>;
  quantity?: Maybe<Scalars['numeric']>;
  revenue_expected_amount?: Maybe<Scalars['numeric']>;
  revenue_liability_amount?: Maybe<Scalars['numeric']>;
  revenue_most_likely_amount?: Maybe<Scalars['numeric']>;
  revenue_schedule_status?: Maybe<Scalars['String']>;
  salesforce_asset_id?: Maybe<Scalars['String']>;
  salesforce_billing_finance_book_id?: Maybe<Scalars['String']>;
  salesforce_billing_finance_period_id?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_created_date: Scalars['timestamptz'];
  salesforce_id: Scalars['String'];
  salesforce_invoice_id: Scalars['String'];
  salesforce_last_modified_date: Scalars['timestamptz'];
  salesforce_legal_entity_id?: Maybe<Scalars['String']>;
  salesforce_order_product_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
  salesforce_product_id?: Maybe<Scalars['String']>;
  salesforce_usage_summary_id?: Maybe<Scalars['String']>;
  sopo_ref_number?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  sub_total?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "invoice_line" */
export type Invoice_Line_Aggregate = {
  __typename?: 'invoice_line_aggregate';
  aggregate?: Maybe<Invoice_Line_Aggregate_Fields>;
  nodes: Array<Invoice_Line>;
};

export type Invoice_Line_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Invoice_Line_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Invoice_Line_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Invoice_Line_Aggregate_Bool_Exp_Count>;
};

export type Invoice_Line_Aggregate_Bool_Exp_Bool_And = {
  arguments: Invoice_Line_Select_Column_Invoice_Line_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Line_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoice_Line_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Invoice_Line_Select_Column_Invoice_Line_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Line_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoice_Line_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoice_Line_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoice_Line_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invoice_line" */
export type Invoice_Line_Aggregate_Fields = {
  __typename?: 'invoice_line_aggregate_fields';
  avg?: Maybe<Invoice_Line_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Invoice_Line_Max_Fields>;
  min?: Maybe<Invoice_Line_Min_Fields>;
  stddev?: Maybe<Invoice_Line_Stddev_Fields>;
  stddev_pop?: Maybe<Invoice_Line_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoice_Line_Stddev_Samp_Fields>;
  sum?: Maybe<Invoice_Line_Sum_Fields>;
  var_pop?: Maybe<Invoice_Line_Var_Pop_Fields>;
  var_samp?: Maybe<Invoice_Line_Var_Samp_Fields>;
  variance?: Maybe<Invoice_Line_Variance_Fields>;
};


/** aggregate fields of "invoice_line" */
export type Invoice_Line_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoice_Line_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoice_line" */
export type Invoice_Line_Aggregate_Order_By = {
  avg?: InputMaybe<Invoice_Line_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoice_Line_Max_Order_By>;
  min?: InputMaybe<Invoice_Line_Min_Order_By>;
  stddev?: InputMaybe<Invoice_Line_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invoice_Line_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invoice_Line_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invoice_Line_Sum_Order_By>;
  var_pop?: InputMaybe<Invoice_Line_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invoice_Line_Var_Samp_Order_By>;
  variance?: InputMaybe<Invoice_Line_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Invoice_Line_Avg_Fields = {
  __typename?: 'invoice_line_avg_fields';
  allocated_revenue_amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  balance_without_debits?: Maybe<Scalars['Float']>;
  base_currency_amount?: Maybe<Scalars['Float']>;
  calculated_quantity?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  days_past_due?: Maybe<Scalars['Float']>;
  debit_payments?: Maybe<Scalars['Float']>;
  debits?: Maybe<Scalars['Float']>;
  grouped_quantity?: Maybe<Scalars['Float']>;
  impact_amount?: Maybe<Scalars['Float']>;
  payments?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  revenue_expected_amount?: Maybe<Scalars['Float']>;
  revenue_liability_amount?: Maybe<Scalars['Float']>;
  revenue_most_likely_amount?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoice_line" */
export type Invoice_Line_Avg_Order_By = {
  allocated_revenue_amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  balance_without_debits?: InputMaybe<Order_By>;
  base_currency_amount?: InputMaybe<Order_By>;
  calculated_quantity?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  days_past_due?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  grouped_quantity?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  revenue_expected_amount?: InputMaybe<Order_By>;
  revenue_liability_amount?: InputMaybe<Order_By>;
  revenue_most_likely_amount?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoice_line". All fields are combined with a logical 'AND'. */
export type Invoice_Line_Bool_Exp = {
  _and?: InputMaybe<Array<Invoice_Line_Bool_Exp>>;
  _not?: InputMaybe<Invoice_Line_Bool_Exp>;
  _or?: InputMaybe<Array<Invoice_Line_Bool_Exp>>;
  allocated_revenue_amount?: InputMaybe<Numeric_Comparison_Exp>;
  ar_status?: InputMaybe<String_Comparison_Exp>;
  balance?: InputMaybe<Numeric_Comparison_Exp>;
  balance_without_debits?: InputMaybe<Numeric_Comparison_Exp>;
  base_currency?: InputMaybe<String_Comparison_Exp>;
  base_currency_amount?: InputMaybe<Numeric_Comparison_Exp>;
  billing_frequency?: InputMaybe<String_Comparison_Exp>;
  calculated_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  channel?: InputMaybe<Channel_Bool_Exp>;
  charge_date?: InputMaybe<String_Comparison_Exp>;
  charge_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  credits?: InputMaybe<Numeric_Comparison_Exp>;
  days_past_due?: InputMaybe<Numeric_Comparison_Exp>;
  debit_payments?: InputMaybe<Numeric_Comparison_Exp>;
  debits?: InputMaybe<Numeric_Comparison_Exp>;
  due_date?: InputMaybe<Date_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  grouped_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  impact_amount?: InputMaybe<Numeric_Comparison_Exp>;
  invoice?: InputMaybe<Invoice_Bool_Exp>;
  invoice_line_month?: InputMaybe<String_Comparison_Exp>;
  invoice_line_state?: InputMaybe<String_Comparison_Exp>;
  invoice_line_status?: InputMaybe<String_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  legal_entity_reference?: InputMaybe<String_Comparison_Exp>;
  payments?: InputMaybe<Numeric_Comparison_Exp>;
  platform?: InputMaybe<Platform_Bool_Exp>;
  po_number?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  revenue_expected_amount?: InputMaybe<Numeric_Comparison_Exp>;
  revenue_liability_amount?: InputMaybe<Numeric_Comparison_Exp>;
  revenue_most_likely_amount?: InputMaybe<Numeric_Comparison_Exp>;
  revenue_schedule_status?: InputMaybe<String_Comparison_Exp>;
  salesforce_asset_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_billing_finance_book_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_billing_finance_period_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_channel_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_invoice_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_legal_entity_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_order_product_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_platform_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_product_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_usage_summary_id?: InputMaybe<String_Comparison_Exp>;
  sopo_ref_number?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  sub_total?: InputMaybe<Numeric_Comparison_Exp>;
  tax_amount?: InputMaybe<Numeric_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Invoice_Line_Max_Fields = {
  __typename?: 'invoice_line_max_fields';
  allocated_revenue_amount?: Maybe<Scalars['numeric']>;
  ar_status?: Maybe<Scalars['String']>;
  balance?: Maybe<Scalars['numeric']>;
  balance_without_debits?: Maybe<Scalars['numeric']>;
  base_currency?: Maybe<Scalars['String']>;
  base_currency_amount?: Maybe<Scalars['numeric']>;
  billing_frequency?: Maybe<Scalars['String']>;
  calculated_quantity?: Maybe<Scalars['numeric']>;
  charge_date?: Maybe<Scalars['String']>;
  charge_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credits?: Maybe<Scalars['numeric']>;
  days_past_due?: Maybe<Scalars['numeric']>;
  debit_payments?: Maybe<Scalars['numeric']>;
  debits?: Maybe<Scalars['numeric']>;
  due_date?: Maybe<Scalars['date']>;
  end_date?: Maybe<Scalars['date']>;
  grouped_quantity?: Maybe<Scalars['numeric']>;
  impact_amount?: Maybe<Scalars['numeric']>;
  invoice_line_month?: Maybe<Scalars['String']>;
  invoice_line_state?: Maybe<Scalars['String']>;
  invoice_line_status?: Maybe<Scalars['String']>;
  legal_entity_reference?: Maybe<Scalars['String']>;
  payments?: Maybe<Scalars['numeric']>;
  po_number?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  revenue_expected_amount?: Maybe<Scalars['numeric']>;
  revenue_liability_amount?: Maybe<Scalars['numeric']>;
  revenue_most_likely_amount?: Maybe<Scalars['numeric']>;
  revenue_schedule_status?: Maybe<Scalars['String']>;
  salesforce_asset_id?: Maybe<Scalars['String']>;
  salesforce_billing_finance_book_id?: Maybe<Scalars['String']>;
  salesforce_billing_finance_period_id?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_invoice_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_legal_entity_id?: Maybe<Scalars['String']>;
  salesforce_order_product_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
  salesforce_product_id?: Maybe<Scalars['String']>;
  salesforce_usage_summary_id?: Maybe<Scalars['String']>;
  sopo_ref_number?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  sub_total?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "invoice_line" */
export type Invoice_Line_Max_Order_By = {
  allocated_revenue_amount?: InputMaybe<Order_By>;
  ar_status?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  balance_without_debits?: InputMaybe<Order_By>;
  base_currency?: InputMaybe<Order_By>;
  base_currency_amount?: InputMaybe<Order_By>;
  billing_frequency?: InputMaybe<Order_By>;
  calculated_quantity?: InputMaybe<Order_By>;
  charge_date?: InputMaybe<Order_By>;
  charge_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  days_past_due?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  grouped_quantity?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  invoice_line_month?: InputMaybe<Order_By>;
  invoice_line_state?: InputMaybe<Order_By>;
  invoice_line_status?: InputMaybe<Order_By>;
  legal_entity_reference?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  revenue_expected_amount?: InputMaybe<Order_By>;
  revenue_liability_amount?: InputMaybe<Order_By>;
  revenue_most_likely_amount?: InputMaybe<Order_By>;
  revenue_schedule_status?: InputMaybe<Order_By>;
  salesforce_asset_id?: InputMaybe<Order_By>;
  salesforce_billing_finance_book_id?: InputMaybe<Order_By>;
  salesforce_billing_finance_period_id?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_invoice_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_legal_entity_id?: InputMaybe<Order_By>;
  salesforce_order_product_id?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
  salesforce_product_id?: InputMaybe<Order_By>;
  salesforce_usage_summary_id?: InputMaybe<Order_By>;
  sopo_ref_number?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoice_Line_Min_Fields = {
  __typename?: 'invoice_line_min_fields';
  allocated_revenue_amount?: Maybe<Scalars['numeric']>;
  ar_status?: Maybe<Scalars['String']>;
  balance?: Maybe<Scalars['numeric']>;
  balance_without_debits?: Maybe<Scalars['numeric']>;
  base_currency?: Maybe<Scalars['String']>;
  base_currency_amount?: Maybe<Scalars['numeric']>;
  billing_frequency?: Maybe<Scalars['String']>;
  calculated_quantity?: Maybe<Scalars['numeric']>;
  charge_date?: Maybe<Scalars['String']>;
  charge_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credits?: Maybe<Scalars['numeric']>;
  days_past_due?: Maybe<Scalars['numeric']>;
  debit_payments?: Maybe<Scalars['numeric']>;
  debits?: Maybe<Scalars['numeric']>;
  due_date?: Maybe<Scalars['date']>;
  end_date?: Maybe<Scalars['date']>;
  grouped_quantity?: Maybe<Scalars['numeric']>;
  impact_amount?: Maybe<Scalars['numeric']>;
  invoice_line_month?: Maybe<Scalars['String']>;
  invoice_line_state?: Maybe<Scalars['String']>;
  invoice_line_status?: Maybe<Scalars['String']>;
  legal_entity_reference?: Maybe<Scalars['String']>;
  payments?: Maybe<Scalars['numeric']>;
  po_number?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  revenue_expected_amount?: Maybe<Scalars['numeric']>;
  revenue_liability_amount?: Maybe<Scalars['numeric']>;
  revenue_most_likely_amount?: Maybe<Scalars['numeric']>;
  revenue_schedule_status?: Maybe<Scalars['String']>;
  salesforce_asset_id?: Maybe<Scalars['String']>;
  salesforce_billing_finance_book_id?: Maybe<Scalars['String']>;
  salesforce_billing_finance_period_id?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_invoice_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_legal_entity_id?: Maybe<Scalars['String']>;
  salesforce_order_product_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
  salesforce_product_id?: Maybe<Scalars['String']>;
  salesforce_usage_summary_id?: Maybe<Scalars['String']>;
  sopo_ref_number?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  sub_total?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "invoice_line" */
export type Invoice_Line_Min_Order_By = {
  allocated_revenue_amount?: InputMaybe<Order_By>;
  ar_status?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  balance_without_debits?: InputMaybe<Order_By>;
  base_currency?: InputMaybe<Order_By>;
  base_currency_amount?: InputMaybe<Order_By>;
  billing_frequency?: InputMaybe<Order_By>;
  calculated_quantity?: InputMaybe<Order_By>;
  charge_date?: InputMaybe<Order_By>;
  charge_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  days_past_due?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  grouped_quantity?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  invoice_line_month?: InputMaybe<Order_By>;
  invoice_line_state?: InputMaybe<Order_By>;
  invoice_line_status?: InputMaybe<Order_By>;
  legal_entity_reference?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  revenue_expected_amount?: InputMaybe<Order_By>;
  revenue_liability_amount?: InputMaybe<Order_By>;
  revenue_most_likely_amount?: InputMaybe<Order_By>;
  revenue_schedule_status?: InputMaybe<Order_By>;
  salesforce_asset_id?: InputMaybe<Order_By>;
  salesforce_billing_finance_book_id?: InputMaybe<Order_By>;
  salesforce_billing_finance_period_id?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_invoice_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_legal_entity_id?: InputMaybe<Order_By>;
  salesforce_order_product_id?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
  salesforce_product_id?: InputMaybe<Order_By>;
  salesforce_usage_summary_id?: InputMaybe<Order_By>;
  sopo_ref_number?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "invoice_line". */
export type Invoice_Line_Order_By = {
  allocated_revenue_amount?: InputMaybe<Order_By>;
  ar_status?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  balance_without_debits?: InputMaybe<Order_By>;
  base_currency?: InputMaybe<Order_By>;
  base_currency_amount?: InputMaybe<Order_By>;
  billing_frequency?: InputMaybe<Order_By>;
  calculated_quantity?: InputMaybe<Order_By>;
  channel?: InputMaybe<Channel_Order_By>;
  charge_date?: InputMaybe<Order_By>;
  charge_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  days_past_due?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  grouped_quantity?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Invoice_Order_By>;
  invoice_line_month?: InputMaybe<Order_By>;
  invoice_line_state?: InputMaybe<Order_By>;
  invoice_line_status?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  legal_entity_reference?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  platform?: InputMaybe<Platform_Order_By>;
  po_number?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  quantity?: InputMaybe<Order_By>;
  revenue_expected_amount?: InputMaybe<Order_By>;
  revenue_liability_amount?: InputMaybe<Order_By>;
  revenue_most_likely_amount?: InputMaybe<Order_By>;
  revenue_schedule_status?: InputMaybe<Order_By>;
  salesforce_asset_id?: InputMaybe<Order_By>;
  salesforce_billing_finance_book_id?: InputMaybe<Order_By>;
  salesforce_billing_finance_period_id?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_invoice_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_legal_entity_id?: InputMaybe<Order_By>;
  salesforce_order_product_id?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
  salesforce_product_id?: InputMaybe<Order_By>;
  salesforce_usage_summary_id?: InputMaybe<Order_By>;
  sopo_ref_number?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "invoice_line" */
export enum Invoice_Line_Select_Column {
  /** column name */
  AllocatedRevenueAmount = 'allocated_revenue_amount',
  /** column name */
  ArStatus = 'ar_status',
  /** column name */
  Balance = 'balance',
  /** column name */
  BalanceWithoutDebits = 'balance_without_debits',
  /** column name */
  BaseCurrency = 'base_currency',
  /** column name */
  BaseCurrencyAmount = 'base_currency_amount',
  /** column name */
  BillingFrequency = 'billing_frequency',
  /** column name */
  CalculatedQuantity = 'calculated_quantity',
  /** column name */
  ChargeDate = 'charge_date',
  /** column name */
  ChargeType = 'charge_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credits = 'credits',
  /** column name */
  DaysPastDue = 'days_past_due',
  /** column name */
  DebitPayments = 'debit_payments',
  /** column name */
  Debits = 'debits',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  GroupedQuantity = 'grouped_quantity',
  /** column name */
  ImpactAmount = 'impact_amount',
  /** column name */
  InvoiceLineMonth = 'invoice_line_month',
  /** column name */
  InvoiceLineState = 'invoice_line_state',
  /** column name */
  InvoiceLineStatus = 'invoice_line_status',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LegalEntityReference = 'legal_entity_reference',
  /** column name */
  Payments = 'payments',
  /** column name */
  PoNumber = 'po_number',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RevenueExpectedAmount = 'revenue_expected_amount',
  /** column name */
  RevenueLiabilityAmount = 'revenue_liability_amount',
  /** column name */
  RevenueMostLikelyAmount = 'revenue_most_likely_amount',
  /** column name */
  RevenueScheduleStatus = 'revenue_schedule_status',
  /** column name */
  SalesforceAssetId = 'salesforce_asset_id',
  /** column name */
  SalesforceBillingFinanceBookId = 'salesforce_billing_finance_book_id',
  /** column name */
  SalesforceBillingFinancePeriodId = 'salesforce_billing_finance_period_id',
  /** column name */
  SalesforceChannelId = 'salesforce_channel_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceInvoiceId = 'salesforce_invoice_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  SalesforceLegalEntityId = 'salesforce_legal_entity_id',
  /** column name */
  SalesforceOrderProductId = 'salesforce_order_product_id',
  /** column name */
  SalesforcePlatformId = 'salesforce_platform_id',
  /** column name */
  SalesforceProductId = 'salesforce_product_id',
  /** column name */
  SalesforceUsageSummaryId = 'salesforce_usage_summary_id',
  /** column name */
  SopoRefNumber = 'sopo_ref_number',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  SubTotal = 'sub_total',
  /** column name */
  TaxAmount = 'tax_amount',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "invoice_line_aggregate_bool_exp_bool_and_arguments_columns" columns of table "invoice_line" */
export enum Invoice_Line_Select_Column_Invoice_Line_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "invoice_line_aggregate_bool_exp_bool_or_arguments_columns" columns of table "invoice_line" */
export enum Invoice_Line_Select_Column_Invoice_Line_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** aggregate stddev on columns */
export type Invoice_Line_Stddev_Fields = {
  __typename?: 'invoice_line_stddev_fields';
  allocated_revenue_amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  balance_without_debits?: Maybe<Scalars['Float']>;
  base_currency_amount?: Maybe<Scalars['Float']>;
  calculated_quantity?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  days_past_due?: Maybe<Scalars['Float']>;
  debit_payments?: Maybe<Scalars['Float']>;
  debits?: Maybe<Scalars['Float']>;
  grouped_quantity?: Maybe<Scalars['Float']>;
  impact_amount?: Maybe<Scalars['Float']>;
  payments?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  revenue_expected_amount?: Maybe<Scalars['Float']>;
  revenue_liability_amount?: Maybe<Scalars['Float']>;
  revenue_most_likely_amount?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoice_line" */
export type Invoice_Line_Stddev_Order_By = {
  allocated_revenue_amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  balance_without_debits?: InputMaybe<Order_By>;
  base_currency_amount?: InputMaybe<Order_By>;
  calculated_quantity?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  days_past_due?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  grouped_quantity?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  revenue_expected_amount?: InputMaybe<Order_By>;
  revenue_liability_amount?: InputMaybe<Order_By>;
  revenue_most_likely_amount?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoice_Line_Stddev_Pop_Fields = {
  __typename?: 'invoice_line_stddev_pop_fields';
  allocated_revenue_amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  balance_without_debits?: Maybe<Scalars['Float']>;
  base_currency_amount?: Maybe<Scalars['Float']>;
  calculated_quantity?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  days_past_due?: Maybe<Scalars['Float']>;
  debit_payments?: Maybe<Scalars['Float']>;
  debits?: Maybe<Scalars['Float']>;
  grouped_quantity?: Maybe<Scalars['Float']>;
  impact_amount?: Maybe<Scalars['Float']>;
  payments?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  revenue_expected_amount?: Maybe<Scalars['Float']>;
  revenue_liability_amount?: Maybe<Scalars['Float']>;
  revenue_most_likely_amount?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "invoice_line" */
export type Invoice_Line_Stddev_Pop_Order_By = {
  allocated_revenue_amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  balance_without_debits?: InputMaybe<Order_By>;
  base_currency_amount?: InputMaybe<Order_By>;
  calculated_quantity?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  days_past_due?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  grouped_quantity?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  revenue_expected_amount?: InputMaybe<Order_By>;
  revenue_liability_amount?: InputMaybe<Order_By>;
  revenue_most_likely_amount?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoice_Line_Stddev_Samp_Fields = {
  __typename?: 'invoice_line_stddev_samp_fields';
  allocated_revenue_amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  balance_without_debits?: Maybe<Scalars['Float']>;
  base_currency_amount?: Maybe<Scalars['Float']>;
  calculated_quantity?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  days_past_due?: Maybe<Scalars['Float']>;
  debit_payments?: Maybe<Scalars['Float']>;
  debits?: Maybe<Scalars['Float']>;
  grouped_quantity?: Maybe<Scalars['Float']>;
  impact_amount?: Maybe<Scalars['Float']>;
  payments?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  revenue_expected_amount?: Maybe<Scalars['Float']>;
  revenue_liability_amount?: Maybe<Scalars['Float']>;
  revenue_most_likely_amount?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "invoice_line" */
export type Invoice_Line_Stddev_Samp_Order_By = {
  allocated_revenue_amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  balance_without_debits?: InputMaybe<Order_By>;
  base_currency_amount?: InputMaybe<Order_By>;
  calculated_quantity?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  days_past_due?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  grouped_quantity?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  revenue_expected_amount?: InputMaybe<Order_By>;
  revenue_liability_amount?: InputMaybe<Order_By>;
  revenue_most_likely_amount?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invoice_line" */
export type Invoice_Line_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Line_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Line_Stream_Cursor_Value_Input = {
  allocated_revenue_amount?: InputMaybe<Scalars['numeric']>;
  ar_status?: InputMaybe<Scalars['String']>;
  balance?: InputMaybe<Scalars['numeric']>;
  balance_without_debits?: InputMaybe<Scalars['numeric']>;
  base_currency?: InputMaybe<Scalars['String']>;
  base_currency_amount?: InputMaybe<Scalars['numeric']>;
  billing_frequency?: InputMaybe<Scalars['String']>;
  calculated_quantity?: InputMaybe<Scalars['numeric']>;
  charge_date?: InputMaybe<Scalars['String']>;
  charge_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credits?: InputMaybe<Scalars['numeric']>;
  days_past_due?: InputMaybe<Scalars['numeric']>;
  debit_payments?: InputMaybe<Scalars['numeric']>;
  debits?: InputMaybe<Scalars['numeric']>;
  due_date?: InputMaybe<Scalars['date']>;
  end_date?: InputMaybe<Scalars['date']>;
  grouped_quantity?: InputMaybe<Scalars['numeric']>;
  impact_amount?: InputMaybe<Scalars['numeric']>;
  invoice_line_month?: InputMaybe<Scalars['String']>;
  invoice_line_state?: InputMaybe<Scalars['String']>;
  invoice_line_status?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  legal_entity_reference?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<Scalars['numeric']>;
  po_number?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  revenue_expected_amount?: InputMaybe<Scalars['numeric']>;
  revenue_liability_amount?: InputMaybe<Scalars['numeric']>;
  revenue_most_likely_amount?: InputMaybe<Scalars['numeric']>;
  revenue_schedule_status?: InputMaybe<Scalars['String']>;
  salesforce_asset_id?: InputMaybe<Scalars['String']>;
  salesforce_billing_finance_book_id?: InputMaybe<Scalars['String']>;
  salesforce_billing_finance_period_id?: InputMaybe<Scalars['String']>;
  salesforce_channel_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_invoice_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_legal_entity_id?: InputMaybe<Scalars['String']>;
  salesforce_order_product_id?: InputMaybe<Scalars['String']>;
  salesforce_platform_id?: InputMaybe<Scalars['String']>;
  salesforce_product_id?: InputMaybe<Scalars['String']>;
  salesforce_usage_summary_id?: InputMaybe<Scalars['String']>;
  sopo_ref_number?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  sub_total?: InputMaybe<Scalars['numeric']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Invoice_Line_Sum_Fields = {
  __typename?: 'invoice_line_sum_fields';
  allocated_revenue_amount?: Maybe<Scalars['numeric']>;
  balance?: Maybe<Scalars['numeric']>;
  balance_without_debits?: Maybe<Scalars['numeric']>;
  base_currency_amount?: Maybe<Scalars['numeric']>;
  calculated_quantity?: Maybe<Scalars['numeric']>;
  credits?: Maybe<Scalars['numeric']>;
  days_past_due?: Maybe<Scalars['numeric']>;
  debit_payments?: Maybe<Scalars['numeric']>;
  debits?: Maybe<Scalars['numeric']>;
  grouped_quantity?: Maybe<Scalars['numeric']>;
  impact_amount?: Maybe<Scalars['numeric']>;
  payments?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  revenue_expected_amount?: Maybe<Scalars['numeric']>;
  revenue_liability_amount?: Maybe<Scalars['numeric']>;
  revenue_most_likely_amount?: Maybe<Scalars['numeric']>;
  sub_total?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "invoice_line" */
export type Invoice_Line_Sum_Order_By = {
  allocated_revenue_amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  balance_without_debits?: InputMaybe<Order_By>;
  base_currency_amount?: InputMaybe<Order_By>;
  calculated_quantity?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  days_past_due?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  grouped_quantity?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  revenue_expected_amount?: InputMaybe<Order_By>;
  revenue_liability_amount?: InputMaybe<Order_By>;
  revenue_most_likely_amount?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Invoice_Line_Var_Pop_Fields = {
  __typename?: 'invoice_line_var_pop_fields';
  allocated_revenue_amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  balance_without_debits?: Maybe<Scalars['Float']>;
  base_currency_amount?: Maybe<Scalars['Float']>;
  calculated_quantity?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  days_past_due?: Maybe<Scalars['Float']>;
  debit_payments?: Maybe<Scalars['Float']>;
  debits?: Maybe<Scalars['Float']>;
  grouped_quantity?: Maybe<Scalars['Float']>;
  impact_amount?: Maybe<Scalars['Float']>;
  payments?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  revenue_expected_amount?: Maybe<Scalars['Float']>;
  revenue_liability_amount?: Maybe<Scalars['Float']>;
  revenue_most_likely_amount?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "invoice_line" */
export type Invoice_Line_Var_Pop_Order_By = {
  allocated_revenue_amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  balance_without_debits?: InputMaybe<Order_By>;
  base_currency_amount?: InputMaybe<Order_By>;
  calculated_quantity?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  days_past_due?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  grouped_quantity?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  revenue_expected_amount?: InputMaybe<Order_By>;
  revenue_liability_amount?: InputMaybe<Order_By>;
  revenue_most_likely_amount?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoice_Line_Var_Samp_Fields = {
  __typename?: 'invoice_line_var_samp_fields';
  allocated_revenue_amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  balance_without_debits?: Maybe<Scalars['Float']>;
  base_currency_amount?: Maybe<Scalars['Float']>;
  calculated_quantity?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  days_past_due?: Maybe<Scalars['Float']>;
  debit_payments?: Maybe<Scalars['Float']>;
  debits?: Maybe<Scalars['Float']>;
  grouped_quantity?: Maybe<Scalars['Float']>;
  impact_amount?: Maybe<Scalars['Float']>;
  payments?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  revenue_expected_amount?: Maybe<Scalars['Float']>;
  revenue_liability_amount?: Maybe<Scalars['Float']>;
  revenue_most_likely_amount?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "invoice_line" */
export type Invoice_Line_Var_Samp_Order_By = {
  allocated_revenue_amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  balance_without_debits?: InputMaybe<Order_By>;
  base_currency_amount?: InputMaybe<Order_By>;
  calculated_quantity?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  days_past_due?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  grouped_quantity?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  revenue_expected_amount?: InputMaybe<Order_By>;
  revenue_liability_amount?: InputMaybe<Order_By>;
  revenue_most_likely_amount?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoice_Line_Variance_Fields = {
  __typename?: 'invoice_line_variance_fields';
  allocated_revenue_amount?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  balance_without_debits?: Maybe<Scalars['Float']>;
  base_currency_amount?: Maybe<Scalars['Float']>;
  calculated_quantity?: Maybe<Scalars['Float']>;
  credits?: Maybe<Scalars['Float']>;
  days_past_due?: Maybe<Scalars['Float']>;
  debit_payments?: Maybe<Scalars['Float']>;
  debits?: Maybe<Scalars['Float']>;
  grouped_quantity?: Maybe<Scalars['Float']>;
  impact_amount?: Maybe<Scalars['Float']>;
  payments?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  revenue_expected_amount?: Maybe<Scalars['Float']>;
  revenue_liability_amount?: Maybe<Scalars['Float']>;
  revenue_most_likely_amount?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoice_line" */
export type Invoice_Line_Variance_Order_By = {
  allocated_revenue_amount?: InputMaybe<Order_By>;
  balance?: InputMaybe<Order_By>;
  balance_without_debits?: InputMaybe<Order_By>;
  base_currency_amount?: InputMaybe<Order_By>;
  calculated_quantity?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  days_past_due?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  grouped_quantity?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  revenue_expected_amount?: InputMaybe<Order_By>;
  revenue_liability_amount?: InputMaybe<Order_By>;
  revenue_most_likely_amount?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

export type Invoice_Lines_By_Id_Args = {
  _id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Invoice_Max_Fields = {
  __typename?: 'invoice_max_fields';
  ar_status?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credits?: Maybe<Scalars['numeric']>;
  custom_invoice_number?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  days_outstanding?: Maybe<Scalars['numeric']>;
  debit_payments?: Maybe<Scalars['numeric']>;
  debits?: Maybe<Scalars['numeric']>;
  default_payment_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  impact_amount?: Maybe<Scalars['numeric']>;
  integration_status?: Maybe<Scalars['String']>;
  invoice_month?: Maybe<Scalars['String']>;
  invoice_pdf_attached?: Maybe<Scalars['String']>;
  negative_line_conversion?: Maybe<Scalars['numeric']>;
  payment_days?: Maybe<Scalars['numeric']>;
  payment_status?: Maybe<Scalars['String']>;
  payment_terms?: Maybe<Scalars['String']>;
  payments?: Maybe<Scalars['numeric']>;
  po_number?: Maybe<Scalars['String']>;
  posted_date?: Maybe<Scalars['date']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_legal_entity_id?: Maybe<Scalars['String']>;
  salesforce_order_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  sub_total?: Maybe<Scalars['numeric']>;
  target_date?: Maybe<Scalars['date']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "invoice" */
export type Invoice_Max_Order_By = {
  ar_status?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  custom_invoice_number?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  days_outstanding?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  default_payment_type?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  integration_status?: InputMaybe<Order_By>;
  invoice_month?: InputMaybe<Order_By>;
  invoice_pdf_attached?: InputMaybe<Order_By>;
  negative_line_conversion?: InputMaybe<Order_By>;
  payment_days?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  posted_date?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_legal_entity_id?: InputMaybe<Order_By>;
  salesforce_order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  target_date?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoice_Min_Fields = {
  __typename?: 'invoice_min_fields';
  ar_status?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  credits?: Maybe<Scalars['numeric']>;
  custom_invoice_number?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  days_outstanding?: Maybe<Scalars['numeric']>;
  debit_payments?: Maybe<Scalars['numeric']>;
  debits?: Maybe<Scalars['numeric']>;
  default_payment_type?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  impact_amount?: Maybe<Scalars['numeric']>;
  integration_status?: Maybe<Scalars['String']>;
  invoice_month?: Maybe<Scalars['String']>;
  invoice_pdf_attached?: Maybe<Scalars['String']>;
  negative_line_conversion?: Maybe<Scalars['numeric']>;
  payment_days?: Maybe<Scalars['numeric']>;
  payment_status?: Maybe<Scalars['String']>;
  payment_terms?: Maybe<Scalars['String']>;
  payments?: Maybe<Scalars['numeric']>;
  po_number?: Maybe<Scalars['String']>;
  posted_date?: Maybe<Scalars['date']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_legal_entity_id?: Maybe<Scalars['String']>;
  salesforce_order_id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  sub_total?: Maybe<Scalars['numeric']>;
  target_date?: Maybe<Scalars['date']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "invoice" */
export type Invoice_Min_Order_By = {
  ar_status?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  custom_invoice_number?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  days_outstanding?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  default_payment_type?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  integration_status?: InputMaybe<Order_By>;
  invoice_month?: InputMaybe<Order_By>;
  invoice_pdf_attached?: InputMaybe<Order_By>;
  negative_line_conversion?: InputMaybe<Order_By>;
  payment_days?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  posted_date?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_legal_entity_id?: InputMaybe<Order_By>;
  salesforce_order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  target_date?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "invoice". */
export type Invoice_Order_By = {
  ar_status?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  credits?: InputMaybe<Order_By>;
  custom_invoice_number?: InputMaybe<Order_By>;
  customer?: InputMaybe<Account_Order_By>;
  date?: InputMaybe<Order_By>;
  days_outstanding?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  default_payment_type?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  integration_status?: InputMaybe<Order_By>;
  invoice_lines_aggregate?: InputMaybe<Invoice_Line_Aggregate_Order_By>;
  invoice_month?: InputMaybe<Order_By>;
  invoice_pdf_attached?: InputMaybe<Order_By>;
  invoice_to_netsuite_transaction?: InputMaybe<Netsuite_Transaction_Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  negative_line_conversion?: InputMaybe<Order_By>;
  netsuite_invoice?: InputMaybe<Netsuite_Transaction_Order_By>;
  order?: InputMaybe<Order_Order_By>;
  payment_days?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  po_number?: InputMaybe<Order_By>;
  posted_date?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_legal_entity_id?: InputMaybe<Order_By>;
  salesforce_order_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  target_date?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "invoice" */
export enum Invoice_Select_Column {
  /** column name */
  ArStatus = 'ar_status',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Credits = 'credits',
  /** column name */
  CustomInvoiceNumber = 'custom_invoice_number',
  /** column name */
  Date = 'date',
  /** column name */
  DaysOutstanding = 'days_outstanding',
  /** column name */
  DebitPayments = 'debit_payments',
  /** column name */
  Debits = 'debits',
  /** column name */
  DefaultPaymentType = 'default_payment_type',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  ImpactAmount = 'impact_amount',
  /** column name */
  IntegrationStatus = 'integration_status',
  /** column name */
  InvoiceMonth = 'invoice_month',
  /** column name */
  InvoicePdfAttached = 'invoice_pdf_attached',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  NegativeLineConversion = 'negative_line_conversion',
  /** column name */
  PaymentDays = 'payment_days',
  /** column name */
  PaymentStatus = 'payment_status',
  /** column name */
  PaymentTerms = 'payment_terms',
  /** column name */
  Payments = 'payments',
  /** column name */
  PoNumber = 'po_number',
  /** column name */
  PostedDate = 'posted_date',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  SalesforceLegalEntityId = 'salesforce_legal_entity_id',
  /** column name */
  SalesforceOrderId = 'salesforce_order_id',
  /** column name */
  Status = 'status',
  /** column name */
  SubTotal = 'sub_total',
  /** column name */
  TargetDate = 'target_date',
  /** column name */
  TaxAmount = 'tax_amount',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "invoice_aggregate_bool_exp_bool_and_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "invoice_aggregate_bool_exp_bool_or_arguments_columns" columns of table "invoice" */
export enum Invoice_Select_Column_Invoice_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** aggregate stddev on columns */
export type Invoice_Stddev_Fields = {
  __typename?: 'invoice_stddev_fields';
  credits?: Maybe<Scalars['Float']>;
  days_outstanding?: Maybe<Scalars['Float']>;
  debit_payments?: Maybe<Scalars['Float']>;
  debits?: Maybe<Scalars['Float']>;
  impact_amount?: Maybe<Scalars['Float']>;
  negative_line_conversion?: Maybe<Scalars['Float']>;
  payment_days?: Maybe<Scalars['Float']>;
  payments?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoice" */
export type Invoice_Stddev_Order_By = {
  credits?: InputMaybe<Order_By>;
  days_outstanding?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  negative_line_conversion?: InputMaybe<Order_By>;
  payment_days?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoice_Stddev_Pop_Fields = {
  __typename?: 'invoice_stddev_pop_fields';
  credits?: Maybe<Scalars['Float']>;
  days_outstanding?: Maybe<Scalars['Float']>;
  debit_payments?: Maybe<Scalars['Float']>;
  debits?: Maybe<Scalars['Float']>;
  impact_amount?: Maybe<Scalars['Float']>;
  negative_line_conversion?: Maybe<Scalars['Float']>;
  payment_days?: Maybe<Scalars['Float']>;
  payments?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "invoice" */
export type Invoice_Stddev_Pop_Order_By = {
  credits?: InputMaybe<Order_By>;
  days_outstanding?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  negative_line_conversion?: InputMaybe<Order_By>;
  payment_days?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoice_Stddev_Samp_Fields = {
  __typename?: 'invoice_stddev_samp_fields';
  credits?: Maybe<Scalars['Float']>;
  days_outstanding?: Maybe<Scalars['Float']>;
  debit_payments?: Maybe<Scalars['Float']>;
  debits?: Maybe<Scalars['Float']>;
  impact_amount?: Maybe<Scalars['Float']>;
  negative_line_conversion?: Maybe<Scalars['Float']>;
  payment_days?: Maybe<Scalars['Float']>;
  payments?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "invoice" */
export type Invoice_Stddev_Samp_Order_By = {
  credits?: InputMaybe<Order_By>;
  days_outstanding?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  negative_line_conversion?: InputMaybe<Order_By>;
  payment_days?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invoice" */
export type Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoice_Stream_Cursor_Value_Input = {
  ar_status?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  credits?: InputMaybe<Scalars['numeric']>;
  custom_invoice_number?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  days_outstanding?: InputMaybe<Scalars['numeric']>;
  debit_payments?: InputMaybe<Scalars['numeric']>;
  debits?: InputMaybe<Scalars['numeric']>;
  default_payment_type?: InputMaybe<Scalars['String']>;
  due_date?: InputMaybe<Scalars['date']>;
  impact_amount?: InputMaybe<Scalars['numeric']>;
  integration_status?: InputMaybe<Scalars['String']>;
  invoice_month?: InputMaybe<Scalars['String']>;
  invoice_pdf_attached?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  negative_line_conversion?: InputMaybe<Scalars['numeric']>;
  payment_days?: InputMaybe<Scalars['numeric']>;
  payment_status?: InputMaybe<Scalars['String']>;
  payment_terms?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<Scalars['numeric']>;
  po_number?: InputMaybe<Scalars['String']>;
  posted_date?: InputMaybe<Scalars['date']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_legal_entity_id?: InputMaybe<Scalars['String']>;
  salesforce_order_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  sub_total?: InputMaybe<Scalars['numeric']>;
  target_date?: InputMaybe<Scalars['date']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Invoice_Sum_Fields = {
  __typename?: 'invoice_sum_fields';
  credits?: Maybe<Scalars['numeric']>;
  days_outstanding?: Maybe<Scalars['numeric']>;
  debit_payments?: Maybe<Scalars['numeric']>;
  debits?: Maybe<Scalars['numeric']>;
  impact_amount?: Maybe<Scalars['numeric']>;
  negative_line_conversion?: Maybe<Scalars['numeric']>;
  payment_days?: Maybe<Scalars['numeric']>;
  payments?: Maybe<Scalars['numeric']>;
  sub_total?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "invoice" */
export type Invoice_Sum_Order_By = {
  credits?: InputMaybe<Order_By>;
  days_outstanding?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  negative_line_conversion?: InputMaybe<Order_By>;
  payment_days?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Invoice_Var_Pop_Fields = {
  __typename?: 'invoice_var_pop_fields';
  credits?: Maybe<Scalars['Float']>;
  days_outstanding?: Maybe<Scalars['Float']>;
  debit_payments?: Maybe<Scalars['Float']>;
  debits?: Maybe<Scalars['Float']>;
  impact_amount?: Maybe<Scalars['Float']>;
  negative_line_conversion?: Maybe<Scalars['Float']>;
  payment_days?: Maybe<Scalars['Float']>;
  payments?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "invoice" */
export type Invoice_Var_Pop_Order_By = {
  credits?: InputMaybe<Order_By>;
  days_outstanding?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  negative_line_conversion?: InputMaybe<Order_By>;
  payment_days?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoice_Var_Samp_Fields = {
  __typename?: 'invoice_var_samp_fields';
  credits?: Maybe<Scalars['Float']>;
  days_outstanding?: Maybe<Scalars['Float']>;
  debit_payments?: Maybe<Scalars['Float']>;
  debits?: Maybe<Scalars['Float']>;
  impact_amount?: Maybe<Scalars['Float']>;
  negative_line_conversion?: Maybe<Scalars['Float']>;
  payment_days?: Maybe<Scalars['Float']>;
  payments?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "invoice" */
export type Invoice_Var_Samp_Order_By = {
  credits?: InputMaybe<Order_By>;
  days_outstanding?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  negative_line_conversion?: InputMaybe<Order_By>;
  payment_days?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoice_Variance_Fields = {
  __typename?: 'invoice_variance_fields';
  credits?: Maybe<Scalars['Float']>;
  days_outstanding?: Maybe<Scalars['Float']>;
  debit_payments?: Maybe<Scalars['Float']>;
  debits?: Maybe<Scalars['Float']>;
  impact_amount?: Maybe<Scalars['Float']>;
  negative_line_conversion?: Maybe<Scalars['Float']>;
  payment_days?: Maybe<Scalars['Float']>;
  payments?: Maybe<Scalars['Float']>;
  sub_total?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoice" */
export type Invoice_Variance_Order_By = {
  credits?: InputMaybe<Order_By>;
  days_outstanding?: InputMaybe<Order_By>;
  debit_payments?: InputMaybe<Order_By>;
  debits?: InputMaybe<Order_By>;
  impact_amount?: InputMaybe<Order_By>;
  negative_line_conversion?: InputMaybe<Order_By>;
  payment_days?: InputMaybe<Order_By>;
  payments?: InputMaybe<Order_By>;
  sub_total?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

export type Invoices_Due_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Invoices_Overdue_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Invoices_Paid_In_Full_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Invoices_Total_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "legal_entity" */
export type Legal_Entity = {
  __typename?: 'legal_entity';
  /** An array relationship */
  accounts: Array<Account>;
  /** An aggregate relationship */
  accounts_aggregate: Account_Aggregate;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  is_active?: Maybe<Scalars['Boolean']>;
  legal_entity_name?: Maybe<Scalars['String']>;
  legal_entity_number?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  salesforce_id: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  street_one?: Maybe<Scalars['String']>;
  street_two?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_postal_code?: Maybe<Scalars['String']>;
};


/** columns and relationships of "legal_entity" */
export type Legal_EntityAccountsArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


/** columns and relationships of "legal_entity" */
export type Legal_EntityAccounts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};

/** aggregated selection of "legal_entity" */
export type Legal_Entity_Aggregate = {
  __typename?: 'legal_entity_aggregate';
  aggregate?: Maybe<Legal_Entity_Aggregate_Fields>;
  nodes: Array<Legal_Entity>;
};

/** aggregate fields of "legal_entity" */
export type Legal_Entity_Aggregate_Fields = {
  __typename?: 'legal_entity_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Legal_Entity_Max_Fields>;
  min?: Maybe<Legal_Entity_Min_Fields>;
};


/** aggregate fields of "legal_entity" */
export type Legal_Entity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Legal_Entity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "legal_entity". All fields are combined with a logical 'AND'. */
export type Legal_Entity_Bool_Exp = {
  _and?: InputMaybe<Array<Legal_Entity_Bool_Exp>>;
  _not?: InputMaybe<Legal_Entity_Bool_Exp>;
  _or?: InputMaybe<Array<Legal_Entity_Bool_Exp>>;
  accounts?: InputMaybe<Account_Bool_Exp>;
  accounts_aggregate?: InputMaybe<Account_Aggregate_Bool_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  county?: InputMaybe<String_Comparison_Exp>;
  currency_iso_code?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  legal_entity_name?: InputMaybe<String_Comparison_Exp>;
  legal_entity_number?: InputMaybe<String_Comparison_Exp>;
  notes?: InputMaybe<String_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street_one?: InputMaybe<String_Comparison_Exp>;
  street_two?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  zip_postal_code?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Legal_Entity_Max_Fields = {
  __typename?: 'legal_entity_max_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  legal_entity_name?: Maybe<Scalars['String']>;
  legal_entity_number?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street_one?: Maybe<Scalars['String']>;
  street_two?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_postal_code?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Legal_Entity_Min_Fields = {
  __typename?: 'legal_entity_min_fields';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  legal_entity_name?: Maybe<Scalars['String']>;
  legal_entity_number?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street_one?: Maybe<Scalars['String']>;
  street_two?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  zip_postal_code?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "legal_entity". */
export type Legal_Entity_Order_By = {
  accounts_aggregate?: InputMaybe<Account_Aggregate_Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  county?: InputMaybe<Order_By>;
  currency_iso_code?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  legal_entity_name?: InputMaybe<Order_By>;
  legal_entity_number?: InputMaybe<Order_By>;
  notes?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_one?: InputMaybe<Order_By>;
  street_two?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  zip_postal_code?: InputMaybe<Order_By>;
};

/** select columns of table "legal_entity" */
export enum Legal_Entity_Select_Column {
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  County = 'county',
  /** column name */
  CurrencyIsoCode = 'currency_iso_code',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LegalEntityName = 'legal_entity_name',
  /** column name */
  LegalEntityNumber = 'legal_entity_number',
  /** column name */
  Notes = 'notes',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  State = 'state',
  /** column name */
  StreetOne = 'street_one',
  /** column name */
  StreetTwo = 'street_two',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ZipPostalCode = 'zip_postal_code'
}

/** Streaming cursor of the table "legal_entity" */
export type Legal_Entity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Legal_Entity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Legal_Entity_Stream_Cursor_Value_Input = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  currency_iso_code?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  legal_entity_name?: InputMaybe<Scalars['String']>;
  legal_entity_number?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street_one?: InputMaybe<Scalars['String']>;
  street_two?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  zip_postal_code?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "media_industry_sub_segment" */
export type Media_Industry_Sub_Segment = {
  __typename?: 'media_industry_sub_segment';
  broadcast_sub_segment?: Maybe<Scalars['String']>;
  content_type?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  salesforce_account_id: Scalars['String'];
  streaming_tv_sub_segment?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "media_industry_sub_segment" */
export type Media_Industry_Sub_SegmentContent_TypeArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "media_industry_sub_segment" */
export type Media_Industry_Sub_Segment_Aggregate = {
  __typename?: 'media_industry_sub_segment_aggregate';
  aggregate?: Maybe<Media_Industry_Sub_Segment_Aggregate_Fields>;
  nodes: Array<Media_Industry_Sub_Segment>;
};

/** aggregate fields of "media_industry_sub_segment" */
export type Media_Industry_Sub_Segment_Aggregate_Fields = {
  __typename?: 'media_industry_sub_segment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Media_Industry_Sub_Segment_Max_Fields>;
  min?: Maybe<Media_Industry_Sub_Segment_Min_Fields>;
};


/** aggregate fields of "media_industry_sub_segment" */
export type Media_Industry_Sub_Segment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Media_Industry_Sub_Segment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "media_industry_sub_segment". All fields are combined with a logical 'AND'. */
export type Media_Industry_Sub_Segment_Bool_Exp = {
  _and?: InputMaybe<Array<Media_Industry_Sub_Segment_Bool_Exp>>;
  _not?: InputMaybe<Media_Industry_Sub_Segment_Bool_Exp>;
  _or?: InputMaybe<Array<Media_Industry_Sub_Segment_Bool_Exp>>;
  broadcast_sub_segment?: InputMaybe<String_Comparison_Exp>;
  content_type?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  streaming_tv_sub_segment?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Media_Industry_Sub_Segment_Max_Fields = {
  __typename?: 'media_industry_sub_segment_max_fields';
  broadcast_sub_segment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  streaming_tv_sub_segment?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Media_Industry_Sub_Segment_Min_Fields = {
  __typename?: 'media_industry_sub_segment_min_fields';
  broadcast_sub_segment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  streaming_tv_sub_segment?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "media_industry_sub_segment". */
export type Media_Industry_Sub_Segment_Order_By = {
  broadcast_sub_segment?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  streaming_tv_sub_segment?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "media_industry_sub_segment" */
export enum Media_Industry_Sub_Segment_Select_Column {
  /** column name */
  BroadcastSubSegment = 'broadcast_sub_segment',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  StreamingTvSubSegment = 'streaming_tv_sub_segment',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "media_industry_sub_segment" */
export type Media_Industry_Sub_Segment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Media_Industry_Sub_Segment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Media_Industry_Sub_Segment_Stream_Cursor_Value_Input = {
  broadcast_sub_segment?: InputMaybe<Scalars['String']>;
  content_type?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  streaming_tv_sub_segment?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "msa_master" */
export type Msa_Master = {
  __typename?: 'msa_master';
  amagi_id?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "msa_master" */
export type Msa_MasterDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "msa_master" */
export type Msa_Master_Aggregate = {
  __typename?: 'msa_master_aggregate';
  aggregate?: Maybe<Msa_Master_Aggregate_Fields>;
  nodes: Array<Msa_Master>;
};

/** aggregate fields of "msa_master" */
export type Msa_Master_Aggregate_Fields = {
  __typename?: 'msa_master_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Msa_Master_Max_Fields>;
  min?: Maybe<Msa_Master_Min_Fields>;
};


/** aggregate fields of "msa_master" */
export type Msa_Master_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Msa_Master_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "msa_master". All fields are combined with a logical 'AND'. */
export type Msa_Master_Bool_Exp = {
  _and?: InputMaybe<Array<Msa_Master_Bool_Exp>>;
  _not?: InputMaybe<Msa_Master_Bool_Exp>;
  _or?: InputMaybe<Array<Msa_Master_Bool_Exp>>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** aggregate max on columns */
export type Msa_Master_Max_Fields = {
  __typename?: 'msa_master_max_fields';
  amagi_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Msa_Master_Min_Fields = {
  __typename?: 'msa_master_min_fields';
  amagi_id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "msa_master". */
export type Msa_Master_Order_By = {
  amagi_id?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
};

/** select columns of table "msa_master" */
export enum Msa_Master_Select_Column {
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  Data = 'data'
}

/** Streaming cursor of the table "msa_master" */
export type Msa_Master_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Msa_Master_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Msa_Master_Stream_Cursor_Value_Input = {
  amagi_id?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "msa_rate_card" */
export type Msa_Rate_Card = {
  __typename?: 'msa_rate_card';
  amagi_id: Scalars['String'];
  billing_frequency?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  /** A computed field, executes function "comp_quote_type_or_quote_number" */
  computed_quote_type_or_quote_number?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  discount_tiers_at_product_level?: Maybe<Scalars['jsonb']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  msa_rate_card_to_customer?: Maybe<Account>;
  /** An object relationship */
  msa_rate_card_to_product?: Maybe<Product>;
  /** A computed field, executes function "msa_revenue_type" */
  msa_revenue_type?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  quote_number: Scalars['String'];
  quote_type?: Maybe<Scalars['String']>;
  quote_type_or_quote_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tier_at_product_level?: Maybe<Scalars['jsonb']>;
  type?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};


/** columns and relationships of "msa_rate_card" */
export type Msa_Rate_CardDiscount_Tiers_At_Product_LevelArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "msa_rate_card" */
export type Msa_Rate_CardTier_At_Product_LevelArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "msa_rate_card" */
export type Msa_Rate_Card_Aggregate = {
  __typename?: 'msa_rate_card_aggregate';
  aggregate?: Maybe<Msa_Rate_Card_Aggregate_Fields>;
  nodes: Array<Msa_Rate_Card>;
};

/** aggregate fields of "msa_rate_card" */
export type Msa_Rate_Card_Aggregate_Fields = {
  __typename?: 'msa_rate_card_aggregate_fields';
  avg?: Maybe<Msa_Rate_Card_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Msa_Rate_Card_Max_Fields>;
  min?: Maybe<Msa_Rate_Card_Min_Fields>;
  stddev?: Maybe<Msa_Rate_Card_Stddev_Fields>;
  stddev_pop?: Maybe<Msa_Rate_Card_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Msa_Rate_Card_Stddev_Samp_Fields>;
  sum?: Maybe<Msa_Rate_Card_Sum_Fields>;
  var_pop?: Maybe<Msa_Rate_Card_Var_Pop_Fields>;
  var_samp?: Maybe<Msa_Rate_Card_Var_Samp_Fields>;
  variance?: Maybe<Msa_Rate_Card_Variance_Fields>;
};


/** aggregate fields of "msa_rate_card" */
export type Msa_Rate_Card_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Msa_Rate_Card_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Msa_Rate_Card_Append_Input = {
  tier_at_product_level?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Msa_Rate_Card_Avg_Fields = {
  __typename?: 'msa_rate_card_avg_fields';
  price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "msa_rate_card". All fields are combined with a logical 'AND'. */
export type Msa_Rate_Card_Bool_Exp = {
  _and?: InputMaybe<Array<Msa_Rate_Card_Bool_Exp>>;
  _not?: InputMaybe<Msa_Rate_Card_Bool_Exp>;
  _or?: InputMaybe<Array<Msa_Rate_Card_Bool_Exp>>;
  amagi_id?: InputMaybe<String_Comparison_Exp>;
  billing_frequency?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  computed_quote_type_or_quote_number?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  discount_tiers_at_product_level?: InputMaybe<Jsonb_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  msa_rate_card_to_customer?: InputMaybe<Account_Bool_Exp>;
  msa_rate_card_to_product?: InputMaybe<Product_Bool_Exp>;
  msa_revenue_type?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  quote_number?: InputMaybe<String_Comparison_Exp>;
  quote_type?: InputMaybe<String_Comparison_Exp>;
  quote_type_or_quote_number?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tier_at_product_level?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "msa_rate_card" */
export enum Msa_Rate_Card_Constraint {
  /** unique or primary key constraint on columns "code", "amagi_id", "quote_number" */
  MsaRateCardPkey = 'msa_rate_card_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Msa_Rate_Card_Delete_At_Path_Input = {
  tier_at_product_level?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Msa_Rate_Card_Delete_Elem_Input = {
  tier_at_product_level?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Msa_Rate_Card_Delete_Key_Input = {
  tier_at_product_level?: InputMaybe<Scalars['String']>;
};

export type Msa_Rate_Card_Fn_Args = {
  amagi_ids?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "msa_rate_card" */
export type Msa_Rate_Card_Inc_Input = {
  price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "msa_rate_card" */
export type Msa_Rate_Card_Insert_Input = {
  amagi_id?: InputMaybe<Scalars['String']>;
  billing_frequency?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  quote_type?: InputMaybe<Scalars['String']>;
  tier_at_product_level?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Msa_Rate_Card_Max_Fields = {
  __typename?: 'msa_rate_card_max_fields';
  amagi_id?: Maybe<Scalars['String']>;
  billing_frequency?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  quote_number?: Maybe<Scalars['String']>;
  quote_type?: Maybe<Scalars['String']>;
  quote_type_or_quote_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Msa_Rate_Card_Min_Fields = {
  __typename?: 'msa_rate_card_min_fields';
  amagi_id?: Maybe<Scalars['String']>;
  billing_frequency?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  quote_number?: Maybe<Scalars['String']>;
  quote_type?: Maybe<Scalars['String']>;
  quote_type_or_quote_number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "msa_rate_card" */
export type Msa_Rate_Card_Mutation_Response = {
  __typename?: 'msa_rate_card_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Msa_Rate_Card>;
};

/** on_conflict condition type for table "msa_rate_card" */
export type Msa_Rate_Card_On_Conflict = {
  constraint: Msa_Rate_Card_Constraint;
  update_columns?: Array<Msa_Rate_Card_Update_Column>;
  where?: InputMaybe<Msa_Rate_Card_Bool_Exp>;
};

/** Ordering options when selecting data from "msa_rate_card". */
export type Msa_Rate_Card_Order_By = {
  amagi_id?: InputMaybe<Order_By>;
  billing_frequency?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  computed_quote_type_or_quote_number?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  discount_tiers_at_product_level?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  msa_rate_card_to_customer?: InputMaybe<Account_Order_By>;
  msa_rate_card_to_product?: InputMaybe<Product_Order_By>;
  msa_revenue_type?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  quote_number?: InputMaybe<Order_By>;
  quote_type?: InputMaybe<Order_By>;
  quote_type_or_quote_number?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tier_at_product_level?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
};

/** primary key columns input for table: msa_rate_card */
export type Msa_Rate_Card_Pk_Columns_Input = {
  amagi_id: Scalars['String'];
  code: Scalars['String'];
  quote_number: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Msa_Rate_Card_Prepend_Input = {
  tier_at_product_level?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "msa_rate_card" */
export enum Msa_Rate_Card_Select_Column {
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  BillingFrequency = 'billing_frequency',
  /** column name */
  Code = 'code',
  /** column name */
  Currency = 'currency',
  /** column name */
  DiscountTiersAtProductLevel = 'discount_tiers_at_product_level',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Price = 'price',
  /** column name */
  QuoteNumber = 'quote_number',
  /** column name */
  QuoteType = 'quote_type',
  /** column name */
  QuoteTypeOrQuoteNumber = 'quote_type_or_quote_number',
  /** column name */
  Status = 'status',
  /** column name */
  TierAtProductLevel = 'tier_at_product_level',
  /** column name */
  Type = 'type',
  /** column name */
  Unit = 'unit'
}

/** input type for updating data in table "msa_rate_card" */
export type Msa_Rate_Card_Set_Input = {
  amagi_id?: InputMaybe<Scalars['String']>;
  billing_frequency?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  quote_type?: InputMaybe<Scalars['String']>;
  tier_at_product_level?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Msa_Rate_Card_Stddev_Fields = {
  __typename?: 'msa_rate_card_stddev_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Msa_Rate_Card_Stddev_Pop_Fields = {
  __typename?: 'msa_rate_card_stddev_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Msa_Rate_Card_Stddev_Samp_Fields = {
  __typename?: 'msa_rate_card_stddev_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "msa_rate_card" */
export type Msa_Rate_Card_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Msa_Rate_Card_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Msa_Rate_Card_Stream_Cursor_Value_Input = {
  amagi_id?: InputMaybe<Scalars['String']>;
  billing_frequency?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  discount_tiers_at_product_level?: InputMaybe<Scalars['jsonb']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  price?: InputMaybe<Scalars['numeric']>;
  quote_number?: InputMaybe<Scalars['String']>;
  quote_type?: InputMaybe<Scalars['String']>;
  quote_type_or_quote_number?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  tier_at_product_level?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Msa_Rate_Card_Sum_Fields = {
  __typename?: 'msa_rate_card_sum_fields';
  price?: Maybe<Scalars['numeric']>;
};

/** update columns of table "msa_rate_card" */
export enum Msa_Rate_Card_Update_Column {
  /** column name */
  AmagiId = 'amagi_id',
  /** column name */
  BillingFrequency = 'billing_frequency',
  /** column name */
  Code = 'code',
  /** column name */
  Currency = 'currency',
  /** column name */
  Price = 'price',
  /** column name */
  QuoteType = 'quote_type',
  /** column name */
  TierAtProductLevel = 'tier_at_product_level',
  /** column name */
  Type = 'type',
  /** column name */
  Unit = 'unit'
}

export type Msa_Rate_Card_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Msa_Rate_Card_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Msa_Rate_Card_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Msa_Rate_Card_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Msa_Rate_Card_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Msa_Rate_Card_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Msa_Rate_Card_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Msa_Rate_Card_Set_Input>;
  /** filter the rows which have to be updated */
  where: Msa_Rate_Card_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Msa_Rate_Card_Var_Pop_Fields = {
  __typename?: 'msa_rate_card_var_pop_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Msa_Rate_Card_Var_Samp_Fields = {
  __typename?: 'msa_rate_card_var_samp_fields';
  price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Msa_Rate_Card_Variance_Fields = {
  __typename?: 'msa_rate_card_variance_fields';
  price?: Maybe<Scalars['Float']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** api key generate */
  api_key_create: ApiKeyCreateResponse;
  /** delete data from the table: "msa_rate_card" */
  delete_msa_rate_card?: Maybe<Msa_Rate_Card_Mutation_Response>;
  /** delete single row from the table: "msa_rate_card" */
  delete_msa_rate_card_by_pk?: Maybe<Msa_Rate_Card>;
  /** insert data into the table: "channel" */
  insert_channel?: Maybe<Channel_Mutation_Response>;
  /** insert a single row into the table: "channel" */
  insert_channel_one?: Maybe<Channel>;
   /** delete data from the table: "redundant_playout_channels" */
  delete_redundant_playout_channels?: Maybe<Redundant_Playout_Channels_Mutation_Response>;
  /** delete single row from the table: "redundant_playout_channels" */
  delete_redundant_playout_channels_by_pk?: Maybe<Redundant_Playout_Channels>;
  /** insert data into the table: "redundant_playout_channels" */
  insert_redundant_playout_channels?: Maybe<Redundant_Playout_Channels_Mutation_Response>;
  /** insert a single row into the table: "redundant_playout_channels" */
  insert_redundant_playout_channels_one?: Maybe<Redundant_Playout_Channels>;
  /** insert data into the table: "msa_rate_card" */
  insert_msa_rate_card?: Maybe<Msa_Rate_Card_Mutation_Response>;
  /** insert a single row into the table: "msa_rate_card" */
  insert_msa_rate_card_one?: Maybe<Msa_Rate_Card>;
  /** insert data into the table: "page" */
  insert_page?: Maybe<Page_Mutation_Response>;
  /** insert a single row into the table: "page" */
  insert_page_one?: Maybe<Page>;
  /** insert data into the table: "platform" */
  insert_platform?: Maybe<Platform_Mutation_Response>;
  /** insert a single row into the table: "platform" */
  insert_platform_one?: Maybe<Platform>;
  /** update data of the table: "account" */
  update_account?: Maybe<Account_Mutation_Response>;
  /** update single row of the table: "account" */
  update_account_by_pk?: Maybe<Account>;
  /** update multiples rows of table: "account" */
  update_account_many?: Maybe<Array<Maybe<Account_Mutation_Response>>>;
  /** update data of the table: "channel" */
  update_channel?: Maybe<Channel_Mutation_Response>;
  /** update single row of the table: "channel" */
  update_channel_by_pk?: Maybe<Channel>;
  /** update multiples rows of table: "channel" */
  update_channel_many?: Maybe<Array<Maybe<Channel_Mutation_Response>>>;
  /** update data of the table: "delivery" */
  update_delivery?: Maybe<Delivery_Mutation_Response>;
  /** update single row of the table: "delivery" */
  update_delivery_by_pk?: Maybe<Delivery>;
  /** update data of the table: "delivery_data" */
  update_delivery_data?: Maybe<Delivery_Data_Mutation_Response>;
  /** update multiples rows of table: "delivery_data" */
  update_delivery_data_many?: Maybe<Array<Maybe<Delivery_Data_Mutation_Response>>>;
  /** update multiples rows of table: "delivery" */
  update_delivery_many?: Maybe<Array<Maybe<Delivery_Mutation_Response>>>;
  /** update data of the table: "msa_rate_card" */
  update_msa_rate_card?: Maybe<Msa_Rate_Card_Mutation_Response>;
  /** update single row of the table: "msa_rate_card" */
  update_msa_rate_card_by_pk?: Maybe<Msa_Rate_Card>;
  /** update multiples rows of table: "msa_rate_card" */
  update_msa_rate_card_many?: Maybe<Array<Maybe<Msa_Rate_Card_Mutation_Response>>>;
  /** update data of the table: "page" */
  update_page?: Maybe<Page_Mutation_Response>;
  /** update single row of the table: "page" */
  update_page_by_pk?: Maybe<Page>;
  /** update multiples rows of table: "page" */
  update_page_many?: Maybe<Array<Maybe<Page_Mutation_Response>>>;
  /** update data of the table: "platform" */
  update_platform?: Maybe<Platform_Mutation_Response>;
  /** update single row of the table: "platform" */
  update_platform_by_pk?: Maybe<Platform>;
  /** update multiples rows of table: "platform" */
  update_platform_many?: Maybe<Array<Maybe<Platform_Mutation_Response>>>;
  /** update data of the table: "product" */
  update_product?: Maybe<Product_Mutation_Response>;
  /** update single row of the table: "product" */
  update_product_by_pk?: Maybe<Product>;
  /** update multiples rows of table: "product" */
  update_product_many?: Maybe<Array<Maybe<Product_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootApi_Key_CreateArgs = {
  input: ApiKeyCreateInput;
};


/** mutation root */
export type Mutation_RootDelete_Msa_Rate_CardArgs = {
  where: Msa_Rate_Card_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Msa_Rate_Card_By_PkArgs = {
  amagi_id: Scalars['String'];
  code: Scalars['String'];
  quote_number: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_ChannelArgs = {
  objects: Array<Channel_Insert_Input>;
  on_conflict?: InputMaybe<Channel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Channel_OneArgs = {
  object: Channel_Insert_Input;
  on_conflict?: InputMaybe<Channel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Msa_Rate_CardArgs = {
  objects: Array<Msa_Rate_Card_Insert_Input>;
  on_conflict?: InputMaybe<Msa_Rate_Card_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Msa_Rate_Card_OneArgs = {
  object: Msa_Rate_Card_Insert_Input;
  on_conflict?: InputMaybe<Msa_Rate_Card_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PageArgs = {
  objects: Array<Page_Insert_Input>;
  on_conflict?: InputMaybe<Page_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Page_OneArgs = {
  object: Page_Insert_Input;
  on_conflict?: InputMaybe<Page_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PlatformArgs = {
  objects: Array<Platform_Insert_Input>;
  on_conflict?: InputMaybe<Platform_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Platform_OneArgs = {
  object: Platform_Insert_Input;
  on_conflict?: InputMaybe<Platform_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_AccountArgs = {
  _inc?: InputMaybe<Account_Inc_Input>;
  _set?: InputMaybe<Account_Set_Input>;
  where: Account_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Account_By_PkArgs = {
  _inc?: InputMaybe<Account_Inc_Input>;
  _set?: InputMaybe<Account_Set_Input>;
  pk_columns: Account_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Account_ManyArgs = {
  updates: Array<Account_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ChannelArgs = {
  _append?: InputMaybe<Channel_Append_Input>;
  _delete_at_path?: InputMaybe<Channel_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Channel_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Channel_Delete_Key_Input>;
  _prepend?: InputMaybe<Channel_Prepend_Input>;
  _set?: InputMaybe<Channel_Set_Input>;
  where: Channel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Channel_By_PkArgs = {
  _append?: InputMaybe<Channel_Append_Input>;
  _delete_at_path?: InputMaybe<Channel_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Channel_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Channel_Delete_Key_Input>;
  _prepend?: InputMaybe<Channel_Prepend_Input>;
  _set?: InputMaybe<Channel_Set_Input>;
  pk_columns: Channel_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Channel_ManyArgs = {
  updates: Array<Channel_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DeliveryArgs = {
  _append?: InputMaybe<Delivery_Append_Input>;
  _delete_at_path?: InputMaybe<Delivery_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Delivery_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Delivery_Delete_Key_Input>;
  _inc?: InputMaybe<Delivery_Inc_Input>;
  _prepend?: InputMaybe<Delivery_Prepend_Input>;
  _set?: InputMaybe<Delivery_Set_Input>;
  where: Delivery_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_By_PkArgs = {
  _append?: InputMaybe<Delivery_Append_Input>;
  _delete_at_path?: InputMaybe<Delivery_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Delivery_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Delivery_Delete_Key_Input>;
  _inc?: InputMaybe<Delivery_Inc_Input>;
  _prepend?: InputMaybe<Delivery_Prepend_Input>;
  _set?: InputMaybe<Delivery_Set_Input>;
  pk_columns: Delivery_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_DataArgs = {
  _append?: InputMaybe<Delivery_Data_Append_Input>;
  _delete_at_path?: InputMaybe<Delivery_Data_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Delivery_Data_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Delivery_Data_Delete_Key_Input>;
  _inc?: InputMaybe<Delivery_Data_Inc_Input>;
  _prepend?: InputMaybe<Delivery_Data_Prepend_Input>;
  _set?: InputMaybe<Delivery_Data_Set_Input>;
  where: Delivery_Data_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_Data_ManyArgs = {
  updates: Array<Delivery_Data_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Delivery_ManyArgs = {
  updates: Array<Delivery_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Msa_Rate_CardArgs = {
  _append?: InputMaybe<Msa_Rate_Card_Append_Input>;
  _delete_at_path?: InputMaybe<Msa_Rate_Card_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Msa_Rate_Card_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Msa_Rate_Card_Delete_Key_Input>;
  _inc?: InputMaybe<Msa_Rate_Card_Inc_Input>;
  _prepend?: InputMaybe<Msa_Rate_Card_Prepend_Input>;
  _set?: InputMaybe<Msa_Rate_Card_Set_Input>;
  where: Msa_Rate_Card_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Msa_Rate_Card_By_PkArgs = {
  _append?: InputMaybe<Msa_Rate_Card_Append_Input>;
  _delete_at_path?: InputMaybe<Msa_Rate_Card_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Msa_Rate_Card_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Msa_Rate_Card_Delete_Key_Input>;
  _inc?: InputMaybe<Msa_Rate_Card_Inc_Input>;
  _prepend?: InputMaybe<Msa_Rate_Card_Prepend_Input>;
  _set?: InputMaybe<Msa_Rate_Card_Set_Input>;
  pk_columns: Msa_Rate_Card_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Msa_Rate_Card_ManyArgs = {
  updates: Array<Msa_Rate_Card_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PageArgs = {
  _set?: InputMaybe<Page_Set_Input>;
  where: Page_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Page_By_PkArgs = {
  _set?: InputMaybe<Page_Set_Input>;
  pk_columns: Page_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Page_ManyArgs = {
  updates: Array<Page_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PlatformArgs = {
  _append?: InputMaybe<Platform_Append_Input>;
  _delete_at_path?: InputMaybe<Platform_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Platform_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Platform_Delete_Key_Input>;
  _inc?: InputMaybe<Platform_Inc_Input>;
  _prepend?: InputMaybe<Platform_Prepend_Input>;
  _set?: InputMaybe<Platform_Set_Input>;
  where: Platform_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Platform_By_PkArgs = {
  _append?: InputMaybe<Platform_Append_Input>;
  _delete_at_path?: InputMaybe<Platform_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Platform_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Platform_Delete_Key_Input>;
  _inc?: InputMaybe<Platform_Inc_Input>;
  _prepend?: InputMaybe<Platform_Prepend_Input>;
  _set?: InputMaybe<Platform_Set_Input>;
  pk_columns: Platform_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Platform_ManyArgs = {
  updates: Array<Platform_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProductArgs = {
  _set?: InputMaybe<Product_Set_Input>;
  where: Product_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Product_By_PkArgs = {
  _set?: InputMaybe<Product_Set_Input>;
  pk_columns: Product_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Product_ManyArgs = {
  updates: Array<Product_Updates>;
};

export type Net_Invoices_Due_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Net_Invoices_Outstanding_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Net_Invoices_Overdue_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Netsuite_Credit_Issued_Cummulative_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
};

export type Netsuite_Credit_Issued_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "netsuite_currency_rate" */
export type Netsuite_Currency_Rate = {
  __typename?: 'netsuite_currency_rate';
  base_symbol: Scalars['String'];
  effective_date: Scalars['date'];
  exchange_rate: Scalars['numeric'];
  id: Scalars['numeric'];
  transaction_symbol: Scalars['String'];
};

/** aggregated selection of "netsuite_currency_rate" */
export type Netsuite_Currency_Rate_Aggregate = {
  __typename?: 'netsuite_currency_rate_aggregate';
  aggregate?: Maybe<Netsuite_Currency_Rate_Aggregate_Fields>;
  nodes: Array<Netsuite_Currency_Rate>;
};

/** aggregate fields of "netsuite_currency_rate" */
export type Netsuite_Currency_Rate_Aggregate_Fields = {
  __typename?: 'netsuite_currency_rate_aggregate_fields';
  avg?: Maybe<Netsuite_Currency_Rate_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Netsuite_Currency_Rate_Max_Fields>;
  min?: Maybe<Netsuite_Currency_Rate_Min_Fields>;
  stddev?: Maybe<Netsuite_Currency_Rate_Stddev_Fields>;
  stddev_pop?: Maybe<Netsuite_Currency_Rate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Netsuite_Currency_Rate_Stddev_Samp_Fields>;
  sum?: Maybe<Netsuite_Currency_Rate_Sum_Fields>;
  var_pop?: Maybe<Netsuite_Currency_Rate_Var_Pop_Fields>;
  var_samp?: Maybe<Netsuite_Currency_Rate_Var_Samp_Fields>;
  variance?: Maybe<Netsuite_Currency_Rate_Variance_Fields>;
};


/** aggregate fields of "netsuite_currency_rate" */
export type Netsuite_Currency_Rate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Netsuite_Currency_Rate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Netsuite_Currency_Rate_Avg_Fields = {
  __typename?: 'netsuite_currency_rate_avg_fields';
  exchange_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "netsuite_currency_rate". All fields are combined with a logical 'AND'. */
export type Netsuite_Currency_Rate_Bool_Exp = {
  _and?: InputMaybe<Array<Netsuite_Currency_Rate_Bool_Exp>>;
  _not?: InputMaybe<Netsuite_Currency_Rate_Bool_Exp>;
  _or?: InputMaybe<Array<Netsuite_Currency_Rate_Bool_Exp>>;
  base_symbol?: InputMaybe<String_Comparison_Exp>;
  effective_date?: InputMaybe<Date_Comparison_Exp>;
  exchange_rate?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Numeric_Comparison_Exp>;
  transaction_symbol?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Netsuite_Currency_Rate_Max_Fields = {
  __typename?: 'netsuite_currency_rate_max_fields';
  base_symbol?: Maybe<Scalars['String']>;
  effective_date?: Maybe<Scalars['date']>;
  exchange_rate?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  transaction_symbol?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Netsuite_Currency_Rate_Min_Fields = {
  __typename?: 'netsuite_currency_rate_min_fields';
  base_symbol?: Maybe<Scalars['String']>;
  effective_date?: Maybe<Scalars['date']>;
  exchange_rate?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
  transaction_symbol?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "netsuite_currency_rate". */
export type Netsuite_Currency_Rate_Order_By = {
  base_symbol?: InputMaybe<Order_By>;
  effective_date?: InputMaybe<Order_By>;
  exchange_rate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_symbol?: InputMaybe<Order_By>;
};

/** select columns of table "netsuite_currency_rate" */
export enum Netsuite_Currency_Rate_Select_Column {
  /** column name */
  BaseSymbol = 'base_symbol',
  /** column name */
  EffectiveDate = 'effective_date',
  /** column name */
  ExchangeRate = 'exchange_rate',
  /** column name */
  Id = 'id',
  /** column name */
  TransactionSymbol = 'transaction_symbol'
}

/** aggregate stddev on columns */
export type Netsuite_Currency_Rate_Stddev_Fields = {
  __typename?: 'netsuite_currency_rate_stddev_fields';
  exchange_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Netsuite_Currency_Rate_Stddev_Pop_Fields = {
  __typename?: 'netsuite_currency_rate_stddev_pop_fields';
  exchange_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Netsuite_Currency_Rate_Stddev_Samp_Fields = {
  __typename?: 'netsuite_currency_rate_stddev_samp_fields';
  exchange_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "netsuite_currency_rate" */
export type Netsuite_Currency_Rate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Netsuite_Currency_Rate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Netsuite_Currency_Rate_Stream_Cursor_Value_Input = {
  base_symbol?: InputMaybe<Scalars['String']>;
  effective_date?: InputMaybe<Scalars['date']>;
  exchange_rate?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['numeric']>;
  transaction_symbol?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Netsuite_Currency_Rate_Sum_Fields = {
  __typename?: 'netsuite_currency_rate_sum_fields';
  exchange_rate?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Netsuite_Currency_Rate_Var_Pop_Fields = {
  __typename?: 'netsuite_currency_rate_var_pop_fields';
  exchange_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Netsuite_Currency_Rate_Var_Samp_Fields = {
  __typename?: 'netsuite_currency_rate_var_samp_fields';
  exchange_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Netsuite_Currency_Rate_Variance_Fields = {
  __typename?: 'netsuite_currency_rate_variance_fields';
  exchange_rate?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "netsuite_receipt" */
export type Netsuite_Receipt = {
  __typename?: 'netsuite_receipt';
  applied_amount?: Maybe<Scalars['numeric']>;
  applied_amount_usd?: Maybe<Scalars['numeric']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  memo?: Maybe<Scalars['String']>;
  netsuite_customer_id?: Maybe<Scalars['numeric']>;
  netsuite_id: Scalars['numeric'];
  /** An array relationship */
  netsuite_receipt_lines: Array<Netsuite_Receipt_Line>;
  /** An aggregate relationship */
  netsuite_receipt_lines_aggregate: Netsuite_Receipt_Line_Aggregate;
  receipt_no?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_usd?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  unapplied_amount?: Maybe<Scalars['numeric']>;
  unapplied_amount_usd?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "netsuite_receipt" */
export type Netsuite_ReceiptNetsuite_Receipt_LinesArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Receipt_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Receipt_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Receipt_Line_Bool_Exp>;
};


/** columns and relationships of "netsuite_receipt" */
export type Netsuite_ReceiptNetsuite_Receipt_Lines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Receipt_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Receipt_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Receipt_Line_Bool_Exp>;
};

/** aggregated selection of "netsuite_receipt" */
export type Netsuite_Receipt_Aggregate = {
  __typename?: 'netsuite_receipt_aggregate';
  aggregate?: Maybe<Netsuite_Receipt_Aggregate_Fields>;
  nodes: Array<Netsuite_Receipt>;
};

export type Netsuite_Receipt_Aggregate_Bool_Exp = {
  count?: InputMaybe<Netsuite_Receipt_Aggregate_Bool_Exp_Count>;
};

export type Netsuite_Receipt_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Netsuite_Receipt_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Netsuite_Receipt_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "netsuite_receipt" */
export type Netsuite_Receipt_Aggregate_Fields = {
  __typename?: 'netsuite_receipt_aggregate_fields';
  avg?: Maybe<Netsuite_Receipt_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Netsuite_Receipt_Max_Fields>;
  min?: Maybe<Netsuite_Receipt_Min_Fields>;
  stddev?: Maybe<Netsuite_Receipt_Stddev_Fields>;
  stddev_pop?: Maybe<Netsuite_Receipt_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Netsuite_Receipt_Stddev_Samp_Fields>;
  sum?: Maybe<Netsuite_Receipt_Sum_Fields>;
  var_pop?: Maybe<Netsuite_Receipt_Var_Pop_Fields>;
  var_samp?: Maybe<Netsuite_Receipt_Var_Samp_Fields>;
  variance?: Maybe<Netsuite_Receipt_Variance_Fields>;
};


/** aggregate fields of "netsuite_receipt" */
export type Netsuite_Receipt_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Netsuite_Receipt_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "netsuite_receipt" */
export type Netsuite_Receipt_Aggregate_Order_By = {
  avg?: InputMaybe<Netsuite_Receipt_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Netsuite_Receipt_Max_Order_By>;
  min?: InputMaybe<Netsuite_Receipt_Min_Order_By>;
  stddev?: InputMaybe<Netsuite_Receipt_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Netsuite_Receipt_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Netsuite_Receipt_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Netsuite_Receipt_Sum_Order_By>;
  var_pop?: InputMaybe<Netsuite_Receipt_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Netsuite_Receipt_Var_Samp_Order_By>;
  variance?: InputMaybe<Netsuite_Receipt_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Netsuite_Receipt_Avg_Fields = {
  __typename?: 'netsuite_receipt_avg_fields';
  applied_amount?: Maybe<Scalars['Float']>;
  applied_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_amount_usd?: Maybe<Scalars['Float']>;
  unapplied_amount?: Maybe<Scalars['Float']>;
  unapplied_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "netsuite_receipt" */
export type Netsuite_Receipt_Avg_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  applied_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_amount_usd?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
  unapplied_amount_usd?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "netsuite_receipt". All fields are combined with a logical 'AND'. */
export type Netsuite_Receipt_Bool_Exp = {
  _and?: InputMaybe<Array<Netsuite_Receipt_Bool_Exp>>;
  _not?: InputMaybe<Netsuite_Receipt_Bool_Exp>;
  _or?: InputMaybe<Array<Netsuite_Receipt_Bool_Exp>>;
  applied_amount?: InputMaybe<Numeric_Comparison_Exp>;
  applied_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  memo?: InputMaybe<String_Comparison_Exp>;
  netsuite_customer_id?: InputMaybe<Numeric_Comparison_Exp>;
  netsuite_id?: InputMaybe<Numeric_Comparison_Exp>;
  netsuite_receipt_lines?: InputMaybe<Netsuite_Receipt_Line_Bool_Exp>;
  netsuite_receipt_lines_aggregate?: InputMaybe<Netsuite_Receipt_Line_Aggregate_Bool_Exp>;
  receipt_no?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  total_amount?: InputMaybe<Numeric_Comparison_Exp>;
  total_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  unapplied_amount?: InputMaybe<Numeric_Comparison_Exp>;
  unapplied_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "netsuite_receipt_line" */
export type Netsuite_Receipt_Line = {
  __typename?: 'netsuite_receipt_line';
  amount_due?: Maybe<Scalars['numeric']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  /** An object relationship */
  netsuite_receipt?: Maybe<Netsuite_Receipt>;
  netsuite_receipt_id?: Maybe<Scalars['numeric']>;
  netsuite_receipt_line_id: Scalars['numeric'];
  netsuite_transaction_id?: Maybe<Scalars['String']>;
  original_amount?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
  receipt_id: Scalars['uuid'];
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Aggregate = {
  __typename?: 'netsuite_receipt_line_aggregate';
  aggregate?: Maybe<Netsuite_Receipt_Line_Aggregate_Fields>;
  nodes: Array<Netsuite_Receipt_Line>;
};

export type Netsuite_Receipt_Line_Aggregate_Bool_Exp = {
  count?: InputMaybe<Netsuite_Receipt_Line_Aggregate_Bool_Exp_Count>;
};

export type Netsuite_Receipt_Line_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Netsuite_Receipt_Line_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Netsuite_Receipt_Line_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Aggregate_Fields = {
  __typename?: 'netsuite_receipt_line_aggregate_fields';
  avg?: Maybe<Netsuite_Receipt_Line_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Netsuite_Receipt_Line_Max_Fields>;
  min?: Maybe<Netsuite_Receipt_Line_Min_Fields>;
  stddev?: Maybe<Netsuite_Receipt_Line_Stddev_Fields>;
  stddev_pop?: Maybe<Netsuite_Receipt_Line_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Netsuite_Receipt_Line_Stddev_Samp_Fields>;
  sum?: Maybe<Netsuite_Receipt_Line_Sum_Fields>;
  var_pop?: Maybe<Netsuite_Receipt_Line_Var_Pop_Fields>;
  var_samp?: Maybe<Netsuite_Receipt_Line_Var_Samp_Fields>;
  variance?: Maybe<Netsuite_Receipt_Line_Variance_Fields>;
};


/** aggregate fields of "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Netsuite_Receipt_Line_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Aggregate_Order_By = {
  avg?: InputMaybe<Netsuite_Receipt_Line_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Netsuite_Receipt_Line_Max_Order_By>;
  min?: InputMaybe<Netsuite_Receipt_Line_Min_Order_By>;
  stddev?: InputMaybe<Netsuite_Receipt_Line_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Netsuite_Receipt_Line_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Netsuite_Receipt_Line_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Netsuite_Receipt_Line_Sum_Order_By>;
  var_pop?: InputMaybe<Netsuite_Receipt_Line_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Netsuite_Receipt_Line_Var_Samp_Order_By>;
  variance?: InputMaybe<Netsuite_Receipt_Line_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Netsuite_Receipt_Line_Avg_Fields = {
  __typename?: 'netsuite_receipt_line_avg_fields';
  amount_due?: Maybe<Scalars['Float']>;
  netsuite_receipt_id?: Maybe<Scalars['Float']>;
  netsuite_receipt_line_id?: Maybe<Scalars['Float']>;
  original_amount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Avg_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  netsuite_receipt_id?: InputMaybe<Order_By>;
  netsuite_receipt_line_id?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "netsuite_receipt_line". All fields are combined with a logical 'AND'. */
export type Netsuite_Receipt_Line_Bool_Exp = {
  _and?: InputMaybe<Array<Netsuite_Receipt_Line_Bool_Exp>>;
  _not?: InputMaybe<Netsuite_Receipt_Line_Bool_Exp>;
  _or?: InputMaybe<Array<Netsuite_Receipt_Line_Bool_Exp>>;
  amount_due?: InputMaybe<Numeric_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  netsuite_receipt?: InputMaybe<Netsuite_Receipt_Bool_Exp>;
  netsuite_receipt_id?: InputMaybe<Numeric_Comparison_Exp>;
  netsuite_receipt_line_id?: InputMaybe<Numeric_Comparison_Exp>;
  netsuite_transaction_id?: InputMaybe<String_Comparison_Exp>;
  original_amount?: InputMaybe<Numeric_Comparison_Exp>;
  payment?: InputMaybe<Numeric_Comparison_Exp>;
  receipt_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Netsuite_Receipt_Line_Max_Fields = {
  __typename?: 'netsuite_receipt_line_max_fields';
  amount_due?: Maybe<Scalars['numeric']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  netsuite_receipt_id?: Maybe<Scalars['numeric']>;
  netsuite_receipt_line_id?: Maybe<Scalars['numeric']>;
  netsuite_transaction_id?: Maybe<Scalars['String']>;
  original_amount?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
  receipt_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Max_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  netsuite_receipt_id?: InputMaybe<Order_By>;
  netsuite_receipt_line_id?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Netsuite_Receipt_Line_Min_Fields = {
  __typename?: 'netsuite_receipt_line_min_fields';
  amount_due?: Maybe<Scalars['numeric']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  netsuite_receipt_id?: Maybe<Scalars['numeric']>;
  netsuite_receipt_line_id?: Maybe<Scalars['numeric']>;
  netsuite_transaction_id?: Maybe<Scalars['String']>;
  original_amount?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
  receipt_id?: Maybe<Scalars['uuid']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Min_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  netsuite_receipt_id?: InputMaybe<Order_By>;
  netsuite_receipt_line_id?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "netsuite_receipt_line". */
export type Netsuite_Receipt_Line_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  netsuite_receipt?: InputMaybe<Netsuite_Receipt_Order_By>;
  netsuite_receipt_id?: InputMaybe<Order_By>;
  netsuite_receipt_line_id?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
  receipt_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "netsuite_receipt_line" */
export enum Netsuite_Receipt_Line_Select_Column {
  /** column name */
  AmountDue = 'amount_due',
  /** column name */
  Currency = 'currency',
  /** column name */
  Date = 'date',
  /** column name */
  NetsuiteReceiptId = 'netsuite_receipt_id',
  /** column name */
  NetsuiteReceiptLineId = 'netsuite_receipt_line_id',
  /** column name */
  NetsuiteTransactionId = 'netsuite_transaction_id',
  /** column name */
  OriginalAmount = 'original_amount',
  /** column name */
  Payment = 'payment',
  /** column name */
  ReceiptId = 'receipt_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Netsuite_Receipt_Line_Stddev_Fields = {
  __typename?: 'netsuite_receipt_line_stddev_fields';
  amount_due?: Maybe<Scalars['Float']>;
  netsuite_receipt_id?: Maybe<Scalars['Float']>;
  netsuite_receipt_line_id?: Maybe<Scalars['Float']>;
  original_amount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Stddev_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  netsuite_receipt_id?: InputMaybe<Order_By>;
  netsuite_receipt_line_id?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Netsuite_Receipt_Line_Stddev_Pop_Fields = {
  __typename?: 'netsuite_receipt_line_stddev_pop_fields';
  amount_due?: Maybe<Scalars['Float']>;
  netsuite_receipt_id?: Maybe<Scalars['Float']>;
  netsuite_receipt_line_id?: Maybe<Scalars['Float']>;
  original_amount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Stddev_Pop_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  netsuite_receipt_id?: InputMaybe<Order_By>;
  netsuite_receipt_line_id?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Netsuite_Receipt_Line_Stddev_Samp_Fields = {
  __typename?: 'netsuite_receipt_line_stddev_samp_fields';
  amount_due?: Maybe<Scalars['Float']>;
  netsuite_receipt_id?: Maybe<Scalars['Float']>;
  netsuite_receipt_line_id?: Maybe<Scalars['Float']>;
  original_amount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Stddev_Samp_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  netsuite_receipt_id?: InputMaybe<Order_By>;
  netsuite_receipt_line_id?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Netsuite_Receipt_Line_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Netsuite_Receipt_Line_Stream_Cursor_Value_Input = {
  amount_due?: InputMaybe<Scalars['numeric']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  netsuite_receipt_id?: InputMaybe<Scalars['numeric']>;
  netsuite_receipt_line_id?: InputMaybe<Scalars['numeric']>;
  netsuite_transaction_id?: InputMaybe<Scalars['String']>;
  original_amount?: InputMaybe<Scalars['numeric']>;
  payment?: InputMaybe<Scalars['numeric']>;
  receipt_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Netsuite_Receipt_Line_Sum_Fields = {
  __typename?: 'netsuite_receipt_line_sum_fields';
  amount_due?: Maybe<Scalars['numeric']>;
  netsuite_receipt_id?: Maybe<Scalars['numeric']>;
  netsuite_receipt_line_id?: Maybe<Scalars['numeric']>;
  original_amount?: Maybe<Scalars['numeric']>;
  payment?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Sum_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  netsuite_receipt_id?: InputMaybe<Order_By>;
  netsuite_receipt_line_id?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Netsuite_Receipt_Line_Var_Pop_Fields = {
  __typename?: 'netsuite_receipt_line_var_pop_fields';
  amount_due?: Maybe<Scalars['Float']>;
  netsuite_receipt_id?: Maybe<Scalars['Float']>;
  netsuite_receipt_line_id?: Maybe<Scalars['Float']>;
  original_amount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Var_Pop_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  netsuite_receipt_id?: InputMaybe<Order_By>;
  netsuite_receipt_line_id?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Netsuite_Receipt_Line_Var_Samp_Fields = {
  __typename?: 'netsuite_receipt_line_var_samp_fields';
  amount_due?: Maybe<Scalars['Float']>;
  netsuite_receipt_id?: Maybe<Scalars['Float']>;
  netsuite_receipt_line_id?: Maybe<Scalars['Float']>;
  original_amount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Var_Samp_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  netsuite_receipt_id?: InputMaybe<Order_By>;
  netsuite_receipt_line_id?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Netsuite_Receipt_Line_Variance_Fields = {
  __typename?: 'netsuite_receipt_line_variance_fields';
  amount_due?: Maybe<Scalars['Float']>;
  netsuite_receipt_id?: Maybe<Scalars['Float']>;
  netsuite_receipt_line_id?: Maybe<Scalars['Float']>;
  original_amount?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "netsuite_receipt_line" */
export type Netsuite_Receipt_Line_Variance_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  netsuite_receipt_id?: InputMaybe<Order_By>;
  netsuite_receipt_line_id?: InputMaybe<Order_By>;
  original_amount?: InputMaybe<Order_By>;
  payment?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Netsuite_Receipt_Max_Fields = {
  __typename?: 'netsuite_receipt_max_fields';
  applied_amount?: Maybe<Scalars['numeric']>;
  applied_amount_usd?: Maybe<Scalars['numeric']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  memo?: Maybe<Scalars['String']>;
  netsuite_customer_id?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  receipt_no?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_usd?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  unapplied_amount?: Maybe<Scalars['numeric']>;
  unapplied_amount_usd?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "netsuite_receipt" */
export type Netsuite_Receipt_Max_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  applied_amount_usd?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  memo?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  receipt_no?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_amount_usd?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
  unapplied_amount_usd?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Netsuite_Receipt_Min_Fields = {
  __typename?: 'netsuite_receipt_min_fields';
  applied_amount?: Maybe<Scalars['numeric']>;
  applied_amount_usd?: Maybe<Scalars['numeric']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  memo?: Maybe<Scalars['String']>;
  netsuite_customer_id?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  receipt_no?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_usd?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  unapplied_amount?: Maybe<Scalars['numeric']>;
  unapplied_amount_usd?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "netsuite_receipt" */
export type Netsuite_Receipt_Min_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  applied_amount_usd?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  memo?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  receipt_no?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_amount_usd?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
  unapplied_amount_usd?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "netsuite_receipt". */
export type Netsuite_Receipt_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  applied_amount_usd?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  memo?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  netsuite_receipt_lines_aggregate?: InputMaybe<Netsuite_Receipt_Line_Aggregate_Order_By>;
  receipt_no?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_amount_usd?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
  unapplied_amount_usd?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "netsuite_receipt" */
export enum Netsuite_Receipt_Select_Column {
  /** column name */
  AppliedAmount = 'applied_amount',
  /** column name */
  AppliedAmountUsd = 'applied_amount_usd',
  /** column name */
  Currency = 'currency',
  /** column name */
  Date = 'date',
  /** column name */
  Memo = 'memo',
  /** column name */
  NetsuiteCustomerId = 'netsuite_customer_id',
  /** column name */
  NetsuiteId = 'netsuite_id',
  /** column name */
  ReceiptNo = 'receipt_no',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TotalAmountUsd = 'total_amount_usd',
  /** column name */
  Type = 'type',
  /** column name */
  UnappliedAmount = 'unapplied_amount',
  /** column name */
  UnappliedAmountUsd = 'unapplied_amount_usd',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Netsuite_Receipt_Stddev_Fields = {
  __typename?: 'netsuite_receipt_stddev_fields';
  applied_amount?: Maybe<Scalars['Float']>;
  applied_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_amount_usd?: Maybe<Scalars['Float']>;
  unapplied_amount?: Maybe<Scalars['Float']>;
  unapplied_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "netsuite_receipt" */
export type Netsuite_Receipt_Stddev_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  applied_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_amount_usd?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
  unapplied_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Netsuite_Receipt_Stddev_Pop_Fields = {
  __typename?: 'netsuite_receipt_stddev_pop_fields';
  applied_amount?: Maybe<Scalars['Float']>;
  applied_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_amount_usd?: Maybe<Scalars['Float']>;
  unapplied_amount?: Maybe<Scalars['Float']>;
  unapplied_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "netsuite_receipt" */
export type Netsuite_Receipt_Stddev_Pop_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  applied_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_amount_usd?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
  unapplied_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Netsuite_Receipt_Stddev_Samp_Fields = {
  __typename?: 'netsuite_receipt_stddev_samp_fields';
  applied_amount?: Maybe<Scalars['Float']>;
  applied_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_amount_usd?: Maybe<Scalars['Float']>;
  unapplied_amount?: Maybe<Scalars['Float']>;
  unapplied_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "netsuite_receipt" */
export type Netsuite_Receipt_Stddev_Samp_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  applied_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_amount_usd?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
  unapplied_amount_usd?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "netsuite_receipt" */
export type Netsuite_Receipt_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Netsuite_Receipt_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Netsuite_Receipt_Stream_Cursor_Value_Input = {
  applied_amount?: InputMaybe<Scalars['numeric']>;
  applied_amount_usd?: InputMaybe<Scalars['numeric']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  memo?: InputMaybe<Scalars['String']>;
  netsuite_customer_id?: InputMaybe<Scalars['numeric']>;
  netsuite_id?: InputMaybe<Scalars['numeric']>;
  receipt_no?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  total_amount?: InputMaybe<Scalars['numeric']>;
  total_amount_usd?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
  unapplied_amount?: InputMaybe<Scalars['numeric']>;
  unapplied_amount_usd?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Netsuite_Receipt_Sum_Fields = {
  __typename?: 'netsuite_receipt_sum_fields';
  applied_amount?: Maybe<Scalars['numeric']>;
  applied_amount_usd?: Maybe<Scalars['numeric']>;
  netsuite_customer_id?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  total_amount?: Maybe<Scalars['numeric']>;
  total_amount_usd?: Maybe<Scalars['numeric']>;
  unapplied_amount?: Maybe<Scalars['numeric']>;
  unapplied_amount_usd?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "netsuite_receipt" */
export type Netsuite_Receipt_Sum_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  applied_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_amount_usd?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
  unapplied_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Netsuite_Receipt_Var_Pop_Fields = {
  __typename?: 'netsuite_receipt_var_pop_fields';
  applied_amount?: Maybe<Scalars['Float']>;
  applied_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_amount_usd?: Maybe<Scalars['Float']>;
  unapplied_amount?: Maybe<Scalars['Float']>;
  unapplied_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "netsuite_receipt" */
export type Netsuite_Receipt_Var_Pop_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  applied_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_amount_usd?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
  unapplied_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Netsuite_Receipt_Var_Samp_Fields = {
  __typename?: 'netsuite_receipt_var_samp_fields';
  applied_amount?: Maybe<Scalars['Float']>;
  applied_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_amount_usd?: Maybe<Scalars['Float']>;
  unapplied_amount?: Maybe<Scalars['Float']>;
  unapplied_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "netsuite_receipt" */
export type Netsuite_Receipt_Var_Samp_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  applied_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_amount_usd?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
  unapplied_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Netsuite_Receipt_Variance_Fields = {
  __typename?: 'netsuite_receipt_variance_fields';
  applied_amount?: Maybe<Scalars['Float']>;
  applied_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  total_amount?: Maybe<Scalars['Float']>;
  total_amount_usd?: Maybe<Scalars['Float']>;
  unapplied_amount?: Maybe<Scalars['Float']>;
  unapplied_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "netsuite_receipt" */
export type Netsuite_Receipt_Variance_Order_By = {
  applied_amount?: InputMaybe<Order_By>;
  applied_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  total_amount_usd?: InputMaybe<Order_By>;
  unapplied_amount?: InputMaybe<Order_By>;
  unapplied_amount_usd?: InputMaybe<Order_By>;
};

/** columns and relationships of "netsuite_tax" */
export type Netsuite_Tax = {
  __typename?: 'netsuite_tax';
  name?: Maybe<Scalars['String']>;
  net_amount?: Maybe<Scalars['numeric']>;
  netsuite_id: Scalars['String'];
  netsuite_transaction_id?: Maybe<Scalars['String']>;
  netsuite_transaction_line_id?: Maybe<Scalars['String']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_basis?: Maybe<Scalars['numeric']>;
  tax_code?: Maybe<Scalars['String']>;
  tax_detail_reference?: Maybe<Scalars['String']>;
  tax_details?: Maybe<Scalars['String']>;
  tax_rate?: Maybe<Scalars['String']>;
  tax_type?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "netsuite_tax" */
export type Netsuite_Tax_Aggregate = {
  __typename?: 'netsuite_tax_aggregate';
  aggregate?: Maybe<Netsuite_Tax_Aggregate_Fields>;
  nodes: Array<Netsuite_Tax>;
};

export type Netsuite_Tax_Aggregate_Bool_Exp = {
  count?: InputMaybe<Netsuite_Tax_Aggregate_Bool_Exp_Count>;
};

export type Netsuite_Tax_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Netsuite_Tax_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Netsuite_Tax_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "netsuite_tax" */
export type Netsuite_Tax_Aggregate_Fields = {
  __typename?: 'netsuite_tax_aggregate_fields';
  avg?: Maybe<Netsuite_Tax_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Netsuite_Tax_Max_Fields>;
  min?: Maybe<Netsuite_Tax_Min_Fields>;
  stddev?: Maybe<Netsuite_Tax_Stddev_Fields>;
  stddev_pop?: Maybe<Netsuite_Tax_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Netsuite_Tax_Stddev_Samp_Fields>;
  sum?: Maybe<Netsuite_Tax_Sum_Fields>;
  var_pop?: Maybe<Netsuite_Tax_Var_Pop_Fields>;
  var_samp?: Maybe<Netsuite_Tax_Var_Samp_Fields>;
  variance?: Maybe<Netsuite_Tax_Variance_Fields>;
};


/** aggregate fields of "netsuite_tax" */
export type Netsuite_Tax_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Netsuite_Tax_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "netsuite_tax" */
export type Netsuite_Tax_Aggregate_Order_By = {
  avg?: InputMaybe<Netsuite_Tax_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Netsuite_Tax_Max_Order_By>;
  min?: InputMaybe<Netsuite_Tax_Min_Order_By>;
  stddev?: InputMaybe<Netsuite_Tax_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Netsuite_Tax_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Netsuite_Tax_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Netsuite_Tax_Sum_Order_By>;
  var_pop?: InputMaybe<Netsuite_Tax_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Netsuite_Tax_Var_Samp_Order_By>;
  variance?: InputMaybe<Netsuite_Tax_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Netsuite_Tax_Avg_Fields = {
  __typename?: 'netsuite_tax_avg_fields';
  net_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_basis?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "netsuite_tax" */
export type Netsuite_Tax_Avg_Order_By = {
  net_amount?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_basis?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "netsuite_tax". All fields are combined with a logical 'AND'. */
export type Netsuite_Tax_Bool_Exp = {
  _and?: InputMaybe<Array<Netsuite_Tax_Bool_Exp>>;
  _not?: InputMaybe<Netsuite_Tax_Bool_Exp>;
  _or?: InputMaybe<Array<Netsuite_Tax_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  net_amount?: InputMaybe<Numeric_Comparison_Exp>;
  netsuite_id?: InputMaybe<String_Comparison_Exp>;
  netsuite_transaction_id?: InputMaybe<String_Comparison_Exp>;
  netsuite_transaction_line_id?: InputMaybe<String_Comparison_Exp>;
  tax_amount?: InputMaybe<Numeric_Comparison_Exp>;
  tax_basis?: InputMaybe<Numeric_Comparison_Exp>;
  tax_code?: InputMaybe<String_Comparison_Exp>;
  tax_detail_reference?: InputMaybe<String_Comparison_Exp>;
  tax_details?: InputMaybe<String_Comparison_Exp>;
  tax_rate?: InputMaybe<String_Comparison_Exp>;
  tax_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Netsuite_Tax_Max_Fields = {
  __typename?: 'netsuite_tax_max_fields';
  name?: Maybe<Scalars['String']>;
  net_amount?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['String']>;
  netsuite_transaction_id?: Maybe<Scalars['String']>;
  netsuite_transaction_line_id?: Maybe<Scalars['String']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_basis?: Maybe<Scalars['numeric']>;
  tax_code?: Maybe<Scalars['String']>;
  tax_detail_reference?: Maybe<Scalars['String']>;
  tax_details?: Maybe<Scalars['String']>;
  tax_rate?: Maybe<Scalars['String']>;
  tax_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "netsuite_tax" */
export type Netsuite_Tax_Max_Order_By = {
  name?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  netsuite_transaction_line_id?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_basis?: InputMaybe<Order_By>;
  tax_code?: InputMaybe<Order_By>;
  tax_detail_reference?: InputMaybe<Order_By>;
  tax_details?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
  tax_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Netsuite_Tax_Min_Fields = {
  __typename?: 'netsuite_tax_min_fields';
  name?: Maybe<Scalars['String']>;
  net_amount?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['String']>;
  netsuite_transaction_id?: Maybe<Scalars['String']>;
  netsuite_transaction_line_id?: Maybe<Scalars['String']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_basis?: Maybe<Scalars['numeric']>;
  tax_code?: Maybe<Scalars['String']>;
  tax_detail_reference?: Maybe<Scalars['String']>;
  tax_details?: Maybe<Scalars['String']>;
  tax_rate?: Maybe<Scalars['String']>;
  tax_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "netsuite_tax" */
export type Netsuite_Tax_Min_Order_By = {
  name?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  netsuite_transaction_line_id?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_basis?: InputMaybe<Order_By>;
  tax_code?: InputMaybe<Order_By>;
  tax_detail_reference?: InputMaybe<Order_By>;
  tax_details?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
  tax_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "netsuite_tax". */
export type Netsuite_Tax_Order_By = {
  name?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  netsuite_transaction_line_id?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_basis?: InputMaybe<Order_By>;
  tax_code?: InputMaybe<Order_By>;
  tax_detail_reference?: InputMaybe<Order_By>;
  tax_details?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
  tax_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "netsuite_tax" */
export enum Netsuite_Tax_Select_Column {
  /** column name */
  Name = 'name',
  /** column name */
  NetAmount = 'net_amount',
  /** column name */
  NetsuiteId = 'netsuite_id',
  /** column name */
  NetsuiteTransactionId = 'netsuite_transaction_id',
  /** column name */
  NetsuiteTransactionLineId = 'netsuite_transaction_line_id',
  /** column name */
  TaxAmount = 'tax_amount',
  /** column name */
  TaxBasis = 'tax_basis',
  /** column name */
  TaxCode = 'tax_code',
  /** column name */
  TaxDetailReference = 'tax_detail_reference',
  /** column name */
  TaxDetails = 'tax_details',
  /** column name */
  TaxRate = 'tax_rate',
  /** column name */
  TaxType = 'tax_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Netsuite_Tax_Stddev_Fields = {
  __typename?: 'netsuite_tax_stddev_fields';
  net_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_basis?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "netsuite_tax" */
export type Netsuite_Tax_Stddev_Order_By = {
  net_amount?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_basis?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Netsuite_Tax_Stddev_Pop_Fields = {
  __typename?: 'netsuite_tax_stddev_pop_fields';
  net_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_basis?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "netsuite_tax" */
export type Netsuite_Tax_Stddev_Pop_Order_By = {
  net_amount?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_basis?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Netsuite_Tax_Stddev_Samp_Fields = {
  __typename?: 'netsuite_tax_stddev_samp_fields';
  net_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_basis?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "netsuite_tax" */
export type Netsuite_Tax_Stddev_Samp_Order_By = {
  net_amount?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_basis?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "netsuite_tax" */
export type Netsuite_Tax_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Netsuite_Tax_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Netsuite_Tax_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
  net_amount?: InputMaybe<Scalars['numeric']>;
  netsuite_id?: InputMaybe<Scalars['String']>;
  netsuite_transaction_id?: InputMaybe<Scalars['String']>;
  netsuite_transaction_line_id?: InputMaybe<Scalars['String']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  tax_basis?: InputMaybe<Scalars['numeric']>;
  tax_code?: InputMaybe<Scalars['String']>;
  tax_detail_reference?: InputMaybe<Scalars['String']>;
  tax_details?: InputMaybe<Scalars['String']>;
  tax_rate?: InputMaybe<Scalars['String']>;
  tax_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Netsuite_Tax_Sum_Fields = {
  __typename?: 'netsuite_tax_sum_fields';
  net_amount?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_basis?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "netsuite_tax" */
export type Netsuite_Tax_Sum_Order_By = {
  net_amount?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_basis?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Netsuite_Tax_Var_Pop_Fields = {
  __typename?: 'netsuite_tax_var_pop_fields';
  net_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_basis?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "netsuite_tax" */
export type Netsuite_Tax_Var_Pop_Order_By = {
  net_amount?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_basis?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Netsuite_Tax_Var_Samp_Fields = {
  __typename?: 'netsuite_tax_var_samp_fields';
  net_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_basis?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "netsuite_tax" */
export type Netsuite_Tax_Var_Samp_Order_By = {
  net_amount?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_basis?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Netsuite_Tax_Variance_Fields = {
  __typename?: 'netsuite_tax_variance_fields';
  net_amount?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_basis?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "netsuite_tax" */
export type Netsuite_Tax_Variance_Order_By = {
  net_amount?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_basis?: InputMaybe<Order_By>;
};

/** columns and relationships of "netsuite_transaction" */
export type Netsuite_Transaction = {
  __typename?: 'netsuite_transaction';
  amount_due?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "amount_due_in_native_currency" */
  amount_due_in_native_currency?: Maybe<Scalars['numeric']>;
  amount_due_usd?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "amount_in_native_currency" */
  amount_in_native_currency?: Maybe<Scalars['numeric']>;
  billing_period?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  /** An object relationship */
  customer?: Maybe<Customer>;
  due_date?: Maybe<Scalars['date']>;
  initial_term?: Maybe<Scalars['String']>;
  invoice_amount?: Maybe<Scalars['numeric']>;
  invoice_amount_usd?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  lines: Array<Netsuite_Transaction_Line>;
  /** An aggregate relationship */
  lines_aggregate: Netsuite_Transaction_Line_Aggregate;
  netsuite_created_at?: Maybe<Scalars['timestamptz']>;
  netsuite_customer_id?: Maybe<Scalars['numeric']>;
  netsuite_id: Scalars['numeric'];
  netsuite_updated_at?: Maybe<Scalars['timestamptz']>;
  paid_date?: Maybe<Scalars['date']>;
  payment_status?: Maybe<Scalars['String']>;
  payment_terms?: Maybe<Scalars['String']>;
  renewal_date?: Maybe<Scalars['date']>;
  root_cause_reason?: Maybe<Scalars['String']>;
  /** An object relationship */
  salesforce_invoice?: Maybe<Invoice>;
  so_po_reference_number?: Maybe<Scalars['String']>;
  sub_status?: Maybe<Scalars['String']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
  transaction_date?: Maybe<Scalars['date']>;
  transaction_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "netsuite_transaction" */
export type Netsuite_TransactionLinesArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Transaction_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Transaction_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Transaction_Line_Bool_Exp>;
};


/** columns and relationships of "netsuite_transaction" */
export type Netsuite_TransactionLines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Transaction_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Transaction_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Transaction_Line_Bool_Exp>;
};

/** aggregated selection of "netsuite_transaction" */
export type Netsuite_Transaction_Aggregate = {
  __typename?: 'netsuite_transaction_aggregate';
  aggregate?: Maybe<Netsuite_Transaction_Aggregate_Fields>;
  nodes: Array<Netsuite_Transaction>;
};

export type Netsuite_Transaction_Aggregate_Bool_Exp = {
  count?: InputMaybe<Netsuite_Transaction_Aggregate_Bool_Exp_Count>;
};

export type Netsuite_Transaction_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Netsuite_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Netsuite_Transaction_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "netsuite_transaction" */
export type Netsuite_Transaction_Aggregate_Fields = {
  __typename?: 'netsuite_transaction_aggregate_fields';
  avg?: Maybe<Netsuite_Transaction_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Netsuite_Transaction_Max_Fields>;
  min?: Maybe<Netsuite_Transaction_Min_Fields>;
  stddev?: Maybe<Netsuite_Transaction_Stddev_Fields>;
  stddev_pop?: Maybe<Netsuite_Transaction_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Netsuite_Transaction_Stddev_Samp_Fields>;
  sum?: Maybe<Netsuite_Transaction_Sum_Fields>;
  var_pop?: Maybe<Netsuite_Transaction_Var_Pop_Fields>;
  var_samp?: Maybe<Netsuite_Transaction_Var_Samp_Fields>;
  variance?: Maybe<Netsuite_Transaction_Variance_Fields>;
};


/** aggregate fields of "netsuite_transaction" */
export type Netsuite_Transaction_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Netsuite_Transaction_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "netsuite_transaction" */
export type Netsuite_Transaction_Aggregate_Order_By = {
  avg?: InputMaybe<Netsuite_Transaction_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Netsuite_Transaction_Max_Order_By>;
  min?: InputMaybe<Netsuite_Transaction_Min_Order_By>;
  stddev?: InputMaybe<Netsuite_Transaction_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Netsuite_Transaction_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Netsuite_Transaction_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Netsuite_Transaction_Sum_Order_By>;
  var_pop?: InputMaybe<Netsuite_Transaction_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Netsuite_Transaction_Var_Samp_Order_By>;
  variance?: InputMaybe<Netsuite_Transaction_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Netsuite_Transaction_Avg_Fields = {
  __typename?: 'netsuite_transaction_avg_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_due_usd?: Maybe<Scalars['Float']>;
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "netsuite_transaction" */
export type Netsuite_Transaction_Avg_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "netsuite_transaction". All fields are combined with a logical 'AND'. */
export type Netsuite_Transaction_Bool_Exp = {
  _and?: InputMaybe<Array<Netsuite_Transaction_Bool_Exp>>;
  _not?: InputMaybe<Netsuite_Transaction_Bool_Exp>;
  _or?: InputMaybe<Array<Netsuite_Transaction_Bool_Exp>>;
  amount_due?: InputMaybe<Numeric_Comparison_Exp>;
  amount_due_in_native_currency?: InputMaybe<Numeric_Comparison_Exp>;
  amount_due_usd?: InputMaybe<Numeric_Comparison_Exp>;
  amount_in_native_currency?: InputMaybe<Numeric_Comparison_Exp>;
  billing_period?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  customer?: InputMaybe<Customer_Bool_Exp>;
  due_date?: InputMaybe<Date_Comparison_Exp>;
  initial_term?: InputMaybe<String_Comparison_Exp>;
  invoice_amount?: InputMaybe<Numeric_Comparison_Exp>;
  invoice_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  lines?: InputMaybe<Netsuite_Transaction_Line_Bool_Exp>;
  lines_aggregate?: InputMaybe<Netsuite_Transaction_Line_Aggregate_Bool_Exp>;
  netsuite_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  netsuite_customer_id?: InputMaybe<Numeric_Comparison_Exp>;
  netsuite_id?: InputMaybe<Numeric_Comparison_Exp>;
  netsuite_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  paid_date?: InputMaybe<Date_Comparison_Exp>;
  payment_status?: InputMaybe<String_Comparison_Exp>;
  payment_terms?: InputMaybe<String_Comparison_Exp>;
  renewal_date?: InputMaybe<Date_Comparison_Exp>;
  root_cause_reason?: InputMaybe<String_Comparison_Exp>;
  salesforce_invoice?: InputMaybe<Invoice_Bool_Exp>;
  so_po_reference_number?: InputMaybe<String_Comparison_Exp>;
  sub_status?: InputMaybe<String_Comparison_Exp>;
  tax_amount?: InputMaybe<Numeric_Comparison_Exp>;
  tax_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  transaction_date?: InputMaybe<Date_Comparison_Exp>;
  transaction_id?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "netsuite_transaction_line" */
export type Netsuite_Transaction_Line = {
  __typename?: 'netsuite_transaction_line';
  amount?: Maybe<Scalars['numeric']>;
  amount_usd?: Maybe<Scalars['numeric']>;
  billing_type?: Maybe<Scalars['String']>;
  cdpderived_product_id?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  gross_amount?: Maybe<Scalars['numeric']>;
  gross_amount_usd?: Maybe<Scalars['numeric']>;
  netsuite_id: Scalars['String'];
  /** An array relationship */
  netsuite_taxes: Array<Netsuite_Tax>;
  /** An aggregate relationship */
  netsuite_taxes_aggregate: Netsuite_Tax_Aggregate;
  netsuite_transaction_id?: Maybe<Scalars['numeric']>;
  netsuite_updated_at?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "ns_line_amount_in_native_currency" */
  ns_line_amount_in_native_currency?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "ns_line_gross_amount_in_native_currency" */
  ns_line_gross_amount_in_native_currency?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "ns_revenue_type" */
  ns_revenue_type?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  /** An object relationship */
  product?: Maybe<Product>;
  product_code?: Maybe<Scalars['String']>;
  product_name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  rate?: Maybe<Scalars['numeric']>;
  region?: Maybe<Scalars['String']>;
  revenue_type?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
  tax_code?: Maybe<Scalars['String']>;
  tax_rate?: Maybe<Scalars['numeric']>;
  transaction_line_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "netsuite_transaction_line" */
export type Netsuite_Transaction_LineNetsuite_TaxesArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Tax_Order_By>>;
  where?: InputMaybe<Netsuite_Tax_Bool_Exp>;
};


/** columns and relationships of "netsuite_transaction_line" */
export type Netsuite_Transaction_LineNetsuite_Taxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Tax_Order_By>>;
  where?: InputMaybe<Netsuite_Tax_Bool_Exp>;
};

/** aggregated selection of "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Aggregate = {
  __typename?: 'netsuite_transaction_line_aggregate';
  aggregate?: Maybe<Netsuite_Transaction_Line_Aggregate_Fields>;
  nodes: Array<Netsuite_Transaction_Line>;
};

export type Netsuite_Transaction_Line_Aggregate_Bool_Exp = {
  count?: InputMaybe<Netsuite_Transaction_Line_Aggregate_Bool_Exp_Count>;
};

export type Netsuite_Transaction_Line_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Netsuite_Transaction_Line_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Netsuite_Transaction_Line_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Aggregate_Fields = {
  __typename?: 'netsuite_transaction_line_aggregate_fields';
  avg?: Maybe<Netsuite_Transaction_Line_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Netsuite_Transaction_Line_Max_Fields>;
  min?: Maybe<Netsuite_Transaction_Line_Min_Fields>;
  stddev?: Maybe<Netsuite_Transaction_Line_Stddev_Fields>;
  stddev_pop?: Maybe<Netsuite_Transaction_Line_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Netsuite_Transaction_Line_Stddev_Samp_Fields>;
  sum?: Maybe<Netsuite_Transaction_Line_Sum_Fields>;
  var_pop?: Maybe<Netsuite_Transaction_Line_Var_Pop_Fields>;
  var_samp?: Maybe<Netsuite_Transaction_Line_Var_Samp_Fields>;
  variance?: Maybe<Netsuite_Transaction_Line_Variance_Fields>;
};


/** aggregate fields of "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Netsuite_Transaction_Line_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Aggregate_Order_By = {
  avg?: InputMaybe<Netsuite_Transaction_Line_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Netsuite_Transaction_Line_Max_Order_By>;
  min?: InputMaybe<Netsuite_Transaction_Line_Min_Order_By>;
  stddev?: InputMaybe<Netsuite_Transaction_Line_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Netsuite_Transaction_Line_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Netsuite_Transaction_Line_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Netsuite_Transaction_Line_Sum_Order_By>;
  var_pop?: InputMaybe<Netsuite_Transaction_Line_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Netsuite_Transaction_Line_Var_Samp_Order_By>;
  variance?: InputMaybe<Netsuite_Transaction_Line_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Netsuite_Transaction_Line_Avg_Fields = {
  __typename?: 'netsuite_transaction_line_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  gross_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_transaction_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
  tax_rate?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "netsuite_transaction_line". All fields are combined with a logical 'AND'. */
export type Netsuite_Transaction_Line_Bool_Exp = {
  _and?: InputMaybe<Array<Netsuite_Transaction_Line_Bool_Exp>>;
  _not?: InputMaybe<Netsuite_Transaction_Line_Bool_Exp>;
  _or?: InputMaybe<Array<Netsuite_Transaction_Line_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  billing_type?: InputMaybe<String_Comparison_Exp>;
  cdpderived_product_id?: InputMaybe<String_Comparison_Exp>;
  channel?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  gross_amount?: InputMaybe<Numeric_Comparison_Exp>;
  gross_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  netsuite_id?: InputMaybe<String_Comparison_Exp>;
  netsuite_taxes?: InputMaybe<Netsuite_Tax_Bool_Exp>;
  netsuite_taxes_aggregate?: InputMaybe<Netsuite_Tax_Aggregate_Bool_Exp>;
  netsuite_transaction_id?: InputMaybe<Numeric_Comparison_Exp>;
  netsuite_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ns_line_amount_in_native_currency?: InputMaybe<Numeric_Comparison_Exp>;
  ns_line_gross_amount_in_native_currency?: InputMaybe<Numeric_Comparison_Exp>;
  ns_revenue_type?: InputMaybe<String_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  product_code?: InputMaybe<String_Comparison_Exp>;
  product_name?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Numeric_Comparison_Exp>;
  rate?: InputMaybe<Numeric_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  revenue_type?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  tax_amount?: InputMaybe<Numeric_Comparison_Exp>;
  tax_amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  tax_code?: InputMaybe<String_Comparison_Exp>;
  tax_rate?: InputMaybe<Numeric_Comparison_Exp>;
  transaction_line_date?: InputMaybe<Date_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Netsuite_Transaction_Line_Max_Fields = {
  __typename?: 'netsuite_transaction_line_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_usd?: Maybe<Scalars['numeric']>;
  billing_type?: Maybe<Scalars['String']>;
  cdpderived_product_id?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  gross_amount?: Maybe<Scalars['numeric']>;
  gross_amount_usd?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['String']>;
  netsuite_transaction_id?: Maybe<Scalars['numeric']>;
  netsuite_updated_at?: Maybe<Scalars['timestamptz']>;
  platform?: Maybe<Scalars['String']>;
  product_code?: Maybe<Scalars['String']>;
  product_name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  rate?: Maybe<Scalars['numeric']>;
  region?: Maybe<Scalars['String']>;
  revenue_type?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
  tax_code?: Maybe<Scalars['String']>;
  tax_rate?: Maybe<Scalars['numeric']>;
  transaction_line_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  cdpderived_product_id?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  netsuite_updated_at?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  product_code?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  revenue_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  tax_code?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
  transaction_line_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Netsuite_Transaction_Line_Min_Fields = {
  __typename?: 'netsuite_transaction_line_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_usd?: Maybe<Scalars['numeric']>;
  billing_type?: Maybe<Scalars['String']>;
  cdpderived_product_id?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['date']>;
  gross_amount?: Maybe<Scalars['numeric']>;
  gross_amount_usd?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['String']>;
  netsuite_transaction_id?: Maybe<Scalars['numeric']>;
  netsuite_updated_at?: Maybe<Scalars['timestamptz']>;
  platform?: Maybe<Scalars['String']>;
  product_code?: Maybe<Scalars['String']>;
  product_name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['numeric']>;
  rate?: Maybe<Scalars['numeric']>;
  region?: Maybe<Scalars['String']>;
  revenue_type?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['date']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
  tax_code?: Maybe<Scalars['String']>;
  tax_rate?: Maybe<Scalars['numeric']>;
  transaction_line_date?: Maybe<Scalars['date']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  cdpderived_product_id?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  netsuite_updated_at?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  product_code?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  revenue_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  tax_code?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
  transaction_line_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "netsuite_transaction_line". */
export type Netsuite_Transaction_Line_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  cdpderived_product_id?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  netsuite_taxes_aggregate?: InputMaybe<Netsuite_Tax_Aggregate_Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  netsuite_updated_at?: InputMaybe<Order_By>;
  ns_line_amount_in_native_currency?: InputMaybe<Order_By>;
  ns_line_gross_amount_in_native_currency?: InputMaybe<Order_By>;
  ns_revenue_type?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  product?: InputMaybe<Product_Order_By>;
  product_code?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  revenue_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  tax_code?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
  transaction_line_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "netsuite_transaction_line" */
export enum Netsuite_Transaction_Line_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountUsd = 'amount_usd',
  /** column name */
  BillingType = 'billing_type',
  /** column name */
  CdpderivedProductId = 'cdpderived_product_id',
  /** column name */
  Channel = 'channel',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  GrossAmount = 'gross_amount',
  /** column name */
  GrossAmountUsd = 'gross_amount_usd',
  /** column name */
  NetsuiteId = 'netsuite_id',
  /** column name */
  NetsuiteTransactionId = 'netsuite_transaction_id',
  /** column name */
  NetsuiteUpdatedAt = 'netsuite_updated_at',
  /** column name */
  Platform = 'platform',
  /** column name */
  ProductCode = 'product_code',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Rate = 'rate',
  /** column name */
  Region = 'region',
  /** column name */
  RevenueType = 'revenue_type',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TaxAmount = 'tax_amount',
  /** column name */
  TaxAmountUsd = 'tax_amount_usd',
  /** column name */
  TaxCode = 'tax_code',
  /** column name */
  TaxRate = 'tax_rate',
  /** column name */
  TransactionLineDate = 'transaction_line_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Netsuite_Transaction_Line_Stddev_Fields = {
  __typename?: 'netsuite_transaction_line_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  gross_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_transaction_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
  tax_rate?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Netsuite_Transaction_Line_Stddev_Pop_Fields = {
  __typename?: 'netsuite_transaction_line_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  gross_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_transaction_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
  tax_rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Netsuite_Transaction_Line_Stddev_Samp_Fields = {
  __typename?: 'netsuite_transaction_line_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  gross_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_transaction_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
  tax_rate?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Netsuite_Transaction_Line_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Netsuite_Transaction_Line_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  amount_usd?: InputMaybe<Scalars['numeric']>;
  billing_type?: InputMaybe<Scalars['String']>;
  cdpderived_product_id?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['date']>;
  gross_amount?: InputMaybe<Scalars['numeric']>;
  gross_amount_usd?: InputMaybe<Scalars['numeric']>;
  netsuite_id?: InputMaybe<Scalars['String']>;
  netsuite_transaction_id?: InputMaybe<Scalars['numeric']>;
  netsuite_updated_at?: InputMaybe<Scalars['timestamptz']>;
  platform?: InputMaybe<Scalars['String']>;
  product_code?: InputMaybe<Scalars['String']>;
  product_name?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['numeric']>;
  rate?: InputMaybe<Scalars['numeric']>;
  region?: InputMaybe<Scalars['String']>;
  revenue_type?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['date']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  tax_amount_usd?: InputMaybe<Scalars['numeric']>;
  tax_code?: InputMaybe<Scalars['String']>;
  tax_rate?: InputMaybe<Scalars['numeric']>;
  transaction_line_date?: InputMaybe<Scalars['date']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Netsuite_Transaction_Line_Sum_Fields = {
  __typename?: 'netsuite_transaction_line_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_usd?: Maybe<Scalars['numeric']>;
  gross_amount?: Maybe<Scalars['numeric']>;
  gross_amount_usd?: Maybe<Scalars['numeric']>;
  netsuite_transaction_id?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['numeric']>;
  rate?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
  tax_rate?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Netsuite_Transaction_Line_Var_Pop_Fields = {
  __typename?: 'netsuite_transaction_line_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  gross_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_transaction_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
  tax_rate?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Netsuite_Transaction_Line_Var_Samp_Fields = {
  __typename?: 'netsuite_transaction_line_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  gross_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_transaction_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
  tax_rate?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Netsuite_Transaction_Line_Variance_Fields = {
  __typename?: 'netsuite_transaction_line_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  gross_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_transaction_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
  tax_rate?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "netsuite_transaction_line" */
export type Netsuite_Transaction_Line_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  gross_amount_usd?: InputMaybe<Order_By>;
  netsuite_transaction_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Netsuite_Transaction_Max_Fields = {
  __typename?: 'netsuite_transaction_max_fields';
  amount_due?: Maybe<Scalars['numeric']>;
  amount_due_usd?: Maybe<Scalars['numeric']>;
  billing_period?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  initial_term?: Maybe<Scalars['String']>;
  invoice_amount?: Maybe<Scalars['numeric']>;
  invoice_amount_usd?: Maybe<Scalars['numeric']>;
  netsuite_created_at?: Maybe<Scalars['timestamptz']>;
  netsuite_customer_id?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  netsuite_updated_at?: Maybe<Scalars['timestamptz']>;
  paid_date?: Maybe<Scalars['date']>;
  payment_status?: Maybe<Scalars['String']>;
  payment_terms?: Maybe<Scalars['String']>;
  renewal_date?: Maybe<Scalars['date']>;
  root_cause_reason?: Maybe<Scalars['String']>;
  so_po_reference_number?: Maybe<Scalars['String']>;
  sub_status?: Maybe<Scalars['String']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
  transaction_date?: Maybe<Scalars['date']>;
  transaction_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "netsuite_transaction" */
export type Netsuite_Transaction_Max_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  billing_period?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  initial_term?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  netsuite_created_at?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  netsuite_updated_at?: InputMaybe<Order_By>;
  paid_date?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  renewal_date?: InputMaybe<Order_By>;
  root_cause_reason?: InputMaybe<Order_By>;
  so_po_reference_number?: InputMaybe<Order_By>;
  sub_status?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Netsuite_Transaction_Min_Fields = {
  __typename?: 'netsuite_transaction_min_fields';
  amount_due?: Maybe<Scalars['numeric']>;
  amount_due_usd?: Maybe<Scalars['numeric']>;
  billing_period?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  initial_term?: Maybe<Scalars['String']>;
  invoice_amount?: Maybe<Scalars['numeric']>;
  invoice_amount_usd?: Maybe<Scalars['numeric']>;
  netsuite_created_at?: Maybe<Scalars['timestamptz']>;
  netsuite_customer_id?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  netsuite_updated_at?: Maybe<Scalars['timestamptz']>;
  paid_date?: Maybe<Scalars['date']>;
  payment_status?: Maybe<Scalars['String']>;
  payment_terms?: Maybe<Scalars['String']>;
  renewal_date?: Maybe<Scalars['date']>;
  root_cause_reason?: Maybe<Scalars['String']>;
  so_po_reference_number?: Maybe<Scalars['String']>;
  sub_status?: Maybe<Scalars['String']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
  transaction_date?: Maybe<Scalars['date']>;
  transaction_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "netsuite_transaction" */
export type Netsuite_Transaction_Min_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  billing_period?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  initial_term?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  netsuite_created_at?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  netsuite_updated_at?: InputMaybe<Order_By>;
  paid_date?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  renewal_date?: InputMaybe<Order_By>;
  root_cause_reason?: InputMaybe<Order_By>;
  so_po_reference_number?: InputMaybe<Order_By>;
  sub_status?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "netsuite_transaction". */
export type Netsuite_Transaction_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_in_native_currency?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  amount_in_native_currency?: InputMaybe<Order_By>;
  billing_period?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer?: InputMaybe<Customer_Order_By>;
  due_date?: InputMaybe<Order_By>;
  initial_term?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  lines_aggregate?: InputMaybe<Netsuite_Transaction_Line_Aggregate_Order_By>;
  netsuite_created_at?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  netsuite_updated_at?: InputMaybe<Order_By>;
  paid_date?: InputMaybe<Order_By>;
  payment_status?: InputMaybe<Order_By>;
  payment_terms?: InputMaybe<Order_By>;
  renewal_date?: InputMaybe<Order_By>;
  root_cause_reason?: InputMaybe<Order_By>;
  salesforce_invoice?: InputMaybe<Invoice_Order_By>;
  so_po_reference_number?: InputMaybe<Order_By>;
  sub_status?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "netsuite_transaction" */
export enum Netsuite_Transaction_Select_Column {
  /** column name */
  AmountDue = 'amount_due',
  /** column name */
  AmountDueUsd = 'amount_due_usd',
  /** column name */
  BillingPeriod = 'billing_period',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  InitialTerm = 'initial_term',
  /** column name */
  InvoiceAmount = 'invoice_amount',
  /** column name */
  InvoiceAmountUsd = 'invoice_amount_usd',
  /** column name */
  NetsuiteCreatedAt = 'netsuite_created_at',
  /** column name */
  NetsuiteCustomerId = 'netsuite_customer_id',
  /** column name */
  NetsuiteId = 'netsuite_id',
  /** column name */
  NetsuiteUpdatedAt = 'netsuite_updated_at',
  /** column name */
  PaidDate = 'paid_date',
  /** column name */
  PaymentStatus = 'payment_status',
  /** column name */
  PaymentTerms = 'payment_terms',
  /** column name */
  RenewalDate = 'renewal_date',
  /** column name */
  RootCauseReason = 'root_cause_reason',
  /** column name */
  SoPoReferenceNumber = 'so_po_reference_number',
  /** column name */
  SubStatus = 'sub_status',
  /** column name */
  TaxAmount = 'tax_amount',
  /** column name */
  TaxAmountUsd = 'tax_amount_usd',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Netsuite_Transaction_Stddev_Fields = {
  __typename?: 'netsuite_transaction_stddev_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_due_usd?: Maybe<Scalars['Float']>;
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "netsuite_transaction" */
export type Netsuite_Transaction_Stddev_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Netsuite_Transaction_Stddev_Pop_Fields = {
  __typename?: 'netsuite_transaction_stddev_pop_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_due_usd?: Maybe<Scalars['Float']>;
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "netsuite_transaction" */
export type Netsuite_Transaction_Stddev_Pop_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Netsuite_Transaction_Stddev_Samp_Fields = {
  __typename?: 'netsuite_transaction_stddev_samp_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_due_usd?: Maybe<Scalars['Float']>;
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "netsuite_transaction" */
export type Netsuite_Transaction_Stddev_Samp_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "netsuite_transaction" */
export type Netsuite_Transaction_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Netsuite_Transaction_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Netsuite_Transaction_Stream_Cursor_Value_Input = {
  amount_due?: InputMaybe<Scalars['numeric']>;
  amount_due_usd?: InputMaybe<Scalars['numeric']>;
  billing_period?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  due_date?: InputMaybe<Scalars['date']>;
  initial_term?: InputMaybe<Scalars['String']>;
  invoice_amount?: InputMaybe<Scalars['numeric']>;
  invoice_amount_usd?: InputMaybe<Scalars['numeric']>;
  netsuite_created_at?: InputMaybe<Scalars['timestamptz']>;
  netsuite_customer_id?: InputMaybe<Scalars['numeric']>;
  netsuite_id?: InputMaybe<Scalars['numeric']>;
  netsuite_updated_at?: InputMaybe<Scalars['timestamptz']>;
  paid_date?: InputMaybe<Scalars['date']>;
  payment_status?: InputMaybe<Scalars['String']>;
  payment_terms?: InputMaybe<Scalars['String']>;
  renewal_date?: InputMaybe<Scalars['date']>;
  root_cause_reason?: InputMaybe<Scalars['String']>;
  so_po_reference_number?: InputMaybe<Scalars['String']>;
  sub_status?: InputMaybe<Scalars['String']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  tax_amount_usd?: InputMaybe<Scalars['numeric']>;
  transaction_date?: InputMaybe<Scalars['date']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Netsuite_Transaction_Sum_Fields = {
  __typename?: 'netsuite_transaction_sum_fields';
  amount_due?: Maybe<Scalars['numeric']>;
  amount_due_usd?: Maybe<Scalars['numeric']>;
  invoice_amount?: Maybe<Scalars['numeric']>;
  invoice_amount_usd?: Maybe<Scalars['numeric']>;
  netsuite_customer_id?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_amount_usd?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "netsuite_transaction" */
export type Netsuite_Transaction_Sum_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Netsuite_Transaction_Var_Pop_Fields = {
  __typename?: 'netsuite_transaction_var_pop_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_due_usd?: Maybe<Scalars['Float']>;
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "netsuite_transaction" */
export type Netsuite_Transaction_Var_Pop_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Netsuite_Transaction_Var_Samp_Fields = {
  __typename?: 'netsuite_transaction_var_samp_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_due_usd?: Maybe<Scalars['Float']>;
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "netsuite_transaction" */
export type Netsuite_Transaction_Var_Samp_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Netsuite_Transaction_Variance_Fields = {
  __typename?: 'netsuite_transaction_variance_fields';
  amount_due?: Maybe<Scalars['Float']>;
  amount_due_usd?: Maybe<Scalars['Float']>;
  invoice_amount?: Maybe<Scalars['Float']>;
  invoice_amount_usd?: Maybe<Scalars['Float']>;
  netsuite_customer_id?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  tax_amount_usd?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "netsuite_transaction" */
export type Netsuite_Transaction_Variance_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_due_usd?: InputMaybe<Order_By>;
  invoice_amount?: InputMaybe<Order_By>;
  invoice_amount_usd?: InputMaybe<Order_By>;
  netsuite_customer_id?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_amount_usd?: InputMaybe<Order_By>;
};

/** columns and relationships of "netsuite_vendor_invoice" */
export type Netsuite_Vendor_Invoice = {
  __typename?: 'netsuite_vendor_invoice';
  account?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  amount_usd?: Maybe<Scalars['numeric']>;
  approval_status?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  invoice_creation_date?: Maybe<Scalars['String']>;
  narration?: Maybe<Scalars['String']>;
  netsuite_id: Scalars['numeric'];
  status?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['numeric']>;
  transaction_no?: Maybe<Scalars['String']>;
  transaction_reference_no?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
  vendor_invoice_no?: Maybe<Scalars['String']>;
};

/** aggregated selection of "netsuite_vendor_invoice" */
export type Netsuite_Vendor_Invoice_Aggregate = {
  __typename?: 'netsuite_vendor_invoice_aggregate';
  aggregate?: Maybe<Netsuite_Vendor_Invoice_Aggregate_Fields>;
  nodes: Array<Netsuite_Vendor_Invoice>;
};

/** aggregate fields of "netsuite_vendor_invoice" */
export type Netsuite_Vendor_Invoice_Aggregate_Fields = {
  __typename?: 'netsuite_vendor_invoice_aggregate_fields';
  avg?: Maybe<Netsuite_Vendor_Invoice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Netsuite_Vendor_Invoice_Max_Fields>;
  min?: Maybe<Netsuite_Vendor_Invoice_Min_Fields>;
  stddev?: Maybe<Netsuite_Vendor_Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Netsuite_Vendor_Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Netsuite_Vendor_Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Netsuite_Vendor_Invoice_Sum_Fields>;
  var_pop?: Maybe<Netsuite_Vendor_Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Netsuite_Vendor_Invoice_Var_Samp_Fields>;
  variance?: Maybe<Netsuite_Vendor_Invoice_Variance_Fields>;
};


/** aggregate fields of "netsuite_vendor_invoice" */
export type Netsuite_Vendor_Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Netsuite_Vendor_Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Netsuite_Vendor_Invoice_Avg_Fields = {
  __typename?: 'netsuite_vendor_invoice_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "netsuite_vendor_invoice". All fields are combined with a logical 'AND'. */
export type Netsuite_Vendor_Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Netsuite_Vendor_Invoice_Bool_Exp>>;
  _not?: InputMaybe<Netsuite_Vendor_Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Netsuite_Vendor_Invoice_Bool_Exp>>;
  account?: InputMaybe<String_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  amount_usd?: InputMaybe<Numeric_Comparison_Exp>;
  approval_status?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  due_date?: InputMaybe<Date_Comparison_Exp>;
  invoice_creation_date?: InputMaybe<String_Comparison_Exp>;
  narration?: InputMaybe<String_Comparison_Exp>;
  netsuite_id?: InputMaybe<Numeric_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tax?: InputMaybe<Numeric_Comparison_Exp>;
  transaction_no?: InputMaybe<String_Comparison_Exp>;
  transaction_reference_no?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  vendor?: InputMaybe<String_Comparison_Exp>;
  vendor_invoice_no?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "netsuite_vendor_invoice_expense" */
export type Netsuite_Vendor_Invoice_Expense = {
  __typename?: 'netsuite_vendor_invoice_expense';
  account?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  business_unit?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  gross_amount?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  netsuite_id: Scalars['String'];
  netsuite_vendor_invoice_id?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_details_reference?: Maybe<Scalars['String']>;
};

/** aggregated selection of "netsuite_vendor_invoice_expense" */
export type Netsuite_Vendor_Invoice_Expense_Aggregate = {
  __typename?: 'netsuite_vendor_invoice_expense_aggregate';
  aggregate?: Maybe<Netsuite_Vendor_Invoice_Expense_Aggregate_Fields>;
  nodes: Array<Netsuite_Vendor_Invoice_Expense>;
};

/** aggregate fields of "netsuite_vendor_invoice_expense" */
export type Netsuite_Vendor_Invoice_Expense_Aggregate_Fields = {
  __typename?: 'netsuite_vendor_invoice_expense_aggregate_fields';
  avg?: Maybe<Netsuite_Vendor_Invoice_Expense_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Netsuite_Vendor_Invoice_Expense_Max_Fields>;
  min?: Maybe<Netsuite_Vendor_Invoice_Expense_Min_Fields>;
  stddev?: Maybe<Netsuite_Vendor_Invoice_Expense_Stddev_Fields>;
  stddev_pop?: Maybe<Netsuite_Vendor_Invoice_Expense_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Netsuite_Vendor_Invoice_Expense_Stddev_Samp_Fields>;
  sum?: Maybe<Netsuite_Vendor_Invoice_Expense_Sum_Fields>;
  var_pop?: Maybe<Netsuite_Vendor_Invoice_Expense_Var_Pop_Fields>;
  var_samp?: Maybe<Netsuite_Vendor_Invoice_Expense_Var_Samp_Fields>;
  variance?: Maybe<Netsuite_Vendor_Invoice_Expense_Variance_Fields>;
};


/** aggregate fields of "netsuite_vendor_invoice_expense" */
export type Netsuite_Vendor_Invoice_Expense_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Netsuite_Vendor_Invoice_Expense_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Netsuite_Vendor_Invoice_Expense_Avg_Fields = {
  __typename?: 'netsuite_vendor_invoice_expense_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "netsuite_vendor_invoice_expense". All fields are combined with a logical 'AND'. */
export type Netsuite_Vendor_Invoice_Expense_Bool_Exp = {
  _and?: InputMaybe<Array<Netsuite_Vendor_Invoice_Expense_Bool_Exp>>;
  _not?: InputMaybe<Netsuite_Vendor_Invoice_Expense_Bool_Exp>;
  _or?: InputMaybe<Array<Netsuite_Vendor_Invoice_Expense_Bool_Exp>>;
  account?: InputMaybe<String_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  business_unit?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  department?: InputMaybe<String_Comparison_Exp>;
  frequency?: InputMaybe<String_Comparison_Exp>;
  gross_amount?: InputMaybe<Numeric_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  memo?: InputMaybe<String_Comparison_Exp>;
  netsuite_id?: InputMaybe<String_Comparison_Exp>;
  netsuite_vendor_invoice_id?: InputMaybe<Numeric_Comparison_Exp>;
  tax_amount?: InputMaybe<Numeric_Comparison_Exp>;
  tax_details_reference?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Netsuite_Vendor_Invoice_Expense_Max_Fields = {
  __typename?: 'netsuite_vendor_invoice_expense_max_fields';
  account?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  business_unit?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  gross_amount?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  netsuite_id?: Maybe<Scalars['String']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_details_reference?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Netsuite_Vendor_Invoice_Expense_Min_Fields = {
  __typename?: 'netsuite_vendor_invoice_expense_min_fields';
  account?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  business_unit?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  gross_amount?: Maybe<Scalars['numeric']>;
  location?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  netsuite_id?: Maybe<Scalars['String']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_details_reference?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "netsuite_vendor_invoice_expense". */
export type Netsuite_Vendor_Invoice_Expense_Order_By = {
  account?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  business_unit?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  department?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  gross_amount?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  memo?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  netsuite_vendor_invoice_id?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_details_reference?: InputMaybe<Order_By>;
};

/** select columns of table "netsuite_vendor_invoice_expense" */
export enum Netsuite_Vendor_Invoice_Expense_Select_Column {
  /** column name */
  Account = 'account',
  /** column name */
  Amount = 'amount',
  /** column name */
  BusinessUnit = 'business_unit',
  /** column name */
  Category = 'category',
  /** column name */
  Department = 'department',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  GrossAmount = 'gross_amount',
  /** column name */
  Location = 'location',
  /** column name */
  Memo = 'memo',
  /** column name */
  NetsuiteId = 'netsuite_id',
  /** column name */
  NetsuiteVendorInvoiceId = 'netsuite_vendor_invoice_id',
  /** column name */
  TaxAmount = 'tax_amount',
  /** column name */
  TaxDetailsReference = 'tax_details_reference'
}

/** aggregate stddev on columns */
export type Netsuite_Vendor_Invoice_Expense_Stddev_Fields = {
  __typename?: 'netsuite_vendor_invoice_expense_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Netsuite_Vendor_Invoice_Expense_Stddev_Pop_Fields = {
  __typename?: 'netsuite_vendor_invoice_expense_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Netsuite_Vendor_Invoice_Expense_Stddev_Samp_Fields = {
  __typename?: 'netsuite_vendor_invoice_expense_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "netsuite_vendor_invoice_expense" */
export type Netsuite_Vendor_Invoice_Expense_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Netsuite_Vendor_Invoice_Expense_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Netsuite_Vendor_Invoice_Expense_Stream_Cursor_Value_Input = {
  account?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['numeric']>;
  business_unit?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  gross_amount?: InputMaybe<Scalars['numeric']>;
  location?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  netsuite_id?: InputMaybe<Scalars['String']>;
  netsuite_vendor_invoice_id?: InputMaybe<Scalars['numeric']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  tax_details_reference?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Netsuite_Vendor_Invoice_Expense_Sum_Fields = {
  __typename?: 'netsuite_vendor_invoice_expense_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  gross_amount?: Maybe<Scalars['numeric']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Netsuite_Vendor_Invoice_Expense_Var_Pop_Fields = {
  __typename?: 'netsuite_vendor_invoice_expense_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Netsuite_Vendor_Invoice_Expense_Var_Samp_Fields = {
  __typename?: 'netsuite_vendor_invoice_expense_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Netsuite_Vendor_Invoice_Expense_Variance_Fields = {
  __typename?: 'netsuite_vendor_invoice_expense_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  gross_amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "netsuite_vendor_invoice_line" */
export type Netsuite_Vendor_Invoice_Line = {
  __typename?: 'netsuite_vendor_invoice_line';
  amount?: Maybe<Scalars['numeric']>;
  date?: Maybe<Scalars['date']>;
  netsuite_id: Scalars['String'];
  netsuite_vendor_invoice_id?: Maybe<Scalars['numeric']>;
  number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "netsuite_vendor_invoice_line" */
export type Netsuite_Vendor_Invoice_Line_Aggregate = {
  __typename?: 'netsuite_vendor_invoice_line_aggregate';
  aggregate?: Maybe<Netsuite_Vendor_Invoice_Line_Aggregate_Fields>;
  nodes: Array<Netsuite_Vendor_Invoice_Line>;
};

/** aggregate fields of "netsuite_vendor_invoice_line" */
export type Netsuite_Vendor_Invoice_Line_Aggregate_Fields = {
  __typename?: 'netsuite_vendor_invoice_line_aggregate_fields';
  avg?: Maybe<Netsuite_Vendor_Invoice_Line_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Netsuite_Vendor_Invoice_Line_Max_Fields>;
  min?: Maybe<Netsuite_Vendor_Invoice_Line_Min_Fields>;
  stddev?: Maybe<Netsuite_Vendor_Invoice_Line_Stddev_Fields>;
  stddev_pop?: Maybe<Netsuite_Vendor_Invoice_Line_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Netsuite_Vendor_Invoice_Line_Stddev_Samp_Fields>;
  sum?: Maybe<Netsuite_Vendor_Invoice_Line_Sum_Fields>;
  var_pop?: Maybe<Netsuite_Vendor_Invoice_Line_Var_Pop_Fields>;
  var_samp?: Maybe<Netsuite_Vendor_Invoice_Line_Var_Samp_Fields>;
  variance?: Maybe<Netsuite_Vendor_Invoice_Line_Variance_Fields>;
};


/** aggregate fields of "netsuite_vendor_invoice_line" */
export type Netsuite_Vendor_Invoice_Line_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Netsuite_Vendor_Invoice_Line_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Netsuite_Vendor_Invoice_Line_Avg_Fields = {
  __typename?: 'netsuite_vendor_invoice_line_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "netsuite_vendor_invoice_line". All fields are combined with a logical 'AND'. */
export type Netsuite_Vendor_Invoice_Line_Bool_Exp = {
  _and?: InputMaybe<Array<Netsuite_Vendor_Invoice_Line_Bool_Exp>>;
  _not?: InputMaybe<Netsuite_Vendor_Invoice_Line_Bool_Exp>;
  _or?: InputMaybe<Array<Netsuite_Vendor_Invoice_Line_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  netsuite_id?: InputMaybe<String_Comparison_Exp>;
  netsuite_vendor_invoice_id?: InputMaybe<Numeric_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Netsuite_Vendor_Invoice_Line_Max_Fields = {
  __typename?: 'netsuite_vendor_invoice_line_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  date?: Maybe<Scalars['date']>;
  netsuite_id?: Maybe<Scalars['String']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['numeric']>;
  number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Netsuite_Vendor_Invoice_Line_Min_Fields = {
  __typename?: 'netsuite_vendor_invoice_line_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  date?: Maybe<Scalars['date']>;
  netsuite_id?: Maybe<Scalars['String']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['numeric']>;
  number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "netsuite_vendor_invoice_line". */
export type Netsuite_Vendor_Invoice_Line_Order_By = {
  amount?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  netsuite_vendor_invoice_id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "netsuite_vendor_invoice_line" */
export enum Netsuite_Vendor_Invoice_Line_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  Date = 'date',
  /** column name */
  NetsuiteId = 'netsuite_id',
  /** column name */
  NetsuiteVendorInvoiceId = 'netsuite_vendor_invoice_id',
  /** column name */
  Number = 'number',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type Netsuite_Vendor_Invoice_Line_Stddev_Fields = {
  __typename?: 'netsuite_vendor_invoice_line_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Netsuite_Vendor_Invoice_Line_Stddev_Pop_Fields = {
  __typename?: 'netsuite_vendor_invoice_line_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Netsuite_Vendor_Invoice_Line_Stddev_Samp_Fields = {
  __typename?: 'netsuite_vendor_invoice_line_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "netsuite_vendor_invoice_line" */
export type Netsuite_Vendor_Invoice_Line_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Netsuite_Vendor_Invoice_Line_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Netsuite_Vendor_Invoice_Line_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  date?: InputMaybe<Scalars['date']>;
  netsuite_id?: InputMaybe<Scalars['String']>;
  netsuite_vendor_invoice_id?: InputMaybe<Scalars['numeric']>;
  number?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Netsuite_Vendor_Invoice_Line_Sum_Fields = {
  __typename?: 'netsuite_vendor_invoice_line_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Netsuite_Vendor_Invoice_Line_Var_Pop_Fields = {
  __typename?: 'netsuite_vendor_invoice_line_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Netsuite_Vendor_Invoice_Line_Var_Samp_Fields = {
  __typename?: 'netsuite_vendor_invoice_line_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Netsuite_Vendor_Invoice_Line_Variance_Fields = {
  __typename?: 'netsuite_vendor_invoice_line_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Netsuite_Vendor_Invoice_Max_Fields = {
  __typename?: 'netsuite_vendor_invoice_max_fields';
  account?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  amount_usd?: Maybe<Scalars['numeric']>;
  approval_status?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  invoice_creation_date?: Maybe<Scalars['String']>;
  narration?: Maybe<Scalars['String']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['numeric']>;
  transaction_no?: Maybe<Scalars['String']>;
  transaction_reference_no?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
  vendor_invoice_no?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Netsuite_Vendor_Invoice_Min_Fields = {
  __typename?: 'netsuite_vendor_invoice_min_fields';
  account?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  amount_usd?: Maybe<Scalars['numeric']>;
  approval_status?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  due_date?: Maybe<Scalars['date']>;
  invoice_creation_date?: Maybe<Scalars['String']>;
  narration?: Maybe<Scalars['String']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  status?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['numeric']>;
  transaction_no?: Maybe<Scalars['String']>;
  transaction_reference_no?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
  vendor_invoice_no?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "netsuite_vendor_invoice". */
export type Netsuite_Vendor_Invoice_Order_By = {
  account?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  amount_usd?: InputMaybe<Order_By>;
  approval_status?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  invoice_creation_date?: InputMaybe<Order_By>;
  narration?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  transaction_no?: InputMaybe<Order_By>;
  transaction_reference_no?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  vendor?: InputMaybe<Order_By>;
  vendor_invoice_no?: InputMaybe<Order_By>;
};

/** select columns of table "netsuite_vendor_invoice" */
export enum Netsuite_Vendor_Invoice_Select_Column {
  /** column name */
  Account = 'account',
  /** column name */
  Amount = 'amount',
  /** column name */
  AmountUsd = 'amount_usd',
  /** column name */
  ApprovalStatus = 'approval_status',
  /** column name */
  Currency = 'currency',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  InvoiceCreationDate = 'invoice_creation_date',
  /** column name */
  Narration = 'narration',
  /** column name */
  NetsuiteId = 'netsuite_id',
  /** column name */
  Status = 'status',
  /** column name */
  Tax = 'tax',
  /** column name */
  TransactionNo = 'transaction_no',
  /** column name */
  TransactionReferenceNo = 'transaction_reference_no',
  /** column name */
  Type = 'type',
  /** column name */
  Vendor = 'vendor',
  /** column name */
  VendorInvoiceNo = 'vendor_invoice_no'
}

/** aggregate stddev on columns */
export type Netsuite_Vendor_Invoice_Stddev_Fields = {
  __typename?: 'netsuite_vendor_invoice_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Netsuite_Vendor_Invoice_Stddev_Pop_Fields = {
  __typename?: 'netsuite_vendor_invoice_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Netsuite_Vendor_Invoice_Stddev_Samp_Fields = {
  __typename?: 'netsuite_vendor_invoice_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "netsuite_vendor_invoice" */
export type Netsuite_Vendor_Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Netsuite_Vendor_Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Netsuite_Vendor_Invoice_Stream_Cursor_Value_Input = {
  account?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['numeric']>;
  amount_usd?: InputMaybe<Scalars['numeric']>;
  approval_status?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  due_date?: InputMaybe<Scalars['date']>;
  invoice_creation_date?: InputMaybe<Scalars['String']>;
  narration?: InputMaybe<Scalars['String']>;
  netsuite_id?: InputMaybe<Scalars['numeric']>;
  status?: InputMaybe<Scalars['String']>;
  tax?: InputMaybe<Scalars['numeric']>;
  transaction_no?: InputMaybe<Scalars['String']>;
  transaction_reference_no?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  vendor?: InputMaybe<Scalars['String']>;
  vendor_invoice_no?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Netsuite_Vendor_Invoice_Sum_Fields = {
  __typename?: 'netsuite_vendor_invoice_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  amount_usd?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['numeric']>;
  tax?: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "netsuite_vendor_invoice_tax" */
export type Netsuite_Vendor_Invoice_Tax = {
  __typename?: 'netsuite_vendor_invoice_tax';
  details?: Maybe<Scalars['String']>;
  line_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  net_amount?: Maybe<Scalars['numeric']>;
  netsuite_id: Scalars['String'];
  netsuite_vendor_invoice_id?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_basis?: Maybe<Scalars['String']>;
  tax_code?: Maybe<Scalars['String']>;
  tax_rate?: Maybe<Scalars['String']>;
  tax_type?: Maybe<Scalars['String']>;
};

/** aggregated selection of "netsuite_vendor_invoice_tax" */
export type Netsuite_Vendor_Invoice_Tax_Aggregate = {
  __typename?: 'netsuite_vendor_invoice_tax_aggregate';
  aggregate?: Maybe<Netsuite_Vendor_Invoice_Tax_Aggregate_Fields>;
  nodes: Array<Netsuite_Vendor_Invoice_Tax>;
};

/** aggregate fields of "netsuite_vendor_invoice_tax" */
export type Netsuite_Vendor_Invoice_Tax_Aggregate_Fields = {
  __typename?: 'netsuite_vendor_invoice_tax_aggregate_fields';
  avg?: Maybe<Netsuite_Vendor_Invoice_Tax_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Netsuite_Vendor_Invoice_Tax_Max_Fields>;
  min?: Maybe<Netsuite_Vendor_Invoice_Tax_Min_Fields>;
  stddev?: Maybe<Netsuite_Vendor_Invoice_Tax_Stddev_Fields>;
  stddev_pop?: Maybe<Netsuite_Vendor_Invoice_Tax_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Netsuite_Vendor_Invoice_Tax_Stddev_Samp_Fields>;
  sum?: Maybe<Netsuite_Vendor_Invoice_Tax_Sum_Fields>;
  var_pop?: Maybe<Netsuite_Vendor_Invoice_Tax_Var_Pop_Fields>;
  var_samp?: Maybe<Netsuite_Vendor_Invoice_Tax_Var_Samp_Fields>;
  variance?: Maybe<Netsuite_Vendor_Invoice_Tax_Variance_Fields>;
};


/** aggregate fields of "netsuite_vendor_invoice_tax" */
export type Netsuite_Vendor_Invoice_Tax_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Netsuite_Vendor_Invoice_Tax_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Netsuite_Vendor_Invoice_Tax_Avg_Fields = {
  __typename?: 'netsuite_vendor_invoice_tax_avg_fields';
  net_amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "netsuite_vendor_invoice_tax". All fields are combined with a logical 'AND'. */
export type Netsuite_Vendor_Invoice_Tax_Bool_Exp = {
  _and?: InputMaybe<Array<Netsuite_Vendor_Invoice_Tax_Bool_Exp>>;
  _not?: InputMaybe<Netsuite_Vendor_Invoice_Tax_Bool_Exp>;
  _or?: InputMaybe<Array<Netsuite_Vendor_Invoice_Tax_Bool_Exp>>;
  details?: InputMaybe<String_Comparison_Exp>;
  line_type?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  net_amount?: InputMaybe<Numeric_Comparison_Exp>;
  netsuite_id?: InputMaybe<String_Comparison_Exp>;
  netsuite_vendor_invoice_id?: InputMaybe<Numeric_Comparison_Exp>;
  tax_amount?: InputMaybe<Numeric_Comparison_Exp>;
  tax_basis?: InputMaybe<String_Comparison_Exp>;
  tax_code?: InputMaybe<String_Comparison_Exp>;
  tax_rate?: InputMaybe<String_Comparison_Exp>;
  tax_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Netsuite_Vendor_Invoice_Tax_Max_Fields = {
  __typename?: 'netsuite_vendor_invoice_tax_max_fields';
  details?: Maybe<Scalars['String']>;
  line_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  net_amount?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['String']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_basis?: Maybe<Scalars['String']>;
  tax_code?: Maybe<Scalars['String']>;
  tax_rate?: Maybe<Scalars['String']>;
  tax_type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Netsuite_Vendor_Invoice_Tax_Min_Fields = {
  __typename?: 'netsuite_vendor_invoice_tax_min_fields';
  details?: Maybe<Scalars['String']>;
  line_type?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  net_amount?: Maybe<Scalars['numeric']>;
  netsuite_id?: Maybe<Scalars['String']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  tax_basis?: Maybe<Scalars['String']>;
  tax_code?: Maybe<Scalars['String']>;
  tax_rate?: Maybe<Scalars['String']>;
  tax_type?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "netsuite_vendor_invoice_tax". */
export type Netsuite_Vendor_Invoice_Tax_Order_By = {
  details?: InputMaybe<Order_By>;
  line_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  netsuite_id?: InputMaybe<Order_By>;
  netsuite_vendor_invoice_id?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  tax_basis?: InputMaybe<Order_By>;
  tax_code?: InputMaybe<Order_By>;
  tax_rate?: InputMaybe<Order_By>;
  tax_type?: InputMaybe<Order_By>;
};

/** select columns of table "netsuite_vendor_invoice_tax" */
export enum Netsuite_Vendor_Invoice_Tax_Select_Column {
  /** column name */
  Details = 'details',
  /** column name */
  LineType = 'line_type',
  /** column name */
  Name = 'name',
  /** column name */
  NetAmount = 'net_amount',
  /** column name */
  NetsuiteId = 'netsuite_id',
  /** column name */
  NetsuiteVendorInvoiceId = 'netsuite_vendor_invoice_id',
  /** column name */
  TaxAmount = 'tax_amount',
  /** column name */
  TaxBasis = 'tax_basis',
  /** column name */
  TaxCode = 'tax_code',
  /** column name */
  TaxRate = 'tax_rate',
  /** column name */
  TaxType = 'tax_type'
}

/** aggregate stddev on columns */
export type Netsuite_Vendor_Invoice_Tax_Stddev_Fields = {
  __typename?: 'netsuite_vendor_invoice_tax_stddev_fields';
  net_amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Netsuite_Vendor_Invoice_Tax_Stddev_Pop_Fields = {
  __typename?: 'netsuite_vendor_invoice_tax_stddev_pop_fields';
  net_amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Netsuite_Vendor_Invoice_Tax_Stddev_Samp_Fields = {
  __typename?: 'netsuite_vendor_invoice_tax_stddev_samp_fields';
  net_amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "netsuite_vendor_invoice_tax" */
export type Netsuite_Vendor_Invoice_Tax_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Netsuite_Vendor_Invoice_Tax_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Netsuite_Vendor_Invoice_Tax_Stream_Cursor_Value_Input = {
  details?: InputMaybe<Scalars['String']>;
  line_type?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  net_amount?: InputMaybe<Scalars['numeric']>;
  netsuite_id?: InputMaybe<Scalars['String']>;
  netsuite_vendor_invoice_id?: InputMaybe<Scalars['numeric']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  tax_basis?: InputMaybe<Scalars['String']>;
  tax_code?: InputMaybe<Scalars['String']>;
  tax_rate?: InputMaybe<Scalars['String']>;
  tax_type?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Netsuite_Vendor_Invoice_Tax_Sum_Fields = {
  __typename?: 'netsuite_vendor_invoice_tax_sum_fields';
  net_amount?: Maybe<Scalars['numeric']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['numeric']>;
  tax_amount?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Netsuite_Vendor_Invoice_Tax_Var_Pop_Fields = {
  __typename?: 'netsuite_vendor_invoice_tax_var_pop_fields';
  net_amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Netsuite_Vendor_Invoice_Tax_Var_Samp_Fields = {
  __typename?: 'netsuite_vendor_invoice_tax_var_samp_fields';
  net_amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Netsuite_Vendor_Invoice_Tax_Variance_Fields = {
  __typename?: 'netsuite_vendor_invoice_tax_variance_fields';
  net_amount?: Maybe<Scalars['Float']>;
  netsuite_vendor_invoice_id?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
};

/** aggregate var_pop on columns */
export type Netsuite_Vendor_Invoice_Var_Pop_Fields = {
  __typename?: 'netsuite_vendor_invoice_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Netsuite_Vendor_Invoice_Var_Samp_Fields = {
  __typename?: 'netsuite_vendor_invoice_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Netsuite_Vendor_Invoice_Variance_Fields = {
  __typename?: 'netsuite_vendor_invoice_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  amount_usd?: Maybe<Scalars['Float']>;
  netsuite_id?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "onboarding_customer_contacts" */
export type Onboarding_Customer_Contacts = {
  __typename?: 'onboarding_customer_contacts';
  /** An object relationship */
  onboarding_customer_contacts?: Maybe<Customer>;
  onboarding_customer_email_id_1?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_2?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_3?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_4?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_5?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_6?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_7?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_8?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_9?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_10?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "onboarding_customer_contacts" */
export type Onboarding_Customer_Contacts_Aggregate = {
  __typename?: 'onboarding_customer_contacts_aggregate';
  aggregate?: Maybe<Onboarding_Customer_Contacts_Aggregate_Fields>;
  nodes: Array<Onboarding_Customer_Contacts>;
};

/** aggregate fields of "onboarding_customer_contacts" */
export type Onboarding_Customer_Contacts_Aggregate_Fields = {
  __typename?: 'onboarding_customer_contacts_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Onboarding_Customer_Contacts_Max_Fields>;
  min?: Maybe<Onboarding_Customer_Contacts_Min_Fields>;
};


/** aggregate fields of "onboarding_customer_contacts" */
export type Onboarding_Customer_Contacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Onboarding_Customer_Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "onboarding_customer_contacts". All fields are combined with a logical 'AND'. */
export type Onboarding_Customer_Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Onboarding_Customer_Contacts_Bool_Exp>>;
  _not?: InputMaybe<Onboarding_Customer_Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Onboarding_Customer_Contacts_Bool_Exp>>;
  onboarding_customer_contacts?: InputMaybe<Customer_Bool_Exp>;
  onboarding_customer_email_id_1?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_2?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_3?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_4?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_5?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_6?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_7?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_8?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_9?: InputMaybe<String_Comparison_Exp>;
  onboarding_customer_email_id_10?: InputMaybe<String_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Onboarding_Customer_Contacts_Max_Fields = {
  __typename?: 'onboarding_customer_contacts_max_fields';
  onboarding_customer_email_id_1?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_2?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_3?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_4?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_5?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_6?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_7?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_8?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_9?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_10?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Onboarding_Customer_Contacts_Min_Fields = {
  __typename?: 'onboarding_customer_contacts_min_fields';
  onboarding_customer_email_id_1?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_2?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_3?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_4?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_5?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_6?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_7?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_8?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_9?: Maybe<Scalars['String']>;
  onboarding_customer_email_id_10?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "onboarding_customer_contacts". */
export type Onboarding_Customer_Contacts_Order_By = {
  onboarding_customer_contacts?: InputMaybe<Customer_Order_By>;
  onboarding_customer_email_id_1?: InputMaybe<Order_By>;
  onboarding_customer_email_id_2?: InputMaybe<Order_By>;
  onboarding_customer_email_id_3?: InputMaybe<Order_By>;
  onboarding_customer_email_id_4?: InputMaybe<Order_By>;
  onboarding_customer_email_id_5?: InputMaybe<Order_By>;
  onboarding_customer_email_id_6?: InputMaybe<Order_By>;
  onboarding_customer_email_id_7?: InputMaybe<Order_By>;
  onboarding_customer_email_id_8?: InputMaybe<Order_By>;
  onboarding_customer_email_id_9?: InputMaybe<Order_By>;
  onboarding_customer_email_id_10?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
};

/** select columns of table "onboarding_customer_contacts" */
export enum Onboarding_Customer_Contacts_Select_Column {
  /** column name */
  OnboardingCustomerEmailId_1 = 'onboarding_customer_email_id_1',
  /** column name */
  OnboardingCustomerEmailId_2 = 'onboarding_customer_email_id_2',
  /** column name */
  OnboardingCustomerEmailId_3 = 'onboarding_customer_email_id_3',
  /** column name */
  OnboardingCustomerEmailId_4 = 'onboarding_customer_email_id_4',
  /** column name */
  OnboardingCustomerEmailId_5 = 'onboarding_customer_email_id_5',
  /** column name */
  OnboardingCustomerEmailId_6 = 'onboarding_customer_email_id_6',
  /** column name */
  OnboardingCustomerEmailId_7 = 'onboarding_customer_email_id_7',
  /** column name */
  OnboardingCustomerEmailId_8 = 'onboarding_customer_email_id_8',
  /** column name */
  OnboardingCustomerEmailId_9 = 'onboarding_customer_email_id_9',
  /** column name */
  OnboardingCustomerEmailId_10 = 'onboarding_customer_email_id_10',
  /** column name */
  SalesforceId = 'salesforce_id'
}

/** Streaming cursor of the table "onboarding_customer_contacts" */
export type Onboarding_Customer_Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Onboarding_Customer_Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Onboarding_Customer_Contacts_Stream_Cursor_Value_Input = {
  onboarding_customer_email_id_1?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_2?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_3?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_4?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_5?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_6?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_7?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_8?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_9?: InputMaybe<Scalars['String']>;
  onboarding_customer_email_id_10?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "opportunity" */
export type Opportunity = {
  __typename?: 'opportunity';
  ads_plus: Scalars['Boolean'];
  amg_id?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  annual_contract_value?: Maybe<Scalars['numeric']>;
  approval_submitted_date?: Maybe<Scalars['timestamptz']>;
  approval_time?: Maybe<Scalars['String']>;
  aws_involved: Scalars['Boolean'];
  billing_estimate_for_fy?: Maybe<Scalars['numeric']>;
  billing_geography?: Maybe<Scalars['String']>;
  bread_winner_total_amount_due?: Maybe<Scalars['numeric']>;
  bread_winner_total_amount_invoiced?: Maybe<Scalars['numeric']>;
  bread_winner_total_amount_overdue?: Maybe<Scalars['numeric']>;
  bread_winner_total_amount_paid?: Maybe<Scalars['numeric']>;
  bread_winner_total_draft_amount?: Maybe<Scalars['numeric']>;
  cdn_fee_per_gb?: Maybe<Scalars['numeric']>;
  close_date?: Maybe<Scalars['date']>;
  cloud_partner?: Maybe<Scalars['String']>;
  commission_percentage?: Maybe<Scalars['numeric']>;
  commission_value?: Maybe<Scalars['numeric']>;
  competition?: Maybe<Scalars['String']>;
  contact_salesforce_owner_id?: Maybe<Scalars['String']>;
  content_plus: Scalars['Boolean'];
  contract_period?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_salesforce_owner_id?: Maybe<Scalars['String']>;
  csm?: Maybe<Scalars['String']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  current_generators?: Maybe<Scalars['String']>;
  /** An object relationship */
  customer: Account;
  delivery_date?: Maybe<Scalars['date']>;
  delivery_installation_status?: Maybe<Scalars['String']>;
  deposit_fee?: Maybe<Scalars['numeric']>;
  describe_the_reason_for_closed_lost?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  details_from_proposal_from?: Maybe<Scalars['String']>;
  expected_revenue?: Maybe<Scalars['numeric']>;
  files?: Maybe<SalesforceOpportunityResponse>;
  fiscal?: Maybe<Scalars['String']>;
  fiscal_quarter?: Maybe<Scalars['numeric']>;
  fiscal_year?: Maybe<Scalars['numeric']>;
  forecast_category?: Maybe<Scalars['String']>;
  forecast_category_name?: Maybe<Scalars['String']>;
  fsys_forecast_category?: Maybe<Scalars['String']>;
  gcp_involvement: Scalars['Boolean'];
  go_live_date?: Maybe<Scalars['date']>;
  gross_margin?: Maybe<Scalars['numeric']>;
  has_opportunity_line_item: Scalars['Boolean'];
  has_overdue_task: Scalars['Boolean'];
  impact?: Maybe<Scalars['String']>;
  initial_fees?: Maybe<Scalars['numeric']>;
  is_approved: Scalars['Boolean'];
  is_closed: Scalars['Boolean'];
  is_deleted: Scalars['Boolean'];
  is_influenced: Scalars['Boolean'];
  is_private?: Maybe<Scalars['Boolean']>;
  is_split: Scalars['Boolean'];
  is_won: Scalars['Boolean'];
  lead_source?: Maybe<Scalars['String']>;
  lifetime_contract_value?: Maybe<Scalars['numeric']>;
  linked_in_company_id?: Maybe<Scalars['String']>;
  main_competitors?: Maybe<Scalars['String']>;
  modified_commission?: Maybe<Scalars['numeric']>;
  monetization_model?: Maybe<Scalars['String']>;
  monthly_fees?: Maybe<Scalars['numeric']>;
  name: Scalars['String'];
  next_step_by?: Maybe<Scalars['String']>;
  next_step_due_date?: Maybe<Scalars['date']>;
  old_probability?: Maybe<Scalars['numeric']>;
  opportunity_type?: Maybe<Scalars['String']>;
  order_number?: Maybe<Scalars['String']>;
  power_of_1?: Maybe<Scalars['numeric']>;
  pre_sales_delay?: Maybe<Scalars['String']>;
  pre_sales_due_date?: Maybe<Scalars['date']>;
  presales_involed?: Maybe<Scalars['String']>;
  presales_status?: Maybe<Scalars['String']>;
  presales_update?: Maybe<Scalars['String']>;
  probability?: Maybe<Scalars['numeric']>;
  product?: Maybe<Scalars['String']>;
  prospect_strength?: Maybe<Scalars['String']>;
  /** An array relationship */
  quotes: Array<Quote>;
  /** An aggregate relationship */
  quotes_aggregate: Quote_Aggregate;
  reason_for_closed_lost?: Maybe<Scalars['String']>;
  reason_for_closed_won?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  renewal_date_temporary?: Maybe<Scalars['date']>;
  request_origin?: Maybe<Scalars['String']>;
  requestor_email?: Maybe<Scalars['String']>;
  requestor_name?: Maybe<Scalars['String']>;
  rev_share?: Maybe<Scalars['numeric']>;
  sales_channel?: Maybe<Scalars['String']>;
  salesforce_account_id: Scalars['String'];
  salesforce_campaign_id?: Maybe<Scalars['String']>;
  salesforce_contract_id?: Maybe<Scalars['String']>;
  salesforce_created_date: Scalars['timestamptz'];
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date: Scalars['timestamptz'];
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_partner_account_id?: Maybe<Scalars['String']>;
  salesforce_primary_contact_id?: Maybe<Scalars['String']>;
  salesforce_record_type_id?: Maybe<Scalars['String']>;
  salesforce_reseller_account_id?: Maybe<Scalars['String']>;
  salesforce_sbqq_amended_contract_id?: Maybe<Scalars['String']>;
  salesforce_sbqq_primary_quote_id?: Maybe<Scalars['String']>;
  salesforce_sbqq_renewed_contract_id?: Maybe<Scalars['String']>;
  salesforce_synced_quote_id?: Maybe<Scalars['String']>;
  salesforce_target_id?: Maybe<Scalars['String']>;
  sbqq_contracted: Scalars['Boolean'];
  sbqq_create_contracted_prices: Scalars['Boolean'];
  sbqq_order_group_id?: Maybe<Scalars['String']>;
  sbqq_ordered: Scalars['Boolean'];
  sbqq_quote_pricebook_id?: Maybe<Scalars['String']>;
  sbqq_renewal: Scalars['Boolean'];
  /** An object relationship */
  self_serve_information?: Maybe<Opportunity_Self_Serve_Information>;
  so?: Maybe<Scalars['String']>;
  stage_name?: Maybe<Scalars['String']>;
  status_update?: Maybe<Scalars['String']>;
  system_integrators?: Maybe<Scalars['String']>;
  total_amount_first_year?: Maybe<Scalars['numeric']>;
  total_opportunity_quantity?: Maybe<Scalars['numeric']>;
  tracking_number?: Maybe<Scalars['String']>;
  ts_cpm_fee?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vod_delivery_fee?: Maybe<Scalars['numeric']>;
  vod_mgmt_fee?: Maybe<Scalars['numeric']>;
  vod_transcoding_fee?: Maybe<Scalars['numeric']>;
  weighted_booking?: Maybe<Scalars['numeric']>;
  weighted_mrr?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "opportunity" */
export type OpportunityQuotesArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


/** columns and relationships of "opportunity" */
export type OpportunityQuotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};

/** aggregated selection of "opportunity" */
export type Opportunity_Aggregate = {
  __typename?: 'opportunity_aggregate';
  aggregate?: Maybe<Opportunity_Aggregate_Fields>;
  nodes: Array<Opportunity>;
};

export type Opportunity_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Opportunity_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Opportunity_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Opportunity_Aggregate_Bool_Exp_Count>;
};

export type Opportunity_Aggregate_Bool_Exp_Bool_And = {
  arguments: Opportunity_Select_Column_Opportunity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Opportunity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Opportunity_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Opportunity_Select_Column_Opportunity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Opportunity_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Opportunity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Opportunity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Opportunity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "opportunity" */
export type Opportunity_Aggregate_Fields = {
  __typename?: 'opportunity_aggregate_fields';
  avg?: Maybe<Opportunity_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Opportunity_Max_Fields>;
  min?: Maybe<Opportunity_Min_Fields>;
  stddev?: Maybe<Opportunity_Stddev_Fields>;
  stddev_pop?: Maybe<Opportunity_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Opportunity_Stddev_Samp_Fields>;
  sum?: Maybe<Opportunity_Sum_Fields>;
  var_pop?: Maybe<Opportunity_Var_Pop_Fields>;
  var_samp?: Maybe<Opportunity_Var_Samp_Fields>;
  variance?: Maybe<Opportunity_Variance_Fields>;
};


/** aggregate fields of "opportunity" */
export type Opportunity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Opportunity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "opportunity" */
export type Opportunity_Aggregate_Order_By = {
  avg?: InputMaybe<Opportunity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Opportunity_Max_Order_By>;
  min?: InputMaybe<Opportunity_Min_Order_By>;
  stddev?: InputMaybe<Opportunity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Opportunity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Opportunity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Opportunity_Sum_Order_By>;
  var_pop?: InputMaybe<Opportunity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Opportunity_Var_Samp_Order_By>;
  variance?: InputMaybe<Opportunity_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Opportunity_Avg_Fields = {
  __typename?: 'opportunity_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  annual_contract_value?: Maybe<Scalars['Float']>;
  billing_estimate_for_fy?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_due?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_invoiced?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_overdue?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_paid?: Maybe<Scalars['Float']>;
  bread_winner_total_draft_amount?: Maybe<Scalars['Float']>;
  cdn_fee_per_gb?: Maybe<Scalars['Float']>;
  commission_percentage?: Maybe<Scalars['Float']>;
  commission_value?: Maybe<Scalars['Float']>;
  contract_period?: Maybe<Scalars['Float']>;
  deposit_fee?: Maybe<Scalars['Float']>;
  expected_revenue?: Maybe<Scalars['Float']>;
  fiscal_quarter?: Maybe<Scalars['Float']>;
  fiscal_year?: Maybe<Scalars['Float']>;
  gross_margin?: Maybe<Scalars['Float']>;
  initial_fees?: Maybe<Scalars['Float']>;
  lifetime_contract_value?: Maybe<Scalars['Float']>;
  modified_commission?: Maybe<Scalars['Float']>;
  monthly_fees?: Maybe<Scalars['Float']>;
  old_probability?: Maybe<Scalars['Float']>;
  power_of_1?: Maybe<Scalars['Float']>;
  probability?: Maybe<Scalars['Float']>;
  rev_share?: Maybe<Scalars['Float']>;
  total_amount_first_year?: Maybe<Scalars['Float']>;
  total_opportunity_quantity?: Maybe<Scalars['Float']>;
  ts_cpm_fee?: Maybe<Scalars['Float']>;
  vod_delivery_fee?: Maybe<Scalars['Float']>;
  vod_mgmt_fee?: Maybe<Scalars['Float']>;
  vod_transcoding_fee?: Maybe<Scalars['Float']>;
  weighted_booking?: Maybe<Scalars['Float']>;
  weighted_mrr?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "opportunity" */
export type Opportunity_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  billing_estimate_for_fy?: InputMaybe<Order_By>;
  bread_winner_total_amount_due?: InputMaybe<Order_By>;
  bread_winner_total_amount_invoiced?: InputMaybe<Order_By>;
  bread_winner_total_amount_overdue?: InputMaybe<Order_By>;
  bread_winner_total_amount_paid?: InputMaybe<Order_By>;
  bread_winner_total_draft_amount?: InputMaybe<Order_By>;
  cdn_fee_per_gb?: InputMaybe<Order_By>;
  commission_percentage?: InputMaybe<Order_By>;
  commission_value?: InputMaybe<Order_By>;
  contract_period?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  expected_revenue?: InputMaybe<Order_By>;
  fiscal_quarter?: InputMaybe<Order_By>;
  fiscal_year?: InputMaybe<Order_By>;
  gross_margin?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  modified_commission?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  old_probability?: InputMaybe<Order_By>;
  power_of_1?: InputMaybe<Order_By>;
  probability?: InputMaybe<Order_By>;
  rev_share?: InputMaybe<Order_By>;
  total_amount_first_year?: InputMaybe<Order_By>;
  total_opportunity_quantity?: InputMaybe<Order_By>;
  ts_cpm_fee?: InputMaybe<Order_By>;
  vod_delivery_fee?: InputMaybe<Order_By>;
  vod_mgmt_fee?: InputMaybe<Order_By>;
  vod_transcoding_fee?: InputMaybe<Order_By>;
  weighted_booking?: InputMaybe<Order_By>;
  weighted_mrr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "opportunity". All fields are combined with a logical 'AND'. */
export type Opportunity_Bool_Exp = {
  _and?: InputMaybe<Array<Opportunity_Bool_Exp>>;
  _not?: InputMaybe<Opportunity_Bool_Exp>;
  _or?: InputMaybe<Array<Opportunity_Bool_Exp>>;
  ads_plus?: InputMaybe<Boolean_Comparison_Exp>;
  amg_id?: InputMaybe<String_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  annual_contract_value?: InputMaybe<Numeric_Comparison_Exp>;
  approval_submitted_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  approval_time?: InputMaybe<String_Comparison_Exp>;
  aws_involved?: InputMaybe<Boolean_Comparison_Exp>;
  billing_estimate_for_fy?: InputMaybe<Numeric_Comparison_Exp>;
  billing_geography?: InputMaybe<String_Comparison_Exp>;
  bread_winner_total_amount_due?: InputMaybe<Numeric_Comparison_Exp>;
  bread_winner_total_amount_invoiced?: InputMaybe<Numeric_Comparison_Exp>;
  bread_winner_total_amount_overdue?: InputMaybe<Numeric_Comparison_Exp>;
  bread_winner_total_amount_paid?: InputMaybe<Numeric_Comparison_Exp>;
  bread_winner_total_draft_amount?: InputMaybe<Numeric_Comparison_Exp>;
  cdn_fee_per_gb?: InputMaybe<Numeric_Comparison_Exp>;
  close_date?: InputMaybe<Date_Comparison_Exp>;
  cloud_partner?: InputMaybe<String_Comparison_Exp>;
  commission_percentage?: InputMaybe<Numeric_Comparison_Exp>;
  commission_value?: InputMaybe<Numeric_Comparison_Exp>;
  competition?: InputMaybe<String_Comparison_Exp>;
  contact_salesforce_owner_id?: InputMaybe<String_Comparison_Exp>;
  content_plus?: InputMaybe<Boolean_Comparison_Exp>;
  contract_period?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_salesforce_owner_id?: InputMaybe<String_Comparison_Exp>;
  csm?: InputMaybe<String_Comparison_Exp>;
  currency_iso_code?: InputMaybe<String_Comparison_Exp>;
  current_generators?: InputMaybe<String_Comparison_Exp>;
  customer?: InputMaybe<Account_Bool_Exp>;
  delivery_date?: InputMaybe<Date_Comparison_Exp>;
  delivery_installation_status?: InputMaybe<String_Comparison_Exp>;
  deposit_fee?: InputMaybe<Numeric_Comparison_Exp>;
  describe_the_reason_for_closed_lost?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  details_from_proposal_from?: InputMaybe<String_Comparison_Exp>;
  expected_revenue?: InputMaybe<Numeric_Comparison_Exp>;
  fiscal?: InputMaybe<String_Comparison_Exp>;
  fiscal_quarter?: InputMaybe<Numeric_Comparison_Exp>;
  fiscal_year?: InputMaybe<Numeric_Comparison_Exp>;
  forecast_category?: InputMaybe<String_Comparison_Exp>;
  forecast_category_name?: InputMaybe<String_Comparison_Exp>;
  fsys_forecast_category?: InputMaybe<String_Comparison_Exp>;
  gcp_involvement?: InputMaybe<Boolean_Comparison_Exp>;
  go_live_date?: InputMaybe<Date_Comparison_Exp>;
  gross_margin?: InputMaybe<Numeric_Comparison_Exp>;
  has_opportunity_line_item?: InputMaybe<Boolean_Comparison_Exp>;
  has_overdue_task?: InputMaybe<Boolean_Comparison_Exp>;
  impact?: InputMaybe<String_Comparison_Exp>;
  initial_fees?: InputMaybe<Numeric_Comparison_Exp>;
  is_approved?: InputMaybe<Boolean_Comparison_Exp>;
  is_closed?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_influenced?: InputMaybe<Boolean_Comparison_Exp>;
  is_private?: InputMaybe<Boolean_Comparison_Exp>;
  is_split?: InputMaybe<Boolean_Comparison_Exp>;
  is_won?: InputMaybe<Boolean_Comparison_Exp>;
  lead_source?: InputMaybe<String_Comparison_Exp>;
  lifetime_contract_value?: InputMaybe<Numeric_Comparison_Exp>;
  linked_in_company_id?: InputMaybe<String_Comparison_Exp>;
  main_competitors?: InputMaybe<String_Comparison_Exp>;
  modified_commission?: InputMaybe<Numeric_Comparison_Exp>;
  monetization_model?: InputMaybe<String_Comparison_Exp>;
  monthly_fees?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  next_step_by?: InputMaybe<String_Comparison_Exp>;
  next_step_due_date?: InputMaybe<Date_Comparison_Exp>;
  old_probability?: InputMaybe<Numeric_Comparison_Exp>;
  opportunity_type?: InputMaybe<String_Comparison_Exp>;
  order_number?: InputMaybe<String_Comparison_Exp>;
  power_of_1?: InputMaybe<Numeric_Comparison_Exp>;
  pre_sales_delay?: InputMaybe<String_Comparison_Exp>;
  pre_sales_due_date?: InputMaybe<Date_Comparison_Exp>;
  presales_involed?: InputMaybe<String_Comparison_Exp>;
  presales_status?: InputMaybe<String_Comparison_Exp>;
  presales_update?: InputMaybe<String_Comparison_Exp>;
  probability?: InputMaybe<Numeric_Comparison_Exp>;
  product?: InputMaybe<String_Comparison_Exp>;
  prospect_strength?: InputMaybe<String_Comparison_Exp>;
  quotes?: InputMaybe<Quote_Bool_Exp>;
  quotes_aggregate?: InputMaybe<Quote_Aggregate_Bool_Exp>;
  reason_for_closed_lost?: InputMaybe<String_Comparison_Exp>;
  reason_for_closed_won?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  renewal_date_temporary?: InputMaybe<Date_Comparison_Exp>;
  request_origin?: InputMaybe<String_Comparison_Exp>;
  requestor_email?: InputMaybe<String_Comparison_Exp>;
  requestor_name?: InputMaybe<String_Comparison_Exp>;
  rev_share?: InputMaybe<Numeric_Comparison_Exp>;
  sales_channel?: InputMaybe<String_Comparison_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_campaign_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_contract_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_owner_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_partner_account_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_primary_contact_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_record_type_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_reseller_account_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_sbqq_amended_contract_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_sbqq_primary_quote_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_sbqq_renewed_contract_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_synced_quote_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_target_id?: InputMaybe<String_Comparison_Exp>;
  sbqq_contracted?: InputMaybe<Boolean_Comparison_Exp>;
  sbqq_create_contracted_prices?: InputMaybe<Boolean_Comparison_Exp>;
  sbqq_order_group_id?: InputMaybe<String_Comparison_Exp>;
  sbqq_ordered?: InputMaybe<Boolean_Comparison_Exp>;
  sbqq_quote_pricebook_id?: InputMaybe<String_Comparison_Exp>;
  sbqq_renewal?: InputMaybe<Boolean_Comparison_Exp>;
  self_serve_information?: InputMaybe<Opportunity_Self_Serve_Information_Bool_Exp>;
  so?: InputMaybe<String_Comparison_Exp>;
  stage_name?: InputMaybe<String_Comparison_Exp>;
  status_update?: InputMaybe<String_Comparison_Exp>;
  system_integrators?: InputMaybe<String_Comparison_Exp>;
  total_amount_first_year?: InputMaybe<Numeric_Comparison_Exp>;
  total_opportunity_quantity?: InputMaybe<Numeric_Comparison_Exp>;
  tracking_number?: InputMaybe<String_Comparison_Exp>;
  ts_cpm_fee?: InputMaybe<Numeric_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  vod_delivery_fee?: InputMaybe<Numeric_Comparison_Exp>;
  vod_mgmt_fee?: InputMaybe<Numeric_Comparison_Exp>;
  vod_transcoding_fee?: InputMaybe<Numeric_Comparison_Exp>;
  weighted_booking?: InputMaybe<Numeric_Comparison_Exp>;
  weighted_mrr?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Opportunity_Max_Fields = {
  __typename?: 'opportunity_max_fields';
  amg_id?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  annual_contract_value?: Maybe<Scalars['numeric']>;
  approval_submitted_date?: Maybe<Scalars['timestamptz']>;
  approval_time?: Maybe<Scalars['String']>;
  billing_estimate_for_fy?: Maybe<Scalars['numeric']>;
  billing_geography?: Maybe<Scalars['String']>;
  bread_winner_total_amount_due?: Maybe<Scalars['numeric']>;
  bread_winner_total_amount_invoiced?: Maybe<Scalars['numeric']>;
  bread_winner_total_amount_overdue?: Maybe<Scalars['numeric']>;
  bread_winner_total_amount_paid?: Maybe<Scalars['numeric']>;
  bread_winner_total_draft_amount?: Maybe<Scalars['numeric']>;
  cdn_fee_per_gb?: Maybe<Scalars['numeric']>;
  close_date?: Maybe<Scalars['date']>;
  cloud_partner?: Maybe<Scalars['String']>;
  commission_percentage?: Maybe<Scalars['numeric']>;
  commission_value?: Maybe<Scalars['numeric']>;
  competition?: Maybe<Scalars['String']>;
  contact_salesforce_owner_id?: Maybe<Scalars['String']>;
  contract_period?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_salesforce_owner_id?: Maybe<Scalars['String']>;
  csm?: Maybe<Scalars['String']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  current_generators?: Maybe<Scalars['String']>;
  delivery_date?: Maybe<Scalars['date']>;
  delivery_installation_status?: Maybe<Scalars['String']>;
  deposit_fee?: Maybe<Scalars['numeric']>;
  describe_the_reason_for_closed_lost?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  details_from_proposal_from?: Maybe<Scalars['String']>;
  expected_revenue?: Maybe<Scalars['numeric']>;
  fiscal?: Maybe<Scalars['String']>;
  fiscal_quarter?: Maybe<Scalars['numeric']>;
  fiscal_year?: Maybe<Scalars['numeric']>;
  forecast_category?: Maybe<Scalars['String']>;
  forecast_category_name?: Maybe<Scalars['String']>;
  fsys_forecast_category?: Maybe<Scalars['String']>;
  go_live_date?: Maybe<Scalars['date']>;
  gross_margin?: Maybe<Scalars['numeric']>;
  impact?: Maybe<Scalars['String']>;
  initial_fees?: Maybe<Scalars['numeric']>;
  lead_source?: Maybe<Scalars['String']>;
  lifetime_contract_value?: Maybe<Scalars['numeric']>;
  linked_in_company_id?: Maybe<Scalars['String']>;
  main_competitors?: Maybe<Scalars['String']>;
  modified_commission?: Maybe<Scalars['numeric']>;
  monetization_model?: Maybe<Scalars['String']>;
  monthly_fees?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  next_step_by?: Maybe<Scalars['String']>;
  next_step_due_date?: Maybe<Scalars['date']>;
  old_probability?: Maybe<Scalars['numeric']>;
  opportunity_type?: Maybe<Scalars['String']>;
  order_number?: Maybe<Scalars['String']>;
  power_of_1?: Maybe<Scalars['numeric']>;
  pre_sales_delay?: Maybe<Scalars['String']>;
  pre_sales_due_date?: Maybe<Scalars['date']>;
  presales_involed?: Maybe<Scalars['String']>;
  presales_status?: Maybe<Scalars['String']>;
  presales_update?: Maybe<Scalars['String']>;
  probability?: Maybe<Scalars['numeric']>;
  product?: Maybe<Scalars['String']>;
  prospect_strength?: Maybe<Scalars['String']>;
  reason_for_closed_lost?: Maybe<Scalars['String']>;
  reason_for_closed_won?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  renewal_date_temporary?: Maybe<Scalars['date']>;
  request_origin?: Maybe<Scalars['String']>;
  requestor_email?: Maybe<Scalars['String']>;
  requestor_name?: Maybe<Scalars['String']>;
  rev_share?: Maybe<Scalars['numeric']>;
  sales_channel?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_campaign_id?: Maybe<Scalars['String']>;
  salesforce_contract_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_partner_account_id?: Maybe<Scalars['String']>;
  salesforce_primary_contact_id?: Maybe<Scalars['String']>;
  salesforce_record_type_id?: Maybe<Scalars['String']>;
  salesforce_reseller_account_id?: Maybe<Scalars['String']>;
  salesforce_sbqq_amended_contract_id?: Maybe<Scalars['String']>;
  salesforce_sbqq_primary_quote_id?: Maybe<Scalars['String']>;
  salesforce_sbqq_renewed_contract_id?: Maybe<Scalars['String']>;
  salesforce_synced_quote_id?: Maybe<Scalars['String']>;
  salesforce_target_id?: Maybe<Scalars['String']>;
  sbqq_order_group_id?: Maybe<Scalars['String']>;
  sbqq_quote_pricebook_id?: Maybe<Scalars['String']>;
  so?: Maybe<Scalars['String']>;
  stage_name?: Maybe<Scalars['String']>;
  status_update?: Maybe<Scalars['String']>;
  system_integrators?: Maybe<Scalars['String']>;
  total_amount_first_year?: Maybe<Scalars['numeric']>;
  total_opportunity_quantity?: Maybe<Scalars['numeric']>;
  tracking_number?: Maybe<Scalars['String']>;
  ts_cpm_fee?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vod_delivery_fee?: Maybe<Scalars['numeric']>;
  vod_mgmt_fee?: Maybe<Scalars['numeric']>;
  vod_transcoding_fee?: Maybe<Scalars['numeric']>;
  weighted_booking?: Maybe<Scalars['numeric']>;
  weighted_mrr?: Maybe<Scalars['numeric']>;
};

/** order by max() on columns of table "opportunity" */
export type Opportunity_Max_Order_By = {
  amg_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  approval_submitted_date?: InputMaybe<Order_By>;
  approval_time?: InputMaybe<Order_By>;
  billing_estimate_for_fy?: InputMaybe<Order_By>;
  billing_geography?: InputMaybe<Order_By>;
  bread_winner_total_amount_due?: InputMaybe<Order_By>;
  bread_winner_total_amount_invoiced?: InputMaybe<Order_By>;
  bread_winner_total_amount_overdue?: InputMaybe<Order_By>;
  bread_winner_total_amount_paid?: InputMaybe<Order_By>;
  bread_winner_total_draft_amount?: InputMaybe<Order_By>;
  cdn_fee_per_gb?: InputMaybe<Order_By>;
  close_date?: InputMaybe<Order_By>;
  cloud_partner?: InputMaybe<Order_By>;
  commission_percentage?: InputMaybe<Order_By>;
  commission_value?: InputMaybe<Order_By>;
  competition?: InputMaybe<Order_By>;
  contact_salesforce_owner_id?: InputMaybe<Order_By>;
  contract_period?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_salesforce_owner_id?: InputMaybe<Order_By>;
  csm?: InputMaybe<Order_By>;
  currency_iso_code?: InputMaybe<Order_By>;
  current_generators?: InputMaybe<Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  delivery_installation_status?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  describe_the_reason_for_closed_lost?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  details_from_proposal_from?: InputMaybe<Order_By>;
  expected_revenue?: InputMaybe<Order_By>;
  fiscal?: InputMaybe<Order_By>;
  fiscal_quarter?: InputMaybe<Order_By>;
  fiscal_year?: InputMaybe<Order_By>;
  forecast_category?: InputMaybe<Order_By>;
  forecast_category_name?: InputMaybe<Order_By>;
  fsys_forecast_category?: InputMaybe<Order_By>;
  go_live_date?: InputMaybe<Order_By>;
  gross_margin?: InputMaybe<Order_By>;
  impact?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lead_source?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  linked_in_company_id?: InputMaybe<Order_By>;
  main_competitors?: InputMaybe<Order_By>;
  modified_commission?: InputMaybe<Order_By>;
  monetization_model?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  next_step_by?: InputMaybe<Order_By>;
  next_step_due_date?: InputMaybe<Order_By>;
  old_probability?: InputMaybe<Order_By>;
  opportunity_type?: InputMaybe<Order_By>;
  order_number?: InputMaybe<Order_By>;
  power_of_1?: InputMaybe<Order_By>;
  pre_sales_delay?: InputMaybe<Order_By>;
  pre_sales_due_date?: InputMaybe<Order_By>;
  presales_involed?: InputMaybe<Order_By>;
  presales_status?: InputMaybe<Order_By>;
  presales_update?: InputMaybe<Order_By>;
  probability?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  prospect_strength?: InputMaybe<Order_By>;
  reason_for_closed_lost?: InputMaybe<Order_By>;
  reason_for_closed_won?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  renewal_date_temporary?: InputMaybe<Order_By>;
  request_origin?: InputMaybe<Order_By>;
  requestor_email?: InputMaybe<Order_By>;
  requestor_name?: InputMaybe<Order_By>;
  rev_share?: InputMaybe<Order_By>;
  sales_channel?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_campaign_id?: InputMaybe<Order_By>;
  salesforce_contract_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_partner_account_id?: InputMaybe<Order_By>;
  salesforce_primary_contact_id?: InputMaybe<Order_By>;
  salesforce_record_type_id?: InputMaybe<Order_By>;
  salesforce_reseller_account_id?: InputMaybe<Order_By>;
  salesforce_sbqq_amended_contract_id?: InputMaybe<Order_By>;
  salesforce_sbqq_primary_quote_id?: InputMaybe<Order_By>;
  salesforce_sbqq_renewed_contract_id?: InputMaybe<Order_By>;
  salesforce_synced_quote_id?: InputMaybe<Order_By>;
  salesforce_target_id?: InputMaybe<Order_By>;
  sbqq_order_group_id?: InputMaybe<Order_By>;
  sbqq_quote_pricebook_id?: InputMaybe<Order_By>;
  so?: InputMaybe<Order_By>;
  stage_name?: InputMaybe<Order_By>;
  status_update?: InputMaybe<Order_By>;
  system_integrators?: InputMaybe<Order_By>;
  total_amount_first_year?: InputMaybe<Order_By>;
  total_opportunity_quantity?: InputMaybe<Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  ts_cpm_fee?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vod_delivery_fee?: InputMaybe<Order_By>;
  vod_mgmt_fee?: InputMaybe<Order_By>;
  vod_transcoding_fee?: InputMaybe<Order_By>;
  weighted_booking?: InputMaybe<Order_By>;
  weighted_mrr?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Opportunity_Min_Fields = {
  __typename?: 'opportunity_min_fields';
  amg_id?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['numeric']>;
  annual_contract_value?: Maybe<Scalars['numeric']>;
  approval_submitted_date?: Maybe<Scalars['timestamptz']>;
  approval_time?: Maybe<Scalars['String']>;
  billing_estimate_for_fy?: Maybe<Scalars['numeric']>;
  billing_geography?: Maybe<Scalars['String']>;
  bread_winner_total_amount_due?: Maybe<Scalars['numeric']>;
  bread_winner_total_amount_invoiced?: Maybe<Scalars['numeric']>;
  bread_winner_total_amount_overdue?: Maybe<Scalars['numeric']>;
  bread_winner_total_amount_paid?: Maybe<Scalars['numeric']>;
  bread_winner_total_draft_amount?: Maybe<Scalars['numeric']>;
  cdn_fee_per_gb?: Maybe<Scalars['numeric']>;
  close_date?: Maybe<Scalars['date']>;
  cloud_partner?: Maybe<Scalars['String']>;
  commission_percentage?: Maybe<Scalars['numeric']>;
  commission_value?: Maybe<Scalars['numeric']>;
  competition?: Maybe<Scalars['String']>;
  contact_salesforce_owner_id?: Maybe<Scalars['String']>;
  contract_period?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  created_by_salesforce_owner_id?: Maybe<Scalars['String']>;
  csm?: Maybe<Scalars['String']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  current_generators?: Maybe<Scalars['String']>;
  delivery_date?: Maybe<Scalars['date']>;
  delivery_installation_status?: Maybe<Scalars['String']>;
  deposit_fee?: Maybe<Scalars['numeric']>;
  describe_the_reason_for_closed_lost?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  details_from_proposal_from?: Maybe<Scalars['String']>;
  expected_revenue?: Maybe<Scalars['numeric']>;
  fiscal?: Maybe<Scalars['String']>;
  fiscal_quarter?: Maybe<Scalars['numeric']>;
  fiscal_year?: Maybe<Scalars['numeric']>;
  forecast_category?: Maybe<Scalars['String']>;
  forecast_category_name?: Maybe<Scalars['String']>;
  fsys_forecast_category?: Maybe<Scalars['String']>;
  go_live_date?: Maybe<Scalars['date']>;
  gross_margin?: Maybe<Scalars['numeric']>;
  impact?: Maybe<Scalars['String']>;
  initial_fees?: Maybe<Scalars['numeric']>;
  lead_source?: Maybe<Scalars['String']>;
  lifetime_contract_value?: Maybe<Scalars['numeric']>;
  linked_in_company_id?: Maybe<Scalars['String']>;
  main_competitors?: Maybe<Scalars['String']>;
  modified_commission?: Maybe<Scalars['numeric']>;
  monetization_model?: Maybe<Scalars['String']>;
  monthly_fees?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  next_step_by?: Maybe<Scalars['String']>;
  next_step_due_date?: Maybe<Scalars['date']>;
  old_probability?: Maybe<Scalars['numeric']>;
  opportunity_type?: Maybe<Scalars['String']>;
  order_number?: Maybe<Scalars['String']>;
  power_of_1?: Maybe<Scalars['numeric']>;
  pre_sales_delay?: Maybe<Scalars['String']>;
  pre_sales_due_date?: Maybe<Scalars['date']>;
  presales_involed?: Maybe<Scalars['String']>;
  presales_status?: Maybe<Scalars['String']>;
  presales_update?: Maybe<Scalars['String']>;
  probability?: Maybe<Scalars['numeric']>;
  product?: Maybe<Scalars['String']>;
  prospect_strength?: Maybe<Scalars['String']>;
  reason_for_closed_lost?: Maybe<Scalars['String']>;
  reason_for_closed_won?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  renewal_date_temporary?: Maybe<Scalars['date']>;
  request_origin?: Maybe<Scalars['String']>;
  requestor_email?: Maybe<Scalars['String']>;
  requestor_name?: Maybe<Scalars['String']>;
  rev_share?: Maybe<Scalars['numeric']>;
  sales_channel?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_campaign_id?: Maybe<Scalars['String']>;
  salesforce_contract_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_partner_account_id?: Maybe<Scalars['String']>;
  salesforce_primary_contact_id?: Maybe<Scalars['String']>;
  salesforce_record_type_id?: Maybe<Scalars['String']>;
  salesforce_reseller_account_id?: Maybe<Scalars['String']>;
  salesforce_sbqq_amended_contract_id?: Maybe<Scalars['String']>;
  salesforce_sbqq_primary_quote_id?: Maybe<Scalars['String']>;
  salesforce_sbqq_renewed_contract_id?: Maybe<Scalars['String']>;
  salesforce_synced_quote_id?: Maybe<Scalars['String']>;
  salesforce_target_id?: Maybe<Scalars['String']>;
  sbqq_order_group_id?: Maybe<Scalars['String']>;
  sbqq_quote_pricebook_id?: Maybe<Scalars['String']>;
  so?: Maybe<Scalars['String']>;
  stage_name?: Maybe<Scalars['String']>;
  status_update?: Maybe<Scalars['String']>;
  system_integrators?: Maybe<Scalars['String']>;
  total_amount_first_year?: Maybe<Scalars['numeric']>;
  total_opportunity_quantity?: Maybe<Scalars['numeric']>;
  tracking_number?: Maybe<Scalars['String']>;
  ts_cpm_fee?: Maybe<Scalars['numeric']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  vod_delivery_fee?: Maybe<Scalars['numeric']>;
  vod_mgmt_fee?: Maybe<Scalars['numeric']>;
  vod_transcoding_fee?: Maybe<Scalars['numeric']>;
  weighted_booking?: Maybe<Scalars['numeric']>;
  weighted_mrr?: Maybe<Scalars['numeric']>;
};

/** order by min() on columns of table "opportunity" */
export type Opportunity_Min_Order_By = {
  amg_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  approval_submitted_date?: InputMaybe<Order_By>;
  approval_time?: InputMaybe<Order_By>;
  billing_estimate_for_fy?: InputMaybe<Order_By>;
  billing_geography?: InputMaybe<Order_By>;
  bread_winner_total_amount_due?: InputMaybe<Order_By>;
  bread_winner_total_amount_invoiced?: InputMaybe<Order_By>;
  bread_winner_total_amount_overdue?: InputMaybe<Order_By>;
  bread_winner_total_amount_paid?: InputMaybe<Order_By>;
  bread_winner_total_draft_amount?: InputMaybe<Order_By>;
  cdn_fee_per_gb?: InputMaybe<Order_By>;
  close_date?: InputMaybe<Order_By>;
  cloud_partner?: InputMaybe<Order_By>;
  commission_percentage?: InputMaybe<Order_By>;
  commission_value?: InputMaybe<Order_By>;
  competition?: InputMaybe<Order_By>;
  contact_salesforce_owner_id?: InputMaybe<Order_By>;
  contract_period?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_salesforce_owner_id?: InputMaybe<Order_By>;
  csm?: InputMaybe<Order_By>;
  currency_iso_code?: InputMaybe<Order_By>;
  current_generators?: InputMaybe<Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  delivery_installation_status?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  describe_the_reason_for_closed_lost?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  details_from_proposal_from?: InputMaybe<Order_By>;
  expected_revenue?: InputMaybe<Order_By>;
  fiscal?: InputMaybe<Order_By>;
  fiscal_quarter?: InputMaybe<Order_By>;
  fiscal_year?: InputMaybe<Order_By>;
  forecast_category?: InputMaybe<Order_By>;
  forecast_category_name?: InputMaybe<Order_By>;
  fsys_forecast_category?: InputMaybe<Order_By>;
  go_live_date?: InputMaybe<Order_By>;
  gross_margin?: InputMaybe<Order_By>;
  impact?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lead_source?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  linked_in_company_id?: InputMaybe<Order_By>;
  main_competitors?: InputMaybe<Order_By>;
  modified_commission?: InputMaybe<Order_By>;
  monetization_model?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  next_step_by?: InputMaybe<Order_By>;
  next_step_due_date?: InputMaybe<Order_By>;
  old_probability?: InputMaybe<Order_By>;
  opportunity_type?: InputMaybe<Order_By>;
  order_number?: InputMaybe<Order_By>;
  power_of_1?: InputMaybe<Order_By>;
  pre_sales_delay?: InputMaybe<Order_By>;
  pre_sales_due_date?: InputMaybe<Order_By>;
  presales_involed?: InputMaybe<Order_By>;
  presales_status?: InputMaybe<Order_By>;
  presales_update?: InputMaybe<Order_By>;
  probability?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  prospect_strength?: InputMaybe<Order_By>;
  reason_for_closed_lost?: InputMaybe<Order_By>;
  reason_for_closed_won?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  renewal_date_temporary?: InputMaybe<Order_By>;
  request_origin?: InputMaybe<Order_By>;
  requestor_email?: InputMaybe<Order_By>;
  requestor_name?: InputMaybe<Order_By>;
  rev_share?: InputMaybe<Order_By>;
  sales_channel?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_campaign_id?: InputMaybe<Order_By>;
  salesforce_contract_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_partner_account_id?: InputMaybe<Order_By>;
  salesforce_primary_contact_id?: InputMaybe<Order_By>;
  salesforce_record_type_id?: InputMaybe<Order_By>;
  salesforce_reseller_account_id?: InputMaybe<Order_By>;
  salesforce_sbqq_amended_contract_id?: InputMaybe<Order_By>;
  salesforce_sbqq_primary_quote_id?: InputMaybe<Order_By>;
  salesforce_sbqq_renewed_contract_id?: InputMaybe<Order_By>;
  salesforce_synced_quote_id?: InputMaybe<Order_By>;
  salesforce_target_id?: InputMaybe<Order_By>;
  sbqq_order_group_id?: InputMaybe<Order_By>;
  sbqq_quote_pricebook_id?: InputMaybe<Order_By>;
  so?: InputMaybe<Order_By>;
  stage_name?: InputMaybe<Order_By>;
  status_update?: InputMaybe<Order_By>;
  system_integrators?: InputMaybe<Order_By>;
  total_amount_first_year?: InputMaybe<Order_By>;
  total_opportunity_quantity?: InputMaybe<Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  ts_cpm_fee?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vod_delivery_fee?: InputMaybe<Order_By>;
  vod_mgmt_fee?: InputMaybe<Order_By>;
  vod_transcoding_fee?: InputMaybe<Order_By>;
  weighted_booking?: InputMaybe<Order_By>;
  weighted_mrr?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "opportunity". */
export type Opportunity_Order_By = {
  ads_plus?: InputMaybe<Order_By>;
  amg_id?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  approval_submitted_date?: InputMaybe<Order_By>;
  approval_time?: InputMaybe<Order_By>;
  aws_involved?: InputMaybe<Order_By>;
  billing_estimate_for_fy?: InputMaybe<Order_By>;
  billing_geography?: InputMaybe<Order_By>;
  bread_winner_total_amount_due?: InputMaybe<Order_By>;
  bread_winner_total_amount_invoiced?: InputMaybe<Order_By>;
  bread_winner_total_amount_overdue?: InputMaybe<Order_By>;
  bread_winner_total_amount_paid?: InputMaybe<Order_By>;
  bread_winner_total_draft_amount?: InputMaybe<Order_By>;
  cdn_fee_per_gb?: InputMaybe<Order_By>;
  close_date?: InputMaybe<Order_By>;
  cloud_partner?: InputMaybe<Order_By>;
  commission_percentage?: InputMaybe<Order_By>;
  commission_value?: InputMaybe<Order_By>;
  competition?: InputMaybe<Order_By>;
  contact_salesforce_owner_id?: InputMaybe<Order_By>;
  content_plus?: InputMaybe<Order_By>;
  contract_period?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_salesforce_owner_id?: InputMaybe<Order_By>;
  csm?: InputMaybe<Order_By>;
  currency_iso_code?: InputMaybe<Order_By>;
  current_generators?: InputMaybe<Order_By>;
  customer?: InputMaybe<Account_Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  delivery_installation_status?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  describe_the_reason_for_closed_lost?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  details_from_proposal_from?: InputMaybe<Order_By>;
  expected_revenue?: InputMaybe<Order_By>;
  fiscal?: InputMaybe<Order_By>;
  fiscal_quarter?: InputMaybe<Order_By>;
  fiscal_year?: InputMaybe<Order_By>;
  forecast_category?: InputMaybe<Order_By>;
  forecast_category_name?: InputMaybe<Order_By>;
  fsys_forecast_category?: InputMaybe<Order_By>;
  gcp_involvement?: InputMaybe<Order_By>;
  go_live_date?: InputMaybe<Order_By>;
  gross_margin?: InputMaybe<Order_By>;
  has_opportunity_line_item?: InputMaybe<Order_By>;
  has_overdue_task?: InputMaybe<Order_By>;
  impact?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  is_approved?: InputMaybe<Order_By>;
  is_closed?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_influenced?: InputMaybe<Order_By>;
  is_private?: InputMaybe<Order_By>;
  is_split?: InputMaybe<Order_By>;
  is_won?: InputMaybe<Order_By>;
  lead_source?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  linked_in_company_id?: InputMaybe<Order_By>;
  main_competitors?: InputMaybe<Order_By>;
  modified_commission?: InputMaybe<Order_By>;
  monetization_model?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  next_step_by?: InputMaybe<Order_By>;
  next_step_due_date?: InputMaybe<Order_By>;
  old_probability?: InputMaybe<Order_By>;
  opportunity_type?: InputMaybe<Order_By>;
  order_number?: InputMaybe<Order_By>;
  power_of_1?: InputMaybe<Order_By>;
  pre_sales_delay?: InputMaybe<Order_By>;
  pre_sales_due_date?: InputMaybe<Order_By>;
  presales_involed?: InputMaybe<Order_By>;
  presales_status?: InputMaybe<Order_By>;
  presales_update?: InputMaybe<Order_By>;
  probability?: InputMaybe<Order_By>;
  product?: InputMaybe<Order_By>;
  prospect_strength?: InputMaybe<Order_By>;
  quotes_aggregate?: InputMaybe<Quote_Aggregate_Order_By>;
  reason_for_closed_lost?: InputMaybe<Order_By>;
  reason_for_closed_won?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  renewal_date_temporary?: InputMaybe<Order_By>;
  request_origin?: InputMaybe<Order_By>;
  requestor_email?: InputMaybe<Order_By>;
  requestor_name?: InputMaybe<Order_By>;
  rev_share?: InputMaybe<Order_By>;
  sales_channel?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_campaign_id?: InputMaybe<Order_By>;
  salesforce_contract_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_partner_account_id?: InputMaybe<Order_By>;
  salesforce_primary_contact_id?: InputMaybe<Order_By>;
  salesforce_record_type_id?: InputMaybe<Order_By>;
  salesforce_reseller_account_id?: InputMaybe<Order_By>;
  salesforce_sbqq_amended_contract_id?: InputMaybe<Order_By>;
  salesforce_sbqq_primary_quote_id?: InputMaybe<Order_By>;
  salesforce_sbqq_renewed_contract_id?: InputMaybe<Order_By>;
  salesforce_synced_quote_id?: InputMaybe<Order_By>;
  salesforce_target_id?: InputMaybe<Order_By>;
  sbqq_contracted?: InputMaybe<Order_By>;
  sbqq_create_contracted_prices?: InputMaybe<Order_By>;
  sbqq_order_group_id?: InputMaybe<Order_By>;
  sbqq_ordered?: InputMaybe<Order_By>;
  sbqq_quote_pricebook_id?: InputMaybe<Order_By>;
  sbqq_renewal?: InputMaybe<Order_By>;
  self_serve_information?: InputMaybe<Opportunity_Self_Serve_Information_Order_By>;
  so?: InputMaybe<Order_By>;
  stage_name?: InputMaybe<Order_By>;
  status_update?: InputMaybe<Order_By>;
  system_integrators?: InputMaybe<Order_By>;
  total_amount_first_year?: InputMaybe<Order_By>;
  total_opportunity_quantity?: InputMaybe<Order_By>;
  tracking_number?: InputMaybe<Order_By>;
  ts_cpm_fee?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vod_delivery_fee?: InputMaybe<Order_By>;
  vod_mgmt_fee?: InputMaybe<Order_By>;
  vod_transcoding_fee?: InputMaybe<Order_By>;
  weighted_booking?: InputMaybe<Order_By>;
  weighted_mrr?: InputMaybe<Order_By>;
};

/** select columns of table "opportunity" */
export enum Opportunity_Select_Column {
  /** column name */
  AdsPlus = 'ads_plus',
  /** column name */
  AmgId = 'amg_id',
  /** column name */
  Amount = 'amount',
  /** column name */
  AnnualContractValue = 'annual_contract_value',
  /** column name */
  ApprovalSubmittedDate = 'approval_submitted_date',
  /** column name */
  ApprovalTime = 'approval_time',
  /** column name */
  AwsInvolved = 'aws_involved',
  /** column name */
  BillingEstimateForFy = 'billing_estimate_for_fy',
  /** column name */
  BillingGeography = 'billing_geography',
  /** column name */
  BreadWinnerTotalAmountDue = 'bread_winner_total_amount_due',
  /** column name */
  BreadWinnerTotalAmountInvoiced = 'bread_winner_total_amount_invoiced',
  /** column name */
  BreadWinnerTotalAmountOverdue = 'bread_winner_total_amount_overdue',
  /** column name */
  BreadWinnerTotalAmountPaid = 'bread_winner_total_amount_paid',
  /** column name */
  BreadWinnerTotalDraftAmount = 'bread_winner_total_draft_amount',
  /** column name */
  CdnFeePerGb = 'cdn_fee_per_gb',
  /** column name */
  CloseDate = 'close_date',
  /** column name */
  CloudPartner = 'cloud_partner',
  /** column name */
  CommissionPercentage = 'commission_percentage',
  /** column name */
  CommissionValue = 'commission_value',
  /** column name */
  Competition = 'competition',
  /** column name */
  ContactSalesforceOwnerId = 'contact_salesforce_owner_id',
  /** column name */
  ContentPlus = 'content_plus',
  /** column name */
  ContractPeriod = 'contract_period',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBySalesforceOwnerId = 'created_by_salesforce_owner_id',
  /** column name */
  Csm = 'csm',
  /** column name */
  CurrencyIsoCode = 'currency_iso_code',
  /** column name */
  CurrentGenerators = 'current_generators',
  /** column name */
  DeliveryDate = 'delivery_date',
  /** column name */
  DeliveryInstallationStatus = 'delivery_installation_status',
  /** column name */
  DepositFee = 'deposit_fee',
  /** column name */
  DescribeTheReasonForClosedLost = 'describe_the_reason_for_closed_lost',
  /** column name */
  Description = 'description',
  /** column name */
  DetailsFromProposalFrom = 'details_from_proposal_from',
  /** column name */
  ExpectedRevenue = 'expected_revenue',
  /** column name */
  Fiscal = 'fiscal',
  /** column name */
  FiscalQuarter = 'fiscal_quarter',
  /** column name */
  FiscalYear = 'fiscal_year',
  /** column name */
  ForecastCategory = 'forecast_category',
  /** column name */
  ForecastCategoryName = 'forecast_category_name',
  /** column name */
  FsysForecastCategory = 'fsys_forecast_category',
  /** column name */
  GcpInvolvement = 'gcp_involvement',
  /** column name */
  GoLiveDate = 'go_live_date',
  /** column name */
  GrossMargin = 'gross_margin',
  /** column name */
  HasOpportunityLineItem = 'has_opportunity_line_item',
  /** column name */
  HasOverdueTask = 'has_overdue_task',
  /** column name */
  Impact = 'impact',
  /** column name */
  InitialFees = 'initial_fees',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsInfluenced = 'is_influenced',
  /** column name */
  IsPrivate = 'is_private',
  /** column name */
  IsSplit = 'is_split',
  /** column name */
  IsWon = 'is_won',
  /** column name */
  LeadSource = 'lead_source',
  /** column name */
  LifetimeContractValue = 'lifetime_contract_value',
  /** column name */
  LinkedInCompanyId = 'linked_in_company_id',
  /** column name */
  MainCompetitors = 'main_competitors',
  /** column name */
  ModifiedCommission = 'modified_commission',
  /** column name */
  MonetizationModel = 'monetization_model',
  /** column name */
  MonthlyFees = 'monthly_fees',
  /** column name */
  Name = 'name',
  /** column name */
  NextStepBy = 'next_step_by',
  /** column name */
  NextStepDueDate = 'next_step_due_date',
  /** column name */
  OldProbability = 'old_probability',
  /** column name */
  OpportunityType = 'opportunity_type',
  /** column name */
  OrderNumber = 'order_number',
  /** column name */
  PowerOf_1 = 'power_of_1',
  /** column name */
  PreSalesDelay = 'pre_sales_delay',
  /** column name */
  PreSalesDueDate = 'pre_sales_due_date',
  /** column name */
  PresalesInvoled = 'presales_involed',
  /** column name */
  PresalesStatus = 'presales_status',
  /** column name */
  PresalesUpdate = 'presales_update',
  /** column name */
  Probability = 'probability',
  /** column name */
  Product = 'product',
  /** column name */
  ProspectStrength = 'prospect_strength',
  /** column name */
  ReasonForClosedLost = 'reason_for_closed_lost',
  /** column name */
  ReasonForClosedWon = 'reason_for_closed_won',
  /** column name */
  Region = 'region',
  /** column name */
  RenewalDateTemporary = 'renewal_date_temporary',
  /** column name */
  RequestOrigin = 'request_origin',
  /** column name */
  RequestorEmail = 'requestor_email',
  /** column name */
  RequestorName = 'requestor_name',
  /** column name */
  RevShare = 'rev_share',
  /** column name */
  SalesChannel = 'sales_channel',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SalesforceCampaignId = 'salesforce_campaign_id',
  /** column name */
  SalesforceContractId = 'salesforce_contract_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  SalesforceOwnerId = 'salesforce_owner_id',
  /** column name */
  SalesforcePartnerAccountId = 'salesforce_partner_account_id',
  /** column name */
  SalesforcePrimaryContactId = 'salesforce_primary_contact_id',
  /** column name */
  SalesforceRecordTypeId = 'salesforce_record_type_id',
  /** column name */
  SalesforceResellerAccountId = 'salesforce_reseller_account_id',
  /** column name */
  SalesforceSbqqAmendedContractId = 'salesforce_sbqq_amended_contract_id',
  /** column name */
  SalesforceSbqqPrimaryQuoteId = 'salesforce_sbqq_primary_quote_id',
  /** column name */
  SalesforceSbqqRenewedContractId = 'salesforce_sbqq_renewed_contract_id',
  /** column name */
  SalesforceSyncedQuoteId = 'salesforce_synced_quote_id',
  /** column name */
  SalesforceTargetId = 'salesforce_target_id',
  /** column name */
  SbqqContracted = 'sbqq_contracted',
  /** column name */
  SbqqCreateContractedPrices = 'sbqq_create_contracted_prices',
  /** column name */
  SbqqOrderGroupId = 'sbqq_order_group_id',
  /** column name */
  SbqqOrdered = 'sbqq_ordered',
  /** column name */
  SbqqQuotePricebookId = 'sbqq_quote_pricebook_id',
  /** column name */
  SbqqRenewal = 'sbqq_renewal',
  /** column name */
  So = 'so',
  /** column name */
  StageName = 'stage_name',
  /** column name */
  StatusUpdate = 'status_update',
  /** column name */
  SystemIntegrators = 'system_integrators',
  /** column name */
  TotalAmountFirstYear = 'total_amount_first_year',
  /** column name */
  TotalOpportunityQuantity = 'total_opportunity_quantity',
  /** column name */
  TrackingNumber = 'tracking_number',
  /** column name */
  TsCpmFee = 'ts_cpm_fee',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VodDeliveryFee = 'vod_delivery_fee',
  /** column name */
  VodMgmtFee = 'vod_mgmt_fee',
  /** column name */
  VodTranscodingFee = 'vod_transcoding_fee',
  /** column name */
  WeightedBooking = 'weighted_booking',
  /** column name */
  WeightedMrr = 'weighted_mrr'
}

/** select "opportunity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "opportunity" */
export enum Opportunity_Select_Column_Opportunity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AdsPlus = 'ads_plus',
  /** column name */
  AwsInvolved = 'aws_involved',
  /** column name */
  ContentPlus = 'content_plus',
  /** column name */
  GcpInvolvement = 'gcp_involvement',
  /** column name */
  HasOpportunityLineItem = 'has_opportunity_line_item',
  /** column name */
  HasOverdueTask = 'has_overdue_task',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsInfluenced = 'is_influenced',
  /** column name */
  IsPrivate = 'is_private',
  /** column name */
  IsSplit = 'is_split',
  /** column name */
  IsWon = 'is_won',
  /** column name */
  SbqqContracted = 'sbqq_contracted',
  /** column name */
  SbqqCreateContractedPrices = 'sbqq_create_contracted_prices',
  /** column name */
  SbqqOrdered = 'sbqq_ordered',
  /** column name */
  SbqqRenewal = 'sbqq_renewal'
}

/** select "opportunity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "opportunity" */
export enum Opportunity_Select_Column_Opportunity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AdsPlus = 'ads_plus',
  /** column name */
  AwsInvolved = 'aws_involved',
  /** column name */
  ContentPlus = 'content_plus',
  /** column name */
  GcpInvolvement = 'gcp_involvement',
  /** column name */
  HasOpportunityLineItem = 'has_opportunity_line_item',
  /** column name */
  HasOverdueTask = 'has_overdue_task',
  /** column name */
  IsApproved = 'is_approved',
  /** column name */
  IsClosed = 'is_closed',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsInfluenced = 'is_influenced',
  /** column name */
  IsPrivate = 'is_private',
  /** column name */
  IsSplit = 'is_split',
  /** column name */
  IsWon = 'is_won',
  /** column name */
  SbqqContracted = 'sbqq_contracted',
  /** column name */
  SbqqCreateContractedPrices = 'sbqq_create_contracted_prices',
  /** column name */
  SbqqOrdered = 'sbqq_ordered',
  /** column name */
  SbqqRenewal = 'sbqq_renewal'
}

/** columns and relationships of "opportunity_self_serve_information" */
export type Opportunity_Self_Serve_Information = {
  __typename?: 'opportunity_self_serve_information';
  request_origin?: Maybe<Scalars['String']>;
  requestor_email?: Maybe<Scalars['String']>;
  requestor_name?: Maybe<Scalars['String']>;
  salesforce_opportunity_id?: Maybe<Scalars['String']>;
};

/** aggregated selection of "opportunity_self_serve_information" */
export type Opportunity_Self_Serve_Information_Aggregate = {
  __typename?: 'opportunity_self_serve_information_aggregate';
  aggregate?: Maybe<Opportunity_Self_Serve_Information_Aggregate_Fields>;
  nodes: Array<Opportunity_Self_Serve_Information>;
};

/** aggregate fields of "opportunity_self_serve_information" */
export type Opportunity_Self_Serve_Information_Aggregate_Fields = {
  __typename?: 'opportunity_self_serve_information_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Opportunity_Self_Serve_Information_Max_Fields>;
  min?: Maybe<Opportunity_Self_Serve_Information_Min_Fields>;
};


/** aggregate fields of "opportunity_self_serve_information" */
export type Opportunity_Self_Serve_Information_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Opportunity_Self_Serve_Information_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "opportunity_self_serve_information". All fields are combined with a logical 'AND'. */
export type Opportunity_Self_Serve_Information_Bool_Exp = {
  _and?: InputMaybe<Array<Opportunity_Self_Serve_Information_Bool_Exp>>;
  _not?: InputMaybe<Opportunity_Self_Serve_Information_Bool_Exp>;
  _or?: InputMaybe<Array<Opportunity_Self_Serve_Information_Bool_Exp>>;
  request_origin?: InputMaybe<String_Comparison_Exp>;
  requestor_email?: InputMaybe<String_Comparison_Exp>;
  requestor_name?: InputMaybe<String_Comparison_Exp>;
  salesforce_opportunity_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Opportunity_Self_Serve_Information_Max_Fields = {
  __typename?: 'opportunity_self_serve_information_max_fields';
  request_origin?: Maybe<Scalars['String']>;
  requestor_email?: Maybe<Scalars['String']>;
  requestor_name?: Maybe<Scalars['String']>;
  salesforce_opportunity_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Opportunity_Self_Serve_Information_Min_Fields = {
  __typename?: 'opportunity_self_serve_information_min_fields';
  request_origin?: Maybe<Scalars['String']>;
  requestor_email?: Maybe<Scalars['String']>;
  requestor_name?: Maybe<Scalars['String']>;
  salesforce_opportunity_id?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "opportunity_self_serve_information". */
export type Opportunity_Self_Serve_Information_Order_By = {
  request_origin?: InputMaybe<Order_By>;
  requestor_email?: InputMaybe<Order_By>;
  requestor_name?: InputMaybe<Order_By>;
  salesforce_opportunity_id?: InputMaybe<Order_By>;
};

/** select columns of table "opportunity_self_serve_information" */
export enum Opportunity_Self_Serve_Information_Select_Column {
  /** column name */
  RequestOrigin = 'request_origin',
  /** column name */
  RequestorEmail = 'requestor_email',
  /** column name */
  RequestorName = 'requestor_name',
  /** column name */
  SalesforceOpportunityId = 'salesforce_opportunity_id'
}

/** Streaming cursor of the table "opportunity_self_serve_information" */
export type Opportunity_Self_Serve_Information_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Opportunity_Self_Serve_Information_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Opportunity_Self_Serve_Information_Stream_Cursor_Value_Input = {
  request_origin?: InputMaybe<Scalars['String']>;
  requestor_email?: InputMaybe<Scalars['String']>;
  requestor_name?: InputMaybe<Scalars['String']>;
  salesforce_opportunity_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Opportunity_Stddev_Fields = {
  __typename?: 'opportunity_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  annual_contract_value?: Maybe<Scalars['Float']>;
  billing_estimate_for_fy?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_due?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_invoiced?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_overdue?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_paid?: Maybe<Scalars['Float']>;
  bread_winner_total_draft_amount?: Maybe<Scalars['Float']>;
  cdn_fee_per_gb?: Maybe<Scalars['Float']>;
  commission_percentage?: Maybe<Scalars['Float']>;
  commission_value?: Maybe<Scalars['Float']>;
  contract_period?: Maybe<Scalars['Float']>;
  deposit_fee?: Maybe<Scalars['Float']>;
  expected_revenue?: Maybe<Scalars['Float']>;
  fiscal_quarter?: Maybe<Scalars['Float']>;
  fiscal_year?: Maybe<Scalars['Float']>;
  gross_margin?: Maybe<Scalars['Float']>;
  initial_fees?: Maybe<Scalars['Float']>;
  lifetime_contract_value?: Maybe<Scalars['Float']>;
  modified_commission?: Maybe<Scalars['Float']>;
  monthly_fees?: Maybe<Scalars['Float']>;
  old_probability?: Maybe<Scalars['Float']>;
  power_of_1?: Maybe<Scalars['Float']>;
  probability?: Maybe<Scalars['Float']>;
  rev_share?: Maybe<Scalars['Float']>;
  total_amount_first_year?: Maybe<Scalars['Float']>;
  total_opportunity_quantity?: Maybe<Scalars['Float']>;
  ts_cpm_fee?: Maybe<Scalars['Float']>;
  vod_delivery_fee?: Maybe<Scalars['Float']>;
  vod_mgmt_fee?: Maybe<Scalars['Float']>;
  vod_transcoding_fee?: Maybe<Scalars['Float']>;
  weighted_booking?: Maybe<Scalars['Float']>;
  weighted_mrr?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "opportunity" */
export type Opportunity_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  billing_estimate_for_fy?: InputMaybe<Order_By>;
  bread_winner_total_amount_due?: InputMaybe<Order_By>;
  bread_winner_total_amount_invoiced?: InputMaybe<Order_By>;
  bread_winner_total_amount_overdue?: InputMaybe<Order_By>;
  bread_winner_total_amount_paid?: InputMaybe<Order_By>;
  bread_winner_total_draft_amount?: InputMaybe<Order_By>;
  cdn_fee_per_gb?: InputMaybe<Order_By>;
  commission_percentage?: InputMaybe<Order_By>;
  commission_value?: InputMaybe<Order_By>;
  contract_period?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  expected_revenue?: InputMaybe<Order_By>;
  fiscal_quarter?: InputMaybe<Order_By>;
  fiscal_year?: InputMaybe<Order_By>;
  gross_margin?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  modified_commission?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  old_probability?: InputMaybe<Order_By>;
  power_of_1?: InputMaybe<Order_By>;
  probability?: InputMaybe<Order_By>;
  rev_share?: InputMaybe<Order_By>;
  total_amount_first_year?: InputMaybe<Order_By>;
  total_opportunity_quantity?: InputMaybe<Order_By>;
  ts_cpm_fee?: InputMaybe<Order_By>;
  vod_delivery_fee?: InputMaybe<Order_By>;
  vod_mgmt_fee?: InputMaybe<Order_By>;
  vod_transcoding_fee?: InputMaybe<Order_By>;
  weighted_booking?: InputMaybe<Order_By>;
  weighted_mrr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Opportunity_Stddev_Pop_Fields = {
  __typename?: 'opportunity_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  annual_contract_value?: Maybe<Scalars['Float']>;
  billing_estimate_for_fy?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_due?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_invoiced?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_overdue?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_paid?: Maybe<Scalars['Float']>;
  bread_winner_total_draft_amount?: Maybe<Scalars['Float']>;
  cdn_fee_per_gb?: Maybe<Scalars['Float']>;
  commission_percentage?: Maybe<Scalars['Float']>;
  commission_value?: Maybe<Scalars['Float']>;
  contract_period?: Maybe<Scalars['Float']>;
  deposit_fee?: Maybe<Scalars['Float']>;
  expected_revenue?: Maybe<Scalars['Float']>;
  fiscal_quarter?: Maybe<Scalars['Float']>;
  fiscal_year?: Maybe<Scalars['Float']>;
  gross_margin?: Maybe<Scalars['Float']>;
  initial_fees?: Maybe<Scalars['Float']>;
  lifetime_contract_value?: Maybe<Scalars['Float']>;
  modified_commission?: Maybe<Scalars['Float']>;
  monthly_fees?: Maybe<Scalars['Float']>;
  old_probability?: Maybe<Scalars['Float']>;
  power_of_1?: Maybe<Scalars['Float']>;
  probability?: Maybe<Scalars['Float']>;
  rev_share?: Maybe<Scalars['Float']>;
  total_amount_first_year?: Maybe<Scalars['Float']>;
  total_opportunity_quantity?: Maybe<Scalars['Float']>;
  ts_cpm_fee?: Maybe<Scalars['Float']>;
  vod_delivery_fee?: Maybe<Scalars['Float']>;
  vod_mgmt_fee?: Maybe<Scalars['Float']>;
  vod_transcoding_fee?: Maybe<Scalars['Float']>;
  weighted_booking?: Maybe<Scalars['Float']>;
  weighted_mrr?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "opportunity" */
export type Opportunity_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  billing_estimate_for_fy?: InputMaybe<Order_By>;
  bread_winner_total_amount_due?: InputMaybe<Order_By>;
  bread_winner_total_amount_invoiced?: InputMaybe<Order_By>;
  bread_winner_total_amount_overdue?: InputMaybe<Order_By>;
  bread_winner_total_amount_paid?: InputMaybe<Order_By>;
  bread_winner_total_draft_amount?: InputMaybe<Order_By>;
  cdn_fee_per_gb?: InputMaybe<Order_By>;
  commission_percentage?: InputMaybe<Order_By>;
  commission_value?: InputMaybe<Order_By>;
  contract_period?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  expected_revenue?: InputMaybe<Order_By>;
  fiscal_quarter?: InputMaybe<Order_By>;
  fiscal_year?: InputMaybe<Order_By>;
  gross_margin?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  modified_commission?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  old_probability?: InputMaybe<Order_By>;
  power_of_1?: InputMaybe<Order_By>;
  probability?: InputMaybe<Order_By>;
  rev_share?: InputMaybe<Order_By>;
  total_amount_first_year?: InputMaybe<Order_By>;
  total_opportunity_quantity?: InputMaybe<Order_By>;
  ts_cpm_fee?: InputMaybe<Order_By>;
  vod_delivery_fee?: InputMaybe<Order_By>;
  vod_mgmt_fee?: InputMaybe<Order_By>;
  vod_transcoding_fee?: InputMaybe<Order_By>;
  weighted_booking?: InputMaybe<Order_By>;
  weighted_mrr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Opportunity_Stddev_Samp_Fields = {
  __typename?: 'opportunity_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  annual_contract_value?: Maybe<Scalars['Float']>;
  billing_estimate_for_fy?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_due?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_invoiced?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_overdue?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_paid?: Maybe<Scalars['Float']>;
  bread_winner_total_draft_amount?: Maybe<Scalars['Float']>;
  cdn_fee_per_gb?: Maybe<Scalars['Float']>;
  commission_percentage?: Maybe<Scalars['Float']>;
  commission_value?: Maybe<Scalars['Float']>;
  contract_period?: Maybe<Scalars['Float']>;
  deposit_fee?: Maybe<Scalars['Float']>;
  expected_revenue?: Maybe<Scalars['Float']>;
  fiscal_quarter?: Maybe<Scalars['Float']>;
  fiscal_year?: Maybe<Scalars['Float']>;
  gross_margin?: Maybe<Scalars['Float']>;
  initial_fees?: Maybe<Scalars['Float']>;
  lifetime_contract_value?: Maybe<Scalars['Float']>;
  modified_commission?: Maybe<Scalars['Float']>;
  monthly_fees?: Maybe<Scalars['Float']>;
  old_probability?: Maybe<Scalars['Float']>;
  power_of_1?: Maybe<Scalars['Float']>;
  probability?: Maybe<Scalars['Float']>;
  rev_share?: Maybe<Scalars['Float']>;
  total_amount_first_year?: Maybe<Scalars['Float']>;
  total_opportunity_quantity?: Maybe<Scalars['Float']>;
  ts_cpm_fee?: Maybe<Scalars['Float']>;
  vod_delivery_fee?: Maybe<Scalars['Float']>;
  vod_mgmt_fee?: Maybe<Scalars['Float']>;
  vod_transcoding_fee?: Maybe<Scalars['Float']>;
  weighted_booking?: Maybe<Scalars['Float']>;
  weighted_mrr?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "opportunity" */
export type Opportunity_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  billing_estimate_for_fy?: InputMaybe<Order_By>;
  bread_winner_total_amount_due?: InputMaybe<Order_By>;
  bread_winner_total_amount_invoiced?: InputMaybe<Order_By>;
  bread_winner_total_amount_overdue?: InputMaybe<Order_By>;
  bread_winner_total_amount_paid?: InputMaybe<Order_By>;
  bread_winner_total_draft_amount?: InputMaybe<Order_By>;
  cdn_fee_per_gb?: InputMaybe<Order_By>;
  commission_percentage?: InputMaybe<Order_By>;
  commission_value?: InputMaybe<Order_By>;
  contract_period?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  expected_revenue?: InputMaybe<Order_By>;
  fiscal_quarter?: InputMaybe<Order_By>;
  fiscal_year?: InputMaybe<Order_By>;
  gross_margin?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  modified_commission?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  old_probability?: InputMaybe<Order_By>;
  power_of_1?: InputMaybe<Order_By>;
  probability?: InputMaybe<Order_By>;
  rev_share?: InputMaybe<Order_By>;
  total_amount_first_year?: InputMaybe<Order_By>;
  total_opportunity_quantity?: InputMaybe<Order_By>;
  ts_cpm_fee?: InputMaybe<Order_By>;
  vod_delivery_fee?: InputMaybe<Order_By>;
  vod_mgmt_fee?: InputMaybe<Order_By>;
  vod_transcoding_fee?: InputMaybe<Order_By>;
  weighted_booking?: InputMaybe<Order_By>;
  weighted_mrr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "opportunity" */
export type Opportunity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Opportunity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Opportunity_Stream_Cursor_Value_Input = {
  ads_plus?: InputMaybe<Scalars['Boolean']>;
  amg_id?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['numeric']>;
  annual_contract_value?: InputMaybe<Scalars['numeric']>;
  approval_submitted_date?: InputMaybe<Scalars['timestamptz']>;
  approval_time?: InputMaybe<Scalars['String']>;
  aws_involved?: InputMaybe<Scalars['Boolean']>;
  billing_estimate_for_fy?: InputMaybe<Scalars['numeric']>;
  billing_geography?: InputMaybe<Scalars['String']>;
  bread_winner_total_amount_due?: InputMaybe<Scalars['numeric']>;
  bread_winner_total_amount_invoiced?: InputMaybe<Scalars['numeric']>;
  bread_winner_total_amount_overdue?: InputMaybe<Scalars['numeric']>;
  bread_winner_total_amount_paid?: InputMaybe<Scalars['numeric']>;
  bread_winner_total_draft_amount?: InputMaybe<Scalars['numeric']>;
  cdn_fee_per_gb?: InputMaybe<Scalars['numeric']>;
  close_date?: InputMaybe<Scalars['date']>;
  cloud_partner?: InputMaybe<Scalars['String']>;
  commission_percentage?: InputMaybe<Scalars['numeric']>;
  commission_value?: InputMaybe<Scalars['numeric']>;
  competition?: InputMaybe<Scalars['String']>;
  contact_salesforce_owner_id?: InputMaybe<Scalars['String']>;
  content_plus?: InputMaybe<Scalars['Boolean']>;
  contract_period?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  created_by_salesforce_owner_id?: InputMaybe<Scalars['String']>;
  csm?: InputMaybe<Scalars['String']>;
  currency_iso_code?: InputMaybe<Scalars['String']>;
  current_generators?: InputMaybe<Scalars['String']>;
  delivery_date?: InputMaybe<Scalars['date']>;
  delivery_installation_status?: InputMaybe<Scalars['String']>;
  deposit_fee?: InputMaybe<Scalars['numeric']>;
  describe_the_reason_for_closed_lost?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  details_from_proposal_from?: InputMaybe<Scalars['String']>;
  expected_revenue?: InputMaybe<Scalars['numeric']>;
  fiscal?: InputMaybe<Scalars['String']>;
  fiscal_quarter?: InputMaybe<Scalars['numeric']>;
  fiscal_year?: InputMaybe<Scalars['numeric']>;
  forecast_category?: InputMaybe<Scalars['String']>;
  forecast_category_name?: InputMaybe<Scalars['String']>;
  fsys_forecast_category?: InputMaybe<Scalars['String']>;
  gcp_involvement?: InputMaybe<Scalars['Boolean']>;
  go_live_date?: InputMaybe<Scalars['date']>;
  gross_margin?: InputMaybe<Scalars['numeric']>;
  has_opportunity_line_item?: InputMaybe<Scalars['Boolean']>;
  has_overdue_task?: InputMaybe<Scalars['Boolean']>;
  impact?: InputMaybe<Scalars['String']>;
  initial_fees?: InputMaybe<Scalars['numeric']>;
  is_approved?: InputMaybe<Scalars['Boolean']>;
  is_closed?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_influenced?: InputMaybe<Scalars['Boolean']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  is_split?: InputMaybe<Scalars['Boolean']>;
  is_won?: InputMaybe<Scalars['Boolean']>;
  lead_source?: InputMaybe<Scalars['String']>;
  lifetime_contract_value?: InputMaybe<Scalars['numeric']>;
  linked_in_company_id?: InputMaybe<Scalars['String']>;
  main_competitors?: InputMaybe<Scalars['String']>;
  modified_commission?: InputMaybe<Scalars['numeric']>;
  monetization_model?: InputMaybe<Scalars['String']>;
  monthly_fees?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  next_step_by?: InputMaybe<Scalars['String']>;
  next_step_due_date?: InputMaybe<Scalars['date']>;
  old_probability?: InputMaybe<Scalars['numeric']>;
  opportunity_type?: InputMaybe<Scalars['String']>;
  order_number?: InputMaybe<Scalars['String']>;
  power_of_1?: InputMaybe<Scalars['numeric']>;
  pre_sales_delay?: InputMaybe<Scalars['String']>;
  pre_sales_due_date?: InputMaybe<Scalars['date']>;
  presales_involed?: InputMaybe<Scalars['String']>;
  presales_status?: InputMaybe<Scalars['String']>;
  presales_update?: InputMaybe<Scalars['String']>;
  probability?: InputMaybe<Scalars['numeric']>;
  product?: InputMaybe<Scalars['String']>;
  prospect_strength?: InputMaybe<Scalars['String']>;
  reason_for_closed_lost?: InputMaybe<Scalars['String']>;
  reason_for_closed_won?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  renewal_date_temporary?: InputMaybe<Scalars['date']>;
  request_origin?: InputMaybe<Scalars['String']>;
  requestor_email?: InputMaybe<Scalars['String']>;
  requestor_name?: InputMaybe<Scalars['String']>;
  rev_share?: InputMaybe<Scalars['numeric']>;
  sales_channel?: InputMaybe<Scalars['String']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_campaign_id?: InputMaybe<Scalars['String']>;
  salesforce_contract_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_owner_id?: InputMaybe<Scalars['String']>;
  salesforce_partner_account_id?: InputMaybe<Scalars['String']>;
  salesforce_primary_contact_id?: InputMaybe<Scalars['String']>;
  salesforce_record_type_id?: InputMaybe<Scalars['String']>;
  salesforce_reseller_account_id?: InputMaybe<Scalars['String']>;
  salesforce_sbqq_amended_contract_id?: InputMaybe<Scalars['String']>;
  salesforce_sbqq_primary_quote_id?: InputMaybe<Scalars['String']>;
  salesforce_sbqq_renewed_contract_id?: InputMaybe<Scalars['String']>;
  salesforce_synced_quote_id?: InputMaybe<Scalars['String']>;
  salesforce_target_id?: InputMaybe<Scalars['String']>;
  sbqq_contracted?: InputMaybe<Scalars['Boolean']>;
  sbqq_create_contracted_prices?: InputMaybe<Scalars['Boolean']>;
  sbqq_order_group_id?: InputMaybe<Scalars['String']>;
  sbqq_ordered?: InputMaybe<Scalars['Boolean']>;
  sbqq_quote_pricebook_id?: InputMaybe<Scalars['String']>;
  sbqq_renewal?: InputMaybe<Scalars['Boolean']>;
  so?: InputMaybe<Scalars['String']>;
  stage_name?: InputMaybe<Scalars['String']>;
  status_update?: InputMaybe<Scalars['String']>;
  system_integrators?: InputMaybe<Scalars['String']>;
  total_amount_first_year?: InputMaybe<Scalars['numeric']>;
  total_opportunity_quantity?: InputMaybe<Scalars['numeric']>;
  tracking_number?: InputMaybe<Scalars['String']>;
  ts_cpm_fee?: InputMaybe<Scalars['numeric']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  vod_delivery_fee?: InputMaybe<Scalars['numeric']>;
  vod_mgmt_fee?: InputMaybe<Scalars['numeric']>;
  vod_transcoding_fee?: InputMaybe<Scalars['numeric']>;
  weighted_booking?: InputMaybe<Scalars['numeric']>;
  weighted_mrr?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Opportunity_Sum_Fields = {
  __typename?: 'opportunity_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  annual_contract_value?: Maybe<Scalars['numeric']>;
  billing_estimate_for_fy?: Maybe<Scalars['numeric']>;
  bread_winner_total_amount_due?: Maybe<Scalars['numeric']>;
  bread_winner_total_amount_invoiced?: Maybe<Scalars['numeric']>;
  bread_winner_total_amount_overdue?: Maybe<Scalars['numeric']>;
  bread_winner_total_amount_paid?: Maybe<Scalars['numeric']>;
  bread_winner_total_draft_amount?: Maybe<Scalars['numeric']>;
  cdn_fee_per_gb?: Maybe<Scalars['numeric']>;
  commission_percentage?: Maybe<Scalars['numeric']>;
  commission_value?: Maybe<Scalars['numeric']>;
  contract_period?: Maybe<Scalars['numeric']>;
  deposit_fee?: Maybe<Scalars['numeric']>;
  expected_revenue?: Maybe<Scalars['numeric']>;
  fiscal_quarter?: Maybe<Scalars['numeric']>;
  fiscal_year?: Maybe<Scalars['numeric']>;
  gross_margin?: Maybe<Scalars['numeric']>;
  initial_fees?: Maybe<Scalars['numeric']>;
  lifetime_contract_value?: Maybe<Scalars['numeric']>;
  modified_commission?: Maybe<Scalars['numeric']>;
  monthly_fees?: Maybe<Scalars['numeric']>;
  old_probability?: Maybe<Scalars['numeric']>;
  power_of_1?: Maybe<Scalars['numeric']>;
  probability?: Maybe<Scalars['numeric']>;
  rev_share?: Maybe<Scalars['numeric']>;
  total_amount_first_year?: Maybe<Scalars['numeric']>;
  total_opportunity_quantity?: Maybe<Scalars['numeric']>;
  ts_cpm_fee?: Maybe<Scalars['numeric']>;
  vod_delivery_fee?: Maybe<Scalars['numeric']>;
  vod_mgmt_fee?: Maybe<Scalars['numeric']>;
  vod_transcoding_fee?: Maybe<Scalars['numeric']>;
  weighted_booking?: Maybe<Scalars['numeric']>;
  weighted_mrr?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "opportunity" */
export type Opportunity_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  billing_estimate_for_fy?: InputMaybe<Order_By>;
  bread_winner_total_amount_due?: InputMaybe<Order_By>;
  bread_winner_total_amount_invoiced?: InputMaybe<Order_By>;
  bread_winner_total_amount_overdue?: InputMaybe<Order_By>;
  bread_winner_total_amount_paid?: InputMaybe<Order_By>;
  bread_winner_total_draft_amount?: InputMaybe<Order_By>;
  cdn_fee_per_gb?: InputMaybe<Order_By>;
  commission_percentage?: InputMaybe<Order_By>;
  commission_value?: InputMaybe<Order_By>;
  contract_period?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  expected_revenue?: InputMaybe<Order_By>;
  fiscal_quarter?: InputMaybe<Order_By>;
  fiscal_year?: InputMaybe<Order_By>;
  gross_margin?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  modified_commission?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  old_probability?: InputMaybe<Order_By>;
  power_of_1?: InputMaybe<Order_By>;
  probability?: InputMaybe<Order_By>;
  rev_share?: InputMaybe<Order_By>;
  total_amount_first_year?: InputMaybe<Order_By>;
  total_opportunity_quantity?: InputMaybe<Order_By>;
  ts_cpm_fee?: InputMaybe<Order_By>;
  vod_delivery_fee?: InputMaybe<Order_By>;
  vod_mgmt_fee?: InputMaybe<Order_By>;
  vod_transcoding_fee?: InputMaybe<Order_By>;
  weighted_booking?: InputMaybe<Order_By>;
  weighted_mrr?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Opportunity_Var_Pop_Fields = {
  __typename?: 'opportunity_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  annual_contract_value?: Maybe<Scalars['Float']>;
  billing_estimate_for_fy?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_due?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_invoiced?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_overdue?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_paid?: Maybe<Scalars['Float']>;
  bread_winner_total_draft_amount?: Maybe<Scalars['Float']>;
  cdn_fee_per_gb?: Maybe<Scalars['Float']>;
  commission_percentage?: Maybe<Scalars['Float']>;
  commission_value?: Maybe<Scalars['Float']>;
  contract_period?: Maybe<Scalars['Float']>;
  deposit_fee?: Maybe<Scalars['Float']>;
  expected_revenue?: Maybe<Scalars['Float']>;
  fiscal_quarter?: Maybe<Scalars['Float']>;
  fiscal_year?: Maybe<Scalars['Float']>;
  gross_margin?: Maybe<Scalars['Float']>;
  initial_fees?: Maybe<Scalars['Float']>;
  lifetime_contract_value?: Maybe<Scalars['Float']>;
  modified_commission?: Maybe<Scalars['Float']>;
  monthly_fees?: Maybe<Scalars['Float']>;
  old_probability?: Maybe<Scalars['Float']>;
  power_of_1?: Maybe<Scalars['Float']>;
  probability?: Maybe<Scalars['Float']>;
  rev_share?: Maybe<Scalars['Float']>;
  total_amount_first_year?: Maybe<Scalars['Float']>;
  total_opportunity_quantity?: Maybe<Scalars['Float']>;
  ts_cpm_fee?: Maybe<Scalars['Float']>;
  vod_delivery_fee?: Maybe<Scalars['Float']>;
  vod_mgmt_fee?: Maybe<Scalars['Float']>;
  vod_transcoding_fee?: Maybe<Scalars['Float']>;
  weighted_booking?: Maybe<Scalars['Float']>;
  weighted_mrr?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "opportunity" */
export type Opportunity_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  billing_estimate_for_fy?: InputMaybe<Order_By>;
  bread_winner_total_amount_due?: InputMaybe<Order_By>;
  bread_winner_total_amount_invoiced?: InputMaybe<Order_By>;
  bread_winner_total_amount_overdue?: InputMaybe<Order_By>;
  bread_winner_total_amount_paid?: InputMaybe<Order_By>;
  bread_winner_total_draft_amount?: InputMaybe<Order_By>;
  cdn_fee_per_gb?: InputMaybe<Order_By>;
  commission_percentage?: InputMaybe<Order_By>;
  commission_value?: InputMaybe<Order_By>;
  contract_period?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  expected_revenue?: InputMaybe<Order_By>;
  fiscal_quarter?: InputMaybe<Order_By>;
  fiscal_year?: InputMaybe<Order_By>;
  gross_margin?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  modified_commission?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  old_probability?: InputMaybe<Order_By>;
  power_of_1?: InputMaybe<Order_By>;
  probability?: InputMaybe<Order_By>;
  rev_share?: InputMaybe<Order_By>;
  total_amount_first_year?: InputMaybe<Order_By>;
  total_opportunity_quantity?: InputMaybe<Order_By>;
  ts_cpm_fee?: InputMaybe<Order_By>;
  vod_delivery_fee?: InputMaybe<Order_By>;
  vod_mgmt_fee?: InputMaybe<Order_By>;
  vod_transcoding_fee?: InputMaybe<Order_By>;
  weighted_booking?: InputMaybe<Order_By>;
  weighted_mrr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Opportunity_Var_Samp_Fields = {
  __typename?: 'opportunity_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  annual_contract_value?: Maybe<Scalars['Float']>;
  billing_estimate_for_fy?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_due?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_invoiced?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_overdue?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_paid?: Maybe<Scalars['Float']>;
  bread_winner_total_draft_amount?: Maybe<Scalars['Float']>;
  cdn_fee_per_gb?: Maybe<Scalars['Float']>;
  commission_percentage?: Maybe<Scalars['Float']>;
  commission_value?: Maybe<Scalars['Float']>;
  contract_period?: Maybe<Scalars['Float']>;
  deposit_fee?: Maybe<Scalars['Float']>;
  expected_revenue?: Maybe<Scalars['Float']>;
  fiscal_quarter?: Maybe<Scalars['Float']>;
  fiscal_year?: Maybe<Scalars['Float']>;
  gross_margin?: Maybe<Scalars['Float']>;
  initial_fees?: Maybe<Scalars['Float']>;
  lifetime_contract_value?: Maybe<Scalars['Float']>;
  modified_commission?: Maybe<Scalars['Float']>;
  monthly_fees?: Maybe<Scalars['Float']>;
  old_probability?: Maybe<Scalars['Float']>;
  power_of_1?: Maybe<Scalars['Float']>;
  probability?: Maybe<Scalars['Float']>;
  rev_share?: Maybe<Scalars['Float']>;
  total_amount_first_year?: Maybe<Scalars['Float']>;
  total_opportunity_quantity?: Maybe<Scalars['Float']>;
  ts_cpm_fee?: Maybe<Scalars['Float']>;
  vod_delivery_fee?: Maybe<Scalars['Float']>;
  vod_mgmt_fee?: Maybe<Scalars['Float']>;
  vod_transcoding_fee?: Maybe<Scalars['Float']>;
  weighted_booking?: Maybe<Scalars['Float']>;
  weighted_mrr?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "opportunity" */
export type Opportunity_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  billing_estimate_for_fy?: InputMaybe<Order_By>;
  bread_winner_total_amount_due?: InputMaybe<Order_By>;
  bread_winner_total_amount_invoiced?: InputMaybe<Order_By>;
  bread_winner_total_amount_overdue?: InputMaybe<Order_By>;
  bread_winner_total_amount_paid?: InputMaybe<Order_By>;
  bread_winner_total_draft_amount?: InputMaybe<Order_By>;
  cdn_fee_per_gb?: InputMaybe<Order_By>;
  commission_percentage?: InputMaybe<Order_By>;
  commission_value?: InputMaybe<Order_By>;
  contract_period?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  expected_revenue?: InputMaybe<Order_By>;
  fiscal_quarter?: InputMaybe<Order_By>;
  fiscal_year?: InputMaybe<Order_By>;
  gross_margin?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  modified_commission?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  old_probability?: InputMaybe<Order_By>;
  power_of_1?: InputMaybe<Order_By>;
  probability?: InputMaybe<Order_By>;
  rev_share?: InputMaybe<Order_By>;
  total_amount_first_year?: InputMaybe<Order_By>;
  total_opportunity_quantity?: InputMaybe<Order_By>;
  ts_cpm_fee?: InputMaybe<Order_By>;
  vod_delivery_fee?: InputMaybe<Order_By>;
  vod_mgmt_fee?: InputMaybe<Order_By>;
  vod_transcoding_fee?: InputMaybe<Order_By>;
  weighted_booking?: InputMaybe<Order_By>;
  weighted_mrr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Opportunity_Variance_Fields = {
  __typename?: 'opportunity_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  annual_contract_value?: Maybe<Scalars['Float']>;
  billing_estimate_for_fy?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_due?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_invoiced?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_overdue?: Maybe<Scalars['Float']>;
  bread_winner_total_amount_paid?: Maybe<Scalars['Float']>;
  bread_winner_total_draft_amount?: Maybe<Scalars['Float']>;
  cdn_fee_per_gb?: Maybe<Scalars['Float']>;
  commission_percentage?: Maybe<Scalars['Float']>;
  commission_value?: Maybe<Scalars['Float']>;
  contract_period?: Maybe<Scalars['Float']>;
  deposit_fee?: Maybe<Scalars['Float']>;
  expected_revenue?: Maybe<Scalars['Float']>;
  fiscal_quarter?: Maybe<Scalars['Float']>;
  fiscal_year?: Maybe<Scalars['Float']>;
  gross_margin?: Maybe<Scalars['Float']>;
  initial_fees?: Maybe<Scalars['Float']>;
  lifetime_contract_value?: Maybe<Scalars['Float']>;
  modified_commission?: Maybe<Scalars['Float']>;
  monthly_fees?: Maybe<Scalars['Float']>;
  old_probability?: Maybe<Scalars['Float']>;
  power_of_1?: Maybe<Scalars['Float']>;
  probability?: Maybe<Scalars['Float']>;
  rev_share?: Maybe<Scalars['Float']>;
  total_amount_first_year?: Maybe<Scalars['Float']>;
  total_opportunity_quantity?: Maybe<Scalars['Float']>;
  ts_cpm_fee?: Maybe<Scalars['Float']>;
  vod_delivery_fee?: Maybe<Scalars['Float']>;
  vod_mgmt_fee?: Maybe<Scalars['Float']>;
  vod_transcoding_fee?: Maybe<Scalars['Float']>;
  weighted_booking?: Maybe<Scalars['Float']>;
  weighted_mrr?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "opportunity" */
export type Opportunity_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  billing_estimate_for_fy?: InputMaybe<Order_By>;
  bread_winner_total_amount_due?: InputMaybe<Order_By>;
  bread_winner_total_amount_invoiced?: InputMaybe<Order_By>;
  bread_winner_total_amount_overdue?: InputMaybe<Order_By>;
  bread_winner_total_amount_paid?: InputMaybe<Order_By>;
  bread_winner_total_draft_amount?: InputMaybe<Order_By>;
  cdn_fee_per_gb?: InputMaybe<Order_By>;
  commission_percentage?: InputMaybe<Order_By>;
  commission_value?: InputMaybe<Order_By>;
  contract_period?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  expected_revenue?: InputMaybe<Order_By>;
  fiscal_quarter?: InputMaybe<Order_By>;
  fiscal_year?: InputMaybe<Order_By>;
  gross_margin?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  modified_commission?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  old_probability?: InputMaybe<Order_By>;
  power_of_1?: InputMaybe<Order_By>;
  probability?: InputMaybe<Order_By>;
  rev_share?: InputMaybe<Order_By>;
  total_amount_first_year?: InputMaybe<Order_By>;
  total_opportunity_quantity?: InputMaybe<Order_By>;
  ts_cpm_fee?: InputMaybe<Order_By>;
  vod_delivery_fee?: InputMaybe<Order_By>;
  vod_mgmt_fee?: InputMaybe<Order_By>;
  vod_transcoding_fee?: InputMaybe<Order_By>;
  weighted_booking?: InputMaybe<Order_By>;
  weighted_mrr?: InputMaybe<Order_By>;
};

/** columns and relationships of "order" */
export type Order = {
  __typename?: 'order';
  activated_date?: Maybe<Scalars['timestamptz']>;
  actual_delivery_date?: Maybe<Scalars['date']>;
  actual_golive_date?: Maybe<Scalars['date']>;
  amount?: Maybe<Scalars['numeric']>;
  billing_term?: Maybe<Scalars['String']>;
  company_authorized_date?: Maybe<Scalars['date']>;
  consumption_mr_value?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  /** An object relationship */
  customer: Account;
  customer_authorized_date?: Maybe<Scalars['date']>;
  effective_date?: Maybe<Scalars['date']>;
  end_date?: Maybe<Scalars['date']>;
  handover_to_onboarding?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  invoices: Array<Invoice>;
  /** An aggregate relationship */
  invoices_aggregate: Invoice_Aggregate;
  is_deleted: Scalars['Boolean'];
  mrr_value?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  opportunity?: Maybe<Opportunity>;
  order_billing_status?: Maybe<Scalars['String']>;
  /** An array relationship */
  order_item_by_salesforce_order_id: Array<Order_Item>;
  /** An aggregate relationship */
  order_item_by_salesforce_order_id_aggregate: Order_Item_Aggregate;
  /** An array relationship */
  order_items: Array<Order_Product>;
  /** An aggregate relationship */
  order_items_aggregate: Order_Product_Aggregate;
  /** An array relationship */
  order_items_by_salesforce_order_id: Array<Order_Item>;
  /** An aggregate relationship */
  order_items_by_salesforce_order_id_aggregate: Order_Item_Aggregate;
  order_number?: Maybe<Scalars['String']>;
  /** An array relationship */
  order_products: Array<Order_Product>;
  /** An aggregate relationship */
  order_products_aggregate: Order_Product_Aggregate;
  order_type?: Maybe<Scalars['String']>;
  planned_delivery_date?: Maybe<Scalars['date']>;
  planned_golive_date?: Maybe<Scalars['date']>;
  po_date?: Maybe<Scalars['date']>;
  /** An object relationship */
  quote?: Maybe<Quote>;
  salesforce_account_id: Scalars['String'];
  salesforce_created_date: Scalars['timestamptz'];
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date: Scalars['timestamptz'];
  salesforce_opportunity_id?: Maybe<Scalars['String']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_quote_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscription_mrr_value?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "order" */
export type OrderInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrder_Item_By_Salesforce_Order_IdArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Order_By>>;
  where?: InputMaybe<Order_Item_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrder_Item_By_Salesforce_Order_Id_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Order_By>>;
  where?: InputMaybe<Order_Item_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrder_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrder_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrder_Items_By_Salesforce_Order_IdArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Order_By>>;
  where?: InputMaybe<Order_Item_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrder_Items_By_Salesforce_Order_Id_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Order_By>>;
  where?: InputMaybe<Order_Item_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrder_ProductsArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderOrder_Products_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};

/** aggregated selection of "order" */
export type Order_Aggregate = {
  __typename?: 'order_aggregate';
  aggregate?: Maybe<Order_Aggregate_Fields>;
  nodes: Array<Order>;
};

export type Order_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Order_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Order_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Order_Aggregate_Bool_Exp_Count>;
};

export type Order_Aggregate_Bool_Exp_Bool_And = {
  arguments: Order_Select_Column_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Order_Select_Column_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order" */
export type Order_Aggregate_Fields = {
  __typename?: 'order_aggregate_fields';
  avg?: Maybe<Order_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Max_Fields>;
  min?: Maybe<Order_Min_Fields>;
  stddev?: Maybe<Order_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Sum_Fields>;
  var_pop?: Maybe<Order_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Var_Samp_Fields>;
  variance?: Maybe<Order_Variance_Fields>;
};


/** aggregate fields of "order" */
export type Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order" */
export type Order_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Max_Order_By>;
  min?: InputMaybe<Order_Min_Order_By>;
  stddev?: InputMaybe<Order_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Order_Avg_Fields = {
  __typename?: 'order_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  consumption_mr_value?: Maybe<Scalars['Float']>;
  mrr_value?: Maybe<Scalars['Float']>;
  subscription_mrr_value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order" */
export type Order_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  consumption_mr_value?: InputMaybe<Order_By>;
  mrr_value?: InputMaybe<Order_By>;
  subscription_mrr_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order". All fields are combined with a logical 'AND'. */
export type Order_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Bool_Exp>>;
  _not?: InputMaybe<Order_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Bool_Exp>>;
  activated_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  actual_delivery_date?: InputMaybe<Date_Comparison_Exp>;
  actual_golive_date?: InputMaybe<Date_Comparison_Exp>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  billing_term?: InputMaybe<String_Comparison_Exp>;
  company_authorized_date?: InputMaybe<Date_Comparison_Exp>;
  consumption_mr_value?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  customer?: InputMaybe<Account_Bool_Exp>;
  customer_authorized_date?: InputMaybe<Date_Comparison_Exp>;
  effective_date?: InputMaybe<Date_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  handover_to_onboarding?: InputMaybe<Boolean_Comparison_Exp>;
  invoices?: InputMaybe<Invoice_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Bool_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  mrr_value?: InputMaybe<Numeric_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  opportunity?: InputMaybe<Opportunity_Bool_Exp>;
  order_billing_status?: InputMaybe<String_Comparison_Exp>;
  order_item_by_salesforce_order_id?: InputMaybe<Order_Item_Bool_Exp>;
  order_item_by_salesforce_order_id_aggregate?: InputMaybe<Order_Item_Aggregate_Bool_Exp>;
  order_items?: InputMaybe<Order_Product_Bool_Exp>;
  order_items_aggregate?: InputMaybe<Order_Product_Aggregate_Bool_Exp>;
  order_items_by_salesforce_order_id?: InputMaybe<Order_Item_Bool_Exp>;
  order_items_by_salesforce_order_id_aggregate?: InputMaybe<Order_Item_Aggregate_Bool_Exp>;
  order_number?: InputMaybe<String_Comparison_Exp>;
  order_products?: InputMaybe<Order_Product_Bool_Exp>;
  order_products_aggregate?: InputMaybe<Order_Product_Aggregate_Bool_Exp>;
  order_type?: InputMaybe<String_Comparison_Exp>;
  planned_delivery_date?: InputMaybe<Date_Comparison_Exp>;
  planned_golive_date?: InputMaybe<Date_Comparison_Exp>;
  po_date?: InputMaybe<Date_Comparison_Exp>;
  quote?: InputMaybe<Quote_Bool_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_opportunity_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_owner_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_quote_id?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subscription_mrr_value?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "order_item" */
export type Order_Item = {
  __typename?: 'order_item';
  actual_delivery_date?: Maybe<Scalars['date']>;
  actual_go_live_date?: Maybe<Scalars['date']>;
  approved_for_onboarding_date?: Maybe<Scalars['date']>;
  assignee?: Maybe<Scalars['String']>;
  billing_contact_name_one?: Maybe<Scalars['String']>;
  billing_contact_name_three?: Maybe<Scalars['String']>;
  billing_contact_name_two?: Maybe<Scalars['String']>;
  billing_contact_one?: Maybe<Scalars['String']>;
  billing_contact_three?: Maybe<Scalars['String']>;
  billing_contact_two?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  blocked_reason?: Maybe<Scalars['String']>;
  blocked_reason_details?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['timestamptz']>;
  delivery_id?: Maybe<Scalars['String']>;
  delivery_using_amagi_now?: Maybe<Scalars['String']>;
  epg_url?: Maybe<Scalars['String']>;
  fixed_monthly_recurring_charges?: Maybe<Scalars['numeric']>;
  initial_planned_delivery_date?: Maybe<Scalars['date']>;
  initial_planned_go_live_date?: Maybe<Scalars['date']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  monetization_model?: Maybe<Scalars['String']>;
  oit_created?: Maybe<Scalars['String']>;
  oit_integration_error_message?: Maybe<Scalars['String']>;
  oit_integration_status?: Maybe<Scalars['String']>;
  oit_team?: Maybe<Scalars['String']>;
  oit_ticket?: Maybe<Scalars['String']>;
  oit_ticket_status?: Maybe<Scalars['String']>;
  on_hold_date?: Maybe<Scalars['timestamptz']>;
  on_hold_reason?: Maybe<Scalars['String']>;
  one_time_charges?: Maybe<Scalars['numeric']>;
  opportunity_id?: Maybe<Scalars['String']>;
  opportunity_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  order?: Maybe<Order>;
  order_item_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  order_item_lines: Array<Order_Item_Line>;
  /** An aggregate relationship */
  order_item_lines_aggregate: Order_Item_Line_Aggregate;
  order_item_name?: Maybe<Scalars['String']>;
  order_no?: Maybe<Scalars['String']>;
  order_type?: Maybe<Scalars['String']>;
  /** An object relationship */
  owner?: Maybe<Owner>;
  ready_for_oit_creation?: Maybe<Scalars['Boolean']>;
  revised_expected_delivery_date?: Maybe<Scalars['date']>;
  revised_expected_delivery_date_counter?: Maybe<Scalars['numeric']>;
  revised_expected_go_live_date?: Maybe<Scalars['date']>;
  sales_account_owner?: Maybe<Scalars['String']>;
  salesforce_id: Scalars['String'];
  salesforce_order_id?: Maybe<Scalars['String']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  stream_url?: Maybe<Scalars['String']>;
  tech_lead?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "order_item" */
export type Order_ItemOrder_Item_LinesArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Line_Order_By>>;
  where?: InputMaybe<Order_Item_Line_Bool_Exp>;
};


/** columns and relationships of "order_item" */
export type Order_ItemOrder_Item_Lines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Line_Order_By>>;
  where?: InputMaybe<Order_Item_Line_Bool_Exp>;
};

/** aggregated selection of "order_item" */
export type Order_Item_Aggregate = {
  __typename?: 'order_item_aggregate';
  aggregate?: Maybe<Order_Item_Aggregate_Fields>;
  nodes: Array<Order_Item>;
};

export type Order_Item_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Order_Item_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Order_Item_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Order_Item_Aggregate_Bool_Exp_Count>;
};

export type Order_Item_Aggregate_Bool_Exp_Bool_And = {
  arguments: Order_Item_Select_Column_Order_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Item_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Order_Item_Select_Column_Order_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Item_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Item_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Item_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_item" */
export type Order_Item_Aggregate_Fields = {
  __typename?: 'order_item_aggregate_fields';
  avg?: Maybe<Order_Item_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Item_Max_Fields>;
  min?: Maybe<Order_Item_Min_Fields>;
  stddev?: Maybe<Order_Item_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Item_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Item_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Item_Sum_Fields>;
  var_pop?: Maybe<Order_Item_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Item_Var_Samp_Fields>;
  variance?: Maybe<Order_Item_Variance_Fields>;
};


/** aggregate fields of "order_item" */
export type Order_Item_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Item_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_item" */
export type Order_Item_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Item_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Item_Max_Order_By>;
  min?: InputMaybe<Order_Item_Min_Order_By>;
  stddev?: InputMaybe<Order_Item_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Item_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Item_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Item_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Item_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Item_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Item_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Order_Item_Avg_Fields = {
  __typename?: 'order_item_avg_fields';
  fixed_monthly_recurring_charges?: Maybe<Scalars['Float']>;
  one_time_charges?: Maybe<Scalars['Float']>;
  revised_expected_delivery_date_counter?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_item" */
export type Order_Item_Avg_Order_By = {
  fixed_monthly_recurring_charges?: InputMaybe<Order_By>;
  one_time_charges?: InputMaybe<Order_By>;
  revised_expected_delivery_date_counter?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_item". All fields are combined with a logical 'AND'. */
export type Order_Item_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Item_Bool_Exp>>;
  _not?: InputMaybe<Order_Item_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Item_Bool_Exp>>;
  actual_delivery_date?: InputMaybe<Date_Comparison_Exp>;
  actual_go_live_date?: InputMaybe<Date_Comparison_Exp>;
  approved_for_onboarding_date?: InputMaybe<Date_Comparison_Exp>;
  assignee?: InputMaybe<String_Comparison_Exp>;
  billing_contact_name_one?: InputMaybe<String_Comparison_Exp>;
  billing_contact_name_three?: InputMaybe<String_Comparison_Exp>;
  billing_contact_name_two?: InputMaybe<String_Comparison_Exp>;
  billing_contact_one?: InputMaybe<String_Comparison_Exp>;
  billing_contact_three?: InputMaybe<String_Comparison_Exp>;
  billing_contact_two?: InputMaybe<String_Comparison_Exp>;
  billing_type?: InputMaybe<String_Comparison_Exp>;
  blocked_reason?: InputMaybe<String_Comparison_Exp>;
  blocked_reason_details?: InputMaybe<String_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  delivery_id?: InputMaybe<String_Comparison_Exp>;
  delivery_using_amagi_now?: InputMaybe<String_Comparison_Exp>;
  epg_url?: InputMaybe<String_Comparison_Exp>;
  fixed_monthly_recurring_charges?: InputMaybe<Numeric_Comparison_Exp>;
  initial_planned_delivery_date?: InputMaybe<Date_Comparison_Exp>;
  initial_planned_go_live_date?: InputMaybe<Date_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  monetization_model?: InputMaybe<String_Comparison_Exp>;
  oit_created?: InputMaybe<String_Comparison_Exp>;
  oit_integration_error_message?: InputMaybe<String_Comparison_Exp>;
  oit_integration_status?: InputMaybe<String_Comparison_Exp>;
  oit_team?: InputMaybe<String_Comparison_Exp>;
  oit_ticket?: InputMaybe<String_Comparison_Exp>;
  oit_ticket_status?: InputMaybe<String_Comparison_Exp>;
  on_hold_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  on_hold_reason?: InputMaybe<String_Comparison_Exp>;
  one_time_charges?: InputMaybe<Numeric_Comparison_Exp>;
  opportunity_id?: InputMaybe<String_Comparison_Exp>;
  opportunity_name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  order_item_id?: InputMaybe<String_Comparison_Exp>;
  order_item_lines?: InputMaybe<Order_Item_Line_Bool_Exp>;
  order_item_lines_aggregate?: InputMaybe<Order_Item_Line_Aggregate_Bool_Exp>;
  order_item_name?: InputMaybe<String_Comparison_Exp>;
  order_no?: InputMaybe<String_Comparison_Exp>;
  order_type?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<Owner_Bool_Exp>;
  ready_for_oit_creation?: InputMaybe<Boolean_Comparison_Exp>;
  revised_expected_delivery_date?: InputMaybe<Date_Comparison_Exp>;
  revised_expected_delivery_date_counter?: InputMaybe<Numeric_Comparison_Exp>;
  revised_expected_go_live_date?: InputMaybe<Date_Comparison_Exp>;
  sales_account_owner?: InputMaybe<String_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_order_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_owner_id?: InputMaybe<String_Comparison_Exp>;
  stage?: InputMaybe<String_Comparison_Exp>;
  stream_url?: InputMaybe<String_Comparison_Exp>;
  tech_lead?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "order_item_line" */
export type Order_Item_Line = {
  __typename?: 'order_item_line';
  actual_delivery_date?: Maybe<Scalars['date']>;
  actual_go_live_date?: Maybe<Scalars['date']>;
  assignee?: Maybe<Scalars['String']>;
  billing_start_date_rule?: Maybe<Scalars['String']>;
  blip_url?: Maybe<Scalars['String']>;
  /** A computed field, executes function "order_item_line_get_channel_name" */
  channel_name?: Maybe<Scalars['String']>;
  charge_type?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  delivery_id?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  line_amount?: Maybe<Scalars['numeric']>;
  line_invoiced_or_not?: Maybe<Scalars['String']>;
  on_hold_reason?: Maybe<Scalars['String']>;
  /** An object relationship */
  order_item?: Maybe<Order_Item>;
  order_item_line_id?: Maybe<Scalars['String']>;
  order_item_line_name?: Maybe<Scalars['String']>;
  order_product_number?: Maybe<Scalars['String']>;
  /** An object relationship */
  owner?: Maybe<Owner>;
  /** A computed field, executes function "order_item_line_get_platform" */
  platform?: Maybe<Scalars['String']>;
  /** A computed field, executes function "order_item_line_get_platform_region" */
  platform_region?: Maybe<Scalars['String']>;
  product_code?: Maybe<Scalars['String']>;
  /** A computed field, executes function "order_item_line_get_product_name" */
  product_name?: Maybe<Scalars['String']>;
  reporter?: Maybe<Scalars['String']>;
  revised_expected_delivery_date?: Maybe<Scalars['date']>;
  revised_expected_go_live_date?: Maybe<Scalars['date']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_id: Scalars['String'];
  salesforce_order_item_id?: Maybe<Scalars['String']>;
  salesforce_order_product_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
  ssai?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  who_pays?: Maybe<Scalars['String']>;
};

/** aggregated selection of "order_item_line" */
export type Order_Item_Line_Aggregate = {
  __typename?: 'order_item_line_aggregate';
  aggregate?: Maybe<Order_Item_Line_Aggregate_Fields>;
  nodes: Array<Order_Item_Line>;
};

export type Order_Item_Line_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Order_Item_Line_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Order_Item_Line_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Order_Item_Line_Aggregate_Bool_Exp_Count>;
};

export type Order_Item_Line_Aggregate_Bool_Exp_Bool_And = {
  arguments: Order_Item_Line_Select_Column_Order_Item_Line_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Item_Line_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Item_Line_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Order_Item_Line_Select_Column_Order_Item_Line_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Item_Line_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Item_Line_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Item_Line_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Item_Line_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "order_item_line" */
export type Order_Item_Line_Aggregate_Fields = {
  __typename?: 'order_item_line_aggregate_fields';
  avg?: Maybe<Order_Item_Line_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Item_Line_Max_Fields>;
  min?: Maybe<Order_Item_Line_Min_Fields>;
  stddev?: Maybe<Order_Item_Line_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Item_Line_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Item_Line_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Item_Line_Sum_Fields>;
  var_pop?: Maybe<Order_Item_Line_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Item_Line_Var_Samp_Fields>;
  variance?: Maybe<Order_Item_Line_Variance_Fields>;
};


/** aggregate fields of "order_item_line" */
export type Order_Item_Line_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Item_Line_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_item_line" */
export type Order_Item_Line_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Item_Line_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Item_Line_Max_Order_By>;
  min?: InputMaybe<Order_Item_Line_Min_Order_By>;
  stddev?: InputMaybe<Order_Item_Line_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Item_Line_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Item_Line_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Item_Line_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Item_Line_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Item_Line_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Item_Line_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Order_Item_Line_Avg_Fields = {
  __typename?: 'order_item_line_avg_fields';
  line_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_item_line" */
export type Order_Item_Line_Avg_Order_By = {
  line_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_item_line". All fields are combined with a logical 'AND'. */
export type Order_Item_Line_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Item_Line_Bool_Exp>>;
  _not?: InputMaybe<Order_Item_Line_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Item_Line_Bool_Exp>>;
  actual_delivery_date?: InputMaybe<Date_Comparison_Exp>;
  actual_go_live_date?: InputMaybe<Date_Comparison_Exp>;
  assignee?: InputMaybe<String_Comparison_Exp>;
  billing_start_date_rule?: InputMaybe<String_Comparison_Exp>;
  blip_url?: InputMaybe<String_Comparison_Exp>;
  channel_name?: InputMaybe<String_Comparison_Exp>;
  charge_type?: InputMaybe<String_Comparison_Exp>;
  created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  delivery_id?: InputMaybe<String_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  line_amount?: InputMaybe<Numeric_Comparison_Exp>;
  line_invoiced_or_not?: InputMaybe<String_Comparison_Exp>;
  on_hold_reason?: InputMaybe<String_Comparison_Exp>;
  order_item?: InputMaybe<Order_Item_Bool_Exp>;
  order_item_line_id?: InputMaybe<String_Comparison_Exp>;
  order_item_line_name?: InputMaybe<String_Comparison_Exp>;
  order_product_number?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<Owner_Bool_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  platform_region?: InputMaybe<String_Comparison_Exp>;
  product_code?: InputMaybe<String_Comparison_Exp>;
  product_name?: InputMaybe<String_Comparison_Exp>;
  reporter?: InputMaybe<String_Comparison_Exp>;
  revised_expected_delivery_date?: InputMaybe<Date_Comparison_Exp>;
  revised_expected_go_live_date?: InputMaybe<Date_Comparison_Exp>;
  salesforce_channel_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_order_item_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_order_product_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_platform_id?: InputMaybe<String_Comparison_Exp>;
  ssai?: InputMaybe<String_Comparison_Exp>;
  stage?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  who_pays?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Order_Item_Line_Max_Fields = {
  __typename?: 'order_item_line_max_fields';
  actual_delivery_date?: Maybe<Scalars['date']>;
  actual_go_live_date?: Maybe<Scalars['date']>;
  assignee?: Maybe<Scalars['String']>;
  billing_start_date_rule?: Maybe<Scalars['String']>;
  blip_url?: Maybe<Scalars['String']>;
  charge_type?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  delivery_id?: Maybe<Scalars['String']>;
  line_amount?: Maybe<Scalars['numeric']>;
  line_invoiced_or_not?: Maybe<Scalars['String']>;
  on_hold_reason?: Maybe<Scalars['String']>;
  order_item_line_id?: Maybe<Scalars['String']>;
  order_item_line_name?: Maybe<Scalars['String']>;
  order_product_number?: Maybe<Scalars['String']>;
  product_code?: Maybe<Scalars['String']>;
  reporter?: Maybe<Scalars['String']>;
  revised_expected_delivery_date?: Maybe<Scalars['date']>;
  revised_expected_go_live_date?: Maybe<Scalars['date']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_order_item_id?: Maybe<Scalars['String']>;
  salesforce_order_product_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
  ssai?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  who_pays?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "order_item_line" */
export type Order_Item_Line_Max_Order_By = {
  actual_delivery_date?: InputMaybe<Order_By>;
  actual_go_live_date?: InputMaybe<Order_By>;
  assignee?: InputMaybe<Order_By>;
  billing_start_date_rule?: InputMaybe<Order_By>;
  blip_url?: InputMaybe<Order_By>;
  charge_type?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  delivery_id?: InputMaybe<Order_By>;
  line_amount?: InputMaybe<Order_By>;
  line_invoiced_or_not?: InputMaybe<Order_By>;
  on_hold_reason?: InputMaybe<Order_By>;
  order_item_line_id?: InputMaybe<Order_By>;
  order_item_line_name?: InputMaybe<Order_By>;
  order_product_number?: InputMaybe<Order_By>;
  product_code?: InputMaybe<Order_By>;
  reporter?: InputMaybe<Order_By>;
  revised_expected_delivery_date?: InputMaybe<Order_By>;
  revised_expected_go_live_date?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_order_item_id?: InputMaybe<Order_By>;
  salesforce_order_product_id?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
  ssai?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  who_pays?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Item_Line_Min_Fields = {
  __typename?: 'order_item_line_min_fields';
  actual_delivery_date?: Maybe<Scalars['date']>;
  actual_go_live_date?: Maybe<Scalars['date']>;
  assignee?: Maybe<Scalars['String']>;
  billing_start_date_rule?: Maybe<Scalars['String']>;
  blip_url?: Maybe<Scalars['String']>;
  charge_type?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  delivery_id?: Maybe<Scalars['String']>;
  line_amount?: Maybe<Scalars['numeric']>;
  line_invoiced_or_not?: Maybe<Scalars['String']>;
  on_hold_reason?: Maybe<Scalars['String']>;
  order_item_line_id?: Maybe<Scalars['String']>;
  order_item_line_name?: Maybe<Scalars['String']>;
  order_product_number?: Maybe<Scalars['String']>;
  product_code?: Maybe<Scalars['String']>;
  reporter?: Maybe<Scalars['String']>;
  revised_expected_delivery_date?: Maybe<Scalars['date']>;
  revised_expected_go_live_date?: Maybe<Scalars['date']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_order_item_id?: Maybe<Scalars['String']>;
  salesforce_order_product_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
  ssai?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  who_pays?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "order_item_line" */
export type Order_Item_Line_Min_Order_By = {
  actual_delivery_date?: InputMaybe<Order_By>;
  actual_go_live_date?: InputMaybe<Order_By>;
  assignee?: InputMaybe<Order_By>;
  billing_start_date_rule?: InputMaybe<Order_By>;
  blip_url?: InputMaybe<Order_By>;
  charge_type?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  delivery_id?: InputMaybe<Order_By>;
  line_amount?: InputMaybe<Order_By>;
  line_invoiced_or_not?: InputMaybe<Order_By>;
  on_hold_reason?: InputMaybe<Order_By>;
  order_item_line_id?: InputMaybe<Order_By>;
  order_item_line_name?: InputMaybe<Order_By>;
  order_product_number?: InputMaybe<Order_By>;
  product_code?: InputMaybe<Order_By>;
  reporter?: InputMaybe<Order_By>;
  revised_expected_delivery_date?: InputMaybe<Order_By>;
  revised_expected_go_live_date?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_order_item_id?: InputMaybe<Order_By>;
  salesforce_order_product_id?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
  ssai?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  who_pays?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_item_line". */
export type Order_Item_Line_Order_By = {
  actual_delivery_date?: InputMaybe<Order_By>;
  actual_go_live_date?: InputMaybe<Order_By>;
  assignee?: InputMaybe<Order_By>;
  billing_start_date_rule?: InputMaybe<Order_By>;
  blip_url?: InputMaybe<Order_By>;
  channel_name?: InputMaybe<Order_By>;
  charge_type?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  delivery_id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  line_amount?: InputMaybe<Order_By>;
  line_invoiced_or_not?: InputMaybe<Order_By>;
  on_hold_reason?: InputMaybe<Order_By>;
  order_item?: InputMaybe<Order_Item_Order_By>;
  order_item_line_id?: InputMaybe<Order_By>;
  order_item_line_name?: InputMaybe<Order_By>;
  order_product_number?: InputMaybe<Order_By>;
  owner?: InputMaybe<Owner_Order_By>;
  platform?: InputMaybe<Order_By>;
  platform_region?: InputMaybe<Order_By>;
  product_code?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  reporter?: InputMaybe<Order_By>;
  revised_expected_delivery_date?: InputMaybe<Order_By>;
  revised_expected_go_live_date?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_order_item_id?: InputMaybe<Order_By>;
  salesforce_order_product_id?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
  ssai?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  who_pays?: InputMaybe<Order_By>;
};

/** select columns of table "order_item_line" */
export enum Order_Item_Line_Select_Column {
  /** column name */
  ActualDeliveryDate = 'actual_delivery_date',
  /** column name */
  ActualGoLiveDate = 'actual_go_live_date',
  /** column name */
  Assignee = 'assignee',
  /** column name */
  BillingStartDateRule = 'billing_start_date_rule',
  /** column name */
  BlipUrl = 'blip_url',
  /** column name */
  ChargeType = 'charge_type',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeliveryId = 'delivery_id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LineAmount = 'line_amount',
  /** column name */
  LineInvoicedOrNot = 'line_invoiced_or_not',
  /** column name */
  OnHoldReason = 'on_hold_reason',
  /** column name */
  OrderItemLineId = 'order_item_line_id',
  /** column name */
  OrderItemLineName = 'order_item_line_name',
  /** column name */
  OrderProductNumber = 'order_product_number',
  /** column name */
  ProductCode = 'product_code',
  /** column name */
  Reporter = 'reporter',
  /** column name */
  RevisedExpectedDeliveryDate = 'revised_expected_delivery_date',
  /** column name */
  RevisedExpectedGoLiveDate = 'revised_expected_go_live_date',
  /** column name */
  SalesforceChannelId = 'salesforce_channel_id',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceOrderItemId = 'salesforce_order_item_id',
  /** column name */
  SalesforceOrderProductId = 'salesforce_order_product_id',
  /** column name */
  SalesforcePlatformId = 'salesforce_platform_id',
  /** column name */
  Ssai = 'ssai',
  /** column name */
  Stage = 'stage',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WhoPays = 'who_pays'
}

/** select "order_item_line_aggregate_bool_exp_bool_and_arguments_columns" columns of table "order_item_line" */
export enum Order_Item_Line_Select_Column_Order_Item_Line_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "order_item_line_aggregate_bool_exp_bool_or_arguments_columns" columns of table "order_item_line" */
export enum Order_Item_Line_Select_Column_Order_Item_Line_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** aggregate stddev on columns */
export type Order_Item_Line_Stddev_Fields = {
  __typename?: 'order_item_line_stddev_fields';
  line_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_item_line" */
export type Order_Item_Line_Stddev_Order_By = {
  line_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Item_Line_Stddev_Pop_Fields = {
  __typename?: 'order_item_line_stddev_pop_fields';
  line_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_item_line" */
export type Order_Item_Line_Stddev_Pop_Order_By = {
  line_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Item_Line_Stddev_Samp_Fields = {
  __typename?: 'order_item_line_stddev_samp_fields';
  line_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_item_line" */
export type Order_Item_Line_Stddev_Samp_Order_By = {
  line_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_item_line" */
export type Order_Item_Line_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Item_Line_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Item_Line_Stream_Cursor_Value_Input = {
  actual_delivery_date?: InputMaybe<Scalars['date']>;
  actual_go_live_date?: InputMaybe<Scalars['date']>;
  assignee?: InputMaybe<Scalars['String']>;
  billing_start_date_rule?: InputMaybe<Scalars['String']>;
  blip_url?: InputMaybe<Scalars['String']>;
  charge_type?: InputMaybe<Scalars['String']>;
  created_date?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  delivery_id?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  line_amount?: InputMaybe<Scalars['numeric']>;
  line_invoiced_or_not?: InputMaybe<Scalars['String']>;
  on_hold_reason?: InputMaybe<Scalars['String']>;
  order_item_line_id?: InputMaybe<Scalars['String']>;
  order_item_line_name?: InputMaybe<Scalars['String']>;
  order_product_number?: InputMaybe<Scalars['String']>;
  product_code?: InputMaybe<Scalars['String']>;
  reporter?: InputMaybe<Scalars['String']>;
  revised_expected_delivery_date?: InputMaybe<Scalars['date']>;
  revised_expected_go_live_date?: InputMaybe<Scalars['date']>;
  salesforce_channel_id?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_order_item_id?: InputMaybe<Scalars['String']>;
  salesforce_order_product_id?: InputMaybe<Scalars['String']>;
  salesforce_platform_id?: InputMaybe<Scalars['String']>;
  ssai?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  who_pays?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Order_Item_Line_Sum_Fields = {
  __typename?: 'order_item_line_sum_fields';
  line_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "order_item_line" */
export type Order_Item_Line_Sum_Order_By = {
  line_amount?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Order_Item_Line_Var_Pop_Fields = {
  __typename?: 'order_item_line_var_pop_fields';
  line_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_item_line" */
export type Order_Item_Line_Var_Pop_Order_By = {
  line_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Item_Line_Var_Samp_Fields = {
  __typename?: 'order_item_line_var_samp_fields';
  line_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_item_line" */
export type Order_Item_Line_Var_Samp_Order_By = {
  line_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Item_Line_Variance_Fields = {
  __typename?: 'order_item_line_variance_fields';
  line_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_item_line" */
export type Order_Item_Line_Variance_Order_By = {
  line_amount?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Order_Item_Max_Fields = {
  __typename?: 'order_item_max_fields';
  actual_delivery_date?: Maybe<Scalars['date']>;
  actual_go_live_date?: Maybe<Scalars['date']>;
  approved_for_onboarding_date?: Maybe<Scalars['date']>;
  assignee?: Maybe<Scalars['String']>;
  billing_contact_name_one?: Maybe<Scalars['String']>;
  billing_contact_name_three?: Maybe<Scalars['String']>;
  billing_contact_name_two?: Maybe<Scalars['String']>;
  billing_contact_one?: Maybe<Scalars['String']>;
  billing_contact_three?: Maybe<Scalars['String']>;
  billing_contact_two?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  blocked_reason?: Maybe<Scalars['String']>;
  blocked_reason_details?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['timestamptz']>;
  delivery_id?: Maybe<Scalars['String']>;
  delivery_using_amagi_now?: Maybe<Scalars['String']>;
  epg_url?: Maybe<Scalars['String']>;
  fixed_monthly_recurring_charges?: Maybe<Scalars['numeric']>;
  initial_planned_delivery_date?: Maybe<Scalars['date']>;
  initial_planned_go_live_date?: Maybe<Scalars['date']>;
  monetization_model?: Maybe<Scalars['String']>;
  oit_created?: Maybe<Scalars['String']>;
  oit_integration_error_message?: Maybe<Scalars['String']>;
  oit_integration_status?: Maybe<Scalars['String']>;
  oit_team?: Maybe<Scalars['String']>;
  oit_ticket?: Maybe<Scalars['String']>;
  oit_ticket_status?: Maybe<Scalars['String']>;
  on_hold_date?: Maybe<Scalars['timestamptz']>;
  on_hold_reason?: Maybe<Scalars['String']>;
  one_time_charges?: Maybe<Scalars['numeric']>;
  opportunity_id?: Maybe<Scalars['String']>;
  opportunity_name?: Maybe<Scalars['String']>;
  order_item_id?: Maybe<Scalars['String']>;
  order_item_name?: Maybe<Scalars['String']>;
  order_no?: Maybe<Scalars['String']>;
  order_type?: Maybe<Scalars['String']>;
  revised_expected_delivery_date?: Maybe<Scalars['date']>;
  revised_expected_delivery_date_counter?: Maybe<Scalars['numeric']>;
  revised_expected_go_live_date?: Maybe<Scalars['date']>;
  sales_account_owner?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_order_id?: Maybe<Scalars['String']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  stream_url?: Maybe<Scalars['String']>;
  tech_lead?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "order_item" */
export type Order_Item_Max_Order_By = {
  actual_delivery_date?: InputMaybe<Order_By>;
  actual_go_live_date?: InputMaybe<Order_By>;
  approved_for_onboarding_date?: InputMaybe<Order_By>;
  assignee?: InputMaybe<Order_By>;
  billing_contact_name_one?: InputMaybe<Order_By>;
  billing_contact_name_three?: InputMaybe<Order_By>;
  billing_contact_name_two?: InputMaybe<Order_By>;
  billing_contact_one?: InputMaybe<Order_By>;
  billing_contact_three?: InputMaybe<Order_By>;
  billing_contact_two?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  blocked_reason?: InputMaybe<Order_By>;
  blocked_reason_details?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  delivery_id?: InputMaybe<Order_By>;
  delivery_using_amagi_now?: InputMaybe<Order_By>;
  epg_url?: InputMaybe<Order_By>;
  fixed_monthly_recurring_charges?: InputMaybe<Order_By>;
  initial_planned_delivery_date?: InputMaybe<Order_By>;
  initial_planned_go_live_date?: InputMaybe<Order_By>;
  monetization_model?: InputMaybe<Order_By>;
  oit_created?: InputMaybe<Order_By>;
  oit_integration_error_message?: InputMaybe<Order_By>;
  oit_integration_status?: InputMaybe<Order_By>;
  oit_team?: InputMaybe<Order_By>;
  oit_ticket?: InputMaybe<Order_By>;
  oit_ticket_status?: InputMaybe<Order_By>;
  on_hold_date?: InputMaybe<Order_By>;
  on_hold_reason?: InputMaybe<Order_By>;
  one_time_charges?: InputMaybe<Order_By>;
  opportunity_id?: InputMaybe<Order_By>;
  opportunity_name?: InputMaybe<Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  order_item_name?: InputMaybe<Order_By>;
  order_no?: InputMaybe<Order_By>;
  order_type?: InputMaybe<Order_By>;
  revised_expected_delivery_date?: InputMaybe<Order_By>;
  revised_expected_delivery_date_counter?: InputMaybe<Order_By>;
  revised_expected_go_live_date?: InputMaybe<Order_By>;
  sales_account_owner?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_order_id?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  stream_url?: InputMaybe<Order_By>;
  tech_lead?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Item_Min_Fields = {
  __typename?: 'order_item_min_fields';
  actual_delivery_date?: Maybe<Scalars['date']>;
  actual_go_live_date?: Maybe<Scalars['date']>;
  approved_for_onboarding_date?: Maybe<Scalars['date']>;
  assignee?: Maybe<Scalars['String']>;
  billing_contact_name_one?: Maybe<Scalars['String']>;
  billing_contact_name_three?: Maybe<Scalars['String']>;
  billing_contact_name_two?: Maybe<Scalars['String']>;
  billing_contact_one?: Maybe<Scalars['String']>;
  billing_contact_three?: Maybe<Scalars['String']>;
  billing_contact_two?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  blocked_reason?: Maybe<Scalars['String']>;
  blocked_reason_details?: Maybe<Scalars['String']>;
  created_date?: Maybe<Scalars['timestamptz']>;
  delivery_id?: Maybe<Scalars['String']>;
  delivery_using_amagi_now?: Maybe<Scalars['String']>;
  epg_url?: Maybe<Scalars['String']>;
  fixed_monthly_recurring_charges?: Maybe<Scalars['numeric']>;
  initial_planned_delivery_date?: Maybe<Scalars['date']>;
  initial_planned_go_live_date?: Maybe<Scalars['date']>;
  monetization_model?: Maybe<Scalars['String']>;
  oit_created?: Maybe<Scalars['String']>;
  oit_integration_error_message?: Maybe<Scalars['String']>;
  oit_integration_status?: Maybe<Scalars['String']>;
  oit_team?: Maybe<Scalars['String']>;
  oit_ticket?: Maybe<Scalars['String']>;
  oit_ticket_status?: Maybe<Scalars['String']>;
  on_hold_date?: Maybe<Scalars['timestamptz']>;
  on_hold_reason?: Maybe<Scalars['String']>;
  one_time_charges?: Maybe<Scalars['numeric']>;
  opportunity_id?: Maybe<Scalars['String']>;
  opportunity_name?: Maybe<Scalars['String']>;
  order_item_id?: Maybe<Scalars['String']>;
  order_item_name?: Maybe<Scalars['String']>;
  order_no?: Maybe<Scalars['String']>;
  order_type?: Maybe<Scalars['String']>;
  revised_expected_delivery_date?: Maybe<Scalars['date']>;
  revised_expected_delivery_date_counter?: Maybe<Scalars['numeric']>;
  revised_expected_go_live_date?: Maybe<Scalars['date']>;
  sales_account_owner?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_order_id?: Maybe<Scalars['String']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  stage?: Maybe<Scalars['String']>;
  stream_url?: Maybe<Scalars['String']>;
  tech_lead?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "order_item" */
export type Order_Item_Min_Order_By = {
  actual_delivery_date?: InputMaybe<Order_By>;
  actual_go_live_date?: InputMaybe<Order_By>;
  approved_for_onboarding_date?: InputMaybe<Order_By>;
  assignee?: InputMaybe<Order_By>;
  billing_contact_name_one?: InputMaybe<Order_By>;
  billing_contact_name_three?: InputMaybe<Order_By>;
  billing_contact_name_two?: InputMaybe<Order_By>;
  billing_contact_one?: InputMaybe<Order_By>;
  billing_contact_three?: InputMaybe<Order_By>;
  billing_contact_two?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  blocked_reason?: InputMaybe<Order_By>;
  blocked_reason_details?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  delivery_id?: InputMaybe<Order_By>;
  delivery_using_amagi_now?: InputMaybe<Order_By>;
  epg_url?: InputMaybe<Order_By>;
  fixed_monthly_recurring_charges?: InputMaybe<Order_By>;
  initial_planned_delivery_date?: InputMaybe<Order_By>;
  initial_planned_go_live_date?: InputMaybe<Order_By>;
  monetization_model?: InputMaybe<Order_By>;
  oit_created?: InputMaybe<Order_By>;
  oit_integration_error_message?: InputMaybe<Order_By>;
  oit_integration_status?: InputMaybe<Order_By>;
  oit_team?: InputMaybe<Order_By>;
  oit_ticket?: InputMaybe<Order_By>;
  oit_ticket_status?: InputMaybe<Order_By>;
  on_hold_date?: InputMaybe<Order_By>;
  on_hold_reason?: InputMaybe<Order_By>;
  one_time_charges?: InputMaybe<Order_By>;
  opportunity_id?: InputMaybe<Order_By>;
  opportunity_name?: InputMaybe<Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  order_item_name?: InputMaybe<Order_By>;
  order_no?: InputMaybe<Order_By>;
  order_type?: InputMaybe<Order_By>;
  revised_expected_delivery_date?: InputMaybe<Order_By>;
  revised_expected_delivery_date_counter?: InputMaybe<Order_By>;
  revised_expected_go_live_date?: InputMaybe<Order_By>;
  sales_account_owner?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_order_id?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  stream_url?: InputMaybe<Order_By>;
  tech_lead?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_item". */
export type Order_Item_Order_By = {
  actual_delivery_date?: InputMaybe<Order_By>;
  actual_go_live_date?: InputMaybe<Order_By>;
  approved_for_onboarding_date?: InputMaybe<Order_By>;
  assignee?: InputMaybe<Order_By>;
  billing_contact_name_one?: InputMaybe<Order_By>;
  billing_contact_name_three?: InputMaybe<Order_By>;
  billing_contact_name_two?: InputMaybe<Order_By>;
  billing_contact_one?: InputMaybe<Order_By>;
  billing_contact_three?: InputMaybe<Order_By>;
  billing_contact_two?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  blocked_reason?: InputMaybe<Order_By>;
  blocked_reason_details?: InputMaybe<Order_By>;
  created_date?: InputMaybe<Order_By>;
  delivery_id?: InputMaybe<Order_By>;
  delivery_using_amagi_now?: InputMaybe<Order_By>;
  epg_url?: InputMaybe<Order_By>;
  fixed_monthly_recurring_charges?: InputMaybe<Order_By>;
  initial_planned_delivery_date?: InputMaybe<Order_By>;
  initial_planned_go_live_date?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  monetization_model?: InputMaybe<Order_By>;
  oit_created?: InputMaybe<Order_By>;
  oit_integration_error_message?: InputMaybe<Order_By>;
  oit_integration_status?: InputMaybe<Order_By>;
  oit_team?: InputMaybe<Order_By>;
  oit_ticket?: InputMaybe<Order_By>;
  oit_ticket_status?: InputMaybe<Order_By>;
  on_hold_date?: InputMaybe<Order_By>;
  on_hold_reason?: InputMaybe<Order_By>;
  one_time_charges?: InputMaybe<Order_By>;
  opportunity_id?: InputMaybe<Order_By>;
  opportunity_name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  order_item_id?: InputMaybe<Order_By>;
  order_item_lines_aggregate?: InputMaybe<Order_Item_Line_Aggregate_Order_By>;
  order_item_name?: InputMaybe<Order_By>;
  order_no?: InputMaybe<Order_By>;
  order_type?: InputMaybe<Order_By>;
  owner?: InputMaybe<Owner_Order_By>;
  ready_for_oit_creation?: InputMaybe<Order_By>;
  revised_expected_delivery_date?: InputMaybe<Order_By>;
  revised_expected_delivery_date_counter?: InputMaybe<Order_By>;
  revised_expected_go_live_date?: InputMaybe<Order_By>;
  sales_account_owner?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_order_id?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  stage?: InputMaybe<Order_By>;
  stream_url?: InputMaybe<Order_By>;
  tech_lead?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "order_item" */
export enum Order_Item_Select_Column {
  /** column name */
  ActualDeliveryDate = 'actual_delivery_date',
  /** column name */
  ActualGoLiveDate = 'actual_go_live_date',
  /** column name */
  ApprovedForOnboardingDate = 'approved_for_onboarding_date',
  /** column name */
  Assignee = 'assignee',
  /** column name */
  BillingContactNameOne = 'billing_contact_name_one',
  /** column name */
  BillingContactNameThree = 'billing_contact_name_three',
  /** column name */
  BillingContactNameTwo = 'billing_contact_name_two',
  /** column name */
  BillingContactOne = 'billing_contact_one',
  /** column name */
  BillingContactThree = 'billing_contact_three',
  /** column name */
  BillingContactTwo = 'billing_contact_two',
  /** column name */
  BillingType = 'billing_type',
  /** column name */
  BlockedReason = 'blocked_reason',
  /** column name */
  BlockedReasonDetails = 'blocked_reason_details',
  /** column name */
  CreatedDate = 'created_date',
  /** column name */
  DeliveryId = 'delivery_id',
  /** column name */
  DeliveryUsingAmagiNow = 'delivery_using_amagi_now',
  /** column name */
  EpgUrl = 'epg_url',
  /** column name */
  FixedMonthlyRecurringCharges = 'fixed_monthly_recurring_charges',
  /** column name */
  InitialPlannedDeliveryDate = 'initial_planned_delivery_date',
  /** column name */
  InitialPlannedGoLiveDate = 'initial_planned_go_live_date',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  MonetizationModel = 'monetization_model',
  /** column name */
  OitCreated = 'oit_created',
  /** column name */
  OitIntegrationErrorMessage = 'oit_integration_error_message',
  /** column name */
  OitIntegrationStatus = 'oit_integration_status',
  /** column name */
  OitTeam = 'oit_team',
  /** column name */
  OitTicket = 'oit_ticket',
  /** column name */
  OitTicketStatus = 'oit_ticket_status',
  /** column name */
  OnHoldDate = 'on_hold_date',
  /** column name */
  OnHoldReason = 'on_hold_reason',
  /** column name */
  OneTimeCharges = 'one_time_charges',
  /** column name */
  OpportunityId = 'opportunity_id',
  /** column name */
  OpportunityName = 'opportunity_name',
  /** column name */
  OrderItemId = 'order_item_id',
  /** column name */
  OrderItemName = 'order_item_name',
  /** column name */
  OrderNo = 'order_no',
  /** column name */
  OrderType = 'order_type',
  /** column name */
  ReadyForOitCreation = 'ready_for_oit_creation',
  /** column name */
  RevisedExpectedDeliveryDate = 'revised_expected_delivery_date',
  /** column name */
  RevisedExpectedDeliveryDateCounter = 'revised_expected_delivery_date_counter',
  /** column name */
  RevisedExpectedGoLiveDate = 'revised_expected_go_live_date',
  /** column name */
  SalesAccountOwner = 'sales_account_owner',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceOrderId = 'salesforce_order_id',
  /** column name */
  SalesforceOwnerId = 'salesforce_owner_id',
  /** column name */
  Stage = 'stage',
  /** column name */
  StreamUrl = 'stream_url',
  /** column name */
  TechLead = 'tech_lead',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "order_item_aggregate_bool_exp_bool_and_arguments_columns" columns of table "order_item" */
export enum Order_Item_Select_Column_Order_Item_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  ReadyForOitCreation = 'ready_for_oit_creation'
}

/** select "order_item_aggregate_bool_exp_bool_or_arguments_columns" columns of table "order_item" */
export enum Order_Item_Select_Column_Order_Item_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  ReadyForOitCreation = 'ready_for_oit_creation'
}

/** aggregate stddev on columns */
export type Order_Item_Stddev_Fields = {
  __typename?: 'order_item_stddev_fields';
  fixed_monthly_recurring_charges?: Maybe<Scalars['Float']>;
  one_time_charges?: Maybe<Scalars['Float']>;
  revised_expected_delivery_date_counter?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_item" */
export type Order_Item_Stddev_Order_By = {
  fixed_monthly_recurring_charges?: InputMaybe<Order_By>;
  one_time_charges?: InputMaybe<Order_By>;
  revised_expected_delivery_date_counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Item_Stddev_Pop_Fields = {
  __typename?: 'order_item_stddev_pop_fields';
  fixed_monthly_recurring_charges?: Maybe<Scalars['Float']>;
  one_time_charges?: Maybe<Scalars['Float']>;
  revised_expected_delivery_date_counter?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_item" */
export type Order_Item_Stddev_Pop_Order_By = {
  fixed_monthly_recurring_charges?: InputMaybe<Order_By>;
  one_time_charges?: InputMaybe<Order_By>;
  revised_expected_delivery_date_counter?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Item_Stddev_Samp_Fields = {
  __typename?: 'order_item_stddev_samp_fields';
  fixed_monthly_recurring_charges?: Maybe<Scalars['Float']>;
  one_time_charges?: Maybe<Scalars['Float']>;
  revised_expected_delivery_date_counter?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_item" */
export type Order_Item_Stddev_Samp_Order_By = {
  fixed_monthly_recurring_charges?: InputMaybe<Order_By>;
  one_time_charges?: InputMaybe<Order_By>;
  revised_expected_delivery_date_counter?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_item" */
export type Order_Item_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Item_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Item_Stream_Cursor_Value_Input = {
  actual_delivery_date?: InputMaybe<Scalars['date']>;
  actual_go_live_date?: InputMaybe<Scalars['date']>;
  approved_for_onboarding_date?: InputMaybe<Scalars['date']>;
  assignee?: InputMaybe<Scalars['String']>;
  billing_contact_name_one?: InputMaybe<Scalars['String']>;
  billing_contact_name_three?: InputMaybe<Scalars['String']>;
  billing_contact_name_two?: InputMaybe<Scalars['String']>;
  billing_contact_one?: InputMaybe<Scalars['String']>;
  billing_contact_three?: InputMaybe<Scalars['String']>;
  billing_contact_two?: InputMaybe<Scalars['String']>;
  billing_type?: InputMaybe<Scalars['String']>;
  blocked_reason?: InputMaybe<Scalars['String']>;
  blocked_reason_details?: InputMaybe<Scalars['String']>;
  created_date?: InputMaybe<Scalars['timestamptz']>;
  delivery_id?: InputMaybe<Scalars['String']>;
  delivery_using_amagi_now?: InputMaybe<Scalars['String']>;
  epg_url?: InputMaybe<Scalars['String']>;
  fixed_monthly_recurring_charges?: InputMaybe<Scalars['numeric']>;
  initial_planned_delivery_date?: InputMaybe<Scalars['date']>;
  initial_planned_go_live_date?: InputMaybe<Scalars['date']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  monetization_model?: InputMaybe<Scalars['String']>;
  oit_created?: InputMaybe<Scalars['String']>;
  oit_integration_error_message?: InputMaybe<Scalars['String']>;
  oit_integration_status?: InputMaybe<Scalars['String']>;
  oit_team?: InputMaybe<Scalars['String']>;
  oit_ticket?: InputMaybe<Scalars['String']>;
  oit_ticket_status?: InputMaybe<Scalars['String']>;
  on_hold_date?: InputMaybe<Scalars['timestamptz']>;
  on_hold_reason?: InputMaybe<Scalars['String']>;
  one_time_charges?: InputMaybe<Scalars['numeric']>;
  opportunity_id?: InputMaybe<Scalars['String']>;
  opportunity_name?: InputMaybe<Scalars['String']>;
  order_item_id?: InputMaybe<Scalars['String']>;
  order_item_name?: InputMaybe<Scalars['String']>;
  order_no?: InputMaybe<Scalars['String']>;
  order_type?: InputMaybe<Scalars['String']>;
  ready_for_oit_creation?: InputMaybe<Scalars['Boolean']>;
  revised_expected_delivery_date?: InputMaybe<Scalars['date']>;
  revised_expected_delivery_date_counter?: InputMaybe<Scalars['numeric']>;
  revised_expected_go_live_date?: InputMaybe<Scalars['date']>;
  sales_account_owner?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_order_id?: InputMaybe<Scalars['String']>;
  salesforce_owner_id?: InputMaybe<Scalars['String']>;
  stage?: InputMaybe<Scalars['String']>;
  stream_url?: InputMaybe<Scalars['String']>;
  tech_lead?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Order_Item_Sum_Fields = {
  __typename?: 'order_item_sum_fields';
  fixed_monthly_recurring_charges?: Maybe<Scalars['numeric']>;
  one_time_charges?: Maybe<Scalars['numeric']>;
  revised_expected_delivery_date_counter?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "order_item" */
export type Order_Item_Sum_Order_By = {
  fixed_monthly_recurring_charges?: InputMaybe<Order_By>;
  one_time_charges?: InputMaybe<Order_By>;
  revised_expected_delivery_date_counter?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Order_Item_Var_Pop_Fields = {
  __typename?: 'order_item_var_pop_fields';
  fixed_monthly_recurring_charges?: Maybe<Scalars['Float']>;
  one_time_charges?: Maybe<Scalars['Float']>;
  revised_expected_delivery_date_counter?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_item" */
export type Order_Item_Var_Pop_Order_By = {
  fixed_monthly_recurring_charges?: InputMaybe<Order_By>;
  one_time_charges?: InputMaybe<Order_By>;
  revised_expected_delivery_date_counter?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Item_Var_Samp_Fields = {
  __typename?: 'order_item_var_samp_fields';
  fixed_monthly_recurring_charges?: Maybe<Scalars['Float']>;
  one_time_charges?: Maybe<Scalars['Float']>;
  revised_expected_delivery_date_counter?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_item" */
export type Order_Item_Var_Samp_Order_By = {
  fixed_monthly_recurring_charges?: InputMaybe<Order_By>;
  one_time_charges?: InputMaybe<Order_By>;
  revised_expected_delivery_date_counter?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Item_Variance_Fields = {
  __typename?: 'order_item_variance_fields';
  fixed_monthly_recurring_charges?: Maybe<Scalars['Float']>;
  one_time_charges?: Maybe<Scalars['Float']>;
  revised_expected_delivery_date_counter?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_item" */
export type Order_Item_Variance_Order_By = {
  fixed_monthly_recurring_charges?: InputMaybe<Order_By>;
  one_time_charges?: InputMaybe<Order_By>;
  revised_expected_delivery_date_counter?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Order_Max_Fields = {
  __typename?: 'order_max_fields';
  activated_date?: Maybe<Scalars['timestamptz']>;
  actual_delivery_date?: Maybe<Scalars['date']>;
  actual_golive_date?: Maybe<Scalars['date']>;
  amount?: Maybe<Scalars['numeric']>;
  billing_term?: Maybe<Scalars['String']>;
  company_authorized_date?: Maybe<Scalars['date']>;
  consumption_mr_value?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  customer_authorized_date?: Maybe<Scalars['date']>;
  effective_date?: Maybe<Scalars['date']>;
  end_date?: Maybe<Scalars['date']>;
  mrr_value?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  order_billing_status?: Maybe<Scalars['String']>;
  order_number?: Maybe<Scalars['String']>;
  order_type?: Maybe<Scalars['String']>;
  planned_delivery_date?: Maybe<Scalars['date']>;
  planned_golive_date?: Maybe<Scalars['date']>;
  po_date?: Maybe<Scalars['date']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_opportunity_id?: Maybe<Scalars['String']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_quote_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscription_mrr_value?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "order" */
export type Order_Max_Order_By = {
  activated_date?: InputMaybe<Order_By>;
  actual_delivery_date?: InputMaybe<Order_By>;
  actual_golive_date?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  billing_term?: InputMaybe<Order_By>;
  company_authorized_date?: InputMaybe<Order_By>;
  consumption_mr_value?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_authorized_date?: InputMaybe<Order_By>;
  effective_date?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  mrr_value?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_billing_status?: InputMaybe<Order_By>;
  order_number?: InputMaybe<Order_By>;
  order_type?: InputMaybe<Order_By>;
  planned_delivery_date?: InputMaybe<Order_By>;
  planned_golive_date?: InputMaybe<Order_By>;
  po_date?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_opportunity_id?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_quote_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subscription_mrr_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Min_Fields = {
  __typename?: 'order_min_fields';
  activated_date?: Maybe<Scalars['timestamptz']>;
  actual_delivery_date?: Maybe<Scalars['date']>;
  actual_golive_date?: Maybe<Scalars['date']>;
  amount?: Maybe<Scalars['numeric']>;
  billing_term?: Maybe<Scalars['String']>;
  company_authorized_date?: Maybe<Scalars['date']>;
  consumption_mr_value?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  customer_authorized_date?: Maybe<Scalars['date']>;
  effective_date?: Maybe<Scalars['date']>;
  end_date?: Maybe<Scalars['date']>;
  mrr_value?: Maybe<Scalars['numeric']>;
  name?: Maybe<Scalars['String']>;
  order_billing_status?: Maybe<Scalars['String']>;
  order_number?: Maybe<Scalars['String']>;
  order_type?: Maybe<Scalars['String']>;
  planned_delivery_date?: Maybe<Scalars['date']>;
  planned_golive_date?: Maybe<Scalars['date']>;
  po_date?: Maybe<Scalars['date']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_opportunity_id?: Maybe<Scalars['String']>;
  salesforce_owner_id?: Maybe<Scalars['String']>;
  salesforce_quote_id?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscription_mrr_value?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "order" */
export type Order_Min_Order_By = {
  activated_date?: InputMaybe<Order_By>;
  actual_delivery_date?: InputMaybe<Order_By>;
  actual_golive_date?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  billing_term?: InputMaybe<Order_By>;
  company_authorized_date?: InputMaybe<Order_By>;
  consumption_mr_value?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_authorized_date?: InputMaybe<Order_By>;
  effective_date?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  mrr_value?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_billing_status?: InputMaybe<Order_By>;
  order_number?: InputMaybe<Order_By>;
  order_type?: InputMaybe<Order_By>;
  planned_delivery_date?: InputMaybe<Order_By>;
  planned_golive_date?: InputMaybe<Order_By>;
  po_date?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_opportunity_id?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_quote_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subscription_mrr_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order". */
export type Order_Order_By = {
  activated_date?: InputMaybe<Order_By>;
  actual_delivery_date?: InputMaybe<Order_By>;
  actual_golive_date?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  billing_term?: InputMaybe<Order_By>;
  company_authorized_date?: InputMaybe<Order_By>;
  consumption_mr_value?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer?: InputMaybe<Account_Order_By>;
  customer_authorized_date?: InputMaybe<Order_By>;
  effective_date?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  handover_to_onboarding?: InputMaybe<Order_By>;
  invoices_aggregate?: InputMaybe<Invoice_Aggregate_Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  mrr_value?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  opportunity?: InputMaybe<Opportunity_Order_By>;
  order_billing_status?: InputMaybe<Order_By>;
  order_item_by_salesforce_order_id_aggregate?: InputMaybe<Order_Item_Aggregate_Order_By>;
  order_items_aggregate?: InputMaybe<Order_Product_Aggregate_Order_By>;
  order_items_by_salesforce_order_id_aggregate?: InputMaybe<Order_Item_Aggregate_Order_By>;
  order_number?: InputMaybe<Order_By>;
  order_products_aggregate?: InputMaybe<Order_Product_Aggregate_Order_By>;
  order_type?: InputMaybe<Order_By>;
  planned_delivery_date?: InputMaybe<Order_By>;
  planned_golive_date?: InputMaybe<Order_By>;
  po_date?: InputMaybe<Order_By>;
  quote?: InputMaybe<Quote_Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_opportunity_id?: InputMaybe<Order_By>;
  salesforce_owner_id?: InputMaybe<Order_By>;
  salesforce_quote_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subscription_mrr_value?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_product" */
export type Order_Product = {
  __typename?: 'order_product';
  access_to_viewership_analytics?: Maybe<Scalars['String']>;
  activation_status?: Maybe<Scalars['String']>;
  ad_analytics_access_to_content_partner?: Maybe<Scalars['String']>;
  ad_analytics_access_to_platform?: Maybe<Scalars['String']>;
  ad_tags_from?: Maybe<Scalars['String']>;
  ads_plus_model?: Maybe<Scalars['String']>;
  agreed_billing_start_date?: Maybe<Scalars['date']>;
  bill_through_date_override?: Maybe<Scalars['date']>;
  billable_unit_price?: Maybe<Scalars['numeric']>;
  billed_amount_without_tax?: Maybe<Scalars['numeric']>;
  billing_start_date_rule?: Maybe<Scalars['String']>;
  business_model?: Maybe<Scalars['String']>;
  cdn_region?: Maybe<Scalars['String']>;
  /** An object relationship */
  channel?: Maybe<Channel>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  epg_channel?: Maybe<Scalars['String']>;
  epg_type?: Maybe<Scalars['String']>;
  fsys_unit_net_price?: Maybe<Scalars['numeric']>;
  invoice_run?: Maybe<Scalars['String']>;
  invoice_run_processing_status?: Maybe<Scalars['String']>;
  invoice_run_start_date?: Maybe<Scalars['timestamptz']>;
  is_activated?: Maybe<Scalars['Boolean']>;
  is_deleted: Scalars['Boolean'];
  last_charge_to_date?: Maybe<Scalars['date']>;
  last_invoice_target_date?: Maybe<Scalars['date']>;
  list_price: Scalars['numeric'];
  next_billing_date?: Maybe<Scalars['date']>;
  next_charge_date?: Maybe<Scalars['date']>;
  /** An object relationship */
  order: Order;
  order_product_line_status?: Maybe<Scalars['String']>;
  order_product_number?: Maybe<Scalars['String']>;
  /** An object relationship */
  order_product_to_quote_line?: Maybe<Quote_Line>;
  override_next_billing_date?: Maybe<Scalars['date']>;
  /** An object relationship */
  platform?: Maybe<Platform>;
  /** An object relationship */
  product?: Maybe<Product>;
  quantity?: Maybe<Scalars['float8']>;
  revenue_model?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_created_date: Scalars['timestamptz'];
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date: Scalars['timestamptz'];
  salesforce_order_id: Scalars['String'];
  salesforce_platform_id?: Maybe<Scalars['String']>;
  salesforce_product_id?: Maybe<Scalars['String']>;
  salesforce_quote_line_id?: Maybe<Scalars['String']>;
  service_date?: Maybe<Scalars['date']>;
  so_po_reference_number?: Maybe<Scalars['String']>;
  ssai_ad_server?: Maybe<Scalars['String']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  terminated_date?: Maybe<Scalars['date']>;
  thunderstorm_setup_account?: Maybe<Scalars['String']>;
  total_price: Scalars['numeric'];
  unit_price: Scalars['numeric'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "order_product" */
export type Order_Product_Aggregate = {
  __typename?: 'order_product_aggregate';
  aggregate?: Maybe<Order_Product_Aggregate_Fields>;
  nodes: Array<Order_Product>;
};

export type Order_Product_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Order_Product_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Order_Product_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Order_Product_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Order_Product_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Order_Product_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Order_Product_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Order_Product_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Order_Product_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Order_Product_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Order_Product_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Order_Product_Aggregate_Bool_Exp_Var_Samp>;
};

export type Order_Product_Aggregate_Bool_Exp_Avg = {
  arguments: Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Product_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Product_Aggregate_Bool_Exp_Bool_And = {
  arguments: Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Product_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Product_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Product_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Order_Product_Aggregate_Bool_Exp_Corr = {
  arguments: Order_Product_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Product_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Product_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Order_Product_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Product_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Order_Product_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Order_Product_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Product_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Product_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Order_Product_Aggregate_Bool_Exp_Max = {
  arguments: Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Product_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Product_Aggregate_Bool_Exp_Min = {
  arguments: Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Product_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Product_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Product_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Product_Aggregate_Bool_Exp_Sum = {
  arguments: Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Product_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Product_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Product_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "order_product" */
export type Order_Product_Aggregate_Fields = {
  __typename?: 'order_product_aggregate_fields';
  avg?: Maybe<Order_Product_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Product_Max_Fields>;
  min?: Maybe<Order_Product_Min_Fields>;
  stddev?: Maybe<Order_Product_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Product_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Product_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Product_Sum_Fields>;
  var_pop?: Maybe<Order_Product_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Product_Var_Samp_Fields>;
  variance?: Maybe<Order_Product_Variance_Fields>;
};


/** aggregate fields of "order_product" */
export type Order_Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_product" */
export type Order_Product_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Product_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Product_Max_Order_By>;
  min?: InputMaybe<Order_Product_Min_Order_By>;
  stddev?: InputMaybe<Order_Product_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Product_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Product_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Product_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Product_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Product_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Product_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Order_Product_Avg_Fields = {
  __typename?: 'order_product_avg_fields';
  billable_unit_price?: Maybe<Scalars['Float']>;
  billed_amount_without_tax?: Maybe<Scalars['Float']>;
  fsys_unit_net_price?: Maybe<Scalars['Float']>;
  list_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_price?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_product" */
export type Order_Product_Avg_Order_By = {
  billable_unit_price?: InputMaybe<Order_By>;
  billed_amount_without_tax?: InputMaybe<Order_By>;
  fsys_unit_net_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_product". All fields are combined with a logical 'AND'. */
export type Order_Product_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Product_Bool_Exp>>;
  _not?: InputMaybe<Order_Product_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Product_Bool_Exp>>;
  access_to_viewership_analytics?: InputMaybe<String_Comparison_Exp>;
  activation_status?: InputMaybe<String_Comparison_Exp>;
  ad_analytics_access_to_content_partner?: InputMaybe<String_Comparison_Exp>;
  ad_analytics_access_to_platform?: InputMaybe<String_Comparison_Exp>;
  ad_tags_from?: InputMaybe<String_Comparison_Exp>;
  ads_plus_model?: InputMaybe<String_Comparison_Exp>;
  agreed_billing_start_date?: InputMaybe<Date_Comparison_Exp>;
  bill_through_date_override?: InputMaybe<Date_Comparison_Exp>;
  billable_unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  billed_amount_without_tax?: InputMaybe<Numeric_Comparison_Exp>;
  billing_start_date_rule?: InputMaybe<String_Comparison_Exp>;
  business_model?: InputMaybe<String_Comparison_Exp>;
  cdn_region?: InputMaybe<String_Comparison_Exp>;
  channel?: InputMaybe<Channel_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  epg_channel?: InputMaybe<String_Comparison_Exp>;
  epg_type?: InputMaybe<String_Comparison_Exp>;
  fsys_unit_net_price?: InputMaybe<Numeric_Comparison_Exp>;
  invoice_run?: InputMaybe<String_Comparison_Exp>;
  invoice_run_processing_status?: InputMaybe<String_Comparison_Exp>;
  invoice_run_start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  is_activated?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  last_charge_to_date?: InputMaybe<Date_Comparison_Exp>;
  last_invoice_target_date?: InputMaybe<Date_Comparison_Exp>;
  list_price?: InputMaybe<Numeric_Comparison_Exp>;
  next_billing_date?: InputMaybe<Date_Comparison_Exp>;
  next_charge_date?: InputMaybe<Date_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  order_product_line_status?: InputMaybe<String_Comparison_Exp>;
  order_product_number?: InputMaybe<String_Comparison_Exp>;
  order_product_to_quote_line?: InputMaybe<Quote_Line_Bool_Exp>;
  override_next_billing_date?: InputMaybe<Date_Comparison_Exp>;
  platform?: InputMaybe<Platform_Bool_Exp>;
  product?: InputMaybe<Product_Bool_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  revenue_model?: InputMaybe<String_Comparison_Exp>;
  salesforce_channel_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_order_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_platform_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_product_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_quote_line_id?: InputMaybe<String_Comparison_Exp>;
  service_date?: InputMaybe<Date_Comparison_Exp>;
  so_po_reference_number?: InputMaybe<String_Comparison_Exp>;
  ssai_ad_server?: InputMaybe<String_Comparison_Exp>;
  tax_amount?: InputMaybe<Numeric_Comparison_Exp>;
  terminated_date?: InputMaybe<Date_Comparison_Exp>;
  thunderstorm_setup_account?: InputMaybe<String_Comparison_Exp>;
  total_price?: InputMaybe<Numeric_Comparison_Exp>;
  unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Order_Product_Max_Fields = {
  __typename?: 'order_product_max_fields';
  access_to_viewership_analytics?: Maybe<Scalars['String']>;
  activation_status?: Maybe<Scalars['String']>;
  ad_analytics_access_to_content_partner?: Maybe<Scalars['String']>;
  ad_analytics_access_to_platform?: Maybe<Scalars['String']>;
  ad_tags_from?: Maybe<Scalars['String']>;
  ads_plus_model?: Maybe<Scalars['String']>;
  agreed_billing_start_date?: Maybe<Scalars['date']>;
  bill_through_date_override?: Maybe<Scalars['date']>;
  billable_unit_price?: Maybe<Scalars['numeric']>;
  billed_amount_without_tax?: Maybe<Scalars['numeric']>;
  billing_start_date_rule?: Maybe<Scalars['String']>;
  business_model?: Maybe<Scalars['String']>;
  cdn_region?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  epg_channel?: Maybe<Scalars['String']>;
  epg_type?: Maybe<Scalars['String']>;
  fsys_unit_net_price?: Maybe<Scalars['numeric']>;
  invoice_run?: Maybe<Scalars['String']>;
  invoice_run_processing_status?: Maybe<Scalars['String']>;
  invoice_run_start_date?: Maybe<Scalars['timestamptz']>;
  last_charge_to_date?: Maybe<Scalars['date']>;
  last_invoice_target_date?: Maybe<Scalars['date']>;
  list_price?: Maybe<Scalars['numeric']>;
  next_billing_date?: Maybe<Scalars['date']>;
  next_charge_date?: Maybe<Scalars['date']>;
  order_product_line_status?: Maybe<Scalars['String']>;
  order_product_number?: Maybe<Scalars['String']>;
  override_next_billing_date?: Maybe<Scalars['date']>;
  quantity?: Maybe<Scalars['float8']>;
  revenue_model?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_order_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
  salesforce_product_id?: Maybe<Scalars['String']>;
  salesforce_quote_line_id?: Maybe<Scalars['String']>;
  service_date?: Maybe<Scalars['date']>;
  so_po_reference_number?: Maybe<Scalars['String']>;
  ssai_ad_server?: Maybe<Scalars['String']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  terminated_date?: Maybe<Scalars['date']>;
  thunderstorm_setup_account?: Maybe<Scalars['String']>;
  total_price?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "order_product" */
export type Order_Product_Max_Order_By = {
  access_to_viewership_analytics?: InputMaybe<Order_By>;
  activation_status?: InputMaybe<Order_By>;
  ad_analytics_access_to_content_partner?: InputMaybe<Order_By>;
  ad_analytics_access_to_platform?: InputMaybe<Order_By>;
  ad_tags_from?: InputMaybe<Order_By>;
  ads_plus_model?: InputMaybe<Order_By>;
  agreed_billing_start_date?: InputMaybe<Order_By>;
  bill_through_date_override?: InputMaybe<Order_By>;
  billable_unit_price?: InputMaybe<Order_By>;
  billed_amount_without_tax?: InputMaybe<Order_By>;
  billing_start_date_rule?: InputMaybe<Order_By>;
  business_model?: InputMaybe<Order_By>;
  cdn_region?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  epg_channel?: InputMaybe<Order_By>;
  epg_type?: InputMaybe<Order_By>;
  fsys_unit_net_price?: InputMaybe<Order_By>;
  invoice_run?: InputMaybe<Order_By>;
  invoice_run_processing_status?: InputMaybe<Order_By>;
  invoice_run_start_date?: InputMaybe<Order_By>;
  last_charge_to_date?: InputMaybe<Order_By>;
  last_invoice_target_date?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  next_billing_date?: InputMaybe<Order_By>;
  next_charge_date?: InputMaybe<Order_By>;
  order_product_line_status?: InputMaybe<Order_By>;
  order_product_number?: InputMaybe<Order_By>;
  override_next_billing_date?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  revenue_model?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_order_id?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
  salesforce_product_id?: InputMaybe<Order_By>;
  salesforce_quote_line_id?: InputMaybe<Order_By>;
  service_date?: InputMaybe<Order_By>;
  so_po_reference_number?: InputMaybe<Order_By>;
  ssai_ad_server?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  terminated_date?: InputMaybe<Order_By>;
  thunderstorm_setup_account?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Product_Min_Fields = {
  __typename?: 'order_product_min_fields';
  access_to_viewership_analytics?: Maybe<Scalars['String']>;
  activation_status?: Maybe<Scalars['String']>;
  ad_analytics_access_to_content_partner?: Maybe<Scalars['String']>;
  ad_analytics_access_to_platform?: Maybe<Scalars['String']>;
  ad_tags_from?: Maybe<Scalars['String']>;
  ads_plus_model?: Maybe<Scalars['String']>;
  agreed_billing_start_date?: Maybe<Scalars['date']>;
  bill_through_date_override?: Maybe<Scalars['date']>;
  billable_unit_price?: Maybe<Scalars['numeric']>;
  billed_amount_without_tax?: Maybe<Scalars['numeric']>;
  billing_start_date_rule?: Maybe<Scalars['String']>;
  business_model?: Maybe<Scalars['String']>;
  cdn_region?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  end_date?: Maybe<Scalars['date']>;
  epg_channel?: Maybe<Scalars['String']>;
  epg_type?: Maybe<Scalars['String']>;
  fsys_unit_net_price?: Maybe<Scalars['numeric']>;
  invoice_run?: Maybe<Scalars['String']>;
  invoice_run_processing_status?: Maybe<Scalars['String']>;
  invoice_run_start_date?: Maybe<Scalars['timestamptz']>;
  last_charge_to_date?: Maybe<Scalars['date']>;
  last_invoice_target_date?: Maybe<Scalars['date']>;
  list_price?: Maybe<Scalars['numeric']>;
  next_billing_date?: Maybe<Scalars['date']>;
  next_charge_date?: Maybe<Scalars['date']>;
  order_product_line_status?: Maybe<Scalars['String']>;
  order_product_number?: Maybe<Scalars['String']>;
  override_next_billing_date?: Maybe<Scalars['date']>;
  quantity?: Maybe<Scalars['float8']>;
  revenue_model?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_order_id?: Maybe<Scalars['String']>;
  salesforce_platform_id?: Maybe<Scalars['String']>;
  salesforce_product_id?: Maybe<Scalars['String']>;
  salesforce_quote_line_id?: Maybe<Scalars['String']>;
  service_date?: Maybe<Scalars['date']>;
  so_po_reference_number?: Maybe<Scalars['String']>;
  ssai_ad_server?: Maybe<Scalars['String']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  terminated_date?: Maybe<Scalars['date']>;
  thunderstorm_setup_account?: Maybe<Scalars['String']>;
  total_price?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "order_product" */
export type Order_Product_Min_Order_By = {
  access_to_viewership_analytics?: InputMaybe<Order_By>;
  activation_status?: InputMaybe<Order_By>;
  ad_analytics_access_to_content_partner?: InputMaybe<Order_By>;
  ad_analytics_access_to_platform?: InputMaybe<Order_By>;
  ad_tags_from?: InputMaybe<Order_By>;
  ads_plus_model?: InputMaybe<Order_By>;
  agreed_billing_start_date?: InputMaybe<Order_By>;
  bill_through_date_override?: InputMaybe<Order_By>;
  billable_unit_price?: InputMaybe<Order_By>;
  billed_amount_without_tax?: InputMaybe<Order_By>;
  billing_start_date_rule?: InputMaybe<Order_By>;
  business_model?: InputMaybe<Order_By>;
  cdn_region?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  epg_channel?: InputMaybe<Order_By>;
  epg_type?: InputMaybe<Order_By>;
  fsys_unit_net_price?: InputMaybe<Order_By>;
  invoice_run?: InputMaybe<Order_By>;
  invoice_run_processing_status?: InputMaybe<Order_By>;
  invoice_run_start_date?: InputMaybe<Order_By>;
  last_charge_to_date?: InputMaybe<Order_By>;
  last_invoice_target_date?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  next_billing_date?: InputMaybe<Order_By>;
  next_charge_date?: InputMaybe<Order_By>;
  order_product_line_status?: InputMaybe<Order_By>;
  order_product_number?: InputMaybe<Order_By>;
  override_next_billing_date?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  revenue_model?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_order_id?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
  salesforce_product_id?: InputMaybe<Order_By>;
  salesforce_quote_line_id?: InputMaybe<Order_By>;
  service_date?: InputMaybe<Order_By>;
  so_po_reference_number?: InputMaybe<Order_By>;
  ssai_ad_server?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  terminated_date?: InputMaybe<Order_By>;
  thunderstorm_setup_account?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "order_product". */
export type Order_Product_Order_By = {
  access_to_viewership_analytics?: InputMaybe<Order_By>;
  activation_status?: InputMaybe<Order_By>;
  ad_analytics_access_to_content_partner?: InputMaybe<Order_By>;
  ad_analytics_access_to_platform?: InputMaybe<Order_By>;
  ad_tags_from?: InputMaybe<Order_By>;
  ads_plus_model?: InputMaybe<Order_By>;
  agreed_billing_start_date?: InputMaybe<Order_By>;
  bill_through_date_override?: InputMaybe<Order_By>;
  billable_unit_price?: InputMaybe<Order_By>;
  billed_amount_without_tax?: InputMaybe<Order_By>;
  billing_start_date_rule?: InputMaybe<Order_By>;
  business_model?: InputMaybe<Order_By>;
  cdn_region?: InputMaybe<Order_By>;
  channel?: InputMaybe<Channel_Order_By>;
  created_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  epg_channel?: InputMaybe<Order_By>;
  epg_type?: InputMaybe<Order_By>;
  fsys_unit_net_price?: InputMaybe<Order_By>;
  invoice_run?: InputMaybe<Order_By>;
  invoice_run_processing_status?: InputMaybe<Order_By>;
  invoice_run_start_date?: InputMaybe<Order_By>;
  is_activated?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  last_charge_to_date?: InputMaybe<Order_By>;
  last_invoice_target_date?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  next_billing_date?: InputMaybe<Order_By>;
  next_charge_date?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  order_product_line_status?: InputMaybe<Order_By>;
  order_product_number?: InputMaybe<Order_By>;
  order_product_to_quote_line?: InputMaybe<Quote_Line_Order_By>;
  override_next_billing_date?: InputMaybe<Order_By>;
  platform?: InputMaybe<Platform_Order_By>;
  product?: InputMaybe<Product_Order_By>;
  quantity?: InputMaybe<Order_By>;
  revenue_model?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_order_id?: InputMaybe<Order_By>;
  salesforce_platform_id?: InputMaybe<Order_By>;
  salesforce_product_id?: InputMaybe<Order_By>;
  salesforce_quote_line_id?: InputMaybe<Order_By>;
  service_date?: InputMaybe<Order_By>;
  so_po_reference_number?: InputMaybe<Order_By>;
  ssai_ad_server?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  terminated_date?: InputMaybe<Order_By>;
  thunderstorm_setup_account?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "order_product" */
export enum Order_Product_Select_Column {
  /** column name */
  AccessToViewershipAnalytics = 'access_to_viewership_analytics',
  /** column name */
  ActivationStatus = 'activation_status',
  /** column name */
  AdAnalyticsAccessToContentPartner = 'ad_analytics_access_to_content_partner',
  /** column name */
  AdAnalyticsAccessToPlatform = 'ad_analytics_access_to_platform',
  /** column name */
  AdTagsFrom = 'ad_tags_from',
  /** column name */
  AdsPlusModel = 'ads_plus_model',
  /** column name */
  AgreedBillingStartDate = 'agreed_billing_start_date',
  /** column name */
  BillThroughDateOverride = 'bill_through_date_override',
  /** column name */
  BillableUnitPrice = 'billable_unit_price',
  /** column name */
  BilledAmountWithoutTax = 'billed_amount_without_tax',
  /** column name */
  BillingStartDateRule = 'billing_start_date_rule',
  /** column name */
  BusinessModel = 'business_model',
  /** column name */
  CdnRegion = 'cdn_region',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EpgChannel = 'epg_channel',
  /** column name */
  EpgType = 'epg_type',
  /** column name */
  FsysUnitNetPrice = 'fsys_unit_net_price',
  /** column name */
  InvoiceRun = 'invoice_run',
  /** column name */
  InvoiceRunProcessingStatus = 'invoice_run_processing_status',
  /** column name */
  InvoiceRunStartDate = 'invoice_run_start_date',
  /** column name */
  IsActivated = 'is_activated',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LastChargeToDate = 'last_charge_to_date',
  /** column name */
  LastInvoiceTargetDate = 'last_invoice_target_date',
  /** column name */
  ListPrice = 'list_price',
  /** column name */
  NextBillingDate = 'next_billing_date',
  /** column name */
  NextChargeDate = 'next_charge_date',
  /** column name */
  OrderProductLineStatus = 'order_product_line_status',
  /** column name */
  OrderProductNumber = 'order_product_number',
  /** column name */
  OverrideNextBillingDate = 'override_next_billing_date',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RevenueModel = 'revenue_model',
  /** column name */
  SalesforceChannelId = 'salesforce_channel_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  SalesforceOrderId = 'salesforce_order_id',
  /** column name */
  SalesforcePlatformId = 'salesforce_platform_id',
  /** column name */
  SalesforceProductId = 'salesforce_product_id',
  /** column name */
  SalesforceQuoteLineId = 'salesforce_quote_line_id',
  /** column name */
  ServiceDate = 'service_date',
  /** column name */
  SoPoReferenceNumber = 'so_po_reference_number',
  /** column name */
  SsaiAdServer = 'ssai_ad_server',
  /** column name */
  TaxAmount = 'tax_amount',
  /** column name */
  TerminatedDate = 'terminated_date',
  /** column name */
  ThunderstormSetupAccount = 'thunderstorm_setup_account',
  /** column name */
  TotalPrice = 'total_price',
  /** column name */
  UnitPrice = 'unit_price',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "order_product_aggregate_bool_exp_avg_arguments_columns" columns of table "order_product" */
export enum Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  Quantity = 'quantity'
}

/** select "order_product_aggregate_bool_exp_bool_and_arguments_columns" columns of table "order_product" */
export enum Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActivated = 'is_activated',
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "order_product_aggregate_bool_exp_bool_or_arguments_columns" columns of table "order_product" */
export enum Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActivated = 'is_activated',
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "order_product_aggregate_bool_exp_corr_arguments_columns" columns of table "order_product" */
export enum Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  Quantity = 'quantity'
}

/** select "order_product_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "order_product" */
export enum Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  Quantity = 'quantity'
}

/** select "order_product_aggregate_bool_exp_max_arguments_columns" columns of table "order_product" */
export enum Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  Quantity = 'quantity'
}

/** select "order_product_aggregate_bool_exp_min_arguments_columns" columns of table "order_product" */
export enum Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  Quantity = 'quantity'
}

/** select "order_product_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "order_product" */
export enum Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  Quantity = 'quantity'
}

/** select "order_product_aggregate_bool_exp_sum_arguments_columns" columns of table "order_product" */
export enum Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  Quantity = 'quantity'
}

/** select "order_product_aggregate_bool_exp_var_samp_arguments_columns" columns of table "order_product" */
export enum Order_Product_Select_Column_Order_Product_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  Quantity = 'quantity'
}

/** aggregate stddev on columns */
export type Order_Product_Stddev_Fields = {
  __typename?: 'order_product_stddev_fields';
  billable_unit_price?: Maybe<Scalars['Float']>;
  billed_amount_without_tax?: Maybe<Scalars['Float']>;
  fsys_unit_net_price?: Maybe<Scalars['Float']>;
  list_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_price?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_product" */
export type Order_Product_Stddev_Order_By = {
  billable_unit_price?: InputMaybe<Order_By>;
  billed_amount_without_tax?: InputMaybe<Order_By>;
  fsys_unit_net_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Product_Stddev_Pop_Fields = {
  __typename?: 'order_product_stddev_pop_fields';
  billable_unit_price?: Maybe<Scalars['Float']>;
  billed_amount_without_tax?: Maybe<Scalars['Float']>;
  fsys_unit_net_price?: Maybe<Scalars['Float']>;
  list_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_price?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_product" */
export type Order_Product_Stddev_Pop_Order_By = {
  billable_unit_price?: InputMaybe<Order_By>;
  billed_amount_without_tax?: InputMaybe<Order_By>;
  fsys_unit_net_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Product_Stddev_Samp_Fields = {
  __typename?: 'order_product_stddev_samp_fields';
  billable_unit_price?: Maybe<Scalars['Float']>;
  billed_amount_without_tax?: Maybe<Scalars['Float']>;
  fsys_unit_net_price?: Maybe<Scalars['Float']>;
  list_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_price?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_product" */
export type Order_Product_Stddev_Samp_Order_By = {
  billable_unit_price?: InputMaybe<Order_By>;
  billed_amount_without_tax?: InputMaybe<Order_By>;
  fsys_unit_net_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_product" */
export type Order_Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Product_Stream_Cursor_Value_Input = {
  access_to_viewership_analytics?: InputMaybe<Scalars['String']>;
  activation_status?: InputMaybe<Scalars['String']>;
  ad_analytics_access_to_content_partner?: InputMaybe<Scalars['String']>;
  ad_analytics_access_to_platform?: InputMaybe<Scalars['String']>;
  ad_tags_from?: InputMaybe<Scalars['String']>;
  ads_plus_model?: InputMaybe<Scalars['String']>;
  agreed_billing_start_date?: InputMaybe<Scalars['date']>;
  bill_through_date_override?: InputMaybe<Scalars['date']>;
  billable_unit_price?: InputMaybe<Scalars['numeric']>;
  billed_amount_without_tax?: InputMaybe<Scalars['numeric']>;
  billing_start_date_rule?: InputMaybe<Scalars['String']>;
  business_model?: InputMaybe<Scalars['String']>;
  cdn_region?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  end_date?: InputMaybe<Scalars['date']>;
  epg_channel?: InputMaybe<Scalars['String']>;
  epg_type?: InputMaybe<Scalars['String']>;
  fsys_unit_net_price?: InputMaybe<Scalars['numeric']>;
  invoice_run?: InputMaybe<Scalars['String']>;
  invoice_run_processing_status?: InputMaybe<Scalars['String']>;
  invoice_run_start_date?: InputMaybe<Scalars['timestamptz']>;
  is_activated?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  last_charge_to_date?: InputMaybe<Scalars['date']>;
  last_invoice_target_date?: InputMaybe<Scalars['date']>;
  list_price?: InputMaybe<Scalars['numeric']>;
  next_billing_date?: InputMaybe<Scalars['date']>;
  next_charge_date?: InputMaybe<Scalars['date']>;
  order_product_line_status?: InputMaybe<Scalars['String']>;
  order_product_number?: InputMaybe<Scalars['String']>;
  override_next_billing_date?: InputMaybe<Scalars['date']>;
  quantity?: InputMaybe<Scalars['float8']>;
  revenue_model?: InputMaybe<Scalars['String']>;
  salesforce_channel_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_order_id?: InputMaybe<Scalars['String']>;
  salesforce_platform_id?: InputMaybe<Scalars['String']>;
  salesforce_product_id?: InputMaybe<Scalars['String']>;
  salesforce_quote_line_id?: InputMaybe<Scalars['String']>;
  service_date?: InputMaybe<Scalars['date']>;
  so_po_reference_number?: InputMaybe<Scalars['String']>;
  ssai_ad_server?: InputMaybe<Scalars['String']>;
  tax_amount?: InputMaybe<Scalars['numeric']>;
  terminated_date?: InputMaybe<Scalars['date']>;
  thunderstorm_setup_account?: InputMaybe<Scalars['String']>;
  total_price?: InputMaybe<Scalars['numeric']>;
  unit_price?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Order_Product_Sum_Fields = {
  __typename?: 'order_product_sum_fields';
  billable_unit_price?: Maybe<Scalars['numeric']>;
  billed_amount_without_tax?: Maybe<Scalars['numeric']>;
  fsys_unit_net_price?: Maybe<Scalars['numeric']>;
  list_price?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['float8']>;
  tax_amount?: Maybe<Scalars['numeric']>;
  total_price?: Maybe<Scalars['numeric']>;
  unit_price?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "order_product" */
export type Order_Product_Sum_Order_By = {
  billable_unit_price?: InputMaybe<Order_By>;
  billed_amount_without_tax?: InputMaybe<Order_By>;
  fsys_unit_net_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Order_Product_Var_Pop_Fields = {
  __typename?: 'order_product_var_pop_fields';
  billable_unit_price?: Maybe<Scalars['Float']>;
  billed_amount_without_tax?: Maybe<Scalars['Float']>;
  fsys_unit_net_price?: Maybe<Scalars['Float']>;
  list_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_price?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_product" */
export type Order_Product_Var_Pop_Order_By = {
  billable_unit_price?: InputMaybe<Order_By>;
  billed_amount_without_tax?: InputMaybe<Order_By>;
  fsys_unit_net_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Product_Var_Samp_Fields = {
  __typename?: 'order_product_var_samp_fields';
  billable_unit_price?: Maybe<Scalars['Float']>;
  billed_amount_without_tax?: Maybe<Scalars['Float']>;
  fsys_unit_net_price?: Maybe<Scalars['Float']>;
  list_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_price?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_product" */
export type Order_Product_Var_Samp_Order_By = {
  billable_unit_price?: InputMaybe<Order_By>;
  billed_amount_without_tax?: InputMaybe<Order_By>;
  fsys_unit_net_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Product_Variance_Fields = {
  __typename?: 'order_product_variance_fields';
  billable_unit_price?: Maybe<Scalars['Float']>;
  billed_amount_without_tax?: Maybe<Scalars['Float']>;
  fsys_unit_net_price?: Maybe<Scalars['Float']>;
  list_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  tax_amount?: Maybe<Scalars['Float']>;
  total_price?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_product" */
export type Order_Product_Variance_Order_By = {
  billable_unit_price?: InputMaybe<Order_By>;
  billed_amount_without_tax?: InputMaybe<Order_By>;
  fsys_unit_net_price?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  tax_amount?: InputMaybe<Order_By>;
  total_price?: InputMaybe<Order_By>;
  unit_price?: InputMaybe<Order_By>;
};

/** select columns of table "order" */
export enum Order_Select_Column {
  /** column name */
  ActivatedDate = 'activated_date',
  /** column name */
  ActualDeliveryDate = 'actual_delivery_date',
  /** column name */
  ActualGoliveDate = 'actual_golive_date',
  /** column name */
  Amount = 'amount',
  /** column name */
  BillingTerm = 'billing_term',
  /** column name */
  CompanyAuthorizedDate = 'company_authorized_date',
  /** column name */
  ConsumptionMrValue = 'consumption_mr_value',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerAuthorizedDate = 'customer_authorized_date',
  /** column name */
  EffectiveDate = 'effective_date',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  HandoverToOnboarding = 'handover_to_onboarding',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  MrrValue = 'mrr_value',
  /** column name */
  Name = 'name',
  /** column name */
  OrderBillingStatus = 'order_billing_status',
  /** column name */
  OrderNumber = 'order_number',
  /** column name */
  OrderType = 'order_type',
  /** column name */
  PlannedDeliveryDate = 'planned_delivery_date',
  /** column name */
  PlannedGoliveDate = 'planned_golive_date',
  /** column name */
  PoDate = 'po_date',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  SalesforceOpportunityId = 'salesforce_opportunity_id',
  /** column name */
  SalesforceOwnerId = 'salesforce_owner_id',
  /** column name */
  SalesforceQuoteId = 'salesforce_quote_id',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  SubscriptionMrrValue = 'subscription_mrr_value',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "order_aggregate_bool_exp_bool_and_arguments_columns" columns of table "order" */
export enum Order_Select_Column_Order_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HandoverToOnboarding = 'handover_to_onboarding',
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "order_aggregate_bool_exp_bool_or_arguments_columns" columns of table "order" */
export enum Order_Select_Column_Order_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HandoverToOnboarding = 'handover_to_onboarding',
  /** column name */
  IsDeleted = 'is_deleted'
}

/** aggregate stddev on columns */
export type Order_Stddev_Fields = {
  __typename?: 'order_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  consumption_mr_value?: Maybe<Scalars['Float']>;
  mrr_value?: Maybe<Scalars['Float']>;
  subscription_mrr_value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order" */
export type Order_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  consumption_mr_value?: InputMaybe<Order_By>;
  mrr_value?: InputMaybe<Order_By>;
  subscription_mrr_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Stddev_Pop_Fields = {
  __typename?: 'order_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  consumption_mr_value?: Maybe<Scalars['Float']>;
  mrr_value?: Maybe<Scalars['Float']>;
  subscription_mrr_value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order" */
export type Order_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  consumption_mr_value?: InputMaybe<Order_By>;
  mrr_value?: InputMaybe<Order_By>;
  subscription_mrr_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Stddev_Samp_Fields = {
  __typename?: 'order_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  consumption_mr_value?: Maybe<Scalars['Float']>;
  mrr_value?: Maybe<Scalars['Float']>;
  subscription_mrr_value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order" */
export type Order_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  consumption_mr_value?: InputMaybe<Order_By>;
  mrr_value?: InputMaybe<Order_By>;
  subscription_mrr_value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order" */
export type Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Stream_Cursor_Value_Input = {
  activated_date?: InputMaybe<Scalars['timestamptz']>;
  actual_delivery_date?: InputMaybe<Scalars['date']>;
  actual_golive_date?: InputMaybe<Scalars['date']>;
  amount?: InputMaybe<Scalars['numeric']>;
  billing_term?: InputMaybe<Scalars['String']>;
  company_authorized_date?: InputMaybe<Scalars['date']>;
  consumption_mr_value?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  customer_authorized_date?: InputMaybe<Scalars['date']>;
  effective_date?: InputMaybe<Scalars['date']>;
  end_date?: InputMaybe<Scalars['date']>;
  handover_to_onboarding?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  mrr_value?: InputMaybe<Scalars['numeric']>;
  name?: InputMaybe<Scalars['String']>;
  order_billing_status?: InputMaybe<Scalars['String']>;
  order_number?: InputMaybe<Scalars['String']>;
  order_type?: InputMaybe<Scalars['String']>;
  planned_delivery_date?: InputMaybe<Scalars['date']>;
  planned_golive_date?: InputMaybe<Scalars['date']>;
  po_date?: InputMaybe<Scalars['date']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_opportunity_id?: InputMaybe<Scalars['String']>;
  salesforce_owner_id?: InputMaybe<Scalars['String']>;
  salesforce_quote_id?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subscription_mrr_value?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Order_Sum_Fields = {
  __typename?: 'order_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  consumption_mr_value?: Maybe<Scalars['numeric']>;
  mrr_value?: Maybe<Scalars['numeric']>;
  subscription_mrr_value?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "order" */
export type Order_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  consumption_mr_value?: InputMaybe<Order_By>;
  mrr_value?: InputMaybe<Order_By>;
  subscription_mrr_value?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Order_Var_Pop_Fields = {
  __typename?: 'order_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  consumption_mr_value?: Maybe<Scalars['Float']>;
  mrr_value?: Maybe<Scalars['Float']>;
  subscription_mrr_value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order" */
export type Order_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  consumption_mr_value?: InputMaybe<Order_By>;
  mrr_value?: InputMaybe<Order_By>;
  subscription_mrr_value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Var_Samp_Fields = {
  __typename?: 'order_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  consumption_mr_value?: Maybe<Scalars['Float']>;
  mrr_value?: Maybe<Scalars['Float']>;
  subscription_mrr_value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order" */
export type Order_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  consumption_mr_value?: InputMaybe<Order_By>;
  mrr_value?: InputMaybe<Order_By>;
  subscription_mrr_value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Variance_Fields = {
  __typename?: 'order_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  consumption_mr_value?: Maybe<Scalars['Float']>;
  mrr_value?: Maybe<Scalars['Float']>;
  subscription_mrr_value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order" */
export type Order_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  consumption_mr_value?: InputMaybe<Order_By>;
  mrr_value?: InputMaybe<Order_By>;
  subscription_mrr_value?: InputMaybe<Order_By>;
};

/** List of users on Salesforce */
export type Owner = {
  __typename?: 'owner';
  /** An object relationship */
  amagi_content_plus_owner?: Maybe<Content_Plus_Contacts>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  first_name?: Maybe<Scalars['String']>;
  is_active: Scalars['Boolean'];
  last_name: Scalars['String'];
  /** An array relationship */
  order_item_lines: Array<Order_Item_Line>;
  /** An aggregate relationship */
  order_item_lines_aggregate: Order_Item_Line_Aggregate;
  /** An array relationship */
  order_items: Array<Order_Item>;
  /** An aggregate relationship */
  order_items_aggregate: Order_Item_Aggregate;
  /** An object relationship */
  owner_to_user?: Maybe<User>;
  region?: Maybe<Scalars['String']>;
  salesforce_created_date: Scalars['timestamptz'];
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date: Scalars['timestamptz'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** List of users on Salesforce */
export type OwnerOrder_Item_LinesArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Line_Order_By>>;
  where?: InputMaybe<Order_Item_Line_Bool_Exp>;
};


/** List of users on Salesforce */
export type OwnerOrder_Item_Lines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Line_Order_By>>;
  where?: InputMaybe<Order_Item_Line_Bool_Exp>;
};


/** List of users on Salesforce */
export type OwnerOrder_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Order_By>>;
  where?: InputMaybe<Order_Item_Bool_Exp>;
};


/** List of users on Salesforce */
export type OwnerOrder_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Order_By>>;
  where?: InputMaybe<Order_Item_Bool_Exp>;
};

/** aggregated selection of "owner" */
export type Owner_Aggregate = {
  __typename?: 'owner_aggregate';
  aggregate?: Maybe<Owner_Aggregate_Fields>;
  nodes: Array<Owner>;
};

/** aggregate fields of "owner" */
export type Owner_Aggregate_Fields = {
  __typename?: 'owner_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Owner_Max_Fields>;
  min?: Maybe<Owner_Min_Fields>;
};


/** aggregate fields of "owner" */
export type Owner_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Owner_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "owner". All fields are combined with a logical 'AND'. */
export type Owner_Bool_Exp = {
  _and?: InputMaybe<Array<Owner_Bool_Exp>>;
  _not?: InputMaybe<Owner_Bool_Exp>;
  _or?: InputMaybe<Array<Owner_Bool_Exp>>;
  amagi_content_plus_owner?: InputMaybe<Content_Plus_Contacts_Bool_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  order_item_lines?: InputMaybe<Order_Item_Line_Bool_Exp>;
  order_item_lines_aggregate?: InputMaybe<Order_Item_Line_Aggregate_Bool_Exp>;
  order_items?: InputMaybe<Order_Item_Bool_Exp>;
  order_items_aggregate?: InputMaybe<Order_Item_Aggregate_Bool_Exp>;
  owner_to_user?: InputMaybe<User_Bool_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Owner_Max_Fields = {
  __typename?: 'owner_max_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Owner_Min_Fields = {
  __typename?: 'owner_min_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "owner". */
export type Owner_Order_By = {
  amagi_content_plus_owner?: InputMaybe<Content_Plus_Contacts_Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  order_item_lines_aggregate?: InputMaybe<Order_Item_Line_Aggregate_Order_By>;
  order_items_aggregate?: InputMaybe<Order_Item_Aggregate_Order_By>;
  owner_to_user?: InputMaybe<User_Order_By>;
  region?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "owner" */
export enum Owner_Select_Column {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Region = 'region',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "owner" */
export type Owner_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Owner_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Owner_Stream_Cursor_Value_Input = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "page" */
export type Page = {
  __typename?: 'page';
  content?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

/** Boolean expression to filter rows from the table "page". All fields are combined with a logical 'AND'. */
export type Page_Bool_Exp = {
  _and?: InputMaybe<Array<Page_Bool_Exp>>;
  _not?: InputMaybe<Page_Bool_Exp>;
  _or?: InputMaybe<Array<Page_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "page" */
export enum Page_Constraint {
  /** unique or primary key constraint on columns "slug" */
  PagePkey = 'page_pkey'
}

/** input type for inserting data into table "page" */
export type Page_Insert_Input = {
  content?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "page" */
export type Page_Mutation_Response = {
  __typename?: 'page_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Page>;
};

/** on_conflict condition type for table "page" */
export type Page_On_Conflict = {
  constraint: Page_Constraint;
  update_columns?: Array<Page_Update_Column>;
  where?: InputMaybe<Page_Bool_Exp>;
};

/** Ordering options when selecting data from "page". */
export type Page_Order_By = {
  content?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
};

/** primary key columns input for table: page */
export type Page_Pk_Columns_Input = {
  slug: Scalars['String'];
};

/** select columns of table "page" */
export enum Page_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "page" */
export type Page_Set_Input = {
  content?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "page" */
export type Page_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Page_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Page_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** update columns of table "page" */
export enum Page_Update_Column {
  /** column name */
  Content = 'content'
}

export type Page_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Page_Set_Input>;
  /** filter the rows which have to be updated */
  where: Page_Bool_Exp;
};

/** columns and relationships of "platform" */
export type Platform = {
  __typename?: 'platform';
  /** An object relationship */
  account?: Maybe<Account>;
  ad_break?: Maybe<Scalars['String']>;
  ad_trigger_type?: Maybe<Scalars['String']>;
  amagi_id_of_platform_owner?: Maybe<Scalars['String']>;
  analytics_share_rule?: Maybe<Scalars['String']>;
  application_usage?: Maybe<Scalars['String']>;
  artwork_dimension?: Maybe<Scalars['String']>;
  aspect_ratio?: Maybe<Scalars['String']>;
  available_in_amagi_now?: Maybe<Scalars['Boolean']>;
  availablity_country_and_regions?: Maybe<Scalars['jsonb']>;
  availibity_countries?: Maybe<Scalars['String']>;
  availibity_region?: Maybe<Scalars['String']>;
  avg_ad_minute_per_hour?: Maybe<Scalars['Int']>;
  avg_monthly_active_user?: Maybe<Scalars['String']>;
  avg_monthly_hov?: Maybe<Scalars['numeric']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  devices_field?: Maybe<Scalars['jsonb']>;
  epg?: Maybe<Scalars['String']>;
  epg_format?: Maybe<Scalars['String']>;
  epg_format_example?: Maybe<Scalars['String']>;
  estimated_channel_deliveries?: Maybe<Scalars['numeric']>;
  facebook?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** A computed field, executes function "convert_to_string_platform_id" */
  id_text?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  inventory_model?: Maybe<Scalars['String']>;
  is_deleted: Scalars['Boolean'];
  is_duplicate?: Maybe<Scalars['Boolean']>;
  is_platform_group?: Maybe<Scalars['String']>;
  keyring?: Maybe<Scalars['jsonb']>;
  linkedin?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  mandatory: Scalars['Boolean'];
  max_file_size?: Maybe<Scalars['Int']>;
  multiple_salesforce_id?: Maybe<Scalars['jsonb']>;
  name: Scalars['String'];
  no_of_player_needed?: Maybe<Scalars['Int']>;
  onboarded_date?: Maybe<Scalars['timestamptz']>;
  overall_bitrate?: Maybe<Scalars['String']>;
  platform_artwork?: Maybe<Scalars['jsonb']>;
  platform_brand?: Maybe<Scalars['String']>;
  platform_contact?: Maybe<Scalars['String']>;
  platform_contacts?: Maybe<Scalars['jsonb']>;
  platform_description?: Maybe<Scalars['String']>;
  platform_manager?: Maybe<Scalars['jsonb']>;
  platform_master_id?: Maybe<Scalars['uuid']>;
  platform_name?: Maybe<Scalars['String']>;
  platform_qa_cycle?: Maybe<Scalars['String']>;
  platform_specific_encoding?: Maybe<Scalars['String']>;
  platform_tier?: Maybe<Scalars['String']>;
  /** An array relationship */
  platform_to_platform: Array<Platform>;
  /** An aggregate relationship */
  platform_to_platform_aggregate: Platform_Aggregate;
  /** An object relationship */
  platform_to_platform_of_grouped?: Maybe<Platform>;
  platforms_grouped?: Maybe<Scalars['String']>;
  poster?: Maybe<Scalars['jsonb']>;
  preferred_business_model?: Maybe<Scalars['String']>;
  preferred_genre?: Maybe<Scalars['jsonb']>;
  preferred_language?: Maybe<Scalars['jsonb']>;
  presentation?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  quote_lines: Array<Quote_Line>;
  /** An aggregate relationship */
  quote_lines_aggregate: Quote_Line_Aggregate;
  redundancy?: Maybe<Scalars['String']>;
  redundancy_delivery_count?: Maybe<Scalars['numeric']>;
  redundancy_player_count?: Maybe<Scalars['numeric']>;
  reference_links?: Maybe<Scalars['jsonb']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_created_date: Scalars['timestamptz'];
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date: Scalars['timestamptz'];
  source?: Maybe<Scalars['String']>;
  specifications_url?: Maybe<Scalars['String']>;
  ssai_by?: Maybe<Scalars['String']>;
  stream_type?: Maybe<Scalars['jsonb']>;
  subtitle_cc_format?: Maybe<Scalars['String']>;
  target_audience?: Maybe<Scalars['jsonb']>;
  technical_spec?: Maybe<Scalars['jsonb']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  video?: Maybe<Scalars['jsonb']>;
  video_player?: Maybe<Scalars['String']>;
  vod_connector_availability?: Maybe<Scalars['String']>;
  vod_delivery_mode?: Maybe<Scalars['String']>;
  vod_support?: Maybe<Scalars['String']>;
  website_url?: Maybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformAvailablity_Country_And_RegionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformDevices_FieldArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformKeyringArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformMultiple_Salesforce_IdArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformPlatform_ArtworkArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformPlatform_ContactsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformPlatform_ManagerArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformPlatform_To_PlatformArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


/** columns and relationships of "platform" */
export type PlatformPlatform_To_Platform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


/** columns and relationships of "platform" */
export type PlatformPosterArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformPreferred_GenreArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformPreferred_LanguageArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformPresentationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformQuote_LinesArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Order_By>>;
  where?: InputMaybe<Quote_Line_Bool_Exp>;
};


/** columns and relationships of "platform" */
export type PlatformQuote_Lines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Order_By>>;
  where?: InputMaybe<Quote_Line_Bool_Exp>;
};


/** columns and relationships of "platform" */
export type PlatformReference_LinksArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformStream_TypeArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformTarget_AudienceArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformTechnical_SpecArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "platform" */
export type PlatformVideoArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "platform" */
export type Platform_Aggregate = {
  __typename?: 'platform_aggregate';
  aggregate?: Maybe<Platform_Aggregate_Fields>;
  nodes: Array<Platform>;
};

export type Platform_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Platform_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Platform_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Platform_Aggregate_Bool_Exp_Count>;
};

export type Platform_Aggregate_Bool_Exp_Bool_And = {
  arguments: Platform_Select_Column_Platform_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Platform_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Platform_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Platform_Select_Column_Platform_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Platform_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Platform_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Platform_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Platform_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "platform" */
export type Platform_Aggregate_Fields = {
  __typename?: 'platform_aggregate_fields';
  avg?: Maybe<Platform_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Platform_Max_Fields>;
  min?: Maybe<Platform_Min_Fields>;
  stddev?: Maybe<Platform_Stddev_Fields>;
  stddev_pop?: Maybe<Platform_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Platform_Stddev_Samp_Fields>;
  sum?: Maybe<Platform_Sum_Fields>;
  var_pop?: Maybe<Platform_Var_Pop_Fields>;
  var_samp?: Maybe<Platform_Var_Samp_Fields>;
  variance?: Maybe<Platform_Variance_Fields>;
};


/** aggregate fields of "platform" */
export type Platform_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Platform_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "platform" */
export type Platform_Aggregate_Order_By = {
  avg?: InputMaybe<Platform_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Platform_Max_Order_By>;
  min?: InputMaybe<Platform_Min_Order_By>;
  stddev?: InputMaybe<Platform_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Platform_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Platform_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Platform_Sum_Order_By>;
  var_pop?: InputMaybe<Platform_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Platform_Var_Samp_Order_By>;
  variance?: InputMaybe<Platform_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Platform_Append_Input = {
  availablity_country_and_regions?: InputMaybe<Scalars['jsonb']>;
  devices_field?: InputMaybe<Scalars['jsonb']>;
  keyring?: InputMaybe<Scalars['jsonb']>;
  multiple_salesforce_id?: InputMaybe<Scalars['jsonb']>;
  platform_artwork?: InputMaybe<Scalars['jsonb']>;
  platform_contacts?: InputMaybe<Scalars['jsonb']>;
  platform_manager?: InputMaybe<Scalars['jsonb']>;
  poster?: InputMaybe<Scalars['jsonb']>;
  preferred_genre?: InputMaybe<Scalars['jsonb']>;
  preferred_language?: InputMaybe<Scalars['jsonb']>;
  presentation?: InputMaybe<Scalars['jsonb']>;
  reference_links?: InputMaybe<Scalars['jsonb']>;
  stream_type?: InputMaybe<Scalars['jsonb']>;
  target_audience?: InputMaybe<Scalars['jsonb']>;
  technical_spec?: InputMaybe<Scalars['jsonb']>;
  video?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "platform" */
export type Platform_Arr_Rel_Insert_Input = {
  data: Array<Platform_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Platform_On_Conflict>;
};

/** aggregate avg on columns */
export type Platform_Avg_Fields = {
  __typename?: 'platform_avg_fields';
  avg_ad_minute_per_hour?: Maybe<Scalars['Float']>;
  avg_monthly_hov?: Maybe<Scalars['Float']>;
  estimated_channel_deliveries?: Maybe<Scalars['Float']>;
  max_file_size?: Maybe<Scalars['Float']>;
  no_of_player_needed?: Maybe<Scalars['Float']>;
  redundancy_delivery_count?: Maybe<Scalars['Float']>;
  redundancy_player_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "platform" */
export type Platform_Avg_Order_By = {
  avg_ad_minute_per_hour?: InputMaybe<Order_By>;
  avg_monthly_hov?: InputMaybe<Order_By>;
  estimated_channel_deliveries?: InputMaybe<Order_By>;
  max_file_size?: InputMaybe<Order_By>;
  no_of_player_needed?: InputMaybe<Order_By>;
  redundancy_delivery_count?: InputMaybe<Order_By>;
  redundancy_player_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "platform". All fields are combined with a logical 'AND'. */
export type Platform_Bool_Exp = {
  _and?: InputMaybe<Array<Platform_Bool_Exp>>;
  _not?: InputMaybe<Platform_Bool_Exp>;
  _or?: InputMaybe<Array<Platform_Bool_Exp>>;
  account?: InputMaybe<Account_Bool_Exp>;
  ad_break?: InputMaybe<String_Comparison_Exp>;
  ad_trigger_type?: InputMaybe<String_Comparison_Exp>;
  amagi_id_of_platform_owner?: InputMaybe<String_Comparison_Exp>;
  analytics_share_rule?: InputMaybe<String_Comparison_Exp>;
  application_usage?: InputMaybe<String_Comparison_Exp>;
  artwork_dimension?: InputMaybe<String_Comparison_Exp>;
  aspect_ratio?: InputMaybe<String_Comparison_Exp>;
  available_in_amagi_now?: InputMaybe<Boolean_Comparison_Exp>;
  availablity_country_and_regions?: InputMaybe<Jsonb_Comparison_Exp>;
  availibity_countries?: InputMaybe<String_Comparison_Exp>;
  availibity_region?: InputMaybe<String_Comparison_Exp>;
  avg_ad_minute_per_hour?: InputMaybe<Int_Comparison_Exp>;
  avg_monthly_active_user?: InputMaybe<String_Comparison_Exp>;
  avg_monthly_hov?: InputMaybe<Numeric_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  devices_field?: InputMaybe<Jsonb_Comparison_Exp>;
  epg?: InputMaybe<String_Comparison_Exp>;
  epg_format?: InputMaybe<String_Comparison_Exp>;
  epg_format_example?: InputMaybe<String_Comparison_Exp>;
  estimated_channel_deliveries?: InputMaybe<Numeric_Comparison_Exp>;
  facebook?: InputMaybe<String_Comparison_Exp>;
  format?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  id_text?: InputMaybe<String_Comparison_Exp>;
  instagram?: InputMaybe<String_Comparison_Exp>;
  inventory_model?: InputMaybe<String_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_duplicate?: InputMaybe<Boolean_Comparison_Exp>;
  is_platform_group?: InputMaybe<String_Comparison_Exp>;
  keyring?: InputMaybe<Jsonb_Comparison_Exp>;
  linkedin?: InputMaybe<String_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  mandatory?: InputMaybe<Boolean_Comparison_Exp>;
  max_file_size?: InputMaybe<Int_Comparison_Exp>;
  multiple_salesforce_id?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  no_of_player_needed?: InputMaybe<Int_Comparison_Exp>;
  onboarded_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  overall_bitrate?: InputMaybe<String_Comparison_Exp>;
  platform_artwork?: InputMaybe<Jsonb_Comparison_Exp>;
  platform_brand?: InputMaybe<String_Comparison_Exp>;
  platform_contact?: InputMaybe<String_Comparison_Exp>;
  platform_contacts?: InputMaybe<Jsonb_Comparison_Exp>;
  platform_description?: InputMaybe<String_Comparison_Exp>;
  platform_manager?: InputMaybe<Jsonb_Comparison_Exp>;
  platform_master_id?: InputMaybe<Uuid_Comparison_Exp>;
  platform_name?: InputMaybe<String_Comparison_Exp>;
  platform_qa_cycle?: InputMaybe<String_Comparison_Exp>;
  platform_specific_encoding?: InputMaybe<String_Comparison_Exp>;
  platform_tier?: InputMaybe<String_Comparison_Exp>;
  platform_to_platform?: InputMaybe<Platform_Bool_Exp>;
  platform_to_platform_aggregate?: InputMaybe<Platform_Aggregate_Bool_Exp>;
  platform_to_platform_of_grouped?: InputMaybe<Platform_Bool_Exp>;
  platforms_grouped?: InputMaybe<String_Comparison_Exp>;
  poster?: InputMaybe<Jsonb_Comparison_Exp>;
  preferred_business_model?: InputMaybe<String_Comparison_Exp>;
  preferred_genre?: InputMaybe<Jsonb_Comparison_Exp>;
  preferred_language?: InputMaybe<Jsonb_Comparison_Exp>;
  presentation?: InputMaybe<Jsonb_Comparison_Exp>;
  quote_lines?: InputMaybe<Quote_Line_Bool_Exp>;
  quote_lines_aggregate?: InputMaybe<Quote_Line_Aggregate_Bool_Exp>;
  redundancy?: InputMaybe<String_Comparison_Exp>;
  redundancy_delivery_count?: InputMaybe<Numeric_Comparison_Exp>;
  redundancy_player_count?: InputMaybe<Numeric_Comparison_Exp>;
  reference_links?: InputMaybe<Jsonb_Comparison_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  specifications_url?: InputMaybe<String_Comparison_Exp>;
  ssai_by?: InputMaybe<String_Comparison_Exp>;
  stream_type?: InputMaybe<Jsonb_Comparison_Exp>;
  subtitle_cc_format?: InputMaybe<String_Comparison_Exp>;
  target_audience?: InputMaybe<Jsonb_Comparison_Exp>;
  technical_spec?: InputMaybe<Jsonb_Comparison_Exp>;
  twitter?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  video?: InputMaybe<Jsonb_Comparison_Exp>;
  video_player?: InputMaybe<String_Comparison_Exp>;
  vod_connector_availability?: InputMaybe<String_Comparison_Exp>;
  vod_delivery_mode?: InputMaybe<String_Comparison_Exp>;
  vod_support?: InputMaybe<String_Comparison_Exp>;
  website_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "platform" */
export enum Platform_Constraint {
  /** unique or primary key constraint on columns "id" */
  PlatformIdKey = 'platform_id_key',
  /** unique or primary key constraint on columns "id" */
  PlatformPkey = 'platform_pkey',
  /** unique or primary key constraint on columns "salesforce_id" */
  PlatformSalesforceIdKey = 'platform_salesforce_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Platform_Delete_At_Path_Input = {
  availablity_country_and_regions?: InputMaybe<Array<Scalars['String']>>;
  devices_field?: InputMaybe<Array<Scalars['String']>>;
  keyring?: InputMaybe<Array<Scalars['String']>>;
  multiple_salesforce_id?: InputMaybe<Array<Scalars['String']>>;
  platform_artwork?: InputMaybe<Array<Scalars['String']>>;
  platform_contacts?: InputMaybe<Array<Scalars['String']>>;
  platform_manager?: InputMaybe<Array<Scalars['String']>>;
  poster?: InputMaybe<Array<Scalars['String']>>;
  preferred_genre?: InputMaybe<Array<Scalars['String']>>;
  preferred_language?: InputMaybe<Array<Scalars['String']>>;
  presentation?: InputMaybe<Array<Scalars['String']>>;
  reference_links?: InputMaybe<Array<Scalars['String']>>;
  stream_type?: InputMaybe<Array<Scalars['String']>>;
  target_audience?: InputMaybe<Array<Scalars['String']>>;
  technical_spec?: InputMaybe<Array<Scalars['String']>>;
  video?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Platform_Delete_Elem_Input = {
  availablity_country_and_regions?: InputMaybe<Scalars['Int']>;
  devices_field?: InputMaybe<Scalars['Int']>;
  keyring?: InputMaybe<Scalars['Int']>;
  multiple_salesforce_id?: InputMaybe<Scalars['Int']>;
  platform_artwork?: InputMaybe<Scalars['Int']>;
  platform_contacts?: InputMaybe<Scalars['Int']>;
  platform_manager?: InputMaybe<Scalars['Int']>;
  poster?: InputMaybe<Scalars['Int']>;
  preferred_genre?: InputMaybe<Scalars['Int']>;
  preferred_language?: InputMaybe<Scalars['Int']>;
  presentation?: InputMaybe<Scalars['Int']>;
  reference_links?: InputMaybe<Scalars['Int']>;
  stream_type?: InputMaybe<Scalars['Int']>;
  target_audience?: InputMaybe<Scalars['Int']>;
  technical_spec?: InputMaybe<Scalars['Int']>;
  video?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Platform_Delete_Key_Input = {
  availablity_country_and_regions?: InputMaybe<Scalars['String']>;
  devices_field?: InputMaybe<Scalars['String']>;
  keyring?: InputMaybe<Scalars['String']>;
  multiple_salesforce_id?: InputMaybe<Scalars['String']>;
  platform_artwork?: InputMaybe<Scalars['String']>;
  platform_contacts?: InputMaybe<Scalars['String']>;
  platform_manager?: InputMaybe<Scalars['String']>;
  poster?: InputMaybe<Scalars['String']>;
  preferred_genre?: InputMaybe<Scalars['String']>;
  preferred_language?: InputMaybe<Scalars['String']>;
  presentation?: InputMaybe<Scalars['String']>;
  reference_links?: InputMaybe<Scalars['String']>;
  stream_type?: InputMaybe<Scalars['String']>;
  target_audience?: InputMaybe<Scalars['String']>;
  technical_spec?: InputMaybe<Scalars['String']>;
  video?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "platform" */
export type Platform_Inc_Input = {
  avg_ad_minute_per_hour?: InputMaybe<Scalars['Int']>;
  avg_monthly_hov?: InputMaybe<Scalars['numeric']>;
  estimated_channel_deliveries?: InputMaybe<Scalars['numeric']>;
  max_file_size?: InputMaybe<Scalars['Int']>;
  no_of_player_needed?: InputMaybe<Scalars['Int']>;
  redundancy_delivery_count?: InputMaybe<Scalars['numeric']>;
  redundancy_player_count?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "platform" */
export type Platform_Insert_Input = {
  ad_trigger_type?: InputMaybe<Scalars['String']>;
  amagi_id_of_platform_owner?: InputMaybe<Scalars['String']>;
  application_usage?: InputMaybe<Scalars['String']>;
  artwork_dimension?: InputMaybe<Scalars['String']>;
  aspect_ratio?: InputMaybe<Scalars['String']>;
  available_in_amagi_now?: InputMaybe<Scalars['Boolean']>;
  availablity_country_and_regions?: InputMaybe<Scalars['jsonb']>;
  availibity_countries?: InputMaybe<Scalars['String']>;
  availibity_region?: InputMaybe<Scalars['String']>;
  avg_ad_minute_per_hour?: InputMaybe<Scalars['Int']>;
  avg_monthly_active_user?: InputMaybe<Scalars['String']>;
  avg_monthly_hov?: InputMaybe<Scalars['numeric']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  devices_field?: InputMaybe<Scalars['jsonb']>;
  epg_format?: InputMaybe<Scalars['String']>;
  epg_format_example?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  keyring?: InputMaybe<Scalars['jsonb']>;
  linkedin?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  max_file_size?: InputMaybe<Scalars['Int']>;
  multiple_salesforce_id?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  no_of_player_needed?: InputMaybe<Scalars['Int']>;
  onboarded_date?: InputMaybe<Scalars['timestamptz']>;
  overall_bitrate?: InputMaybe<Scalars['String']>;
  platform_artwork?: InputMaybe<Scalars['jsonb']>;
  platform_brand?: InputMaybe<Scalars['String']>;
  platform_contacts?: InputMaybe<Scalars['jsonb']>;
  platform_description?: InputMaybe<Scalars['String']>;
  platform_manager?: InputMaybe<Scalars['jsonb']>;
  platform_master_id?: InputMaybe<Scalars['uuid']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_qa_cycle?: InputMaybe<Scalars['String']>;
  platform_tier?: InputMaybe<Scalars['String']>;
  platform_to_platform?: InputMaybe<Platform_Arr_Rel_Insert_Input>;
  platform_to_platform_of_grouped?: InputMaybe<Platform_Obj_Rel_Insert_Input>;
  poster?: InputMaybe<Scalars['jsonb']>;
  preferred_genre?: InputMaybe<Scalars['jsonb']>;
  preferred_language?: InputMaybe<Scalars['jsonb']>;
  presentation?: InputMaybe<Scalars['jsonb']>;
  redundancy?: InputMaybe<Scalars['String']>;
  reference_links?: InputMaybe<Scalars['jsonb']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  source?: InputMaybe<Scalars['String']>;
  stream_type?: InputMaybe<Scalars['jsonb']>;
  subtitle_cc_format?: InputMaybe<Scalars['String']>;
  target_audience?: InputMaybe<Scalars['jsonb']>;
  technical_spec?: InputMaybe<Scalars['jsonb']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  video?: InputMaybe<Scalars['jsonb']>;
  video_player?: InputMaybe<Scalars['String']>;
  website_url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Platform_Max_Fields = {
  __typename?: 'platform_max_fields';
  ad_break?: Maybe<Scalars['String']>;
  ad_trigger_type?: Maybe<Scalars['String']>;
  amagi_id_of_platform_owner?: Maybe<Scalars['String']>;
  analytics_share_rule?: Maybe<Scalars['String']>;
  application_usage?: Maybe<Scalars['String']>;
  artwork_dimension?: Maybe<Scalars['String']>;
  aspect_ratio?: Maybe<Scalars['String']>;
  availibity_countries?: Maybe<Scalars['String']>;
  availibity_region?: Maybe<Scalars['String']>;
  avg_ad_minute_per_hour?: Maybe<Scalars['Int']>;
  avg_monthly_active_user?: Maybe<Scalars['String']>;
  avg_monthly_hov?: Maybe<Scalars['numeric']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  epg?: Maybe<Scalars['String']>;
  epg_format?: Maybe<Scalars['String']>;
  epg_format_example?: Maybe<Scalars['String']>;
  estimated_channel_deliveries?: Maybe<Scalars['numeric']>;
  facebook?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  inventory_model?: Maybe<Scalars['String']>;
  is_platform_group?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  max_file_size?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  no_of_player_needed?: Maybe<Scalars['Int']>;
  onboarded_date?: Maybe<Scalars['timestamptz']>;
  overall_bitrate?: Maybe<Scalars['String']>;
  platform_brand?: Maybe<Scalars['String']>;
  platform_contact?: Maybe<Scalars['String']>;
  platform_description?: Maybe<Scalars['String']>;
  platform_master_id?: Maybe<Scalars['uuid']>;
  platform_name?: Maybe<Scalars['String']>;
  platform_qa_cycle?: Maybe<Scalars['String']>;
  platform_specific_encoding?: Maybe<Scalars['String']>;
  platform_tier?: Maybe<Scalars['String']>;
  platforms_grouped?: Maybe<Scalars['String']>;
  preferred_business_model?: Maybe<Scalars['String']>;
  redundancy?: Maybe<Scalars['String']>;
  redundancy_delivery_count?: Maybe<Scalars['numeric']>;
  redundancy_player_count?: Maybe<Scalars['numeric']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  source?: Maybe<Scalars['String']>;
  specifications_url?: Maybe<Scalars['String']>;
  ssai_by?: Maybe<Scalars['String']>;
  subtitle_cc_format?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  video_player?: Maybe<Scalars['String']>;
  vod_connector_availability?: Maybe<Scalars['String']>;
  vod_delivery_mode?: Maybe<Scalars['String']>;
  vod_support?: Maybe<Scalars['String']>;
  website_url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "platform" */
export type Platform_Max_Order_By = {
  ad_break?: InputMaybe<Order_By>;
  ad_trigger_type?: InputMaybe<Order_By>;
  amagi_id_of_platform_owner?: InputMaybe<Order_By>;
  analytics_share_rule?: InputMaybe<Order_By>;
  application_usage?: InputMaybe<Order_By>;
  artwork_dimension?: InputMaybe<Order_By>;
  aspect_ratio?: InputMaybe<Order_By>;
  availibity_countries?: InputMaybe<Order_By>;
  availibity_region?: InputMaybe<Order_By>;
  avg_ad_minute_per_hour?: InputMaybe<Order_By>;
  avg_monthly_active_user?: InputMaybe<Order_By>;
  avg_monthly_hov?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  epg?: InputMaybe<Order_By>;
  epg_format?: InputMaybe<Order_By>;
  epg_format_example?: InputMaybe<Order_By>;
  estimated_channel_deliveries?: InputMaybe<Order_By>;
  facebook?: InputMaybe<Order_By>;
  format?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  inventory_model?: InputMaybe<Order_By>;
  is_platform_group?: InputMaybe<Order_By>;
  linkedin?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  max_file_size?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  no_of_player_needed?: InputMaybe<Order_By>;
  onboarded_date?: InputMaybe<Order_By>;
  overall_bitrate?: InputMaybe<Order_By>;
  platform_brand?: InputMaybe<Order_By>;
  platform_contact?: InputMaybe<Order_By>;
  platform_description?: InputMaybe<Order_By>;
  platform_master_id?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  platform_qa_cycle?: InputMaybe<Order_By>;
  platform_specific_encoding?: InputMaybe<Order_By>;
  platform_tier?: InputMaybe<Order_By>;
  platforms_grouped?: InputMaybe<Order_By>;
  preferred_business_model?: InputMaybe<Order_By>;
  redundancy?: InputMaybe<Order_By>;
  redundancy_delivery_count?: InputMaybe<Order_By>;
  redundancy_player_count?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  specifications_url?: InputMaybe<Order_By>;
  ssai_by?: InputMaybe<Order_By>;
  subtitle_cc_format?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_player?: InputMaybe<Order_By>;
  vod_connector_availability?: InputMaybe<Order_By>;
  vod_delivery_mode?: InputMaybe<Order_By>;
  vod_support?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Platform_Min_Fields = {
  __typename?: 'platform_min_fields';
  ad_break?: Maybe<Scalars['String']>;
  ad_trigger_type?: Maybe<Scalars['String']>;
  amagi_id_of_platform_owner?: Maybe<Scalars['String']>;
  analytics_share_rule?: Maybe<Scalars['String']>;
  application_usage?: Maybe<Scalars['String']>;
  artwork_dimension?: Maybe<Scalars['String']>;
  aspect_ratio?: Maybe<Scalars['String']>;
  availibity_countries?: Maybe<Scalars['String']>;
  availibity_region?: Maybe<Scalars['String']>;
  avg_ad_minute_per_hour?: Maybe<Scalars['Int']>;
  avg_monthly_active_user?: Maybe<Scalars['String']>;
  avg_monthly_hov?: Maybe<Scalars['numeric']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  epg?: Maybe<Scalars['String']>;
  epg_format?: Maybe<Scalars['String']>;
  epg_format_example?: Maybe<Scalars['String']>;
  estimated_channel_deliveries?: Maybe<Scalars['numeric']>;
  facebook?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  instagram?: Maybe<Scalars['String']>;
  inventory_model?: Maybe<Scalars['String']>;
  is_platform_group?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  max_file_size?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  no_of_player_needed?: Maybe<Scalars['Int']>;
  onboarded_date?: Maybe<Scalars['timestamptz']>;
  overall_bitrate?: Maybe<Scalars['String']>;
  platform_brand?: Maybe<Scalars['String']>;
  platform_contact?: Maybe<Scalars['String']>;
  platform_description?: Maybe<Scalars['String']>;
  platform_master_id?: Maybe<Scalars['uuid']>;
  platform_name?: Maybe<Scalars['String']>;
  platform_qa_cycle?: Maybe<Scalars['String']>;
  platform_specific_encoding?: Maybe<Scalars['String']>;
  platform_tier?: Maybe<Scalars['String']>;
  platforms_grouped?: Maybe<Scalars['String']>;
  preferred_business_model?: Maybe<Scalars['String']>;
  redundancy?: Maybe<Scalars['String']>;
  redundancy_delivery_count?: Maybe<Scalars['numeric']>;
  redundancy_player_count?: Maybe<Scalars['numeric']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  source?: Maybe<Scalars['String']>;
  specifications_url?: Maybe<Scalars['String']>;
  ssai_by?: Maybe<Scalars['String']>;
  subtitle_cc_format?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  video_player?: Maybe<Scalars['String']>;
  vod_connector_availability?: Maybe<Scalars['String']>;
  vod_delivery_mode?: Maybe<Scalars['String']>;
  vod_support?: Maybe<Scalars['String']>;
  website_url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "platform" */
export type Platform_Min_Order_By = {
  ad_break?: InputMaybe<Order_By>;
  ad_trigger_type?: InputMaybe<Order_By>;
  amagi_id_of_platform_owner?: InputMaybe<Order_By>;
  analytics_share_rule?: InputMaybe<Order_By>;
  application_usage?: InputMaybe<Order_By>;
  artwork_dimension?: InputMaybe<Order_By>;
  aspect_ratio?: InputMaybe<Order_By>;
  availibity_countries?: InputMaybe<Order_By>;
  availibity_region?: InputMaybe<Order_By>;
  avg_ad_minute_per_hour?: InputMaybe<Order_By>;
  avg_monthly_active_user?: InputMaybe<Order_By>;
  avg_monthly_hov?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  epg?: InputMaybe<Order_By>;
  epg_format?: InputMaybe<Order_By>;
  epg_format_example?: InputMaybe<Order_By>;
  estimated_channel_deliveries?: InputMaybe<Order_By>;
  facebook?: InputMaybe<Order_By>;
  format?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  inventory_model?: InputMaybe<Order_By>;
  is_platform_group?: InputMaybe<Order_By>;
  linkedin?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  max_file_size?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  no_of_player_needed?: InputMaybe<Order_By>;
  onboarded_date?: InputMaybe<Order_By>;
  overall_bitrate?: InputMaybe<Order_By>;
  platform_brand?: InputMaybe<Order_By>;
  platform_contact?: InputMaybe<Order_By>;
  platform_description?: InputMaybe<Order_By>;
  platform_master_id?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  platform_qa_cycle?: InputMaybe<Order_By>;
  platform_specific_encoding?: InputMaybe<Order_By>;
  platform_tier?: InputMaybe<Order_By>;
  platforms_grouped?: InputMaybe<Order_By>;
  preferred_business_model?: InputMaybe<Order_By>;
  redundancy?: InputMaybe<Order_By>;
  redundancy_delivery_count?: InputMaybe<Order_By>;
  redundancy_player_count?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  specifications_url?: InputMaybe<Order_By>;
  ssai_by?: InputMaybe<Order_By>;
  subtitle_cc_format?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_player?: InputMaybe<Order_By>;
  vod_connector_availability?: InputMaybe<Order_By>;
  vod_delivery_mode?: InputMaybe<Order_By>;
  vod_support?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "platform" */
export type Platform_Mutation_Response = {
  __typename?: 'platform_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Platform>;
};

/** input type for inserting object relation for remote table "platform" */
export type Platform_Obj_Rel_Insert_Input = {
  data: Platform_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Platform_On_Conflict>;
};

/** on_conflict condition type for table "platform" */
export type Platform_On_Conflict = {
  constraint: Platform_Constraint;
  update_columns?: Array<Platform_Update_Column>;
  where?: InputMaybe<Platform_Bool_Exp>;
};

/** Ordering options when selecting data from "platform". */
export type Platform_Order_By = {
  account?: InputMaybe<Account_Order_By>;
  ad_break?: InputMaybe<Order_By>;
  ad_trigger_type?: InputMaybe<Order_By>;
  amagi_id_of_platform_owner?: InputMaybe<Order_By>;
  analytics_share_rule?: InputMaybe<Order_By>;
  application_usage?: InputMaybe<Order_By>;
  artwork_dimension?: InputMaybe<Order_By>;
  aspect_ratio?: InputMaybe<Order_By>;
  available_in_amagi_now?: InputMaybe<Order_By>;
  availablity_country_and_regions?: InputMaybe<Order_By>;
  availibity_countries?: InputMaybe<Order_By>;
  availibity_region?: InputMaybe<Order_By>;
  avg_ad_minute_per_hour?: InputMaybe<Order_By>;
  avg_monthly_active_user?: InputMaybe<Order_By>;
  avg_monthly_hov?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  devices_field?: InputMaybe<Order_By>;
  epg?: InputMaybe<Order_By>;
  epg_format?: InputMaybe<Order_By>;
  epg_format_example?: InputMaybe<Order_By>;
  estimated_channel_deliveries?: InputMaybe<Order_By>;
  facebook?: InputMaybe<Order_By>;
  format?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  id_text?: InputMaybe<Order_By>;
  instagram?: InputMaybe<Order_By>;
  inventory_model?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_duplicate?: InputMaybe<Order_By>;
  is_platform_group?: InputMaybe<Order_By>;
  keyring?: InputMaybe<Order_By>;
  linkedin?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  mandatory?: InputMaybe<Order_By>;
  max_file_size?: InputMaybe<Order_By>;
  multiple_salesforce_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  no_of_player_needed?: InputMaybe<Order_By>;
  onboarded_date?: InputMaybe<Order_By>;
  overall_bitrate?: InputMaybe<Order_By>;
  platform_artwork?: InputMaybe<Order_By>;
  platform_brand?: InputMaybe<Order_By>;
  platform_contact?: InputMaybe<Order_By>;
  platform_contacts?: InputMaybe<Order_By>;
  platform_description?: InputMaybe<Order_By>;
  platform_manager?: InputMaybe<Order_By>;
  platform_master_id?: InputMaybe<Order_By>;
  platform_name?: InputMaybe<Order_By>;
  platform_qa_cycle?: InputMaybe<Order_By>;
  platform_specific_encoding?: InputMaybe<Order_By>;
  platform_tier?: InputMaybe<Order_By>;
  platform_to_platform_aggregate?: InputMaybe<Platform_Aggregate_Order_By>;
  platform_to_platform_of_grouped?: InputMaybe<Platform_Order_By>;
  platforms_grouped?: InputMaybe<Order_By>;
  poster?: InputMaybe<Order_By>;
  preferred_business_model?: InputMaybe<Order_By>;
  preferred_genre?: InputMaybe<Order_By>;
  preferred_language?: InputMaybe<Order_By>;
  presentation?: InputMaybe<Order_By>;
  quote_lines_aggregate?: InputMaybe<Quote_Line_Aggregate_Order_By>;
  redundancy?: InputMaybe<Order_By>;
  redundancy_delivery_count?: InputMaybe<Order_By>;
  redundancy_player_count?: InputMaybe<Order_By>;
  reference_links?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  specifications_url?: InputMaybe<Order_By>;
  ssai_by?: InputMaybe<Order_By>;
  stream_type?: InputMaybe<Order_By>;
  subtitle_cc_format?: InputMaybe<Order_By>;
  target_audience?: InputMaybe<Order_By>;
  technical_spec?: InputMaybe<Order_By>;
  twitter?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video?: InputMaybe<Order_By>;
  video_player?: InputMaybe<Order_By>;
  vod_connector_availability?: InputMaybe<Order_By>;
  vod_delivery_mode?: InputMaybe<Order_By>;
  vod_support?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: platform */
export type Platform_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Platform_Prepend_Input = {
  availablity_country_and_regions?: InputMaybe<Scalars['jsonb']>;
  devices_field?: InputMaybe<Scalars['jsonb']>;
  keyring?: InputMaybe<Scalars['jsonb']>;
  multiple_salesforce_id?: InputMaybe<Scalars['jsonb']>;
  platform_artwork?: InputMaybe<Scalars['jsonb']>;
  platform_contacts?: InputMaybe<Scalars['jsonb']>;
  platform_manager?: InputMaybe<Scalars['jsonb']>;
  poster?: InputMaybe<Scalars['jsonb']>;
  preferred_genre?: InputMaybe<Scalars['jsonb']>;
  preferred_language?: InputMaybe<Scalars['jsonb']>;
  presentation?: InputMaybe<Scalars['jsonb']>;
  reference_links?: InputMaybe<Scalars['jsonb']>;
  stream_type?: InputMaybe<Scalars['jsonb']>;
  target_audience?: InputMaybe<Scalars['jsonb']>;
  technical_spec?: InputMaybe<Scalars['jsonb']>;
  video?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "platform" */
export enum Platform_Select_Column {
  /** column name */
  AdBreak = 'ad_break',
  /** column name */
  AdTriggerType = 'ad_trigger_type',
  /** column name */
  AmagiIdOfPlatformOwner = 'amagi_id_of_platform_owner',
  /** column name */
  AnalyticsShareRule = 'analytics_share_rule',
  /** column name */
  ApplicationUsage = 'application_usage',
  /** column name */
  ArtworkDimension = 'artwork_dimension',
  /** column name */
  AspectRatio = 'aspect_ratio',
  /** column name */
  AvailableInAmagiNow = 'available_in_amagi_now',
  /** column name */
  AvailablityCountryAndRegions = 'availablity_country_and_regions',
  /** column name */
  AvailibityCountries = 'availibity_countries',
  /** column name */
  AvailibityRegion = 'availibity_region',
  /** column name */
  AvgAdMinutePerHour = 'avg_ad_minute_per_hour',
  /** column name */
  AvgMonthlyActiveUser = 'avg_monthly_active_user',
  /** column name */
  AvgMonthlyHov = 'avg_monthly_hov',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevicesField = 'devices_field',
  /** column name */
  Epg = 'epg',
  /** column name */
  EpgFormat = 'epg_format',
  /** column name */
  EpgFormatExample = 'epg_format_example',
  /** column name */
  EstimatedChannelDeliveries = 'estimated_channel_deliveries',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  Format = 'format',
  /** column name */
  Id = 'id',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  InventoryModel = 'inventory_model',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDuplicate = 'is_duplicate',
  /** column name */
  IsPlatformGroup = 'is_platform_group',
  /** column name */
  Keyring = 'keyring',
  /** column name */
  Linkedin = 'linkedin',
  /** column name */
  Logo = 'logo',
  /** column name */
  Mandatory = 'mandatory',
  /** column name */
  MaxFileSize = 'max_file_size',
  /** column name */
  MultipleSalesforceId = 'multiple_salesforce_id',
  /** column name */
  Name = 'name',
  /** column name */
  NoOfPlayerNeeded = 'no_of_player_needed',
  /** column name */
  OnboardedDate = 'onboarded_date',
  /** column name */
  OverallBitrate = 'overall_bitrate',
  /** column name */
  PlatformArtwork = 'platform_artwork',
  /** column name */
  PlatformBrand = 'platform_brand',
  /** column name */
  PlatformContact = 'platform_contact',
  /** column name */
  PlatformContacts = 'platform_contacts',
  /** column name */
  PlatformDescription = 'platform_description',
  /** column name */
  PlatformManager = 'platform_manager',
  /** column name */
  PlatformMasterId = 'platform_master_id',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  PlatformQaCycle = 'platform_qa_cycle',
  /** column name */
  PlatformSpecificEncoding = 'platform_specific_encoding',
  /** column name */
  PlatformTier = 'platform_tier',
  /** column name */
  PlatformsGrouped = 'platforms_grouped',
  /** column name */
  Poster = 'poster',
  /** column name */
  PreferredBusinessModel = 'preferred_business_model',
  /** column name */
  PreferredGenre = 'preferred_genre',
  /** column name */
  PreferredLanguage = 'preferred_language',
  /** column name */
  Presentation = 'presentation',
  /** column name */
  Redundancy = 'redundancy',
  /** column name */
  RedundancyDeliveryCount = 'redundancy_delivery_count',
  /** column name */
  RedundancyPlayerCount = 'redundancy_player_count',
  /** column name */
  ReferenceLinks = 'reference_links',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  Source = 'source',
  /** column name */
  SpecificationsUrl = 'specifications_url',
  /** column name */
  SsaiBy = 'ssai_by',
  /** column name */
  StreamType = 'stream_type',
  /** column name */
  SubtitleCcFormat = 'subtitle_cc_format',
  /** column name */
  TargetAudience = 'target_audience',
  /** column name */
  TechnicalSpec = 'technical_spec',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Video = 'video',
  /** column name */
  VideoPlayer = 'video_player',
  /** column name */
  VodConnectorAvailability = 'vod_connector_availability',
  /** column name */
  VodDeliveryMode = 'vod_delivery_mode',
  /** column name */
  VodSupport = 'vod_support',
  /** column name */
  WebsiteUrl = 'website_url'
}

/** select "platform_aggregate_bool_exp_bool_and_arguments_columns" columns of table "platform" */
export enum Platform_Select_Column_Platform_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AvailableInAmagiNow = 'available_in_amagi_now',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDuplicate = 'is_duplicate',
  /** column name */
  Mandatory = 'mandatory'
}

/** select "platform_aggregate_bool_exp_bool_or_arguments_columns" columns of table "platform" */
export enum Platform_Select_Column_Platform_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AvailableInAmagiNow = 'available_in_amagi_now',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsDuplicate = 'is_duplicate',
  /** column name */
  Mandatory = 'mandatory'
}

/** input type for updating data in table "platform" */
export type Platform_Set_Input = {
  ad_break?: InputMaybe<Scalars['String']>;
  ad_trigger_type?: InputMaybe<Scalars['String']>;
  amagi_id_of_platform_owner?: InputMaybe<Scalars['String']>;
  analytics_share_rule?: InputMaybe<Scalars['String']>;
  application_usage?: InputMaybe<Scalars['String']>;
  artwork_dimension?: InputMaybe<Scalars['String']>;
  aspect_ratio?: InputMaybe<Scalars['String']>;
  available_in_amagi_now?: InputMaybe<Scalars['Boolean']>;
  availablity_country_and_regions?: InputMaybe<Scalars['jsonb']>;
  availibity_countries?: InputMaybe<Scalars['String']>;
  availibity_region?: InputMaybe<Scalars['String']>;
  avg_ad_minute_per_hour?: InputMaybe<Scalars['Int']>;
  avg_monthly_active_user?: InputMaybe<Scalars['String']>;
  avg_monthly_hov?: InputMaybe<Scalars['numeric']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  devices_field?: InputMaybe<Scalars['jsonb']>;
  epg?: InputMaybe<Scalars['String']>;
  epg_format?: InputMaybe<Scalars['String']>;
  epg_format_example?: InputMaybe<Scalars['String']>;
  estimated_channel_deliveries?: InputMaybe<Scalars['numeric']>;
  facebook?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  inventory_model?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_platform_group?: InputMaybe<Scalars['String']>;
  keyring?: InputMaybe<Scalars['jsonb']>;
  linkedin?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  max_file_size?: InputMaybe<Scalars['Int']>;
  multiple_salesforce_id?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  no_of_player_needed?: InputMaybe<Scalars['Int']>;
  onboarded_date?: InputMaybe<Scalars['timestamptz']>;
  overall_bitrate?: InputMaybe<Scalars['String']>;
  platform_artwork?: InputMaybe<Scalars['jsonb']>;
  platform_brand?: InputMaybe<Scalars['String']>;
  platform_contact?: InputMaybe<Scalars['String']>;
  platform_contacts?: InputMaybe<Scalars['jsonb']>;
  platform_description?: InputMaybe<Scalars['String']>;
  platform_manager?: InputMaybe<Scalars['jsonb']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_qa_cycle?: InputMaybe<Scalars['String']>;
  platform_specific_encoding?: InputMaybe<Scalars['String']>;
  platform_tier?: InputMaybe<Scalars['String']>;
  platforms_grouped?: InputMaybe<Scalars['String']>;
  poster?: InputMaybe<Scalars['jsonb']>;
  preferred_business_model?: InputMaybe<Scalars['String']>;
  preferred_genre?: InputMaybe<Scalars['jsonb']>;
  preferred_language?: InputMaybe<Scalars['jsonb']>;
  presentation?: InputMaybe<Scalars['jsonb']>;
  redundancy?: InputMaybe<Scalars['String']>;
  redundancy_delivery_count?: InputMaybe<Scalars['numeric']>;
  redundancy_player_count?: InputMaybe<Scalars['numeric']>;
  reference_links?: InputMaybe<Scalars['jsonb']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  source?: InputMaybe<Scalars['String']>;
  specifications_url?: InputMaybe<Scalars['String']>;
  ssai_by?: InputMaybe<Scalars['String']>;
  stream_type?: InputMaybe<Scalars['jsonb']>;
  subtitle_cc_format?: InputMaybe<Scalars['String']>;
  target_audience?: InputMaybe<Scalars['jsonb']>;
  technical_spec?: InputMaybe<Scalars['jsonb']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  video?: InputMaybe<Scalars['jsonb']>;
  video_player?: InputMaybe<Scalars['String']>;
  vod_connector_availability?: InputMaybe<Scalars['String']>;
  vod_delivery_mode?: InputMaybe<Scalars['String']>;
  vod_support?: InputMaybe<Scalars['String']>;
  website_url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Platform_Stddev_Fields = {
  __typename?: 'platform_stddev_fields';
  avg_ad_minute_per_hour?: Maybe<Scalars['Float']>;
  avg_monthly_hov?: Maybe<Scalars['Float']>;
  estimated_channel_deliveries?: Maybe<Scalars['Float']>;
  max_file_size?: Maybe<Scalars['Float']>;
  no_of_player_needed?: Maybe<Scalars['Float']>;
  redundancy_delivery_count?: Maybe<Scalars['Float']>;
  redundancy_player_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "platform" */
export type Platform_Stddev_Order_By = {
  avg_ad_minute_per_hour?: InputMaybe<Order_By>;
  avg_monthly_hov?: InputMaybe<Order_By>;
  estimated_channel_deliveries?: InputMaybe<Order_By>;
  max_file_size?: InputMaybe<Order_By>;
  no_of_player_needed?: InputMaybe<Order_By>;
  redundancy_delivery_count?: InputMaybe<Order_By>;
  redundancy_player_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Platform_Stddev_Pop_Fields = {
  __typename?: 'platform_stddev_pop_fields';
  avg_ad_minute_per_hour?: Maybe<Scalars['Float']>;
  avg_monthly_hov?: Maybe<Scalars['Float']>;
  estimated_channel_deliveries?: Maybe<Scalars['Float']>;
  max_file_size?: Maybe<Scalars['Float']>;
  no_of_player_needed?: Maybe<Scalars['Float']>;
  redundancy_delivery_count?: Maybe<Scalars['Float']>;
  redundancy_player_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "platform" */
export type Platform_Stddev_Pop_Order_By = {
  avg_ad_minute_per_hour?: InputMaybe<Order_By>;
  avg_monthly_hov?: InputMaybe<Order_By>;
  estimated_channel_deliveries?: InputMaybe<Order_By>;
  max_file_size?: InputMaybe<Order_By>;
  no_of_player_needed?: InputMaybe<Order_By>;
  redundancy_delivery_count?: InputMaybe<Order_By>;
  redundancy_player_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Platform_Stddev_Samp_Fields = {
  __typename?: 'platform_stddev_samp_fields';
  avg_ad_minute_per_hour?: Maybe<Scalars['Float']>;
  avg_monthly_hov?: Maybe<Scalars['Float']>;
  estimated_channel_deliveries?: Maybe<Scalars['Float']>;
  max_file_size?: Maybe<Scalars['Float']>;
  no_of_player_needed?: Maybe<Scalars['Float']>;
  redundancy_delivery_count?: Maybe<Scalars['Float']>;
  redundancy_player_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "platform" */
export type Platform_Stddev_Samp_Order_By = {
  avg_ad_minute_per_hour?: InputMaybe<Order_By>;
  avg_monthly_hov?: InputMaybe<Order_By>;
  estimated_channel_deliveries?: InputMaybe<Order_By>;
  max_file_size?: InputMaybe<Order_By>;
  no_of_player_needed?: InputMaybe<Order_By>;
  redundancy_delivery_count?: InputMaybe<Order_By>;
  redundancy_player_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "platform" */
export type Platform_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Platform_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Platform_Stream_Cursor_Value_Input = {
  ad_break?: InputMaybe<Scalars['String']>;
  ad_trigger_type?: InputMaybe<Scalars['String']>;
  amagi_id_of_platform_owner?: InputMaybe<Scalars['String']>;
  analytics_share_rule?: InputMaybe<Scalars['String']>;
  application_usage?: InputMaybe<Scalars['String']>;
  artwork_dimension?: InputMaybe<Scalars['String']>;
  aspect_ratio?: InputMaybe<Scalars['String']>;
  available_in_amagi_now?: InputMaybe<Scalars['Boolean']>;
  availablity_country_and_regions?: InputMaybe<Scalars['jsonb']>;
  availibity_countries?: InputMaybe<Scalars['String']>;
  availibity_region?: InputMaybe<Scalars['String']>;
  avg_ad_minute_per_hour?: InputMaybe<Scalars['Int']>;
  avg_monthly_active_user?: InputMaybe<Scalars['String']>;
  avg_monthly_hov?: InputMaybe<Scalars['numeric']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  devices_field?: InputMaybe<Scalars['jsonb']>;
  epg?: InputMaybe<Scalars['String']>;
  epg_format?: InputMaybe<Scalars['String']>;
  epg_format_example?: InputMaybe<Scalars['String']>;
  estimated_channel_deliveries?: InputMaybe<Scalars['numeric']>;
  facebook?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  instagram?: InputMaybe<Scalars['String']>;
  inventory_model?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_duplicate?: InputMaybe<Scalars['Boolean']>;
  is_platform_group?: InputMaybe<Scalars['String']>;
  keyring?: InputMaybe<Scalars['jsonb']>;
  linkedin?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  max_file_size?: InputMaybe<Scalars['Int']>;
  multiple_salesforce_id?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  no_of_player_needed?: InputMaybe<Scalars['Int']>;
  onboarded_date?: InputMaybe<Scalars['timestamptz']>;
  overall_bitrate?: InputMaybe<Scalars['String']>;
  platform_artwork?: InputMaybe<Scalars['jsonb']>;
  platform_brand?: InputMaybe<Scalars['String']>;
  platform_contact?: InputMaybe<Scalars['String']>;
  platform_contacts?: InputMaybe<Scalars['jsonb']>;
  platform_description?: InputMaybe<Scalars['String']>;
  platform_manager?: InputMaybe<Scalars['jsonb']>;
  platform_master_id?: InputMaybe<Scalars['uuid']>;
  platform_name?: InputMaybe<Scalars['String']>;
  platform_qa_cycle?: InputMaybe<Scalars['String']>;
  platform_specific_encoding?: InputMaybe<Scalars['String']>;
  platform_tier?: InputMaybe<Scalars['String']>;
  platforms_grouped?: InputMaybe<Scalars['String']>;
  poster?: InputMaybe<Scalars['jsonb']>;
  preferred_business_model?: InputMaybe<Scalars['String']>;
  preferred_genre?: InputMaybe<Scalars['jsonb']>;
  preferred_language?: InputMaybe<Scalars['jsonb']>;
  presentation?: InputMaybe<Scalars['jsonb']>;
  redundancy?: InputMaybe<Scalars['String']>;
  redundancy_delivery_count?: InputMaybe<Scalars['numeric']>;
  redundancy_player_count?: InputMaybe<Scalars['numeric']>;
  reference_links?: InputMaybe<Scalars['jsonb']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  source?: InputMaybe<Scalars['String']>;
  specifications_url?: InputMaybe<Scalars['String']>;
  ssai_by?: InputMaybe<Scalars['String']>;
  stream_type?: InputMaybe<Scalars['jsonb']>;
  subtitle_cc_format?: InputMaybe<Scalars['String']>;
  target_audience?: InputMaybe<Scalars['jsonb']>;
  technical_spec?: InputMaybe<Scalars['jsonb']>;
  twitter?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  video?: InputMaybe<Scalars['jsonb']>;
  video_player?: InputMaybe<Scalars['String']>;
  vod_connector_availability?: InputMaybe<Scalars['String']>;
  vod_delivery_mode?: InputMaybe<Scalars['String']>;
  vod_support?: InputMaybe<Scalars['String']>;
  website_url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Platform_Sum_Fields = {
  __typename?: 'platform_sum_fields';
  avg_ad_minute_per_hour?: Maybe<Scalars['Int']>;
  avg_monthly_hov?: Maybe<Scalars['numeric']>;
  estimated_channel_deliveries?: Maybe<Scalars['numeric']>;
  max_file_size?: Maybe<Scalars['Int']>;
  no_of_player_needed?: Maybe<Scalars['Int']>;
  redundancy_delivery_count?: Maybe<Scalars['numeric']>;
  redundancy_player_count?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "platform" */
export type Platform_Sum_Order_By = {
  avg_ad_minute_per_hour?: InputMaybe<Order_By>;
  avg_monthly_hov?: InputMaybe<Order_By>;
  estimated_channel_deliveries?: InputMaybe<Order_By>;
  max_file_size?: InputMaybe<Order_By>;
  no_of_player_needed?: InputMaybe<Order_By>;
  redundancy_delivery_count?: InputMaybe<Order_By>;
  redundancy_player_count?: InputMaybe<Order_By>;
};

/** update columns of table "platform" */
export enum Platform_Update_Column {
  /** column name */
  AdBreak = 'ad_break',
  /** column name */
  AdTriggerType = 'ad_trigger_type',
  /** column name */
  AmagiIdOfPlatformOwner = 'amagi_id_of_platform_owner',
  /** column name */
  AnalyticsShareRule = 'analytics_share_rule',
  /** column name */
  ApplicationUsage = 'application_usage',
  /** column name */
  ArtworkDimension = 'artwork_dimension',
  /** column name */
  AspectRatio = 'aspect_ratio',
  /** column name */
  AvailableInAmagiNow = 'available_in_amagi_now',
  /** column name */
  AvailablityCountryAndRegions = 'availablity_country_and_regions',
  /** column name */
  AvailibityCountries = 'availibity_countries',
  /** column name */
  AvailibityRegion = 'availibity_region',
  /** column name */
  AvgAdMinutePerHour = 'avg_ad_minute_per_hour',
  /** column name */
  AvgMonthlyActiveUser = 'avg_monthly_active_user',
  /** column name */
  AvgMonthlyHov = 'avg_monthly_hov',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevicesField = 'devices_field',
  /** column name */
  Epg = 'epg',
  /** column name */
  EpgFormat = 'epg_format',
  /** column name */
  EpgFormatExample = 'epg_format_example',
  /** column name */
  EstimatedChannelDeliveries = 'estimated_channel_deliveries',
  /** column name */
  Facebook = 'facebook',
  /** column name */
  Format = 'format',
  /** column name */
  Instagram = 'instagram',
  /** column name */
  InventoryModel = 'inventory_model',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsPlatformGroup = 'is_platform_group',
  /** column name */
  Keyring = 'keyring',
  /** column name */
  Linkedin = 'linkedin',
  /** column name */
  Logo = 'logo',
  /** column name */
  Mandatory = 'mandatory',
  /** column name */
  MaxFileSize = 'max_file_size',
  /** column name */
  MultipleSalesforceId = 'multiple_salesforce_id',
  /** column name */
  Name = 'name',
  /** column name */
  NoOfPlayerNeeded = 'no_of_player_needed',
  /** column name */
  OnboardedDate = 'onboarded_date',
  /** column name */
  OverallBitrate = 'overall_bitrate',
  /** column name */
  PlatformArtwork = 'platform_artwork',
  /** column name */
  PlatformBrand = 'platform_brand',
  /** column name */
  PlatformContact = 'platform_contact',
  /** column name */
  PlatformContacts = 'platform_contacts',
  /** column name */
  PlatformDescription = 'platform_description',
  /** column name */
  PlatformManager = 'platform_manager',
  /** column name */
  PlatformName = 'platform_name',
  /** column name */
  PlatformQaCycle = 'platform_qa_cycle',
  /** column name */
  PlatformSpecificEncoding = 'platform_specific_encoding',
  /** column name */
  PlatformTier = 'platform_tier',
  /** column name */
  PlatformsGrouped = 'platforms_grouped',
  /** column name */
  Poster = 'poster',
  /** column name */
  PreferredBusinessModel = 'preferred_business_model',
  /** column name */
  PreferredGenre = 'preferred_genre',
  /** column name */
  PreferredLanguage = 'preferred_language',
  /** column name */
  Presentation = 'presentation',
  /** column name */
  Redundancy = 'redundancy',
  /** column name */
  RedundancyDeliveryCount = 'redundancy_delivery_count',
  /** column name */
  RedundancyPlayerCount = 'redundancy_player_count',
  /** column name */
  ReferenceLinks = 'reference_links',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  Source = 'source',
  /** column name */
  SpecificationsUrl = 'specifications_url',
  /** column name */
  SsaiBy = 'ssai_by',
  /** column name */
  StreamType = 'stream_type',
  /** column name */
  SubtitleCcFormat = 'subtitle_cc_format',
  /** column name */
  TargetAudience = 'target_audience',
  /** column name */
  TechnicalSpec = 'technical_spec',
  /** column name */
  Twitter = 'twitter',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Video = 'video',
  /** column name */
  VideoPlayer = 'video_player',
  /** column name */
  VodConnectorAvailability = 'vod_connector_availability',
  /** column name */
  VodDeliveryMode = 'vod_delivery_mode',
  /** column name */
  VodSupport = 'vod_support',
  /** column name */
  WebsiteUrl = 'website_url'
}

export type Platform_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Platform_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Platform_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Platform_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Platform_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Platform_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Platform_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Platform_Set_Input>;
  /** filter the rows which have to be updated */
  where: Platform_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Platform_Var_Pop_Fields = {
  __typename?: 'platform_var_pop_fields';
  avg_ad_minute_per_hour?: Maybe<Scalars['Float']>;
  avg_monthly_hov?: Maybe<Scalars['Float']>;
  estimated_channel_deliveries?: Maybe<Scalars['Float']>;
  max_file_size?: Maybe<Scalars['Float']>;
  no_of_player_needed?: Maybe<Scalars['Float']>;
  redundancy_delivery_count?: Maybe<Scalars['Float']>;
  redundancy_player_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "platform" */
export type Platform_Var_Pop_Order_By = {
  avg_ad_minute_per_hour?: InputMaybe<Order_By>;
  avg_monthly_hov?: InputMaybe<Order_By>;
  estimated_channel_deliveries?: InputMaybe<Order_By>;
  max_file_size?: InputMaybe<Order_By>;
  no_of_player_needed?: InputMaybe<Order_By>;
  redundancy_delivery_count?: InputMaybe<Order_By>;
  redundancy_player_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Platform_Var_Samp_Fields = {
  __typename?: 'platform_var_samp_fields';
  avg_ad_minute_per_hour?: Maybe<Scalars['Float']>;
  avg_monthly_hov?: Maybe<Scalars['Float']>;
  estimated_channel_deliveries?: Maybe<Scalars['Float']>;
  max_file_size?: Maybe<Scalars['Float']>;
  no_of_player_needed?: Maybe<Scalars['Float']>;
  redundancy_delivery_count?: Maybe<Scalars['Float']>;
  redundancy_player_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "platform" */
export type Platform_Var_Samp_Order_By = {
  avg_ad_minute_per_hour?: InputMaybe<Order_By>;
  avg_monthly_hov?: InputMaybe<Order_By>;
  estimated_channel_deliveries?: InputMaybe<Order_By>;
  max_file_size?: InputMaybe<Order_By>;
  no_of_player_needed?: InputMaybe<Order_By>;
  redundancy_delivery_count?: InputMaybe<Order_By>;
  redundancy_player_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Platform_Variance_Fields = {
  __typename?: 'platform_variance_fields';
  avg_ad_minute_per_hour?: Maybe<Scalars['Float']>;
  avg_monthly_hov?: Maybe<Scalars['Float']>;
  estimated_channel_deliveries?: Maybe<Scalars['Float']>;
  max_file_size?: Maybe<Scalars['Float']>;
  no_of_player_needed?: Maybe<Scalars['Float']>;
  redundancy_delivery_count?: Maybe<Scalars['Float']>;
  redundancy_player_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "platform" */
export type Platform_Variance_Order_By = {
  avg_ad_minute_per_hour?: InputMaybe<Order_By>;
  avg_monthly_hov?: InputMaybe<Order_By>;
  estimated_channel_deliveries?: InputMaybe<Order_By>;
  max_file_size?: InputMaybe<Order_By>;
  no_of_player_needed?: InputMaybe<Order_By>;
  redundancy_delivery_count?: InputMaybe<Order_By>;
  redundancy_player_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "price_book" */
export type Price_Book = {
  __typename?: 'price_book';
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  is_active?: Maybe<Scalars['Boolean']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  is_standard_price_book?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  price_book_entries: Array<Price_Book_Entry>;
  /** An aggregate relationship */
  price_book_entries_aggregate: Price_Book_Entry_Aggregate;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "price_book" */
export type Price_BookPrice_Book_EntriesArgs = {
  distinct_on?: InputMaybe<Array<Price_Book_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Price_Book_Entry_Order_By>>;
  where?: InputMaybe<Price_Book_Entry_Bool_Exp>;
};


/** columns and relationships of "price_book" */
export type Price_BookPrice_Book_Entries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Price_Book_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Price_Book_Entry_Order_By>>;
  where?: InputMaybe<Price_Book_Entry_Bool_Exp>;
};

/** aggregated selection of "price_book" */
export type Price_Book_Aggregate = {
  __typename?: 'price_book_aggregate';
  aggregate?: Maybe<Price_Book_Aggregate_Fields>;
  nodes: Array<Price_Book>;
};

/** aggregate fields of "price_book" */
export type Price_Book_Aggregate_Fields = {
  __typename?: 'price_book_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Price_Book_Max_Fields>;
  min?: Maybe<Price_Book_Min_Fields>;
};


/** aggregate fields of "price_book" */
export type Price_Book_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Price_Book_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "price_book". All fields are combined with a logical 'AND'. */
export type Price_Book_Bool_Exp = {
  _and?: InputMaybe<Array<Price_Book_Bool_Exp>>;
  _not?: InputMaybe<Price_Book_Bool_Exp>;
  _or?: InputMaybe<Array<Price_Book_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_standard_price_book?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  price_book_entries?: InputMaybe<Price_Book_Entry_Bool_Exp>;
  price_book_entries_aggregate?: InputMaybe<Price_Book_Entry_Aggregate_Bool_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "price_book_entry" */
export type Price_Book_Entry = {
  __typename?: 'price_book_entry';
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  is_active?: Maybe<Scalars['Boolean']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  list_price?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  price_book?: Maybe<Price_Book>;
  /** A computed field, executes function "price_book_entry_rate" */
  price_book_entry_rate?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  price_book_entry_to_product?: Maybe<Product>;
  product_code?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_price_book_id?: Maybe<Scalars['String']>;
  salesforce_product_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "price_book_entry" */
export type Price_Book_EntryPrice_Book_Entry_RateArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "price_book_entry" */
export type Price_Book_Entry_Aggregate = {
  __typename?: 'price_book_entry_aggregate';
  aggregate?: Maybe<Price_Book_Entry_Aggregate_Fields>;
  nodes: Array<Price_Book_Entry>;
};

export type Price_Book_Entry_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Price_Book_Entry_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Price_Book_Entry_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Price_Book_Entry_Aggregate_Bool_Exp_Count>;
};

export type Price_Book_Entry_Aggregate_Bool_Exp_Bool_And = {
  arguments: Price_Book_Entry_Select_Column_Price_Book_Entry_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Price_Book_Entry_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Price_Book_Entry_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Price_Book_Entry_Select_Column_Price_Book_Entry_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Price_Book_Entry_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Price_Book_Entry_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Price_Book_Entry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Price_Book_Entry_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "price_book_entry" */
export type Price_Book_Entry_Aggregate_Fields = {
  __typename?: 'price_book_entry_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Price_Book_Entry_Max_Fields>;
  min?: Maybe<Price_Book_Entry_Min_Fields>;
};


/** aggregate fields of "price_book_entry" */
export type Price_Book_Entry_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Price_Book_Entry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "price_book_entry" */
export type Price_Book_Entry_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Price_Book_Entry_Max_Order_By>;
  min?: InputMaybe<Price_Book_Entry_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "price_book_entry". All fields are combined with a logical 'AND'. */
export type Price_Book_Entry_Bool_Exp = {
  _and?: InputMaybe<Array<Price_Book_Entry_Bool_Exp>>;
  _not?: InputMaybe<Price_Book_Entry_Bool_Exp>;
  _or?: InputMaybe<Array<Price_Book_Entry_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  list_price?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  price_book?: InputMaybe<Price_Book_Bool_Exp>;
  price_book_entry_rate?: InputMaybe<Jsonb_Comparison_Exp>;
  price_book_entry_to_product?: InputMaybe<Product_Bool_Exp>;
  product_code?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_price_book_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_product_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Price_Book_Entry_Max_Fields = {
  __typename?: 'price_book_entry_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  list_price?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  product_code?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_price_book_id?: Maybe<Scalars['String']>;
  salesforce_product_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "price_book_entry" */
export type Price_Book_Entry_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_code?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_price_book_id?: InputMaybe<Order_By>;
  salesforce_product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Price_Book_Entry_Min_Fields = {
  __typename?: 'price_book_entry_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  list_price?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  product_code?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_price_book_id?: Maybe<Scalars['String']>;
  salesforce_product_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "price_book_entry" */
export type Price_Book_Entry_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_code?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_price_book_id?: InputMaybe<Order_By>;
  salesforce_product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_book_entry". */
export type Price_Book_Entry_Order_By = {
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  list_price?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price_book?: InputMaybe<Price_Book_Order_By>;
  price_book_entry_rate?: InputMaybe<Order_By>;
  price_book_entry_to_product?: InputMaybe<Product_Order_By>;
  product_code?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_price_book_id?: InputMaybe<Order_By>;
  salesforce_product_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "price_book_entry" */
export enum Price_Book_Entry_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  ListPrice = 'list_price',
  /** column name */
  Name = 'name',
  /** column name */
  ProductCode = 'product_code',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  SalesforcePriceBookId = 'salesforce_price_book_id',
  /** column name */
  SalesforceProductId = 'salesforce_product_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "price_book_entry_aggregate_bool_exp_bool_and_arguments_columns" columns of table "price_book_entry" */
export enum Price_Book_Entry_Select_Column_Price_Book_Entry_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "price_book_entry_aggregate_bool_exp_bool_or_arguments_columns" columns of table "price_book_entry" */
export enum Price_Book_Entry_Select_Column_Price_Book_Entry_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted'
}

/** Streaming cursor of the table "price_book_entry" */
export type Price_Book_Entry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Price_Book_Entry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Price_Book_Entry_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  list_price?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  product_code?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_price_book_id?: InputMaybe<Scalars['String']>;
  salesforce_product_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Price_Book_Max_Fields = {
  __typename?: 'price_book_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Price_Book_Min_Fields = {
  __typename?: 'price_book_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "price_book". */
export type Price_Book_Order_By = {
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_standard_price_book?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price_book_entries_aggregate?: InputMaybe<Price_Book_Entry_Aggregate_Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "price_book" */
export enum Price_Book_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsStandardPriceBook = 'is_standard_price_book',
  /** column name */
  Name = 'name',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "price_book" */
export type Price_Book_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Price_Book_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Price_Book_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_standard_price_book?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "product" */
export type Product = {
  __typename?: 'product';
  adsplus_revenue_share?: Maybe<Scalars['float8']>;
  billing_frequency?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  bu?: Maybe<Scalars['String']>;
  charge_type?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  display_unit?: Maybe<Scalars['String']>;
  family?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  includes_sub_licenses?: Maybe<Scalars['Boolean']>;
  is_active: Scalars['Boolean'];
  is_add_on?: Maybe<Scalars['Boolean']>;
  is_deleted: Scalars['Boolean'];
  license_expiry_date?: Maybe<Scalars['date']>;
  license_used?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** An array relationship */
  order_items: Array<Order_Product>;
  /** An aggregate relationship */
  order_items_aggregate: Order_Product_Aggregate;
  product_dso?: Maybe<Scalars['String']>;
  product_license_type?: Maybe<Scalars['String']>;
  product_owner?: Maybe<Scalars['String']>;
  product_type?: Maybe<Scalars['String']>;
  /** A computed field, executes function "revenue_type" */
  revenue_type?: Maybe<Scalars['String']>;
  salesforce_created_date: Scalars['timestamptz'];
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date: Scalars['timestamptz'];
  short_name?: Maybe<Scalars['String']>;
  sub_group?: Maybe<Scalars['String']>;
  sub_group_category?: Maybe<Scalars['String']>;
  subscription_pricing?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "product" */
export type ProductOrder_ItemsArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


/** columns and relationships of "product" */
export type ProductOrder_Items_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};

/** columns and relationships of "product_active" */
export type Product_Active = {
  __typename?: 'product_active';
  /** An object relationship */
  account_info?: Maybe<Account>;
  /** An object relationship */
  product_info?: Maybe<Product>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_product_id?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "product_active". All fields are combined with a logical 'AND'. */
export type Product_Active_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Active_Bool_Exp>>;
  _not?: InputMaybe<Product_Active_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Active_Bool_Exp>>;
  account_info?: InputMaybe<Account_Bool_Exp>;
  product_info?: InputMaybe<Product_Bool_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_product_id?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "product_active". */
export type Product_Active_Order_By = {
  account_info?: InputMaybe<Account_Order_By>;
  product_info?: InputMaybe<Product_Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_product_id?: InputMaybe<Order_By>;
};

/** select columns of table "product_active" */
export enum Product_Active_Select_Column {
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SalesforceProductId = 'salesforce_product_id'
}

/** Streaming cursor of the table "product_active" */
export type Product_Active_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Active_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Active_Stream_Cursor_Value_Input = {
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_product_id?: InputMaybe<Scalars['String']>;
};

export type Product_Aggregate = {
  __typename?: 'product_aggregate';
  aggregate?: Maybe<Product_Aggregate_Fields>;
  nodes: Array<Product>;
};

/** aggregate fields of "product" */
export type Product_Aggregate_Fields = {
  __typename?: 'product_aggregate_fields';
  avg?: Maybe<Product_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Product_Max_Fields>;
  min?: Maybe<Product_Min_Fields>;
  stddev?: Maybe<Product_Stddev_Fields>;
  stddev_pop?: Maybe<Product_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Product_Stddev_Samp_Fields>;
  sum?: Maybe<Product_Sum_Fields>;
  var_pop?: Maybe<Product_Var_Pop_Fields>;
  var_samp?: Maybe<Product_Var_Samp_Fields>;
  variance?: Maybe<Product_Variance_Fields>;
};


/** aggregate fields of "product" */
export type Product_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Product_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Product_Avg_Fields = {
  __typename?: 'product_avg_fields';
  adsplus_revenue_share?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "product". All fields are combined with a logical 'AND'. */
export type Product_Bool_Exp = {
  _and?: InputMaybe<Array<Product_Bool_Exp>>;
  _not?: InputMaybe<Product_Bool_Exp>;
  _or?: InputMaybe<Array<Product_Bool_Exp>>;
  adsplus_revenue_share?: InputMaybe<Float8_Comparison_Exp>;
  billing_frequency?: InputMaybe<String_Comparison_Exp>;
  billing_type?: InputMaybe<String_Comparison_Exp>;
  bu?: InputMaybe<String_Comparison_Exp>;
  charge_type?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_unit?: InputMaybe<String_Comparison_Exp>;
  family?: InputMaybe<String_Comparison_Exp>;
  group?: InputMaybe<String_Comparison_Exp>;
  includes_sub_licenses?: InputMaybe<Boolean_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_add_on?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  license_expiry_date?: InputMaybe<Date_Comparison_Exp>;
  license_used?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_items?: InputMaybe<Order_Product_Bool_Exp>;
  order_items_aggregate?: InputMaybe<Order_Product_Aggregate_Bool_Exp>;
  product_dso?: InputMaybe<String_Comparison_Exp>;
  product_license_type?: InputMaybe<String_Comparison_Exp>;
  product_owner?: InputMaybe<String_Comparison_Exp>;
  product_type?: InputMaybe<String_Comparison_Exp>;
  revenue_type?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
  sub_group?: InputMaybe<String_Comparison_Exp>;
  sub_group_category?: InputMaybe<String_Comparison_Exp>;
  subscription_pricing?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Product_Max_Fields = {
  __typename?: 'product_max_fields';
  adsplus_revenue_share?: Maybe<Scalars['float8']>;
  billing_frequency?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  bu?: Maybe<Scalars['String']>;
  charge_type?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  display_unit?: Maybe<Scalars['String']>;
  family?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  license_expiry_date?: Maybe<Scalars['date']>;
  license_used?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  product_dso?: Maybe<Scalars['String']>;
  product_license_type?: Maybe<Scalars['String']>;
  product_owner?: Maybe<Scalars['String']>;
  product_type?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  short_name?: Maybe<Scalars['String']>;
  sub_group?: Maybe<Scalars['String']>;
  sub_group_category?: Maybe<Scalars['String']>;
  subscription_pricing?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Product_Min_Fields = {
  __typename?: 'product_min_fields';
  adsplus_revenue_share?: Maybe<Scalars['float8']>;
  billing_frequency?: Maybe<Scalars['String']>;
  billing_type?: Maybe<Scalars['String']>;
  bu?: Maybe<Scalars['String']>;
  charge_type?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  display_unit?: Maybe<Scalars['String']>;
  family?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['String']>;
  license_expiry_date?: Maybe<Scalars['date']>;
  license_used?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  product_dso?: Maybe<Scalars['String']>;
  product_license_type?: Maybe<Scalars['String']>;
  product_owner?: Maybe<Scalars['String']>;
  product_type?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  short_name?: Maybe<Scalars['String']>;
  sub_group?: Maybe<Scalars['String']>;
  sub_group_category?: Maybe<Scalars['String']>;
  subscription_pricing?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "product" */
export type Product_Mutation_Response = {
  __typename?: 'product_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Product>;
};

/** Ordering options when selecting data from "product". */
export type Product_Order_By = {
  adsplus_revenue_share?: InputMaybe<Order_By>;
  billing_frequency?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  bu?: InputMaybe<Order_By>;
  charge_type?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_unit?: InputMaybe<Order_By>;
  family?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  includes_sub_licenses?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_add_on?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  license_expiry_date?: InputMaybe<Order_By>;
  license_used?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_items_aggregate?: InputMaybe<Order_Product_Aggregate_Order_By>;
  product_dso?: InputMaybe<Order_By>;
  product_license_type?: InputMaybe<Order_By>;
  product_owner?: InputMaybe<Order_By>;
  product_type?: InputMaybe<Order_By>;
  revenue_type?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
  sub_group?: InputMaybe<Order_By>;
  sub_group_category?: InputMaybe<Order_By>;
  subscription_pricing?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: product */
export type Product_Pk_Columns_Input = {
  salesforce_id: Scalars['String'];
};

/** select columns of table "product" */
export enum Product_Select_Column {
  /** column name */
  AdsplusRevenueShare = 'adsplus_revenue_share',
  /** column name */
  BillingFrequency = 'billing_frequency',
  /** column name */
  BillingType = 'billing_type',
  /** column name */
  Bu = 'bu',
  /** column name */
  ChargeType = 'charge_type',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayUnit = 'display_unit',
  /** column name */
  Family = 'family',
  /** column name */
  Group = 'group',
  /** column name */
  IncludesSubLicenses = 'includes_sub_licenses',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsAddOn = 'is_add_on',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LicenseExpiryDate = 'license_expiry_date',
  /** column name */
  LicenseUsed = 'license_used',
  /** column name */
  Name = 'name',
  /** column name */
  ProductDso = 'product_dso',
  /** column name */
  ProductLicenseType = 'product_license_type',
  /** column name */
  ProductOwner = 'product_owner',
  /** column name */
  ProductType = 'product_type',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  SubGroup = 'sub_group',
  /** column name */
  SubGroupCategory = 'sub_group_category',
  /** column name */
  SubscriptionPricing = 'subscription_pricing',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "product" */
export type Product_Set_Input = {
  includes_sub_licenses?: InputMaybe<Scalars['Boolean']>;
  license_expiry_date?: InputMaybe<Scalars['date']>;
  license_used?: InputMaybe<Scalars['String']>;
  product_owner?: InputMaybe<Scalars['String']>;
  product_type?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Product_Stddev_Fields = {
  __typename?: 'product_stddev_fields';
  adsplus_revenue_share?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Product_Stddev_Pop_Fields = {
  __typename?: 'product_stddev_pop_fields';
  adsplus_revenue_share?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Product_Stddev_Samp_Fields = {
  __typename?: 'product_stddev_samp_fields';
  adsplus_revenue_share?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "product" */
export type Product_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Product_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Product_Stream_Cursor_Value_Input = {
  adsplus_revenue_share?: InputMaybe<Scalars['float8']>;
  billing_frequency?: InputMaybe<Scalars['String']>;
  billing_type?: InputMaybe<Scalars['String']>;
  bu?: InputMaybe<Scalars['String']>;
  charge_type?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  display_unit?: InputMaybe<Scalars['String']>;
  family?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  includes_sub_licenses?: InputMaybe<Scalars['Boolean']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_add_on?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  license_expiry_date?: InputMaybe<Scalars['date']>;
  license_used?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  product_dso?: InputMaybe<Scalars['String']>;
  product_license_type?: InputMaybe<Scalars['String']>;
  product_owner?: InputMaybe<Scalars['String']>;
  product_type?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  short_name?: InputMaybe<Scalars['String']>;
  sub_group?: InputMaybe<Scalars['String']>;
  sub_group_category?: InputMaybe<Scalars['String']>;
  subscription_pricing?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Product_Sum_Fields = {
  __typename?: 'product_sum_fields';
  adsplus_revenue_share?: Maybe<Scalars['float8']>;
};

export type Product_Table_Detail_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Product_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Product_Set_Input>;
  /** filter the rows which have to be updated */
  where: Product_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Product_Var_Pop_Fields = {
  __typename?: 'product_var_pop_fields';
  adsplus_revenue_share?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Product_Var_Samp_Fields = {
  __typename?: 'product_var_samp_fields';
  adsplus_revenue_share?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Product_Variance_Fields = {
  __typename?: 'product_variance_fields';
  adsplus_revenue_share?: Maybe<Scalars['Float']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "account" */
  account: Array<Account>;
  /** fetch aggregated fields from the table: "account" */
  account_aggregate: Account_Aggregate;
  /** fetch data from the table: "account" using primary key columns */
  account_by_pk?: Maybe<Account>;
  /** fetch data from the table: "ads_plus_customer_contacts" */
  ads_plus_customer_contacts: Array<Ads_Plus_Customer_Contacts>;
  /** fetch aggregated fields from the table: "ads_plus_customer_contacts" */
  ads_plus_customer_contacts_aggregate: Ads_Plus_Customer_Contacts_Aggregate;
  /** api key list */
  api_keys?: Maybe<Array<Maybe<ApiKey>>>;
  /** fetch data from the table: "case" */
  case: Array<Case>;
  /** fetch aggregated fields from the table: "case" */
  case_aggregate: Case_Aggregate;
  /** fetch data from the table: "case" using primary key columns */
  case_by_pk?: Maybe<Case>;
  /** fetch data from the table: "channel" */
  channel: Array<Channel>;
  /** fetch data from the table: "channel_active" */
  channel_active: Array<Channel_Active>;
  /** fetch aggregated fields from the table: "channel_active" */
  channel_active_aggregate: Channel_Active_Aggregate;
  /** fetch aggregated fields from the table: "channel" */
  channel_aggregate: Channel_Aggregate;
  /** fetch data from the table: "channel" using primary key columns */
  channel_by_pk?: Maybe<Channel>;
  /** fetch data from the table: "channel_churned" */
  channel_churned: Array<Channel_Churned>;
  /** fetch aggregated fields from the table: "channel_churned" */
  channel_churned_aggregate: Channel_Churned_Aggregate;
  /** fetch data from the table: "channel_delivered_to_go_live" */
  channel_delivered_to_go_live: Array<Channel_Delivered_To_Go_Live>;
  /** fetch data from the table: "channel_master" */
  channel_master: Array<Channel_Master>;
  /** fetch aggregated fields from the table: "channel_master" */
  channel_master_aggregate: Channel_Master_Aggregate;
  /** fetch data from the table: "channel_master" using primary key columns */
  channel_master_by_pk?: Maybe<Channel_Master>;
  /** fetch data from the table: "channel_progress" */
  channel_progress: Array<Channel_Progress>;
  /** fetch aggregated fields from the table: "channel_progress" */
  channel_progress_aggregate: Channel_Progress_Aggregate;
  /** fetch data from the table: "cloudport" */
  cloudport: Array<Cloudport>;
  /** fetch data from the table: "cloudport" using primary key columns */
  cloudport_by_pk?: Maybe<Cloudport>;
  /** fetch data from the table: "company_address" */
  company_address: Array<Company_Address>;
  /** fetch aggregated fields from the table: "company_address" */
  company_address_aggregate: Company_Address_Aggregate;
  /** fetch data from the table: "company_address" using primary key columns */
  company_address_by_pk?: Maybe<Company_Address>;
  /** fetch data from the table: "consumption_rate" */
  consumption_rate: Array<Consumption_Rate>;
  /** fetch aggregated fields from the table: "consumption_rate" */
  consumption_rate_aggregate: Consumption_Rate_Aggregate;
  /** fetch data from the table: "consumption_rate" using primary key columns */
  consumption_rate_by_pk?: Maybe<Consumption_Rate>;
  /** fetch data from the table: "consumption_schedule" */
  consumption_schedule: Array<Consumption_Schedule>;
  /** fetch aggregated fields from the table: "consumption_schedule" */
  consumption_schedule_aggregate: Consumption_Schedule_Aggregate;
  /** fetch data from the table: "consumption_schedule" using primary key columns */
  consumption_schedule_by_pk?: Maybe<Consumption_Schedule>;
  /** fetch data from the table: "contact" */
  contact: Array<Contact>;
  /** fetch aggregated fields from the table: "contact" */
  contact_aggregate: Contact_Aggregate;
  /** fetch data from the table: "contact" using primary key columns */
  contact_by_pk?: Maybe<Contact>;
  /** fetch data from the table: "content_plus_contacts" */
  content_plus_contacts: Array<Content_Plus_Contacts>;
  /** execute function "credit_memo_by_id" which returns "fn_return.combined_invoice" */
  credit_memo_by_id: Array<Fn_Return_Combined_Invoice>;
  /** execute function "credit_memo_by_id" and query aggregates on result of table type "fn_return.combined_invoice" */
  credit_memo_by_id_aggregate: Fn_Return_Combined_Invoice_Aggregate;
  /** fetch data from the table: "customer" */
  customer: Array<Customer>;
  /** fetch aggregated fields from the table: "customer" */
  customer_aggregate: Customer_Aggregate;
  /** execute function "customer_by_amagi_id" which returns "customer" */
  customer_by_amagi_id?: Maybe<Customer>;
  /** execute function "customer_by_amagi_id" and query aggregates on result of table type "customer" */
  customer_by_amagi_id_aggregate: Customer_Aggregate;
  /** fetch data from the table: "customer_contract_terms" */
  customer_contract_terms: Array<Customer_Contract_Terms>;
  /** fetch aggregated fields from the table: "customer_contract_terms" */
  customer_contract_terms_aggregate: Customer_Contract_Terms_Aggregate;
  /** execute function "customer_count" which returns "fn_return.customer_type" */
  customer_count: Array<Fn_Return_Customer_Type>;
  /** execute function "customer_industry_segment" which returns "fn_return.customer_industry_type" */
  customer_industry_segment: Array<Fn_Return_Customer_Industry_Type>;
  /** execute function "customer_product_by_amagi_id" which returns "product" */
  customer_product_by_amagi_id: Array<Product>;
  /** execute function "customer_product_by_amagi_id" and query aggregates on result of table type "product" */
  customer_product_by_amagi_id_aggregate: Product_Aggregate;
  /** execute function "customer_product_purchased_by_amagi_id" which returns "fn_return.product_purchased" */
  customer_product_purchased_by_amagi_id: Array<Fn_Return_Product_Purchased>;
  /** fetch data from the table: "customer_product_url" */
  customer_product_url: Array<Customer_Product_Url>;
  /** fetch aggregated fields from the table: "customer_product_url" */
  customer_product_url_aggregate: Customer_Product_Url_Aggregate;
  /** execute function "customer_region_revenue" which returns "fn_return.customer_region_revenue" */
  customer_region_revenue: Array<Fn_Return_Customer_Region_Revenue>;
  /** fetch data from the table: "customer_revenue_segment" */
  customer_revenue_segment: Array<Customer_Revenue_Segment>;
  /** fetch aggregated fields from the table: "customer_revenue_segment" */
  customer_revenue_segment_aggregate: Customer_Revenue_Segment_Aggregate;
  /** fetch data from the table: "customer_revenue_segment" using primary key columns */
  customer_revenue_segment_by_pk?: Maybe<Customer_Revenue_Segment>;
  /** fetch data from the table: "customer_revenue_segment_data" */
  customer_revenue_segment_data: Array<Customer_Revenue_Segment_Data>;
  /** fetch aggregated fields from the table: "customer_revenue_segment_data" */
  customer_revenue_segment_data_aggregate: Customer_Revenue_Segment_Data_Aggregate;
  /** fetch data from the table: "customer_revenue_segment_data" using primary key columns */
  customer_revenue_segment_data_by_pk?: Maybe<Customer_Revenue_Segment_Data>;
  /** execute function "customer_tier_revenue" which returns "fn_return.customer_tier_revenue" */
  customer_tier_revenue: Array<Fn_Return_Customer_Tier_Revenue>;
  /** execute function "customer_type" which returns "fn_return.customer_type" */
  customer_type: Array<Fn_Return_Customer_Type>;
  /** execute function "customer_type_revenue" which returns "fn_return.customer_type_revenue" */
  customer_type_revenue: Array<Fn_Return_Customer_Type_Revenue>;
  /** execute function "dashboard_revenue_split" which returns "fn_return.revenue_split" */
  dashboard_revenue_split: Array<Fn_Return_Revenue_Split>;
  /** fetch data from the table: "data_growth" */
  data_growth: Array<Data_Growth>;
  /** fetch data from the table: "data_growth" using primary key columns */
  data_growth_by_pk?: Maybe<Data_Growth>;
  /** execute function "data_growth_trend" which returns "fn_return.data_growth_graph" */
  data_growth_trend: Array<Fn_Return_Data_Growth_Graph>;
  /** fetch data from the table: "data_quality" */
  data_quality: Array<Data_Quality>;
  /** fetch data from the table: "data_quality" using primary key columns */
  data_quality_by_pk?: Maybe<Data_Quality>;
  /** execute function "data_quality_table" which returns "fn_return.data_quality" */
  data_quality_table: Array<Fn_Return_Data_Quality>;
  /** execute function "data_quality_trend" which returns "fn_return.data_quality_graph" */
  data_quality_trend: Array<Fn_Return_Data_Quality_Graph>;
  /** fetch data from the table: "delivery" */
  delivery: Array<Delivery>;
  /** fetch aggregated fields from the table: "delivery" */
  delivery_aggregate: Delivery_Aggregate;
  /** fetch data from the table: "delivery" using primary key columns */
  delivery_by_pk?: Maybe<Delivery>;
  /** execute function "delivery_channel_platform" which returns "fn_return.delivery_channel_platform" */
  delivery_channel_platform: Array<Fn_Return_Delivery_Channel_Platform>;
  /** execute function "delivery_channel_platform" and query aggregates on result of table type "fn_return.delivery_channel_platform" */
  delivery_channel_platform_aggregate: Fn_Return_Delivery_Channel_Platform_Aggregate;
  /** fetch data from the table: "delivery_main" */
  delivery_main: Array<Delivery_Main>;
  /** fetch aggregated fields from the table: "delivery_main" */
  delivery_main_aggregate: Delivery_Main_Aggregate;
  /** fetch data from the table: "delivery_now" */
  delivery_now: Array<Delivery_Now>;
  /** execute function "delivery_payload" which returns "fn_return.delivery_payload" */
  delivery_payload: Array<Fn_Return_Delivery_Payload>;
  /** execute function "delivery_payload" and query aggregates on result of table type "fn_return.delivery_payload" */
  delivery_payload_aggregate: Fn_Return_Delivery_Payload_Aggregate;
  /** fetch data from the table: "delivery_timeline" */
  delivery_timeline: Array<Delivery_Timeline>;
  /** fetch aggregated fields from the table: "delivery_timeline" */
  delivery_timeline_aggregate: Delivery_Timeline_Aggregate;
  /** execute function "domain_exist" which returns "fn_return.domain_validation" */
  domain_exist: Array<Fn_Return_Domain_Validation>;
  /** execute function "domain_exist" and query aggregates on result of table type "fn_return.domain_validation" */
  domain_exist_aggregate: Fn_Return_Domain_Validation_Aggregate;
  /** execute function "email_exist" which returns "fn_return.email_validation" */
  email_exist: Array<Fn_Return_Email_Validation>;
  /** execute function "email_exist" and query aggregates on result of table type "fn_return.email_validation" */
  email_exist_aggregate: Fn_Return_Email_Validation_Aggregate;
  /** execute function "existing_new_churned_dashboard" which returns "fn_return.existing_new_churned_dashboard" */
  existing_new_churned_dashboard: Array<Fn_Return_Existing_New_Churned_Dashboard>;
  /** execute function "existing_new_churned_dashboard_channel" which returns "fn_return.existing_new_churned_dashboard" */
  existing_new_churned_dashboard_channel: Array<Fn_Return_Existing_New_Churned_Dashboard>;
  /** execute function "existing_new_churned_platform_dashboard" which returns "fn_return.existing_new_churned_dashboard" */
  existing_new_churned_platform_dashboard: Array<Fn_Return_Existing_New_Churned_Dashboard>;
  /** fetch data from the table: "feature_flag" */
  feature_flag: Array<Feature_Flag>;
  /** fetch data from the table: "feature_flag" using primary key columns */
  feature_flag_by_pk?: Maybe<Feature_Flag>;
  /** fetch data from the table: "fn_return.account_statement" */
  fn_return_account_statement: Array<Fn_Return_Account_Statement>;
  /** fetch aggregated fields from the table: "fn_return.account_statement" */
  fn_return_account_statement_aggregate: Fn_Return_Account_Statement_Aggregate;
  /** fetch data from the table: "fn_return.account_statement" using primary key columns */
  fn_return_account_statement_by_pk?: Maybe<Fn_Return_Account_Statement>;
  /** fetch data from the table: "fn_return.account_statement_meta" */
  fn_return_account_statement_meta: Array<Fn_Return_Account_Statement_Meta>;
  /** fetch aggregated fields from the table: "fn_return.account_statement_meta" */
  fn_return_account_statement_meta_aggregate: Fn_Return_Account_Statement_Meta_Aggregate;
  /** fetch data from the table: "fn_return.account_statement_meta" using primary key columns */
  fn_return_account_statement_meta_by_pk?: Maybe<Fn_Return_Account_Statement_Meta>;
  /** fetch data from the table: "fn_return.account_statement_outstanding" */
  fn_return_account_statement_outstanding: Array<Fn_Return_Account_Statement_Outstanding>;
  /** fetch aggregated fields from the table: "fn_return.account_statement_outstanding" */
  fn_return_account_statement_outstanding_aggregate: Fn_Return_Account_Statement_Outstanding_Aggregate;
  /** fetch data from the table: "fn_return.account_statement_outstanding" using primary key columns */
  fn_return_account_statement_outstanding_by_pk?: Maybe<Fn_Return_Account_Statement_Outstanding>;
  /** fetch data from the table: "fn_return.account_statement_summary" */
  fn_return_account_statement_summary: Array<Fn_Return_Account_Statement_Summary>;
  /** fetch aggregated fields from the table: "fn_return.account_statement_summary" */
  fn_return_account_statement_summary_aggregate: Fn_Return_Account_Statement_Summary_Aggregate;
  /** fetch data from the table: "fn_return.account_statement_summary" using primary key columns */
  fn_return_account_statement_summary_by_pk?: Maybe<Fn_Return_Account_Statement_Summary>;
  /** fetch data from the table: "fn_return.avg_service_availibity" */
  fn_return_avg_service_availibity: Array<Fn_Return_Avg_Service_Availibity>;
  /** fetch aggregated fields from the table: "fn_return.avg_service_availibity" */
  fn_return_avg_service_availibity_aggregate: Fn_Return_Avg_Service_Availibity_Aggregate;
  /** fetch data from the table: "fn_return.avg_service_availibity" using primary key columns */
  fn_return_avg_service_availibity_by_pk?: Maybe<Fn_Return_Avg_Service_Availibity>;
  /** fetch data from the table: "fn_return.billing_summary" */
  fn_return_billing_summary: Array<Fn_Return_Billing_Summary>;
  /** fetch aggregated fields from the table: "fn_return.billing_summary" */
  fn_return_billing_summary_aggregate: Fn_Return_Billing_Summary_Aggregate;
  /** fetch data from the table: "fn_return.billing_summary" using primary key columns */
  fn_return_billing_summary_by_pk?: Maybe<Fn_Return_Billing_Summary>;
  /** fetch data from the table: "fn_return.channel_deliveries_count" */
  fn_return_channel_deliveries_count: Array<Fn_Return_Channel_Deliveries_Count>;
  /** fetch data from the table: "fn_return.channel_deliveries_count" using primary key columns */
  fn_return_channel_deliveries_count_by_pk?: Maybe<Fn_Return_Channel_Deliveries_Count>;
  /** fetch data from the table: "fn_return.combined_invoice" */
  fn_return_combined_invoice: Array<Fn_Return_Combined_Invoice>;
  /** fetch aggregated fields from the table: "fn_return.combined_invoice" */
  fn_return_combined_invoice_aggregate: Fn_Return_Combined_Invoice_Aggregate;
  /** fetch data from the table: "fn_return.combined_invoice" using primary key columns */
  fn_return_combined_invoice_by_pk?: Maybe<Fn_Return_Combined_Invoice>;
  /** fetch data from the table: "fn_return.combined_invoice_line" */
  fn_return_combined_invoice_line: Array<Fn_Return_Combined_Invoice_Line>;
  /** fetch aggregated fields from the table: "fn_return.combined_invoice_line" */
  fn_return_combined_invoice_line_aggregate: Fn_Return_Combined_Invoice_Line_Aggregate;
  /** fetch data from the table: "fn_return.combined_invoice_line" using primary key columns */
  fn_return_combined_invoice_line_by_pk?: Maybe<Fn_Return_Combined_Invoice_Line>;
  /** fetch data from the table: "fn_return.combined_receipt" */
  fn_return_combined_receipt: Array<Fn_Return_Combined_Receipt>;
  /** fetch aggregated fields from the table: "fn_return.combined_receipt" */
  fn_return_combined_receipt_aggregate: Fn_Return_Combined_Receipt_Aggregate;
  /** fetch data from the table: "fn_return.combined_receipt_line" */
  fn_return_combined_receipt_line: Array<Fn_Return_Combined_Receipt_Line>;
  /** fetch aggregated fields from the table: "fn_return.combined_receipt_line" */
  fn_return_combined_receipt_line_aggregate: Fn_Return_Combined_Receipt_Line_Aggregate;
  /** fetch data from the table: "fn_return.count_of_channels_using_ads_plus" */
  /** fetch data from the table: "fn_return.customer_industry_type" */
  fn_return_customer_industry_type: Array<Fn_Return_Customer_Industry_Type>;
  /** fetch data from the table: "fn_return.customer_industry_type" using primary key columns */
  fn_return_customer_industry_type_by_pk?: Maybe<Fn_Return_Customer_Industry_Type>;
  /** fetch data from the table: "fn_return.customer_region_revenue" */
  fn_return_customer_region_revenue: Array<Fn_Return_Customer_Region_Revenue>;
  /** fetch data from the table: "fn_return.customer_region_revenue" using primary key columns */
  fn_return_customer_region_revenue_by_pk?: Maybe<Fn_Return_Customer_Region_Revenue>;
  /** fetch data from the table: "fn_return.customer_search" */
  fn_return_customer_search: Array<Fn_Return_Customer_Search>;
  /** fetch aggregated fields from the table: "fn_return.customer_search" */
  fn_return_customer_search_aggregate: Fn_Return_Customer_Search_Aggregate;
  /** fetch data from the table: "fn_return.customer_search" using primary key columns */
  fn_return_customer_search_by_pk?: Maybe<Fn_Return_Customer_Search>;
  /** fetch data from the table: "fn_return.customer_tier_revenue" */
  fn_return_customer_tier_revenue: Array<Fn_Return_Customer_Tier_Revenue>;
  /** fetch data from the table: "fn_return.customer_tier_revenue" using primary key columns */
  fn_return_customer_tier_revenue_by_pk?: Maybe<Fn_Return_Customer_Tier_Revenue>;
  /** fetch data from the table: "fn_return.customer_type" */
  fn_return_customer_type: Array<Fn_Return_Customer_Type>;
  /** fetch data from the table: "fn_return.customer_type" using primary key columns */
  fn_return_customer_type_by_pk?: Maybe<Fn_Return_Customer_Type>;
  /** fetch data from the table: "fn_return.customer_type_revenue" */
  fn_return_customer_type_revenue: Array<Fn_Return_Customer_Type_Revenue>;
  /** fetch data from the table: "fn_return.customer_type_revenue" using primary key columns */
  fn_return_customer_type_revenue_by_pk?: Maybe<Fn_Return_Customer_Type_Revenue>;
  /** fetch data from the table: "fn_return.data_growth_graph" */
  fn_return_data_growth_graph: Array<Fn_Return_Data_Growth_Graph>;
  /** fetch data from the table: "fn_return.data_growth_graph" using primary key columns */
  fn_return_data_growth_graph_by_pk?: Maybe<Fn_Return_Data_Growth_Graph>;
  /** fetch data from the table: "fn_return.data_quality" */
  fn_return_data_quality: Array<Fn_Return_Data_Quality>;
  /** fetch data from the table: "fn_return.data_quality" using primary key columns */
  fn_return_data_quality_by_pk?: Maybe<Fn_Return_Data_Quality>;
  /** fetch data from the table: "fn_return.data_quality_graph" */
  fn_return_data_quality_graph: Array<Fn_Return_Data_Quality_Graph>;
  /** fetch data from the table: "fn_return.data_quality_graph" using primary key columns */
  fn_return_data_quality_graph_by_pk?: Maybe<Fn_Return_Data_Quality_Graph>;
  /** fetch data from the table: "fn_return.deliveries_count" */
  fn_return_deliveries_count: Array<Fn_Return_Deliveries_Count>;
  /** fetch aggregated fields from the table: "fn_return.deliveries_count" */
  fn_return_deliveries_count_aggregate: Fn_Return_Deliveries_Count_Aggregate;
  /** fetch data from the table: "fn_return.deliveries_count" using primary key columns */
  fn_return_deliveries_count_by_pk?: Maybe<Fn_Return_Deliveries_Count>;
  /** fetch data from the table: "fn_return.delivery_channel_platform" */
  fn_return_delivery_channel_platform: Array<Fn_Return_Delivery_Channel_Platform>;
  /** fetch aggregated fields from the table: "fn_return.delivery_channel_platform" */
  fn_return_delivery_channel_platform_aggregate: Fn_Return_Delivery_Channel_Platform_Aggregate;
  /** fetch data from the table: "fn_return.delivery_channel_platform" using primary key columns */
  fn_return_delivery_channel_platform_by_pk?: Maybe<Fn_Return_Delivery_Channel_Platform>;
  /** fetch data from the table: "fn_return.delivery_count" */
  fn_return_delivery_count: Array<Fn_Return_Delivery_Count>;
  /** fetch data from the table: "fn_return.delivery_count" using primary key columns */
  fn_return_delivery_count_by_pk?: Maybe<Fn_Return_Delivery_Count>;
  /** fetch data from the table: "fn_return.delivery_payload" */
  fn_return_delivery_payload: Array<Fn_Return_Delivery_Payload>;
  /** fetch aggregated fields from the table: "fn_return.delivery_payload" */
  fn_return_delivery_payload_aggregate: Fn_Return_Delivery_Payload_Aggregate;
  /** fetch data from the table: "fn_return.delivery_payload" using primary key columns */
  fn_return_delivery_payload_by_pk?: Maybe<Fn_Return_Delivery_Payload>;
  /** fetch data from the table: "fn_return.delivery_share" */
  fn_return_delivery_share: Array<Fn_Return_Delivery_Share>;
  /** fetch aggregated fields from the table: "fn_return.delivery_share" */
  fn_return_delivery_share_aggregate: Fn_Return_Delivery_Share_Aggregate;
  /** fetch data from the table: "fn_return.delivery_share" using primary key columns */
  fn_return_delivery_share_by_pk?: Maybe<Fn_Return_Delivery_Share>;
  /** fetch data from the table: "fn_return.domain_validation" */
  fn_return_domain_validation: Array<Fn_Return_Domain_Validation>;
  /** fetch aggregated fields from the table: "fn_return.domain_validation" */
  fn_return_domain_validation_aggregate: Fn_Return_Domain_Validation_Aggregate;
  /** fetch data from the table: "fn_return.domain_validation" using primary key columns */
  fn_return_domain_validation_by_pk?: Maybe<Fn_Return_Domain_Validation>;
  /** fetch data from the table: "fn_return.email_validation" */
  fn_return_email_validation: Array<Fn_Return_Email_Validation>;
  /** fetch aggregated fields from the table: "fn_return.email_validation" */
  fn_return_email_validation_aggregate: Fn_Return_Email_Validation_Aggregate;
  /** fetch data from the table: "fn_return.email_validation" using primary key columns */
  fn_return_email_validation_by_pk?: Maybe<Fn_Return_Email_Validation>;
  /** fetch data from the table: "fn_return.existing_new_churned_dashboard" */
  fn_return_existing_new_churned_dashboard: Array<Fn_Return_Existing_New_Churned_Dashboard>;
  /** fetch data from the table: "fn_return.existing_new_churned_dashboard" using primary key columns */
  fn_return_existing_new_churned_dashboard_by_pk?: Maybe<Fn_Return_Existing_New_Churned_Dashboard>;
  /** fetch data from the table: "fn_return.financial_graph" */
  fn_return_financial_graph: Array<Fn_Return_Financial_Graph>;
  /** fetch data from the table: "fn_return.financial_graph" using primary key columns */
  fn_return_financial_graph_by_pk?: Maybe<Fn_Return_Financial_Graph>;
  /** fetch data from the table: "fn_return.latest_mrr" */
  fn_return_latest_mrr: Array<Fn_Return_Latest_Mrr>;
  /** fetch aggregated fields from the table: "fn_return.latest_mrr" */
  fn_return_latest_mrr_aggregate: Fn_Return_Latest_Mrr_Aggregate;
  /** fetch data from the table: "fn_return.latest_mrr" using primary key columns */
  fn_return_latest_mrr_by_pk?: Maybe<Fn_Return_Latest_Mrr>;
  /** fetch data from the table: "fn_return.msa_rate_card" */
  fn_return_msa_rate_card: Array<Fn_Return_Msa_Rate_Card>;
  /** fetch aggregated fields from the table: "fn_return.msa_rate_card" */
  fn_return_msa_rate_card_aggregate: Fn_Return_Msa_Rate_Card_Aggregate;
  /** fetch data from the table: "fn_return.msa_rate_card" using primary key columns */
  fn_return_msa_rate_card_by_pk?: Maybe<Fn_Return_Msa_Rate_Card>;
  /** fetch data from the table: "fn_return.product_financial_graph" */
  fn_return_product_financial_graph: Array<Fn_Return_Product_Financial_Graph>;
  /** fetch data from the table: "fn_return.product_financial_graph" using primary key columns */
  fn_return_product_financial_graph_by_pk?: Maybe<Fn_Return_Product_Financial_Graph>;
  /** fetch data from the table: "fn_return.product_purchased" */
  fn_return_product_purchased: Array<Fn_Return_Product_Purchased>;
  /** fetch data from the table: "fn_return.product_purchased" using primary key columns */
  fn_return_product_purchased_by_pk?: Maybe<Fn_Return_Product_Purchased>;
  /** fetch data from the table: "fn_return.product_table_detail" */
  fn_return_product_table_detail: Array<Fn_Return_Product_Table_Detail>;
  /** fetch data from the table: "fn_return.product_table_detail" using primary key columns */
  fn_return_product_table_detail_by_pk?: Maybe<Fn_Return_Product_Table_Detail>;
  /** fetch data from the table: "fn_return.revenue_segment_data" */
  fn_return_revenue_segment_data: Array<Fn_Return_Revenue_Segment_Data>;
  /** fetch aggregated fields from the table: "fn_return.revenue_segment_data" */
  fn_return_revenue_segment_data_aggregate: Fn_Return_Revenue_Segment_Data_Aggregate;
  /** fetch data from the table: "fn_return.revenue_segment_data" using primary key columns */
  fn_return_revenue_segment_data_by_pk?: Maybe<Fn_Return_Revenue_Segment_Data>;
  /** fetch data from the table: "fn_return.revenue_split" */
  fn_return_revenue_split: Array<Fn_Return_Revenue_Split>;
  /** fetch data from the table: "fn_return.revenue_split" using primary key columns */
  fn_return_revenue_split_by_pk?: Maybe<Fn_Return_Revenue_Split>;
  /** fetch data from the table: "fn_return.sales_response" */
  fn_return_sales_response: Array<Fn_Return_Sales_Response>;
  /** fetch data from the table: "fn_return.sales_response" using primary key columns */
  fn_return_sales_response_by_pk?: Maybe<Fn_Return_Sales_Response>;
  /** fetch data from the table: "fn_return.sf_ns_check" */
  fn_return_sf_ns_check: Array<Fn_Return_Sf_Ns_Check>;
  /** fetch data from the table: "fn_return.sf_ns_check" using primary key columns */
  fn_return_sf_ns_check_by_pk?: Maybe<Fn_Return_Sf_Ns_Check>;
  /** fetch data from the table: "fn_return.top_customers" */
  fn_return_top_customers: Array<Fn_Return_Top_Customers>;
  /** fetch data from the table: "fn_return.top_customers" using primary key columns */
  fn_return_top_customers_by_pk?: Maybe<Fn_Return_Top_Customers>;
  /** fetch data from the table: "fn_return.total_open_close_ticket_dashboard" */
  fn_return_total_open_close_ticket_dashboard: Array<Fn_Return_Total_Open_Close_Ticket_Dashboard>;
  /** fetch aggregated fields from the table: "fn_return.total_open_close_ticket_dashboard" */
  fn_return_total_open_close_ticket_dashboard_aggregate: Fn_Return_Total_Open_Close_Ticket_Dashboard_Aggregate;
  /** fetch data from the table: "fn_return.total_open_close_ticket_dashboard" using primary key columns */
  fn_return_total_open_close_ticket_dashboard_by_pk?: Maybe<Fn_Return_Total_Open_Close_Ticket_Dashboard>;
  /** fetch data from the table: "freshdesk_company" */
  freshdesk_company: Array<Freshdesk_Company>;
  /** fetch aggregated fields from the table: "freshdesk_company" */
  freshdesk_company_aggregate: Freshdesk_Company_Aggregate;
  /** fetch data from the table: "freshdesk_company" using primary key columns */
  freshdesk_company_by_pk?: Maybe<Freshdesk_Company>;
  /** fetch data from the table: "freshdesk_contact" */
  freshdesk_contact: Array<Freshdesk_Contact>;
  /** fetch aggregated fields from the table: "freshdesk_contact" */
  freshdesk_contact_aggregate: Freshdesk_Contact_Aggregate;
  /** fetch data from the table: "freshdesk_contact" using primary key columns */
  freshdesk_contact_by_pk?: Maybe<Freshdesk_Contact>;
  /** fetch data from the table: "freshdesk_ticket" */
  freshdesk_ticket: Array<Freshdesk_Ticket>;
  /** fetch aggregated fields from the table: "freshdesk_ticket" */
  freshdesk_ticket_aggregate: Freshdesk_Ticket_Aggregate;
  /** fetch data from the table: "freshdesk_ticket" using primary key columns */
  freshdesk_ticket_by_pk?: Maybe<Freshdesk_Ticket>;
  /** fetch data from the table: "incident" */
  incident: Array<Incident>;
  /** fetch aggregated fields from the table: "incident" */
  incident_aggregate: Incident_Aggregate;
  /** fetch data from the table: "incident" using primary key columns */
  incident_by_pk?: Maybe<Incident>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** execute function "invoice_by_id" which returns "fn_return.combined_invoice" */
  invoice_by_id: Array<Fn_Return_Combined_Invoice>;
  /** execute function "invoice_by_id" and query aggregates on result of table type "fn_return.combined_invoice" */
  invoice_by_id_aggregate: Fn_Return_Combined_Invoice_Aggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table: "invoice_line" */
  invoice_line: Array<Invoice_Line>;
  /** fetch aggregated fields from the table: "invoice_line" */
  invoice_line_aggregate: Invoice_Line_Aggregate;
  /** fetch data from the table: "invoice_line" using primary key columns */
  invoice_line_by_pk?: Maybe<Invoice_Line>;
  /** execute function "invoice_lines_by_id" which returns "fn_return.combined_invoice_line" */
  invoice_lines_by_id: Array<Fn_Return_Combined_Invoice_Line>;
  /** execute function "invoice_lines_by_id" and query aggregates on result of table type "fn_return.combined_invoice_line" */
  invoice_lines_by_id_aggregate: Fn_Return_Combined_Invoice_Line_Aggregate;
  /** fetch data from the table: "legal_entity" */
  legal_entity: Array<Legal_Entity>;
  /** fetch aggregated fields from the table: "legal_entity" */
  legal_entity_aggregate: Legal_Entity_Aggregate;
  /** fetch data from the table: "legal_entity" using primary key columns */
  legal_entity_by_pk?: Maybe<Legal_Entity>;
  /** fetch data from the table: "media_industry_sub_segment" */
  media_industry_sub_segment: Array<Media_Industry_Sub_Segment>;
  /** fetch aggregated fields from the table: "media_industry_sub_segment" */
  media_industry_sub_segment_aggregate: Media_Industry_Sub_Segment_Aggregate;
  /** fetch data from the table: "media_industry_sub_segment" using primary key columns */
  media_industry_sub_segment_by_pk?: Maybe<Media_Industry_Sub_Segment>;
  /** fetch data from the table: "msa_master" */
  msa_master: Array<Msa_Master>;
  /** fetch aggregated fields from the table: "msa_master" */
  msa_master_aggregate: Msa_Master_Aggregate;
  /** fetch data from the table: "msa_rate_card" */
  msa_rate_card: Array<Msa_Rate_Card>;
  /** fetch aggregated fields from the table: "msa_rate_card" */
  msa_rate_card_aggregate: Msa_Rate_Card_Aggregate;
  /** fetch data from the table: "msa_rate_card" using primary key columns */
  msa_rate_card_by_pk?: Maybe<Msa_Rate_Card>;
  /** execute function "msa_rate_card_fn" which returns "fn_return.msa_rate_card" */
  msa_rate_card_fn: Array<Fn_Return_Msa_Rate_Card>;
  /** execute function "msa_rate_card_fn" and query aggregates on result of table type "fn_return.msa_rate_card" */
  msa_rate_card_fn_aggregate: Fn_Return_Msa_Rate_Card_Aggregate;
  /** execute function "net_invoices_due" which returns "fn_return.billing_summary" */
  net_invoices_due: Array<Fn_Return_Billing_Summary>;
  /** execute function "net_invoices_due" and query aggregates on result of table type "fn_return.billing_summary" */
  net_invoices_due_aggregate: Fn_Return_Billing_Summary_Aggregate;
  /** execute function "net_invoices_outstanding" which returns "fn_return.billing_summary" */
  net_invoices_outstanding: Array<Fn_Return_Billing_Summary>;
  /** execute function "net_invoices_outstanding" and query aggregates on result of table type "fn_return.billing_summary" */
  net_invoices_outstanding_aggregate: Fn_Return_Billing_Summary_Aggregate;
  /** execute function "net_invoices_overdue" which returns "fn_return.billing_summary" */
  net_invoices_overdue: Array<Fn_Return_Billing_Summary>;
  /** execute function "net_invoices_overdue" and query aggregates on result of table type "fn_return.billing_summary" */
  net_invoices_overdue_aggregate: Fn_Return_Billing_Summary_Aggregate;
  /** fetch data from the table: "netsuite_currency_rate" */
  netsuite_currency_rate: Array<Netsuite_Currency_Rate>;
  /** fetch aggregated fields from the table: "netsuite_currency_rate" */
  netsuite_currency_rate_aggregate: Netsuite_Currency_Rate_Aggregate;
  /** fetch data from the table: "netsuite_currency_rate" using primary key columns */
  netsuite_currency_rate_by_pk?: Maybe<Netsuite_Currency_Rate>;
  netsuite_pdf_file?: Maybe<NetsuiteFileResponse>;
  /** fetch data from the table: "netsuite_receipt" */
  netsuite_receipt: Array<Netsuite_Receipt>;
  /** fetch aggregated fields from the table: "netsuite_receipt" */
  netsuite_receipt_aggregate: Netsuite_Receipt_Aggregate;
  /** fetch data from the table: "netsuite_receipt" using primary key columns */
  netsuite_receipt_by_pk?: Maybe<Netsuite_Receipt>;
  /** fetch data from the table: "netsuite_receipt_line" */
  netsuite_receipt_line: Array<Netsuite_Receipt_Line>;
  /** fetch aggregated fields from the table: "netsuite_receipt_line" */
  netsuite_receipt_line_aggregate: Netsuite_Receipt_Line_Aggregate;
  /** fetch data from the table: "netsuite_receipt_line" using primary key columns */
  netsuite_receipt_line_by_pk?: Maybe<Netsuite_Receipt_Line>;
  /** fetch data from the table: "netsuite_tax" */
  netsuite_tax: Array<Netsuite_Tax>;
  /** fetch aggregated fields from the table: "netsuite_tax" */
  netsuite_tax_aggregate: Netsuite_Tax_Aggregate;
  /** fetch data from the table: "netsuite_tax" using primary key columns */
  netsuite_tax_by_pk?: Maybe<Netsuite_Tax>;
  /** fetch data from the table: "netsuite_transaction" */
  netsuite_transaction: Array<Netsuite_Transaction>;
  /** fetch aggregated fields from the table: "netsuite_transaction" */
  netsuite_transaction_aggregate: Netsuite_Transaction_Aggregate;
  /** fetch data from the table: "netsuite_transaction" using primary key columns */
  netsuite_transaction_by_pk?: Maybe<Netsuite_Transaction>;
  /** fetch data from the table: "netsuite_transaction_line" */
  netsuite_transaction_line: Array<Netsuite_Transaction_Line>;
  /** fetch aggregated fields from the table: "netsuite_transaction_line" */
  netsuite_transaction_line_aggregate: Netsuite_Transaction_Line_Aggregate;
  /** fetch data from the table: "netsuite_transaction_line" using primary key columns */
  netsuite_transaction_line_by_pk?: Maybe<Netsuite_Transaction_Line>;
  /** fetch data from the table: "netsuite_vendor_invoice" */
  netsuite_vendor_invoice: Array<Netsuite_Vendor_Invoice>;
  /** fetch aggregated fields from the table: "netsuite_vendor_invoice" */
  netsuite_vendor_invoice_aggregate: Netsuite_Vendor_Invoice_Aggregate;
  /** fetch data from the table: "netsuite_vendor_invoice" using primary key columns */
  netsuite_vendor_invoice_by_pk?: Maybe<Netsuite_Vendor_Invoice>;
  /** fetch data from the table: "netsuite_vendor_invoice_expense" */
  netsuite_vendor_invoice_expense: Array<Netsuite_Vendor_Invoice_Expense>;
  /** fetch aggregated fields from the table: "netsuite_vendor_invoice_expense" */
  netsuite_vendor_invoice_expense_aggregate: Netsuite_Vendor_Invoice_Expense_Aggregate;
  /** fetch data from the table: "netsuite_vendor_invoice_expense" using primary key columns */
  netsuite_vendor_invoice_expense_by_pk?: Maybe<Netsuite_Vendor_Invoice_Expense>;
  /** fetch data from the table: "netsuite_vendor_invoice_line" */
  netsuite_vendor_invoice_line: Array<Netsuite_Vendor_Invoice_Line>;
  /** fetch aggregated fields from the table: "netsuite_vendor_invoice_line" */
  netsuite_vendor_invoice_line_aggregate: Netsuite_Vendor_Invoice_Line_Aggregate;
  /** fetch data from the table: "netsuite_vendor_invoice_line" using primary key columns */
  netsuite_vendor_invoice_line_by_pk?: Maybe<Netsuite_Vendor_Invoice_Line>;
  /** fetch data from the table: "netsuite_vendor_invoice_tax" */
  netsuite_vendor_invoice_tax: Array<Netsuite_Vendor_Invoice_Tax>;
  /** fetch aggregated fields from the table: "netsuite_vendor_invoice_tax" */
  netsuite_vendor_invoice_tax_aggregate: Netsuite_Vendor_Invoice_Tax_Aggregate;
  /** fetch data from the table: "netsuite_vendor_invoice_tax" using primary key columns */
  netsuite_vendor_invoice_tax_by_pk?: Maybe<Netsuite_Vendor_Invoice_Tax>;
  /** fetch data from the table: "onboarding_customer_contacts" */
  onboarding_customer_contacts: Array<Onboarding_Customer_Contacts>;
  /** fetch aggregated fields from the table: "onboarding_customer_contacts" */
  onboarding_customer_contacts_aggregate: Onboarding_Customer_Contacts_Aggregate;
  /** An array relationship */
  opportunity: Array<Opportunity>;
  /** An aggregate relationship */
  opportunity_aggregate: Opportunity_Aggregate;
  /** fetch data from the table: "opportunity" using primary key columns */
  opportunity_by_pk?: Maybe<Opportunity>;
  opportunity_files?: Maybe<SalesforceOpportunityResponse>;
  /** fetch data from the table: "opportunity_self_serve_information" */
  opportunity_self_serve_information: Array<Opportunity_Self_Serve_Information>;
  /** fetch aggregated fields from the table: "opportunity_self_serve_information" */
  opportunity_self_serve_information_aggregate: Opportunity_Self_Serve_Information_Aggregate;
  /** fetch data from the table: "order" */
  order: Array<Order>;
  /** fetch aggregated fields from the table: "order" */
  order_aggregate: Order_Aggregate;
  /** fetch data from the table: "order" using primary key columns */
  order_by_pk?: Maybe<Order>;
  /** fetch data from the table: "order_item" */
  order_item: Array<Order_Item>;
  /** fetch aggregated fields from the table: "order_item" */
  order_item_aggregate: Order_Item_Aggregate;
  /** fetch data from the table: "order_item" using primary key columns */
  order_item_by_pk?: Maybe<Order_Item>;
  /** fetch data from the table: "order_item_line" */
  order_item_line: Array<Order_Item_Line>;
  /** fetch aggregated fields from the table: "order_item_line" */
  order_item_line_aggregate: Order_Item_Line_Aggregate;
  /** fetch data from the table: "order_item_line" using primary key columns */
  order_item_line_by_pk?: Maybe<Order_Item_Line>;
  /** fetch data from the table: "order_product" */
  order_product: Array<Order_Product>;
  /** fetch aggregated fields from the table: "order_product" */
  order_product_aggregate: Order_Product_Aggregate;
  /** fetch data from the table: "order_product" using primary key columns */
  order_product_by_pk?: Maybe<Order_Product>;
  /** fetch data from the table: "owner" */
  owner: Array<Owner>;
  /** fetch aggregated fields from the table: "owner" */
  owner_aggregate: Owner_Aggregate;
  /** fetch data from the table: "owner" using primary key columns */
  owner_by_pk?: Maybe<Owner>;
  /** fetch data from the table: "page" */
  page: Array<Page>;
  /** fetch data from the table: "page" using primary key columns */
  page_by_pk?: Maybe<Page>;
  /** execute function "partial_text_search" which returns "fn_return.customer_search" */
  partial_text_search: Array<Fn_Return_Customer_Search>;
  /** execute function "partial_text_search" and query aggregates on result of table type "fn_return.customer_search" */
  partial_text_search_aggregate: Fn_Return_Customer_Search_Aggregate;
  /** An array relationship */
  platform: Array<Platform>;
  /** An aggregate relationship */
  platform_aggregate: Platform_Aggregate;
  /** fetch data from the table: "platform" using primary key columns */
  platform_by_pk?: Maybe<Platform>;
  /** fetch data from the table: "price_book" */
  price_book: Array<Price_Book>;
  /** fetch aggregated fields from the table: "price_book" */
  price_book_aggregate: Price_Book_Aggregate;
  /** fetch data from the table: "price_book" using primary key columns */
  price_book_by_pk?: Maybe<Price_Book>;
  /** fetch data from the table: "price_book_entry" */
  price_book_entry: Array<Price_Book_Entry>;
  /** fetch aggregated fields from the table: "price_book_entry" */
  price_book_entry_aggregate: Price_Book_Entry_Aggregate;
  /** fetch data from the table: "price_book_entry" using primary key columns */
  price_book_entry_by_pk?: Maybe<Price_Book_Entry>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch data from the table: "product_active" */
  product_active: Array<Product_Active>;
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table: "quote" */
  quote: Array<Quote>;
  /** fetch aggregated fields from the table: "quote" */
  quote_aggregate: Quote_Aggregate;
  /** fetch data from the table: "quote" using primary key columns */
  quote_by_pk?: Maybe<Quote>;
  /** fetch data from the table: "quote_line" */
  quote_line: Array<Quote_Line>;
  /** fetch aggregated fields from the table: "quote_line" */
  quote_line_aggregate: Quote_Line_Aggregate;
  /** fetch data from the table: "quote_line" using primary key columns */
  quote_line_by_pk?: Maybe<Quote_Line>;
  /** fetch data from the table: "quote_line_consumption_schedule" */
  quote_line_consumption_schedule: Array<Quote_Line_Consumption_Schedule>;
  /** fetch aggregated fields from the table: "quote_line_consumption_schedule" */
  quote_line_consumption_schedule_aggregate: Quote_Line_Consumption_Schedule_Aggregate;
  /** fetch data from the table: "quote_line_consumption_schedule" using primary key columns */
  quote_line_consumption_schedule_by_pk?: Maybe<Quote_Line_Consumption_Schedule>;
  /** fetch data from the table: "quote_line_group" */
  quote_line_group: Array<Quote_Line_Group>;
  /** fetch aggregated fields from the table: "quote_line_group" */
  quote_line_group_aggregate: Quote_Line_Group_Aggregate;
  /** fetch data from the table: "quote_line_group" using primary key columns */
  quote_line_group_by_pk?: Maybe<Quote_Line_Group>;
  /** fetch data from the table: "record_type" */
  record_type: Array<Record_Type>;
  /** fetch aggregated fields from the table: "record_type" */
  record_type_aggregate: Record_Type_Aggregate;
  /** fetch data from the table: "record_type" using primary key columns */
  record_type_by_pk?: Maybe<Record_Type>;
  /** execute function "revenue_segment_data" which returns "fn_return.revenue_segment_data" */
  revenue_segment_data: Array<Fn_Return_Revenue_Segment_Data>;
  /** execute function "revenue_segment_data" and query aggregates on result of table type "fn_return.revenue_segment_data" */
  revenue_segment_data_aggregate: Fn_Return_Revenue_Segment_Data_Aggregate;
  /** execute function "search_channel" which returns "channel" */
  search_channel: Array<Channel>;
  /** execute function "search_channel" and query aggregates on result of table type "channel" */
  search_channel_aggregate: Channel_Aggregate;
  /** execute function "search_customer" which returns "account" */
  search_customer: Array<Account>;
  /** execute function "search_customer" and query aggregates on result of table type "account" */
  search_customer_aggregate: Account_Aggregate;
  /** fetch data from the table: "segment" */
  segment: Array<Segment>;
  /** fetch aggregated fields from the table: "segment" */
  segment_aggregate: Segment_Aggregate;
  /** fetch data from the table: "segment" using primary key columns */
  segment_by_pk?: Maybe<Segment>;
  /** execute function "sf_ns_check" which returns "fn_return.sf_ns_check" */
  sf_ns_check: Array<Fn_Return_Sf_Ns_Check>;
  /** execute function "top_customers_consumption" which returns "fn_return.top_customers" */
  top_customers_consumption: Array<Fn_Return_Top_Customers>;
  /** execute function "top_customers_overall" which returns "fn_return.top_customers" */
  top_customers_overall: Array<Fn_Return_Top_Customers>;
  /** execute function "top_customers_subscription" which returns "fn_return.top_customers" */
  top_customers_subscription: Array<Fn_Return_Top_Customers>;
  /** execute function "total_open_close_ticket_dashboard" which returns "fn_return.total_open_close_ticket_dashboard" */
  total_open_close_ticket_dashboard: Array<Fn_Return_Total_Open_Close_Ticket_Dashboard>;
  /** execute function "total_open_close_ticket_dashboard" and query aggregates on result of table type "fn_return.total_open_close_ticket_dashboard" */
  total_open_close_ticket_dashboard_aggregate: Fn_Return_Total_Open_Close_Ticket_Dashboard_Aggregate;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
};


export type Query_RootAccountArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Query_RootAccount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Query_RootAccount_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootAds_Plus_Customer_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Ads_Plus_Customer_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ads_Plus_Customer_Contacts_Order_By>>;
  where?: InputMaybe<Ads_Plus_Customer_Contacts_Bool_Exp>;
};


export type Query_RootAds_Plus_Customer_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ads_Plus_Customer_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ads_Plus_Customer_Contacts_Order_By>>;
  where?: InputMaybe<Ads_Plus_Customer_Contacts_Bool_Exp>;
};


export type Query_RootCaseArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


export type Query_RootCase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


export type Query_RootCase_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_Rootcdp_top10_non_paying_Cust_MvArgs = {
  distinct_on?: InputMaybe<Array<cdp_top10_non_paying_Cust_Mv_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<cdp_top10_non_paying_Cust_Mv_Order_By>>;
  where?: InputMaybe<cdp_top10_non_paying_Cust_Mv_Bool_Exp>;
};


export type Query_Rootcdp_top10_paying_Cust_MvArgs = {
  distinct_on?: InputMaybe<Array<cdp_top10_paying_Cust_Mv_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<cdp_top10_paying_Cust_Mv_Order_By>>;
  where?: InputMaybe<cdp_top10_paying_Cust_Mv_Bool_Exp>;
};


export type Query_RootChannelArgs = {
  distinct_on?: InputMaybe<Array<Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Order_By>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


export type Query_RootChannel_ActiveArgs = {
  distinct_on?: InputMaybe<Array<Channel_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Active_Order_By>>;
  where?: InputMaybe<Channel_Active_Bool_Exp>;
};


export type Query_RootChannel_Active_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Active_Order_By>>;
  where?: InputMaybe<Channel_Active_Bool_Exp>;
};


export type Query_RootChannel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Order_By>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


export type Query_RootChannel_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootChannel_ChurnedArgs = {
  distinct_on?: InputMaybe<Array<Channel_Churned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Churned_Order_By>>;
  where?: InputMaybe<Channel_Churned_Bool_Exp>;
};


export type Query_RootChannel_Churned_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Churned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Churned_Order_By>>;
  where?: InputMaybe<Channel_Churned_Bool_Exp>;
};


export type Query_RootChannel_Delivered_To_Go_LiveArgs = {
  distinct_on?: InputMaybe<Array<Channel_Delivered_To_Go_Live_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Delivered_To_Go_Live_Order_By>>;
  where?: InputMaybe<Channel_Delivered_To_Go_Live_Bool_Exp>;
};


export type Query_RootChannel_MasterArgs = {
  distinct_on?: InputMaybe<Array<Channel_Master_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Master_Order_By>>;
  where?: InputMaybe<Channel_Master_Bool_Exp>;
};


export type Query_RootChannel_Master_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Master_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Master_Order_By>>;
  where?: InputMaybe<Channel_Master_Bool_Exp>;
};


export type Query_RootChannel_Master_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootChannel_ProgressArgs = {
  distinct_on?: InputMaybe<Array<Channel_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Progress_Order_By>>;
  where?: InputMaybe<Channel_Progress_Bool_Exp>;
};


export type Query_RootChannel_Progress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Progress_Order_By>>;
  where?: InputMaybe<Channel_Progress_Bool_Exp>;
};


export type Query_RootCloudportArgs = {
  distinct_on?: InputMaybe<Array<Cloudport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cloudport_Order_By>>;
  where?: InputMaybe<Cloudport_Bool_Exp>;
};


export type Query_RootCloudport_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCompany_AddressArgs = {
  distinct_on?: InputMaybe<Array<Company_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Address_Order_By>>;
  where?: InputMaybe<Company_Address_Bool_Exp>;
};


export type Query_RootCompany_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Address_Order_By>>;
  where?: InputMaybe<Company_Address_Bool_Exp>;
};


export type Query_RootCompany_Address_By_PkArgs = {
  salesforce_account_id: Scalars['String'];
};


export type Query_RootConsumption_RateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumption_Rate_Order_By>>;
  where?: InputMaybe<Consumption_Rate_Bool_Exp>;
};


export type Query_RootConsumption_Rate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumption_Rate_Order_By>>;
  where?: InputMaybe<Consumption_Rate_Bool_Exp>;
};


export type Query_RootConsumption_Rate_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootConsumption_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumption_Schedule_Order_By>>;
  where?: InputMaybe<Consumption_Schedule_Bool_Exp>;
};


export type Query_RootConsumption_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumption_Schedule_Order_By>>;
  where?: InputMaybe<Consumption_Schedule_Bool_Exp>;
};


export type Query_RootConsumption_Schedule_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootContactArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Query_RootContact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Query_RootContact_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootContent_Plus_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Content_Plus_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Plus_Contacts_Order_By>>;
  where?: InputMaybe<Content_Plus_Contacts_Bool_Exp>;
};


export type Query_RootCredit_Memo_By_IdArgs = {
  args: Credit_Memo_By_Id_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


export type Query_RootCredit_Memo_By_Id_AggregateArgs = {
  args: Credit_Memo_By_Id_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


export type Query_RootCustomerArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Query_RootCustomer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Query_RootCustomer_By_Amagi_IdArgs = {
  args: Customer_By_Amagi_Id_Args;
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Query_RootCustomer_By_Amagi_Id_AggregateArgs = {
  args: Customer_By_Amagi_Id_Args;
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Query_RootCustomer_Contract_TermsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Contract_Terms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Contract_Terms_Order_By>>;
  where?: InputMaybe<Customer_Contract_Terms_Bool_Exp>;
};


export type Query_RootCustomer_Contract_Terms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Contract_Terms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Contract_Terms_Order_By>>;
  where?: InputMaybe<Customer_Contract_Terms_Bool_Exp>;
};


export type Query_RootCustomer_CountArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Type_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Type_Bool_Exp>;
};


export type Query_RootCustomer_Industry_SegmentArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Industry_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Industry_Type_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Industry_Type_Bool_Exp>;
};


export type Query_RootCustomer_Product_By_Amagi_IdArgs = {
  args: Customer_Product_By_Amagi_Id_Args;
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootCustomer_Product_By_Amagi_Id_AggregateArgs = {
  args: Customer_Product_By_Amagi_Id_Args;
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootCustomer_Product_Purchased_By_Amagi_IdArgs = {
  args: Customer_Product_Purchased_By_Amagi_Id_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Product_Purchased_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Product_Purchased_Order_By>>;
  where?: InputMaybe<Fn_Return_Product_Purchased_Bool_Exp>;
};


export type Query_RootCustomer_Product_UrlArgs = {
  distinct_on?: InputMaybe<Array<Customer_Product_Url_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Product_Url_Order_By>>;
  where?: InputMaybe<Customer_Product_Url_Bool_Exp>;
};


export type Query_RootCustomer_Product_Url_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Product_Url_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Product_Url_Order_By>>;
  where?: InputMaybe<Customer_Product_Url_Bool_Exp>;
};


export type Query_RootCustomer_Region_RevenueArgs = {
  args: Customer_Region_Revenue_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Region_Revenue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Region_Revenue_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Region_Revenue_Bool_Exp>;
};


export type Query_RootCustomer_Revenue_SegmentArgs = {
  distinct_on?: InputMaybe<Array<Customer_Revenue_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Revenue_Segment_Order_By>>;
  where?: InputMaybe<Customer_Revenue_Segment_Bool_Exp>;
};


export type Query_RootCustomer_Revenue_Segment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Revenue_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Revenue_Segment_Order_By>>;
  where?: InputMaybe<Customer_Revenue_Segment_Bool_Exp>;
};


export type Query_RootCustomer_Revenue_Segment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCustomer_Revenue_Segment_DataArgs = {
  distinct_on?: InputMaybe<Array<Customer_Revenue_Segment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Revenue_Segment_Data_Order_By>>;
  where?: InputMaybe<Customer_Revenue_Segment_Data_Bool_Exp>;
};


export type Query_RootCustomer_Revenue_Segment_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Revenue_Segment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Revenue_Segment_Data_Order_By>>;
  where?: InputMaybe<Customer_Revenue_Segment_Data_Bool_Exp>;
};


export type Query_RootCustomer_Revenue_Segment_Data_By_PkArgs = {
  amagi_id: Scalars['String'];
};


export type Query_RootCustomer_Tier_RevenueArgs = {
  args: Customer_Tier_Revenue_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Tier_Revenue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Tier_Revenue_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Tier_Revenue_Bool_Exp>;
};


export type Query_RootCustomer_TypeArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Type_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Type_Bool_Exp>;
};


export type Query_RootCustomer_Type_RevenueArgs = {
  args: Customer_Type_Revenue_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Type_Revenue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Type_Revenue_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Type_Revenue_Bool_Exp>;
};


export type Query_RootDashboard_Revenue_SplitArgs = {
  args: Dashboard_Revenue_Split_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Revenue_Split_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Revenue_Split_Order_By>>;
  where?: InputMaybe<Fn_Return_Revenue_Split_Bool_Exp>;
};


export type Query_RootData_GrowthArgs = {
  distinct_on?: InputMaybe<Array<Data_Growth_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Data_Growth_Order_By>>;
  where?: InputMaybe<Data_Growth_Bool_Exp>;
};


export type Query_RootData_Growth_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootData_Growth_TrendArgs = {
  args: Data_Growth_Trend_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Data_Growth_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Data_Growth_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Data_Growth_Graph_Bool_Exp>;
};


export type Query_RootData_QualityArgs = {
  distinct_on?: InputMaybe<Array<Data_Quality_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Data_Quality_Order_By>>;
  where?: InputMaybe<Data_Quality_Bool_Exp>;
};


export type Query_RootData_Quality_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootData_Quality_TableArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Data_Quality_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Data_Quality_Order_By>>;
  where?: InputMaybe<Fn_Return_Data_Quality_Bool_Exp>;
};


export type Query_RootData_Quality_TrendArgs = {
  args: Data_Quality_Trend_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Data_Quality_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Data_Quality_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Data_Quality_Graph_Bool_Exp>;
};


export type Query_RootDeliveryArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Order_By>>;
  where?: InputMaybe<Delivery_Bool_Exp>;
};


export type Query_RootDelivery_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Order_By>>;
  where?: InputMaybe<Delivery_Bool_Exp>;
};


export type Query_RootDelivery_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootDelivery_Channel_PlatformArgs = {
  args: Delivery_Channel_Platform_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Channel_Platform_Bool_Exp>;
};


export type Query_RootDelivery_Channel_Platform_AggregateArgs = {
  args: Delivery_Channel_Platform_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Channel_Platform_Bool_Exp>;
};


export type Query_RootDelivery_MainArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Main_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Main_Order_By>>;
  where?: InputMaybe<Delivery_Main_Bool_Exp>;
};


export type Query_RootDelivery_Main_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Main_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Main_Order_By>>;
  where?: InputMaybe<Delivery_Main_Bool_Exp>;
};


export type Query_RootDelivery_NowArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Now_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Now_Order_By>>;
  where?: InputMaybe<Delivery_Now_Bool_Exp>;
};


export type Query_RootDelivery_PayloadArgs = {
  args: Delivery_Payload_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Payload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Payload_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Payload_Bool_Exp>;
};


export type Query_RootDelivery_Payload_AggregateArgs = {
  args: Delivery_Payload_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Payload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Payload_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Payload_Bool_Exp>;
};


export type Query_RootDelivery_TimelineArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Timeline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Timeline_Order_By>>;
  where?: InputMaybe<Delivery_Timeline_Bool_Exp>;
};


export type Query_RootDelivery_Timeline_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Timeline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Timeline_Order_By>>;
  where?: InputMaybe<Delivery_Timeline_Bool_Exp>;
};


export type Query_RootDomain_ExistArgs = {
  args: Domain_Exist_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Domain_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Domain_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Domain_Validation_Bool_Exp>;
};


export type Query_RootDomain_Exist_AggregateArgs = {
  args: Domain_Exist_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Domain_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Domain_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Domain_Validation_Bool_Exp>;
};


export type Query_RootEmail_ExistArgs = {
  args: Email_Exist_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Email_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Email_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Email_Validation_Bool_Exp>;
};


export type Query_RootEmail_Exist_AggregateArgs = {
  args: Email_Exist_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Email_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Email_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Email_Validation_Bool_Exp>;
};


export type Query_RootExisting_New_Churned_DashboardArgs = {
  args: Existing_New_Churned_Dashboard_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Existing_New_Churned_Dashboard_Bool_Exp>;
};


export type Query_RootExisting_New_Churned_Dashboard_ChannelArgs = {
  args: Existing_New_Churned_Dashboard_Channel_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Existing_New_Churned_Dashboard_Bool_Exp>;
};


export type Query_RootExisting_New_Churned_Platform_DashboardArgs = {
  args: Existing_New_Churned_Platform_Dashboard_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Existing_New_Churned_Dashboard_Bool_Exp>;
};


export type Query_RootFeature_FlagArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Flag_Order_By>>;
  where?: InputMaybe<Feature_Flag_Bool_Exp>;
};


export type Query_RootFeature_Flag_By_PkArgs = {
  feature: Scalars['String'];
};


export type Query_RootFn_Return_Account_StatementArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Bool_Exp>;
};


export type Query_RootFn_Return_Account_Statement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Bool_Exp>;
};


export type Query_RootFn_Return_Account_Statement_By_PkArgs = {
  transaction_date: Scalars['String'];
};


export type Query_RootFn_Return_Account_Statement_MetaArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Meta_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Meta_Bool_Exp>;
};


export type Query_RootFn_Return_Account_Statement_Meta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Meta_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Meta_Bool_Exp>;
};


export type Query_RootFn_Return_Account_Statement_Meta_By_PkArgs = {
  transaction_type: Scalars['String'];
};


export type Query_RootFn_Return_Account_Statement_OutstandingArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Outstanding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Outstanding_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Outstanding_Bool_Exp>;
};


export type Query_RootFn_Return_Account_Statement_Outstanding_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Outstanding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Outstanding_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Outstanding_Bool_Exp>;
};


export type Query_RootFn_Return_Account_Statement_Outstanding_By_PkArgs = {
  outstanding: Scalars['String'];
};


export type Query_RootFn_Return_Account_Statement_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Summary_Bool_Exp>;
};


export type Query_RootFn_Return_Account_Statement_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Summary_Bool_Exp>;
};


export type Query_RootFn_Return_Account_Statement_Summary_By_PkArgs = {
  total: Scalars['String'];
};


export type Query_RootFn_Return_Avg_Service_AvailibityArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Avg_Service_Availibity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Avg_Service_Availibity_Order_By>>;
  where?: InputMaybe<Fn_Return_Avg_Service_Availibity_Bool_Exp>;
};


export type Query_RootFn_Return_Avg_Service_Availibity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Avg_Service_Availibity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Avg_Service_Availibity_Order_By>>;
  where?: InputMaybe<Fn_Return_Avg_Service_Availibity_Bool_Exp>;
};


export type Query_RootFn_Return_Avg_Service_Availibity_By_PkArgs = {
  months: Scalars['date'];
};


export type Query_RootFn_Return_Billing_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Query_RootFn_Return_Billing_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Query_RootFn_Return_Billing_Summary_By_PkArgs = {
  amount: Scalars['numeric'];
};


export type Query_RootFn_Return_Channel_Deliveries_CountArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Channel_Deliveries_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Channel_Deliveries_Count_Order_By>>;
  where?: InputMaybe<Fn_Return_Channel_Deliveries_Count_Bool_Exp>;
};


export type Query_RootFn_Return_Channel_Deliveries_Count_By_PkArgs = {
  delivery_status: Scalars['String'];
};


export type Query_RootFn_Return_Combined_InvoiceArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


export type Query_RootFn_Return_Combined_Invoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


export type Query_RootFn_Return_Combined_Invoice_By_PkArgs = {
  invoice_id: Scalars['String'];
};


export type Query_RootFn_Return_Combined_Invoice_LineArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
};


export type Query_RootFn_Return_Combined_Invoice_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
};


export type Query_RootFn_Return_Combined_Invoice_Line_By_PkArgs = {
  product_id: Scalars['String'];
};


export type Query_RootFn_Return_Customer_Industry_TypeArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Industry_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Industry_Type_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Industry_Type_Bool_Exp>;
};


export type Query_RootFn_Return_Customer_Industry_Type_By_PkArgs = {
  industry_type: Scalars['String'];
};


export type Query_RootFn_Return_Customer_Region_RevenueArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Region_Revenue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Region_Revenue_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Region_Revenue_Bool_Exp>;
};


export type Query_RootFn_Return_Customer_Region_Revenue_By_PkArgs = {
  customer_region: Scalars['String'];
};


export type Query_RootFn_Return_Customer_SearchArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Search_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Search_Bool_Exp>;
};


export type Query_RootFn_Return_Customer_Search_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Search_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Search_Bool_Exp>;
};


export type Query_RootFn_Return_Customer_Search_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootFn_Return_Customer_Tier_RevenueArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Tier_Revenue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Tier_Revenue_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Tier_Revenue_Bool_Exp>;
};


export type Query_RootFn_Return_Customer_Tier_Revenue_By_PkArgs = {
  customer_tier: Scalars['String'];
};


export type Query_RootFn_Return_Customer_TypeArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Type_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Type_Bool_Exp>;
};


export type Query_RootFn_Return_Customer_Type_By_PkArgs = {
  customer_type: Scalars['String'];
};


export type Query_RootFn_Return_Customer_Type_RevenueArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Type_Revenue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Type_Revenue_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Type_Revenue_Bool_Exp>;
};


export type Query_RootFn_Return_Customer_Type_Revenue_By_PkArgs = {
  customer_type: Scalars['String'];
};


export type Query_RootFn_Return_Data_Growth_GraphArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Data_Growth_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Data_Growth_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Data_Growth_Graph_Bool_Exp>;
};


export type Query_RootFn_Return_Data_Growth_Graph_By_PkArgs = {
  date: Scalars['date'];
};


export type Query_RootFn_Return_Data_QualityArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Data_Quality_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Data_Quality_Order_By>>;
  where?: InputMaybe<Fn_Return_Data_Quality_Bool_Exp>;
};


export type Query_RootFn_Return_Data_Quality_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootFn_Return_Data_Quality_GraphArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Data_Quality_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Data_Quality_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Data_Quality_Graph_Bool_Exp>;
};


export type Query_RootFn_Return_Data_Quality_Graph_By_PkArgs = {
  date: Scalars['date'];
};


export type Query_RootFn_Return_Deliveries_CountArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Deliveries_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Deliveries_Count_Order_By>>;
  where?: InputMaybe<Fn_Return_Deliveries_Count_Bool_Exp>;
};


export type Query_RootFn_Return_Deliveries_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Deliveries_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Deliveries_Count_Order_By>>;
  where?: InputMaybe<Fn_Return_Deliveries_Count_Bool_Exp>;
};


export type Query_RootFn_Return_Deliveries_Count_By_PkArgs = {
  result: Scalars['jsonb'];
};


export type Query_RootFn_Return_Delivery_Channel_PlatformArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Channel_Platform_Bool_Exp>;
};


export type Query_RootFn_Return_Delivery_Channel_Platform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Channel_Platform_Bool_Exp>;
};


export type Query_RootFn_Return_Delivery_Channel_Platform_By_PkArgs = {
  products: Scalars['jsonb'];
};


export type Query_RootFn_Return_Delivery_CountArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Count_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Count_Bool_Exp>;
};


export type Query_RootFn_Return_Delivery_Count_By_PkArgs = {
  count: Scalars['bigint'];
};


export type Query_RootFn_Return_Delivery_PayloadArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Payload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Payload_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Payload_Bool_Exp>;
};


export type Query_RootFn_Return_Delivery_Payload_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Payload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Payload_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Payload_Bool_Exp>;
};


export type Query_RootFn_Return_Delivery_Payload_By_PkArgs = {
  amagi_id: Scalars['String'];
};


export type Query_RootFn_Return_Delivery_ShareArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Share_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Share_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Share_Bool_Exp>;
};


export type Query_RootFn_Return_Delivery_Share_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Share_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Share_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Share_Bool_Exp>;
};


export type Query_RootFn_Return_Delivery_Share_By_PkArgs = {
  delivery_deal: Scalars['jsonb'];
};


export type Query_RootFn_Return_Domain_ValidationArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Domain_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Domain_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Domain_Validation_Bool_Exp>;
};


export type Query_RootFn_Return_Domain_Validation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Domain_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Domain_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Domain_Validation_Bool_Exp>;
};


export type Query_RootFn_Return_Domain_Validation_By_PkArgs = {
  domain_exist: Scalars['jsonb'];
  email_exist: Scalars['jsonb'];
};


export type Query_RootFn_Return_Email_ValidationArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Email_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Email_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Email_Validation_Bool_Exp>;
};


export type Query_RootFn_Return_Email_Validation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Email_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Email_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Email_Validation_Bool_Exp>;
};


export type Query_RootFn_Return_Email_Validation_By_PkArgs = {
  email_exist: Scalars['jsonb'];
};


export type Query_RootFn_Return_Existing_New_Churned_DashboardArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Existing_New_Churned_Dashboard_Bool_Exp>;
};


export type Query_RootFn_Return_Existing_New_Churned_Dashboard_By_PkArgs = {
  month: Scalars['String'];
};


export type Query_RootFn_Return_Financial_GraphArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


export type Query_RootFn_Return_Financial_Graph_By_PkArgs = {
  month: Scalars['String'];
};


export type Query_RootFn_Return_Latest_MrrArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Latest_Mrr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Latest_Mrr_Order_By>>;
  where?: InputMaybe<Fn_Return_Latest_Mrr_Bool_Exp>;
};


export type Query_RootFn_Return_Latest_Mrr_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Latest_Mrr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Latest_Mrr_Order_By>>;
  where?: InputMaybe<Fn_Return_Latest_Mrr_Bool_Exp>;
};


export type Query_RootFn_Return_Latest_Mrr_By_PkArgs = {
  month: Scalars['String'];
};


export type Query_RootFn_Return_Msa_Rate_CardArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Order_By>>;
  where?: InputMaybe<Fn_Return_Msa_Rate_Card_Bool_Exp>;
};


export type Query_RootFn_Return_Msa_Rate_Card_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Order_By>>;
  where?: InputMaybe<Fn_Return_Msa_Rate_Card_Bool_Exp>;
};


export type Query_RootFn_Return_Msa_Rate_Card_By_PkArgs = {
  quote_number: Scalars['String'];
};


export type Query_RootFn_Return_Product_Financial_GraphArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Product_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Product_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Product_Financial_Graph_Bool_Exp>;
};


export type Query_RootFn_Return_Product_Financial_Graph_By_PkArgs = {
  month: Scalars['String'];
};


export type Query_RootFn_Return_Product_PurchasedArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Product_Purchased_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Product_Purchased_Order_By>>;
  where?: InputMaybe<Fn_Return_Product_Purchased_Bool_Exp>;
};


export type Query_RootFn_Return_Product_Purchased_By_PkArgs = {
  product_id: Scalars['String'];
};


export type Query_RootFn_Return_Product_Table_DetailArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Product_Table_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Product_Table_Detail_Order_By>>;
  where?: InputMaybe<Fn_Return_Product_Table_Detail_Bool_Exp>;
};


export type Query_RootFn_Return_Product_Table_Detail_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootFn_Return_Revenue_Segment_DataArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Order_By>>;
  where?: InputMaybe<Fn_Return_Revenue_Segment_Data_Bool_Exp>;
};


export type Query_RootFn_Return_Revenue_Segment_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Order_By>>;
  where?: InputMaybe<Fn_Return_Revenue_Segment_Data_Bool_Exp>;
};


export type Query_RootFn_Return_Revenue_Segment_Data_By_PkArgs = {
  amagi_id: Scalars['String'];
};


export type Query_RootFn_Return_Revenue_SplitArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Revenue_Split_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Revenue_Split_Order_By>>;
  where?: InputMaybe<Fn_Return_Revenue_Split_Bool_Exp>;
};


export type Query_RootFn_Return_Revenue_Split_By_PkArgs = {
  month: Scalars['String'];
};


export type Query_RootFn_Return_Sales_ResponseArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Sales_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Sales_Response_Order_By>>;
  where?: InputMaybe<Fn_Return_Sales_Response_Bool_Exp>;
};


export type Query_RootFn_Return_Sales_Response_By_PkArgs = {
  source: Scalars['String'];
  status: Scalars['String'];
};


export type Query_RootFn_Return_Sf_Ns_CheckArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Sf_Ns_Check_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Sf_Ns_Check_Order_By>>;
  where?: InputMaybe<Fn_Return_Sf_Ns_Check_Bool_Exp>;
};


export type Query_RootFn_Return_Sf_Ns_Check_By_PkArgs = {
  check: Scalars['String'];
};


export type Query_RootFn_Return_Top_CustomersArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Top_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Top_Customers_Order_By>>;
  where?: InputMaybe<Fn_Return_Top_Customers_Bool_Exp>;
};


export type Query_RootFn_Return_Top_Customers_By_PkArgs = {
  account_name: Scalars['String'];
};


export type Query_RootFn_Return_Total_Open_Close_Ticket_DashboardArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Bool_Exp>;
};


export type Query_RootFn_Return_Total_Open_Close_Ticket_Dashboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Bool_Exp>;
};


export type Query_RootFn_Return_Total_Open_Close_Ticket_Dashboard_By_PkArgs = {
  month: Scalars['String'];
};


export type Query_RootFreshdesk_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Freshdesk_Company_Order_By>>;
  where?: InputMaybe<Freshdesk_Company_Bool_Exp>;
};


export type Query_RootFreshdesk_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Freshdesk_Company_Order_By>>;
  where?: InputMaybe<Freshdesk_Company_Bool_Exp>;
};


export type Query_RootFreshdesk_Company_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootFreshdesk_ContactArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Freshdesk_Contact_Order_By>>;
  where?: InputMaybe<Freshdesk_Contact_Bool_Exp>;
};


export type Query_RootFreshdesk_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Freshdesk_Contact_Order_By>>;
  where?: InputMaybe<Freshdesk_Contact_Bool_Exp>;
};


export type Query_RootFreshdesk_Contact_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootFreshdesk_TicketArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Freshdesk_Ticket_Order_By>>;
  where?: InputMaybe<Freshdesk_Ticket_Bool_Exp>;
};


export type Query_RootFreshdesk_Ticket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Freshdesk_Ticket_Order_By>>;
  where?: InputMaybe<Freshdesk_Ticket_Bool_Exp>;
};


export type Query_RootFreshdesk_Ticket_By_PkArgs = {
  ticket_id: Scalars['numeric'];
};


export type Query_RootIncidentArgs = {
  distinct_on?: InputMaybe<Array<Incident_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Incident_Order_By>>;
  where?: InputMaybe<Incident_Bool_Exp>;
};


export type Query_RootIncident_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incident_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Incident_Order_By>>;
  where?: InputMaybe<Incident_Bool_Exp>;
};


export type Query_RootIncident_By_PkArgs = {
  amagi_id: Scalars['String'];
  id: Scalars['String'];
};


export type Query_RootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Query_RootInvoice_By_IdArgs = {
  args: Invoice_By_Id_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


export type Query_RootInvoice_By_Id_AggregateArgs = {
  args: Invoice_By_Id_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


export type Query_RootInvoice_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootInvoice_LineArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Line_Order_By>>;
  where?: InputMaybe<Invoice_Line_Bool_Exp>;
};


export type Query_RootInvoice_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Line_Order_By>>;
  where?: InputMaybe<Invoice_Line_Bool_Exp>;
};


export type Query_RootInvoice_Line_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootInvoice_Lines_By_IdArgs = {
  args: Invoice_Lines_By_Id_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
};


export type Query_RootInvoice_Lines_By_Id_AggregateArgs = {
  args: Invoice_Lines_By_Id_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
};


export type Query_RootLegal_EntityArgs = {
  distinct_on?: InputMaybe<Array<Legal_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Entity_Order_By>>;
  where?: InputMaybe<Legal_Entity_Bool_Exp>;
};


export type Query_RootLegal_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legal_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Entity_Order_By>>;
  where?: InputMaybe<Legal_Entity_Bool_Exp>;
};


export type Query_RootLegal_Entity_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootMedia_Industry_Sub_SegmentArgs = {
  distinct_on?: InputMaybe<Array<Media_Industry_Sub_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Industry_Sub_Segment_Order_By>>;
  where?: InputMaybe<Media_Industry_Sub_Segment_Bool_Exp>;
};


export type Query_RootMedia_Industry_Sub_Segment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Media_Industry_Sub_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Industry_Sub_Segment_Order_By>>;
  where?: InputMaybe<Media_Industry_Sub_Segment_Bool_Exp>;
};


export type Query_RootMedia_Industry_Sub_Segment_By_PkArgs = {
  salesforce_account_id: Scalars['String'];
};


export type Query_RootMsa_MasterArgs = {
  distinct_on?: InputMaybe<Array<Msa_Master_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Msa_Master_Order_By>>;
  where?: InputMaybe<Msa_Master_Bool_Exp>;
};


export type Query_RootMsa_Master_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Msa_Master_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Msa_Master_Order_By>>;
  where?: InputMaybe<Msa_Master_Bool_Exp>;
};


export type Query_RootMsa_Rate_CardArgs = {
  distinct_on?: InputMaybe<Array<Msa_Rate_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Msa_Rate_Card_Order_By>>;
  where?: InputMaybe<Msa_Rate_Card_Bool_Exp>;
};


export type Query_RootMsa_Rate_Card_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Msa_Rate_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Msa_Rate_Card_Order_By>>;
  where?: InputMaybe<Msa_Rate_Card_Bool_Exp>;
};


export type Query_RootMsa_Rate_Card_By_PkArgs = {
  amagi_id: Scalars['String'];
  code: Scalars['String'];
  quote_number: Scalars['String'];
};


export type Query_RootMsa_Rate_Card_FnArgs = {
  args: Msa_Rate_Card_Fn_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Order_By>>;
  where?: InputMaybe<Fn_Return_Msa_Rate_Card_Bool_Exp>;
};


export type Query_RootMsa_Rate_Card_Fn_AggregateArgs = {
  args: Msa_Rate_Card_Fn_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Order_By>>;
  where?: InputMaybe<Fn_Return_Msa_Rate_Card_Bool_Exp>;
};


export type Query_RootNet_Invoices_DueArgs = {
  args: Net_Invoices_Due_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Query_RootNet_Invoices_Due_AggregateArgs = {
  args: Net_Invoices_Due_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Query_RootNet_Invoices_OutstandingArgs = {
  args: Net_Invoices_Outstanding_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Query_RootNet_Invoices_Outstanding_AggregateArgs = {
  args: Net_Invoices_Outstanding_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Query_RootNet_Invoices_OverdueArgs = {
  args: Net_Invoices_Overdue_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Query_RootNet_Invoices_Overdue_AggregateArgs = {
  args: Net_Invoices_Overdue_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Query_RootNetsuite_Currency_RateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Currency_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Currency_Rate_Order_By>>;
  where?: InputMaybe<Netsuite_Currency_Rate_Bool_Exp>;
};


export type Query_RootNetsuite_Currency_Rate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Currency_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Currency_Rate_Order_By>>;
  where?: InputMaybe<Netsuite_Currency_Rate_Bool_Exp>;
};


export type Query_RootNetsuite_Currency_Rate_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Query_RootNetsuite_Pdf_FileArgs = {
  id: Scalars['String'];
};


export type Query_RootNetsuite_ReceiptArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Receipt_Order_By>>;
  where?: InputMaybe<Netsuite_Receipt_Bool_Exp>;
};


export type Query_RootNetsuite_Receipt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Receipt_Order_By>>;
  where?: InputMaybe<Netsuite_Receipt_Bool_Exp>;
};


export type Query_RootNetsuite_Receipt_By_PkArgs = {
  netsuite_id: Scalars['numeric'];
};


export type Query_RootNetsuite_Receipt_LineArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Receipt_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Receipt_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Receipt_Line_Bool_Exp>;
};


export type Query_RootNetsuite_Receipt_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Receipt_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Receipt_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Receipt_Line_Bool_Exp>;
};


export type Query_RootNetsuite_Receipt_Line_By_PkArgs = {
  netsuite_receipt_line_id: Scalars['numeric'];
};


export type Query_RootNetsuite_TaxArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Tax_Order_By>>;
  where?: InputMaybe<Netsuite_Tax_Bool_Exp>;
};


export type Query_RootNetsuite_Tax_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Tax_Order_By>>;
  where?: InputMaybe<Netsuite_Tax_Bool_Exp>;
};


export type Query_RootNetsuite_Tax_By_PkArgs = {
  netsuite_id: Scalars['String'];
};


export type Query_RootNetsuite_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Transaction_Order_By>>;
  where?: InputMaybe<Netsuite_Transaction_Bool_Exp>;
};


export type Query_RootNetsuite_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Transaction_Order_By>>;
  where?: InputMaybe<Netsuite_Transaction_Bool_Exp>;
};


export type Query_RootNetsuite_Transaction_By_PkArgs = {
  netsuite_id: Scalars['numeric'];
};


export type Query_RootNetsuite_Transaction_LineArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Transaction_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Transaction_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Transaction_Line_Bool_Exp>;
};


export type Query_RootNetsuite_Transaction_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Transaction_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Transaction_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Transaction_Line_Bool_Exp>;
};


export type Query_RootNetsuite_Transaction_Line_By_PkArgs = {
  netsuite_id: Scalars['String'];
};


export type Query_RootNetsuite_Vendor_InvoiceArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Bool_Exp>;
};


export type Query_RootNetsuite_Vendor_Invoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Bool_Exp>;
};


export type Query_RootNetsuite_Vendor_Invoice_By_PkArgs = {
  netsuite_id: Scalars['numeric'];
};


export type Query_RootNetsuite_Vendor_Invoice_ExpenseArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Expense_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Expense_Bool_Exp>;
};


export type Query_RootNetsuite_Vendor_Invoice_Expense_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Expense_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Expense_Bool_Exp>;
};


export type Query_RootNetsuite_Vendor_Invoice_Expense_By_PkArgs = {
  netsuite_id: Scalars['String'];
};


export type Query_RootNetsuite_Vendor_Invoice_LineArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Line_Bool_Exp>;
};


export type Query_RootNetsuite_Vendor_Invoice_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Line_Bool_Exp>;
};


export type Query_RootNetsuite_Vendor_Invoice_Line_By_PkArgs = {
  netsuite_id: Scalars['String'];
};


export type Query_RootNetsuite_Vendor_Invoice_TaxArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Tax_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Tax_Bool_Exp>;
};


export type Query_RootNetsuite_Vendor_Invoice_Tax_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Tax_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Tax_Bool_Exp>;
};


export type Query_RootNetsuite_Vendor_Invoice_Tax_By_PkArgs = {
  netsuite_id: Scalars['String'];
};


export type Query_RootOnboarding_Customer_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Onboarding_Customer_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Onboarding_Customer_Contacts_Order_By>>;
  where?: InputMaybe<Onboarding_Customer_Contacts_Bool_Exp>;
};


export type Query_RootOnboarding_Customer_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Onboarding_Customer_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Onboarding_Customer_Contacts_Order_By>>;
  where?: InputMaybe<Onboarding_Customer_Contacts_Bool_Exp>;
};


export type Query_RootOpportunityArgs = {
  distinct_on?: InputMaybe<Array<Opportunity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opportunity_Order_By>>;
  where?: InputMaybe<Opportunity_Bool_Exp>;
};


export type Query_RootOpportunity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Opportunity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opportunity_Order_By>>;
  where?: InputMaybe<Opportunity_Bool_Exp>;
};


export type Query_RootOpportunity_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootOpportunity_FilesArgs = {
  id: Scalars['String'];
};


export type Query_RootOpportunity_Self_Serve_InformationArgs = {
  distinct_on?: InputMaybe<Array<Opportunity_Self_Serve_Information_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opportunity_Self_Serve_Information_Order_By>>;
  where?: InputMaybe<Opportunity_Self_Serve_Information_Bool_Exp>;
};


export type Query_RootOpportunity_Self_Serve_Information_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Opportunity_Self_Serve_Information_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opportunity_Self_Serve_Information_Order_By>>;
  where?: InputMaybe<Opportunity_Self_Serve_Information_Bool_Exp>;
};


export type Query_RootOrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootOrder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootOrder_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootOrder_ItemArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Order_By>>;
  where?: InputMaybe<Order_Item_Bool_Exp>;
};


export type Query_RootOrder_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Order_By>>;
  where?: InputMaybe<Order_Item_Bool_Exp>;
};


export type Query_RootOrder_Item_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootOrder_Item_LineArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Line_Order_By>>;
  where?: InputMaybe<Order_Item_Line_Bool_Exp>;
};


export type Query_RootOrder_Item_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Line_Order_By>>;
  where?: InputMaybe<Order_Item_Line_Bool_Exp>;
};


export type Query_RootOrder_Item_Line_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootOrder_ProductArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


export type Query_RootOrder_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


export type Query_RootOrder_Product_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootOwnerArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


export type Query_RootOwner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


export type Query_RootOwner_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootPageArgs = {
  distinct_on?: InputMaybe<Array<Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Order_By>>;
  where?: InputMaybe<Page_Bool_Exp>;
};


export type Query_RootPage_By_PkArgs = {
  slug: Scalars['String'];
};


export type Query_RootPartial_Text_SearchArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Search_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Search_Bool_Exp>;
};


export type Query_RootPartial_Text_Search_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Search_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Search_Bool_Exp>;
};


export type Query_RootPlatformArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


export type Query_RootPlatform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


export type Query_RootPlatform_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPrice_BookArgs = {
  distinct_on?: InputMaybe<Array<Price_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Price_Book_Order_By>>;
  where?: InputMaybe<Price_Book_Bool_Exp>;
};


export type Query_RootPrice_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Price_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Price_Book_Order_By>>;
  where?: InputMaybe<Price_Book_Bool_Exp>;
};


export type Query_RootPrice_Book_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootPrice_Book_EntryArgs = {
  distinct_on?: InputMaybe<Array<Price_Book_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Price_Book_Entry_Order_By>>;
  where?: InputMaybe<Price_Book_Entry_Bool_Exp>;
};


export type Query_RootPrice_Book_Entry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Price_Book_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Price_Book_Entry_Order_By>>;
  where?: InputMaybe<Price_Book_Entry_Bool_Exp>;
};


export type Query_RootPrice_Book_Entry_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_ActiveArgs = {
  distinct_on?: InputMaybe<Array<Product_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Active_Order_By>>;
  where?: InputMaybe<Product_Active_Bool_Exp>;
};


export type Query_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Query_RootProduct_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootQuoteArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Query_RootQuote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Query_RootQuote_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootQuote_LineArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Order_By>>;
  where?: InputMaybe<Quote_Line_Bool_Exp>;
};


export type Query_RootQuote_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Order_By>>;
  where?: InputMaybe<Quote_Line_Bool_Exp>;
};


export type Query_RootQuote_Line_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootQuote_Line_Consumption_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Order_By>>;
  where?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
};


export type Query_RootQuote_Line_Consumption_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Order_By>>;
  where?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
};


export type Query_RootQuote_Line_Consumption_Schedule_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootQuote_Line_GroupArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Group_Order_By>>;
  where?: InputMaybe<Quote_Line_Group_Bool_Exp>;
};


export type Query_RootQuote_Line_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Group_Order_By>>;
  where?: InputMaybe<Quote_Line_Group_Bool_Exp>;
};


export type Query_RootQuote_Line_Group_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootRecord_TypeArgs = {
  distinct_on?: InputMaybe<Array<Record_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Record_Type_Order_By>>;
  where?: InputMaybe<Record_Type_Bool_Exp>;
};


export type Query_RootRecord_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Record_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Record_Type_Order_By>>;
  where?: InputMaybe<Record_Type_Bool_Exp>;
};


export type Query_RootRecord_Type_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Query_RootRevenue_Segment_DataArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Order_By>>;
  where?: InputMaybe<Fn_Return_Revenue_Segment_Data_Bool_Exp>;
};


export type Query_RootRevenue_Segment_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Order_By>>;
  where?: InputMaybe<Fn_Return_Revenue_Segment_Data_Bool_Exp>;
};


export type Query_RootSearch_ChannelArgs = {
  args: Search_Channel_Args;
  distinct_on?: InputMaybe<Array<Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Order_By>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


export type Query_RootSearch_Channel_AggregateArgs = {
  args: Search_Channel_Args;
  distinct_on?: InputMaybe<Array<Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Order_By>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


export type Query_RootSearch_CustomerArgs = {
  args: Search_Customer_Args;
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Query_RootSearch_Customer_AggregateArgs = {
  args: Search_Customer_Args;
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Query_RootSegmentArgs = {
  distinct_on?: InputMaybe<Array<Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Segment_Order_By>>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type Query_RootSegment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Segment_Order_By>>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type Query_RootSegment_By_PkArgs = {
  salesforce_account_id: Scalars['String'];
};


export type Query_RootSf_Ns_CheckArgs = {
  args: Sf_Ns_Check_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Sf_Ns_Check_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Sf_Ns_Check_Order_By>>;
  where?: InputMaybe<Fn_Return_Sf_Ns_Check_Bool_Exp>;
};


export type Query_RootTop_Customers_ConsumptionArgs = {
  args: Top_Customers_Consumption_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Top_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Top_Customers_Order_By>>;
  where?: InputMaybe<Fn_Return_Top_Customers_Bool_Exp>;
};


export type Query_RootTop_Customers_OverallArgs = {
  args: Top_Customers_Overall_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Top_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Top_Customers_Order_By>>;
  where?: InputMaybe<Fn_Return_Top_Customers_Bool_Exp>;
};


export type Query_RootTop_Customers_SubscriptionArgs = {
  args: Top_Customers_Subscription_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Top_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Top_Customers_Order_By>>;
  where?: InputMaybe<Fn_Return_Top_Customers_Bool_Exp>;
};


export type Query_RootTotal_Open_Close_Ticket_DashboardArgs = {
  args: Total_Open_Close_Ticket_Dashboard_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Bool_Exp>;
};


export type Query_RootTotal_Open_Close_Ticket_Dashboard_AggregateArgs = {
  args: Total_Open_Close_Ticket_Dashboard_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Bool_Exp>;
};


export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_By_PkArgs = {
  salesforce_id: Scalars['String'];
};

/** columns and relationships of "quote" */
export type Quote = {
  __typename?: 'quote';
  accepted_date_time?: Maybe<Scalars['timestamptz']>;
  accepted_quote_actions?: Maybe<Scalars['Boolean']>;
  additional_discount_amount?: Maybe<Scalars['numeric']>;
  annual_contract_value?: Maybe<Scalars['numeric']>;
  avg_customer_discount?: Maybe<Scalars['float8']>;
  bill_to_city?: Maybe<Scalars['String']>;
  bill_to_country?: Maybe<Scalars['String']>;
  bill_to_name?: Maybe<Scalars['String']>;
  bill_to_postal_code?: Maybe<Scalars['String']>;
  bill_to_state?: Maybe<Scalars['String']>;
  bill_to_street?: Maybe<Scalars['String']>;
  create_order_without_signed_so?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  customer?: Maybe<Customer>;
  deposit?: Maybe<Scalars['String']>;
  deposit_fee?: Maybe<Scalars['numeric']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  estimated_cdn_consumption_fees?: Maybe<Scalars['numeric']>;
  exclude_distribution_partners?: Maybe<Scalars['String']>;
  fixed_recurring?: Maybe<Scalars['String']>;
  go_live_date?: Maybe<Scalars['timestamptz']>;
  group_line_items?: Maybe<Scalars['Boolean']>;
  initial_fees?: Maybe<Scalars['numeric']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  lifetime_contract_value?: Maybe<Scalars['numeric']>;
  max_discount_rate?: Maybe<Scalars['float8']>;
  monthly_fees?: Maybe<Scalars['numeric']>;
  msa_quote?: Maybe<Scalars['String']>;
  msa_quote_type?: Maybe<Scalars['String']>;
  net_amount?: Maybe<Scalars['numeric']>;
  no_of_months_deposit?: Maybe<Scalars['float8']>;
  one_time?: Maybe<Scalars['String']>;
  /** An object relationship */
  opportunity?: Maybe<Opportunity>;
  ordered_quote_actions?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  orders: Array<Order>;
  /** An aggregate relationship */
  orders_aggregate: Order_Aggregate;
  original_quote_monthly_fees?: Maybe<Scalars['float8']>;
  primary_contact?: Maybe<Scalars['String']>;
  primary_quote_actions?: Maybe<Scalars['Boolean']>;
  print_line_items?: Maybe<Scalars['Boolean']>;
  quote_accepted_date?: Maybe<Scalars['timestamptz']>;
  quote_created_date?: Maybe<Scalars['timestamptz']>;
  quote_expires_on?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  quote_line_groups: Array<Quote_Line_Group>;
  /** An aggregate relationship */
  quote_line_groups_aggregate: Quote_Line_Group_Aggregate;
  /** An array relationship */
  quote_lines: Array<Quote_Line>;
  /** An aggregate relationship */
  quote_lines_aggregate: Quote_Line_Aggregate;
  quote_number: Scalars['String'];
  quote_totals_net_amount?: Maybe<Scalars['numeric']>;
  quote_type?: Maybe<Scalars['String']>;
  record_type?: Maybe<Scalars['String']>;
  renewal_term?: Maybe<Scalars['float8']>;
  renewal_uplift?: Maybe<Scalars['float8']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_id: Scalars['String'];
  salesforce_opportunity_id?: Maybe<Scalars['String']>;
  ship_to_city?: Maybe<Scalars['String']>;
  ship_to_country?: Maybe<Scalars['String']>;
  ship_to_name?: Maybe<Scalars['String']>;
  ship_to_postal_code?: Maybe<Scalars['String']>;
  ship_to_state?: Maybe<Scalars['String']>;
  ship_to_street?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  subscription_term?: Maybe<Scalars['float8']>;
  territory?: Maybe<Scalars['String']>;
  territory_text_1?: Maybe<Scalars['String']>;
  territory_text_2?: Maybe<Scalars['String']>;
  variable_recurring?: Maybe<Scalars['String']>;
};


/** columns and relationships of "quote" */
export type QuoteOrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "quote" */
export type QuoteOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "quote" */
export type QuoteQuote_Line_GroupsArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Group_Order_By>>;
  where?: InputMaybe<Quote_Line_Group_Bool_Exp>;
};


/** columns and relationships of "quote" */
export type QuoteQuote_Line_Groups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Group_Order_By>>;
  where?: InputMaybe<Quote_Line_Group_Bool_Exp>;
};


/** columns and relationships of "quote" */
export type QuoteQuote_LinesArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Order_By>>;
  where?: InputMaybe<Quote_Line_Bool_Exp>;
};


/** columns and relationships of "quote" */
export type QuoteQuote_Lines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Order_By>>;
  where?: InputMaybe<Quote_Line_Bool_Exp>;
};

/** aggregated selection of "quote" */
export type Quote_Aggregate = {
  __typename?: 'quote_aggregate';
  aggregate?: Maybe<Quote_Aggregate_Fields>;
  nodes: Array<Quote>;
};

export type Quote_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Quote_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Quote_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Quote_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Quote_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Quote_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Quote_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Quote_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Quote_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Quote_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Quote_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Quote_Aggregate_Bool_Exp_Var_Samp>;
};

export type Quote_Aggregate_Bool_Exp_Avg = {
  arguments: Quote_Select_Column_Quote_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Aggregate_Bool_Exp_Bool_And = {
  arguments: Quote_Select_Column_Quote_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quote_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Quote_Select_Column_Quote_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quote_Aggregate_Bool_Exp_Corr = {
  arguments: Quote_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Quote_Select_Column_Quote_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Quote_Select_Column_Quote_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Quote_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Quote_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Quote_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Quote_Select_Column_Quote_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Quote_Select_Column_Quote_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Quote_Aggregate_Bool_Exp_Max = {
  arguments: Quote_Select_Column_Quote_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Aggregate_Bool_Exp_Min = {
  arguments: Quote_Select_Column_Quote_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Quote_Select_Column_Quote_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Aggregate_Bool_Exp_Sum = {
  arguments: Quote_Select_Column_Quote_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Quote_Select_Column_Quote_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "quote" */
export type Quote_Aggregate_Fields = {
  __typename?: 'quote_aggregate_fields';
  avg?: Maybe<Quote_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Quote_Max_Fields>;
  min?: Maybe<Quote_Min_Fields>;
  stddev?: Maybe<Quote_Stddev_Fields>;
  stddev_pop?: Maybe<Quote_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quote_Stddev_Samp_Fields>;
  sum?: Maybe<Quote_Sum_Fields>;
  var_pop?: Maybe<Quote_Var_Pop_Fields>;
  var_samp?: Maybe<Quote_Var_Samp_Fields>;
  variance?: Maybe<Quote_Variance_Fields>;
};


/** aggregate fields of "quote" */
export type Quote_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "quote" */
export type Quote_Aggregate_Order_By = {
  avg?: InputMaybe<Quote_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quote_Max_Order_By>;
  min?: InputMaybe<Quote_Min_Order_By>;
  stddev?: InputMaybe<Quote_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quote_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quote_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quote_Sum_Order_By>;
  var_pop?: InputMaybe<Quote_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quote_Var_Samp_Order_By>;
  variance?: InputMaybe<Quote_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Quote_Avg_Fields = {
  __typename?: 'quote_avg_fields';
  additional_discount_amount?: Maybe<Scalars['Float']>;
  annual_contract_value?: Maybe<Scalars['Float']>;
  avg_customer_discount?: Maybe<Scalars['Float']>;
  deposit_fee?: Maybe<Scalars['Float']>;
  estimated_cdn_consumption_fees?: Maybe<Scalars['Float']>;
  initial_fees?: Maybe<Scalars['Float']>;
  lifetime_contract_value?: Maybe<Scalars['Float']>;
  max_discount_rate?: Maybe<Scalars['Float']>;
  monthly_fees?: Maybe<Scalars['Float']>;
  net_amount?: Maybe<Scalars['Float']>;
  no_of_months_deposit?: Maybe<Scalars['Float']>;
  original_quote_monthly_fees?: Maybe<Scalars['Float']>;
  quote_totals_net_amount?: Maybe<Scalars['Float']>;
  renewal_term?: Maybe<Scalars['Float']>;
  renewal_uplift?: Maybe<Scalars['Float']>;
  subscription_term?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "quote" */
export type Quote_Avg_Order_By = {
  additional_discount_amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  avg_customer_discount?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  estimated_cdn_consumption_fees?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  max_discount_rate?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  no_of_months_deposit?: InputMaybe<Order_By>;
  original_quote_monthly_fees?: InputMaybe<Order_By>;
  quote_totals_net_amount?: InputMaybe<Order_By>;
  renewal_term?: InputMaybe<Order_By>;
  renewal_uplift?: InputMaybe<Order_By>;
  subscription_term?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quote". All fields are combined with a logical 'AND'. */
export type Quote_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Bool_Exp>>;
  _not?: InputMaybe<Quote_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Bool_Exp>>;
  accepted_date_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  accepted_quote_actions?: InputMaybe<Boolean_Comparison_Exp>;
  additional_discount_amount?: InputMaybe<Numeric_Comparison_Exp>;
  annual_contract_value?: InputMaybe<Numeric_Comparison_Exp>;
  avg_customer_discount?: InputMaybe<Float8_Comparison_Exp>;
  bill_to_city?: InputMaybe<String_Comparison_Exp>;
  bill_to_country?: InputMaybe<String_Comparison_Exp>;
  bill_to_name?: InputMaybe<String_Comparison_Exp>;
  bill_to_postal_code?: InputMaybe<String_Comparison_Exp>;
  bill_to_state?: InputMaybe<String_Comparison_Exp>;
  bill_to_street?: InputMaybe<String_Comparison_Exp>;
  create_order_without_signed_so?: InputMaybe<Boolean_Comparison_Exp>;
  customer?: InputMaybe<Customer_Bool_Exp>;
  deposit?: InputMaybe<String_Comparison_Exp>;
  deposit_fee?: InputMaybe<Numeric_Comparison_Exp>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  estimated_cdn_consumption_fees?: InputMaybe<Numeric_Comparison_Exp>;
  exclude_distribution_partners?: InputMaybe<String_Comparison_Exp>;
  fixed_recurring?: InputMaybe<String_Comparison_Exp>;
  go_live_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  group_line_items?: InputMaybe<Boolean_Comparison_Exp>;
  initial_fees?: InputMaybe<Numeric_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  lifetime_contract_value?: InputMaybe<Numeric_Comparison_Exp>;
  max_discount_rate?: InputMaybe<Float8_Comparison_Exp>;
  monthly_fees?: InputMaybe<Numeric_Comparison_Exp>;
  msa_quote?: InputMaybe<String_Comparison_Exp>;
  msa_quote_type?: InputMaybe<String_Comparison_Exp>;
  net_amount?: InputMaybe<Numeric_Comparison_Exp>;
  no_of_months_deposit?: InputMaybe<Float8_Comparison_Exp>;
  one_time?: InputMaybe<String_Comparison_Exp>;
  opportunity?: InputMaybe<Opportunity_Bool_Exp>;
  ordered_quote_actions?: InputMaybe<Boolean_Comparison_Exp>;
  orders?: InputMaybe<Order_Bool_Exp>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Bool_Exp>;
  original_quote_monthly_fees?: InputMaybe<Float8_Comparison_Exp>;
  primary_contact?: InputMaybe<String_Comparison_Exp>;
  primary_quote_actions?: InputMaybe<Boolean_Comparison_Exp>;
  print_line_items?: InputMaybe<Boolean_Comparison_Exp>;
  quote_accepted_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  quote_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  quote_expires_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  quote_line_groups?: InputMaybe<Quote_Line_Group_Bool_Exp>;
  quote_line_groups_aggregate?: InputMaybe<Quote_Line_Group_Aggregate_Bool_Exp>;
  quote_lines?: InputMaybe<Quote_Line_Bool_Exp>;
  quote_lines_aggregate?: InputMaybe<Quote_Line_Aggregate_Bool_Exp>;
  quote_number?: InputMaybe<String_Comparison_Exp>;
  quote_totals_net_amount?: InputMaybe<Numeric_Comparison_Exp>;
  quote_type?: InputMaybe<String_Comparison_Exp>;
  record_type?: InputMaybe<String_Comparison_Exp>;
  renewal_term?: InputMaybe<Float8_Comparison_Exp>;
  renewal_uplift?: InputMaybe<Float8_Comparison_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_opportunity_id?: InputMaybe<String_Comparison_Exp>;
  ship_to_city?: InputMaybe<String_Comparison_Exp>;
  ship_to_country?: InputMaybe<String_Comparison_Exp>;
  ship_to_name?: InputMaybe<String_Comparison_Exp>;
  ship_to_postal_code?: InputMaybe<String_Comparison_Exp>;
  ship_to_state?: InputMaybe<String_Comparison_Exp>;
  ship_to_street?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subscription_term?: InputMaybe<Float8_Comparison_Exp>;
  territory?: InputMaybe<String_Comparison_Exp>;
  territory_text_1?: InputMaybe<String_Comparison_Exp>;
  territory_text_2?: InputMaybe<String_Comparison_Exp>;
  variable_recurring?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "quote_line" */
export type Quote_Line = {
  __typename?: 'quote_line';
  SST_integration_error_message?: Maybe<Scalars['String']>;
  SST_integration_status?: Maybe<Scalars['String']>;
  SST_jira_parent_ticket?: Maybe<Scalars['String']>;
  SST_jira_ticket?: Maybe<Scalars['String']>;
  additional_discount?: Maybe<Scalars['numeric']>;
  additional_discount_percentage?: Maybe<Scalars['float8']>;
  additional_discount_unit?: Maybe<Scalars['String']>;
  ads_plus_certified?: Maybe<Scalars['String']>;
  adsplus_deal_type?: Maybe<Scalars['String']>;
  adsplus_percent_of_total?: Maybe<Scalars['float8']>;
  adsplus_revenue_share?: Maybe<Scalars['float8']>;
  amagi_ad_tag_provided_by?: Maybe<Scalars['String']>;
  amagi_ads_monetised_backfill?: Maybe<Scalars['String']>;
  amagi_ads_monetised_primary?: Maybe<Scalars['String']>;
  amagi_adsplus_revenue_share?: Maybe<Scalars['float8']>;
  amagi_percentage_of_inventory?: Maybe<Scalars['float8']>;
  approvals_quantity?: Maybe<Scalars['float8']>;
  billable_unit_price?: Maybe<Scalars['numeric']>;
  billing_type?: Maybe<Scalars['String']>;
  bundled: Scalars['Boolean'];
  cdn_tagging?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  /** An object relationship */
  channel_details?: Maybe<Channel>;
  charge_type?: Maybe<Scalars['String']>;
  churn_type?: Maybe<Scalars['String']>;
  compound_discount?: Maybe<Scalars['float8']>;
  connect_distribution_model?: Maybe<Scalars['String']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  content_partner_ad_tag_provided_by?: Maybe<Scalars['String']>;
  content_partner_ads_monetised_backfill?: Maybe<Scalars['String']>;
  content_partner_ads_monetised_primary?: Maybe<Scalars['String']>;
  content_partner_ads_plus_commission_percentage?: Maybe<Scalars['float8']>;
  contracted_price?: Maybe<Scalars['float8']>;
  cost_editable?: Maybe<Scalars['Boolean']>;
  cpm?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customer_churn_request?: Maybe<Scalars['String']>;
  customer_percentage_of_inventory?: Maybe<Scalars['float8']>;
  customer_total?: Maybe<Scalars['numeric']>;
  customer_unit_price?: Maybe<Scalars['numeric']>;
  default_subscription_term?: Maybe<Scalars['String']>;
  delivery_tier?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discount_schedule?: Maybe<Scalars['String']>;
  discount_tier?: Maybe<Scalars['String']>;
  effective_end_date?: Maybe<Scalars['timestamptz']>;
  effective_start_date?: Maybe<Scalars['timestamptz']>;
  effective_subscription_term?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  group?: Maybe<Scalars['String']>;
  guidance?: Maybe<Scalars['float8']>;
  hidden?: Maybe<Scalars['Boolean']>;
  inventory_share_amagi_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_amagi_primary_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_content_partner_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_content_partner_primary_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_platform_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_platform_primary_ad_tag?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  line_name: Scalars['String'];
  list_total?: Maybe<Scalars['numeric']>;
  list_unit_price?: Maybe<Scalars['numeric']>;
  markup?: Maybe<Scalars['numeric']>;
  max_deductions?: Maybe<Scalars['float8']>;
  net_mrr?: Maybe<Scalars['numeric']>;
  net_total?: Maybe<Scalars['numeric']>;
  net_unit_price?: Maybe<Scalars['float8']>;
  non_discountable?: Maybe<Scalars['Boolean']>;
  non_partner_discountable: Scalars['Boolean'];
  number?: Maybe<Scalars['float8']>;
  number_of_months_deposit?: Maybe<Scalars['float8']>;
  option_discount?: Maybe<Scalars['float8']>;
  other_churn_reason?: Maybe<Scalars['String']>;
  package_cost?: Maybe<Scalars['numeric']>;
  package_list_total?: Maybe<Scalars['numeric']>;
  package_total?: Maybe<Scalars['numeric']>;
  partner_discount?: Maybe<Scalars['String']>;
  percent_of_total?: Maybe<Scalars['float8']>;
  percent_of_total_base?: Maybe<Scalars['String']>;
  percent_of_total_percentage?: Maybe<Scalars['float8']>;
  percent_of_total_scope?: Maybe<Scalars['float8']>;
  /** An object relationship */
  platform?: Maybe<Platform>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  platform_ad_tag_provided_by?: Maybe<Scalars['String']>;
  platform_ads_monetised_backfill?: Maybe<Scalars['String']>;
  platform_ads_monetised_primary?: Maybe<Scalars['String']>;
  platform_ads_plus_commission_percentage?: Maybe<Scalars['float8']>;
  platform_model?: Maybe<Scalars['String']>;
  platform_percentage_of_inventory?: Maybe<Scalars['float8']>;
  preferred_business_model?: Maybe<Scalars['String']>;
  previous_segment_regular_price?: Maybe<Scalars['numeric']>;
  previous_segment_uplift?: Maybe<Scalars['numeric']>;
  price_dimension?: Maybe<Scalars['String']>;
  price_editable?: Maybe<Scalars['Boolean']>;
  pricing_information_unit_net_price?: Maybe<Scalars['float8']>;
  pricing_method?: Maybe<Scalars['String']>;
  pricing_method_editable?: Maybe<Scalars['Boolean']>;
  product_code?: Maybe<Scalars['String']>;
  /** An object relationship */
  product_details?: Maybe<Product>;
  product_name?: Maybe<Scalars['String']>;
  product_option?: Maybe<Scalars['String']>;
  prorate_amount_discount?: Maybe<Scalars['float8']>;
  prorate_multiplier?: Maybe<Scalars['float8']>;
  prorated_list_price?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['float8']>;
  /** An object relationship */
  quote: Quote;
  /** An array relationship */
  quote_line_consumption_schedules: Array<Quote_Line_Consumption_Schedule>;
  /** An aggregate relationship */
  quote_line_consumption_schedules_aggregate: Quote_Line_Consumption_Schedule_Aggregate;
  regular_unit_price?: Maybe<Scalars['numeric']>;
  renewal?: Maybe<Scalars['Boolean']>;
  renewed_subscription?: Maybe<Scalars['String']>;
  revenue_share_backfill_ad_tag?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_backfill?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_primary?: Maybe<Scalars['String']>;
  revenue_share_primary_ad_tag?: Maybe<Scalars['String']>;
  salesforce_id: Scalars['String'];
  salesforce_product_code?: Maybe<Scalars['String']>;
  salesforce_quote_id: Scalars['String'];
  segment_index?: Maybe<Scalars['numeric']>;
  segment_key?: Maybe<Scalars['String']>;
  segment_label?: Maybe<Scalars['String']>;
  so_po_ref_number?: Maybe<Scalars['String']>;
  special_price?: Maybe<Scalars['numeric']>;
  special_price_description?: Maybe<Scalars['String']>;
  special_price_type?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  subscription_pricing?: Maybe<Scalars['String']>;
  subscription_type?: Maybe<Scalars['String']>;
  term_discount?: Maybe<Scalars['String']>;
  term_discount_schedule?: Maybe<Scalars['String']>;
  total_discount?: Maybe<Scalars['numeric']>;
  total_discount_percentage?: Maybe<Scalars['float8']>;
  ts_account?: Maybe<Scalars['String']>;
  unit_cost?: Maybe<Scalars['numeric']>;
  unit_net_price?: Maybe<Scalars['numeric']>;
  unprorated_net_price?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  volume_discount?: Maybe<Scalars['String']>;
  who_pays?: Maybe<Scalars['String']>;
};


/** columns and relationships of "quote_line" */
export type Quote_LineQuote_Line_Consumption_SchedulesArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Order_By>>;
  where?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
};


/** columns and relationships of "quote_line" */
export type Quote_LineQuote_Line_Consumption_Schedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Order_By>>;
  where?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
};

/** aggregated selection of "quote_line" */
export type Quote_Line_Aggregate = {
  __typename?: 'quote_line_aggregate';
  aggregate?: Maybe<Quote_Line_Aggregate_Fields>;
  nodes: Array<Quote_Line>;
};

export type Quote_Line_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Quote_Line_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Quote_Line_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Quote_Line_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Quote_Line_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Quote_Line_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Quote_Line_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Quote_Line_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Quote_Line_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Quote_Line_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Quote_Line_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Quote_Line_Aggregate_Bool_Exp_Var_Samp>;
};

export type Quote_Line_Aggregate_Bool_Exp_Avg = {
  arguments: Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Line_Aggregate_Bool_Exp_Bool_And = {
  arguments: Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quote_Line_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quote_Line_Aggregate_Bool_Exp_Corr = {
  arguments: Quote_Line_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Line_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Quote_Line_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quote_Line_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Quote_Line_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Quote_Line_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Line_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Quote_Line_Aggregate_Bool_Exp_Max = {
  arguments: Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Line_Aggregate_Bool_Exp_Min = {
  arguments: Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Line_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Line_Aggregate_Bool_Exp_Sum = {
  arguments: Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Line_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "quote_line" */
export type Quote_Line_Aggregate_Fields = {
  __typename?: 'quote_line_aggregate_fields';
  avg?: Maybe<Quote_Line_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Quote_Line_Max_Fields>;
  min?: Maybe<Quote_Line_Min_Fields>;
  stddev?: Maybe<Quote_Line_Stddev_Fields>;
  stddev_pop?: Maybe<Quote_Line_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quote_Line_Stddev_Samp_Fields>;
  sum?: Maybe<Quote_Line_Sum_Fields>;
  var_pop?: Maybe<Quote_Line_Var_Pop_Fields>;
  var_samp?: Maybe<Quote_Line_Var_Samp_Fields>;
  variance?: Maybe<Quote_Line_Variance_Fields>;
};


/** aggregate fields of "quote_line" */
export type Quote_Line_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Line_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "quote_line" */
export type Quote_Line_Aggregate_Order_By = {
  avg?: InputMaybe<Quote_Line_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quote_Line_Max_Order_By>;
  min?: InputMaybe<Quote_Line_Min_Order_By>;
  stddev?: InputMaybe<Quote_Line_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quote_Line_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quote_Line_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quote_Line_Sum_Order_By>;
  var_pop?: InputMaybe<Quote_Line_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quote_Line_Var_Samp_Order_By>;
  variance?: InputMaybe<Quote_Line_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Quote_Line_Avg_Fields = {
  __typename?: 'quote_line_avg_fields';
  additional_discount?: Maybe<Scalars['Float']>;
  additional_discount_percentage?: Maybe<Scalars['Float']>;
  adsplus_percent_of_total?: Maybe<Scalars['Float']>;
  adsplus_revenue_share?: Maybe<Scalars['Float']>;
  amagi_adsplus_revenue_share?: Maybe<Scalars['Float']>;
  amagi_percentage_of_inventory?: Maybe<Scalars['Float']>;
  approvals_quantity?: Maybe<Scalars['Float']>;
  billable_unit_price?: Maybe<Scalars['Float']>;
  compound_discount?: Maybe<Scalars['Float']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  content_partner_ads_plus_commission_percentage?: Maybe<Scalars['Float']>;
  contracted_price?: Maybe<Scalars['Float']>;
  customer_percentage_of_inventory?: Maybe<Scalars['Float']>;
  customer_total?: Maybe<Scalars['Float']>;
  customer_unit_price?: Maybe<Scalars['Float']>;
  effective_subscription_term?: Maybe<Scalars['Float']>;
  guidance?: Maybe<Scalars['Float']>;
  list_total?: Maybe<Scalars['Float']>;
  list_unit_price?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  max_deductions?: Maybe<Scalars['Float']>;
  net_mrr?: Maybe<Scalars['Float']>;
  net_total?: Maybe<Scalars['Float']>;
  net_unit_price?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
  number_of_months_deposit?: Maybe<Scalars['Float']>;
  option_discount?: Maybe<Scalars['Float']>;
  package_cost?: Maybe<Scalars['Float']>;
  package_list_total?: Maybe<Scalars['Float']>;
  package_total?: Maybe<Scalars['Float']>;
  percent_of_total?: Maybe<Scalars['Float']>;
  percent_of_total_percentage?: Maybe<Scalars['Float']>;
  percent_of_total_scope?: Maybe<Scalars['Float']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  platform_ads_plus_commission_percentage?: Maybe<Scalars['Float']>;
  platform_percentage_of_inventory?: Maybe<Scalars['Float']>;
  previous_segment_regular_price?: Maybe<Scalars['Float']>;
  previous_segment_uplift?: Maybe<Scalars['Float']>;
  pricing_information_unit_net_price?: Maybe<Scalars['Float']>;
  prorate_amount_discount?: Maybe<Scalars['Float']>;
  prorate_multiplier?: Maybe<Scalars['Float']>;
  prorated_list_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  regular_unit_price?: Maybe<Scalars['Float']>;
  segment_index?: Maybe<Scalars['Float']>;
  special_price?: Maybe<Scalars['Float']>;
  total_discount?: Maybe<Scalars['Float']>;
  total_discount_percentage?: Maybe<Scalars['Float']>;
  unit_cost?: Maybe<Scalars['Float']>;
  unit_net_price?: Maybe<Scalars['Float']>;
  unprorated_net_price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "quote_line" */
export type Quote_Line_Avg_Order_By = {
  additional_discount?: InputMaybe<Order_By>;
  additional_discount_percentage?: InputMaybe<Order_By>;
  adsplus_percent_of_total?: InputMaybe<Order_By>;
  adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_percentage_of_inventory?: InputMaybe<Order_By>;
  approvals_quantity?: InputMaybe<Order_By>;
  billable_unit_price?: InputMaybe<Order_By>;
  compound_discount?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  content_partner_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  contracted_price?: InputMaybe<Order_By>;
  customer_percentage_of_inventory?: InputMaybe<Order_By>;
  customer_total?: InputMaybe<Order_By>;
  customer_unit_price?: InputMaybe<Order_By>;
  effective_subscription_term?: InputMaybe<Order_By>;
  guidance?: InputMaybe<Order_By>;
  list_total?: InputMaybe<Order_By>;
  list_unit_price?: InputMaybe<Order_By>;
  markup?: InputMaybe<Order_By>;
  max_deductions?: InputMaybe<Order_By>;
  net_mrr?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  net_unit_price?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_of_months_deposit?: InputMaybe<Order_By>;
  option_discount?: InputMaybe<Order_By>;
  package_cost?: InputMaybe<Order_By>;
  package_list_total?: InputMaybe<Order_By>;
  package_total?: InputMaybe<Order_By>;
  percent_of_total?: InputMaybe<Order_By>;
  percent_of_total_percentage?: InputMaybe<Order_By>;
  percent_of_total_scope?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  platform_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  platform_percentage_of_inventory?: InputMaybe<Order_By>;
  previous_segment_regular_price?: InputMaybe<Order_By>;
  previous_segment_uplift?: InputMaybe<Order_By>;
  pricing_information_unit_net_price?: InputMaybe<Order_By>;
  prorate_amount_discount?: InputMaybe<Order_By>;
  prorate_multiplier?: InputMaybe<Order_By>;
  prorated_list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  regular_unit_price?: InputMaybe<Order_By>;
  segment_index?: InputMaybe<Order_By>;
  special_price?: InputMaybe<Order_By>;
  total_discount?: InputMaybe<Order_By>;
  total_discount_percentage?: InputMaybe<Order_By>;
  unit_cost?: InputMaybe<Order_By>;
  unit_net_price?: InputMaybe<Order_By>;
  unprorated_net_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quote_line". All fields are combined with a logical 'AND'. */
export type Quote_Line_Bool_Exp = {
  SST_integration_error_message?: InputMaybe<String_Comparison_Exp>;
  SST_integration_status?: InputMaybe<String_Comparison_Exp>;
  SST_jira_parent_ticket?: InputMaybe<String_Comparison_Exp>;
  SST_jira_ticket?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<Quote_Line_Bool_Exp>>;
  _not?: InputMaybe<Quote_Line_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Line_Bool_Exp>>;
  additional_discount?: InputMaybe<Numeric_Comparison_Exp>;
  additional_discount_percentage?: InputMaybe<Float8_Comparison_Exp>;
  additional_discount_unit?: InputMaybe<String_Comparison_Exp>;
  ads_plus_certified?: InputMaybe<String_Comparison_Exp>;
  adsplus_deal_type?: InputMaybe<String_Comparison_Exp>;
  adsplus_percent_of_total?: InputMaybe<Float8_Comparison_Exp>;
  adsplus_revenue_share?: InputMaybe<Float8_Comparison_Exp>;
  amagi_ad_tag_provided_by?: InputMaybe<String_Comparison_Exp>;
  amagi_ads_monetised_backfill?: InputMaybe<String_Comparison_Exp>;
  amagi_ads_monetised_primary?: InputMaybe<String_Comparison_Exp>;
  amagi_adsplus_revenue_share?: InputMaybe<Float8_Comparison_Exp>;
  amagi_percentage_of_inventory?: InputMaybe<Float8_Comparison_Exp>;
  approvals_quantity?: InputMaybe<Float8_Comparison_Exp>;
  billable_unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  billing_type?: InputMaybe<String_Comparison_Exp>;
  bundled?: InputMaybe<Boolean_Comparison_Exp>;
  cdn_tagging?: InputMaybe<String_Comparison_Exp>;
  channel?: InputMaybe<String_Comparison_Exp>;
  channel_details?: InputMaybe<Channel_Bool_Exp>;
  charge_type?: InputMaybe<String_Comparison_Exp>;
  churn_type?: InputMaybe<String_Comparison_Exp>;
  compound_discount?: InputMaybe<Float8_Comparison_Exp>;
  connect_distribution_model?: InputMaybe<String_Comparison_Exp>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Numeric_Comparison_Exp>;
  content_partner_ad_tag_provided_by?: InputMaybe<String_Comparison_Exp>;
  content_partner_ads_monetised_backfill?: InputMaybe<String_Comparison_Exp>;
  content_partner_ads_monetised_primary?: InputMaybe<String_Comparison_Exp>;
  content_partner_ads_plus_commission_percentage?: InputMaybe<Float8_Comparison_Exp>;
  contracted_price?: InputMaybe<Float8_Comparison_Exp>;
  cost_editable?: InputMaybe<Boolean_Comparison_Exp>;
  cpm?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  customer_churn_request?: InputMaybe<String_Comparison_Exp>;
  customer_percentage_of_inventory?: InputMaybe<Float8_Comparison_Exp>;
  customer_total?: InputMaybe<Numeric_Comparison_Exp>;
  customer_unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  default_subscription_term?: InputMaybe<String_Comparison_Exp>;
  delivery_tier?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discount_schedule?: InputMaybe<String_Comparison_Exp>;
  discount_tier?: InputMaybe<String_Comparison_Exp>;
  effective_end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  effective_start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  effective_subscription_term?: InputMaybe<Float8_Comparison_Exp>;
  end_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  group?: InputMaybe<String_Comparison_Exp>;
  guidance?: InputMaybe<Float8_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  inventory_share_amagi_backfill_ad_tag?: InputMaybe<String_Comparison_Exp>;
  inventory_share_amagi_primary_ad_tag?: InputMaybe<String_Comparison_Exp>;
  inventory_share_content_partner_backfill_ad_tag?: InputMaybe<String_Comparison_Exp>;
  inventory_share_content_partner_primary_ad_tag?: InputMaybe<String_Comparison_Exp>;
  inventory_share_platform_backfill_ad_tag?: InputMaybe<String_Comparison_Exp>;
  inventory_share_platform_primary_ad_tag?: InputMaybe<String_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  line_name?: InputMaybe<String_Comparison_Exp>;
  list_total?: InputMaybe<Numeric_Comparison_Exp>;
  list_unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  markup?: InputMaybe<Numeric_Comparison_Exp>;
  max_deductions?: InputMaybe<Float8_Comparison_Exp>;
  net_mrr?: InputMaybe<Numeric_Comparison_Exp>;
  net_total?: InputMaybe<Numeric_Comparison_Exp>;
  net_unit_price?: InputMaybe<Float8_Comparison_Exp>;
  non_discountable?: InputMaybe<Boolean_Comparison_Exp>;
  non_partner_discountable?: InputMaybe<Boolean_Comparison_Exp>;
  number?: InputMaybe<Float8_Comparison_Exp>;
  number_of_months_deposit?: InputMaybe<Float8_Comparison_Exp>;
  option_discount?: InputMaybe<Float8_Comparison_Exp>;
  other_churn_reason?: InputMaybe<String_Comparison_Exp>;
  package_cost?: InputMaybe<Numeric_Comparison_Exp>;
  package_list_total?: InputMaybe<Numeric_Comparison_Exp>;
  package_total?: InputMaybe<Numeric_Comparison_Exp>;
  partner_discount?: InputMaybe<String_Comparison_Exp>;
  percent_of_total?: InputMaybe<Float8_Comparison_Exp>;
  percent_of_total_base?: InputMaybe<String_Comparison_Exp>;
  percent_of_total_percentage?: InputMaybe<Float8_Comparison_Exp>;
  percent_of_total_scope?: InputMaybe<Float8_Comparison_Exp>;
  platform?: InputMaybe<Platform_Bool_Exp>;
  platform_ad_sales_commission_percentage?: InputMaybe<Numeric_Comparison_Exp>;
  platform_ad_tag_provided_by?: InputMaybe<String_Comparison_Exp>;
  platform_ads_monetised_backfill?: InputMaybe<String_Comparison_Exp>;
  platform_ads_monetised_primary?: InputMaybe<String_Comparison_Exp>;
  platform_ads_plus_commission_percentage?: InputMaybe<Float8_Comparison_Exp>;
  platform_model?: InputMaybe<String_Comparison_Exp>;
  platform_percentage_of_inventory?: InputMaybe<Float8_Comparison_Exp>;
  preferred_business_model?: InputMaybe<String_Comparison_Exp>;
  previous_segment_regular_price?: InputMaybe<Numeric_Comparison_Exp>;
  previous_segment_uplift?: InputMaybe<Numeric_Comparison_Exp>;
  price_dimension?: InputMaybe<String_Comparison_Exp>;
  price_editable?: InputMaybe<Boolean_Comparison_Exp>;
  pricing_information_unit_net_price?: InputMaybe<Float8_Comparison_Exp>;
  pricing_method?: InputMaybe<String_Comparison_Exp>;
  pricing_method_editable?: InputMaybe<Boolean_Comparison_Exp>;
  product_code?: InputMaybe<String_Comparison_Exp>;
  product_details?: InputMaybe<Product_Bool_Exp>;
  product_name?: InputMaybe<String_Comparison_Exp>;
  product_option?: InputMaybe<String_Comparison_Exp>;
  prorate_amount_discount?: InputMaybe<Float8_Comparison_Exp>;
  prorate_multiplier?: InputMaybe<Float8_Comparison_Exp>;
  prorated_list_price?: InputMaybe<Numeric_Comparison_Exp>;
  quantity?: InputMaybe<Float8_Comparison_Exp>;
  quote?: InputMaybe<Quote_Bool_Exp>;
  quote_line_consumption_schedules?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
  quote_line_consumption_schedules_aggregate?: InputMaybe<Quote_Line_Consumption_Schedule_Aggregate_Bool_Exp>;
  regular_unit_price?: InputMaybe<Numeric_Comparison_Exp>;
  renewal?: InputMaybe<Boolean_Comparison_Exp>;
  renewed_subscription?: InputMaybe<String_Comparison_Exp>;
  revenue_share_backfill_ad_tag?: InputMaybe<String_Comparison_Exp>;
  revenue_share_monetised_by_backfill?: InputMaybe<String_Comparison_Exp>;
  revenue_share_monetised_by_primary?: InputMaybe<String_Comparison_Exp>;
  revenue_share_primary_ad_tag?: InputMaybe<String_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_product_code?: InputMaybe<String_Comparison_Exp>;
  salesforce_quote_id?: InputMaybe<String_Comparison_Exp>;
  segment_index?: InputMaybe<Numeric_Comparison_Exp>;
  segment_key?: InputMaybe<String_Comparison_Exp>;
  segment_label?: InputMaybe<String_Comparison_Exp>;
  so_po_ref_number?: InputMaybe<String_Comparison_Exp>;
  special_price?: InputMaybe<Numeric_Comparison_Exp>;
  special_price_description?: InputMaybe<String_Comparison_Exp>;
  special_price_type?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  subscription_pricing?: InputMaybe<String_Comparison_Exp>;
  subscription_type?: InputMaybe<String_Comparison_Exp>;
  term_discount?: InputMaybe<String_Comparison_Exp>;
  term_discount_schedule?: InputMaybe<String_Comparison_Exp>;
  total_discount?: InputMaybe<Numeric_Comparison_Exp>;
  total_discount_percentage?: InputMaybe<Float8_Comparison_Exp>;
  ts_account?: InputMaybe<String_Comparison_Exp>;
  unit_cost?: InputMaybe<Numeric_Comparison_Exp>;
  unit_net_price?: InputMaybe<Numeric_Comparison_Exp>;
  unprorated_net_price?: InputMaybe<Numeric_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  volume_discount?: InputMaybe<String_Comparison_Exp>;
  who_pays?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule = {
  __typename?: 'quote_line_consumption_schedule';
  billing_term?: Maybe<Scalars['numeric']>;
  billing_term_unit?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  /** An object relationship */
  consumption_schedule?: Maybe<Consumption_Schedule>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  matching_attribute?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  quote_line?: Maybe<Quote_Line>;
  rating_method?: Maybe<Scalars['String']>;
  salesforce_consumption_schedule_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_quote_line_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unit_of_measure?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Aggregate = {
  __typename?: 'quote_line_consumption_schedule_aggregate';
  aggregate?: Maybe<Quote_Line_Consumption_Schedule_Aggregate_Fields>;
  nodes: Array<Quote_Line_Consumption_Schedule>;
};

export type Quote_Line_Consumption_Schedule_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Quote_Line_Consumption_Schedule_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Quote_Line_Consumption_Schedule_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Quote_Line_Consumption_Schedule_Aggregate_Bool_Exp_Count>;
};

export type Quote_Line_Consumption_Schedule_Aggregate_Bool_Exp_Bool_And = {
  arguments: Quote_Line_Consumption_Schedule_Select_Column_Quote_Line_Consumption_Schedule_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quote_Line_Consumption_Schedule_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Quote_Line_Consumption_Schedule_Select_Column_Quote_Line_Consumption_Schedule_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quote_Line_Consumption_Schedule_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Aggregate_Fields = {
  __typename?: 'quote_line_consumption_schedule_aggregate_fields';
  avg?: Maybe<Quote_Line_Consumption_Schedule_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Quote_Line_Consumption_Schedule_Max_Fields>;
  min?: Maybe<Quote_Line_Consumption_Schedule_Min_Fields>;
  stddev?: Maybe<Quote_Line_Consumption_Schedule_Stddev_Fields>;
  stddev_pop?: Maybe<Quote_Line_Consumption_Schedule_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quote_Line_Consumption_Schedule_Stddev_Samp_Fields>;
  sum?: Maybe<Quote_Line_Consumption_Schedule_Sum_Fields>;
  var_pop?: Maybe<Quote_Line_Consumption_Schedule_Var_Pop_Fields>;
  var_samp?: Maybe<Quote_Line_Consumption_Schedule_Var_Samp_Fields>;
  variance?: Maybe<Quote_Line_Consumption_Schedule_Variance_Fields>;
};


/** aggregate fields of "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Aggregate_Order_By = {
  avg?: InputMaybe<Quote_Line_Consumption_Schedule_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quote_Line_Consumption_Schedule_Max_Order_By>;
  min?: InputMaybe<Quote_Line_Consumption_Schedule_Min_Order_By>;
  stddev?: InputMaybe<Quote_Line_Consumption_Schedule_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quote_Line_Consumption_Schedule_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quote_Line_Consumption_Schedule_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quote_Line_Consumption_Schedule_Sum_Order_By>;
  var_pop?: InputMaybe<Quote_Line_Consumption_Schedule_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quote_Line_Consumption_Schedule_Var_Samp_Order_By>;
  variance?: InputMaybe<Quote_Line_Consumption_Schedule_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Quote_Line_Consumption_Schedule_Avg_Fields = {
  __typename?: 'quote_line_consumption_schedule_avg_fields';
  billing_term?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Avg_Order_By = {
  billing_term?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quote_line_consumption_schedule". All fields are combined with a logical 'AND'. */
export type Quote_Line_Consumption_Schedule_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Bool_Exp>>;
  _not?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Bool_Exp>>;
  billing_term?: InputMaybe<Numeric_Comparison_Exp>;
  billing_term_unit?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  consumption_schedule?: InputMaybe<Consumption_Schedule_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency_iso_code?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  matching_attribute?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  quote_line?: InputMaybe<Quote_Line_Bool_Exp>;
  rating_method?: InputMaybe<String_Comparison_Exp>;
  salesforce_consumption_schedule_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_quote_line_id?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  unit_of_measure?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Quote_Line_Consumption_Schedule_Max_Fields = {
  __typename?: 'quote_line_consumption_schedule_max_fields';
  billing_term?: Maybe<Scalars['numeric']>;
  billing_term_unit?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  matching_attribute?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rating_method?: Maybe<Scalars['String']>;
  salesforce_consumption_schedule_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_quote_line_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unit_of_measure?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Max_Order_By = {
  billing_term?: InputMaybe<Order_By>;
  billing_term_unit?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_iso_code?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  matching_attribute?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rating_method?: InputMaybe<Order_By>;
  salesforce_consumption_schedule_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_quote_line_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unit_of_measure?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quote_Line_Consumption_Schedule_Min_Fields = {
  __typename?: 'quote_line_consumption_schedule_min_fields';
  billing_term?: Maybe<Scalars['numeric']>;
  billing_term_unit?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currency_iso_code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  matching_attribute?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  rating_method?: Maybe<Scalars['String']>;
  salesforce_consumption_schedule_id?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  salesforce_quote_line_id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unit_of_measure?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Min_Order_By = {
  billing_term?: InputMaybe<Order_By>;
  billing_term_unit?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_iso_code?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  matching_attribute?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  rating_method?: InputMaybe<Order_By>;
  salesforce_consumption_schedule_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_quote_line_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unit_of_measure?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "quote_line_consumption_schedule". */
export type Quote_Line_Consumption_Schedule_Order_By = {
  billing_term?: InputMaybe<Order_By>;
  billing_term_unit?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  consumption_schedule?: InputMaybe<Consumption_Schedule_Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency_iso_code?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  matching_attribute?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  quote_line?: InputMaybe<Quote_Line_Order_By>;
  rating_method?: InputMaybe<Order_By>;
  salesforce_consumption_schedule_id?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  salesforce_quote_line_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  unit_of_measure?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "quote_line_consumption_schedule" */
export enum Quote_Line_Consumption_Schedule_Select_Column {
  /** column name */
  BillingTerm = 'billing_term',
  /** column name */
  BillingTermUnit = 'billing_term_unit',
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrencyIsoCode = 'currency_iso_code',
  /** column name */
  Description = 'description',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  MatchingAttribute = 'matching_attribute',
  /** column name */
  Name = 'name',
  /** column name */
  RatingMethod = 'rating_method',
  /** column name */
  SalesforceConsumptionScheduleId = 'salesforce_consumption_schedule_id',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  SalesforceQuoteLineId = 'salesforce_quote_line_id',
  /** column name */
  Type = 'type',
  /** column name */
  UnitOfMeasure = 'unit_of_measure',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "quote_line_consumption_schedule_aggregate_bool_exp_bool_and_arguments_columns" columns of table "quote_line_consumption_schedule" */
export enum Quote_Line_Consumption_Schedule_Select_Column_Quote_Line_Consumption_Schedule_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "quote_line_consumption_schedule_aggregate_bool_exp_bool_or_arguments_columns" columns of table "quote_line_consumption_schedule" */
export enum Quote_Line_Consumption_Schedule_Select_Column_Quote_Line_Consumption_Schedule_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** aggregate stddev on columns */
export type Quote_Line_Consumption_Schedule_Stddev_Fields = {
  __typename?: 'quote_line_consumption_schedule_stddev_fields';
  billing_term?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Stddev_Order_By = {
  billing_term?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quote_Line_Consumption_Schedule_Stddev_Pop_Fields = {
  __typename?: 'quote_line_consumption_schedule_stddev_pop_fields';
  billing_term?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Stddev_Pop_Order_By = {
  billing_term?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quote_Line_Consumption_Schedule_Stddev_Samp_Fields = {
  __typename?: 'quote_line_consumption_schedule_stddev_samp_fields';
  billing_term?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Stddev_Samp_Order_By = {
  billing_term?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Line_Consumption_Schedule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Line_Consumption_Schedule_Stream_Cursor_Value_Input = {
  billing_term?: InputMaybe<Scalars['numeric']>;
  billing_term_unit?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currency_iso_code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  matching_attribute?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rating_method?: InputMaybe<Scalars['String']>;
  salesforce_consumption_schedule_id?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_quote_line_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unit_of_measure?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Quote_Line_Consumption_Schedule_Sum_Fields = {
  __typename?: 'quote_line_consumption_schedule_sum_fields';
  billing_term?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Sum_Order_By = {
  billing_term?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Quote_Line_Consumption_Schedule_Var_Pop_Fields = {
  __typename?: 'quote_line_consumption_schedule_var_pop_fields';
  billing_term?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Var_Pop_Order_By = {
  billing_term?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quote_Line_Consumption_Schedule_Var_Samp_Fields = {
  __typename?: 'quote_line_consumption_schedule_var_samp_fields';
  billing_term?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Var_Samp_Order_By = {
  billing_term?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quote_Line_Consumption_Schedule_Variance_Fields = {
  __typename?: 'quote_line_consumption_schedule_variance_fields';
  billing_term?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "quote_line_consumption_schedule" */
export type Quote_Line_Consumption_Schedule_Variance_Order_By = {
  billing_term?: InputMaybe<Order_By>;
};

/** columns and relationships of "quote_line_group" */
export type Quote_Line_Group = {
  __typename?: 'quote_line_group';
  channel_type?: Maybe<Scalars['String']>;
  group_name?: Maybe<Scalars['String']>;
  group_sequence_number?: Maybe<Scalars['float8']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  new_channel_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  quote: Quote;
  quote_process?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_id: Scalars['String'];
  salesforce_platform_model_id?: Maybe<Scalars['String']>;
  salesforce_quote_id: Scalars['String'];
};

/** aggregated selection of "quote_line_group" */
export type Quote_Line_Group_Aggregate = {
  __typename?: 'quote_line_group_aggregate';
  aggregate?: Maybe<Quote_Line_Group_Aggregate_Fields>;
  nodes: Array<Quote_Line_Group>;
};

export type Quote_Line_Group_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Quote_Line_Group_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Quote_Line_Group_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Quote_Line_Group_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Quote_Line_Group_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Quote_Line_Group_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Quote_Line_Group_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Quote_Line_Group_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Quote_Line_Group_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Quote_Line_Group_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Quote_Line_Group_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Quote_Line_Group_Aggregate_Bool_Exp_Var_Samp>;
};

export type Quote_Line_Group_Aggregate_Bool_Exp_Avg = {
  arguments: Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Group_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Line_Group_Aggregate_Bool_Exp_Bool_And = {
  arguments: Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Group_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quote_Line_Group_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Group_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Quote_Line_Group_Aggregate_Bool_Exp_Corr = {
  arguments: Quote_Line_Group_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Group_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Line_Group_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Quote_Line_Group_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Quote_Line_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Group_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Quote_Line_Group_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Quote_Line_Group_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Group_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Line_Group_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Quote_Line_Group_Aggregate_Bool_Exp_Max = {
  arguments: Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Group_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Line_Group_Aggregate_Bool_Exp_Min = {
  arguments: Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Group_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Line_Group_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Group_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Line_Group_Aggregate_Bool_Exp_Sum = {
  arguments: Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Group_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Quote_Line_Group_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Quote_Line_Group_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "quote_line_group" */
export type Quote_Line_Group_Aggregate_Fields = {
  __typename?: 'quote_line_group_aggregate_fields';
  avg?: Maybe<Quote_Line_Group_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Quote_Line_Group_Max_Fields>;
  min?: Maybe<Quote_Line_Group_Min_Fields>;
  stddev?: Maybe<Quote_Line_Group_Stddev_Fields>;
  stddev_pop?: Maybe<Quote_Line_Group_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Quote_Line_Group_Stddev_Samp_Fields>;
  sum?: Maybe<Quote_Line_Group_Sum_Fields>;
  var_pop?: Maybe<Quote_Line_Group_Var_Pop_Fields>;
  var_samp?: Maybe<Quote_Line_Group_Var_Samp_Fields>;
  variance?: Maybe<Quote_Line_Group_Variance_Fields>;
};


/** aggregate fields of "quote_line_group" */
export type Quote_Line_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Quote_Line_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "quote_line_group" */
export type Quote_Line_Group_Aggregate_Order_By = {
  avg?: InputMaybe<Quote_Line_Group_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Quote_Line_Group_Max_Order_By>;
  min?: InputMaybe<Quote_Line_Group_Min_Order_By>;
  stddev?: InputMaybe<Quote_Line_Group_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Quote_Line_Group_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Quote_Line_Group_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Quote_Line_Group_Sum_Order_By>;
  var_pop?: InputMaybe<Quote_Line_Group_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Quote_Line_Group_Var_Samp_Order_By>;
  variance?: InputMaybe<Quote_Line_Group_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Quote_Line_Group_Avg_Fields = {
  __typename?: 'quote_line_group_avg_fields';
  group_sequence_number?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "quote_line_group" */
export type Quote_Line_Group_Avg_Order_By = {
  group_sequence_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "quote_line_group". All fields are combined with a logical 'AND'. */
export type Quote_Line_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Quote_Line_Group_Bool_Exp>>;
  _not?: InputMaybe<Quote_Line_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Quote_Line_Group_Bool_Exp>>;
  channel_type?: InputMaybe<String_Comparison_Exp>;
  group_name?: InputMaybe<String_Comparison_Exp>;
  group_sequence_number?: InputMaybe<Float8_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  new_channel_name?: InputMaybe<String_Comparison_Exp>;
  quote?: InputMaybe<Quote_Bool_Exp>;
  quote_process?: InputMaybe<String_Comparison_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_channel_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_platform_model_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_quote_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Quote_Line_Group_Max_Fields = {
  __typename?: 'quote_line_group_max_fields';
  channel_type?: Maybe<Scalars['String']>;
  group_name?: Maybe<Scalars['String']>;
  group_sequence_number?: Maybe<Scalars['float8']>;
  new_channel_name?: Maybe<Scalars['String']>;
  quote_process?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_platform_model_id?: Maybe<Scalars['String']>;
  salesforce_quote_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "quote_line_group" */
export type Quote_Line_Group_Max_Order_By = {
  channel_type?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  group_sequence_number?: InputMaybe<Order_By>;
  new_channel_name?: InputMaybe<Order_By>;
  quote_process?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_platform_model_id?: InputMaybe<Order_By>;
  salesforce_quote_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quote_Line_Group_Min_Fields = {
  __typename?: 'quote_line_group_min_fields';
  channel_type?: Maybe<Scalars['String']>;
  group_name?: Maybe<Scalars['String']>;
  group_sequence_number?: Maybe<Scalars['float8']>;
  new_channel_name?: Maybe<Scalars['String']>;
  quote_process?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_channel_id?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_platform_model_id?: Maybe<Scalars['String']>;
  salesforce_quote_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "quote_line_group" */
export type Quote_Line_Group_Min_Order_By = {
  channel_type?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  group_sequence_number?: InputMaybe<Order_By>;
  new_channel_name?: InputMaybe<Order_By>;
  quote_process?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_platform_model_id?: InputMaybe<Order_By>;
  salesforce_quote_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "quote_line_group". */
export type Quote_Line_Group_Order_By = {
  channel_type?: InputMaybe<Order_By>;
  group_name?: InputMaybe<Order_By>;
  group_sequence_number?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  new_channel_name?: InputMaybe<Order_By>;
  quote?: InputMaybe<Quote_Order_By>;
  quote_process?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_channel_id?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_platform_model_id?: InputMaybe<Order_By>;
  salesforce_quote_id?: InputMaybe<Order_By>;
};

/** select columns of table "quote_line_group" */
export enum Quote_Line_Group_Select_Column {
  /** column name */
  ChannelType = 'channel_type',
  /** column name */
  GroupName = 'group_name',
  /** column name */
  GroupSequenceNumber = 'group_sequence_number',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  NewChannelName = 'new_channel_name',
  /** column name */
  QuoteProcess = 'quote_process',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SalesforceChannelId = 'salesforce_channel_id',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforcePlatformModelId = 'salesforce_platform_model_id',
  /** column name */
  SalesforceQuoteId = 'salesforce_quote_id'
}

/** select "quote_line_group_aggregate_bool_exp_avg_arguments_columns" columns of table "quote_line_group" */
export enum Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  GroupSequenceNumber = 'group_sequence_number'
}

/** select "quote_line_group_aggregate_bool_exp_bool_and_arguments_columns" columns of table "quote_line_group" */
export enum Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "quote_line_group_aggregate_bool_exp_bool_or_arguments_columns" columns of table "quote_line_group" */
export enum Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsDeleted = 'is_deleted'
}

/** select "quote_line_group_aggregate_bool_exp_corr_arguments_columns" columns of table "quote_line_group" */
export enum Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  GroupSequenceNumber = 'group_sequence_number'
}

/** select "quote_line_group_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "quote_line_group" */
export enum Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  GroupSequenceNumber = 'group_sequence_number'
}

/** select "quote_line_group_aggregate_bool_exp_max_arguments_columns" columns of table "quote_line_group" */
export enum Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  GroupSequenceNumber = 'group_sequence_number'
}

/** select "quote_line_group_aggregate_bool_exp_min_arguments_columns" columns of table "quote_line_group" */
export enum Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  GroupSequenceNumber = 'group_sequence_number'
}

/** select "quote_line_group_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "quote_line_group" */
export enum Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  GroupSequenceNumber = 'group_sequence_number'
}

/** select "quote_line_group_aggregate_bool_exp_sum_arguments_columns" columns of table "quote_line_group" */
export enum Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  GroupSequenceNumber = 'group_sequence_number'
}

/** select "quote_line_group_aggregate_bool_exp_var_samp_arguments_columns" columns of table "quote_line_group" */
export enum Quote_Line_Group_Select_Column_Quote_Line_Group_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  GroupSequenceNumber = 'group_sequence_number'
}

/** aggregate stddev on columns */
export type Quote_Line_Group_Stddev_Fields = {
  __typename?: 'quote_line_group_stddev_fields';
  group_sequence_number?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "quote_line_group" */
export type Quote_Line_Group_Stddev_Order_By = {
  group_sequence_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quote_Line_Group_Stddev_Pop_Fields = {
  __typename?: 'quote_line_group_stddev_pop_fields';
  group_sequence_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "quote_line_group" */
export type Quote_Line_Group_Stddev_Pop_Order_By = {
  group_sequence_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quote_Line_Group_Stddev_Samp_Fields = {
  __typename?: 'quote_line_group_stddev_samp_fields';
  group_sequence_number?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "quote_line_group" */
export type Quote_Line_Group_Stddev_Samp_Order_By = {
  group_sequence_number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quote_line_group" */
export type Quote_Line_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Line_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Line_Group_Stream_Cursor_Value_Input = {
  channel_type?: InputMaybe<Scalars['String']>;
  group_name?: InputMaybe<Scalars['String']>;
  group_sequence_number?: InputMaybe<Scalars['float8']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  new_channel_name?: InputMaybe<Scalars['String']>;
  quote_process?: InputMaybe<Scalars['String']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_channel_id?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_platform_model_id?: InputMaybe<Scalars['String']>;
  salesforce_quote_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Quote_Line_Group_Sum_Fields = {
  __typename?: 'quote_line_group_sum_fields';
  group_sequence_number?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "quote_line_group" */
export type Quote_Line_Group_Sum_Order_By = {
  group_sequence_number?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Quote_Line_Group_Var_Pop_Fields = {
  __typename?: 'quote_line_group_var_pop_fields';
  group_sequence_number?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "quote_line_group" */
export type Quote_Line_Group_Var_Pop_Order_By = {
  group_sequence_number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quote_Line_Group_Var_Samp_Fields = {
  __typename?: 'quote_line_group_var_samp_fields';
  group_sequence_number?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "quote_line_group" */
export type Quote_Line_Group_Var_Samp_Order_By = {
  group_sequence_number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quote_Line_Group_Variance_Fields = {
  __typename?: 'quote_line_group_variance_fields';
  group_sequence_number?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "quote_line_group" */
export type Quote_Line_Group_Variance_Order_By = {
  group_sequence_number?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Quote_Line_Max_Fields = {
  __typename?: 'quote_line_max_fields';
  SST_integration_error_message?: Maybe<Scalars['String']>;
  SST_integration_status?: Maybe<Scalars['String']>;
  SST_jira_parent_ticket?: Maybe<Scalars['String']>;
  SST_jira_ticket?: Maybe<Scalars['String']>;
  additional_discount?: Maybe<Scalars['numeric']>;
  additional_discount_percentage?: Maybe<Scalars['float8']>;
  additional_discount_unit?: Maybe<Scalars['String']>;
  ads_plus_certified?: Maybe<Scalars['String']>;
  adsplus_deal_type?: Maybe<Scalars['String']>;
  adsplus_percent_of_total?: Maybe<Scalars['float8']>;
  adsplus_revenue_share?: Maybe<Scalars['float8']>;
  amagi_ad_tag_provided_by?: Maybe<Scalars['String']>;
  amagi_ads_monetised_backfill?: Maybe<Scalars['String']>;
  amagi_ads_monetised_primary?: Maybe<Scalars['String']>;
  amagi_adsplus_revenue_share?: Maybe<Scalars['float8']>;
  amagi_percentage_of_inventory?: Maybe<Scalars['float8']>;
  approvals_quantity?: Maybe<Scalars['float8']>;
  billable_unit_price?: Maybe<Scalars['numeric']>;
  billing_type?: Maybe<Scalars['String']>;
  cdn_tagging?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  charge_type?: Maybe<Scalars['String']>;
  churn_type?: Maybe<Scalars['String']>;
  compound_discount?: Maybe<Scalars['float8']>;
  connect_distribution_model?: Maybe<Scalars['String']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  content_partner_ad_tag_provided_by?: Maybe<Scalars['String']>;
  content_partner_ads_monetised_backfill?: Maybe<Scalars['String']>;
  content_partner_ads_monetised_primary?: Maybe<Scalars['String']>;
  content_partner_ads_plus_commission_percentage?: Maybe<Scalars['float8']>;
  contracted_price?: Maybe<Scalars['float8']>;
  cpm?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customer_churn_request?: Maybe<Scalars['String']>;
  customer_percentage_of_inventory?: Maybe<Scalars['float8']>;
  customer_total?: Maybe<Scalars['numeric']>;
  customer_unit_price?: Maybe<Scalars['numeric']>;
  default_subscription_term?: Maybe<Scalars['String']>;
  delivery_tier?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discount_schedule?: Maybe<Scalars['String']>;
  discount_tier?: Maybe<Scalars['String']>;
  effective_end_date?: Maybe<Scalars['timestamptz']>;
  effective_start_date?: Maybe<Scalars['timestamptz']>;
  effective_subscription_term?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  group?: Maybe<Scalars['String']>;
  guidance?: Maybe<Scalars['float8']>;
  inventory_share_amagi_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_amagi_primary_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_content_partner_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_content_partner_primary_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_platform_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_platform_primary_ad_tag?: Maybe<Scalars['String']>;
  line_name?: Maybe<Scalars['String']>;
  list_total?: Maybe<Scalars['numeric']>;
  list_unit_price?: Maybe<Scalars['numeric']>;
  markup?: Maybe<Scalars['numeric']>;
  max_deductions?: Maybe<Scalars['float8']>;
  net_mrr?: Maybe<Scalars['numeric']>;
  net_total?: Maybe<Scalars['numeric']>;
  net_unit_price?: Maybe<Scalars['float8']>;
  number?: Maybe<Scalars['float8']>;
  number_of_months_deposit?: Maybe<Scalars['float8']>;
  option_discount?: Maybe<Scalars['float8']>;
  other_churn_reason?: Maybe<Scalars['String']>;
  package_cost?: Maybe<Scalars['numeric']>;
  package_list_total?: Maybe<Scalars['numeric']>;
  package_total?: Maybe<Scalars['numeric']>;
  partner_discount?: Maybe<Scalars['String']>;
  percent_of_total?: Maybe<Scalars['float8']>;
  percent_of_total_base?: Maybe<Scalars['String']>;
  percent_of_total_percentage?: Maybe<Scalars['float8']>;
  percent_of_total_scope?: Maybe<Scalars['float8']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  platform_ad_tag_provided_by?: Maybe<Scalars['String']>;
  platform_ads_monetised_backfill?: Maybe<Scalars['String']>;
  platform_ads_monetised_primary?: Maybe<Scalars['String']>;
  platform_ads_plus_commission_percentage?: Maybe<Scalars['float8']>;
  platform_model?: Maybe<Scalars['String']>;
  platform_percentage_of_inventory?: Maybe<Scalars['float8']>;
  preferred_business_model?: Maybe<Scalars['String']>;
  previous_segment_regular_price?: Maybe<Scalars['numeric']>;
  previous_segment_uplift?: Maybe<Scalars['numeric']>;
  price_dimension?: Maybe<Scalars['String']>;
  pricing_information_unit_net_price?: Maybe<Scalars['float8']>;
  pricing_method?: Maybe<Scalars['String']>;
  product_code?: Maybe<Scalars['String']>;
  product_name?: Maybe<Scalars['String']>;
  product_option?: Maybe<Scalars['String']>;
  prorate_amount_discount?: Maybe<Scalars['float8']>;
  prorate_multiplier?: Maybe<Scalars['float8']>;
  prorated_list_price?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['float8']>;
  regular_unit_price?: Maybe<Scalars['numeric']>;
  renewed_subscription?: Maybe<Scalars['String']>;
  revenue_share_backfill_ad_tag?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_backfill?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_primary?: Maybe<Scalars['String']>;
  revenue_share_primary_ad_tag?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_product_code?: Maybe<Scalars['String']>;
  salesforce_quote_id?: Maybe<Scalars['String']>;
  segment_index?: Maybe<Scalars['numeric']>;
  segment_key?: Maybe<Scalars['String']>;
  segment_label?: Maybe<Scalars['String']>;
  so_po_ref_number?: Maybe<Scalars['String']>;
  special_price?: Maybe<Scalars['numeric']>;
  special_price_description?: Maybe<Scalars['String']>;
  special_price_type?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  subscription_pricing?: Maybe<Scalars['String']>;
  subscription_type?: Maybe<Scalars['String']>;
  term_discount?: Maybe<Scalars['String']>;
  term_discount_schedule?: Maybe<Scalars['String']>;
  total_discount?: Maybe<Scalars['numeric']>;
  total_discount_percentage?: Maybe<Scalars['float8']>;
  ts_account?: Maybe<Scalars['String']>;
  unit_cost?: Maybe<Scalars['numeric']>;
  unit_net_price?: Maybe<Scalars['numeric']>;
  unprorated_net_price?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  volume_discount?: Maybe<Scalars['String']>;
  who_pays?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "quote_line" */
export type Quote_Line_Max_Order_By = {
  SST_integration_error_message?: InputMaybe<Order_By>;
  SST_integration_status?: InputMaybe<Order_By>;
  SST_jira_parent_ticket?: InputMaybe<Order_By>;
  SST_jira_ticket?: InputMaybe<Order_By>;
  additional_discount?: InputMaybe<Order_By>;
  additional_discount_percentage?: InputMaybe<Order_By>;
  additional_discount_unit?: InputMaybe<Order_By>;
  ads_plus_certified?: InputMaybe<Order_By>;
  adsplus_deal_type?: InputMaybe<Order_By>;
  adsplus_percent_of_total?: InputMaybe<Order_By>;
  adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_ad_tag_provided_by?: InputMaybe<Order_By>;
  amagi_ads_monetised_backfill?: InputMaybe<Order_By>;
  amagi_ads_monetised_primary?: InputMaybe<Order_By>;
  amagi_adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_percentage_of_inventory?: InputMaybe<Order_By>;
  approvals_quantity?: InputMaybe<Order_By>;
  billable_unit_price?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  cdn_tagging?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  charge_type?: InputMaybe<Order_By>;
  churn_type?: InputMaybe<Order_By>;
  compound_discount?: InputMaybe<Order_By>;
  connect_distribution_model?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  content_partner_ad_tag_provided_by?: InputMaybe<Order_By>;
  content_partner_ads_monetised_backfill?: InputMaybe<Order_By>;
  content_partner_ads_monetised_primary?: InputMaybe<Order_By>;
  content_partner_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  contracted_price?: InputMaybe<Order_By>;
  cpm?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_churn_request?: InputMaybe<Order_By>;
  customer_percentage_of_inventory?: InputMaybe<Order_By>;
  customer_total?: InputMaybe<Order_By>;
  customer_unit_price?: InputMaybe<Order_By>;
  default_subscription_term?: InputMaybe<Order_By>;
  delivery_tier?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discount_schedule?: InputMaybe<Order_By>;
  discount_tier?: InputMaybe<Order_By>;
  effective_end_date?: InputMaybe<Order_By>;
  effective_start_date?: InputMaybe<Order_By>;
  effective_subscription_term?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  guidance?: InputMaybe<Order_By>;
  inventory_share_amagi_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_amagi_primary_ad_tag?: InputMaybe<Order_By>;
  inventory_share_content_partner_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_content_partner_primary_ad_tag?: InputMaybe<Order_By>;
  inventory_share_platform_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_platform_primary_ad_tag?: InputMaybe<Order_By>;
  line_name?: InputMaybe<Order_By>;
  list_total?: InputMaybe<Order_By>;
  list_unit_price?: InputMaybe<Order_By>;
  markup?: InputMaybe<Order_By>;
  max_deductions?: InputMaybe<Order_By>;
  net_mrr?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  net_unit_price?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_of_months_deposit?: InputMaybe<Order_By>;
  option_discount?: InputMaybe<Order_By>;
  other_churn_reason?: InputMaybe<Order_By>;
  package_cost?: InputMaybe<Order_By>;
  package_list_total?: InputMaybe<Order_By>;
  package_total?: InputMaybe<Order_By>;
  partner_discount?: InputMaybe<Order_By>;
  percent_of_total?: InputMaybe<Order_By>;
  percent_of_total_base?: InputMaybe<Order_By>;
  percent_of_total_percentage?: InputMaybe<Order_By>;
  percent_of_total_scope?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  platform_ad_tag_provided_by?: InputMaybe<Order_By>;
  platform_ads_monetised_backfill?: InputMaybe<Order_By>;
  platform_ads_monetised_primary?: InputMaybe<Order_By>;
  platform_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  platform_model?: InputMaybe<Order_By>;
  platform_percentage_of_inventory?: InputMaybe<Order_By>;
  preferred_business_model?: InputMaybe<Order_By>;
  previous_segment_regular_price?: InputMaybe<Order_By>;
  previous_segment_uplift?: InputMaybe<Order_By>;
  price_dimension?: InputMaybe<Order_By>;
  pricing_information_unit_net_price?: InputMaybe<Order_By>;
  pricing_method?: InputMaybe<Order_By>;
  product_code?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  product_option?: InputMaybe<Order_By>;
  prorate_amount_discount?: InputMaybe<Order_By>;
  prorate_multiplier?: InputMaybe<Order_By>;
  prorated_list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  regular_unit_price?: InputMaybe<Order_By>;
  renewed_subscription?: InputMaybe<Order_By>;
  revenue_share_backfill_ad_tag?: InputMaybe<Order_By>;
  revenue_share_monetised_by_backfill?: InputMaybe<Order_By>;
  revenue_share_monetised_by_primary?: InputMaybe<Order_By>;
  revenue_share_primary_ad_tag?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_product_code?: InputMaybe<Order_By>;
  salesforce_quote_id?: InputMaybe<Order_By>;
  segment_index?: InputMaybe<Order_By>;
  segment_key?: InputMaybe<Order_By>;
  segment_label?: InputMaybe<Order_By>;
  so_po_ref_number?: InputMaybe<Order_By>;
  special_price?: InputMaybe<Order_By>;
  special_price_description?: InputMaybe<Order_By>;
  special_price_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  subscription_pricing?: InputMaybe<Order_By>;
  subscription_type?: InputMaybe<Order_By>;
  term_discount?: InputMaybe<Order_By>;
  term_discount_schedule?: InputMaybe<Order_By>;
  total_discount?: InputMaybe<Order_By>;
  total_discount_percentage?: InputMaybe<Order_By>;
  ts_account?: InputMaybe<Order_By>;
  unit_cost?: InputMaybe<Order_By>;
  unit_net_price?: InputMaybe<Order_By>;
  unprorated_net_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  volume_discount?: InputMaybe<Order_By>;
  who_pays?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quote_Line_Min_Fields = {
  __typename?: 'quote_line_min_fields';
  SST_integration_error_message?: Maybe<Scalars['String']>;
  SST_integration_status?: Maybe<Scalars['String']>;
  SST_jira_parent_ticket?: Maybe<Scalars['String']>;
  SST_jira_ticket?: Maybe<Scalars['String']>;
  additional_discount?: Maybe<Scalars['numeric']>;
  additional_discount_percentage?: Maybe<Scalars['float8']>;
  additional_discount_unit?: Maybe<Scalars['String']>;
  ads_plus_certified?: Maybe<Scalars['String']>;
  adsplus_deal_type?: Maybe<Scalars['String']>;
  adsplus_percent_of_total?: Maybe<Scalars['float8']>;
  adsplus_revenue_share?: Maybe<Scalars['float8']>;
  amagi_ad_tag_provided_by?: Maybe<Scalars['String']>;
  amagi_ads_monetised_backfill?: Maybe<Scalars['String']>;
  amagi_ads_monetised_primary?: Maybe<Scalars['String']>;
  amagi_adsplus_revenue_share?: Maybe<Scalars['float8']>;
  amagi_percentage_of_inventory?: Maybe<Scalars['float8']>;
  approvals_quantity?: Maybe<Scalars['float8']>;
  billable_unit_price?: Maybe<Scalars['numeric']>;
  billing_type?: Maybe<Scalars['String']>;
  cdn_tagging?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  charge_type?: Maybe<Scalars['String']>;
  churn_type?: Maybe<Scalars['String']>;
  compound_discount?: Maybe<Scalars['float8']>;
  connect_distribution_model?: Maybe<Scalars['String']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  content_partner_ad_tag_provided_by?: Maybe<Scalars['String']>;
  content_partner_ads_monetised_backfill?: Maybe<Scalars['String']>;
  content_partner_ads_monetised_primary?: Maybe<Scalars['String']>;
  content_partner_ads_plus_commission_percentage?: Maybe<Scalars['float8']>;
  contracted_price?: Maybe<Scalars['float8']>;
  cpm?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customer_churn_request?: Maybe<Scalars['String']>;
  customer_percentage_of_inventory?: Maybe<Scalars['float8']>;
  customer_total?: Maybe<Scalars['numeric']>;
  customer_unit_price?: Maybe<Scalars['numeric']>;
  default_subscription_term?: Maybe<Scalars['String']>;
  delivery_tier?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discount_schedule?: Maybe<Scalars['String']>;
  discount_tier?: Maybe<Scalars['String']>;
  effective_end_date?: Maybe<Scalars['timestamptz']>;
  effective_start_date?: Maybe<Scalars['timestamptz']>;
  effective_subscription_term?: Maybe<Scalars['float8']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  group?: Maybe<Scalars['String']>;
  guidance?: Maybe<Scalars['float8']>;
  inventory_share_amagi_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_amagi_primary_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_content_partner_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_content_partner_primary_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_platform_backfill_ad_tag?: Maybe<Scalars['String']>;
  inventory_share_platform_primary_ad_tag?: Maybe<Scalars['String']>;
  line_name?: Maybe<Scalars['String']>;
  list_total?: Maybe<Scalars['numeric']>;
  list_unit_price?: Maybe<Scalars['numeric']>;
  markup?: Maybe<Scalars['numeric']>;
  max_deductions?: Maybe<Scalars['float8']>;
  net_mrr?: Maybe<Scalars['numeric']>;
  net_total?: Maybe<Scalars['numeric']>;
  net_unit_price?: Maybe<Scalars['float8']>;
  number?: Maybe<Scalars['float8']>;
  number_of_months_deposit?: Maybe<Scalars['float8']>;
  option_discount?: Maybe<Scalars['float8']>;
  other_churn_reason?: Maybe<Scalars['String']>;
  package_cost?: Maybe<Scalars['numeric']>;
  package_list_total?: Maybe<Scalars['numeric']>;
  package_total?: Maybe<Scalars['numeric']>;
  partner_discount?: Maybe<Scalars['String']>;
  percent_of_total?: Maybe<Scalars['float8']>;
  percent_of_total_base?: Maybe<Scalars['String']>;
  percent_of_total_percentage?: Maybe<Scalars['float8']>;
  percent_of_total_scope?: Maybe<Scalars['float8']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  platform_ad_tag_provided_by?: Maybe<Scalars['String']>;
  platform_ads_monetised_backfill?: Maybe<Scalars['String']>;
  platform_ads_monetised_primary?: Maybe<Scalars['String']>;
  platform_ads_plus_commission_percentage?: Maybe<Scalars['float8']>;
  platform_model?: Maybe<Scalars['String']>;
  platform_percentage_of_inventory?: Maybe<Scalars['float8']>;
  preferred_business_model?: Maybe<Scalars['String']>;
  previous_segment_regular_price?: Maybe<Scalars['numeric']>;
  previous_segment_uplift?: Maybe<Scalars['numeric']>;
  price_dimension?: Maybe<Scalars['String']>;
  pricing_information_unit_net_price?: Maybe<Scalars['float8']>;
  pricing_method?: Maybe<Scalars['String']>;
  product_code?: Maybe<Scalars['String']>;
  product_name?: Maybe<Scalars['String']>;
  product_option?: Maybe<Scalars['String']>;
  prorate_amount_discount?: Maybe<Scalars['float8']>;
  prorate_multiplier?: Maybe<Scalars['float8']>;
  prorated_list_price?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['float8']>;
  regular_unit_price?: Maybe<Scalars['numeric']>;
  renewed_subscription?: Maybe<Scalars['String']>;
  revenue_share_backfill_ad_tag?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_backfill?: Maybe<Scalars['String']>;
  revenue_share_monetised_by_primary?: Maybe<Scalars['String']>;
  revenue_share_primary_ad_tag?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_product_code?: Maybe<Scalars['String']>;
  salesforce_quote_id?: Maybe<Scalars['String']>;
  segment_index?: Maybe<Scalars['numeric']>;
  segment_key?: Maybe<Scalars['String']>;
  segment_label?: Maybe<Scalars['String']>;
  so_po_ref_number?: Maybe<Scalars['String']>;
  special_price?: Maybe<Scalars['numeric']>;
  special_price_description?: Maybe<Scalars['String']>;
  special_price_type?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  subscription_pricing?: Maybe<Scalars['String']>;
  subscription_type?: Maybe<Scalars['String']>;
  term_discount?: Maybe<Scalars['String']>;
  term_discount_schedule?: Maybe<Scalars['String']>;
  total_discount?: Maybe<Scalars['numeric']>;
  total_discount_percentage?: Maybe<Scalars['float8']>;
  ts_account?: Maybe<Scalars['String']>;
  unit_cost?: Maybe<Scalars['numeric']>;
  unit_net_price?: Maybe<Scalars['numeric']>;
  unprorated_net_price?: Maybe<Scalars['numeric']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  volume_discount?: Maybe<Scalars['String']>;
  who_pays?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "quote_line" */
export type Quote_Line_Min_Order_By = {
  SST_integration_error_message?: InputMaybe<Order_By>;
  SST_integration_status?: InputMaybe<Order_By>;
  SST_jira_parent_ticket?: InputMaybe<Order_By>;
  SST_jira_ticket?: InputMaybe<Order_By>;
  additional_discount?: InputMaybe<Order_By>;
  additional_discount_percentage?: InputMaybe<Order_By>;
  additional_discount_unit?: InputMaybe<Order_By>;
  ads_plus_certified?: InputMaybe<Order_By>;
  adsplus_deal_type?: InputMaybe<Order_By>;
  adsplus_percent_of_total?: InputMaybe<Order_By>;
  adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_ad_tag_provided_by?: InputMaybe<Order_By>;
  amagi_ads_monetised_backfill?: InputMaybe<Order_By>;
  amagi_ads_monetised_primary?: InputMaybe<Order_By>;
  amagi_adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_percentage_of_inventory?: InputMaybe<Order_By>;
  approvals_quantity?: InputMaybe<Order_By>;
  billable_unit_price?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  cdn_tagging?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  charge_type?: InputMaybe<Order_By>;
  churn_type?: InputMaybe<Order_By>;
  compound_discount?: InputMaybe<Order_By>;
  connect_distribution_model?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  content_partner_ad_tag_provided_by?: InputMaybe<Order_By>;
  content_partner_ads_monetised_backfill?: InputMaybe<Order_By>;
  content_partner_ads_monetised_primary?: InputMaybe<Order_By>;
  content_partner_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  contracted_price?: InputMaybe<Order_By>;
  cpm?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_churn_request?: InputMaybe<Order_By>;
  customer_percentage_of_inventory?: InputMaybe<Order_By>;
  customer_total?: InputMaybe<Order_By>;
  customer_unit_price?: InputMaybe<Order_By>;
  default_subscription_term?: InputMaybe<Order_By>;
  delivery_tier?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discount_schedule?: InputMaybe<Order_By>;
  discount_tier?: InputMaybe<Order_By>;
  effective_end_date?: InputMaybe<Order_By>;
  effective_start_date?: InputMaybe<Order_By>;
  effective_subscription_term?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  guidance?: InputMaybe<Order_By>;
  inventory_share_amagi_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_amagi_primary_ad_tag?: InputMaybe<Order_By>;
  inventory_share_content_partner_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_content_partner_primary_ad_tag?: InputMaybe<Order_By>;
  inventory_share_platform_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_platform_primary_ad_tag?: InputMaybe<Order_By>;
  line_name?: InputMaybe<Order_By>;
  list_total?: InputMaybe<Order_By>;
  list_unit_price?: InputMaybe<Order_By>;
  markup?: InputMaybe<Order_By>;
  max_deductions?: InputMaybe<Order_By>;
  net_mrr?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  net_unit_price?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_of_months_deposit?: InputMaybe<Order_By>;
  option_discount?: InputMaybe<Order_By>;
  other_churn_reason?: InputMaybe<Order_By>;
  package_cost?: InputMaybe<Order_By>;
  package_list_total?: InputMaybe<Order_By>;
  package_total?: InputMaybe<Order_By>;
  partner_discount?: InputMaybe<Order_By>;
  percent_of_total?: InputMaybe<Order_By>;
  percent_of_total_base?: InputMaybe<Order_By>;
  percent_of_total_percentage?: InputMaybe<Order_By>;
  percent_of_total_scope?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  platform_ad_tag_provided_by?: InputMaybe<Order_By>;
  platform_ads_monetised_backfill?: InputMaybe<Order_By>;
  platform_ads_monetised_primary?: InputMaybe<Order_By>;
  platform_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  platform_model?: InputMaybe<Order_By>;
  platform_percentage_of_inventory?: InputMaybe<Order_By>;
  preferred_business_model?: InputMaybe<Order_By>;
  previous_segment_regular_price?: InputMaybe<Order_By>;
  previous_segment_uplift?: InputMaybe<Order_By>;
  price_dimension?: InputMaybe<Order_By>;
  pricing_information_unit_net_price?: InputMaybe<Order_By>;
  pricing_method?: InputMaybe<Order_By>;
  product_code?: InputMaybe<Order_By>;
  product_name?: InputMaybe<Order_By>;
  product_option?: InputMaybe<Order_By>;
  prorate_amount_discount?: InputMaybe<Order_By>;
  prorate_multiplier?: InputMaybe<Order_By>;
  prorated_list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  regular_unit_price?: InputMaybe<Order_By>;
  renewed_subscription?: InputMaybe<Order_By>;
  revenue_share_backfill_ad_tag?: InputMaybe<Order_By>;
  revenue_share_monetised_by_backfill?: InputMaybe<Order_By>;
  revenue_share_monetised_by_primary?: InputMaybe<Order_By>;
  revenue_share_primary_ad_tag?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_product_code?: InputMaybe<Order_By>;
  salesforce_quote_id?: InputMaybe<Order_By>;
  segment_index?: InputMaybe<Order_By>;
  segment_key?: InputMaybe<Order_By>;
  segment_label?: InputMaybe<Order_By>;
  so_po_ref_number?: InputMaybe<Order_By>;
  special_price?: InputMaybe<Order_By>;
  special_price_description?: InputMaybe<Order_By>;
  special_price_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  subscription_pricing?: InputMaybe<Order_By>;
  subscription_type?: InputMaybe<Order_By>;
  term_discount?: InputMaybe<Order_By>;
  term_discount_schedule?: InputMaybe<Order_By>;
  total_discount?: InputMaybe<Order_By>;
  total_discount_percentage?: InputMaybe<Order_By>;
  ts_account?: InputMaybe<Order_By>;
  unit_cost?: InputMaybe<Order_By>;
  unit_net_price?: InputMaybe<Order_By>;
  unprorated_net_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  volume_discount?: InputMaybe<Order_By>;
  who_pays?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "quote_line". */
export type Quote_Line_Order_By = {
  SST_integration_error_message?: InputMaybe<Order_By>;
  SST_integration_status?: InputMaybe<Order_By>;
  SST_jira_parent_ticket?: InputMaybe<Order_By>;
  SST_jira_ticket?: InputMaybe<Order_By>;
  additional_discount?: InputMaybe<Order_By>;
  additional_discount_percentage?: InputMaybe<Order_By>;
  additional_discount_unit?: InputMaybe<Order_By>;
  ads_plus_certified?: InputMaybe<Order_By>;
  adsplus_deal_type?: InputMaybe<Order_By>;
  adsplus_percent_of_total?: InputMaybe<Order_By>;
  adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_ad_tag_provided_by?: InputMaybe<Order_By>;
  amagi_ads_monetised_backfill?: InputMaybe<Order_By>;
  amagi_ads_monetised_primary?: InputMaybe<Order_By>;
  amagi_adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_percentage_of_inventory?: InputMaybe<Order_By>;
  approvals_quantity?: InputMaybe<Order_By>;
  billable_unit_price?: InputMaybe<Order_By>;
  billing_type?: InputMaybe<Order_By>;
  bundled?: InputMaybe<Order_By>;
  cdn_tagging?: InputMaybe<Order_By>;
  channel?: InputMaybe<Order_By>;
  channel_details?: InputMaybe<Channel_Order_By>;
  charge_type?: InputMaybe<Order_By>;
  churn_type?: InputMaybe<Order_By>;
  compound_discount?: InputMaybe<Order_By>;
  connect_distribution_model?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  content_partner_ad_tag_provided_by?: InputMaybe<Order_By>;
  content_partner_ads_monetised_backfill?: InputMaybe<Order_By>;
  content_partner_ads_monetised_primary?: InputMaybe<Order_By>;
  content_partner_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  contracted_price?: InputMaybe<Order_By>;
  cost_editable?: InputMaybe<Order_By>;
  cpm?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer_churn_request?: InputMaybe<Order_By>;
  customer_percentage_of_inventory?: InputMaybe<Order_By>;
  customer_total?: InputMaybe<Order_By>;
  customer_unit_price?: InputMaybe<Order_By>;
  default_subscription_term?: InputMaybe<Order_By>;
  delivery_tier?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discount_schedule?: InputMaybe<Order_By>;
  discount_tier?: InputMaybe<Order_By>;
  effective_end_date?: InputMaybe<Order_By>;
  effective_start_date?: InputMaybe<Order_By>;
  effective_subscription_term?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  guidance?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  inventory_share_amagi_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_amagi_primary_ad_tag?: InputMaybe<Order_By>;
  inventory_share_content_partner_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_content_partner_primary_ad_tag?: InputMaybe<Order_By>;
  inventory_share_platform_backfill_ad_tag?: InputMaybe<Order_By>;
  inventory_share_platform_primary_ad_tag?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  line_name?: InputMaybe<Order_By>;
  list_total?: InputMaybe<Order_By>;
  list_unit_price?: InputMaybe<Order_By>;
  markup?: InputMaybe<Order_By>;
  max_deductions?: InputMaybe<Order_By>;
  net_mrr?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  net_unit_price?: InputMaybe<Order_By>;
  non_discountable?: InputMaybe<Order_By>;
  non_partner_discountable?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_of_months_deposit?: InputMaybe<Order_By>;
  option_discount?: InputMaybe<Order_By>;
  other_churn_reason?: InputMaybe<Order_By>;
  package_cost?: InputMaybe<Order_By>;
  package_list_total?: InputMaybe<Order_By>;
  package_total?: InputMaybe<Order_By>;
  partner_discount?: InputMaybe<Order_By>;
  percent_of_total?: InputMaybe<Order_By>;
  percent_of_total_base?: InputMaybe<Order_By>;
  percent_of_total_percentage?: InputMaybe<Order_By>;
  percent_of_total_scope?: InputMaybe<Order_By>;
  platform?: InputMaybe<Platform_Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  platform_ad_tag_provided_by?: InputMaybe<Order_By>;
  platform_ads_monetised_backfill?: InputMaybe<Order_By>;
  platform_ads_monetised_primary?: InputMaybe<Order_By>;
  platform_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  platform_model?: InputMaybe<Order_By>;
  platform_percentage_of_inventory?: InputMaybe<Order_By>;
  preferred_business_model?: InputMaybe<Order_By>;
  previous_segment_regular_price?: InputMaybe<Order_By>;
  previous_segment_uplift?: InputMaybe<Order_By>;
  price_dimension?: InputMaybe<Order_By>;
  price_editable?: InputMaybe<Order_By>;
  pricing_information_unit_net_price?: InputMaybe<Order_By>;
  pricing_method?: InputMaybe<Order_By>;
  pricing_method_editable?: InputMaybe<Order_By>;
  product_code?: InputMaybe<Order_By>;
  product_details?: InputMaybe<Product_Order_By>;
  product_name?: InputMaybe<Order_By>;
  product_option?: InputMaybe<Order_By>;
  prorate_amount_discount?: InputMaybe<Order_By>;
  prorate_multiplier?: InputMaybe<Order_By>;
  prorated_list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quote?: InputMaybe<Quote_Order_By>;
  quote_line_consumption_schedules_aggregate?: InputMaybe<Quote_Line_Consumption_Schedule_Aggregate_Order_By>;
  regular_unit_price?: InputMaybe<Order_By>;
  renewal?: InputMaybe<Order_By>;
  renewed_subscription?: InputMaybe<Order_By>;
  revenue_share_backfill_ad_tag?: InputMaybe<Order_By>;
  revenue_share_monetised_by_backfill?: InputMaybe<Order_By>;
  revenue_share_monetised_by_primary?: InputMaybe<Order_By>;
  revenue_share_primary_ad_tag?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_product_code?: InputMaybe<Order_By>;
  salesforce_quote_id?: InputMaybe<Order_By>;
  segment_index?: InputMaybe<Order_By>;
  segment_key?: InputMaybe<Order_By>;
  segment_label?: InputMaybe<Order_By>;
  so_po_ref_number?: InputMaybe<Order_By>;
  special_price?: InputMaybe<Order_By>;
  special_price_description?: InputMaybe<Order_By>;
  special_price_type?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  subscription_pricing?: InputMaybe<Order_By>;
  subscription_type?: InputMaybe<Order_By>;
  term_discount?: InputMaybe<Order_By>;
  term_discount_schedule?: InputMaybe<Order_By>;
  total_discount?: InputMaybe<Order_By>;
  total_discount_percentage?: InputMaybe<Order_By>;
  ts_account?: InputMaybe<Order_By>;
  unit_cost?: InputMaybe<Order_By>;
  unit_net_price?: InputMaybe<Order_By>;
  unprorated_net_price?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  volume_discount?: InputMaybe<Order_By>;
  who_pays?: InputMaybe<Order_By>;
};

/** select columns of table "quote_line" */
export enum Quote_Line_Select_Column {
  /** column name */
  SstIntegrationErrorMessage = 'SST_integration_error_message',
  /** column name */
  SstIntegrationStatus = 'SST_integration_status',
  /** column name */
  SstJiraParentTicket = 'SST_jira_parent_ticket',
  /** column name */
  SstJiraTicket = 'SST_jira_ticket',
  /** column name */
  AdditionalDiscount = 'additional_discount',
  /** column name */
  AdditionalDiscountPercentage = 'additional_discount_percentage',
  /** column name */
  AdditionalDiscountUnit = 'additional_discount_unit',
  /** column name */
  AdsPlusCertified = 'ads_plus_certified',
  /** column name */
  AdsplusDealType = 'adsplus_deal_type',
  /** column name */
  AdsplusPercentOfTotal = 'adsplus_percent_of_total',
  /** column name */
  AdsplusRevenueShare = 'adsplus_revenue_share',
  /** column name */
  AmagiAdTagProvidedBy = 'amagi_ad_tag_provided_by',
  /** column name */
  AmagiAdsMonetisedBackfill = 'amagi_ads_monetised_backfill',
  /** column name */
  AmagiAdsMonetisedPrimary = 'amagi_ads_monetised_primary',
  /** column name */
  AmagiAdsplusRevenueShare = 'amagi_adsplus_revenue_share',
  /** column name */
  AmagiPercentageOfInventory = 'amagi_percentage_of_inventory',
  /** column name */
  ApprovalsQuantity = 'approvals_quantity',
  /** column name */
  BillableUnitPrice = 'billable_unit_price',
  /** column name */
  BillingType = 'billing_type',
  /** column name */
  Bundled = 'bundled',
  /** column name */
  CdnTagging = 'cdn_tagging',
  /** column name */
  Channel = 'channel',
  /** column name */
  ChargeType = 'charge_type',
  /** column name */
  ChurnType = 'churn_type',
  /** column name */
  CompoundDiscount = 'compound_discount',
  /** column name */
  ConnectDistributionModel = 'connect_distribution_model',
  /** column name */
  ContentPartnerAdSalesCommissionPercentage = 'content_partner_ad_sales_commission_percentage',
  /** column name */
  ContentPartnerAdTagProvidedBy = 'content_partner_ad_tag_provided_by',
  /** column name */
  ContentPartnerAdsMonetisedBackfill = 'content_partner_ads_monetised_backfill',
  /** column name */
  ContentPartnerAdsMonetisedPrimary = 'content_partner_ads_monetised_primary',
  /** column name */
  ContentPartnerAdsPlusCommissionPercentage = 'content_partner_ads_plus_commission_percentage',
  /** column name */
  ContractedPrice = 'contracted_price',
  /** column name */
  CostEditable = 'cost_editable',
  /** column name */
  Cpm = 'cpm',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomerChurnRequest = 'customer_churn_request',
  /** column name */
  CustomerPercentageOfInventory = 'customer_percentage_of_inventory',
  /** column name */
  CustomerTotal = 'customer_total',
  /** column name */
  CustomerUnitPrice = 'customer_unit_price',
  /** column name */
  DefaultSubscriptionTerm = 'default_subscription_term',
  /** column name */
  DeliveryTier = 'delivery_tier',
  /** column name */
  Description = 'description',
  /** column name */
  DiscountSchedule = 'discount_schedule',
  /** column name */
  DiscountTier = 'discount_tier',
  /** column name */
  EffectiveEndDate = 'effective_end_date',
  /** column name */
  EffectiveStartDate = 'effective_start_date',
  /** column name */
  EffectiveSubscriptionTerm = 'effective_subscription_term',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Group = 'group',
  /** column name */
  Guidance = 'guidance',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  InventoryShareAmagiBackfillAdTag = 'inventory_share_amagi_backfill_ad_tag',
  /** column name */
  InventoryShareAmagiPrimaryAdTag = 'inventory_share_amagi_primary_ad_tag',
  /** column name */
  InventoryShareContentPartnerBackfillAdTag = 'inventory_share_content_partner_backfill_ad_tag',
  /** column name */
  InventoryShareContentPartnerPrimaryAdTag = 'inventory_share_content_partner_primary_ad_tag',
  /** column name */
  InventorySharePlatformBackfillAdTag = 'inventory_share_platform_backfill_ad_tag',
  /** column name */
  InventorySharePlatformPrimaryAdTag = 'inventory_share_platform_primary_ad_tag',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LineName = 'line_name',
  /** column name */
  ListTotal = 'list_total',
  /** column name */
  ListUnitPrice = 'list_unit_price',
  /** column name */
  Markup = 'markup',
  /** column name */
  MaxDeductions = 'max_deductions',
  /** column name */
  NetMrr = 'net_mrr',
  /** column name */
  NetTotal = 'net_total',
  /** column name */
  NetUnitPrice = 'net_unit_price',
  /** column name */
  NonDiscountable = 'non_discountable',
  /** column name */
  NonPartnerDiscountable = 'non_partner_discountable',
  /** column name */
  Number = 'number',
  /** column name */
  NumberOfMonthsDeposit = 'number_of_months_deposit',
  /** column name */
  OptionDiscount = 'option_discount',
  /** column name */
  OtherChurnReason = 'other_churn_reason',
  /** column name */
  PackageCost = 'package_cost',
  /** column name */
  PackageListTotal = 'package_list_total',
  /** column name */
  PackageTotal = 'package_total',
  /** column name */
  PartnerDiscount = 'partner_discount',
  /** column name */
  PercentOfTotal = 'percent_of_total',
  /** column name */
  PercentOfTotalBase = 'percent_of_total_base',
  /** column name */
  PercentOfTotalPercentage = 'percent_of_total_percentage',
  /** column name */
  PercentOfTotalScope = 'percent_of_total_scope',
  /** column name */
  PlatformAdSalesCommissionPercentage = 'platform_ad_sales_commission_percentage',
  /** column name */
  PlatformAdTagProvidedBy = 'platform_ad_tag_provided_by',
  /** column name */
  PlatformAdsMonetisedBackfill = 'platform_ads_monetised_backfill',
  /** column name */
  PlatformAdsMonetisedPrimary = 'platform_ads_monetised_primary',
  /** column name */
  PlatformAdsPlusCommissionPercentage = 'platform_ads_plus_commission_percentage',
  /** column name */
  PlatformModel = 'platform_model',
  /** column name */
  PlatformPercentageOfInventory = 'platform_percentage_of_inventory',
  /** column name */
  PreferredBusinessModel = 'preferred_business_model',
  /** column name */
  PreviousSegmentRegularPrice = 'previous_segment_regular_price',
  /** column name */
  PreviousSegmentUplift = 'previous_segment_uplift',
  /** column name */
  PriceDimension = 'price_dimension',
  /** column name */
  PriceEditable = 'price_editable',
  /** column name */
  PricingInformationUnitNetPrice = 'pricing_information_unit_net_price',
  /** column name */
  PricingMethod = 'pricing_method',
  /** column name */
  PricingMethodEditable = 'pricing_method_editable',
  /** column name */
  ProductCode = 'product_code',
  /** column name */
  ProductName = 'product_name',
  /** column name */
  ProductOption = 'product_option',
  /** column name */
  ProrateAmountDiscount = 'prorate_amount_discount',
  /** column name */
  ProrateMultiplier = 'prorate_multiplier',
  /** column name */
  ProratedListPrice = 'prorated_list_price',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RegularUnitPrice = 'regular_unit_price',
  /** column name */
  Renewal = 'renewal',
  /** column name */
  RenewedSubscription = 'renewed_subscription',
  /** column name */
  RevenueShareBackfillAdTag = 'revenue_share_backfill_ad_tag',
  /** column name */
  RevenueShareMonetisedByBackfill = 'revenue_share_monetised_by_backfill',
  /** column name */
  RevenueShareMonetisedByPrimary = 'revenue_share_monetised_by_primary',
  /** column name */
  RevenueSharePrimaryAdTag = 'revenue_share_primary_ad_tag',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceProductCode = 'salesforce_product_code',
  /** column name */
  SalesforceQuoteId = 'salesforce_quote_id',
  /** column name */
  SegmentIndex = 'segment_index',
  /** column name */
  SegmentKey = 'segment_key',
  /** column name */
  SegmentLabel = 'segment_label',
  /** column name */
  SoPoRefNumber = 'so_po_ref_number',
  /** column name */
  SpecialPrice = 'special_price',
  /** column name */
  SpecialPriceDescription = 'special_price_description',
  /** column name */
  SpecialPriceType = 'special_price_type',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  SubscriptionPricing = 'subscription_pricing',
  /** column name */
  SubscriptionType = 'subscription_type',
  /** column name */
  TermDiscount = 'term_discount',
  /** column name */
  TermDiscountSchedule = 'term_discount_schedule',
  /** column name */
  TotalDiscount = 'total_discount',
  /** column name */
  TotalDiscountPercentage = 'total_discount_percentage',
  /** column name */
  TsAccount = 'ts_account',
  /** column name */
  UnitCost = 'unit_cost',
  /** column name */
  UnitNetPrice = 'unit_net_price',
  /** column name */
  UnproratedNetPrice = 'unprorated_net_price',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VolumeDiscount = 'volume_discount',
  /** column name */
  WhoPays = 'who_pays'
}

/** select "quote_line_aggregate_bool_exp_avg_arguments_columns" columns of table "quote_line" */
export enum Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  AdditionalDiscountPercentage = 'additional_discount_percentage',
  /** column name */
  AdsplusPercentOfTotal = 'adsplus_percent_of_total',
  /** column name */
  AdsplusRevenueShare = 'adsplus_revenue_share',
  /** column name */
  AmagiAdsplusRevenueShare = 'amagi_adsplus_revenue_share',
  /** column name */
  AmagiPercentageOfInventory = 'amagi_percentage_of_inventory',
  /** column name */
  ApprovalsQuantity = 'approvals_quantity',
  /** column name */
  CompoundDiscount = 'compound_discount',
  /** column name */
  ContentPartnerAdsPlusCommissionPercentage = 'content_partner_ads_plus_commission_percentage',
  /** column name */
  ContractedPrice = 'contracted_price',
  /** column name */
  CustomerPercentageOfInventory = 'customer_percentage_of_inventory',
  /** column name */
  EffectiveSubscriptionTerm = 'effective_subscription_term',
  /** column name */
  Guidance = 'guidance',
  /** column name */
  MaxDeductions = 'max_deductions',
  /** column name */
  NetUnitPrice = 'net_unit_price',
  /** column name */
  Number = 'number',
  /** column name */
  NumberOfMonthsDeposit = 'number_of_months_deposit',
  /** column name */
  OptionDiscount = 'option_discount',
  /** column name */
  PercentOfTotal = 'percent_of_total',
  /** column name */
  PercentOfTotalPercentage = 'percent_of_total_percentage',
  /** column name */
  PercentOfTotalScope = 'percent_of_total_scope',
  /** column name */
  PlatformAdsPlusCommissionPercentage = 'platform_ads_plus_commission_percentage',
  /** column name */
  PlatformPercentageOfInventory = 'platform_percentage_of_inventory',
  /** column name */
  PricingInformationUnitNetPrice = 'pricing_information_unit_net_price',
  /** column name */
  ProrateAmountDiscount = 'prorate_amount_discount',
  /** column name */
  ProrateMultiplier = 'prorate_multiplier',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TotalDiscountPercentage = 'total_discount_percentage'
}

/** select "quote_line_aggregate_bool_exp_bool_and_arguments_columns" columns of table "quote_line" */
export enum Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Bundled = 'bundled',
  /** column name */
  CostEditable = 'cost_editable',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  NonDiscountable = 'non_discountable',
  /** column name */
  NonPartnerDiscountable = 'non_partner_discountable',
  /** column name */
  PriceEditable = 'price_editable',
  /** column name */
  PricingMethodEditable = 'pricing_method_editable',
  /** column name */
  Renewal = 'renewal'
}

/** select "quote_line_aggregate_bool_exp_bool_or_arguments_columns" columns of table "quote_line" */
export enum Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Bundled = 'bundled',
  /** column name */
  CostEditable = 'cost_editable',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  NonDiscountable = 'non_discountable',
  /** column name */
  NonPartnerDiscountable = 'non_partner_discountable',
  /** column name */
  PriceEditable = 'price_editable',
  /** column name */
  PricingMethodEditable = 'pricing_method_editable',
  /** column name */
  Renewal = 'renewal'
}

/** select "quote_line_aggregate_bool_exp_corr_arguments_columns" columns of table "quote_line" */
export enum Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  AdditionalDiscountPercentage = 'additional_discount_percentage',
  /** column name */
  AdsplusPercentOfTotal = 'adsplus_percent_of_total',
  /** column name */
  AdsplusRevenueShare = 'adsplus_revenue_share',
  /** column name */
  AmagiAdsplusRevenueShare = 'amagi_adsplus_revenue_share',
  /** column name */
  AmagiPercentageOfInventory = 'amagi_percentage_of_inventory',
  /** column name */
  ApprovalsQuantity = 'approvals_quantity',
  /** column name */
  CompoundDiscount = 'compound_discount',
  /** column name */
  ContentPartnerAdsPlusCommissionPercentage = 'content_partner_ads_plus_commission_percentage',
  /** column name */
  ContractedPrice = 'contracted_price',
  /** column name */
  CustomerPercentageOfInventory = 'customer_percentage_of_inventory',
  /** column name */
  EffectiveSubscriptionTerm = 'effective_subscription_term',
  /** column name */
  Guidance = 'guidance',
  /** column name */
  MaxDeductions = 'max_deductions',
  /** column name */
  NetUnitPrice = 'net_unit_price',
  /** column name */
  Number = 'number',
  /** column name */
  NumberOfMonthsDeposit = 'number_of_months_deposit',
  /** column name */
  OptionDiscount = 'option_discount',
  /** column name */
  PercentOfTotal = 'percent_of_total',
  /** column name */
  PercentOfTotalPercentage = 'percent_of_total_percentage',
  /** column name */
  PercentOfTotalScope = 'percent_of_total_scope',
  /** column name */
  PlatformAdsPlusCommissionPercentage = 'platform_ads_plus_commission_percentage',
  /** column name */
  PlatformPercentageOfInventory = 'platform_percentage_of_inventory',
  /** column name */
  PricingInformationUnitNetPrice = 'pricing_information_unit_net_price',
  /** column name */
  ProrateAmountDiscount = 'prorate_amount_discount',
  /** column name */
  ProrateMultiplier = 'prorate_multiplier',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TotalDiscountPercentage = 'total_discount_percentage'
}

/** select "quote_line_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "quote_line" */
export enum Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  AdditionalDiscountPercentage = 'additional_discount_percentage',
  /** column name */
  AdsplusPercentOfTotal = 'adsplus_percent_of_total',
  /** column name */
  AdsplusRevenueShare = 'adsplus_revenue_share',
  /** column name */
  AmagiAdsplusRevenueShare = 'amagi_adsplus_revenue_share',
  /** column name */
  AmagiPercentageOfInventory = 'amagi_percentage_of_inventory',
  /** column name */
  ApprovalsQuantity = 'approvals_quantity',
  /** column name */
  CompoundDiscount = 'compound_discount',
  /** column name */
  ContentPartnerAdsPlusCommissionPercentage = 'content_partner_ads_plus_commission_percentage',
  /** column name */
  ContractedPrice = 'contracted_price',
  /** column name */
  CustomerPercentageOfInventory = 'customer_percentage_of_inventory',
  /** column name */
  EffectiveSubscriptionTerm = 'effective_subscription_term',
  /** column name */
  Guidance = 'guidance',
  /** column name */
  MaxDeductions = 'max_deductions',
  /** column name */
  NetUnitPrice = 'net_unit_price',
  /** column name */
  Number = 'number',
  /** column name */
  NumberOfMonthsDeposit = 'number_of_months_deposit',
  /** column name */
  OptionDiscount = 'option_discount',
  /** column name */
  PercentOfTotal = 'percent_of_total',
  /** column name */
  PercentOfTotalPercentage = 'percent_of_total_percentage',
  /** column name */
  PercentOfTotalScope = 'percent_of_total_scope',
  /** column name */
  PlatformAdsPlusCommissionPercentage = 'platform_ads_plus_commission_percentage',
  /** column name */
  PlatformPercentageOfInventory = 'platform_percentage_of_inventory',
  /** column name */
  PricingInformationUnitNetPrice = 'pricing_information_unit_net_price',
  /** column name */
  ProrateAmountDiscount = 'prorate_amount_discount',
  /** column name */
  ProrateMultiplier = 'prorate_multiplier',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TotalDiscountPercentage = 'total_discount_percentage'
}

/** select "quote_line_aggregate_bool_exp_max_arguments_columns" columns of table "quote_line" */
export enum Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  AdditionalDiscountPercentage = 'additional_discount_percentage',
  /** column name */
  AdsplusPercentOfTotal = 'adsplus_percent_of_total',
  /** column name */
  AdsplusRevenueShare = 'adsplus_revenue_share',
  /** column name */
  AmagiAdsplusRevenueShare = 'amagi_adsplus_revenue_share',
  /** column name */
  AmagiPercentageOfInventory = 'amagi_percentage_of_inventory',
  /** column name */
  ApprovalsQuantity = 'approvals_quantity',
  /** column name */
  CompoundDiscount = 'compound_discount',
  /** column name */
  ContentPartnerAdsPlusCommissionPercentage = 'content_partner_ads_plus_commission_percentage',
  /** column name */
  ContractedPrice = 'contracted_price',
  /** column name */
  CustomerPercentageOfInventory = 'customer_percentage_of_inventory',
  /** column name */
  EffectiveSubscriptionTerm = 'effective_subscription_term',
  /** column name */
  Guidance = 'guidance',
  /** column name */
  MaxDeductions = 'max_deductions',
  /** column name */
  NetUnitPrice = 'net_unit_price',
  /** column name */
  Number = 'number',
  /** column name */
  NumberOfMonthsDeposit = 'number_of_months_deposit',
  /** column name */
  OptionDiscount = 'option_discount',
  /** column name */
  PercentOfTotal = 'percent_of_total',
  /** column name */
  PercentOfTotalPercentage = 'percent_of_total_percentage',
  /** column name */
  PercentOfTotalScope = 'percent_of_total_scope',
  /** column name */
  PlatformAdsPlusCommissionPercentage = 'platform_ads_plus_commission_percentage',
  /** column name */
  PlatformPercentageOfInventory = 'platform_percentage_of_inventory',
  /** column name */
  PricingInformationUnitNetPrice = 'pricing_information_unit_net_price',
  /** column name */
  ProrateAmountDiscount = 'prorate_amount_discount',
  /** column name */
  ProrateMultiplier = 'prorate_multiplier',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TotalDiscountPercentage = 'total_discount_percentage'
}

/** select "quote_line_aggregate_bool_exp_min_arguments_columns" columns of table "quote_line" */
export enum Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  AdditionalDiscountPercentage = 'additional_discount_percentage',
  /** column name */
  AdsplusPercentOfTotal = 'adsplus_percent_of_total',
  /** column name */
  AdsplusRevenueShare = 'adsplus_revenue_share',
  /** column name */
  AmagiAdsplusRevenueShare = 'amagi_adsplus_revenue_share',
  /** column name */
  AmagiPercentageOfInventory = 'amagi_percentage_of_inventory',
  /** column name */
  ApprovalsQuantity = 'approvals_quantity',
  /** column name */
  CompoundDiscount = 'compound_discount',
  /** column name */
  ContentPartnerAdsPlusCommissionPercentage = 'content_partner_ads_plus_commission_percentage',
  /** column name */
  ContractedPrice = 'contracted_price',
  /** column name */
  CustomerPercentageOfInventory = 'customer_percentage_of_inventory',
  /** column name */
  EffectiveSubscriptionTerm = 'effective_subscription_term',
  /** column name */
  Guidance = 'guidance',
  /** column name */
  MaxDeductions = 'max_deductions',
  /** column name */
  NetUnitPrice = 'net_unit_price',
  /** column name */
  Number = 'number',
  /** column name */
  NumberOfMonthsDeposit = 'number_of_months_deposit',
  /** column name */
  OptionDiscount = 'option_discount',
  /** column name */
  PercentOfTotal = 'percent_of_total',
  /** column name */
  PercentOfTotalPercentage = 'percent_of_total_percentage',
  /** column name */
  PercentOfTotalScope = 'percent_of_total_scope',
  /** column name */
  PlatformAdsPlusCommissionPercentage = 'platform_ads_plus_commission_percentage',
  /** column name */
  PlatformPercentageOfInventory = 'platform_percentage_of_inventory',
  /** column name */
  PricingInformationUnitNetPrice = 'pricing_information_unit_net_price',
  /** column name */
  ProrateAmountDiscount = 'prorate_amount_discount',
  /** column name */
  ProrateMultiplier = 'prorate_multiplier',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TotalDiscountPercentage = 'total_discount_percentage'
}

/** select "quote_line_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "quote_line" */
export enum Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  AdditionalDiscountPercentage = 'additional_discount_percentage',
  /** column name */
  AdsplusPercentOfTotal = 'adsplus_percent_of_total',
  /** column name */
  AdsplusRevenueShare = 'adsplus_revenue_share',
  /** column name */
  AmagiAdsplusRevenueShare = 'amagi_adsplus_revenue_share',
  /** column name */
  AmagiPercentageOfInventory = 'amagi_percentage_of_inventory',
  /** column name */
  ApprovalsQuantity = 'approvals_quantity',
  /** column name */
  CompoundDiscount = 'compound_discount',
  /** column name */
  ContentPartnerAdsPlusCommissionPercentage = 'content_partner_ads_plus_commission_percentage',
  /** column name */
  ContractedPrice = 'contracted_price',
  /** column name */
  CustomerPercentageOfInventory = 'customer_percentage_of_inventory',
  /** column name */
  EffectiveSubscriptionTerm = 'effective_subscription_term',
  /** column name */
  Guidance = 'guidance',
  /** column name */
  MaxDeductions = 'max_deductions',
  /** column name */
  NetUnitPrice = 'net_unit_price',
  /** column name */
  Number = 'number',
  /** column name */
  NumberOfMonthsDeposit = 'number_of_months_deposit',
  /** column name */
  OptionDiscount = 'option_discount',
  /** column name */
  PercentOfTotal = 'percent_of_total',
  /** column name */
  PercentOfTotalPercentage = 'percent_of_total_percentage',
  /** column name */
  PercentOfTotalScope = 'percent_of_total_scope',
  /** column name */
  PlatformAdsPlusCommissionPercentage = 'platform_ads_plus_commission_percentage',
  /** column name */
  PlatformPercentageOfInventory = 'platform_percentage_of_inventory',
  /** column name */
  PricingInformationUnitNetPrice = 'pricing_information_unit_net_price',
  /** column name */
  ProrateAmountDiscount = 'prorate_amount_discount',
  /** column name */
  ProrateMultiplier = 'prorate_multiplier',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TotalDiscountPercentage = 'total_discount_percentage'
}

/** select "quote_line_aggregate_bool_exp_sum_arguments_columns" columns of table "quote_line" */
export enum Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  AdditionalDiscountPercentage = 'additional_discount_percentage',
  /** column name */
  AdsplusPercentOfTotal = 'adsplus_percent_of_total',
  /** column name */
  AdsplusRevenueShare = 'adsplus_revenue_share',
  /** column name */
  AmagiAdsplusRevenueShare = 'amagi_adsplus_revenue_share',
  /** column name */
  AmagiPercentageOfInventory = 'amagi_percentage_of_inventory',
  /** column name */
  ApprovalsQuantity = 'approvals_quantity',
  /** column name */
  CompoundDiscount = 'compound_discount',
  /** column name */
  ContentPartnerAdsPlusCommissionPercentage = 'content_partner_ads_plus_commission_percentage',
  /** column name */
  ContractedPrice = 'contracted_price',
  /** column name */
  CustomerPercentageOfInventory = 'customer_percentage_of_inventory',
  /** column name */
  EffectiveSubscriptionTerm = 'effective_subscription_term',
  /** column name */
  Guidance = 'guidance',
  /** column name */
  MaxDeductions = 'max_deductions',
  /** column name */
  NetUnitPrice = 'net_unit_price',
  /** column name */
  Number = 'number',
  /** column name */
  NumberOfMonthsDeposit = 'number_of_months_deposit',
  /** column name */
  OptionDiscount = 'option_discount',
  /** column name */
  PercentOfTotal = 'percent_of_total',
  /** column name */
  PercentOfTotalPercentage = 'percent_of_total_percentage',
  /** column name */
  PercentOfTotalScope = 'percent_of_total_scope',
  /** column name */
  PlatformAdsPlusCommissionPercentage = 'platform_ads_plus_commission_percentage',
  /** column name */
  PlatformPercentageOfInventory = 'platform_percentage_of_inventory',
  /** column name */
  PricingInformationUnitNetPrice = 'pricing_information_unit_net_price',
  /** column name */
  ProrateAmountDiscount = 'prorate_amount_discount',
  /** column name */
  ProrateMultiplier = 'prorate_multiplier',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TotalDiscountPercentage = 'total_discount_percentage'
}

/** select "quote_line_aggregate_bool_exp_var_samp_arguments_columns" columns of table "quote_line" */
export enum Quote_Line_Select_Column_Quote_Line_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  AdditionalDiscountPercentage = 'additional_discount_percentage',
  /** column name */
  AdsplusPercentOfTotal = 'adsplus_percent_of_total',
  /** column name */
  AdsplusRevenueShare = 'adsplus_revenue_share',
  /** column name */
  AmagiAdsplusRevenueShare = 'amagi_adsplus_revenue_share',
  /** column name */
  AmagiPercentageOfInventory = 'amagi_percentage_of_inventory',
  /** column name */
  ApprovalsQuantity = 'approvals_quantity',
  /** column name */
  CompoundDiscount = 'compound_discount',
  /** column name */
  ContentPartnerAdsPlusCommissionPercentage = 'content_partner_ads_plus_commission_percentage',
  /** column name */
  ContractedPrice = 'contracted_price',
  /** column name */
  CustomerPercentageOfInventory = 'customer_percentage_of_inventory',
  /** column name */
  EffectiveSubscriptionTerm = 'effective_subscription_term',
  /** column name */
  Guidance = 'guidance',
  /** column name */
  MaxDeductions = 'max_deductions',
  /** column name */
  NetUnitPrice = 'net_unit_price',
  /** column name */
  Number = 'number',
  /** column name */
  NumberOfMonthsDeposit = 'number_of_months_deposit',
  /** column name */
  OptionDiscount = 'option_discount',
  /** column name */
  PercentOfTotal = 'percent_of_total',
  /** column name */
  PercentOfTotalPercentage = 'percent_of_total_percentage',
  /** column name */
  PercentOfTotalScope = 'percent_of_total_scope',
  /** column name */
  PlatformAdsPlusCommissionPercentage = 'platform_ads_plus_commission_percentage',
  /** column name */
  PlatformPercentageOfInventory = 'platform_percentage_of_inventory',
  /** column name */
  PricingInformationUnitNetPrice = 'pricing_information_unit_net_price',
  /** column name */
  ProrateAmountDiscount = 'prorate_amount_discount',
  /** column name */
  ProrateMultiplier = 'prorate_multiplier',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  TotalDiscountPercentage = 'total_discount_percentage'
}

/** aggregate stddev on columns */
export type Quote_Line_Stddev_Fields = {
  __typename?: 'quote_line_stddev_fields';
  additional_discount?: Maybe<Scalars['Float']>;
  additional_discount_percentage?: Maybe<Scalars['Float']>;
  adsplus_percent_of_total?: Maybe<Scalars['Float']>;
  adsplus_revenue_share?: Maybe<Scalars['Float']>;
  amagi_adsplus_revenue_share?: Maybe<Scalars['Float']>;
  amagi_percentage_of_inventory?: Maybe<Scalars['Float']>;
  approvals_quantity?: Maybe<Scalars['Float']>;
  billable_unit_price?: Maybe<Scalars['Float']>;
  compound_discount?: Maybe<Scalars['Float']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  content_partner_ads_plus_commission_percentage?: Maybe<Scalars['Float']>;
  contracted_price?: Maybe<Scalars['Float']>;
  customer_percentage_of_inventory?: Maybe<Scalars['Float']>;
  customer_total?: Maybe<Scalars['Float']>;
  customer_unit_price?: Maybe<Scalars['Float']>;
  effective_subscription_term?: Maybe<Scalars['Float']>;
  guidance?: Maybe<Scalars['Float']>;
  list_total?: Maybe<Scalars['Float']>;
  list_unit_price?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  max_deductions?: Maybe<Scalars['Float']>;
  net_mrr?: Maybe<Scalars['Float']>;
  net_total?: Maybe<Scalars['Float']>;
  net_unit_price?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
  number_of_months_deposit?: Maybe<Scalars['Float']>;
  option_discount?: Maybe<Scalars['Float']>;
  package_cost?: Maybe<Scalars['Float']>;
  package_list_total?: Maybe<Scalars['Float']>;
  package_total?: Maybe<Scalars['Float']>;
  percent_of_total?: Maybe<Scalars['Float']>;
  percent_of_total_percentage?: Maybe<Scalars['Float']>;
  percent_of_total_scope?: Maybe<Scalars['Float']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  platform_ads_plus_commission_percentage?: Maybe<Scalars['Float']>;
  platform_percentage_of_inventory?: Maybe<Scalars['Float']>;
  previous_segment_regular_price?: Maybe<Scalars['Float']>;
  previous_segment_uplift?: Maybe<Scalars['Float']>;
  pricing_information_unit_net_price?: Maybe<Scalars['Float']>;
  prorate_amount_discount?: Maybe<Scalars['Float']>;
  prorate_multiplier?: Maybe<Scalars['Float']>;
  prorated_list_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  regular_unit_price?: Maybe<Scalars['Float']>;
  segment_index?: Maybe<Scalars['Float']>;
  special_price?: Maybe<Scalars['Float']>;
  total_discount?: Maybe<Scalars['Float']>;
  total_discount_percentage?: Maybe<Scalars['Float']>;
  unit_cost?: Maybe<Scalars['Float']>;
  unit_net_price?: Maybe<Scalars['Float']>;
  unprorated_net_price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "quote_line" */
export type Quote_Line_Stddev_Order_By = {
  additional_discount?: InputMaybe<Order_By>;
  additional_discount_percentage?: InputMaybe<Order_By>;
  adsplus_percent_of_total?: InputMaybe<Order_By>;
  adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_percentage_of_inventory?: InputMaybe<Order_By>;
  approvals_quantity?: InputMaybe<Order_By>;
  billable_unit_price?: InputMaybe<Order_By>;
  compound_discount?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  content_partner_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  contracted_price?: InputMaybe<Order_By>;
  customer_percentage_of_inventory?: InputMaybe<Order_By>;
  customer_total?: InputMaybe<Order_By>;
  customer_unit_price?: InputMaybe<Order_By>;
  effective_subscription_term?: InputMaybe<Order_By>;
  guidance?: InputMaybe<Order_By>;
  list_total?: InputMaybe<Order_By>;
  list_unit_price?: InputMaybe<Order_By>;
  markup?: InputMaybe<Order_By>;
  max_deductions?: InputMaybe<Order_By>;
  net_mrr?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  net_unit_price?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_of_months_deposit?: InputMaybe<Order_By>;
  option_discount?: InputMaybe<Order_By>;
  package_cost?: InputMaybe<Order_By>;
  package_list_total?: InputMaybe<Order_By>;
  package_total?: InputMaybe<Order_By>;
  percent_of_total?: InputMaybe<Order_By>;
  percent_of_total_percentage?: InputMaybe<Order_By>;
  percent_of_total_scope?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  platform_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  platform_percentage_of_inventory?: InputMaybe<Order_By>;
  previous_segment_regular_price?: InputMaybe<Order_By>;
  previous_segment_uplift?: InputMaybe<Order_By>;
  pricing_information_unit_net_price?: InputMaybe<Order_By>;
  prorate_amount_discount?: InputMaybe<Order_By>;
  prorate_multiplier?: InputMaybe<Order_By>;
  prorated_list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  regular_unit_price?: InputMaybe<Order_By>;
  segment_index?: InputMaybe<Order_By>;
  special_price?: InputMaybe<Order_By>;
  total_discount?: InputMaybe<Order_By>;
  total_discount_percentage?: InputMaybe<Order_By>;
  unit_cost?: InputMaybe<Order_By>;
  unit_net_price?: InputMaybe<Order_By>;
  unprorated_net_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quote_Line_Stddev_Pop_Fields = {
  __typename?: 'quote_line_stddev_pop_fields';
  additional_discount?: Maybe<Scalars['Float']>;
  additional_discount_percentage?: Maybe<Scalars['Float']>;
  adsplus_percent_of_total?: Maybe<Scalars['Float']>;
  adsplus_revenue_share?: Maybe<Scalars['Float']>;
  amagi_adsplus_revenue_share?: Maybe<Scalars['Float']>;
  amagi_percentage_of_inventory?: Maybe<Scalars['Float']>;
  approvals_quantity?: Maybe<Scalars['Float']>;
  billable_unit_price?: Maybe<Scalars['Float']>;
  compound_discount?: Maybe<Scalars['Float']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  content_partner_ads_plus_commission_percentage?: Maybe<Scalars['Float']>;
  contracted_price?: Maybe<Scalars['Float']>;
  customer_percentage_of_inventory?: Maybe<Scalars['Float']>;
  customer_total?: Maybe<Scalars['Float']>;
  customer_unit_price?: Maybe<Scalars['Float']>;
  effective_subscription_term?: Maybe<Scalars['Float']>;
  guidance?: Maybe<Scalars['Float']>;
  list_total?: Maybe<Scalars['Float']>;
  list_unit_price?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  max_deductions?: Maybe<Scalars['Float']>;
  net_mrr?: Maybe<Scalars['Float']>;
  net_total?: Maybe<Scalars['Float']>;
  net_unit_price?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
  number_of_months_deposit?: Maybe<Scalars['Float']>;
  option_discount?: Maybe<Scalars['Float']>;
  package_cost?: Maybe<Scalars['Float']>;
  package_list_total?: Maybe<Scalars['Float']>;
  package_total?: Maybe<Scalars['Float']>;
  percent_of_total?: Maybe<Scalars['Float']>;
  percent_of_total_percentage?: Maybe<Scalars['Float']>;
  percent_of_total_scope?: Maybe<Scalars['Float']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  platform_ads_plus_commission_percentage?: Maybe<Scalars['Float']>;
  platform_percentage_of_inventory?: Maybe<Scalars['Float']>;
  previous_segment_regular_price?: Maybe<Scalars['Float']>;
  previous_segment_uplift?: Maybe<Scalars['Float']>;
  pricing_information_unit_net_price?: Maybe<Scalars['Float']>;
  prorate_amount_discount?: Maybe<Scalars['Float']>;
  prorate_multiplier?: Maybe<Scalars['Float']>;
  prorated_list_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  regular_unit_price?: Maybe<Scalars['Float']>;
  segment_index?: Maybe<Scalars['Float']>;
  special_price?: Maybe<Scalars['Float']>;
  total_discount?: Maybe<Scalars['Float']>;
  total_discount_percentage?: Maybe<Scalars['Float']>;
  unit_cost?: Maybe<Scalars['Float']>;
  unit_net_price?: Maybe<Scalars['Float']>;
  unprorated_net_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "quote_line" */
export type Quote_Line_Stddev_Pop_Order_By = {
  additional_discount?: InputMaybe<Order_By>;
  additional_discount_percentage?: InputMaybe<Order_By>;
  adsplus_percent_of_total?: InputMaybe<Order_By>;
  adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_percentage_of_inventory?: InputMaybe<Order_By>;
  approvals_quantity?: InputMaybe<Order_By>;
  billable_unit_price?: InputMaybe<Order_By>;
  compound_discount?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  content_partner_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  contracted_price?: InputMaybe<Order_By>;
  customer_percentage_of_inventory?: InputMaybe<Order_By>;
  customer_total?: InputMaybe<Order_By>;
  customer_unit_price?: InputMaybe<Order_By>;
  effective_subscription_term?: InputMaybe<Order_By>;
  guidance?: InputMaybe<Order_By>;
  list_total?: InputMaybe<Order_By>;
  list_unit_price?: InputMaybe<Order_By>;
  markup?: InputMaybe<Order_By>;
  max_deductions?: InputMaybe<Order_By>;
  net_mrr?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  net_unit_price?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_of_months_deposit?: InputMaybe<Order_By>;
  option_discount?: InputMaybe<Order_By>;
  package_cost?: InputMaybe<Order_By>;
  package_list_total?: InputMaybe<Order_By>;
  package_total?: InputMaybe<Order_By>;
  percent_of_total?: InputMaybe<Order_By>;
  percent_of_total_percentage?: InputMaybe<Order_By>;
  percent_of_total_scope?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  platform_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  platform_percentage_of_inventory?: InputMaybe<Order_By>;
  previous_segment_regular_price?: InputMaybe<Order_By>;
  previous_segment_uplift?: InputMaybe<Order_By>;
  pricing_information_unit_net_price?: InputMaybe<Order_By>;
  prorate_amount_discount?: InputMaybe<Order_By>;
  prorate_multiplier?: InputMaybe<Order_By>;
  prorated_list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  regular_unit_price?: InputMaybe<Order_By>;
  segment_index?: InputMaybe<Order_By>;
  special_price?: InputMaybe<Order_By>;
  total_discount?: InputMaybe<Order_By>;
  total_discount_percentage?: InputMaybe<Order_By>;
  unit_cost?: InputMaybe<Order_By>;
  unit_net_price?: InputMaybe<Order_By>;
  unprorated_net_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quote_Line_Stddev_Samp_Fields = {
  __typename?: 'quote_line_stddev_samp_fields';
  additional_discount?: Maybe<Scalars['Float']>;
  additional_discount_percentage?: Maybe<Scalars['Float']>;
  adsplus_percent_of_total?: Maybe<Scalars['Float']>;
  adsplus_revenue_share?: Maybe<Scalars['Float']>;
  amagi_adsplus_revenue_share?: Maybe<Scalars['Float']>;
  amagi_percentage_of_inventory?: Maybe<Scalars['Float']>;
  approvals_quantity?: Maybe<Scalars['Float']>;
  billable_unit_price?: Maybe<Scalars['Float']>;
  compound_discount?: Maybe<Scalars['Float']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  content_partner_ads_plus_commission_percentage?: Maybe<Scalars['Float']>;
  contracted_price?: Maybe<Scalars['Float']>;
  customer_percentage_of_inventory?: Maybe<Scalars['Float']>;
  customer_total?: Maybe<Scalars['Float']>;
  customer_unit_price?: Maybe<Scalars['Float']>;
  effective_subscription_term?: Maybe<Scalars['Float']>;
  guidance?: Maybe<Scalars['Float']>;
  list_total?: Maybe<Scalars['Float']>;
  list_unit_price?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  max_deductions?: Maybe<Scalars['Float']>;
  net_mrr?: Maybe<Scalars['Float']>;
  net_total?: Maybe<Scalars['Float']>;
  net_unit_price?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
  number_of_months_deposit?: Maybe<Scalars['Float']>;
  option_discount?: Maybe<Scalars['Float']>;
  package_cost?: Maybe<Scalars['Float']>;
  package_list_total?: Maybe<Scalars['Float']>;
  package_total?: Maybe<Scalars['Float']>;
  percent_of_total?: Maybe<Scalars['Float']>;
  percent_of_total_percentage?: Maybe<Scalars['Float']>;
  percent_of_total_scope?: Maybe<Scalars['Float']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  platform_ads_plus_commission_percentage?: Maybe<Scalars['Float']>;
  platform_percentage_of_inventory?: Maybe<Scalars['Float']>;
  previous_segment_regular_price?: Maybe<Scalars['Float']>;
  previous_segment_uplift?: Maybe<Scalars['Float']>;
  pricing_information_unit_net_price?: Maybe<Scalars['Float']>;
  prorate_amount_discount?: Maybe<Scalars['Float']>;
  prorate_multiplier?: Maybe<Scalars['Float']>;
  prorated_list_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  regular_unit_price?: Maybe<Scalars['Float']>;
  segment_index?: Maybe<Scalars['Float']>;
  special_price?: Maybe<Scalars['Float']>;
  total_discount?: Maybe<Scalars['Float']>;
  total_discount_percentage?: Maybe<Scalars['Float']>;
  unit_cost?: Maybe<Scalars['Float']>;
  unit_net_price?: Maybe<Scalars['Float']>;
  unprorated_net_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "quote_line" */
export type Quote_Line_Stddev_Samp_Order_By = {
  additional_discount?: InputMaybe<Order_By>;
  additional_discount_percentage?: InputMaybe<Order_By>;
  adsplus_percent_of_total?: InputMaybe<Order_By>;
  adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_percentage_of_inventory?: InputMaybe<Order_By>;
  approvals_quantity?: InputMaybe<Order_By>;
  billable_unit_price?: InputMaybe<Order_By>;
  compound_discount?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  content_partner_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  contracted_price?: InputMaybe<Order_By>;
  customer_percentage_of_inventory?: InputMaybe<Order_By>;
  customer_total?: InputMaybe<Order_By>;
  customer_unit_price?: InputMaybe<Order_By>;
  effective_subscription_term?: InputMaybe<Order_By>;
  guidance?: InputMaybe<Order_By>;
  list_total?: InputMaybe<Order_By>;
  list_unit_price?: InputMaybe<Order_By>;
  markup?: InputMaybe<Order_By>;
  max_deductions?: InputMaybe<Order_By>;
  net_mrr?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  net_unit_price?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_of_months_deposit?: InputMaybe<Order_By>;
  option_discount?: InputMaybe<Order_By>;
  package_cost?: InputMaybe<Order_By>;
  package_list_total?: InputMaybe<Order_By>;
  package_total?: InputMaybe<Order_By>;
  percent_of_total?: InputMaybe<Order_By>;
  percent_of_total_percentage?: InputMaybe<Order_By>;
  percent_of_total_scope?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  platform_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  platform_percentage_of_inventory?: InputMaybe<Order_By>;
  previous_segment_regular_price?: InputMaybe<Order_By>;
  previous_segment_uplift?: InputMaybe<Order_By>;
  pricing_information_unit_net_price?: InputMaybe<Order_By>;
  prorate_amount_discount?: InputMaybe<Order_By>;
  prorate_multiplier?: InputMaybe<Order_By>;
  prorated_list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  regular_unit_price?: InputMaybe<Order_By>;
  segment_index?: InputMaybe<Order_By>;
  special_price?: InputMaybe<Order_By>;
  total_discount?: InputMaybe<Order_By>;
  total_discount_percentage?: InputMaybe<Order_By>;
  unit_cost?: InputMaybe<Order_By>;
  unit_net_price?: InputMaybe<Order_By>;
  unprorated_net_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quote_line" */
export type Quote_Line_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Line_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Line_Stream_Cursor_Value_Input = {
  SST_integration_error_message?: InputMaybe<Scalars['String']>;
  SST_integration_status?: InputMaybe<Scalars['String']>;
  SST_jira_parent_ticket?: InputMaybe<Scalars['String']>;
  SST_jira_ticket?: InputMaybe<Scalars['String']>;
  additional_discount?: InputMaybe<Scalars['numeric']>;
  additional_discount_percentage?: InputMaybe<Scalars['float8']>;
  additional_discount_unit?: InputMaybe<Scalars['String']>;
  ads_plus_certified?: InputMaybe<Scalars['String']>;
  adsplus_deal_type?: InputMaybe<Scalars['String']>;
  adsplus_percent_of_total?: InputMaybe<Scalars['float8']>;
  adsplus_revenue_share?: InputMaybe<Scalars['float8']>;
  amagi_ad_tag_provided_by?: InputMaybe<Scalars['String']>;
  amagi_ads_monetised_backfill?: InputMaybe<Scalars['String']>;
  amagi_ads_monetised_primary?: InputMaybe<Scalars['String']>;
  amagi_adsplus_revenue_share?: InputMaybe<Scalars['float8']>;
  amagi_percentage_of_inventory?: InputMaybe<Scalars['float8']>;
  approvals_quantity?: InputMaybe<Scalars['float8']>;
  billable_unit_price?: InputMaybe<Scalars['numeric']>;
  billing_type?: InputMaybe<Scalars['String']>;
  bundled?: InputMaybe<Scalars['Boolean']>;
  cdn_tagging?: InputMaybe<Scalars['String']>;
  channel?: InputMaybe<Scalars['String']>;
  charge_type?: InputMaybe<Scalars['String']>;
  churn_type?: InputMaybe<Scalars['String']>;
  compound_discount?: InputMaybe<Scalars['float8']>;
  connect_distribution_model?: InputMaybe<Scalars['String']>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Scalars['numeric']>;
  content_partner_ad_tag_provided_by?: InputMaybe<Scalars['String']>;
  content_partner_ads_monetised_backfill?: InputMaybe<Scalars['String']>;
  content_partner_ads_monetised_primary?: InputMaybe<Scalars['String']>;
  content_partner_ads_plus_commission_percentage?: InputMaybe<Scalars['float8']>;
  contracted_price?: InputMaybe<Scalars['float8']>;
  cost_editable?: InputMaybe<Scalars['Boolean']>;
  cpm?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  customer_churn_request?: InputMaybe<Scalars['String']>;
  customer_percentage_of_inventory?: InputMaybe<Scalars['float8']>;
  customer_total?: InputMaybe<Scalars['numeric']>;
  customer_unit_price?: InputMaybe<Scalars['numeric']>;
  default_subscription_term?: InputMaybe<Scalars['String']>;
  delivery_tier?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discount_schedule?: InputMaybe<Scalars['String']>;
  discount_tier?: InputMaybe<Scalars['String']>;
  effective_end_date?: InputMaybe<Scalars['timestamptz']>;
  effective_start_date?: InputMaybe<Scalars['timestamptz']>;
  effective_subscription_term?: InputMaybe<Scalars['float8']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  group?: InputMaybe<Scalars['String']>;
  guidance?: InputMaybe<Scalars['float8']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  inventory_share_amagi_backfill_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_amagi_primary_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_content_partner_backfill_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_content_partner_primary_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_platform_backfill_ad_tag?: InputMaybe<Scalars['String']>;
  inventory_share_platform_primary_ad_tag?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  line_name?: InputMaybe<Scalars['String']>;
  list_total?: InputMaybe<Scalars['numeric']>;
  list_unit_price?: InputMaybe<Scalars['numeric']>;
  markup?: InputMaybe<Scalars['numeric']>;
  max_deductions?: InputMaybe<Scalars['float8']>;
  net_mrr?: InputMaybe<Scalars['numeric']>;
  net_total?: InputMaybe<Scalars['numeric']>;
  net_unit_price?: InputMaybe<Scalars['float8']>;
  non_discountable?: InputMaybe<Scalars['Boolean']>;
  non_partner_discountable?: InputMaybe<Scalars['Boolean']>;
  number?: InputMaybe<Scalars['float8']>;
  number_of_months_deposit?: InputMaybe<Scalars['float8']>;
  option_discount?: InputMaybe<Scalars['float8']>;
  other_churn_reason?: InputMaybe<Scalars['String']>;
  package_cost?: InputMaybe<Scalars['numeric']>;
  package_list_total?: InputMaybe<Scalars['numeric']>;
  package_total?: InputMaybe<Scalars['numeric']>;
  partner_discount?: InputMaybe<Scalars['String']>;
  percent_of_total?: InputMaybe<Scalars['float8']>;
  percent_of_total_base?: InputMaybe<Scalars['String']>;
  percent_of_total_percentage?: InputMaybe<Scalars['float8']>;
  percent_of_total_scope?: InputMaybe<Scalars['float8']>;
  platform_ad_sales_commission_percentage?: InputMaybe<Scalars['numeric']>;
  platform_ad_tag_provided_by?: InputMaybe<Scalars['String']>;
  platform_ads_monetised_backfill?: InputMaybe<Scalars['String']>;
  platform_ads_monetised_primary?: InputMaybe<Scalars['String']>;
  platform_ads_plus_commission_percentage?: InputMaybe<Scalars['float8']>;
  platform_model?: InputMaybe<Scalars['String']>;
  platform_percentage_of_inventory?: InputMaybe<Scalars['float8']>;
  preferred_business_model?: InputMaybe<Scalars['String']>;
  previous_segment_regular_price?: InputMaybe<Scalars['numeric']>;
  previous_segment_uplift?: InputMaybe<Scalars['numeric']>;
  price_dimension?: InputMaybe<Scalars['String']>;
  price_editable?: InputMaybe<Scalars['Boolean']>;
  pricing_information_unit_net_price?: InputMaybe<Scalars['float8']>;
  pricing_method?: InputMaybe<Scalars['String']>;
  pricing_method_editable?: InputMaybe<Scalars['Boolean']>;
  product_code?: InputMaybe<Scalars['String']>;
  product_name?: InputMaybe<Scalars['String']>;
  product_option?: InputMaybe<Scalars['String']>;
  prorate_amount_discount?: InputMaybe<Scalars['float8']>;
  prorate_multiplier?: InputMaybe<Scalars['float8']>;
  prorated_list_price?: InputMaybe<Scalars['numeric']>;
  quantity?: InputMaybe<Scalars['float8']>;
  regular_unit_price?: InputMaybe<Scalars['numeric']>;
  renewal?: InputMaybe<Scalars['Boolean']>;
  renewed_subscription?: InputMaybe<Scalars['String']>;
  revenue_share_backfill_ad_tag?: InputMaybe<Scalars['String']>;
  revenue_share_monetised_by_backfill?: InputMaybe<Scalars['String']>;
  revenue_share_monetised_by_primary?: InputMaybe<Scalars['String']>;
  revenue_share_primary_ad_tag?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_product_code?: InputMaybe<Scalars['String']>;
  salesforce_quote_id?: InputMaybe<Scalars['String']>;
  segment_index?: InputMaybe<Scalars['numeric']>;
  segment_key?: InputMaybe<Scalars['String']>;
  segment_label?: InputMaybe<Scalars['String']>;
  so_po_ref_number?: InputMaybe<Scalars['String']>;
  special_price?: InputMaybe<Scalars['numeric']>;
  special_price_description?: InputMaybe<Scalars['String']>;
  special_price_type?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  subscription_pricing?: InputMaybe<Scalars['String']>;
  subscription_type?: InputMaybe<Scalars['String']>;
  term_discount?: InputMaybe<Scalars['String']>;
  term_discount_schedule?: InputMaybe<Scalars['String']>;
  total_discount?: InputMaybe<Scalars['numeric']>;
  total_discount_percentage?: InputMaybe<Scalars['float8']>;
  ts_account?: InputMaybe<Scalars['String']>;
  unit_cost?: InputMaybe<Scalars['numeric']>;
  unit_net_price?: InputMaybe<Scalars['numeric']>;
  unprorated_net_price?: InputMaybe<Scalars['numeric']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  volume_discount?: InputMaybe<Scalars['String']>;
  who_pays?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Quote_Line_Sum_Fields = {
  __typename?: 'quote_line_sum_fields';
  additional_discount?: Maybe<Scalars['numeric']>;
  additional_discount_percentage?: Maybe<Scalars['float8']>;
  adsplus_percent_of_total?: Maybe<Scalars['float8']>;
  adsplus_revenue_share?: Maybe<Scalars['float8']>;
  amagi_adsplus_revenue_share?: Maybe<Scalars['float8']>;
  amagi_percentage_of_inventory?: Maybe<Scalars['float8']>;
  approvals_quantity?: Maybe<Scalars['float8']>;
  billable_unit_price?: Maybe<Scalars['numeric']>;
  compound_discount?: Maybe<Scalars['float8']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  content_partner_ads_plus_commission_percentage?: Maybe<Scalars['float8']>;
  contracted_price?: Maybe<Scalars['float8']>;
  customer_percentage_of_inventory?: Maybe<Scalars['float8']>;
  customer_total?: Maybe<Scalars['numeric']>;
  customer_unit_price?: Maybe<Scalars['numeric']>;
  effective_subscription_term?: Maybe<Scalars['float8']>;
  guidance?: Maybe<Scalars['float8']>;
  list_total?: Maybe<Scalars['numeric']>;
  list_unit_price?: Maybe<Scalars['numeric']>;
  markup?: Maybe<Scalars['numeric']>;
  max_deductions?: Maybe<Scalars['float8']>;
  net_mrr?: Maybe<Scalars['numeric']>;
  net_total?: Maybe<Scalars['numeric']>;
  net_unit_price?: Maybe<Scalars['float8']>;
  number?: Maybe<Scalars['float8']>;
  number_of_months_deposit?: Maybe<Scalars['float8']>;
  option_discount?: Maybe<Scalars['float8']>;
  package_cost?: Maybe<Scalars['numeric']>;
  package_list_total?: Maybe<Scalars['numeric']>;
  package_total?: Maybe<Scalars['numeric']>;
  percent_of_total?: Maybe<Scalars['float8']>;
  percent_of_total_percentage?: Maybe<Scalars['float8']>;
  percent_of_total_scope?: Maybe<Scalars['float8']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['numeric']>;
  platform_ads_plus_commission_percentage?: Maybe<Scalars['float8']>;
  platform_percentage_of_inventory?: Maybe<Scalars['float8']>;
  previous_segment_regular_price?: Maybe<Scalars['numeric']>;
  previous_segment_uplift?: Maybe<Scalars['numeric']>;
  pricing_information_unit_net_price?: Maybe<Scalars['float8']>;
  prorate_amount_discount?: Maybe<Scalars['float8']>;
  prorate_multiplier?: Maybe<Scalars['float8']>;
  prorated_list_price?: Maybe<Scalars['numeric']>;
  quantity?: Maybe<Scalars['float8']>;
  regular_unit_price?: Maybe<Scalars['numeric']>;
  segment_index?: Maybe<Scalars['numeric']>;
  special_price?: Maybe<Scalars['numeric']>;
  total_discount?: Maybe<Scalars['numeric']>;
  total_discount_percentage?: Maybe<Scalars['float8']>;
  unit_cost?: Maybe<Scalars['numeric']>;
  unit_net_price?: Maybe<Scalars['numeric']>;
  unprorated_net_price?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "quote_line" */
export type Quote_Line_Sum_Order_By = {
  additional_discount?: InputMaybe<Order_By>;
  additional_discount_percentage?: InputMaybe<Order_By>;
  adsplus_percent_of_total?: InputMaybe<Order_By>;
  adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_percentage_of_inventory?: InputMaybe<Order_By>;
  approvals_quantity?: InputMaybe<Order_By>;
  billable_unit_price?: InputMaybe<Order_By>;
  compound_discount?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  content_partner_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  contracted_price?: InputMaybe<Order_By>;
  customer_percentage_of_inventory?: InputMaybe<Order_By>;
  customer_total?: InputMaybe<Order_By>;
  customer_unit_price?: InputMaybe<Order_By>;
  effective_subscription_term?: InputMaybe<Order_By>;
  guidance?: InputMaybe<Order_By>;
  list_total?: InputMaybe<Order_By>;
  list_unit_price?: InputMaybe<Order_By>;
  markup?: InputMaybe<Order_By>;
  max_deductions?: InputMaybe<Order_By>;
  net_mrr?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  net_unit_price?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_of_months_deposit?: InputMaybe<Order_By>;
  option_discount?: InputMaybe<Order_By>;
  package_cost?: InputMaybe<Order_By>;
  package_list_total?: InputMaybe<Order_By>;
  package_total?: InputMaybe<Order_By>;
  percent_of_total?: InputMaybe<Order_By>;
  percent_of_total_percentage?: InputMaybe<Order_By>;
  percent_of_total_scope?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  platform_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  platform_percentage_of_inventory?: InputMaybe<Order_By>;
  previous_segment_regular_price?: InputMaybe<Order_By>;
  previous_segment_uplift?: InputMaybe<Order_By>;
  pricing_information_unit_net_price?: InputMaybe<Order_By>;
  prorate_amount_discount?: InputMaybe<Order_By>;
  prorate_multiplier?: InputMaybe<Order_By>;
  prorated_list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  regular_unit_price?: InputMaybe<Order_By>;
  segment_index?: InputMaybe<Order_By>;
  special_price?: InputMaybe<Order_By>;
  total_discount?: InputMaybe<Order_By>;
  total_discount_percentage?: InputMaybe<Order_By>;
  unit_cost?: InputMaybe<Order_By>;
  unit_net_price?: InputMaybe<Order_By>;
  unprorated_net_price?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Quote_Line_Var_Pop_Fields = {
  __typename?: 'quote_line_var_pop_fields';
  additional_discount?: Maybe<Scalars['Float']>;
  additional_discount_percentage?: Maybe<Scalars['Float']>;
  adsplus_percent_of_total?: Maybe<Scalars['Float']>;
  adsplus_revenue_share?: Maybe<Scalars['Float']>;
  amagi_adsplus_revenue_share?: Maybe<Scalars['Float']>;
  amagi_percentage_of_inventory?: Maybe<Scalars['Float']>;
  approvals_quantity?: Maybe<Scalars['Float']>;
  billable_unit_price?: Maybe<Scalars['Float']>;
  compound_discount?: Maybe<Scalars['Float']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  content_partner_ads_plus_commission_percentage?: Maybe<Scalars['Float']>;
  contracted_price?: Maybe<Scalars['Float']>;
  customer_percentage_of_inventory?: Maybe<Scalars['Float']>;
  customer_total?: Maybe<Scalars['Float']>;
  customer_unit_price?: Maybe<Scalars['Float']>;
  effective_subscription_term?: Maybe<Scalars['Float']>;
  guidance?: Maybe<Scalars['Float']>;
  list_total?: Maybe<Scalars['Float']>;
  list_unit_price?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  max_deductions?: Maybe<Scalars['Float']>;
  net_mrr?: Maybe<Scalars['Float']>;
  net_total?: Maybe<Scalars['Float']>;
  net_unit_price?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
  number_of_months_deposit?: Maybe<Scalars['Float']>;
  option_discount?: Maybe<Scalars['Float']>;
  package_cost?: Maybe<Scalars['Float']>;
  package_list_total?: Maybe<Scalars['Float']>;
  package_total?: Maybe<Scalars['Float']>;
  percent_of_total?: Maybe<Scalars['Float']>;
  percent_of_total_percentage?: Maybe<Scalars['Float']>;
  percent_of_total_scope?: Maybe<Scalars['Float']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  platform_ads_plus_commission_percentage?: Maybe<Scalars['Float']>;
  platform_percentage_of_inventory?: Maybe<Scalars['Float']>;
  previous_segment_regular_price?: Maybe<Scalars['Float']>;
  previous_segment_uplift?: Maybe<Scalars['Float']>;
  pricing_information_unit_net_price?: Maybe<Scalars['Float']>;
  prorate_amount_discount?: Maybe<Scalars['Float']>;
  prorate_multiplier?: Maybe<Scalars['Float']>;
  prorated_list_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  regular_unit_price?: Maybe<Scalars['Float']>;
  segment_index?: Maybe<Scalars['Float']>;
  special_price?: Maybe<Scalars['Float']>;
  total_discount?: Maybe<Scalars['Float']>;
  total_discount_percentage?: Maybe<Scalars['Float']>;
  unit_cost?: Maybe<Scalars['Float']>;
  unit_net_price?: Maybe<Scalars['Float']>;
  unprorated_net_price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "quote_line" */
export type Quote_Line_Var_Pop_Order_By = {
  additional_discount?: InputMaybe<Order_By>;
  additional_discount_percentage?: InputMaybe<Order_By>;
  adsplus_percent_of_total?: InputMaybe<Order_By>;
  adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_percentage_of_inventory?: InputMaybe<Order_By>;
  approvals_quantity?: InputMaybe<Order_By>;
  billable_unit_price?: InputMaybe<Order_By>;
  compound_discount?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  content_partner_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  contracted_price?: InputMaybe<Order_By>;
  customer_percentage_of_inventory?: InputMaybe<Order_By>;
  customer_total?: InputMaybe<Order_By>;
  customer_unit_price?: InputMaybe<Order_By>;
  effective_subscription_term?: InputMaybe<Order_By>;
  guidance?: InputMaybe<Order_By>;
  list_total?: InputMaybe<Order_By>;
  list_unit_price?: InputMaybe<Order_By>;
  markup?: InputMaybe<Order_By>;
  max_deductions?: InputMaybe<Order_By>;
  net_mrr?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  net_unit_price?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_of_months_deposit?: InputMaybe<Order_By>;
  option_discount?: InputMaybe<Order_By>;
  package_cost?: InputMaybe<Order_By>;
  package_list_total?: InputMaybe<Order_By>;
  package_total?: InputMaybe<Order_By>;
  percent_of_total?: InputMaybe<Order_By>;
  percent_of_total_percentage?: InputMaybe<Order_By>;
  percent_of_total_scope?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  platform_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  platform_percentage_of_inventory?: InputMaybe<Order_By>;
  previous_segment_regular_price?: InputMaybe<Order_By>;
  previous_segment_uplift?: InputMaybe<Order_By>;
  pricing_information_unit_net_price?: InputMaybe<Order_By>;
  prorate_amount_discount?: InputMaybe<Order_By>;
  prorate_multiplier?: InputMaybe<Order_By>;
  prorated_list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  regular_unit_price?: InputMaybe<Order_By>;
  segment_index?: InputMaybe<Order_By>;
  special_price?: InputMaybe<Order_By>;
  total_discount?: InputMaybe<Order_By>;
  total_discount_percentage?: InputMaybe<Order_By>;
  unit_cost?: InputMaybe<Order_By>;
  unit_net_price?: InputMaybe<Order_By>;
  unprorated_net_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quote_Line_Var_Samp_Fields = {
  __typename?: 'quote_line_var_samp_fields';
  additional_discount?: Maybe<Scalars['Float']>;
  additional_discount_percentage?: Maybe<Scalars['Float']>;
  adsplus_percent_of_total?: Maybe<Scalars['Float']>;
  adsplus_revenue_share?: Maybe<Scalars['Float']>;
  amagi_adsplus_revenue_share?: Maybe<Scalars['Float']>;
  amagi_percentage_of_inventory?: Maybe<Scalars['Float']>;
  approvals_quantity?: Maybe<Scalars['Float']>;
  billable_unit_price?: Maybe<Scalars['Float']>;
  compound_discount?: Maybe<Scalars['Float']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  content_partner_ads_plus_commission_percentage?: Maybe<Scalars['Float']>;
  contracted_price?: Maybe<Scalars['Float']>;
  customer_percentage_of_inventory?: Maybe<Scalars['Float']>;
  customer_total?: Maybe<Scalars['Float']>;
  customer_unit_price?: Maybe<Scalars['Float']>;
  effective_subscription_term?: Maybe<Scalars['Float']>;
  guidance?: Maybe<Scalars['Float']>;
  list_total?: Maybe<Scalars['Float']>;
  list_unit_price?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  max_deductions?: Maybe<Scalars['Float']>;
  net_mrr?: Maybe<Scalars['Float']>;
  net_total?: Maybe<Scalars['Float']>;
  net_unit_price?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
  number_of_months_deposit?: Maybe<Scalars['Float']>;
  option_discount?: Maybe<Scalars['Float']>;
  package_cost?: Maybe<Scalars['Float']>;
  package_list_total?: Maybe<Scalars['Float']>;
  package_total?: Maybe<Scalars['Float']>;
  percent_of_total?: Maybe<Scalars['Float']>;
  percent_of_total_percentage?: Maybe<Scalars['Float']>;
  percent_of_total_scope?: Maybe<Scalars['Float']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  platform_ads_plus_commission_percentage?: Maybe<Scalars['Float']>;
  platform_percentage_of_inventory?: Maybe<Scalars['Float']>;
  previous_segment_regular_price?: Maybe<Scalars['Float']>;
  previous_segment_uplift?: Maybe<Scalars['Float']>;
  pricing_information_unit_net_price?: Maybe<Scalars['Float']>;
  prorate_amount_discount?: Maybe<Scalars['Float']>;
  prorate_multiplier?: Maybe<Scalars['Float']>;
  prorated_list_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  regular_unit_price?: Maybe<Scalars['Float']>;
  segment_index?: Maybe<Scalars['Float']>;
  special_price?: Maybe<Scalars['Float']>;
  total_discount?: Maybe<Scalars['Float']>;
  total_discount_percentage?: Maybe<Scalars['Float']>;
  unit_cost?: Maybe<Scalars['Float']>;
  unit_net_price?: Maybe<Scalars['Float']>;
  unprorated_net_price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "quote_line" */
export type Quote_Line_Var_Samp_Order_By = {
  additional_discount?: InputMaybe<Order_By>;
  additional_discount_percentage?: InputMaybe<Order_By>;
  adsplus_percent_of_total?: InputMaybe<Order_By>;
  adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_percentage_of_inventory?: InputMaybe<Order_By>;
  approvals_quantity?: InputMaybe<Order_By>;
  billable_unit_price?: InputMaybe<Order_By>;
  compound_discount?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  content_partner_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  contracted_price?: InputMaybe<Order_By>;
  customer_percentage_of_inventory?: InputMaybe<Order_By>;
  customer_total?: InputMaybe<Order_By>;
  customer_unit_price?: InputMaybe<Order_By>;
  effective_subscription_term?: InputMaybe<Order_By>;
  guidance?: InputMaybe<Order_By>;
  list_total?: InputMaybe<Order_By>;
  list_unit_price?: InputMaybe<Order_By>;
  markup?: InputMaybe<Order_By>;
  max_deductions?: InputMaybe<Order_By>;
  net_mrr?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  net_unit_price?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_of_months_deposit?: InputMaybe<Order_By>;
  option_discount?: InputMaybe<Order_By>;
  package_cost?: InputMaybe<Order_By>;
  package_list_total?: InputMaybe<Order_By>;
  package_total?: InputMaybe<Order_By>;
  percent_of_total?: InputMaybe<Order_By>;
  percent_of_total_percentage?: InputMaybe<Order_By>;
  percent_of_total_scope?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  platform_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  platform_percentage_of_inventory?: InputMaybe<Order_By>;
  previous_segment_regular_price?: InputMaybe<Order_By>;
  previous_segment_uplift?: InputMaybe<Order_By>;
  pricing_information_unit_net_price?: InputMaybe<Order_By>;
  prorate_amount_discount?: InputMaybe<Order_By>;
  prorate_multiplier?: InputMaybe<Order_By>;
  prorated_list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  regular_unit_price?: InputMaybe<Order_By>;
  segment_index?: InputMaybe<Order_By>;
  special_price?: InputMaybe<Order_By>;
  total_discount?: InputMaybe<Order_By>;
  total_discount_percentage?: InputMaybe<Order_By>;
  unit_cost?: InputMaybe<Order_By>;
  unit_net_price?: InputMaybe<Order_By>;
  unprorated_net_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quote_Line_Variance_Fields = {
  __typename?: 'quote_line_variance_fields';
  additional_discount?: Maybe<Scalars['Float']>;
  additional_discount_percentage?: Maybe<Scalars['Float']>;
  adsplus_percent_of_total?: Maybe<Scalars['Float']>;
  adsplus_revenue_share?: Maybe<Scalars['Float']>;
  amagi_adsplus_revenue_share?: Maybe<Scalars['Float']>;
  amagi_percentage_of_inventory?: Maybe<Scalars['Float']>;
  approvals_quantity?: Maybe<Scalars['Float']>;
  billable_unit_price?: Maybe<Scalars['Float']>;
  compound_discount?: Maybe<Scalars['Float']>;
  content_partner_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  content_partner_ads_plus_commission_percentage?: Maybe<Scalars['Float']>;
  contracted_price?: Maybe<Scalars['Float']>;
  customer_percentage_of_inventory?: Maybe<Scalars['Float']>;
  customer_total?: Maybe<Scalars['Float']>;
  customer_unit_price?: Maybe<Scalars['Float']>;
  effective_subscription_term?: Maybe<Scalars['Float']>;
  guidance?: Maybe<Scalars['Float']>;
  list_total?: Maybe<Scalars['Float']>;
  list_unit_price?: Maybe<Scalars['Float']>;
  markup?: Maybe<Scalars['Float']>;
  max_deductions?: Maybe<Scalars['Float']>;
  net_mrr?: Maybe<Scalars['Float']>;
  net_total?: Maybe<Scalars['Float']>;
  net_unit_price?: Maybe<Scalars['Float']>;
  number?: Maybe<Scalars['Float']>;
  number_of_months_deposit?: Maybe<Scalars['Float']>;
  option_discount?: Maybe<Scalars['Float']>;
  package_cost?: Maybe<Scalars['Float']>;
  package_list_total?: Maybe<Scalars['Float']>;
  package_total?: Maybe<Scalars['Float']>;
  percent_of_total?: Maybe<Scalars['Float']>;
  percent_of_total_percentage?: Maybe<Scalars['Float']>;
  percent_of_total_scope?: Maybe<Scalars['Float']>;
  platform_ad_sales_commission_percentage?: Maybe<Scalars['Float']>;
  platform_ads_plus_commission_percentage?: Maybe<Scalars['Float']>;
  platform_percentage_of_inventory?: Maybe<Scalars['Float']>;
  previous_segment_regular_price?: Maybe<Scalars['Float']>;
  previous_segment_uplift?: Maybe<Scalars['Float']>;
  pricing_information_unit_net_price?: Maybe<Scalars['Float']>;
  prorate_amount_discount?: Maybe<Scalars['Float']>;
  prorate_multiplier?: Maybe<Scalars['Float']>;
  prorated_list_price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  regular_unit_price?: Maybe<Scalars['Float']>;
  segment_index?: Maybe<Scalars['Float']>;
  special_price?: Maybe<Scalars['Float']>;
  total_discount?: Maybe<Scalars['Float']>;
  total_discount_percentage?: Maybe<Scalars['Float']>;
  unit_cost?: Maybe<Scalars['Float']>;
  unit_net_price?: Maybe<Scalars['Float']>;
  unprorated_net_price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "quote_line" */
export type Quote_Line_Variance_Order_By = {
  additional_discount?: InputMaybe<Order_By>;
  additional_discount_percentage?: InputMaybe<Order_By>;
  adsplus_percent_of_total?: InputMaybe<Order_By>;
  adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_adsplus_revenue_share?: InputMaybe<Order_By>;
  amagi_percentage_of_inventory?: InputMaybe<Order_By>;
  approvals_quantity?: InputMaybe<Order_By>;
  billable_unit_price?: InputMaybe<Order_By>;
  compound_discount?: InputMaybe<Order_By>;
  content_partner_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  content_partner_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  contracted_price?: InputMaybe<Order_By>;
  customer_percentage_of_inventory?: InputMaybe<Order_By>;
  customer_total?: InputMaybe<Order_By>;
  customer_unit_price?: InputMaybe<Order_By>;
  effective_subscription_term?: InputMaybe<Order_By>;
  guidance?: InputMaybe<Order_By>;
  list_total?: InputMaybe<Order_By>;
  list_unit_price?: InputMaybe<Order_By>;
  markup?: InputMaybe<Order_By>;
  max_deductions?: InputMaybe<Order_By>;
  net_mrr?: InputMaybe<Order_By>;
  net_total?: InputMaybe<Order_By>;
  net_unit_price?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  number_of_months_deposit?: InputMaybe<Order_By>;
  option_discount?: InputMaybe<Order_By>;
  package_cost?: InputMaybe<Order_By>;
  package_list_total?: InputMaybe<Order_By>;
  package_total?: InputMaybe<Order_By>;
  percent_of_total?: InputMaybe<Order_By>;
  percent_of_total_percentage?: InputMaybe<Order_By>;
  percent_of_total_scope?: InputMaybe<Order_By>;
  platform_ad_sales_commission_percentage?: InputMaybe<Order_By>;
  platform_ads_plus_commission_percentage?: InputMaybe<Order_By>;
  platform_percentage_of_inventory?: InputMaybe<Order_By>;
  previous_segment_regular_price?: InputMaybe<Order_By>;
  previous_segment_uplift?: InputMaybe<Order_By>;
  pricing_information_unit_net_price?: InputMaybe<Order_By>;
  prorate_amount_discount?: InputMaybe<Order_By>;
  prorate_multiplier?: InputMaybe<Order_By>;
  prorated_list_price?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  regular_unit_price?: InputMaybe<Order_By>;
  segment_index?: InputMaybe<Order_By>;
  special_price?: InputMaybe<Order_By>;
  total_discount?: InputMaybe<Order_By>;
  total_discount_percentage?: InputMaybe<Order_By>;
  unit_cost?: InputMaybe<Order_By>;
  unit_net_price?: InputMaybe<Order_By>;
  unprorated_net_price?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Quote_Max_Fields = {
  __typename?: 'quote_max_fields';
  accepted_date_time?: Maybe<Scalars['timestamptz']>;
  additional_discount_amount?: Maybe<Scalars['numeric']>;
  annual_contract_value?: Maybe<Scalars['numeric']>;
  avg_customer_discount?: Maybe<Scalars['float8']>;
  bill_to_city?: Maybe<Scalars['String']>;
  bill_to_country?: Maybe<Scalars['String']>;
  bill_to_name?: Maybe<Scalars['String']>;
  bill_to_postal_code?: Maybe<Scalars['String']>;
  bill_to_state?: Maybe<Scalars['String']>;
  bill_to_street?: Maybe<Scalars['String']>;
  deposit?: Maybe<Scalars['String']>;
  deposit_fee?: Maybe<Scalars['numeric']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  estimated_cdn_consumption_fees?: Maybe<Scalars['numeric']>;
  exclude_distribution_partners?: Maybe<Scalars['String']>;
  fixed_recurring?: Maybe<Scalars['String']>;
  go_live_date?: Maybe<Scalars['timestamptz']>;
  initial_fees?: Maybe<Scalars['numeric']>;
  lifetime_contract_value?: Maybe<Scalars['numeric']>;
  max_discount_rate?: Maybe<Scalars['float8']>;
  monthly_fees?: Maybe<Scalars['numeric']>;
  msa_quote?: Maybe<Scalars['String']>;
  msa_quote_type?: Maybe<Scalars['String']>;
  net_amount?: Maybe<Scalars['numeric']>;
  no_of_months_deposit?: Maybe<Scalars['float8']>;
  one_time?: Maybe<Scalars['String']>;
  original_quote_monthly_fees?: Maybe<Scalars['float8']>;
  primary_contact?: Maybe<Scalars['String']>;
  quote_accepted_date?: Maybe<Scalars['timestamptz']>;
  quote_created_date?: Maybe<Scalars['timestamptz']>;
  quote_expires_on?: Maybe<Scalars['timestamptz']>;
  quote_number?: Maybe<Scalars['String']>;
  quote_totals_net_amount?: Maybe<Scalars['numeric']>;
  quote_type?: Maybe<Scalars['String']>;
  record_type?: Maybe<Scalars['String']>;
  renewal_term?: Maybe<Scalars['float8']>;
  renewal_uplift?: Maybe<Scalars['float8']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_opportunity_id?: Maybe<Scalars['String']>;
  ship_to_city?: Maybe<Scalars['String']>;
  ship_to_country?: Maybe<Scalars['String']>;
  ship_to_name?: Maybe<Scalars['String']>;
  ship_to_postal_code?: Maybe<Scalars['String']>;
  ship_to_state?: Maybe<Scalars['String']>;
  ship_to_street?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  subscription_term?: Maybe<Scalars['float8']>;
  territory?: Maybe<Scalars['String']>;
  territory_text_1?: Maybe<Scalars['String']>;
  territory_text_2?: Maybe<Scalars['String']>;
  variable_recurring?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "quote" */
export type Quote_Max_Order_By = {
  accepted_date_time?: InputMaybe<Order_By>;
  additional_discount_amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  avg_customer_discount?: InputMaybe<Order_By>;
  bill_to_city?: InputMaybe<Order_By>;
  bill_to_country?: InputMaybe<Order_By>;
  bill_to_name?: InputMaybe<Order_By>;
  bill_to_postal_code?: InputMaybe<Order_By>;
  bill_to_state?: InputMaybe<Order_By>;
  bill_to_street?: InputMaybe<Order_By>;
  deposit?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  estimated_cdn_consumption_fees?: InputMaybe<Order_By>;
  exclude_distribution_partners?: InputMaybe<Order_By>;
  fixed_recurring?: InputMaybe<Order_By>;
  go_live_date?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  max_discount_rate?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  msa_quote?: InputMaybe<Order_By>;
  msa_quote_type?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  no_of_months_deposit?: InputMaybe<Order_By>;
  one_time?: InputMaybe<Order_By>;
  original_quote_monthly_fees?: InputMaybe<Order_By>;
  primary_contact?: InputMaybe<Order_By>;
  quote_accepted_date?: InputMaybe<Order_By>;
  quote_created_date?: InputMaybe<Order_By>;
  quote_expires_on?: InputMaybe<Order_By>;
  quote_number?: InputMaybe<Order_By>;
  quote_totals_net_amount?: InputMaybe<Order_By>;
  quote_type?: InputMaybe<Order_By>;
  record_type?: InputMaybe<Order_By>;
  renewal_term?: InputMaybe<Order_By>;
  renewal_uplift?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_opportunity_id?: InputMaybe<Order_By>;
  ship_to_city?: InputMaybe<Order_By>;
  ship_to_country?: InputMaybe<Order_By>;
  ship_to_name?: InputMaybe<Order_By>;
  ship_to_postal_code?: InputMaybe<Order_By>;
  ship_to_state?: InputMaybe<Order_By>;
  ship_to_street?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subscription_term?: InputMaybe<Order_By>;
  territory?: InputMaybe<Order_By>;
  territory_text_1?: InputMaybe<Order_By>;
  territory_text_2?: InputMaybe<Order_By>;
  variable_recurring?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Quote_Min_Fields = {
  __typename?: 'quote_min_fields';
  accepted_date_time?: Maybe<Scalars['timestamptz']>;
  additional_discount_amount?: Maybe<Scalars['numeric']>;
  annual_contract_value?: Maybe<Scalars['numeric']>;
  avg_customer_discount?: Maybe<Scalars['float8']>;
  bill_to_city?: Maybe<Scalars['String']>;
  bill_to_country?: Maybe<Scalars['String']>;
  bill_to_name?: Maybe<Scalars['String']>;
  bill_to_postal_code?: Maybe<Scalars['String']>;
  bill_to_state?: Maybe<Scalars['String']>;
  bill_to_street?: Maybe<Scalars['String']>;
  deposit?: Maybe<Scalars['String']>;
  deposit_fee?: Maybe<Scalars['numeric']>;
  end_date?: Maybe<Scalars['timestamptz']>;
  estimated_cdn_consumption_fees?: Maybe<Scalars['numeric']>;
  exclude_distribution_partners?: Maybe<Scalars['String']>;
  fixed_recurring?: Maybe<Scalars['String']>;
  go_live_date?: Maybe<Scalars['timestamptz']>;
  initial_fees?: Maybe<Scalars['numeric']>;
  lifetime_contract_value?: Maybe<Scalars['numeric']>;
  max_discount_rate?: Maybe<Scalars['float8']>;
  monthly_fees?: Maybe<Scalars['numeric']>;
  msa_quote?: Maybe<Scalars['String']>;
  msa_quote_type?: Maybe<Scalars['String']>;
  net_amount?: Maybe<Scalars['numeric']>;
  no_of_months_deposit?: Maybe<Scalars['float8']>;
  one_time?: Maybe<Scalars['String']>;
  original_quote_monthly_fees?: Maybe<Scalars['float8']>;
  primary_contact?: Maybe<Scalars['String']>;
  quote_accepted_date?: Maybe<Scalars['timestamptz']>;
  quote_created_date?: Maybe<Scalars['timestamptz']>;
  quote_expires_on?: Maybe<Scalars['timestamptz']>;
  quote_number?: Maybe<Scalars['String']>;
  quote_totals_net_amount?: Maybe<Scalars['numeric']>;
  quote_type?: Maybe<Scalars['String']>;
  record_type?: Maybe<Scalars['String']>;
  renewal_term?: Maybe<Scalars['float8']>;
  renewal_uplift?: Maybe<Scalars['float8']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_opportunity_id?: Maybe<Scalars['String']>;
  ship_to_city?: Maybe<Scalars['String']>;
  ship_to_country?: Maybe<Scalars['String']>;
  ship_to_name?: Maybe<Scalars['String']>;
  ship_to_postal_code?: Maybe<Scalars['String']>;
  ship_to_state?: Maybe<Scalars['String']>;
  ship_to_street?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  subscription_term?: Maybe<Scalars['float8']>;
  territory?: Maybe<Scalars['String']>;
  territory_text_1?: Maybe<Scalars['String']>;
  territory_text_2?: Maybe<Scalars['String']>;
  variable_recurring?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "quote" */
export type Quote_Min_Order_By = {
  accepted_date_time?: InputMaybe<Order_By>;
  additional_discount_amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  avg_customer_discount?: InputMaybe<Order_By>;
  bill_to_city?: InputMaybe<Order_By>;
  bill_to_country?: InputMaybe<Order_By>;
  bill_to_name?: InputMaybe<Order_By>;
  bill_to_postal_code?: InputMaybe<Order_By>;
  bill_to_state?: InputMaybe<Order_By>;
  bill_to_street?: InputMaybe<Order_By>;
  deposit?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  estimated_cdn_consumption_fees?: InputMaybe<Order_By>;
  exclude_distribution_partners?: InputMaybe<Order_By>;
  fixed_recurring?: InputMaybe<Order_By>;
  go_live_date?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  max_discount_rate?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  msa_quote?: InputMaybe<Order_By>;
  msa_quote_type?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  no_of_months_deposit?: InputMaybe<Order_By>;
  one_time?: InputMaybe<Order_By>;
  original_quote_monthly_fees?: InputMaybe<Order_By>;
  primary_contact?: InputMaybe<Order_By>;
  quote_accepted_date?: InputMaybe<Order_By>;
  quote_created_date?: InputMaybe<Order_By>;
  quote_expires_on?: InputMaybe<Order_By>;
  quote_number?: InputMaybe<Order_By>;
  quote_totals_net_amount?: InputMaybe<Order_By>;
  quote_type?: InputMaybe<Order_By>;
  record_type?: InputMaybe<Order_By>;
  renewal_term?: InputMaybe<Order_By>;
  renewal_uplift?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_opportunity_id?: InputMaybe<Order_By>;
  ship_to_city?: InputMaybe<Order_By>;
  ship_to_country?: InputMaybe<Order_By>;
  ship_to_name?: InputMaybe<Order_By>;
  ship_to_postal_code?: InputMaybe<Order_By>;
  ship_to_state?: InputMaybe<Order_By>;
  ship_to_street?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subscription_term?: InputMaybe<Order_By>;
  territory?: InputMaybe<Order_By>;
  territory_text_1?: InputMaybe<Order_By>;
  territory_text_2?: InputMaybe<Order_By>;
  variable_recurring?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "quote". */
export type Quote_Order_By = {
  accepted_date_time?: InputMaybe<Order_By>;
  accepted_quote_actions?: InputMaybe<Order_By>;
  additional_discount_amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  avg_customer_discount?: InputMaybe<Order_By>;
  bill_to_city?: InputMaybe<Order_By>;
  bill_to_country?: InputMaybe<Order_By>;
  bill_to_name?: InputMaybe<Order_By>;
  bill_to_postal_code?: InputMaybe<Order_By>;
  bill_to_state?: InputMaybe<Order_By>;
  bill_to_street?: InputMaybe<Order_By>;
  create_order_without_signed_so?: InputMaybe<Order_By>;
  customer?: InputMaybe<Customer_Order_By>;
  deposit?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  estimated_cdn_consumption_fees?: InputMaybe<Order_By>;
  exclude_distribution_partners?: InputMaybe<Order_By>;
  fixed_recurring?: InputMaybe<Order_By>;
  go_live_date?: InputMaybe<Order_By>;
  group_line_items?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  max_discount_rate?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  msa_quote?: InputMaybe<Order_By>;
  msa_quote_type?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  no_of_months_deposit?: InputMaybe<Order_By>;
  one_time?: InputMaybe<Order_By>;
  opportunity?: InputMaybe<Opportunity_Order_By>;
  ordered_quote_actions?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Order_Aggregate_Order_By>;
  original_quote_monthly_fees?: InputMaybe<Order_By>;
  primary_contact?: InputMaybe<Order_By>;
  primary_quote_actions?: InputMaybe<Order_By>;
  print_line_items?: InputMaybe<Order_By>;
  quote_accepted_date?: InputMaybe<Order_By>;
  quote_created_date?: InputMaybe<Order_By>;
  quote_expires_on?: InputMaybe<Order_By>;
  quote_line_groups_aggregate?: InputMaybe<Quote_Line_Group_Aggregate_Order_By>;
  quote_lines_aggregate?: InputMaybe<Quote_Line_Aggregate_Order_By>;
  quote_number?: InputMaybe<Order_By>;
  quote_totals_net_amount?: InputMaybe<Order_By>;
  quote_type?: InputMaybe<Order_By>;
  record_type?: InputMaybe<Order_By>;
  renewal_term?: InputMaybe<Order_By>;
  renewal_uplift?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_opportunity_id?: InputMaybe<Order_By>;
  ship_to_city?: InputMaybe<Order_By>;
  ship_to_country?: InputMaybe<Order_By>;
  ship_to_name?: InputMaybe<Order_By>;
  ship_to_postal_code?: InputMaybe<Order_By>;
  ship_to_state?: InputMaybe<Order_By>;
  ship_to_street?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subscription_term?: InputMaybe<Order_By>;
  territory?: InputMaybe<Order_By>;
  territory_text_1?: InputMaybe<Order_By>;
  territory_text_2?: InputMaybe<Order_By>;
  variable_recurring?: InputMaybe<Order_By>;
};

/** select columns of table "quote" */
export enum Quote_Select_Column {
  /** column name */
  AcceptedDateTime = 'accepted_date_time',
  /** column name */
  AcceptedQuoteActions = 'accepted_quote_actions',
  /** column name */
  AdditionalDiscountAmount = 'additional_discount_amount',
  /** column name */
  AnnualContractValue = 'annual_contract_value',
  /** column name */
  AvgCustomerDiscount = 'avg_customer_discount',
  /** column name */
  BillToCity = 'bill_to_city',
  /** column name */
  BillToCountry = 'bill_to_country',
  /** column name */
  BillToName = 'bill_to_name',
  /** column name */
  BillToPostalCode = 'bill_to_postal_code',
  /** column name */
  BillToState = 'bill_to_state',
  /** column name */
  BillToStreet = 'bill_to_street',
  /** column name */
  CreateOrderWithoutSignedSo = 'create_order_without_signed_so',
  /** column name */
  Deposit = 'deposit',
  /** column name */
  DepositFee = 'deposit_fee',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EstimatedCdnConsumptionFees = 'estimated_cdn_consumption_fees',
  /** column name */
  ExcludeDistributionPartners = 'exclude_distribution_partners',
  /** column name */
  FixedRecurring = 'fixed_recurring',
  /** column name */
  GoLiveDate = 'go_live_date',
  /** column name */
  GroupLineItems = 'group_line_items',
  /** column name */
  InitialFees = 'initial_fees',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  LifetimeContractValue = 'lifetime_contract_value',
  /** column name */
  MaxDiscountRate = 'max_discount_rate',
  /** column name */
  MonthlyFees = 'monthly_fees',
  /** column name */
  MsaQuote = 'msa_quote',
  /** column name */
  MsaQuoteType = 'msa_quote_type',
  /** column name */
  NetAmount = 'net_amount',
  /** column name */
  NoOfMonthsDeposit = 'no_of_months_deposit',
  /** column name */
  OneTime = 'one_time',
  /** column name */
  OrderedQuoteActions = 'ordered_quote_actions',
  /** column name */
  OriginalQuoteMonthlyFees = 'original_quote_monthly_fees',
  /** column name */
  PrimaryContact = 'primary_contact',
  /** column name */
  PrimaryQuoteActions = 'primary_quote_actions',
  /** column name */
  PrintLineItems = 'print_line_items',
  /** column name */
  QuoteAcceptedDate = 'quote_accepted_date',
  /** column name */
  QuoteCreatedDate = 'quote_created_date',
  /** column name */
  QuoteExpiresOn = 'quote_expires_on',
  /** column name */
  QuoteNumber = 'quote_number',
  /** column name */
  QuoteTotalsNetAmount = 'quote_totals_net_amount',
  /** column name */
  QuoteType = 'quote_type',
  /** column name */
  RecordType = 'record_type',
  /** column name */
  RenewalTerm = 'renewal_term',
  /** column name */
  RenewalUplift = 'renewal_uplift',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceOpportunityId = 'salesforce_opportunity_id',
  /** column name */
  ShipToCity = 'ship_to_city',
  /** column name */
  ShipToCountry = 'ship_to_country',
  /** column name */
  ShipToName = 'ship_to_name',
  /** column name */
  ShipToPostalCode = 'ship_to_postal_code',
  /** column name */
  ShipToState = 'ship_to_state',
  /** column name */
  ShipToStreet = 'ship_to_street',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  SubscriptionTerm = 'subscription_term',
  /** column name */
  Territory = 'territory',
  /** column name */
  TerritoryText_1 = 'territory_text_1',
  /** column name */
  TerritoryText_2 = 'territory_text_2',
  /** column name */
  VariableRecurring = 'variable_recurring'
}

/** select "quote_aggregate_bool_exp_avg_arguments_columns" columns of table "quote" */
export enum Quote_Select_Column_Quote_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  AvgCustomerDiscount = 'avg_customer_discount',
  /** column name */
  MaxDiscountRate = 'max_discount_rate',
  /** column name */
  NoOfMonthsDeposit = 'no_of_months_deposit',
  /** column name */
  OriginalQuoteMonthlyFees = 'original_quote_monthly_fees',
  /** column name */
  RenewalTerm = 'renewal_term',
  /** column name */
  RenewalUplift = 'renewal_uplift',
  /** column name */
  SubscriptionTerm = 'subscription_term'
}

/** select "quote_aggregate_bool_exp_bool_and_arguments_columns" columns of table "quote" */
export enum Quote_Select_Column_Quote_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AcceptedQuoteActions = 'accepted_quote_actions',
  /** column name */
  CreateOrderWithoutSignedSo = 'create_order_without_signed_so',
  /** column name */
  GroupLineItems = 'group_line_items',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  OrderedQuoteActions = 'ordered_quote_actions',
  /** column name */
  PrimaryQuoteActions = 'primary_quote_actions',
  /** column name */
  PrintLineItems = 'print_line_items'
}

/** select "quote_aggregate_bool_exp_bool_or_arguments_columns" columns of table "quote" */
export enum Quote_Select_Column_Quote_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AcceptedQuoteActions = 'accepted_quote_actions',
  /** column name */
  CreateOrderWithoutSignedSo = 'create_order_without_signed_so',
  /** column name */
  GroupLineItems = 'group_line_items',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  OrderedQuoteActions = 'ordered_quote_actions',
  /** column name */
  PrimaryQuoteActions = 'primary_quote_actions',
  /** column name */
  PrintLineItems = 'print_line_items'
}

/** select "quote_aggregate_bool_exp_corr_arguments_columns" columns of table "quote" */
export enum Quote_Select_Column_Quote_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  AvgCustomerDiscount = 'avg_customer_discount',
  /** column name */
  MaxDiscountRate = 'max_discount_rate',
  /** column name */
  NoOfMonthsDeposit = 'no_of_months_deposit',
  /** column name */
  OriginalQuoteMonthlyFees = 'original_quote_monthly_fees',
  /** column name */
  RenewalTerm = 'renewal_term',
  /** column name */
  RenewalUplift = 'renewal_uplift',
  /** column name */
  SubscriptionTerm = 'subscription_term'
}

/** select "quote_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "quote" */
export enum Quote_Select_Column_Quote_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  AvgCustomerDiscount = 'avg_customer_discount',
  /** column name */
  MaxDiscountRate = 'max_discount_rate',
  /** column name */
  NoOfMonthsDeposit = 'no_of_months_deposit',
  /** column name */
  OriginalQuoteMonthlyFees = 'original_quote_monthly_fees',
  /** column name */
  RenewalTerm = 'renewal_term',
  /** column name */
  RenewalUplift = 'renewal_uplift',
  /** column name */
  SubscriptionTerm = 'subscription_term'
}

/** select "quote_aggregate_bool_exp_max_arguments_columns" columns of table "quote" */
export enum Quote_Select_Column_Quote_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  AvgCustomerDiscount = 'avg_customer_discount',
  /** column name */
  MaxDiscountRate = 'max_discount_rate',
  /** column name */
  NoOfMonthsDeposit = 'no_of_months_deposit',
  /** column name */
  OriginalQuoteMonthlyFees = 'original_quote_monthly_fees',
  /** column name */
  RenewalTerm = 'renewal_term',
  /** column name */
  RenewalUplift = 'renewal_uplift',
  /** column name */
  SubscriptionTerm = 'subscription_term'
}

/** select "quote_aggregate_bool_exp_min_arguments_columns" columns of table "quote" */
export enum Quote_Select_Column_Quote_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  AvgCustomerDiscount = 'avg_customer_discount',
  /** column name */
  MaxDiscountRate = 'max_discount_rate',
  /** column name */
  NoOfMonthsDeposit = 'no_of_months_deposit',
  /** column name */
  OriginalQuoteMonthlyFees = 'original_quote_monthly_fees',
  /** column name */
  RenewalTerm = 'renewal_term',
  /** column name */
  RenewalUplift = 'renewal_uplift',
  /** column name */
  SubscriptionTerm = 'subscription_term'
}

/** select "quote_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "quote" */
export enum Quote_Select_Column_Quote_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  AvgCustomerDiscount = 'avg_customer_discount',
  /** column name */
  MaxDiscountRate = 'max_discount_rate',
  /** column name */
  NoOfMonthsDeposit = 'no_of_months_deposit',
  /** column name */
  OriginalQuoteMonthlyFees = 'original_quote_monthly_fees',
  /** column name */
  RenewalTerm = 'renewal_term',
  /** column name */
  RenewalUplift = 'renewal_uplift',
  /** column name */
  SubscriptionTerm = 'subscription_term'
}

/** select "quote_aggregate_bool_exp_sum_arguments_columns" columns of table "quote" */
export enum Quote_Select_Column_Quote_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  AvgCustomerDiscount = 'avg_customer_discount',
  /** column name */
  MaxDiscountRate = 'max_discount_rate',
  /** column name */
  NoOfMonthsDeposit = 'no_of_months_deposit',
  /** column name */
  OriginalQuoteMonthlyFees = 'original_quote_monthly_fees',
  /** column name */
  RenewalTerm = 'renewal_term',
  /** column name */
  RenewalUplift = 'renewal_uplift',
  /** column name */
  SubscriptionTerm = 'subscription_term'
}

/** select "quote_aggregate_bool_exp_var_samp_arguments_columns" columns of table "quote" */
export enum Quote_Select_Column_Quote_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  AvgCustomerDiscount = 'avg_customer_discount',
  /** column name */
  MaxDiscountRate = 'max_discount_rate',
  /** column name */
  NoOfMonthsDeposit = 'no_of_months_deposit',
  /** column name */
  OriginalQuoteMonthlyFees = 'original_quote_monthly_fees',
  /** column name */
  RenewalTerm = 'renewal_term',
  /** column name */
  RenewalUplift = 'renewal_uplift',
  /** column name */
  SubscriptionTerm = 'subscription_term'
}

/** aggregate stddev on columns */
export type Quote_Stddev_Fields = {
  __typename?: 'quote_stddev_fields';
  additional_discount_amount?: Maybe<Scalars['Float']>;
  annual_contract_value?: Maybe<Scalars['Float']>;
  avg_customer_discount?: Maybe<Scalars['Float']>;
  deposit_fee?: Maybe<Scalars['Float']>;
  estimated_cdn_consumption_fees?: Maybe<Scalars['Float']>;
  initial_fees?: Maybe<Scalars['Float']>;
  lifetime_contract_value?: Maybe<Scalars['Float']>;
  max_discount_rate?: Maybe<Scalars['Float']>;
  monthly_fees?: Maybe<Scalars['Float']>;
  net_amount?: Maybe<Scalars['Float']>;
  no_of_months_deposit?: Maybe<Scalars['Float']>;
  original_quote_monthly_fees?: Maybe<Scalars['Float']>;
  quote_totals_net_amount?: Maybe<Scalars['Float']>;
  renewal_term?: Maybe<Scalars['Float']>;
  renewal_uplift?: Maybe<Scalars['Float']>;
  subscription_term?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "quote" */
export type Quote_Stddev_Order_By = {
  additional_discount_amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  avg_customer_discount?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  estimated_cdn_consumption_fees?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  max_discount_rate?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  no_of_months_deposit?: InputMaybe<Order_By>;
  original_quote_monthly_fees?: InputMaybe<Order_By>;
  quote_totals_net_amount?: InputMaybe<Order_By>;
  renewal_term?: InputMaybe<Order_By>;
  renewal_uplift?: InputMaybe<Order_By>;
  subscription_term?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Quote_Stddev_Pop_Fields = {
  __typename?: 'quote_stddev_pop_fields';
  additional_discount_amount?: Maybe<Scalars['Float']>;
  annual_contract_value?: Maybe<Scalars['Float']>;
  avg_customer_discount?: Maybe<Scalars['Float']>;
  deposit_fee?: Maybe<Scalars['Float']>;
  estimated_cdn_consumption_fees?: Maybe<Scalars['Float']>;
  initial_fees?: Maybe<Scalars['Float']>;
  lifetime_contract_value?: Maybe<Scalars['Float']>;
  max_discount_rate?: Maybe<Scalars['Float']>;
  monthly_fees?: Maybe<Scalars['Float']>;
  net_amount?: Maybe<Scalars['Float']>;
  no_of_months_deposit?: Maybe<Scalars['Float']>;
  original_quote_monthly_fees?: Maybe<Scalars['Float']>;
  quote_totals_net_amount?: Maybe<Scalars['Float']>;
  renewal_term?: Maybe<Scalars['Float']>;
  renewal_uplift?: Maybe<Scalars['Float']>;
  subscription_term?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "quote" */
export type Quote_Stddev_Pop_Order_By = {
  additional_discount_amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  avg_customer_discount?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  estimated_cdn_consumption_fees?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  max_discount_rate?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  no_of_months_deposit?: InputMaybe<Order_By>;
  original_quote_monthly_fees?: InputMaybe<Order_By>;
  quote_totals_net_amount?: InputMaybe<Order_By>;
  renewal_term?: InputMaybe<Order_By>;
  renewal_uplift?: InputMaybe<Order_By>;
  subscription_term?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Quote_Stddev_Samp_Fields = {
  __typename?: 'quote_stddev_samp_fields';
  additional_discount_amount?: Maybe<Scalars['Float']>;
  annual_contract_value?: Maybe<Scalars['Float']>;
  avg_customer_discount?: Maybe<Scalars['Float']>;
  deposit_fee?: Maybe<Scalars['Float']>;
  estimated_cdn_consumption_fees?: Maybe<Scalars['Float']>;
  initial_fees?: Maybe<Scalars['Float']>;
  lifetime_contract_value?: Maybe<Scalars['Float']>;
  max_discount_rate?: Maybe<Scalars['Float']>;
  monthly_fees?: Maybe<Scalars['Float']>;
  net_amount?: Maybe<Scalars['Float']>;
  no_of_months_deposit?: Maybe<Scalars['Float']>;
  original_quote_monthly_fees?: Maybe<Scalars['Float']>;
  quote_totals_net_amount?: Maybe<Scalars['Float']>;
  renewal_term?: Maybe<Scalars['Float']>;
  renewal_uplift?: Maybe<Scalars['Float']>;
  subscription_term?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "quote" */
export type Quote_Stddev_Samp_Order_By = {
  additional_discount_amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  avg_customer_discount?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  estimated_cdn_consumption_fees?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  max_discount_rate?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  no_of_months_deposit?: InputMaybe<Order_By>;
  original_quote_monthly_fees?: InputMaybe<Order_By>;
  quote_totals_net_amount?: InputMaybe<Order_By>;
  renewal_term?: InputMaybe<Order_By>;
  renewal_uplift?: InputMaybe<Order_By>;
  subscription_term?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "quote" */
export type Quote_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Quote_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Quote_Stream_Cursor_Value_Input = {
  accepted_date_time?: InputMaybe<Scalars['timestamptz']>;
  accepted_quote_actions?: InputMaybe<Scalars['Boolean']>;
  additional_discount_amount?: InputMaybe<Scalars['numeric']>;
  annual_contract_value?: InputMaybe<Scalars['numeric']>;
  avg_customer_discount?: InputMaybe<Scalars['float8']>;
  bill_to_city?: InputMaybe<Scalars['String']>;
  bill_to_country?: InputMaybe<Scalars['String']>;
  bill_to_name?: InputMaybe<Scalars['String']>;
  bill_to_postal_code?: InputMaybe<Scalars['String']>;
  bill_to_state?: InputMaybe<Scalars['String']>;
  bill_to_street?: InputMaybe<Scalars['String']>;
  create_order_without_signed_so?: InputMaybe<Scalars['Boolean']>;
  deposit?: InputMaybe<Scalars['String']>;
  deposit_fee?: InputMaybe<Scalars['numeric']>;
  end_date?: InputMaybe<Scalars['timestamptz']>;
  estimated_cdn_consumption_fees?: InputMaybe<Scalars['numeric']>;
  exclude_distribution_partners?: InputMaybe<Scalars['String']>;
  fixed_recurring?: InputMaybe<Scalars['String']>;
  go_live_date?: InputMaybe<Scalars['timestamptz']>;
  group_line_items?: InputMaybe<Scalars['Boolean']>;
  initial_fees?: InputMaybe<Scalars['numeric']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  lifetime_contract_value?: InputMaybe<Scalars['numeric']>;
  max_discount_rate?: InputMaybe<Scalars['float8']>;
  monthly_fees?: InputMaybe<Scalars['numeric']>;
  msa_quote?: InputMaybe<Scalars['String']>;
  msa_quote_type?: InputMaybe<Scalars['String']>;
  net_amount?: InputMaybe<Scalars['numeric']>;
  no_of_months_deposit?: InputMaybe<Scalars['float8']>;
  one_time?: InputMaybe<Scalars['String']>;
  ordered_quote_actions?: InputMaybe<Scalars['Boolean']>;
  original_quote_monthly_fees?: InputMaybe<Scalars['float8']>;
  primary_contact?: InputMaybe<Scalars['String']>;
  primary_quote_actions?: InputMaybe<Scalars['Boolean']>;
  print_line_items?: InputMaybe<Scalars['Boolean']>;
  quote_accepted_date?: InputMaybe<Scalars['timestamptz']>;
  quote_created_date?: InputMaybe<Scalars['timestamptz']>;
  quote_expires_on?: InputMaybe<Scalars['timestamptz']>;
  quote_number?: InputMaybe<Scalars['String']>;
  quote_totals_net_amount?: InputMaybe<Scalars['numeric']>;
  quote_type?: InputMaybe<Scalars['String']>;
  record_type?: InputMaybe<Scalars['String']>;
  renewal_term?: InputMaybe<Scalars['float8']>;
  renewal_uplift?: InputMaybe<Scalars['float8']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_opportunity_id?: InputMaybe<Scalars['String']>;
  ship_to_city?: InputMaybe<Scalars['String']>;
  ship_to_country?: InputMaybe<Scalars['String']>;
  ship_to_name?: InputMaybe<Scalars['String']>;
  ship_to_postal_code?: InputMaybe<Scalars['String']>;
  ship_to_state?: InputMaybe<Scalars['String']>;
  ship_to_street?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  subscription_term?: InputMaybe<Scalars['float8']>;
  territory?: InputMaybe<Scalars['String']>;
  territory_text_1?: InputMaybe<Scalars['String']>;
  territory_text_2?: InputMaybe<Scalars['String']>;
  variable_recurring?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Quote_Sum_Fields = {
  __typename?: 'quote_sum_fields';
  additional_discount_amount?: Maybe<Scalars['numeric']>;
  annual_contract_value?: Maybe<Scalars['numeric']>;
  avg_customer_discount?: Maybe<Scalars['float8']>;
  deposit_fee?: Maybe<Scalars['numeric']>;
  estimated_cdn_consumption_fees?: Maybe<Scalars['numeric']>;
  initial_fees?: Maybe<Scalars['numeric']>;
  lifetime_contract_value?: Maybe<Scalars['numeric']>;
  max_discount_rate?: Maybe<Scalars['float8']>;
  monthly_fees?: Maybe<Scalars['numeric']>;
  net_amount?: Maybe<Scalars['numeric']>;
  no_of_months_deposit?: Maybe<Scalars['float8']>;
  original_quote_monthly_fees?: Maybe<Scalars['float8']>;
  quote_totals_net_amount?: Maybe<Scalars['numeric']>;
  renewal_term?: Maybe<Scalars['float8']>;
  renewal_uplift?: Maybe<Scalars['float8']>;
  subscription_term?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "quote" */
export type Quote_Sum_Order_By = {
  additional_discount_amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  avg_customer_discount?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  estimated_cdn_consumption_fees?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  max_discount_rate?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  no_of_months_deposit?: InputMaybe<Order_By>;
  original_quote_monthly_fees?: InputMaybe<Order_By>;
  quote_totals_net_amount?: InputMaybe<Order_By>;
  renewal_term?: InputMaybe<Order_By>;
  renewal_uplift?: InputMaybe<Order_By>;
  subscription_term?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Quote_Var_Pop_Fields = {
  __typename?: 'quote_var_pop_fields';
  additional_discount_amount?: Maybe<Scalars['Float']>;
  annual_contract_value?: Maybe<Scalars['Float']>;
  avg_customer_discount?: Maybe<Scalars['Float']>;
  deposit_fee?: Maybe<Scalars['Float']>;
  estimated_cdn_consumption_fees?: Maybe<Scalars['Float']>;
  initial_fees?: Maybe<Scalars['Float']>;
  lifetime_contract_value?: Maybe<Scalars['Float']>;
  max_discount_rate?: Maybe<Scalars['Float']>;
  monthly_fees?: Maybe<Scalars['Float']>;
  net_amount?: Maybe<Scalars['Float']>;
  no_of_months_deposit?: Maybe<Scalars['Float']>;
  original_quote_monthly_fees?: Maybe<Scalars['Float']>;
  quote_totals_net_amount?: Maybe<Scalars['Float']>;
  renewal_term?: Maybe<Scalars['Float']>;
  renewal_uplift?: Maybe<Scalars['Float']>;
  subscription_term?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "quote" */
export type Quote_Var_Pop_Order_By = {
  additional_discount_amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  avg_customer_discount?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  estimated_cdn_consumption_fees?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  max_discount_rate?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  no_of_months_deposit?: InputMaybe<Order_By>;
  original_quote_monthly_fees?: InputMaybe<Order_By>;
  quote_totals_net_amount?: InputMaybe<Order_By>;
  renewal_term?: InputMaybe<Order_By>;
  renewal_uplift?: InputMaybe<Order_By>;
  subscription_term?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Quote_Var_Samp_Fields = {
  __typename?: 'quote_var_samp_fields';
  additional_discount_amount?: Maybe<Scalars['Float']>;
  annual_contract_value?: Maybe<Scalars['Float']>;
  avg_customer_discount?: Maybe<Scalars['Float']>;
  deposit_fee?: Maybe<Scalars['Float']>;
  estimated_cdn_consumption_fees?: Maybe<Scalars['Float']>;
  initial_fees?: Maybe<Scalars['Float']>;
  lifetime_contract_value?: Maybe<Scalars['Float']>;
  max_discount_rate?: Maybe<Scalars['Float']>;
  monthly_fees?: Maybe<Scalars['Float']>;
  net_amount?: Maybe<Scalars['Float']>;
  no_of_months_deposit?: Maybe<Scalars['Float']>;
  original_quote_monthly_fees?: Maybe<Scalars['Float']>;
  quote_totals_net_amount?: Maybe<Scalars['Float']>;
  renewal_term?: Maybe<Scalars['Float']>;
  renewal_uplift?: Maybe<Scalars['Float']>;
  subscription_term?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "quote" */
export type Quote_Var_Samp_Order_By = {
  additional_discount_amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  avg_customer_discount?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  estimated_cdn_consumption_fees?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  max_discount_rate?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  no_of_months_deposit?: InputMaybe<Order_By>;
  original_quote_monthly_fees?: InputMaybe<Order_By>;
  quote_totals_net_amount?: InputMaybe<Order_By>;
  renewal_term?: InputMaybe<Order_By>;
  renewal_uplift?: InputMaybe<Order_By>;
  subscription_term?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Quote_Variance_Fields = {
  __typename?: 'quote_variance_fields';
  additional_discount_amount?: Maybe<Scalars['Float']>;
  annual_contract_value?: Maybe<Scalars['Float']>;
  avg_customer_discount?: Maybe<Scalars['Float']>;
  deposit_fee?: Maybe<Scalars['Float']>;
  estimated_cdn_consumption_fees?: Maybe<Scalars['Float']>;
  initial_fees?: Maybe<Scalars['Float']>;
  lifetime_contract_value?: Maybe<Scalars['Float']>;
  max_discount_rate?: Maybe<Scalars['Float']>;
  monthly_fees?: Maybe<Scalars['Float']>;
  net_amount?: Maybe<Scalars['Float']>;
  no_of_months_deposit?: Maybe<Scalars['Float']>;
  original_quote_monthly_fees?: Maybe<Scalars['Float']>;
  quote_totals_net_amount?: Maybe<Scalars['Float']>;
  renewal_term?: Maybe<Scalars['Float']>;
  renewal_uplift?: Maybe<Scalars['Float']>;
  subscription_term?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "quote" */
export type Quote_Variance_Order_By = {
  additional_discount_amount?: InputMaybe<Order_By>;
  annual_contract_value?: InputMaybe<Order_By>;
  avg_customer_discount?: InputMaybe<Order_By>;
  deposit_fee?: InputMaybe<Order_By>;
  estimated_cdn_consumption_fees?: InputMaybe<Order_By>;
  initial_fees?: InputMaybe<Order_By>;
  lifetime_contract_value?: InputMaybe<Order_By>;
  max_discount_rate?: InputMaybe<Order_By>;
  monthly_fees?: InputMaybe<Order_By>;
  net_amount?: InputMaybe<Order_By>;
  no_of_months_deposit?: InputMaybe<Order_By>;
  original_quote_monthly_fees?: InputMaybe<Order_By>;
  quote_totals_net_amount?: InputMaybe<Order_By>;
  renewal_term?: InputMaybe<Order_By>;
  renewal_uplift?: InputMaybe<Order_By>;
  subscription_term?: InputMaybe<Order_By>;
};

export type Receipts_Applied_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Receipts_Total_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Receipts_Unapplied_Customer_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "record_type" */
export type Record_Type = {
  __typename?: 'record_type';
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  customers: Array<Customer>;
  /** An aggregate relationship */
  customers_aggregate: Customer_Aggregate;
  name: Scalars['String'];
  salesforce_created_date: Scalars['timestamptz'];
  salesforce_id: Scalars['String'];
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "record_type" */
export type Record_TypeCustomersArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


/** columns and relationships of "record_type" */
export type Record_TypeCustomers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};

/** aggregated selection of "record_type" */
export type Record_Type_Aggregate = {
  __typename?: 'record_type_aggregate';
  aggregate?: Maybe<Record_Type_Aggregate_Fields>;
  nodes: Array<Record_Type>;
};

/** aggregate fields of "record_type" */
export type Record_Type_Aggregate_Fields = {
  __typename?: 'record_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Record_Type_Max_Fields>;
  min?: Maybe<Record_Type_Min_Fields>;
};


/** aggregate fields of "record_type" */
export type Record_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Record_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "record_type". All fields are combined with a logical 'AND'. */
export type Record_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Record_Type_Bool_Exp>>;
  _not?: InputMaybe<Record_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Record_Type_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  customers?: InputMaybe<Customer_Bool_Exp>;
  customers_aggregate?: InputMaybe<Customer_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  salesforce_created_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_last_modified_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Record_Type_Max_Fields = {
  __typename?: 'record_type_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Record_Type_Min_Fields = {
  __typename?: 'record_type_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  name?: Maybe<Scalars['String']>;
  salesforce_created_date?: Maybe<Scalars['timestamptz']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_last_modified_date?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "record_type". */
export type Record_Type_Order_By = {
  created_at?: InputMaybe<Order_By>;
  customers_aggregate?: InputMaybe<Customer_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  salesforce_created_date?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_last_modified_date?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "record_type" */
export enum Record_Type_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  SalesforceCreatedDate = 'salesforce_created_date',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceLastModifiedDate = 'salesforce_last_modified_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "record_type" */
export type Record_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Record_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Record_Type_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  name?: InputMaybe<Scalars['String']>;
  salesforce_created_date?: InputMaybe<Scalars['timestamptz']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_last_modified_date?: InputMaybe<Scalars['timestamptz']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

export type Search_Channel_Args = {
  _search_query?: InputMaybe<Scalars['String']>;
};

export type Search_Customer_Args = {
  _search_query?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "segment" */
export type Segment = {
  __typename?: 'segment';
  buying_motivation?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  growth_trend?: Maybe<Scalars['String']>;
  industry_size?: Maybe<Scalars['numeric']>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onboarding_preference?: Maybe<Scalars['String']>;
  salesforce_account_id: Scalars['String'];
  solution_complexity?: Maybe<Scalars['String']>;
  solution_delivery_preference?: Maybe<Scalars['String']>;
  support_preference?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "segment" */
export type Segment_Aggregate = {
  __typename?: 'segment_aggregate';
  aggregate?: Maybe<Segment_Aggregate_Fields>;
  nodes: Array<Segment>;
};

/** aggregate fields of "segment" */
export type Segment_Aggregate_Fields = {
  __typename?: 'segment_aggregate_fields';
  avg?: Maybe<Segment_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Segment_Max_Fields>;
  min?: Maybe<Segment_Min_Fields>;
  stddev?: Maybe<Segment_Stddev_Fields>;
  stddev_pop?: Maybe<Segment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Segment_Stddev_Samp_Fields>;
  sum?: Maybe<Segment_Sum_Fields>;
  var_pop?: Maybe<Segment_Var_Pop_Fields>;
  var_samp?: Maybe<Segment_Var_Samp_Fields>;
  variance?: Maybe<Segment_Variance_Fields>;
};


/** aggregate fields of "segment" */
export type Segment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Segment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Segment_Avg_Fields = {
  __typename?: 'segment_avg_fields';
  industry_size?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "segment". All fields are combined with a logical 'AND'. */
export type Segment_Bool_Exp = {
  _and?: InputMaybe<Array<Segment_Bool_Exp>>;
  _not?: InputMaybe<Segment_Bool_Exp>;
  _or?: InputMaybe<Array<Segment_Bool_Exp>>;
  buying_motivation?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  growth_trend?: InputMaybe<String_Comparison_Exp>;
  industry_size?: InputMaybe<Numeric_Comparison_Exp>;
  maturity?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  onboarding_preference?: InputMaybe<String_Comparison_Exp>;
  salesforce_account_id?: InputMaybe<String_Comparison_Exp>;
  solution_complexity?: InputMaybe<String_Comparison_Exp>;
  solution_delivery_preference?: InputMaybe<String_Comparison_Exp>;
  support_preference?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Segment_Max_Fields = {
  __typename?: 'segment_max_fields';
  buying_motivation?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  growth_trend?: Maybe<Scalars['String']>;
  industry_size?: Maybe<Scalars['numeric']>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onboarding_preference?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  solution_complexity?: Maybe<Scalars['String']>;
  solution_delivery_preference?: Maybe<Scalars['String']>;
  support_preference?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Segment_Min_Fields = {
  __typename?: 'segment_min_fields';
  buying_motivation?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  growth_trend?: Maybe<Scalars['String']>;
  industry_size?: Maybe<Scalars['numeric']>;
  maturity?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onboarding_preference?: Maybe<Scalars['String']>;
  salesforce_account_id?: Maybe<Scalars['String']>;
  solution_complexity?: Maybe<Scalars['String']>;
  solution_delivery_preference?: Maybe<Scalars['String']>;
  support_preference?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "segment". */
export type Segment_Order_By = {
  buying_motivation?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  growth_trend?: InputMaybe<Order_By>;
  industry_size?: InputMaybe<Order_By>;
  maturity?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  onboarding_preference?: InputMaybe<Order_By>;
  salesforce_account_id?: InputMaybe<Order_By>;
  solution_complexity?: InputMaybe<Order_By>;
  solution_delivery_preference?: InputMaybe<Order_By>;
  support_preference?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "segment" */
export enum Segment_Select_Column {
  /** column name */
  BuyingMotivation = 'buying_motivation',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GrowthTrend = 'growth_trend',
  /** column name */
  IndustrySize = 'industry_size',
  /** column name */
  Maturity = 'maturity',
  /** column name */
  Name = 'name',
  /** column name */
  OnboardingPreference = 'onboarding_preference',
  /** column name */
  SalesforceAccountId = 'salesforce_account_id',
  /** column name */
  SolutionComplexity = 'solution_complexity',
  /** column name */
  SolutionDeliveryPreference = 'solution_delivery_preference',
  /** column name */
  SupportPreference = 'support_preference',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Segment_Stddev_Fields = {
  __typename?: 'segment_stddev_fields';
  industry_size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Segment_Stddev_Pop_Fields = {
  __typename?: 'segment_stddev_pop_fields';
  industry_size?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Segment_Stddev_Samp_Fields = {
  __typename?: 'segment_stddev_samp_fields';
  industry_size?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "segment" */
export type Segment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Segment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Segment_Stream_Cursor_Value_Input = {
  buying_motivation?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  growth_trend?: InputMaybe<Scalars['String']>;
  industry_size?: InputMaybe<Scalars['numeric']>;
  maturity?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  onboarding_preference?: InputMaybe<Scalars['String']>;
  salesforce_account_id?: InputMaybe<Scalars['String']>;
  solution_complexity?: InputMaybe<Scalars['String']>;
  solution_delivery_preference?: InputMaybe<Scalars['String']>;
  support_preference?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Segment_Sum_Fields = {
  __typename?: 'segment_sum_fields';
  industry_size?: Maybe<Scalars['numeric']>;
};

/** aggregate var_pop on columns */
export type Segment_Var_Pop_Fields = {
  __typename?: 'segment_var_pop_fields';
  industry_size?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Segment_Var_Samp_Fields = {
  __typename?: 'segment_var_samp_fields';
  industry_size?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Segment_Variance_Fields = {
  __typename?: 'segment_variance_fields';
  industry_size?: Maybe<Scalars['Float']>;
};

export type Sf_Ns_Check_Args = {
  _id?: InputMaybe<Scalars['String']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "account" */
  account: Array<Account>;
  /** fetch aggregated fields from the table: "account" */
  account_aggregate: Account_Aggregate;
  /** fetch data from the table: "account" using primary key columns */
  account_by_pk?: Maybe<Account>;
  /** fetch data from the table in a streaming manner: "account" */
  account_stream: Array<Account>;
  /** fetch data from the table: "ads_plus_customer_contacts" */
  ads_plus_customer_contacts: Array<Ads_Plus_Customer_Contacts>;
  /** fetch aggregated fields from the table: "ads_plus_customer_contacts" */
  ads_plus_customer_contacts_aggregate: Ads_Plus_Customer_Contacts_Aggregate;
  /** fetch data from the table in a streaming manner: "ads_plus_customer_contacts" */
  ads_plus_customer_contacts_stream: Array<Ads_Plus_Customer_Contacts>;
  /** fetch data from the table: "case" */
  case: Array<Case>;
  /** fetch aggregated fields from the table: "case" */
  case_aggregate: Case_Aggregate;
  /** fetch data from the table: "case" using primary key columns */
  case_by_pk?: Maybe<Case>;
  /** fetch data from the table in a streaming manner: "case" */
  case_stream: Array<Case>;
  /** fetch data from the table: "cdp_top10_non_paying_cust_mv" */
  cdp_top10_non_paying_cust_mv: Array<cdp_top10_non_paying_cust_mv>;
  /** fetch data from the table in a streaming manner: "cdp_top10_non_paying_cust_mv" */
  cdp_top10_non_paying_cust_mv_stream: Array<cdp_top10_non_paying_cust_mv>;
  /** fetch data from the table: "cdp_top10_paying_cust_mv" */
  cdp_top10_paying_cust_mv: Array<cdp_top10_paying_Cust_Mv>;
  /** fetch data from the table in a streaming manner: "cdp_top10_paying_cust_mv" */
  cdp_top10_paying_cust_mv_stream: Array<cdp_top10_paying_Cust_Mv>;
  /** fetch data from the table: "channel" */
  channel: Array<Channel>;
  /** fetch data from the table: "channel_active" */
  channel_active: Array<Channel_Active>;
  /** fetch aggregated fields from the table: "channel_active" */
  channel_active_aggregate: Channel_Active_Aggregate;
  /** fetch data from the table in a streaming manner: "channel_active" */
  channel_active_stream: Array<Channel_Active>;
  /** fetch aggregated fields from the table: "channel" */
  channel_aggregate: Channel_Aggregate;
  /** fetch data from the table: "channel" using primary key columns */
  channel_by_pk?: Maybe<Channel>;
  /** fetch data from the table: "channel_churned" */
  channel_churned: Array<Channel_Churned>;
  /** fetch aggregated fields from the table: "channel_churned" */
  channel_churned_aggregate: Channel_Churned_Aggregate;
  /** fetch data from the table in a streaming manner: "channel_churned" */
  channel_churned_stream: Array<Channel_Churned>;
  /** fetch data from the table: "channel_delivered_to_go_live" */
  channel_delivered_to_go_live: Array<Channel_Delivered_To_Go_Live>;
  /** fetch data from the table in a streaming manner: "channel_delivered_to_go_live" */
  channel_delivered_to_go_live_stream: Array<Channel_Delivered_To_Go_Live>;
  /** fetch data from the table: "channel_master" */
  channel_master: Array<Channel_Master>;
  /** fetch aggregated fields from the table: "channel_master" */
  channel_master_aggregate: Channel_Master_Aggregate;
  /** fetch data from the table: "channel_master" using primary key columns */
  channel_master_by_pk?: Maybe<Channel_Master>;
  /** fetch data from the table in a streaming manner: "channel_master" */
  channel_master_stream: Array<Channel_Master>;
  /** fetch data from the table: "channel_progress" */
  channel_progress: Array<Channel_Progress>;
  /** fetch aggregated fields from the table: "channel_progress" */
  channel_progress_aggregate: Channel_Progress_Aggregate;
  /** fetch data from the table in a streaming manner: "channel_progress" */
  channel_progress_stream: Array<Channel_Progress>;
  /** fetch data from the table in a streaming manner: "channel" */
  channel_stream: Array<Channel>;
  /** fetch data from the table: "cloudport" */
  cloudport: Array<Cloudport>;
  /** fetch data from the table: "cloudport" using primary key columns */
  cloudport_by_pk?: Maybe<Cloudport>;
  /** fetch data from the table in a streaming manner: "cloudport" */
  cloudport_stream: Array<Cloudport>;
  /** fetch data from the table: "company_address" */
  company_address: Array<Company_Address>;
  /** fetch aggregated fields from the table: "company_address" */
  company_address_aggregate: Company_Address_Aggregate;
  /** fetch data from the table: "company_address" using primary key columns */
  company_address_by_pk?: Maybe<Company_Address>;
  /** fetch data from the table in a streaming manner: "company_address" */
  company_address_stream: Array<Company_Address>;
  /** fetch data from the table: "consumption_rate" */
  consumption_rate: Array<Consumption_Rate>;
  /** fetch aggregated fields from the table: "consumption_rate" */
  consumption_rate_aggregate: Consumption_Rate_Aggregate;
  /** fetch data from the table: "consumption_rate" using primary key columns */
  consumption_rate_by_pk?: Maybe<Consumption_Rate>;
  /** fetch data from the table in a streaming manner: "consumption_rate" */
  consumption_rate_stream: Array<Consumption_Rate>;
  /** fetch data from the table: "consumption_schedule" */
  consumption_schedule: Array<Consumption_Schedule>;
  /** fetch aggregated fields from the table: "consumption_schedule" */
  consumption_schedule_aggregate: Consumption_Schedule_Aggregate;
  /** fetch data from the table: "consumption_schedule" using primary key columns */
  consumption_schedule_by_pk?: Maybe<Consumption_Schedule>;
  /** fetch data from the table in a streaming manner: "consumption_schedule" */
  consumption_schedule_stream: Array<Consumption_Schedule>;
  /** fetch data from the table: "contact" */
  contact: Array<Contact>;
  /** fetch aggregated fields from the table: "contact" */
  contact_aggregate: Contact_Aggregate;
  /** fetch data from the table: "contact" using primary key columns */
  contact_by_pk?: Maybe<Contact>;
  /** fetch data from the table in a streaming manner: "contact" */
  contact_stream: Array<Contact>;
  /** fetch data from the table: "content_plus_contacts" */
  content_plus_contacts: Array<Content_Plus_Contacts>;
  /** fetch data from the table in a streaming manner: "content_plus_contacts" */
  content_plus_contacts_stream: Array<Content_Plus_Contacts>;
  /** execute function "credit_memo_by_id" which returns "fn_return.combined_invoice" */
  credit_memo_by_id: Array<Fn_Return_Combined_Invoice>;
  /** execute function "credit_memo_by_id" and query aggregates on result of table type "fn_return.combined_invoice" */
  credit_memo_by_id_aggregate: Fn_Return_Combined_Invoice_Aggregate;
  /** fetch data from the table: "customer" */
  customer: Array<Customer>;
  /** fetch aggregated fields from the table: "customer" */
  customer_aggregate: Customer_Aggregate;
  /** execute function "customer_by_amagi_id" which returns "customer" */
  customer_by_amagi_id?: Maybe<Customer>;
  /** execute function "customer_by_amagi_id" and query aggregates on result of table type "customer" */
  customer_by_amagi_id_aggregate: Customer_Aggregate;
  /** fetch data from the table: "customer_contract_terms" */
  customer_contract_terms: Array<Customer_Contract_Terms>;
  /** fetch aggregated fields from the table: "customer_contract_terms" */
  customer_contract_terms_aggregate: Customer_Contract_Terms_Aggregate;
  /** fetch data from the table in a streaming manner: "customer_contract_terms" */
  customer_contract_terms_stream: Array<Customer_Contract_Terms>;
  /** execute function "customer_count" which returns "fn_return.customer_type" */
  customer_count: Array<Fn_Return_Customer_Type>;
  /** execute function "customer_industry_segment" which returns "fn_return.customer_industry_type" */
  customer_industry_segment: Array<Fn_Return_Customer_Industry_Type>;
  /** execute function "customer_product_by_amagi_id" which returns "product" */
  customer_product_by_amagi_id: Array<Product>;
  /** execute function "customer_product_by_amagi_id" and query aggregates on result of table type "product" */
  customer_product_by_amagi_id_aggregate: Product_Aggregate;
  /** execute function "customer_product_purchased_by_amagi_id" which returns "fn_return.product_purchased" */
  customer_product_purchased_by_amagi_id: Array<Fn_Return_Product_Purchased>;
  /** fetch data from the table: "customer_product_url" */
  customer_product_url: Array<Customer_Product_Url>;
  /** fetch aggregated fields from the table: "customer_product_url" */
  customer_product_url_aggregate: Customer_Product_Url_Aggregate;
  /** fetch data from the table in a streaming manner: "customer_product_url" */
  customer_product_url_stream: Array<Customer_Product_Url>;
  /** execute function "customer_region_revenue" which returns "fn_return.customer_region_revenue" */
  customer_region_revenue: Array<Fn_Return_Customer_Region_Revenue>;
  /** fetch data from the table: "customer_revenue_segment" */
  customer_revenue_segment: Array<Customer_Revenue_Segment>;
  /** fetch aggregated fields from the table: "customer_revenue_segment" */
  customer_revenue_segment_aggregate: Customer_Revenue_Segment_Aggregate;
  /** fetch data from the table: "customer_revenue_segment" using primary key columns */
  customer_revenue_segment_by_pk?: Maybe<Customer_Revenue_Segment>;
  /** fetch data from the table: "customer_revenue_segment_data" */
  customer_revenue_segment_data: Array<Customer_Revenue_Segment_Data>;
  /** fetch aggregated fields from the table: "customer_revenue_segment_data" */
  customer_revenue_segment_data_aggregate: Customer_Revenue_Segment_Data_Aggregate;
  /** fetch data from the table: "customer_revenue_segment_data" using primary key columns */
  customer_revenue_segment_data_by_pk?: Maybe<Customer_Revenue_Segment_Data>;
  /** fetch data from the table in a streaming manner: "customer_revenue_segment_data" */
  customer_revenue_segment_data_stream: Array<Customer_Revenue_Segment_Data>;
  /** fetch data from the table in a streaming manner: "customer_revenue_segment" */
  customer_revenue_segment_stream: Array<Customer_Revenue_Segment>;
  /** fetch data from the table in a streaming manner: "customer" */
  customer_stream: Array<Customer>;
  /** execute function "customer_tier_revenue" which returns "fn_return.customer_tier_revenue" */
  customer_tier_revenue: Array<Fn_Return_Customer_Tier_Revenue>;
  /** execute function "customer_type" which returns "fn_return.customer_type" */
  customer_type: Array<Fn_Return_Customer_Type>;
  /** execute function "customer_type_revenue" which returns "fn_return.customer_type_revenue" */
  customer_type_revenue: Array<Fn_Return_Customer_Type_Revenue>;
  /** execute function "dashboard_revenue_split" which returns "fn_return.revenue_split" */
  dashboard_revenue_split: Array<Fn_Return_Revenue_Split>;
  /** fetch data from the table: "data_growth" */
  data_growth: Array<Data_Growth>;
  /** fetch data from the table: "data_growth" using primary key columns */
  data_growth_by_pk?: Maybe<Data_Growth>;
  /** fetch data from the table in a streaming manner: "data_growth" */
  data_growth_stream: Array<Data_Growth>;
  /** execute function "data_growth_trend" which returns "fn_return.data_growth_graph" */
  data_growth_trend: Array<Fn_Return_Data_Growth_Graph>;
  /** fetch data from the table: "data_quality" */
  data_quality: Array<Data_Quality>;
  /** fetch data from the table: "data_quality" using primary key columns */
  data_quality_by_pk?: Maybe<Data_Quality>;
  /** fetch data from the table in a streaming manner: "data_quality" */
  data_quality_stream: Array<Data_Quality>;
  /** execute function "data_quality_table" which returns "fn_return.data_quality" */
  data_quality_table: Array<Fn_Return_Data_Quality>;
  /** execute function "data_quality_trend" which returns "fn_return.data_quality_graph" */
  data_quality_trend: Array<Fn_Return_Data_Quality_Graph>;
  /** fetch data from the table: "delivery" */
  delivery: Array<Delivery>;
  /** fetch aggregated fields from the table: "delivery" */
  delivery_aggregate: Delivery_Aggregate;
  /** fetch data from the table: "delivery" using primary key columns */
  delivery_by_pk?: Maybe<Delivery>;
  /** execute function "delivery_channel_platform" which returns "fn_return.delivery_channel_platform" */
  delivery_channel_platform: Array<Fn_Return_Delivery_Channel_Platform>;
  /** execute function "delivery_channel_platform" and query aggregates on result of table type "fn_return.delivery_channel_platform" */
  delivery_channel_platform_aggregate: Fn_Return_Delivery_Channel_Platform_Aggregate;
  /** fetch data from the table: "delivery_main" */
  delivery_main: Array<Delivery_Main>;
  /** fetch aggregated fields from the table: "delivery_main" */
  delivery_main_aggregate: Delivery_Main_Aggregate;
  /** fetch data from the table in a streaming manner: "delivery_main" */
  delivery_main_stream: Array<Delivery_Main>;
  /** fetch data from the table: "delivery_now" */
  delivery_now: Array<Delivery_Now>;
  /** fetch data from the table in a streaming manner: "delivery_now" */
  delivery_now_stream: Array<Delivery_Now>;
  /** execute function "delivery_payload" which returns "fn_return.delivery_payload" */
  delivery_payload: Array<Fn_Return_Delivery_Payload>;
  /** execute function "delivery_payload" and query aggregates on result of table type "fn_return.delivery_payload" */
  delivery_payload_aggregate: Fn_Return_Delivery_Payload_Aggregate;
  /** fetch data from the table in a streaming manner: "delivery" */
  delivery_stream: Array<Delivery>;
  /** fetch data from the table: "delivery_timeline" */
  delivery_timeline: Array<Delivery_Timeline>;
  /** fetch aggregated fields from the table: "delivery_timeline" */
  delivery_timeline_aggregate: Delivery_Timeline_Aggregate;
  /** fetch data from the table in a streaming manner: "delivery_timeline" */
  delivery_timeline_stream: Array<Delivery_Timeline>;
  /** execute function "domain_exist" which returns "fn_return.domain_validation" */
  domain_exist: Array<Fn_Return_Domain_Validation>;
  /** execute function "domain_exist" and query aggregates on result of table type "fn_return.domain_validation" */
  domain_exist_aggregate: Fn_Return_Domain_Validation_Aggregate;
  /** execute function "email_exist" which returns "fn_return.email_validation" */
  email_exist: Array<Fn_Return_Email_Validation>;
  /** execute function "email_exist" and query aggregates on result of table type "fn_return.email_validation" */
  email_exist_aggregate: Fn_Return_Email_Validation_Aggregate;
  /** execute function "existing_new_churned_dashboard" which returns "fn_return.existing_new_churned_dashboard" */
  existing_new_churned_dashboard: Array<Fn_Return_Existing_New_Churned_Dashboard>;
  /** execute function "existing_new_churned_dashboard_channel" which returns "fn_return.existing_new_churned_dashboard" */
  existing_new_churned_dashboard_channel: Array<Fn_Return_Existing_New_Churned_Dashboard>;
  /** execute function "existing_new_churned_platform_dashboard" which returns "fn_return.existing_new_churned_dashboard" */
  existing_new_churned_platform_dashboard: Array<Fn_Return_Existing_New_Churned_Dashboard>;
  /** fetch data from the table: "feature_flag" */
  feature_flag: Array<Feature_Flag>;
  /** fetch data from the table: "feature_flag" using primary key columns */
  feature_flag_by_pk?: Maybe<Feature_Flag>;
  /** fetch data from the table in a streaming manner: "feature_flag" */
  feature_flag_stream: Array<Feature_Flag>;
  /** fetch data from the table: "fn_return.account_statement" */
  fn_return_account_statement: Array<Fn_Return_Account_Statement>;
  /** fetch aggregated fields from the table: "fn_return.account_statement" */
  fn_return_account_statement_aggregate: Fn_Return_Account_Statement_Aggregate;
  /** fetch data from the table: "fn_return.account_statement" using primary key columns */
  fn_return_account_statement_by_pk?: Maybe<Fn_Return_Account_Statement>;
  /** fetch data from the table: "fn_return.account_statement_meta" */
  fn_return_account_statement_meta: Array<Fn_Return_Account_Statement_Meta>;
  /** fetch aggregated fields from the table: "fn_return.account_statement_meta" */
  fn_return_account_statement_meta_aggregate: Fn_Return_Account_Statement_Meta_Aggregate;
  /** fetch data from the table: "fn_return.account_statement_meta" using primary key columns */
  fn_return_account_statement_meta_by_pk?: Maybe<Fn_Return_Account_Statement_Meta>;
  /** fetch data from the table in a streaming manner: "fn_return.account_statement_meta" */
  fn_return_account_statement_meta_stream: Array<Fn_Return_Account_Statement_Meta>;
  /** fetch data from the table: "fn_return.account_statement_outstanding" */
  fn_return_account_statement_outstanding: Array<Fn_Return_Account_Statement_Outstanding>;
  /** fetch aggregated fields from the table: "fn_return.account_statement_outstanding" */
  fn_return_account_statement_outstanding_aggregate: Fn_Return_Account_Statement_Outstanding_Aggregate;
  /** fetch data from the table: "fn_return.account_statement_outstanding" using primary key columns */
  fn_return_account_statement_outstanding_by_pk?: Maybe<Fn_Return_Account_Statement_Outstanding>;
  /** fetch data from the table in a streaming manner: "fn_return.account_statement_outstanding" */
  fn_return_account_statement_outstanding_stream: Array<Fn_Return_Account_Statement_Outstanding>;
  /** fetch data from the table in a streaming manner: "fn_return.account_statement" */
  fn_return_account_statement_stream: Array<Fn_Return_Account_Statement>;
  /** fetch data from the table: "fn_return.account_statement_summary" */
  fn_return_account_statement_summary: Array<Fn_Return_Account_Statement_Summary>;
  /** fetch aggregated fields from the table: "fn_return.account_statement_summary" */
  fn_return_account_statement_summary_aggregate: Fn_Return_Account_Statement_Summary_Aggregate;
  /** fetch data from the table: "fn_return.account_statement_summary" using primary key columns */
  fn_return_account_statement_summary_by_pk?: Maybe<Fn_Return_Account_Statement_Summary>;
  /** fetch data from the table in a streaming manner: "fn_return.account_statement_summary" */
  fn_return_account_statement_summary_stream: Array<Fn_Return_Account_Statement_Summary>;
  /** fetch data from the table: "fn_return.avg_service_availibity" */
  fn_return_avg_service_availibity: Array<Fn_Return_Avg_Service_Availibity>;
  /** fetch aggregated fields from the table: "fn_return.avg_service_availibity" */
  fn_return_avg_service_availibity_aggregate: Fn_Return_Avg_Service_Availibity_Aggregate;
  /** fetch data from the table: "fn_return.avg_service_availibity" using primary key columns */
  fn_return_avg_service_availibity_by_pk?: Maybe<Fn_Return_Avg_Service_Availibity>;
  /** fetch data from the table in a streaming manner: "fn_return.avg_service_availibity" */
  fn_return_avg_service_availibity_stream: Array<Fn_Return_Avg_Service_Availibity>;
  /** fetch data from the table: "fn_return.billing_summary" */
  fn_return_billing_summary: Array<Fn_Return_Billing_Summary>;
  /** fetch aggregated fields from the table: "fn_return.billing_summary" */
  fn_return_billing_summary_aggregate: Fn_Return_Billing_Summary_Aggregate;
  /** fetch data from the table: "fn_return.billing_summary" using primary key columns */
  fn_return_billing_summary_by_pk?: Maybe<Fn_Return_Billing_Summary>;
  /** fetch data from the table in a streaming manner: "fn_return.billing_summary" */
  fn_return_billing_summary_stream: Array<Fn_Return_Billing_Summary>;
  /** fetch data from the table: "fn_return.channel_deliveries_count" */
  fn_return_channel_deliveries_count: Array<Fn_Return_Channel_Deliveries_Count>;
  /** fetch data from the table: "fn_return.channel_deliveries_count" using primary key columns */
  fn_return_channel_deliveries_count_by_pk?: Maybe<Fn_Return_Channel_Deliveries_Count>;
  /** fetch data from the table in a streaming manner: "fn_return.channel_deliveries_count" */
  fn_return_channel_deliveries_count_stream: Array<Fn_Return_Channel_Deliveries_Count>;
  /** fetch data from the table: "fn_return.combined_invoice" */
  fn_return_combined_invoice: Array<Fn_Return_Combined_Invoice>;
  /** fetch aggregated fields from the table: "fn_return.combined_invoice" */
  fn_return_combined_invoice_aggregate: Fn_Return_Combined_Invoice_Aggregate;
  /** fetch data from the table: "fn_return.combined_invoice" using primary key columns */
  fn_return_combined_invoice_by_pk?: Maybe<Fn_Return_Combined_Invoice>;
  /** fetch data from the table: "fn_return.combined_invoice_line" */
  fn_return_combined_invoice_line: Array<Fn_Return_Combined_Invoice_Line>;
  /** fetch aggregated fields from the table: "fn_return.combined_invoice_line" */
  fn_return_combined_invoice_line_aggregate: Fn_Return_Combined_Invoice_Line_Aggregate;
  /** fetch data from the table: "fn_return.combined_invoice_line" using primary key columns */
  fn_return_combined_invoice_line_by_pk?: Maybe<Fn_Return_Combined_Invoice_Line>;
  /** fetch data from the table in a streaming manner: "fn_return.combined_invoice_line" */
  fn_return_combined_invoice_line_stream: Array<Fn_Return_Combined_Invoice_Line>;
  /** fetch data from the table in a streaming manner: "fn_return.combined_invoice" */
  fn_return_combined_invoice_stream: Array<Fn_Return_Combined_Invoice>;
  /** fetch data from the table: "fn_return.combined_receipt" */
  fn_return_combined_receipt: Array<Fn_Return_Combined_Receipt>;
  /** fetch aggregated fields from the table: "fn_return.combined_receipt" */
  fn_return_combined_receipt_aggregate: Fn_Return_Combined_Receipt_Aggregate;
  /** fetch data from the table: "fn_return.combined_receipt_line" */
  fn_return_combined_receipt_line: Array<Fn_Return_Combined_Receipt_Line>;
  /** fetch aggregated fields from the table: "fn_return.combined_receipt_line" */
  fn_return_combined_receipt_line_aggregate: Fn_Return_Combined_Receipt_Line_Aggregate;
  /** fetch data from the table: "fn_return.customer_industry_type" */
  fn_return_customer_industry_type: Array<Fn_Return_Customer_Industry_Type>;
  /** fetch data from the table: "fn_return.customer_industry_type" using primary key columns */
  fn_return_customer_industry_type_by_pk?: Maybe<Fn_Return_Customer_Industry_Type>;
  /** fetch data from the table in a streaming manner: "fn_return.customer_industry_type" */
  fn_return_customer_industry_type_stream: Array<Fn_Return_Customer_Industry_Type>;
  /** fetch data from the table: "fn_return.customer_region_revenue" */
  fn_return_customer_region_revenue: Array<Fn_Return_Customer_Region_Revenue>;
  /** fetch data from the table: "fn_return.customer_region_revenue" using primary key columns */
  fn_return_customer_region_revenue_by_pk?: Maybe<Fn_Return_Customer_Region_Revenue>;
  /** fetch data from the table in a streaming manner: "fn_return.customer_region_revenue" */
  fn_return_customer_region_revenue_stream: Array<Fn_Return_Customer_Region_Revenue>;
  /** fetch data from the table: "fn_return.customer_search" */
  fn_return_customer_search: Array<Fn_Return_Customer_Search>;
  /** fetch aggregated fields from the table: "fn_return.customer_search" */
  fn_return_customer_search_aggregate: Fn_Return_Customer_Search_Aggregate;
  /** fetch data from the table: "fn_return.customer_search" using primary key columns */
  fn_return_customer_search_by_pk?: Maybe<Fn_Return_Customer_Search>;
  /** fetch data from the table in a streaming manner: "fn_return.customer_search" */
  fn_return_customer_search_stream: Array<Fn_Return_Customer_Search>;
  /** fetch data from the table: "fn_return.customer_tier_revenue" */
  fn_return_customer_tier_revenue: Array<Fn_Return_Customer_Tier_Revenue>;
  /** fetch data from the table: "fn_return.customer_tier_revenue" using primary key columns */
  fn_return_customer_tier_revenue_by_pk?: Maybe<Fn_Return_Customer_Tier_Revenue>;
  /** fetch data from the table in a streaming manner: "fn_return.customer_tier_revenue" */
  fn_return_customer_tier_revenue_stream: Array<Fn_Return_Customer_Tier_Revenue>;
  /** fetch data from the table: "fn_return.customer_type" */
  fn_return_customer_type: Array<Fn_Return_Customer_Type>;
  /** fetch data from the table: "fn_return.customer_type" using primary key columns */
  fn_return_customer_type_by_pk?: Maybe<Fn_Return_Customer_Type>;
  /** fetch data from the table: "fn_return.customer_type_revenue" */
  fn_return_customer_type_revenue: Array<Fn_Return_Customer_Type_Revenue>;
  /** fetch data from the table: "fn_return.customer_type_revenue" using primary key columns */
  fn_return_customer_type_revenue_by_pk?: Maybe<Fn_Return_Customer_Type_Revenue>;
  /** fetch data from the table in a streaming manner: "fn_return.customer_type_revenue" */
  fn_return_customer_type_revenue_stream: Array<Fn_Return_Customer_Type_Revenue>;
  /** fetch data from the table in a streaming manner: "fn_return.customer_type" */
  fn_return_customer_type_stream: Array<Fn_Return_Customer_Type>;
  /** fetch data from the table: "fn_return.data_growth_graph" */
  fn_return_data_growth_graph: Array<Fn_Return_Data_Growth_Graph>;
  /** fetch data from the table: "fn_return.data_growth_graph" using primary key columns */
  fn_return_data_growth_graph_by_pk?: Maybe<Fn_Return_Data_Growth_Graph>;
  /** fetch data from the table in a streaming manner: "fn_return.data_growth_graph" */
  fn_return_data_growth_graph_stream: Array<Fn_Return_Data_Growth_Graph>;
  /** fetch data from the table: "fn_return.data_quality" */
  fn_return_data_quality: Array<Fn_Return_Data_Quality>;
  /** fetch data from the table: "fn_return.data_quality" using primary key columns */
  fn_return_data_quality_by_pk?: Maybe<Fn_Return_Data_Quality>;
  /** fetch data from the table: "fn_return.data_quality_graph" */
  fn_return_data_quality_graph: Array<Fn_Return_Data_Quality_Graph>;
  /** fetch data from the table: "fn_return.data_quality_graph" using primary key columns */
  fn_return_data_quality_graph_by_pk?: Maybe<Fn_Return_Data_Quality_Graph>;
  /** fetch data from the table in a streaming manner: "fn_return.data_quality_graph" */
  fn_return_data_quality_graph_stream: Array<Fn_Return_Data_Quality_Graph>;
  /** fetch data from the table in a streaming manner: "fn_return.data_quality" */
  fn_return_data_quality_stream: Array<Fn_Return_Data_Quality>;
  /** fetch data from the table: "fn_return.deliveries_count" */
  fn_return_deliveries_count: Array<Fn_Return_Deliveries_Count>;
  /** fetch aggregated fields from the table: "fn_return.deliveries_count" */
  fn_return_deliveries_count_aggregate: Fn_Return_Deliveries_Count_Aggregate;
  /** fetch data from the table: "fn_return.deliveries_count" using primary key columns */
  fn_return_deliveries_count_by_pk?: Maybe<Fn_Return_Deliveries_Count>;
  /** fetch data from the table in a streaming manner: "fn_return.deliveries_count" */
  fn_return_deliveries_count_stream: Array<Fn_Return_Deliveries_Count>;
  /** fetch data from the table: "fn_return.delivery_channel_platform" */
  fn_return_delivery_channel_platform: Array<Fn_Return_Delivery_Channel_Platform>;
  /** fetch aggregated fields from the table: "fn_return.delivery_channel_platform" */
  fn_return_delivery_channel_platform_aggregate: Fn_Return_Delivery_Channel_Platform_Aggregate;
  /** fetch data from the table: "fn_return.delivery_channel_platform" using primary key columns */
  fn_return_delivery_channel_platform_by_pk?: Maybe<Fn_Return_Delivery_Channel_Platform>;
  /** fetch data from the table in a streaming manner: "fn_return.delivery_channel_platform" */
  fn_return_delivery_channel_platform_stream: Array<Fn_Return_Delivery_Channel_Platform>;
  /** fetch data from the table: "fn_return.delivery_count" */
  fn_return_delivery_count: Array<Fn_Return_Delivery_Count>;
  /** fetch data from the table: "fn_return.delivery_count" using primary key columns */
  fn_return_delivery_count_by_pk?: Maybe<Fn_Return_Delivery_Count>;
  /** fetch data from the table in a streaming manner: "fn_return.delivery_count" */
  fn_return_delivery_count_stream: Array<Fn_Return_Delivery_Count>;
  /** fetch data from the table: "fn_return.delivery_payload" */
  fn_return_delivery_payload: Array<Fn_Return_Delivery_Payload>;
  /** fetch aggregated fields from the table: "fn_return.delivery_payload" */
  fn_return_delivery_payload_aggregate: Fn_Return_Delivery_Payload_Aggregate;
  /** fetch data from the table: "fn_return.delivery_payload" using primary key columns */
  fn_return_delivery_payload_by_pk?: Maybe<Fn_Return_Delivery_Payload>;
  /** fetch data from the table in a streaming manner: "fn_return.delivery_payload" */
  fn_return_delivery_payload_stream: Array<Fn_Return_Delivery_Payload>;
  /** fetch data from the table: "fn_return.delivery_share" */
  fn_return_delivery_share: Array<Fn_Return_Delivery_Share>;
  /** fetch aggregated fields from the table: "fn_return.delivery_share" */
  fn_return_delivery_share_aggregate: Fn_Return_Delivery_Share_Aggregate;
  /** fetch data from the table: "fn_return.delivery_share" using primary key columns */
  fn_return_delivery_share_by_pk?: Maybe<Fn_Return_Delivery_Share>;
  /** fetch data from the table in a streaming manner: "fn_return.delivery_share" */
  fn_return_delivery_share_stream: Array<Fn_Return_Delivery_Share>;
  /** fetch data from the table: "fn_return.domain_validation" */
  fn_return_domain_validation: Array<Fn_Return_Domain_Validation>;
  /** fetch aggregated fields from the table: "fn_return.domain_validation" */
  fn_return_domain_validation_aggregate: Fn_Return_Domain_Validation_Aggregate;
  /** fetch data from the table: "fn_return.domain_validation" using primary key columns */
  fn_return_domain_validation_by_pk?: Maybe<Fn_Return_Domain_Validation>;
  /** fetch data from the table in a streaming manner: "fn_return.domain_validation" */
  fn_return_domain_validation_stream: Array<Fn_Return_Domain_Validation>;
  /** fetch data from the table: "fn_return.email_validation" */
  fn_return_email_validation: Array<Fn_Return_Email_Validation>;
  /** fetch aggregated fields from the table: "fn_return.email_validation" */
  fn_return_email_validation_aggregate: Fn_Return_Email_Validation_Aggregate;
  /** fetch data from the table: "fn_return.email_validation" using primary key columns */
  fn_return_email_validation_by_pk?: Maybe<Fn_Return_Email_Validation>;
  /** fetch data from the table in a streaming manner: "fn_return.email_validation" */
  fn_return_email_validation_stream: Array<Fn_Return_Email_Validation>;
  /** fetch data from the table: "fn_return.existing_new_churned_dashboard" */
  fn_return_existing_new_churned_dashboard: Array<Fn_Return_Existing_New_Churned_Dashboard>;
  /** fetch data from the table: "fn_return.existing_new_churned_dashboard" using primary key columns */
  fn_return_existing_new_churned_dashboard_by_pk?: Maybe<Fn_Return_Existing_New_Churned_Dashboard>;
  /** fetch data from the table in a streaming manner: "fn_return.existing_new_churned_dashboard" */
  fn_return_existing_new_churned_dashboard_stream: Array<Fn_Return_Existing_New_Churned_Dashboard>;
  /** fetch data from the table: "fn_return.financial_graph" */
  fn_return_financial_graph: Array<Fn_Return_Financial_Graph>;
  /** fetch data from the table: "fn_return.financial_graph" using primary key columns */
  fn_return_financial_graph_by_pk?: Maybe<Fn_Return_Financial_Graph>;
  /** fetch data from the table in a streaming manner: "fn_return.financial_graph" */
  fn_return_financial_graph_stream: Array<Fn_Return_Financial_Graph>;
  /** fetch data from the table: "fn_return.latest_mrr" */
  fn_return_latest_mrr: Array<Fn_Return_Latest_Mrr>;
  /** fetch aggregated fields from the table: "fn_return.latest_mrr" */
  fn_return_latest_mrr_aggregate: Fn_Return_Latest_Mrr_Aggregate;
  /** fetch data from the table: "fn_return.latest_mrr" using primary key columns */
  fn_return_latest_mrr_by_pk?: Maybe<Fn_Return_Latest_Mrr>;
  /** fetch data from the table in a streaming manner: "fn_return.latest_mrr" */
  fn_return_latest_mrr_stream: Array<Fn_Return_Latest_Mrr>;
  /** fetch data from the table: "fn_return.msa_rate_card" */
  fn_return_msa_rate_card: Array<Fn_Return_Msa_Rate_Card>;
  /** fetch aggregated fields from the table: "fn_return.msa_rate_card" */
  fn_return_msa_rate_card_aggregate: Fn_Return_Msa_Rate_Card_Aggregate;
  /** fetch data from the table: "fn_return.msa_rate_card" using primary key columns */
  fn_return_msa_rate_card_by_pk?: Maybe<Fn_Return_Msa_Rate_Card>;
  /** fetch data from the table in a streaming manner: "fn_return.msa_rate_card" */
  fn_return_msa_rate_card_stream: Array<Fn_Return_Msa_Rate_Card>;
  /** fetch data from the table: "fn_return.product_financial_graph" */
  fn_return_product_financial_graph: Array<Fn_Return_Product_Financial_Graph>;
  /** fetch data from the table: "fn_return.product_financial_graph" using primary key columns */
  fn_return_product_financial_graph_by_pk?: Maybe<Fn_Return_Product_Financial_Graph>;
  /** fetch data from the table in a streaming manner: "fn_return.product_financial_graph" */
  fn_return_product_financial_graph_stream: Array<Fn_Return_Product_Financial_Graph>;
  /** fetch data from the table: "fn_return.product_purchased" */
  fn_return_product_purchased: Array<Fn_Return_Product_Purchased>;
  /** fetch data from the table: "fn_return.product_purchased" using primary key columns */
  fn_return_product_purchased_by_pk?: Maybe<Fn_Return_Product_Purchased>;
  /** fetch data from the table in a streaming manner: "fn_return.product_purchased" */
  fn_return_product_purchased_stream: Array<Fn_Return_Product_Purchased>;
  /** fetch data from the table: "fn_return.product_table_detail" */
  fn_return_product_table_detail: Array<Fn_Return_Product_Table_Detail>;
  /** fetch data from the table: "fn_return.product_table_detail" using primary key columns */
  fn_return_product_table_detail_by_pk?: Maybe<Fn_Return_Product_Table_Detail>;
  /** fetch data from the table in a streaming manner: "fn_return.product_table_detail" */
  fn_return_product_table_detail_stream: Array<Fn_Return_Product_Table_Detail>;
  /** fetch data from the table: "fn_return.revenue_segment_data" */
  fn_return_revenue_segment_data: Array<Fn_Return_Revenue_Segment_Data>;
  /** fetch aggregated fields from the table: "fn_return.revenue_segment_data" */
  fn_return_revenue_segment_data_aggregate: Fn_Return_Revenue_Segment_Data_Aggregate;
  /** fetch data from the table: "fn_return.revenue_segment_data" using primary key columns */
  fn_return_revenue_segment_data_by_pk?: Maybe<Fn_Return_Revenue_Segment_Data>;
  /** fetch data from the table in a streaming manner: "fn_return.revenue_segment_data" */
  fn_return_revenue_segment_data_stream: Array<Fn_Return_Revenue_Segment_Data>;
  /** fetch data from the table: "fn_return.revenue_split" */
  fn_return_revenue_split: Array<Fn_Return_Revenue_Split>;
  /** fetch data from the table: "fn_return.revenue_split" using primary key columns */
  fn_return_revenue_split_by_pk?: Maybe<Fn_Return_Revenue_Split>;
  /** fetch data from the table in a streaming manner: "fn_return.revenue_split" */
  fn_return_revenue_split_stream: Array<Fn_Return_Revenue_Split>;
  /** fetch data from the table: "fn_return.sales_response" */
  fn_return_sales_response: Array<Fn_Return_Sales_Response>;
  /** fetch data from the table: "fn_return.sales_response" using primary key columns */
  fn_return_sales_response_by_pk?: Maybe<Fn_Return_Sales_Response>;
  /** fetch data from the table in a streaming manner: "fn_return.sales_response" */
  fn_return_sales_response_stream: Array<Fn_Return_Sales_Response>;
  /** fetch data from the table: "fn_return.sf_ns_check" */
  fn_return_sf_ns_check: Array<Fn_Return_Sf_Ns_Check>;
  /** fetch data from the table: "fn_return.sf_ns_check" using primary key columns */
  fn_return_sf_ns_check_by_pk?: Maybe<Fn_Return_Sf_Ns_Check>;
  /** fetch data from the table in a streaming manner: "fn_return.sf_ns_check" */
  fn_return_sf_ns_check_stream: Array<Fn_Return_Sf_Ns_Check>;
  /** fetch data from the table: "fn_return.top_customers" */
  fn_return_top_customers: Array<Fn_Return_Top_Customers>;
  /** fetch data from the table: "fn_return.top_customers" using primary key columns */
  fn_return_top_customers_by_pk?: Maybe<Fn_Return_Top_Customers>;
  /** fetch data from the table in a streaming manner: "fn_return.top_customers" */
  fn_return_top_customers_stream: Array<Fn_Return_Top_Customers>;
  /** fetch data from the table: "fn_return.total_open_close_ticket_dashboard" */
  fn_return_total_open_close_ticket_dashboard: Array<Fn_Return_Total_Open_Close_Ticket_Dashboard>;
  /** fetch aggregated fields from the table: "fn_return.total_open_close_ticket_dashboard" */
  fn_return_total_open_close_ticket_dashboard_aggregate: Fn_Return_Total_Open_Close_Ticket_Dashboard_Aggregate;
  /** fetch data from the table: "fn_return.total_open_close_ticket_dashboard" using primary key columns */
  fn_return_total_open_close_ticket_dashboard_by_pk?: Maybe<Fn_Return_Total_Open_Close_Ticket_Dashboard>;
  /** fetch data from the table in a streaming manner: "fn_return.total_open_close_ticket_dashboard" */
  fn_return_total_open_close_ticket_dashboard_stream: Array<Fn_Return_Total_Open_Close_Ticket_Dashboard>;
  /** fetch data from the table: "freshdesk_company" */
  freshdesk_company: Array<Freshdesk_Company>;
  /** fetch aggregated fields from the table: "freshdesk_company" */
  freshdesk_company_aggregate: Freshdesk_Company_Aggregate;
  /** fetch data from the table: "freshdesk_company" using primary key columns */
  freshdesk_company_by_pk?: Maybe<Freshdesk_Company>;
  /** fetch data from the table in a streaming manner: "freshdesk_company" */
  freshdesk_company_stream: Array<Freshdesk_Company>;
  /** fetch data from the table: "freshdesk_contact" */
  freshdesk_contact: Array<Freshdesk_Contact>;
  /** fetch aggregated fields from the table: "freshdesk_contact" */
  freshdesk_contact_aggregate: Freshdesk_Contact_Aggregate;
  /** fetch data from the table: "freshdesk_contact" using primary key columns */
  freshdesk_contact_by_pk?: Maybe<Freshdesk_Contact>;
  /** fetch data from the table in a streaming manner: "freshdesk_contact" */
  freshdesk_contact_stream: Array<Freshdesk_Contact>;
  /** fetch data from the table: "freshdesk_ticket" */
  freshdesk_ticket: Array<Freshdesk_Ticket>;
  /** fetch aggregated fields from the table: "freshdesk_ticket" */
  freshdesk_ticket_aggregate: Freshdesk_Ticket_Aggregate;
  /** fetch data from the table: "freshdesk_ticket" using primary key columns */
  freshdesk_ticket_by_pk?: Maybe<Freshdesk_Ticket>;
  /** fetch data from the table in a streaming manner: "freshdesk_ticket" */
  freshdesk_ticket_stream: Array<Freshdesk_Ticket>;
  /** fetch data from the table: "incident" */
  incident: Array<Incident>;
  /** fetch aggregated fields from the table: "incident" */
  incident_aggregate: Incident_Aggregate;
  /** fetch data from the table: "incident" using primary key columns */
  incident_by_pk?: Maybe<Incident>;
  /** fetch data from the table in a streaming manner: "incident" */
  incident_stream: Array<Incident>;
  /** fetch data from the table: "invoice" */
  invoice: Array<Invoice>;
  /** fetch aggregated fields from the table: "invoice" */
  invoice_aggregate: Invoice_Aggregate;
  /** execute function "invoice_by_id" which returns "fn_return.combined_invoice" */
  invoice_by_id: Array<Fn_Return_Combined_Invoice>;
  /** execute function "invoice_by_id" and query aggregates on result of table type "fn_return.combined_invoice" */
  invoice_by_id_aggregate: Fn_Return_Combined_Invoice_Aggregate;
  /** fetch data from the table: "invoice" using primary key columns */
  invoice_by_pk?: Maybe<Invoice>;
  /** fetch data from the table: "invoice_line" */
  invoice_line: Array<Invoice_Line>;
  /** fetch aggregated fields from the table: "invoice_line" */
  invoice_line_aggregate: Invoice_Line_Aggregate;
  /** fetch data from the table: "invoice_line" using primary key columns */
  invoice_line_by_pk?: Maybe<Invoice_Line>;
  /** fetch data from the table in a streaming manner: "invoice_line" */
  invoice_line_stream: Array<Invoice_Line>;
  /** execute function "invoice_lines_by_id" which returns "fn_return.combined_invoice_line" */
  invoice_lines_by_id: Array<Fn_Return_Combined_Invoice_Line>;
  /** execute function "invoice_lines_by_id" and query aggregates on result of table type "fn_return.combined_invoice_line" */
  invoice_lines_by_id_aggregate: Fn_Return_Combined_Invoice_Line_Aggregate;
  /** fetch data from the table in a streaming manner: "invoice" */
  invoice_stream: Array<Invoice>;
  /** fetch data from the table: "legal_entity" */
  legal_entity: Array<Legal_Entity>;
  /** fetch aggregated fields from the table: "legal_entity" */
  legal_entity_aggregate: Legal_Entity_Aggregate;
  /** fetch data from the table: "legal_entity" using primary key columns */
  legal_entity_by_pk?: Maybe<Legal_Entity>;
  /** fetch data from the table in a streaming manner: "legal_entity" */
  legal_entity_stream: Array<Legal_Entity>;
  /** fetch data from the table: "media_industry_sub_segment" */
  media_industry_sub_segment: Array<Media_Industry_Sub_Segment>;
  /** fetch aggregated fields from the table: "media_industry_sub_segment" */
  media_industry_sub_segment_aggregate: Media_Industry_Sub_Segment_Aggregate;
  /** fetch data from the table: "media_industry_sub_segment" using primary key columns */
  media_industry_sub_segment_by_pk?: Maybe<Media_Industry_Sub_Segment>;
  /** fetch data from the table in a streaming manner: "media_industry_sub_segment" */
  media_industry_sub_segment_stream: Array<Media_Industry_Sub_Segment>;
  /** fetch data from the table: "msa_master" */
  msa_master: Array<Msa_Master>;
  /** fetch aggregated fields from the table: "msa_master" */
  msa_master_aggregate: Msa_Master_Aggregate;
  /** fetch data from the table in a streaming manner: "msa_master" */
  msa_master_stream: Array<Msa_Master>;
  /** fetch data from the table: "msa_rate_card" */
  msa_rate_card: Array<Msa_Rate_Card>;
  /** fetch aggregated fields from the table: "msa_rate_card" */
  msa_rate_card_aggregate: Msa_Rate_Card_Aggregate;
  /** fetch data from the table: "msa_rate_card" using primary key columns */
  msa_rate_card_by_pk?: Maybe<Msa_Rate_Card>;
  /** execute function "msa_rate_card_fn" which returns "fn_return.msa_rate_card" */
  msa_rate_card_fn: Array<Fn_Return_Msa_Rate_Card>;
  /** execute function "msa_rate_card_fn" and query aggregates on result of table type "fn_return.msa_rate_card" */
  msa_rate_card_fn_aggregate: Fn_Return_Msa_Rate_Card_Aggregate;
  /** fetch data from the table in a streaming manner: "msa_rate_card" */
  msa_rate_card_stream: Array<Msa_Rate_Card>;
  /** execute function "net_invoices_due" which returns "fn_return.billing_summary" */
  net_invoices_due: Array<Fn_Return_Billing_Summary>;
  /** execute function "net_invoices_due" and query aggregates on result of table type "fn_return.billing_summary" */
  net_invoices_due_aggregate: Fn_Return_Billing_Summary_Aggregate;
  /** execute function "net_invoices_outstanding" which returns "fn_return.billing_summary" */
  net_invoices_outstanding: Array<Fn_Return_Billing_Summary>;
  /** execute function "net_invoices_outstanding" and query aggregates on result of table type "fn_return.billing_summary" */
  net_invoices_outstanding_aggregate: Fn_Return_Billing_Summary_Aggregate;
  /** execute function "net_invoices_overdue" which returns "fn_return.billing_summary" */
  net_invoices_overdue: Array<Fn_Return_Billing_Summary>;
  /** execute function "net_invoices_overdue" and query aggregates on result of table type "fn_return.billing_summary" */
  net_invoices_overdue_aggregate: Fn_Return_Billing_Summary_Aggregate;
  /** fetch data from the table: "netsuite_currency_rate" */
  netsuite_currency_rate: Array<Netsuite_Currency_Rate>;
  /** fetch aggregated fields from the table: "netsuite_currency_rate" */
  netsuite_currency_rate_aggregate: Netsuite_Currency_Rate_Aggregate;
  /** fetch data from the table: "netsuite_currency_rate" using primary key columns */
  netsuite_currency_rate_by_pk?: Maybe<Netsuite_Currency_Rate>;
  /** fetch data from the table in a streaming manner: "netsuite_currency_rate" */
  netsuite_currency_rate_stream: Array<Netsuite_Currency_Rate>;
  /** fetch data from the table: "netsuite_receipt" */
  netsuite_receipt: Array<Netsuite_Receipt>;
  /** fetch aggregated fields from the table: "netsuite_receipt" */
  netsuite_receipt_aggregate: Netsuite_Receipt_Aggregate;
  /** fetch data from the table: "netsuite_receipt" using primary key columns */
  netsuite_receipt_by_pk?: Maybe<Netsuite_Receipt>;
  /** fetch data from the table: "netsuite_receipt_line" */
  netsuite_receipt_line: Array<Netsuite_Receipt_Line>;
  /** fetch aggregated fields from the table: "netsuite_receipt_line" */
  netsuite_receipt_line_aggregate: Netsuite_Receipt_Line_Aggregate;
  /** fetch data from the table: "netsuite_receipt_line" using primary key columns */
  netsuite_receipt_line_by_pk?: Maybe<Netsuite_Receipt_Line>;
  /** fetch data from the table in a streaming manner: "netsuite_receipt_line" */
  netsuite_receipt_line_stream: Array<Netsuite_Receipt_Line>;
  /** fetch data from the table in a streaming manner: "netsuite_receipt" */
  netsuite_receipt_stream: Array<Netsuite_Receipt>;
  /** fetch data from the table: "netsuite_tax" */
  netsuite_tax: Array<Netsuite_Tax>;
  /** fetch aggregated fields from the table: "netsuite_tax" */
  netsuite_tax_aggregate: Netsuite_Tax_Aggregate;
  /** fetch data from the table: "netsuite_tax" using primary key columns */
  netsuite_tax_by_pk?: Maybe<Netsuite_Tax>;
  /** fetch data from the table in a streaming manner: "netsuite_tax" */
  netsuite_tax_stream: Array<Netsuite_Tax>;
  /** fetch data from the table: "netsuite_transaction" */
  netsuite_transaction: Array<Netsuite_Transaction>;
  /** fetch aggregated fields from the table: "netsuite_transaction" */
  netsuite_transaction_aggregate: Netsuite_Transaction_Aggregate;
  /** fetch data from the table: "netsuite_transaction" using primary key columns */
  netsuite_transaction_by_pk?: Maybe<Netsuite_Transaction>;
  /** fetch data from the table: "netsuite_transaction_line" */
  netsuite_transaction_line: Array<Netsuite_Transaction_Line>;
  /** fetch aggregated fields from the table: "netsuite_transaction_line" */
  netsuite_transaction_line_aggregate: Netsuite_Transaction_Line_Aggregate;
  /** fetch data from the table: "netsuite_transaction_line" using primary key columns */
  netsuite_transaction_line_by_pk?: Maybe<Netsuite_Transaction_Line>;
  /** fetch data from the table in a streaming manner: "netsuite_transaction_line" */
  netsuite_transaction_line_stream: Array<Netsuite_Transaction_Line>;
  /** fetch data from the table in a streaming manner: "netsuite_transaction" */
  netsuite_transaction_stream: Array<Netsuite_Transaction>;
  /** fetch data from the table: "netsuite_vendor_invoice" */
  netsuite_vendor_invoice: Array<Netsuite_Vendor_Invoice>;
  /** fetch aggregated fields from the table: "netsuite_vendor_invoice" */
  netsuite_vendor_invoice_aggregate: Netsuite_Vendor_Invoice_Aggregate;
  /** fetch data from the table: "netsuite_vendor_invoice" using primary key columns */
  netsuite_vendor_invoice_by_pk?: Maybe<Netsuite_Vendor_Invoice>;
  /** fetch data from the table: "netsuite_vendor_invoice_expense" */
  netsuite_vendor_invoice_expense: Array<Netsuite_Vendor_Invoice_Expense>;
  /** fetch aggregated fields from the table: "netsuite_vendor_invoice_expense" */
  netsuite_vendor_invoice_expense_aggregate: Netsuite_Vendor_Invoice_Expense_Aggregate;
  /** fetch data from the table: "netsuite_vendor_invoice_expense" using primary key columns */
  netsuite_vendor_invoice_expense_by_pk?: Maybe<Netsuite_Vendor_Invoice_Expense>;
  /** fetch data from the table in a streaming manner: "netsuite_vendor_invoice_expense" */
  netsuite_vendor_invoice_expense_stream: Array<Netsuite_Vendor_Invoice_Expense>;
  /** fetch data from the table: "netsuite_vendor_invoice_line" */
  netsuite_vendor_invoice_line: Array<Netsuite_Vendor_Invoice_Line>;
  /** fetch aggregated fields from the table: "netsuite_vendor_invoice_line" */
  netsuite_vendor_invoice_line_aggregate: Netsuite_Vendor_Invoice_Line_Aggregate;
  /** fetch data from the table: "netsuite_vendor_invoice_line" using primary key columns */
  netsuite_vendor_invoice_line_by_pk?: Maybe<Netsuite_Vendor_Invoice_Line>;
  /** fetch data from the table in a streaming manner: "netsuite_vendor_invoice_line" */
  netsuite_vendor_invoice_line_stream: Array<Netsuite_Vendor_Invoice_Line>;
  /** fetch data from the table in a streaming manner: "netsuite_vendor_invoice" */
  netsuite_vendor_invoice_stream: Array<Netsuite_Vendor_Invoice>;
  /** fetch data from the table: "netsuite_vendor_invoice_tax" */
  netsuite_vendor_invoice_tax: Array<Netsuite_Vendor_Invoice_Tax>;
  /** fetch aggregated fields from the table: "netsuite_vendor_invoice_tax" */
  netsuite_vendor_invoice_tax_aggregate: Netsuite_Vendor_Invoice_Tax_Aggregate;
  /** fetch data from the table: "netsuite_vendor_invoice_tax" using primary key columns */
  netsuite_vendor_invoice_tax_by_pk?: Maybe<Netsuite_Vendor_Invoice_Tax>;
  /** fetch data from the table in a streaming manner: "netsuite_vendor_invoice_tax" */
  netsuite_vendor_invoice_tax_stream: Array<Netsuite_Vendor_Invoice_Tax>;
  /** fetch data from the table: "onboarding_customer_contacts" */
  onboarding_customer_contacts: Array<Onboarding_Customer_Contacts>;
  /** fetch aggregated fields from the table: "onboarding_customer_contacts" */
  onboarding_customer_contacts_aggregate: Onboarding_Customer_Contacts_Aggregate;
  /** fetch data from the table in a streaming manner: "onboarding_customer_contacts" */
  onboarding_customer_contacts_stream: Array<Onboarding_Customer_Contacts>;
  /** An array relationship */
  opportunity: Array<Opportunity>;
  /** An aggregate relationship */
  opportunity_aggregate: Opportunity_Aggregate;
  /** fetch data from the table: "opportunity" using primary key columns */
  opportunity_by_pk?: Maybe<Opportunity>;
  /** fetch data from the table: "opportunity_self_serve_information" */
  opportunity_self_serve_information: Array<Opportunity_Self_Serve_Information>;
  /** fetch aggregated fields from the table: "opportunity_self_serve_information" */
  opportunity_self_serve_information_aggregate: Opportunity_Self_Serve_Information_Aggregate;
  /** fetch data from the table in a streaming manner: "opportunity_self_serve_information" */
  opportunity_self_serve_information_stream: Array<Opportunity_Self_Serve_Information>;
  /** fetch data from the table in a streaming manner: "opportunity" */
  opportunity_stream: Array<Opportunity>;
  /** fetch data from the table: "order" */
  order: Array<Order>;
  /** fetch aggregated fields from the table: "order" */
  order_aggregate: Order_Aggregate;
  /** fetch data from the table: "order" using primary key columns */
  order_by_pk?: Maybe<Order>;
  /** fetch data from the table: "order_item" */
  order_item: Array<Order_Item>;
  /** fetch aggregated fields from the table: "order_item" */
  order_item_aggregate: Order_Item_Aggregate;
  /** fetch data from the table: "order_item" using primary key columns */
  order_item_by_pk?: Maybe<Order_Item>;
  /** fetch data from the table: "order_item_line" */
  order_item_line: Array<Order_Item_Line>;
  /** fetch aggregated fields from the table: "order_item_line" */
  order_item_line_aggregate: Order_Item_Line_Aggregate;
  /** fetch data from the table: "order_item_line" using primary key columns */
  order_item_line_by_pk?: Maybe<Order_Item_Line>;
  /** fetch data from the table in a streaming manner: "order_item_line" */
  order_item_line_stream: Array<Order_Item_Line>;
  /** fetch data from the table in a streaming manner: "order_item" */
  order_item_stream: Array<Order_Item>;
  /** fetch data from the table: "order_product" */
  order_product: Array<Order_Product>;
  /** fetch aggregated fields from the table: "order_product" */
  order_product_aggregate: Order_Product_Aggregate;
  /** fetch data from the table: "order_product" using primary key columns */
  order_product_by_pk?: Maybe<Order_Product>;
  /** fetch data from the table in a streaming manner: "order_product" */
  order_product_stream: Array<Order_Product>;
  /** fetch data from the table in a streaming manner: "order" */
  order_stream: Array<Order>;
  /** fetch data from the table: "owner" */
  owner: Array<Owner>;
  /** fetch aggregated fields from the table: "owner" */
  owner_aggregate: Owner_Aggregate;
  /** fetch data from the table: "owner" using primary key columns */
  owner_by_pk?: Maybe<Owner>;
  /** fetch data from the table in a streaming manner: "owner" */
  owner_stream: Array<Owner>;
  /** fetch data from the table: "page" */
  page: Array<Page>;
  /** fetch data from the table: "page" using primary key columns */
  page_by_pk?: Maybe<Page>;
  /** fetch data from the table in a streaming manner: "page" */
  page_stream: Array<Page>;
  /** execute function "partial_text_search" which returns "fn_return.customer_search" */
  partial_text_search: Array<Fn_Return_Customer_Search>;
  /** execute function "partial_text_search" and query aggregates on result of table type "fn_return.customer_search" */
  partial_text_search_aggregate: Fn_Return_Customer_Search_Aggregate;
  /** An array relationship */
  platform: Array<Platform>;
  /** An aggregate relationship */
  platform_aggregate: Platform_Aggregate;
  /** fetch data from the table: "platform" using primary key columns */
  platform_by_pk?: Maybe<Platform>;
  /** fetch data from the table in a streaming manner: "platform" */
  platform_stream: Array<Platform>;
  /** fetch data from the table: "price_book" */
  price_book: Array<Price_Book>;
  /** fetch aggregated fields from the table: "price_book" */
  price_book_aggregate: Price_Book_Aggregate;
  /** fetch data from the table: "price_book" using primary key columns */
  price_book_by_pk?: Maybe<Price_Book>;
  /** fetch data from the table: "price_book_entry" */
  price_book_entry: Array<Price_Book_Entry>;
  /** fetch aggregated fields from the table: "price_book_entry" */
  price_book_entry_aggregate: Price_Book_Entry_Aggregate;
  /** fetch data from the table: "price_book_entry" using primary key columns */
  price_book_entry_by_pk?: Maybe<Price_Book_Entry>;
  /** fetch data from the table in a streaming manner: "price_book_entry" */
  price_book_entry_stream: Array<Price_Book_Entry>;
  /** fetch data from the table in a streaming manner: "price_book" */
  price_book_stream: Array<Price_Book>;
  /** fetch data from the table: "product" */
  product: Array<Product>;
  /** fetch data from the table: "product_active" */
  product_active: Array<Product_Active>;
  /** fetch data from the table in a streaming manner: "product_active" */
  product_active_stream: Array<Product_Active>;
  /** fetch aggregated fields from the table: "product" */
  product_aggregate: Product_Aggregate;
  /** fetch data from the table: "product" using primary key columns */
  product_by_pk?: Maybe<Product>;
  /** fetch data from the table in a streaming manner: "product" */
  product_stream: Array<Product>;
  /** fetch data from the table: "quote" */
  quote: Array<Quote>;
  /** fetch aggregated fields from the table: "quote" */
  quote_aggregate: Quote_Aggregate;
  /** fetch data from the table: "quote" using primary key columns */
  quote_by_pk?: Maybe<Quote>;
  /** fetch data from the table: "quote_line" */
  quote_line: Array<Quote_Line>;
  /** fetch aggregated fields from the table: "quote_line" */
  quote_line_aggregate: Quote_Line_Aggregate;
  /** fetch data from the table: "quote_line" using primary key columns */
  quote_line_by_pk?: Maybe<Quote_Line>;
  /** fetch data from the table: "quote_line_consumption_schedule" */
  quote_line_consumption_schedule: Array<Quote_Line_Consumption_Schedule>;
  /** fetch aggregated fields from the table: "quote_line_consumption_schedule" */
  quote_line_consumption_schedule_aggregate: Quote_Line_Consumption_Schedule_Aggregate;
  /** fetch data from the table: "quote_line_consumption_schedule" using primary key columns */
  quote_line_consumption_schedule_by_pk?: Maybe<Quote_Line_Consumption_Schedule>;
  /** fetch data from the table in a streaming manner: "quote_line_consumption_schedule" */
  quote_line_consumption_schedule_stream: Array<Quote_Line_Consumption_Schedule>;
  /** fetch data from the table: "quote_line_group" */
  quote_line_group: Array<Quote_Line_Group>;
  /** fetch aggregated fields from the table: "quote_line_group" */
  quote_line_group_aggregate: Quote_Line_Group_Aggregate;
  /** fetch data from the table: "quote_line_group" using primary key columns */
  quote_line_group_by_pk?: Maybe<Quote_Line_Group>;
  /** fetch data from the table in a streaming manner: "quote_line_group" */
  quote_line_group_stream: Array<Quote_Line_Group>;
  /** fetch data from the table in a streaming manner: "quote_line" */
  quote_line_stream: Array<Quote_Line>;
  /** fetch data from the table in a streaming manner: "quote" */
  quote_stream: Array<Quote>;
  /** fetch data from the table: "record_type" */
  record_type: Array<Record_Type>;
  /** fetch aggregated fields from the table: "record_type" */
  record_type_aggregate: Record_Type_Aggregate;
  /** fetch data from the table: "record_type" using primary key columns */
  record_type_by_pk?: Maybe<Record_Type>;
  /** fetch data from the table in a streaming manner: "record_type" */
  record_type_stream: Array<Record_Type>;
  /** execute function "revenue_segment_data" which returns "fn_return.revenue_segment_data" */
  revenue_segment_data: Array<Fn_Return_Revenue_Segment_Data>;
  /** execute function "revenue_segment_data" and query aggregates on result of table type "fn_return.revenue_segment_data" */
  revenue_segment_data_aggregate: Fn_Return_Revenue_Segment_Data_Aggregate;
  /** execute function "search_channel" which returns "channel" */
  search_channel: Array<Channel>;
  /** execute function "search_channel" and query aggregates on result of table type "channel" */
  search_channel_aggregate: Channel_Aggregate;
  /** execute function "search_customer" which returns "account" */
  search_customer: Array<Account>;
  /** execute function "search_customer" and query aggregates on result of table type "account" */
  search_customer_aggregate: Account_Aggregate;
  /** fetch data from the table: "segment" */
  segment: Array<Segment>;
  /** fetch aggregated fields from the table: "segment" */
  segment_aggregate: Segment_Aggregate;
  /** fetch data from the table: "segment" using primary key columns */
  segment_by_pk?: Maybe<Segment>;
  /** fetch data from the table in a streaming manner: "segment" */
  segment_stream: Array<Segment>;
  /** execute function "sf_ns_check" which returns "fn_return.sf_ns_check" */
  sf_ns_check: Array<Fn_Return_Sf_Ns_Check>;
  /** execute function "top_customers_consumption" which returns "fn_return.top_customers" */
  top_customers_consumption: Array<Fn_Return_Top_Customers>;
  /** execute function "top_customers_overall" which returns "fn_return.top_customers" */
  top_customers_overall: Array<Fn_Return_Top_Customers>;
  /** execute function "top_customers_subscription" which returns "fn_return.top_customers" */
  top_customers_subscription: Array<Fn_Return_Top_Customers>;
  /** execute function "total_open_close_ticket_dashboard" which returns "fn_return.total_open_close_ticket_dashboard" */
  total_open_close_ticket_dashboard: Array<Fn_Return_Total_Open_Close_Ticket_Dashboard>;
  /** execute function "total_open_close_ticket_dashboard" and query aggregates on result of table type "fn_return.total_open_close_ticket_dashboard" */
  total_open_close_ticket_dashboard_aggregate: Fn_Return_Total_Open_Close_Ticket_Dashboard_Aggregate;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: User_Aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<User>;
};


export type Subscription_RootAccountArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootAccount_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootAccount_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootAccount_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Account_Stream_Cursor_Input>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootAds_Plus_Customer_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Ads_Plus_Customer_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ads_Plus_Customer_Contacts_Order_By>>;
  where?: InputMaybe<Ads_Plus_Customer_Contacts_Bool_Exp>;
};


export type Subscription_RootAds_Plus_Customer_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ads_Plus_Customer_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ads_Plus_Customer_Contacts_Order_By>>;
  where?: InputMaybe<Ads_Plus_Customer_Contacts_Bool_Exp>;
};


export type Subscription_RootAds_Plus_Customer_Contacts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ads_Plus_Customer_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Ads_Plus_Customer_Contacts_Bool_Exp>;
};


export type Subscription_RootCaseArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


export type Subscription_RootCase_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Case_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Case_Order_By>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


export type Subscription_RootCase_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootCase_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Case_Stream_Cursor_Input>>;
  where?: InputMaybe<Case_Bool_Exp>;
};


export type Subscription_Rootcdp_top10_non_paying_Cust_MvArgs = {
  distinct_on?: InputMaybe<Array<cdp_top10_non_paying_Cust_Mv_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<cdp_top10_non_paying_Cust_Mv_Order_By>>;
  where?: InputMaybe<cdp_top10_non_paying_Cust_Mv_Bool_Exp>;
};


export type Subscription_Rootcdp_top10_non_paying_Cust_Mv_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<cdp_top10_non_paying_Cust_Mv_Stream_Cursor_Input>>;
  where?: InputMaybe<cdp_top10_non_paying_Cust_Mv_Bool_Exp>;
};


export type Subscription_Rootcdp_top10_paying_Cust_MvArgs = {
  distinct_on?: InputMaybe<Array<cdp_top10_paying_Cust_Mv_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<cdp_top10_paying_Cust_Mv_Order_By>>;
  where?: InputMaybe<cdp_top10_paying_Cust_Mv_Bool_Exp>;
};


export type Subscription_Rootcdp_top10_paying_Cust_Mv_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<cdp_top10_paying_Cust_Mv_Stream_Cursor_Input>>;
  where?: InputMaybe<cdp_top10_paying_Cust_Mv_Bool_Exp>;
};


export type Subscription_RootChannelArgs = {
  distinct_on?: InputMaybe<Array<Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Order_By>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


export type Subscription_RootChannel_ActiveArgs = {
  distinct_on?: InputMaybe<Array<Channel_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Active_Order_By>>;
  where?: InputMaybe<Channel_Active_Bool_Exp>;
};


export type Subscription_RootChannel_Active_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Active_Order_By>>;
  where?: InputMaybe<Channel_Active_Bool_Exp>;
};


export type Subscription_RootChannel_Active_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Channel_Active_Stream_Cursor_Input>>;
  where?: InputMaybe<Channel_Active_Bool_Exp>;
};


export type Subscription_RootChannel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Order_By>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


export type Subscription_RootChannel_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootChannel_ChurnedArgs = {
  distinct_on?: InputMaybe<Array<Channel_Churned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Churned_Order_By>>;
  where?: InputMaybe<Channel_Churned_Bool_Exp>;
};


export type Subscription_RootChannel_Churned_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Churned_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Churned_Order_By>>;
  where?: InputMaybe<Channel_Churned_Bool_Exp>;
};


export type Subscription_RootChannel_Churned_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Channel_Churned_Stream_Cursor_Input>>;
  where?: InputMaybe<Channel_Churned_Bool_Exp>;
};


export type Subscription_RootChannel_Delivered_To_Go_LiveArgs = {
  distinct_on?: InputMaybe<Array<Channel_Delivered_To_Go_Live_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Delivered_To_Go_Live_Order_By>>;
  where?: InputMaybe<Channel_Delivered_To_Go_Live_Bool_Exp>;
};


export type Subscription_RootChannel_Delivered_To_Go_Live_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Channel_Delivered_To_Go_Live_Stream_Cursor_Input>>;
  where?: InputMaybe<Channel_Delivered_To_Go_Live_Bool_Exp>;
};


export type Subscription_RootChannel_MasterArgs = {
  distinct_on?: InputMaybe<Array<Channel_Master_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Master_Order_By>>;
  where?: InputMaybe<Channel_Master_Bool_Exp>;
};


export type Subscription_RootChannel_Master_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Master_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Master_Order_By>>;
  where?: InputMaybe<Channel_Master_Bool_Exp>;
};


export type Subscription_RootChannel_Master_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootChannel_Master_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Channel_Master_Stream_Cursor_Input>>;
  where?: InputMaybe<Channel_Master_Bool_Exp>;
};


export type Subscription_RootChannel_ProgressArgs = {
  distinct_on?: InputMaybe<Array<Channel_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Progress_Order_By>>;
  where?: InputMaybe<Channel_Progress_Bool_Exp>;
};


export type Subscription_RootChannel_Progress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Channel_Progress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Progress_Order_By>>;
  where?: InputMaybe<Channel_Progress_Bool_Exp>;
};


export type Subscription_RootChannel_Progress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Channel_Progress_Stream_Cursor_Input>>;
  where?: InputMaybe<Channel_Progress_Bool_Exp>;
};


export type Subscription_RootChannel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Channel_Stream_Cursor_Input>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


export type Subscription_RootCloudportArgs = {
  distinct_on?: InputMaybe<Array<Cloudport_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cloudport_Order_By>>;
  where?: InputMaybe<Cloudport_Bool_Exp>;
};


export type Subscription_RootCloudport_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCloudport_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cloudport_Stream_Cursor_Input>>;
  where?: InputMaybe<Cloudport_Bool_Exp>;
};


export type Subscription_RootCompany_AddressArgs = {
  distinct_on?: InputMaybe<Array<Company_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Address_Order_By>>;
  where?: InputMaybe<Company_Address_Bool_Exp>;
};


export type Subscription_RootCompany_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Company_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Company_Address_Order_By>>;
  where?: InputMaybe<Company_Address_Bool_Exp>;
};


export type Subscription_RootCompany_Address_By_PkArgs = {
  salesforce_account_id: Scalars['String'];
};


export type Subscription_RootCompany_Address_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Company_Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Company_Address_Bool_Exp>;
};


export type Subscription_RootConsumption_RateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumption_Rate_Order_By>>;
  where?: InputMaybe<Consumption_Rate_Bool_Exp>;
};


export type Subscription_RootConsumption_Rate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumption_Rate_Order_By>>;
  where?: InputMaybe<Consumption_Rate_Bool_Exp>;
};


export type Subscription_RootConsumption_Rate_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootConsumption_Rate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Consumption_Rate_Stream_Cursor_Input>>;
  where?: InputMaybe<Consumption_Rate_Bool_Exp>;
};


export type Subscription_RootConsumption_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumption_Schedule_Order_By>>;
  where?: InputMaybe<Consumption_Schedule_Bool_Exp>;
};


export type Subscription_RootConsumption_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consumption_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consumption_Schedule_Order_By>>;
  where?: InputMaybe<Consumption_Schedule_Bool_Exp>;
};


export type Subscription_RootConsumption_Schedule_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootConsumption_Schedule_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Consumption_Schedule_Stream_Cursor_Input>>;
  where?: InputMaybe<Consumption_Schedule_Bool_Exp>;
};


export type Subscription_RootContactArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Subscription_RootContact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contact_Order_By>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Subscription_RootContact_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootContact_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Contact_Stream_Cursor_Input>>;
  where?: InputMaybe<Contact_Bool_Exp>;
};


export type Subscription_RootContent_Plus_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Content_Plus_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Content_Plus_Contacts_Order_By>>;
  where?: InputMaybe<Content_Plus_Contacts_Bool_Exp>;
};


export type Subscription_RootContent_Plus_Contacts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Content_Plus_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Content_Plus_Contacts_Bool_Exp>;
};


export type Subscription_RootCredit_Memo_By_IdArgs = {
  args: Credit_Memo_By_Id_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


export type Subscription_RootCredit_Memo_By_Id_AggregateArgs = {
  args: Credit_Memo_By_Id_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


export type Subscription_RootCustomerArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Subscription_RootCustomer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Subscription_RootCustomer_By_Amagi_IdArgs = {
  args: Customer_By_Amagi_Id_Args;
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Subscription_RootCustomer_By_Amagi_Id_AggregateArgs = {
  args: Customer_By_Amagi_Id_Args;
  distinct_on?: InputMaybe<Array<Customer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Order_By>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Subscription_RootCustomer_Contract_TermsArgs = {
  distinct_on?: InputMaybe<Array<Customer_Contract_Terms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Contract_Terms_Order_By>>;
  where?: InputMaybe<Customer_Contract_Terms_Bool_Exp>;
};


export type Subscription_RootCustomer_Contract_Terms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Contract_Terms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Contract_Terms_Order_By>>;
  where?: InputMaybe<Customer_Contract_Terms_Bool_Exp>;
};


export type Subscription_RootCustomer_Contract_Terms_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customer_Contract_Terms_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Contract_Terms_Bool_Exp>;
};


export type Subscription_RootCustomer_CountArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Type_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Type_Bool_Exp>;
};


export type Subscription_RootCustomer_Industry_SegmentArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Industry_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Industry_Type_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Industry_Type_Bool_Exp>;
};


export type Subscription_RootCustomer_Product_By_Amagi_IdArgs = {
  args: Customer_Product_By_Amagi_Id_Args;
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootCustomer_Product_By_Amagi_Id_AggregateArgs = {
  args: Customer_Product_By_Amagi_Id_Args;
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootCustomer_Product_Purchased_By_Amagi_IdArgs = {
  args: Customer_Product_Purchased_By_Amagi_Id_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Product_Purchased_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Product_Purchased_Order_By>>;
  where?: InputMaybe<Fn_Return_Product_Purchased_Bool_Exp>;
};


export type Subscription_RootCustomer_Product_UrlArgs = {
  distinct_on?: InputMaybe<Array<Customer_Product_Url_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Product_Url_Order_By>>;
  where?: InputMaybe<Customer_Product_Url_Bool_Exp>;
};


export type Subscription_RootCustomer_Product_Url_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Product_Url_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Product_Url_Order_By>>;
  where?: InputMaybe<Customer_Product_Url_Bool_Exp>;
};


export type Subscription_RootCustomer_Product_Url_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customer_Product_Url_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Product_Url_Bool_Exp>;
};


export type Subscription_RootCustomer_Region_RevenueArgs = {
  args: Customer_Region_Revenue_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Region_Revenue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Region_Revenue_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Region_Revenue_Bool_Exp>;
};


export type Subscription_RootCustomer_Revenue_SegmentArgs = {
  distinct_on?: InputMaybe<Array<Customer_Revenue_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Revenue_Segment_Order_By>>;
  where?: InputMaybe<Customer_Revenue_Segment_Bool_Exp>;
};


export type Subscription_RootCustomer_Revenue_Segment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Revenue_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Revenue_Segment_Order_By>>;
  where?: InputMaybe<Customer_Revenue_Segment_Bool_Exp>;
};


export type Subscription_RootCustomer_Revenue_Segment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCustomer_Revenue_Segment_DataArgs = {
  distinct_on?: InputMaybe<Array<Customer_Revenue_Segment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Revenue_Segment_Data_Order_By>>;
  where?: InputMaybe<Customer_Revenue_Segment_Data_Bool_Exp>;
};


export type Subscription_RootCustomer_Revenue_Segment_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Customer_Revenue_Segment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Customer_Revenue_Segment_Data_Order_By>>;
  where?: InputMaybe<Customer_Revenue_Segment_Data_Bool_Exp>;
};


export type Subscription_RootCustomer_Revenue_Segment_Data_By_PkArgs = {
  amagi_id: Scalars['String'];
};


export type Subscription_RootCustomer_Revenue_Segment_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customer_Revenue_Segment_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Revenue_Segment_Data_Bool_Exp>;
};


export type Subscription_RootCustomer_Revenue_Segment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customer_Revenue_Segment_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Revenue_Segment_Bool_Exp>;
};


export type Subscription_RootCustomer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Customer_Stream_Cursor_Input>>;
  where?: InputMaybe<Customer_Bool_Exp>;
};


export type Subscription_RootCustomer_Tier_RevenueArgs = {
  args: Customer_Tier_Revenue_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Tier_Revenue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Tier_Revenue_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Tier_Revenue_Bool_Exp>;
};


export type Subscription_RootCustomer_TypeArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Type_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Type_Bool_Exp>;
};


export type Subscription_RootCustomer_Type_RevenueArgs = {
  args: Customer_Type_Revenue_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Type_Revenue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Type_Revenue_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Type_Revenue_Bool_Exp>;
};


export type Subscription_RootDashboard_Revenue_SplitArgs = {
  args: Dashboard_Revenue_Split_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Revenue_Split_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Revenue_Split_Order_By>>;
  where?: InputMaybe<Fn_Return_Revenue_Split_Bool_Exp>;
};


export type Subscription_RootData_GrowthArgs = {
  distinct_on?: InputMaybe<Array<Data_Growth_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Data_Growth_Order_By>>;
  where?: InputMaybe<Data_Growth_Bool_Exp>;
};


export type Subscription_RootData_Growth_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootData_Growth_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Data_Growth_Stream_Cursor_Input>>;
  where?: InputMaybe<Data_Growth_Bool_Exp>;
};


export type Subscription_RootData_Growth_TrendArgs = {
  args: Data_Growth_Trend_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Data_Growth_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Data_Growth_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Data_Growth_Graph_Bool_Exp>;
};


export type Subscription_RootData_QualityArgs = {
  distinct_on?: InputMaybe<Array<Data_Quality_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Data_Quality_Order_By>>;
  where?: InputMaybe<Data_Quality_Bool_Exp>;
};


export type Subscription_RootData_Quality_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootData_Quality_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Data_Quality_Stream_Cursor_Input>>;
  where?: InputMaybe<Data_Quality_Bool_Exp>;
};


export type Subscription_RootData_Quality_TableArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Data_Quality_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Data_Quality_Order_By>>;
  where?: InputMaybe<Fn_Return_Data_Quality_Bool_Exp>;
};


export type Subscription_RootData_Quality_TrendArgs = {
  args: Data_Quality_Trend_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Data_Quality_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Data_Quality_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Data_Quality_Graph_Bool_Exp>;
};


export type Subscription_RootDeliveryArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Order_By>>;
  where?: InputMaybe<Delivery_Bool_Exp>;
};


export type Subscription_RootDelivery_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Order_By>>;
  where?: InputMaybe<Delivery_Bool_Exp>;
};


export type Subscription_RootDelivery_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDelivery_Channel_PlatformArgs = {
  args: Delivery_Channel_Platform_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Channel_Platform_Bool_Exp>;
};


export type Subscription_RootDelivery_Channel_Platform_AggregateArgs = {
  args: Delivery_Channel_Platform_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Channel_Platform_Bool_Exp>;
};


export type Subscription_RootDelivery_MainArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Main_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Main_Order_By>>;
  where?: InputMaybe<Delivery_Main_Bool_Exp>;
};


export type Subscription_RootDelivery_Main_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Main_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Main_Order_By>>;
  where?: InputMaybe<Delivery_Main_Bool_Exp>;
};


export type Subscription_RootDelivery_Main_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Delivery_Main_Stream_Cursor_Input>>;
  where?: InputMaybe<Delivery_Main_Bool_Exp>;
};


export type Subscription_RootDelivery_NowArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Now_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Now_Order_By>>;
  where?: InputMaybe<Delivery_Now_Bool_Exp>;
};


export type Subscription_RootDelivery_Now_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Delivery_Now_Stream_Cursor_Input>>;
  where?: InputMaybe<Delivery_Now_Bool_Exp>;
};


export type Subscription_RootDelivery_PayloadArgs = {
  args: Delivery_Payload_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Payload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Payload_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Payload_Bool_Exp>;
};


export type Subscription_RootDelivery_Payload_AggregateArgs = {
  args: Delivery_Payload_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Payload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Payload_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Payload_Bool_Exp>;
};


export type Subscription_RootDelivery_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Delivery_Stream_Cursor_Input>>;
  where?: InputMaybe<Delivery_Bool_Exp>;
};


export type Subscription_RootDelivery_TimelineArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Timeline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Timeline_Order_By>>;
  where?: InputMaybe<Delivery_Timeline_Bool_Exp>;
};


export type Subscription_RootDelivery_Timeline_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Delivery_Timeline_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Delivery_Timeline_Order_By>>;
  where?: InputMaybe<Delivery_Timeline_Bool_Exp>;
};


export type Subscription_RootDelivery_Timeline_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Delivery_Timeline_Stream_Cursor_Input>>;
  where?: InputMaybe<Delivery_Timeline_Bool_Exp>;
};


export type Subscription_RootDomain_ExistArgs = {
  args: Domain_Exist_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Domain_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Domain_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Domain_Validation_Bool_Exp>;
};


export type Subscription_RootDomain_Exist_AggregateArgs = {
  args: Domain_Exist_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Domain_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Domain_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Domain_Validation_Bool_Exp>;
};


export type Subscription_RootEmail_ExistArgs = {
  args: Email_Exist_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Email_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Email_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Email_Validation_Bool_Exp>;
};


export type Subscription_RootEmail_Exist_AggregateArgs = {
  args: Email_Exist_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Email_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Email_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Email_Validation_Bool_Exp>;
};


export type Subscription_RootExisting_New_Churned_DashboardArgs = {
  args: Existing_New_Churned_Dashboard_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Existing_New_Churned_Dashboard_Bool_Exp>;
};


export type Subscription_RootExisting_New_Churned_Dashboard_ChannelArgs = {
  args: Existing_New_Churned_Dashboard_Channel_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Existing_New_Churned_Dashboard_Bool_Exp>;
};


export type Subscription_RootExisting_New_Churned_Platform_DashboardArgs = {
  args: Existing_New_Churned_Platform_Dashboard_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Existing_New_Churned_Dashboard_Bool_Exp>;
};


export type Subscription_RootFeature_FlagArgs = {
  distinct_on?: InputMaybe<Array<Feature_Flag_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Feature_Flag_Order_By>>;
  where?: InputMaybe<Feature_Flag_Bool_Exp>;
};


export type Subscription_RootFeature_Flag_By_PkArgs = {
  feature: Scalars['String'];
};


export type Subscription_RootFeature_Flag_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Feature_Flag_Stream_Cursor_Input>>;
  where?: InputMaybe<Feature_Flag_Bool_Exp>;
};


export type Subscription_RootFn_Return_Account_StatementArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Bool_Exp>;
};


export type Subscription_RootFn_Return_Account_Statement_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Bool_Exp>;
};


export type Subscription_RootFn_Return_Account_Statement_By_PkArgs = {
  transaction_date: Scalars['String'];
};


export type Subscription_RootFn_Return_Account_Statement_MetaArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Meta_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Meta_Bool_Exp>;
};


export type Subscription_RootFn_Return_Account_Statement_Meta_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Meta_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Meta_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Meta_Bool_Exp>;
};


export type Subscription_RootFn_Return_Account_Statement_Meta_By_PkArgs = {
  transaction_type: Scalars['String'];
};


export type Subscription_RootFn_Return_Account_Statement_Meta_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Account_Statement_Meta_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Meta_Bool_Exp>;
};


export type Subscription_RootFn_Return_Account_Statement_OutstandingArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Outstanding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Outstanding_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Outstanding_Bool_Exp>;
};


export type Subscription_RootFn_Return_Account_Statement_Outstanding_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Outstanding_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Outstanding_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Outstanding_Bool_Exp>;
};


export type Subscription_RootFn_Return_Account_Statement_Outstanding_By_PkArgs = {
  outstanding: Scalars['String'];
};


export type Subscription_RootFn_Return_Account_Statement_Outstanding_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Account_Statement_Outstanding_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Outstanding_Bool_Exp>;
};


export type Subscription_RootFn_Return_Account_Statement_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Account_Statement_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Bool_Exp>;
};


export type Subscription_RootFn_Return_Account_Statement_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Summary_Bool_Exp>;
};


export type Subscription_RootFn_Return_Account_Statement_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Account_Statement_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Account_Statement_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Summary_Bool_Exp>;
};


export type Subscription_RootFn_Return_Account_Statement_Summary_By_PkArgs = {
  total: Scalars['String'];
};


export type Subscription_RootFn_Return_Account_Statement_Summary_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Account_Statement_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Account_Statement_Summary_Bool_Exp>;
};


export type Subscription_RootFn_Return_Avg_Service_AvailibityArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Avg_Service_Availibity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Avg_Service_Availibity_Order_By>>;
  where?: InputMaybe<Fn_Return_Avg_Service_Availibity_Bool_Exp>;
};


export type Subscription_RootFn_Return_Avg_Service_Availibity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Avg_Service_Availibity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Avg_Service_Availibity_Order_By>>;
  where?: InputMaybe<Fn_Return_Avg_Service_Availibity_Bool_Exp>;
};


export type Subscription_RootFn_Return_Avg_Service_Availibity_By_PkArgs = {
  months: Scalars['date'];
};


export type Subscription_RootFn_Return_Avg_Service_Availibity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Avg_Service_Availibity_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Avg_Service_Availibity_Bool_Exp>;
};


export type Subscription_RootFn_Return_Billing_SummaryArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Subscription_RootFn_Return_Billing_Summary_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Subscription_RootFn_Return_Billing_Summary_By_PkArgs = {
  amount: Scalars['numeric'];
};


export type Subscription_RootFn_Return_Billing_Summary_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Billing_Summary_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Subscription_RootFn_Return_Channel_Deliveries_CountArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Channel_Deliveries_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Channel_Deliveries_Count_Order_By>>;
  where?: InputMaybe<Fn_Return_Channel_Deliveries_Count_Bool_Exp>;
};


export type Subscription_RootFn_Return_Channel_Deliveries_Count_By_PkArgs = {
  delivery_status: Scalars['String'];
};


export type Subscription_RootFn_Return_Channel_Deliveries_Count_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Channel_Deliveries_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Channel_Deliveries_Count_Bool_Exp>;
};


export type Subscription_RootFn_Return_Combined_InvoiceArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


export type Subscription_RootFn_Return_Combined_Invoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


export type Subscription_RootFn_Return_Combined_Invoice_By_PkArgs = {
  invoice_id: Scalars['String'];
};


export type Subscription_RootFn_Return_Combined_Invoice_LineArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
};


export type Subscription_RootFn_Return_Combined_Invoice_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
};


export type Subscription_RootFn_Return_Combined_Invoice_Line_By_PkArgs = {
  product_id: Scalars['String'];
};


export type Subscription_RootFn_Return_Combined_Invoice_Line_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Combined_Invoice_Line_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
};


export type Subscription_RootFn_Return_Combined_Invoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Combined_Invoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


export type Subscription_RootFn_Return_Customer_Industry_TypeArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Industry_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Industry_Type_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Industry_Type_Bool_Exp>;
};


export type Subscription_RootFn_Return_Customer_Industry_Type_By_PkArgs = {
  industry_type: Scalars['String'];
};


export type Subscription_RootFn_Return_Customer_Industry_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Customer_Industry_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Customer_Industry_Type_Bool_Exp>;
};


export type Subscription_RootFn_Return_Customer_Region_RevenueArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Region_Revenue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Region_Revenue_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Region_Revenue_Bool_Exp>;
};


export type Subscription_RootFn_Return_Customer_Region_Revenue_By_PkArgs = {
  customer_region: Scalars['String'];
};


export type Subscription_RootFn_Return_Customer_Region_Revenue_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Customer_Region_Revenue_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Customer_Region_Revenue_Bool_Exp>;
};


export type Subscription_RootFn_Return_Customer_SearchArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Search_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Search_Bool_Exp>;
};


export type Subscription_RootFn_Return_Customer_Search_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Search_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Search_Bool_Exp>;
};


export type Subscription_RootFn_Return_Customer_Search_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootFn_Return_Customer_Search_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Customer_Search_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Customer_Search_Bool_Exp>;
};


export type Subscription_RootFn_Return_Customer_Tier_RevenueArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Tier_Revenue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Tier_Revenue_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Tier_Revenue_Bool_Exp>;
};


export type Subscription_RootFn_Return_Customer_Tier_Revenue_By_PkArgs = {
  customer_tier: Scalars['String'];
};


export type Subscription_RootFn_Return_Customer_Tier_Revenue_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Customer_Tier_Revenue_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Customer_Tier_Revenue_Bool_Exp>;
};


export type Subscription_RootFn_Return_Customer_TypeArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Type_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Type_Bool_Exp>;
};


export type Subscription_RootFn_Return_Customer_Type_By_PkArgs = {
  customer_type: Scalars['String'];
};


export type Subscription_RootFn_Return_Customer_Type_RevenueArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Type_Revenue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Type_Revenue_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Type_Revenue_Bool_Exp>;
};


export type Subscription_RootFn_Return_Customer_Type_Revenue_By_PkArgs = {
  customer_type: Scalars['String'];
};


export type Subscription_RootFn_Return_Customer_Type_Revenue_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Customer_Type_Revenue_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Customer_Type_Revenue_Bool_Exp>;
};


export type Subscription_RootFn_Return_Customer_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Customer_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Customer_Type_Bool_Exp>;
};


export type Subscription_RootFn_Return_Data_Growth_GraphArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Data_Growth_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Data_Growth_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Data_Growth_Graph_Bool_Exp>;
};


export type Subscription_RootFn_Return_Data_Growth_Graph_By_PkArgs = {
  date: Scalars['date'];
};


export type Subscription_RootFn_Return_Data_Growth_Graph_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Data_Growth_Graph_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Data_Growth_Graph_Bool_Exp>;
};


export type Subscription_RootFn_Return_Data_QualityArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Data_Quality_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Data_Quality_Order_By>>;
  where?: InputMaybe<Fn_Return_Data_Quality_Bool_Exp>;
};


export type Subscription_RootFn_Return_Data_Quality_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootFn_Return_Data_Quality_GraphArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Data_Quality_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Data_Quality_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Data_Quality_Graph_Bool_Exp>;
};


export type Subscription_RootFn_Return_Data_Quality_Graph_By_PkArgs = {
  date: Scalars['date'];
};


export type Subscription_RootFn_Return_Data_Quality_Graph_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Data_Quality_Graph_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Data_Quality_Graph_Bool_Exp>;
};


export type Subscription_RootFn_Return_Data_Quality_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Data_Quality_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Data_Quality_Bool_Exp>;
};


export type Subscription_RootFn_Return_Deliveries_CountArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Deliveries_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Deliveries_Count_Order_By>>;
  where?: InputMaybe<Fn_Return_Deliveries_Count_Bool_Exp>;
};


export type Subscription_RootFn_Return_Deliveries_Count_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Deliveries_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Deliveries_Count_Order_By>>;
  where?: InputMaybe<Fn_Return_Deliveries_Count_Bool_Exp>;
};


export type Subscription_RootFn_Return_Deliveries_Count_By_PkArgs = {
  result: Scalars['jsonb'];
};


export type Subscription_RootFn_Return_Deliveries_Count_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Deliveries_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Deliveries_Count_Bool_Exp>;
};


export type Subscription_RootFn_Return_Delivery_Channel_PlatformArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Channel_Platform_Bool_Exp>;
};


export type Subscription_RootFn_Return_Delivery_Channel_Platform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Channel_Platform_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Channel_Platform_Bool_Exp>;
};


export type Subscription_RootFn_Return_Delivery_Channel_Platform_By_PkArgs = {
  products: Scalars['jsonb'];
};


export type Subscription_RootFn_Return_Delivery_Channel_Platform_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Delivery_Channel_Platform_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Delivery_Channel_Platform_Bool_Exp>;
};


export type Subscription_RootFn_Return_Delivery_CountArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Count_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Count_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Count_Bool_Exp>;
};


export type Subscription_RootFn_Return_Delivery_Count_By_PkArgs = {
  count: Scalars['bigint'];
};


export type Subscription_RootFn_Return_Delivery_Count_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Delivery_Count_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Delivery_Count_Bool_Exp>;
};


export type Subscription_RootFn_Return_Delivery_PayloadArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Payload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Payload_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Payload_Bool_Exp>;
};


export type Subscription_RootFn_Return_Delivery_Payload_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Payload_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Payload_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Payload_Bool_Exp>;
};


export type Subscription_RootFn_Return_Delivery_Payload_By_PkArgs = {
  amagi_id: Scalars['String'];
};


export type Subscription_RootFn_Return_Delivery_Payload_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Delivery_Payload_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Delivery_Payload_Bool_Exp>;
};


export type Subscription_RootFn_Return_Delivery_ShareArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Share_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Share_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Share_Bool_Exp>;
};


export type Subscription_RootFn_Return_Delivery_Share_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Delivery_Share_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Delivery_Share_Order_By>>;
  where?: InputMaybe<Fn_Return_Delivery_Share_Bool_Exp>;
};


export type Subscription_RootFn_Return_Delivery_Share_By_PkArgs = {
  delivery_deal: Scalars['jsonb'];
};


export type Subscription_RootFn_Return_Delivery_Share_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Delivery_Share_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Delivery_Share_Bool_Exp>;
};


export type Subscription_RootFn_Return_Domain_ValidationArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Domain_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Domain_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Domain_Validation_Bool_Exp>;
};


export type Subscription_RootFn_Return_Domain_Validation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Domain_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Domain_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Domain_Validation_Bool_Exp>;
};


export type Subscription_RootFn_Return_Domain_Validation_By_PkArgs = {
  domain_exist: Scalars['jsonb'];
  email_exist: Scalars['jsonb'];
};


export type Subscription_RootFn_Return_Domain_Validation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Domain_Validation_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Domain_Validation_Bool_Exp>;
};


export type Subscription_RootFn_Return_Email_ValidationArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Email_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Email_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Email_Validation_Bool_Exp>;
};


export type Subscription_RootFn_Return_Email_Validation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Email_Validation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Email_Validation_Order_By>>;
  where?: InputMaybe<Fn_Return_Email_Validation_Bool_Exp>;
};


export type Subscription_RootFn_Return_Email_Validation_By_PkArgs = {
  email_exist: Scalars['jsonb'];
};


export type Subscription_RootFn_Return_Email_Validation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Email_Validation_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Email_Validation_Bool_Exp>;
};


export type Subscription_RootFn_Return_Existing_New_Churned_DashboardArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Existing_New_Churned_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Existing_New_Churned_Dashboard_Bool_Exp>;
};


export type Subscription_RootFn_Return_Existing_New_Churned_Dashboard_By_PkArgs = {
  month: Scalars['String'];
};


export type Subscription_RootFn_Return_Existing_New_Churned_Dashboard_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Existing_New_Churned_Dashboard_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Existing_New_Churned_Dashboard_Bool_Exp>;
};


export type Subscription_RootFn_Return_Financial_GraphArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


export type Subscription_RootFn_Return_Financial_Graph_By_PkArgs = {
  month: Scalars['String'];
};


export type Subscription_RootFn_Return_Financial_Graph_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Financial_Graph_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Financial_Graph_Bool_Exp>;
};


export type Subscription_RootFn_Return_Latest_MrrArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Latest_Mrr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Latest_Mrr_Order_By>>;
  where?: InputMaybe<Fn_Return_Latest_Mrr_Bool_Exp>;
};


export type Subscription_RootFn_Return_Latest_Mrr_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Latest_Mrr_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Latest_Mrr_Order_By>>;
  where?: InputMaybe<Fn_Return_Latest_Mrr_Bool_Exp>;
};


export type Subscription_RootFn_Return_Latest_Mrr_By_PkArgs = {
  month: Scalars['String'];
};


export type Subscription_RootFn_Return_Latest_Mrr_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Latest_Mrr_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Latest_Mrr_Bool_Exp>;
};


export type Subscription_RootFn_Return_Msa_Rate_CardArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Order_By>>;
  where?: InputMaybe<Fn_Return_Msa_Rate_Card_Bool_Exp>;
};


export type Subscription_RootFn_Return_Msa_Rate_Card_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Order_By>>;
  where?: InputMaybe<Fn_Return_Msa_Rate_Card_Bool_Exp>;
};


export type Subscription_RootFn_Return_Msa_Rate_Card_By_PkArgs = {
  quote_number: Scalars['String'];
};


export type Subscription_RootFn_Return_Msa_Rate_Card_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Msa_Rate_Card_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Msa_Rate_Card_Bool_Exp>;
};


export type Subscription_RootFn_Return_Product_Financial_GraphArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Product_Financial_Graph_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Product_Financial_Graph_Order_By>>;
  where?: InputMaybe<Fn_Return_Product_Financial_Graph_Bool_Exp>;
};


export type Subscription_RootFn_Return_Product_Financial_Graph_By_PkArgs = {
  month: Scalars['String'];
};


export type Subscription_RootFn_Return_Product_Financial_Graph_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Product_Financial_Graph_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Product_Financial_Graph_Bool_Exp>;
};


export type Subscription_RootFn_Return_Product_PurchasedArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Product_Purchased_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Product_Purchased_Order_By>>;
  where?: InputMaybe<Fn_Return_Product_Purchased_Bool_Exp>;
};


export type Subscription_RootFn_Return_Product_Purchased_By_PkArgs = {
  product_id: Scalars['String'];
};


export type Subscription_RootFn_Return_Product_Purchased_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Product_Purchased_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Product_Purchased_Bool_Exp>;
};


export type Subscription_RootFn_Return_Product_Table_DetailArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Product_Table_Detail_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Product_Table_Detail_Order_By>>;
  where?: InputMaybe<Fn_Return_Product_Table_Detail_Bool_Exp>;
};


export type Subscription_RootFn_Return_Product_Table_Detail_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootFn_Return_Product_Table_Detail_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Product_Table_Detail_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Product_Table_Detail_Bool_Exp>;
};


export type Subscription_RootFn_Return_Revenue_Segment_DataArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Order_By>>;
  where?: InputMaybe<Fn_Return_Revenue_Segment_Data_Bool_Exp>;
};


export type Subscription_RootFn_Return_Revenue_Segment_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Order_By>>;
  where?: InputMaybe<Fn_Return_Revenue_Segment_Data_Bool_Exp>;
};


export type Subscription_RootFn_Return_Revenue_Segment_Data_By_PkArgs = {
  amagi_id: Scalars['String'];
};


export type Subscription_RootFn_Return_Revenue_Segment_Data_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Revenue_Segment_Data_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Revenue_Segment_Data_Bool_Exp>;
};


export type Subscription_RootFn_Return_Revenue_SplitArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Revenue_Split_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Revenue_Split_Order_By>>;
  where?: InputMaybe<Fn_Return_Revenue_Split_Bool_Exp>;
};


export type Subscription_RootFn_Return_Revenue_Split_By_PkArgs = {
  month: Scalars['String'];
};


export type Subscription_RootFn_Return_Revenue_Split_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Revenue_Split_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Revenue_Split_Bool_Exp>;
};


export type Subscription_RootFn_Return_Sales_ResponseArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Sales_Response_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Sales_Response_Order_By>>;
  where?: InputMaybe<Fn_Return_Sales_Response_Bool_Exp>;
};


export type Subscription_RootFn_Return_Sales_Response_By_PkArgs = {
  source: Scalars['String'];
  status: Scalars['String'];
};


export type Subscription_RootFn_Return_Sales_Response_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Sales_Response_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Sales_Response_Bool_Exp>;
};


export type Subscription_RootFn_Return_Sf_Ns_CheckArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Sf_Ns_Check_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Sf_Ns_Check_Order_By>>;
  where?: InputMaybe<Fn_Return_Sf_Ns_Check_Bool_Exp>;
};


export type Subscription_RootFn_Return_Sf_Ns_Check_By_PkArgs = {
  check: Scalars['String'];
};


export type Subscription_RootFn_Return_Sf_Ns_Check_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Sf_Ns_Check_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Sf_Ns_Check_Bool_Exp>;
};


export type Subscription_RootFn_Return_Top_CustomersArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Top_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Top_Customers_Order_By>>;
  where?: InputMaybe<Fn_Return_Top_Customers_Bool_Exp>;
};


export type Subscription_RootFn_Return_Top_Customers_By_PkArgs = {
  account_name: Scalars['String'];
};


export type Subscription_RootFn_Return_Top_Customers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Top_Customers_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Top_Customers_Bool_Exp>;
};


export type Subscription_RootFn_Return_Total_Open_Close_Ticket_DashboardArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Bool_Exp>;
};


export type Subscription_RootFn_Return_Total_Open_Close_Ticket_Dashboard_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Bool_Exp>;
};


export type Subscription_RootFn_Return_Total_Open_Close_Ticket_Dashboard_By_PkArgs = {
  month: Scalars['String'];
};


export type Subscription_RootFn_Return_Total_Open_Close_Ticket_Dashboard_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Stream_Cursor_Input>>;
  where?: InputMaybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Bool_Exp>;
};


export type Subscription_RootFreshdesk_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Freshdesk_Company_Order_By>>;
  where?: InputMaybe<Freshdesk_Company_Bool_Exp>;
};


export type Subscription_RootFreshdesk_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Freshdesk_Company_Order_By>>;
  where?: InputMaybe<Freshdesk_Company_Bool_Exp>;
};


export type Subscription_RootFreshdesk_Company_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootFreshdesk_Company_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Freshdesk_Company_Stream_Cursor_Input>>;
  where?: InputMaybe<Freshdesk_Company_Bool_Exp>;
};


export type Subscription_RootFreshdesk_ContactArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Freshdesk_Contact_Order_By>>;
  where?: InputMaybe<Freshdesk_Contact_Bool_Exp>;
};


export type Subscription_RootFreshdesk_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Freshdesk_Contact_Order_By>>;
  where?: InputMaybe<Freshdesk_Contact_Bool_Exp>;
};


export type Subscription_RootFreshdesk_Contact_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootFreshdesk_Contact_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Freshdesk_Contact_Stream_Cursor_Input>>;
  where?: InputMaybe<Freshdesk_Contact_Bool_Exp>;
};


export type Subscription_RootFreshdesk_TicketArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Freshdesk_Ticket_Order_By>>;
  where?: InputMaybe<Freshdesk_Ticket_Bool_Exp>;
};


export type Subscription_RootFreshdesk_Ticket_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Freshdesk_Ticket_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Freshdesk_Ticket_Order_By>>;
  where?: InputMaybe<Freshdesk_Ticket_Bool_Exp>;
};


export type Subscription_RootFreshdesk_Ticket_By_PkArgs = {
  ticket_id: Scalars['numeric'];
};


export type Subscription_RootFreshdesk_Ticket_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Freshdesk_Ticket_Stream_Cursor_Input>>;
  where?: InputMaybe<Freshdesk_Ticket_Bool_Exp>;
};


export type Subscription_RootIncidentArgs = {
  distinct_on?: InputMaybe<Array<Incident_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Incident_Order_By>>;
  where?: InputMaybe<Incident_Bool_Exp>;
};


export type Subscription_RootIncident_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Incident_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Incident_Order_By>>;
  where?: InputMaybe<Incident_Bool_Exp>;
};


export type Subscription_RootIncident_By_PkArgs = {
  amagi_id: Scalars['String'];
  id: Scalars['String'];
};


export type Subscription_RootIncident_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Incident_Stream_Cursor_Input>>;
  where?: InputMaybe<Incident_Bool_Exp>;
};


export type Subscription_RootInvoiceArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Order_By>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_By_IdArgs = {
  args: Invoice_By_Id_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_By_Id_AggregateArgs = {
  args: Invoice_By_Id_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Bool_Exp>;
};


export type Subscription_RootInvoice_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootInvoice_LineArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Line_Order_By>>;
  where?: InputMaybe<Invoice_Line_Bool_Exp>;
};


export type Subscription_RootInvoice_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoice_Line_Order_By>>;
  where?: InputMaybe<Invoice_Line_Bool_Exp>;
};


export type Subscription_RootInvoice_Line_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootInvoice_Line_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invoice_Line_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoice_Line_Bool_Exp>;
};


export type Subscription_RootInvoice_Lines_By_IdArgs = {
  args: Invoice_Lines_By_Id_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
};


export type Subscription_RootInvoice_Lines_By_Id_AggregateArgs = {
  args: Invoice_Lines_By_Id_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Combined_Invoice_Line_Order_By>>;
  where?: InputMaybe<Fn_Return_Combined_Invoice_Line_Bool_Exp>;
};


export type Subscription_RootInvoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoice_Bool_Exp>;
};


export type Subscription_RootLegal_EntityArgs = {
  distinct_on?: InputMaybe<Array<Legal_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Entity_Order_By>>;
  where?: InputMaybe<Legal_Entity_Bool_Exp>;
};


export type Subscription_RootLegal_Entity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legal_Entity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legal_Entity_Order_By>>;
  where?: InputMaybe<Legal_Entity_Bool_Exp>;
};


export type Subscription_RootLegal_Entity_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootLegal_Entity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Legal_Entity_Stream_Cursor_Input>>;
  where?: InputMaybe<Legal_Entity_Bool_Exp>;
};


export type Subscription_RootMedia_Industry_Sub_SegmentArgs = {
  distinct_on?: InputMaybe<Array<Media_Industry_Sub_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Industry_Sub_Segment_Order_By>>;
  where?: InputMaybe<Media_Industry_Sub_Segment_Bool_Exp>;
};


export type Subscription_RootMedia_Industry_Sub_Segment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Media_Industry_Sub_Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Media_Industry_Sub_Segment_Order_By>>;
  where?: InputMaybe<Media_Industry_Sub_Segment_Bool_Exp>;
};


export type Subscription_RootMedia_Industry_Sub_Segment_By_PkArgs = {
  salesforce_account_id: Scalars['String'];
};


export type Subscription_RootMedia_Industry_Sub_Segment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Media_Industry_Sub_Segment_Stream_Cursor_Input>>;
  where?: InputMaybe<Media_Industry_Sub_Segment_Bool_Exp>;
};


export type Subscription_RootMsa_MasterArgs = {
  distinct_on?: InputMaybe<Array<Msa_Master_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Msa_Master_Order_By>>;
  where?: InputMaybe<Msa_Master_Bool_Exp>;
};


export type Subscription_RootMsa_Master_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Msa_Master_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Msa_Master_Order_By>>;
  where?: InputMaybe<Msa_Master_Bool_Exp>;
};


export type Subscription_RootMsa_Master_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Msa_Master_Stream_Cursor_Input>>;
  where?: InputMaybe<Msa_Master_Bool_Exp>;
};


export type Subscription_RootMsa_Rate_CardArgs = {
  distinct_on?: InputMaybe<Array<Msa_Rate_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Msa_Rate_Card_Order_By>>;
  where?: InputMaybe<Msa_Rate_Card_Bool_Exp>;
};


export type Subscription_RootMsa_Rate_Card_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Msa_Rate_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Msa_Rate_Card_Order_By>>;
  where?: InputMaybe<Msa_Rate_Card_Bool_Exp>;
};


export type Subscription_RootMsa_Rate_Card_By_PkArgs = {
  amagi_id: Scalars['String'];
  code: Scalars['String'];
  quote_number: Scalars['String'];
};


export type Subscription_RootMsa_Rate_Card_FnArgs = {
  args: Msa_Rate_Card_Fn_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Order_By>>;
  where?: InputMaybe<Fn_Return_Msa_Rate_Card_Bool_Exp>;
};


export type Subscription_RootMsa_Rate_Card_Fn_AggregateArgs = {
  args: Msa_Rate_Card_Fn_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Msa_Rate_Card_Order_By>>;
  where?: InputMaybe<Fn_Return_Msa_Rate_Card_Bool_Exp>;
};


export type Subscription_RootMsa_Rate_Card_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Msa_Rate_Card_Stream_Cursor_Input>>;
  where?: InputMaybe<Msa_Rate_Card_Bool_Exp>;
};


export type Subscription_RootNet_Invoices_DueArgs = {
  args: Net_Invoices_Due_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Subscription_RootNet_Invoices_Due_AggregateArgs = {
  args: Net_Invoices_Due_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Subscription_RootNet_Invoices_OutstandingArgs = {
  args: Net_Invoices_Outstanding_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Subscription_RootNet_Invoices_Outstanding_AggregateArgs = {
  args: Net_Invoices_Outstanding_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Subscription_RootNet_Invoices_OverdueArgs = {
  args: Net_Invoices_Overdue_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Subscription_RootNet_Invoices_Overdue_AggregateArgs = {
  args: Net_Invoices_Overdue_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Billing_Summary_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Billing_Summary_Order_By>>;
  where?: InputMaybe<Fn_Return_Billing_Summary_Bool_Exp>;
};


export type Subscription_RootNetsuite_Currency_RateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Currency_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Currency_Rate_Order_By>>;
  where?: InputMaybe<Netsuite_Currency_Rate_Bool_Exp>;
};


export type Subscription_RootNetsuite_Currency_Rate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Currency_Rate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Currency_Rate_Order_By>>;
  where?: InputMaybe<Netsuite_Currency_Rate_Bool_Exp>;
};


export type Subscription_RootNetsuite_Currency_Rate_By_PkArgs = {
  id: Scalars['numeric'];
};


export type Subscription_RootNetsuite_Currency_Rate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Netsuite_Currency_Rate_Stream_Cursor_Input>>;
  where?: InputMaybe<Netsuite_Currency_Rate_Bool_Exp>;
};


export type Subscription_RootNetsuite_ReceiptArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Receipt_Order_By>>;
  where?: InputMaybe<Netsuite_Receipt_Bool_Exp>;
};


export type Subscription_RootNetsuite_Receipt_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Receipt_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Receipt_Order_By>>;
  where?: InputMaybe<Netsuite_Receipt_Bool_Exp>;
};


export type Subscription_RootNetsuite_Receipt_By_PkArgs = {
  netsuite_id: Scalars['numeric'];
};


export type Subscription_RootNetsuite_Receipt_LineArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Receipt_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Receipt_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Receipt_Line_Bool_Exp>;
};


export type Subscription_RootNetsuite_Receipt_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Receipt_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Receipt_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Receipt_Line_Bool_Exp>;
};


export type Subscription_RootNetsuite_Receipt_Line_By_PkArgs = {
  netsuite_receipt_line_id: Scalars['numeric'];
};


export type Subscription_RootNetsuite_Receipt_Line_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Netsuite_Receipt_Line_Stream_Cursor_Input>>;
  where?: InputMaybe<Netsuite_Receipt_Line_Bool_Exp>;
};


export type Subscription_RootNetsuite_Receipt_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Netsuite_Receipt_Stream_Cursor_Input>>;
  where?: InputMaybe<Netsuite_Receipt_Bool_Exp>;
};


export type Subscription_RootNetsuite_TaxArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Tax_Order_By>>;
  where?: InputMaybe<Netsuite_Tax_Bool_Exp>;
};


export type Subscription_RootNetsuite_Tax_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Tax_Order_By>>;
  where?: InputMaybe<Netsuite_Tax_Bool_Exp>;
};


export type Subscription_RootNetsuite_Tax_By_PkArgs = {
  netsuite_id: Scalars['String'];
};


export type Subscription_RootNetsuite_Tax_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Netsuite_Tax_Stream_Cursor_Input>>;
  where?: InputMaybe<Netsuite_Tax_Bool_Exp>;
};


export type Subscription_RootNetsuite_TransactionArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Transaction_Order_By>>;
  where?: InputMaybe<Netsuite_Transaction_Bool_Exp>;
};


export type Subscription_RootNetsuite_Transaction_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Transaction_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Transaction_Order_By>>;
  where?: InputMaybe<Netsuite_Transaction_Bool_Exp>;
};


export type Subscription_RootNetsuite_Transaction_By_PkArgs = {
  netsuite_id: Scalars['numeric'];
};


export type Subscription_RootNetsuite_Transaction_LineArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Transaction_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Transaction_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Transaction_Line_Bool_Exp>;
};


export type Subscription_RootNetsuite_Transaction_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Transaction_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Transaction_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Transaction_Line_Bool_Exp>;
};


export type Subscription_RootNetsuite_Transaction_Line_By_PkArgs = {
  netsuite_id: Scalars['String'];
};


export type Subscription_RootNetsuite_Transaction_Line_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Netsuite_Transaction_Line_Stream_Cursor_Input>>;
  where?: InputMaybe<Netsuite_Transaction_Line_Bool_Exp>;
};


export type Subscription_RootNetsuite_Transaction_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Netsuite_Transaction_Stream_Cursor_Input>>;
  where?: InputMaybe<Netsuite_Transaction_Bool_Exp>;
};


export type Subscription_RootNetsuite_Vendor_InvoiceArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Bool_Exp>;
};


export type Subscription_RootNetsuite_Vendor_Invoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Bool_Exp>;
};


export type Subscription_RootNetsuite_Vendor_Invoice_By_PkArgs = {
  netsuite_id: Scalars['numeric'];
};


export type Subscription_RootNetsuite_Vendor_Invoice_ExpenseArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Expense_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Expense_Bool_Exp>;
};


export type Subscription_RootNetsuite_Vendor_Invoice_Expense_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Expense_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Expense_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Expense_Bool_Exp>;
};


export type Subscription_RootNetsuite_Vendor_Invoice_Expense_By_PkArgs = {
  netsuite_id: Scalars['String'];
};


export type Subscription_RootNetsuite_Vendor_Invoice_Expense_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Netsuite_Vendor_Invoice_Expense_Stream_Cursor_Input>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Expense_Bool_Exp>;
};


export type Subscription_RootNetsuite_Vendor_Invoice_LineArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Line_Bool_Exp>;
};


export type Subscription_RootNetsuite_Vendor_Invoice_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Line_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Line_Bool_Exp>;
};


export type Subscription_RootNetsuite_Vendor_Invoice_Line_By_PkArgs = {
  netsuite_id: Scalars['String'];
};


export type Subscription_RootNetsuite_Vendor_Invoice_Line_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Netsuite_Vendor_Invoice_Line_Stream_Cursor_Input>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Line_Bool_Exp>;
};


export type Subscription_RootNetsuite_Vendor_Invoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Netsuite_Vendor_Invoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Bool_Exp>;
};


export type Subscription_RootNetsuite_Vendor_Invoice_TaxArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Tax_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Tax_Bool_Exp>;
};


export type Subscription_RootNetsuite_Vendor_Invoice_Tax_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Netsuite_Vendor_Invoice_Tax_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Netsuite_Vendor_Invoice_Tax_Order_By>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Tax_Bool_Exp>;
};


export type Subscription_RootNetsuite_Vendor_Invoice_Tax_By_PkArgs = {
  netsuite_id: Scalars['String'];
};


export type Subscription_RootNetsuite_Vendor_Invoice_Tax_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Netsuite_Vendor_Invoice_Tax_Stream_Cursor_Input>>;
  where?: InputMaybe<Netsuite_Vendor_Invoice_Tax_Bool_Exp>;
};


export type Subscription_RootOnboarding_Customer_ContactsArgs = {
  distinct_on?: InputMaybe<Array<Onboarding_Customer_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Onboarding_Customer_Contacts_Order_By>>;
  where?: InputMaybe<Onboarding_Customer_Contacts_Bool_Exp>;
};


export type Subscription_RootOnboarding_Customer_Contacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Onboarding_Customer_Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Onboarding_Customer_Contacts_Order_By>>;
  where?: InputMaybe<Onboarding_Customer_Contacts_Bool_Exp>;
};


export type Subscription_RootOnboarding_Customer_Contacts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Onboarding_Customer_Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Onboarding_Customer_Contacts_Bool_Exp>;
};


export type Subscription_RootOpportunityArgs = {
  distinct_on?: InputMaybe<Array<Opportunity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opportunity_Order_By>>;
  where?: InputMaybe<Opportunity_Bool_Exp>;
};


export type Subscription_RootOpportunity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Opportunity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opportunity_Order_By>>;
  where?: InputMaybe<Opportunity_Bool_Exp>;
};


export type Subscription_RootOpportunity_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootOpportunity_Self_Serve_InformationArgs = {
  distinct_on?: InputMaybe<Array<Opportunity_Self_Serve_Information_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opportunity_Self_Serve_Information_Order_By>>;
  where?: InputMaybe<Opportunity_Self_Serve_Information_Bool_Exp>;
};


export type Subscription_RootOpportunity_Self_Serve_Information_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Opportunity_Self_Serve_Information_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Opportunity_Self_Serve_Information_Order_By>>;
  where?: InputMaybe<Opportunity_Self_Serve_Information_Bool_Exp>;
};


export type Subscription_RootOpportunity_Self_Serve_Information_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Opportunity_Self_Serve_Information_Stream_Cursor_Input>>;
  where?: InputMaybe<Opportunity_Self_Serve_Information_Bool_Exp>;
};


export type Subscription_RootOpportunity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Opportunity_Stream_Cursor_Input>>;
  where?: InputMaybe<Opportunity_Bool_Exp>;
};


export type Subscription_RootOrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootOrder_ItemArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Order_By>>;
  where?: InputMaybe<Order_Item_Bool_Exp>;
};


export type Subscription_RootOrder_Item_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Order_By>>;
  where?: InputMaybe<Order_Item_Bool_Exp>;
};


export type Subscription_RootOrder_Item_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootOrder_Item_LineArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Line_Order_By>>;
  where?: InputMaybe<Order_Item_Line_Bool_Exp>;
};


export type Subscription_RootOrder_Item_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Item_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Item_Line_Order_By>>;
  where?: InputMaybe<Order_Item_Line_Bool_Exp>;
};


export type Subscription_RootOrder_Item_Line_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootOrder_Item_Line_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Item_Line_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Item_Line_Bool_Exp>;
};


export type Subscription_RootOrder_Item_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Item_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Item_Bool_Exp>;
};


export type Subscription_RootOrder_ProductArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


export type Subscription_RootOrder_Product_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Product_Order_By>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


export type Subscription_RootOrder_Product_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootOrder_Product_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Product_Bool_Exp>;
};


export type Subscription_RootOrder_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOwnerArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


export type Subscription_RootOwner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Owner_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Owner_Order_By>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


export type Subscription_RootOwner_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootOwner_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Owner_Stream_Cursor_Input>>;
  where?: InputMaybe<Owner_Bool_Exp>;
};


export type Subscription_RootPageArgs = {
  distinct_on?: InputMaybe<Array<Page_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Page_Order_By>>;
  where?: InputMaybe<Page_Bool_Exp>;
};


export type Subscription_RootPage_By_PkArgs = {
  slug: Scalars['String'];
};


export type Subscription_RootPage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Page_Stream_Cursor_Input>>;
  where?: InputMaybe<Page_Bool_Exp>;
};


export type Subscription_RootPartial_Text_SearchArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Search_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Search_Bool_Exp>;
};


export type Subscription_RootPartial_Text_Search_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Customer_Search_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Customer_Search_Order_By>>;
  where?: InputMaybe<Fn_Return_Customer_Search_Bool_Exp>;
};


export type Subscription_RootPlatformArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


export type Subscription_RootPlatform_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Platform_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Platform_Order_By>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


export type Subscription_RootPlatform_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPlatform_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Platform_Stream_Cursor_Input>>;
  where?: InputMaybe<Platform_Bool_Exp>;
};


export type Subscription_RootPrice_BookArgs = {
  distinct_on?: InputMaybe<Array<Price_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Price_Book_Order_By>>;
  where?: InputMaybe<Price_Book_Bool_Exp>;
};


export type Subscription_RootPrice_Book_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Price_Book_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Price_Book_Order_By>>;
  where?: InputMaybe<Price_Book_Bool_Exp>;
};


export type Subscription_RootPrice_Book_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootPrice_Book_EntryArgs = {
  distinct_on?: InputMaybe<Array<Price_Book_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Price_Book_Entry_Order_By>>;
  where?: InputMaybe<Price_Book_Entry_Bool_Exp>;
};


export type Subscription_RootPrice_Book_Entry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Price_Book_Entry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Price_Book_Entry_Order_By>>;
  where?: InputMaybe<Price_Book_Entry_Bool_Exp>;
};


export type Subscription_RootPrice_Book_Entry_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootPrice_Book_Entry_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Price_Book_Entry_Stream_Cursor_Input>>;
  where?: InputMaybe<Price_Book_Entry_Bool_Exp>;
};


export type Subscription_RootPrice_Book_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Price_Book_Stream_Cursor_Input>>;
  where?: InputMaybe<Price_Book_Bool_Exp>;
};


export type Subscription_RootProductArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_ActiveArgs = {
  distinct_on?: InputMaybe<Array<Product_Active_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Active_Order_By>>;
  where?: InputMaybe<Product_Active_Bool_Exp>;
};


export type Subscription_RootProduct_Active_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Active_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Active_Bool_Exp>;
};


export type Subscription_RootProduct_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Product_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Product_Order_By>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootProduct_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootProduct_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Product_Stream_Cursor_Input>>;
  where?: InputMaybe<Product_Bool_Exp>;
};


export type Subscription_RootQuoteArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Subscription_RootQuote_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Order_By>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Subscription_RootQuote_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootQuote_LineArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Order_By>>;
  where?: InputMaybe<Quote_Line_Bool_Exp>;
};


export type Subscription_RootQuote_Line_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Order_By>>;
  where?: InputMaybe<Quote_Line_Bool_Exp>;
};


export type Subscription_RootQuote_Line_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootQuote_Line_Consumption_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Order_By>>;
  where?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Consumption_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Consumption_Schedule_Order_By>>;
  where?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Consumption_Schedule_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootQuote_Line_Consumption_Schedule_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quote_Line_Consumption_Schedule_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Line_Consumption_Schedule_Bool_Exp>;
};


export type Subscription_RootQuote_Line_GroupArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Group_Order_By>>;
  where?: InputMaybe<Quote_Line_Group_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Quote_Line_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Quote_Line_Group_Order_By>>;
  where?: InputMaybe<Quote_Line_Group_Bool_Exp>;
};


export type Subscription_RootQuote_Line_Group_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootQuote_Line_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quote_Line_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Line_Group_Bool_Exp>;
};


export type Subscription_RootQuote_Line_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quote_Line_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Line_Bool_Exp>;
};


export type Subscription_RootQuote_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Quote_Stream_Cursor_Input>>;
  where?: InputMaybe<Quote_Bool_Exp>;
};


export type Subscription_RootRecord_TypeArgs = {
  distinct_on?: InputMaybe<Array<Record_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Record_Type_Order_By>>;
  where?: InputMaybe<Record_Type_Bool_Exp>;
};


export type Subscription_RootRecord_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Record_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Record_Type_Order_By>>;
  where?: InputMaybe<Record_Type_Bool_Exp>;
};


export type Subscription_RootRecord_Type_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootRecord_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Record_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Record_Type_Bool_Exp>;
};


export type Subscription_RootRevenue_Segment_DataArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Order_By>>;
  where?: InputMaybe<Fn_Return_Revenue_Segment_Data_Bool_Exp>;
};


export type Subscription_RootRevenue_Segment_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Revenue_Segment_Data_Order_By>>;
  where?: InputMaybe<Fn_Return_Revenue_Segment_Data_Bool_Exp>;
};


export type Subscription_RootSearch_ChannelArgs = {
  args: Search_Channel_Args;
  distinct_on?: InputMaybe<Array<Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Order_By>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


export type Subscription_RootSearch_Channel_AggregateArgs = {
  args: Search_Channel_Args;
  distinct_on?: InputMaybe<Array<Channel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Channel_Order_By>>;
  where?: InputMaybe<Channel_Bool_Exp>;
};


export type Subscription_RootSearch_CustomerArgs = {
  args: Search_Customer_Args;
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootSearch_Customer_AggregateArgs = {
  args: Search_Customer_Args;
  distinct_on?: InputMaybe<Array<Account_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Account_Order_By>>;
  where?: InputMaybe<Account_Bool_Exp>;
};


export type Subscription_RootSegmentArgs = {
  distinct_on?: InputMaybe<Array<Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Segment_Order_By>>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type Subscription_RootSegment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Segment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Segment_Order_By>>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type Subscription_RootSegment_By_PkArgs = {
  salesforce_account_id: Scalars['String'];
};


export type Subscription_RootSegment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Segment_Stream_Cursor_Input>>;
  where?: InputMaybe<Segment_Bool_Exp>;
};


export type Subscription_RootSf_Ns_CheckArgs = {
  args: Sf_Ns_Check_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Sf_Ns_Check_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Sf_Ns_Check_Order_By>>;
  where?: InputMaybe<Fn_Return_Sf_Ns_Check_Bool_Exp>;
};


export type Subscription_RootTop_Customers_ConsumptionArgs = {
  args: Top_Customers_Consumption_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Top_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Top_Customers_Order_By>>;
  where?: InputMaybe<Fn_Return_Top_Customers_Bool_Exp>;
};


export type Subscription_RootTop_Customers_OverallArgs = {
  args: Top_Customers_Overall_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Top_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Top_Customers_Order_By>>;
  where?: InputMaybe<Fn_Return_Top_Customers_Bool_Exp>;
};


export type Subscription_RootTop_Customers_SubscriptionArgs = {
  args: Top_Customers_Subscription_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Top_Customers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Top_Customers_Order_By>>;
  where?: InputMaybe<Fn_Return_Top_Customers_Bool_Exp>;
};


export type Subscription_RootTotal_Open_Close_Ticket_DashboardArgs = {
  args: Total_Open_Close_Ticket_Dashboard_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Bool_Exp>;
};


export type Subscription_RootTotal_Open_Close_Ticket_Dashboard_AggregateArgs = {
  args: Total_Open_Close_Ticket_Dashboard_Args;
  distinct_on?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fn_Return_Total_Open_Close_Ticket_Dashboard_Order_By>>;
  where?: InputMaybe<Fn_Return_Total_Open_Close_Ticket_Dashboard_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  salesforce_id: Scalars['String'];
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']>;
  _gt?: InputMaybe<Scalars['time']>;
  _gte?: InputMaybe<Scalars['time']>;
  _in?: InputMaybe<Array<Scalars['time']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['time']>;
  _lte?: InputMaybe<Scalars['time']>;
  _neq?: InputMaybe<Scalars['time']>;
  _nin?: InputMaybe<Array<Scalars['time']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

export type Top_Customers_Consumption_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Top_Customers_Overall_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Top_Customers_Subscription_Args = {
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
};

export type Total_Open_Close_Ticket_Dashboard_Args = {
  from_date?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "user" */
export type User = {
  __typename?: 'user';
  address?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rep_director?: Maybe<Scalars['String']>;
  rep_manager?: Maybe<Scalars['String']>;
  rep_region?: Maybe<Scalars['String']>;
  rep_territory?: Maybe<Scalars['String']>;
  rep_type?: Maybe<Scalars['String']>;
  salesforce_id: Scalars['String'];
  salesforce_manager_id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "user" */
export type User_Aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<User_Aggregate_Fields>;
  nodes: Array<User>;
};

/** aggregate fields of "user" */
export type User_Aggregate_Fields = {
  __typename?: 'user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Max_Fields>;
  min?: Maybe<User_Min_Fields>;
};


/** aggregate fields of "user" */
export type User_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  mobile?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  rep_director?: InputMaybe<String_Comparison_Exp>;
  rep_manager?: InputMaybe<String_Comparison_Exp>;
  rep_region?: InputMaybe<String_Comparison_Exp>;
  rep_territory?: InputMaybe<String_Comparison_Exp>;
  rep_type?: InputMaybe<String_Comparison_Exp>;
  salesforce_id?: InputMaybe<String_Comparison_Exp>;
  salesforce_manager_id?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type User_Max_Fields = {
  __typename?: 'user_max_fields';
  address?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rep_director?: Maybe<Scalars['String']>;
  rep_manager?: Maybe<Scalars['String']>;
  rep_region?: Maybe<Scalars['String']>;
  rep_territory?: Maybe<Scalars['String']>;
  rep_type?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_manager_id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type User_Min_Fields = {
  __typename?: 'user_min_fields';
  address?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rep_director?: Maybe<Scalars['String']>;
  rep_manager?: Maybe<Scalars['String']>;
  rep_region?: Maybe<Scalars['String']>;
  rep_territory?: Maybe<Scalars['String']>;
  rep_type?: Maybe<Scalars['String']>;
  salesforce_id?: Maybe<Scalars['String']>;
  salesforce_manager_id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  address?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  mobile?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  rep_director?: InputMaybe<Order_By>;
  rep_manager?: InputMaybe<Order_By>;
  rep_region?: InputMaybe<Order_By>;
  rep_territory?: InputMaybe<Order_By>;
  rep_type?: InputMaybe<Order_By>;
  salesforce_id?: InputMaybe<Order_By>;
  salesforce_manager_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "user" */
export enum User_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  Name = 'name',
  /** column name */
  Phone = 'phone',
  /** column name */
  RepDirector = 'rep_director',
  /** column name */
  RepManager = 'rep_manager',
  /** column name */
  RepRegion = 'rep_region',
  /** column name */
  RepTerritory = 'rep_territory',
  /** column name */
  RepType = 'rep_type',
  /** column name */
  SalesforceId = 'salesforce_id',
  /** column name */
  SalesforceManagerId = 'salesforce_manager_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  rep_director?: InputMaybe<Scalars['String']>;
  rep_manager?: InputMaybe<Scalars['String']>;
  rep_region?: InputMaybe<Scalars['String']>;
  rep_territory?: InputMaybe<Scalars['String']>;
  rep_type?: InputMaybe<Scalars['String']>;
  salesforce_id?: InputMaybe<Scalars['String']>;
  salesforce_manager_id?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type ArrQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type ArrQuery = { __typename?: 'query_root', customer_by_amagi_id?: { __typename?: 'customer', latest_arr?: Array<{ __typename?: 'fn_return_latest_mrr', revenue_split?: string | null, month: string, arr: any }> | null } | null };

export type ChannelByPkQueryVariables = Exact<{
  _id: Scalars['uuid'];
}>;


export type ChannelByPkQuery = { __typename?: 'query_root', channel?: { __typename?: 'channel', id: any, multiple_salesforce_id?: any | null, salesforce_id: string, name: string, keyring?: any | null, description?: any | null, amagi_id_of_channel_owner?: string | null, availablity_country_and_regions?: any | null, channel_origin_country_region?: string | null, genre?: any | null, is_redundant?: boolean | null, channel_type?: string | null, channel_brand?: string | null, subtitle_support?: boolean | null, subtitle_type?: any | null, subtitle_language?: any | null, feed_type?: string | null, original_audio_language?: string | null, graphics_support?: any | null, channel_rating?: any | null, parental_rating_standard?: string | null, platform_delivered_to?: any | null, channel_resolution?: string | null, videos?: any | null, logo?: string | null, posters?: any | null, presentations?: any | null, instagram?: string | null, facebook?: string | null, twitter?: string | null, linkedin?: string | null, target_audience?: any | null, custom_fields?: any | null, stream_container_type?: string | null, custom_tags: any, ssai_partner?: string | null, channel_start_time?: any | null, channel_end_time?: any | null, paid_flag?: boolean | null, ad_flag?: boolean | null, promotion_flag?: boolean | null, is_contentplus_channel?: boolean | null, is_adsplus_channel?: boolean | null, subtitling?: boolean | null, closed_captioning?: boolean | null, dubbing?: boolean | null, dubbing_language?: any | null, sponsorship?: boolean | null, trademark_and_logo?: boolean | null, create_promotional?: boolean | null, edit_promotional?: boolean | null, create_short_form_video?: boolean | null, create_pop_channel?: boolean | null, use_of_display_technology?: boolean | null, time_zone?: string | null, start_time?: any | null, playout_format?: string | null, video_format?: string | null, audio_format?: string | null, playlist_format?: string | null, metadata_ingest_format?: string | null, content_ingest_format?: string | null, live_playout?: boolean | null, live_feed_input?: string | null, live_recording?: boolean | null, live_management?: boolean | null, closed_caption?: boolean | null, closed_caption_type?: string | null, closed_caption_language?: any | null, amagi_auto_cc_generation?: boolean | null, graphics_enabled?: boolean | null, graphics_type?: string | null, channel_logo_bug?: boolean | null, graphics_format?: string | null, fast?: string | null, sub_genre?: any | null, channels_grouped?: string | null, grouped_channel?: string | null, ordered_channel?: string | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string, logo?: string | null } | null, channel_to_channel: Array<{ __typename?: 'channel', id: any, salesforce_id: string, logo?: string | null, name: string, channel_type?: string | null }>, channel_to_channel_of_grouped?: { __typename?: 'channel', id: any, salesforce_id: string, logo?: string | null, name: string, channel_type?: string | null } | null } | null, channels: Array<{ __typename?: 'channel', salesforce_id: string, source?: string | null }>, customer: Array<{ __typename?: 'customer', amagi_id?: string | null, account_name?: string | null }> };

export type ChanelFieldsFragment = { __typename?: 'channel', id: any, multiple_salesforce_id?: any | null, salesforce_id: string, name: string, keyring?: any | null, description?: any | null, amagi_id_of_channel_owner?: string | null, availablity_country_and_regions?: any | null, channel_origin_country_region?: string | null, genre?: any | null, is_redundant?: boolean | null, channel_type?: string | null, channel_brand?: string | null, subtitle_support?: boolean | null, subtitle_type?: any | null, subtitle_language?: any | null, feed_type?: string | null, original_audio_language?: string | null, graphics_support?: any | null, channel_rating?: any | null, parental_rating_standard?: string | null, platform_delivered_to?: any | null, channel_resolution?: string | null, videos?: any | null, logo?: string | null, posters?: any | null, presentations?: any | null, instagram?: string | null, facebook?: string | null, twitter?: string | null, linkedin?: string | null, target_audience?: any | null, custom_fields?: any | null, stream_container_type?: string | null, custom_tags: any, ssai_partner?: string | null, channel_start_time?: any | null, channel_end_time?: any | null, paid_flag?: boolean | null, ad_flag?: boolean | null, promotion_flag?: boolean | null, is_contentplus_channel?: boolean | null, is_adsplus_channel?: boolean | null, subtitling?: boolean | null, closed_captioning?: boolean | null, dubbing?: boolean | null, dubbing_language?: any | null, sponsorship?: boolean | null, trademark_and_logo?: boolean | null, create_promotional?: boolean | null, edit_promotional?: boolean | null, create_short_form_video?: boolean | null, create_pop_channel?: boolean | null, use_of_display_technology?: boolean | null, time_zone?: string | null, start_time?: any | null, playout_format?: string | null, video_format?: string | null, audio_format?: string | null, playlist_format?: string | null, metadata_ingest_format?: string | null, content_ingest_format?: string | null, live_playout?: boolean | null, live_feed_input?: string | null, live_recording?: boolean | null, live_management?: boolean | null, closed_caption?: boolean | null, closed_caption_type?: string | null, closed_caption_language?: any | null, amagi_auto_cc_generation?: boolean | null, graphics_enabled?: boolean | null, graphics_type?: string | null, channel_logo_bug?: boolean | null, graphics_format?: string | null, fast?: string | null, sub_genre?: any | null, channels_grouped?: string | null, grouped_channel?: string | null, ordered_channel?: string | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string, logo?: string | null } | null, channel_to_channel: Array<{ __typename?: 'channel', id: any, salesforce_id: string, logo?: string | null, name: string, channel_type?: string | null }>, channel_to_channel_of_grouped?: { __typename?: 'channel', id: any, salesforce_id: string, logo?: string | null, name: string, channel_type?: string | null } | null };

export type ChannelGridFragment = { __typename?: 'channel', id: any, salesforce_id: string, channels_grouped?: string | null, name: string, ordered_channel?: string | null, feed_type?: string | null, fast?: string | null, platform_delivered_to?: any | null, channel_type?: string | null, channel_brand?: string | null, genre?: any | null, logo?: string | null, keyring?: any | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string, status?: string | null, logo?: string | null } | null };

export type LinearChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type LinearChannelsQuery = { __typename?: 'query_root', channel: Array<{ __typename?: 'channel', id: any, salesforce_id: string, channels_grouped?: string | null, name: string, ordered_channel?: string | null, feed_type?: string | null, fast?: string | null, platform_delivered_to?: any | null, channel_type?: string | null, channel_brand?: string | null, genre?: any | null, logo?: string | null, keyring?: any | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string, status?: string | null, logo?: string | null } | null }> };

export type GroupedChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GroupedChannelsQuery = { __typename?: 'query_root', channel: Array<{ __typename?: 'channel', id: any, salesforce_id: string, channels_grouped?: string | null, name: string, ordered_channel?: string | null, feed_type?: string | null, fast?: string | null, platform_delivered_to?: any | null, channel_type?: string | null, channel_brand?: string | null, genre?: any | null, logo?: string | null, keyring?: any | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string, status?: string | null, logo?: string | null } | null }> };

export type CommonChannelsQueryVariables = Exact<{
  channel_type: Scalars['String'];
}>;


export type CommonChannelsQuery = { __typename?: 'query_root', channel: Array<{ __typename?: 'channel', id: any, salesforce_id: string, channels_grouped?: string | null, name: string, ordered_channel?: string | null, feed_type?: string | null, fast?: string | null, platform_delivered_to?: any | null, channel_type?: string | null, channel_brand?: string | null, genre?: any | null, logo?: string | null, keyring?: any | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string, status?: string | null, logo?: string | null } | null }> };

export type UpdateCustomerLogoMutationVariables = Exact<{
  amagi_id: Scalars['String'];
  logoUrl: Scalars['String'];
}>;


export type UpdateCustomerLogoMutation = { __typename?: 'mutation_root', update_customer?: { __typename?: 'customer_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'customer', amagi_id?: string | null, logo?: string | null }> } | null };

export type UpdateChannelMutationVariables = Exact<{
  id: Scalars['uuid'];
  input?: InputMaybe<Channel_Set_Input>;
}>;


export type UpdateChannelMutation = { __typename?: 'mutation_root', channel?: { __typename?: 'channel', id: any, multiple_salesforce_id?: any | null, salesforce_id: string, name: string, keyring?: any | null, description?: any | null, amagi_id_of_channel_owner?: string | null, availablity_country_and_regions?: any | null, channel_origin_country_region?: string | null, genre?: any | null, is_redundant?: boolean | null, channel_type?: string | null, channel_brand?: string | null, subtitle_support?: boolean | null, subtitle_type?: any | null, subtitle_language?: any | null, feed_type?: string | null, original_audio_language?: string | null, graphics_support?: any | null, channel_rating?: any | null, parental_rating_standard?: string | null, platform_delivered_to?: any | null, channel_resolution?: string | null, videos?: any | null, logo?: string | null, posters?: any | null, presentations?: any | null, instagram?: string | null, facebook?: string | null, twitter?: string | null, linkedin?: string | null, target_audience?: any | null, custom_fields?: any | null, stream_container_type?: string | null, custom_tags: any, ssai_partner?: string | null, channel_start_time?: any | null, channel_end_time?: any | null, paid_flag?: boolean | null, ad_flag?: boolean | null, promotion_flag?: boolean | null, is_contentplus_channel?: boolean | null, is_adsplus_channel?: boolean | null, subtitling?: boolean | null, closed_captioning?: boolean | null, dubbing?: boolean | null, dubbing_language?: any | null, sponsorship?: boolean | null, trademark_and_logo?: boolean | null, create_promotional?: boolean | null, edit_promotional?: boolean | null, create_short_form_video?: boolean | null, create_pop_channel?: boolean | null, use_of_display_technology?: boolean | null, time_zone?: string | null, start_time?: any | null, playout_format?: string | null, video_format?: string | null, audio_format?: string | null, playlist_format?: string | null, metadata_ingest_format?: string | null, content_ingest_format?: string | null, live_playout?: boolean | null, live_feed_input?: string | null, live_recording?: boolean | null, live_management?: boolean | null, closed_caption?: boolean | null, closed_caption_type?: string | null, closed_caption_language?: any | null, amagi_auto_cc_generation?: boolean | null, graphics_enabled?: boolean | null, graphics_type?: string | null, channel_logo_bug?: boolean | null, graphics_format?: string | null, fast?: string | null, sub_genre?: any | null, channels_grouped?: string | null, grouped_channel?: string | null, ordered_channel?: string | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string, logo?: string | null } | null, channel_to_channel: Array<{ __typename?: 'channel', id: any, salesforce_id: string, logo?: string | null, name: string, channel_type?: string | null }>, channel_to_channel_of_grouped?: { __typename?: 'channel', id: any, salesforce_id: string, logo?: string | null, name: string, channel_type?: string | null } | null } | null };

export type LinearChannelsByCustomerQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type LinearChannelsByCustomerQuery = { __typename?: 'query_root', channel: Array<{ __typename?: 'channel', id: any, salesforce_id: string, channels_grouped?: string | null, name: string, ordered_channel?: string | null, feed_type?: string | null, fast?: string | null, platform_delivered_to?: any | null, channel_type?: string | null, channel_brand?: string | null, genre?: any | null, logo?: string | null, keyring?: any | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string, status?: string | null, logo?: string | null } | null }> };

export type GroupedChannelsByCustomerQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type GroupedChannelsByCustomerQuery = { __typename?: 'query_root', channel: Array<{ __typename?: 'channel', id: any, salesforce_id: string, channels_grouped?: string | null, name: string, ordered_channel?: string | null, feed_type?: string | null, fast?: string | null, platform_delivered_to?: any | null, channel_type?: string | null, channel_brand?: string | null, genre?: any | null, logo?: string | null, keyring?: any | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string, status?: string | null, logo?: string | null } | null }> };

export type CommonChannelsByCustomerQueryVariables = Exact<{
  channel_type: Scalars['String'];
  amagi_id: Scalars['String'];
}>;


export type CommonChannelsByCustomerQuery = { __typename?: 'query_root', channel: Array<{ __typename?: 'channel', id: any, salesforce_id: string, channels_grouped?: string | null, name: string, ordered_channel?: string | null, feed_type?: string | null, fast?: string | null, platform_delivered_to?: any | null, channel_type?: string | null, channel_brand?: string | null, genre?: any | null, logo?: string | null, keyring?: any | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string, status?: string | null, logo?: string | null } | null }> };

export type CustomerAllDataFragment = { __typename?: 'customer', amagi_id?: string | null, account_creation_date?: any | null, account_currency?: string | null, account_deactivation_date?: any | null, account_legal_name?: string | null, account_name?: string | null, ad_revenue_model?: string | null, customer_tier?: string | null, description?: string | null, phone?: string | null, tam?: string | null, billing_term?: string | null, churn_risk_percentage?: any | null, cloud_region?: any | null, cloud_service_provider?: any | null, comments?: string | null, created_at?: any | null, credit_period_in_days?: string | null, credit_score?: any | null, customer_business_model?: string | null, customer_contract_period?: any | null, customer_life_time_value?: any | null, customer_revenue_for_previous_year?: any | null, customer_revenue_for_the_present_year?: any | null, customer_type?: string | null, customers_profit_for_previous_year?: any | null, customers_profit_for_the_present_year?: any | null, dso?: string | null, first_invoice_date?: any | null, industry_segment?: string | null, invoicing_currency?: string | null, is_active?: boolean | null, is_deleted?: boolean | null, is_msa_ratecard_customer?: boolean | null, is_ono?: boolean | null, language?: string | null, status?: string | null, service_tier?: string | null, salesforce_created_date?: any | null, customer_since_date?: any | null, salesforce_last_modified_date?: any | null, salesforce_accountmanager_id?: string | null, salesforce_record_type_id?: string | null, revenue_group_2?: string | null, revenue_group_1?: string | null, preferred_payment_channel?: string | null, payment_terms_in_days?: any | null, payment_due_on_receipt?: boolean | null, payment_terms?: string | null, legal_entity_name?: string | null, logo?: string | null, billing_address?: any | null, account_category?: string | null, business_category?: string | null, no_of_employees?: any | null, company_category?: string | null, customer_financial_risk_category?: string | null, netsuite_id?: any | null, size?: string | null, customer_scale?: string | null, region?: string | null, platform_tier?: string | null, billing_contact?: any | null, address?: { __typename?: 'company_address', address_line_1?: string | null, city?: string | null, zip_code?: string | null, country?: string | null, region?: string | null, company_establishment_date?: string | null, company_industry_segment?: string | null, company_industry_sub_segment?: string | null, company_linkedin_handle?: string | null, company_size?: number | null, company_twitter_handle?: string | null, company_website?: string | null, name?: string | null, salesforce_account_id: string, state_province?: string | null, address_line_2?: string | null, address_line_3?: string | null } | null, owner?: { __typename?: 'owner', last_name: string, first_name?: string | null, email: string, region?: string | null } | null, parent?: { __typename?: 'customer', amagi_id?: string | null, account_legal_name?: string | null, account_name?: string | null, media_industry_sub_segment?: { __typename?: 'media_industry_sub_segment', name?: string | null } | null, children: Array<{ __typename?: 'customer', amagi_id?: string | null, account_legal_name?: string | null, account_name?: string | null, media_industry_sub_segment?: { __typename?: 'media_industry_sub_segment', name?: string | null } | null }> } | null, orders_aggregate: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null }, csm?: { __typename?: 'owner', first_name?: string | null, last_name: string, email: string } | null, account_manager?: { __typename?: 'owner', first_name?: string | null, last_name: string, email: string } | null, channels: Array<{ __typename?: 'channel', id: any, subtitle_type?: any | null, subtitle_support?: boolean | null, ssai_partner?: string | null, salesforce_last_modified_date?: any | null, salesforce_id: string, salesforce_created_date?: any | null, salesforce_account_id?: string | null, parental_rating_standard?: string | null, name: string, is_redundant?: boolean | null, is_deleted: boolean, input_audio_format?: string | null, graphics_support?: any | null, genre?: any | null, feed_type?: string | null, description?: any | null, custom_tags: any, channel_type?: string | null, channel_resolution?: string | null, channel_rating?: any | null, billing_contact?: string | null, original_audio_language?: string | null }>, children: Array<{ __typename?: 'customer', amagi_id?: string | null, account_legal_name?: string | null, account_name?: string | null, media_industry_sub_segment?: { __typename?: 'media_industry_sub_segment', name?: string | null } | null }>, sales?: Array<{ __typename?: 'fn_return_sales_response', amount: any, source: string, status: string }> | null, orders: Array<{ __typename?: 'order', order_products: Array<{ __typename?: 'order_product', product?: { __typename?: 'product', family?: string | null } | null }> }>, invoices_aggregate: { __typename?: 'invoice_aggregate', aggregate?: { __typename?: 'invoice_aggregate_fields', sum?: { __typename?: 'invoice_sum_fields', total_amount?: any | null } | null } | null }, product_url?: { __typename?: 'customer_product_url', cloudport_urls?: any | null, thunderstorm_url?: string | null, planner_url?: string | null, amagi_now_url?: string | null } | null, content_plus_contacts?: { __typename?: 'content_plus_contacts', content_plus_internal_email_id?: string | null, content_plus_customer_email_id_1?: string | null, content_plus_customer_email_id_2?: string | null, content_plus_customer_email_id_3?: string | null, content_plus_customer_email_id_4?: string | null, content_plus_customer_email_id_5?: string | null, content_plus_customer_email_id_6?: string | null, amagi_content_plus_owner?: { __typename?: 'owner', first_name?: string | null, last_name: string, email: string } | null } | null, onboarding_customer_contacts?: { __typename?: 'onboarding_customer_contacts', onboarding_customer_email_id_1?: string | null, onboarding_customer_email_id_2?: string | null, onboarding_customer_email_id_3?: string | null, onboarding_customer_email_id_4?: string | null, onboarding_customer_email_id_5?: string | null, onboarding_customer_email_id_6?: string | null, onboarding_customer_email_id_7?: string | null, onboarding_customer_email_id_8?: string | null, onboarding_customer_email_id_9?: string | null, onboarding_customer_email_id_10?: string | null } | null, ads_plus_customer_contacts?: { __typename?: 'ads_plus_customer_contacts', ads_plus_customer_email_id_1?: string | null, ads_plus_customer_email_id_2?: string | null, ads_plus_customer_email_id_3?: string | null, ads_plus_customer_email_id_4?: string | null, ads_plus_customer_email_id_5?: string | null, ads_plus_customer_email_id_6?: string | null } | null };

export type CustomerByPkQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type CustomerByPkQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', amagi_id?: string | null, account_creation_date?: any | null, account_currency?: string | null, account_deactivation_date?: any | null, account_legal_name?: string | null, account_name?: string | null, ad_revenue_model?: string | null, customer_tier?: string | null, description?: string | null, phone?: string | null, tam?: string | null, billing_term?: string | null, churn_risk_percentage?: any | null, cloud_region?: any | null, cloud_service_provider?: any | null, comments?: string | null, created_at?: any | null, credit_period_in_days?: string | null, credit_score?: any | null, customer_business_model?: string | null, customer_contract_period?: any | null, customer_life_time_value?: any | null, customer_revenue_for_previous_year?: any | null, customer_revenue_for_the_present_year?: any | null, customer_type?: string | null, customers_profit_for_previous_year?: any | null, customers_profit_for_the_present_year?: any | null, dso?: string | null, first_invoice_date?: any | null, industry_segment?: string | null, invoicing_currency?: string | null, is_active?: boolean | null, is_deleted?: boolean | null, is_msa_ratecard_customer?: boolean | null, is_ono?: boolean | null, language?: string | null, status?: string | null, service_tier?: string | null, salesforce_created_date?: any | null, customer_since_date?: any | null, salesforce_last_modified_date?: any | null, salesforce_accountmanager_id?: string | null, revenue_group_2?: string | null, revenue_group_1?: string | null, preferred_payment_channel?: string | null, payment_terms_in_days?: any | null, payment_due_on_receipt?: boolean | null, payment_terms?: string | null, legal_entity_name?: string | null, logo?: string | null, billing_address?: any | null, account_category?: string | null, business_category?: string | null, no_of_employees?: any | null, company_category?: string | null, customer_financial_risk_category?: string | null, netsuite_id?: any | null, size?: string | null, customer_scale?: string | null, region?: string | null, platform_tier?: string | null, billing_contact?: any | null, address?: { __typename?: 'company_address', address_line_1?: string | null, city?: string | null, zip_code?: string | null, country?: string | null, region?: string | null, company_establishment_date?: string | null, company_industry_segment?: string | null, company_industry_sub_segment?: string | null, company_linkedin_handle?: string | null, company_size?: number | null, company_twitter_handle?: string | null, company_website?: string | null, name?: string | null, salesforce_account_id: string, state_province?: string | null, address_line_2?: string | null, address_line_3?: string | null } | null, owner?: { __typename?: 'owner', last_name: string, first_name?: string | null, email: string, region?: string | null } | null, parent?: { __typename?: 'customer', amagi_id?: string | null, account_legal_name?: string | null, account_name?: string | null, media_industry_sub_segment?: { __typename?: 'media_industry_sub_segment', name?: string | null } | null, children: Array<{ __typename?: 'customer', amagi_id?: string | null, account_legal_name?: string | null, account_name?: string | null, media_industry_sub_segment?: { __typename?: 'media_industry_sub_segment', name?: string | null } | null }> } | null, orders_aggregate: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null }, csm?: { __typename?: 'owner', first_name?: string | null, last_name: string, email: string } | null, account_manager?: { __typename?: 'owner', first_name?: string | null, last_name: string, email: string } | null, channels: Array<{ __typename?: 'channel', id: any, subtitle_type?: any | null, subtitle_support?: boolean | null, ssai_partner?: string | null, salesforce_last_modified_date?: any | null, salesforce_id: string, salesforce_created_date?: any | null, salesforce_account_id?: string | null, parental_rating_standard?: string | null, name: string, is_redundant?: boolean | null, is_deleted: boolean, input_audio_format?: string | null, graphics_support?: any | null, genre?: any | null, feed_type?: string | null, description?: any | null, custom_tags: any, channel_type?: string | null, channel_resolution?: string | null, channel_rating?: any | null, billing_contact?: string | null, original_audio_language?: string | null }>, children: Array<{ __typename?: 'customer', amagi_id?: string | null, account_legal_name?: string | null, account_name?: string | null, media_industry_sub_segment?: { __typename?: 'media_industry_sub_segment', name?: string | null } | null }>, sales?: Array<{ __typename?: 'fn_return_sales_response', amount: any, source: string, status: string }> | null, orders: Array<{ __typename?: 'order', order_products: Array<{ __typename?: 'order_product', product?: { __typename?: 'product', family?: string | null } | null }> }>, invoices_aggregate: { __typename?: 'invoice_aggregate', aggregate?: { __typename?: 'invoice_aggregate_fields', sum?: { __typename?: 'invoice_sum_fields', total_amount?: any | null } | null } | null }, product_url?: { __typename?: 'customer_product_url', cloudport_urls?: any | null, thunderstorm_url?: string | null, planner_url?: string | null, amagi_now_url?: string | null } | null, content_plus_contacts?: { __typename?: 'content_plus_contacts', content_plus_internal_email_id?: string | null, content_plus_customer_email_id_1?: string | null, content_plus_customer_email_id_2?: string | null, content_plus_customer_email_id_3?: string | null, content_plus_customer_email_id_4?: string | null, content_plus_customer_email_id_5?: string | null, content_plus_customer_email_id_6?: string | null, amagi_content_plus_owner?: { __typename?: 'owner', first_name?: string | null, last_name: string, email: string } | null } | null, onboarding_customer_contacts?: { __typename?: 'onboarding_customer_contacts', onboarding_customer_email_id_1?: string | null, onboarding_customer_email_id_2?: string | null, onboarding_customer_email_id_3?: string | null, onboarding_customer_email_id_4?: string | null, onboarding_customer_email_id_5?: string | null, onboarding_customer_email_id_6?: string | null, onboarding_customer_email_id_7?: string | null, onboarding_customer_email_id_8?: string | null, onboarding_customer_email_id_9?: string | null, onboarding_customer_email_id_10?: string | null } | null, ads_plus_customer_contacts?: { __typename?: 'ads_plus_customer_contacts', ads_plus_customer_email_id_1?: string | null, ads_plus_customer_email_id_2?: string | null, ads_plus_customer_email_id_3?: string | null, ads_plus_customer_email_id_4?: string | null, ads_plus_customer_email_id_5?: string | null, ads_plus_customer_email_id_6?: string | null } | null } | null };

export type CustomerContactsDataFragment = { __typename?: 'customer', contacts: Array<{ __typename?: 'contact', first_name?: string | null, last_name: string, work_phone_number?: string | null, region?: string | null, mobile_phone_number?: string | null, department?: string | null, country?: string | null, email_id?: string | null, title?: string | null }> };

export type CustomerContactsByPkQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type CustomerContactsByPkQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', contacts: Array<{ __typename?: 'contact', first_name?: string | null, last_name: string, work_phone_number?: string | null, region?: string | null, mobile_phone_number?: string | null, department?: string | null, country?: string | null, email_id?: string | null, title?: string | null }> } | null };

export type CustomerContractDocumentsQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type CustomerContractDocumentsQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', customer_files?: { __typename?: 'SalesforceOpportunityResponse', totalSize: number, records: Array<{ __typename?: 'OpportunityFile', id: string, details: { __typename?: 'OpportunityFileDetails', name: string, type: string, extension: string, size: number }, document: { __typename?: 'OpportunityFileVersion', document_base64: string } }> } | null } | null };

export type CustomerContractTermsFragment = { __typename?: 'customer', contract_terms?: { __typename?: 'customer_contract_terms', billing_type?: string | null, payment_terms?: string | null, price_escalation?: string | null, msa_effective_date?: any | null, price_escalation_period?: any | null, yearly_escalation_percentage?: any | null, order_initial_term?: any | null, order_renewal_term?: any | null, so_cancel_notice_after_oit?: any | null, so_cancel_notice_during_oit?: any | null, security_deposit?: string | null, deposit_amount_mrr_months?: any | null, payment_term_for_terminated_services?: any | null, entitled_to_stop_services_after?: string | null, termination_due_to_platform_notice?: any | null, interest_percent_applicable_post_due_date?: any | null, billing_date_rule?: string | null, billing_threshold_rule?: string | null } | null };

export type CustomerContractTermsByPkQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type CustomerContractTermsByPkQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', cplus_msa_effective_date?: any | null, connect_msa_effective_date?: any | null, contract_terms?: { __typename?: 'customer_contract_terms', billing_type?: string | null, payment_terms?: string | null, price_escalation?: string | null, msa_effective_date?: any | null, price_escalation_period?: any | null, yearly_escalation_percentage?: any | null, order_initial_term?: any | null, order_renewal_term?: any | null, so_cancel_notice_after_oit?: any | null, so_cancel_notice_during_oit?: any | null, security_deposit?: string | null, deposit_amount_mrr_months?: any | null, payment_term_for_terminated_services?: any | null, entitled_to_stop_services_after?: string | null, termination_due_to_platform_notice?: any | null, interest_percent_applicable_post_due_date?: any | null, billing_date_rule?: string | null, billing_threshold_rule?: string | null } | null } | null };

export type CustomerFinChartCummulativeDataFragment = { __typename?: 'customer', booked_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, billed_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, actual_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, netsuite_credit_issued?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null };

export type CustomerFinChartDataFragment = { __typename?: 'customer', booked_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, billed_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, actual_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, netsuite_credit_issued?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null };

export type CustomerFinChartCummulativeByPkQueryVariables = Exact<{
  amagi_id: Scalars['String'];
  from_date: Scalars['String'];
}>;


export type CustomerFinChartCummulativeByPkQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', booked_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, billed_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, actual_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, netsuite_credit_issued?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null } | null };

export type CustomerFinChartByPkQueryVariables = Exact<{
  amagi_id: Scalars['String'];
  from_date: Scalars['String'];
}>;


export type CustomerFinChartByPkQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', booked_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, billed_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, actual_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, netsuite_credit_issued?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null } | null };

export type CustomerInvoicesDataFragment = { __typename?: 'customer', financials?: Array<{ __typename?: 'fn_return_combined_invoice', invoice_id: string, type?: string | null, invoice_date?: any | null, due_date?: any | null, payment_status?: string | null, tax?: any | null, invoice_amount?: any | null, amount_due?: any | null, billing_period?: string | null, so_po_reference_number?: string | null, root_cause_reason?: string | null, currency?: string | null, lines?: Array<{ __typename?: 'fn_return_combined_invoice_line', product_id: string, product?: string | null, description?: string | null, platform?: string | null, channel?: string | null, region?: string | null, charge_type?: string | null, revenue_type?: string | null, quantity?: any | null, rate?: any | null, amount?: any | null, tax_type?: string | null, tax_rate?: string | null, tax_amount?: any | null, gross_amount?: any | null, start_date?: any | null, end_date?: any | null, currency?: string | null, product_info?: { __typename?: 'product', name: string, short_name?: string | null, code: string, description?: string | null } | null }> | null }> | null, date?: Array<{ __typename?: 'fn_return_combined_invoice', invoice_date?: any | null }> | null };

export type CustomerCreditMemosDataFragment = { __typename?: 'customer', financials?: Array<{ __typename?: 'fn_return_combined_invoice', invoice_id: string, type?: string | null, invoice_date?: any | null, due_date?: any | null, payment_status?: string | null, tax?: any | null, invoice_amount?: any | null, amount_due?: any | null, billing_period?: string | null, so_po_reference_number?: string | null, root_cause_reason?: string | null, currency?: string | null, lines?: Array<{ __typename?: 'fn_return_combined_invoice_line', product_id: string, product?: string | null, description?: string | null, platform?: string | null, channel?: string | null, region?: string | null, charge_type?: string | null, revenue_type?: string | null, quantity?: any | null, rate?: any | null, amount?: any | null, tax_type?: string | null, tax_rate?: string | null, tax_amount?: any | null, gross_amount?: any | null, start_date?: any | null, end_date?: any | null, currency?: string | null, product_info?: { __typename?: 'product', name: string, short_name?: string | null, code: string, description?: string | null } | null }> | null }> | null, date?: Array<{ __typename?: 'fn_return_combined_invoice', invoice_date?: any | null }> | null };

export type FinancialCardCummulativeDataFragment = { __typename?: 'customer', booked_revenue?: Array<{ __typename?: 'fn_return_financial_graph', amount: any }> | null, billed_revenue?: Array<{ __typename?: 'fn_return_financial_graph', amount: any }> | null, actual_revenue?: Array<{ __typename?: 'fn_return_financial_graph', amount: any }> | null, netsuite_credit_issued?: Array<{ __typename?: 'fn_return_financial_graph', amount: any }> | null };

export type CustomerInvoicesByPkQueryVariables = Exact<{
  amagi_id: Scalars['String'];
  from?: InputMaybe<Scalars['date']>;
  to?: InputMaybe<Scalars['date']>;
}>;


export type CustomerInvoicesByPkQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', financials?: Array<{ __typename?: 'fn_return_combined_invoice', invoice_id: string, type?: string | null, invoice_date?: any | null, due_date?: any | null, payment_status?: string | null, tax?: any | null, invoice_amount?: any | null, amount_due?: any | null, billing_period?: string | null, so_po_reference_number?: string | null, root_cause_reason?: string | null, currency?: string | null, lines?: Array<{ __typename?: 'fn_return_combined_invoice_line', product_id: string, product?: string | null, description?: string | null, platform?: string | null, channel?: string | null, region?: string | null, charge_type?: string | null, revenue_type?: string | null, quantity?: any | null, rate?: any | null, amount?: any | null, tax_type?: string | null, tax_rate?: string | null, tax_amount?: any | null, gross_amount?: any | null, start_date?: any | null, end_date?: any | null, currency?: string | null, product_info?: { __typename?: 'product', name: string, short_name?: string | null, code: string, description?: string | null } | null }> | null }> | null, date?: Array<{ __typename?: 'fn_return_combined_invoice', invoice_date?: any | null }> | null } | null };

export type CustomerCreditMemosByPkQueryVariables = Exact<{
  amagi_id: Scalars['String'];
  from?: InputMaybe<Scalars['date']>;
  to?: InputMaybe<Scalars['date']>;
}>;


export type CustomerCreditMemosByPkQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', financials?: Array<{ __typename?: 'fn_return_combined_invoice', invoice_id: string, type?: string | null, invoice_date?: any | null, due_date?: any | null, payment_status?: string | null, tax?: any | null, invoice_amount?: any | null, amount_due?: any | null, billing_period?: string | null, so_po_reference_number?: string | null, root_cause_reason?: string | null, currency?: string | null, lines?: Array<{ __typename?: 'fn_return_combined_invoice_line', product_id: string, product?: string | null, description?: string | null, platform?: string | null, channel?: string | null, region?: string | null, charge_type?: string | null, revenue_type?: string | null, quantity?: any | null, rate?: any | null, amount?: any | null, tax_type?: string | null, tax_rate?: string | null, tax_amount?: any | null, gross_amount?: any | null, start_date?: any | null, end_date?: any | null, currency?: string | null, product_info?: { __typename?: 'product', name: string, short_name?: string | null, code: string, description?: string | null } | null }> | null }> | null, date?: Array<{ __typename?: 'fn_return_combined_invoice', invoice_date?: any | null }> | null } | null };

export type CustomerFinancialCumulativeByPkQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type CustomerFinancialCumulativeByPkQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', booked_revenue?: Array<{ __typename?: 'fn_return_financial_graph', amount: any }> | null, billed_revenue?: Array<{ __typename?: 'fn_return_financial_graph', amount: any }> | null, actual_revenue?: Array<{ __typename?: 'fn_return_financial_graph', amount: any }> | null, netsuite_credit_issued?: Array<{ __typename?: 'fn_return_financial_graph', amount: any }> | null } | null };

export type OrderDataFragment = { __typename?: 'order', salesforce_id: string, order_number?: string | null, status?: string | null, amount?: any | null, currency?: string | null, opportunity?: { __typename?: 'opportunity', name: string, id: string } | null, order_products: Array<{ __typename?: 'order_product', salesforce_id: string, order_product_number?: string | null, order_product_line_status?: string | null, fsys_unit_net_price?: any | null, list_price: any, unit_price: any, tax_amount?: any | null, total_price: any, service_date?: any | null, end_date?: any | null, product?: { __typename?: 'product', name: string, short_name?: string | null, code: string } | null, channel?: { __typename?: 'channel', name: string } | null, platform?: { __typename?: 'platform', name: string } | null }>, order_items_by_salesforce_order_id: Array<{ __typename?: 'order_item', order_item_name?: string | null, order_item_id?: string | null, tech_lead?: string | null, order_type?: string | null, on_hold_reason?: string | null, stage?: string | null, oit_created?: string | null, oit_ticket_status?: string | null, revised_expected_go_live_date?: any | null, revised_expected_delivery_date?: any | null, actual_go_live_date?: any | null, actual_delivery_date?: any | null, approved_for_onboarding_date?: any | null, owner?: { __typename?: 'owner', first_name?: string | null, last_name: string } | null, order_item_lines: Array<{ __typename?: 'order_item_line', order_item_line_id?: string | null, order_item_line_name?: string | null, order_product_number?: string | null, stage?: string | null, billing_start_date_rule?: string | null, line_invoiced_or_not?: string | null, actual_go_live_date?: any | null, actual_delivery_date?: any | null, revised_expected_go_live_date?: any | null, revised_expected_delivery_date?: any | null, owner?: { __typename?: 'owner', first_name?: string | null, last_name: string } | null }> }> };

export type OrderQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type OrderQuery = { __typename?: 'query_root', order: Array<{ __typename?: 'order', salesforce_id: string, order_number?: string | null, status?: string | null, amount?: any | null, currency?: string | null, opportunity?: { __typename?: 'opportunity', name: string, id: string } | null, order_products: Array<{ __typename?: 'order_product', salesforce_id: string, order_product_number?: string | null, order_product_line_status?: string | null, fsys_unit_net_price?: any | null, list_price: any, unit_price: any, tax_amount?: any | null, total_price: any, service_date?: any | null, end_date?: any | null, product?: { __typename?: 'product', name: string, short_name?: string | null, code: string } | null, channel?: { __typename?: 'channel', name: string } | null, platform?: { __typename?: 'platform', name: string } | null }>, order_items_by_salesforce_order_id: Array<{ __typename?: 'order_item', order_item_name?: string | null, order_item_id?: string | null, tech_lead?: string | null, order_type?: string | null, on_hold_reason?: string | null, stage?: string | null, oit_created?: string | null, oit_ticket_status?: string | null, revised_expected_go_live_date?: any | null, revised_expected_delivery_date?: any | null, actual_go_live_date?: any | null, actual_delivery_date?: any | null, approved_for_onboarding_date?: any | null, owner?: { __typename?: 'owner', first_name?: string | null, last_name: string } | null, order_item_lines: Array<{ __typename?: 'order_item_line', order_item_line_id?: string | null, order_item_line_name?: string | null, order_product_number?: string | null, stage?: string | null, billing_start_date_rule?: string | null, line_invoiced_or_not?: string | null, actual_go_live_date?: any | null, actual_delivery_date?: any | null, revised_expected_go_live_date?: any | null, revised_expected_delivery_date?: any | null, owner?: { __typename?: 'owner', first_name?: string | null, last_name: string } | null }> }> }> };

export type CustomerProductDataFragment = { __typename?: 'customer', product_table_detail?: Array<{ __typename?: 'fn_return_product_table_detail', name: string, short_name?: string | null, product_id: string, family: string, group: string, sub_group: string, subscription: any, mrr: any, arr: any, consumption: any, others: any }> | null };

export type CustomerProductByPkQueryVariables = Exact<{
  amagi_id: Scalars['String'];
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
}>;


export type CustomerProductByPkQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', product_table_detail?: Array<{ __typename?: 'fn_return_product_table_detail', name: string, short_name?: string | null, product_id: string, family: string, group: string, sub_group: string, subscription: any, mrr: any, arr: any, consumption: any, others: any }> | null } | null };

export type CustomerProductRevenueQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type CustomerProductRevenueQuery = { __typename?: 'query_root', delivery_channel_platform: Array<{ __typename?: 'fn_return_delivery_channel_platform', channel_id?: any | null, channel_name?: string | null, channel_logo?: string | null, platform_id?: any | null, platform_name?: string | null, platform_logo?: string | null, products: any }> };

export type CustomerQuotesDataFragment = { __typename?: 'customer', quotes: Array<{ __typename?: 'quote', quote_number: string, quote_type?: string | null, msa_quote_type?: string | null, status?: string | null, primary_quote_actions?: boolean | null, start_date?: any | null, end_date?: any | null, opportunity?: { __typename?: 'opportunity', name: string } | null, quote_lines: Array<{ __typename?: 'quote_line', product_code?: string | null, product_name?: string | null, currency?: string | null, unit_net_price?: any | null, list_unit_price?: any | null, additional_discount_percentage?: any | null, additional_discount?: any | null, product_details?: { __typename?: 'product', short_name?: string | null } | null, channel_details?: { __typename?: 'channel', name: string } | null, platform?: { __typename?: 'platform', name: string } | null }> }> };

export type CustomerQuotesByPkQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type CustomerQuotesByPkQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', quotes: Array<{ __typename?: 'quote', quote_number: string, quote_type?: string | null, msa_quote_type?: string | null, status?: string | null, primary_quote_actions?: boolean | null, start_date?: any | null, end_date?: any | null, opportunity?: { __typename?: 'opportunity', name: string } | null, quote_lines: Array<{ __typename?: 'quote_line', product_code?: string | null, product_name?: string | null, currency?: string | null, unit_net_price?: any | null, list_unit_price?: any | null, additional_discount_percentage?: any | null, additional_discount?: any | null, product_details?: { __typename?: 'product', short_name?: string | null } | null, channel_details?: { __typename?: 'channel', name: string } | null, platform?: { __typename?: 'platform', name: string } | null }> }> } | null };

export type ProductSkuDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductSkuDataQuery = { __typename?: 'query_root', product_sku_data: Array<{ __typename?: 'product_sku_data', code?: string | null, name?: string | null, charge_type?: string | null, display_unit?: string | null, is_active?: boolean | null, description?: string | null, bu?: string | null, product_group?: string | null, product_sub_group?: string | null, product_sub_group_category?: string | null, usd?: string | null, apac_usd?: string | null, apac_inr?: string | null, eur?: string | null, qar?: string | null, gbp?: string | null, is_deprecated?: boolean | null, so_description?: string | null, sku_type?: string | null, account_exclusive_product?: boolean | null, hidden_from_so_invoice?: boolean | null }> };

export type GetCustomerRegionRevenueQueryVariables = Exact<{
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
}>;


export type GetCustomerRegionRevenueQuery = { __typename?: 'query_root', customer_region_revenue: Array<{ __typename?: 'fn_return_customer_region_revenue', customer_region: string, total?: any | null }> };

export type GetOutstandingAmountsQueryVariables = Exact<{
  from_date: Scalars['String'];
  to_date: Scalars['String'];
}>;


export type GetOutstandingAmountsQuery = { __typename?: 'query_root', customer_outstanding_amount: Array<{ __typename?: 'fn_return_customer_outstanding_amount', revenue_type: string, due_amount?: any | null, overdue_amount?: any | null }>, customer_churn_revenue: Array<{ __typename?: 'fn_return_customer_churn_revenue', revenue_type: string, value?: any | null }>, customer_downsell_revenue: Array<{ __typename?: 'fn_return_customer_downsell_revenue', revenue_type: string, value?: any | null }> };

export type GetMrrTrendsQueryVariables = Exact<{
  from_date: Scalars['String'];
  to_date: Scalars['String'];
  from_year: Scalars['Int'];
  to_year: Scalars['Int'];
}>;



export type GetMrrTrendsQuery = { __typename?: 'query_root', cdp_billed_mrr: Array<{ __typename?: 'fn_return_mrr_trends', billing_month: any, amount_usd?: any | null }>, cdp_annual_billed_mrr: Array<{ __typename?: 'fn_return_annual_mrr_trends', year: number, amount_usd?: any | null }>, cdp_contracted_mrr: Array<{ __typename?: 'fn_return_mrr_trends', billing_month: any, amount_usd?: any | null }>, cdp_annual_contracted_mrr: Array<{ __typename?: 'fn_return_annual_mrr_trends', year: number, amount_usd?: any | null }>, cdp_booked_mrr: Array<{ __typename?: 'fn_return_mrr_trends', billing_month: any, amount_usd?: any | null }>, cdp_annual_booked_mrr: Array<{ __typename?: 'fn_return_annual_mrr_trends', year: number, amount_usd?: any | null }>, cdp_recognised_mrr: Array<{ __typename?: 'fn_return_mrr_trends', billing_month: any, amount_usd?: any | null }>, cdp_annual_recognised_mrr: Array<{ __typename?: 'fn_return_annual_mrr_trends', year: number, amount_usd?: any | null }> };


export type GetConsumptionSubscriptionRevenueQueryVariables = Exact<{
  from_date: Scalars["String"];
  to_date: Scalars["String"];
}>;

export type GetConsumptionSubscriptionRevenueQuery = {
  __typename?: "query_root";
  cdp_consumption_mrr: Array<{
    __typename?: "fn_return_mrr_trends";
    billing_month: any;
    amount_usd?: any | null;
  }>;
  cdp_subscription_mrr: Array<{
    __typename?: "fn_return_mrr_trends";
    billing_month: any;
    amount_usd?: any | null;
  }>;
};

export type CustomerSalesDataFragment = { __typename?: 'customer', owner?: { __typename?: 'owner', last_name: string, first_name?: string | null, email: string, region?: string | null } | null, csm?: { __typename?: 'owner', first_name?: string | null, last_name: string, email: string } | null, account_manager?: { __typename?: 'owner', first_name?: string | null, last_name: string, email: string } | null, sales?: Array<{ __typename?: 'fn_return_sales_response', amount: any, source: string, status: string }> | null, opportunity: Array<{ __typename?: 'opportunity', name: string, description?: string | null, amount?: any | null, stage_name?: string | null, opportunity_type?: string | null, expected_revenue?: any | null, close_date?: any | null, lead_source?: string | null, salesforce_contract_id?: string | null, salesforce_id: string, product?: string | null, reason_for_closed_won?: string | null, reason_for_closed_lost?: string | null, monetization_model?: string | null, so?: string | null, competition?: string | null, currency_iso_code?: string | null }> };

export type CustomerSalesByPkQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type CustomerSalesByPkQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', owner?: { __typename?: 'owner', last_name: string, first_name?: string | null, email: string, region?: string | null } | null, csm?: { __typename?: 'owner', first_name?: string | null, last_name: string, email: string } | null, account_manager?: { __typename?: 'owner', first_name?: string | null, last_name: string, email: string } | null, sales?: Array<{ __typename?: 'fn_return_sales_response', amount: any, source: string, status: string }> | null, opportunity: Array<{ __typename?: 'opportunity', name: string, description?: string | null, amount?: any | null, stage_name?: string | null, opportunity_type?: string | null, expected_revenue?: any | null, close_date?: any | null, lead_source?: string | null, salesforce_contract_id?: string | null, salesforce_id: string, product?: string | null, reason_for_closed_won?: string | null, reason_for_closed_lost?: string | null, monetization_model?: string | null, so?: string | null, competition?: string | null, currency_iso_code?: string | null }> } | null };

export type CustomerFdTicketsDataFragment = { __typename?: 'freshdesk_ticket', ticket_id: any, subject?: string | null, description?: string | null, impact?: string | null, product_resp?: string | null, product_resp_area?: string | null, product_resp_area_component?: string | null, priority?: any | null, ticket_type?: string | null, status?: any | null, resolved_date?: any | null, closed_at?: any | null, root_cause?: string | null, credit_amount?: string | null, credit_currency?: string | null, delivery_channel?: string | null, created_date?: any | null, tags?: any | null, company_id?: any | null, invoice_number?: string | null, dispute_type?: string | null, dispute_outcome?: string | null, invoice_month?: any | null, invoice_amount?: string | null, disputed_amount?: string | null, charge_codes?: string | null, region?: string | null, coordinator?: string | null, billing_issue_status?: string | null, root_cause_category?: string | null, root_cause_owner?: string | null, group?: any | null, group_agent?: any | null, customer_id?: string | null, customer_name?: string | null, source?: any | null, last_updated_date?: any | null };

export type ServiceTicketsQueryVariables = Exact<{
  amagi_id?: InputMaybe<Scalars['String']>;
}>;


export type ServiceTicketsQuery = { __typename?: 'query_root', service_tickets: Array<{ __typename?: 'freshdesk_company', tickets: Array<{ __typename?: 'freshdesk_ticket', ticket_id: any, subject?: string | null, description?: string | null, impact?: string | null, product_resp?: string | null, product_resp_area?: string | null, product_resp_area_component?: string | null, priority?: any | null, ticket_type?: string | null, status?: any | null, resolved_date?: any | null, closed_at?: any | null, root_cause?: string | null, credit_amount?: string | null, credit_currency?: string | null, delivery_channel?: string | null, created_date?: any | null, tags?: any | null, company_id?: any | null, invoice_number?: string | null, dispute_type?: string | null, dispute_outcome?: string | null, invoice_month?: any | null, invoice_amount?: string | null, disputed_amount?: string | null, charge_codes?: string | null, region?: string | null, coordinator?: string | null, billing_issue_status?: string | null, root_cause_category?: string | null, root_cause_owner?: string | null, group?: any | null, group_agent?: any | null, customer_id?: string | null, customer_name?: string | null, source?: any | null, is_deleted?: boolean | null, last_updated_date?: any | null }> }>, total: Array<{ __typename?: 'freshdesk_company', tickets_aggregate: { __typename?: 'freshdesk_ticket_aggregate', aggregate?: { __typename?: 'freshdesk_ticket_aggregate_fields', count: number } | null } }>, closed: Array<{ __typename?: 'freshdesk_company', tickets_aggregate: { __typename?: 'freshdesk_ticket_aggregate', aggregate?: { __typename?: 'freshdesk_ticket_aggregate_fields', count: number } | null } }> };

export type GetCustomerTierRevenueQueryVariables = Exact<{
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
}>;


export type GetCustomerTierRevenueQuery = { __typename?: 'query_root', customer_tier_revenue: Array<{ __typename?: 'fn_return_customer_tier_revenue', customer_tier: string, total?: any | null }> };

export type CustomerTotalOutstandingQueryVariables = Exact<{
  amagi_id: Scalars['String'];
  from_date: Scalars['String'];
  to_date: Scalars['String'];
}>;


export type CustomerTotalOutstandingQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', invoices_due?: Array<{ __typename?: 'fn_return_billing_summary', amount: any, count?: any | null }> | null, invoices_overdue?: Array<{ __typename?: 'fn_return_billing_summary', amount: any, count?: any | null }> | null } | null };

export type GetCustomerTypeRevenueQueryVariables = Exact<{
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
}>;


export type GetCustomerTypeRevenueQuery = { __typename?: 'query_root', customer_type_revenue: Array<{ __typename?: 'fn_return_customer_type_revenue', customer_type: string, total?: any | null }> };

export type AllCustomerDataFragment = { __typename?: 'customer', customer_tier?: string | null, salesforce_id?: string | null, amagi_id?: string | null, account_name?: string | null, account_legal_name?: string | null, industry_segment?: string | null, logo?: string | null, status?: string | null, size?: string | null, service_tier?: string | null, customer_type?: string | null, invoicing_currency?: string | null, media_industry_sub_segment?: { __typename?: 'media_industry_sub_segment', name?: string | null } | null, address?: { __typename?: 'company_address', region?: string | null } | null, owner?: { __typename?: 'owner', region?: string | null, owner_to_user?: { __typename?: 'user', rep_director?: string | null, rep_manager?: string | null, name?: string | null } | null } | null };

export type CustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerQuery = { __typename?: 'query_root', customer: Array<{ __typename?: 'customer', customer_tier?: string | null, salesforce_id?: string | null, amagi_id?: string | null, account_name?: string | null, account_legal_name?: string | null, industry_segment?: string | null, logo?: string | null, status?: string | null, size?: string | null, service_tier?: string | null, customer_type?: string | null, tam?: string | null, invoicing_currency?: string | null, media_industry_sub_segment?: { __typename?: 'media_industry_sub_segment', name?: string | null } | null, address?: { __typename?: 'company_address', region?: string | null } | null, owner?: { __typename?: 'owner', region?: string | null, owner_to_user?: { __typename?: 'user', rep_director?: string | null, rep_manager?: string | null, name?: string | null } }, record_type?: {__typename?: 'record_type', name?: string | null} | null }>};

export type GetAmagiIdsForUserQuery = {__typename?: 'query_root', financial_permissions: Array<{__typename?: 'financial_permissions', amagi_id?: string | null;}>;};

export type GetAmagiIdsForUserQueryVariables = Exact<{

  user_email: string | null

}>;

export type DashboardCountQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardCountQuery = { __typename?: 'query_root', customer_count: Array<{ __typename?: 'fn_return_customer_type', customer_type: string, count?: any | null }>, channel_aggregate: { __typename?: 'channel_aggregate', aggregate?: { __typename?: 'channel_aggregate_fields', count: number } | null }, platform_aggregate: { __typename?: 'platform_aggregate', aggregate?: { __typename?: 'platform_aggregate_fields', count: number } | null } };

export type DataQualityDetailsQueryVariables = Exact<{
  from_date?: InputMaybe<Scalars['date']>;
  to_date?: InputMaybe<Scalars['date']>;
}>;


export type DataQualityDetailsQuery = { __typename?: 'query_root', data_quality: Array<{ __typename?: 'data_quality', id: number, date?: any | null, table_name?: string | null, column_name?: string | null, accuracy?: any | null, completeness?: any | null, complete_weight?: any | null, completeness_weight?: any | null, weight?: any | null, custom_value?: any | null }>, key_metrics: Array<{ __typename?: 'data_quality', id: number, date?: any | null, table_name?: string | null, column_name?: string | null, custom_value?: any | null }> };

export type DataQualityTrendsQueryVariables = Exact<{
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
}>;


export type DataQualityTrendsQuery = { __typename?: 'query_root', data_quality_trend: Array<{ __typename?: 'fn_return_data_quality_graph', date: any, accuracy?: any | null, completeness?: any | null }>, data_growth_trend: Array<{ __typename?: 'fn_return_data_growth_graph', date: any, total_rows?: any | null }> };

export type DeleteMsaRateCardMutationVariables = Exact<{
  amagi_id: Scalars['String'];
  code: Scalars['String'];
  quote_number: Scalars['String'];
}>;


export type DeleteMsaRateCardMutation = { __typename?: 'mutation_root', delete_msa_rate_card_by_pk?: { __typename?: 'msa_rate_card', amagi_id: string, billing_frequency?: string | null, code: string, quote_number: string, currency?: string | null, price?: any | null, quote_type?: string | null, tier_at_product_level?: any | null, type?: string | null, unit?: string | null } | null };

export type ChannelInfoFragment = { __typename?: 'channel', id: any, name: string, channel_id?: string | null, genre?: any | null, logo?: string | null, channels_grouped?: string | null, channel_type?: string | null, original_audio_language?: string | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string } | null };

export type PlatformInfoFragment = { __typename?: 'platform', id: any, name: string, logo?: string | null, is_platform_group?: string | null, platform_tier?: string | null, availablity_country_and_regions?: any | null, account?: { __typename?: 'account', amagi_id: string, account_name: string } | null };

export type DeliveryInfoFragment = { __typename?: 'delivery_main', id?: any | null, ssai?: boolean | null, delivered_date?: any | null, go_live_date?: any | null, cdp_delivery_type?: string | null, request_origin?: string | null, product_purchased_for_this_delivery?: any | null, business_model?: any | null, deal_type_for_content_partner?: string | null, deal_split_with_content_partner?: number | null, deal_type_for_platform_partner?: string | null, deal_split_with_platform_partner?: number | null, deal_split_amagi_share?: number | null, delivery_type?: string | null, delivery_stream_type?: any | null, delivered_region?: any | null, delivery_status?: string | null, channel?: { __typename?: 'channel', id: any, name: string, channel_id?: string | null, genre?: any | null, logo?: string | null, channels_grouped?: string | null, channel_type?: string | null, original_audio_language?: string | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string } | null } | null, platform?: { __typename?: 'platform', id: any, name: string, logo?: string | null, is_platform_group?: string | null, platform_tier?: string | null, availablity_country_and_regions?: any | null, account?: { __typename?: 'account', amagi_id: string, account_name: string } | null } | null };

export type DeliveriesByCustomerQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type DeliveriesByCustomerQuery = { __typename?: 'query_root', channel_delivery: Array<{ __typename?: 'delivery_main', id?: any | null, ssai?: boolean | null, delivered_date?: any | null, go_live_date?: any | null, cdp_delivery_type?: string | null, request_origin?: string | null, product_purchased_for_this_delivery?: any | null, business_model?: any | null, deal_type_for_content_partner?: string | null, deal_split_with_content_partner?: number | null, deal_type_for_platform_partner?: string | null, deal_split_with_platform_partner?: number | null, deal_split_amagi_share?: number | null, delivery_type?: string | null, delivery_stream_type?: any | null, delivered_region?: any | null, delivery_status?: string | null, channel?: { __typename?: 'channel', id: any, name: string, channel_id?: string | null, genre?: any | null, logo?: string | null, channels_grouped?: string | null, channel_type?: string | null, original_audio_language?: string | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string } | null } | null, platform?: { __typename?: 'platform', id: any, name: string, logo?: string | null, is_platform_group?: string | null, platform_tier?: string | null, availablity_country_and_regions?: any | null, account?: { __typename?: 'account', amagi_id: string, account_name: string } | null } | null }>, vod_delivery: Array<{ __typename?: 'delivery_main', id?: any | null, ssai?: boolean | null, delivered_date?: any | null, go_live_date?: any | null, cdp_delivery_type?: string | null, request_origin?: string | null, product_purchased_for_this_delivery?: any | null, business_model?: any | null, deal_type_for_content_partner?: string | null, deal_split_with_content_partner?: number | null, deal_type_for_platform_partner?: string | null, deal_split_with_platform_partner?: number | null, deal_split_amagi_share?: number | null, delivery_type?: string | null, delivery_stream_type?: any | null, delivered_region?: any | null, delivery_status?: string | null, channel?: { __typename?: 'channel', id: any, name: string, channel_id?: string | null, genre?: any | null, logo?: string | null, channels_grouped?: string | null, channel_type?: string | null, original_audio_language?: string | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string } | null } | null, platform?: { __typename?: 'platform', id: any, name: string, logo?: string | null, is_platform_group?: string | null, platform_tier?: string | null, availablity_country_and_regions?: any | null, account?: { __typename?: 'account', amagi_id: string, account_name: string } | null } | null }>,live_delivery: Array<{ __typename?: 'delivery_main', id?: any | null, ssai?: boolean | null, delivered_date?: any | null, go_live_date?: any | null, cdp_delivery_type?: string | null, request_origin?: string | null, product_purchased_for_this_delivery?: any | null, business_model?: any | null, deal_type_for_content_partner?: string | null, deal_split_with_content_partner?: number | null, deal_type_for_platform_partner?: string | null, deal_split_with_platform_partner?: number | null, deal_split_amagi_share?: number | null, delivery_type?: string | null, delivery_stream_type?: any | null, delivered_region?: any | null, delivery_status?: string | null, channel?: { __typename?: 'channel', id: any, name: string, channel_id?: string | null, genre?: any | null, logo?: string | null, channels_grouped?: string | null, channel_type?: string | null, original_audio_language?: string | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string } | null } | null, platform?: { __typename?: 'platform', id: any, name: string, logo?: string | null, is_platform_group?: string | null, platform_tier?: string | null, availablity_country_and_regions?: any | null, account?: { __typename?: 'account', amagi_id: string, account_name: string } | null } | null }>, playouts: Array<{ __typename?: 'delivery_main', id?: any | null, ssai?: boolean | null, delivered_date?: any | null, go_live_date?: any | null, cdp_delivery_type?: string | null, request_origin?: string | null, product_purchased_for_this_delivery?: any | null, business_model?: any | null, deal_type_for_content_partner?: string | null, deal_split_with_content_partner?: number | null, deal_type_for_platform_partner?: string | null, deal_split_with_platform_partner?: number | null, deal_split_amagi_share?: number | null, delivery_type?: string | null, delivery_stream_type?: any | null, delivered_region?: any | null, delivery_status?: string | null, channel?: { __typename?: 'channel', id: any, name: string, channel_id?: string | null, genre?: any | null, logo?: string | null, channels_grouped?: string | null, channel_type?: string | null, original_audio_language?: string | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string } | null } | null, platform?: { __typename?: 'platform', id: any, name: string, logo?: string | null, is_platform_group?: string | null, platform_tier?: string | null, availablity_country_and_regions?: any | null, account?: { __typename?: 'account', amagi_id: string, account_name: string } | null } | null }>, channel_aggregate: { __typename?: 'channel_aggregate', aggregate?: { __typename?: 'channel_aggregate_fields', count: number } | null } };

export type DeliveryFragment = { __typename?: 'delivery', id: any, point_product_delivery_id?: string | null, ts_setup?: string | null, salesforce_channel_id?: string | null, salesforce_platform_id?: string | null, delivered_region?: any | null, delivered_using_amagi_now?: string | null, salesforce_order_id?: string | null, salesforce_order_item_id?: string | null, salesforce_order_product_id?: string | null, redundancy?: number | null, ordered_date?: any | null, provisioning_start_date?: any | null, delivered_date?: any | null, go_live_date?: any | null, churned_date?: any | null, churned_reason?: string | null, delivery_type?: string | null, test_playout?: string | null, redundant_playout?: number | null, redundant_playout_channels?: any | null, test_delivery?: string | null, delivery_stream_type?: any | null, on_hold_date?: any | null, on_hold_reason?: string | null, blocked_reason?: string | null, blocked_reason_details?: string | null, assignee?: string | null, ads_plus?: string | null, content_plus?: string | null, feed_type?: string | null, ssai?: boolean | null, ad_load_minutes?: number | null, turnaround?: boolean | null, business_model?: any | null, stream_url?: string | null, epg_url?: string | null, deal_type_for_content_partner?: string | null, deal_split_with_content_partner?: number | null, content_partner_primary?: string | null, content_partner_backfill?: string | null, deal_type_for_platform_partner?: string | null, deal_split_with_platform_partner?: number | null, platform_partner_primary?: string | null, platform_partner_backfill?: string | null, deal_split_amagi_share?: number | null, amagi_share_primary?: string | null, amagi_share_backfill?: string | null, product_purchased_for_this_delivery?: any | null, delivery_status?: string | null, audio_languages?: any | null, request_origin?: string | null, cdn_fee_owner?: string | null, cdn_tag_1?: string | null, cdn_tag_2?: string | null, cdn_tag_3?: string | null, cdn_tag_4?: string | null,  ssai_fee_owner?: string | null, connect_distribution_model?: string | null, content_partner_ad_sales_commission_percentage?: any | null, platform_ad_sales_commission_percentage?: any | null, inventory_share_amagi_primary_ad_tag?: string | null, inventory_share_amagi_backfill_ad_tag?: string | null, inventory_share_platform_primary_ad_tag?: string | null, inventory_share_platform_backfill_ad_tag?: string | null, inventory_share_content_partner_primary_ad_tag?: string | null, inventory_share_content_partner_backfill_ad_tag?: string | null, revenue_share_monetised_by_primary?: string | null, revenue_share_monetised_by_backfill?: string | null, revenue_share_primary_ad_tag?: string | null, revenue_share_backfill_ad_tag?: string | null, channel?: { __typename?: 'channel', id: any, salesforce_id: string, channels_grouped?: string | null, name: string, logo?: string | null, channel_type?: string | null } | null, order?: { __typename?: 'order', customer: { __typename?: 'account', account_name: string, amagi_id: string, logo?: string | null } } | null, platform?: { __typename?: 'platform', id: any, salesforce_id: string, is_platform_group?: string | null, name: string, logo?: string | null } | null, user?: { __typename?: 'user', name?: string | null, email?: string | null } | null };


export type DeliveryGridFragment = { __typename?: 'delivery_main', id?: any | null, point_product_delivery_id?: string | null, salesforce_channel_id?: string | null, salesforce_platform_id?: string | null, delivered_using_amagi_now?: string | null, delivered_region?: any | null, delivery_status?: string | null, channel?: { __typename?: 'channel', id: any, salesforce_id: string, channels_grouped?: string | null, name: string, logo?: string | null, channel_type?: string | null } | null, order?: { __typename?: 'order', customer: { __typename?: 'account', account_name: string, amagi_id: string, logo?: string | null } } | null, platform?: { __typename?: 'platform', id: any, salesforce_id: string, is_platform_group?: string | null, name: string, logo?: string | null } | null };

export type ChannelDeliveriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ChannelDeliveriesQuery = { __typename?: 'query_root', delivery: Array<{ __typename?: 'delivery_main', id?: any | null, point_product_delivery_id?: string | null, salesforce_channel_id?: string | null, salesforce_platform_id?: string | null, delivered_using_amagi_now?: string | null, delivered_region?: any | null, delivery_status?: string | null, channel?: { __typename?: 'channel', id: any, salesforce_id: string, channels_grouped?: string | null, name: string, logo?: string | null, channel_type?: string | null } | null, order?: { __typename?: 'order', customer: { __typename?: 'account', account_name: string, amagi_id: string, logo?: string | null } } | null, platform?: { __typename?: 'platform', id: any, salesforce_id: string, is_platform_group?: string | null, name: string, logo?: string | null } | null }> };

export type VodDeliveriesQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayoutDeliveriesQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayoutDeliveriesQuery = { __typename?: 'query_root', delivery: Array<{ __typename?: 'delivery_main', id?: any | null, point_product_delivery_id?: string | null, salesforce_channel_id?: string | null, salesforce_platform_id?: string | null, delivered_using_amagi_now?: string | null, delivered_region?: any | null, delivery_status?: string | null, channel?: { __typename?: 'channel', id: any, salesforce_id: string, channels_grouped?: string | null, name: string, logo?: string | null, channel_type?: string | null } | null, order?: { __typename?: 'order', customer: { __typename?: 'account', account_name: string, amagi_id: string, logo?: string | null } } | null, platform?: { __typename?: 'platform', id: any, salesforce_id: string, is_platform_group?: string | null, name: string, logo?: string | null } | null }> };



export type VodDeliveriesQuery = { __typename?: 'query_root', delivery: Array<{ __typename?: 'delivery_main', id?: any | null, point_product_delivery_id?: string | null, salesforce_channel_id?: string | null, salesforce_platform_id?: string | null, delivered_using_amagi_now?: string | null, delivered_region?: any | null, delivery_status?: string | null, channel?: { __typename?: 'channel', id: any, salesforce_id: string, channels_grouped?: string | null, name: string, logo?: string | null, channel_type?: string | null } | null, order?: { __typename?: 'order', customer: { __typename?: 'account', account_name: string, amagi_id: string, logo?: string | null } } | null, platform?: { __typename?: 'platform', id: any, salesforce_id: string, is_platform_group?: string | null, name: string, logo?: string | null } | null }> };

export type LiveDeliveriesQueryVariables = Exact<{ [key: string]: never; }>;

export type LiveDeliveriesQuery = { __typename?: 'query_root', delivery: Array<{ __typename?: 'delivery_main', id?: any | null, point_product_delivery_id?: string | null, salesforce_channel_id?: string | null, salesforce_platform_id?: string | null, delivered_using_amagi_now?: string | null, delivered_region?: any | null, delivery_status?: string | null, channel?: { __typename?: 'channel', id: any, salesforce_id: string, channels_grouped?: string | null, name: string, logo?: string | null, channel_type?: string | null } | null, order?: { __typename?: 'order', customer: { __typename?: 'account', account_name: string, amagi_id: string, logo?: string | null } } | null, platform?: { __typename?: 'platform', id: any, salesforce_id: string, is_platform_group?: string | null, name: string, logo?: string | null } | null }> };

export type DeliverybyPkQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeliverybyPkQuery = { __typename?: 'query_root', delivery: Array<{ __typename?: 'delivery', id: any, point_product_delivery_id?: string | null, ts_setup?: string | null, salesforce_channel_id?: string | null, salesforce_platform_id?: string | null, delivered_region?: any | null, delivered_using_amagi_now?: string | null, salesforce_order_id?: string | null, salesforce_order_item_id?: string | null, salesforce_order_product_id?: string | null, redundancy?: number | null, ordered_date?: any | null, provisioning_start_date?: any | null, delivered_date?: any | null, go_live_date?: any | null, churned_date?: any | null, churned_reason?: string | null, delivery_type?: string | null, test_delivery?: string | null, test_playout?: string | null, redundant_playout?: number | null, redundant_playout_channels?: any | null, delivery_stream_type?: any | null, on_hold_date?: any | null, on_hold_reason?: string | null, blocked_reason?: string | null, blocked_reason_details?: string | null, assignee?: string | null, ads_plus?: string | null, content_plus?: string | null, feed_type?: string | null, ssai?: boolean | null, ad_load_minutes?: number | null, turnaround?: boolean | null, business_model?: any | null, stream_url?: string | null, epg_url?: string | null, deal_type_for_content_partner?: string | null, deal_split_with_content_partner?: number | null, content_partner_primary?: string | null, content_partner_backfill?: string | null, deal_type_for_platform_partner?: string | null, deal_split_with_platform_partner?: number | null, platform_partner_primary?: string | null, platform_partner_backfill?: string | null, deal_split_amagi_share?: number | null, amagi_share_primary?: string | null, amagi_share_backfill?: string | null, product_purchased_for_this_delivery?: any | null, delivery_status?: string | null, audio_languages?: any | null, request_origin?: string | null, cdn_fee_owner?: string | null, cdn_tag_1?: string | null, cdn_tag_2?: string | null, cdn_tag_3?: string | null, cdn_tag_4?: string | null, ssai_fee_owner?: string | null, connect_distribution_model?: string | null, content_partner_ad_sales_commission_percentage?: any | null, platform_ad_sales_commission_percentage?: any | null, inventory_share_amagi_primary_ad_tag?: string | null, inventory_share_amagi_backfill_ad_tag?: string | null, inventory_share_platform_primary_ad_tag?: string | null, inventory_share_platform_backfill_ad_tag?: string | null, inventory_share_content_partner_primary_ad_tag?: string | null, inventory_share_content_partner_backfill_ad_tag?: string | null, revenue_share_monetised_by_primary?: string | null, revenue_share_monetised_by_backfill?: string | null, revenue_share_primary_ad_tag?: string | null, revenue_share_backfill_ad_tag?: string | null, channel?: { __typename?: 'channel', id: any, salesforce_id: string, channels_grouped?: string | null, name: string, logo?: string | null, channel_type?: string | null } | null, order?: { __typename?: 'order', customer: { __typename?: 'account', account_name: string, amagi_id: string, logo?: string | null } } | null, platform?: { __typename?: 'platform', id: any, salesforce_id: string, is_platform_group?: string | null, name: string, logo?: string | null } | null, user?: { __typename?: 'user', name?: string | null, email?: string | null } | null }>, channel: Array<{ __typename?: 'channel', name: string, salesforce_id: string }>, platform: Array<{ __typename?: 'platform', name: string, salesforce_id: string }>, product: Array<{ __typename?: 'product', code: string, name: string }> };

export type UpdateDeliveryMutationVariables = Exact<{
  id: Scalars['uuid'];
  input?: InputMaybe<Delivery_Set_Input>;
}>;


export type UpdateDeliveryMutation = { __typename?: 'mutation_root', delivery?: { __typename?: 'delivery', id: any } | null };

export type UpdateDocsPageMutationVariables = Exact<{
  input?: InputMaybe<Page_Set_Input>;
}>;


export type UpdateDocsPageMutation = { __typename?: 'mutation_root', update_page_by_pk?: { __typename?: 'page', content?: string | null, slug: string } | null };

export type DocsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type DocsPageQuery = { __typename?: 'query_root', page_by_pk?: { __typename?: 'page', content?: string | null, slug: string } | null };

export type DqOverviewChannelTrendsQueryVariables = Exact<{
  from_date?: InputMaybe<Scalars['String']>;
}>;


export type DqOverviewChannelTrendsQuery = { __typename?: 'query_root', channel_trends: Array<{ __typename?: 'fn_return_existing_new_churned_dashboard', churned: any, existing: any, new: any, month: string }> };

export type DqOverviewCustomerTrendsQueryVariables = Exact<{
  from_date?: InputMaybe<Scalars['String']>;
}>;


export type DqOverviewCustomerTrendsQuery = { __typename?: 'query_root', customer_trends: Array<{ __typename?: 'fn_return_existing_new_churned_dashboard', churned: any, existing: any, new: any, month: string }> };

export type DqOverviewPlatformTrendsQueryVariables = Exact<{
  from_date?: InputMaybe<Scalars['String']>;
}>;


export type DqOverviewPlatformTrendsQuery = { __typename?: 'query_root', platform_trends: Array<{ __typename?: 'fn_return_existing_new_churned_dashboard', churned: any, existing: any, new: any, month: string }> };

export type DqCustomerTicketsQueryVariables = Exact<{
  from_date?: InputMaybe<Scalars['String']>;
}>;


export type DqCustomerTicketsQuery = { __typename?: 'query_root', tickets: Array<{ __typename?: 'fn_return_total_open_close_ticket_dashboard', month: string, open_ticket?: any | null, closed_ticket?: any | null }> };

export type NetsuiteTransactionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['date']>;
  end_date?: InputMaybe<Scalars['date']>;
}>;


export type NetsuiteTransactionsQuery = { __typename?: 'query_root', netsuite_transaction_line: Array<{ __typename?: 'netsuite_transaction_line', amount_usd?: any | null, amount?: any | null, billing_type?: string | null, channel?: string | null, end_date?: any | null, currency?: string | null, platform?: string | null, netsuite_id: string, netsuite_transaction_id?: any | null, quantity?: any | null, cdpderived_product_id?: string | null, product_name?: string | null, start_date?: any | null, netsuite_transaction?: { __typename?: 'netsuite_transaction',type?: string | null, billing_period?: string | null, transaction_id?: string | null, customer?: { __typename?: 'customer', account_legal_name?: string | null, amagi_id?: string | null } | null } | null }> };

export type GetCustomerDetailsQueryVariables = Exact<{
  amagi_id_or_customer_name: Scalars['String'];
}>;


export type GetCustomerDetailsQuery = { __typename?: 'query_root', customer: Array<{ __typename?: 'customer', salesforce_id?: string | null, amagi_id?: string | null, account_name?: string | null, account_legal_name?: string | null, invoicing_currency?: string | null, industry_segment?: string | null, logo?: string | null, size?: string | null, status?: string | null, service_tier?: string | null, customer_tier?: string | null, customer_type?: string | null, media_industry_sub_segment?: { __typename?: 'media_industry_sub_segment', name?: string | null } | null, address?: { __typename?: 'company_address', region?: string | null } | null, owner?: { __typename?: 'owner', region?: string | null } | null, invoices_aggregate: { __typename?: 'invoice_aggregate', aggregate?: { __typename?: 'invoice_aggregate_fields', sum?: { __typename?: 'invoice_sum_fields', total_amount?: any | null } | null } | null } }> };

export type FeatureFlagQueryVariables = Exact<{ [key: string]: never; }>;


export type FeatureFlagQuery = { __typename?: 'query_root', feature_flag: Array<{ __typename?: 'feature_flag', feature: string, roles?: any | null }> };

export type FinancialStatementsQueryVariables = Exact<{
  amagi_id: Scalars['String'];
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
}>;


export type FinancialStatementsQuery = { __typename?: 'query_root', account_statement?: { __typename?: 'customer', outstanding?: Array<{ __typename?: 'fn_return_account_statement_outstanding', balance?: any | null }> | null, statements?: Array<{ __typename?: 'fn_return_account_statement', transaction_date: string, transaction_type?: string | null, transaction_id?: string | null, charges?: any | null, payment?: any | null, balance?: any | null }> | null, grand_total?: Array<{ __typename?: 'fn_return_account_statement_summary', charges?: any | null, payment?: any | null, balance?: any | null }> | null, meta?: Array<{ __typename?: 'fn_return_account_statement_meta', transaction_type: string, count?: any | null }> | null } | null };


export type GetAverageAmountPerCustomerQueryVariables = Exact<{
  from_date: Scalars['String'];
  to_date: Scalars['String'];
}>;

export type GetAverageAmountPerCustomerQuery = { __typename?: 'query_root', average_customer_revenue: Array<{ __typename?: 'fn_return_average_customer_revenue', revenue_type: string, value?: any | null }>, average_subscription_revenue: Array<{ __typename?: 'fn_return_average_customer_revenue', revenue_type: string, value?: any | null }>, average_consumption_revenue: Array<{ __typename?: 'fn_return_average_customer_revenue', revenue_type: string, value?: any | null }> };

export type CheckSalesforceNetsuiteInvoiceQueryVariables = Exact<{
  transaction_id?: InputMaybe<Scalars['String']>;
}>;


export type CheckSalesforceNetsuiteInvoiceQuery = { __typename?: 'query_root', sf_ns_check: Array<{ __typename?: 'fn_return_sf_ns_check', check: string }> };

export type MrrQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type MrrQuery = { __typename?: 'query_root', customer_by_amagi_id?: { __typename?: 'customer', latest_mrr?: Array<{ __typename?: 'fn_return_latest_mrr', revenue_split?: string | null, month: string, mrr: any }> | null } | null };

export type MsaRateCardByAmagiIdQueryVariables = Exact<{
  amagiId: Scalars['String'];
}>;


export type MsaRateCardByAmagiIdQuery = { __typename?: 'query_root', msa_rate_card: Array<{ __typename?: 'fn_return_msa_rate_card', quote_number: string, quote_type?: string | null, status?: string | null, products?: any | null }> };

export type OpportunityFileQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type OpportunityFileQuery = { __typename?: 'query_root', opportunity: Array<{ __typename?: 'opportunity', salesforce_id: string, files?: { __typename?: 'SalesforceOpportunityResponse', done: boolean, totalSize: number, records: Array<{ __typename?: 'OpportunityFile', Id: string, ContentVersion: { __typename?: 'OpportunityFileVersion', Id: string, Content: string }, ContentDocument: { __typename?: 'OpportunityFileDetails', ContentSize: number, FileExtension: string, FileType: string, Title: string } }> } | null }> };

export type OrderCountQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type OrderCountQuery = { __typename?: 'query_root', total: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number, sum?: { __typename?: 'order_sum_fields', amount?: any | null } | null } | null }, draft: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number, sum?: { __typename?: 'order_sum_fields', amount?: any | null } | null } | null }, on_hold: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number, sum?: { __typename?: 'order_sum_fields', amount?: any | null } | null } | null }, in_progress: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number, sum?: { __typename?: 'order_sum_fields', amount?: any | null } | null } | null }, activated: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number, sum?: { __typename?: 'order_sum_fields', amount?: any | null } | null } | null } };

export type NetBillingSummaryQueryVariables = Exact<{
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
}>;


export type NetBillingSummaryQuery = { __typename?: 'query_root', net_invoices_outstanding: Array<{ __typename?: 'fn_return_billing_summary', amount: any }>, net_invoices_due: Array<{ __typename?: 'fn_return_billing_summary', amount: any }>, net_invoices_overdue: Array<{ __typename?: 'fn_return_billing_summary', amount: any }> };

export type CustomerOverviewFinancialDataFragment = { __typename?: 'customer', booked_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, billed_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, actual_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null };

export type CustomerOverviewFinancialQueryVariables = Exact<{
  amagi_id: Scalars['String'];
  from_date: Scalars['String'];
}>;


export type CustomerOverviewFinancialQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', booked_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, billed_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null, actual_revenue?: Array<{ __typename?: 'fn_return_financial_graph', month: string, amount: any }> | null } | null };

export type CustomerOverviewMrrFragment = { __typename?: 'customer', orders: Array<{ __typename?: 'order', order_products: Array<{ __typename?: 'order_product', product?: { __typename?: 'product', family?: string | null } | null }> }> };

export type CustomerOverviewMrrByPkQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type CustomerOverviewMrrByPkQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', orders: Array<{ __typename?: 'order', order_products: Array<{ __typename?: 'order_product', product?: { __typename?: 'product', family?: string | null } | null }> }> } | null };

export type CustomerOverviewRevenueDataFragment = { __typename?: 'customer', customer_revenue_split?: Array<{ __typename?: 'fn_return_revenue_split', revenue_split: string, month: string, amount: any }> | null };

export type CustomerOverviewRevenueQueryVariables = Exact<{
  amagi_id: Scalars['String'];
  from_date: Scalars['String'];
  to_date: Scalars['String'];
}>;


export type CustomerOverviewRevenueQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', customer_revenue_split?: Array<{ __typename?: 'fn_return_revenue_split', revenue_split: string, month: string, amount: any }> | null } | null };

export type PlatformFieldsFragment = { __typename?: 'platform', id: any, salesforce_id: string, multiple_salesforce_id?: any | null, name: string, keyring?: any | null, salesforce_account_id?: string | null, availablity_country_and_regions?: any | null, onboarded_date?: any | null, platform_brand?: string | null, platform_description?: string | null, platform_tier?: string | null, website_url?: string | null, logo?: string | null, poster?: any | null, video?: any | null, presentation?: any | null, devices_field?: any | null, twitter?: string | null, instagram?: string | null, facebook?: string | null, linkedin?: string | null, target_audience?: any | null, preferred_genre?: any | null, preferred_language?: any | null, platform_artwork?: any | null, avg_monthly_active_user?: string | null, avg_monthly_hov?: any | null, avg_ad_minute_per_hour?: number | null, stream_type?: any | null, technical_spec?: any | null, epg?: string | null, epg_format?: string | null, epg_format_example?: string | null, overall_bitrate?: string | null, subtitle_cc_format?: string | null, redundancy?: string | null, no_of_player_needed?: number | null, ad_trigger_type?: string | null, ad_break?: string | null, platform_qa_cycle?: string | null, video_player?: string | null, preferred_business_model?: string | null, estimated_channel_deliveries?: any | null, is_platform_group?: string | null, platforms_grouped?: string | null, vod_support?: string | null, vod_delivery_mode?: string | null, vod_connector_availability?: string | null, ssai_by?: string | null, platform_specific_encoding?: string | null, inventory_model?: string | null, analytics_share_rule?: string | null, redundancy_player_count?: any | null, redundancy_delivery_count?: any | null, platform_contact?: string | null, specifications_url?: string | null, platform_manager?: any | null, available_in_amagi_now?: boolean | null, platform_contacts?: any | null, reference_links?: any | null, account?: { __typename?: 'account', amagi_id: string, account_name: string, logo?: string | null } | null, platform_to_platform: Array<{ __typename?: 'platform', id: any, salesforce_id: string, name: string, logo?: string | null }>, platform_to_platform_of_grouped?: { __typename?: 'platform', id: any, salesforce_id: string, name: string, logo?: string | null } | null };

export type PlatformByPkQueryVariables = Exact<{
  _id: Scalars['uuid'];
}>;


export type PlatformByPkQuery = { __typename?: 'query_root', platform?: { __typename?: 'platform', id: any, salesforce_id: string, multiple_salesforce_id?: any | null, name: string, keyring?: any | null, salesforce_account_id?: string | null, availablity_country_and_regions?: any | null, onboarded_date?: any | null, platform_brand?: string | null, platform_description?: string | null, platform_tier?: string | null, website_url?: string | null, logo?: string | null, poster?: any | null, video?: any | null, presentation?: any | null, devices_field?: any | null, twitter?: string | null, instagram?: string | null, facebook?: string | null, linkedin?: string | null, target_audience?: any | null, preferred_genre?: any | null, preferred_language?: any | null, platform_artwork?: any | null, avg_monthly_active_user?: string | null, avg_monthly_hov?: any | null, avg_ad_minute_per_hour?: number | null, stream_type?: any | null, technical_spec?: any | null, epg?: string | null, epg_format?: string | null, epg_format_example?: string | null, overall_bitrate?: string | null, subtitle_cc_format?: string | null, redundancy?: string | null, no_of_player_needed?: number | null, ad_trigger_type?: string | null, ad_break?: string | null, platform_qa_cycle?: string | null, video_player?: string | null, preferred_business_model?: string | null, estimated_channel_deliveries?: any | null, is_platform_group?: string | null, platforms_grouped?: string | null, vod_support?: string | null, vod_delivery_mode?: string | null, vod_connector_availability?: string | null, ssai_by?: string | null, platform_specific_encoding?: string | null, inventory_model?: string | null, analytics_share_rule?: string | null, redundancy_player_count?: any | null, redundancy_delivery_count?: any | null, platform_contact?: string | null, specifications_url?: string | null, platform_manager?: any | null, available_in_amagi_now?: boolean | null, platform_contacts?: any | null, reference_links?: any | null, account?: { __typename?: 'account', amagi_id: string, account_name: string, logo?: string | null } | null, platform_to_platform: Array<{ __typename?: 'platform', id: any, salesforce_id: string, name: string, logo?: string | null }>, platform_to_platform_of_grouped?: { __typename?: 'platform', id: any, salesforce_id: string, name: string, logo?: string | null } | null } | null, platforms: Array<{ __typename?: 'platform', salesforce_id: string }>, customer: Array<{ __typename?: 'customer', amagi_id?: string | null, account_name?: string | null, salesforce_id?: string | null }> };

export type UpdatePlatformMutationVariables = Exact<{
  id: Scalars['uuid'];
  input?: InputMaybe<Platform_Set_Input>;
}>;


export type UpdatePlatformMutation = { __typename?: 'mutation_root', platform?: { __typename?: 'platform', id: any, salesforce_id: string, multiple_salesforce_id?: any | null, name: string, keyring?: any | null, salesforce_account_id?: string | null, availablity_country_and_regions?: any | null, onboarded_date?: any | null, platform_brand?: string | null, platform_description?: string | null, platform_tier?: string | null, website_url?: string | null, logo?: string | null, poster?: any | null, video?: any | null, presentation?: any | null, devices_field?: any | null, twitter?: string | null, instagram?: string | null, facebook?: string | null, linkedin?: string | null, target_audience?: any | null, preferred_genre?: any | null, preferred_language?: any | null, platform_artwork?: any | null, avg_monthly_active_user?: string | null, avg_monthly_hov?: any | null, avg_ad_minute_per_hour?: number | null, stream_type?: any | null, technical_spec?: any | null, epg?: string | null, epg_format?: string | null, epg_format_example?: string | null, overall_bitrate?: string | null, subtitle_cc_format?: string | null, redundancy?: string | null, no_of_player_needed?: number | null, ad_trigger_type?: string | null, ad_break?: string | null, platform_qa_cycle?: string | null, video_player?: string | null, preferred_business_model?: string | null, estimated_channel_deliveries?: any | null, is_platform_group?: string | null, platforms_grouped?: string | null, vod_support?: string | null, vod_delivery_mode?: string | null, vod_connector_availability?: string | null, ssai_by?: string | null, platform_specific_encoding?: string | null, inventory_model?: string | null, analytics_share_rule?: string | null, redundancy_player_count?: any | null, redundancy_delivery_count?: any | null, platform_contact?: string | null, specifications_url?: string | null, platform_manager?: any | null, available_in_amagi_now?: boolean | null, platform_contacts?: any | null, reference_links?: any | null, account?: { __typename?: 'account', amagi_id: string, account_name: string, logo?: string | null } | null, platform_to_platform: Array<{ __typename?: 'platform', id: any, salesforce_id: string, name: string, logo?: string | null }>, platform_to_platform_of_grouped?: { __typename?: 'platform', id: any, salesforce_id: string, name: string, logo?: string | null } | null } | null };

export type Get_Redundant_Channel_Names_Args = {
  input_channel_id?: InputMaybe<Scalars['uuid']>;
};

export type GetRedundantChannelNamesQueryVariables = Exact<{
  args: Get_Redundant_Channel_Names_Args;
}>;


export type GetRedundantChannelNamesQuery = { __typename?: 'query_root', get_redundant_channel_names: Array<{ __typename?: 'fn_return_redundant_playout_channels', redundant_playout_channels?: any | null }> };


export type UpsertRedundantPlayoutChannelMutationVariables = Exact<{
  RedundantId: Scalars['uuid'];
  channelId: Scalars['uuid'];
}>;


export type UpsertRedundantPlayoutChannelMutation = { __typename?: 'mutation_root', insert_redundant_playout_channels?: { __typename?: 'redundant_playout_channels_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'redundant_playout_channels', delivery_id: any, channel_id: any, redundant_channel_id: any }> } | null };

export type DeleteRedundantPlayoutChannelMutationVariables = Exact<{
  RedundantId: Scalars['uuid'];
  channelId: Scalars['uuid'];
}>;


export type DeleteRedundantPlayoutChannelMutation = { __typename?: 'mutation_root', delete_redundant_playout_channels?: { __typename?: 'redundant_playout_channels_mutation_response', affected_rows: number } | null };

export type PlatformGridFragment = { __typename?: 'platform', id: any, salesforce_id: string, logo?: string | null, name: string, platform_brand?: string | null, platform_tier?: string | null, onboarded_date?: any | null, availablity_country_and_regions?: any | null, platform_manager?: any | null, available_in_amagi_now?: boolean | null, ssai_by?: string | null, inventory_model?: string | null, vod_support?: string | null, stream_type?: any | null, epg?: string | null, epg_format?: string | null, overall_bitrate?: string | null, subtitle_cc_format?: string | null, ad_trigger_type?: string | null, ad_break?: string | null, platform_specific_encoding?: string | null, account?: { __typename?: 'account', logo?: string | null, amagi_id: string, account_name: string, status?: string | null } | null };

export type PlatformsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformsQuery = { __typename?: 'query_root', platform: Array<{ __typename?: 'platform', id: any, salesforce_id: string, logo?: string | null, name: string, platform_brand?: string | null, platform_tier?: string | null, onboarded_date?: any | null, availablity_country_and_regions?: any | null, platform_manager?: any | null, available_in_amagi_now?: boolean | null, ssai_by?: string | null, inventory_model?: string | null, vod_support?: string | null, stream_type?: any | null, epg?: string | null, epg_format?: string | null, overall_bitrate?: string | null, subtitle_cc_format?: string | null, ad_trigger_type?: string | null, ad_break?: string | null, platform_specific_encoding?: string | null, account?: { __typename?: 'account', logo?: string | null, amagi_id: string, account_name: string, status?: string | null } | null }> };

export type GroupedPlatformsQueryVariables = Exact<{ [key: string]: never; }>;

export type GetRecordTypeNameQueryVariables = Exact<{
  salesforceId: Scalars['String'];
}>;


export type GetRecordTypeNameQuery = { __typename?: 'query_root', record_type: Array<{ __typename?: 'record_type', name: string }> };

export type GroupedPlatformsQuery = { __typename?: 'query_root', platform: Array<{ __typename?: 'platform', id: any, salesforce_id: string, logo?: string | null, name: string, platform_brand?: string | null, platform_tier?: string | null, onboarded_date?: any | null, availablity_country_and_regions?: any | null, platform_manager?: any | null, available_in_amagi_now?: boolean | null, ssai_by?: string | null, inventory_model?: string | null, vod_support?: string | null, stream_type?: any | null, epg?: string | null, epg_format?: string | null, overall_bitrate?: string | null, subtitle_cc_format?: string | null, ad_trigger_type?: string | null, ad_break?: string | null, platform_specific_encoding?: string | null, account?: { __typename?: 'account', logo?: string | null, amagi_id: string, account_name: string, status?: string | null } | null }> };

export type ReceiptsDataFragment = { __typename?: 'customer', netsuite_receipts: Array<{ __typename?: 'netsuite_receipt', receipt_no?: string | null, status?: string | null, total_amount?: any | null, applied_amount?: any | null, unapplied_amount?: any | null, date?: any | null, memo?: string | null, currency?: string | null, netsuite_receipt_lines: Array<{ __typename?: 'netsuite_receipt_line', date?: any | null, type?: string | null, netsuite_transaction_id?: string | null, original_amount?: any | null, amount_due?: any | null, currency?: string | null, payment?: any | null }> }> };

export type ReceiptsByCustomerQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type ReceiptsByCustomerQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', netsuite_receipts: Array<{ __typename?: 'netsuite_receipt', receipt_no?: string | null, status?: string | null, total_amount?: any | null, applied_amount?: any | null, unapplied_amount?: any | null, date?: any | null, memo?: string | null, currency?: string | null, netsuite_receipt_lines: Array<{ __typename?: 'netsuite_receipt_line', date?: any | null, type?: string | null, netsuite_transaction_id?: string | null, original_amount?: any | null, amount_due?: any | null, currency?: string | null, payment?: any | null }> }> } | null };

export type SearchCustomerQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type SearchCustomerQuery = { __typename?: 'query_root', search_customer: Array<{ __typename?: 'account', salesforce_id: string, amagi_id: string, account_name: string, account_legal_name?: string | null, invoicing_currency?: string | null, industry_segment?: string | null, logo?: string | null, size?: string | null, status?: string | null, service_tier?: string | null, customer_tier?: string | null, customer_type?: string | null, tam?: string | null, media_industry_sub_segment?: { __typename?: 'media_industry_sub_segment', name?: string | null } | null, address?: { __typename?: 'company_address', region?: string | null } | null, owner: { __typename?: 'owner', region?: string | null },  record_type?: {__typename?: 'record_type', name?: string | null}, invoices_aggregate: { __typename?: 'invoice_aggregate', aggregate?: { __typename?: 'invoice_aggregate_fields', sum?: { __typename?: 'invoice_sum_fields', total_amount?: any | null }  | null } | null } }> };

export type ServiceAvailabilityQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type ServiceAvailabilityQuery = { __typename?: 'query_root', customer?: { __typename?: 'customer', avg_service_availibity?: Array<{ __typename?: 'fn_return_avg_service_availibity', months: any, available_time_secs?: any | null, down_time_secs?: any | null, avg_service_availability?: any | null }> | null } | null };

export type GetAllChannelsQueryVariables = Exact<{ [key: string]: never; }>;

export type GetAllChannelsQuery = { __typename?: 'query_root', channel: Array<{ __typename?: 'channel', id: any, name: string, logo: string, channel_type: string, channels_grouped: string }> };

export type GetChannelsByIdAndNameQueryVariables = Exact<{
  id: Scalars['uuid'];
  name: Scalars['String'];
}>;


export type GetChannelsByIdAndNameQuery = { __typename?: 'query_root', channel: Array<{ __typename?: 'channel', id: any, name: string, logo?: string | null, channel_type?: string | null, channels_grouped?: string | null }> };

export type GetTopCustomersConsumptionQueryVariables = Exact<{
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
}>;


export type GetTopCustomersConsumptionQuery = { __typename?: 'query_root', top_customers_consumption: Array<{ __typename?: 'fn_return_top_customers', account_name: string, total?: any | null, logo?: string | null }> };

export type GetTopCustomersQueryVariables = Exact<{
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
}>;


export type GetTopCustomersQuery = { __typename?: 'query_root', top_customers_overall: Array<{ __typename?: 'fn_return_top_customers', account_name: string, total?: any | null }> };

export type GetTopCustomersSubscriptionQueryVariables = Exact<{
  from_date?: InputMaybe<Scalars['String']>;
  to_date?: InputMaybe<Scalars['String']>;
}>;


export type GetTopCustomersSubscriptionQuery = { __typename?: 'query_root', top_customers_subscription: Array<{ __typename?: 'fn_return_top_customers', account_name: string, total?: any | null, logo?: string | null }> };

export type GetTopNonPayingCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopNonPayingCustomersQuery = { __typename?: 'query_root', cdp_top10_non_paying_cust_mv: Array<{ __typename?: 'cdp_top10_non_paying_cust_mv', account_name?: string | null, final_due_amount?: any | null, logo?: string | null }> };

export type GetTopPayingCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopPayingCustomersQuery = { __typename?: 'query_root', cdp_top10_paying_cust_mv: Array<{ __typename?: 'cdp_top10_paying_cust_mv', account_name?: string | null, invoice_amount_usd?: any | null, logo?: string | null }> };

export type CustomerNetsuitePdfQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type GetAverageCustomerAmountsQueryVariables = Exact<{
  from_date: Scalars['timestamptz'];
  to_date: Scalars['timestamptz'];
}>;


export type GetAverageCustomerAmountsQuery = { __typename?: 'query_root', consumption: { __typename?: 'cdp_invoiced_revenue_mv_aggregate', aggregate?: { __typename?: 'cdp_invoiced_revenue_mv_aggregate_fields', avg?: { __typename?: 'cdp_invoiced_revenue_mv_avg_fields', amount_usd?: number | null } | null } | null }, subscription: { __typename?: 'cdp_invoiced_revenue_mv_aggregate', aggregate?: { __typename?: 'cdp_invoiced_revenue_mv_aggregate_fields', avg?: { __typename?: 'cdp_invoiced_revenue_mv_avg_fields', amount_usd?: number | null } | null } | null }, total: { __typename?: 'cdp_invoiced_revenue_mv_aggregate', aggregate?: { __typename?: 'cdp_invoiced_revenue_mv_aggregate_fields', avg?: { __typename?: 'cdp_invoiced_revenue_mv_avg_fields', amount_usd?: number | null } | null } | null } };

export type CustomerNetsuiteIdsQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type CustomerNetsuiteIdsQuery = { __typename: 'query_root', customer_by_amagi_id?: { __typename: 'customer', netsuite_id?: any | null, old_netsuite_Id: Array<{ __typename?: 'customer_netsuite_old_ids', netsuite_id?: any | null }> } | null };


export type CustomerNetsuitePdfQuery = { __typename?: 'query_root', transaction_file?: { __typename?: 'NetsuiteFileResponse', base64_file: string } | null };

export type CustomerGetSalesforceIDofInvoiceQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type CustomerGetSalesforceIDofInvoiceQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', salesforce_id: string }> };

export type CustomerSalesforcePdfQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CustomerSalesforcePdfQuery = { __typename?: 'query_root', invoice: Array<{ __typename?: 'invoice', invoices?: { __typename?: 'SalesforceOpportunityResponse', totalSize: number, records: Array<{ __typename?: 'OpportunityFile', id: string, details: { __typename?: 'OpportunityFileDetails', name: string, type: string, extension: string, size: number }, document: { __typename?: 'OpportunityFileVersion', document_base64: string } }> } | null }> };

export type UpdateMsaRateCardMutationVariables = Exact<{
  objects: Array<Msa_Rate_Card_Insert_Input> | Msa_Rate_Card_Insert_Input;
}>;


export type UpdateMsaRateCardMutation = { __typename?: 'mutation_root', insert_msa_rate_card?: { __typename?: 'msa_rate_card_mutation_response', affected_rows: number } | null };

export type VodDeliveriesByCustomerQueryVariables = Exact<{
  amagi_id: Scalars['String'];
}>;


export type VodDeliveriesByCustomerQuery = { __typename?: 'query_root', delivery: Array<{ __typename?: 'delivery_main', id?: any | null, ssai?: boolean | null, delivered_date?: any | null, go_live_date?: any | null, cdp_delivery_type?: string | null, request_origin?: string | null, product_purchased_for_this_delivery?: any | null, business_model?: any | null, deal_type_for_content_partner?: string | null, deal_split_with_content_partner?: number | null, deal_type_for_platform_partner?: string | null, deal_split_with_platform_partner?: number | null, deal_split_amagi_share?: number | null, delivery_type?: string | null, delivery_stream_type?: any | null, delivered_region?: any | null, delivery_status?: string | null, channel?: { __typename?: 'channel', id: any, name: string, channel_id?: string | null, genre?: any | null, logo?: string | null, channels_grouped?: string | null, channel_type?: string | null, original_audio_language?: string | null, customer?: { __typename?: 'account', amagi_id: string, account_name: string } | null } | null, platform?: { __typename?: 'platform', id: any, name: string, logo?: string | null, is_platform_group?: string | null, platform_tier?: string | null, availablity_country_and_regions?: any | null, account?: { __typename?: 'account', amagi_id: string, account_name: string } | null } | null }>, channel_aggregate: { __typename?: 'channel_aggregate', aggregate?: { __typename?: 'channel_aggregate_fields', count: number } | null } };

export const ChanelFieldsFragmentDoc = gql`
    fragment ChanelFields on channel {
  id
  multiple_salesforce_id
  salesforce_id
  name
  keyring
  description
  customer {
    amagi_id
    account_name
    logo
  }
  amagi_id_of_channel_owner
  availablity_country_and_regions
  channel_origin_country_region
  genre
  is_redundant
  channel_type
  channel_brand
  subtitle_support
  subtitle_type
  subtitle_language
  feed_type
  original_audio_language
  graphics_support
  channel_rating
  parental_rating_standard
  platform_delivered_to
  channel_resolution
  videos
  logo
  posters
  presentations
  instagram
  facebook
  twitter
  linkedin
  target_audience
  custom_fields
  stream_container_type
  custom_tags
  ssai_partner
  channel_start_time
  channel_end_time
  paid_flag
  ad_flag
  promotion_flag
  is_contentplus_channel
  is_adsplus_channel
  subtitling
  closed_captioning
  dubbing
  dubbing_language
  sponsorship
  trademark_and_logo
  create_promotional
  edit_promotional
  create_short_form_video
  create_pop_channel
  use_of_display_technology
  time_zone
  start_time
  playout_format
  video_format
  audio_format
  playlist_format
  metadata_ingest_format
  content_ingest_format
  live_playout
  live_feed_input
  live_recording
  live_management
  closed_caption
  closed_caption_type
  closed_caption_language
  amagi_auto_cc_generation
  graphics_enabled
  graphics_type
  channel_logo_bug
  graphics_format
  fast
  sub_genre
  channels_grouped
  grouped_channel
  ordered_channel
  channel_to_channel {
    id
    salesforce_id
    logo
    name
    channel_type
  }
  channel_to_channel_of_grouped {
    id
    salesforce_id
    logo
    name
    channel_type
  }
}
    `;
export const ChannelGridFragmentDoc = gql`
    fragment ChannelGrid on channel {
  id
  salesforce_id
  channels_grouped
  name
  ordered_channel
  feed_type
  fast
  platform_delivered_to
  customer {
    amagi_id
    account_name
    status
    logo
  }
  channel_type
  channel_brand
  genre
  logo
  keyring
}
    `;
export const CustomerAllDataFragmentDoc = gql`
    fragment CustomerAllData on customer {
  amagi_id
  account_creation_date
  account_currency
  account_deactivation_date
  account_legal_name
  account_name
  ad_revenue_model
  customer_tier
  description
  address {
    address_line_1
    city
    zip_code
    country
    region
    company_establishment_date
    company_industry_segment
    company_industry_sub_segment
    company_linkedin_handle
    company_size
    company_twitter_handle
    company_website
    name
    salesforce_account_id
    state_province
    address_line_2
    address_line_3
  }
  phone
  tam
  billing_term
  churn_risk_percentage
  cloud_region
  cloud_service_provider
  comments
  created_at
  credit_period_in_days
  credit_score
  customer_business_model
  customer_contract_period
  customer_life_time_value
  customer_revenue_for_previous_year
  customer_revenue_for_the_present_year
  customer_type
  customers_profit_for_previous_year
  customers_profit_for_the_present_year
  dso
  first_invoice_date
  industry_segment
  invoicing_currency
  is_active
  is_deleted
  is_msa_ratecard_customer
  is_ono
  language
  status
  service_tier
  salesforce_created_date
  customer_since_date
  salesforce_last_modified_date
  salesforce_accountmanager_id
  salesforce_record_type_id
  revenue_group_2
  revenue_group_1
  preferred_payment_channel
  payment_terms_in_days
  payment_due_on_receipt
  payment_terms
  legal_entity_name
  logo
  billing_address
  account_category
  business_category
  no_of_employees
  company_category
  customer_financial_risk_category
  netsuite_id
  size
  customer_scale
  owner {
    last_name
    first_name
    email
    region
  }
  parent {
    amagi_id
    account_legal_name
    account_name
    media_industry_sub_segment {
      name
    }
    children {
      amagi_id
      account_legal_name
      account_name
      media_industry_sub_segment {
        name
      }
    }
  }
  orders_aggregate {
    aggregate {
      count
    }
  }
  csm {
    first_name
    last_name
    email
  }
  account_manager {
    first_name
    last_name
    email
  }
  channels {
    id
    subtitle_type
    subtitle_support
    ssai_partner
    salesforce_last_modified_date
    salesforce_id
    salesforce_created_date
    salesforce_account_id
    parental_rating_standard
    name
    is_redundant
    is_deleted
    input_audio_format
    graphics_support
    genre
    feed_type
    description
    custom_tags
    channel_type
    channel_resolution
    channel_rating
    billing_contact
    original_audio_language
  }
  children {
    amagi_id
    account_legal_name
    account_name
    media_industry_sub_segment {
      name
    }
  }
  sales {
    amount
    source
    status
  }
  orders {
    order_products(distinct_on: salesforce_product_id) {
      product {
        family
      }
    }
  }
  invoices_aggregate {
    aggregate {
      sum {
        total_amount
      }
    }
  }
  product_url {
    cloudport_urls
    thunderstorm_url
    planner_url
    amagi_now_url
  }
  region
  platform_tier
  content_plus_contacts {
    amagi_content_plus_owner {
      first_name
      last_name
      email
    }
    content_plus_internal_email_id
    content_plus_customer_email_id_1
    content_plus_customer_email_id_2
    content_plus_customer_email_id_3
    content_plus_customer_email_id_4
    content_plus_customer_email_id_5
    content_plus_customer_email_id_6
  }
  billing_contact
  onboarding_customer_contacts {
    onboarding_customer_email_id_1
    onboarding_customer_email_id_2
    onboarding_customer_email_id_3
    onboarding_customer_email_id_4
    onboarding_customer_email_id_5
    onboarding_customer_email_id_6
    onboarding_customer_email_id_7
    onboarding_customer_email_id_8
    onboarding_customer_email_id_9
    onboarding_customer_email_id_10
  }
  ads_plus_customer_contacts {
    ads_plus_customer_email_id_1
    ads_plus_customer_email_id_2
    ads_plus_customer_email_id_3
    ads_plus_customer_email_id_4
    ads_plus_customer_email_id_5
    ads_plus_customer_email_id_6
  }
}
    `;
export const CustomerContactsDataFragmentDoc = gql`
    fragment CustomerContactsData on customer {
  contacts(where: {is_deleted: {_eq: false}}) {
    first_name
    last_name
    work_phone_number
    region
    mobile_phone_number
    department
    country
    email_id
    title
  }
}
    `;
export const CustomerContractTermsFragmentDoc = gql`
    fragment CustomerContractTerms on customer {
  contract_terms {
    billing_type
    payment_terms
    price_escalation
    msa_effective_date
    price_escalation_period
    yearly_escalation_percentage
    order_initial_term
    order_renewal_term
    so_cancel_notice_after_oit
    so_cancel_notice_during_oit
    security_deposit
    deposit_amount_mrr_months
    payment_term_for_terminated_services
    entitled_to_stop_services_after
    termination_due_to_platform_notice
    interest_percent_applicable_post_due_date
    billing_date_rule
    billing_threshold_rule
  }
}
    `;
export const CustomerFinChartCummulativeDataFragmentDoc = gql`
    fragment CustomerFinChartCummulativeData on customer {
  booked_revenue: booked_revenue_cummulative(args: {from_date: $from_date}) {
    month
    amount
  }
  billed_revenue: billed_revenue_cummulative(args: {from_date: $from_date}) {
    month
    amount
  }
  actual_revenue: actual_revenue_cummulative(args: {from_date: $from_date}) {
    month
    amount
  }
  netsuite_credit_issued: netsuite_credit_issued_cummulative(
    args: {from_date: $from_date}
  ) {
    month
    amount
  }
}
    `;
export const CustomerFinChartDataFragmentDoc = gql`
    fragment CustomerFinChartData on customer {
  booked_revenue(args: {from_date: $from_date}) {
    month
    amount
  }
  billed_revenue(args: {from_date: $from_date}) {
    month
    amount
  }
  actual_revenue(args: {from_date: $from_date}) {
    month
    amount
  }
  netsuite_credit_issued(args: {from_date: $from_date}) {
    month
    amount
  }
}
    `;
export const CustomerInvoicesDataFragmentDoc = gql`
    fragment CustomerInvoicesData on customer {
  financials: combined_invoices(
    where: {_and: [{invoice_date: {_gte: $from}}, {invoice_date: {_lte: $to}}]}
  ) {
    invoice_id
    type
    invoice_date
    due_date
    payment_status
    tax
    invoice_amount
    amount_due
    billing_period
    so_po_reference_number
    root_cause_reason
    currency
    lines: combined_invoice_lines {
      product_id
      product
      description
      product_info {
        name
        short_name
        code
        description
      }
      platform
      channel
      region
      charge_type
      revenue_type
      quantity
      rate
      amount
      tax_type
      tax_rate
      tax_amount
      gross_amount
      start_date
      end_date
      currency
    }
  }
  date: combined_invoices(distinct_on: invoice_date) {
    invoice_date
  }
}
    `;
export const CustomerCreditMemosDataFragmentDoc = gql`
    fragment CustomerCreditMemosData on customer {
  financials: combined_credit_memos(
    where: {_and: [{invoice_date: {_gte: $from}}, {invoice_date: {_lte: $to}}]}
  ) {
    invoice_id
    type
    invoice_date
    due_date
    payment_status
    tax
    invoice_amount
    amount_due
    billing_period
    so_po_reference_number
    root_cause_reason
    currency
    lines: combined_credit_memo_lines {
      product_id
      product
      description
      product_info {
        name
        short_name
        code
        description
      }
      platform
      channel
      region
      charge_type
      revenue_type
      quantity
      rate
      amount
      tax_type
      tax_rate
      tax_amount
      gross_amount
      start_date
      end_date
      currency
    }
  }
  date: combined_credit_memos(distinct_on: invoice_date) {
    invoice_date
  }
}
    `;
export const FinancialCardCummulativeDataFragmentDoc = gql`
    fragment FinancialCardCummulativeData on customer {
  booked_revenue: booked_revenue_cummulative_origin {
    amount
  }
  billed_revenue: billed_revenue_cummulative_origin {
    amount
  }
  actual_revenue: actual_revenue_cummulative_origin {
    amount
  }
  netsuite_credit_issued: netsuite_credit_issued_cummulative_origin {
    amount
  }
}
    `;
export const OrderDataFragmentDoc = gql`
    fragment OrderData on order {
  salesforce_id
  order_number
  status
  amount
  currency
  opportunity {
    name
    id: salesforce_id
  }
  order_products {
    salesforce_id
    order_product_number
    order_product_line_status
    product {
      name
      short_name
      code
    }
    channel {
      name
    }
    platform {
      name
    }
    fsys_unit_net_price
    list_price
    unit_price
    tax_amount
    total_price
    service_date
    end_date
  }
  order_items_by_salesforce_order_id {
    order_item_name
    order_item_id
    tech_lead
    owner {
      first_name
      last_name
    }
    order_type
    on_hold_reason
    stage
    oit_created
    oit_ticket_status
    revised_expected_go_live_date
    revised_expected_delivery_date
    actual_go_live_date
    actual_delivery_date
    approved_for_onboarding_date
    order_item_lines {
      order_item_line_id
      order_item_line_name
      order_product_number
      owner {
        first_name
        last_name
      }
      stage
      billing_start_date_rule
      line_invoiced_or_not
      actual_go_live_date
      actual_delivery_date
      revised_expected_go_live_date
      revised_expected_delivery_date
    }
  }
}
    `;
export const CustomerProductDataFragmentDoc = gql`
    fragment CustomerProductData on customer {
  product_table_detail(args: {from_date: $from, to_date: $to}) {
    name
    short_name
    product_id
    family
    group
    sub_group
    subscription
    consumption: consumption_mrr
    others: one_time_fee
    mrr
    arr
  }
}
    `;
export const CustomerQuotesDataFragmentDoc = gql`
    fragment CustomerQuotesData on customer {
  quotes {
    quote_number
    quote_type
    msa_quote_type
    status
    opportunity {
      name
    }
    primary_quote_actions
    start_date
    end_date
    quote_lines {
      product_code
      product_name
      product_details {
        short_name
      }
      currency
      channel_details {
        name
      }
      platform {
        name
      }
      unit_net_price
      list_unit_price
      additional_discount_percentage
      additional_discount
    }
  }
}
    `;
export const CustomerSalesDataFragmentDoc = gql`
    fragment CustomerSalesData on customer {
  owner {
    last_name
    first_name
    email
    region
  }
  csm {
    first_name
    last_name
    email
  }
  account_manager {
    first_name
    last_name
    email
  }
  sales(where: {source: {_eq: "opportunity"}}) {
    amount
    source
    status
  }
  opportunity {
    name
    description
    amount
    stage_name
    opportunity_type
    expected_revenue
    close_date
    lead_source
    salesforce_contract_id
    salesforce_id
    product
    reason_for_closed_won
    reason_for_closed_lost
    monetization_model
    so
    competition
    currency_iso_code
  }
}
    `;
export const CustomerFdTicketsDataFragmentDoc = gql`
    fragment CustomerFDTicketsData on freshdesk_ticket {
  ticket_id
  subject
  description
  impact
  product_resp
  product_resp_area
  product_resp_area_component
  priority
  ticket_type
  status
  resolved_date
  closed_at
  root_cause
  credit_amount
  credit_currency
  delivery_channel
  created_date
  tags
  company_id
  invoice_number
  dispute_type
  dispute_outcome
  invoice_month
  invoice_amount
  disputed_amount
  charge_codes
  region
  coordinator
  billing_issue_status
  root_cause_category
  root_cause_owner
  group
  group_agent
  customer_id
  customer_name
  source
  last_updated_date
}
    `;
export const AllCustomerDataFragmentDoc = gql`
    fragment AllCustomerData on customer {
  customer_tier
  salesforce_id
  amagi_id
  account_name
  account_legal_name
  industry_segment
  logo
  media_industry_sub_segment {
    name
  }
  status
  address {
    region
  }
  owner {
    region
    owner_to_user {
      rep_director
      rep_manager
      name
    }
  }
  tam
  record_type {
    name
  }
  status
  size
  service_tier
  customer_type
  invoicing_currency
}
    `;
export const ChannelInfoFragmentDoc = gql`
    fragment ChannelInfo on channel {
  id
  name
  channel_id
  customer {
    amagi_id
    account_name
  }
  genre
  logo
  channels_grouped
  channel_type
  original_audio_language
}
    `;
export const PlatformInfoFragmentDoc = gql`
    fragment PlatformInfo on platform {
  id
  name
  logo
  is_platform_group
  account {
    amagi_id
    account_name
  }
  platform_tier
  availablity_country_and_regions
}
    `;
export const DeliveryInfoFragmentDoc = gql`
    fragment DeliveryInfo on delivery_main {
  id
  channel: delivery_to_channel {
    ...ChannelInfo
  }
  platform: delivery_to_platform {
    ...PlatformInfo
  }
  ssai
  delivered_date
  go_live_date
  cdp_delivery_type
  request_origin
  product_purchased_for_this_delivery
  business_model
  deal_type_for_content_partner
  deal_split_with_content_partner
  deal_type_for_platform_partner
  deal_split_with_platform_partner
  deal_split_amagi_share
  delivery_type
  delivery_stream_type
  delivered_region
  delivery_status
}
    ${ChannelInfoFragmentDoc}
${PlatformInfoFragmentDoc}`;
export const DeliveryFragmentDoc = gql`
    fragment Delivery on delivery {
  channel: delivery_to_channel {
    id
    salesforce_id
    channels_grouped
    name
    logo
    channel_type
  }
  order: delivery_to_order {
    customer {
      account_name
      amagi_id
      logo
    }
  }
  platform: delivery_to_platform {
    id
    salesforce_id
    is_platform_group
    name
    logo
  }
  id
  point_product_delivery_id
  ts_setup
  salesforce_channel_id
  salesforce_platform_id
  delivered_region
  delivered_using_amagi_now
  salesforce_order_id
  salesforce_order_item_id
  salesforce_order_product_id
  redundancy
  ordered_date
  provisioning_start_date
  delivered_date
  go_live_date
  churned_date
  churned_reason
  delivery_type
  test_delivery
  test_playout
  redundant_playout
  redundant_playout_channels
  delivery_stream_type
  on_hold_date
  on_hold_reason
  blocked_reason
  blocked_reason_details
  assignee
  ads_plus
  content_plus
  user {
    name
    email
  }
  feed_type
  ssai
  ad_load_minutes
  turnaround
  business_model
  stream_url
  epg_url
  deal_type_for_content_partner
  deal_split_with_content_partner
  content_partner_primary
  content_partner_backfill
  deal_type_for_platform_partner
  deal_split_with_platform_partner
  platform_partner_primary
  platform_partner_backfill
  deal_split_amagi_share
  amagi_share_primary
  amagi_share_backfill
  product_purchased_for_this_delivery
  delivery_status
  audio_languages
  request_origin
  cdn_fee_owner
  cdn_tag_1
  cdn_tag_2
  cdn_tag_3
  cdn_tag_4
  ssai_fee_owner
  connect_distribution_model
  content_partner_ad_sales_commission_percentage
  platform_ad_sales_commission_percentage
  inventory_share_amagi_primary_ad_tag
  inventory_share_amagi_backfill_ad_tag
  inventory_share_platform_primary_ad_tag
  inventory_share_platform_backfill_ad_tag
  inventory_share_content_partner_primary_ad_tag
  inventory_share_content_partner_backfill_ad_tag
  revenue_share_monetised_by_primary
  revenue_share_monetised_by_backfill
  revenue_share_primary_ad_tag
  revenue_share_backfill_ad_tag
}
    `;
export const DeliveryGridFragmentDoc = gql`
    fragment DeliveryGrid on delivery_main {
  channel: delivery_to_channel {
    id
    salesforce_id
    channels_grouped
    name
    logo
    channel_type
  }
  order: delivery_to_order {
    customer {
      account_name
      amagi_id
      logo
    }
  }
  platform: delivery_to_platform {
    id
    salesforce_id
    is_platform_group
    name
    logo
  }
  id
  point_product_delivery_id
  salesforce_channel_id
  salesforce_platform_id
  delivered_using_amagi_now
  delivered_region
  delivery_status
}
    `;
export const CustomerOverviewFinancialDataFragmentDoc = gql`
    fragment CustomerOverviewFinancialData on customer {
  booked_revenue(args: {from_date: $from_date}) {
    month
    amount
  }
  billed_revenue(args: {from_date: $from_date}) {
    month
    amount
  }
  actual_revenue(args: {from_date: $from_date}) {
    month
    amount
  }
}
    `;
export const CustomerOverviewMrrFragmentDoc = gql`
    fragment CustomerOverviewMRR on customer {
  orders {
    order_products(distinct_on: salesforce_product_id) {
      product {
        family
      }
    }
  }
}
    `;
export const CustomerOverviewRevenueDataFragmentDoc = gql`
    fragment CustomerOverviewRevenueData on customer {
  customer_revenue_split(args: {from_date: $from_date, to_date: $to_date}) {
    revenue_split
    month
    amount
  }
}
    `;
export const PlatformFieldsFragmentDoc = gql`
    fragment PlatformFields on platform {
  id
  salesforce_id
  multiple_salesforce_id
  name
  keyring
  account {
    amagi_id
    account_name
    logo
  }
  salesforce_account_id
  availablity_country_and_regions
  onboarded_date
  platform_brand
  platform_description
  platform_tier
  website_url
  logo
  poster
  video
  presentation
  devices_field
  twitter
  instagram
  facebook
  linkedin
  target_audience
  preferred_genre
  preferred_language
  platform_artwork
  avg_monthly_active_user
  avg_monthly_hov
  avg_ad_minute_per_hour
  stream_type
  technical_spec
  epg
  epg_format
  epg_format_example
  overall_bitrate
  subtitle_cc_format
  redundancy
  no_of_player_needed
  ad_trigger_type
  ad_break
  platform_qa_cycle
  video_player
  preferred_business_model
  estimated_channel_deliveries
  is_platform_group
  platforms_grouped
  vod_support
  vod_delivery_mode
  vod_connector_availability
  ssai_by
  platform_specific_encoding
  inventory_model
  analytics_share_rule
  redundancy_player_count
  redundancy_delivery_count
  platform_contact
  specifications_url
  platform_manager
  available_in_amagi_now
  platform_contacts
  reference_links
  platform_to_platform {
    id
    salesforce_id
    name
    logo
  }
  platform_to_platform_of_grouped {
    id
    salesforce_id
    name
    logo
  }
}
    `;
export const PlatformGridFragmentDoc = gql`
    fragment PlatformGrid on platform {
  id
  salesforce_id
  logo
  account {
    logo
    amagi_id
    account_name
    status
  }
  name
  onboarded_date
  platform_brand
  platform_tier
  onboarded_date
  availablity_country_and_regions
  platform_manager
  available_in_amagi_now
  ssai_by
  inventory_model
  vod_support
  stream_type
  epg
  epg_format
  overall_bitrate
  subtitle_cc_format
  ad_trigger_type
  ad_break
  platform_specific_encoding
}
    `;
export const ReceiptsDataFragmentDoc = gql`
    fragment ReceiptsData on customer {
  netsuite_receipts: combined_receipts {
    receipt_no
    status
    total_amount
    applied_amount
    unapplied_amount
    date
    memo
    currency
    netsuite_receipt_lines: combined_receipt_lines {
      date
      type
      netsuite_transaction_id
      original_amount
      amount_due
      currency
      payment
    }
  }
}
    `;
export const ArrDocument = gql`
    query ARR($amagi_id: String!) {
  customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    latest_arr {
      revenue_split
      arr: amount
      month
    }
  }
}
    `;

/**
 * __useArrQuery__
 *
 * To run a query within a React component, call `useArrQuery` and pass it any options that fit your needs.
 * When your component renders, `useArrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArrQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useArrQuery(baseOptions: Apollo.QueryHookOptions<ArrQuery, ArrQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArrQuery, ArrQueryVariables>(ArrDocument, options);
      }
export function useArrLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArrQuery, ArrQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArrQuery, ArrQueryVariables>(ArrDocument, options);
        }
export type ArrQueryHookResult = ReturnType<typeof useArrQuery>;
export type ArrLazyQueryHookResult = ReturnType<typeof useArrLazyQuery>;
export type ArrQueryResult = Apollo.QueryResult<ArrQuery, ArrQueryVariables>;
export const ChannelByPkDocument = gql`
    query ChannelByPk($_id: uuid!) {
  channel: channel_by_pk(id: $_id) {
    ...ChanelFields
  }
  channels: channel {
    salesforce_id
    source
  }
  customer {
    amagi_id
    account_name
  }
}
    ${ChanelFieldsFragmentDoc}`;

/**
 * __useChannelByPkQuery__
 *
 * To run a query within a React component, call `useChannelByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelByPkQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useChannelByPkQuery(baseOptions: Apollo.QueryHookOptions<ChannelByPkQuery, ChannelByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelByPkQuery, ChannelByPkQueryVariables>(ChannelByPkDocument, options);
      }
export function useChannelByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelByPkQuery, ChannelByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelByPkQuery, ChannelByPkQueryVariables>(ChannelByPkDocument, options);
        }
export type ChannelByPkQueryHookResult = ReturnType<typeof useChannelByPkQuery>;
export type ChannelByPkLazyQueryHookResult = ReturnType<typeof useChannelByPkLazyQuery>;
export type ChannelByPkQueryResult = Apollo.QueryResult<ChannelByPkQuery, ChannelByPkQueryVariables>;
export const LinearChannelsDocument = gql`
    query LinearChannels {
  channel(
    where: {_and: [{channel_to_channel_master: {preferred_channel_master_id: {_is_null: true}}}, {channel_type: {_is_null: true}}, {_or: [{channels_grouped: {_neq: "Yes"}}, {channels_grouped: {_is_null: true}}]}]}
  ) {
    ...ChannelGrid
  }
}
    ${ChannelGridFragmentDoc}`;

/**
 * __useLinearChannelsQuery__
 *
 * To run a query within a React component, call `useLinearChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinearChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinearChannelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLinearChannelsQuery(baseOptions?: Apollo.QueryHookOptions<LinearChannelsQuery, LinearChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinearChannelsQuery, LinearChannelsQueryVariables>(LinearChannelsDocument, options);
      }
export function useLinearChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinearChannelsQuery, LinearChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinearChannelsQuery, LinearChannelsQueryVariables>(LinearChannelsDocument, options);
        }
export type LinearChannelsQueryHookResult = ReturnType<typeof useLinearChannelsQuery>;
export type LinearChannelsLazyQueryHookResult = ReturnType<typeof useLinearChannelsLazyQuery>;
export type LinearChannelsQueryResult = Apollo.QueryResult<LinearChannelsQuery, LinearChannelsQueryVariables>;
export const GroupedChannelsDocument = gql`
    query GroupedChannels {
  channel(
    where: {_and: [{channel_to_channel_master: {preferred_channel_master_id: {_is_null: true}}}, {channels_grouped: {_eq: "Yes"}}]}
  ) {
    ...ChannelGrid
  }
}
    ${ChannelGridFragmentDoc}`;

/**
 * __useGroupedChannelsQuery__
 *
 * To run a query within a React component, call `useGroupedChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedChannelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGroupedChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GroupedChannelsQuery, GroupedChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupedChannelsQuery, GroupedChannelsQueryVariables>(GroupedChannelsDocument, options);
      }
export function useGroupedChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupedChannelsQuery, GroupedChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupedChannelsQuery, GroupedChannelsQueryVariables>(GroupedChannelsDocument, options);
        }
export type GroupedChannelsQueryHookResult = ReturnType<typeof useGroupedChannelsQuery>;
export type GroupedChannelsLazyQueryHookResult = ReturnType<typeof useGroupedChannelsLazyQuery>;
export type GroupedChannelsQueryResult = Apollo.QueryResult<GroupedChannelsQuery, GroupedChannelsQueryVariables>;
export const CommonChannelsDocument = gql`
    query CommonChannels($channel_type: String!) {
  channel(
    where: {_and: [{channel_to_channel_master: {preferred_channel_master_id: {_is_null: true}}}, {channel_type: {_eq: $channel_type}}]}
  ) {
    ...ChannelGrid
  }
}
    ${ChannelGridFragmentDoc}`;

/**
 * __useCommonChannelsQuery__
 *
 * To run a query within a React component, call `useCommonChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonChannelsQuery({
 *   variables: {
 *      channel_type: // value for 'channel_type'
 *   },
 * });
 */
export function useCommonChannelsQuery(baseOptions: Apollo.QueryHookOptions<CommonChannelsQuery, CommonChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommonChannelsQuery, CommonChannelsQueryVariables>(CommonChannelsDocument, options);
      }
export function useCommonChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommonChannelsQuery, CommonChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommonChannelsQuery, CommonChannelsQueryVariables>(CommonChannelsDocument, options);
        }
export type CommonChannelsQueryHookResult = ReturnType<typeof useCommonChannelsQuery>;
export type CommonChannelsLazyQueryHookResult = ReturnType<typeof useCommonChannelsLazyQuery>;
export type CommonChannelsQueryResult = Apollo.QueryResult<CommonChannelsQuery, CommonChannelsQueryVariables>;
export const UpdateChannelDocument = gql`
    mutation UpdateChannel($id: uuid!, $input: channel_set_input) {
  channel: update_channel_by_pk(pk_columns: {id: $id}, _set: $input) {
    ...ChanelFields
  }
}
    ${ChanelFieldsFragmentDoc}`;
export type UpdateChannelMutationFn = Apollo.MutationFunction<UpdateChannelMutation, UpdateChannelMutationVariables>;

/**
 * __useUpdateChannelMutation__
 *
 * To run a mutation, you first call `useUpdateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChannelMutation, { data, loading, error }] = useUpdateChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChannelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChannelMutation, UpdateChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChannelMutation, UpdateChannelMutationVariables>(UpdateChannelDocument, options);
      }
export type UpdateChannelMutationHookResult = ReturnType<typeof useUpdateChannelMutation>;
export type UpdateChannelMutationResult = Apollo.MutationResult<UpdateChannelMutation>;
export type UpdateChannelMutationOptions = Apollo.BaseMutationOptions<UpdateChannelMutation, UpdateChannelMutationVariables>;

export const UpdateCustomerLogoDocument = gql`
    mutation UpdateCustomerLogo($amagi_id: String!, $logoUrl: String!) {
  update_customer(where: {amagi_id: {_eq: $amagi_id}}, _set: {logo: $logoUrl}) {
    affected_rows
    returning {
      amagi_id
      logo
    }
  }
}
    `;

export type UpdateCustomerLogoFn = Apollo.MutationFunction<UpdateCustomerLogoMutation, UpdateCustomerLogoMutationVariables>;
export function useUpdateCustomerLogoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerLogoMutation, UpdateCustomerLogoMutationVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useMutation<UpdateCustomerLogoMutation, UpdateCustomerLogoMutationVariables>(UpdateCustomerLogoDocument, options);
}
export type UpdateCustomerLogoMutationHookResult = ReturnType<typeof useUpdateCustomerLogoMutation>;
export type UpdateCustomerLogoMutationResult = Apollo.MutationResult<UpdateCustomerLogoMutation>;
export type UpdateCustomerLogoMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerLogoMutation, UpdateCustomerLogoMutationVariables>;

export const LinearChannelsByCustomerDocument = gql`
    query LinearChannelsByCustomer($amagi_id: String!) {
  channel(
    where: {_and: [{customer: {amagi_id: {_eq: $amagi_id}}}, {channel_to_channel_master: {preferred_channel_master_id: {_is_null: true}}}, {channel_type: {_is_null: true}}, {_or: [{channels_grouped: {_neq: "Yes"}}, {channels_grouped: {_is_null: true}}]}]}
  ) {
    ...ChannelGrid
  }
}
    ${ChannelGridFragmentDoc}`;

/**
 * __useLinearChannelsByCustomerQuery__
 *
 * To run a query within a React component, call `useLinearChannelsByCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinearChannelsByCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinearChannelsByCustomerQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useLinearChannelsByCustomerQuery(baseOptions: Apollo.QueryHookOptions<LinearChannelsByCustomerQuery, LinearChannelsByCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinearChannelsByCustomerQuery, LinearChannelsByCustomerQueryVariables>(LinearChannelsByCustomerDocument, options);
      }
export function useLinearChannelsByCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinearChannelsByCustomerQuery, LinearChannelsByCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinearChannelsByCustomerQuery, LinearChannelsByCustomerQueryVariables>(LinearChannelsByCustomerDocument, options);
        }
export type LinearChannelsByCustomerQueryHookResult = ReturnType<typeof useLinearChannelsByCustomerQuery>;
export type LinearChannelsByCustomerLazyQueryHookResult = ReturnType<typeof useLinearChannelsByCustomerLazyQuery>;
export type LinearChannelsByCustomerQueryResult = Apollo.QueryResult<LinearChannelsByCustomerQuery, LinearChannelsByCustomerQueryVariables>;
export const GroupedChannelsByCustomerDocument = gql`
    query GroupedChannelsByCustomer($amagi_id: String!) {
  channel(
    where: {_and: [{customer: {amagi_id: {_eq: $amagi_id}}}, {channel_to_channel_master: {preferred_channel_master_id: {_is_null: true}}}, {channels_grouped: {_eq: "Yes"}}]}
  ) {
    ...ChannelGrid
  }
}
    ${ChannelGridFragmentDoc}`;

/**
 * __useGroupedChannelsByCustomerQuery__
 *
 * To run a query within a React component, call `useGroupedChannelsByCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedChannelsByCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedChannelsByCustomerQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useGroupedChannelsByCustomerQuery(baseOptions: Apollo.QueryHookOptions<GroupedChannelsByCustomerQuery, GroupedChannelsByCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupedChannelsByCustomerQuery, GroupedChannelsByCustomerQueryVariables>(GroupedChannelsByCustomerDocument, options);
      }
export function useGroupedChannelsByCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupedChannelsByCustomerQuery, GroupedChannelsByCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupedChannelsByCustomerQuery, GroupedChannelsByCustomerQueryVariables>(GroupedChannelsByCustomerDocument, options);
        }
export type GroupedChannelsByCustomerQueryHookResult = ReturnType<typeof useGroupedChannelsByCustomerQuery>;
export type GroupedChannelsByCustomerLazyQueryHookResult = ReturnType<typeof useGroupedChannelsByCustomerLazyQuery>;
export type GroupedChannelsByCustomerQueryResult = Apollo.QueryResult<GroupedChannelsByCustomerQuery, GroupedChannelsByCustomerQueryVariables>;
export const CommonChannelsByCustomerDocument = gql`
    query CommonChannelsByCustomer($channel_type: String!, $amagi_id: String!) {
  channel(
    where: {_and: [{customer: {amagi_id: {_eq: $amagi_id}}}, {channel_to_channel_master: {preferred_channel_master_id: {_is_null: true}}}, {channel_type: {_eq: $channel_type}}]}
  ) {
    ...ChannelGrid
  }
}
    ${ChannelGridFragmentDoc}`;

/**
 * __useCommonChannelsByCustomerQuery__
 *
 * To run a query within a React component, call `useCommonChannelsByCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommonChannelsByCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommonChannelsByCustomerQuery({
 *   variables: {
 *      channel_type: // value for 'channel_type'
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useCommonChannelsByCustomerQuery(baseOptions: Apollo.QueryHookOptions<CommonChannelsByCustomerQuery, CommonChannelsByCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommonChannelsByCustomerQuery, CommonChannelsByCustomerQueryVariables>(CommonChannelsByCustomerDocument, options);
      }
export function useCommonChannelsByCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommonChannelsByCustomerQuery, CommonChannelsByCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommonChannelsByCustomerQuery, CommonChannelsByCustomerQueryVariables>(CommonChannelsByCustomerDocument, options);
        }
export type CommonChannelsByCustomerQueryHookResult = ReturnType<typeof useCommonChannelsByCustomerQuery>;
export type CommonChannelsByCustomerLazyQueryHookResult = ReturnType<typeof useCommonChannelsByCustomerLazyQuery>;
export type CommonChannelsByCustomerQueryResult = Apollo.QueryResult<CommonChannelsByCustomerQuery, CommonChannelsByCustomerQueryVariables>;
export const CustomerByPkDocument = gql`
    query CustomerByPk($amagi_id: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...CustomerAllData
  }
}
    ${CustomerAllDataFragmentDoc}`;

/**
 * __useCustomerByPkQuery__
 *
 * To run a query within a React component, call `useCustomerByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerByPkQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useCustomerByPkQuery(baseOptions: Apollo.QueryHookOptions<CustomerByPkQuery, CustomerByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerByPkQuery, CustomerByPkQueryVariables>(CustomerByPkDocument, options);
      }
export function useCustomerByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerByPkQuery, CustomerByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerByPkQuery, CustomerByPkQueryVariables>(CustomerByPkDocument, options);
        }
export type CustomerByPkQueryHookResult = ReturnType<typeof useCustomerByPkQuery>;
export type CustomerByPkLazyQueryHookResult = ReturnType<typeof useCustomerByPkLazyQuery>;
export type CustomerByPkQueryResult = Apollo.QueryResult<CustomerByPkQuery, CustomerByPkQueryVariables>;
export const CustomerContactsByPkDocument = gql`
    query CustomerContactsByPk($amagi_id: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...CustomerContactsData
  }
}
    ${CustomerContactsDataFragmentDoc}`;

/**
 * __useCustomerContactsByPkQuery__
 *
 * To run a query within a React component, call `useCustomerContactsByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContactsByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContactsByPkQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useCustomerContactsByPkQuery(baseOptions: Apollo.QueryHookOptions<CustomerContactsByPkQuery, CustomerContactsByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerContactsByPkQuery, CustomerContactsByPkQueryVariables>(CustomerContactsByPkDocument, options);
      }
export function useCustomerContactsByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerContactsByPkQuery, CustomerContactsByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerContactsByPkQuery, CustomerContactsByPkQueryVariables>(CustomerContactsByPkDocument, options);
        }
export type CustomerContactsByPkQueryHookResult = ReturnType<typeof useCustomerContactsByPkQuery>;
export type CustomerContactsByPkLazyQueryHookResult = ReturnType<typeof useCustomerContactsByPkLazyQuery>;
export type CustomerContactsByPkQueryResult = Apollo.QueryResult<CustomerContactsByPkQuery, CustomerContactsByPkQueryVariables>;
export const CustomerContractDocumentsDocument = gql`
    query CustomerContractDocuments($amagi_id: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    customer_files {
      totalSize
      records {
        id: Id
        details: ContentDocument {
          name: Title
          type: FileType
          extension: FileExtension
          size: ContentSize
        }
        document: ContentVersion {
          document_base64: Content
        }
      }
    }
  }
}
    `;

/**
 * __useCustomerContractDocumentsQuery__
 *
 * To run a query within a React component, call `useCustomerContractDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContractDocumentsQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useCustomerContractDocumentsQuery(baseOptions: Apollo.QueryHookOptions<CustomerContractDocumentsQuery, CustomerContractDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerContractDocumentsQuery, CustomerContractDocumentsQueryVariables>(CustomerContractDocumentsDocument, options);
      }
export function useCustomerContractDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerContractDocumentsQuery, CustomerContractDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerContractDocumentsQuery, CustomerContractDocumentsQueryVariables>(CustomerContractDocumentsDocument, options);
        }
export type CustomerContractDocumentsQueryHookResult = ReturnType<typeof useCustomerContractDocumentsQuery>;
export type CustomerContractDocumentsLazyQueryHookResult = ReturnType<typeof useCustomerContractDocumentsLazyQuery>;
export type CustomerContractDocumentsQueryResult = Apollo.QueryResult<CustomerContractDocumentsQuery, CustomerContractDocumentsQueryVariables>;
export const CustomerContractTermsByPkDocument = gql`
    query CustomerContractTermsByPk($amagi_id: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...CustomerContractTerms
    cplus_msa_effective_date
    connect_msa_effective_date
  }
}
    ${CustomerContractTermsFragmentDoc}`;

/**
 * __useCustomerContractTermsByPkQuery__
 *
 * To run a query within a React component, call `useCustomerContractTermsByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractTermsByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContractTermsByPkQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useCustomerContractTermsByPkQuery(baseOptions: Apollo.QueryHookOptions<CustomerContractTermsByPkQuery, CustomerContractTermsByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerContractTermsByPkQuery, CustomerContractTermsByPkQueryVariables>(CustomerContractTermsByPkDocument, options);
      }
export function useCustomerContractTermsByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerContractTermsByPkQuery, CustomerContractTermsByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerContractTermsByPkQuery, CustomerContractTermsByPkQueryVariables>(CustomerContractTermsByPkDocument, options);
        }
export type CustomerContractTermsByPkQueryHookResult = ReturnType<typeof useCustomerContractTermsByPkQuery>;
export type CustomerContractTermsByPkLazyQueryHookResult = ReturnType<typeof useCustomerContractTermsByPkLazyQuery>;
export type CustomerContractTermsByPkQueryResult = Apollo.QueryResult<CustomerContractTermsByPkQuery, CustomerContractTermsByPkQueryVariables>;
export const CustomerFinChartCummulativeByPkDocument = gql`
    query CustomerFinChartCummulativeByPk($amagi_id: String!, $from_date: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...CustomerFinChartCummulativeData
  }
}
    ${CustomerFinChartCummulativeDataFragmentDoc}`;

/**
 * __useCustomerFinChartCummulativeByPkQuery__
 *
 * To run a query within a React component, call `useCustomerFinChartCummulativeByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerFinChartCummulativeByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerFinChartCummulativeByPkQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *      from_date: // value for 'from_date'
 *   },
 * });
 */
export function useCustomerFinChartCummulativeByPkQuery(baseOptions: Apollo.QueryHookOptions<CustomerFinChartCummulativeByPkQuery, CustomerFinChartCummulativeByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerFinChartCummulativeByPkQuery, CustomerFinChartCummulativeByPkQueryVariables>(CustomerFinChartCummulativeByPkDocument, options);
      }
export function useCustomerFinChartCummulativeByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerFinChartCummulativeByPkQuery, CustomerFinChartCummulativeByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerFinChartCummulativeByPkQuery, CustomerFinChartCummulativeByPkQueryVariables>(CustomerFinChartCummulativeByPkDocument, options);
        }
export type CustomerFinChartCummulativeByPkQueryHookResult = ReturnType<typeof useCustomerFinChartCummulativeByPkQuery>;
export type CustomerFinChartCummulativeByPkLazyQueryHookResult = ReturnType<typeof useCustomerFinChartCummulativeByPkLazyQuery>;
export type CustomerFinChartCummulativeByPkQueryResult = Apollo.QueryResult<CustomerFinChartCummulativeByPkQuery, CustomerFinChartCummulativeByPkQueryVariables>;
export const CustomerFinChartByPkDocument = gql`
    query CustomerFinChartByPk($amagi_id: String!, $from_date: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...CustomerFinChartData
  }
}
    ${CustomerFinChartDataFragmentDoc}`;

/**
 * __useCustomerFinChartByPkQuery__
 *
 * To run a query within a React component, call `useCustomerFinChartByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerFinChartByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerFinChartByPkQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *      from_date: // value for 'from_date'
 *   },
 * });
 */
export function useCustomerFinChartByPkQuery(baseOptions: Apollo.QueryHookOptions<CustomerFinChartByPkQuery, CustomerFinChartByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerFinChartByPkQuery, CustomerFinChartByPkQueryVariables>(CustomerFinChartByPkDocument, options);
      }
export function useCustomerFinChartByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerFinChartByPkQuery, CustomerFinChartByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerFinChartByPkQuery, CustomerFinChartByPkQueryVariables>(CustomerFinChartByPkDocument, options);
        }
export type CustomerFinChartByPkQueryHookResult = ReturnType<typeof useCustomerFinChartByPkQuery>;
export type CustomerFinChartByPkLazyQueryHookResult = ReturnType<typeof useCustomerFinChartByPkLazyQuery>;
export type CustomerFinChartByPkQueryResult = Apollo.QueryResult<CustomerFinChartByPkQuery, CustomerFinChartByPkQueryVariables>;
export const CustomerInvoicesByPkDocument = gql`
    query CustomerInvoicesByPk($amagi_id: String!, $from: date, $to: date) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...CustomerInvoicesData
  }
}
    ${CustomerInvoicesDataFragmentDoc}`;

/**
 * __useCustomerInvoicesByPkQuery__
 *
 * To run a query within a React component, call `useCustomerInvoicesByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerInvoicesByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerInvoicesByPkQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCustomerInvoicesByPkQuery(baseOptions: Apollo.QueryHookOptions<CustomerInvoicesByPkQuery, CustomerInvoicesByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerInvoicesByPkQuery, CustomerInvoicesByPkQueryVariables>(CustomerInvoicesByPkDocument, options);
      }
export function useCustomerInvoicesByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerInvoicesByPkQuery, CustomerInvoicesByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerInvoicesByPkQuery, CustomerInvoicesByPkQueryVariables>(CustomerInvoicesByPkDocument, options);
        }
export type CustomerInvoicesByPkQueryHookResult = ReturnType<typeof useCustomerInvoicesByPkQuery>;
export type CustomerInvoicesByPkLazyQueryHookResult = ReturnType<typeof useCustomerInvoicesByPkLazyQuery>;
export type CustomerInvoicesByPkQueryResult = Apollo.QueryResult<CustomerInvoicesByPkQuery, CustomerInvoicesByPkQueryVariables>;
export const CustomerCreditMemosByPkDocument = gql`
    query CustomerCreditMemosByPk($amagi_id: String!, $from: date, $to: date) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...CustomerCreditMemosData
  }
}
    ${CustomerCreditMemosDataFragmentDoc}`;

/**
 * __useCustomerCreditMemosByPkQuery__
 *
 * To run a query within a React component, call `useCustomerCreditMemosByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerCreditMemosByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerCreditMemosByPkQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCustomerCreditMemosByPkQuery(baseOptions: Apollo.QueryHookOptions<CustomerCreditMemosByPkQuery, CustomerCreditMemosByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerCreditMemosByPkQuery, CustomerCreditMemosByPkQueryVariables>(CustomerCreditMemosByPkDocument, options);
      }
export function useCustomerCreditMemosByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerCreditMemosByPkQuery, CustomerCreditMemosByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerCreditMemosByPkQuery, CustomerCreditMemosByPkQueryVariables>(CustomerCreditMemosByPkDocument, options);
        }
export type CustomerCreditMemosByPkQueryHookResult = ReturnType<typeof useCustomerCreditMemosByPkQuery>;
export type CustomerCreditMemosByPkLazyQueryHookResult = ReturnType<typeof useCustomerCreditMemosByPkLazyQuery>;
export type CustomerCreditMemosByPkQueryResult = Apollo.QueryResult<CustomerCreditMemosByPkQuery, CustomerCreditMemosByPkQueryVariables>;
export const CustomerFinancialCumulativeByPkDocument = gql`
    query CustomerFinancialCumulativeByPk($amagi_id: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...FinancialCardCummulativeData
  }
}
    ${FinancialCardCummulativeDataFragmentDoc}`;

/**
 * __useCustomerFinancialCumulativeByPkQuery__
 *
 * To run a query within a React component, call `useCustomerFinancialCumulativeByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerFinancialCumulativeByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerFinancialCumulativeByPkQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useCustomerFinancialCumulativeByPkQuery(baseOptions: Apollo.QueryHookOptions<CustomerFinancialCumulativeByPkQuery, CustomerFinancialCumulativeByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerFinancialCumulativeByPkQuery, CustomerFinancialCumulativeByPkQueryVariables>(CustomerFinancialCumulativeByPkDocument, options);
      }
export function useCustomerFinancialCumulativeByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerFinancialCumulativeByPkQuery, CustomerFinancialCumulativeByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerFinancialCumulativeByPkQuery, CustomerFinancialCumulativeByPkQueryVariables>(CustomerFinancialCumulativeByPkDocument, options);
        }
export type CustomerFinancialCumulativeByPkQueryHookResult = ReturnType<typeof useCustomerFinancialCumulativeByPkQuery>;
export type CustomerFinancialCumulativeByPkLazyQueryHookResult = ReturnType<typeof useCustomerFinancialCumulativeByPkLazyQuery>;
export type CustomerFinancialCumulativeByPkQueryResult = Apollo.QueryResult<CustomerFinancialCumulativeByPkQuery, CustomerFinancialCumulativeByPkQueryVariables>;
export const OrderDocument = gql`
    query Order($amagi_id: String!) {
  order(where: {customer: {amagi_id: {_eq: $amagi_id}}}) {
    ...OrderData
  }
}
    ${OrderDataFragmentDoc}`;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const CustomerProductByPkDocument = gql`
    query CustomerProductByPk($amagi_id: String!, $from: String, $to: String) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...CustomerProductData
  }
}
    ${CustomerProductDataFragmentDoc}`;

/**
 * __useCustomerProductByPkQuery__
 *
 * To run a query within a React component, call `useCustomerProductByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerProductByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerProductByPkQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCustomerProductByPkQuery(baseOptions: Apollo.QueryHookOptions<CustomerProductByPkQuery, CustomerProductByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerProductByPkQuery, CustomerProductByPkQueryVariables>(CustomerProductByPkDocument, options);
      }
export function useCustomerProductByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerProductByPkQuery, CustomerProductByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerProductByPkQuery, CustomerProductByPkQueryVariables>(CustomerProductByPkDocument, options);
        }
export type CustomerProductByPkQueryHookResult = ReturnType<typeof useCustomerProductByPkQuery>;
export type CustomerProductByPkLazyQueryHookResult = ReturnType<typeof useCustomerProductByPkLazyQuery>;
export type CustomerProductByPkQueryResult = Apollo.QueryResult<CustomerProductByPkQuery, CustomerProductByPkQueryVariables>;
export const CustomerProductRevenueDocument = gql`
    query CustomerProductRevenue($amagi_id: String!) {
  delivery_channel_platform(args: {amagi_ids: $amagi_id}) {
    channel_id
    channel_name
    channel_logo
    platform_id
    platform_name
    platform_logo
    products
  }
}
    `;

/**
 * __useCustomerProductRevenueQuery__
 *
 * To run a query within a React component, call `useCustomerProductRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerProductRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerProductRevenueQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useCustomerProductRevenueQuery(baseOptions: Apollo.QueryHookOptions<CustomerProductRevenueQuery, CustomerProductRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerProductRevenueQuery, CustomerProductRevenueQueryVariables>(CustomerProductRevenueDocument, options);
      }
export function useCustomerProductRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerProductRevenueQuery, CustomerProductRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerProductRevenueQuery, CustomerProductRevenueQueryVariables>(CustomerProductRevenueDocument, options);
        }
export type CustomerProductRevenueQueryHookResult = ReturnType<typeof useCustomerProductRevenueQuery>;
export type CustomerProductRevenueLazyQueryHookResult = ReturnType<typeof useCustomerProductRevenueLazyQuery>;
export type CustomerProductRevenueQueryResult = Apollo.QueryResult<CustomerProductRevenueQuery, CustomerProductRevenueQueryVariables>;
export const CustomerQuotesByPkDocument = gql`
    query CustomerQuotesByPk($amagi_id: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...CustomerQuotesData
  }
}
    ${CustomerQuotesDataFragmentDoc}`;

/**
 * __useCustomerQuotesByPkQuery__
 *
 * To run a query within a React component, call `useCustomerQuotesByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuotesByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuotesByPkQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useCustomerQuotesByPkQuery(baseOptions: Apollo.QueryHookOptions<CustomerQuotesByPkQuery, CustomerQuotesByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuotesByPkQuery, CustomerQuotesByPkQueryVariables>(CustomerQuotesByPkDocument, options);
      }
export function useCustomerQuotesByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuotesByPkQuery, CustomerQuotesByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuotesByPkQuery, CustomerQuotesByPkQueryVariables>(CustomerQuotesByPkDocument, options);
        }
export type CustomerQuotesByPkQueryHookResult = ReturnType<typeof useCustomerQuotesByPkQuery>;
export type CustomerQuotesByPkLazyQueryHookResult = ReturnType<typeof useCustomerQuotesByPkLazyQuery>;
export type CustomerQuotesByPkQueryResult = Apollo.QueryResult<CustomerQuotesByPkQuery, CustomerQuotesByPkQueryVariables>;
export const GetCustomerRegionRevenueDocument = gql`
    query GetCustomerReigonRevenue($from_date: String, $to_date: String) {
  customer_region_revenue(args: {from_date: $from_date, to_date: $to_date}) {
    customer_region
    total
  }
}
    `;

/**
 * __useGetCustomerRegionRevenueQuery__
 *
 * To run a query within a React component, call `useGetCustomerReigonRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerReigonRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerReigonRevenueQuery({
 *   variables: {
 *      from_date: // value for 'from_date'
 *      to_date: // value for 'to_date'
 *   },
 * });
 */
export function useGetCustomerRegionRevenueQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerRegionRevenueQuery, GetCustomerRegionRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerRegionRevenueQuery, GetCustomerRegionRevenueQueryVariables>(GetCustomerRegionRevenueDocument, options);
      }
export function useGetCustomerRegionRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerRegionRevenueQuery, GetCustomerRegionRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerRegionRevenueQuery, GetCustomerRegionRevenueQueryVariables>(GetCustomerRegionRevenueDocument, options);
        }
export type GetCustomerReigonRevenueQueryHookResult = ReturnType<typeof useGetCustomerRegionRevenueQuery>;
export type GetCustomerReigonRevenueLazyQueryHookResult = ReturnType<typeof useGetCustomerRegionRevenueLazyQuery>;
export type GetCustomerReigonRevenueQueryResult = Apollo.QueryResult<GetCustomerRegionRevenueQuery, GetCustomerRegionRevenueQueryVariables>;
export const CustomerSalesByPkDocument = gql`
    query CustomerSalesByPk($amagi_id: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...CustomerSalesData
  }
}
    ${CustomerSalesDataFragmentDoc}`;

/**
 * __useCustomerSalesByPkQuery__
 *
 * To run a query within a React component, call `useCustomerSalesByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSalesByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSalesByPkQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useCustomerSalesByPkQuery(baseOptions: Apollo.QueryHookOptions<CustomerSalesByPkQuery, CustomerSalesByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSalesByPkQuery, CustomerSalesByPkQueryVariables>(CustomerSalesByPkDocument, options);
      }
export function useCustomerSalesByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSalesByPkQuery, CustomerSalesByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSalesByPkQuery, CustomerSalesByPkQueryVariables>(CustomerSalesByPkDocument, options);
        }
export type CustomerSalesByPkQueryHookResult = ReturnType<typeof useCustomerSalesByPkQuery>;
export type CustomerSalesByPkLazyQueryHookResult = ReturnType<typeof useCustomerSalesByPkLazyQuery>;
export type CustomerSalesByPkQueryResult = Apollo.QueryResult<CustomerSalesByPkQuery, CustomerSalesByPkQueryVariables>;
export const ServiceTicketsDocument = gql`
    query ServiceTickets($amagi_id: String) {
  service_tickets: freshdesk_company(
    where: {amagi_id: {_eq: $amagi_id}, tickets: {is_deleted: {_eq: false}}}
  ) {
    tickets(where: {is_deleted: {_eq: false}}) {
      ...CustomerFDTicketsData
    }
  }
  total: freshdesk_company(
    where: {amagi_id: {_eq: $amagi_id}, tickets: {is_deleted: {_eq: false}}}
  ) {
    tickets_aggregate(where: {is_deleted: {_eq: false}}) {
      aggregate {
        count(columns: ticket_id)
      }
    }
  }
  closed: freshdesk_company(
    where: {amagi_id: {_eq: $amagi_id}, tickets: {is_deleted: {_eq: false}, status: {_eq: 5.0}}}
  ) {
    tickets_aggregate(where: {is_deleted: {_eq: false}}) {
      aggregate {
        count(columns: ticket_id)
      }
    }
  }
}
    ${CustomerFdTicketsDataFragmentDoc}`;

/**
 * __useServiceTicketsQuery__
 *
 * To run a query within a React component, call `useServiceTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceTicketsQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useServiceTicketsQuery(baseOptions?: Apollo.QueryHookOptions<ServiceTicketsQuery, ServiceTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceTicketsQuery, ServiceTicketsQueryVariables>(ServiceTicketsDocument, options);
      }
export function useServiceTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceTicketsQuery, ServiceTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceTicketsQuery, ServiceTicketsQueryVariables>(ServiceTicketsDocument, options);
        }
export type ServiceTicketsQueryHookResult = ReturnType<typeof useServiceTicketsQuery>;
export type ServiceTicketsLazyQueryHookResult = ReturnType<typeof useServiceTicketsLazyQuery>;
export type ServiceTicketsQueryResult = Apollo.QueryResult<ServiceTicketsQuery, ServiceTicketsQueryVariables>;
export const GetCustomerTierRevenueDocument = gql`
    query GetCustomerTierRevenue($from_date: String, $to_date: String) {
  customer_tier_revenue(args: {from_date: $from_date, to_date: $to_date}) {
    customer_tier
    total
  }
}
    `;

/**
 * __useGetCustomerTierRevenueQuery__
 *
 * To run a query within a React component, call `useGetCustomerTierRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerTierRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerTierRevenueQuery({
 *   variables: {
 *      from_date: // value for 'from_date'
 *      to_date: // value for 'to_date'
 *   },
 * });
 */
export function useGetCustomerTierRevenueQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerTierRevenueQuery, GetCustomerTierRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerTierRevenueQuery, GetCustomerTierRevenueQueryVariables>(GetCustomerTierRevenueDocument, options);
      }
export function useGetCustomerTierRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerTierRevenueQuery, GetCustomerTierRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerTierRevenueQuery, GetCustomerTierRevenueQueryVariables>(GetCustomerTierRevenueDocument, options);
        }
export type GetCustomerTierRevenueQueryHookResult = ReturnType<typeof useGetCustomerTierRevenueQuery>;
export type GetCustomerTierRevenueLazyQueryHookResult = ReturnType<typeof useGetCustomerTierRevenueLazyQuery>;
export type GetCustomerTierRevenueQueryResult = Apollo.QueryResult<GetCustomerTierRevenueQuery, GetCustomerTierRevenueQueryVariables>;
export const CustomerTotalOutstandingDocument = gql`
    query CustomerTotalOutstanding($amagi_id: String!, $from_date: String!, $to_date: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    invoices_due(args: {from_date: $from_date, to_date: $to_date}) {
      amount
      count
    }
    invoices_overdue(args: {from_date: $from_date, to_date: $to_date}) {
      amount
      count
    }
  }
}
    `;

/**
 * __useCustomerTotalOutstandingQuery__
 *
 * To run a query within a React component, call `useCustomerTotalOutstandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerTotalOutstandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerTotalOutstandingQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *      from_date: // value for 'from_date'
 *      to_date: // value for 'to_date'
 *   },
 * });
 */
export function useCustomerTotalOutstandingQuery(baseOptions: Apollo.QueryHookOptions<CustomerTotalOutstandingQuery, CustomerTotalOutstandingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerTotalOutstandingQuery, CustomerTotalOutstandingQueryVariables>(CustomerTotalOutstandingDocument, options);
      }
export function useCustomerTotalOutstandingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerTotalOutstandingQuery, CustomerTotalOutstandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerTotalOutstandingQuery, CustomerTotalOutstandingQueryVariables>(CustomerTotalOutstandingDocument, options);
        }
export type CustomerTotalOutstandingQueryHookResult = ReturnType<typeof useCustomerTotalOutstandingQuery>;
export type CustomerTotalOutstandingLazyQueryHookResult = ReturnType<typeof useCustomerTotalOutstandingLazyQuery>;
export type CustomerTotalOutstandingQueryResult = Apollo.QueryResult<CustomerTotalOutstandingQuery, CustomerTotalOutstandingQueryVariables>;
export const GetCustomerTypeRevenueDocument = gql`
    query GetCustomerTypeRevenue($from_date: String, $to_date: String) {
  customer_type_revenue(args: {from_date: $from_date, to_date: $to_date}) {
    customer_type
    total
  }
}
    `;

/**
 * __useGetCustomerTypeRevenueQuery__
 *
 * To run a query within a React component, call `useGetCustomerTypeRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerTypeRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerTypeRevenueQuery({
 *   variables: {
 *      from_date: // value for 'from_date'
 *      to_date: // value for 'to_date'
 *   },
 * });
 */
export function useGetCustomerTypeRevenueQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerTypeRevenueQuery, GetCustomerTypeRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerTypeRevenueQuery, GetCustomerTypeRevenueQueryVariables>(GetCustomerTypeRevenueDocument, options);
      }
export function useGetCustomerTypeRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerTypeRevenueQuery, GetCustomerTypeRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerTypeRevenueQuery, GetCustomerTypeRevenueQueryVariables>(GetCustomerTypeRevenueDocument, options);
        }
export type GetCustomerTypeRevenueQueryHookResult = ReturnType<typeof useGetCustomerTypeRevenueQuery>;
export type GetCustomerTypeRevenueLazyQueryHookResult = ReturnType<typeof useGetCustomerTypeRevenueLazyQuery>;
export type GetCustomerTypeRevenueQueryResult = Apollo.QueryResult<GetCustomerTypeRevenueQuery, GetCustomerTypeRevenueQueryVariables>;
export const CustomerDocument = gql`
    query Customer {
  customer {
    ...AllCustomerData
  }
}
    ${AllCustomerDataFragmentDoc}`;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerQuery(baseOptions?: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;


export const GetAmagiIdsForUserDocument =gql`
 query GetAmagiIdsForUser($user_email: String!) {
  financial_permissions(where: {user_email: {_eq: $user_email}}) {
    amagi_id
  }
}
`;

export function useGetAmagiIdsForUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAmagiIdsForUserQuery, GetAmagiIdsForUserQueryVariables>) {
      const options = {...defaultOptions, ...baseOptions}
      return Apollo.useQuery<GetAmagiIdsForUserQuery, GetAmagiIdsForUserQueryVariables>(GetAmagiIdsForUserDocument, options);
    }
export function useGetAmagiIdsForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmagiIdsForUserQuery, GetAmagiIdsForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useLazyQuery<GetAmagiIdsForUserQuery, GetAmagiIdsForUserQueryVariables>(GetAmagiIdsForUserDocument, options);
      }
export type GetAmagiIdsForUserLazyQueryHookResult = ReturnType<typeof useGetAmagiIdsForUserLazyQuery>;
export type GetAmagiIdsForUserLazyQueryResult = Apollo.QueryResult<GetAmagiIdsForUserQuery, GetAmagiIdsForUserQueryVariables>;
export type GetAmagiIdsForUserQueryResult = Apollo.QueryResult<GetAmagiIdsForUserQuery,GetAmagiIdsForUserQueryVariables>;



export const DashboardCountDocument = gql`
    query DashboardCount {
  customer_count {
    customer_type
    count
  }
  channel_aggregate {
    aggregate {
      count
    }
  }
  platform_aggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useDashboardCountQuery__
 *
 * To run a query within a React component, call `useDashboardCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardCountQuery(baseOptions?: Apollo.QueryHookOptions<DashboardCountQuery, DashboardCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardCountQuery, DashboardCountQueryVariables>(DashboardCountDocument, options);
      }
export function useDashboardCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardCountQuery, DashboardCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardCountQuery, DashboardCountQueryVariables>(DashboardCountDocument, options);
        }
export type DashboardCountQueryHookResult = ReturnType<typeof useDashboardCountQuery>;
export type DashboardCountLazyQueryHookResult = ReturnType<typeof useDashboardCountLazyQuery>;
export type DashboardCountQueryResult = Apollo.QueryResult<DashboardCountQuery, DashboardCountQueryVariables>;
export const DataQualityDetailsDocument = gql`
    query DataQualityDetails($from_date: date, $to_date: date) {
  data_quality(
    where: {date: {_gte: $from_date, _lte: $to_date}, completeness_weight: {_is_null: false}}
  ) {
    id
    date
    table_name
    column_name
    accuracy
    completeness
    complete_weight
    completeness_weight
    weight
    custom_value
  }
  key_metrics: data_quality(
    where: {date: {_gte: $from_date, _lte: $to_date}, custom_value: {_is_null: false}}
  ) {
    id
    date
    table_name
    column_name
    custom_value
  }
}
    `;

/**
 * __useDataQualityDetailsQuery__
 *
 * To run a query within a React component, call `useDataQualityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataQualityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataQualityDetailsQuery({
 *   variables: {
 *      from_date: // value for 'from_date'
 *      to_date: // value for 'to_date'
 *   },
 * });
 */
export function useDataQualityDetailsQuery(baseOptions?: Apollo.QueryHookOptions<DataQualityDetailsQuery, DataQualityDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataQualityDetailsQuery, DataQualityDetailsQueryVariables>(DataQualityDetailsDocument, options);
      }
export function useDataQualityDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataQualityDetailsQuery, DataQualityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataQualityDetailsQuery, DataQualityDetailsQueryVariables>(DataQualityDetailsDocument, options);
        }
export type DataQualityDetailsQueryHookResult = ReturnType<typeof useDataQualityDetailsQuery>;
export type DataQualityDetailsLazyQueryHookResult = ReturnType<typeof useDataQualityDetailsLazyQuery>;
export type DataQualityDetailsQueryResult = Apollo.QueryResult<DataQualityDetailsQuery, DataQualityDetailsQueryVariables>;
export const DataQualityTrendsDocument = gql`
    query DataQualityTrends($from_date: String, $to_date: String) {
  data_quality_trend(args: {from_date: $from_date, to_date: $to_date}) {
    date
    accuracy
    completeness
  }
  data_growth_trend(args: {from_date: $from_date, to_date: $to_date}) {
    date
    total_rows
  }
}
    `;

/**
 * __useDataQualityTrendsQuery__
 *
 * To run a query within a React component, call `useDataQualityTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataQualityTrendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataQualityTrendsQuery({
 *   variables: {
 *      from_date: // value for 'from_date'
 *      to_date: // value for 'to_date'
 *   },
 * });
 */
export function useDataQualityTrendsQuery(baseOptions?: Apollo.QueryHookOptions<DataQualityTrendsQuery, DataQualityTrendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DataQualityTrendsQuery, DataQualityTrendsQueryVariables>(DataQualityTrendsDocument, options);
      }
export function useDataQualityTrendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DataQualityTrendsQuery, DataQualityTrendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DataQualityTrendsQuery, DataQualityTrendsQueryVariables>(DataQualityTrendsDocument, options);
        }
export type DataQualityTrendsQueryHookResult = ReturnType<typeof useDataQualityTrendsQuery>;
export type DataQualityTrendsLazyQueryHookResult = ReturnType<typeof useDataQualityTrendsLazyQuery>;
export type DataQualityTrendsQueryResult = Apollo.QueryResult<DataQualityTrendsQuery, DataQualityTrendsQueryVariables>;
export const DeleteMsaRateCardDocument = gql`
    mutation DeleteMSARateCard($amagi_id: String!, $code: String!, $quote_number: String!) {
  delete_msa_rate_card_by_pk(
    amagi_id: $amagi_id
    code: $code
    quote_number: $quote_number
  ) {
    amagi_id
    billing_frequency
    code
    quote_number
    currency
    price
    quote_type
    tier_at_product_level
    type
    unit
  }
}
    `;
export type DeleteMsaRateCardMutationFn = Apollo.MutationFunction<DeleteMsaRateCardMutation, DeleteMsaRateCardMutationVariables>;

/**
 * __useDeleteMsaRateCardMutation__
 *
 * To run a mutation, you first call `useDeleteMsaRateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMsaRateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMsaRateCardMutation, { data, loading, error }] = useDeleteMsaRateCardMutation({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *      code: // value for 'code'
 *      quote_number: // value for 'quote_number'
 *   },
 * });
 */
export function useDeleteMsaRateCardMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMsaRateCardMutation, DeleteMsaRateCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMsaRateCardMutation, DeleteMsaRateCardMutationVariables>(DeleteMsaRateCardDocument, options);
      }
export type DeleteMsaRateCardMutationHookResult = ReturnType<typeof useDeleteMsaRateCardMutation>;
export type DeleteMsaRateCardMutationResult = Apollo.MutationResult<DeleteMsaRateCardMutation>;
export type DeleteMsaRateCardMutationOptions = Apollo.BaseMutationOptions<DeleteMsaRateCardMutation, DeleteMsaRateCardMutationVariables>;
export const DeliveriesByCustomerDocument = gql`
    query DeliveriesByCustomer($amagi_id: String!) {
  channel_delivery: delivery_main(
    where: {_and: [{delivery_to_order: {customer: {amagi_id: {_eq: $amagi_id}}}}, {cdp_delivery_type: {_eq: "channel_delivery"}}]}
  ) {
    ...DeliveryInfo
  }
  vod_delivery: delivery_main(
    where: {_and: [{delivery_to_order: {customer: {amagi_id: {_eq: $amagi_id}}}}, {cdp_delivery_type: {_eq: "vod_delivery"}}]}
  ) {
    ...DeliveryInfo
  }
  live_delivery: delivery_main(
    where: {_and: [{delivery_to_order: {customer: {amagi_id: {_eq: $amagi_id}}}}, {cdp_delivery_type: {_eq: "live_delivery"}}]}
  ) {
    ...DeliveryInfo
  }
  playouts: delivery_main(
    where: {_and: [{delivery_to_order: {customer: {amagi_id: {_eq: $amagi_id}}}}, {cdp_delivery_type: {_eq: "playout_delivery"}}]}
  ) {
    ...DeliveryInfo
  }
  channel_aggregate(where: {customer: {amagi_id: {_eq: $amagi_id}}}) {
    aggregate {
      count
    }
  }
}
    ${DeliveryInfoFragmentDoc}`;

/**
 * __useDeliveriesByCustomerQuery__
 *
 * To run a query within a React component, call `useDeliveriesByCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveriesByCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveriesByCustomerQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useDeliveriesByCustomerQuery(baseOptions: Apollo.QueryHookOptions<DeliveriesByCustomerQuery, DeliveriesByCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveriesByCustomerQuery, DeliveriesByCustomerQueryVariables>(DeliveriesByCustomerDocument, options);
      }
export function useDeliveriesByCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveriesByCustomerQuery, DeliveriesByCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveriesByCustomerQuery, DeliveriesByCustomerQueryVariables>(DeliveriesByCustomerDocument, options);
        }
export type DeliveriesByCustomerQueryHookResult = ReturnType<typeof useDeliveriesByCustomerQuery>;
export type DeliveriesByCustomerLazyQueryHookResult = ReturnType<typeof useDeliveriesByCustomerLazyQuery>;
export type DeliveriesByCustomerQueryResult = Apollo.QueryResult<DeliveriesByCustomerQuery, DeliveriesByCustomerQueryVariables>;
export const ChannelDeliveriesDocument = gql`
    query ChannelDeliveries {
  delivery: delivery_main(where: {cdp_delivery_type: {_eq: "channel_delivery"}}) {
    ...DeliveryGrid
  }
}
    ${DeliveryGridFragmentDoc}`;

/**
 * __useChannelDeliveriesQuery__
 *
 * To run a query within a React component, call `useChannelDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChannelDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChannelDeliveriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useChannelDeliveriesQuery(baseOptions?: Apollo.QueryHookOptions<ChannelDeliveriesQuery, ChannelDeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChannelDeliveriesQuery, ChannelDeliveriesQueryVariables>(ChannelDeliveriesDocument, options);
      }
export function useChannelDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChannelDeliveriesQuery, ChannelDeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChannelDeliveriesQuery, ChannelDeliveriesQueryVariables>(ChannelDeliveriesDocument, options);
        }
export type ChannelDeliveriesQueryHookResult = ReturnType<typeof useChannelDeliveriesQuery>;
export type ChannelDeliveriesLazyQueryHookResult = ReturnType<typeof useChannelDeliveriesLazyQuery>;
export type ChannelDeliveriesQueryResult = Apollo.QueryResult<ChannelDeliveriesQuery, ChannelDeliveriesQueryVariables>;
export const VodDeliveriesDocument = gql`
    query VODDeliveries {
  delivery: delivery_main(where: {cdp_delivery_type: {_eq: "vod_delivery"}}) {
    ...DeliveryGrid
  }
}
    ${DeliveryGridFragmentDoc}`;

/**
 * __useVodDeliveriesQuery__
 *
 * To run a query within a React component, call `useVodDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVodDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVodDeliveriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useVodDeliveriesQuery(baseOptions?: Apollo.QueryHookOptions<VodDeliveriesQuery, VodDeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VodDeliveriesQuery, VodDeliveriesQueryVariables>(VodDeliveriesDocument, options);
      }
export function useVodDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VodDeliveriesQuery, VodDeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VodDeliveriesQuery, VodDeliveriesQueryVariables>(VodDeliveriesDocument, options);
        }
export type VodDeliveriesQueryHookResult = ReturnType<typeof useVodDeliveriesQuery>;
export type VodDeliveriesLazyQueryHookResult = ReturnType<typeof useVodDeliveriesLazyQuery>;
export type VodDeliveriesQueryResult = Apollo.QueryResult<VodDeliveriesQuery, VodDeliveriesQueryVariables>;

export const LiveDeliveriesDocument = gql`
    query LiveDeliveries {
  delivery: delivery_main(where: {cdp_delivery_type: {_eq: "live_delivery"}}) {
    ...DeliveryGrid
  }
}
    ${DeliveryGridFragmentDoc}`;

/**
 * __useLiveDeliveriesQuery__
 *
 * To run a query within a React component, call `useLiveDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiveDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiveDeliveriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLiveDeliveriesQuery(baseOptions?: Apollo.QueryHookOptions<LiveDeliveriesQuery, LiveDeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiveDeliveriesQuery, LiveDeliveriesQueryVariables>(LiveDeliveriesDocument, options);
      }
export function useLiveDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiveDeliveriesQuery, LiveDeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiveDeliveriesQuery, LiveDeliveriesQueryVariables>(LiveDeliveriesDocument, options);
        }
export type LiveDeliveriesQueryHookResult = ReturnType<typeof useLiveDeliveriesQuery>;
export type LiveDeliveriesLazyQueryHookResult = ReturnType<typeof useLiveDeliveriesLazyQuery>;
export type LiveDeliveriesQueryResult = Apollo.QueryResult<LiveDeliveriesQuery, LiveDeliveriesQueryVariables>;

export const PlayoutDeliveriesDocument = gql`
    query PlayoutDeliveries {
  delivery: delivery_main(where: {cdp_delivery_type: {_eq: "playout_delivery"}}) {
    ...DeliveryGrid
  }
}
    ${DeliveryGridFragmentDoc}`;

/**
 * __usePlayoutDeliveriesQuery__
 *
 * To run a query within a React component, call `usePlayoutDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayoutDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayoutDeliveriesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlayoutDeliveriesQuery(baseOptions?: Apollo.QueryHookOptions<PlayoutDeliveriesQuery, PlayoutDeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayoutDeliveriesQuery, PlayoutDeliveriesQueryVariables>(PlayoutDeliveriesDocument, options);
      }
export function usePlayoutDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayoutDeliveriesQuery, PlayoutDeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayoutDeliveriesQuery, PlayoutDeliveriesQueryVariables>(PlayoutDeliveriesDocument, options);
        }
export type PlayoutDeliveriesQueryHookResult = ReturnType<typeof usePlayoutDeliveriesQuery>;
export type PlayoutDeliveriesLazyQueryHookResult = ReturnType<typeof usePlayoutDeliveriesLazyQuery>;
export type PlayoutDeliveriesQueryResult = Apollo.QueryResult<PlayoutDeliveriesQuery,PlayoutDeliveriesQueryVariables>;

export const DeliverybyPkDocument = gql`
    query DeliverybyPk($id: uuid!) {
  delivery(where: {id: {_eq: $id}}) {
    ...Delivery
  }
  channel {
    name
    salesforce_id
  }
  platform {
    name
    salesforce_id
  }
  product {
    code
    name
  }
}
    ${DeliveryFragmentDoc}`;

/**
 * __useDeliverybyPkQuery__
 *
 * To run a query within a React component, call `useDeliverybyPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliverybyPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliverybyPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeliverybyPkQuery(baseOptions: Apollo.QueryHookOptions<DeliverybyPkQuery, DeliverybyPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliverybyPkQuery, DeliverybyPkQueryVariables>(DeliverybyPkDocument, options);
      }
export function useDeliverybyPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliverybyPkQuery, DeliverybyPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliverybyPkQuery, DeliverybyPkQueryVariables>(DeliverybyPkDocument, options);
        }
export type DeliverybyPkQueryHookResult = ReturnType<typeof useDeliverybyPkQuery>;
export type DeliverybyPkLazyQueryHookResult = ReturnType<typeof useDeliverybyPkLazyQuery>;
export type DeliverybyPkQueryResult = Apollo.QueryResult<DeliverybyPkQuery, DeliverybyPkQueryVariables>;
export const UpdateDeliveryDocument = gql`
    mutation UpdateDelivery($id: uuid!, $input: delivery_set_input) {
  delivery: update_delivery_by_pk(pk_columns: {id: $id}, _set: $input) {
    id
  }
}
    `;
export type UpdateDeliveryMutationFn = Apollo.MutationFunction<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>;

/**
 * __useUpdateDeliveryMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryMutation, { data, loading, error }] = useUpdateDeliveryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>(UpdateDeliveryDocument, options);
      }
export type UpdateDeliveryMutationHookResult = ReturnType<typeof useUpdateDeliveryMutation>;
export type UpdateDeliveryMutationResult = Apollo.MutationResult<UpdateDeliveryMutation>;
export type UpdateDeliveryMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryMutation, UpdateDeliveryMutationVariables>;
export const UpdateDocsPageDocument = gql`
    mutation UpdateDocsPage($input: page_set_input) {
  update_page_by_pk(pk_columns: {slug: "docs"}, _set: $input) {
    content
    slug
  }
}
    `;
export type UpdateDocsPageMutationFn = Apollo.MutationFunction<UpdateDocsPageMutation, UpdateDocsPageMutationVariables>;

/**
 * __useUpdateDocsPageMutation__
 *
 * To run a mutation, you first call `useUpdateDocsPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocsPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocsPageMutation, { data, loading, error }] = useUpdateDocsPageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocsPageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocsPageMutation, UpdateDocsPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocsPageMutation, UpdateDocsPageMutationVariables>(UpdateDocsPageDocument, options);
      }
export type UpdateDocsPageMutationHookResult = ReturnType<typeof useUpdateDocsPageMutation>;
export type UpdateDocsPageMutationResult = Apollo.MutationResult<UpdateDocsPageMutation>;
export type UpdateDocsPageMutationOptions = Apollo.BaseMutationOptions<UpdateDocsPageMutation, UpdateDocsPageMutationVariables>;
export const DocsPageDocument = gql`
    query DocsPage {
  page_by_pk(slug: "docs") {
    content
    slug
  }
}
    `;

/**
 * __useDocsPageQuery__
 *
 * To run a query within a React component, call `useDocsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocsPageQuery(baseOptions?: Apollo.QueryHookOptions<DocsPageQuery, DocsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocsPageQuery, DocsPageQueryVariables>(DocsPageDocument, options);
      }
export function useDocsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocsPageQuery, DocsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocsPageQuery, DocsPageQueryVariables>(DocsPageDocument, options);
        }
export type DocsPageQueryHookResult = ReturnType<typeof useDocsPageQuery>;
export type DocsPageLazyQueryHookResult = ReturnType<typeof useDocsPageLazyQuery>;
export type DocsPageQueryResult = Apollo.QueryResult<DocsPageQuery, DocsPageQueryVariables>;
export const DqOverviewChannelTrendsDocument = gql`
    query DQOverviewChannelTrends($from_date: String) {
  channel_trends: existing_new_churned_dashboard_channel(
    args: {from_date: $from_date}
  ) {
    churned
    existing
    new
    month
  }
}
    `;

/**
 * __useDqOverviewChannelTrendsQuery__
 *
 * To run a query within a React component, call `useDqOverviewChannelTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDqOverviewChannelTrendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDqOverviewChannelTrendsQuery({
 *   variables: {
 *      from_date: // value for 'from_date'
 *   },
 * });
 */
export function useDqOverviewChannelTrendsQuery(baseOptions?: Apollo.QueryHookOptions<DqOverviewChannelTrendsQuery, DqOverviewChannelTrendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DqOverviewChannelTrendsQuery, DqOverviewChannelTrendsQueryVariables>(DqOverviewChannelTrendsDocument, options);
      }
export function useDqOverviewChannelTrendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DqOverviewChannelTrendsQuery, DqOverviewChannelTrendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DqOverviewChannelTrendsQuery, DqOverviewChannelTrendsQueryVariables>(DqOverviewChannelTrendsDocument, options);
        }
export type DqOverviewChannelTrendsQueryHookResult = ReturnType<typeof useDqOverviewChannelTrendsQuery>;
export type DqOverviewChannelTrendsLazyQueryHookResult = ReturnType<typeof useDqOverviewChannelTrendsLazyQuery>;
export type DqOverviewChannelTrendsQueryResult = Apollo.QueryResult<DqOverviewChannelTrendsQuery, DqOverviewChannelTrendsQueryVariables>;
export const DqOverviewCustomerTrendsDocument = gql`
    query DQOverviewCustomerTrends($from_date: String) {
  customer_trends: existing_new_churned_dashboard(args: {from_date: $from_date}) {
    churned
    existing
    new
    month
  }
}
    `;

/**
 * __useDqOverviewCustomerTrendsQuery__
 *
 * To run a query within a React component, call `useDqOverviewCustomerTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDqOverviewCustomerTrendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDqOverviewCustomerTrendsQuery({
 *   variables: {
 *      from_date: // value for 'from_date'
 *   },
 * });
 */
export function useDqOverviewCustomerTrendsQuery(baseOptions?: Apollo.QueryHookOptions<DqOverviewCustomerTrendsQuery, DqOverviewCustomerTrendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DqOverviewCustomerTrendsQuery, DqOverviewCustomerTrendsQueryVariables>(DqOverviewCustomerTrendsDocument, options);
      }
export function useDqOverviewCustomerTrendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DqOverviewCustomerTrendsQuery, DqOverviewCustomerTrendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DqOverviewCustomerTrendsQuery, DqOverviewCustomerTrendsQueryVariables>(DqOverviewCustomerTrendsDocument, options);
        }
export type DqOverviewCustomerTrendsQueryHookResult = ReturnType<typeof useDqOverviewCustomerTrendsQuery>;
export type DqOverviewCustomerTrendsLazyQueryHookResult = ReturnType<typeof useDqOverviewCustomerTrendsLazyQuery>;
export type DqOverviewCustomerTrendsQueryResult = Apollo.QueryResult<DqOverviewCustomerTrendsQuery, DqOverviewCustomerTrendsQueryVariables>;
export const DqOverviewPlatformTrendsDocument = gql`
    query DQOverviewPlatformTrends($from_date: String) {
  platform_trends: existing_new_churned_platform_dashboard(
    args: {from_date: $from_date}
  ) {
    churned
    existing
    new
    month
  }
}
    `;

/**
 * __useDqOverviewPlatformTrendsQuery__
 *
 * To run a query within a React component, call `useDqOverviewPlatformTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDqOverviewPlatformTrendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDqOverviewPlatformTrendsQuery({
 *   variables: {
 *      from_date: // value for 'from_date'
 *   },
 * });
 */
export function useDqOverviewPlatformTrendsQuery(baseOptions?: Apollo.QueryHookOptions<DqOverviewPlatformTrendsQuery, DqOverviewPlatformTrendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DqOverviewPlatformTrendsQuery, DqOverviewPlatformTrendsQueryVariables>(DqOverviewPlatformTrendsDocument, options);
      }
export function useDqOverviewPlatformTrendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DqOverviewPlatformTrendsQuery, DqOverviewPlatformTrendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DqOverviewPlatformTrendsQuery, DqOverviewPlatformTrendsQueryVariables>(DqOverviewPlatformTrendsDocument, options);
        }
export type DqOverviewPlatformTrendsQueryHookResult = ReturnType<typeof useDqOverviewPlatformTrendsQuery>;
export type DqOverviewPlatformTrendsLazyQueryHookResult = ReturnType<typeof useDqOverviewPlatformTrendsLazyQuery>;
export type DqOverviewPlatformTrendsQueryResult = Apollo.QueryResult<DqOverviewPlatformTrendsQuery, DqOverviewPlatformTrendsQueryVariables>;
export const DqCustomerTicketsDocument = gql`
    query DQCustomerTickets($from_date: String) {
  tickets: total_open_close_ticket_dashboard(args: {from_date: $from_date}) {
    month
    open_ticket
    closed_ticket
  }
}
    `;

/**
 * __useDqCustomerTicketsQuery__
 *
 * To run a query within a React component, call `useDqCustomerTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDqCustomerTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDqCustomerTicketsQuery({
 *   variables: {
 *      from_date: // value for 'from_date'
 *   },
 * });
 */
export function useDqCustomerTicketsQuery(baseOptions?: Apollo.QueryHookOptions<DqCustomerTicketsQuery, DqCustomerTicketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DqCustomerTicketsQuery, DqCustomerTicketsQueryVariables>(DqCustomerTicketsDocument, options);
      }
export function useDqCustomerTicketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DqCustomerTicketsQuery, DqCustomerTicketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DqCustomerTicketsQuery, DqCustomerTicketsQueryVariables>(DqCustomerTicketsDocument, options);
        }
export type DqCustomerTicketsQueryHookResult = ReturnType<typeof useDqCustomerTicketsQuery>;
export type DqCustomerTicketsLazyQueryHookResult = ReturnType<typeof useDqCustomerTicketsLazyQuery>;
export type DqCustomerTicketsQueryResult = Apollo.QueryResult<DqCustomerTicketsQuery, DqCustomerTicketsQueryVariables>;
export const GetCustomerDetailsDocument = gql`
    query getCustomerDetails($amagi_id_or_customer_name: String!) {
  customer(
    where: {_or: [{amagi_id: {_eq: $amagi_id_or_customer_name}}, {account_name: {_eq: $amagi_id_or_customer_name}}]}
  ) {
    salesforce_id
    amagi_id
    account_name
    account_legal_name
    invoicing_currency
    industry_segment
    logo
    media_industry_sub_segment {
      name
    }
    address {
      region
    }
    owner {
      region
    }
    size
    status
    service_tier
    customer_tier
    customer_type
    invoices_aggregate {
      aggregate {
        sum {
          total_amount
        }
      }
    }
  }
}
    `;

/**
 * __useGetCustomerDetailsQuery__
 *
 * To run a query within a React component, call `useGetCustomerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerDetailsQuery({
 *   variables: {
 *      amagi_id_or_customer_name: // value for 'amagi_id_or_customer_name'
 *   },
 * });
 */
export function useGetCustomerDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>(GetCustomerDetailsDocument, options);
      }
export function useGetCustomerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>(GetCustomerDetailsDocument, options);
        }
export type GetCustomerDetailsQueryHookResult = ReturnType<typeof useGetCustomerDetailsQuery>;
export type GetCustomerDetailsLazyQueryHookResult = ReturnType<typeof useGetCustomerDetailsLazyQuery>;
export type GetCustomerDetailsQueryResult = Apollo.QueryResult<GetCustomerDetailsQuery, GetCustomerDetailsQueryVariables>;
export const FeatureFlagDocument = gql`
    query FeatureFlag {
  feature_flag {
    feature
    roles
  }
}
    `;

/**
 * __useFeatureFlagQuery__
 *
 * To run a query within a React component, call `useFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureFlagQuery(baseOptions?: Apollo.QueryHookOptions<FeatureFlagQuery, FeatureFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureFlagQuery, FeatureFlagQueryVariables>(FeatureFlagDocument, options);
      }
export function useFeatureFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureFlagQuery, FeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureFlagQuery, FeatureFlagQueryVariables>(FeatureFlagDocument, options);
        }
export type FeatureFlagQueryHookResult = ReturnType<typeof useFeatureFlagQuery>;
export type FeatureFlagLazyQueryHookResult = ReturnType<typeof useFeatureFlagLazyQuery>;
export type FeatureFlagQueryResult = Apollo.QueryResult<FeatureFlagQuery, FeatureFlagQueryVariables>;
export const FinancialStatementsDocument = gql`
    query FinancialStatements($amagi_id: String!, $from_date: String, $to_date: String) {
  account_statement: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    outstanding: account_statement_outstanding(args: {from_date: $from_date}) {
      balance
    }
    statements: account_statement(args: {from_date: $from_date, to_date: $to_date}) {
      transaction_date
      transaction_type
      transaction_id
      charges
      payment
      balance
    }
    grand_total: account_statement_summary(
      args: {from_date: $from_date, to_date: $to_date}
    ) {
      charges
      payment
      balance
    }
    meta: account_statement_meta(args: {from_date: $from_date, to_date: $to_date}) {
      transaction_type
      count
    }
  }
}
    `;

/**
 * __useFinancialStatementsQuery__
 *
 * To run a query within a React component, call `useFinancialStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialStatementsQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *      from_date: // value for 'from_date'
 *      to_date: // value for 'to_date'
 *   },
 * });
 */
export function useFinancialStatementsQuery(baseOptions: Apollo.QueryHookOptions<FinancialStatementsQuery, FinancialStatementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinancialStatementsQuery, FinancialStatementsQueryVariables>(FinancialStatementsDocument, options);
      }
export function useFinancialStatementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinancialStatementsQuery, FinancialStatementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinancialStatementsQuery, FinancialStatementsQueryVariables>(FinancialStatementsDocument, options);
        }
export type FinancialStatementsQueryHookResult = ReturnType<typeof useFinancialStatementsQuery>;
export type FinancialStatementsLazyQueryHookResult = ReturnType<typeof useFinancialStatementsLazyQuery>;
export type FinancialStatementsQueryResult = Apollo.QueryResult<FinancialStatementsQuery, FinancialStatementsQueryVariables>;
export const CheckSalesforceNetsuiteInvoiceDocument = gql`
    query CheckSalesforceNetsuiteInvoice($transaction_id: String) {
  sf_ns_check(args: {_id: $transaction_id}) {
    check
  }
}
    `;

/**
 * __useCheckSalesforceNetsuiteInvoiceQuery__
 *
 * To run a query within a React component, call `useCheckSalesforceNetsuiteInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSalesforceNetsuiteInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSalesforceNetsuiteInvoiceQuery({
 *   variables: {
 *      transaction_id: // value for 'transaction_id'
 *   },
 * });
 */
export function useCheckSalesforceNetsuiteInvoiceQuery(baseOptions?: Apollo.QueryHookOptions<CheckSalesforceNetsuiteInvoiceQuery, CheckSalesforceNetsuiteInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSalesforceNetsuiteInvoiceQuery, CheckSalesforceNetsuiteInvoiceQueryVariables>(CheckSalesforceNetsuiteInvoiceDocument, options);
      }
export function useCheckSalesforceNetsuiteInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSalesforceNetsuiteInvoiceQuery, CheckSalesforceNetsuiteInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSalesforceNetsuiteInvoiceQuery, CheckSalesforceNetsuiteInvoiceQueryVariables>(CheckSalesforceNetsuiteInvoiceDocument, options);
        }
export type CheckSalesforceNetsuiteInvoiceQueryHookResult = ReturnType<typeof useCheckSalesforceNetsuiteInvoiceQuery>;
export type CheckSalesforceNetsuiteInvoiceLazyQueryHookResult = ReturnType<typeof useCheckSalesforceNetsuiteInvoiceLazyQuery>;
export type CheckSalesforceNetsuiteInvoiceQueryResult = Apollo.QueryResult<CheckSalesforceNetsuiteInvoiceQuery, CheckSalesforceNetsuiteInvoiceQueryVariables>;
export const MrrDocument = gql`
    query MRR($amagi_id: String!) {
  customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    latest_mrr {
      revenue_split
      mrr: amount
      month
    }
  }
}
    `;

/**
 * __useMrrQuery__
 *
 * To run a query within a React component, call `useMrrQuery` and pass it any options that fit your needs.
 * When your component renders, `useMrrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMrrQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useMrrQuery(baseOptions: Apollo.QueryHookOptions<MrrQuery, MrrQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MrrQuery, MrrQueryVariables>(MrrDocument, options);
      }
export function useMrrLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MrrQuery, MrrQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MrrQuery, MrrQueryVariables>(MrrDocument, options);
        }
export type MrrQueryHookResult = ReturnType<typeof useMrrQuery>;
export type MrrLazyQueryHookResult = ReturnType<typeof useMrrLazyQuery>;
export type MrrQueryResult = Apollo.QueryResult<MrrQuery, MrrQueryVariables>;
export const MsaRateCardByAmagiIdDocument = gql`
    query MSARateCardByAmagiID($amagiId: String!) {
  msa_rate_card: msa_rate_card_fn(args: {amagi_ids: $amagiId}) {
    quote_number
    quote_type
    status
    products
  }
}
    `;

/**
 * __useMsaRateCardByAmagiIdQuery__
 *
 * To run a query within a React component, call `useMsaRateCardByAmagiIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMsaRateCardByAmagiIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMsaRateCardByAmagiIdQuery({
 *   variables: {
 *      amagiId: // value for 'amagiId'
 *   },
 * });
 */
export function useMsaRateCardByAmagiIdQuery(baseOptions: Apollo.QueryHookOptions<MsaRateCardByAmagiIdQuery, MsaRateCardByAmagiIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MsaRateCardByAmagiIdQuery, MsaRateCardByAmagiIdQueryVariables>(MsaRateCardByAmagiIdDocument, options);
      }
export function useMsaRateCardByAmagiIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MsaRateCardByAmagiIdQuery, MsaRateCardByAmagiIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MsaRateCardByAmagiIdQuery, MsaRateCardByAmagiIdQueryVariables>(MsaRateCardByAmagiIdDocument, options);
        }
export type MsaRateCardByAmagiIdQueryHookResult = ReturnType<typeof useMsaRateCardByAmagiIdQuery>;
export type MsaRateCardByAmagiIdLazyQueryHookResult = ReturnType<typeof useMsaRateCardByAmagiIdLazyQuery>;
export type MsaRateCardByAmagiIdQueryResult = Apollo.QueryResult<MsaRateCardByAmagiIdQuery, MsaRateCardByAmagiIdQueryVariables>;
export const OpportunityFileDocument = gql`
    query OpportunityFile($id: String!) {
  opportunity(where: {salesforce_id: {_eq: $id}}) {
    salesforce_id
    files {
      done
      totalSize
      records {
        Id
        ContentVersion {
          Id
          Content
        }
        ContentDocument {
          ContentSize
          FileExtension
          FileType
          Title
        }
      }
    }
  }
}
    `;

/**
 * __useOpportunityFileQuery__
 *
 * To run a query within a React component, call `useOpportunityFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpportunityFileQuery(baseOptions: Apollo.QueryHookOptions<OpportunityFileQuery, OpportunityFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityFileQuery, OpportunityFileQueryVariables>(OpportunityFileDocument, options);
      }
export function useOpportunityFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityFileQuery, OpportunityFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityFileQuery, OpportunityFileQueryVariables>(OpportunityFileDocument, options);
        }
export type OpportunityFileQueryHookResult = ReturnType<typeof useOpportunityFileQuery>;
export type OpportunityFileLazyQueryHookResult = ReturnType<typeof useOpportunityFileLazyQuery>;
export type OpportunityFileQueryResult = Apollo.QueryResult<OpportunityFileQuery, OpportunityFileQueryVariables>;
export const OrderCountDocument = gql`
    query OrderCount($amagi_id: String!) {
  total: order_aggregate(where: {customer: {amagi_id: {_eq: $amagi_id}}}) {
    aggregate {
      count
      sum {
        amount
      }
    }
  }
  draft: order_aggregate(
    where: {customer: {amagi_id: {_eq: $amagi_id}}, status: {_eq: "Draft"}}
  ) {
    aggregate {
      count
      sum {
        amount
      }
    }
  }
  on_hold: order_aggregate(
    where: {customer: {amagi_id: {_eq: $amagi_id}}, status: {_eq: "On Hold"}}
  ) {
    aggregate {
      count
      sum {
        amount
      }
    }
  }
  in_progress: order_aggregate(
    where: {customer: {amagi_id: {_eq: $amagi_id}}, status: {_eq: "In Progress"}}
  ) {
    aggregate {
      count
      sum {
        amount
      }
    }
  }
  activated: order_aggregate(
    where: {customer: {amagi_id: {_eq: $amagi_id}}, status: {_eq: "Activated"}}
  ) {
    aggregate {
      count
      sum {
        amount
      }
    }
  }
}
    `;

/**
 * __useOrderCountQuery__
 *
 * To run a query within a React component, call `useOrderCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderCountQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useOrderCountQuery(baseOptions: Apollo.QueryHookOptions<OrderCountQuery, OrderCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderCountQuery, OrderCountQueryVariables>(OrderCountDocument, options);
      }
export function useOrderCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderCountQuery, OrderCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderCountQuery, OrderCountQueryVariables>(OrderCountDocument, options);
        }
export type OrderCountQueryHookResult = ReturnType<typeof useOrderCountQuery>;
export type OrderCountLazyQueryHookResult = ReturnType<typeof useOrderCountLazyQuery>;
export type OrderCountQueryResult = Apollo.QueryResult<OrderCountQuery, OrderCountQueryVariables>;
export const NetBillingSummaryDocument = gql`
    query NetBillingSummary($from_date: String, $to_date: String) {
  net_invoices_outstanding(args: {from_date: $from_date, to_date: $to_date}) {
    amount
  }
  net_invoices_due(args: {from_date: $from_date, to_date: $to_date}) {
    amount
  }
  net_invoices_overdue(args: {from_date: $from_date, to_date: $to_date}) {
    amount
  }
}
    `;

/**
 * __useNetBillingSummaryQuery__
 *
 * To run a query within a React component, call `useNetBillingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetBillingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetBillingSummaryQuery({
 *   variables: {
 *      from_date: // value for 'from_date'
 *      to_date: // value for 'to_date'
 *   },
 * });
 */
export function useNetBillingSummaryQuery(baseOptions?: Apollo.QueryHookOptions<NetBillingSummaryQuery, NetBillingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetBillingSummaryQuery, NetBillingSummaryQueryVariables>(NetBillingSummaryDocument, options);
      }
export function useNetBillingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetBillingSummaryQuery, NetBillingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetBillingSummaryQuery, NetBillingSummaryQueryVariables>(NetBillingSummaryDocument, options);
        }
export type NetBillingSummaryQueryHookResult = ReturnType<typeof useNetBillingSummaryQuery>;
export type NetBillingSummaryLazyQueryHookResult = ReturnType<typeof useNetBillingSummaryLazyQuery>;
export type NetBillingSummaryQueryResult = Apollo.QueryResult<NetBillingSummaryQuery, NetBillingSummaryQueryVariables>;
export const CustomerOverviewFinancialDocument = gql`
    query CustomerOverviewFinancial($amagi_id: String!, $from_date: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...CustomerOverviewFinancialData
  }
}
    ${CustomerOverviewFinancialDataFragmentDoc}`;

/**
 * __useCustomerOverviewFinancialQuery__
 *
 * To run a query within a React component, call `useCustomerOverviewFinancialQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerOverviewFinancialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerOverviewFinancialQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *      from_date: // value for 'from_date'
 *   },
 * });
 */
export function useCustomerOverviewFinancialQuery(baseOptions: Apollo.QueryHookOptions<CustomerOverviewFinancialQuery, CustomerOverviewFinancialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerOverviewFinancialQuery, CustomerOverviewFinancialQueryVariables>(CustomerOverviewFinancialDocument, options);
      }
export function useCustomerOverviewFinancialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerOverviewFinancialQuery, CustomerOverviewFinancialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerOverviewFinancialQuery, CustomerOverviewFinancialQueryVariables>(CustomerOverviewFinancialDocument, options);
        }
export type CustomerOverviewFinancialQueryHookResult = ReturnType<typeof useCustomerOverviewFinancialQuery>;
export type CustomerOverviewFinancialLazyQueryHookResult = ReturnType<typeof useCustomerOverviewFinancialLazyQuery>;
export type CustomerOverviewFinancialQueryResult = Apollo.QueryResult<CustomerOverviewFinancialQuery, CustomerOverviewFinancialQueryVariables>;
export const CustomerOverviewMrrByPkDocument = gql`
    query CustomerOverviewMRRByPk($amagi_id: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...CustomerOverviewMRR
  }
}
    ${CustomerOverviewMrrFragmentDoc}`;

/**
 * __useCustomerOverviewMrrByPkQuery__
 *
 * To run a query within a React component, call `useCustomerOverviewMrrByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerOverviewMrrByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerOverviewMrrByPkQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useCustomerOverviewMrrByPkQuery(baseOptions: Apollo.QueryHookOptions<CustomerOverviewMrrByPkQuery, CustomerOverviewMrrByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerOverviewMrrByPkQuery, CustomerOverviewMrrByPkQueryVariables>(CustomerOverviewMrrByPkDocument, options);
      }
export function useCustomerOverviewMrrByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerOverviewMrrByPkQuery, CustomerOverviewMrrByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerOverviewMrrByPkQuery, CustomerOverviewMrrByPkQueryVariables>(CustomerOverviewMrrByPkDocument, options);
        }
export type CustomerOverviewMrrByPkQueryHookResult = ReturnType<typeof useCustomerOverviewMrrByPkQuery>;
export type CustomerOverviewMrrByPkLazyQueryHookResult = ReturnType<typeof useCustomerOverviewMrrByPkLazyQuery>;
export type CustomerOverviewMrrByPkQueryResult = Apollo.QueryResult<CustomerOverviewMrrByPkQuery, CustomerOverviewMrrByPkQueryVariables>;
export const CustomerOverviewRevenueDocument = gql`
    query CustomerOverviewRevenue($amagi_id: String!, $from_date: String!, $to_date: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...CustomerOverviewRevenueData
  }
}
    ${CustomerOverviewRevenueDataFragmentDoc}`;

/**
 * __useCustomerOverviewRevenueQuery__
 *
 * To run a query within a React component, call `useCustomerOverviewRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerOverviewRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerOverviewRevenueQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *      from_date: // value for 'from_date'
 *      to_date: // value for 'to_date'
 *   },
 * });
 */
export function useCustomerOverviewRevenueQuery(baseOptions: Apollo.QueryHookOptions<CustomerOverviewRevenueQuery, CustomerOverviewRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerOverviewRevenueQuery, CustomerOverviewRevenueQueryVariables>(CustomerOverviewRevenueDocument, options);
      }
export function useCustomerOverviewRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerOverviewRevenueQuery, CustomerOverviewRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerOverviewRevenueQuery, CustomerOverviewRevenueQueryVariables>(CustomerOverviewRevenueDocument, options);
        }
export type CustomerOverviewRevenueQueryHookResult = ReturnType<typeof useCustomerOverviewRevenueQuery>;
export type CustomerOverviewRevenueLazyQueryHookResult = ReturnType<typeof useCustomerOverviewRevenueLazyQuery>;
export type CustomerOverviewRevenueQueryResult = Apollo.QueryResult<CustomerOverviewRevenueQuery, CustomerOverviewRevenueQueryVariables>;
export const PlatformByPkDocument = gql`
    query PlatformByPk($_id: uuid!) {
  platform: platform_by_pk(id: $_id) {
    ...PlatformFields
  }
  platforms: platform {
    salesforce_id
  }
  customer {
    amagi_id
    account_name
    salesforce_id
  }
}
    ${PlatformFieldsFragmentDoc}`;

/**
 * __usePlatformByPkQuery__
 *
 * To run a query within a React component, call `usePlatformByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformByPkQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function usePlatformByPkQuery(baseOptions: Apollo.QueryHookOptions<PlatformByPkQuery, PlatformByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformByPkQuery, PlatformByPkQueryVariables>(PlatformByPkDocument, options);
      }
export function usePlatformByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatformByPkQuery, PlatformByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformByPkQuery, PlatformByPkQueryVariables>(PlatformByPkDocument, options);
        }
export type PlatformByPkQueryHookResult = ReturnType<typeof usePlatformByPkQuery>;
export type PlatformByPkLazyQueryHookResult = ReturnType<typeof usePlatformByPkLazyQuery>;
export type PlatformByPkQueryResult = Apollo.QueryResult<PlatformByPkQuery, PlatformByPkQueryVariables>;
export const UpdatePlatformDocument = gql`
    mutation UpdatePlatform($id: uuid!, $input: platform_set_input) {
  platform: update_platform_by_pk(pk_columns: {id: $id}, _set: $input) {
    ...PlatformFields
  }
}
    ${PlatformFieldsFragmentDoc}`;
export type UpdatePlatformMutationFn = Apollo.MutationFunction<UpdatePlatformMutation, UpdatePlatformMutationVariables>;

/**
 * __useUpdatePlatformMutation__
 *
 * To run a mutation, you first call `useUpdatePlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformMutation, { data, loading, error }] = useUpdatePlatformMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlatformMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformMutation, UpdatePlatformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformMutation, UpdatePlatformMutationVariables>(UpdatePlatformDocument, options);
      }
export type UpdatePlatformMutationHookResult = ReturnType<typeof useUpdatePlatformMutation>;
export type UpdatePlatformMutationResult = Apollo.MutationResult<UpdatePlatformMutation>;
export type UpdatePlatformMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformMutation, UpdatePlatformMutationVariables>;

export const GetRedundantChannelNamesDocument = gql`
  query GetRedundantChannelNames($args: get_redundant_channel_names_args!) {
    get_redundant_channel_names(args: $args) {
      redundant_playout_channels
    }
  }
`;

export function useGetRedundantChannelNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetRedundantChannelNamesQuery, GetRedundantChannelNamesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRedundantChannelNamesQuery, GetRedundantChannelNamesQueryVariables>(GetRedundantChannelNamesDocument, options);
}

export function useGetRedundantChannelNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRedundantChannelNamesQuery, GetRedundantChannelNamesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRedundantChannelNamesQuery, GetRedundantChannelNamesQueryVariables>(GetRedundantChannelNamesDocument, options);
}

export type GetRedundantChannelNamesHookResult = ReturnType<typeof useGetRedundantChannelNamesQuery>;
export type GetRedundantChannelNamesLazyQueryHookResult = ReturnType<typeof useGetRedundantChannelNamesLazyQuery>;
export type GetRedundantChannelNamesQueryResult = Apollo.QueryResult<GetRedundantChannelNamesQuery, GetRedundantChannelNamesQueryVariables>;


export const UpsertRedundantPlayoutChannelDocument = gql`
mutation UpsertRedundantPlayoutChannel($RedundantId: uuid!, $channelId: uuid!) {
  redundant_channels:insert_redundant_playout_channels(objects: [{redundant_channel_id: $RedundantId, channel_id: $channelId}], on_conflict: {constraint: redundant_playout_channels_pkey, update_columns: [redundant_channel_id, channel_id], where: {redundant_channel_id: {_eq: $RedundantId}}}) {
    affected_rows
    returning {
      channel_id
      redundant_channel_id
    }
  }
}

`;

export const useUpsertRedundantPlayoutChannelMutation = (
  baseOptions?: Apollo.MutationHookOptions<UpsertRedundantPlayoutChannelMutation, UpsertRedundantPlayoutChannelMutationVariables>
) => {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertRedundantPlayoutChannelMutation, UpsertRedundantPlayoutChannelMutationVariables>(
    UpsertRedundantPlayoutChannelDocument,
    options
  );
};

export type UpsertRedundantPlayoutChannelMutationHookResult = ReturnType<typeof useUpsertRedundantPlayoutChannelMutation>;
export type UpsertRedundantPlayoutChannelMutationResult = Apollo.MutationResult<UpsertRedundantPlayoutChannelMutation>;
export type UpsertRedundantPlayoutChannelMutationOptions = Apollo.BaseMutationOptions<
  UpsertRedundantPlayoutChannelMutation,
  UpsertRedundantPlayoutChannelMutationVariables
>;
export const DeleteRedundantPlayoutChannelDocument = gql`
 mutation DeleteRedundantPlayoutChannel($RedundantId: uuid!, $channelId: uuid!) {
    redundant_channels: delete_redundant_playout_channels(
      where: {redundant_channel_id: {_eq: $RedundantId}, channel_id: {_eq: $channelId} }
    ) {
      affected_rows
    }
  }
`;
export const useDeleteRedundantPlayoutChannelMutation = (
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRedundantPlayoutChannelMutation,
    DeleteRedundantPlayoutChannelMutationVariables
  >
) => {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteRedundantPlayoutChannelMutation, DeleteRedundantPlayoutChannelMutationVariables>(
    DeleteRedundantPlayoutChannelDocument,
    options
  );
};

export type DeleteRedundantPlayoutChannelMutationHookResult = ReturnType<
  typeof useDeleteRedundantPlayoutChannelMutation
>;
export type DeleteRedundantPlayoutChannelMutationResult = Apollo.MutationResult<
  DeleteRedundantPlayoutChannelMutation
>;
export type DeleteRedundantPlayoutChannelMutationOptions = Apollo.BaseMutationOptions<
  DeleteRedundantPlayoutChannelMutation,
  DeleteRedundantPlayoutChannelMutationVariables
>;

export const PlatformsDocument = gql`
    query Platforms {
  platform(
    where: {_or: [{is_platform_group: {_neq: "Yes"}}, {is_platform_group: {_is_null: true}}]}
  ) {
    ...PlatformGrid
  }
}
    ${PlatformGridFragmentDoc}`;

/**
 * __usePlatformsQuery__
 *
 * To run a query within a React component, call `usePlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlatformsQuery(baseOptions?: Apollo.QueryHookOptions<PlatformsQuery, PlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformsQuery, PlatformsQueryVariables>(PlatformsDocument, options);
      }
export function usePlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlatformsQuery, PlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformsQuery, PlatformsQueryVariables>(PlatformsDocument, options);
        }
export type PlatformsQueryHookResult = ReturnType<typeof usePlatformsQuery>;
export type PlatformsLazyQueryHookResult = ReturnType<typeof usePlatformsLazyQuery>;
export type PlatformsQueryResult = Apollo.QueryResult<PlatformsQuery, PlatformsQueryVariables>;
export const GroupedPlatformsDocument = gql`
    query GroupedPlatforms {
  platform(where: {is_platform_group: {_eq: "Yes"}}) {
    ...PlatformGrid
  }
}
    ${PlatformGridFragmentDoc}`;

/**
 * __useGroupedPlatformsQuery__
 *
 * To run a query within a React component, call `useGroupedPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedPlatformsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGroupedPlatformsQuery(baseOptions?: Apollo.QueryHookOptions<GroupedPlatformsQuery, GroupedPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupedPlatformsQuery, GroupedPlatformsQueryVariables>(GroupedPlatformsDocument, options);
      }
export function useGroupedPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupedPlatformsQuery, GroupedPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupedPlatformsQuery, GroupedPlatformsQueryVariables>(GroupedPlatformsDocument, options);
        }
export type GroupedPlatformsQueryHookResult = ReturnType<typeof useGroupedPlatformsQuery>;
export type GroupedPlatformsLazyQueryHookResult = ReturnType<typeof useGroupedPlatformsLazyQuery>;
export type GroupedPlatformsQueryResult = Apollo.QueryResult<GroupedPlatformsQuery, GroupedPlatformsQueryVariables>;
export const ReceiptsByCustomerDocument = gql`
    query ReceiptsByCustomer($amagi_id: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    ...ReceiptsData
  }
}
    ${ReceiptsDataFragmentDoc}`;

/**
 * __useReceiptsByCustomerQuery__
 *
 * To run a query within a React component, call `useReceiptsByCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useReceiptsByCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReceiptsByCustomerQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useReceiptsByCustomerQuery(baseOptions: Apollo.QueryHookOptions<ReceiptsByCustomerQuery, ReceiptsByCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReceiptsByCustomerQuery, ReceiptsByCustomerQueryVariables>(ReceiptsByCustomerDocument, options);
      }
export function useReceiptsByCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReceiptsByCustomerQuery, ReceiptsByCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReceiptsByCustomerQuery, ReceiptsByCustomerQueryVariables>(ReceiptsByCustomerDocument, options);
        }
export type ReceiptsByCustomerQueryHookResult = ReturnType<typeof useReceiptsByCustomerQuery>;
export type ReceiptsByCustomerLazyQueryHookResult = ReturnType<typeof useReceiptsByCustomerLazyQuery>;
export type ReceiptsByCustomerQueryResult = Apollo.QueryResult<ReceiptsByCustomerQuery, ReceiptsByCustomerQueryVariables>;
export const SearchCustomerDocument = gql`
    query SearchCustomer($query: String) {
  search_customer(args: {_search_query: $query}) {
    salesforce_id
    amagi_id
    account_name
    account_legal_name
    invoicing_currency
    industry_segment
    logo
    media_industry_sub_segment {
      name
    }
    address {
      region
    }
    owner {
      region
    }
    record_type {
      name
    }
    tam
    size
    status
    service_tier
    customer_tier
    customer_type
    invoices_aggregate {
      aggregate {
        sum {
          total_amount
        }
      }
    }
  }
}
    `;

/**
 * __useSearchCustomerQuery__
 *
 * To run a query within a React component, call `useSearchCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomerQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchCustomerQuery(baseOptions?: Apollo.QueryHookOptions<SearchCustomerQuery, SearchCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomerQuery, SearchCustomerQueryVariables>(SearchCustomerDocument, options);
      }
export function useSearchCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomerQuery, SearchCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomerQuery, SearchCustomerQueryVariables>(SearchCustomerDocument, options);
        }
export type SearchCustomerQueryHookResult = ReturnType<typeof useSearchCustomerQuery>;
export type SearchCustomerLazyQueryHookResult = ReturnType<typeof useSearchCustomerLazyQuery>;
export type SearchCustomerQueryResult = Apollo.QueryResult<SearchCustomerQuery, SearchCustomerQueryVariables>;
export const ServiceAvailabilityDocument = gql`
    query ServiceAvailability($amagi_id: String!) {
  customer: customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
    avg_service_availibity {
      months
      available_time_secs
      down_time_secs
      avg_service_availability
    }
  }
}
    `;

/**
 * __useServiceAvailabilityQuery__
 *
 * To run a query within a React component, call `useServiceAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceAvailabilityQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useServiceAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<ServiceAvailabilityQuery, ServiceAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceAvailabilityQuery, ServiceAvailabilityQueryVariables>(ServiceAvailabilityDocument, options);
      }
export function useServiceAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceAvailabilityQuery, ServiceAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceAvailabilityQuery, ServiceAvailabilityQueryVariables>(ServiceAvailabilityDocument, options);
        }
export type ServiceAvailabilityQueryHookResult = ReturnType<typeof useServiceAvailabilityQuery>;
export type ServiceAvailabilityLazyQueryHookResult = ReturnType<typeof useServiceAvailabilityLazyQuery>;
export type ServiceAvailabilityQueryResult = Apollo.QueryResult<ServiceAvailabilityQuery, ServiceAvailabilityQueryVariables>;
export const GetTopCustomersConsumptionDocument = gql`
    query GetTopCustomersConsumption($from_date: String, $to_date: String) {
  top_customers_consumption(args: {from_date: $from_date, to_date: $to_date}) {
    account_name
    amagi_id
    total
    logo
  }
}
    `;

/**
 * __useGetTopCustomersConsumptionQuery__
 *
 * To run a query within a React component, call `useGetTopCustomersConsumptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopCustomersConsumptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopCustomersConsumptionQuery({
 *   variables: {
 *      from_date: // value for 'from_date'
 *      to_date: // value for 'to_date'
 *   },
 * });
 */
export function useGetTopCustomersConsumptionQuery(baseOptions?: Apollo.QueryHookOptions<GetTopCustomersConsumptionQuery, GetTopCustomersConsumptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopCustomersConsumptionQuery, GetTopCustomersConsumptionQueryVariables>(GetTopCustomersConsumptionDocument, options);
      }
export function useGetTopCustomersConsumptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopCustomersConsumptionQuery, GetTopCustomersConsumptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopCustomersConsumptionQuery, GetTopCustomersConsumptionQueryVariables>(GetTopCustomersConsumptionDocument, options);
        }
export type GetTopCustomersConsumptionQueryHookResult = ReturnType<typeof useGetTopCustomersConsumptionQuery>;
export type GetTopCustomersConsumptionLazyQueryHookResult = ReturnType<typeof useGetTopCustomersConsumptionLazyQuery>;
export type GetTopCustomersConsumptionQueryResult = Apollo.QueryResult<GetTopCustomersConsumptionQuery, GetTopCustomersConsumptionQueryVariables>;
export const GetTopCustomersDocument = gql`
    query GetTopCustomers($from_date: String, $to_date: String) {
  top_customers_overall(args: {from_date: $from_date, to_date: $to_date}) {
    account_name
    total
  }
}
    `;

/**
 * __useGetTopCustomersQuery__
 *
 * To run a query within a React component, call `useGetTopCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopCustomersQuery({
 *   variables: {
 *      from_date: // value for 'from_date'
 *      to_date: // value for 'to_date'
 *   },
 * });
 */
export function useGetTopCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetTopCustomersQuery, GetTopCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopCustomersQuery, GetTopCustomersQueryVariables>(GetTopCustomersDocument, options);
      }
export function useGetTopCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopCustomersQuery, GetTopCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopCustomersQuery, GetTopCustomersQueryVariables>(GetTopCustomersDocument, options);
        }
export type GetTopCustomersQueryHookResult = ReturnType<typeof useGetTopCustomersQuery>;
export type GetTopCustomersLazyQueryHookResult = ReturnType<typeof useGetTopCustomersLazyQuery>;
export type GetTopCustomersQueryResult = Apollo.QueryResult<GetTopCustomersQuery, GetTopCustomersQueryVariables>;
export const GetTopCustomersSubscriptionDocument = gql`
    query GetTopCustomersSubscription($from_date: String, $to_date: String) {
  top_customers_subscription(args: {from_date: $from_date, to_date: $to_date}) {
    account_name
    amagi_id
    total
    logo
  }
}
    `;

/**
 * __useGetTopCustomersSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetTopCustomersSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopCustomersSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopCustomersSubscriptionQuery({
 *   variables: {
 *      from_date: // value for 'from_date'
 *      to_date: // value for 'to_date'
 *   },
 * });
 */
export function useGetTopCustomersSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<GetTopCustomersSubscriptionQuery, GetTopCustomersSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopCustomersSubscriptionQuery, GetTopCustomersSubscriptionQueryVariables>(GetTopCustomersSubscriptionDocument, options);
      }
export function useGetTopCustomersSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopCustomersSubscriptionQuery, GetTopCustomersSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopCustomersSubscriptionQuery, GetTopCustomersSubscriptionQueryVariables>(GetTopCustomersSubscriptionDocument, options);
        }
export type GetTopCustomersSubscriptionQueryHookResult = ReturnType<typeof useGetTopCustomersSubscriptionQuery>;
export type GetTopCustomersSubscriptionLazyQueryHookResult = ReturnType<typeof useGetTopCustomersSubscriptionLazyQuery>;
export type GetTopCustomersSubscriptionQueryResult = Apollo.QueryResult<GetTopCustomersSubscriptionQuery, GetTopCustomersSubscriptionQueryVariables>;
export const GetTopNonPayingCustomersDocument = gql`
    query GetTopNonPayingCustomers {
  cdp_top10_non_paying_cust_mv(order_by: {final_due_amount: desc}, limit: 10) {
    account_name
    amagi_id
    final_due_amount
    logo
  }
}
    `;

/**
 * __useGetTopNonPayingCustomersQuery__
 *
 * To run a query within a React component, call `useGetTopNonPayingCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopNonPayingCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopNonPayingCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopNonPayingCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetTopNonPayingCustomersQuery, GetTopNonPayingCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopNonPayingCustomersQuery, GetTopNonPayingCustomersQueryVariables>(GetTopNonPayingCustomersDocument, options);
      }
export function useGetTopNonPayingCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopNonPayingCustomersQuery, GetTopNonPayingCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopNonPayingCustomersQuery, GetTopNonPayingCustomersQueryVariables>(GetTopNonPayingCustomersDocument, options);
        }
export type GetTopNonPayingCustomersQueryHookResult = ReturnType<typeof useGetTopNonPayingCustomersQuery>;
export type GetTopNonPayingCustomersLazyQueryHookResult = ReturnType<typeof useGetTopNonPayingCustomersLazyQuery>;
export type GetTopNonPayingCustomersQueryResult = Apollo.QueryResult<GetTopNonPayingCustomersQuery, GetTopNonPayingCustomersQueryVariables>;
export const GetTopPayingCustomersDocument = gql`
    query GetTopPayingCustomers {
  cdp_top10_paying_cust_mv(order_by: {invoice_amount_usd: desc}, limit: 10) {
    account_name
    amagi_id
    invoice_amount_usd
    logo
  }
}
    `;

/**
 * __useGetTopPayingCustomersQuery__
 *
 * To run a query within a React component, call `useGetTopPayingCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopPayingCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopPayingCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopPayingCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetTopPayingCustomersQuery, GetTopPayingCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopPayingCustomersQuery, GetTopPayingCustomersQueryVariables>(GetTopPayingCustomersDocument, options);
      }
export function useGetTopPayingCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopPayingCustomersQuery, GetTopPayingCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopPayingCustomersQuery, GetTopPayingCustomersQueryVariables>(GetTopPayingCustomersDocument, options);
        }
export type GetTopPayingCustomersQueryHookResult = ReturnType<typeof useGetTopPayingCustomersQuery>;
export type GetTopPayingCustomersLazyQueryHookResult = ReturnType<typeof useGetTopPayingCustomersLazyQuery>;
export type GetTopPayingCustomersQueryResult = Apollo.QueryResult<GetTopPayingCustomersQuery, GetTopPayingCustomersQueryVariables>;
export const CustomerNetsuitePdfDocument = gql`
    query CustomerNetsuitePDF($id: String!) {
  transaction_file: netsuite_pdf_file(id: $id) {
    base64_file: pdf
  }
}
    `;
export const CustomerNetsuiteIdsDocument = gql`
query CustomerNetsuiteIds($amagi_id: String!) {
customer_by_amagi_id(args: {_amagi_id: $amagi_id}) {
netsuite_id
old_netsuite_Id {
  netsuite_id
}
__typename
}
__typename
}
`;
export function useCustomerNetsuiteIdsQuery(baseOptions: Apollo.QueryHookOptions<CustomerNetsuiteIdsQuery, CustomerNetsuiteIdsQueryVariables>) {
  const options = {...defaultOptions, ...baseOptions}
  return Apollo.useQuery<CustomerNetsuiteIdsQuery, CustomerNetsuiteIdsQueryVariables>(CustomerNetsuiteIdsDocument, options);
}
export function useCustomerNetsuiteIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerNetsuiteIdsQuery, CustomerNetsuiteIdsQueryVariables>) {
    const options = {...defaultOptions, ...baseOptions}
    return Apollo.useLazyQuery<CustomerNetsuiteIdsQuery, CustomerNetsuiteIdsQueryVariables>(CustomerNetsuiteIdsDocument, options);
  }
export type CustomerNetsuiteIdsQueryHookResult = ReturnType<typeof useCustomerNetsuiteIdsQuery>;
export type CustomerNetsuiteIdsLazyQueryHookResult = ReturnType<typeof useCustomerNetsuiteIdsLazyQuery>;
export type CustomerNetsuiteIdsQueryResult = Apollo.QueryResult<CustomerNetsuiteIdsQuery, CustomerNetsuiteIdsQueryVariables>;

    export const GetAverageAmountPerCustomerDocument = gql`
    query GetAverageAmountPerCustomer($from_date: String!, $to_date: String!) {
  average_customer_revenue: average_customer_revenue(
    args: {from_date: $from_date, to_date: $to_date}
  ) {
    revenue_type
    value
  }
  average_subscription_revenue: average_customer_revenue_subscription(
    args: {from_date: $from_date, to_date: $to_date}
  ) {
    revenue_type
    value
  }
  average_consumption_revenue: average_customer_revenue_consumption(
    args: {from_date: $from_date, to_date: $to_date}
  ) {
    revenue_type
    value
  }
}
    `;
export function useGetAverageAmountPerCustomerQuery(baseOptions?: Apollo.QueryHookOptions<GetAverageAmountPerCustomerQuery, GetAverageAmountPerCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAverageAmountPerCustomerQuery, GetAverageAmountPerCustomerQueryVariables>(GetAverageAmountPerCustomerDocument,options);
      }
export function useGetAverageAmountPerCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAverageAmountPerCustomerQuery, GetAverageAmountPerCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAverageAmountPerCustomerQuery, GetAverageAmountPerCustomerQueryVariables>(GetAverageAmountPerCustomerDocument, options);
        }
export type GetAverageAmountPerCustomerQueryHookResult = ReturnType<typeof useGetAverageAmountPerCustomerQuery>;
export type GetAverageAmountPerCustomerLazyQueryHookResult = ReturnType<typeof useGetAverageAmountPerCustomerLazyQuery>;
export type GetAverageAmountPerCustomerQueryResult = Apollo.QueryResult<GetAverageAmountPerCustomerQuery, GetAverageAmountPerCustomerQueryVariables>;

export const GetOutstandingAmountsDocument = gql`
    query GetOutstandingAmounts($from_date: String!, $to_date: String!) {
  customer_outstanding_amount: customer_outstanding_amount(
    args: {from_date: $from_date, to_date: $to_date}
  ) {
    revenue_type
    due_amount
    overdue_amount
  }
  customer_churn_revenue: customer_churn_revenue(
    args: {from_date: $from_date, to_date: $to_date}
  ) {
    revenue_type
    value
  }
  customer_downsell_revenue: customer_downsell_revenue(
    args: {from_date: $from_date, to_date: $to_date}
  ) {
    revenue_type
    value
  }
}
    `;
export function useGetOutstandingAmountsQuery(baseOptions?: Apollo.QueryHookOptions<GetOutstandingAmountsQuery, GetOutstandingAmountsQueryVariables>) {
      const options = {...defaultOptions, ...baseOptions}
      return Apollo.useQuery<GetOutstandingAmountsQuery, GetOutstandingAmountsQueryVariables>(GetOutstandingAmountsDocument,options);
    }
export function useGetOutstandingAmountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOutstandingAmountsQuery, GetOutstandingAmountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useLazyQuery<GetOutstandingAmountsQuery, GetOutstandingAmountsQueryVariables>(GetOutstandingAmountsDocument, options);
      }
export type GetOutstandingAmountsQueryHookResult = ReturnType<typeof useGetOutstandingAmountsQuery>;
export type GetOutstandingAmountsLazyQueryHookResult = ReturnType<typeof useGetOutstandingAmountsLazyQuery>;
export type GetOutstandingAmountsQueryResult = Apollo.QueryResult<GetOutstandingAmountsQuery, GetOutstandingAmountsQueryVariables>;


export const GetMrrTrendsDocument = gql`
query GetMRRTrends($from_date: String!, $to_date: String!,$from_year: Int,$to_year: Int) {
  cdp_billed_mrr: billed_mrr(args: {from_date: $from_date, to_date: $to_date}) {
    billing_month
    amount_usd
  }
  cdp_annual_billed_mrr: annual_billed_mrr(args:{from_year: $from_year, to_year:$to_year}) {
    year
    amount_usd
  }
  cdp_contracted_mrr: contracted_mrr(
    args: {from_date: $from_date, to_date: $to_date}
  ) {
    billing_month
    amount_usd
  }
   cdp_annual_contracted_mrr: annual_contracted_mrr(args:{from_year: $from_year, to_year:$to_year}) {
    year
    amount_usd
  }
  cdp_booked_mrr: booked_mrr(args: {from_date: $from_date, to_date: $to_date}) {
    billing_month
    amount_usd
  }
   cdp_annual_booked_mrr: annual_booked_mrr(args:{from_year: $from_year, to_year:$to_year}) {
    year
    amount_usd
  }
  cdp_recognised_mrr: recognised_mrr(args: {from_date: $from_date, to_date: $to_date}) {
    billing_month
    amount_usd
  }
   cdp_annual_recognised_mrr: annual_recognised_mrr(args:{from_year: $from_year, to_year:$to_year}) {
    year
    amount_usd
  }
}

    `;

export function useGetMrrTrendsQuery(baseOptions?: Apollo.QueryHookOptions<GetMrrTrendsQuery, GetMrrTrendsQueryVariables>) {
      const options = {...defaultOptions, ...baseOptions}
      return Apollo.useQuery<GetMrrTrendsQuery, GetMrrTrendsQueryVariables>(GetMrrTrendsDocument,options);
    }
export function useGetMrrTrendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMrrTrendsQuery, GetMrrTrendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useLazyQuery<GetMrrTrendsQuery, GetMrrTrendsQueryVariables>(GetMrrTrendsDocument, options);
      }
export type GetMrrTrendsQueryHookResult = ReturnType<typeof useGetMrrTrendsQuery>;
export type GetMrrTrendsLazyQueryHookResult = ReturnType<typeof useGetMrrTrendsLazyQuery>;
export type GetMrrTrendsQueryResult = Apollo.QueryResult<GetMrrTrendsQuery, GetMrrTrendsQueryVariables>;


export const GetConsumptionSubscriptionRevenueDocument = gql`
  query GetConsumptionSubscriptionRevenue(
    $from_date: String!
    $to_date: String!
  ) {
    cdp_consumption_mrr: consumption_mrr(
      args: { from_date: $from_date, to_date: $to_date }
    ) {
      billing_month
      amount_usd
    }
    cdp_subscription_mrr: subscription_mrr(
      args: { from_date: $from_date, to_date: $to_date }
    ) {
      billing_month
      amount_usd
    }
  }
`;

export function useGetConsumptionSubscriptionRevenueQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetConsumptionSubscriptionRevenueQuery,
    GetConsumptionSubscriptionRevenueQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetConsumptionSubscriptionRevenueQuery,
    GetConsumptionSubscriptionRevenueQueryVariables
  >(GetConsumptionSubscriptionRevenueDocument, options);
}
export function useGetConsumptionSubscriptionRevenueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetConsumptionSubscriptionRevenueQuery,
    GetConsumptionSubscriptionRevenueQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetConsumptionSubscriptionRevenueQuery,
    GetConsumptionSubscriptionRevenueQueryVariables
  >(GetMrrTrendsDocument, options);
}
export type GetConsumptionSubscriptionRevenueQueryHookResult = ReturnType<
  typeof useGetConsumptionSubscriptionRevenueQuery
>;
export type GetConsumptionSubscriptionRevenueLazyQueryHookResult = ReturnType<
  typeof useGetConsumptionSubscriptionRevenueLazyQuery
>;
export type GetConsumptionSubscriptionRevenueQueryResult = Apollo.QueryResult<
  GetConsumptionSubscriptionRevenueQuery,
  GetConsumptionSubscriptionRevenueQueryVariables
>;

/**
 * __useCustomerNetsuitePdfQuery__
 *
 * To run a query within a React component, call `useCustomerNetsuitePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerNetsuitePdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerNetsuitePdfQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerNetsuitePdfQuery(baseOptions: Apollo.QueryHookOptions<CustomerNetsuitePdfQuery, CustomerNetsuitePdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerNetsuitePdfQuery, CustomerNetsuitePdfQueryVariables>(CustomerNetsuitePdfDocument, options);
      }
export function useCustomerNetsuitePdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerNetsuitePdfQuery, CustomerNetsuitePdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerNetsuitePdfQuery, CustomerNetsuitePdfQueryVariables>(CustomerNetsuitePdfDocument, options);
        }
export type CustomerNetsuitePdfQueryHookResult = ReturnType<typeof useCustomerNetsuitePdfQuery>;
export type CustomerNetsuitePdfLazyQueryHookResult = ReturnType<typeof useCustomerNetsuitePdfLazyQuery>;
export type CustomerNetsuitePdfQueryResult = Apollo.QueryResult<CustomerNetsuitePdfQuery, CustomerNetsuitePdfQueryVariables>;
export const CustomerGetSalesforceIDofInvoiceDocument = gql`
    query CustomerGetSalesforceIDofInvoice($id: String) {
  invoice(where: {custom_invoice_number: {_eq: $id}}) {
    salesforce_id
  }
}
    `;

/**
 * __useCustomerGetSalesforceIDofInvoiceQuery__
 *
 * To run a query within a React component, call `useCustomerGetSalesforceIDofInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGetSalesforceIDofInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGetSalesforceIDofInvoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerGetSalesforceIDofInvoiceQuery(baseOptions?: Apollo.QueryHookOptions<CustomerGetSalesforceIDofInvoiceQuery, CustomerGetSalesforceIDofInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerGetSalesforceIDofInvoiceQuery, CustomerGetSalesforceIDofInvoiceQueryVariables>(CustomerGetSalesforceIDofInvoiceDocument, options);
      }
export function useCustomerGetSalesforceIDofInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerGetSalesforceIDofInvoiceQuery, CustomerGetSalesforceIDofInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerGetSalesforceIDofInvoiceQuery, CustomerGetSalesforceIDofInvoiceQueryVariables>(CustomerGetSalesforceIDofInvoiceDocument, options);
        }
export type CustomerGetSalesforceIDofInvoiceQueryHookResult = ReturnType<typeof useCustomerGetSalesforceIDofInvoiceQuery>;
export type CustomerGetSalesforceIDofInvoiceLazyQueryHookResult = ReturnType<typeof useCustomerGetSalesforceIDofInvoiceLazyQuery>;
export type CustomerGetSalesforceIDofInvoiceQueryResult = Apollo.QueryResult<CustomerGetSalesforceIDofInvoiceQuery, CustomerGetSalesforceIDofInvoiceQueryVariables>;
export const CustomerSalesforcePdfDocument = gql`
    query CustomerSalesforcePDF($id: String!) {
  invoice(where: {salesforce_id: {_eq: $id}}) {
    invoices {
      totalSize
      records {
        id: Id
        details: ContentDocument {
          name: Title
          type: FileType
          extension: FileExtension
          size: ContentSize
        }
        document: ContentVersion {
          document_base64: Content
        }
      }
    }
  }
}
    `;

/**
 * __useCustomerSalesforcePdfQuery__
 *
 * To run a query within a React component, call `useCustomerSalesforcePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSalesforcePdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSalesforcePdfQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerSalesforcePdfQuery(baseOptions: Apollo.QueryHookOptions<CustomerSalesforcePdfQuery, CustomerSalesforcePdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSalesforcePdfQuery, CustomerSalesforcePdfQueryVariables>(CustomerSalesforcePdfDocument, options);
      }
export function useCustomerSalesforcePdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSalesforcePdfQuery, CustomerSalesforcePdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSalesforcePdfQuery, CustomerSalesforcePdfQueryVariables>(CustomerSalesforcePdfDocument, options);
        }
export type CustomerSalesforcePdfQueryHookResult = ReturnType<typeof useCustomerSalesforcePdfQuery>;
export type CustomerSalesforcePdfLazyQueryHookResult = ReturnType<typeof useCustomerSalesforcePdfLazyQuery>;
export type CustomerSalesforcePdfQueryResult = Apollo.QueryResult<CustomerSalesforcePdfQuery, CustomerSalesforcePdfQueryVariables>;
export const UpdateMsaRateCardDocument = gql`
    mutation UpdateMSARateCard($objects: [msa_rate_card_insert_input!]!) {
  insert_msa_rate_card(
    objects: $objects
    on_conflict: {constraint: msa_rate_card_pkey, update_columns: [billing_frequency, type, currency, price, unit, tier_at_product_level]}
  ) {
    affected_rows
  }
}
    `;
export type UpdateMsaRateCardMutationFn = Apollo.MutationFunction<UpdateMsaRateCardMutation, UpdateMsaRateCardMutationVariables>;

/**
 * __useUpdateMsaRateCardMutation__
 *
 * To run a mutation, you first call `useUpdateMsaRateCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMsaRateCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMsaRateCardMutation, { data, loading, error }] = useUpdateMsaRateCardMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpdateMsaRateCardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMsaRateCardMutation, UpdateMsaRateCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMsaRateCardMutation, UpdateMsaRateCardMutationVariables>(UpdateMsaRateCardDocument, options);
      }
export type UpdateMsaRateCardMutationHookResult = ReturnType<typeof useUpdateMsaRateCardMutation>;
export type UpdateMsaRateCardMutationResult = Apollo.MutationResult<UpdateMsaRateCardMutation>;
export type UpdateMsaRateCardMutationOptions = Apollo.BaseMutationOptions<UpdateMsaRateCardMutation, UpdateMsaRateCardMutationVariables>;
export const VodDeliveriesByCustomerDocument = gql`
    query VODDeliveriesByCustomer($amagi_id: String!) {
  delivery: delivery_main(
    where: {_and: [{delivery_to_channel: {customer: {amagi_id: {_eq: $amagi_id}}}}, {cdp_delivery_type: {_eq: "vod_delivery"}}]}
  ) {
    ...DeliveryInfo
  }
  channel_aggregate(where: {customer: {amagi_id: {_eq: $amagi_id}}}) {
    aggregate {
      count
    }
  }
}
    ${DeliveryInfoFragmentDoc}`;

/**
 * __useVodDeliveriesByCustomerQuery__
 *
 * To run a query within a React component, call `useVodDeliveriesByCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useVodDeliveriesByCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVodDeliveriesByCustomerQuery({
 *   variables: {
 *      amagi_id: // value for 'amagi_id'
 *   },
 * });
 */
export function useVodDeliveriesByCustomerQuery(baseOptions: Apollo.QueryHookOptions<VodDeliveriesByCustomerQuery, VodDeliveriesByCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VodDeliveriesByCustomerQuery, VodDeliveriesByCustomerQueryVariables>(VodDeliveriesByCustomerDocument, options);
      }
export function useVodDeliveriesByCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VodDeliveriesByCustomerQuery, VodDeliveriesByCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VodDeliveriesByCustomerQuery, VodDeliveriesByCustomerQueryVariables>(VodDeliveriesByCustomerDocument, options);
        }
export type VodDeliveriesByCustomerQueryHookResult = ReturnType<typeof useVodDeliveriesByCustomerQuery>;
export type VodDeliveriesByCustomerLazyQueryHookResult = ReturnType<typeof useVodDeliveriesByCustomerLazyQuery>;
export type VodDeliveriesByCustomerQueryResult = Apollo.QueryResult<VodDeliveriesByCustomerQuery, VodDeliveriesByCustomerQueryVariables>;

export const NetsuiteTransactionsDocument = gql`
    query NetsuiteTransactions($limit: Int, $offset: Int, $start_date: date, $end_date: date) {
  netsuite_transaction_line(
    offset: $offset
    limit: $limit
    where: {_and: {end_date: {_lte: $end_date}, start_date: {_gte: $start_date}, netsuite_transaction: {type: {_eq: "invoice"}, customer: {account_legal_name: {_is_null: false}}}}}
  ) {
    amount_usd
    amount
    billing_type
    channel
    end_date
    currency
    platform
    netsuite_id
    netsuite_transaction_id
    quantity
    cdpderived_product_id
    product_name
    start_date
    netsuite_transaction {
      type
      billing_period
      transaction_id
      customer {
        account_legal_name
        amagi_id
      }
    }
  }
}
    `;
export function useNetsuiteTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<NetsuiteTransactionsQuery, NetsuiteTransactionsQueryVariables>) {
    const options = {...defaultOptions, ...baseOptions}
    return Apollo.useQuery<NetsuiteTransactionsQuery, NetsuiteTransactionsQueryVariables>(NetsuiteTransactionsDocument,options);
  }
export function useNetsuiteTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetsuiteTransactionsQuery, NetsuiteTransactionsQueryVariables>) {
      const options = {...defaultOptions, ...baseOptions}
      return Apollo.useLazyQuery<NetsuiteTransactionsQuery, NetsuiteTransactionsQueryVariables>(NetsuiteTransactionsDocument, options);
    }
export type NetsuiteTransactionsQueryHookResult = ReturnType<typeof useNetsuiteTransactionsQuery>;
export type NetsuiteTransactionsLazyQueryHookResult = ReturnType<typeof useNetsuiteTransactionsLazyQuery>;
export type NetsuiteTransactionsQueryResult = Apollo.QueryResult<NetsuiteTransactionsQuery,NetsuiteTransactionsQueryVariables>;

export const ProductSkuDataDocument = gql`
    query ProductSkuData {
  product_sku_data {
    code
    name
    charge_type
    account_exclusive_product
    display_unit
    is_active
    description
    bu
    product_group
    product_sub_group
    product_sub_group_category
    usd
    apac_usd
    apac_inr
    eur
    qar
    gbp
    is_deprecated
    so_description
    sku_type
    hidden_from_so_invoice
  }
}
    `;
export function useProductSkuDataQuery(baseOptions?: Apollo.QueryHookOptions<ProductSkuDataQuery, ProductSkuDataQueryVariables>) {
    const options = {...defaultOptions, ...baseOptions}
    return Apollo.useQuery<ProductSkuDataQuery, ProductSkuDataQueryVariables>(ProductSkuDataDocument,options);
  }
export function useProductSkuDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSkuDataQuery, ProductSkuDataQueryVariables>) {
      const options = {...defaultOptions, ...baseOptions}
      return Apollo.useLazyQuery<ProductSkuDataQuery, ProductSkuDataQueryVariables>(ProductSkuDataDocument, options);
    }
export type ProductSkuDataQueryHookResult = ReturnType<typeof useProductSkuDataQuery>;
export type ProductSkuDataLazyQueryHookResult = ReturnType<typeof useProductSkuDataLazyQuery>;
export type ProductSkuDataQueryResult = Apollo.QueryResult<ProductSkuDataQuery,ProductSkuDataQueryVariables>;

export const GetRecordTypeNameDocument = gql`
    query GetRecordTypeName($salesforceId: String!) {
  record_type(where: {salesforce_id: {_eq: $salesforceId}}) {
    name
  }
}
    `;
export function useGetRecordTypeNameQuery(baseOptions?: Apollo.QueryHookOptions<GetRecordTypeNameQuery,GetRecordTypeNameQueryVariables>) {
      const options = {...defaultOptions, ...baseOptions}
      return Apollo.useQuery<GetRecordTypeNameQuery,GetRecordTypeNameQueryVariables>(GetRecordTypeNameDocument,options);
    }
  export function useRecordTypeNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecordTypeNameQuery, GetRecordTypeNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useLazyQuery<GetRecordTypeNameQuery, GetRecordTypeNameQueryVariables>(GetRecordTypeNameDocument, options);
      }
  export type GetRecordTypeNameHookResult = ReturnType<typeof useGetRecordTypeNameQuery>;
  export type GetRecordTypeNameLazyQueryHookResult = ReturnType<typeof useGetCustomerRegionRevenueLazyQuery>;
  export type GetRecordTypeNameQueryResult = Apollo.QueryResult<GetRecordTypeNameQuery,GetRecordTypeNameQueryVariables>;

  export const GetAllChannelsDocument = gql`
    query GetAllChannels {
  channel {
    id
    name
    logo
    channel_type
    channels_grouped
  }
}
    `;

export function useGetAllChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllChannelsQuery,GetAllChannelsQueryVariables>) {
    const options = {...defaultOptions, ...baseOptions}
    return Apollo.useQuery<GetAllChannelsQuery,GetAllChannelsQueryVariables>(GetAllChannelsDocument,options);
  }
export function useGetAllChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllChannelsQuery, GetAllChannelsQueryVariables>) {
      const options = {...defaultOptions, ...baseOptions}
      return Apollo.useLazyQuery<GetAllChannelsQuery, GetAllChannelsQueryVariables>(GetAllChannelsDocument, options);
    }
export type GetAllChannelsHookResult = ReturnType<typeof useGetAllChannelsQuery>;
export type GetAllChannelsLazyQueryHookResult = ReturnType<typeof useGetAllChannelsLazyQuery>;
export type GetAllChannelsQueryResult = Apollo.QueryResult<GetAllChannelsQuery,GetAllChannelsQueryVariables>;
export const GetChannelsByIdAndNameDocument = gql`
    query GetChannelsByIdAndName($id: uuid!, $name: String!) {
  channel(where: {id: {_eq: $id}, name: {_eq: $name}}) {
    id
    name
    logo
    channel_type
    channels_grouped
  }
}
    `;

export function useGetChannelsByIdAndNameQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelsByIdAndNameQuery,GetChannelsByIdAndNameQueryVariables>) {
      const options = {...defaultOptions, ...baseOptions}
      return Apollo.useQuery<GetChannelsByIdAndNameQuery,GetChannelsByIdAndNameQueryVariables>(GetChannelsByIdAndNameDocument,options);
    }
  export function useGetChannelsByIdAndNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelsByIdAndNameQuery, GetChannelsByIdAndNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useLazyQuery<GetChannelsByIdAndNameQuery, GetChannelsByIdAndNameQueryVariables>(GetAllChannelsDocument, options);
      }
  export type GetChannelsByIdAndNameHookResult = ReturnType<typeof useGetChannelsByIdAndNameQuery>;
  export type GetChannelsByIdAndNameLazyQueryHookResult = ReturnType<typeof useGetChannelsByIdAndNameLazyQuery>;
  export type GetChannelsByIdAndNameQueryResult = Apollo.QueryResult<GetChannelsByIdAndNameQuery,GetChannelsByIdAndNameQueryVariables>;
